{
  "79774": {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Domino's Pizza",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "79748",
              "name": "Domino's Pizza",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "dominos-pizza-malviya-nagar-test-bhopal",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/11/a79cd4df-8afa-4cc5-a46f-b9df80cea822_79748.JPG",
              "locality": "New Market Main Road",
              "areaName": "Malviya Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Pizzas",
                "Italian"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "79748",
                "icon": "dominos_cod_xc6inc"
              },
              "parentId": "2456",
              "avgRatingString": "4.3",
              "totalRatingsString": "2.9K+ ratings",
              "sla": {
                "restaurantId": "79748",
                "deliveryTime": 25,
                "minDeliveryTime": 20,
                "maxDeliveryTime": 25,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 698,
                "slaString": "20-25 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "50% off",
                "shortDescriptionList": [
                  {
                    "meta": "50% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Get items under 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "50% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Get items under 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "dominos-pizza-malviya-nagar-test-bhopal",
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "First Floor, Madhya Bharat, Plot No 82, New Maket main road, Malviya Nagar Bhopal, Madhya Pardesh 400708"
                },
                {
                  "title": "Cuisines",
                  "message": "Pizzas,Italian"
                }
              ],
              "totalRatings": 2900,
              "aggregatedDiscountInfoV2": {
                "header": "50% off",
                "shortDescriptionList": [
                  {
                    "meta": "50% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Get items under 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "50% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Get items under 59",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  }
                ]
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 4,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 149
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/79748"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {

                      }
                    },
                    "linkCta": {

                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.236253,77.401449",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 4,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT 50% OFF",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "7ab14d82-fe50-4c22-aed8-3e5884fbbb04"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "79748",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "NO CODE REQUIRED"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "ITEMS AT ₹799",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "0b7eafaf-5cd2-4586-8c3e-f8d725ac61e4"
                      ],
                      "expiryTime": "1970-01-02T07:29:55Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "79748",
                      "offerLogo": "offers/DealRush_Offer_Icon.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CELEBRATIONS",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "79748",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE CELEBRATIONS"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "79748",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "Offer"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7552431",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Cheese Lava - Peppy Paneer",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "187636888",
                              "name": "Cheese Lava - Peppy Paneer",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with paneer, capsicum & red paprika! Pull, dip & let the cheese take over.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/8da6bd12-a637-4bdc-9d3b-318bfe74de71_14db5c04-ccc2-4c9a-85c2-e0929e7bb53a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754457",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754458",
                                          "variationId": "206025709"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754458",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025709",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754457",
                                        "variationId": "206025708"
                                      },
                                      {
                                        "groupId": "68754458",
                                        "variationId": "206025709"
                                      }
                                    ],
                                    "price": 49900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143707"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7553050",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Sourdough Classic Veg Pizza (Reg)",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "186252773",
                              "name": "Sourdough Classic Veg Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "A rich medley of 4 cheeses on classic airy sourdough crust. Airy, cheesy and utterly satisfying. *Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/da86eec5-0c04-44c0-9958-bd8cfc610b98_8308debf-4e77-4291-ad5c-c5865ff59965.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163279",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764699",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163280",
                                          "variationId": "204764700"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163280",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764700",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163279",
                                        "variationId": "204764699"
                                      },
                                      {
                                        "groupId": "68163280",
                                        "variationId": "204764700"
                                      }
                                    ],
                                    "price": 36900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 36900,
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249045"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7551676",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Sourdough Classic Truffle Pepperoni Pizza (Reg)",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "186252782",
                              "name": "Sourdough Classic Truffle Pepperoni Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Succulent chicken pepperoni, truffle mushroom sauce and molten 4-cheeses on airy sourdough. Bold, smoky, irresistible.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/7821e3f9-ae75-4ec6-ba63-bae702a8bb73_86178eef-4b3b-4373-a07c-44a7f7bfa7df.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163297",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764717",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163298",
                                          "variationId": "204764718"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163298",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764718",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163297",
                                        "variationId": "204764717"
                                      },
                                      {
                                        "groupId": "68163298",
                                        "variationId": "204764718"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249043"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7550121",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Big Big 6in1 Pizza - Veg",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "166941001",
                              "name": "Big Big 6in1 Pizza - Veg",
                              "category": "Big Big Pizza",
                              "description": "6 Veggie Blockbusters in 1 Epic Pan Pizza: Corn N Cheese, Peppy Paneer, Farmhouse, Mexican Green Wave, Veg Paradise, Margherita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a1c1ce99-5c73-4fc5-882a-71d2abf98d7c_6922fe24-b22b-4d0b-a86f-b05f309c168c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 79900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67237732",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "202581533",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67237733",
                                          "variationId": "202581534"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67237733",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large Plus",
                                        "default": 1,
                                        "id": "202581534",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67237732",
                                        "variationId": "202581533"
                                      },
                                      {
                                        "groupId": "67237733",
                                        "variationId": "202581534"
                                      }
                                    ],
                                    "price": 166900,
                                    "finalPrice": {
                                      "units": "799"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 166900,
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "offerIds": [
                                "0b7eafaf-5cd2-4586-8c3e-f8d725ac61e4",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "100631164",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "3:59 AM"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7554156",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Big Big 6in1 Pizza – Cheese Carnival",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "179060885",
                              "name": "Big Big 6in1 Pizza – Cheese Carnival",
                              "category": "Big Big Pizza",
                              "description": "6 irresistible cheese flavors packed into one epic pizza. Cheese Lava, Herbed Cheese, Margherita, Cheezy Burst, Cheese Overload, Cheddar Delight",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/19969c34-e561-4c95-a804-fe78aec1eea2_69d06869-19d3-4a0a-83a8-98471adfca33.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 99900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "64026235",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "195396633",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "64026236",
                                          "variationId": "195396635"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "64026236",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large Plus",
                                        "default": 1,
                                        "id": "195396635",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "64026235",
                                        "variationId": "195396633"
                                      },
                                      {
                                        "groupId": "64026236",
                                        "variationId": "195396635"
                                      }
                                    ],
                                    "price": 149900,
                                    "finalPrice": {
                                      "units": "999"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 149900,
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "offerIds": [
                                "c95ccad2-2b7b-4f29-94f3-1b19f6c60f13",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "108435347",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "3:59 AM"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252773",
                              "name": "Sourdough Classic Veg Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "A rich medley of 4 cheeses on classic airy sourdough crust. Airy, cheesy and utterly satisfying. *Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/da86eec5-0c04-44c0-9958-bd8cfc610b98_8308debf-4e77-4291-ad5c-c5865ff59965.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163279",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764699",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163280",
                                          "variationId": "204764700"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163280",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764700",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163279",
                                        "variationId": "204764699"
                                      },
                                      {
                                        "groupId": "68163280",
                                        "variationId": "204764700"
                                      }
                                    ],
                                    "price": 36900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 36900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249045"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252776",
                              "name": "Sourdough Classic Truffle Veg Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Velvety truffle mushroom sauce, golden 4-cheeses on airy sourdough. Creamy, earthy, indulgent.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/b27c5696-fa26-47dc-9d75-c1761085e275_2a99aa9f-d33f-4b9c-93ba-c8a0053601ef.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163285",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764705",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163286",
                                          "variationId": "204764706"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163286",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764706",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163285",
                                        "variationId": "204764705"
                                      },
                                      {
                                        "groupId": "68163286",
                                        "variationId": "204764706"
                                      }
                                    ],
                                    "price": 36900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 36900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249044"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252783",
                              "name": "Sourdough Creamy Truffle Mushroom Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle sauce, mushrooms and jalapeños with 4-cheeses on airy sourdough crust.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/8ad9aaf9-7e5f-4793-9b4b-43a5d825ceec_1cd67f13-65e8-4a9d-8471-06b22819de95.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163299",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764719",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163300",
                                          "variationId": "204764720"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163300",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764720",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163299",
                                        "variationId": "204764719"
                                      },
                                      {
                                        "groupId": "68163300",
                                        "variationId": "204764720"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249047"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252785",
                              "name": "Sourdough Pesto Veggie Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled red & yellow bell peppers, olives and a basil pesto drizzle over classic sourdough topped with 4-cheeses.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/0d42cb15-444f-48a7-954f-862f010dede4_b5a7c398-d91c-4301-b9d8-1419eb737514.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163303",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764723",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163304",
                                          "variationId": "204764724"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163304",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764724",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163303",
                                        "variationId": "204764723"
                                      },
                                      {
                                        "groupId": "68163304",
                                        "variationId": "204764724"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249052"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252772",
                              "name": "Sourdough Fiery Peri Peri Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Paprika and olives bring a punch of flavour to this fiery, 4-cheese sourdough delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5447d49c-8550-4458-9a74-7fb4a23f0387_d8db5ccf-59a2-4dfd-98fc-dcec745eb475.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163277",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764697",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163278",
                                          "variationId": "204764698"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163278",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764698",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163277",
                                        "variationId": "204764697"
                                      },
                                      {
                                        "groupId": "68163278",
                                        "variationId": "204764698"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249049"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252782",
                              "name": "Sourdough Classic Truffle Pepperoni Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Succulent chicken pepperoni, truffle mushroom sauce and molten 4-cheeses on airy sourdough. Bold, smoky, irresistible.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/7821e3f9-ae75-4ec6-ba63-bae702a8bb73_86178eef-4b3b-4373-a07c-44a7f7bfa7df.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163297",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764717",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163298",
                                          "variationId": "204764718"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163298",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764718",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163297",
                                        "variationId": "204764717"
                                      },
                                      {
                                        "groupId": "68163298",
                                        "variationId": "204764718"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249043"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252778",
                              "name": "Sourdough Chicken Pepperoni Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Chicken pepperoni and 4 cheeses on airy sourdough. Savoury, smoky, an absolute delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/7821e3f9-ae75-4ec6-ba63-bae702a8bb73_86178eef-4b3b-4373-a07c-44a7f7bfa7df.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163289",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764709",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163290",
                                          "variationId": "204764710"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163290",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764710",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163289",
                                        "variationId": "204764709"
                                      },
                                      {
                                        "groupId": "68163290",
                                        "variationId": "204764710"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252788",
                              "name": "Sourdough Fiery Peri Peri Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken rashers with paprika, olives and bold cheeses on airy sourdough. Spicy, tangy, craveable.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/e6d57bd6-be8c-4e91-b2ee-79fc29463b92_64ee11f3-21fe-4d52-8f15-e0231f05bb67.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163307",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764727",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163308",
                                          "variationId": "204764728"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163308",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764728",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163307",
                                        "variationId": "204764727"
                                      },
                                      {
                                        "groupId": "68163308",
                                        "variationId": "204764728"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249048"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252770",
                              "name": "Sourdough Pesto Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken rashers, olives and a touch of basil pesto over 4-cheeses on airy sourdough. Pure delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/c76ec569-9678-4e6d-862c-c2a0af139c66_b49bc4a1-7c1c-418f-a3b6-ce63a4ba11c3.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163273",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764693",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163274",
                                          "variationId": "204764694"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163274",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764694",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163273",
                                        "variationId": "204764693"
                                      },
                                      {
                                        "groupId": "68163274",
                                        "variationId": "204764694"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249051"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252771",
                              "name": "Sourdough Creamy Truffle Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle mushroom sauce, grilled chicken rashers and jalapeños over 4-cheeses on airy sourdough. Earthy, rich, indulgent.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/70fd2b37-e413-4efa-a6fc-28bb6c97c2c8_1abe61d0-b12e-4906-bec7-75e7aa808326.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163275",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764695",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163276",
                                          "variationId": "204764696"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163276",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764696",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163275",
                                        "variationId": "204764695"
                                      },
                                      {
                                        "groupId": "68163276",
                                        "variationId": "204764696"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249046"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252777",
                              "name": "Sourdough Slim Classic Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Four rich cheeses on a crisp slim sourdough crust. Light, cheesy and perfectly satisfying.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/12313890-b30e-4fcc-9fb6-7f84d5583fef_afb7be1b-44b2-4bb7-9fa3-29beb2650ba7.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163287",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764707",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163288",
                                          "variationId": "204764708"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163288",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163287",
                                        "variationId": "204764707"
                                      },
                                      {
                                        "groupId": "68163288",
                                        "variationId": "204764708"
                                      }
                                    ],
                                    "price": 56900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 56900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249056"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252775",
                              "name": "Sourdough Slim Classic Truffle Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Velvety truffle mushroom sauce, 4-cheeses and veg pepperoni bites on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/c101a6a7-4095-48e9-b384-eb805dfef8ff_bb9cd20a-16a8-4535-88f1-f4e694325041.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163283",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163284",
                                          "variationId": "204764704"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163284",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764704",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163283",
                                        "variationId": "204764703"
                                      },
                                      {
                                        "groupId": "68163284",
                                        "variationId": "204764704"
                                      }
                                    ],
                                    "price": 56900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 56900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249055"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252786",
                              "name": "Sourdough Slim Fiery Peri Peri Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Paprika and olives pack a fiery crisp punch with 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/3aa9a980-2c1e-47bd-9877-a51d5cee1e43_cd4eed83-090c-448b-9065-f0cbb4077c72.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163305",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764725",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163306",
                                          "variationId": "204764726"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163306",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764726",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163305",
                                        "variationId": "204764725"
                                      },
                                      {
                                        "groupId": "68163306",
                                        "variationId": "204764726"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249060"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252779",
                              "name": "Sourdough Slim Creamy Truffle Mushroom Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle sauce, mushrooms and jalapeños with 4-cheeses on slim sourdough crust.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/a00de7a9-026c-4bdb-ad38-868a38942a61_c8bc10e6-4519-4681-9480-3b12abab41cc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163291",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764711",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163292",
                                          "variationId": "204764712"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163292",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764712",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163291",
                                        "variationId": "204764711"
                                      },
                                      {
                                        "groupId": "68163292",
                                        "variationId": "204764712"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249058"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252774",
                              "name": "Sourdough Slim Pesto Veggie Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled red & yellow bell peppers, olives and a basil pesto drizzle over 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/d95dffe4-ac6e-4008-b563-7dfe0f227a4f_2d7c55b2-e752-4b25-8c34-1fc6401f029e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163281",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764701",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163282",
                                          "variationId": "204764702"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163282",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764702",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163281",
                                        "variationId": "204764701"
                                      },
                                      {
                                        "groupId": "68163282",
                                        "variationId": "204764702"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249062"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252780",
                              "name": "Sourdough Slim Classic Truffle Pepperoni Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Succulent chicken pepperoni, truffle mushroom sauce and molten 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5b5d9847-38f8-4f85-9d77-5a0bea782c2a_99d475f0-901f-4def-8a33-1f0015be3a75.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163293",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764713",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163294",
                                          "variationId": "204764714"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163294",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764714",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163293",
                                        "variationId": "204764713"
                                      },
                                      {
                                        "groupId": "68163294",
                                        "variationId": "204764714"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249054"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252781",
                              "name": "Sourdough Slim Chicken Pepperoni Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Smoky chicken pepperoni with 4-cheeses on a thin, slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5b5d9847-38f8-4f85-9d77-5a0bea782c2a_99d475f0-901f-4def-8a33-1f0015be3a75.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163295",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764715",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163296",
                                          "variationId": "204764716"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163296",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764716",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163295",
                                        "variationId": "204764715"
                                      },
                                      {
                                        "groupId": "68163296",
                                        "variationId": "204764716"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249053"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186251757",
                              "name": "Sourdough Slim Pesto Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken, olives and herby basil pesto swirl over 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/2abb8841-a23b-4409-ae1f-a4cfad38df9e_345d4798-2ff3-41b4-b2e9-29a5cd349112.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68161312",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204762725",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68161313",
                                          "variationId": "204762727"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68161313",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204762727",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68161312",
                                        "variationId": "204762725"
                                      },
                                      {
                                        "groupId": "68161313",
                                        "variationId": "204762727"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249061"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186251758",
                              "name": "Sourdough Slim Fiery Peri Peri Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken, paprika, olives and bold cheeses on slim sourdough. Spicy, tangy, craveable.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/dc0bf707-8c8c-457d-a91a-ea83a52fa5aa_2a8db22b-7993-4f59-9125-f8a5b27204b3.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68161315",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204762729",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68161316",
                                          "variationId": "204762730"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68161316",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204762730",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68161315",
                                        "variationId": "204762729"
                                      },
                                      {
                                        "groupId": "68161316",
                                        "variationId": "204762730"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249059"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252784",
                              "name": "Sourdough Slim Creamy Truffle Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle mushroom sauce, grilled chicken, jalapeno and 4-cheeses on slim sourdough. Earthy and indulgent.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/a32657e7-60dd-41d7-bf64-0014983d08a4_f1d40b2b-ee7f-4eea-bc19-c23c216a1d58.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163301",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764721",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163302",
                                          "variationId": "204764722"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163302",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764722",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163301",
                                        "variationId": "204764721"
                                      },
                                      {
                                        "groupId": "68163302",
                                        "variationId": "204764722"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249057"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sourdough Range",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252773",
                              "name": "Sourdough Classic Veg Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "A rich medley of 4 cheeses on classic airy sourdough crust. Airy, cheesy and utterly satisfying. *Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/da86eec5-0c04-44c0-9958-bd8cfc610b98_8308debf-4e77-4291-ad5c-c5865ff59965.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163279",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764699",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163280",
                                          "variationId": "204764700"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163280",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764700",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163279",
                                        "variationId": "204764699"
                                      },
                                      {
                                        "groupId": "68163280",
                                        "variationId": "204764700"
                                      }
                                    ],
                                    "price": 36900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 36900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249045"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252776",
                              "name": "Sourdough Classic Truffle Veg Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Velvety truffle mushroom sauce, golden 4-cheeses on airy sourdough. Creamy, earthy, indulgent.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/b27c5696-fa26-47dc-9d75-c1761085e275_2a99aa9f-d33f-4b9c-93ba-c8a0053601ef.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163285",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764705",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163286",
                                          "variationId": "204764706"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163286",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764706",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163285",
                                        "variationId": "204764705"
                                      },
                                      {
                                        "groupId": "68163286",
                                        "variationId": "204764706"
                                      }
                                    ],
                                    "price": 36900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 36900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249044"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252783",
                              "name": "Sourdough Creamy Truffle Mushroom Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle sauce, mushrooms and jalapeños with 4-cheeses on airy sourdough crust.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/8ad9aaf9-7e5f-4793-9b4b-43a5d825ceec_1cd67f13-65e8-4a9d-8471-06b22819de95.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163299",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764719",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163300",
                                          "variationId": "204764720"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163300",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764720",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163299",
                                        "variationId": "204764719"
                                      },
                                      {
                                        "groupId": "68163300",
                                        "variationId": "204764720"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249047"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252785",
                              "name": "Sourdough Pesto Veggie Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled red & yellow bell peppers, olives and a basil pesto drizzle over classic sourdough topped with 4-cheeses.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/0d42cb15-444f-48a7-954f-862f010dede4_b5a7c398-d91c-4301-b9d8-1419eb737514.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163303",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764723",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163304",
                                          "variationId": "204764724"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163304",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764724",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163303",
                                        "variationId": "204764723"
                                      },
                                      {
                                        "groupId": "68163304",
                                        "variationId": "204764724"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249052"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252772",
                              "name": "Sourdough Fiery Peri Peri Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Paprika and olives bring a punch of flavour to this fiery, 4-cheese sourdough delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5447d49c-8550-4458-9a74-7fb4a23f0387_d8db5ccf-59a2-4dfd-98fc-dcec745eb475.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163277",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764697",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163278",
                                          "variationId": "204764698"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163278",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764698",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163277",
                                        "variationId": "204764697"
                                      },
                                      {
                                        "groupId": "68163278",
                                        "variationId": "204764698"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249049"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252782",
                              "name": "Sourdough Classic Truffle Pepperoni Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Succulent chicken pepperoni, truffle mushroom sauce and molten 4-cheeses on airy sourdough. Bold, smoky, irresistible.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/7821e3f9-ae75-4ec6-ba63-bae702a8bb73_86178eef-4b3b-4373-a07c-44a7f7bfa7df.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163297",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764717",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163298",
                                          "variationId": "204764718"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163298",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764718",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163297",
                                        "variationId": "204764717"
                                      },
                                      {
                                        "groupId": "68163298",
                                        "variationId": "204764718"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249043"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252778",
                              "name": "Sourdough Chicken Pepperoni Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Chicken pepperoni and 4 cheeses on airy sourdough. Savoury, smoky, an absolute delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/7821e3f9-ae75-4ec6-ba63-bae702a8bb73_86178eef-4b3b-4373-a07c-44a7f7bfa7df.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163289",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764709",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163290",
                                          "variationId": "204764710"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163290",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764710",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163289",
                                        "variationId": "204764709"
                                      },
                                      {
                                        "groupId": "68163290",
                                        "variationId": "204764710"
                                      }
                                    ],
                                    "price": 41900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252788",
                              "name": "Sourdough Fiery Peri Peri Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken rashers with paprika, olives and bold cheeses on airy sourdough. Spicy, tangy, craveable.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/e6d57bd6-be8c-4e91-b2ee-79fc29463b92_64ee11f3-21fe-4d52-8f15-e0231f05bb67.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163307",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764727",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163308",
                                          "variationId": "204764728"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163308",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764728",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163307",
                                        "variationId": "204764727"
                                      },
                                      {
                                        "groupId": "68163308",
                                        "variationId": "204764728"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249048"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252770",
                              "name": "Sourdough Pesto Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken rashers, olives and a touch of basil pesto over 4-cheeses on airy sourdough. Pure delight.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/c76ec569-9678-4e6d-862c-c2a0af139c66_b49bc4a1-7c1c-418f-a3b6-ce63a4ba11c3.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163273",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764693",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163274",
                                          "variationId": "204764694"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163274",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764694",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163273",
                                        "variationId": "204764693"
                                      },
                                      {
                                        "groupId": "68163274",
                                        "variationId": "204764694"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249051"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252771",
                              "name": "Sourdough Creamy Truffle Chicken Pizza (Reg)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle mushroom sauce, grilled chicken rashers and jalapeños over 4-cheeses on airy sourdough. Earthy, rich, indulgent.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/70fd2b37-e413-4efa-a6fc-28bb6c97c2c8_1abe61d0-b12e-4906-bec7-75e7aa808326.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163275",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764695",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163276",
                                          "variationId": "204764696"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163276",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "204764696",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163275",
                                        "variationId": "204764695"
                                      },
                                      {
                                        "groupId": "68163276",
                                        "variationId": "204764696"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249046"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252777",
                              "name": "Sourdough Slim Classic Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Four rich cheeses on a crisp slim sourdough crust. Light, cheesy and perfectly satisfying.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/12313890-b30e-4fcc-9fb6-7f84d5583fef_afb7be1b-44b2-4bb7-9fa3-29beb2650ba7.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163287",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764707",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163288",
                                          "variationId": "204764708"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163288",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163287",
                                        "variationId": "204764707"
                                      },
                                      {
                                        "groupId": "68163288",
                                        "variationId": "204764708"
                                      }
                                    ],
                                    "price": 56900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 56900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249056"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252775",
                              "name": "Sourdough Slim Classic Truffle Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Velvety truffle mushroom sauce, 4-cheeses and veg pepperoni bites on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/c101a6a7-4095-48e9-b384-eb805dfef8ff_bb9cd20a-16a8-4535-88f1-f4e694325041.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163283",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163284",
                                          "variationId": "204764704"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163284",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764704",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163283",
                                        "variationId": "204764703"
                                      },
                                      {
                                        "groupId": "68163284",
                                        "variationId": "204764704"
                                      }
                                    ],
                                    "price": 56900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 56900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249055"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252786",
                              "name": "Sourdough Slim Fiery Peri Peri Veg Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Paprika and olives pack a fiery crisp punch with 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/3aa9a980-2c1e-47bd-9877-a51d5cee1e43_cd4eed83-090c-448b-9065-f0cbb4077c72.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163305",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764725",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163306",
                                          "variationId": "204764726"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163306",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764726",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163305",
                                        "variationId": "204764725"
                                      },
                                      {
                                        "groupId": "68163306",
                                        "variationId": "204764726"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249060"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252779",
                              "name": "Sourdough Slim Creamy Truffle Mushroom Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle sauce, mushrooms and jalapeños with 4-cheeses on slim sourdough crust.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/a00de7a9-026c-4bdb-ad38-868a38942a61_c8bc10e6-4519-4681-9480-3b12abab41cc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163291",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764711",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163292",
                                          "variationId": "204764712"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163292",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764712",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163291",
                                        "variationId": "204764711"
                                      },
                                      {
                                        "groupId": "68163292",
                                        "variationId": "204764712"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249058"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252774",
                              "name": "Sourdough Slim Pesto Veggie Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled red & yellow bell peppers, olives and a basil pesto drizzle over 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/d95dffe4-ac6e-4008-b563-7dfe0f227a4f_2d7c55b2-e752-4b25-8c34-1fc6401f029e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163281",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764701",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163282",
                                          "variationId": "204764702"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163282",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764702",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163281",
                                        "variationId": "204764701"
                                      },
                                      {
                                        "groupId": "68163282",
                                        "variationId": "204764702"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249062"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252780",
                              "name": "Sourdough Slim Classic Truffle Pepperoni Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Succulent chicken pepperoni, truffle mushroom sauce and molten 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5b5d9847-38f8-4f85-9d77-5a0bea782c2a_99d475f0-901f-4def-8a33-1f0015be3a75.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163293",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764713",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163294",
                                          "variationId": "204764714"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163294",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764714",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163293",
                                        "variationId": "204764713"
                                      },
                                      {
                                        "groupId": "68163294",
                                        "variationId": "204764714"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249054"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252781",
                              "name": "Sourdough Slim Chicken Pepperoni Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Smoky chicken pepperoni with 4-cheeses on a thin, slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/5b5d9847-38f8-4f85-9d77-5a0bea782c2a_99d475f0-901f-4def-8a33-1f0015be3a75.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163295",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764715",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163296",
                                          "variationId": "204764716"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163296",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764716",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163295",
                                        "variationId": "204764715"
                                      },
                                      {
                                        "groupId": "68163296",
                                        "variationId": "204764716"
                                      }
                                    ],
                                    "price": 61900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249053"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186251757",
                              "name": "Sourdough Slim Pesto Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken, olives and herby basil pesto swirl over 4-cheeses on slim sourdough crust.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/2abb8841-a23b-4409-ae1f-a4cfad38df9e_345d4798-2ff3-41b4-b2e9-29a5cd349112.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68161312",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204762725",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68161313",
                                          "variationId": "204762727"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68161313",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204762727",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68161312",
                                        "variationId": "204762725"
                                      },
                                      {
                                        "groupId": "68161313",
                                        "variationId": "204762727"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249061"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186251758",
                              "name": "Sourdough Slim Fiery Peri Peri Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Grilled chicken, paprika, olives and bold cheeses on slim sourdough. Spicy, tangy, craveable.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/dc0bf707-8c8c-457d-a91a-ea83a52fa5aa_2a8db22b-7993-4f59-9125-f8a5b27204b3.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68161315",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204762729",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68161316",
                                          "variationId": "204762730"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68161316",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204762730",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68161315",
                                        "variationId": "204762729"
                                      },
                                      {
                                        "groupId": "68161316",
                                        "variationId": "204762730"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249059"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252784",
                              "name": "Sourdough Slim Creamy Truffle Chicken Pizza (Med)",
                              "category": "Sourdough Range",
                              "description": "Creamy truffle mushroom sauce, grilled chicken, jalapeno and 4-cheeses on slim sourdough. Earthy and indulgent.*Leaves subject to availability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/a32657e7-60dd-41d7-bf64-0014983d08a4_f1d40b2b-ee7f-4eea-bc19-c23c216a1d58.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68163301",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Sourdough",
                                        "default": 1,
                                        "id": "204764721",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68163302",
                                          "variationId": "204764722"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68163302",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204764722",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68163301",
                                        "variationId": "204764721"
                                      },
                                      {
                                        "groupId": "68163302",
                                        "variationId": "204764722"
                                      }
                                    ],
                                    "price": 66900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 66900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249057"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/da86eec5-0c04-44c0-9958-bd8cfc610b98_8308debf-4e77-4291-ad5c-c5865ff59965.jpg",
                      "categoryId": "68543713"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "PIZZA MANIA",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110399164",
                              "name": "Chicken Keema & Onion with Desi Makhani Sauce",
                              "category": "PIZZA MANIA",
                              "description": "Authentic Indian Flavor of Makhani Sauce loaded with meaty Chicken Keema and crunchy Onion.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6827ba66-012d-4560-ba43-27a835adfc89_d64d974a-3b51-408f-9eb3-07fc7fa09b05.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544281",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295624",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544282",
                                          "variationId": "203295626"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295625",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544282",
                                          "variationId": "203295626"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544282",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295626",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544281",
                                        "variationId": "203295625"
                                      },
                                      {
                                        "groupId": "67544282",
                                        "variationId": "203295626"
                                      }
                                    ],
                                    "price": 14900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544281",
                                        "variationId": "203295624"
                                      },
                                      {
                                        "groupId": "67544282",
                                        "variationId": "203295626"
                                      }
                                    ],
                                    "price": 17900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60938153"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110399165",
                              "name": "Paneer, Onion & Capsicum with Desi Makhani Sauce",
                              "category": "PIZZA MANIA",
                              "description": "Authentic Indian Flavor of Makhani Sauce loaded with juicy Paneer, crisp Capsicum and crunchy Onion.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2a13ec06-bf36-484d-8038-fe49d54114e7_532a9161-85b9-41e6-b017-9924451bafbe.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544383",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295787",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544384",
                                          "variationId": "203295789"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295788",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544384",
                                          "variationId": "203295789"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544384",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295789",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544383",
                                        "variationId": "203295788"
                                      },
                                      {
                                        "groupId": "67544384",
                                        "variationId": "203295789"
                                      }
                                    ],
                                    "price": 13500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544383",
                                        "variationId": "203295787"
                                      },
                                      {
                                        "groupId": "67544384",
                                        "variationId": "203295789"
                                      }
                                    ],
                                    "price": 16500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "181 ratings",
                                  "ratingCountV2": "181"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60938156"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876168",
                              "name": "Non Veg Loaded",
                              "category": "PIZZA MANIA",
                              "description": "Chicken sausage, pepper barbecue chicken & peri-peri chicken in a fresh pan crust",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/4065cdbd-f0fb-4455-9f9e-1dd72a4aa6b2_480fd6c1-0c77-4838-8864-5b086ceb541f.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544375",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "203295776",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544376",
                                          "variationId": "203295777"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544376",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295777",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544375",
                                        "variationId": "203295776"
                                      },
                                      {
                                        "groupId": "67544376",
                                        "variationId": "203295777"
                                      }
                                    ],
                                    "price": 20500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "43 ratings",
                                  "ratingCountV2": "43"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974151"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876174",
                              "name": "Veg Loaded",
                              "category": "PIZZA MANIA",
                              "description": "Tomato, Jalapeno, Corn, Grilled Mushroom & crushed Aranchini Patty in a fresh pan crust",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ec18f227-7a69-4c54-b5f1-fa1eed20a774_f8f2db28-7e9b-473a-97ed-ddf220007148.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544304",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "203295664",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544305",
                                          "variationId": "203295665"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544305",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295665",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544304",
                                        "variationId": "203295664"
                                      },
                                      {
                                        "groupId": "67544305",
                                        "variationId": "203295665"
                                      }
                                    ],
                                    "price": 19500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "80 ratings",
                                  "ratingCountV2": "80"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974245"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110399166",
                              "name": "Paneer & Capsicum with Videshi Hot Sauce",
                              "category": "PIZZA MANIA",
                              "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with juicy Paneer and crisp Capsicum.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b3d5b586-905d-4522-a10f-8e81a9f90fd1_b7894091-d7a5-4698-b9cb-b5544576a702.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544321",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295691",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544323",
                                          "variationId": "203295694"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295692",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544323",
                                          "variationId": "203295694"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544323",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295694",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544321",
                                        "variationId": "203295692"
                                      },
                                      {
                                        "groupId": "67544323",
                                        "variationId": "203295694"
                                      }
                                    ],
                                    "price": 11500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544321",
                                        "variationId": "203295691"
                                      },
                                      {
                                        "groupId": "67544323",
                                        "variationId": "203295694"
                                      }
                                    ],
                                    "price": 14500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "116 ratings",
                                  "ratingCountV2": "116"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60938155"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110399167",
                              "name": "Capsicum & Red Paprika with Videshi Hot Sauce",
                              "category": "PIZZA MANIA",
                              "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with crisp Capsicum and spicy Red Paprika.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c0dbc644-43a3-4357-b6fb-008f2603f464_62ab9b9e-5a03-430a-9b39-54d5299711f2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544437",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295869",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544438",
                                          "variationId": "203295871"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295870",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544438",
                                          "variationId": "203295871"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544438",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295871",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544437",
                                        "variationId": "203295870"
                                      },
                                      {
                                        "groupId": "67544438",
                                        "variationId": "203295871"
                                      }
                                    ],
                                    "price": 9500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544437",
                                        "variationId": "203295869"
                                      },
                                      {
                                        "groupId": "67544438",
                                        "variationId": "203295871"
                                      }
                                    ],
                                    "price": 12500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60938152"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91964488",
                              "name": "Pepper Barbecue Chicken",
                              "category": "PIZZA MANIA",
                              "description": "Pepper barbecue chicken for that extra zing",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b2bea526-1845-46dd-ba10-2034c52f22d2_bbe2c4eb-3c08-408b-8198-16b438bfb461.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544427",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295855",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544428",
                                          "variationId": "203295857"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295856",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544428",
                                          "variationId": "203295857"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544428",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295857",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544427",
                                        "variationId": "203295856"
                                      },
                                      {
                                        "groupId": "67544428",
                                        "variationId": "203295857"
                                      }
                                    ],
                                    "price": 12500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544427",
                                        "variationId": "203295855"
                                      },
                                      {
                                        "groupId": "67544428",
                                        "variationId": "203295857"
                                      }
                                    ],
                                    "price": 15500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 12500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974170"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91964489",
                              "name": "Chicken Sausage",
                              "category": "PIZZA MANIA",
                              "description": "American classic! Spicy, herbed chicken sausage on pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d7bc4adc-9290-4180-9f7c-9e9e2e3d783d_bd8b7c4a-a31d-44a2-b477-80dfe62ff1b7.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544307",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295667",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544309",
                                          "variationId": "203295670"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295668",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544309",
                                          "variationId": "203295670"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544309",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295670",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544307",
                                        "variationId": "203295668"
                                      },
                                      {
                                        "groupId": "67544309",
                                        "variationId": "203295670"
                                      }
                                    ],
                                    "price": 10900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544307",
                                        "variationId": "203295667"
                                      },
                                      {
                                        "groupId": "67544309",
                                        "variationId": "203295670"
                                      }
                                    ],
                                    "price": 13900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973990"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876206",
                              "name": "Golden Corn",
                              "category": "PIZZA MANIA",
                              "description": "Sweet & juicy golden corn for that lipsmacking taste",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ace067b0-2f20-40ca-9968-0e7703ef1e89_fd1a21e7-a6ae-465c-8e46-e4d2b1b137d7.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544399",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295813",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544400",
                                          "variationId": "203295815"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295814",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544400",
                                          "variationId": "203295815"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544400",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295815",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544399",
                                        "variationId": "203295814"
                                      },
                                      {
                                        "groupId": "67544400",
                                        "variationId": "203295815"
                                      }
                                    ],
                                    "price": 9500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544399",
                                        "variationId": "203295813"
                                      },
                                      {
                                        "groupId": "67544400",
                                        "variationId": "203295815"
                                      }
                                    ],
                                    "price": 12500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974089"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876216",
                              "name": "Onion",
                              "category": "PIZZA MANIA",
                              "description": "Our classic Pizza Mania topped with crunchy Onions",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7aa768f8-b48e-444a-913c-17e139441c56_d7f74422-30f0-4b05-916b-e54807274aa0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544401",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "203295816",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544402",
                                          "variationId": "203295818"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "203295817",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544402",
                                          "variationId": "203295818"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544402",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295818",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544401",
                                        "variationId": "203295816"
                                      },
                                      {
                                        "groupId": "67544402",
                                        "variationId": "203295818"
                                      }
                                    ],
                                    "price": 10500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544401",
                                        "variationId": "203295817"
                                      },
                                      {
                                        "groupId": "67544402",
                                        "variationId": "203295818"
                                      }
                                    ],
                                    "price": 7500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "66 ratings",
                                  "ratingCountV2": "66"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974155"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110505578",
                              "name": "Classic",
                              "category": "PIZZA MANIA",
                              "description": "A classic pizza topped with sprinkle of basil and parsley herbs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6d13296d-bcfe-472e-a92b-cf57e7721f2f_3a08fa86-d49e-4675-87cc-c449bd1d00c6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544284",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295628",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544286",
                                          "variationId": "203295631"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "203295629",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544286",
                                          "variationId": "203295631"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544286",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295631",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544284",
                                        "variationId": "203295629"
                                      },
                                      {
                                        "groupId": "67544286",
                                        "variationId": "203295631"
                                      }
                                    ],
                                    "price": 4900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544284",
                                        "variationId": "203295628"
                                      },
                                      {
                                        "groupId": "67544286",
                                        "variationId": "203295631"
                                      }
                                    ],
                                    "price": 7900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "63579592"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6827ba66-012d-4560-ba43-27a835adfc89_d64d974a-3b51-408f-9eb3-07fc7fa09b05.jpg",
                      "categoryId": "39982885"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dominos Classics",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875454",
                              "name": "Margherita Pizza",
                              "category": "Dominos Classics",
                              "description": "Classic delight with 100% real mozzarella cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f3b8f6fb-bf73-4ee0-bed8-a6a57742f7cb_19f4a228-886b-4072-a5c8-3417090132ae.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36901098",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114960332",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827462",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114960338",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114960340",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114960343",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504854",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504855",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504856",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901101",
                                          "variationId": "114960346"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36901101",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114960346",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114960348",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114960350",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504855"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504855"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504856"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504856"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504854"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "155504854"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "208827462"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "208827462"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 31500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960332"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960332"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960350"
                                      }
                                    ],
                                    "price": 48500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132514613",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132514601",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132514606",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960332"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960338"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960338"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960343"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960340"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960346"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514558",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514573",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514565",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901098",
                                        "variationId": "114960340"
                                      },
                                      {
                                        "groupId": "36901101",
                                        "variationId": "114960348"
                                      }
                                    ],
                                    "price": 30500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514586",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514594",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514581",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132514558",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514565",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514573",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514581",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514586",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514594",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514601",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514606",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514613",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464117"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875456",
                              "name": "Double Cheese Margherita Pizza",
                              "category": "Dominos Classics",
                              "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/27f4d80d-f7ce-4ce5-bc80-0a05ed07fe8d_ad4b4ba4-a833-442a-89e3-b8e3cdfe89a2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36898745",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114953498",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827456",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114953505",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114953509",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114953512",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504767",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504768",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504769",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898751",
                                          "variationId": "114953518"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36898751",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114953518",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114953519",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114953520",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504768"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504768"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504769"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504769"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504767"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "155504767"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953498"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953498"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953520"
                                      }
                                    ],
                                    "price": 64900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132509443",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132509431",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132509435",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953498"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953505"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953505"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953512"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953509"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "114953509"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "208827456"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953518"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509414",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509426",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509418",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898745",
                                        "variationId": "208827456"
                                      },
                                      {
                                        "groupId": "36898751",
                                        "variationId": "114953519"
                                      }
                                    ],
                                    "price": 45900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509456",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509460",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509452",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132509414",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509418",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509426",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509452",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509456",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509460",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509431",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509435",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509443",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464110"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875744",
                              "name": "Fresh Veggie Pizza",
                              "category": "Dominos Classics",
                              "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/73bc5eb4-19c7-40ec-a910-f54e11f30ae7_b6c9ab2b-81b4-423b-97c8-2e018456b604.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36898636",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114953171",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827465",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114953173",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114953174",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114953175",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504716",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504717",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504718",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898637",
                                          "variationId": "114953176"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36898637",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114953176",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114953178",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114953181",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504717"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504717"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504718"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504718"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504716"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "155504716"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953171"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953171"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953181"
                                      }
                                    ],
                                    "price": 64900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132509176",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132509158",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132509166",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953171"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953173"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953173"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953175"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953174"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "114953174"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "208827465"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953176"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509115",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509141",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509125",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898636",
                                        "variationId": "208827465"
                                      },
                                      {
                                        "groupId": "36898637",
                                        "variationId": "114953178"
                                      }
                                    ],
                                    "price": 45900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509189",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509201",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509182",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132509115",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509125",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509141",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509182",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509189",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509201",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509158",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509166",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509176",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464112"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109956431",
                              "name": "Cheese n Corn Pizza",
                              "category": "Dominos Classics",
                              "description": "A delectable combination of sweet & juicy golden corn",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/451767f4-a8f2-4bd8-8f3a-b231af4b1380_d9db553e-0496-4522-a60f-921bddd43805.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899755",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114956471",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827458",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114956475",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114956477",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114956478",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504635",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504636",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504637",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899756",
                                          "variationId": "114956479"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899756",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114956479",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114956480",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114956482",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504637"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504637"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504635"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504635"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504636"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "155504636"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956475"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956475"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956478"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956477"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956477"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "208827458"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "208827458"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 45900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956471"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956479"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511586",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511595",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511590",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956471"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956482"
                                      }
                                    ],
                                    "price": 64900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132511611",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132511600",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132511604",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899755",
                                        "variationId": "114956471"
                                      },
                                      {
                                        "groupId": "36899756",
                                        "variationId": "114956480"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511575",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511581",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511568",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132511586",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511590",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511595",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511568",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511575",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511581",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511600",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511604",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511611",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464102"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875468",
                              "name": "Peppy Paneer Pizza",
                              "category": "Dominos Classics",
                              "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/5d638141-3d2d-495d-ad9d-9778e6d3db45_bc5886b8-4158-466a-9cb6-9c86e83e3d51.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36900765",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114959414",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827455",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114959416",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114959417",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114959418",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504813",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504816",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504817",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900766",
                                          "variationId": "114959419"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36900766",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114959419",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114959420",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114959421",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504813"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504816"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504816"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504817"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504817"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "155504813"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959416"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959418"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959417"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959417"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "208827455"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "208827455"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959414"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959419"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513855",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513862",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959414"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959421"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132513908",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132513897",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132513904",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959414"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900765",
                                        "variationId": "114959416"
                                      },
                                      {
                                        "groupId": "36900766",
                                        "variationId": "114959420"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513882",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513890",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513874",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132513874",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513882",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513890",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513855",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513862",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513867",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513897",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513904",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513908",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464123"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876161",
                              "name": "Chicken Sausage Pizza",
                              "category": "Dominos Classics",
                              "description": "American classic! Spicy, herbed chicken sausage on pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ffe62bc6-19b6-43e4-9506-d4c88275b864_e8c91c25-9e61-4908-8d54-ee93d7c090d0.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899511",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114955750",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827464",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114955755",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114955758",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114955761",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504674",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504675",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504676",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899515",
                                          "variationId": "114955763"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899515",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114955763",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114955766",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114955768",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504675"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504675"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504676"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504676"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504674"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "155504674"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "208827464"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "208827464"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 43900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955750"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955750"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955768"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132511115",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132511096",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132511105",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955750"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955755"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955755"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955761"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955758"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955763"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511042",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511056",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511047",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899511",
                                        "variationId": "114955758"
                                      },
                                      {
                                        "groupId": "36899515",
                                        "variationId": "114955766"
                                      }
                                    ],
                                    "price": 42900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511077",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511087",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511066",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132511042",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511047",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511056",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511066",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511077",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511087",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511096",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511105",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511115",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464108"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876159",
                              "name": "Pepper Barbecue Chicken Pizza",
                              "category": "Dominos Classics",
                              "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a49624df-bc96-4b75-8901-1f07d73ef1ce_09bef26d-edfb-40e6-833f-6a4371b5393e.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36901567",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114961721",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827470",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114961723",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114961724",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114961725",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504782",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504783",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504784",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901568",
                                          "variationId": "114961726"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36901568",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114961726",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114961727",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114961728",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504783"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504783"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504784"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504784"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504782"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "155504782"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961724"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "208827470"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "208827470"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961721"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961721"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961728"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132515639",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132515624",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132515628",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961721"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961723"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961727"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515587",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515595",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515584",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961723"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961725"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901567",
                                        "variationId": "114961724"
                                      },
                                      {
                                        "groupId": "36901568",
                                        "variationId": "114961726"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515603",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515614",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515609",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132515603",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515609",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515614",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515584",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515587",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515595",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515624",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515628",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515639",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464122"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82816129",
                              "name": "Spiced Double Chicken",
                              "category": "Dominos Classics",
                              "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/e66b2bd4-c44e-4a44-99ca-429d547e7232_1b1f5906-8502-4c1f-97d4-151a72a87e0b.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544441",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "203295877",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827468",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "203295879",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295880",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "203295881",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295882",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295883",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295884",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544442",
                                          "variationId": "203295885"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544442",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295885",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295886",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "203295887",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295884"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295884"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295882"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295882"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295883"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295883"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295880"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295880"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 59900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "208827468"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "208827468"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295877"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 31500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295877"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295887"
                                      }
                                    ],
                                    "price": 84500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "249435306",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "249435304",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "249435305",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295877"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 56900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295879"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295886"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435302",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435303",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435301",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295879"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544441",
                                        "variationId": "203295881"
                                      },
                                      {
                                        "groupId": "67544442",
                                        "variationId": "203295885"
                                      }
                                    ],
                                    "price": 31500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435298",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435300",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435299",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435298",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435299",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435300",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435301",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435302",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435303",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435304",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435305",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435306",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 31500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "40638005"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876008",
                              "name": "Chicken Golden Delight Pizza",
                              "category": "Dominos Classics",
                              "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c9276156-1ce1-4886-b96e-9eb9e2b375d7_c96aa347-e7fb-4d44-a4b6-16be17763b55.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36898706",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114953374",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827466",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114953382",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114953385",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114953387",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504644",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504645",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504646",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36898710",
                                          "variationId": "114953390"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36898710",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114953390",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114953392",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114953394",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504645"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504646"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504646"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504644"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504644"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "155504645"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "208827466"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953374"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953374"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953394"
                                      }
                                    ],
                                    "price": 87900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132509368",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132509342",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132509355",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953374"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953382"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953382"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953387"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953385"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "114953385"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953392"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509285",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509300",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509272",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36898706",
                                        "variationId": "208827466"
                                      },
                                      {
                                        "groupId": "36898710",
                                        "variationId": "114953390"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509313",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509331",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509319",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132509272",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509285",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509300",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509313",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509319",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509331",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509342",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509355",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509368",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464106"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876017",
                              "name": "Chicken Pepperoni Pizza",
                              "category": "Dominos Classics",
                              "description": "A classic American taste! Relish the delectable flavor of Chicken Pepperoni, topped with extra cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3b206237-1d28-4df0-a32f-bfca54eb3482_2ecc8bfa-ec80-46b8-8aa2-d1b50c2fad79.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899023",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114954309",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827459",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114954311",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114954312",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114954313",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504749",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504751",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504753",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899024",
                                          "variationId": "114954314"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899024",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114954314",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114954315",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114954317",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504751"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504751"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504753"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504753"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504749"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "155504749"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "208827459"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "208827459"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 67900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954309"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954309"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954317"
                                      }
                                    ],
                                    "price": 96900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132510006",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132509997",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132510002",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954309"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954311"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954311"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954313"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954312"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954314"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509978",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132509984",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132509980",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899023",
                                        "variationId": "114954312"
                                      },
                                      {
                                        "groupId": "36899024",
                                        "variationId": "114954315"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132509991",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132509994",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132509988",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132509978",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509980",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509984",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509988",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509991",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509994",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132509997",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510002",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510006",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 37900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464107"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f3b8f6fb-bf73-4ee0-bed8-a6a57742f7cb_19f4a228-886b-4072-a5c8-3417090132ae.jpg",
                      "categoryId": "44665414"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cheese Burst - 3 New Flavours",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309623",
                              "name": "Peppy Paneer Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Flavorful trio of juicy paneer, crisp capsicum & spicy red paprika",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/166484ee-6de2-400c-a180-5ce9d6aa6ec1_b911a6b9-9824-46aa-98ee-e6deecf7d76f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583073",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505403",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583074",
                                          "variationId": "155505410"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505405",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583074",
                                          "variationId": "155505410"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505407",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583074",
                                          "variationId": "155505410"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505409",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583074",
                                          "variationId": "155505410"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583074",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505410",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018676",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505405"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "204018676"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076730",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505405"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "155505410"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777844",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505407"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "155505410"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777844",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505407"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "204018676"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076730",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505409"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "155505410"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777844",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505409"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "204018676"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076730",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505403"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "155505410"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777844",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777848",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777845",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583073",
                                        "variationId": "155505403"
                                      },
                                      {
                                        "groupId": "49583074",
                                        "variationId": "204018676"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076731",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076732",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076730",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "251076730",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076731",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076732",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777844",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777845",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777848",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232056"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309613",
                              "name": "Farmhouse Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion, capsicum, tomato & grilled mushroom",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/af94c8f2-d56f-4713-b645-73d9a4e314ad_160aa184-6015-4c41-9b9b-74e6b4e021ad.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583057",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505352",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583058",
                                          "variationId": "155505356"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505353",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583058",
                                          "variationId": "155505356"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505354",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583058",
                                          "variationId": "155505356"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505355",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583058",
                                          "variationId": "155505356"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583058",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505356",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018675",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505353"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "155505356"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777792",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505353"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "204018675"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076727",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505354"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "155505356"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777792",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505354"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "204018675"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076727",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505355"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "155505356"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777792",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505355"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "204018675"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076727",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505352"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "155505356"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777792",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777795",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777794",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583057",
                                        "variationId": "155505352"
                                      },
                                      {
                                        "groupId": "49583058",
                                        "variationId": "204018675"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076728",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076729",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076727",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777792",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777794",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777795",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076727",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076728",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076729",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232038"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309627",
                              "name": "Veggie Paradise Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Golden corn, black olives, capsicum & red paprika",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a8403e44-f6a6-45a6-942d-083b13f25d71_a2bdb589-ffe5-4f54-9aa4-76ab830285ea.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583081",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505430",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583082",
                                          "variationId": "155505434"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505431",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583082",
                                          "variationId": "155505434"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505432",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583082",
                                          "variationId": "155505434"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505433",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583082",
                                          "variationId": "155505434"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583082",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505434",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "155505435",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505431"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505434"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777865",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505431"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505435"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777869",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505432"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505434"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777865",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505432"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505435"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777869",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505433"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505434"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777865",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505433"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505435"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777869",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505430"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505434"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777865",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777867",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777866",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583081",
                                        "variationId": "155505430"
                                      },
                                      {
                                        "groupId": "49583082",
                                        "variationId": "155505435"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777870",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777872",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777869",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777865",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777866",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777867",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777869",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777870",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777872",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232059"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309585",
                              "name": "Margherita Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with delight of 100% real mozzarella cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2c8da055-745a-47be-8f17-2242747dc1d9_e2cd35f0-ee0e-4f52-aed1-2d476a8084ff.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583016",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505210",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583018",
                                          "variationId": "155505218"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505212",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583018",
                                          "variationId": "155505218"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505214",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583018",
                                          "variationId": "155505218"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505216",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583018",
                                          "variationId": "155505218"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583018",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505218",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018666",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505212"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "155505218"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777667",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505212"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "204018666"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076700",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505214"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "155505218"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777667",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505214"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "204018666"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076700",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505216"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "155505218"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777667",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505216"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "204018666"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076700",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505210"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "155505218"
                                      }
                                    ],
                                    "price": 18800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777667",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777672",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777669",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583016",
                                        "variationId": "155505210"
                                      },
                                      {
                                        "groupId": "49583018",
                                        "variationId": "204018666"
                                      }
                                    ],
                                    "price": 36400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076701",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076702",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076700",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777667",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777669",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777672",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076700",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076701",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076702",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232053"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309641",
                              "name": "Spiced Double Chicken Pizza",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Molten Cheese Indulgence with combination of Pepper Barbecue Chicken & Peri Peri Chicken for Chicken lovers",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b64ad8df-7d56-428f-9b04-07c5eb1891d0_1784820c-fedf-4bfa-b82f-5a50363aa4fc.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544457",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295902",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544458",
                                          "variationId": "203295906"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "203295903",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544458",
                                          "variationId": "203295906"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295904",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544458",
                                          "variationId": "203295906"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295905",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544458",
                                          "variationId": "203295906"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544458",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295906",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295907",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295902"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295906"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435307",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295902"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295907"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435310",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295903"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295907"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435310",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295903"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295906"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435307",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295904"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295906"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435307",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295904"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295907"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435310",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295905"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295906"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435307",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435309",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435308",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544457",
                                        "variationId": "203295905"
                                      },
                                      {
                                        "groupId": "67544458",
                                        "variationId": "203295907"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435311",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435312",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435310",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435307",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435308",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435309",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435310",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435311",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435312",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39400,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232057"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309601",
                              "name": "Mexican Green Wave Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/0132e103-601e-49fa-839b-1b948cc1f4e1_8c903c45-ef48-45ba-850d-95a102d3b5fe.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583043",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505304",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583045",
                                          "variationId": "155505312"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505306",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583045",
                                          "variationId": "155505312"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505308",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583045",
                                          "variationId": "155505312"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505310",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583045",
                                          "variationId": "155505312"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583045",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505312",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018674",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505306"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "155505312"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777751",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505306"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "204018674"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076724",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505308"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "155505312"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777751",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505308"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "204018674"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076724",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505310"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "155505312"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777751",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505310"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "204018674"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076724",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505304"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "155505312"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777751",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777755",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777753",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583043",
                                        "variationId": "155505304"
                                      },
                                      {
                                        "groupId": "49583045",
                                        "variationId": "204018674"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076725",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076726",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076724",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777751",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777753",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777755",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076724",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076725",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076726",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232054"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309642",
                              "name": "Pepper Barbecue Chicken Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Pepper Barbecue chicken for that extra zing",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/501f0609-997c-43b4-af61-7abb45174f09_3ba839be-1bc0-43f5-9b20-098833a043eb.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583097",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505481",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583098",
                                          "variationId": "155505485"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505482",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583098",
                                          "variationId": "155505485"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505483",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583098",
                                          "variationId": "155505485"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505484",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583098",
                                          "variationId": "155505485"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583098",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505485",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018667",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505482"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "155505485"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777913",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505482"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "204018667"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076703",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505483"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "155505485"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777913",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505483"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "204018667"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076703",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505484"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "155505485"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777913",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505484"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "204018667"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076703",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505481"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "155505485"
                                      }
                                    ],
                                    "price": 34800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777913",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777915",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777914",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583097",
                                        "variationId": "155505481"
                                      },
                                      {
                                        "groupId": "49583098",
                                        "variationId": "204018667"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076704",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076705",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076703",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777913",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777914",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777915",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076703",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076704",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076705",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 34800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232055"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309607",
                              "name": "Indi Tandoori Paneer Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with spicy tandoori paneer, capsicum, red paprika & mint mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/05e2ab77-50f3-4f49-b215-3e47867d20ea_7e4f4605-78b8-4857-b40e-057cd6085866.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583051",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505331",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583052",
                                          "variationId": "155505335"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505332",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583052",
                                          "variationId": "155505335"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505333",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583052",
                                          "variationId": "155505335"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505334",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583052",
                                          "variationId": "155505335"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583052",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505335",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018668",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505334"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "155505335"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777772",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505334"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "204018668"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076706",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505331"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "155505335"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777772",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505331"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "204018668"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076706",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505332"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "155505335"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777772",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505332"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "204018668"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076706",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505333"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "155505335"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777772",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777776",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777774",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583051",
                                        "variationId": "155505333"
                                      },
                                      {
                                        "groupId": "49583052",
                                        "variationId": "204018668"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076707",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076708",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076706",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777772",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777774",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777776",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076706",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076707",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076708",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 39800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232046"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309578",
                              "name": "Indi Chicken Tikka Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with wholesome flavour of tandoori masala topped with Chicken tikka, onion, red paprika & mint mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/12d5b6a4-5c65-4c46-8bd9-f6198c60a7dc_fe0ac536-86f3-475f-938c-4ef8ba7776e7.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583007",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505184",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583008",
                                          "variationId": "155505188"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505185",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583008",
                                          "variationId": "155505188"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505186",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583008",
                                          "variationId": "155505188"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505187",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583008",
                                          "variationId": "155505188"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583008",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505188",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018673",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505187"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "204018673"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076721",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505184"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "155505188"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777650",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505184"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "204018673"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076721",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505185"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "155505188"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777650",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505185"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "204018673"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076721",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505186"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "155505188"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777650",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505186"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "204018673"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076722",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076723",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076721",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583007",
                                        "variationId": "155505187"
                                      },
                                      {
                                        "groupId": "49583008",
                                        "variationId": "155505188"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777650",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777654",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777652",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "251076721",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076722",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076723",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777650",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777652",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777654",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 45800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232045"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309590",
                              "name": "Double Cheese Margherita Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with loaded delight of 100% real mozzarella cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/8117d0e0-b72c-4bcb-b669-bc0271a8e43a_608c4e3f-1265-4551-a291-b2e91888db41.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583027",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505250",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583028",
                                          "variationId": "155505257"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505251",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583028",
                                          "variationId": "155505257"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505252",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583028",
                                          "variationId": "155505257"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505254",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583028",
                                          "variationId": "155505257"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583028",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505257",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018669",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505251"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "155505257"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777702",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505251"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "204018669"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076709",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505252"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "155505257"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777702",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505252"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "204018669"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076709",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505254"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "155505257"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777702",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505254"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "204018669"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076709",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505250"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "155505257"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777702",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777705",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777703",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583027",
                                        "variationId": "155505250"
                                      },
                                      {
                                        "groupId": "49583028",
                                        "variationId": "204018669"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076710",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076711",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076709",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777702",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777703",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777705",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076709",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076710",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076711",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 30800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232037"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309548",
                              "name": "Cheese n Corn Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Molten Cheese Indulgence with a delectable combination of sweet & juicy golden corn",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3f0fdc90-df20-464e-b924-3050fc6328ae_d55ac1d7-c0e2-4b15-a2d7-0ec88b653ace.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49582965",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505028",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582966",
                                          "variationId": "155505034"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505029",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582966",
                                          "variationId": "155505034"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505030",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582966",
                                          "variationId": "155505034"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505032",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582966",
                                          "variationId": "155505034"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49582966",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505034",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "155505036",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505032"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505034"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777514",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505032"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505036"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777520",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505028"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505034"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777514",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505028"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505036"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777520",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505029"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505036"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777520",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505029"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505034"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777514",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505030"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505034"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777514",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777518",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777515",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582965",
                                        "variationId": "155505030"
                                      },
                                      {
                                        "groupId": "49582966",
                                        "variationId": "155505036"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777523",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777526",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777520",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777514",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777515",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777518",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777520",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777523",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777526",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 30800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232032"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309569",
                              "name": "Chicken Golden Delight Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Double pepper Barbecue chicken, golden corn and extra cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/17513a28-0c9c-47ba-bafd-2ed9ed51f651_977c1223-5874-48cc-9d4b-766301cbf627.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49582999",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505154",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583000",
                                          "variationId": "155505158"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505155",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583000",
                                          "variationId": "155505158"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505156",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583000",
                                          "variationId": "155505158"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505157",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583000",
                                          "variationId": "155505158"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583000",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505158",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "155505159",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505156"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505159"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777619",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505157"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505158"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777622",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505157"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505159"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777619",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505154"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505158"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777622",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505154"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505159"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777619",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505155"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505158"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777622",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505155"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505159"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "180777620",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "180777621",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "180777619",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582999",
                                        "variationId": "155505156"
                                      },
                                      {
                                        "groupId": "49583000",
                                        "variationId": "155505158"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777622",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777627",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777624",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777619",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777620",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777621",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777622",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777624",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777627",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 40800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232034"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309596",
                              "name": "Chicken Fiesta Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with Grilled chicken rashers, peri-peri chicken, onion & capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7cae987a-c5a3-4f96-ac79-e55cf3cf83d5_6ee2dd35-c12f-42e7-b6ac-3f9afe1ee8e0.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583035",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505277",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583037",
                                          "variationId": "155505284"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505278",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583037",
                                          "variationId": "155505284"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505279",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583037",
                                          "variationId": "155505284"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505281",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583037",
                                          "variationId": "155505284"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583037",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505284",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018670",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505278"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "204018670"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076712",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505278"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "155505284"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777735",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505279"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "155505284"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777735",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505279"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "204018670"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076712",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505281"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "155505284"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777735",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505281"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "204018670"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076712",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505277"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "155505284"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777735",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777740",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777737",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583035",
                                        "variationId": "155505277"
                                      },
                                      {
                                        "groupId": "49583037",
                                        "variationId": "204018670"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076713",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076714",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076712",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "251076712",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076713",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076714",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777735",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777737",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777740",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 40800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232033"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309565",
                              "name": "Fresh Veggie Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with combination of onion & capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/5a3de8b4-1bc5-4789-b07d-f6089e977699_3cbf85e9-61c3-4264-8d87-967e51965ddb.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49582991",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505127",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582992",
                                          "variationId": "155505131"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505128",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582992",
                                          "variationId": "155505131"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505129",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582992",
                                          "variationId": "155505131"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505130",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582992",
                                          "variationId": "155505131"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49582992",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505131",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018672",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505129"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "155505131"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777595",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505129"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "204018672"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076718",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505130"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "155505131"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777595",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505130"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "204018672"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076718",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505127"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "155505131"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777595",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505127"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "204018672"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076718",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505128"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "204018672"
                                      }
                                    ],
                                    "price": 50800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076719",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076720",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076718",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582991",
                                        "variationId": "155505128"
                                      },
                                      {
                                        "groupId": "49582992",
                                        "variationId": "155505131"
                                      }
                                    ],
                                    "price": 30800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777595",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777597",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777596",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777595",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777596",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777597",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076718",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076719",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076720",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 30800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232044"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309560",
                              "name": "Chicken Pepperoni Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic flavored Chicken Pepperoni, topped with extra cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/962e720c-79f7-41c4-bae3-5503b686e24a_33f01d77-fa11-4a22-aabf-193edad48c90.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49582983",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505100",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582984",
                                          "variationId": "155505104"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505101",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582984",
                                          "variationId": "155505104"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505102",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582984",
                                          "variationId": "155505104"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505103",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49582984",
                                          "variationId": "155505104"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49582984",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505104",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018671",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505101"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "204018671"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076715",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505101"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "155505104"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777574",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505102"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "155505104"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777574",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505102"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "204018671"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076715",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505103"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "155505104"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777574",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505103"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "204018671"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076715",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505100"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "155505104"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777574",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777580",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777576",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49582983",
                                        "variationId": "155505100"
                                      },
                                      {
                                        "groupId": "49582984",
                                        "variationId": "204018671"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076716",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076717",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076715",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "251076715",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076716",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076717",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777574",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777576",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777580",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 45800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232035"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309649",
                              "name": "Achari Do Pyaza Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with tangy & spicy achari flavours on a super cheesy onion pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/aabdc09a-f705-41bf-9f0f-6be3df250bc0_1e1235a1-1dcd-4906-836d-fc6d41cb5711.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544471",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295926",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544472",
                                          "variationId": "203295930"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "203295927",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544472",
                                          "variationId": "203295930"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295928",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544472",
                                          "variationId": "203295930"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295929",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544472",
                                          "variationId": "203295930"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544472",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295930",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295931",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295927"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295931"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435313",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295927"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295930"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435316",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295928"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295930"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435316",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295928"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295931"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435313",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295929"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295930"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435316",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295929"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295931"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435313",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295926"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295930"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435316",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435318",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435317",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544471",
                                        "variationId": "203295926"
                                      },
                                      {
                                        "groupId": "67544472",
                                        "variationId": "203295931"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435314",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435315",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435313",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435313",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435314",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435315",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435316",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435317",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435318",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232029"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309655",
                              "name": "The 5 Chicken Feast Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Molten Cheese Indulgence Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken MeatBalls, Chicken Tikka, herby Chicken Sausage & Chicken Keema",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/49a6ed84-cc8d-4ffb-b970-8bcf0d3e40ac_4f3de2ed-8869-49c5-8e9b-f5b9170686ad.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583115",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295436",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583117",
                                          "variationId": "155505545"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505536",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583117",
                                          "variationId": "155505545"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295437",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583117",
                                          "variationId": "155505545"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295438",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583117",
                                          "variationId": "155505545"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583117",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505545",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295439",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295436"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "203295439"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435271",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "155505536"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "203295439"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435271",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "155505536"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "155505545"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777975",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295437"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "155505545"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777975",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295437"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "203295439"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435271",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295438"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "155505545"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777975",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295438"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "203295439"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435272",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435273",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435271",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583115",
                                        "variationId": "203295436"
                                      },
                                      {
                                        "groupId": "49583117",
                                        "variationId": "155505545"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777975",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777978",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777977",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435271",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435272",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435273",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777975",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777977",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777978",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 48400,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232058"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309645",
                              "name": "Chicken Sausage Cheese Burst",
                              "category": "Cheese Burst - 3 New Flavours",
                              "description": "Now in 3 New Flavours - Molten Cheese Indulgence with American classic herbed chicken sausage",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/afcb1f3f-a4aa-45bd-b8da-c735f7d346cd_b19aa179-f5dc-4d48-aa7a-1f2f6e03c49d.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "49583103",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155505499",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583104",
                                          "variationId": "155505503"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "default": 1,
                                        "id": "155505500",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583104",
                                          "variationId": "155505503"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155505501",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583104",
                                          "variationId": "155505503"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155505502",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "49583104",
                                          "variationId": "155505503"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "49583104",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "155505503",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "204018665",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505500"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "155505503"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777931",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505500"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "204018665"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076697",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505501"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "155505503"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777931",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505501"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "204018665"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076697",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505502"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "155505503"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777931",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505502"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "204018665"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076697",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505499"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "155505503"
                                      }
                                    ],
                                    "price": 29800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "180777931",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "180777933",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "180777932",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "49583103",
                                        "variationId": "155505499"
                                      },
                                      {
                                        "groupId": "49583104",
                                        "variationId": "204018665"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "251076698",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "251076699",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "251076697",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "180777931",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777932",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "180777933",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076697",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076698",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "251076699",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 29800,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232036"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/166484ee-6de2-400c-a180-5ce9d6aa6ec1_b911a6b9-9824-46aa-98ee-e6deecf7d76f.jpg",
                      "categoryId": "54114014"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Big Big Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166941001",
                              "name": "Big Big 6in1 Pizza - Veg",
                              "category": "Big Big Pizza",
                              "description": "6 Veggie Blockbusters in 1 Epic Pan Pizza: Corn N Cheese, Peppy Paneer, Farmhouse, Mexican Green Wave, Veg Paradise, Margherita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a1c1ce99-5c73-4fc5-882a-71d2abf98d7c_6922fe24-b22b-4d0b-a86f-b05f309c168c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 79900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67237732",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "202581533",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67237733",
                                          "variationId": "202581534"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67237733",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large Plus",
                                        "default": 1,
                                        "id": "202581534",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67237732",
                                        "variationId": "202581533"
                                      },
                                      {
                                        "groupId": "67237733",
                                        "variationId": "202581534"
                                      }
                                    ],
                                    "price": 166900,
                                    "finalPrice": {
                                      "units": "799"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 166900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "0b7eafaf-5cd2-4586-8c3e-f8d725ac61e4",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "100631164",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "3:59 AM"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166941002",
                              "name": "Big Big 6in1 Pizza - Non Veg",
                              "category": "Big Big Pizza",
                              "description": "6 Chicken Bangers in 1 Epic Pan Pizza: Pepper Barbeque Chicken, Chicken Dominator, Chicken Fiesta, Spiced Double Chicken, Chicken Golden Delight",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c361ae1a-2b1d-459d-89bc-682d63416322_0f7b2ca8-c144-40db-8d36-684895417cb6.jpg",
                              "inStock": 1,
                              "finalPrice": 99900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544395",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "203295806",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544396",
                                          "variationId": "203295807"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544396",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large Plus",
                                        "default": 1,
                                        "id": "203295807",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544395",
                                        "variationId": "203295806"
                                      },
                                      {
                                        "groupId": "67544396",
                                        "variationId": "203295807"
                                      }
                                    ],
                                    "price": 219900,
                                    "finalPrice": {
                                      "units": "999"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 219900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "c95ccad2-2b7b-4f29-94f3-1b19f6c60f13",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "100631163",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "3:59 AM"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179060885",
                              "name": "Big Big 6in1 Pizza – Cheese Carnival",
                              "category": "Big Big Pizza",
                              "description": "6 irresistible cheese flavors packed into one epic pizza. Cheese Lava, Herbed Cheese, Margherita, Cheezy Burst, Cheese Overload, Cheddar Delight",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/19969c34-e561-4c95-a804-fe78aec1eea2_69d06869-19d3-4a0a-83a8-98471adfca33.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 99900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "64026235",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "195396633",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "64026236",
                                          "variationId": "195396635"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "64026236",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large Plus",
                                        "default": 1,
                                        "id": "195396635",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "64026235",
                                        "variationId": "195396633"
                                      },
                                      {
                                        "groupId": "64026236",
                                        "variationId": "195396635"
                                      }
                                    ],
                                    "price": 149900,
                                    "finalPrice": {
                                      "units": "999"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 149900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "c95ccad2-2b7b-4f29-94f3-1b19f6c60f13",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "108435347",
                              "offerCategory": "OFFER_CATEGORY_DEAL_RUSH",
                              "offerHeader": "Only till",
                              "offerSubHeader": "3:59 AM"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a1c1ce99-5c73-4fc5-882a-71d2abf98d7c_6922fe24-b22b-4d0b-a86f-b05f309c168c.jpg",
                      "categoryId": "59998118"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chicken Feast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176930031",
                              "name": "Chicken Platter for 4-Cream & Onion Dip",
                              "category": "Chicken Feast",
                              "description": "Combo of Grilled Wings, Spicy Chicken Pops, Juicy Boneless Chicken, Spicy Chicken Bomb , Chicken parcel with Cream and Onion Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/dec2e7c9-4425-4da6-b9b3-667c21621cd3_77071ec5-9341-43c2-8139-7f3cf460e618.jpg",
                              "inStock": 1,
                              "price": 75900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106869335"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176930028",
                              "name": "Chicken Platter for 2-Cream & Onion Dip",
                              "category": "Chicken Feast",
                              "description": "Combo of Spicy Chicken Pops, Juicy Boneless Chicken, Spicy Chicken Bomb , Chicken parcel with Cream and Onion Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/574dbca7-41e3-4873-96fb-77e44a0ffd8b_040e6cb3-662e-4be6-a835-b7f90998b899.jpg",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106869332"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170694054",
                              "name": "Saucy Boneless Chicken - Cream & Onion",
                              "category": "Chicken Feast",
                              "description": "Indulge in juicy boneless chicken with creamy onion dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fe259b69-750f-488b-b852-0fc400765b1c_6e014e13-d942-4c0b-aecb-b2f72f42f0d9.jpg",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102955885"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170694053",
                              "name": "Saucy Boneless Chicken - Peri Peri",
                              "category": "Chicken Feast",
                              "description": "Indulge in juicy boneless chicken with  fiery peri peri dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/72554be4-e411-4ac0-b7c1-7598a467e5a7_e1da0e9d-66f4-4b80-b24e-9dbfada6a721.jpg",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102955886"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170694052",
                              "name": "Saucy Chicken Pops - Cream & Onion",
                              "category": "Chicken Feast",
                              "description": "Indulge in spicy chicken Pops with creamy onion dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/23a2ddee-3a81-4f36-a1ff-c29b4b96a09a_3809d632-5e88-466b-8fd0-cd439099a233.jpg",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102955887"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170694051",
                              "name": "Saucy Chicken Pops - Peri Peri",
                              "category": "Chicken Feast",
                              "description": "Indulge in spicy chicken Pops with fiery peri peri dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b564a70b-0ebe-4e50-b702-90f2bbad4804_d2406516-c712-484d-a282-57f053a7b8fa.jpg",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102955888"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506602",
                              "name": "Juicy Boneless Chicken",
                              "category": "Chicken Feast",
                              "description": "Crispy, juicy boneless thighs seasoned with flavorful chili for a delicious spicy kick. Crunchy on the outside, tender on the inside!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/40425e00-33c3-4eea-84d7-86b230c5a2b9_8a99424e-fc00-426c-8883-18b0119e20e6.jpg",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "103061231"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506607",
                              "name": "Grilled Wings Signature Garlic",
                              "category": "Chicken Feast",
                              "description": "Juicy grilled chicken wings roasted with bold garlic flavors for a delicious taste!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ef1d0754-4b3e-4cfc-adac-0e492cd0a7a5_7a2c79cf-f361-431a-9efe-0a9d7f3faf41.jpg",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "98465887"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506603",
                              "name": "Grilled Wings Lemon Pepper",
                              "category": "Chicken Feast",
                              "description": "Juicy grilled chicken wings roasted with zesty lemon pepper seasoning for a delicious taste!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/0babdc2a-0fd9-47b8-af93-5b02500209e9_586ac944-0d5a-45f3-9230-dfe617c5f05a.jpg",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "98335692"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506606",
                              "name": "Grilled wings Southern Spice",
                              "category": "Chicken Feast",
                              "description": "Juicy grilled chicken wings roasted with rich Southern spices for a delicious flavor!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/60e0d30c-d472-4b5f-80cc-ae2a8fee2755_73034cb3-cddb-4b54-b679-b318c61e216c.jpg",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "98408101"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820941",
                              "name": "Mini Garlic Cheesiken Rice",
                              "category": "Chicken Feast",
                              "description": "Juicy Chicken| Creamy Garlic Sauce| Molten Cheese with Rice & Veggies - Onion, Jalapeno & Capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c3acb9ae-9e33-4b5c-af4e-21e4fd54f5bd_f192dec5-9c6b-41ad-b262-aaabae80b9af.jpg",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91296338"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820944",
                              "name": "Mini Tangy Tomato Cheesiken Rice",
                              "category": "Chicken Feast",
                              "description": "Tender Chicken| Zesty Tomato Sauce| Molten Cheese with Rice & Veggies - Onion, Paprika & Capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/78db312a-2d32-4bc2-ba29-875b02e8c47d_56ed2c16-856e-4c2c-b0ce-6e37e6816a07.jpg",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "92763095"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820952",
                              "name": "Mini Hot & Fiery Cheesiken Rice",
                              "category": "Chicken Feast",
                              "description": "Tender Chicken| Guntur Chilli Sauce| Molten Cheese with Rice & Veggies - Onion, Olive & Capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b31dfeeb-7521-4db8-90a2-338e1d83d479_880ff7f0-b97a-49cd-a68a-d7a722fe748e.jpg",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91296339"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820949",
                              "name": "Spicy Chicken Pops",
                              "category": "Chicken Feast",
                              "description": "Crispy Chicken Popcorn| Bold Chilli sprinkle| Fiery burst of flavour",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c16ffbea-f2bf-4e50-a73c-bf7e3378bfd3_fffdf018-5323-4245-b137-e525c0dabf9c.jpg",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85629032"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820942",
                              "name": "Spicy Chicken Bombs",
                              "category": "Chicken Feast",
                              "description": "Tender & Juicy Meat Balls| Guntur Chilli Seasoning | Bliss for Chicken Lovers",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7a243b7a-9764-4ef9-8bc7-5f5d09a0779b_c9171237-1e65-41d8-9105-16f1f8b5c205.jpg",
                              "inStock": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "103061232"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820946",
                              "name": "Garlic Cheesiken",
                              "category": "Chicken Feast",
                              "description": "Tender Chicken| Creamy Garlic Sauce| Molten cheese| Crunchy Veggies - Onion, Paprika & Capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/556f072a-cbe6-4053-aed1-402918830a47_67d3056e-6901-4965-8b4d-491b2fa55f0e.jpg",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85629023"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155820947",
                              "name": "Hot & Fiery Cheesiken",
                              "category": "Chicken Feast",
                              "description": "Juicy Chicken| Spicy Guntur Chilli Sauce | Molten Cheese with Veggies - Onion, Black Olives & Capsicum",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/697af5df-daf4-467e-b825-03139ecd70df_e5191e5c-cd11-4ea0-b12e-ae1b704ef0e3.jpg",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85629025"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176930030",
                              "name": "Chicken Platter for 2-Peri Peri Dip",
                              "category": "Chicken Feast",
                              "description": "Combo of Spicy Chicken Pops, Juicy Boneless Chicken, Spicy Chicken Bomb , Chicken parcel with Peri Peri Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f7cb1697-ada8-46ee-8a54-63d8c0064e2f_2d758184-ba9c-42f2-a0f4-33f6b05c2c69.jpg",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106869334"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176930033",
                              "name": "Chicken Platter for 4-Peri Peri Dip",
                              "category": "Chicken Feast",
                              "description": "Combo of Grilled Wings, Spicy Chicken Pops, Juicy Boneless Chicken, Spicy Chicken Bomb , Chicken parcel with Peri Peri Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/04ca556e-8e2e-4896-9612-39c00afd70df_b76a8e8e-65f6-4be6-ab8d-fae06b53ae43.jpg",
                              "inStock": 1,
                              "price": 75900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106869337"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/dec2e7c9-4425-4da6-b9b3-667c21621cd3_77071ec5-9341-43c2-8139-7f3cf460e618.jpg",
                      "categoryId": "55293066"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chicken Burst",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791606",
                              "name": "Garlic Chicken Burst Pizza (Reg)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Garlic Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/e16ba216-123e-4f1b-a28c-216b72161b92_44dddb6d-ddfc-4fcc-83d1-5ce7e301b7ea.jpg",
                              "inStock": 1,
                              "finalPrice": 35900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "69275506",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "207246868",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69275507",
                                          "variationId": "207246869"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "69275507",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "207246869",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69275506",
                                        "variationId": "207246868"
                                      },
                                      {
                                        "groupId": "69275507",
                                        "variationId": "207246869"
                                      }
                                    ],
                                    "price": 44900,
                                    "finalPrice": {
                                      "units": "359"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "0f5b61c2-829a-4f27-8f43-bfe6444af2e3",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174620"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791619",
                              "name": "Tandoori Chicken Burst Pizza (Reg)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Tandoori Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/db550c2d-83a3-4af5-9bc6-0f8a38e2f7c5_90077b74-0364-4a1d-89f4-70ccb8fcff5a.jpg",
                              "inStock": 1,
                              "finalPrice": 35900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "61427356",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "189307019",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "61427357",
                                          "variationId": "189307020"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "61427357",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "189307020",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "61427356",
                                        "variationId": "189307019"
                                      },
                                      {
                                        "groupId": "61427357",
                                        "variationId": "189307020"
                                      }
                                    ],
                                    "price": 44900,
                                    "finalPrice": {
                                      "units": "359"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "0f5b61c2-829a-4f27-8f43-bfe6444af2e3",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174628"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791622",
                              "name": "Korean Chicken Burst Pizza (Reg)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Korean Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/237f6ffa-e9dd-4d5b-98d3-f99cf62ca699_6b5cd024-631f-4108-85a5-73273b616f96.jpg",
                              "inStock": 1,
                              "finalPrice": 35900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "61427358",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "189307021",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "61427359",
                                          "variationId": "189307022"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "61427359",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "189307022",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "61427358",
                                        "variationId": "189307021"
                                      },
                                      {
                                        "groupId": "61427359",
                                        "variationId": "189307022"
                                      }
                                    ],
                                    "price": 44900,
                                    "finalPrice": {
                                      "units": "359"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "0f5b61c2-829a-4f27-8f43-bfe6444af2e3",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174622"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791610",
                              "name": "Southern Spice Chicken Burst Pizza (Reg)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Guntur Chilli Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/76f32ffd-4c34-4cdb-936b-2fcd2c98b862_60539b6e-7bab-46fd-bf5c-1fd00c9b33e6.jpg",
                              "inStock": 1,
                              "finalPrice": 35900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "61427344",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "189307007",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "61427345",
                                          "variationId": "189307008"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "61427345",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "189307008",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "61427344",
                                        "variationId": "189307007"
                                      },
                                      {
                                        "groupId": "61427345",
                                        "variationId": "189307008"
                                      }
                                    ],
                                    "price": 44900,
                                    "finalPrice": {
                                      "units": "359"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "0f5b61c2-829a-4f27-8f43-bfe6444af2e3",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174626"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791613",
                              "name": "Tandoori Chicken Burst Pizza (Med)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Tandoori Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/db550c2d-83a3-4af5-9bc6-0f8a38e2f7c5_90077b74-0364-4a1d-89f4-70ccb8fcff5a.jpg",
                              "inStock": 1,
                              "finalPrice": 66900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67854826",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "204018681",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67854827",
                                          "variationId": "204018682"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67854827",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204018682",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67854826",
                                        "variationId": "204018681"
                                      },
                                      {
                                        "groupId": "67854827",
                                        "variationId": "204018682"
                                      }
                                    ],
                                    "price": 84900,
                                    "finalPrice": {
                                      "units": "669"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 84900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "5bc72555-9948-4094-91db-4bdc81e10f99",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174627"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791616",
                              "name": "Garlic Chicken Burst Pizza (Med)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Garlic Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/e16ba216-123e-4f1b-a28c-216b72161b92_44dddb6d-ddfc-4fcc-83d1-5ce7e301b7ea.jpg",
                              "inStock": 1,
                              "finalPrice": 66900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "69275508",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "207246870",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69275509",
                                          "variationId": "207246871"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "69275509",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "207246871",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69275508",
                                        "variationId": "207246870"
                                      },
                                      {
                                        "groupId": "69275509",
                                        "variationId": "207246871"
                                      }
                                    ],
                                    "price": 84900,
                                    "finalPrice": {
                                      "units": "669"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 84900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "5bc72555-9948-4094-91db-4bdc81e10f99",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174619"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791608",
                              "name": "Korean Chicken Burst Pizza (Med)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Korean Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/237f6ffa-e9dd-4d5b-98d3-f99cf62ca699_6b5cd024-631f-4108-85a5-73273b616f96.jpg",
                              "inStock": 1,
                              "finalPrice": 66900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67854824",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "204018679",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67854825",
                                          "variationId": "204018680"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67854825",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204018680",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67854824",
                                        "variationId": "204018679"
                                      },
                                      {
                                        "groupId": "67854825",
                                        "variationId": "204018680"
                                      }
                                    ],
                                    "price": 84900,
                                    "finalPrice": {
                                      "units": "669"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 84900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "5bc72555-9948-4094-91db-4bdc81e10f99",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174621"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "173791604",
                              "name": "Southern Spice Chicken Burst Pizza (Med)",
                              "category": "Chicken Burst",
                              "description": "Ultimate 2-layered Chicken Indulgence. Stuffed inside with juicy, garlicky chicken keema & topped with a medley of Peri Peri, BBQ & Chicken Rashers , finished with a drizzle of Guntur Chilli Sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/76f32ffd-4c34-4cdb-936b-2fcd2c98b862_60539b6e-7bab-46fd-bf5c-1fd00c9b33e6.jpg",
                              "inStock": 1,
                              "finalPrice": 66900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67854822",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "204018677",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67854823",
                                          "variationId": "204018678"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67854823",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "204018678",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67854822",
                                        "variationId": "204018677"
                                      },
                                      {
                                        "groupId": "67854823",
                                        "variationId": "204018678"
                                      }
                                    ],
                                    "price": 84900,
                                    "finalPrice": {
                                      "units": "669"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 84900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "5bc72555-9948-4094-91db-4bdc81e10f99",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106174625"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/e16ba216-123e-4f1b-a28c-216b72161b92_44dddb6d-ddfc-4fcc-83d1-5ce7e301b7ea.jpg",
                      "categoryId": "63174268"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Garlic Breads & Dips",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309638",
                              "name": "Korean Paneer Tikka Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Stuffed Garlic Bread infused with Korean Sweet Chili Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cd653a3b-884e-4076-8476-59391bd07cb1_a31db475-073d-4623-88f4-0df8155088ca.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232048"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51158140",
                              "name": "Tomato Ketchup",
                              "category": "Garlic Breads & Dips",
                              "description": "Goodness of Tomato Ketchup in mini sachets",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6b00b0e1-0371-4cb9-bda3-a26d3b5e2a0a_dd751008-4a64-46f7-93e9-df83ee306698.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 190,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "52 ratings",
                                  "ratingCountV2": "52"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974234"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876249",
                              "name": "Classic Stuffed Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly baked garlic bread with cheese, juicy corn & tangy jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fe8a7fad-1c1d-48c0-9469-4bdbba459c69_4f8d230e-53c3-4a08-b7aa-c62f609f355b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "105 ratings",
                                  "ratingCountV2": "105"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974004"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309633",
                              "name": "Makhani Pepperoni Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Garlic Bread infused with Creamy Makhani Sauce, Delectable Chicken Pepperoni & molten Cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/1633c3bd-9b6d-4808-b519-138bae2eaf51_1c1d2272-8ead-4aaf-a67c-3ddea551a90e.jpg",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232052"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309600",
                              "name": "Fiery Pepperoni Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Garlic Bread infused with Spicy Guntur Sauce, Delectable Chicken Pepperoni & molten Cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/910e46d9-d310-4d0f-bd0c-33cc8dcceb28_2b383e22-a5fc-47df-b711-203bc0560256.jpg",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875315",
                              "name": "Paneer Tikka Stuffed Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Stuffed Garlic Bread with Cheese, Onion and Paneer Tikka fillings. Comes with a dash of Basil Parsley Sprinkle on top",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/61dbb54c-d51f-4965-b7a3-2ce569a9ce63_a0b9b47a-6de6-4040-b59f-14651dc46ae4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974163"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876235",
                              "name": "Garlic Breadsticks",
                              "category": "Garlic Breads & Dips",
                              "description": "Baked to perfection. Your perfect pizza partner! Tastes best with dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7c0b042d-7bc4-4ff8-945d-4c6e7c4ff313_f46d1f9f-5ffa-4e74-8e9e-c0c26ad4fb60.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "80 ratings",
                                  "ratingCountV2": "80"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "20974085"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309653",
                              "name": "Makhani Corn & Jalapeno Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly baked garlic bread infused with Creamy Makhani Sauce, Molten cheese, juicy corn & tangy jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ef43452b-cf7b-4c7a-8601-d880fdb6270e_cbc1383c-da05-4f61-b767-8db4508fd980.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232050"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309556",
                              "name": "Makhani Paneer Tikka Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Stuffed Garlic Bread infused with Creamy Makhani Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/597ab5f8-df16-4a66-99a5-64579db7cf3c_62c9f964-82c7-4b86-a9da-4204736b635f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232051"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876243",
                              "name": "Cheesy Dip",
                              "category": "Garlic Breads & Dips",
                              "description": "An all-time favorite with your Garlic Breadsticks & Stuffed Garlic Bread for a Cheesy indulgence",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b73a9c35-8c36-4bf9-9ceb-768ac04a4fff_cdbeca03-f247-496e-b7da-416665e8348d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2757,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973966"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309639",
                              "name": "Fiery Corn & Jalapeno Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly baked garlic bread infused with Spicy Guntur Sauce, Molten cheese, juicy corn & tangy jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2c1f47c7-2e61-4746-8a83-2e6b46cf7d30_9b8f0834-8474-4780-ad86-51896a5c21d3.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232039"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309559",
                              "name": "Fiery Paneer Tikka Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Stuffed Garlic Bread infused with Spicy Guntur Sauce, Molten Cheese, Onion and Paneer Tikka fillings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/437a1732-acc7-4918-b2f7-28a51598d732_ee2ad49f-e6f3-4aca-a690-b4d46814f708.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232041"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875319",
                              "name": "Chicken Pepperoni Stuffed Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Garlic Bread stuffed with Delectable Chicken Pepperoni, Cheese and sprinkled with Basil Parsley",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/4f723227-07b6-4223-8ef4-d8f5d6e88669_bf322915-c11c-460d-bf9d-c0cf3df8ef7c.jpg",
                              "inStock": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973988"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309622",
                              "name": "Korean Corn & Jalapeno Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly baked garlic bread infused with Korean Sweet Chili Sauce, Molten cheese, juicy corn & tangy jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/577e3849-7b77-4be2-9638-72978052993d_ee21d0f2-9ff2-4330-9277-fc354dc49cd9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232047"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153309595",
                              "name": "Korean Pepperoni Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Freshly Baked Garlic Bread infused with Korean Sweet Chili Sauce, Delectable Chicken Pepperoni & molten Cheese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/78f07b09-8e5f-4be7-bd2b-15a47763472f_2953856b-9df3-44e4-a0bf-85b8b4263e8d.jpg",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "91232049"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121323662",
                              "name": "Garlic Breadsticks + Cheesy Dip",
                              "category": "Garlic Breads & Dips",
                              "description": "Enjoy the all-time favorite Garlic Breadsticks with the indulgent Cheesy Dip",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/8f05ff89-cedc-49f0-9777-244d34b119f0_d471203a-6884-4696-9555-c105e2fbc9f2.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15257,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "69583294"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115658374",
                              "name": "Garlic Breadsticks + Beverage",
                              "category": "Garlic Breads & Dips",
                              "description": "Enjoy the all time favourite Garlic Breadsticks with Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/27/16b374df-c88e-4f44-841b-23e10595caf6_33a51a48-0931-44e7-937a-2ad63d3626e0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102026807"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186252787",
                              "name": "Sourdough Garlic Bread",
                              "category": "Garlic Breads & Dips",
                              "description": "Golden sourdough baked with garlic butter and herbs. Crisp outside, fluffy inside.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/7/689b6228-8e8b-403f-bf84-6c775744f50e_1f1c3d20-7cbe-4fe4-81ed-2096c2157b58.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "113249050"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506604",
                              "name": "Cream and Onion Dip",
                              "category": "Garlic Breads & Dips",
                              "description": "A rich and creamy dip with a delicious blend of onion and spices, inspired by international flavors!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/85cc1832-b28c-4086-ac02-6bb4aeb377aa_28d5c177-43ed-4f61-bc0f-7c39693c5787.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "98335691"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163506605",
                              "name": "Peri Peri Dip",
                              "category": "Garlic Breads & Dips",
                              "description": "A spicy and tangy dip with bold peri peri flavors!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/8472a77d-5af8-4043-8091-2a4cbed8dcc7_4d11befa-0889-4030-8271-8898e2e2ee9e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "98335695"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cd653a3b-884e-4076-8476-59391bd07cb1_a31db475-073d-4623-88f4-0df8155088ca.jpg",
                      "categoryId": "39982883"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Loaded Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875718",
                              "name": "Veggie Paradise Pizza",
                              "category": "Loaded Pizza",
                              "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c0087dff-4d75-49b0-8896-6e7335a1ab1f_4ef1e8fe-b323-4622-9840-457b399dc0dd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899917",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114956959",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827471",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114956963",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114956964",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114956966",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504692",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504693",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504695",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899918",
                                          "variationId": "114956967"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899918",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114956967",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114956968",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114956969",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504693"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504693"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504695"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504695"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504692"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "155504692"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956959"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956959"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956969"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132511974",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132511956",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132511965",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956959"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956963"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956963"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956966"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956964"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "114956964"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "208827471"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956967"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511936",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511951",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511942",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899917",
                                        "variationId": "208827471"
                                      },
                                      {
                                        "groupId": "36899918",
                                        "variationId": "114956968"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511984",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511986",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511978",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132511936",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511942",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511951",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511978",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511984",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511986",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511956",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511965",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511974",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464125"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875463",
                              "name": "Farmhouse Pizza",
                              "category": "Loaded Pizza",
                              "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3bf9271f-30b4-49ad-975b-d593c89ec049_3e0d37d9-cb4d-41b2-9e7d-55af5b187dcc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899190",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114954781",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827461",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114954784",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114954786",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114954787",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504707",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504709",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899193",
                                          "variationId": "114954789"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899193",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114954789",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114954791",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114954793",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504708"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504708"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504709"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504709"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504707"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "155504707"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954781"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954781"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954793"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132510340",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132510333",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132510337",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954781"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954784"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954784"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954787"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954786"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "114954786"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "208827461"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954789"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510330",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510326",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899190",
                                        "variationId": "208827461"
                                      },
                                      {
                                        "groupId": "36899193",
                                        "variationId": "114954791"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132510349",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132510355",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132510345",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132510323",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510326",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510330",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510345",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510349",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510355",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510333",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510337",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510340",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464111"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875474",
                              "name": "Mexican Green Wave Pizza",
                              "category": "Loaded Pizza",
                              "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f7b42751-d246-4f5a-9a23-7848e21982d9_d9178f86-cbe0-411e-9dca-908d61393885.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36901482",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114961453",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827472",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114961461",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114961465",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114961469",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504689",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504690",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504691",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901487",
                                          "variationId": "114961476"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36901487",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114961476",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114961482",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114961487",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504690"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504690"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504691"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504691"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504689"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "155504689"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "208827472"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961453"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961453"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961487"
                                      }
                                    ],
                                    "price": 73900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132515430",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132515419",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132515423",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961453"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 48900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961461"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 58800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961461"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961469"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961465"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "114961465"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961482"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515374",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515387",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515364",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901482",
                                        "variationId": "208827472"
                                      },
                                      {
                                        "groupId": "36901487",
                                        "variationId": "114961476"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515397",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515412",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515403",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132515397",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515403",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515412",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515364",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515374",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515387",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515419",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515423",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515430",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464118"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875710",
                              "name": "Veg Extravaganza Pizza",
                              "category": "Loaded Pizza",
                              "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/aeab8204-a5eb-4d40-b28d-1698739ac6e4_48a6c8f8-8d95-49da-be7d-6bf470f8a0b2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36900537",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114958727",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900539",
                                          "variationId": "114958738"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827463",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900539",
                                          "variationId": "114958738"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114958731",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900539",
                                          "variationId": "114958738"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114958733",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900539",
                                          "variationId": "114958738"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114958735",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900539",
                                          "variationId": "114958738"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36900539",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114958738",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114958740",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114958742",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958727"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958740"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513309",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958731"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958740"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513309",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958731"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958738"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958735"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958738"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958733"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958738"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958733"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958740"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513309",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "208827463"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958738"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "208827463"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958740"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132513313",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132513318",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132513309",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958727"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958738"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513323",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132513339",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132513328",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900537",
                                        "variationId": "114958727"
                                      },
                                      {
                                        "groupId": "36900539",
                                        "variationId": "114958742"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132513385",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132513356",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132513369",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132513309",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513313",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513318",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513323",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513328",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513339",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513356",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513369",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132513385",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 31900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464124"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "75125215",
                              "name": "Cheese Overload",
                              "category": "Loaded Pizza",
                              "description": "Cheese Overloaded Pizza with a medley of Mozzarella, Cheddar & Ghost Pepper flavoured Cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/522805ac-7a58-4740-a74d-35b1ff5da799_424828d8-c954-4cb8-84d9-329f9a5499c4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "69412870",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "207538755",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69412871",
                                          "variationId": "207538759"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827457",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69412871",
                                          "variationId": "207538759"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "207538757",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69412871",
                                          "variationId": "207538759"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "207538758",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69412871",
                                          "variationId": "207538759"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "69412871",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "207538759",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "207538760",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "207538761",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538755"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538759"
                                      }
                                    ],
                                    "price": 35500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528886",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538755"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538761"
                                      }
                                    ],
                                    "price": 97900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "262528891",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "262528889",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "262528890",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538755"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538760"
                                      }
                                    ],
                                    "price": 64900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "262528892",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538758"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538759"
                                      }
                                    ],
                                    "price": 35500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528886",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538757"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538759"
                                      }
                                    ],
                                    "price": 38500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528886",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "207538757"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538760"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "262528892",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "208827457"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538759"
                                      }
                                    ],
                                    "price": 38500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528886",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "262528888",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "262528887",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69412870",
                                        "variationId": "208827457"
                                      },
                                      {
                                        "groupId": "69412871",
                                        "variationId": "207538760"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "262528893",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "262528894",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "262528892",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "262528886",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528887",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528888",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528889",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528890",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528891",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528892",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528893",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "262528894",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "79770944"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876154",
                              "name": "Chicken Fiesta Pizza",
                              "category": "Loaded Pizza",
                              "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ef203e49-cba2-496e-9f26-60b1036b768e_598239eb-ad39-44c1-9be3-1cd84d6e602c.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899579",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114955942",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827454",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114955947",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114955949",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114955951",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504866",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504867",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504868",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899582",
                                          "variationId": "114955953"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899582",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114955953",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114955955",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114955958",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504868"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504866"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504866"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504867"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504867"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "155504868"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955947"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 40800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955951"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955949"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955949"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "208827454"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 35900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "208827454"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955942"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955953"
                                      }
                                    ],
                                    "price": 32900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511170",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132511183",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132511178",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955942"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955958"
                                      }
                                    ],
                                    "price": 87900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132511212",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132511203",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132511207",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955942"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899579",
                                        "variationId": "114955947"
                                      },
                                      {
                                        "groupId": "36899582",
                                        "variationId": "114955955"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132511192",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132511198",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132511189",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132511189",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511192",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511198",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511170",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511178",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511183",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511203",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511207",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132511212",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464105"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876002",
                              "name": "Chicken Dominator Pizza",
                              "category": "Loaded Pizza",
                              "description": "Loaded with double pepper barbecue chicken, peri-peri chicken, chicken tikka & grilled chicken rashers. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3a38b46d-180c-4ac0-be57-d84080dc9691_733d49dd-d4d2-48eb-84a7-4f3dbc77f77c.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544293",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "203295643",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544294",
                                          "variationId": "203295649"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827460",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544294",
                                          "variationId": "203295649"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "203295646",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544294",
                                          "variationId": "203295649"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295647",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544294",
                                          "variationId": "203295649"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "203295648",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544294",
                                          "variationId": "203295649"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544294",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295649",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295650",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "203295651",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295643"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295649"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435274",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295643"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295651"
                                      }
                                    ],
                                    "price": 96900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "249435279",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "249435277",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "249435278",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295643"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295650"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435280",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295646"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295650"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435280",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295646"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295649"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435274",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295648"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295649"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435274",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295647"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295649"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435274",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "203295647"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295650"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435280",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "208827460"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295649"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435274",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435276",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435275",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544293",
                                        "variationId": "208827460"
                                      },
                                      {
                                        "groupId": "67544294",
                                        "variationId": "203295650"
                                      }
                                    ],
                                    "price": 67900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435281",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435282",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435280",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435274",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435275",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435276",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435277",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435278",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435279",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435280",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435281",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435282",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 37900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464104"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876011",
                              "name": "Non Veg Supreme Pizza",
                              "category": "Loaded Pizza",
                              "description": "Supreme combination of black olives, onion, capsicum, grilled mushroom, pepper barbecue chicken, peri-peri chicken & grilled chicken rashers",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/de6c6a94-e7c2-4fb2-b0d4-24eb8ff946ba_cacc65e1-328a-4b9d-b33b-291ed4695d47.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36901527",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114961599",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901530",
                                          "variationId": "114961615"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827467",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901530",
                                          "variationId": "114961615"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114961605",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901530",
                                          "variationId": "114961615"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114961608",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901530",
                                          "variationId": "114961615"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114961610",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36901530",
                                          "variationId": "114961615"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36901530",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114961615",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114961617",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114961621",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961605"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961617"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515487",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961605"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961615"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515516",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961610"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961615"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515516",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961608"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961615"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515516",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961608"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961617"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515487",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "208827467"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961615"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515516",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "208827467"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961617"
                                      }
                                    ],
                                    "price": 67900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515487",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961599"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961615"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515516",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132515531",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132515524",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961599"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961621"
                                      }
                                    ],
                                    "price": 96900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132515549",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132515538",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132515542",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36901527",
                                        "variationId": "114961599"
                                      },
                                      {
                                        "groupId": "36901530",
                                        "variationId": "114961617"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132515495",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132515505",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132515487",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132515487",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515495",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515505",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515516",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515524",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515531",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515538",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515542",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132515549",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 37900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464119"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82816183",
                              "name": "The 5 Chicken Feast Pizza",
                              "category": "Loaded Pizza",
                              "description": "Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken Meatballs, Chicken Tikka, herby Chicken Sausage and flavorful Chicken Keema",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a05d07cf-3c42-429e-b4fe-2400e4f32fd8_0a802bdc-5640-4289-ae04-0fd8fe6ddb25.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899062",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "203295333",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827473",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114954438",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295335",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "203295336",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295337",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295339",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295340",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899064",
                                          "variationId": "114954441"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899064",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114954441",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295343",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "203295345",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295337"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295339"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295339"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295340"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295340"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295337"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295335"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 43500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295335"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "208827473"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 43500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "208827473"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 75900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295333"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 40500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295333"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295345"
                                      }
                                    ],
                                    "price": 104900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "249435270",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "249435268",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "249435269",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295333"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 70900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "114954438"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "203295343"
                                      }
                                    ],
                                    "price": 80800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435266",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435267",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435265",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "114954438"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 48400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899062",
                                        "variationId": "203295336"
                                      },
                                      {
                                        "groupId": "36899064",
                                        "variationId": "114954441"
                                      }
                                    ],
                                    "price": 40500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132510080",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132510088",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132510084",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435265",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435266",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435267",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510080",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510084",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132510088",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435268",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435269",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435270",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 40500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "40638006"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c0087dff-4d75-49b0-8896-6e7335a1ab1f_4ef1e8fe-b323-4622-9840-457b399dc0dd.jpg",
                      "categoryId": "45390314"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tacos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179543607",
                              "name": "Tandoori Loaded Veg Taco (Single)",
                              "category": "Tacos",
                              "description": "Taco stuffed with tandoori-spiced paneer and fresh veggies for a bold Indian twist.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/f487f461-aa8c-49db-b438-cd4544bbb62e_f07805b0-74ab-47db-b80f-9876c20f4480.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "finalPrice": 9000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "7ab14d82-fe50-4c22-aed8-3e5884fbbb04"
                              ],
                              "parentId": "108666229"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876250",
                              "name": "Taco Mexicana Non Veg",
                              "category": "Tacos",
                              "description": "Truly irresistible! Crispy taco with non-veg patty & creamy harissa sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/5b39fa33-3d72-4098-bdc3-aec5215e4654_a818518c-135a-4467-b240-12efcbbe94d2.jpg",
                              "inStock": 1,
                              "price": 18500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974225"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179543606",
                              "name": "Tandoori Loaded Veg Taco",
                              "category": "Tacos",
                              "description": "Stuffed with tandoori-spiced paneer for a bold Indian twist. Double tacos for double fun",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/62a0ad9e-76e9-4300-a82a-5b3779357628_499c822a-2d93-4172-9359-bea429bdc3c1.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33900,
                              "finalPrice": 17000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "7ab14d82-fe50-4c22-aed8-3e5884fbbb04",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "108666228"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876251",
                              "name": "Taco Mexicana Veg",
                              "category": "Tacos",
                              "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/994ce161-003e-4425-b6c8-b5c397c487f8_7b5207b3-f8a5-419b-a338-5520bbc898f4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974226"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93083174",
                              "name": "Taco Mexicana Veg (Single)",
                              "category": "Tacos",
                              "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/9065de03-1ecf-4367-aaf4-c631c1c9cdbe_3cdb013b-5190-4c73-9060-074b31b13b65.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "105 ratings",
                                  "ratingCountV2": "105"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974227"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179543608",
                              "name": "Tandoori Loaded Chicken Taco",
                              "category": "Tacos",
                              "description": "Filled with chicken in a sweet-spicy Korean chilli sauce for a delicious fusion bite. Double tacos for double fun",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/6e075ee6-8dbf-4ad0-b711-340484092a06_b353ff57-920f-4b35-81e7-feae9c3e9655.jpg",
                              "inStock": 1,
                              "price": 39900,
                              "finalPrice": 20000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "7ab14d82-fe50-4c22-aed8-3e5884fbbb04",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "108723580"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/f487f461-aa8c-49db-b438-cd4544bbb62e_f07805b0-74ab-47db-b80f-9876c20f4480.jpg",
                      "categoryId": "68222584"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers & Parcels",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179543605",
                              "name": "Tandoori Loaded Paneer Parcel",
                              "category": "Burgers & Parcels",
                              "description": "Delicious Parcel stuffed with smoky tandoori paneer and bold spices for a punch of Indian flavour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/0ba9c7bc-e906-4474-b9cc-052bb9ce0eb2_081cd41d-4b7c-46b7-b9a7-4b75f14e15fd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "finalPrice": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "eb37d598-d5d8-4529-948c-10adf660b21d",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "108666227"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179543604",
                              "name": "Tandoori Loaded Chicken Parcel",
                              "category": "Burgers & Parcels",
                              "description": "Delicious Parcel stuffed with chicken & smoky tandoori sauce and bold spices for a punch of Indian flavour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/a37a3ffc-d23f-4bac-aa84-e6d00a927333_5058eefb-e099-43d5-9909-a776c70621ce.jpg",
                              "inStock": 1,
                              "price": 13900,
                              "finalPrice": 7000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "7ab14d82-fe50-4c22-aed8-3e5884fbbb04"
                              ],
                              "parentId": "108666226"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876267",
                              "name": "Burger Pizza - Classic Non Veg",
                              "category": "Burgers & Parcels",
                              "description": "Oven-baked buns with cheese, peri-peri chicken, tomato & capsicum in creamy mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/161c9d71-04c9-41bb-aab9-710d86025e05_b26681c2-de46-474a-9334-d318f3eaa5cb.jpg",
                              "inStock": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973950"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876261",
                              "name": "Burger Pizza - Classic Veg",
                              "category": "Burgers & Parcels",
                              "description": "Oven-baked buns with cheese, tomato & capsicum in creamy mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a610af1f-af37-42b8-8fe8-667879077cf8_368adb3d-ee98-4070-b509-991bbc29df5c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "20973951"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876257",
                              "name": "Veg Parcel",
                              "category": "Burgers & Parcels",
                              "description": "Snacky bites! Pizza rolls with paneer & creamy harissa sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cacc3fc3-485d-44f0-bb4b-c6f4a16a10b5_77cd5a6f-6d37-4488-81cd-340d760f0dec.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "157 ratings",
                                  "ratingCountV2": "157"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974246"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876264",
                              "name": "Burger Pizza - Premium Veg",
                              "category": "Burgers & Parcels",
                              "description": "Oven-baked buns with cheese, paneer, tomato, capsicum & red paprika in creamy mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c2a33d03-81c1-4748-85eb-7a2582aea3a7_ed4855b0-1fcc-49be-9c4b-6ba1038cf16f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973953"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876253",
                              "name": "Chicken Parcel",
                              "category": "Burgers & Parcels",
                              "description": "Snacky bites! Pizza rolls with chicken sausage & creamy harissa sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c22e6fe7-f576-418e-b6e9-b7dac5173785_f6361875-39b1-4880-855d-2a1cbae16feb.jpg",
                              "inStock": 1,
                              "price": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973986"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/8/12/0ba9c7bc-e906-4474-b9cc-052bb9ce0eb2_081cd41d-4b7c-46b7-b9a7-4b75f14e15fd.jpg",
                      "categoryId": "66055650"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cheese Volcano",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508795",
                              "name": "Cheese Volcano Peppy Paneer",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with peppy Paneer, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/da1a9ce9-2d03-4355-87c3-132927b2621e_db7849c6-fec5-4871-8721-da298df68290.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835694",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971863",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835695",
                                          "variationId": "203971864"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835695",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971864",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971865",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835694",
                                        "variationId": "203971863"
                                      },
                                      {
                                        "groupId": "67835695",
                                        "variationId": "203971864"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919852",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919853",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919851",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835694",
                                        "variationId": "203971863"
                                      },
                                      {
                                        "groupId": "67835695",
                                        "variationId": "203971865"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919854",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919856",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919855",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919851",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919852",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919853",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919854",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919855",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919856",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736560"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508797",
                              "name": "Cheese Volcano Farmhouse",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Onion, Capsicum, Tomato & Grilled Mushroom\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d9d06449-97b2-473f-98f4-c8eb0a9c446f_17ce3f1e-09e0-4508-94e7-3ab08fe0ecf9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835708",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971883",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835709",
                                          "variationId": "203971884"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835709",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971884",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971885",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835708",
                                        "variationId": "203971883"
                                      },
                                      {
                                        "groupId": "67835709",
                                        "variationId": "203971884"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919888",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919889",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919887",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835708",
                                        "variationId": "203971883"
                                      },
                                      {
                                        "groupId": "67835709",
                                        "variationId": "203971885"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919890",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919892",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919891",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919887",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919888",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919889",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919890",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919891",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919892",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736559"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508807",
                              "name": "Cheese Volcano Veg Paradise",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Golden Corn, Black Olives, Capsicum & Red Paprika\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/8b7fe0db-f0e8-4ffc-aff0-2dd38f9c2bdd_c7922a40-93ab-480f-af7b-6fe7ee0a3f40.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835698",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971868",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835699",
                                          "variationId": "203971869"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835699",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971869",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971870",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835698",
                                        "variationId": "203971868"
                                      },
                                      {
                                        "groupId": "67835699",
                                        "variationId": "203971869"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919858",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919859",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919857",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835698",
                                        "variationId": "203971868"
                                      },
                                      {
                                        "groupId": "67835699",
                                        "variationId": "203971870"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919860",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919862",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919861",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919857",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919858",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919859",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919860",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919861",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919862",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736561"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508796",
                              "name": "Corn & Cheese Volcano",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with juicy Golden Corn\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/c3eb5138-3508-40c0-bbf0-c5cd67633c92_546a076d-2ab6-403d-aaa1-819171d471e4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835692",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971860",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835693",
                                          "variationId": "203971861"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835693",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971861",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971862",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835692",
                                        "variationId": "203971860"
                                      },
                                      {
                                        "groupId": "67835693",
                                        "variationId": "203971861"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919846",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919847",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919845",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835692",
                                        "variationId": "203971860"
                                      },
                                      {
                                        "groupId": "67835693",
                                        "variationId": "203971862"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919848",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919850",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919849",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919845",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919846",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919847",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919848",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919849",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919850",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736562"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508803",
                              "name": "Cheese Volcano BBQ Chicken",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3dc7448e-5d68-490f-81b2-6fa82c8bb1d0_1da3fe92-98a4-4fe6-ab66-3cf54d0844c0.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835702",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971874",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835703",
                                          "variationId": "203971875"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835703",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971875",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971876",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835702",
                                        "variationId": "203971874"
                                      },
                                      {
                                        "groupId": "67835703",
                                        "variationId": "203971875"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919870",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919871",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919869",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835702",
                                        "variationId": "203971874"
                                      },
                                      {
                                        "groupId": "67835703",
                                        "variationId": "203971876"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919872",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919874",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919873",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919869",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919870",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919871",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919872",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919873",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919874",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736555"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508798",
                              "name": "Cheese Volcano Chicken Delight",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Golden Corn\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fe210024-4dd5-41d3-92d3-9ea4cfcf5e84_36a63f3c-0f4b-47c8-aa52-5b08f15d00f9.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835706",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971880",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835707",
                                          "variationId": "203971881"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835707",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971881",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971882",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835706",
                                        "variationId": "203971880"
                                      },
                                      {
                                        "groupId": "67835707",
                                        "variationId": "203971881"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919882",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919883",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919881",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835706",
                                        "variationId": "203971880"
                                      },
                                      {
                                        "groupId": "67835707",
                                        "variationId": "203971882"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919884",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919886",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919885",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919881",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919882",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919883",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919884",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919885",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919886",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736557"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508801",
                              "name": "Cheese Volcano Double Chicken",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Pepper BBQ Chicken & Peri Peri Chicken.\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7a9ebcc0-d62b-444a-a65b-917815ac8823_2ceed5aa-2fc0-40af-831e-72aeb6fe83fb.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835700",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971871",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835701",
                                          "variationId": "203971872"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835701",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971872",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971873",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835700",
                                        "variationId": "203971871"
                                      },
                                      {
                                        "groupId": "67835701",
                                        "variationId": "203971872"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919864",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919865",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919863",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835700",
                                        "variationId": "203971871"
                                      },
                                      {
                                        "groupId": "67835701",
                                        "variationId": "203971873"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919866",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919868",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919867",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919863",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919864",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919865",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919866",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919867",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919868",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736558"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "146508799",
                              "name": "Cheese Volcano Blazing Chicken",
                              "category": "Cheese Volcano",
                              "description": "Centre loaded with Molten Cheese & topped with Chicken Keema & Red Paprika with our spicy Peri Peri Sauce\n*Contains non-edible container under the Pizza",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d5c5c0ee-1927-4ebc-82dd-cdcab3be1713_99c2ae87-e899-47e5-ac70-8cfff9e54f5b.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67835704",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Cheese Volcano Crust",
                                        "default": 1,
                                        "id": "203971877",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67835705",
                                          "variationId": "203971878"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67835705",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular Plus",
                                        "default": 1,
                                        "id": "203971878",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium Plus",
                                        "id": "203971879",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835704",
                                        "variationId": "203971877"
                                      },
                                      {
                                        "groupId": "67835705",
                                        "variationId": "203971878"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596021"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596014"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596022"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596020"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596015"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596023"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596018"
                                      },
                                      {
                                        "groupId": "250919876",
                                        "addonId": "140596025"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596013"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596027"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596016"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596017"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596024"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596019"
                                      },
                                      {
                                        "groupId": "250919877",
                                        "addonId": "140596026"
                                      },
                                      {
                                        "groupId": "250919875",
                                        "addonId": "140596012"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67835704",
                                        "variationId": "203971877"
                                      },
                                      {
                                        "groupId": "67835705",
                                        "variationId": "203971879"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335187"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335161"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335173"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335163"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335189"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335158"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335181"
                                      },
                                      {
                                        "groupId": "250919878",
                                        "addonId": "121335176"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335177"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335172"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335162"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335193"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335164"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335159"
                                      },
                                      {
                                        "groupId": "250919880",
                                        "addonId": "121335175"
                                      },
                                      {
                                        "groupId": "250919879",
                                        "addonId": "121335179"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "250919875",
                                  "groupName": "Extra Cheese Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596012",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919876",
                                  "groupName": "Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596021",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596014",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596022",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596020",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596015",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596023",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596018",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596025",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919877",
                                  "groupName": "Non-Veg Toppings Regular Plus",
                                  "choices": [
                                    {
                                      "id": "140596013",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596027",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596016",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596017",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596024",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596019",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140596026",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919878",
                                  "groupName": "Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335187",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335161",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335173",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335163",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335189",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335158",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335181",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335176",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919879",
                                  "groupName": "Extra Cheese Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335179",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "250919880",
                                  "groupName": "Non-Veg Toppings Medium Plus",
                                  "choices": [
                                    {
                                      "id": "121335177",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335172",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335162",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335193",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335164",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335159",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "121335175",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "85736556"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/da1a9ce9-2d03-4355-87c3-132927b2621e_db7849c6-fec5-4871-8721-da298df68290.jpg",
                      "categoryId": "50914857"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Party Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113941831",
                              "name": "Special Party for 4 (Veg) @Rs. 180 off",
                              "category": "Party Combo",
                              "description": "Medium Peppy Paneer + Medium Farmhouse + Garlic Bread + 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/00172250-9249-40a2-b79f-001a80f74afd_4fb431a0-fe7b-4b42-a31c-983f41c057ee.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 105928,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384470"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119166170",
                              "name": "Pizza Party for 4 (Veg) @Rs. 180 Off",
                              "category": "Party Combo",
                              "description": "Meal for 4: Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Regular Farmhouse + Regular Veggie Paradise",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/98e99583-2bdb-435b-a5ff-457b04b74036_c3c9ed95-2539-441e-b10f-7b0badd0548d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 101900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384467"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119166169",
                              "name": "Party for 4 (Veg) @Rs. 130 off",
                              "category": "Party Combo",
                              "description": "Meal for 4: Medium Margherita + Medium Farmhouse with Garlic Bread & 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/5a6e8a9a-3070-4359-9135-30984b4f8259_7e92225f-e4a4-4995-b0f6-067951e34e91.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 88500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384466"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113941833",
                              "name": "Extravaganza Party for 2 (Veg) @Rs. 110 off",
                              "category": "Party Combo",
                              "description": "Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Garlic Bread + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a8cdfe41-54af-4eae-a171-7de5b623a1c1_d3a04258-3f8b-47c3-b0db-8fadb5fd60fe.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 72914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384463"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119166168",
                              "name": "Dominator Party for 2 (Non-Veg) @Rs. 140 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Non Veg Supreme + Regular Chicken Dominator with Garlic Bread & Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/10df7fca-5209-405c-8aa0-243101e0a08a_909edf75-ad3b-4e6b-ace9-08d62b7245e5.jpg",
                              "inStock": 1,
                              "price": 81914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384461"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125889810",
                              "name": "Special Party for 2 (Veg) @Rs. 105 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Farmhouse + Regular Peppy Paneer with Garlic Bread & Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/90bc7700-f339-4640-adb6-698beed62c1c_46c0f06c-9c80-4187-a772-43d287c9a85e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64944,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384469"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131414680",
                              "name": "Match Day Veg Combo @Rs. 110 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Veg Extravaganza + Regular Indi Tandoori Paneer with Chocolava Cake & Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/9bcd3b04-83ef-438b-be63-e9e7562057cb_72ef2ba5-35c9-471a-a166-eaa9b2b47bdf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 71914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "71347683"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119166167",
                              "name": "Special Party for 2 (Non-Veg) @Rs. 115 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Pepper BBQ Chicken + Regular Chicken Dominator with Garlic Bread & Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/9bc402cc-ab92-4734-a4f9-4da5516cf85c_0349ecc1-92d6-48eb-a8dc-9a7987d15e72.jpg",
                              "inStock": 1,
                              "price": 72914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384468"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113941830",
                              "name": "Party for 2 (Non-Veg) @Rs. 85 off",
                              "category": "Party Combo",
                              "description": "Regular Pepper BBQ Chicken + Regular Chicken Sausage + Garlic Bread + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/8ff978a1-b7ce-407b-be92-09bfa926fc8c_3dbd7950-40d4-480e-9a5c-008bef476759.jpg",
                              "inStock": 1,
                              "price": 59914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384464"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113941829",
                              "name": "Party for 2 (Veg) @Rs. 75 off",
                              "category": "Party Combo",
                              "description": "Regular Margherita +Regular  Farmhouse + Garlic Bread + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fdbc9359-daf9-4c14-84db-34369b6201c3_002c7273-1ca7-48e7-bb0b-2c3fe48a2555.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 50914,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384465"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113941834",
                              "name": "Dominator Party for 4 (Non-Veg) @Rs. 300 off",
                              "category": "Party Combo",
                              "description": "Medium Non-veg Supreme + Medium Chicken Dom+ Garlic Bread + 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ca8c134f-2211-44e2-b33f-f7b57a8857cb_11cbeb62-7198-41cb-9c1e-f84d8e4434a3.jpg",
                              "inStock": 1,
                              "price": 121928,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "76384462"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189712903",
                              "name": "Big Big Celebration Combo - Veg",
                              "category": "Party Combo",
                              "description": "Big Big 6in1 Pizza Veg  + 2 Coke 475ml + 4 Choco Bombs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/051fed12-4c8e-42bb-b4bf-b1e0325fc979_55e41962-bf9c-46a6-9dfc-97608e435ccc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 99900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "115412378"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189712904",
                              "name": "Big Big Celebration Combo – Cheese Fest",
                              "category": "Party Combo",
                              "description": "Big Big 6in1 Pizza - Cheezila + 2 Coke 475ml + 4 Choco Bombs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/15a3eea4-b71a-404c-9346-f7f106740e99_70329ac1-aa39-430b-9367-00d9cdf59099.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 119900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "115412376"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189712902",
                              "name": "Big Big Celebration Combo - Non Veg",
                              "category": "Party Combo",
                              "description": "Big Big 6in1 Pizza Non-Veg + 2 Coke 475ml + 4 Choco Bombs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/38c05f25-9bd8-49ba-9daa-3694656ca718_2f2763dc-ac62-479a-a93f-42d2a2423676.jpg",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "115412377"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/00172250-9249-40a2-b79f-001a80f74afd_4fb431a0-fe7b-4b42-a31c-983f41c057ee.jpg",
                      "categoryId": "39982879"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Value Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314186",
                              "name": "Meal for 4: Veg Loaded Pizza",
                              "category": "Value Meals",
                              "description": "Regular Veg Extravaganza + Regular Veg Paradise Pizza + Regular Indi Tandoori Paneer + Regular Farmhouse",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7117f581-66fb-45c4-ac81-ae9202727085_af971dcd-8d6b-4a5f-865e-917cfc6f4547.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 97300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "62676124"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314034",
                              "name": "Meal for 2: Pepper BBQ Chicken & Chicken Dominator",
                              "category": "Value Meals",
                              "description": "Meal for 2: Regular Pepper BBQ Chicken + Regular Chicken Dominator with Garlic Bread & Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6631f60f-49e2-4369-913c-4de98072e186_743db35b-f315-47df-bbed-3ea6cf0e0f11.jpg",
                              "inStock": 1,
                              "price": 69714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459335"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314025",
                              "name": "Meal for 2: Pepper BBQ Chicken & Spiced Double Chicken",
                              "category": "Value Meals",
                              "description": "Regular Pepper BBQ & Regular Spiced Double Chicken + Garlic Bread + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d6d78a51-eebf-4b82-bffa-461fbbc5728b_7c9ec71d-a254-43f1-b0ae-22a34341facd.jpg",
                              "inStock": 1,
                              "price": 65714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459337"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314122",
                              "name": "Meal for 4: Veg Extravaganza & Indi Tandoori Paneer",
                              "category": "Value Meals",
                              "description": "Medium Veg Extravaganza & Medium Indi Tandoori Paneer+Garlic Bread + 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b473034c-b696-4b6c-807e-f904548b9b8b_b5a1d741-8a81-4de2-8868-8ea10345bc2f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 117480,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "70726561"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "64094035",
                              "name": "Ultimate Cheese Burst Deluxe Combo (Veg)",
                              "category": "Value Meals",
                              "description": "Medium Farmhouse Cheese Burst Pizza + Choco Lava Cake + Garlic Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/eb42e7fd-49b5-4bd8-8ff1-9adf573999b2_24e814e6-c6b1-4de5-a6ec-0472334e1fa1.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 80500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974236"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314088",
                              "name": "Meal for 4: Margherita & Peppy Paneer",
                              "category": "Value Meals",
                              "description": "Medium Margherita + Medium Peppy Paneer + Garlic Bread + 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/1e72ad2f-3a27-4375-900e-6613bac2446c_32bd59c2-6700-498c-a140-a03617a50323.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 84080,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459345"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "64094037",
                              "name": "Ultimate Cheese Burst Premium Combo (N Veg)",
                              "category": "Value Meals",
                              "description": "Medium Chicken Dominator Cheese Burst Pizza + Choco Lava Cake + Garlic Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/9bfb8da4-890e-4bb5-a89d-70582fce6c23_0a1323b4-fabf-441a-9d0b-89c0aee637c4.jpg",
                              "inStock": 1,
                              "price": 94100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974237"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107313983",
                              "name": "Meal for 2: Farmhouse & Veg Extravaganza",
                              "category": "Value Meals",
                              "description": "Regular Farmhouse & Regular Veg Extravaganza + Garlic Bread+ Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3028010d-5172-4a4b-9b7c-d41ce491864a_85b8c03d-3e6d-418b-9bb2-2c50c4339d6b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 65714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459328"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "64094038",
                              "name": "Ultimate Cheese Burst Deluxe Combo (N Veg)",
                              "category": "Value Meals",
                              "description": "Medium Pepper BBQ Chicken Cheese Burst Pizza + Choco Lava Cake + Garlic Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d2d43d3a-a2a5-4395-8857-313130a8c034_3efe2a45-0011-49c4-9c7c-ad55327f726d.jpg",
                              "inStock": 1,
                              "price": 79100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974235"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "64094036",
                              "name": "Ultimate Cheese Burst Premium Combo (Veg)",
                              "category": "Value Meals",
                              "description": "Medium Veg Extravaganza Cheese Burst Pizza + Choco Lava Cake + Garlic Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/90936e9c-a93e-4d92-8ef8-9b73ffdc4e31_d92799ab-ae27-4bc7-9bf4-1ec99a4f31aa.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974238"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314179",
                              "name": "Meal for 4: Veg Cheesy Pizza",
                              "category": "Value Meals",
                              "description": "Regular Fresh Veggie + Regular Peppy Paneer + Regular Corn n Cheese + Regular Farmhouse",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cc8188b6-5ac1-44dd-9c6c-674852880378_c6185ee9-2caf-400d-9c38-5afa2af565fd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 82300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "71663812"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107314222",
                              "name": "Meal for 4: Non Veg Pizza Mania Value",
                              "category": "Value Meals",
                              "description": "2 PM Pepper Barbecue Chicken + PM Chicken Sausage + PM Non Veg Loaded",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2c385426-2e89-4116-99fe-0483d4e682a4_5426e5dd-918b-416c-a346-29b17c350d48.jpg",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459348"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107313991",
                              "name": "Meal for 2: Veg Paradise & Farmhouse",
                              "category": "Value Meals",
                              "description": "Regular Veg Paradise + Regular Farmhouse + Garlic Bread + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/1c389bee-0fae-48cf-aaa8-d76a59e82711_b26cfc11-2550-40fd-8803-18d0cb8f9b91.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 62714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "61459340"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7117f581-66fb-45c4-ac81-ae9202727085_af971dcd-8d6b-4a5f-865e-917cfc6f4547.jpg",
                      "categoryId": "39982886"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Flavours of India",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875992",
                              "name": "Achari Do Pyaza Pizza",
                              "category": "Flavours of India",
                              "description": "Tangy & spicy achari flavours on a super cheesy onion pizza- as desi as it gets!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/575de73f-c13f-4a83-a16a-eedf227b8842_6e9b6213-3155-44e1-999a-c8619665cdae.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "67544348",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "203295726",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827469",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "203295729",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "203295730",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "203295732",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "203295733",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "203295734",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "203295736",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "67544350",
                                          "variationId": "203295737"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "67544350",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "203295737",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "203295738",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "203295739",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295734"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295734"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295736"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295736"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295733"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295733"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295726"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295726"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295739"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "249435291",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "249435289",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "249435290",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295726"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295729"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295729"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 27800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295732"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295730"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "203295730"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "208827469"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295737"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435283",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "249435285",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "249435284",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "67544348",
                                        "variationId": "208827469"
                                      },
                                      {
                                        "groupId": "67544350",
                                        "variationId": "203295738"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "249435287",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "249435288",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "249435286",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "249435283",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435284",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435285",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435286",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435287",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435288",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435289",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435290",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "249435291",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464101"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91332678",
                              "name": "Corn n Cheese Paratha Pizza",
                              "category": "Flavours of India",
                              "description": "A crazy fusion like never before. A delicious fusion of corn stuffed paratha and cheesy pizza.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2a59d9aa-31b0-44a4-b3a2-a7068f8141b4_4a8e313a-8270-4352-9f1b-86fbcb8deb30.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "70191839",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "default": 1,
                                        "id": "209212113",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "70191840",
                                          "variationId": "209212114"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "70191840",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "209212114",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "70191839",
                                        "variationId": "209212113"
                                      },
                                      {
                                        "groupId": "70191840",
                                        "variationId": "209212114"
                                      }
                                    ],
                                    "price": 19900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "47960694"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91875767",
                              "name": "Indi Tandoori Paneer Pizza",
                              "category": "Flavours of India",
                              "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/3dcc86f7-d1d9-4f31-a320-bf3cea8013ff_6cabc131-286e-41bf-ae5f-f2ffbdc72040.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36899971",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114957110",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827453",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114957112",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114957113",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114957114",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504896",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504897",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504898",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36899972",
                                          "variationId": "114957115"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36899972",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114957115",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114957116",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114957117",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504898"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504898"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504896"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504896"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504897"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "155504897"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957110"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957110"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957117"
                                      }
                                    ],
                                    "price": 84900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132512080",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132512066",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132512072",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957110"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 58900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957112"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 68800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957112"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 39800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957114"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957113"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "114957113"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "208827453"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957115"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512047",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132512058",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132512053",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36899971",
                                        "variationId": "208827453"
                                      },
                                      {
                                        "groupId": "36899972",
                                        "variationId": "114957116"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132512091",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132512096",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132512087",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132512047",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512053",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512058",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512087",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512091",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512096",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512066",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512072",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132512080",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 31900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464114"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91332680",
                              "name": "Chicken Keema Paratha Pizza",
                              "category": "Flavours of India",
                              "description": "Flavourful & meaty chicken keema paratha and goodness of cheesy pizza coming together in an epic crossover!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cf462d1f-29a7-479a-8b54-1fdcec57536e_6ca94555-979a-444b-ab27-6ced17ded20e.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "70191837",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "default": 1,
                                        "id": "209212111",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "70191838",
                                          "variationId": "209212112"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "70191838",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "209212112",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "70191837",
                                        "variationId": "209212111"
                                      },
                                      {
                                        "groupId": "70191838",
                                        "variationId": "209212112"
                                      }
                                    ],
                                    "price": 26900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "47960693"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876165",
                              "name": "Indi Chicken Tikka Pizza",
                              "category": "Flavours of India",
                              "description": "The wholesome flavour of tandoori masala with Chicken tikka, onion, red paprika & mint mayo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/a12f88d1-a3b4-41e4-bf92-7fefc24c9550_3a2469ee-ff00-4606-97fd-04b0f1aad86e.jpg",
                              "inStock": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36900973",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "114959993",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "208827452",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "114959997",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "114959998",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "114959999",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Korean Sweet Chilli Cheese Burst",
                                        "id": "155504653",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Hot n Fiery Cheese Burst",
                                        "id": "155504654",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      },
                                      {
                                        "name": "Creamy Makhani Cheese Burst",
                                        "id": "155504655",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36900974",
                                          "variationId": "114960000"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36900974",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "114960000",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "id": "114960001",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "id": "114960002",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504655"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504653"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504653"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504654"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504654"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "155504655"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959993"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959993"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960002"
                                      }
                                    ],
                                    "price": 96900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005720"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005727"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005700"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005731"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005726"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005732"
                                      },
                                      {
                                        "groupId": "132514326",
                                        "addonId": "100005710"
                                      },
                                      {
                                        "groupId": "132514309",
                                        "addonId": "100005693"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005714"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005738"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005733"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005737"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005712"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005736"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005702"
                                      },
                                      {
                                        "groupId": "132514316",
                                        "addonId": "100005707"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959993"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959997"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 72800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959997"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 45800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959999"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959998"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "114959998"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "208827452"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960000"
                                      }
                                    ],
                                    "price": 40900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514288",
                                        "addonId": "100005704"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005722"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005695"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005724"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005699"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005717"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005728"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005692"
                                      },
                                      {
                                        "groupId": "132514303",
                                        "addonId": "100005706"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005729"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005721"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005698"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005725"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005691"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005696"
                                      },
                                      {
                                        "groupId": "132514294",
                                        "addonId": "100005711"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36900973",
                                        "variationId": "208827452"
                                      },
                                      {
                                        "groupId": "36900974",
                                        "variationId": "114960001"
                                      }
                                    ],
                                    "price": 67900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005708"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005701"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005715"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005694"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005719"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005730"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005734"
                                      },
                                      {
                                        "groupId": "132514347",
                                        "addonId": "100005718"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005703"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005709"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005713"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005723"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005735"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005705"
                                      },
                                      {
                                        "groupId": "132514362",
                                        "addonId": "100005697"
                                      },
                                      {
                                        "groupId": "132514339",
                                        "addonId": "100005716"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "132514339",
                                  "groupName": "Extra Cheese Medium",
                                  "choices": [
                                    {
                                      "id": "100005716",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514347",
                                  "groupName": "Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005708",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005701",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005715",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005694",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005719",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005730",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005734",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005718",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514362",
                                  "groupName": "Non-Veg Toppings Medium",
                                  "choices": [
                                    {
                                      "id": "100005703",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005709",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005713",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005723",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005735",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005705",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005697",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514288",
                                  "groupName": "Extra Cheese Regular",
                                  "choices": [
                                    {
                                      "id": "100005704",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514294",
                                  "groupName": "Non-Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005729",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005721",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005698",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005725",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005691",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005696",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005711",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514303",
                                  "groupName": "Veg Toppings Regular",
                                  "choices": [
                                    {
                                      "id": "100005722",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005695",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005724",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005699",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005717",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005728",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005692",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005706",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514309",
                                  "groupName": "Extra Cheese Large",
                                  "choices": [
                                    {
                                      "id": "100005693",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514316",
                                  "groupName": "Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005714",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005738",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005733",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005737",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005712",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005736",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005702",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005707",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132514326",
                                  "groupName": "Non-Veg Toppings Large",
                                  "choices": [
                                    {
                                      "id": "100005720",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005727",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005700",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005731",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005726",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005732",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100005710",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 37900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "60464113"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/575de73f-c13f-4a83-a16a-eedf227b8842_6e9b6213-3155-44e1-999a-c8619665cdae.jpg",
                      "categoryId": "45390315"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "DESSERTS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159987304",
                              "name": "Choco Lava Cake Gift Hamper",
                              "category": "DESSERTS",
                              "description": "Dive into the ultimate dessert experience with our Lavalicious Combo that’s Made to Share. \n*We don't include a spoon or napkin to support sustainability",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/a96d7f5e-5bb1-413a-9050-4874cec0861c_98ac77fe-1f34-4ad1-b8b2-27a7fe5177ec.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "94768972"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117821959",
                              "name": "Choco Lava Cake + Beverage",
                              "category": "DESSERTS",
                              "description": "Get the indulgent Choco Lava Cake & Coke for just 149",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/27/1200ca62-f3ed-448a-b80b-3ebbb1aa04da_fb699638-d08d-4740-8ca1-80fe21adb275.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102026806"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69365332",
                              "name": "Red Velvet Lava Cake",
                              "category": "DESSERTS",
                              "description": "A truly indulgent experience with sweet and rich red velvet cake on a creamy cheese flavoured base to give a burst of flavour in every bite!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/e653e2f9-0221-43f6-b418-71b41bd3fde3_e398fc79-ed83-4eb9-a0b2-3ca16f831b27.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20974206"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91876245",
                              "name": "Choco Lava Cake",
                              "category": "DESSERTS",
                              "description": "Chocolate lovers delight! Indulgent, gooey molten lava inside chocolate cake",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/441953ea-96f7-4efc-81b7-f4a6cf9ee25c_0edcc9f8-ba9e-405b-af70-a774f326f935.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "20973999"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "22347517",
                              "name": "Butterscotch Mousse Cake",
                              "category": "DESSERTS",
                              "description": "Sweet temptation! Butterscotch flavored mousse",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2b0bac16-ac6c-47ec-b4af-74505bcef889_2217c939-e5d5-45dd-803e-b7ac7a3d2dbe.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "106 ratings",
                                  "ratingCountV2": "106"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "20973955"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/a96d7f5e-5bb1-413a-9050-4874cec0861c_98ac77fe-1f34-4ad1-b8b2-27a7fe5177ec.jpg",
                      "categoryId": "39982887"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BEVERAGES",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166941000",
                              "name": "Coca Cola 475ml",
                              "category": "BEVERAGES",
                              "description": "Sparkling and Refreshing Beverage",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ee2de6b3-a228-4fcb-8d8e-a7d86feef6b2_e9b9b72e-8003-4741-b38f-d4ca8d3f6a13.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "100491569"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169820274",
                              "name": "Sprite 475ml",
                              "category": "BEVERAGES",
                              "description": "Refreshing clear drink with a natural lemon flavour",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/427f6e0b-0ca6-4595-9570-e2116cd504bb_d4181e56-62b3-4460-a3e7-11fe7294b7b2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "102405335"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166940999",
                              "name": "Coca Cola Zero Sugar 330ml",
                              "category": "BEVERAGES",
                              "description": "Maximum Taste, Zero Sugar",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/4af584f9-cd55-450b-88c6-9ac50818ac54_9c3b1d12-8504-454b-90c7-082003e4038f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6666,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "imageBadges": [
                                {
                                  "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                }
                              ],
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "100491570"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119921288",
                              "name": "B Natural Alphonsos from Ratnagiri (300 ml)",
                              "category": "BEVERAGES",
                              "description": "Alphonsos only from Ratnagiri with the Goodness of Fiber",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/9e8f118b-f275-433d-9125-25615ca26df9_15e11a6a-442b-44dd-917a-fbccf3ab68b6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6943,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "20973940"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155723232",
                              "name": "Packaged Water 500ml",
                              "category": "BEVERAGES",
                              "description": "Packaged Drinking Water",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/2/19c00857-d816-461e-82c9-96cd4e13f903_a4f138bb-58de-44e7-84d0-14aae9716579.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2757,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "109896752"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ee2de6b3-a228-4fcb-8d8e-a7d86feef6b2_e9b9b72e-8003-4741-b38f-d4ca8d3f6a13.jpg",
                      "categoryId": "39982882"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pizza & More",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "150737786",
                              "name": "Margherita Pizza Regular",
                              "category": "Pizza & More",
                              "description": "Classic delight with 100% real mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f3b8f6fb-bf73-4ee0-bed8-a6a57742f7cb_19f4a228-886b-4072-a5c8-3417090132ae.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "78521127"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163983088",
                              "name": "Classic Pizza Mania",
                              "category": "Pizza & More",
                              "description": "A classic pizza topped with sprinkle of basil and parsley herbs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6d13296d-bcfe-472e-a92b-cf57e7721f2f_3a08fa86-d49e-4675-87cc-c449bd1d00c6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "78521126"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/f3b8f6fb-bf73-4ee0-bed8-a6a57742f7cb_19f4a228-886b-4072-a5c8-3417090132ae.jpg",
                      "categoryId": "52985140"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pizza Mania Deals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "178510344",
                              "name": "Pepper Barbecue Chicken Pizza Mania",
                              "category": "Pizza Mania Deals",
                              "description": "Pepper barbecue chicken for that extra zing",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b2bea526-1845-46dd-ba10-2034c52f22d2_bbe2c4eb-3c08-408b-8198-16b438bfb461.jpg",
                              "inStock": 1,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "69377847",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "207446840",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "69377848",
                                          "variationId": "207446841"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "69377848",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "default": 1,
                                        "id": "207446841",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "69377847",
                                        "variationId": "207446840"
                                      },
                                      {
                                        "groupId": "69377848",
                                        "variationId": "207446841"
                                      }
                                    ],
                                    "price": 12500,
                                    "finalPrice": {
                                      "units": "99"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 12500,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d8a63d52-06fc-4907-ab32-7ec57af2bce8",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "107988410"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/b2bea526-1845-46dd-ba10-2034c52f22d2_bbe2c4eb-3c08-408b-8198-16b438bfb461.jpg",
                      "categoryId": "69838015"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cheese Lava Pull Apart Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636890",
                              "name": "Cheese Lava – Farmhouse",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with onion, capsicum, tomato & mushrooms! Pull, dip & taste the cheesy comfort.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/49fc0b3e-4045-478b-8bbd-bc01e4ea8068_64661c75-07c6-4bca-8700-e7dd50fbcad2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754461",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025712",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754462",
                                          "variationId": "206025713"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754462",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025713",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754461",
                                        "variationId": "206025712"
                                      },
                                      {
                                        "groupId": "68754462",
                                        "variationId": "206025713"
                                      }
                                    ],
                                    "price": 49900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143704"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636889",
                              "name": "Cheese Lava -  Spiced Double Chicken",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts loaded with Pepper BBQ Chicken & Peri Peri Chicken! Pull, dip & relish the cheesy heaven.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/8a7b75b0-423f-40d8-b5e2-f17f6e8aa9cd_84e1e867-4254-4a06-b499-78e2fed1ef4b.jpg",
                              "inStock": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754459",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025710",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754460",
                                          "variationId": "206025711"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754460",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025711",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754459",
                                        "variationId": "206025710"
                                      },
                                      {
                                        "groupId": "68754460",
                                        "variationId": "206025711"
                                      }
                                    ],
                                    "price": 59900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143708"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636891",
                              "name": "Cheese Lava - Veg Paradise",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with corn, capsicum, black olives & red paprika. Pull, dip & relish the cheesy indulgence.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/25/4d835443-a107-4169-bff7-7f78763473a0_ea9ced09-e805-4e2b-811e-f334a2d1e52d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754463",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025714",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754464",
                                          "variationId": "206025715"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754464",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025715",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754463",
                                        "variationId": "206025714"
                                      },
                                      {
                                        "groupId": "68754464",
                                        "variationId": "206025715"
                                      }
                                    ],
                                    "price": 49900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143709"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636884",
                              "name": "Cheese Lava - Chicken Golden Delight",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts loaded with Pepper BBQ Chicken & golden corn! Pull, dip & melt into cheesy perfection.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/3c341c54-b77d-4c2e-b33d-72bfc89e469f_876cfc1f-6664-4197-a8bc-001961a3ba4d.jpg",
                              "inStock": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754449",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025700",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754450",
                                          "variationId": "206025701"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754450",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025701",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754449",
                                        "variationId": "206025700"
                                      },
                                      {
                                        "groupId": "68754450",
                                        "variationId": "206025701"
                                      }
                                    ],
                                    "price": 59900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143703"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636887",
                              "name": "Cheese Lava - Blazing Chicken & Paprika",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with chicken keema & red paprika! Pull, dip & feel the cheesy heat.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/ef0eaa13-8660-4c5f-8f50-e3e33f517241_e4af1d3f-1c38-4e15-a6d0-6bd128b2e666.jpg",
                              "inStock": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754455",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025706",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754456",
                                          "variationId": "206025707"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754456",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025707",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754455",
                                        "variationId": "206025706"
                                      },
                                      {
                                        "groupId": "68754456",
                                        "variationId": "206025707"
                                      }
                                    ],
                                    "price": 59900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143702"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636885",
                              "name": "Cheese Lava - Pepper BBQ Chicken",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with pepper BBQ chicken! Pull, dip & melt into cheesy goodness.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/39868bab-a508-46a9-87f8-aa9ec3685f10_b4f61aeb-72eb-4ae5-8c9b-cbed5d75b258.jpg",
                              "inStock": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754451",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025702",
                                        "inStock": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754452",
                                          "variationId": "206025703"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754452",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025703",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754451",
                                        "variationId": "206025702"
                                      },
                                      {
                                        "groupId": "68754452",
                                        "variationId": "206025703"
                                      }
                                    ],
                                    "price": 59900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 59900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143706"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636883",
                              "name": "Cheese Lava - Golden Corn",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with juicy corn! Pull & dip into molten cheese bliss.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/5759aa60-5f67-4334-bc6c-42c7ab40f2e9_a51ce7ad-9a56-4178-9877-fc429a4b7596.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754447",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025698",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754448",
                                          "variationId": "206025699"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754448",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025699",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754447",
                                        "variationId": "206025698"
                                      },
                                      {
                                        "groupId": "68754448",
                                        "variationId": "206025699"
                                      }
                                    ],
                                    "price": 49900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143705"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187636888",
                              "name": "Cheese Lava - Peppy Paneer",
                              "category": "Cheese Lava Pull Apart Pizza",
                              "description": "8 cheesy pull-aparts topped with paneer, capsicum & red paprika! Pull, dip & let the cheese take over.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/8da6bd12-a637-4bdc-9d3b-318bfe74de71_14db5c04-ccc2-4c9a-85c2-e0929e7bb53a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 41900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "68754457",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Pull Apart Crust",
                                        "default": 1,
                                        "id": "206025708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "68754458",
                                          "variationId": "206025709"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "68754458",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "default": 1,
                                        "id": "206025709",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "68754457",
                                        "variationId": "206025708"
                                      },
                                      {
                                        "groupId": "68754458",
                                        "variationId": "206025709"
                                      }
                                    ],
                                    "price": 49900,
                                    "finalPrice": {
                                      "units": "419"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 49900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "b4aa8f27-8571-4fd6-919c-3b1a7d37c92c",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "114143707"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2026/1/7/49fc0b3e-4045-478b-8bbd-bc01e4ea8068_64661c75-07c6-4bca-8700-e7dd50fbcad2.jpg",
                      "categoryId": "69119076"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "5 Course Pizza Feast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156692769",
                              "name": "5 Course Meal: Chicken Sausage Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Chicken Sausage + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ec57de28-ce2e-4bb8-b93f-b66b1b7e28ea_ada33adc-28b4-48dc-997b-7161132baf18.jpg",
                              "price": 25105,
                              "finalPrice": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "81c6f3b0-6ee0-441e-ba37-5515dfeac82e",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "105229579"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156692772",
                              "name": "5 Course Meal: Classic Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Classic + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/6dd479f4-3731-44c3-924f-874d7b2d02f5_bb2d7c18-ffc5-4a60-816b-d58f87241742.jpg",
                              "isVeg": 1,
                              "price": 19105,
                              "finalPrice": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "81c6f3b0-6ee0-441e-ba37-5515dfeac82e",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "94034205"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156692767",
                              "name": "5 Course Meal: Pepper BBQ Chicken Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Pepper Barbecue Chicken + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d0d6ee3c-b5b9-4cc7-93f6-65e28196625d_44494c46-ae0f-4d7a-866f-77db1bfd5177.jpg",
                              "price": 26705,
                              "finalPrice": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "81c6f3b0-6ee0-441e-ba37-5515dfeac82e",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "105229580"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "156692768",
                              "name": "5 Course Meal: Onion Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Onion + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/36ee30fc-88c4-440c-a549-2d9c4880ea56_396d98e3-796a-47f7-b2c9-fe7b41539ff5.jpg",
                              "isVeg": 1,
                              "price": 21705,
                              "finalPrice": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "81c6f3b0-6ee0-441e-ba37-5515dfeac82e",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "94034207"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "177543070",
                              "name": "5 Course Meal: Non Veg Loaded Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Non veg Loaded Pizza + Creamy Tomato Meltz + Chicken Popcorn + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/23/d0304c89-5d10-4328-9784-9da5a47a2671_899a8461-ea1e-46be-8307-603ab98bd7a3.jpg",
                              "price": 36100,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "107336452"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "177543069",
                              "name": "5 Course Meal: Veg Loaded Pizza",
                              "category": "5 Course Pizza Feast",
                              "description": "Pizza Mania Veg Loaded Pizza + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/23/bf9c349b-b7c2-4cef-931e-54200208b0c3_7c76a1ba-3884-4c15-b627-45ef92f08207.jpg",
                              "isVeg": 1,
                              "price": 33100,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "107336453"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ec57de28-ce2e-4bb8-b93f-b66b1b7e28ea_ada33adc-28b4-48dc-997b-7161132baf18.jpg",
                      "categoryId": "70633377"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "5 Course Chicken Feast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179415071",
                              "name": "5 Course: Triple Chicken Garlic Rice Meal with Chicken Wings",
                              "category": "5 Course Chicken Feast",
                              "description": "Garlic Chicken Rice + Chicken Wings (2 pcs) + Chicken Zingy Parcel + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2e571593-abff-40d6-b212-77f9b4ed0f55_f1d7a083-cb3c-4916-9646-f4cf9959c9c6.jpg",
                              "price": 33105,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "101657102"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "168543011",
                              "name": "5 Course: Triple Chicken Hot & Fiery Rice Meal with Chicken Wings",
                              "category": "5 Course Chicken Feast",
                              "description": "Hot & Fiery Chicken Rice + Chicken Wings (2 pcs) + Chicken Zingy Parcel + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d045be45-b362-49f8-a93b-0c078eccae7d_f059f8b7-6099-4cb5-9d50-66ad38908aa5.jpg",
                              "price": 33105,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "101657104"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "168543006",
                              "name": "5 Course: Triple Chicken Garlic Rice Meal with Chicken Pops",
                              "category": "5 Course Chicken Feast",
                              "description": "Garlic Chicken Rice + Chicken Popcorn + Chicken Zingy Parcel + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/cc394104-8f83-4fdb-b62f-184af26ffc4a_21116cbc-b060-4fae-adf4-b86a0bde68de.jpg",
                              "price": 30105,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "101657101"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "168543009",
                              "name": "5 Course: Triple Chicken Hot & Fiery Rice Meal with Chicken Pops",
                              "category": "5 Course Chicken Feast",
                              "description": "Hot & Fiery Chicken Rice + Chicken Popcorn + Chicken Zingy Parcel + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/7a387294-d689-46e2-be9e-27f4d7bdbaa2_a702f777-e246-4394-a33c-d3d719e23dab.jpg",
                              "price": 30105,
                              "finalPrice": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                },
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "a467501d-6a01-4074-96a5-44e416a1d54b",
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "101657103"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/2e571593-abff-40d6-b212-77f9b4ed0f55_f1d7a083-cb3c-4916-9646-f4cf9959c9c6.jpg",
                      "categoryId": "70633378"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Midnight Feast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179047664",
                              "name": "Golden Corn Pizza Midnight Feast",
                              "category": "Midnight Feast",
                              "description": "Pizza Mania Golden Corn + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/41a3584c-c05b-4909-a598-6840b8eb71ac_d47e2691-ef96-4342-80b1-cfd25c75e503.jpg",
                              "isVeg": 1,
                              "price": 23705,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106076179"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179047662",
                              "name": "Pepper BBQ Chicken Pizza Midnight Feast",
                              "category": "Midnight Feast",
                              "description": "Pizza Mania Pepper Barbecue Chicken + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/d0d6ee3c-b5b9-4cc7-93f6-65e28196625d_44494c46-ae0f-4d7a-866f-77db1bfd5177.jpg",
                              "price": 26705,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106076181"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179047665",
                              "name": "Chicken Sausage Pizza Midnight Feast",
                              "category": "Midnight Feast",
                              "description": "Pizza Mania Chicken Sausage + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/ec57de28-ce2e-4bb8-b93f-b66b1b7e28ea_ada33adc-28b4-48dc-997b-7161132baf18.jpg",
                              "price": 25105,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106076178"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179047663",
                              "name": "Onion Pizza Midnight Feast",
                              "category": "Midnight Feast",
                              "description": "Pizza Mania Onion + Creamy Tomato Meltz + Crispy Veggie Bites + Choco Bomb + Carbonated Beverage (Beverage variant subject to availability)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/36ee30fc-88c4-440c-a549-2d9c4880ea56_396d98e3-796a-47f7-b2c9-fe7b41539ff5.jpg",
                              "isVeg": 1,
                              "price": 21705,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 11 pm, today",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "₹200 OFF",
                                  "subTitle": "USE CELEBRATIONS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "fb38fb50-bd05-4b57-9678-8aaa93ed96cf"
                              ],
                              "parentId": "106076180"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/41a3584c-c05b-4909-a598-6840b8eb71ac_d47e2691-ef96-4342-80b1-cfd25c75e503.jpg",
                      "categoryId": "67946963"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11423010000236"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Domino's Pizza",
                      "area": "Malviya Nagar",
                      "completeAddress": "First Floor, Madhya Bharat, Plot No 82, New Maket main road, Malviya Nagar Bhopal, Madhya Pardesh 400708"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "ZZUacVq5XHMo-z9MfwnPCkqTmlt1uo9PBJ7hF8jc"
},
  

  "794529": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "La Pino'z Pizza",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "1269099",
                "name": "La Pino'z Pizza",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "la-pino'z-pizza-mp-nagar-mp-nagar",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/11/21/28765e6c-6122-44d8-bdca-af5b1efa51e4_1269099.jpg",
                "locality": "MP Nagar",
                "areaName": "MP Nagar",
                "costForTwo": "20000",
                "costForTwoMessage": "₹200 for two",
                "cuisines": ["Indian", "Beverages"],
                "avgRating": 4.1,
                "feeDetails": {
                  "restaurantId": "1269099",
                  "fees": [{}]
                },
                "parentId": "4961",
                "avgRatingString": "4.1",
                "totalRatingsString": "100 ratings",
                "sla": {
                  "restaurantId": "1269099",
                  "deliveryTime": 45,
                  "minDeliveryTime": 45,
                  "maxDeliveryTime": 50,
                  "lastMileTravel": 5.8,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 698,
                  "slaString": "45-50 MINS",
                  "lastMileTravelString": "5.8 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2026-01-06 04:30:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "40% off",
                  "shortDescriptionList": [
                    {
                      "meta": "40% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "40% off up to ₹80 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "la-pino'z-pizza-mp-nagar-mp-nagar",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Shop No : Plot No 74 , Floor :  , Plot No 74 Complex Kochhar Arcade, , "
                  },
                  {
                    "title": "Cuisines",
                    "message": "Indian,Beverages"
                  }
                ],
                "totalRatings": 100,
                "aggregatedDiscountInfoV2": {
                  "header": "40% off",
                  "shortDescriptionList": [
                    {
                      "meta": "40% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "40% off up to ₹80 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/1269099"
                },
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {},
                  "subTitle": {},
                  "message": {},
                  "customIcon": {},
                  "commsStyling": {}
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.2320625,77.4355781",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 2,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "40% OFF UPTO ₹80",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["3dd1099c-cacd-4e04-8803-36746f0975b6"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE TRYNEW",
                        "description": "ABOVE ₹159",
                        "offerType": "offers",
                        "restId": "1269099",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE TRYNEW"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "1269099",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Classic Pizzas For Classic Maniacs ",
                        "categories": [
                          {
                            "title": "Classic Pizzas For Classic Maniacs",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678029",
                                    "name": "Sweet Corns Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Sweet and juicy golden corn with our in house sauce. [Fat-5 per 100 g, Protein-10.1 per 100 g, Carbohydrate-50.2 per 100 g, Sugar-6 per 100 g, Calories-286.2 k.cal]Nutritional information per 100g",
                                    "imageId": "j3nizh9dasobzd5m0kz5",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 11500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "21 ratings",
                                        "ratingCountV2": "21"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27694380"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678026",
                                    "name": "Tomatoes Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Thinly cut fresh tomatoes on a cheesy base with in house sauce. [Fat-6.9 per 100 g, Protein-5.1 per 100 g, Carbohydrate-29.8 per 100 g, Sugar-4 per 100 g, Calories-201.7 k.cal]Nutritional information per 100g",
                                    "imageId": "l00ktr91duqpodxm9vnk",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 8500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "14 ratings",
                                        "ratingCountV2": "14"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27694788"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678027",
                                    "name": "Onions Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Onions on a cheesy base with in house sauce. [Fat-7 per 100 g, Protein-12.2 per 100 g, Carbohydrate-50.8 per 100 g, Sugar-7 per 100 g, Calories-315 k.cal]Nutritional information per 100g",
                                    "imageId": "xqtymlvxlpsfj9nbq2j2",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692680"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678035",
                                    "name": "Capsicum, Paneer & Red Paprika Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Flavorful trio of Juicy Paneer, Crisp Capsicum with Spicy Red Paprika. [Fat-10.2 per 100 g, Protein-16.4 per 100 g, Carbohydrate-29.5 per 100 g, Sugar-3.2per 100 g, Calories-275.4 k.cal]Nutritional information per 100g",
                                    "imageId": "f6aak4w44zwpp7ak5bmo",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27688734"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678036",
                                    "name": "Jalapenos, Sweet Corns & Paneer Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Appetizing Combination of Juicy Paneer, Sweet Corn and Jalapeno in our in House Sauce. [Fat-9.8 per 100 g, Protein-15.1 per 100 g, Carbohydrate-38.2 per 100 g, Sugar-4.9 per 100 g, Calories-301 k.cal]Nutritional information per 100g",
                                    "imageId": "lncw0myckjjka3apfmbk",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27691092"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678024",
                                    "name": "Cheese & Herb Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Delicious pizza topped with a blend of savory cheese and aromatic herbs, offering a flavorful and satisfying bite in every slice",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/087dc7d7-b66a-497d-8475-e3f0c9777be9_61a8bd4d-88c5-472f-9519-44b1dec9ad30.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 6500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "99219263"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678030",
                                    "name": "Onions & Capsicum Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "A delectable combination of freshly cooked onions & capsicum with our in house sauce. [Fat-5.7 per 100 g, Protein-7.4 per 100 g, Carbohydrate-10.8 per 100 g, Sugar-3.5 per 100 g, Calories-124.1 k.cal]Nutritional information per 100g",
                                    "imageId": "upcemsilpy4uwvuaetfh",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692672"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678033",
                                    "name": "Onions & Paneer Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "A delectable combination of freshly cooked onions & paneer with our in house sauce. [Fat-21.2 per 100 g, Protein-20.3 per 100 g, Carbohydrate-24.1 per 100 g, Sugar-2.9 per 100 g, Calories-368.4 k.cal]Nutritional information per 100g",
                                    "imageId": "kojenuxc4bv0dpuec2jw",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692677"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678034",
                                    "name": "Jalapenos & Olives Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Remarkable Blend of Jalapenos and Black Olives. [Fat-8.6 per 100 g, Protein-8.7 per 100 g, Carbohydrate-25.2 per 100 g, Sugar-2 per 100 g, Calories-213 k.cal]Nutritional information per 100g",
                                    "imageId": "gbkckytxs5qskbthu6zc",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691066"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678028",
                                    "name": "Capsicum Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Fresh and crispy capsicum cooked to perfection. [Fat-4.1 per 100 g, Protein-6.9 per 100 g, Carbohydrate-28.9 per 100 g, Sugar-3.2 per 100 g, Calories-180.1k.cal]Nutritional information per 100g",
                                    "imageId": "akv27cuizyv2auj02bnf",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 11500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27688739"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678032",
                                    "name": "Capsicum & Paneer Pizza",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "A delectable combination of freshly cooked capsicum & paneer with our in house sauce. [Fat-7.6 per 100 g, Protein-7.3 per 100 g, Carbohydrate-50.1 per 100 g, Sugar-3.3 per 100 g, Calories-298 k.call]Nutritional information per 100g",
                                    "imageId": "zzkznkmfd0pjisglez72",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27688723"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678031",
                                    "name": "Veg Loaded",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Sweet Corn, Tomatoes, Capsicum & Mushrooms",
                                    "imageId": "hc1lebe5yaqt0pr8lthc",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "75860414"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131899"
                          },
                          {
                            "title": "Classic Pizzas Pack Of 4",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678038",
                                    "name": "Premium Veg Pack Of 4",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Onions & Capsicum Pizza + Capsicum & Paneer Pizza + Onions & Paneer Pizza + Jalapenos & Olives Pizza",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/10/ed542bc6-7550-43c5-920a-67c88d0c739c_fe545ba8-e59e-46fb-b346-b50ddb72c884.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 54900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27693686"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678037",
                                    "name": "Single Veg Pack Of 4",
                                    "category": "Classic Pizzas For Classic Maniacs ",
                                    "description": "Onions Pizza + Tomatoes Pizza + Caspsicum Pizza + Sweet Corn Pizza",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/10/0764d162-a6a4-43f3-a4ce-aa8fc64c4040_9eb32e76-3cdb-41d6-9f93-0b92dd1f5534.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 40900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27693977"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131900"
                          }
                        ],
                        "image": "j3nizh9dasobzd5m0kz5",
                        "categoryId": "69131888"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Sides",
                        "categories": [
                          {
                            "title": "Taco's",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678060",
                                    "name": "Paneer Tikka Butter Masala & Red Paprika Taco's",
                                    "category": "Sides",
                                    "description": "Truly Delicous! Taco Stuffed with Paneer Tikka Butter Masala & Red Paprika",
                                    "imageId": "zdlucuhgehqbqwbf8kwm",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798154",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 95,
                                              "default": 1,
                                              "id": "206077765",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 165,
                                              "id": "206077766",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798154",
                                              "variationId": "206077765"
                                            }
                                          ],
                                          "price": 9500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798154",
                                              "variationId": "206077766"
                                            }
                                          ],
                                          "price": 16500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.0",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692867"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678058",
                                    "name": "Paneer & Corns Taco's",
                                    "category": "Sides",
                                    "description": "Crispy Taco filled with Paneer & Corns & Creamy Sauce",
                                    "imageId": "rir2cjvpkifadputfqfr",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798152",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 95,
                                              "default": 1,
                                              "id": "206077761",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 165,
                                              "id": "206077762",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798152",
                                              "variationId": "206077761"
                                            }
                                          ],
                                          "price": 9500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119235",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119235",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798152",
                                              "variationId": "206077762"
                                            }
                                          ],
                                          "price": 16500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119235",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119235",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119235",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692729"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678059",
                                    "name": "Paneer 65 & Onion Taco's",
                                    "category": "Sides",
                                    "description": "A fusion that combines elements from Indian and Mexican cuisines, resulting in a flavorful and unique combination",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/d56baba8-770f-493f-b475-f564fa0b2519_29f5e6a9-188d-4d9f-8db5-c1de11335f7a.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798153",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 95,
                                              "default": 1,
                                              "id": "206077763",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 165,
                                              "id": "206077764",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798153",
                                              "variationId": "206077763"
                                            }
                                          ],
                                          "price": 9500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798153",
                                              "variationId": "206077764"
                                            }
                                          ],
                                          "price": 16500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "81040258"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678057",
                                    "name": "Mushrooms & Onion Taco's",
                                    "category": "Sides",
                                    "description": "Honestly Tempting! Crispy Taco Stuffed with Mushrooms, Onion & Creamy Sauce",
                                    "imageId": "btsxunwnusjzlzmqgo9k",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798151",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 95,
                                              "default": 1,
                                              "id": "206077759",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 165,
                                              "id": "206077760",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798151",
                                              "variationId": "206077759"
                                            }
                                          ],
                                          "price": 9500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798151",
                                              "variationId": "206077760"
                                            }
                                          ],
                                          "price": 16500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "78754369"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131906"
                          },
                          {
                            "title": "Garlic Sticks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678043",
                                    "name": "Cheezo Garlic Bread Stick",
                                    "category": "Sides",
                                    "description": "A golden, crispy delight with rich melted cheese and a bold garlic flavor.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/1dd85d87-e7b3-44f7-a7b5-c69dbff5f377_689d8691-ca6e-4d8a-8ae9-cca6ad66cbb4.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27689025"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678046",
                                    "name": "Paneer Tikka Stuffed Garlic Bread",
                                    "category": "Sides",
                                    "description": "Paneer Tikka Butter Masala. [Fat-12.8 per 100 g, Protein-8.9 per 100 g, Carbohydrate-45.2 per 100 g, Sugar-0.42 per 100 g, Calories-331.6 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/7001106e-5fda-428a-8648-15460c6aa5de_27dbbba5-a6e8-44e6-9fc7-585b7de2bd76.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119234",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692893"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678045",
                                    "name": "Sweet Corn Stuffed Garlic Bread",
                                    "category": "Sides",
                                    "description": "Sweet corns, Jalapenos With Cheese. [Fat-16.2 per 100 g, Protein-10.9 per 100 g, Carbohydrate-65.4 per 100 g, Sugar-0 per 100 g, Calories-424.5 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/50a45b8a-126f-4e60-b202-29c360939b09_d487aaac-be79-413b-9f37-cea16f04580c.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119233",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27694382"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678044",
                                    "name": "Garlic Bread Sticks",
                                    "category": "Sides",
                                    "description": "Crunch your way through our cheesy garlic sticks. [Fat-11.3 per 100 g, Protein-7.6 per 100 g, Carbohydrate-44.9 per 100 g, Sugar-0.6 per 100 g, Calories-311.7 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/4e9bbb56-8038-427e-89e3-34560b1c03b2_7fad15d4-ad49-4de8-bb33-bbf7e7bf22e0.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119232",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690372"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131902"
                          },
                          {
                            "title": "Pasta Veg",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678053",
                                    "name": "Americano White Sauce Pasta Veg",
                                    "category": "Sides",
                                    "description": "A blend of American Flavours in your Favorite Pasta Onion, capsicum, sweet corn, mushroom, olives with cheese. [Fat-10.5 per 100 g, Protein-3.9 per 100 g, Carbohydrate-9.2 per 100 g, Sugar-4.2 per 100 g, Calories-146.9 k.cal] Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/4beabf6b-619c-4ec0-939d-3f7cbd81e847_746d75f3-46bb-43b9-a00e-ff5b3e6847d5.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "58271447"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678056",
                                    "name": "Mexicana Pasta Veg",
                                    "category": "Sides",
                                    "description": "Exotic red sauce with onion, capsicum, mushroom, olives and cheese. [Fat-10.1 per 100 g, Protein-12.1 per 100 g, Carbohydrate-32.6 per 100 g, Sugar-2.4 per 100 g, Calories-269.7k.cal]Nutritional information per 100g",
                                    "imageId": "jujsk3dbt5gdn9yx5uxj",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692030"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678054",
                                    "name": "Indiana Pasta Veg",
                                    "category": "Sides",
                                    "description": "A perfect blend of India flavours and pasta topped with Onion, capsicum, paneer, mushroom, red paprika & cheese. [Fat-9.4 per 100 g, Protein-12.1 per 100 g, Carbohydrate-31.6 per 100 g, Sugar-3.1 per 100 g, Calories-259.1 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/3/8f912ade-b476-464f-8423-14a7abcaad96_248af5ae-489a-47b8-932f-6c168a87d723.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690918"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678055",
                                    "name": "Italiano Pasta Veg",
                                    "category": "Sides",
                                    "description": "An Italian classic with an india twist. Onion, capsicum, paneer, mushroom. [Fat-9.2 per 100 g, Protein-23 per 100 g, Carbohydrate-12.5 per 100 g, Sugar-0.7 per 100 g, Calories-224.8 k.cal]Nutritional information per 100g",
                                    "imageId": "yb2tpnwkcfrgs9kg9zvm",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "27690984"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131905"
                          },
                          {
                            "title": "Garlic Bread",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678040",
                                    "name": "Cheesy Garlic Bread",
                                    "category": "Sides",
                                    "description": "Garlic bread baked to perfection with cheese. [Fat-16 per 100 g, Protein-9.7 per 100 g, Carbohydrate-40.1 per 100 g, Sugar-1.9 per 100 g, Calories-343.2 k.cal]Nutritional information per 100g",
                                    "imageId": "pes4yfbmal657dscidka",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 12900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119229",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27688915"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678039",
                                    "name": "Plain Garlic Bread",
                                    "category": "Sides",
                                    "description": "The quintessential garlic bread side for your pizza. [Fat-12.4 per 100 g, Protein-7.8  per 100 g, Carbohydrate-45.6 per 100 g, Sugar-0.4 per 100 g, Calories-325.2 k.cal]Nutritional information per 100g",
                                    "imageId": "qsllzymmfmfcbycjqzb2",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119228",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27693660"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678042",
                                    "name": "Paneer Tikka Garlic Bread",
                                    "category": "Sides",
                                    "description": "Cheesy garlic bread topped with Chunks of juicy paneer & red paprika. [Fat-18.4 per 100 g, Protein-11 per 100 g, Carbohydrate-8.1 per 100 g, Sugar-0.7 per 100 g, Calories-242 k. cal]Nutritional information per 100g",
                                    "imageId": "rjolfdypdwdavxf48ja7",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119231",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692876"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678041",
                                    "name": "Supreme Garlic Bread",
                                    "category": "Sides",
                                    "description": "Super cheesy garlic bread topped with onions, jalapinos, sweet corn & olives. [Fat-9.6 per 100 g, Protein-6.2- per 100 g, Carbohydrate-40.4 per 100 g, Sugar-0.3 per 100 g, Calories-272.8 k.cal]Nutritional information per 100g",
                                    "imageId": "wpjovhkp9gdow2ffpkp4",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119230",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694344"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131901"
                          },
                          {
                            "title": "Dips",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678066",
                                    "name": "Cheesey Dip",
                                    "category": "Sides",
                                    "description": "Creamy, savory delight, cheese dip enchants taste buds, a luscious blend for irresistible snacking indulgence.",
                                    "imageId": "kejvlymoc6nnbxuryas5",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 3000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "54197662"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678068",
                                    "name": "Peri Peri Dip",
                                    "category": "Sides",
                                    "description": "Zesty, fiery allure, peri peri dip sparks taste buds, delivering a tantalizing kick to every bite.",
                                    "imageId": "hxpunoggbeephclolsdw",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 3000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692994"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678067",
                                    "name": "Jalapeno Dip",
                                    "category": "Sides",
                                    "description": "Spicy kick, creamy bliss, jalapeno dip elevates every snack",
                                    "imageId": "dn3rb6lxtts39i1snjwh",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 3000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691045"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678069",
                                    "name": "Spicy 65 Dip",
                                    "category": "Sides",
                                    "description": "Juicy combination of Indian flavour and the unique spice blend dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/519e1b13-fc00-4f28-9050-54c601740d45_8de97e6b-ab4d-4117-97e2-41dd89ed193c.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 3000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "82458393"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131909"
                          },
                          {
                            "title": "Spaghetti",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678052",
                                    "name": "Veg Spaghetti - Rosy Red",
                                    "category": "Sides",
                                    "description": "Onions, Capsicums, Sweet Corns, Paneer. [Fat-2.4 per 100 g, Protein-8.1 per 100 g, Carbohydrate-43.2 per 100 g, Sugar-0.8 per 100 g, Calories-226.8 k.cal]Nutritional information per 100g",
                                    "imageId": "9c642ed5451258d6dc62349d0e2fbb0d",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245876"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678050",
                                    "name": "Veg Spaghetti - Creamy White",
                                    "category": "Sides",
                                    "description": "Onions, Mushrooms, Sweet Corns, Olives. [Fat-7.9 per 100 g, Protein-11.4 per 100 g, Carbohydrate-62.1 per 100 g, Sugar-6.1 per 100 g, Calories-416.1 k.cal]Nutritional information per 100g",
                                    "imageId": "64b349bdf14f8860cb94c438dce44ce9",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245874"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678051",
                                    "name": "Veg Spaghetti - Pesto",
                                    "category": "Sides",
                                    "description": "Onions, Capsicum, Mushrooms, Sweet Corns, Olives. [Fat-9.1 per 100 g, Protein-6.8 per 100 g, Carbohydrate-27.1 per 100 g, Sugar-0.6 per 100 g, Calories-217.5 k.cal]Nutritional information per 100g",
                                    "imageId": "62bdd2d2d61cfc1bdb17129f09d584aa",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245875"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131904"
                          },
                          {
                            "title": "Lasagna",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678049",
                                    "name": "Veg Lasagna - Rosy Red",
                                    "category": "Sides",
                                    "description": "Onions, Sweetcorn, Paneer, Capsicum Topped With Rosy Red Sauce And Cheese",
                                    "imageId": "e34f5339dc1cf06011ecc6763a8f8abd",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245873"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678048",
                                    "name": "Veg Lasagna - Pesto",
                                    "category": "Sides",
                                    "description": "Onions, Sweet Corn, Paneer, Capsicum Topped With Pesto Sauce And Cheese",
                                    "imageId": "ada92d4d06090c827d6fe155ba117938",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245872"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678047",
                                    "name": "Veg Lasagna - Creamy White",
                                    "category": "Sides",
                                    "description": "Onions, Mushrooms, Sweet Corns, Olives. [Fat-6.4 per 100 g, Protein-7.1 per 100 g, Carbohydrate-7.3 per 100 g, Sugar-1.5 per 100 g, Calories-115.2 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/125380d8-787c-45ef-ada7-f0723af07aa6_49e383f0-f0a8-4476-a515-c21ce781a8d3.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "42245871"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131903"
                          },
                          {
                            "title": "Quesadillas",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678064",
                                    "name": "Paneer 65 & Cheese Quesadillas",
                                    "category": "Sides",
                                    "description": "Deliciously crispy and cheesy quesadilla with a spicy kick from the paneer 65 filling",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/4380e158-f8a1-4377-b2e0-fc42c26dc920_8b3e944c-2ea8-4636-ac24-966cee550e3a.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798156",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 90,
                                              "default": 1,
                                              "id": "206077769",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 160,
                                              "id": "206077770",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798156",
                                              "variationId": "206077769"
                                            }
                                          ],
                                          "price": 9000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798156",
                                              "variationId": "206077770"
                                            }
                                          ],
                                          "price": 16000
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "80989267"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678063",
                                    "name": "Mushroom, Olives & Cheese Quesadillas",
                                    "category": "Sides",
                                    "description": "Soft Shell Tortilla Stuffed with Mushroom, Olives & Cheese. [Fat-8.2 per 100 g, Protein-7.9 per 100 g, Carbohydrate-25.5 per 100 g, Sugar-2.4 per 100 g, Calories-207.4 k.cal]Nutritional information per 100g",
                                    "imageId": "gzt9rgq1rzbxpxedncl3",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798155",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 90,
                                              "default": 1,
                                              "id": "206077767",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 160,
                                              "id": "206077768",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798155",
                                              "variationId": "206077767"
                                            }
                                          ],
                                          "price": 9000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798155",
                                              "variationId": "206077768"
                                            }
                                          ],
                                          "price": 16000
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27692259"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678065",
                                    "name": "Paneer, Sweet Corn & Cheese Quesadillas",
                                    "category": "Sides",
                                    "description": "Soft Shell Tortilla filled with Paneer, Sweet Corn & Cheese. [Fat-8 per 100 g, Protein-9 per 100 g , Carbohydrate-40 per 100 g, Sugar-0 per 100 g, Calories-268 k.cal]Nutritional information per 100g",
                                    "imageId": "yr377k1absshxylbij1o",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798157",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pcs",
                                              "price": 90,
                                              "default": 1,
                                              "id": "206077771",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 Pcs",
                                              "price": 160,
                                              "id": "206077772",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798157",
                                              "variationId": "206077771"
                                            }
                                          ],
                                          "price": 9000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119236",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119236",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798157",
                                              "variationId": "206077772"
                                            }
                                          ],
                                          "price": 16000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119236",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119236",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119236",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692792"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131908"
                          },
                          {
                            "title": "Macaroni & Cheese",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678062",
                                    "name": "Smoke Chilli Macaroni Veg",
                                    "category": "Sides",
                                    "description": "La Pinoz macaroni n cheese veg with a unique smoked chilli flavour. [Fat-8.6 per 100 g, Protein-7.6 per 100 g, Carbohydrate-27.2 per 100 g, Sugar-2.7 per 100 g, Calories-216.6 k.cal]Nutritional information per 100g",
                                    "imageId": "stshcoqrijxm9bzerrnb",
                                    "isVeg": 1,
                                    "price": 16700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "nextAvailableAtMessage": "Next available at 1:51 pm, today",
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694096"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678061",
                                    "name": "Macaroni & Cheese Veg",
                                    "category": "Sides",
                                    "description": "Quintessential veg macaroni n cheese, la pinoz style. [Fat-5 per 100 g, Protein-7.2 per 100 g, Carbohydrate-23.7 per 100 g, Sugar-1.6 per 100 g, Calories-168.6 k.cal]Nutritional information per 100g",
                                    "imageId": "rs4vkdrjs7tk9dd05dfy",
                                    "isVeg": 1,
                                    "price": 16700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "nextAvailableAtMessage": "Next available at 1:51 pm, today",
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691673"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131907"
                          }
                        ],
                        "image": "pes4yfbmal657dscidka",
                        "categoryId": "69131889"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Veg Pizza",
                        "categories": [
                          {
                            "title": "Speciality Veg",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678006",
                                    "name": "English Retreat Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Olives,Red Paprika, Tomatoes, Paneer, Capsicum, Cheese, Jalapeno Dip. An English special. [Fat-11.9 per 100 g, Protein-11.1 per 100 g, Carbohydrate-37.1 per 100 g, Sugar-3.6 per 100 g, Calories-300.3 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/87bb4dfa-c300-41e0-8197-3a0e4b4a669b_21d3aca1-091a-46d5-8d26-944b39eec1a8.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798132",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077700",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077701",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077702",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798132",
                                              "variationId": "206077700"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119096",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119086",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119086",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119090",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119093",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798132",
                                              "variationId": "206077701"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119091",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119096",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119094",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119087",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119087",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798132",
                                              "variationId": "206077702"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119092",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119096",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119088",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119095",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119089",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119086",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119087",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119088",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119089",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119090",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119091",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119092",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119093",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119094",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119095",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119096",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27689965"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678013",
                                    "name": "La Pino'z Paneer Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A La Pinoz special. Onion, Capsicum, Paneer, Sweet Corn & Olives With Cheese Dip. [Fat-8.4 per 100 g, Protein-11.8 per 100 g, Carbohydrate-34.4 per 100 g, Sugar-2 per 100 g, Calories-260.8 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/0d99e64a-4547-41f5-9b0c-9fe4c5517e01_2c94222b-9074-4cad-9f50-a1c15eadd436.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798140",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077724",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077725",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077726",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798140",
                                              "variationId": "206077724"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119149",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119138",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119138",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119142",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119146",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798140",
                                              "variationId": "206077725"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119143",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119149",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119147",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119139",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119139",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798140",
                                              "variationId": "206077726"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119144",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119149",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119140",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119148",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119141",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119138",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119139",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119140",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119141",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119142",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119143",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119144",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119146",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119147",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119148",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119149",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691366"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678005",
                                    "name": "Cheezy-7 Pizza",
                                    "category": "Veg Pizza",
                                    "description": "An Exotic Combination of White Mozzarilla, Cream White Cheese, Cheddar, Monterey Jack, Cream Orange Cheese, Colby, Orange Cheddar. [Fat-12.4 per 100 g, Protein-10.3 per 100 g, Carbohydrate-32.2 per 100 g, Sugar-2.1 per 100 g, Calories-281.8 k.cal]Nutritional information per 100g",
                                    "imageId": "pf5pjfn9ein2xyqvrpor",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798131",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077697",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077698",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077699",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798131",
                                              "variationId": "206077697"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119085",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119075",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119075",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119079",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119082",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798131",
                                              "variationId": "206077698"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119080",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119085",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119083",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119076",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119076",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798131",
                                              "variationId": "206077699"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119081",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119085",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119077",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119084",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119078",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119075",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119076",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119077",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119078",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119079",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119080",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119081",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119082",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119083",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119084",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119085",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27689044"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678002",
                                    "name": "Authentic Veg Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Onion, Capsicum, Paneer With Jalapenos Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/21/756c3a08-b985-408a-9fa5-4a24dce1593b_64f19672-a8b3-4247-81f1-e31bb5975654.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798128",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077688",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077689",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077690",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798128",
                                              "variationId": "206077688"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119053",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119043",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119043",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119047",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119050",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798128",
                                              "variationId": "206077689"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119048",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119053",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119051",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119044",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119044",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798128",
                                              "variationId": "206077690"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119049",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119053",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119045",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119052",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119046",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119043",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119044",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119045",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119046",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119047",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119048",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119049",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119050",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119051",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119052",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119053",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27688455"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678004",
                                    "name": "Cheesy Macaroni Veg Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Paneer, Onions, Capsicum, Olives, Baby Corn  With Loads Of Cheese",
                                    "imageId": "qshil15ztkifwocci9iw",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798130",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077694",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077695",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077696",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798130",
                                              "variationId": "206077694"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119074",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119065",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119065",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119068",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119071",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798130",
                                              "variationId": "206077695"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119069",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119074",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119072",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119066",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119066",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798130",
                                              "variationId": "206077696"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119070",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119074",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119067",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119073",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119065",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119066",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119067",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119068",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119069",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119070",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119071",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119072",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119073",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119074",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27688937"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678023",
                                    "name": "Tandoori Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Capsicum, Sweet Corn, Red Paprika, Double Paneer With Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798150",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077756",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077757",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077758",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798150",
                                              "variationId": "206077756"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119227",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119217",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119217",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119220",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119224",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798150",
                                              "variationId": "206077757"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119221",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119227",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119225",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119218",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119218",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798150",
                                              "variationId": "206077758"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119222",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119227",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119219",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119226",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119217",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119218",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119219",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119220",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119221",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119222",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119224",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119225",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119226",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119227",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694489"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678021",
                                    "name": "Pesto & Basil Veg Pizza.",
                                    "category": "Veg Pizza",
                                    "description": "Onion, Capsicum, Mushroom, Sweet Corn, Jalapenos in Pesto & Basil Sauce",
                                    "imageId": "bmapdc1bez6qappkamqv",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798148",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077750",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077751",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077752",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798148",
                                              "variationId": "206077750"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119204",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119194",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119194",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119197",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119201",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798148",
                                              "variationId": "206077751"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119199",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119204",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119202",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119195",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119195",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798148",
                                              "variationId": "206077752"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119200",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119204",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119196",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119203",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119194",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119195",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119196",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119197",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119199",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119200",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119201",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119202",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119203",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119204",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27693605"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678001",
                                    "name": "Ala Mexican Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Onion,Sweet Corns,Mushroom,Baby Corns,Mexican Salsa Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/21/d1379074-141b-406a-ae7e-2a48dd607fae_121df533-fb3a-4aac-9f98-97992690abc0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798127",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077685",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077686",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077687",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798127",
                                              "variationId": "206077685"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119042",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119033",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119033",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119036",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119039",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798127",
                                              "variationId": "206077686"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119037",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119042",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119040",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119034",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119034",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798127",
                                              "variationId": "206077687"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119038",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119042",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119035",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119041",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119033",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119034",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119035",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119036",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119037",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119038",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119039",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119040",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119041",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119042",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27688359"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678003",
                                    "name": "Cheese Lovers Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Cheese Dip, Jalapeno Dip, Capsicum, Paneer, Onion, Baby Corn, Mushroom [Fat-11.3 per 100 g, Protein-8.7 per 100 g, Carbohydrate-33.4 per 100 g, Sugar-2 per 100 g, Calories-270 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/26/c6b99e73-9b73-4269-9f88-e844739c0acf_c5f243a1-61b6-4859-8f6b-3a9faabf4fef.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798129",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077691",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077692",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077693",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798129",
                                              "variationId": "206077691"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119064",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119054",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119054",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119058",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119061",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798129",
                                              "variationId": "206077692"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119059",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119064",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119062",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119055",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119055",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798129",
                                              "variationId": "206077693"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119060",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119064",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119056",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119063",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119057",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119054",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119055",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119056",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119057",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119058",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119059",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119060",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119061",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119062",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119063",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119064",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27688824"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678007",
                                    "name": "Garlic-to-pizza Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Hot & Garlic Dip with onions, Capsicum, Paneer, Mushroom, Jalapenos. [Fat-12 per 100 g, Protein-14.8 per 100 g, Carbohydrate-24.9 per 100 g, Sugar-2.2 per 100 g, Calories-266.7 4k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/26/472f2cc8-8aca-4af8-88de-b9affc37afae_91b44691-b535-4725-bc2d-b2f578ac31a4.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798133",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077703",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077704",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077705",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798133",
                                              "variationId": "206077703"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119106",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119097",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119097",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119100",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119103",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798133",
                                              "variationId": "206077704"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119101",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119106",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119104",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119098",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119098",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798133",
                                              "variationId": "206077705"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119102",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119106",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119099",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119105",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119097",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119098",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119099",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119100",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119101",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119102",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119103",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119104",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119105",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119106",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690417"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678008",
                                    "name": "Hot Passion Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Hot passion on a Pizza. Jalapenos, Mushrooms, Red Paprika, Fresh Tomato With Jalapeno Dip. [Fat-6.5 per 100 g, Protein-6.1 per 100 g, Carbohydrate-45 per 100 g, Sugar-0 per 100 g, Calories-263.2 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/21/cabeddd9-82ca-41cc-8842-f97ed9448065_fd2f071b-f0a9-43b9-a4df-90d3f1f895d9.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798134",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077706",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077707",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077708",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798134",
                                              "variationId": "206077706"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119117",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119107",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119107",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119111",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119114",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798134",
                                              "variationId": "206077707"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119112",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119117",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119115",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119108",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119108",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798134",
                                              "variationId": "206077708"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119113",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119117",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119109",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119116",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119110",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119107",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119108",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119109",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119110",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119111",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119112",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119113",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119114",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119115",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119116",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119117",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690793"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678009",
                                    "name": "Indian Style Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Onion, Mushroom, Paneer, Olives, Tomatoes In Korma Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/21/ce3b0771-e1f7-4878-82bb-d1b8c4b0332d_2bf8bb6a-bfd1-40bf-bfa6-091658faf90c.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798135",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077709",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077710",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077711",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798135",
                                              "variationId": "206077709"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119127",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119118",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119118",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119121",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119124",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798135",
                                              "variationId": "206077710"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119122",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119127",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119125",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119119",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119119",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798135",
                                              "variationId": "206077711"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119123",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119127",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119120",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119126",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119118",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119119",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119120",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119121",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119122",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119123",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119124",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119125",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119126",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119127",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690952"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678010",
                                    "name": "Korma Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Capsicum, Red paprika, Paneer, Sweet Corn, Baby Corn in Korma Dip [Fat-9.9 per 100 g, Protein-8 per 100 g, Carbohydrate-40.3 per 100 g, Sugar-3.1 per 100 g, Calories-282.3 k.cal]Nutritional information per 100g",
                                    "imageId": "wffp2zw93w1jtqrqaagg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798136",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077712",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077713",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077714",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798136",
                                              "variationId": "206077712"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119137",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119128",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119128",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119131",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119134",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798136",
                                              "variationId": "206077713"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119132",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119137",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119135",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119129",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119129",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798136",
                                              "variationId": "206077714"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119133",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119137",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119130",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119136",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119128",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119129",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119130",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119131",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119132",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119133",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119134",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119135",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119136",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119137",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691254"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678018",
                                    "name": "Las Vegas Treat Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Mushrooms, Jalapenos, Baby Corn , Capsicum, Tomatoes With Peri Peri Dip. [Fat-10.4 per 100 g, Protein-6.7 per 100 g, Carbohydrate-43.1 per 100 g, Sugar-3.6 per 100 g, Calories-292.3 k.call] Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/b093f9e3-e55b-4f2f-b8d2-b4987c8ce948_58c5473c-f378-4224-a1ca-18062f4f09dd.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798145",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077741",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077742",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077743",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798145",
                                              "variationId": "206077741"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119163",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119152",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119152",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119155",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119160",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798145",
                                              "variationId": "206077742"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119156",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119163",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119161",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119153",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119153",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798145",
                                              "variationId": "206077743"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119158",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119163",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119154",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119162",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119152",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119153",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119154",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119155",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119156",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119158",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119160",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119161",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119162",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119163",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691560"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678019",
                                    "name": "Mexican Salsa",
                                    "category": "Veg Pizza",
                                    "description": "Mexican Salsa Dip, Capsicum Sweet Corns, Jalapenos, Onion & Mushroom",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798146",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077744",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077745",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077746",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798146",
                                              "variationId": "206077744"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119177",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119167",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119167",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119170",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119174",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798146",
                                              "variationId": "206077745"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119171",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119177",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119175",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119168",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119168",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798146",
                                              "variationId": "206077746"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119172",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119177",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119169",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119176",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119167",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119168",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119169",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119170",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119171",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119172",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119174",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119175",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119176",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119177",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692053"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678020",
                                    "name": "Peri Peri Veg Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Milder, but just as tasty. Onion, Capsicum, Mushroom, Paneer, Olives With Peri Peri Dip. [Fat-6.1 per 100 g, Protein-13.9 per g, Carbohydrate-33.8 per g, Sugar-0 per g, Calories-246.1 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/e4370050-8a43-409e-bbe8-bf829f9babb8_60f58736-61c6-4aa9-95c6-e35d84123c47.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798147",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077747",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077748",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077749",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798147",
                                              "variationId": "206077747"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119192",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119181",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119181",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119184",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119188",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798147",
                                              "variationId": "206077748"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119185",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119192",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119190",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119182",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119182",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798147",
                                              "variationId": "206077749"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119186",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119192",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119183",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119191",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119181",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119182",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119183",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119184",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119185",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119186",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119188",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119190",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119191",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119192",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27693020"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678022",
                                    "name": "Spicy Veggie 65",
                                    "category": "Veg Pizza",
                                    "description": "Red Peprika,jalapenos,capsicum,onion,paneer 65 with extra cheese",
                                    "imageId": "zu33zosn9iqxeiabfxkf",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798149",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 308,
                                              "default": 1,
                                              "id": "206077753",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 700,
                                              "id": "206077754",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 835,
                                              "id": "206077755",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798149",
                                              "variationId": "206077753"
                                            }
                                          ],
                                          "price": 30800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119216",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119206",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119206",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119209",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119212",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798149",
                                              "variationId": "206077754"
                                            }
                                          ],
                                          "price": 70000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119210",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119216",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119213",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119207",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119207",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798149",
                                              "variationId": "206077755"
                                            }
                                          ],
                                          "price": 83500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119211",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119216",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119208",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119214",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119206",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119207",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119208",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119209",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119210",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119211",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119212",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119213",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119214",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119216",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "76369696"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131898"
                          },
                          {
                            "title": "Exotic Veg",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677977",
                                    "name": "Burn To Hell Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A fiery and lethal combination of hot & garlic dip, jalapenos, mushrooms, olives and capsicum. [Fat-8.4 per 100 g, Protein-13.1 per 100 g, Carbohydrate-43.1 per 100 g, Sugar-2.6 per 100 g, Calories-300.5 k. cal]Nutritional information per 100g",
                                    "imageId": "anmrle3vdtlsjegbvyda",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798119",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077661",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077662",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077663",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798119",
                                              "variationId": "206077661"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118959",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118950",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118950",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118953",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118956",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798119",
                                              "variationId": "206077662"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118954",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118959",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118957",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118951",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118951",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798119",
                                              "variationId": "206077663"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118955",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118959",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118952",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118958",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118950",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118951",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118952",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118953",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118954",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118955",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118956",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118957",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118958",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118959",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27688591"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677978",
                                    "name": "Farm Villa Pizza",
                                    "category": "Veg Pizza",
                                    "description": "The freshness of capsicum, tomatoes, with the flavour of paneer and red paprika topped with a korma dip. [Fat-10.9 per 100 g, Protein-12.7 per 100 g, Carbohydrate-34.9 per 100 g, Sugar-0 per 100 g, Calories-288.9 k.cal]Nutritional information per 100g",
                                    "imageId": "kwznoeoksrxafyg6rx6w",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798120",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077664",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077665",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077666",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798120",
                                              "variationId": "206077664"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118970",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118960",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118960",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118964",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118967",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798120",
                                              "variationId": "206077665"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118965",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118970",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118968",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118961",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118961",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798120",
                                              "variationId": "206077666"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118966",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118970",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118962",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118969",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118963",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118960",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118961",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118962",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118963",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118964",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118965",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118966",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118967",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118968",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118969",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118970",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690127"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677990",
                                    "name": "Paneer Tikka Butter Masala Pizza",
                                    "category": "Veg Pizza",
                                    "description": "An indian Speciality on a La Pinoz Pizza. Exotic Paneer Tikka, Onion, Capsicum & Red Paprika. [Fat-12.7 per 100 g, Protein-13.4 per 100 g, Carbohydrate-24.6 per 100 g, Sugar-0 per 100 g, Calories-266.2 k.cal]Nutritional information per 100g",
                                    "imageId": "cq4lnlqv8a1bntyxnsol",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798124",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077676",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077677",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077678",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798124",
                                              "variationId": "206077676"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119011",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119002",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119002",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119005",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119008",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798124",
                                              "variationId": "206077677"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119006",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119011",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119009",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119003",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119003",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798124",
                                              "variationId": "206077678"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119007",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119011",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119004",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119010",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119002",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119003",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119004",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119005",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119006",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119007",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119008",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119009",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119010",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119011",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692829"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677988",
                                    "name": "Paneer 65",
                                    "category": "Veg Pizza",
                                    "description": "A Combination Of Onion, Capsicum, Red Paprika, Paneer 65 With Extra Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/2e683674-be73-4f20-a054-3621eecab26c_73e6ff2d-fb40-489b-beba-1b200482328f.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798122",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 255,
                                              "default": 1,
                                              "id": "206077670",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 595,
                                              "id": "206077671",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077672",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798122",
                                              "variationId": "206077670"
                                            }
                                          ],
                                          "price": 25500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118991",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118982",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118982",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118985",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118988",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798122",
                                              "variationId": "206077671"
                                            }
                                          ],
                                          "price": 59500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118986",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118991",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118989",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118983",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118983",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798122",
                                              "variationId": "206077672"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118987",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118991",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118984",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118990",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118982",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118983",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118984",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118985",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118986",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118987",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118988",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118989",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118990",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118991",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 25500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "76369695"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677981",
                                    "name": "Garden Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A close cousin of the gardne delight. Capsicum,Mushrooms,Onion, and Fresh Tomatoes. [Fat-18.8 per 100 g, Protein-10.8 per 100 g, Carbohydrate-16.4 per 100 g, Sugar-0 per 100 g, Calories-277.6 k.call]Nutritional information per 100g",
                                    "imageId": "gpnwjuohwsm9tu6jsttc",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798121",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077667",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077668",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077669",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798121",
                                              "variationId": "206077667"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118981",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118972",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118972",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118975",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118978",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798121",
                                              "variationId": "206077668"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118976",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118981",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118979",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118973",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118973",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798121",
                                              "variationId": "206077669"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118977",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118981",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118974",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118980",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118972",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118973",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118974",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118975",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118976",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118977",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118978",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118979",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118980",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118981",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690334"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677989",
                                    "name": "Paneer Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Onion, Capsicum, Double Paneer, Red Paprika In Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798123",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077673",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077674",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077675",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798123",
                                              "variationId": "206077673"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119001",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118992",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118992",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118995",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118998",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798123",
                                              "variationId": "206077674"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118996",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119001",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118999",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118993",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118993",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798123",
                                              "variationId": "206077675"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118997",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119001",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118994",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119000",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118992",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118993",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118994",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118995",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118996",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118997",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118998",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118999",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119000",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119001",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692758"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677991",
                                    "name": "Sweet Heat Pizza",
                                    "category": "Veg Pizza",
                                    "description": "[Available in Jain] Jalapenos, Pineapples, Sweet Corns, Red Paprika",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/3f01ec79-43da-40b7-933c-a14d07a82ade_702d5270-7542-4d21-bd7a-8c81a58b52da.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798125",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077679",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077680",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077681",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798125",
                                              "variationId": "206077679"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119022",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119012",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119012",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119016",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119019",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798125",
                                              "variationId": "206077680"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119017",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119022",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119020",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258119013",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119013",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798125",
                                              "variationId": "206077681"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119018",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119022",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119014",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119021",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258119015",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119012",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119013",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119014",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119015",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119016",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119017",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119018",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119019",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119020",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119021",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119022",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694398"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677993",
                                    "name": "Tandoori Paneer Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Capsicum, Onion, Paneer, Sweet Corn In Korma Dip",
                                    "imageId": "s7hcfjiuascqo8xugevl",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798126",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 286,
                                              "default": 1,
                                              "id": "206077682",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 666,
                                              "id": "206077683",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 803,
                                              "id": "206077684",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798126",
                                              "variationId": "206077682"
                                            }
                                          ],
                                          "price": 28600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119032",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119023",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119023",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119026",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119029",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798126",
                                              "variationId": "206077683"
                                            }
                                          ],
                                          "price": 66600,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119027",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119032",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119030",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119024",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119024",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798126",
                                              "variationId": "206077684"
                                            }
                                          ],
                                          "price": 80300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119028",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119032",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119025",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119031",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119023",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119024",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119025",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119026",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119027",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119028",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119029",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119030",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119031",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119032",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694461"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131897"
                          },
                          {
                            "title": "Simply Veg",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677973",
                                    "name": "Veg Hawaiian Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Nothing says Hawaiian like pineapple, paneer, and sweet corn with extra cheese. [Fat-20.3 per 10 g, Protein-10.9 per 100 g, Carbohydrate-28.6 per 100 g, Sugar-0 per 100 g, Calories-340.9 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/67b7ccfa-1086-4439-a76e-b79255ef9e98_22974675-884d-40d4-8e09-5ee540234a20.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798117",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077655",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077656",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077657",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798117",
                                              "variationId": "206077655"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118939",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118929",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118929",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118933",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118936",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798117",
                                              "variationId": "206077656"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118934",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118939",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118937",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118930",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118930",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798117",
                                              "variationId": "206077657"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118935",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118939",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118931",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118938",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118932",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118929",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118930",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118931",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118932",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118933",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118934",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118935",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118936",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118937",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118938",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118939",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694948"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677951",
                                    "name": "Double Cheese Margherita Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Loaded with extra cheese",
                                    "imageId": "1cd9a5fe410b083323adb073a87895ec",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798106",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077620",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077621",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077622",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798106",
                                              "variationId": "206077620"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118897",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118887",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118887",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118891",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118894",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798106",
                                              "variationId": "206077621"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118892",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118897",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118895",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118888",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118888",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798106",
                                              "variationId": "206077622"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118893",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118897",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118889",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118896",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118890",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118887",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118888",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118889",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118890",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118891",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118892",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118893",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118894",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118895",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118896",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118897",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27689871"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677958",
                                    "name": "Lovers Bite Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A wholesome combination of tossed mushrooms, olives and juicy sweet corn. [Fat-9 per 100 g, Protein-12.4 per 100 g, Carbohydrate-32.2 per 100 g, Sugar-0 per 100 g, Calories-260.1 k.cal]Nutritional information per 100g",
                                    "imageId": "f51re5mmk0wx5ngsu9bl",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798107",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077623",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077624",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077625",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798107",
                                              "variationId": "206077623"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118907",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118898",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118898",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118901",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118904",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798107",
                                              "variationId": "206077624"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118902",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118907",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118905",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118899",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118899",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798107",
                                              "variationId": "206077625"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118903",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118907",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118900",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118906",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118898",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118899",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118900",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118901",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118902",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118903",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118904",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118905",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118906",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118907",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691630"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677962",
                                    "name": "Pesto & Basil Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Capsicum, Jalapenos ,Paneer With Pesto & Basil Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/28/7dea6a78-7ba9-4569-9e0e-e1d83cfe0d79_c2c786f7-4411-430f-aa19-fb748d192c82.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798108",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077626",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077627",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077628",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798108",
                                              "variationId": "206077626"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118917",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118908",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118908",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118911",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118914",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798108",
                                              "variationId": "206077627"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118912",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118917",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118915",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118909",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118909",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798108",
                                              "variationId": "206077628"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118913",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118917",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118910",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118916",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118908",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118909",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118910",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118911",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118912",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118913",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118914",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118915",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118916",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118917",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27693596"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677968",
                                    "name": "Spring Fling Pizza",
                                    "category": "Veg Pizza",
                                    "description": "Quintessentially veg with Paneer, Fresh Tomatoes, Capsicum, Sweet Corns. [Fat-12.1 per 100 g, Protein-10.1 per 100 g, Carbohydrate-34 per 100 g, Sugar-0 per 100 g, Calories-285.2 k.cal]Nutritional information per 100g",
                                    "imageId": "y5xpwhjvk0z0txx00vpv",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798109",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077629",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077630",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077631",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798109",
                                              "variationId": "206077629"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118928",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118918",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118918",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118922",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118925",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798109",
                                              "variationId": "206077630"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118923",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118928",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118926",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118919",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118919",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798109",
                                              "variationId": "206077631"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118924",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118928",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118920",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118927",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118921",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118918",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118919",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118920",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118921",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118922",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118923",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118924",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118925",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118926",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118927",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118928",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27694211"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677976",
                                    "name": "Mac Special Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A special fusion Cheesy mac pizza with Onions,Sweet Corns and Mushrooms",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/a82f9bb5-1614-4173-813d-0a34e9ec1ea9_ac07b396-f94f-4c32-8d6b-a095c199fe26.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798118",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 207,
                                              "default": 1,
                                              "id": "206077658",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 498,
                                              "id": "206077659",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 593,
                                              "id": "206077660",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798118",
                                              "variationId": "206077658"
                                            }
                                          ],
                                          "price": 20700,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118949",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118940",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118940",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118943",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118946",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798118",
                                              "variationId": "206077659"
                                            }
                                          ],
                                          "price": 49800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118944",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118949",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118947",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118941",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118941",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798118",
                                              "variationId": "206077660"
                                            }
                                          ],
                                          "price": 59300,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118945",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118949",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118942",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118948",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118940",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118941",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118942",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118943",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118944",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118945",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118946",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118947",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118948",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118949",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 20700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691712"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131896"
                          },
                          {
                            "title": "Classic Pizza Veg",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677945",
                                    "name": "Margherita Pizza",
                                    "category": "Veg Pizza",
                                    "description": "A classic cheesy Margherita. Cant go wrong. [Fat-14.3 per 100 g, Protein-12.6 per 100 g, Carbohydrate-39.2 per 100 g, Sugar-0 per 100 g, Calories-336 k.cal]Nutritional information per 100g",
                                    "imageId": "j23ok15p0ge6cfwqpg8m",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798102",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 162,
                                              "default": 1,
                                              "id": "206077608",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 398,
                                              "id": "206077609",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 478,
                                              "id": "206077610",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798102",
                                              "variationId": "206077608"
                                            }
                                          ],
                                          "price": 16200,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118855",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118845",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118845",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118849",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118852",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798102",
                                              "variationId": "206077609"
                                            }
                                          ],
                                          "price": 39800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118850",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118855",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118853",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118846",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118846",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798102",
                                              "variationId": "206077610"
                                            }
                                          ],
                                          "price": 47800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118851",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118855",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118847",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118854",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118848",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118845",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118846",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118847",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118848",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118849",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118850",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118851",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118852",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118853",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118854",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118855",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16200,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.7",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "27691777"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677946",
                                    "name": "Makhni Do Pyaza",
                                    "category": "Veg Pizza",
                                    "description": "Makhani Gravy, Onion & Cheese",
                                    "imageId": "gexq4nobtmrzkjlmfehf",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798103",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 162,
                                              "default": 1,
                                              "id": "206077611",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 398,
                                              "id": "206077612",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 478,
                                              "id": "206077613",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798103",
                                              "variationId": "206077611"
                                            }
                                          ],
                                          "price": 16200,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118865",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118856",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118856",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118859",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118862",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798103",
                                              "variationId": "206077612"
                                            }
                                          ],
                                          "price": 39800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118860",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118865",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118863",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118857",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118857",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798103",
                                              "variationId": "206077613"
                                            }
                                          ],
                                          "price": 47800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118861",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118865",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118858",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118864",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118856",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118857",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118858",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118859",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118860",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118861",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118862",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118863",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118864",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118865",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16200,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "54085986"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677948",
                                    "name": "Sweet Corns Delight",
                                    "category": "Veg Pizza",
                                    "description": "A combination of juicy Sweet Corns & Cheese",
                                    "imageId": "byjkpajvtxaptaxofj1l",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798105",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 162,
                                              "default": 1,
                                              "id": "206077617",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 398,
                                              "id": "206077618",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 478,
                                              "id": "206077619",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798105",
                                              "variationId": "206077617"
                                            }
                                          ],
                                          "price": 16200,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118886",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118876",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118876",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118880",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118883",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798105",
                                              "variationId": "206077618"
                                            }
                                          ],
                                          "price": 39800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118881",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118886",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118884",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074475"
                                            },
                                            {
                                              "groupId": "258118877",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118877",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798105",
                                              "variationId": "206077619"
                                            }
                                          ],
                                          "price": 47800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118882",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118886",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118878",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118885",
                                              "addonId": "142074522"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074474"
                                            },
                                            {
                                              "groupId": "258118879",
                                              "addonId": "142074475"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118876",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118877",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118878",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118879",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118880",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118881",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118882",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118883",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118884",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118885",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118886",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16200,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "53063592"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677947",
                                    "name": "Onion Twist",
                                    "category": "Veg Pizza",
                                    "description": "Twisted combination of Onion & Cheese",
                                    "imageId": "riqo29n36reemiuwb3ov",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798104",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular (serves 1, 17.7 Cm)",
                                              "price": 162,
                                              "default": 1,
                                              "id": "206077614",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium (serves 2, 24.5 Cm)",
                                              "price": 398,
                                              "id": "206077615",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large (serves 4, 33 Cm)",
                                              "price": 478,
                                              "id": "206077616",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798104",
                                              "variationId": "206077614"
                                            }
                                          ],
                                          "price": 16200,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118875",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118866",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258118866",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258118869",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258118872",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798104",
                                              "variationId": "206077615"
                                            }
                                          ],
                                          "price": 39800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258118870",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258118875",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258118873",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258118867",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258118867",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798104",
                                              "variationId": "206077616"
                                            }
                                          ],
                                          "price": 47800,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258118871",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258118875",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258118868",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258118874",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258118866",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118867",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118868",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118869",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118870",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118871",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118872",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118873",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118874",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118875",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16200,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "54085987"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131895"
                          }
                        ],
                        "image": "j23ok15p0ge6cfwqpg8m",
                        "categoryId": "69131887"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Personal Pizza Slice",
                        "categories": [
                          {
                            "title": "Personal Slice Veg Pizza.",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677892",
                                    "name": "Sweet Corns Delight Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A combination of juicy Sweet Corns & Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c2cf4499-22b1-40d9-a548-77f9e552c095_5e698aa5-e73f-4245-bf7c-fb6868b12d31.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118736",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118737",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118738",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65224454"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677891",
                                    "name": "Margherita Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A classic cheesy Margherita. Cant go wrong. [Fat-14.3 per 100 g, Protein-12.6 per 100 g, Carbohydrate-39.2 per 100 g, Sugar-0 per 100 g, Calories-336 K.cal] Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/4a1db7bf-c67f-423c-96b4-5fbe40511371_08034486-45ae-4561-946f-976d3f8df81b.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118733",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118734",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118735",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65224439"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677893",
                                    "name": "Makhani Do Pyaza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Makhani Gravy, Onion & Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/2c43856e-0bee-4988-937f-d2271cc1dc33_86867d77-41fc-4ef8-8918-614428432096.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118739",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118740",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118741",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65224438"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677902",
                                    "name": "Cheese Lover Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Cheese Dip, Jalapeno Dip, Capsicum, Paneer, Onion, Baby Corn, Mushroom [Fat-11.3 per 100 g, Protein-8.7 per 100 g, Carbohydrate-33.4 per 100 g, Sugar-2 per 100 g, Calories-270 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/8c1a5579-0ec1-4de9-ba4f-03c8beccc38c_260b2117-a08f-445a-bd28-9d48c3ccc64f.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118768",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118769",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118770",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224410"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677898",
                                    "name": "La Pino'z Paneer Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A La Pinoz special. Onion, Capsicum, Paneer, Sweet Corn & Olives With Cheese Dip. [Fat-8.4 per 100 g, Protein-11.8 per 100 g, Carbohydrate-34.4 per 100 g, Sugar-2 per 100 g, Calories-260.8 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/304e68c0-78a6-4c4e-8ecc-5cda949bd62a_13569b46-3a15-4019-afb4-98d571713625.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118755",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118756",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118757",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224434"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677897",
                                    "name": "Cheezy-7 Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "An Exotic Combination of White Mozzarilla, Cream White Cheese, Cheddar, Monterey Jack, Cream Orange Cheese, Colby, Orange Cheddar. [Fat-12.4, Protein-10.3, Carbohydrate-32.2, Sugar-2.1, Calories-281.8]",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/bcf3b5a5-206b-4b71-9d9e-6d5f4667fcce_13826041-35c5-4b49-a22e-a566767f41a5.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118751",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118752",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118753",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118754",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65224414"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677901",
                                    "name": "English Retreat Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Olives,Red Paprika, Tomatoes, Paneer, Capsicum, Cheese, Jalapeno Dip. An English special. [Fat-11.9 per 100 g, Protein-11.1 per 100 g, Carbohydrate-37.1 per 100 g, Sugar-3.6 per 100 g, Calories-300.3 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c647d919-0643-4839-b9c8-2e1fcf0232c9_06189bab-2c29-4925-9ad5-dcb41596db4b.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118764",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118765",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118766",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118767",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224419"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677935",
                                    "name": "Paneer Tikka Butter Masala Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "An indian Speciality on a La Pinoz Pizza. Exotic Paneer Tikka, Onion, Capsicum & Red Paprika. [Fat-12.7 per 100 g, Protein-13.4 per 100 g, Carbohydrate-24.6  per 100 g, Sugar-0 per 100 g, Calories-266.2 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/7b0128bd-cdae-4990-abb1-cbbe49cb2574_29938a33-622f-4694-9342-8f4c70d73954.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118818",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118819",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118820",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224446"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677911",
                                    "name": "Sweet Heat Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "[Available in Jain] Jalapenos, Pineapples, Sweet Corns, Red Paprika",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/23/e5ad69e2-24eb-46bc-a883-cf71b338af88_4aba003c-ac87-46ce-84a0-cfa7c9236e8e.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118790",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118791",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118792",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118793",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479918"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677914",
                                    "name": "Farm Villa Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "The freshness of capsicum, tomatoes, with the flavour of paneer and red paprika topped with a korma dip . [Fat-10.9 per 100 g, Protein-12.7 per 100 g, Carbohydrate-34.9 per 100 g, Sugar-0 per 100 g, Calories-288.9 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/59dc6657-17f6-41b0-9439-1672e34de1c9_0c2ffd0a-5b1a-4051-8738-664a4abc36c8.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118802",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118803",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118804",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118805",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224421"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677908",
                                    "name": "Lovers Bite Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A wholesome combination of tossed mushrooms, olives and juicy sweet corn. [Fat-9 per 100 g, Protein-12.4 per 100 g, Carbohydrate-32.2 per 100 g, Sugar-0 per 100 g, Calories-260.1 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c34770dd-2d14-4d12-91e0-3dfbb48a3733_ed58a2ab-f760-4319-9c45-b9d46e5edda9.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118781",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118782",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118783",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224436"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677913",
                                    "name": "Spring Fling Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Quintessentially veg with Paneer, Fresh Tomatoes, Capsicum, Sweet Corns. [Fat-12.1 per 100 g, Protein-10.1 per 100 g, Carbohydrate-34 per 100 g, Sugar-0 per 100 g, Calories-285.2 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/b6db7c5a-b9e1-4fea-a288-c6f1848d8f32_1aed90be-a855-4d4f-8787-8d7b8dc4a57c.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118798",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118799",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118800",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118801",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224452"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677894",
                                    "name": "Onion Twist Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Twisted combination of Onion & Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/aea70d0f-7952-45eb-ba24-bce173a121aa_5820834f-1a13-45d8-9bf3-5c5ccd6f491d.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118742",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118743",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118744",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65224445"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677895",
                                    "name": "Mac Special Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Mac Special",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/23/1db89a87-9703-4b82-b9eb-9523e5566e86_5e31f051-0318-4051-88fb-3fbb1d487dc8.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118745",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118746",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118747",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "76369694"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677896",
                                    "name": "Garden Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A close cousin of the gardne delight. Capsicum,Mushrooms,Onion, and Fresh Tomatoes. [Fat-18.8 per 100 g, Protein-10.8 per 100 g, Carbohydrate-16.4 per 100 g, Sugar-0 per 100 g, Calories-277.6 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/e29bc471-25da-4b60-9800-90aebb6b1ec0_5ade8ff3-2edd-46e3-8b04-bfbf8ee1f523.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118748",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118749",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118750",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224424"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677899",
                                    "name": "Las Vegas Treat Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Mushrooms, Jalapenos, Baby Corn, Capsicum, Tomatoes With Peri Peri Dip. [Fat-10.4 per 100 g, Protein-6.7 per 100 g, Carbohydrate-43.1 per 100 g, Sugar-3.6 per 100 g, Calories-292.3 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/ad5cc462-10a9-47ae-8a33-89fd429b8234_6f5bf7c1-0e27-4ff7-8c91-1b5fcae67b8e.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118758",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118759",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118760",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224435"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677900",
                                    "name": "Peri Peri Veg Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Milder, but just as tasty. Onion, Capsicum, Mushroom, Paneer, Olives With Peri Peri Dip. [Fat-6.1 per 100 g, Protein-13.9 per 100 g, Carbohydrate-33.8 per 100 g, Sugar-0 per 100 g, Calories-246.1 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/d5058da6-92cc-458b-8d55-a927f70effc4_71e3b705-4114-440f-9408-a1cb10076285.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118761",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118762",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118763",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224449"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677903",
                                    "name": "Garlic-to-pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Hot & Garlic Dip with onions, Capsicum, Paneer, Mushroom, Jalapenos. [Fat-12 per 100 g, Protein-14.8 per 100 g, Carbohydrate-24.9 per 100 g, Sugar-2.2 per 100 g, Calories-266.7 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/b225db6c-5594-41ea-92a1-0d6188a0ce63_d7efa45e-485f-44d4-b075-0d13e52d7874.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118771",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118772",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118773",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224425"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677904",
                                    "name": "Mexican Salsa Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Mexican Salsa Dip, Capsicum, Sweet Corns, Jalapenos, Onion & Mushroom",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479854"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677905",
                                    "name": "Cheesy Macaroni  Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Paneer, Onions, Capsicum, Olives, Baby Corns With Loads Of Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/64d18482-632e-4f02-a975-a52224dd79a5_1fac1d5d-3014-4e28-9e53-42d7ab1335c1.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 25500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118774",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "80989264"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677906",
                                    "name": "Spicy Veggie 65 Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Red Peprika,Jalapenos,Capsicum,Onion,Paneer 65 With Extra Cheese",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118775",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118776",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118777",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "76612547"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677907",
                                    "name": "Paneer 65 Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A Combination Of Onion, Capsicum, Red Paprika, Paneer 65 With Extra Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/d14af7ca-4fa2-4c8c-baf7-590e95ff6038_3d5e4bfc-28ce-4bcd-940c-c414123a7b73.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118778",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118779",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118780",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "75321437"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677909",
                                    "name": "Double Cheese Margherita Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Loaded with extra cheese",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118784",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118785",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118786",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479777"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677910",
                                    "name": "Paneer Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion, Capsicum, Double Paneer, Red Paprika In Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118787",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118788",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118789",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479880"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677912",
                                    "name": "Veg.hawaiian Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Nothing says Hawaiian like pineapple, paneer, and sweet corn with extra cheese. [Fat-20.3 per 100 g, Protein-10.9 per 100 g, Carbohydrate-28.6 per 100 g, Sugar-0 per 100 g, Calories-340.9 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c9fe5fc7-fae3-4455-952e-4c182f72acf6_2f4b08c3-dc30-4c9d-ad63-a757ead05f87.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118794",
                                        "groupName": "Choice Of Pizza",
                                        "choices": [
                                          {
                                            "id": "142074474",
                                            "name": "Regular",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074475",
                                            "name": "Jain",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118795",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118796",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118797",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224457"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677917",
                                    "name": "Pesto & Basil Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Capsicum, Jalapenos ,Paneer With Pesto & Basil Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118806",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118807",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118808",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479896"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677923",
                                    "name": "Authentic Veg Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion, Capsicum, Paneer With Jalapenos Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118809",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118810",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118811",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479751"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677928",
                                    "name": "Korma Paneer Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion, Sweet Corns, Paneer, Jalapenos in Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118812",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118813",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118814",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479821"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677932",
                                    "name": "Tandoori Paneer Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Capsicum, Onion, Paneer, Sweet Corn In Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118815",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118816",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118817",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479924"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677936",
                                    "name": "Burn To Hell Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "A fiery and lethal combination of hot & garlic dip, jalapenos, mushrooms, olives and capsicum. [Fat-8.4 per 100 g, Protein-13.1 per 100 g, Carbohydrate-43.1 per 100 g, Sugar-2.6 per 100 g, Calories-300.5 k.cal]Nutritional information per 100g",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c53ee0f9-65ba-44d4-afe2-a955135f2919_396b1bce-893f-4dfb-b9e6-bae0288bdd56.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118821",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118822",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118823",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224408"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677937",
                                    "name": "Ala Mexican Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion,Sweet Corns,Mushroom,Baby Corns,Mexican Salsa Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118824",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118825",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118826",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479745"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677938",
                                    "name": "Indian Style Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion, Mushroom, Paneer, Olives, Tomatoes In Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118827",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118828",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118829",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479811"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677940",
                                    "name": "Tandoori Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Capsicum, Sweet Corn, Red Paprika, Double Paneer With Korma Dip",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118830",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118831",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118832",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479927"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677941",
                                    "name": "Hot Passion Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Hot passion on a Pizza. Jalapenos, Mushrooms, Red Paprika, Fresh Tomato With Jalapeno Dip. [Fat-6.5 per 100 g, Protein-6.1 per 100 g, Carbohydrate-45 per 100 g, Sugar-0 per 100 g, Calories-263.2 k.cal]Nutritional information per 100g",
                                    "imageId": "235bea2d2c748ae6befe3e9008179b83",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118833",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118834",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118835",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224427"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677942",
                                    "name": "Pesto & Basil Veg Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Onion, Capsicum, Mushroom, Sweet Corn, Jalapenos in Pesto & Basil Sauce",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118836",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118837",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118838",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65479902"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677943",
                                    "name": "Korma Special Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Capsicum, Red paprika, Paneer, Sweet Corn, Baby Corn in Korma Dip [Fat-9.9 per 100 g, Protein-8 per 100 g, Carbohydrate-40.3 per 100 g, Sugar-3.1 per 100 g, Calories-282.3 k.cal]Nutritional information per 100g",
                                    "imageId": "46433cbba2d93aedf1a92f0f1840df91",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118839",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118840",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118841",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224432"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187677944",
                                    "name": "Cheesy Macaroni Veg Pizza Personal Giant Slice (22.5 Cm)",
                                    "category": "Personal Pizza Slice",
                                    "description": "Paneer, Onions, Capsicum, Olives, Baby Corn With Loads Of Cheese",
                                    "imageId": "e80494d3f3c7d952f6b00ab01d93e81f",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258118842",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118843",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258118844",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65224413"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131894"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/8/c2cf4499-22b1-40d9-a548-77f9e552c095_5e698aa5-e73f-4245-bf7c-fb6868b12d31.JPG",
                        "categoryId": "69131886"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "International Menu",
                        "categories": [
                          {
                            "title": "International Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678077",
                                    "name": "Nashville Veg Pizza",
                                    "category": "International Menu",
                                    "description": "A fiery fusion pizza topped with Nashville sauce, vibrant capsicum, creamy paneer, sweet corn, and smoky red paprika",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/35a83937-ae20-4595-8e81-b5eda774004d_caae222b-044e-43e8-8ccc-82578aded5c9.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798160",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular",
                                              "price": 255,
                                              "default": 1,
                                              "id": "206077785",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium",
                                              "price": 595,
                                              "id": "206077786",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Slice",
                                              "price": 235,
                                              "id": "206077787",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large",
                                              "price": 765,
                                              "id": "206077788",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Giant",
                                              "price": 1095,
                                              "id": "206077789",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Monster",
                                              "price": 1750,
                                              "id": "206077790",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077785"
                                            }
                                          ],
                                          "price": 25500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119271",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119271",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119276",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119282",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077786"
                                            }
                                          ],
                                          "price": 59500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119277",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119283",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119272",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119272",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077787"
                                            }
                                          ],
                                          "price": 23500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074421"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074426"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074419"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074417"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074415"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074413"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074411"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074409"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074432"
                                            },
                                            {
                                              "groupId": "258119275",
                                              "addonId": "142074429"
                                            },
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074436"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074435"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074452"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074450"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074448"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074447"
                                            },
                                            {
                                              "groupId": "258119281",
                                              "addonId": "142074460"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077788"
                                            }
                                          ],
                                          "price": 76500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119278",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119273",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119284",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077789"
                                            }
                                          ],
                                          "price": 109500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074454"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074516"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074518"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074519"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074497"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074449"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074451"
                                            },
                                            {
                                              "groupId": "258119285",
                                              "addonId": "142074453"
                                            },
                                            {
                                              "groupId": "258119274",
                                              "addonId": "142074473"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074523"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074517"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074515"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074514"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074512"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074510"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074508"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074506"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074526"
                                            },
                                            {
                                              "groupId": "258119279",
                                              "addonId": "142074525"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798160",
                                              "variationId": "206077790"
                                            }
                                          ],
                                          "price": 175000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074434"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074433"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074431"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074428"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074425"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074446"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074445"
                                            },
                                            {
                                              "groupId": "258119286",
                                              "addonId": "142074444"
                                            },
                                            {
                                              "groupId": "258119287",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074492"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074520"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074491"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074490"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074489"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074488"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074487"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074495"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074499"
                                            },
                                            {
                                              "groupId": "258119280",
                                              "addonId": "142074498"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119271",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119272",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119273",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119274",
                                        "groupName": "Upgrade Your Ultra Thin Crust Giant Pizza",
                                        "choices": [
                                          {
                                            "id": "142074473",
                                            "name": "Ultra Thin Crust Pizza - Giant Pizza",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119275",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119276",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119277",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119278",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119279",
                                        "groupName": "Toppings-veg (giant)",
                                        "choices": [
                                          {
                                            "id": "142074523",
                                            "name": "Onions",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074517",
                                            "name": "Fresh Tomatoes",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074515",
                                            "name": "Mushroom",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074514",
                                            "name": "Sweet Corns",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074512",
                                            "name": "Pineapples",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074510",
                                            "name": "Red Paprika",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074508",
                                            "name": "Jalapenos",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074506",
                                            "name": "Olives",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074526",
                                            "name": "Paneer",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074525",
                                            "name": "Capsicum",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119280",
                                        "groupName": "Toppings-veg (the Monster)",
                                        "choices": [
                                          {
                                            "id": "142074492",
                                            "name": "Fresh Tomatoes",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074520",
                                            "name": "Onions",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074491",
                                            "name": "Mushroom",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074490",
                                            "name": "Sweet Corns",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074489",
                                            "name": "Pineapples",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074488",
                                            "name": "Red Paprika",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074487",
                                            "name": "Jalapenos",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074495",
                                            "name": "Olives",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074499",
                                            "name": "Paneer",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074498",
                                            "name": "Capsicum",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119281",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119282",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119283",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119284",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119285",
                                        "groupName": "Cheese & Dip (g)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074454",
                                            "name": "Mozzarella",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074516",
                                            "name": "Extra Cheese",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074518",
                                            "name": "Cheese Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074519",
                                            "name": "Jalapeno Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074497",
                                            "name": "Hot & Garlic Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074449",
                                            "name": "Peri Peri Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074451",
                                            "name": "Korma Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074453",
                                            "name": "Cheezy-7",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119286",
                                        "groupName": "Cheese & Dip (ms)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074434",
                                            "name": "Mozzarella",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074433",
                                            "name": "Cheezy-7",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074431",
                                            "name": "Korma Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074428",
                                            "name": "Peri Peri Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074425",
                                            "name": "Hot & Garlic Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074446",
                                            "name": "Jalapeno Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074445",
                                            "name": "Cheese Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074444",
                                            "name": "Extra Cheese",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119287",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 25500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812722"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678076",
                                    "name": "Korean Veg Pizza",
                                    "category": "International Menu",
                                    "description": "A bold fusion pizza loaded with crunchy onions, vibrant capsicum, creamy paneer, sweetcorn, and a fiery Korean sauce",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/d8454d18-6f35-4f4d-bdf4-d0403bef43ca_89a5c795-9cdd-4ad5-9d41-7ea1fae81f93.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798159",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular",
                                              "price": 255,
                                              "default": 1,
                                              "id": "206077779",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium",
                                              "price": 595,
                                              "id": "206077780",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Slice",
                                              "price": 235,
                                              "id": "206077781",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large",
                                              "price": 765,
                                              "id": "206077782",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Giant",
                                              "price": 1095,
                                              "id": "206077783",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Monster",
                                              "price": 1750,
                                              "id": "206077784",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077779"
                                            }
                                          ],
                                          "price": 25500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119254",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119254",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119259",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119265",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077780"
                                            }
                                          ],
                                          "price": 59500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119260",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119266",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119255",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119255",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077781"
                                            }
                                          ],
                                          "price": 23500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074421"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074426"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074419"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074417"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074415"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074413"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074411"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074409"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074432"
                                            },
                                            {
                                              "groupId": "258119258",
                                              "addonId": "142074429"
                                            },
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074436"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074435"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074452"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074450"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074448"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074447"
                                            },
                                            {
                                              "groupId": "258119264",
                                              "addonId": "142074460"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077782"
                                            }
                                          ],
                                          "price": 76500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119261",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119256",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119267",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077783"
                                            }
                                          ],
                                          "price": 109500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074454"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074516"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074518"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074519"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074497"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074449"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074451"
                                            },
                                            {
                                              "groupId": "258119268",
                                              "addonId": "142074453"
                                            },
                                            {
                                              "groupId": "258119257",
                                              "addonId": "142074473"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074523"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074517"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074515"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074514"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074512"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074510"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074508"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074506"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074526"
                                            },
                                            {
                                              "groupId": "258119262",
                                              "addonId": "142074525"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798159",
                                              "variationId": "206077784"
                                            }
                                          ],
                                          "price": 175000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074434"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074433"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074431"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074428"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074425"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074446"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074445"
                                            },
                                            {
                                              "groupId": "258119269",
                                              "addonId": "142074444"
                                            },
                                            {
                                              "groupId": "258119270",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074492"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074520"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074491"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074490"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074489"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074488"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074487"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074495"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074499"
                                            },
                                            {
                                              "groupId": "258119263",
                                              "addonId": "142074498"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119254",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119255",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119256",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119257",
                                        "groupName": "Upgrade Your Ultra Thin Crust Giant Pizza",
                                        "choices": [
                                          {
                                            "id": "142074473",
                                            "name": "Ultra Thin Crust Pizza - Giant Pizza",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119258",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119259",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119260",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119261",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119262",
                                        "groupName": "Toppings-veg (giant)",
                                        "choices": [
                                          {
                                            "id": "142074523",
                                            "name": "Onions",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074517",
                                            "name": "Fresh Tomatoes",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074515",
                                            "name": "Mushroom",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074514",
                                            "name": "Sweet Corns",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074512",
                                            "name": "Pineapples",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074510",
                                            "name": "Red Paprika",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074508",
                                            "name": "Jalapenos",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074506",
                                            "name": "Olives",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074526",
                                            "name": "Paneer",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074525",
                                            "name": "Capsicum",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119263",
                                        "groupName": "Toppings-veg (the Monster)",
                                        "choices": [
                                          {
                                            "id": "142074492",
                                            "name": "Fresh Tomatoes",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074520",
                                            "name": "Onions",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074491",
                                            "name": "Mushroom",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074490",
                                            "name": "Sweet Corns",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074489",
                                            "name": "Pineapples",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074488",
                                            "name": "Red Paprika",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074487",
                                            "name": "Jalapenos",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074495",
                                            "name": "Olives",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074499",
                                            "name": "Paneer",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074498",
                                            "name": "Capsicum",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119264",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119265",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119266",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119267",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119268",
                                        "groupName": "Cheese & Dip (g)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074454",
                                            "name": "Mozzarella",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074516",
                                            "name": "Extra Cheese",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074518",
                                            "name": "Cheese Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074519",
                                            "name": "Jalapeno Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074497",
                                            "name": "Hot & Garlic Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074449",
                                            "name": "Peri Peri Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074451",
                                            "name": "Korma Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074453",
                                            "name": "Cheezy-7",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119269",
                                        "groupName": "Cheese & Dip (ms)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074434",
                                            "name": "Mozzarella",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074433",
                                            "name": "Cheezy-7",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074431",
                                            "name": "Korma Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074428",
                                            "name": "Peri Peri Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074425",
                                            "name": "Hot & Garlic Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074446",
                                            "name": "Jalapeno Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074445",
                                            "name": "Cheese Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074444",
                                            "name": "Extra Cheese",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119270",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 25500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "106812715"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678075",
                                    "name": "Jamaican Jerk Veg Pizza",
                                    "category": "International Menu",
                                    "description": "A vibrant fusion pizza topped with capsicum, creamy paneer, sweet corn and baby corn, spicy jalape",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/7b82ebb9-5618-4780-8e68-130ec30b088f_eb97db94-27f3-4fd3-8466-ebf23f912c08.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798158",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "Regular",
                                              "price": 255,
                                              "default": 1,
                                              "id": "206077773",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Medium",
                                              "price": 595,
                                              "id": "206077774",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Slice",
                                              "price": 235,
                                              "id": "206077775",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Large",
                                              "price": 765,
                                              "id": "206077776",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Giant",
                                              "price": 1095,
                                              "id": "206077777",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Monster",
                                              "price": 1750,
                                              "id": "206077778",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077773"
                                            }
                                          ],
                                          "price": 25500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119237",
                                              "addonId": "142074455"
                                            },
                                            {
                                              "groupId": "258119237",
                                              "addonId": "142074456"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074501"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074481"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074480"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074479"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074494"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074493"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074496"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074504"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074503"
                                            },
                                            {
                                              "groupId": "258119242",
                                              "addonId": "142074502"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074430"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074427"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074423"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074442"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074440"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074439"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074438"
                                            },
                                            {
                                              "groupId": "258119248",
                                              "addonId": "142074437"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077774"
                                            }
                                          ],
                                          "price": 59500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074467"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074466"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074478"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074477"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074476"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074486"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074485"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074484"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074483"
                                            },
                                            {
                                              "groupId": "258119243",
                                              "addonId": "142074482"
                                            },
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074422"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074420"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074418"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074416"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074414"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074412"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074410"
                                            },
                                            {
                                              "groupId": "258119249",
                                              "addonId": "142074408"
                                            },
                                            {
                                              "groupId": "258119238",
                                              "addonId": "142074458"
                                            },
                                            {
                                              "groupId": "258119238",
                                              "addonId": "142074459"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077775"
                                            }
                                          ],
                                          "price": 23500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074421"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074426"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074419"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074417"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074415"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074413"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074411"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074409"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074432"
                                            },
                                            {
                                              "groupId": "258119241",
                                              "addonId": "142074429"
                                            },
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074436"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074435"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074452"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074450"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074448"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074447"
                                            },
                                            {
                                              "groupId": "258119247",
                                              "addonId": "142074460"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077776"
                                            }
                                          ],
                                          "price": 76500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074461"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074465"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074464"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074463"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074462"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074472"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074471"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074470"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074469"
                                            },
                                            {
                                              "groupId": "258119244",
                                              "addonId": "142074468"
                                            },
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119239",
                                              "addonId": "142074457"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074513"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074511"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074509"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074507"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074505"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074521"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074524"
                                            },
                                            {
                                              "groupId": "258119250",
                                              "addonId": "142074522"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077777"
                                            }
                                          ],
                                          "price": 109500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074454"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074516"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074518"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074519"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074497"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074449"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074451"
                                            },
                                            {
                                              "groupId": "258119251",
                                              "addonId": "142074453"
                                            },
                                            {
                                              "groupId": "258119240",
                                              "addonId": "142074473"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074523"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074517"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074515"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074514"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074512"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074510"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074508"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074506"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074526"
                                            },
                                            {
                                              "groupId": "258119245",
                                              "addonId": "142074525"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798158",
                                              "variationId": "206077778"
                                            }
                                          ],
                                          "price": 175000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074434"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074433"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074431"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074428"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074425"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074446"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074445"
                                            },
                                            {
                                              "groupId": "258119252",
                                              "addonId": "142074444"
                                            },
                                            {
                                              "groupId": "258119253",
                                              "addonId": "142074500"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074492"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074520"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074491"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074490"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074489"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074488"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074487"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074495"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074499"
                                            },
                                            {
                                              "groupId": "258119246",
                                              "addonId": "142074498"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "258119237",
                                        "groupName": "Upgrade Your Base - Regular",
                                        "choices": [
                                          {
                                            "id": "142074455",
                                            "name": "Double Burst",
                                            "price": 7900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074456",
                                            "name": "Ultra Thin Crust Pizza - Regular Pizza",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119238",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119239",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119240",
                                        "groupName": "Upgrade Your Ultra Thin Crust Giant Pizza",
                                        "choices": [
                                          {
                                            "id": "142074473",
                                            "name": "Ultra Thin Crust Pizza - Giant Pizza",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119241",
                                        "groupName": "Toppings-veg (giant Slice)",
                                        "choices": [
                                          {
                                            "id": "142074421",
                                            "name": "Fresh Tomatoes",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074426",
                                            "name": "Onions",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074419",
                                            "name": "Mushroom",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074417",
                                            "name": "Sweet Corns",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074415",
                                            "name": "Pineapples",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074413",
                                            "name": "Red Paprika",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074411",
                                            "name": "Jalapenos",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074409",
                                            "name": "Olives",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074432",
                                            "name": "Paneer",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074429",
                                            "name": "Capsicum",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119242",
                                        "groupName": "Toppings-veg (regular)",
                                        "choices": [
                                          {
                                            "id": "142074501",
                                            "name": "Onions",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074481",
                                            "name": "Fresh Tomatoes",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074480",
                                            "name": "Mushroom",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074479",
                                            "name": "Sweet Corns",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074494",
                                            "name": "Pineapples",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074493",
                                            "name": "Red Paprika",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074496",
                                            "name": "Jalapenos",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074504",
                                            "name": "Olives",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074503",
                                            "name": "Paneer",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074502",
                                            "name": "Capsicum",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119243",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119244",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119245",
                                        "groupName": "Toppings-veg (giant)",
                                        "choices": [
                                          {
                                            "id": "142074523",
                                            "name": "Onions",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074517",
                                            "name": "Fresh Tomatoes",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074515",
                                            "name": "Mushroom",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074514",
                                            "name": "Sweet Corns",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074512",
                                            "name": "Pineapples",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074510",
                                            "name": "Red Paprika",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074508",
                                            "name": "Jalapenos",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074506",
                                            "name": "Olives",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074526",
                                            "name": "Paneer",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074525",
                                            "name": "Capsicum",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119246",
                                        "groupName": "Toppings-veg (the Monster)",
                                        "choices": [
                                          {
                                            "id": "142074492",
                                            "name": "Fresh Tomatoes",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074520",
                                            "name": "Onions",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074491",
                                            "name": "Mushroom",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074490",
                                            "name": "Sweet Corns",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074489",
                                            "name": "Pineapples",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074488",
                                            "name": "Red Paprika",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074487",
                                            "name": "Jalapenos",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074495",
                                            "name": "Olives",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074499",
                                            "name": "Paneer",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074498",
                                            "name": "Capsicum",
                                            "price": 13500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119247",
                                        "groupName": "Cheese & Dip (gs)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074436",
                                            "name": "Cheezy-7",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074435",
                                            "name": "Korma Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074452",
                                            "name": "Peri Peri Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074450",
                                            "name": "Hot & Garlic Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074448",
                                            "name": "Jalapeno Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074447",
                                            "name": "Cheese Dip",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074460",
                                            "name": "Extra Cheese",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119248",
                                        "groupName": "Cheese & Dip (r)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074430",
                                            "name": "Mozzarella",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074427",
                                            "name": "Cheezy-7",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074423",
                                            "name": "Korma Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074442",
                                            "name": "Peri Peri Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074440",
                                            "name": "Hot & Garlic Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074439",
                                            "name": "Jalapeno Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074438",
                                            "name": "Cheese Dip",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074437",
                                            "name": "Extra Cheese",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119249",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119250",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119251",
                                        "groupName": "Cheese & Dip (g)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074454",
                                            "name": "Mozzarella",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074516",
                                            "name": "Extra Cheese",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074518",
                                            "name": "Cheese Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074519",
                                            "name": "Jalapeno Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074497",
                                            "name": "Hot & Garlic Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074449",
                                            "name": "Peri Peri Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074451",
                                            "name": "Korma Dip",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074453",
                                            "name": "Cheezy-7",
                                            "price": 12000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119252",
                                        "groupName": "Cheese & Dip (ms)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074434",
                                            "name": "Mozzarella",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074433",
                                            "name": "Cheezy-7",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074431",
                                            "name": "Korma Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074428",
                                            "name": "Peri Peri Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074425",
                                            "name": "Hot & Garlic Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074446",
                                            "name": "Jalapeno Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074445",
                                            "name": "Cheese Dip",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074444",
                                            "name": "Extra Cheese",
                                            "price": 16000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "258119253",
                                        "groupName": "Choose Your Ketchup",
                                        "choices": [
                                          {
                                            "id": "142074500",
                                            "name": "Ketchup",
                                            "price": 100,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 25500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812707"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131913"
                          },
                          {
                            "title": "Korean Tacos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678079",
                                    "name": "Korean Veg Tacos",
                                    "category": "International Menu",
                                    "description": "Tacos filled with Korean-style spiced veggies for a fiery fusion flavor",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/c3d4bcca-94ea-407f-af6c-6dbf64745c7c_272a937a-9f10-40c4-9e0a-e2452e8d7aa2.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798162",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077793",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077794",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798162",
                                              "variationId": "206077793"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798162",
                                              "variationId": "206077794"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "106812717"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678078",
                                    "name": "Jamaican Jerk Veg Tacos",
                                    "category": "International Menu",
                                    "description": "Tacos bursting with jerk-seasoned veggies for an island-inspired veggie delight",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/d2558aea-a75e-43e3-ad90-922779a6cb8a_37952a71-b132-4345-b5e8-e29cb812e3e0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798161",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077791",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077792",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798161",
                                              "variationId": "206077791"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798161",
                                              "variationId": "206077792"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "106812709"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678080",
                                    "name": "Nashville Veg Tacos",
                                    "category": "International Menu",
                                    "description": "Fiery tacos packed with Nashville hot sauce for a bold Southern-style vegetarian twist",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/52866f9c-302e-4ecb-a60e-588297571471_34f0ea5b-6db3-4ac5-8db8-78ee734ef413.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798163",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077795",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077796",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798163",
                                              "variationId": "206077795"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798163",
                                              "variationId": "206077796"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "106812724"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131914"
                          },
                          {
                            "title": "Korean Quesadilla",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678083",
                                    "name": "Nashville Veg Quesadilla",
                                    "category": "International Menu",
                                    "description": "Fiery Quesadillas packed with Nashville hot sauce for a bold Southern-style vegetarian twist",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/8ffa6713-3b3c-48bf-9b98-625adb002ea4_79264f5a-de10-4719-a3b8-8c8ea4bd9b59.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798166",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077801",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077802",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798166",
                                              "variationId": "206077801"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798166",
                                              "variationId": "206077802"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812723"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678082",
                                    "name": "Korean Veg Quesadilla",
                                    "category": "International Menu",
                                    "description": "Quesadillas filled with Korean-style spiced veggies for a fiery fusion flavor",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/f37f5052-e80b-41ee-a8b0-79fcffe1efd7_39124981-74cf-44b2-91c5-d579ad419019.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798165",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077799",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077800",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798165",
                                              "variationId": "206077799"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798165",
                                              "variationId": "206077800"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812716"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678081",
                                    "name": "Jamaican Jerk Veg Quesadilla",
                                    "category": "International Menu",
                                    "description": "Quesadillas bursting with jerk-seasoned veggies for an island-inspired veggie delight",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/84c947a9-ac20-4237-a4fa-662d03cd29fb_9f37bd1f-b639-4e63-8a32-1d6e5bac6b33.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68798164",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "1 Pc",
                                              "price": 85,
                                              "default": 1,
                                              "id": "206077797",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "2 PC",
                                              "price": 149,
                                              "id": "206077798",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798164",
                                              "variationId": "206077797"
                                            }
                                          ],
                                          "price": 8500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68798164",
                                              "variationId": "206077798"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812708"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131915"
                          },
                          {
                            "title": "Stuffed Garlic Bread",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678085",
                                    "name": "Stuffed Garlic Bread With Sweet Corn, Jalapeno With Jamaican Jerk",
                                    "category": "International Menu",
                                    "description": "A cheesy, flavor-packed Garlic Bread Stick loaded with sweet, spicy, and smoky  vibes.\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/ef1f8a92-4acb-4a5a-a958-741a4c0fd10a_e49940bf-c9d8-421f-a585-5f20c201a60a.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 12900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "258119288",
                                        "groupName": "Dips",
                                        "choices": [
                                          {
                                            "id": "142074441",
                                            "name": "Jalapeno Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074443",
                                            "name": "Peri Peri Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074424",
                                            "name": "Cheese Dip",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812727"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131917"
                          },
                          {
                            "title": "Korean Rice",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678084",
                                    "name": "Cheesy Paneer With Korean Rice",
                                    "category": "International Menu",
                                    "description": "A fusion delight combining creamy Paneer with spice packed Korean-style rice.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/3aa614e4-2f22-44cd-9a56-de619d66552b_51a5f775-0dec-4bc5-84e7-e78fe3cda8ca.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106812703"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131916"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/35a83937-ae20-4595-8e81-b5eda774004d_caae222b-044e-43e8-8ccc-82578aded5c9.jpg",
                        "categoryId": "69131892"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Combo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189919315",
                                "name": "2 Chocolava",
                                "category": "Combo",
                                "description": "Two decadent choco lava cakes with a rich, molten chocolate center.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/b1b70774-6f98-406b-84eb-207389a9a92b_a30c79da-4cd1-4fd5-bc0e-e7ce1dc8b608.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 26600,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "27686397"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189919314",
                                "name": "2 Brownie",
                                "category": "Combo",
                                "description": "Two rich, fudgy brownies served for a perfectly indulgent treat",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/899cac73-65d3-4843-9605-2a0854143f8c_df8d4c13-bb73-4edd-b7ad-22e334ed1887.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115482747"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "187678072",
                                "name": "Combo Of Garlic Bread Sticks, Dips & Coke",
                                "category": "Combo",
                                "description": "Garlic Bread Sticks + Dips + Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/ca9af1ed-0f72-4418-b73a-7bfbae5aa9ba_2909c647-7fb4-4061-9554-cd95eb1e1c04.jpeg",
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "nextAvailableAtMessage": "Next available at 1:30 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "76082532"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "187678071",
                                "name": "Combo Of Chocolava & Coke",
                                "category": "Combo",
                                "description": "Chocolava + Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/61031e2d-13db-4d89-ab1f-3ea564c86eb6_b2cc1980-d783-429b-8ac0-3fdfd2b635c1.jpeg",
                                "isVeg": 1,
                                "price": 16700,
                                "variants": {},
                                "variantsV2": {},
                                "nextAvailableAtMessage": "Next available at 1:30 pm, today",
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "76082531"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/24/ca9af1ed-0f72-4418-b73a-7bfbae5aa9ba_2909c647-7fb4-4061-9554-cd95eb1e1c04.jpeg",
                        "categoryId": "70112238"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Dessert & Beverages",
                        "categories": [
                          {
                            "title": "Dessert",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678074",
                                    "name": "Triple Chocolate Brownie",
                                    "category": "Dessert & Beverages",
                                    "description": "Combination of Dark Chocolate & Milk Chocolate topped with Premium quality Chocolate Fudge",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/95b9f0e2-e1b2-4ec0-9ea3-50fe02c3d67c_002d6031-9a11-4577-956c-6698290d32b4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 12900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "81462839"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678073",
                                    "name": "Choco Lava",
                                    "category": "Dessert & Beverages",
                                    "description": "Small muffin infused with warm chocolate! Vintage Dessert",
                                    "imageId": "xdl55wtgzsdf9cpozjko",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27689532"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131912"
                          },
                          {
                            "title": "Refreshing Drinks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180273",
                                    "name": "Lemon Iced Ice",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/3/6a9f28f9-ad45-415a-a8d6-addbf6c04659_06e7cc13-1f16-4048-ab02-e96d72f79527.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103506793"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180272",
                                    "name": "Kala Khatta",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/0eefdd7b-8e73-482a-8a81-a314fb24f0f5_5536820b-8b0c-40f1-97f7-95f639f0f3e1.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103726316"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180270",
                                    "name": "Green Apple",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/3/e03b9120-a9b7-46fb-b63e-9107d020dee5_94106d5f-f87c-400a-b4c7-495fed895447.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27690739"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180271",
                                    "name": "Hibiscus  Drink",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/421f508e-ce44-4ab7-8cc5-c522970211d2_1346a978-0e70-4066-9b58-67fc86681be9.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103726315"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180274",
                                    "name": "Mango",
                                    "category": "Dessert & Beverages",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691743"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180275",
                                    "name": "Mint Mojito",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/3/1c2f6df7-0a60-42ea-9d74-9e544c494e4e_206048a4-cc1f-491a-b118-735d2791c493.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692117"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180276",
                                    "name": "Peach Iced Tea",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/2f1ed8db-9074-45d0-a947-3106259be67a_b96851e9-549c-46c1-a047-84c4c904c520.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27692906"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180277",
                                    "name": "Spicy Guava",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/47abdda3-b8b9-41ab-a51a-c13aa5fdcee8_45acb372-b6ef-4ae0-bed9-e8d4fb0165ca.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103726318"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70112239"
                          },
                          {
                            "title": "Thick Shakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180279",
                                    "name": "Cold Coffee.",
                                    "category": "Dessert & Beverages",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259357221",
                                        "groupName": "Pick Your Flavour",
                                        "choices": [
                                          {
                                            "id": "142230360",
                                            "name": "Classic",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142230359",
                                            "name": "Vanilla",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142230358",
                                            "name": "Hazelnut",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142230357",
                                            "name": "Caramel",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27689716"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180278",
                                    "name": "Chocolate Shake",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/f4853eaf-e186-4e8e-9158-deaa23ac41d6_6e340f4e-cd43-4a47-9166-dfa01d6a2f6c.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27689530"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180280",
                                    "name": "Mango Shake",
                                    "category": "Dessert & Beverages",
                                    "description": "[350 Ml] A perfect blend of ripe mango with milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/420e7337-ecdd-4cd3-b40d-6fcb576980c5_fa5baa46-b512-4b26-9a8e-36314fd6e0f7.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "27691753"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188180281",
                                    "name": "Tiramisu Shake",
                                    "category": "Dessert & Beverages",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/7937e278-d72d-44ed-9bc3-6ff12d71c6f5_c4290659-804d-4091-b9e2-030b63f19526.JPG",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103726319"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70112240"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/95b9f0e2-e1b2-4ec0-9ea3-50fe02c3d67c_002d6031-9a11-4577-956c-6698290d32b4.jpg",
                        "categoryId": "69131891"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Festive Dhamaka Combos",
                        "categories": [
                          {
                            "title": "Quesadilla-fantastic Four",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187678070",
                                    "name": "Quesadilla Pack Of 4 (veg)",
                                    "category": "Festive Dhamaka Combos",
                                    "description": "Cheese & Cheese, Paneer, Sweet corn & Cheese, Mushroom, Olives & Cheese, Sweet Corn, Jalapenos & Cheese",
                                    "imageId": "kvklhbau4guo0zumt1fk",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 25900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "56469792"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69131910"
                          }
                        ],
                        "image": "kvklhbau4guo0zumt1fk",
                        "categoryId": "69131890"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Super Saver Trio",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189919310",
                                "name": "Cheesy Paneer With Korean Rice+1pc Veg Taco+coke",
                                "category": "Super Saver Trio",
                                "description": "A wholesome combo of cheesy paneer with savory Korean rice, a crunchy veg taco, and a refreshing coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/bb1cfa7a-4ff4-44b3-87c6-46b150a8148d_641831f0-681a-46ff-b2c4-ccc9d0a577e6.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25100,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "263764742",
                                    "groupName": "Choice Of Veg Taco's",
                                    "choices": [
                                      {
                                        "id": "143106240",
                                        "name": "Paneer Tikka Buttermasala & Red Paprika",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143106242",
                                        "name": "Paneer & Corn",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143106241",
                                        "name": "Paneer 65 & Onion",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115482748"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189919311",
                                "name": "Cheesy Paneer With Korean Rice+choco Lava+coke",
                                "category": "Super Saver Trio",
                                "description": "An indulgent meal featuring cheesy paneer with Korean-style rice, served with rich choco lava dessert and a chilled coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/07f8db95-5095-4ee9-ac0f-f8bcb43c9c71_ab110e87-396b-4742-b1c8-43f350108109.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 31700,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115482749"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/bb1cfa7a-4ff4-44b3-87c6-46b150a8148d_641831f0-681a-46ff-b2c4-ccc9d0a577e6.jpg",
                        "categoryId": "70112237"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "New Year Party Offer",
                        "categories": [
                          {
                            "title": "Medium Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971613",
                                    "name": "Double Cheese Margherita Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Loaded with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/24/9b691c95-f72b-4150-b0b3-154cbef81207_38df0d37-5bb5-41fc-b27e-8292ef172f9c.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 51800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072860",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072861",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072862",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "116203599"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971614",
                                    "name": "Lovers Bite Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A wholesome combination of tossed mushrooms, olives and juicy sweet corn",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/23/2cb8e938-c3dc-4eef-96a8-cc157ebbacf6_aa6d8393-4e4e-4d38-8a7d-acb99dca4603.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 51800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072863",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072864",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072865",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870322"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971615",
                                    "name": "Margherita Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A classic Margherita Pizza",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/19/45092069-73d4-4ee3-bf0d-22f94f36a80a_44f4a610-8d08-4e71-8866-ac682d230777.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 41800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072866",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072867",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072868",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857401"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971616",
                                    "name": "Onion Medium Twist.",
                                    "category": "New Year Party Offer",
                                    "description": "Twisted combination of Onion & Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/9/a4efe0ce-54a6-4737-a9a4-3120fa68d499_9d9d9422-9947-4641-8750-b14b2bb15a73.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 41800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072869",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072870",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072871",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857406"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971617",
                                    "name": "Spring Fling Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Quintessentially veg with capsicum, sweet corn and flavoured chunks of paneer.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/23/eba05a4c-7056-4b27-bc80-ca13d5d6e453_08b5b8db-80f4-4d25-9db0-bc6a03b77116.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 51800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072872",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072873",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072874",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870325"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70577452"
                          },
                          {
                            "title": "Large Pizzz's",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971630",
                                    "name": "Burn To Hell Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A fiery and lethal combination of hot & garlic dip, jalapenos, mushrooms, olives and capsicum",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/cfef6afb-ca64-40d5-87f7-f83e9e4f454e_99aea4d0-babb-4ecf-87b0-ee916f46227c.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 82300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072911",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072912",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072913",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "111315307"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971631",
                                    "name": "Farm Villa Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "The freshness of capsicum, tomatoes, with the flavour of paneer and red paprika topped with a Korma dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/f004d682-c9f9-43e5-ac50-14a99ed624ee_faf8465a-06db-4053-8b80-0494065d71b7.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 82300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072914",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072915",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072916",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857393"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971632",
                                    "name": "Garden Special Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A close cousin of the gardne delight. Capsicum,Mushrooms,Onion, and Fresh Tomatoes",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/a362780d-49b3-4d7c-bf75-596b031a78fd_214162db-f06d-4405-95a8-2eda158bdf5d.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 82300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072917",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072918",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072919",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870320"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971633",
                                    "name": "Paneer 65 Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A combination of Onion, capsicum, red paprika, paneer 65 with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/23/36cd106f-f55f-4eb0-a47a-323d6c9c36e8_25d8c6da-6d76-40dd-ad73-be9c129b06d8.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 82300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072920",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072921",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072922",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857407"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971634",
                                    "name": "Sweet Heat Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Combination of Jalapenos, Pineapples, Sweet Corns & Red Paprika",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/23/0ec323a1-921f-4c4d-9550-51de90a56929_0b4548fd-b26f-4590-94e5-2aba70063ce2.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 82300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072923",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072924",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072925",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "111315319"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70577455"
                          },
                          {
                            "title": "Medium Pizza's",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971618",
                                    "name": "Burn To Hell Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A fiery and lethal combination of hot & garlic dip, jalapenos, mushrooms, olives and capsicum",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/cfef6afb-ca64-40d5-87f7-f83e9e4f454e_99aea4d0-babb-4ecf-87b0-ee916f46227c.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 68600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072875",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072876",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072877",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "111315308"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971619",
                                    "name": "Farm Villa Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "The freshness of capsicum, tomatoes, with the flavour of paneer and red paprika topped with a Korma dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/f004d682-c9f9-43e5-ac50-14a99ed624ee_faf8465a-06db-4053-8b80-0494065d71b7.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 68600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072878",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072879",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072880",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857394"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971620",
                                    "name": "Garden Special Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A close cousin of the gardne delight. Capsicum,Mushrooms,Onion, and Fresh Tomatoes",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/a362780d-49b3-4d7c-bf75-596b031a78fd_214162db-f06d-4405-95a8-2eda158bdf5d.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 68600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072881",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072882",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072883",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857395"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971621",
                                    "name": "Paneer 65 Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A combination of Onion, capsicum, red paprika, paneer 65 with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/23/36cd106f-f55f-4eb0-a47a-323d6c9c36e8_25d8c6da-6d76-40dd-ad73-be9c129b06d8.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 68600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072884",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072885",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072886",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857408"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971622",
                                    "name": "Sweet Heat Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A combination of Jalapenos, Pineapples, Sweet Corns & Red Paprika",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/23/0ec323a1-921f-4c4d-9550-51de90a56929_0b4548fd-b26f-4590-94e5-2aba70063ce2.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 68600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072887",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072888",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072889",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "111315320"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971623",
                                    "name": "Veg.hawaiian Medium .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Nothing says Hawaiian like pineapple, paneer, and sweet corn with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/8fa73d94-089b-4b69-9e1d-dbe8267cb438_1a6628d4-df67-49b7-a041-775457195c08.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 51800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072890",
                                        "groupName": "Upgrade Your Base - Medium",
                                        "choices": [
                                          {
                                            "id": "142074458",
                                            "name": "Double Burst",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074459",
                                            "name": "Ultra Thin Crust Pizza - Medium Pizza",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072891",
                                        "groupName": "Toppings-veg (medium)",
                                        "choices": [
                                          {
                                            "id": "142074482",
                                            "name": "Onions",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074467",
                                            "name": "Fresh Tomatoes",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074466",
                                            "name": "Mushroom",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074478",
                                            "name": "Sweet Corns",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074477",
                                            "name": "Pineapples",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074476",
                                            "name": "Red Paprika",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074486",
                                            "name": "Jalapenos",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074485",
                                            "name": "Olives",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074484",
                                            "name": "Paneer",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074483",
                                            "name": "Capsicum",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072892",
                                        "groupName": "Cheese & Dip (m)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074422",
                                            "name": "Mozzarella",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074420",
                                            "name": "Cheezy-7",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074418",
                                            "name": "Korma Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074416",
                                            "name": "Peri Peri Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074414",
                                            "name": "Hot & Garlic Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074412",
                                            "name": "Jalapeno Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074410",
                                            "name": "Cheese Dip",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074408",
                                            "name": "Extra Cheese",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857412"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70577453"
                          },
                          {
                            "title": "Large Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971624",
                                    "name": "Double Cheese Margherita Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Loaded with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/24/9b691c95-f72b-4150-b0b3-154cbef81207_38df0d37-5bb5-41fc-b27e-8292ef172f9c.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 61300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072893",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072894",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072895",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "116203598"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971625",
                                    "name": "Lovers Bite Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A wholesome combination of tossed mushrooms, olives and juicy sweet corn",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/23/2cb8e938-c3dc-4eef-96a8-cc157ebbacf6_aa6d8393-4e4e-4d38-8a7d-acb99dca4603.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 61300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072896",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072897",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072898",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870321"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971626",
                                    "name": "Margherita Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "A classic Margherita Pizza",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/19/45092069-73d4-4ee3-bf0d-22f94f36a80a_44f4a610-8d08-4e71-8866-ac682d230777.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 49800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072899",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072900",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072901",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115857400"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971627",
                                    "name": "Onion Large Twist.pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Twisted combination of Onion & Cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/9/a4efe0ce-54a6-4737-a9a4-3120fa68d499_9d9d9422-9947-4641-8750-b14b2bb15a73.jpeg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 49800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072902",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072903",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072904",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "116006248"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971628",
                                    "name": "Spring Fling Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Quintessentially veg with capsicum, sweet corn and flavoured chunks of paneer.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/23/eba05a4c-7056-4b27-bc80-ca13d5d6e453_08b5b8db-80f4-4d25-9db0-bc6a03b77116.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 61300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072905",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072906",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072907",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870324"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "190971629",
                                    "name": "Veg.hawaiian Large .pizza",
                                    "category": "New Year Party Offer",
                                    "description": "Nothing says Hawaiian like pineapple, paneer, and sweet corn with extra cheese",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/8fa73d94-089b-4b69-9e1d-dbe8267cb438_1a6628d4-df67-49b7-a041-775457195c08.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 61300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266072908",
                                        "groupName": "Upgrade Your Ultra Thin Crust Large Pizza",
                                        "choices": [
                                          {
                                            "id": "142074457",
                                            "name": "Ultra Thin Crust - Large Pizza",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072909",
                                        "groupName": "Toppings-veg (large)",
                                        "choices": [
                                          {
                                            "id": "142074461",
                                            "name": "Fresh Tomatoes",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074468",
                                            "name": "Onions",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074465",
                                            "name": "Mushroom",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074464",
                                            "name": "Sweet Corns",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074463",
                                            "name": "Pineapples",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074462",
                                            "name": "Red Paprika",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074472",
                                            "name": "Jalapenos",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074471",
                                            "name": "Olives",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074470",
                                            "name": "Paneer",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074469",
                                            "name": "Capsicum",
                                            "price": 8000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266072910",
                                        "groupName": "Cheese & Dip (l)(spread On The Base)",
                                        "choices": [
                                          {
                                            "id": "142074513",
                                            "name": "Mozzarella",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074511",
                                            "name": "Cheezy-7",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074509",
                                            "name": "Korma Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074507",
                                            "name": "Peri Peri Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074505",
                                            "name": "Hot & Garlic Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074521",
                                            "name": "Jalapeno Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074524",
                                            "name": "Cheese Dip",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142074522",
                                            "name": "Extra Cheese",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96870327"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70577454"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/24/9b691c95-f72b-4150-b0b3-154cbef81207_38df0d37-5bb5-41fc-b27e-8292ef172f9c.jpeg",
                        "categoryId": "70577451"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11425045000086"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "La Pino'z Pizza",
                        "area": "MP Nagar",
                        "completeAddress": "Shop No : Plot No 74 , Floor :  , Plot No 74 Complex Kochhar Arcade, , "
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "0XVGrvAPOMaY-bpawC_ZitWEGN00LPLCrJdn_Lsw"
  },

  "425509": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "KFC",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "508470",
                "name": "KFC",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "kfc-kohefiza-bairagarh",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/10/17/9d7680d1-df5a-42f7-84d9-7c46b5082f8d_508470.JPG",
                "locality": "Housing board Colony",
                "areaName": "Kohefiza",
                "costForTwo": "40000",
                "costForTwoMessage": "₹400 for two",
                "cuisines": ["Burgers", "Fast Food"],
                "avgRating": 4.3,
                "feeDetails": {
                  "restaurantId": "508470",
                  "fees": [{}]
                },
                "parentId": "547",
                "avgRatingString": "4.3",
                "totalRatingsString": "1.9K+ ratings",
                "sla": {
                  "restaurantId": "508470",
                  "deliveryTime": 40,
                  "minDeliveryTime": 40,
                  "maxDeliveryTime": 45,
                  "lastMileTravel": 4.6,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 3040,
                  "slaString": "40-45 MINS",
                  "lastMileTravelString": "4.6 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseMessage": "Closes soon",
                  "nextCloseTime": "2026-01-06 02:00:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "kfc-kohefiza-bairagarh",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "KFC Kohefiza (Sapphire foods India Ltd) Shop/Unit No. A8, Ground floor, Housing board colony, Kohefiza, Main road, Bhopal (M.P) 462001."
                  },
                  {
                    "title": "Cuisines",
                    "message": "Burgers,Fast Food"
                  }
                ],
                "totalRatings": 1900,
                "aggregatedDiscountInfoV2": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ]
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "priority": 8,
                    "discountInfo": {
                      "discountType": "FinalPrice",
                      "value": 799
                    },
                    "unlockedMessage": "Deal of the Day unlocked!",
                    "minItemCount": 1,
                    "maxItemCount": 1,
                    "type": "SILD",
                    "nudgeTagInfo": {
                      "title": "Deal of the Day",
                      "fontName": "FONT_NAME_CONDENSED_BOLD"
                    },
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/508470"
                },
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {},
                  "subTitle": {},
                  "message": {},
                  "customIcon": {},
                  "commsStyling": {}
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.268239,77.377717",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {},
                "requestContexts": ["enable_ecosaver", "99store"]
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "FLAT 50% OFF",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["8183b781-e892-4320-968f-389c67bf18f4"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "508470",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "NO CODE REQUIRED"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "ITEMS AT ₹79",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["4164bd4b-14b2-4966-8976-caedca99cab3"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "508470",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "50% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["44f57de4-0f0d-4dd0-85ae-0d89a6e4aa37"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE TRYNEW",
                        "description": "ABOVE ₹199",
                        "offerType": "offers",
                        "restId": "508470",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE TRYNEW"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹300 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["4c0645d5-7e25-4486-bbd2-2efc6d5a44c3"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT300",
                        "description": "ABOVE ₹1499",
                        "offerType": "offers",
                        "restId": "508470",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT300"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT 20% OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["99eea5b6-d395-4671-bb54-e980f113084e"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE XTRAPARTY",
                        "description": "ABOVE ₹1999",
                        "offerType": "offers",
                        "restId": "508470",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE XTRAPARTY"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "50% OFF"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                        "title": "Top Picks",
                        "carousel": [
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "6906469",
                            "creativeId": "TopPicks2024/184723074F.png",
                            "title": "Chizza - Pizza With A Kfc Twist",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "184731376",
                                "name": "Chizza - Pizza With A Kfc Twist",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/242f5bb7-dbd5-49ad-bd1e-589c562e54bf_23a71707-aa28-4e98-8b43-da0dc4217465.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "112222679"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "6906195",
                            "creativeId": "TopPicks2024/167129719F.png",
                            "title": "Double Down Burger",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "122155693",
                                "name": "Double Down Burger",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "All chicken no bun burger with 2 delicious sauces & veggies [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/53384d58-48c7-4f87-a43e-8500edb39d39_fe59bb58-df7d-4574-a1ce-ec0ad23282be.jpg",
                                "inStock": 1,
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "248986978",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986980",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986982",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986984",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "70203427"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "6909199",
                            "creativeId": "TopPicks2024/170989286F.png",
                            "title": "Gold Edition - Chicken Zinger Burger & Fries",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "172142998",
                                "name": "Gold Edition - Chicken Zinger Burger & Fries",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 59 on Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun and Fries on the side",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/decb99ff-2c14-43f1-828c-dc47a38d92ce_e9e1651f-a2e6-4e2f-af45-758e662e3290.jpg",
                                "inStock": 1,
                                "price": 29905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245398953",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398956",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862737",
                                        "name": "Peri Peri chicken strips - 6 Pc",
                                        "price": 31905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398962",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398968",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "103405118"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "6910114",
                            "creativeId": "TopPicks2024/181067944F.png",
                            "title": "Kfc X Snickers Choco Mousse Cake",
                            "description": " ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "182301844",
                                "name": "Kfc X Snickers Choco Mousse Cake",
                                "category": "Desserts",
                                "description": "Layers of smooth, gooey, nutty, chocolatey delight - with a Snickers twist.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/f078db6a-27c3-4738-a74e-2097fc6a710f_2f7120b2-49a3-44ed-9726-f14e32addc01.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13900,
                                "finalPrice": 7000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "109740418"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588648",
                                "name": "Non Veg Snacking Combo With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Popcorn Chicken with Large Fries and Pepsi Reusable - bite-sized fun to keep the night going strong.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/5a366aa9-bb6f-4f3e-a9f0-25d318e54cb6_95ed7a5e-d231-4518-aa8e-d557fe2f8441.jpg",
                                "inStock": 1,
                                "price": 36300,
                                "finalPrice": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "0e556262-c804-40ea-b0a8-8dc518948ad4"
                                ],
                                "parentId": "112888185"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588647",
                                "name": "Veg Snacking Combo With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Choco Lava Cake, Large Fries, and Pepsi Reusable - a combo that's sweet, salty, and everything nice.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/9a9d1016-4c0f-4569-a639-2fd3ca1cccdc_92978639-df98-439b-9776-f7afbfae6258.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35700,
                                "finalPrice": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "0e556262-c804-40ea-b0a8-8dc518948ad4"
                                ],
                                "parentId": "112888187"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588644",
                                "name": "Veg Roll Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "A delicious paneer & veggie roll with KFC spices, teamed with Large Fries and Pepsi Reusable - light yet filling!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/f403542f-6da2-4855-a28a-fe66a65ad2ce_2106e32b-6c2a-4569-8519-5d2935ccefbc.jpg",
                                "inStock": 1,
                                "price": 36700,
                                "finalPrice": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "fca7403a-b32c-4458-902a-1c218867a9a6"
                                ],
                                "parentId": "112888186"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588642",
                                "name": "Chicken Roll Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Soft wrap loaded with spicy chicken and creamy sauce, paired with Large Fries and Pepsi Reusable for a satisfying meal on the go.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/1fd01a64-e52c-4b4f-b9d5-adc21476f765_af3fe33f-f78c-4be6-98f4-1971c60853d7.jpg",
                                "inStock": 1,
                                "price": 37400,
                                "finalPrice": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "fca7403a-b32c-4458-902a-1c218867a9a6"
                                ],
                                "parentId": "112888183"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588640",
                                "name": "Veg Zinger Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crunchy Veg Zinger Burger, Large Fries, and Pepsi Reusable - the ultimate vegetarian comfort combo for late-night cravings.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/de2f4442-6af3-454f-8a90-7e7f98a99b9b_416d0e00-3231-482a-8b59-47eff2f964c5.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 43700,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "f1bcd798-cbe7-4358-bfd3-24c3e4973c1c"
                                ],
                                "parentId": "112888188"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588638",
                                "name": "Chicken Zinger Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crispy, juicy Chicken Zinger Burger served with Large Fries and chilled Pepsi Reusable - your perfect midnight hunger fix.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/3e3325ae-b50f-4b92-87ff-d7884839469e_6a24ec98-39db-4337-afb5-89acce0cf590.jpg",
                                "inStock": 1,
                                "price": 44700,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "f1bcd798-cbe7-4358-bfd3-24c3e4973c1c"
                                ],
                                "parentId": "112888184"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083062",
                                "name": "Craving Saving meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crave & Save whooping Rs 249 on 4 Pc Hot & Crispy, 4 Pc Peri Peri Strips, Medium Popcorn, 2 Dips & a Pepsi PET 475ml [Serves 2-3]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/9e5902f5-c942-4371-99cf-433bee88b8db_5463d28f-6503-4666-af67-419ebe262289.jpg",
                                "inStock": 1,
                                "price": 77900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420257"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083064",
                                "name": "Party Bucket Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Party time Savings of Rs 92 on 4 Pc Peri Peri Chicken Leg Pc, 2 Pc Peri Peri Strips, Regular Popcorn & a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/6c1b2981-60c2-4bcf-8566-002519dccca1_67401533-ea91-49bd-9320-e55d22ae31f3.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420265"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083066",
                                "name": "Insta Reel Korean Roll Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Flat Rs 95 off on Tangy Korean Chicken Roll, 2 Pc Hot & Crispy, 7Up Zero Sugar Can 330ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a1ef4f33-ccae-4da1-b14e-d898046e4d8a_90e183d8-2b73-4edc-9fb1-1e70ea37df70.jpg",
                                "inStock": 1,
                                "price": 34900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247323136",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323138",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323141",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323143",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420259"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083068",
                                "name": "Night Owl Roll combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Eye opener deal on Classic Chicken Roll & Medium Fries [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/eb4bf183-297e-4c7a-82db-6d2e0f787472_324a0669-3780-43d0-bfb3-2ff3483188c3.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321995",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321998",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322000",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322004",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420263"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083070",
                                "name": "Rice Krunch Bowl Combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Krunchy savings of Rs 69 on Popcorn Chicken Rice Bowl and 4 Pc Peri Peri Strips [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/b328f1b1-ed4e-4a95-9a8f-f02b071f7388_d001011b-08b5-469d-8d8e-0bb9643002e7.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420846",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420847",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420848",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420849",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420268"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083072",
                                "name": "Peri Peri Binge Watch combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Binge & Save Rs 85 on 4 Pc Peri Peri Leg pc, 2 Pc Peri Peri Strips & Regular Popcorn",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/5399c2df-c3d8-4d02-b45b-97d662ac7a57_84ef2049-345c-4aa4-ac20-92b3e5f32b61.jpg",
                                "inStock": 1,
                                "price": 59900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420266"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083074",
                                "name": "Thai Roll Dream meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Dream deal of Rs 145 on 2 units of Thai Spicy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/de2a7280-a059-40b1-9fda-8fef1a6b7660_e839fa2f-4777-4245-b109-2b7e8af9b997.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420270"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083076",
                                "name": "Night Shift Zinger Pro Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Relax in Night shift and save Rs 75 on Zinger Pro Burger, Large Popocorn and 7Up Zero Sugar Can 330ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/286a5a97-6656-42c9-aaa2-1ec3767be7f9_ed0959c9-9b5b-40e5-af19-fef57b4d822a.jpg",
                                "inStock": 1,
                                "price": 48900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321919",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321920",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321922",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321923",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420264"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083078",
                                "name": "Rice & Bites combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Deal meal of Hot & Crispy Rice Bowl and Large Popcorn [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bcceee6c-627d-4708-ace4-8838694bf483_becfb89e-9d3e-4b52-afa6-6582f7ecad5e.jpg",
                                "inStock": 1,
                                "price": 44900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322068",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322070",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322075",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322079",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420267"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083080",
                                "name": "Midnight Spicy Zinger & Popcorn Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Midnight special savings of Rs 85 on Spicy Zinger, Large Popcorn and Pepsi Black Can 330ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/42e73ea0-0d4f-46b7-a179-ea106f37e874_9d4136ac-02c6-4fa9-a97e-5d9886412209.jpg",
                                "inStock": 1,
                                "price": 45900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245974103",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974104",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593393",
                                        "name": "Double Chicken Roll",
                                        "price": 16857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974107",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974108",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420261"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083082",
                                "name": "Gaming Night Korean Roll meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Night fun savings of Rs 145 on 2 units of Korean Tangy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/140c9f75-811e-4d67-983a-19bfee65a0d9_278fffa2-1500-4732-a139-309c5df2914d.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420741",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420743",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420744",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420745",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420258"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083085",
                                "name": "Lazy BFF Rice combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "BFF deal savings of Rs 99 on 2 units of Popcorn Rice Bowl and 4 Leg Pc [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bf86f1c9-3182-4189-9a35-8c5f2ad63ba0_d12d07c2-dc58-4ee8-b182-5b11f17f973e.jpg",
                                "inStock": 1,
                                "price": 79900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321103",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321109",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321114",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321120",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420260"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083088",
                                "name": "Night Bite Veg Roll combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Munching deal of Rs 59 on Veg Spicy Roll & Large Fries [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a39e1ee7-7f57-460a-aff5-e568c6c25b18_fa010fd0-0059-4be3-b193-6a4103fca417.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283902",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283906",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283909",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283912",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420262"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083089",
                                "name": "Still Awake Veg Zinger Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Special Veg deal with Rs 105 off on Veg Zinger Burger, Large Fries & a Pepsi Black Can 330ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/12/552c36a5-a81e-4ef2-b204-40a4d7ba63e0_c6ce48d6-f384-4ee0-9cd2-7380c77a0883.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322341",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322346",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322347",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322353",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420269"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED",
                        "subtitleSuffix": {},
                        "categoryId": "-1"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Late Night Specials (Starting at 199)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588648",
                                "name": "Non Veg Snacking Combo With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Popcorn Chicken with Large Fries and Pepsi Reusable - bite-sized fun to keep the night going strong.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/5a366aa9-bb6f-4f3e-a9f0-25d318e54cb6_95ed7a5e-d231-4518-aa8e-d557fe2f8441.jpg",
                                "inStock": 1,
                                "price": 36300,
                                "finalPrice": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "0e556262-c804-40ea-b0a8-8dc518948ad4"
                                ],
                                "parentId": "112888185"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588647",
                                "name": "Veg Snacking Combo With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Choco Lava Cake, Large Fries, and Pepsi Reusable - a combo that's sweet, salty, and everything nice.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/9a9d1016-4c0f-4569-a639-2fd3ca1cccdc_92978639-df98-439b-9776-f7afbfae6258.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35700,
                                "finalPrice": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "0e556262-c804-40ea-b0a8-8dc518948ad4"
                                ],
                                "parentId": "112888187"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588644",
                                "name": "Veg Roll Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "A delicious paneer & veggie roll with KFC spices, teamed with Large Fries and Pepsi Reusable - light yet filling!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/f403542f-6da2-4855-a28a-fe66a65ad2ce_2106e32b-6c2a-4569-8519-5d2935ccefbc.jpg",
                                "inStock": 1,
                                "price": 36700,
                                "finalPrice": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "fca7403a-b32c-4458-902a-1c218867a9a6"
                                ],
                                "parentId": "112888186"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588642",
                                "name": "Chicken Roll Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Soft wrap loaded with spicy chicken and creamy sauce, paired with Large Fries and Pepsi Reusable for a satisfying meal on the go.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/1fd01a64-e52c-4b4f-b9d5-adc21476f765_af3fe33f-f78c-4be6-98f4-1971c60853d7.jpg",
                                "inStock": 1,
                                "price": 37400,
                                "finalPrice": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "fca7403a-b32c-4458-902a-1c218867a9a6"
                                ],
                                "parentId": "112888183"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588640",
                                "name": "Veg Zinger Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crunchy Veg Zinger Burger, Large Fries, and Pepsi Reusable - the ultimate vegetarian comfort combo for late-night cravings.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/de2f4442-6af3-454f-8a90-7e7f98a99b9b_416d0e00-3231-482a-8b59-47eff2f964c5.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 43700,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "f1bcd798-cbe7-4358-bfd3-24c3e4973c1c"
                                ],
                                "parentId": "112888188"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188588638",
                                "name": "Chicken Zinger Meal With Fries & Pepsi",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crispy, juicy Chicken Zinger Burger served with Large Fries and chilled Pepsi Reusable - your perfect midnight hunger fix.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/3e3325ae-b50f-4b92-87ff-d7884839469e_6a24ec98-39db-4337-afb5-89acce0cf590.jpg",
                                "inStock": 1,
                                "price": 44700,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "f1bcd798-cbe7-4358-bfd3-24c3e4973c1c"
                                ],
                                "parentId": "112888184"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083062",
                                "name": "Craving Saving meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Crave & Save whooping Rs 249 on 4 Pc Hot & Crispy, 4 Pc Peri Peri Strips, Medium Popcorn, 2 Dips & a Pepsi PET 475ml [Serves 2-3]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/9e5902f5-c942-4371-99cf-433bee88b8db_5463d28f-6503-4666-af67-419ebe262289.jpg",
                                "inStock": 1,
                                "price": 77900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420257"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083064",
                                "name": "Party Bucket Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Party time Savings of Rs 92 on 4 Pc Peri Peri Chicken Leg Pc, 2 Pc Peri Peri Strips, Regular Popcorn & a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/6c1b2981-60c2-4bcf-8566-002519dccca1_67401533-ea91-49bd-9320-e55d22ae31f3.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420265"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083066",
                                "name": "Insta Reel Korean Roll Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Flat Rs 95 off on Tangy Korean Chicken Roll, 2 Pc Hot & Crispy, 7Up Zero Sugar Can 330ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a1ef4f33-ccae-4da1-b14e-d898046e4d8a_90e183d8-2b73-4edc-9fb1-1e70ea37df70.jpg",
                                "inStock": 1,
                                "price": 34900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247323136",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323138",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323141",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323143",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420259"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083068",
                                "name": "Night Owl Roll combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Eye opener deal on Classic Chicken Roll & Medium Fries [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/eb4bf183-297e-4c7a-82db-6d2e0f787472_324a0669-3780-43d0-bfb3-2ff3483188c3.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321995",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321998",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322000",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322004",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420263"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083070",
                                "name": "Rice Krunch Bowl Combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Krunchy savings of Rs 69 on Popcorn Chicken Rice Bowl and 4 Pc Peri Peri Strips [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/b328f1b1-ed4e-4a95-9a8f-f02b071f7388_d001011b-08b5-469d-8d8e-0bb9643002e7.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420846",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420847",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420848",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420849",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420268"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083072",
                                "name": "Peri Peri Binge Watch combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Binge & Save Rs 85 on 4 Pc Peri Peri Leg pc, 2 Pc Peri Peri Strips & Regular Popcorn",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/5399c2df-c3d8-4d02-b45b-97d662ac7a57_84ef2049-345c-4aa4-ac20-92b3e5f32b61.jpg",
                                "inStock": 1,
                                "price": 59900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420266"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083074",
                                "name": "Thai Roll Dream meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Dream deal of Rs 145 on 2 units of Thai Spicy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/de2a7280-a059-40b1-9fda-8fef1a6b7660_e839fa2f-4777-4245-b109-2b7e8af9b997.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420270"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083076",
                                "name": "Night Shift Zinger Pro Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Relax in Night shift and save Rs 75 on Zinger Pro Burger, Large Popocorn and 7Up Zero Sugar Can 330ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/286a5a97-6656-42c9-aaa2-1ec3767be7f9_ed0959c9-9b5b-40e5-af19-fef57b4d822a.jpg",
                                "inStock": 1,
                                "price": 48900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321919",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321920",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321922",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321923",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420264"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083078",
                                "name": "Rice & Bites combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Deal meal of Hot & Crispy Rice Bowl and Large Popcorn [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bcceee6c-627d-4708-ace4-8838694bf483_becfb89e-9d3e-4b52-afa6-6582f7ecad5e.jpg",
                                "inStock": 1,
                                "price": 44900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322068",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322070",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322075",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322079",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420267"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083080",
                                "name": "Midnight Spicy Zinger & Popcorn Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Midnight special savings of Rs 85 on Spicy Zinger, Large Popcorn and Pepsi Black Can 330ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/42e73ea0-0d4f-46b7-a179-ea106f37e874_9d4136ac-02c6-4fa9-a97e-5d9886412209.jpg",
                                "inStock": 1,
                                "price": 45900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245974103",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974104",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593393",
                                        "name": "Double Chicken Roll",
                                        "price": 16857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974107",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974108",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420261"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083082",
                                "name": "Gaming Night Korean Roll meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Night fun savings of Rs 145 on 2 units of Korean Tangy Chicken Roll, 2 units of Popcorn Rice Bowl and a Pepsi PET 475ml [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/140c9f75-811e-4d67-983a-19bfee65a0d9_278fffa2-1500-4732-a139-309c5df2914d.jpg",
                                "inStock": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420741",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420743",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420744",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420745",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420258"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083085",
                                "name": "Lazy BFF Rice combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "BFF deal savings of Rs 99 on 2 units of Popcorn Rice Bowl and 4 Leg Pc [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/bf86f1c9-3182-4189-9a35-8c5f2ad63ba0_d12d07c2-dc58-4ee8-b182-5b11f17f973e.jpg",
                                "inStock": 1,
                                "price": 79900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321103",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321109",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321114",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321120",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89420260"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083088",
                                "name": "Night Bite Veg Roll combo",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Munching deal of Rs 59 on Veg Spicy Roll & Large Fries [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/11/a39e1ee7-7f57-460a-aff5-e568c6c25b18_fa010fd0-0059-4be3-b193-6a4103fca417.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283902",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283906",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283909",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283912",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420262"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "151083089",
                                "name": "Still Awake Veg Zinger Meal",
                                "category": "Late Night Specials (Starting at 199)",
                                "description": "Special Veg deal with Rs 105 off on Veg Zinger Burger, Large Fries & a Pepsi Black Can 330ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/12/552c36a5-a81e-4ef2-b204-40a4d7ba63e0_c6ce48d6-f384-4ee0-9cd2-7380c77a0883.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322341",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322346",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322347",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322353",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89420269"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/16/5a366aa9-bb6f-4f3e-a9f0-25d318e54cb6_95ed7a5e-d231-4518-aa8e-d557fe2f8441.jpg",
                        "categoryId": "53161246"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Newly Launched Dunked Range",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191251272",
                                "name": "Dunked Bbq Chicken Strips - 3 Pcs",
                                "category": "Newly Launched Dunked Range",
                                "description": "Three crispy chicken strips dunked in smoky, fiery Texas BBQ sauce for a bold, saucy bite.",
                                "inStock": 1,
                                "price": 21905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                }
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191251271",
                                "name": "Dunked Bbq 2 Leg Pieces",
                                "category": "Newly Launched Dunked Range",
                                "description": "Two juicy chicken drums coated in fiery Texas BBQ glaze-smoky, spicy, and packed with flavour.",
                                "inStock": 1,
                                "price": 27905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                }
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191251270",
                                "name": "Dunked Bbq Zinger Burger",
                                "category": "Newly Launched Dunked Range",
                                "description": "The classic Zinger dunked in fiery Texas BBQ sauce for a smoky, spicy twist.",
                                "inStock": 1,
                                "price": 27905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                }
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191251269",
                                "name": "Dunked Bbq Zinger Meal",
                                "category": "Newly Launched Dunked Range",
                                "description": "A hearty DUNKED feast featuring a Fiery Texas BBQ Zinger, hot wings, medium fries, and a chilled Pepsi PE",
                                "inStock": 1,
                                "price": 42857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                }
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "categoryId": "70709658"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Feastival Meals (Starting at 259)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "184731376",
                                "name": "Chizza - Pizza With A Kfc Twist",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/242f5bb7-dbd5-49ad-bd1e-589c562e54bf_23a71707-aa28-4e98-8b43-da0dc4217465.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "112222679"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155693",
                                "name": "Double Down Burger",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "All chicken no bun burger with 2 delicious sauces & veggies [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/53384d58-48c7-4f87-a43e-8500edb39d39_fe59bb58-df7d-4574-a1ce-ec0ad23282be.jpg",
                                "inStock": 1,
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "248986978",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986980",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986982",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986984",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "34 ratings",
                                    "ratingCountV2": "34"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203427"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172142998",
                                "name": "Gold Edition - Chicken Zinger Burger & Fries",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 59 on Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun and Fries on the side",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/decb99ff-2c14-43f1-828c-dc47a38d92ce_e9e1651f-a2e6-4e2f-af45-758e662e3290.jpg",
                                "inStock": 1,
                                "price": 29905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245398953",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398956",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862737",
                                        "name": "Peri Peri chicken strips - 6 Pc",
                                        "price": 31905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398962",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245398968",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "103405118"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "108488314",
                                "name": "Duo Chicken Chizza",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "2 Crunchy all-chicken-no-crust Chizza topped with cheese, spicy sauce, veggies & herbs [Serves 2-3]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/21cf58a5-d2db-45bf-9d60-f0e6886e2626_2bb84f50-946a-40fe-83e5-88b10df30cd5.jpg",
                                "inStock": 1,
                                "price": 57900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.7",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "62191588"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "127999007",
                                "name": "Chicken Chizza & Pepsi Combo",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/c2f9c0c2-451b-4ee5-961f-e9a9f87253f2_bffd060f-4226-486f-83b6-22f1fb04afe9.jpg",
                                "inStock": 1,
                                "price": 34900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "64303313"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "108488317",
                                "name": "Chicken Chizza & Fries Combo",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 16 on Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml and Medium Fries [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/860307bf-2ed7-4964-ba5b-bb1a9f7ca2c9_ed714d19-c6a9-47b0-bc6a-b81248528f16.jpg",
                                "inStock": 1,
                                "price": 43900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "62191586"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155695",
                                "name": "2 Double Down Burgers",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 19 on 2 Double Down - all chicken no bun Burgers [serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/a55a066a-7e8a-4094-98a9-56a11f0ba681_e38d19a3-8703-42b6-84e7-64064349bec0.jpg",
                                "inStock": 1,
                                "price": 49900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "248986966",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986967",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986968",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986969",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28656797"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155696",
                                "name": "Double Down Burger & Pepsi",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "All chicken no bun burger with 2 delicious sauces & veggies served with Pepsi PET 475ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/c54c178e-3101-4dc8-a7e3-c23ea074467a_7cd9304b-3533-453b-bf06-23c4fc2b417f.jpg",
                                "inStock": 1,
                                "price": 30900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "248986962",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986963",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986964",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986965",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203429"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155697",
                                "name": "Double Down Burger & Popcorn Meal",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 12 on Double Down- all chicken no bun Burger, Regular Popcorn & Pepsi 475ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/19b573b2-0d28-494b-b95a-d5fa190afd5e_abecf5fa-6cfd-4977-b1a8-38b76b9af773.jpg",
                                "inStock": 1,
                                "price": 42900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "248986958",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986959",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986960",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248986961",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203431"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "184731365",
                                "name": "Goldedition Zinger,fries&pepsi",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "Save Rs 66 on Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun with Pepsi PET 475ml and Fries on the side [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/d4a5c010-3cf9-4eaa-9f53-a9d4f1e43efe_38d619c4-fe98-42a0-b3da-44af40951bd7.jpg",
                                "inStock": 1,
                                "price": 34900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "112222685"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "184731364",
                                "name": "2 Gold Chicken Zinger",
                                "category": "Feastival Meals (Starting at 259)",
                                "description": "2 Signature Zinger Dunked in Cheese Sauce in the new Brioche Bun [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/15/bdbc6f6c-ca18-4ad6-a6e2-ae8a769ecc84_73fe01cd-d4cd-4b13-b63d-5d5a18af9e51.jpg",
                                "inStock": 1,
                                "price": 54900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "112222676"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/242f5bb7-dbd5-49ad-bd1e-589c562e54bf_23a71707-aa28-4e98-8b43-da0dc4217465.jpg",
                        "categoryId": "67868733"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Festive Hamper",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190098173",
                                "name": "Snickers Choco Mousse Cake Festive",
                                "category": "Festive Hamper",
                                "description": "Indulge in pure decadence with four slices of Snickers-inspired Choco Mousse Cake - a dreamy blend of caramel, peanuts, and velvety chocolate mousse. Made to sweeten your celebrations!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/ca41eb31-698f-4ed2-9b63-f238fff0d2e7_17618829-2da0-4f01-93ee-acce3d0f0c68.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 55600,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115694951"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190098174",
                                "name": "Choco Lava Festive Hamper 4 Pcs",
                                "category": "Festive Hamper",
                                "description": "Dive into molten happiness! Four rich, gooey Choco Lava cakes - perfectly baked with a molten chocolate core. The ultimate festive treat for every chocoholic.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/03b63bde-bd80-4da7-b97a-34db0a2b9720_49dfad4b-434c-47eb-97fb-ed7946babf1f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 47600,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "112339001"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/24/ca41eb31-698f-4ed2-9b63-f238fff0d2e7_17618829-2da0-4f01-93ee-acce3d0f0c68.jpg",
                        "categoryId": "70195133"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Chicken Burgers and Meals",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386633",
                                "name": "Chicken Zinger Burger - Classic",
                                "category": "Chicken Burgers and Meals",
                                "description": "Signature burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
                                "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                                "inStock": 1,
                                "price": 20857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283682",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283685",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283687",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283689",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "142 ratings",
                                    "ratingCountV2": "142"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "53127268"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386635",
                                "name": "Chicken Zinger Burger - Tandoori",
                                "category": "Chicken Burgers and Meals",
                                "description": "Chicken zinger with a delicious Indian Tandoori flavour sauce and Mayo",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/13/9ec4aae7-63f0-4d7e-8b32-843e21edeed1_5bb6b22e-3935-4be6-b014-4b7ff5e81a6c.jpg",
                                "inStock": 1,
                                "price": 21905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245110253",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110257",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110261",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110262",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "105 ratings",
                                    "ratingCountV2": "105"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "53127270"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386643",
                                "name": "Chicken Burger Buddy Meal",
                                "category": "Chicken Burgers and Meals",
                                "description": "Save Rs. 28 & Share 2 American Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                                "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                                "inStock": 1,
                                "price": 54857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399075",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399076",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399077",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399080",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "53127266"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386637",
                                "name": "Mixed Chicken Zinger Burger Doubles",
                                "category": "Chicken Burgers and Meals",
                                "description": "Save Rs.41 on Best-seller combo of classic chicken Zinger & Tandoori zinger burgers",
                                "imageId": "dd434d7cd80de42b3d04cb979aeacb46",
                                "inStock": 1,
                                "price": 36857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322325",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322328",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322330",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322332",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "48 ratings",
                                    "ratingCountV2": "48"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "53127271"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818806",
                                "name": "American Classic Zinger Mojito Combo",
                                "category": "Chicken Burgers and Meals",
                                "description": "Get All New Mojito Reusable Bottle with American Classic Chicken Zinger Burger",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/18/7d614e39-2124-48f1-b1bf-36b74c880ac6_6898330c-b14e-489b-b3b9-985ab4b7b239.jpg",
                                "inStock": 1,
                                "price": 30762,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245110181",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110185",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110196",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110200",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "85554881"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118346824",
                                "name": "Chicken Longer Burger & 2 Strips Combo",
                                "category": "Chicken Burgers and Meals",
                                "description": "Longgg burger with crunchy chicken, onions & a punchy sauce , served with 2 peri peri chicken strips",
                                "imageId": "e344aa3aac91a825e9d0d0e3f60eda4b",
                                "inStock": 1,
                                "price": 22857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245110695",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110697",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110701",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110706",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "74 ratings",
                                    "ratingCountV2": "74"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "67864076"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147502093",
                                "name": "2 Classic Chicken Krisper Burgers",
                                "category": "Chicken Burgers and Meals",
                                "description": "2 units of delicious chicken value burgers filled with chicken boneless strips & delicious sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/17/6170613a-c811-4615-933d-7f0bb52a05b6_4e8b26a4-cbc5-4b4f-b945-602a3edb0bb3.jpg",
                                "inStock": 1,
                                "price": 25905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247025276",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025277",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025280",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025282",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "80357452"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "d5bc5b32dd177f5f207cad66556a572b",
                        "categoryId": "70195130"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Gourmet Burgers and Meals",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155689",
                                "name": "Chicken Zinger Burger - Classic with Cheese",
                                "category": "Gourmet Burgers and Meals",
                                "description": "Signature burger with a crunchy chicken fillet, cheese slice, veggies & a delicious mayo sauce",
                                "imageId": "418e7dc325cf65d7c1d9faab2e646421",
                                "inStock": 1,
                                "price": 23429,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399773",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399774",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399775",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399776",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66599237"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155688",
                                "name": "Chicken Zinger Burger - Tandoori with Cheese",
                                "category": "Gourmet Burgers and Meals",
                                "description": "Chicken zinger with delicious tandoori sauce & cheese slice",
                                "imageId": "7af6cdbf96ad445ebfce65f568fd0adf",
                                "inStock": 1,
                                "price": 24381,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322785",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322787",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322791",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322795",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66599238"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137764209",
                                "name": "Spicy Zinger Burger",
                                "category": "Gourmet Burgers and Meals",
                                "description": "New Caribbean Spicy Zinger Burger with Spicy Bun & Spicy chilli sauce with Zinger Fillet, Lettuce, Onion and Tomatoes",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/13/c399fbf4-8312-48c0-b661-fa2e052845cf_c96b26a6-55c6-43ff-8231-03e6c10cc4b6.jpg",
                                "inStock": 1,
                                "price": 22952,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322836",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322839",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322845",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322846",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "79 ratings",
                                    "ratingCountV2": "79"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "70203434"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137764204",
                                "name": "Spicy Zinger Burger and Popcorn Meal",
                                "category": "Gourmet Burgers and Meals",
                                "description": "Caribbean Spicy Zinger Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/37fde1f3-777c-48be-8d96-6c5b5d5de72a_14bce274-6cbc-432f-9f98-75000feb041b.jpg",
                                "inStock": 1,
                                "price": 44857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322569",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322570",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322571",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322574",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203436"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137764211",
                                "name": "Spicy Zinger Burger and Chicken Meal",
                                "category": "Gourmet Burgers and Meals",
                                "description": "New Caribbean Spicy Zinger Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/16/97be0ab8-8b40-41fc-926d-5a0da1feda91_b258475e-5a12-46d1-a5a5-618b3c49e62e.jpg",
                                "inStock": 1,
                                "price": 38857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399672",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399676",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399677",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399678",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203435"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155691",
                                "name": "Zinger Pro Burger",
                                "category": "Gourmet Burgers and Meals",
                                "description": "New premium zinger with crunchy zinger fillet,cheese,lettuce,tomatoes,sauce in sesame bun!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/63e333fd-caa9-4032-9f1c-1799f26d5a45_2d9e58d4-6ad7-4acc-b58c-19f3f78acba9.jpg",
                                "inStock": 1,
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245973193",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973195",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139487602",
                                        "name": "Smoky Red Grilled Chicken - 1 pc",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973196",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973197",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "64 ratings",
                                    "ratingCountV2": "64"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "56869955"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818807",
                                "name": "Mexican Zinger Pro Pepsi Bottle Combo",
                                "category": "Gourmet Burgers and Meals",
                                "description": "Get Pepsi in a Reusable Bottle with Mexican Zinger Pro Burger",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/2/6d4e96ba-5fad-4a07-b167-129b7ce83aa3_86ca3b00-ad2d-4bc9-9d12-bac03cd39931.jpg",
                                "inStock": 1,
                                "price": 33905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "244895916",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244895917",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244895918",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244895919",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "85554885"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155690",
                                "name": "Zinger Pro Burger & Chicken Meal",
                                "category": "Gourmet Burgers and Meals",
                                "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/5d53783f-f47c-4c15-936e-7da9cfe3deb4_f1d4aa3e-2e67-492c-87bb-f578eba2bb0b.jpg",
                                "inStock": 1,
                                "price": 40900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245110889",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110890",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110891",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110894",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70203440"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155692",
                                "name": "Zinger Pro Burger & Popcorn Meal",
                                "category": "Gourmet Burgers and Meals",
                                "description": "New Zinger Pro premium Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/2/fa287588-7975-482c-9810-6931f5be4447_06ede9d3-51ef-4efd-877a-ddbb2f0ebebc.jpg",
                                "inStock": 1,
                                "price": 46900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420708",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420709",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420714",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420719",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "70203441"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "418e7dc325cf65d7c1d9faab2e646421",
                        "categoryId": "70195129"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Veg Burgers and Meals",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172142997",
                                "name": "Gold Edition Veg Zinger Burger",
                                "category": "Veg Burgers and Meals",
                                "description": "Our Signature Veg Zinger Dunked in Cheese Sauce in the new Brioche Bun to get your tastebuds tingling",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/16/cb6e9c4a-4de6-4cb4-b549-35db959bf077_e7a57bea-8111-4037-8963-7275075500d2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 23905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247023179",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023184",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862737",
                                        "name": "Peri Peri chicken strips - 6 Pc",
                                        "price": 31905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023185",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023187",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "103405120"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137764203",
                                "name": "Paneer Zinger Burger",
                                "category": "Veg Burgers and Meals",
                                "description": "It's Back! Crunchy Indian Paneer Patty Burger with tangy sauce and Veggies",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/56c5c073-4ac4-4c43-990e-16a558cf3877_87868b65-5a9c-4dd4-8f2e-e47ad6ee57d2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246421038",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421042",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421044",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421048",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "27 ratings",
                                    "ratingCountV2": "27"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657650"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122155687",
                                "name": "Veg Zinger Burger with Cheese",
                                "category": "Veg Burgers and Meals",
                                "description": "Signature veg burger with crispy patties, cheese slice, veggies & a tangy sauce",
                                "imageId": "6d8c645fcd7d5368741ccc61933fafed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22381,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420450",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420451",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420452",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420453",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657964"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177021720",
                                "name": "2 x Chatpata Chana Veg Burger",
                                "category": "Veg Burgers and Meals",
                                "description": "Try New 2 units of Delicious Channa Burger with a unique Indian Chatpata Twist",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/8f55edec-e16c-4f68-985d-14a42e617527_f914dbc7-0a64-45c6-8a47-d603467a8776.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245110808",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110811",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110815",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245110819",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "104913342"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177021719",
                                "name": "2 x Chatpata Chana Veg Burger & Fries combo",
                                "category": "Veg Burgers and Meals",
                                "description": "Save Rs. 56 on 2 units of New Delicious Channa Burger with a unique Indian Chatpata Twist, Medium French Fries & 2 Dips",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/da7b540b-4bcf-4fc5-b764-1d63d4a6e84d_75a88c2c-bc58-4052-ae2f-6eea7e252f1f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 26900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "104913343"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177021717",
                                "name": "2 x Chatpata Chana Veg Burger Meal",
                                "category": "Veg Burgers and Meals",
                                "description": "Flat Rs 36 Off on 2 units of New Delicious Channa Burger with a unique Indian Chatpata Twist, Large Fries & Pepsi 475ml PET",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/c94d0023-5eaa-44f3-84bc-95f100530d3d_66f681f9-56e3-4a2f-8cc9-9b7dcf63e145.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 30900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "104913344"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/16/cb6e9c4a-4de6-4cb4-b549-35db959bf077_e7a57bea-8111-4037-8963-7275075500d2.jpg",
                        "categoryId": "70195128"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113967712",
                                "name": "Double Chicken Roll",
                                "category": "Rolls",
                                "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce [1 unit of Double Chicken Roll, Serves 1]",
                                "imageId": "ebcda29a62123bbf8bb8a33bbe2ab847",
                                "inStock": 1,
                                "price": 16857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245974309",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974312",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974316",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974319",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657292"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113967711",
                                "name": "Classic Chicken Roll",
                                "category": "Rolls",
                                "description": "Street style roll with single chicken strip, onions and two spicy sauce [1 unit of Classic Chicken Roll]",
                                "imageId": "ebd8e706049e4fd5ca79ecf708f8ecba",
                                "inStock": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247023211",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023212",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023215",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023219",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "88 ratings",
                                    "ratingCountV2": "88"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "d28fbce1-5e43-4da6-bcf3-4f70de1e49d4"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "65630981"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113967710",
                                "name": "Double Chicken Roll Meal for 1",
                                "category": "Rolls",
                                "description": "Save Rs. 24 with a Double Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [1 unit of Double Chicken Roll, Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/00af9641-700d-462f-890f-47e358b63bfb_68cecb16-fd2a-4d7d-9392-b5f83d72eaaf.jpg",
                                "inStock": 1,
                                "price": 37905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322299",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322304",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322307",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322311",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65630987"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113967713",
                                "name": "Classic Chicken Roll Meal for 2",
                                "category": "Rolls",
                                "description": "2 units of The classic KFC Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [2 units of Classic Chicken Roll, Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/10/183cb04b-d716-443a-91d9-27f26c566adc_e3c2c7c7-b9a8-4881-a4b5-05532b10ec0a.jpg",
                                "inStock": 1,
                                "price": 47905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322861",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322863",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322867",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322872",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "65630984"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "145446657",
                                "name": "Thai Spicy Chicken Roll",
                                "category": "Rolls",
                                "description": "Fresh burst of Thai flavours and sauces in a flaky paratha, chicken strips and vegetables",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/fa48d82c-2322-4ba7-b419-27e79ca1b217_0800d19e-02b8-45e2-ad64-21ee0d877821.jpg",
                                "inStock": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321704",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321709",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321715",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321719",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "85985884"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "145446656",
                                "name": "Indian Tandoori Chicken Roll",
                                "category": "Rolls",
                                "description": "Flavorful roll made with flaky lachha paratha, perfectly fried chicken strips in rich and creamy tandoori sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/4c966f38-c191-4d0e-a54c-c70b832e4de1_69ee13c1-f267-4385-ab98-6efbc811de33.jpg",
                                "inStock": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322453",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322459",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322465",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322469",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "85985879"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "145446658",
                                "name": "Korean Tangy Chicken Roll",
                                "category": "Rolls",
                                "description": "Delicious new roll featuring tangy Korean kimchi, vegetables and crunchy chicken strips",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/9/377309f8-992e-4fea-a461-1ab5d7218b5e_b814bc78-3961-4332-96df-8aefb9ba86e4.jpg",
                                "inStock": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245973357",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973358",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973360",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973361",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "32 ratings",
                                    "ratingCountV2": "32"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "85985881"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "145446655",
                                "name": "Indian Spicy Veg Roll",
                                "category": "Rolls",
                                "description": "Veg special spicy indian sauce and veggie roll",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/10/523afb1b-9bc9-4a4f-9c6e-1dda60b7da21_61c763cc-a9ca-4c13-ba15-3fe28d631b91.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247025020",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025021",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025022",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025024",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "d28fbce1-5e43-4da6-bcf3-4f70de1e49d4"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "85985878"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824361",
                                "name": "Korean & Thai Roll Chicken Meal",
                                "category": "Rolls",
                                "description": "Rs 154 Off on Korean Tangy Roll & Thai Spicy Roll, Large Popcorn, Large Fries & Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/76d3e89f-2eec-4a04-8c0d-bd82bf153d78_6b7961a1-5a28-482a-a58d-c8e3c03fe112.jpg",
                                "inStock": 1,
                                "price": 56900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245974139",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974142",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245974143",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "86492358"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824360",
                                "name": "Indian Tandoori Roll Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 85 on Indian Tandoori Roll, Classic Zinger Burger, Medium Fries & Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/6b6f3b25-fed1-4e21-afa4-0810da0f2059_b7efdb4b-1568-47b0-9432-1030f6e7ea31.jpg",
                                "inStock": 1,
                                "price": 41900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321292",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321297",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321301",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321303",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492355"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824359",
                                "name": "Korean Tangy Roll & Popcorn Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 76 with Korean Tangy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/213c8941-ef28-41f5-b4b3-81d1d7dc785d_2ddc27a9-dbf7-4164-84c7-06b2e079b10a.jpg",
                                "inStock": 1,
                                "price": 31900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283698",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283699",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283700",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283701",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492356"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824358",
                                "name": "Thai Spicy Roll & Zinger Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 85 with Thai Spicy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/e8d6de01-a6aa-47df-b0c8-6a580359d316_64860f8d-e6bc-4b84-8d79-62615f1f4aa4.jpg",
                                "inStock": 1,
                                "price": 41900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322951",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322952",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322956",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322959",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492360"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824357",
                                "name": "American Roll & Popcorn Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 76 with American Nashville Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/12/09f209e4-a89e-46f4-aec2-bc622f17bd92_d5c5ea67-e942-45ef-af85-655d3f891c90.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246421078",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421080",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421082",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421084",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492354"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824356",
                                "name": "Thai Spicy Roll & Popcorn Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 76 with Thai Spicy Chicken Roll, Medium Popcorn and Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/a0e77537-403f-4fd9-b657-005e878e2049_adf8a8b1-13ab-4056-af16-8e5a932402e4.jpg",
                                "inStock": 1,
                                "price": 31900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247024079",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024080",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024081",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024082",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492359"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147824355",
                                "name": "Korean Tangy Roll & Zinger Chicken Meal",
                                "category": "Rolls",
                                "description": "Save Rs 85 with Korean Tangy Roll with Classic Zinger Burger, Medium Fries and Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/11/bd3efed3-0c20-49ff-b3b4-f49cefb16358_d57b0b7a-b74b-49da-9865-2c65f1d0d65a.jpg",
                                "inStock": 1,
                                "price": 41900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247024552",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024557",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133882799",
                                        "name": "Chicken Zinger Burger - Tandoori",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024568",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024574",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86492357"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "ebcda29a62123bbf8bb8a33bbe2ab847",
                        "categoryId": "39945117"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "All Day Lunch Special Meal Box",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137920077",
                                "name": "All Chicken Box",
                                "category": "All Day Lunch Special Meal Box",
                                "description": "Save Rs 115 with special Chicken Box of 2 Pc Chicken Leg Pc, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/d389059e-c4e5-4b04-b4e5-4989a0599ff8_88bb15e9-b4ad-409f-816b-5b41c484c20f.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247023145",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023146",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023148",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023152",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28656924"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137920076",
                                "name": "Classic Zinger Box",
                                "category": "All Day Lunch Special Meal Box",
                                "description": "All new special Zinger Box with savings of Rs 86 on Classic American Zinger Burger, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/435ff114-9cc0-43bc-af9f-efecd249f098_83fac3c7-9c53-4e9f-85b3-37724f647539.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247025410",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025416",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025420",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025426",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "39 ratings",
                                    "ratingCountV2": "39"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657248"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137920075",
                                "name": "Rice Box Meal",
                                "category": "All Day Lunch Special Meal Box",
                                "description": "Save Rs 106 with special Rice Box Meal of a Popcorn Rice Bowl, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/930821a8-05cd-4138-9322-6ec73b062028_6a395eea-3f19-4e48-8ed7-2b802d6e3d8d.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283946",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283947",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283948",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283949",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657731"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "139009378",
                                "name": "Roll Meal Box",
                                "category": "All Day Lunch Special Meal Box",
                                "description": "Save Rs 88 with special Roll Box Meal of a Classic Chicken Roll , 2 Pc Hot Wings, 2 Pc Peri Peri Strips, Medium Fries & a Pepsi PET 475ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/042acd2b-085f-4400-8b38-397dcb5a0aa1_fc1bae99-1e56-4a60-94d5-574f48e2c50c.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728760",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728761",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728762",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728763",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "81363087"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137920074",
                                "name": "Veg Box Meal",
                                "category": "All Day Lunch Special Meal Box",
                                "description": "Enjoy special Veg Box Meal with savings of Rs 111 on Veg Zinger Burger, 2 Pc Veg patty, Medium Fries & a Pepsi PET 475ml [Serves 1]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/f92325b1-84f8-4e3d-ad6a-2b8bb5a377c2_3876238a-bc22-49ba-b10a-56e8d947b5ac.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247323066",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "134260376",
                                        "name": "Indian Spicy Veg Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323072",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323076",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "80612599"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/20/d389059e-c4e5-4b04-b4e5-4989a0599ff8_88bb15e9-b4ad-409f-816b-5b41c484c20f.jpg",
                        "categoryId": "47228287"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818805",
                                "name": "5 Leg Pc & 2 Dips Pepsi Bottle Combo",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "Get Pepsi 330ml Reusable Bottle with 5 Pc Peri Per Chicken Leg Piece and 2 Dips (20gms each) [serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/d42bd91e-f8ee-43dc-a233-e625b14ce43e_697d354b-b1cd-4915-b653-13a4b1d38bb0.jpg",
                                "inStock": 1,
                                "price": 59900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80357454"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618585",
                                "name": "Peri Peri Chicken 5 Leg Piece Meal",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "5 Spicy Peri Peri Leg Pieces, 2 Dips (20gm each), 1 Med Fries & a Pepsi PET 475ml ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/17/5b8ef1ad-e639-4cc0-b27b-82d1e3eff5d3_f3ba29f9-2f81-4c93-8089-d7c3e1d38bd2.jpg",
                                "inStock": 1,
                                "price": 65905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245729170",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245729173",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245729177",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245729180",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65480597"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113690026",
                                "name": "Peri Peri 10 Pc Chicken Strips & 2 Dips",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "Indulging 10 Piece Peri Peri Boneless Strips and 2 Dips ",
                                "imageId": "a0feef07b2a9d72ba02f4a7d53e46948",
                                "inStock": 1,
                                "price": 52857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247024832",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024836",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024843",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024846",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65480594"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618584",
                                "name": "Peri Peri Chicken 5 Leg Piece Bucket",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "Save Rs 104 on 5 Spicy Peri Peri Leg Pieces",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/22/40640134-7104-45a1-aa7c-4c4202b9fbcd_b7d7cf06-21f4-4af8-9a42-542bc8ce43d3.jpg",
                                "inStock": 1,
                                "price": 54857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728932",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728935",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728937",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728939",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "96153573"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618586",
                                "name": "Peri Peri Chicken 10 Leg Pc & 4 Dips",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "10 Spicy Peri Peri Leg Pieces & 4 Dips (20gm each)",
                                "imageId": "ye1imbdqn5efc7vheuah",
                                "inStock": 1,
                                "price": 96857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322704",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322706",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322708",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322710",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65480595"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818804",
                                "name": "6 Pc Strips & Pepsi Bottle Combo",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "Get Pepsi 330ml Reusable Bottle with 6 Pc Spicy Peri Peri Strips [serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/0f7b1e19-e06b-4f52-a8dc-1640dfe2cd40_ff0f3099-4aae-4e49-9dde-64f9a1cd5ddf.jpg",
                                "inStock": 1,
                                "price": 37900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283842",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283844",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283845",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283847",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80357456"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618583",
                                "name": "Peri Peri chicken strips - 6 Pc",
                                "category": "Peri Peri Chicken Strips & Leg Pc (up to 25%)",
                                "description": "Save 13% with on savouring 6 Spicy Peri Peri chicken boneless strips [serves 2]",
                                "imageId": "qsmfyjef2hbu05emuu2c",
                                "inStock": 1,
                                "price": 31905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321670",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321673",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321676",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321678",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "54 ratings",
                                    "ratingCountV2": "54"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65480598"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/d42bd91e-f8ee-43dc-a233-e625b14ce43e_697d354b-b1cd-4915-b653-13a4b1d38bb0.jpg",
                        "categoryId": "44107831"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Combo Meals for 1-2 (up to 22% off)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189275497",
                                "name": "Full-on Bowl Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Popcorn Chicken Rice Bowl + 1 Peri Peri Leg + 2 Chicken Wings + Pepsi Resuable + Tandoori DIP",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/068f54a8-f116-4cd0-a124-048686beb46f_6c001f7d-cdfe-4e17-9105-2b089e1fed40.jpg",
                                "inStock": 1,
                                "price": 79800,
                                "finalPrice": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "110980017"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189275496",
                                "name": "Mad Duo Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "2 Peri Peri Leg + 4 Chicken Wings + Large Chicken Popcorn+Tandoori DIP",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/f8eaf25a-f309-49db-bd2e-2c1dc1c97889_465aa16e-2dfc-496f-bed6-20571978d83e.jpg",
                                "inStock": 1,
                                "price": 99800,
                                "finalPrice": 49900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "110967033"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189275495",
                                "name": "Thrice As Nice",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "3 Hot and Crispy + 3 Chicken Strip + 3 Wings + Large Chicken Popcorn ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/c85e26ed-57d7-45f9-92cf-20a6dfd53725_51e739a3-bfe4-4c11-9b72-61aa83879813.jpg",
                                "inStock": 1,
                                "price": 129800,
                                "finalPrice": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "110980019"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189275494",
                                "name": "Jumbo Zinger Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "2 Classic Zinger + 2 Pepsi Resuable + 4 Peri Peri Strip + Large Fries+2 Tandoori DIP",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/53451ecd-2528-456f-a621-43d767ac3d1e_48fa9871-41b1-487e-ad8e-b58a140d08ca.jpg",
                                "inStock": 1,
                                "price": 139800,
                                "finalPrice": 69900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "110980018"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "189275493",
                                "name": "Peri Peri Grand Feast",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "2 Peri Peri Leg + 4 Chicken Strip + 4 Wings + 1 Medium Popcorn + 1 Pepsi Pet + 2 Tandoori DIP",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/26/4fb2deec-954c-4714-ac2e-ebc50350714f_8ee0def8-b084-4103-84ba-245ac960b8f6.jpg",
                                "inStock": 1,
                                "price": 129800,
                                "finalPrice": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "109887624"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172843198",
                                "name": "Gold Veg Zinger Burger x 2",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Flat 35% Savings on Signature Veg Zinger Dunked in Cheese Sauce in the new Brioche Bun to get your tastebuds tingling [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/28/f30a81af-9d82-457a-983c-0f4d213b18d9_bedb5130-61b6-414a-865f-2f96d93aa529.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 45800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "104316739"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172843195",
                                "name": "Gold Veg & Paneer Zinger Burger Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Savings of 35% on Gold Veg Cheese Dunked Signature Burger, Paneer Zinger Burger and 2 Masala Pepsi Reusable Bottle [Serves 2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/28/b9401448-4e89-4915-8242-39157f64880e_ed6e7074-32ac-4b05-889f-ff67beb663a9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 64800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "104316738"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172843194",
                                "name": "Trio Zinger Chicken Burgers Deal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Flat 35% Deal on Epic Trio Zinger Burgers of Indian Tandoori Zinger Burger,  Caribbean Spicy Chicken Zinger Burger & American Classic Zinger Burger!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/28/437b7f3b-14f3-4739-b525-5bed2c59b10c_70cf56ab-73f4-4f58-be6a-f2a4473ab981.jpg",
                                "inStock": 1,
                                "price": 62920,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "104316741"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147502092",
                                "name": "Classic Chicken Krisper Burger Combo",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Deal combo of 2 chicken krispers burgers, 2 pc Hot & Crispy, 2 dips (20gm each) & a chilled Pepsi PET 475 ml [Serves 1-2]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/ca7755e3-00d7-4608-8f31-4797b8e59975_92d0dad6-550c-4f37-a38c-6c5ec3b1c462.jpg",
                                "inStock": 1,
                                "price": 58000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728375",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728377",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728379",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728381",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "80357457"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818803",
                                "name": "4 Pc Hot & Crispy Pepsi Bottle Combo",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Get Pepsi 330ml Reusable Bottle with 4 Pc Chicken Hot & Crispy",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/24/dbba9c0a-6724-448a-afec-0e0c76045da4_8c892f8b-6d51-45bd-9fec-8f1906d97a5b.jpg",
                                "inStock": 1,
                                "price": 51900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247025108",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025111",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025114",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247025117",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80357453"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618590",
                                "name": "Chicken Mingles Bucket Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Save Rs. 43 on this crowd favorite combo of 4 Hot Wings, 2 Chicken Peri Peri Boneless Strips, a Reg Popcorn, medium fries & a chilled Pepsi PET 475ml [serves 2 ]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/10/083d6310-fd4b-4a15-a546-37d9cc97dc99_0db16331-66f1-483b-afd1-d2c1b326aa62.jpg",
                                "inStock": 1,
                                "price": 52857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399146",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399147",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399148",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399150",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "16 ratings",
                                    "ratingCountV2": "16"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462652"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818802",
                                "name": "Classic Roll Mojito Meal",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Save Rs 24 with all New Mojito in a Reusable Bottle with Large Fries and Classic Chicken Roll",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/b9ccaa8d-df57-4fd4-9cbb-d96cd3863bb2_92c0cdf1-d0ae-4a19-a43f-69a329ac895a.jpg",
                                "inStock": 1,
                                "price": 34287,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247023443",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023447",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023454",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023459",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80357458"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120701458",
                                "name": "Chicken Mingles Bucket",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Mingle with 4 Chicken Hot Wings, 2 Chicken peri peri boneless strips & a Regular Popcorn at a deal price [serves 1-2]",
                                "imageId": "udmgrvfuwd000kvvqrjf",
                                "inStock": 1,
                                "price": 39905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321599",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321602",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321607",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321609",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "20 ratings",
                                    "ratingCountV2": "20"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462651"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386615",
                                "name": "Chicken & French Fries Bucket",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Crowd-favorite combo of 2pc Hot & Crispy Chicken with Medium French Fries ",
                                "imageId": "pasdg6owucvi23hcp9eb",
                                "inStock": 1,
                                "price": 29905,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36159267",
                                      "name": "Hot & Crispy Chicken -2pc",
                                      "variations": [
                                        {
                                          "name": "Hot & Crispy Chicken -2pc",
                                          "default": 1,
                                          "id": "112405249",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36159268",
                                            "variationId": "112405250"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36159268",
                                      "name": "Select Fries",
                                      "variations": [
                                        {
                                          "name": "French Fries - Medium",
                                          "default": 1,
                                          "id": "112405250",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "French Fries - Large",
                                          "price": 25,
                                          "id": "112405251",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36159267",
                                          "variationId": "112405249"
                                        },
                                        {
                                          "groupId": "36159268",
                                          "variationId": "112405250"
                                        }
                                      ],
                                      "price": 29905
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36159267",
                                          "variationId": "112405249"
                                        },
                                        {
                                          "groupId": "36159268",
                                          "variationId": "112405251"
                                        }
                                      ],
                                      "price": 32405
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "247024278",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024282",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024290",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024296",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29905,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "63453066"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386613",
                                "name": "Chicken Popcorn & French Fries Bucket",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Large Chicken Popcorn with Med French Fries - at a deal price",
                                "imageId": "raq6sxtwfb9fvbd6bakq",
                                "inStock": 1,
                                "price": 32857,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "36159265",
                                      "name": "Chicken Popcorn - Large",
                                      "variations": [
                                        {
                                          "name": "Chicken Popcorn - Large",
                                          "default": 1,
                                          "id": "112405246",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "36159266",
                                            "variationId": "112405247"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "36159266",
                                      "name": "Select Fries",
                                      "variations": [
                                        {
                                          "name": "French Fries - Medium",
                                          "default": 1,
                                          "id": "112405247",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "French Fries - Large",
                                          "price": 25,
                                          "id": "112405248",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36159265",
                                          "variationId": "112405246"
                                        },
                                        {
                                          "groupId": "36159266",
                                          "variationId": "112405247"
                                        }
                                      ],
                                      "price": 32857
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "36159265",
                                          "variationId": "112405246"
                                        },
                                        {
                                          "groupId": "36159266",
                                          "variationId": "112405248"
                                        }
                                      ],
                                      "price": 35357
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "246420690",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420691",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420694",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420695",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 32857,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "32 ratings",
                                    "ratingCountV2": "32"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "63453067"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818801",
                                "name": "Classic Zinger Pepsi Bottle Combo",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Get Pepsi 330ml reusable bottle with Classic chicken Zinger Burger",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/46708834-f4b8-44a8-ac10-8ce89777e614_e94bf79c-1c49-4605-b8a4-d0cefb33c739.jpg",
                                "inStock": 1,
                                "price": 28857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399452",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399455",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399459",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399462",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "80357460"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386662",
                                "name": "Chicken Bucket for Two",
                                "category": "Combo Meals for 1-2 (up to 22% off)",
                                "description": "Flat Rs. 115 off with this variety combo of 2pc Hot & Crispy Chicken, 2 pc Smoky Red Chicken & a Large Popcorn [serves 2-3]",
                                "imageId": "wmn6qpsqazt1ln8hylum",
                                "price": 70105,
                                "finalPrice": 62900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247024975",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024978",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024983",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247024987",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "offerIds": [
                                  "7e49d2c3-3dd8-474d-91e8-26573004a7a2"
                                ],
                                "parentId": "54462648"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/068f54a8-f116-4cd0-a124-048686beb46f_6c001f7d-cdfe-4e17-9105-2b089e1fed40.jpg",
                        "categoryId": "44107829"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Combo Meals for 3-4 (up to 31% off)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117820868",
                                "name": "All in One Chicken Bucket",
                                "category": "Combo Meals for 3-4 (up to 31% off)",
                                "description": "Save 21% with variety bucket of 1 Leg Pc, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml [Serves 2-3]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/514ac4ef-0ff9-4e78-b118-10ba644d54bb_5e50748c-fc45-4d11-be03-ace7d41abb10.jpg",
                                "inStock": 1,
                                "price": 57905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "68874452"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "125826873",
                                "name": "Ultimate Savings Chicken Bucket",
                                "category": "Combo Meals for 3-4 (up to 31% off)",
                                "description": "Savings of 35% on signature bucket of 4 Pc Legs, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/15/6d46d3fd-915a-4455-baa8-c7bfb9c8650e_7ddc5025-6401-4773-a1b6-491eb4d13c91.jpg",
                                "inStock": 1,
                                "price": 105381,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322480",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322486",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322488",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322492",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "43 ratings",
                                    "ratingCountV2": "43"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "68874457"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386665",
                                "name": "Stay Home Chicken Bucket",
                                "category": "Combo Meals for 3-4 (up to 31% off)",
                                "description": "Save Rs. 256 & enjoy 4pc Hot & Crispy Chicken, 4 Hot Wings, 6 chicken peri peri boneless strips & 2 delicious dips (20gm each) [serves 3]",
                                "imageId": "nku1xlhmmifu1hxoiugt",
                                "inStock": 1,
                                "price": 102524,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245973380",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973384",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973385",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245973388",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "63453081"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "95993051",
                                "name": "Big 12 - Chicken Bucket",
                                "category": "Combo Meals for 3-4 (up to 31% off)",
                                "description": "Save 26% on 6pc Hot & Crispy Chicken, 6 Hot Wings & 2 dips (20gm each) [serves 2- 3] ",
                                "imageId": "yqxxwbdxoaconjcyb7ka",
                                "inStock": 1,
                                "price": 99867,
                                "finalPrice": 79900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247023711",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023713",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023718",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247023728",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "offerIds": [
                                  "d2c6efc2-6f3b-4c72-918c-e4f9de5f917e"
                                ],
                                "parentId": "54462645"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386656",
                                "name": "Big 8 - Chicken Bucket",
                                "category": "Combo Meals for 3-4 (up to 31% off)",
                                "description": "2 Hot & Cripsy, 2 Strips + 4 Smoky Red.\n",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/26/9fa82389-a392-4a38-9f6d-1cb50fac5b4b_b721ddcf-4280-49cb-aa51-ee0958038647.jpg",
                                "price": 74857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322153",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322155",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322157",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322159",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "55324928"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/514ac4ef-0ff9-4e78-b118-10ba644d54bb_5e50748c-fc45-4d11-be03-ace7d41abb10.jpg",
                        "categoryId": "44107827"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Hot & Crispy Chicken & Wings",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386655",
                                "name": "Hot & Crispy Chicken - 8 pcs",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "8 pc signature Hot & cripsy chicken.",
                                "imageId": "uspplszjphtrwqn1alef",
                                "inStock": 1,
                                "price": 79905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322385",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322389",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322393",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322397",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462668"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386654",
                                "name": "Hot & Crispy Chicken -6pc",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "Flat 10% off on 6pc signature Hot & crispy chicken [serves 2-3]",
                                "imageId": "ygv0a2rzffhnfgbfajz4",
                                "inStock": 1,
                                "price": 63905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247323323",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323330",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323334",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247323340",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462667"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386614",
                                "name": "Hot & Crispy Chicken-4pc",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "Save Rs. 24 on 4 pc of signature Hot & Crispy Chicken at a deal price",
                                "imageId": "m7q813n17jh4nrhtt7ss",
                                "inStock": 1,
                                "price": 44857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322021",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322023",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322027",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322028",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "20 ratings",
                                    "ratingCountV2": "20"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "55324932"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386609",
                                "name": "Hot & Crispy Chicken -2pc",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "Signature Hot & crispy chicken",
                                "imageId": "n8ictcqllyfu5ojx3oci",
                                "inStock": 1,
                                "price": 21950,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283236",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283239",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283243",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283245",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "29 ratings",
                                    "ratingCountV2": "29"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "54462665"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386606",
                                "name": "Hot Chicken Wings - 4pc",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "Seasoned, signature KFC chicken wings",
                                "imageId": "ubpofq5tlhdgwh2lzo8d",
                                "inStock": 1,
                                "price": 18476,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728306",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728308",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728309",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728311",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "104 ratings",
                                    "ratingCountV2": "104"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462664"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386605",
                                "name": "Hot & Crispy Chicken-1pc",
                                "category": "Hot & Crispy Chicken & Wings",
                                "description": "Signature Hot & crispy chicken",
                                "imageId": "scl1wyh0yg3saadaakbk",
                                "inStock": 1,
                                "price": 11905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246421130",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421131",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421132",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246421133",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "28657428"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "uspplszjphtrwqn1alef",
                        "categoryId": "44107824"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Boneless Chicken Popcorn",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177136761",
                                "name": "Full House Popcorn Chicken Bucket",
                                "category": "Boneless Chicken Popcorn",
                                "description": "Shareable bucket perfect for your family feast or group hangouts [Serves 4-6]",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fbea5902-7c16-4adc-a223-032d0838eca6_6cf9f1d6-b7f2-42ab-9a56-31dc6f6daf6f.jpg",
                                "inStock": 1,
                                "price": 120000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106136692"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386612",
                                "name": "Chicken Popcorn - Large",
                                "category": "Boneless Chicken Popcorn",
                                "description": "Signature bite-sized boneless chicken, with special spices in Large Size",
                                "imageId": "xwunbsyx5mjosb47pgpi",
                                "inStock": 1,
                                "price": 24857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728524",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728529",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728533",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728536",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "47 ratings",
                                    "ratingCountV2": "47"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657120"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386611",
                                "name": "Chicken Popcorn - Medium",
                                "category": "Boneless Chicken Popcorn",
                                "description": "Signature bite-sized boneless chicken, with special spices in Medium Size",
                                "imageId": "vq4hhfaphd4fam2kieqq",
                                "inStock": 1,
                                "price": 19905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728205",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728206",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728213",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728217",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "113 ratings",
                                    "ratingCountV2": "113"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "54319289"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386610",
                                "name": "Chicken Popcorn - Regular",
                                "category": "Boneless Chicken Popcorn",
                                "description": "Signature bite-sized boneless chicken, with special spices",
                                "imageId": "xzzsjnmakrosu2i5qatn",
                                "inStock": 1,
                                "price": 12476,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "246420760",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420762",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420764",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "246420765",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "42 ratings",
                                    "ratingCountV2": "42"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "54462654"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/22/fbea5902-7c16-4adc-a223-032d0838eca6_6cf9f1d6-b7f2-42ab-9a56-31dc6f6daf6f.jpg",
                        "categoryId": "44107823"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Sides and Dips",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "99618560",
                                "name": "Peri Peri chicken strips - 3 pc",
                                "category": "Sides and Dips",
                                "description": "3 Pieces Spicy Peri Peri chicken boneless strips ",
                                "imageId": "fgtsqzqqxxtzxu0p0acw",
                                "inStock": 1,
                                "price": 17905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245399094",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399095",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399098",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245399101",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "64022827"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172142996",
                                "name": "Gold Edition Regular Fries",
                                "category": "Sides and Dips",
                                "description": "Enjoy our Regular Fries Dipped in Cheesy Sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/14/6aea8e43-f8d0-401b-80fe-b1c4971b79bc_65aa8eb0-9be8-476f-8b7c-86ae59de4bae.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "103405119"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386602",
                                "name": "2 pc Veg Patty",
                                "category": "Sides and Dips",
                                "description": "Delicious, crispy, veg add-on",
                                "imageId": "v9thnyukkkv47ifzmxfa",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15524,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28656814"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "95993013",
                                "name": "Spicy Mix French Fries - Large",
                                "category": "Sides and Dips",
                                "description": "Crispy french fries with a spicy chilli lime sprinkle",
                                "imageId": "c5c0c3tmnchhiqmizxsx",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "22 ratings",
                                    "ratingCountV2": "22"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "63453079"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386596",
                                "name": "French Fries - Large",
                                "category": "Sides and Dips",
                                "description": "Jazz up your meal with crispy large fries!",
                                "imageId": "r93ljtqjnlpn2xr24dln",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245283991",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283993",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283994",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245283996",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "50 ratings",
                                    "ratingCountV2": "50"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462659"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "95993012",
                                "name": "Spicy Mix French Fries - Medium",
                                "category": "Sides and Dips",
                                "description": "Crispy french fries with a spicy chilli lime sprinkle",
                                "imageId": "wrh1fdjs1uynfefykyok",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11429,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "63453080"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386595",
                                "name": "French Fries - Medium",
                                "category": "Sides and Dips",
                                "description": "Jazz up your meal with crispy french fries",
                                "imageId": "n4ry9mep4uisjri10uqp",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9905,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245109843",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245109846",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133639273",
                                        "name": "Veg Zinger Burger with Cheese",
                                        "price": 22381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133639271",
                                        "name": "Paneer Zinger Burger",
                                        "price": 21905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245109848",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245109852",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "30 ratings",
                                    "ratingCountV2": "30"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "54462660"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386598",
                                "name": "Pack of 4 Dips -20gm each",
                                "category": "Sides and Dips",
                                "description": "Adding dips is always a good idea! (Save Rs. 5)",
                                "imageId": "2a7a207a21279ef61087d021a97d8329",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10952,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "69286447"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386597",
                                "name": "Pack of 2 Dips-20gm each",
                                "category": "Sides and Dips",
                                "description": "Adding dips is always a good idea!",
                                "imageId": "yblqo1sys6x3sdszulqq",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "69286446"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386599",
                                "name": "Tandoori Flavour Dip - 20 gm",
                                "category": "Sides and Dips",
                                "description": "Special tandoori flavored dip, to add a twist to your meal!",
                                "imageId": "icpcqoet1ssvzkvd4g3m",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "46 ratings",
                                    "ratingCountV2": "46"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79430641"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "fgtsqzqqxxtzxu0p0acw",
                        "categoryId": "44107821"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Desserts",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182301844",
                                "name": "Kfc X Snickers Choco Mousse Cake",
                                "category": "Desserts",
                                "description": "Layers of smooth, gooey, nutty, chocolatey delight - with a Snickers twist.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/f078db6a-27c3-4738-a74e-2097fc6a710f_2f7120b2-49a3-44ed-9726-f14e32addc01.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13900,
                                "finalPrice": 7000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "50% OFF",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "CouponlessSild",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "offerIds": [
                                  "8183b781-e892-4320-968f-389c67bf18f4"
                                ],
                                "parentId": "109740418"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190185295",
                                "name": "Choco Lava Cake",
                                "category": "Desserts",
                                "description": "Chocolate lovers unite! Say hello to our chocolate & cake dessert- a must try! ",
                                "imageId": "d7e156f4831f451253174db52e8a8dcd",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11905,
                                "finalPrice": 7900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "4164bd4b-14b2-4966-8976-caedca99cab3"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "79430639"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386601",
                                "name": "Choco Mud Pie",
                                "category": "Desserts",
                                "description": "Chocolate lovers unite! Say hello to our delicious, new, creamy chocolate & cake dessert- a must try! ",
                                "imageId": "fhtrvjerl7l2ck1crwhp",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28657230"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386600",
                                "name": "Mousse Cake (Coffee flavoured",
                                "category": "Desserts",
                                "description": "Coffee, chocolate, cake?what's not to love? Enjoy our delicious, new dessert for those coffee-licious temptations!",
                                "imageId": "cb0kmlqdl0kjiri0qii9",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13905,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79430640"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/1/f078db6a-27c3-4738-a74e-2097fc6a710f_2f7120b2-49a3-44ed-9726-f14e32addc01.jpg",
                        "categoryId": "70195126"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Beverage",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818798",
                                "name": "Virgin Mojito Reusable Bottle",
                                "category": "Beverage",
                                "description": "A refreshing drink with lime and soda to beat the heat",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/2c400914-f9a8-4364-95dc-39237e57ec58_b1ec722a-e668-4c17-8cc2-63727089a771.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89167241"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818797",
                                "name": "Masala Pepsi Reusable Bottle",
                                "category": "Beverage",
                                "description": "A spicy kick to everyone's favourite drink",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/919f5e98-659d-4dd6-9382-8f0fce0dbda3_e7ae77a6-cab4-4ca1-8ed8-8a19a7ebd742.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89263206"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818796",
                                "name": "Masala Mirinda Reusable Bottle",
                                "category": "Beverage",
                                "description": "A refreshing drink with Mirinda, masala lime and soda to beat the heat",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/deab65cb-ee05-447f-8f08-96ad0938bf92_e1eba102-531b-4114-83b9-9f46bcc5d267.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89263205"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818795",
                                "name": "Dew Mojito Reusable Bottle",
                                "category": "Beverage",
                                "description": "A refreshing drink with Mountain Dew, lime and soda to beat the heat",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/10/fa3a765b-0e7c-44ca-a7d6-9cf0711be53e_f28a7824-699d-4fa1-936a-7170e9c7ee4d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "89263204"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818794",
                                "name": "Pepsi Reusable Bottle",
                                "category": "Beverage",
                                "description": "Pepsi in a KFC reusable bottle",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/1af9ccc6-d64b-4345-86bf-a030427e5149_ee0c4915-6627-40ef-a2ce-9628d08f579d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10857,
                                "finalPrice": 7900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "4164bd4b-14b2-4966-8976-caedca99cab3"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "89167240"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818793",
                                "name": "7Up Reusable Bottle",
                                "category": "Beverage",
                                "description": "7Up in a KFC reusable bottle",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/20/f35c1655-ccc4-4eb9-9d14-0d3f7c36fa15_3976941b-923f-4f19-b381-6067c8e285e2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89263201"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818792",
                                "name": "Mirinda Reusable Bottle",
                                "category": "Beverage",
                                "description": "Mirinda in a KFC reusable bottle",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/14b5bbb5-ca27-4fac-abe3-004d94c7a319_75b050f5-1643-4b0e-86dc-0dcd4c8a7899.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89263207"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818791",
                                "name": "Mountain Dew Reusable Bottle",
                                "category": "Beverage",
                                "description": "Mountain Dew in a KFC reusable bottle",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/14571d11-acd1-4670-abdb-1944d220c4a4_a4ce2314-81e3-48af-adf4-72f0efb0a33c.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "89263209"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386594",
                                "name": "Pepsi PET 475ml",
                                "category": "Beverage",
                                "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/7/dc23843d-5fdc-4f94-a852-ab140ee2ec96_c68da80e-4ffa-4901-a6e6-13b2284de59c.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "30 ratings",
                                    "ratingCountV2": "30"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "64113501"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120467506",
                                "name": "Pepsi Can 330 ml",
                                "category": "Beverage",
                                "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/12/90a37264-cc9f-4a0e-ae02-e7a6cbcbae4e_9e4a6c10-13b0-4271-a2e5-5415fd924c15.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 6667,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28657663"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120467507",
                                "name": "7UP Can 330 ml",
                                "category": "Beverage",
                                "description": "7UP is the ultimate Super-Duper Refresher. Every sip of this crisp lemon flavour refreshes you to the core.",
                                "imageId": "wb1pfru0qksmt131h5uu",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 6667,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28656909"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120467508",
                                "name": "Pepsi Black Can 330 ml",
                                "category": "Beverage",
                                "description": "Enjoy Pepsi Black to make your food rise up to max levels of awesome with Zero sugar and Zero guilt!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/15/e55c98fd-63b1-465d-ac8f-cbddff020c17_62384ee0-1c37-4fbd-9f6a-b5f350567cda.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 6667,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                  }
                                ],
                                "parentId": "28657661"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120467509",
                                "name": "Mirinda Can 330 ml",
                                "category": "Beverage",
                                "description": "Great orange taste and sparking bubbles encourage you to be carefree, spontaneous and playful!",
                                "imageId": "hoxyuosfrlevghoho7u9",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 6667,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28657540"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "165418541",
                                "name": "Pepsi 475ml Pet",
                                "category": "Beverage",
                                "description": "0",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/7/dc23843d-5fdc-4f94-a852-ab140ee2ec96_c68da80e-4ffa-4901-a6e6-13b2284de59c.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 5714,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "99342872"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/2c400914-f9a8-4364-95dc-39237e57ec58_b1ec722a-e668-4c17-8cc2-63727089a771.jpg",
                        "categoryId": "70195125"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Grilled Chicken",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159818800",
                                "name": "5 Pc Smoky Chicken Mojito Combo",
                                "category": "Grilled Chicken",
                                "description": "Get All New Mojito Reusable Bottle with 5 Pc Smoky Red Grilled Chicken",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/5821392c-8d91-4783-b2c0-d137f328ae51_0523173e-da76-419b-b2e3-ee35a91b1921.jpg",
                                "price": 62766,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321821",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321823",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321827",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321830",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80357455"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386652",
                                "name": "Smoky Red Grilled Chicken - 5 pc",
                                "category": "Grilled Chicken",
                                "description": "Grab 5 pc Smoky Red Chicken - grilled to perfection\n",
                                "imageId": "ewi33xnqju9f6ezzwhbk",
                                "price": 54857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247322537",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322541",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322546",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247322548",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "27 ratings",
                                    "ratingCountV2": "27"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "56426960"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386608",
                                "name": "Smoky Red Grilled Chicken - 2 pc",
                                "category": "Grilled Chicken",
                                "description": "Spicy, red, grilled chicken",
                                "imageId": "e2gbhuf1hprednohf5yt",
                                "price": 24857,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "247321175",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321178",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321184",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "247321187",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "34 ratings",
                                    "ratingCountV2": "34"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "63453078"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89386604",
                                "name": "Smoky Red Grilled Chicken - 1 pc",
                                "category": "Grilled Chicken",
                                "description": "Spicy, red, grilled chicken",
                                "imageId": "wfmeqvdcmqmv1wpshbqh",
                                "price": 12476,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "245728685",
                                    "groupName": "Choose your Sides",
                                    "choices": [
                                      {
                                        "id": "110259763",
                                        "name": "Chicken Popcorn - Regular",
                                        "price": 12476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259762",
                                        "name": "Chicken Popcorn - Medium",
                                        "price": 19905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259772",
                                        "name": "Tandoori Flavour Dip - 20 gm",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259771",
                                        "name": "French Fries - Medium",
                                        "price": 9905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259773",
                                        "name": "French Fries - Large",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139888250",
                                        "name": "Gold Edition Regular Fries",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728687",
                                    "groupName": "Choose your Snacks",
                                    "choices": [
                                      {
                                        "id": "133593389",
                                        "name": "Indian Tandoori Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593391",
                                        "name": "Spicy Zinger Burger",
                                        "price": 22952,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593397",
                                        "name": "Chicken Zinger Burger - Classic",
                                        "price": 20857,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593392",
                                        "name": "Thai Spicy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593390",
                                        "name": "Korean Tangy Chicken Roll",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259775",
                                        "name": "Classic Chicken Roll",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "132578523",
                                        "name": "Peri Peri chicken strips - 3 pc",
                                        "price": 17905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259764",
                                        "name": "Hot Chicken Wings - 4pc",
                                        "price": 18476,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259768",
                                        "name": "Hot & Crispy Chicken-1pc",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728689",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "133555930",
                                        "name": "Dew Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593387",
                                        "name": "Masala Mirinda Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593396",
                                        "name": "Masala Pepsi Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "133593395",
                                        "name": "Virgin Mojito Reusable Bottle",
                                        "price": 10857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "110259760",
                                        "name": "Pepsi PET 475ml",
                                        "price": 5714,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "245728691",
                                    "groupName": "Choose your Desserts",
                                    "choices": [
                                      {
                                        "id": "110259776",
                                        "name": "Choco Mud Pie",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136070",
                                        "name": "Mousse Cake (Coffee flavoured",
                                        "price": 13905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "143136069",
                                        "name": "Choco Lava Cake",
                                        "price": 11905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139862734",
                                        "name": "Kfc X Snickers Choco Mousse Cake",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "nextAvailableAtMessage": "Next available at 11 am, today",
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "28 ratings",
                                    "ratingCountV2": "28"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "56426958"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/10/19/5821392c-8d91-4783-b2c0-d137f328ae51_0523173e-da76-419b-b2e3-ee35a91b1921.jpg",
                        "categoryId": "66491375"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11422010000219"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "KFC",
                        "area": "Kohefiza",
                        "completeAddress": "KFC Kohefiza (Sapphire foods India Ltd) Shop/Unit No. A8, Ground floor, Housing board colony, Kohefiza, Main road, Bhopal (M.P) 462001."
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "C3c8OkoXgDTL-BeMD8j8Ru4pHX3qXtyQCGhA3q5c"
  },

  "697182": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Burger King",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                },
                {
                  "id": "Dineout",
                  "title": "Dineout",
                  "cta": "https://swiggy.com/menu/84400/dineout"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "84400",
                "name": "Burger King",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "burger-king-db-city-mall-mp-nagar",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/18/7c067f62-8938-4abb-8937-272b77002c29_84400.jpg",
                "locality": "Maharana Pratap Nagar",
                "areaName": "Db City Mall",
                "costForTwo": "35000",
                "costForTwoMessage": "₹350 for two",
                "cuisines": ["Burgers", "American"],
                "avgRating": 4.2,
                "feeDetails": {
                  "restaurantId": "84400",
                  "fees": [{}]
                },
                "parentId": "166",
                "avgRatingString": "4.2",
                "totalRatingsString": "26K+ ratings",
                "sla": {
                  "restaurantId": "84400",
                  "deliveryTime": 50,
                  "minDeliveryTime": 50,
                  "maxDeliveryTime": 60,
                  "lastMileTravel": 4.9,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 698,
                  "slaString": "50-60 MINS",
                  "lastMileTravelString": "4.9 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2026-01-06 03:00:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "_",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 59",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "70% off| Use ENDOFYEARSALE",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 59",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "70% off up to ₹125 | Use ENDOFYEARSALE",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "burger-king-db-city-mall-mp-nagar",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Fs 11 & 12 Food Court, Third Floor Db City Mall,Opp. M.P. Nagar ,Zone-1 Arera Hills,Bhopal (M.P.) Pin Code-462011"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Burgers,American"
                  }
                ],
                "totalRatings": 26000,
                "aggregatedDiscountInfoV2": {
                  "header": "_",
                  "shortDescriptionList": [
                    {
                      "meta": "Get items under 59",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "70% off| Use ENDOFYEARSALE",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Get items under 59",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "70% off up to ₹125 | Use ENDOFYEARSALE",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "priority": 13,
                    "discountInfo": {
                      "discountType": "FinalPrice",
                      "value": 399
                    },
                    "unlockedMessage": "Deal of the Day unlocked!",
                    "minItemCount": 1,
                    "maxItemCount": 1,
                    "type": "SILD",
                    "nudgeTagInfo": {
                      "title": "Deal of the Day",
                      "fontName": "FONT_NAME_CONDENSED_BOLD"
                    },
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/84400"
                },
                "generalPurposeInfoListV2": [
                  {
                    "cta": {
                      "info": {
                        "recordings": {}
                      },
                      "linkCta": {}
                    }
                  }
                ],
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {},
                  "subTitle": {},
                  "message": {},
                  "customIcon": {},
                  "commsStyling": {}
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.23338771,77.4301044",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {},
                "requestContexts": ["enable_ecosaver", "99store"]
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "ITEMS AT ₹59",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["83c0d13c-9986-4725-af91-ce90d308f4a7"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "84400",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "70% OFF UPTO ₹125",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["562bd1d1-d110-432d-9bd2-335da6f6a751"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE ENDOFYEARSALE",
                        "description": "ABOVE ₹175",
                        "offerType": "offers",
                        "restId": "84400",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE ENDOFYEARSALE"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹75 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["656e05de-a26d-4731-8243-e002f148db3b"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT75",
                        "description": "ABOVE ₹199",
                        "offerType": "offers",
                        "restId": "84400",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT75"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹300 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["b3e5d804-19eb-4801-91a6-6869996a9a62"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT300",
                        "description": "ABOVE ₹999",
                        "offerType": "offers",
                        "restId": "84400",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT300"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT 20% OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["e88c6ba3-ae60-40a0-93c9-9f75801ffe4f"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE XTRAPARTY",
                        "description": "ABOVE ₹1999",
                        "offerType": "offers",
                        "restId": "84400",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE XTRAPARTY"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                        "title": "Top Picks",
                        "carousel": [
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7500612",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Crispy Veg Burger Peri Peri Meal (R)",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "186880381",
                                "name": "Crispy Veg Burger Peri Peri Meal (R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Crispy Veg Burger+Peri Peri Fries( R)+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e0ca39c1-9ba4-4444-b0a4-aba37764620f_f238679e-1f8f-4b4f-8299-e767f9e24fb9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 28357,
                                "finalPrice": 14100,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450366",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 28357,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "804ef7d3-dfd8-4a4c-bf65-fe4b4d855df1"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "105284773"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7503186",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Crispy Chicken Burger Peri Peri Meal (R)",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "166233416",
                                "name": "Crispy Chicken Burger Peri Peri Meal (R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Crispy Chicken Burger+Peri Peri Fries( R)+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/62d2a821-d442-4204-9800-fc1a79c7627c_b39ac354-cb40-4115-aa49-e35e74793f0b.jpg",
                                "inStock": 1,
                                "price": 31257,
                                "finalPrice": 15600,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450365",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 31257,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "7ddbe424-6111-41a7-b169-3c9be1f80d71"
                                ],
                                "parentId": "100153256"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7500853",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "2BK Veggie Burger +2Peri Peri Fries(R)",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "186880382",
                                "name": "2BK Veggie Burger +2Peri Peri Fries(R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "2BK Veggie+2Peri Peri Fries( R)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/cff7cf49-a98c-443e-ab2e-a1ecb3953ad2_cba1b763-c241-4ca9-ac6c-f69e23e3d427.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 51514,
                                "finalPrice": 25700,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450367",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 51514,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f8f11c7a-97c0-4073-9ddc-b92a08b47627"
                                ],
                                "parentId": "105284772"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7504084",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Veg Whopper Deluxe Med Meal,",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "154974898",
                                "name": "Veg Whopper Deluxe Med Meal,",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces. Served with Fries and Coke\nQty: 759 gms| Kcal: 1014 | Carbs: 142 gms| Sugar: 58 gms| Fat: 41 gms| Saturated fat: 16 gms| Protein: 17 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b5c6a2d6-ffaa-4859-9349-c6f83122ec99_b5614192-bbc5-4dec-a3d0-4691946f825f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 36300,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620723",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36300,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503555"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7501277",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Classic Meal Deal for 2",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "182689438",
                                "name": "Classic Meal Deal for 2",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "2 BK Veggie+Fries( M )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/c7c8a6dc-fd8e-4124-bf72-66529d3c066d_c28c96d9-429a-466a-83d7-5f2678101192.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 49200,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630797",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248818217",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630800",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630801",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630803",
                                    "groupName": "Selected 2nd - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "139664013",
                                        "name": "Selected 2nd - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 49200,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110920018"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7503351",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "New Whopper Deluxe Doubles( Any 2 )",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "182604777",
                                "name": "New Whopper Deluxe Doubles( Any 2 )",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 2 from New Whopper Deluxe Range",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/17cea866-6c94-45e5-9062-700bf994d0d9_716203d1-a4ad-453a-8d30-4dee70fce9f5.jpg",
                                "inStock": 1,
                                "price": 39800,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243446576",
                                    "groupName": "Choose Your 1st Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "139664030",
                                        "name": "Molten Cheese Lava Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664035",
                                        "name": "Crunchy Soft Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664034",
                                        "name": "Flame Grilled Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243446577",
                                    "groupName": "Choose Your 2nd Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "139664031",
                                        "name": "Crunchy Soft Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664033",
                                        "name": "Molten Cheese Lava Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664032",
                                        "name": "Flame Grilled Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818205",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39800,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110910458"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7504129",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Kings Meal ( R )- Veg",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "182689444",
                                "name": "Kings Meal ( R )- Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 1 from your New Premium Burger Range+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/d295fd53-77cd-4f1d-976f-19015c4ac6b9_cc43377c-6162-4c2b-9d1c-1f80aece4269.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 48400,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630817",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818212",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630821",
                                    "groupName": "Choose Any 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664010",
                                        "name": "Paneer Royale Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664011",
                                        "name": "Hot 'N' Cheesy Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664020",
                                        "name": "Paneer Royale Wrap",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664021",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630819",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 48400,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110920019"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7501813",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Kings Meal ( R )- Non Veg",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "182689445",
                                "name": "Kings Meal ( R )- Non Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 1 from your New Premium Burger Range+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/7ee5ab69-1764-4223-a84b-6dfb656832bc_9a4e80cb-e228-47e4-a16b-7a1485e11fa7.jpg",
                                "inStock": 1,
                                "price": 48400,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630823",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630825",
                                    "groupName": "Choose 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664019",
                                        "name": "Fiery Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664018",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664017",
                                        "name": "Crunchy Chicken Wrap",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664016",
                                        "name": "Chicken Tandoori Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818218",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630824",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 48400,
                                "ribbon": {},
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110910457"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62374384",
                                "name": "Original Whopper Veg(XL size Bun)",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "Our Original Whopper with Crunchy Veg Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 285 Gms| Kcal: 681.2 | Carbs 97.1 Gms| Sugar: 23.1 Gms| Fat: 25.4 Gms| Saturated fat: 9.8 Gms| Protein: 15.8 Gms| Sodium: 987.8 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/dc90cc06-f883-430d-be4b-75141c8064d9_6b832721-694c-4df4-96f0-308388144da0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619245",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619248",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619250",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619251",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619255",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619257",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "34 ratings",
                                    "ratingCountV2": "34"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106315745"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62374376",
                                "name": "Original Whopper Chicken(XL size Bun)",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "Our Original Whopper with Flame Grilled Chicken Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 280 Gms| Kcal: 667.2 | Carbs 59.1 Gms| Sugar: 8.7 Gms| Fat: 36.3 Gms| Saturated fat: 8.1 Gms| Protein: 26.2 Gms| Sodium: 1018.7 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/523da59d-365f-47bc-bb93-5583508104e9_c9077a2b-eab2-4acf-85f0-d7a357c4757a.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619277",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619278",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619282",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619288",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619292",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619293",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106278675"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101189812",
                                "name": "Crispy Veg Burger",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "Our Best Seller - New Premium Black & White Sesame Bun with Crispy Veg Patty, Fresh Onion and Signature Sauce.\nQty: 137 Gms| Kcal: 362 | Carbs 53.4 Gms| Sugar: 6.5 Gms| Fat: 12.8 Gms| Saturated fat: 4.9 Gms| Protein: 8.4 Gms| Sodium: 798.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4389cb8d-93e5-4dd5-8013-73a927dd6b31_622133db-f6cc-4f88-ba37-118df0b143ce.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 7000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619379",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619384",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619387",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619389",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619390",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619393",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 7000,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "4038 ratings",
                                    "ratingCountV2": "4.0K+"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379122"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "102670992",
                                "name": "Crispy Chicken Burger",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Signature Sauce.\nQty: 125 Gms| Kcal: 359.1 | Carbs 44.3 Gms| Sugar: 7.5 Gms| Fat: 15.1 Gms| Saturated fat: 4.8 Gms| Protein: 11.5 Gms| Sodium: 592.4 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2ea3296b-2776-42b2-b3f7-ba17b0fbd43c_363816e0-8fbb-4fb6-8dbb-12d55d80b954.jpg",
                                "inStock": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619426",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619432",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619435",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619437",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619438",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619444",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "1767 ratings",
                                    "ratingCountV2": "1.8K+"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379085"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101189815",
                                "name": "Crispy Veg Double Patty Burger",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "Double up our best selling crispy veg burger, now with new Premium Black & White Sesame Bun\nQty: 204 Gms| Kcal: 531.4 | Carbs 70.6 Gms| Sugar: 9.1 Gms| Fat: 22.7 Gms| Saturated fat: 9.2 Gms| Protein: 11.2 Gms| Sodium: 1068 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5965c1c3-c079-41d7-a35e-5394b0822f6d_cb654bd9-dccd-4493-85a0-dc6cf1007653.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619540",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619544",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619548",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619551",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619554",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619555",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "1098 ratings",
                                    "ratingCountV2": "1.1K+"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379133"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "102670994",
                                "name": "Crispy Chicken Double Patty Burger",
                                "category": "Burgers, Wraps & Tacos",
                                "description": "Our best-selling burger with Double crispy chicken patty, onion, classic mayo sauce and new premium Black & White Sesame Bun.\nQty: 182 Gms| Kcal: 535.1 | Carbs 52.7 Gms| Sugar: 10.2 Gms| Fat: 28.3 Gms| Saturated fat: 10.4 Gms| Protein: 17.4 Gms| Sodium: 887.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/f00d2a08-be31-43b9-b613-3db884e1fbec_2e7229bb-29bc-41e8-aac3-4cef642aab62.jpg",
                                "inStock": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619589",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619594",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619598",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619602",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619603",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619606",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 13900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "495 ratings",
                                    "ratingCountV2": "495"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379094"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101189924",
                                "name": "King Fries",
                                "category": "Sides & Snacks",
                                "description": "The Perfect Crispy Partner \nQty: 156 Gms| Kcal: 455 | Carbs 609.48 Gms| Sugar: 0 Gms| Fat: 19.7 Gms| Saturated fat: 9.31 Gms| Protein: 8 Gms| Sodium: 723.7 Mg \nContains: Gluten",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fefae94a-53cd-421c-9f1f-d0f642949728_2ddc8be1-0a65-430d-9de8-542fae4ce739.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620152",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620156",
                                    "groupName": "Add Peri Peri Spice Mix",
                                    "choices": [
                                      {
                                        "id": "138686357",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "409 ratings",
                                    "ratingCountV2": "409"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379448"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "101189923",
                                "name": "Medium Fries",
                                "category": "Sides & Snacks",
                                "description": "The Perfect Crispy Partner.\nQty: 114 Gms| Kcal: 332.5 | Carbs 445.39 Gms| Sugar: 0 Gms| Fat: 14.4 Gms| Saturated fat: 6.8 Gms| Protein: 5.9 Gms| Sodium: 528.8 Mg \nContains: Gluten",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fefae94a-53cd-421c-9f1f-d0f642949728_2ddc8be1-0a65-430d-9de8-542fae4ce739.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "257 ratings",
                                    "ratingCountV2": "257"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "73863568",
                                "name": "King Peri Peri Fries",
                                "category": "Sides & Snacks",
                                "description": "Crispy Fries With Tangy Peri Peri Spice.  \nQty: 161 Gms| Kcal: 467.8 | Carbs 611.7 Gms| Sugar: 0.9 Gms| Fat: 20 Gms| Saturated fat: 9.3 Gms| Protein: 8.4 Gms| Sodium: 1193.7 Mg \nContains: Gluten, Soybean",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/fa747205-3c4d-497c-a948-65f3c224a4cf_11129959-8182-4b8c-bbb5-db49665fba19.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620236",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 15900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "108 ratings",
                                    "ratingCountV2": "108"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379450"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "25407601",
                                "name": "Chocolate Thick Shake",
                                "category": "BK Café (Coffee & Shakes)",
                                "description": "Qty:  Gms300 ML| Kcal: 496.08 | Carbs 87.69 Gms| Sugar: 61.44 Gms| Fat: 11.28 Gms| Saturated fat: 7.17 Gms| Protein: 10.95 Gms| Sodium: 10.68 Mg \nContains: , Soybean , Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/cddbd1f0-c2fc-4af3-a108-b482cc0027e2_0564277b-594b-4aa9-a7cd-6796803092fc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "333 ratings",
                                    "ratingCountV2": "333"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379036"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120716600",
                                "name": "Crispy Veg Double Patty Burger+Fries(M)",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Crispy Veg Double Patty Burger+Fries(M) \nQty: 318 Gms| Kcal: 863.9 | Carbs 516 Gms| Sugar: 9.1 Gms| Fat: 37.1 Gms| Saturated fat: 16 Gms| Protein: 17.1 Gms| Sodium: 1596.8 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ca680cf-d5f0-41eb-ab25-d06762871215_cdbfe4dc-ddaf-4bb3-b2db-2156bfcb81c2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "69198429"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "178512871",
                                "name": "Classic Family Feast for 4 - Veg",
                                "category": "Party Specials (Save upto 37%)",
                                "description": "2 Crispy Veg + BK Veggie + Veg Crunchy Taco + 2 Med Fries + 2 Dips + Coca Cola Medium + Chocolate Thick Shake;\nServes 4 or More\n\nKcal: 2926.9 | Carbs 332.3 Gms| Sugar: 145 Gms| Fat: 114.9 Gms| Saturated fat: 51.7 Gms| Protein: 55.8 Gms| Sodium: 4274 Mg Contains: Gluten, Soybean , Milk , Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/9031fc39-d347-4618-9c99-f5b607e13bbd_672d66bc-f7b2-4509-a254-696279b960dc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "66072496"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "77041544",
                                "name": "4 Crispy Veg + 2 Medium Fries",
                                "category": "Friends & Family Combo (Save upto 20%)",
                                "description": "4 Crispy Veg + 2 Medium Fries \nQty: 728 Gms| Kcal: 2101.2 | Carbs 1068.1 Gms| Sugar: 29.9 Gms| Fat: 89.2 Gms| Saturated fat: 32.7 Gms| Protein: 57.6 Gms| Sodium: 3427.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/42495fcf-8f3f-425c-a1e2-8d8c2cec0e45_6c1ec2ef-34b7-4f93-a422-52c63bc5ace6.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 40000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 40000,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "72 ratings",
                                    "ratingCountV2": "72"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10378395"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62104384",
                                "name": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                                "category": "Friends & Family Combo (Save upto 20%)",
                                "description": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ef18e36-f988-4b85-8fa2-75e1fa72406a_86684d36-3c2d-471a-a9cc-082870edc314.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19800,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "943 ratings",
                                    "ratingCountV2": "943"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "10379134"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "67949062",
                                "name": "Veg Whopper Deluxe + Veg Makhani Burst",
                                "category": "Friends & Family Combo (Save upto 20%)",
                                "description": "Veg Whopper Deluxe + Veg Makhani Burst",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/240052e5-aa74-4fca-a76e-e44dda2fed37_6e6f3974-41fe-4e04-a741-c1c82ae7d812.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503557"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED",
                        "subtitleSuffix": {},
                        "categoryId": "-1"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "NEW BK Fusion (Made with KitKat)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019636",
                                "name": "BK Fusion Shake (made with Kit Kat).",
                                "category": "NEW BK Fusion (Made with KitKat)",
                                "description": "Made with Kit Kat, enjoy our rich creamy fusion thick shake.\nQty: 378 gms| Kcal: 703 | Carbs: 119 gms| Sugar: 71 gms| Fat: 19 gms| Saturated fat: 14 gms| Protein: 15 gms.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/c2f29287-024d-459a-b976-ab79f0999c4c_a73a5a21-c43e-4597-beb4-300e348520b8.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396593",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686349",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686240",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686243",
                                        "name": "4 Pc Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219627",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686242",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686244",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219628",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686246",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686224",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686392",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "106949913"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019637",
                                "name": "BK Fusion Sundae  (made with Kit Kat).",
                                "category": "NEW BK Fusion (Made with KitKat)",
                                "description": "Made with Kit Kat, enjoy our rich creamy fusion sundae.\nQty: 128 gms| Kcal: 327 | Carbs: 49 gms| Sugar: 32 gms| Fat: 12 gms| Saturated fat: 10 gms| Protein: 6 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/a645e88a-c645-4526-a2ad-ba7efcbf8fbd_60a3bced-21d8-47fd-a179-75487aece375.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396596",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "106949914"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019638",
                                "name": "BK Fusion Shake (made with KitKat)",
                                "category": "NEW BK Fusion (Made with KitKat)",
                                "description": "Made with Kit Kat, enjoy our rich creamy fusion thick shake.\nQty: 378 gms| Kcal: 703 | Carbs: 119 gms| Sugar: 71 gms| Fat: 19 gms| Saturated fat: 14 gms| Protein: 15 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/c2f29287-024d-459a-b976-ab79f0999c4c_a73a5a21-c43e-4597-beb4-300e348520b8.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396603",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106949913"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019639",
                                "name": "BK Fusion Sundae  (made with KitKat)",
                                "category": "NEW BK Fusion (Made with KitKat)",
                                "description": "Made with Kit Kat, enjoy our rich creamy fusion sundae.\nQty: 128 gms| Kcal: 327 | Carbs: 49 gms| Sugar: 32 gms| Fat: 12 gms| Saturated fat: 10 gms| Protein: 6 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/a645e88a-c645-4526-a2ad-ba7efcbf8fbd_60a3bced-21d8-47fd-a179-75487aece375.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396604",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106949914"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019640",
                                "name": "2 BK Fusion Sundae (made with Kit Kat).",
                                "category": "NEW BK Fusion (Made with KitKat)",
                                "description": "2 X Made with Kit Kat, enjoy our rich creamy fusion thick sundae\nQty: 256 gms| Kcal: 654 | Carbs: 97 gms| Sugar: 64 gms| Fat: 24 gms| Saturated fat: 19 gms| Protein: 13 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/df0bd65b-6ae0-4212-b371-5938a48e0753_3fd5b7a3-c52e-466d-b682-c20f5a539ef7.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25800,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396611",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "106949912"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/c2f29287-024d-459a-b976-ab79f0999c4c_a73a5a21-c43e-4597-beb4-300e348520b8.png",
                        "categoryId": "65040132"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Festive Specials( Save upto 39%)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689438",
                                "name": "Classic Meal Deal for 2",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "2 BK Veggie+Fries( M )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/c7c8a6dc-fd8e-4124-bf72-66529d3c066d_c28c96d9-429a-466a-83d7-5f2678101192.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 49200,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630797",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "248818217",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630800",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630801",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630803",
                                    "groupName": "Selected 2nd - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "139664013",
                                        "name": "Selected 2nd - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 49200,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110920018"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182604777",
                                "name": "New Whopper Deluxe Doubles( Any 2 )",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 2 from New Whopper Deluxe Range",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/17cea866-6c94-45e5-9062-700bf994d0d9_716203d1-a4ad-453a-8d30-4dee70fce9f5.jpg",
                                "inStock": 1,
                                "price": 39800,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243446576",
                                    "groupName": "Choose Your 1st Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "139664030",
                                        "name": "Molten Cheese Lava Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664035",
                                        "name": "Crunchy Soft Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664034",
                                        "name": "Flame Grilled Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243446577",
                                    "groupName": "Choose Your 2nd Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "139664031",
                                        "name": "Crunchy Soft Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664033",
                                        "name": "Molten Cheese Lava Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664032",
                                        "name": "Flame Grilled Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818205",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110910458"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689440",
                                "name": "New Whopper Deluxe Meal Deal ( R )- Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose your New Whopper Deluxe+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/41e71089-036f-4e7b-af51-6713ecbf3fe3_b47b6e78-7683-4e9d-bb23-cd61333d4810.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 38400,
                                "finalPrice": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630806",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818215",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630809",
                                    "groupName": "Choose Your  Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "139664014",
                                        "name": "Molten Cheese Lava Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664015",
                                        "name": "Crunchy Soft Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630807",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 38400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "962d58e1-1519-4410-99b8-4b80bc879370"
                                ],
                                "parentId": "110920021"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689442",
                                "name": "New Whopper Deluxe Meal Deal ( R )- Non Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose your New Whopper Deluxe+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/08f9b880-334f-4d47-b847-dcd7749f4b56_c8d03deb-4d74-404f-b381-903d71d02a99.jpg",
                                "inStock": 1,
                                "price": 38400,
                                "finalPrice": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630811",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818210",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630815",
                                    "groupName": "Choose Your  Whopper Deluxe.",
                                    "choices": [
                                      {
                                        "id": "139664009",
                                        "name": "Smokey Crunchy Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664012",
                                        "name": "Flame Grilled Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630813",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 38400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "962d58e1-1519-4410-99b8-4b80bc879370"
                                ],
                                "parentId": "110920020"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689444",
                                "name": "Kings Meal ( R )- Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 1 from your New Premium Burger Range+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/d295fd53-77cd-4f1d-976f-19015c4ac6b9_cc43377c-6162-4c2b-9d1c-1f80aece4269.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 48400,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630817",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818212",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630821",
                                    "groupName": "Choose Any 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664010",
                                        "name": "Paneer Royale Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664011",
                                        "name": "Hot 'N' Cheesy Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664020",
                                        "name": "Paneer Royale Wrap",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664021",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630819",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 48400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110920019"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689445",
                                "name": "Kings Meal ( R )- Non Veg",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 1 from your New Premium Burger Range+Fries( R )+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/20/7ee5ab69-1764-4223-a84b-6dfb656832bc_9a4e80cb-e228-47e4-a16b-7a1485e11fa7.jpg",
                                "inStock": 1,
                                "price": 48400,
                                "finalPrice": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630823",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630825",
                                    "groupName": "Choose 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664019",
                                        "name": "Fiery Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664018",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664017",
                                        "name": "Crunchy Chicken Wrap",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664016",
                                        "name": "Chicken Tandoori Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818218",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630824",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 48400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "de4f645d-edd7-482b-94e0-f85821708901"
                                ],
                                "parentId": "110910457"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689446",
                                "name": "Kings Premium Doubles- Veg ( Any 2 )",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 2 from New Premium Range",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/21/ebfc61cc-052a-48fd-a6d6-36517bc70afc_0a2661cf-6401-409c-a208-812d6fb4313f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 59800,
                                "finalPrice": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630831",
                                    "groupName": "Choose Any 1 from your New Premium Burger Range.",
                                    "choices": [
                                      {
                                        "id": "139664023",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664024",
                                        "name": "Paneer Royale Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664025",
                                        "name": "Hot 'N' Cheesy Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664022",
                                        "name": "Paneer Royale Wrap",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818213",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "243630830",
                                    "groupName": "Choose Any 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664010",
                                        "name": "Paneer Royale Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664011",
                                        "name": "Hot 'N' Cheesy Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664020",
                                        "name": "Paneer Royale Wrap",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664021",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 59800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "24479a7d-6374-482e-afd1-f93b0ab6be38"
                                ],
                                "parentId": "110966775"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "182689447",
                                "name": "Kings Premium Doubles- Non Veg ( Any 2 )",
                                "category": "Festive Specials( Save upto 39%)",
                                "description": "Choose Any 2 from New Premium Range",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/21/a7c97b78-a998-4f9e-bac5-60032fe9d38a_3b7d4ca5-45ef-4135-8a37-e3dcd8c737b0.jpg",
                                "inStock": 1,
                                "price": 59800,
                                "finalPrice": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "243630834",
                                    "groupName": "Choose 1 from your New Premium Burger Range",
                                    "choices": [
                                      {
                                        "id": "139664019",
                                        "name": "Fiery Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664018",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664017",
                                        "name": "Crunchy Chicken Wrap",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664016",
                                        "name": "Chicken Tandoori Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "243630835",
                                    "groupName": "Choose Any 1 from your New Premium Burger ",
                                    "choices": [
                                      {
                                        "id": "139664029",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664028",
                                        "name": "Fiery Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664026",
                                        "name": "Crunchy Chicken Wrap",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "139664027",
                                        "name": "Chicken Tandoori Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "248818203",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 59800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "24479a7d-6374-482e-afd1-f93b0ab6be38"
                                ],
                                "parentId": "110966774"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/c7c8a6dc-fd8e-4124-bf72-66529d3c066d_c28c96d9-429a-466a-83d7-5f2678101192.jpg",
                        "categoryId": "66813417"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "New Whopper Deluxe",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "148411209",
                                "name": "Veg Whopper Deluxe.",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Extra Crunchy Veg patty  fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 195 gms| Kcal: 484 | Carbs: 49 gms| Sugar: 10 gms| Fat: 27 gms| Saturated fat: 9 gms| Protein: 11 gms|Qty: 194 Gms| Kcal: 456 | Carbs 61.6 Gms| Sugar: 9.2 Gms| Fat: 20 Gms| Saturated fat: 11.9 Gms| Protein: 7.2 Gms| Sodium: 1428.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/6c2837bf-6fd2-49b3-a662-02f3373a1fb4_126fb22b-73bc-45d2-814d-240f47c7c1ec.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619019",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619020",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619021",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619022",
                                    "groupName": "Selected - Whopper Jr Veg",
                                    "choices": [
                                      {
                                        "id": "138686205",
                                        "name": "Selected - Whopper Jr Veg",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "113503550"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175836982",
                                "name": "Veg Whopper Deluxe!",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 195 gms| Kcal: 484 | Carbs: 49 gms| Sugar: 10 gms| Fat: 27 gms| Saturated fat: 9 gms| Protein: 11 gms|Qty: 194 Gms| Kcal: 456 | Carbs 61.6 Gms| Sugar: 9.2 Gms| Fat: 20 Gms| Saturated fat: 11.9 Gms| Protein: 7.2 Gms| Sodium: 1428.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/6c2837bf-6fd2-49b3-a662-02f3373a1fb4_126fb22b-73bc-45d2-814d-240f47c7c1ec.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619023",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619024",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619025",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619026",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619027",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619028",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "49 ratings",
                                    "ratingCountV2": "49"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503550"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175727772",
                                "name": "Paneer Whopper Deluxe.",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Crunchy Paneer patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 225 gms| Kcal: 621 | Carbs: 57 gms| Sugar: 1 gms| Fat: 34 gms| Saturated fat: 14 gms| Protein: 21 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/2192c3e7-7351-451a-8d6f-16cb27df212a_89f44cc6-1325-4715-8245-3cc87b38bdf8.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619029",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619030",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619031",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619032",
                                    "groupName": "Selected - Paneer Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "138686254",
                                        "name": "Paneer Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "113503549"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324762",
                                "name": "Cheese Whopper Deluxe.",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Molten Cheese Lava patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 230 gms| Kcal: 765 | Carbs: 35 gms| Sugar: 10 gms| Fat: 54 gms| Saturated fat: 20 gms| Protein: 35 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/456ade4f-e5ab-434f-a191-846326b13bbe_b417c2ec-589a-4266-a059-c41c96978142.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619033",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619034",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619035",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619036",
                                    "groupName": "Selected - Cheese Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "138686255",
                                        "name": "Cheese Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "113503541"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175727774",
                                "name": "Grill Chicken Whopper Deluxe.",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Flame Grill Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 168 gms| Kcal: 327 | Carbs: 35 gms| Sugar: 1 gms| Fat: 14 gms| Saturated fat: 3 gms| Protein: 15 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b2666401-e450-454f-a1a3-64a4682ab871_6f6d1001-4fb6-4911-994e-24fdc0d7e206.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619037",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619039",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619040",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619041",
                                    "groupName": "Selected - Grill Chicken Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "138686267",
                                        "name": "Grill Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.7",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "113503543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175727775",
                                "name": "Chicken Whopper Deluxe.",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Smokey Crunchy Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 240 gms| Kcal: 834 | Carbs: 76 gms| Sugar: 9 gms| Fat: 60 gms| Saturated fat: 13 gms| Protein: 37 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/ad7622d7-ea12-428d-8803-3bd9f9da190e_2e7ae0e7-8b22-446d-9d65-4c96ec3df716.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619042",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619043",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619044",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619045",
                                    "groupName": "Selected - Chicken Whopper Deluxe",
                                    "choices": [
                                      {
                                        "id": "138686250",
                                        "name": "Chicken Whopper Deluxe",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "113503542"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "159567905",
                                "name": "Grill Mutton Whopper Deluxe",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Flame Grill Mutton patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 186 gms| Kcal: 338 | Carbs: 38 gms| Sugar: 1 gms| Fat: 13 gms| Saturated fat: 4 gms| Protein: 16 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/11414cdb-e615-408a-aa62-1abf4faae75a_8a573f86-fd16-4646-84d1-c09055b2e2b9.jpg",
                                "inStock": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619046",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619047",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619049",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619050",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619051",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619052",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503547"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176941565",
                                "name": "Grill Chicken Whopper Deluxe Double Patty.",
                                "category": "New Whopper Deluxe",
                                "description": "Regular Size Flame-Grill Chicken Whopper Deluxe in premium glaze bun with 7 layers of taste: Double Flame-Grilled Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal) tangy gherkins, creamy & smoky sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/16/40955b4e-f218-4fd9-9012-3e16de76c831_dc97455a-39ac-4ed4-b8fa-96f264fc24ff.jpg",
                                "inStock": 1,
                                "price": 25900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619053",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619054",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619055",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619056",
                                    "groupName": "Selected - Chicken Whopper Jr Double Patty",
                                    "choices": [
                                      {
                                        "id": "138686404",
                                        "name": "Chicken Whopper Jr Double Patty",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503546"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136952497",
                                "name": "2 Veg Whopper Deluxe,",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/15/5a0d8f03-d754-405b-95e5-3c866988a327_8cbef449-a014-4dac-b25f-e3b57f4bc226.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29800,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619057",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619058",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503539"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175963177",
                                "name": "Grill Chicken Whopper Deluxe!",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Flame Grill Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 168 gms| Kcal: 327 | Carbs: 35 gms| Sugar: 1 gms| Fat: 14 gms| Saturated fat: 3 gms| Protein: 15 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b2666401-e450-454f-a1a3-64a4682ab871_6f6d1001-4fb6-4911-994e-24fdc0d7e206.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619070",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619071",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619072",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619073",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619074",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619075",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.7",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175963178",
                                "name": "Paneer Whopper Deluxe!",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Crunchy Paneer patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/2192c3e7-7351-451a-8d6f-16cb27df212a_89f44cc6-1325-4715-8245-3cc87b38bdf8.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619076",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619077",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619079",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619080",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619081",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503549"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324763",
                                "name": "Cheese Whopper Deluxe!",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Molten Cheese Lava patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/456ade4f-e5ab-434f-a191-846326b13bbe_b417c2ec-589a-4266-a059-c41c96978142.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619083",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619084",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619085",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619086",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619087",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503541"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "175963179",
                                "name": "Chicken Whopper Deluxe!",
                                "category": "New Whopper Deluxe",
                                "description": "Reg. Size premium glaze bun with 7 layers of taste: Smokey Crunchy Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/ad7622d7-ea12-428d-8803-3bd9f9da190e_2e7ae0e7-8b22-446d-9d65-4c96ec3df716.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619089",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619090",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619091",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619092",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619093",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503542"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/6c2837bf-6fd2-49b3-a662-02f3373a1fb4_126fb22b-73bc-45d2-814d-240f47c7c1ec.jpg",
                        "categoryId": "64895649"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Korean Spicy Fest(Limited Time Only)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560456",
                                "name": "Korean Spicy Paneer Burger",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Crunchy Soft Paneer patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours. \nQty: 228 Gms| Kcal: 695.26 | Carbs 67.94 Gms| Sugar: 16.99 Gms| Fat: 38.07 Gms| Saturated fat: 15.82 Gms| Protein: 20.20 Gms| Sodium: 1744.70 Mg. \nContains: Gluten, Soybean , Milk \".",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d960f43e-3328-494f-909e-1d38c67f364d_7eda4a11-d26d-4375-86a3-dc94bb55e2d6.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619095",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619096",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619098",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619099",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619101",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703673"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324764",
                                "name": "2 Korean Spicy Paneer Burger @ 399.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "Crunchy Soft Paneer patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/89129316-45e0-445a-85a3-78172f77c65a_f954405d-0773-4d74-8e99-67bef390dad0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619103",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619104",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619105",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619106",
                                    "groupName": "Selected - Korean Spicy Paneer Burger",
                                    "choices": [
                                      {
                                        "id": "138686265",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234619107",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619108",
                                    "groupName": "Selected - Korean Spicy Paneer Burger.",
                                    "choices": [
                                      {
                                        "id": "138686367",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "103654892"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560457",
                                "name": "Korean Spicy Paneer Burger.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Crunchy Soft Paneer patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours. \nQty: 228 Gms| Kcal: 695.26 | Carbs 67.94 Gms| Sugar: 16.99 Gms| Fat: 38.07 Gms| Saturated fat: 15.82 Gms| Protein: 20.20 Gms| Sodium: 1744.70 Mg \nContains: Gluten, Soybean , Milk \"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d960f43e-3328-494f-909e-1d38c67f364d_7eda4a11-d26d-4375-86a3-dc94bb55e2d6.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619111",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619113",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619114",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619116",
                                    "groupName": "Selected - Korean Spicy Paneer Burger",
                                    "choices": [
                                      {
                                        "id": "138686265",
                                        "name": "Korean Spicy Paneer Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "101703673"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324765",
                                "name": "2 Korean Spicy Chicken Burger @ 399.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "Crunchy Juicy whole muscle chicken patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/6926ef18-d268-4010-9506-3a7093ca7276_2482877c-9943-499b-9696-ca6df31a8b51.jpg",
                                "inStock": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619120",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619121",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619123",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619124",
                                    "groupName": "Selected -Korean Spicy Chicken Burger",
                                    "choices": [
                                      {
                                        "id": "138686263",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234619125",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619127",
                                    "groupName": "Selected -Korean Spicy Chicken Burger.",
                                    "choices": [
                                      {
                                        "id": "138686365",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "103654891"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560458",
                                "name": "Korean Spicy Chicken Burger.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Crunchy Juicy whole muscle chicken patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours \nQty: 227 Gms| Kcal: 607.27 | Carbs 55.14 Gms| Sugar: 31.59 Gms| Fat: 31.59 Gms| Saturated fat: 11.58 Gms| Protein: 25.58 Gms| Sodium: 1793.87 Mg \nContains: Gluten, Soybean , Milk \"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/dd6612b2-16e2-4184-9598-5248ad305dcf_7d08c76a-18b4-497a-8206-562ef44ae963.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619129",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619130",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619131",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619132",
                                    "groupName": "Selected -Korean Spicy Chicken Burger",
                                    "choices": [
                                      {
                                        "id": "138686263",
                                        "name": "Korean Spicy Chicken Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "101703670"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560459",
                                "name": "Korean Spicy Chicken Burger",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Crunchy Juicy whole muscle chicken patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours \nQty: 227 Gms| Kcal: 607.27 | Carbs 55.14 Gms| Sugar: 31.59 Gms| Fat: 31.59 Gms| Saturated fat: 11.58 Gms| Protein: 25.58 Gms| Sodium: 1793.87 Mg \nContains: Gluten, Soybean , Milk \"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/dd6612b2-16e2-4184-9598-5248ad305dcf_7d08c76a-18b4-497a-8206-562ef44ae963.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619134",
                                    "groupName": "Say Cheese!",
                                    "choices": [
                                      {
                                        "id": "138686275",
                                        "name": "Double Cheese Slice",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686330",
                                        "name": "Single Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619135",
                                    "groupName": "Make it a Combo!!",
                                    "choices": [
                                      {
                                        "id": "138686312",
                                        "name": "King Fries + Coca Cola (23% off)",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686247",
                                        "name": "Medium Fries + Coca Cola (23% Off)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686266",
                                        "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                        "price": 19500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686406",
                                        "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686332",
                                        "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                        "price": 21900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686385",
                                        "name": "Regular Fries + Coca Cola (28% OFF)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619136",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619137",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619138",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703670"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560460",
                                "name": "Korean Spicy Fries",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Cheesy Fries with hot and sweet Korean glaze. \nQty: 174 Gms| Kcal: 496.70 | Carbs 53.57 Gms| Sugar: 10.88 Gms| Fat: 28.29 Gms| Saturated fat: 10.14 Gms| Protein: 6.94 Gms| Sodium: 1469.93 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/8533f983-9d52-41f7-a782-6b7477ebc1b9_b9faed4b-881a-4964-bb9e-b23d42756ed2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619140",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619141",
                                    "groupName": "Add Peri Peri Spice Mix",
                                    "choices": [
                                      {
                                        "id": "138686357",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 15900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703672"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560461",
                                "name": "Korean Spicy Fries.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Cheesy Fries with hot and sweet Korean glaze. \nQty: 174 Gms| Kcal: 496.70 | Carbs 53.57 Gms| Sugar: 10.88 Gms| Fat: 28.29 Gms| Saturated fat: 10.14 Gms| Protein: 6.94 Gms| Sodium: 1469.93 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/8533f983-9d52-41f7-a782-6b7477ebc1b9_b9faed4b-881a-4964-bb9e-b23d42756ed2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619143",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 15900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "101703672"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168638945",
                                "name": "2Crispy Veg Double Patty Burger+Korean Spicy Fries.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/7dfe8c54-22ad-4903-8618-18550c400c16_b8763332-d632-43f7-9db4-2de6e992d3c3.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35700,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619144",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619145",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35700,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "101703666"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560462",
                                "name": "Korean Spicy Chicken (4 Pc)",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Boneless Chicken dunked in hot and sweet Korean glaze.\nQty: 155 Gms| Kcal: 350.176 | Carbs 27.51 Gms| Sugar: 0 Gms| Fat: 15.5 Gms| Saturated fat: 5.75 Gms| Protein: 25.16 Gms| Sodium: 1592.60 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d498fc01-a040-415d-9c02-b03f92510110_3708ee5c-620f-4ce1-b08c-f401c2f43865.jpg",
                                "inStock": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.4",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703667"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168638946",
                                "name": "Korean Spicy Chicken (4pc) + Crispy Chicken Burger.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/a459ef8b-b4e8-4a79-8e26-734ff6c7527d_20a1ad13-70d7-4799-97a1-c494b3f5143b.jpg",
                                "inStock": 1,
                                "price": 29800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619146",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619147",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "101703668"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560463",
                                "name": "Korean Spicy Chicken (7 Pc)",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Boneless Chicken dunked in hot and sweet Korean glaze. \nQty: 221 Gms| Kcal: 595.04 | Carbs 24.77 Gms| Sugar: 0 Gms| Fat: 39.89 Gms| Saturated fat: 15.25 Gms| Protein: 34.23 Gms| Sodium: 2188.96 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/a56db8d4-9277-4fc2-bbf6-80e8d79239e3_e8fa79df-a7f7-4cd2-8489-545486a41ab2.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703669"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168560464",
                                "name": "Korean Spicy Chicken Wings (4pc)",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "\"Chicken Wings dunked in hot and sweet Korean glaze.\nQty: 172 Gms| Kcal: 496.80 | Carbs 28.19 Gms| Sugar: 0 Gms| Fat: 30.34 Gms| Saturated fat: 11.04 Gms| Protein: 27.74 Gms| Sodium: 2714.33 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/1684f75d-21d6-4266-8d10-ee930c4b89fd_a81918a9-0807-489c-bcec-72d00d495c94.jpg",
                                "inStock": 1,
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101703671"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085315",
                                "name": "2Crispy Veg Burger+Korean Spicy Fries+2Coke.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/fd71d1ea-8822-4a1b-8e26-e91f6b583c4b_110f72ed-2176-4054-a071-8466a4206824.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619150",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968284"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085316",
                                "name": "2Crispy Chicken Burger+Korean Spicy Chicken(4pc)+2Coke.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/b2e527b9-122b-4cf1-8da2-cffa399c26ca_c5237d4d-9b60-48e9-84af-9d033efcbc93.jpg",
                                "inStock": 1,
                                "price": 44900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619151",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 44900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968283"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324781",
                                "name": "2 Grill Chicken Whopper Deluxe+Korean Spicy Chicken(7pc).",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "2 New Whopper Deluxe in premium glazed bun (regular size). 7 layers of taste: Flame-Grilled Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal) tangy gherkins, creamy & smoky sauces + Korean Spicy Chicken(7pc)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/3/bff09c58-5656-4947-ae3b-5c7764c42199_b66a2051-efe7-4cf6-991e-971218ee4d5e.jpg",
                                "inStock": 1,
                                "price": 50900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619152",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619153",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 50900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503538"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177324782",
                                "name": "2 Veg Whopper Deluxe +2 Korean Spicy Fries.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "description": "2 Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.+ 2 Korean Spicy Fries",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/3/af4d5afd-98c2-4e42-b6e1-236abe85d858_47a810a7-7809-4909-8d1b-d1a4a4d806e0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 50900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619155",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619156",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 50900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503540"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085319",
                                "name": "Korean Spicy Paneer Burger Meal.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/9/b3ac8a92-87b9-41b5-99ab-dd7739d1f71d_29aeef19-25fc-4761-88ac-604d270899ca.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 44900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619157",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 44900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968290"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085320",
                                "name": "Korean Spicy Chicken Burger Meal.",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/9/b87ea0a4-cae8-42c9-9bb7-887121012f0b_e9c2f23b-9e7c-493f-a63b-2a5392ecf5aa.jpg",
                                "inStock": 1,
                                "price": 44900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619158",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 44900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968287"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085321",
                                "name": "Korean Spicy Paneer+Korean Spicy Fries(M).",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/9/0d07d0ae-8aa8-4dd5-a5e4-ac455c6e6215_d61277bd-d51c-4fc0-bfa5-67dd36af7bef.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619159",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619160",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968291"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169085322",
                                "name": "Korean Spicy Chicken+Korean Spicy Fries(M).",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/9/d0d0ec68-894a-44f2-a4c9-0ffda6c4c30e_bd86f681-1b1f-48c1-8964-5536c94f6baf.jpg",
                                "inStock": 1,
                                "price": 35900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234619162",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234619163",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968288"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748543",
                                "name": "Korean Spicy Chicken Wings(4pc) + Korean Spicy Chicken (4pc).",
                                "category": "Korean Spicy Fest(Limited Time Only)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/9/2bc420e9-357d-4af6-b558-6ab28ee80504_26204dcb-a8ed-4436-a723-6011cc9c4632.jpg",
                                "inStock": 1,
                                "price": 37900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311620",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311621",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101968289"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d960f43e-3328-494f-909e-1d38c67f364d_7eda4a11-d26d-4375-86a3-dc94bb55e2d6.jpg",
                        "categoryId": "64895650"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Burgers, Wraps & Tacos",
                        "categories": [
                          {
                            "title": "New Whopper Deluxe",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175727776",
                                    "name": "Paneer Whopper Deluxe",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Crunchy Paneer patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/2192c3e7-7351-451a-8d6f-16cb27df212a_89f44cc6-1325-4715-8245-3cc87b38bdf8.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619165",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619166",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619167",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619168",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619169",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503549"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177324785",
                                    "name": "Cheese Whopper Deluxe",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Molten Cheese Lava patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/456ade4f-e5ab-434f-a191-846326b13bbe_b417c2ec-589a-4266-a059-c41c96978142.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619171",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619172",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619173",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619175",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619177",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.8",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503541"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175727778",
                                    "name": "Chicken Whopper Deluxe",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Smokey Crunchy Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/ad7622d7-ea12-428d-8803-3bd9f9da190e_2e7ae0e7-8b22-446d-9d65-4c96ec3df716.jpg",
                                    "inStock": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619178",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619179",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619180",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619181",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619182",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503542"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189852",
                                    "name": "Veg Whopper Deluxe",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 195 gms| Kcal: 484 | Carbs: 49 gms| Sugar: 10 gms| Fat: 27 gms| Saturated fat: 9 gms| Protein: 11 gms|.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/6c2837bf-6fd2-49b3-a662-02f3373a1fb4_126fb22b-73bc-45d2-814d-240f47c7c1ec.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619183",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619184",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619186",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619187",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619188",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619189",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503550"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62374388",
                                    "name": "Grill Chicken Whopper Deluxe",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Flame Grill Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 168 gms| Kcal: 327 | Carbs: 35 gms| Sugar: 1 gms| Fat: 14 gms| Saturated fat: 3 gms| Protein: 15 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b2666401-e450-454f-a1a3-64a4682ab871_6f6d1001-4fb6-4911-994e-24fdc0d7e206.jpg",
                                    "inStock": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619191",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619192",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619193",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619194",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619195",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619196",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.7",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503543"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175813788",
                                    "name": "Veg Whopper Deluxe,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 195 gms| Kcal: 484 | Carbs: 49 gms| Sugar: 10 gms| Fat: 27 gms| Saturated fat: 9 gms| Protein: 11 gms|Qty: 194 Gms| Kcal: 456 | Carbs 61.6 Gms| Sugar: 9.2 Gms| Fat: 20 Gms| Saturated fat: 11.9 Gms| Protein: 7.2 Gms| Sodium: 1428.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/6c2837bf-6fd2-49b3-a662-02f3373a1fb4_126fb22b-73bc-45d2-814d-240f47c7c1ec.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619198",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619199",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619200",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619201",
                                        "groupName": "Selected - Whopper Jr Veg",
                                        "choices": [
                                          {
                                            "id": "138686205",
                                            "name": "Selected - Whopper Jr Veg",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "113503550"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175813789",
                                    "name": "Paneer Whopper Deluxe,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Crunchy Paneer patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 225 gms| Kcal: 621 | Carbs: 57 gms| Sugar: 1 gms| Fat: 34 gms| Saturated fat: 14 gms| Protein: 21 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/2192c3e7-7351-451a-8d6f-16cb27df212a_89f44cc6-1325-4715-8245-3cc87b38bdf8.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "finalPrice": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619203",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619204",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619205",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619207",
                                        "groupName": "Selected - Paneer Whopper Deluxe",
                                        "choices": [
                                          {
                                            "id": "138686254",
                                            "name": "Paneer Whopper Deluxe",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                    ],
                                    "parentId": "113503549"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177324786",
                                    "name": "Cheese Whopper Deluxe,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Molten Cheese Lava patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 230 gms| Kcal: 765 | Carbs: 35 gms| Sugar: 10 gms| Fat: 54 gms| Saturated fat: 20 gms| Protein: 35 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/456ade4f-e5ab-434f-a191-846326b13bbe_b417c2ec-589a-4266-a059-c41c96978142.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "finalPrice": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619208",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619209",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619210",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619211",
                                        "groupName": "Selected - Cheese Whopper Deluxe",
                                        "choices": [
                                          {
                                            "id": "138686255",
                                            "name": "Cheese Whopper Deluxe",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                    ],
                                    "parentId": "113503541"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175813790",
                                    "name": "Grill Chicken Whopper Deluxe,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Flame Grill Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.\nQty: 168 gms| Kcal: 327 | Carbs: 35 gms| Sugar: 1 gms| Fat: 14 gms| Saturated fat: 3 gms| Protein: 15 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b2666401-e450-454f-a1a3-64a4682ab871_6f6d1001-4fb6-4911-994e-24fdc0d7e206.jpg",
                                    "inStock": 1,
                                    "price": 19900,
                                    "finalPrice": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619212",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619213",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619214",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619215",
                                        "groupName": "Selected - Grill Chicken Whopper Deluxe",
                                        "choices": [
                                          {
                                            "id": "138686267",
                                            "name": "Grill Chicken Whopper Deluxe",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.7",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                    ],
                                    "parentId": "113503543"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175813791",
                                    "name": "Chicken Whopper Deluxe,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Reg. Size premium glaze bun with 7 layers of taste: Smokey Crunchy Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.. \nQty: 240 gms| Kcal: 834 | Carbs: 76 gms| Sugar: 9 gms| Fat: 60 gms| Saturated fat: 13 gms| Protein: 37 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/ad7622d7-ea12-428d-8803-3bd9f9da190e_2e7ae0e7-8b22-446d-9d65-4c96ec3df716.jpg",
                                    "inStock": 1,
                                    "price": 19900,
                                    "finalPrice": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619217",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619218",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619219",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619220",
                                        "groupName": "Selected - Chicken Whopper Deluxe",
                                        "choices": [
                                          {
                                            "id": "138686250",
                                            "name": "Chicken Whopper Deluxe",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                    ],
                                    "parentId": "113503542"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895663"
                          },
                          {
                            "title": "Original Whopper (XL Size Bun)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62374384",
                                    "name": "Original Whopper Veg(XL size Bun)",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Original Whopper with Crunchy Veg Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 285 Gms| Kcal: 681.2 | Carbs 97.1 Gms| Sugar: 23.1 Gms| Fat: 25.4 Gms| Saturated fat: 9.8 Gms| Protein: 15.8 Gms| Sodium: 987.8 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/dc90cc06-f883-430d-be4b-75141c8064d9_6b832721-694c-4df4-96f0-308388144da0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619245",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619248",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619250",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619251",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619255",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619257",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "34 ratings",
                                        "ratingCountV2": "34"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106315745"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "110694073",
                                    "name": "Original Whopper Veg(XL size Bun).",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Original Whopper with Crunchy Veg Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 285 Gms| Kcal: 681.2 | Carbs 97.1 Gms| Sugar: 23.1 Gms| Fat: 25.4 Gms| Saturated fat: 9.8 Gms| Protein: 15.8 Gms| Sodium: 987.8 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/dc90cc06-f883-430d-be4b-75141c8064d9_6b832721-694c-4df4-96f0-308388144da0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "finalPrice": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619265",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619266",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619267",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619269",
                                        "groupName": "Selected - Veg Whopper",
                                        "choices": [
                                          {
                                            "id": "138686251",
                                            "name": "Selected - Veg Whopper",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "34 ratings",
                                        "ratingCountV2": "34"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                    ],
                                    "parentId": "106315745"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62374376",
                                    "name": "Original Whopper Chicken(XL size Bun)",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Original Whopper with Flame Grilled Chicken Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 280 Gms| Kcal: 667.2 | Carbs 59.1 Gms| Sugar: 8.7 Gms| Fat: 36.3 Gms| Saturated fat: 8.1 Gms| Protein: 26.2 Gms| Sodium: 1018.7 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/523da59d-365f-47bc-bb93-5583508104e9_c9077a2b-eab2-4acf-85f0-d7a357c4757a.jpg",
                                    "inStock": 1,
                                    "price": 20900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619277",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619278",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619282",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619288",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619292",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619293",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 20900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "23 ratings",
                                        "ratingCountV2": "23"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106278675"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "132689514",
                                    "name": "Original Whopper Chicken(XL size Bun).",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Original Whopper with Flame Grilled Chicken Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Qty: 280 Gms| Kcal: 667.2 | Carbs 59.1 Gms| Sugar: 8.7 Gms| Fat: 36.3 Gms| Saturated fat: 8.1 Gms| Protein: 26.2 Gms| Sodium: 1018.7 Mg Contains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/523da59d-365f-47bc-bb93-5583508104e9_c9077a2b-eab2-4acf-85f0-d7a357c4757a.jpg",
                                    "inStock": 1,
                                    "price": 20900,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619312",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619314",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619316",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619318",
                                        "groupName": "Selected - Chicken Whopper",
                                        "choices": [
                                          {
                                            "id": "138686253",
                                            "name": "Selected - Chicken Whopper",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 20900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "23 ratings",
                                        "ratingCountV2": "23"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "106278675"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "141538482",
                                    "name": "Original Whopper Veg Stacker",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Original Whopper Veg Double Patty with Cheese Slice",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/f24a5b91-68b4-40e7-8e16-5b25ceda28b9_99bd8d78-3eb4-40a6-be00-c194d7967b6a.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 28300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619333",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619335",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619338",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619341",
                                        "groupName": "Say Cheese.",
                                        "choices": [
                                          {
                                            "id": "138686256",
                                            "name": "Cheese Slice",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 28300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401032"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "141538483",
                                    "name": "Original Whopper Chicken Stacker",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Original Whopper Chicken Double Patty with Cheese Slice",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/8f09307c-a55c-44ee-93c9-5b1879e1b299_fedfac41-f115-4fc6-b190-8943915d01db.jpg",
                                    "inStock": 1,
                                    "price": 31300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619356",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619357",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619360",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619364",
                                        "groupName": "Say Cheese.",
                                        "choices": [
                                          {
                                            "id": "138686256",
                                            "name": "Cheese Slice",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 31300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401023"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186793443",
                                    "name": "Original Whopper Veg Stacker.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Original Whopper Veg Double Patty with Cheese Slice",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/f24a5b91-68b4-40e7-8e16-5b25ceda28b9_99bd8d78-3eb4-40a6-be00-c194d7967b6a.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 31300,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "254108092",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "254108093",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 31300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "102401032"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186793444",
                                    "name": "Original Whopper Chicken Stacker.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Original Whopper Chicken Double Patty with Cheese Slice",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/8f09307c-a55c-44ee-93c9-5b1879e1b299_fedfac41-f115-4fc6-b190-8943915d01db.jpg",
                                    "inStock": 1,
                                    "price": 31300,
                                    "finalPrice": 25900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "254108094",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "254108095",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 31300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "962d58e1-1519-4410-99b8-4b80bc879370"
                                    ],
                                    "parentId": "102401023"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895664"
                          },
                          {
                            "title": "Value Burgers & Tacos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189812",
                                    "name": "Crispy Veg Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Best Seller - New Premium Black & White Sesame Bun with Crispy Veg Patty, Fresh Onion and Signature Sauce.\nQty: 137 Gms| Kcal: 362 | Carbs 53.4 Gms| Sugar: 6.5 Gms| Fat: 12.8 Gms| Saturated fat: 4.9 Gms| Protein: 8.4 Gms| Sodium: 798.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4389cb8d-93e5-4dd5-8013-73a927dd6b31_622133db-f6cc-4f88-ba37-118df0b143ce.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 7000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619379",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619384",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619387",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619389",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619390",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619393",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 7000,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "4038 ratings",
                                        "ratingCountV2": "4.0K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379122"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "156521363",
                                    "name": "Crispy Veg Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our Best Seller - New Premium Black & White Sesame Bun with Crispy Veg Patty, Fresh Onion and Signature Sauce.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4389cb8d-93e5-4dd5-8013-73a927dd6b31_622133db-f6cc-4f88-ba37-118df0b143ce.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 7000,
                                    "finalPrice": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619407",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619409",
                                        "groupName": "Selected Burger - Crispy Veg ",
                                        "choices": [
                                          {
                                            "id": "138686298",
                                            "name": "Selected - Crispy Veg",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "234619410",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619413",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 7000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "4038 ratings",
                                        "ratingCountV2": "4.0K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "83c0d13c-9986-4725-af91-ce90d308f4a7"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379122"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102670992",
                                    "name": "Crispy Chicken Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Signature Sauce.\nQty: 125 Gms| Kcal: 359.1 | Carbs 44.3 Gms| Sugar: 7.5 Gms| Fat: 15.1 Gms| Saturated fat: 4.8 Gms| Protein: 11.5 Gms| Sodium: 592.4 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2ea3296b-2776-42b2-b3f7-ba17b0fbd43c_363816e0-8fbb-4fb6-8dbb-12d55d80b954.jpg",
                                    "inStock": 1,
                                    "price": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619426",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619432",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619435",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619437",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619438",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619444",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "1767 ratings",
                                        "ratingCountV2": "1.8K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379085"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117498723",
                                    "name": "Veg Makhani Burst Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Veg Patty, Fresh Onion and Makhani Sauce.\nQty: 135 Gms| Kcal: 315 | Carbs 48.5 Gms| Sugar: 8 Gms| Fat: 9.2 Gms| Saturated fat: 3.4 Gms| Protein: 9.6 Gms| Sodium: 768 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5cdc0592-60c5-4111-8a5d-bd6561dea768_52ca8d02-9b38-4c5b-b81b-2466febf03ab.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 8000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619459",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619463",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619467",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619473",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619475",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619476",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8000,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "469 ratings",
                                        "ratingCountV2": "469"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10380163"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189908",
                                    "name": "Veg Makhani Burst Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Veg Patty, Fresh Onion and Makhani Sauce.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5cdc0592-60c5-4111-8a5d-bd6561dea768_52ca8d02-9b38-4c5b-b81b-2466febf03ab.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 8000,
                                    "finalPrice": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619492",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619493",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619497",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619505",
                                        "groupName": "Selected - Veg Makhani Burst Burger",
                                        "choices": [
                                          {
                                            "id": "138686322",
                                            "name": "Veg Makhani Burst Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 8000,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "469 ratings",
                                        "ratingCountV2": "469"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "83c0d13c-9986-4725-af91-ce90d308f4a7"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10380163"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117498724",
                                    "name": "Chicken Makhani Burst Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Makhani Sauce.\n \nQty: 125 gms| Kcal: 327 | Carbs: 50 gms| Sugar: 6 gms| Fat: 13 gms| Saturated fat: 7 gms| Protein: 2 gms| Sodium: 663 mg\n \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/02307b66-2655-4749-9206-ce28ce1c177b_54466663-40f0-4afe-aa20-fc1098e40a70.jpg",
                                    "inStock": 1,
                                    "price": 10900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619515",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619518",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619520",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619522",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619526",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619530",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 10900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "117 ratings",
                                        "ratingCountV2": "117"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378832"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189815",
                                    "name": "Crispy Veg Double Patty Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Double up our best selling crispy veg burger, now with new Premium Black & White Sesame Bun\nQty: 204 Gms| Kcal: 531.4 | Carbs 70.6 Gms| Sugar: 9.1 Gms| Fat: 22.7 Gms| Saturated fat: 9.2 Gms| Protein: 11.2 Gms| Sodium: 1068 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5965c1c3-c079-41d7-a35e-5394b0822f6d_cb654bd9-dccd-4493-85a0-dc6cf1007653.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619540",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619544",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619548",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619551",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619554",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619555",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "1098 ratings",
                                        "ratingCountV2": "1.1K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379133"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62054579",
                                    "name": "Crispy Chicken Double Patty Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our best-selling burger with Double crispy chicken patty, onion, classic mayo sauce and new premium Black & White Sesame Bun.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/f00d2a08-be31-43b9-b613-3db884e1fbec_2e7229bb-29bc-41e8-aac3-4cef642aab62.jpg",
                                    "inStock": 1,
                                    "price": 13900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619575",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619577",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619578",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619582",
                                        "groupName": "Selected - Crispy Chicken Double Patty",
                                        "choices": [
                                          {
                                            "id": "138686342",
                                            "name": "Selected - Crispy Chicken Double Patty",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "495 ratings",
                                        "ratingCountV2": "495"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379094"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102670994",
                                    "name": "Crispy Chicken Double Patty Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Our best-selling burger with Double crispy chicken patty, onion, classic mayo sauce and new premium Black & White Sesame Bun.\nQty: 182 Gms| Kcal: 535.1 | Carbs 52.7 Gms| Sugar: 10.2 Gms| Fat: 28.3 Gms| Saturated fat: 10.4 Gms| Protein: 17.4 Gms| Sodium: 887.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/f00d2a08-be31-43b9-b613-3db884e1fbec_2e7229bb-29bc-41e8-aac3-4cef642aab62.jpg",
                                    "inStock": 1,
                                    "price": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619589",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619594",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619598",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619602",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619603",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619606",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "495 ratings",
                                        "ratingCountV2": "495"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379094"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "67765535",
                                    "name": "Veg Crunchy Taco",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Crunchy Taco Shell Filled With Beans & Veg Mix, Chef'S Secret Sauce, Onion & Lettuce. \nQty: 105 Gms| Kcal: 336.1 | Carbs 33.7 Gms| Sugar: 7.1 Gms| Fat: 20.8 Gms| Saturated fat: 13.9 Gms| Protein: 3.6 Gms| Sodium: 589.6 Mg \nContains: Soybean, Milk",
                                    "imageId": "424358cb32c40669f3aab9ba92d27141",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311622",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311623",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311624",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311625",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311626",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "598 ratings",
                                        "ratingCountV2": "598"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "61098733"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "148411214",
                                    "name": "Crispy Veg Double Patty Burger with Double Cheese Slice.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/d95c9759-ec7e-4c92-81e6-fea2f8d88da1_129b6e5a-8d6f-45bc-81ce-ee2e89bf72c2.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619676",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619678",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "62 ratings",
                                        "ratingCountV2": "62"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "87576609"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "154974890",
                                    "name": "Chicken Makhani Burst Burger with Cheese.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/02307b66-2655-4749-9206-ce28ce1c177b_54466663-40f0-4afe-aa20-fc1098e40a70.jpg",
                                    "inStock": 1,
                                    "price": 13400,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619690",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619694",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 13400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447811"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "154974888",
                                    "name": "Veg Makhani Burst Double Cheese Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/c36c5882-6751-4669-aff7-1178d879a92c_2dbad587-fee3-4124-b77b-94982bcba1c1.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13000,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619704",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619707",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447818"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "154974894",
                                    "name": "Crispy Chicken Triple Cheese Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/1ab7f8c9-1052-44e0-9b37-61cca15b666e_b352fa8f-edbd-4ba4-8fe0-6ac6120aa79f.jpg",
                                    "inStock": 1,
                                    "price": 17400,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619718",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619719",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 17400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447814"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088284",
                                    "name": "BK Veggie Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Mix Veg Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo.\nQty: 152 Gms| Kcal: 352.5 | Carbs 45.4 Gms| Sugar: 7.8 Gms| Fat: 13.6 Gms| Saturated fat: 4.7 Gms| Protein: 12 Gms| Sodium: 593.8 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/b1e902e7-ef9e-4a2d-8b65-52ca66574937_cb6912fe-d217-4e35-89ef-af51f7b91a11.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619731",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619733",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619736",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619740",
                                        "groupName": "Selected - BK Veggie",
                                        "choices": [
                                          {
                                            "id": "138686340",
                                            "name": "Selected - BK Veggie",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "83 ratings",
                                        "ratingCountV2": "83"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10378533"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189823",
                                    "name": "BK Veggie Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Mix Veg Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo.\nQty: 152 Gms| Kcal: 352.5 | Carbs 45.4 Gms| Sugar: 7.8 Gms| Fat: 13.6 Gms| Saturated fat: 4.7 Gms| Protein: 12 Gms| Sodium: 593.8 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/b1e902e7-ef9e-4a2d-8b65-52ca66574937_cb6912fe-d217-4e35-89ef-af51f7b91a11.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619761",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "83 ratings",
                                        "ratingCountV2": "83"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378533"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189844",
                                    "name": "BK Chicken Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crunchy Chicken Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo.\nQty: 164 Gms| Kcal: 415 | Carbs 39 Gms| Sugar: 7.2 Gms| Fat: 21.2 Gms| Saturated fat: 7.2 Gms| Protein: 17 Gms| Sodium: 283.9 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/56781f71-f576-4a51-9750-483428dd96c1_08251502-1ca2-4bdc-8d34-6f5bf1ce4415.jpg",
                                    "inStock": 1,
                                    "price": 14900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619768",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619770",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619775",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619781",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619784",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619786",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "49 ratings",
                                        "ratingCountV2": "49"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "63621012"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "148411210",
                                    "name": "BK Chicken Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crunchy Chicken Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo.\nQty: 164 Gms| Kcal: 415 | Carbs 39 Gms| Sugar: 7.2 Gms| Fat: 21.2 Gms| Saturated fat: 7.2 Gms| Protein: 17 Gms| Sodium: 283.9 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/56781f71-f576-4a51-9750-483428dd96c1_08251502-1ca2-4bdc-8d34-6f5bf1ce4415.jpg",
                                    "inStock": 1,
                                    "price": 14900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619801",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619803",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619804",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619805",
                                        "groupName": "Selected - BK Chicken.",
                                        "choices": [
                                          {
                                            "id": "138686345",
                                            "name": "Selected - BK Chicken",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "49 ratings",
                                        "ratingCountV2": "49"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "63621012"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "154974893",
                                    "name": "BK Veggie Triple Cheese Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/80999467-e527-4a47-a7a7-f425a21a985e_d3dd8e3e-d3d3-4119-a4d4-a6b4e0331100.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 21400,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619814",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619816",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 21400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447810"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188776854",
                                    "name": "Crispy Chicken Burger*",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Signature Sauce.\nQty: 125 Gms| Kcal: 359.1 | Carbs 44.3 Gms| Sugar: 7.5 Gms| Fat: 15.1 Gms| Saturated fat: 4.8 Gms| Protein: 11.5 Gms| Sodium: 592.4 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2ea3296b-2776-42b2-b3f7-ba17b0fbd43c_363816e0-8fbb-4fb6-8dbb-12d55d80b954.jpg",
                                    "inStock": 1,
                                    "price": 9900,
                                    "finalPrice": 7900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260668905",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668906",
                                        "groupName": "Selected Burger - Crispy Chicken",
                                        "choices": [
                                          {
                                            "id": "138686299",
                                            "name": "Selected - Crispy Chicken Burger",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "260668907",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668908",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "1767 ratings",
                                        "ratingCountV2": "1.8K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379085"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188776855",
                                    "name": "Crispy Veg Double Patty Burger*",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Double up our best selling crispy veg burger, now with new Premium Black & White Sesame Bun\nQty: 204 Gms| Kcal: 531.4 | Carbs 70.6 Gms| Sugar: 9.1 Gms| Fat: 22.7 Gms| Saturated fat: 9.2 Gms| Protein: 11.2 Gms| Sodium: 1068 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5965c1c3-c079-41d7-a35e-5394b0822f6d_cb654bd9-dccd-4493-85a0-dc6cf1007653.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9900,
                                    "finalPrice": 7900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260668909",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668910",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668911",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668912",
                                        "groupName": "Selected Burger - Crispy Veg Double Patty Burger",
                                        "choices": [
                                          {
                                            "id": "138686358",
                                            "name": "Selected - Crispy Veg Double Patty Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "1098 ratings",
                                        "ratingCountV2": "1.1K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379133"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188776853",
                                    "name": "Veg Makhani Burst Double Patty Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/31/0b190b37-8444-44d5-8832-cc9100136d2f_8b69dc6b-7979-46ba-833a-13f4db163286.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 11500,
                                    "finalPrice": 7900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260668903",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668904",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 11500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "93 ratings",
                                        "ratingCountV2": "93"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10380164"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "109342349",
                                    "name": "Veg Crunchy Taco.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Crunchy Taco Shell Filled With Beans & Veg Mix, Chef'S Secret Sauce, Onion & Lettuce. \nQty: 105 Gms| Kcal: 336.1 | Carbs 33.7 Gms| Sugar: 7.1 Gms| Fat: 20.8 Gms| Saturated fat: 13.9 Gms| Protein: 3.6 Gms| Sodium: 589.6 Mg \nContains: Soybean, Milk",
                                    "imageId": "424358cb32c40669f3aab9ba92d27141",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9000,
                                    "finalPrice": 7900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260668913",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668914",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "598 ratings",
                                        "ratingCountV2": "598"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "61098733"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189890",
                                    "name": "Chicken Makhani Burst Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Makhani Sauce.\n \nQty: 125 gms| Kcal: 327 | Carbs: 50 gms| Sugar: 6 gms| Fat: 13 gms| Saturated fat: 7 gms| Protein: 2 gms| Sodium: 663 mg\n \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/02307b66-2655-4749-9206-ce28ce1c177b_54466663-40f0-4afe-aa20-fc1098e40a70.jpg",
                                    "inStock": 1,
                                    "price": 10900,
                                    "finalPrice": 7900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260668915",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260668916",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 10900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "117 ratings",
                                        "ratingCountV2": "117"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10378832"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895665"
                          },
                          {
                            "title": "Premium Burgers & Wraps- (Kings Collection)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "89831974",
                                    "name": "Paneer Royale Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "60 gm Paneer Patty, Sauces In premium Brioche Buns\nQty: 255 Gms| Kcal: 557.5 | Carbs 84 Gms| Sugar: 14.8 Gms| Fat: 29 Gms| Saturated fat: 14 Gms| Protein: 18.9 Gms| Sodium: 1178 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/a3091946-fdb0-4dea-8bf6-4a46534157e4_4927a664-6d27-4348-9d32-5cb082ec618a.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619828",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619829",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619830",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619836",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619839",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "140 ratings",
                                        "ratingCountV2": "140"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "45410944"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "140634899",
                                    "name": "Paneer Royale Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "60 gm Paneer Patty, Sauces In premium Brioche Buns",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/a3091946-fdb0-4dea-8bf6-4a46534157e4_4927a664-6d27-4348-9d32-5cb082ec618a.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619844",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619845",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "140 ratings",
                                        "ratingCountV2": "140"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "45410944"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "140634901",
                                    "name": "Fiery Chicken Burger.",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Spicy Fried Chicken, Loads Of Sauces In premium Brioche Buns",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/a7c753fe-7ebd-415f-a721-ccb0d7ea95cf_0b4ade09-4dcd-4342-bca2-79bd518677c3.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619854",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619858",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "596 ratings",
                                        "ratingCountV2": "596"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "10379253"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020867",
                                    "name": "Paneer Royale Wrap,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Qty: 234 Gms | Kcal: 676.2 | Carbs 63.2 Gms | Sugar: 9.7 Gms | Fat: 35.6 Gms | Saturated fat: 18 Gms | Protein: 25.3 Gms | Sodium: 1077.9 Mg \nContains: Gluten, Soybean , Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/0c99f01d-ed64-4c03-b689-b4559ad8c1a2_c1efd372-6fdb-427d-956e-dfd762138f2b.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 22900,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619865",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619868",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "62 ratings",
                                        "ratingCountV2": "62"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "62844855"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "116073440",
                                    "name": "Paneer Royale Wrap",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "60 gm Paneer Patty, Sauces In Soft Tortilla Wrap. \nQty: 234 Gms| Kcal: 676.2 | Carbs 63.2 Gms| Sugar: 9.7 Gms| Fat: 35.6 Gms| Saturated fat: 18 Gms| Protein: 25.3 Gms| Sodium: 1077.9 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/0c99f01d-ed64-4c03-b689-b4559ad8c1a2_c1efd372-6fdb-427d-956e-dfd762138f2b.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234619881",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619884",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619885",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619889",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234619892",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "62 ratings",
                                        "ratingCountV2": "62"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "62844855"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748544",
                                    "name": "Hot 'N' Cheesy Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Chilli Creamy Patty, Spicy Sauce, in premium Brioche buns.\nQty: 255 Gms| Kcal: 682 | Carbs 82 Gms| Sugar: 17.5 Gms| Fat: 31.4 Gms| Saturated fat: 12.1 Gms| Protein: 17.9 Gms| Sodium: 1198.5 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/c686d35b-4bb8-4921-b9d4-ded351de228c_1ef2b796-68eb-4841-a27e-cefe5a42b7b4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311627",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311628",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311629",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106171550"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748545",
                                    "name": "Hot 'N' Cheesy Burger,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Chilli Creamy Patty, Spicy Sauce, in premium Brioche buns.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/c686d35b-4bb8-4921-b9d4-ded351de228c_1ef2b796-68eb-4841-a27e-cefe5a42b7b4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311630",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311631",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311632",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311633",
                                        "groupName": "Selected - Hot 'N' Saucy Burger",
                                        "choices": [
                                          {
                                            "id": "139076384",
                                            "name": "Hot 'N' Saucy Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "106171550"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "136952506",
                                    "name": "Crunchy Chicken Wrap,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Qty: 252 Gms | Kcal: 483.8 | Carbs 50.6 Gms | Sugar: 9.3 Gms | Fat: 22.5 Gms | Saturated fat: 8.2 Gms | Protein: 19.8 Gms | Sodium: 1176.5 Mg \nContains: Gluten, Soybean , Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/9b61d39e-8195-4823-be78-11f4120eb9c6_eb124329-869d-467b-a04d-6d9180cce643.jpg",
                                    "inStock": 1,
                                    "price": 22900,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311634",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311635",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "101748308"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "128756165",
                                    "name": "Crunchy Chicken Wrap",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Spicy Fried Chicken, Loads Of Sauces In Soft Tortilla Wrap. \nQty: 252 Gms| Kcal: 483.8 | Carbs 50.6 Gms| Sugar: 9.3 Gms| Fat: 22.5 Gms| Saturated fat: 8.2 Gms| Protein: 19.8 Gms| Sodium: 1176.5 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/9b61d39e-8195-4823-be78-11f4120eb9c6_eb124329-869d-467b-a04d-6d9180cce643.jpg",
                                    "inStock": 1,
                                    "price": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311636",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311637",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311638",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311639",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311640",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "13 ratings",
                                        "ratingCountV2": "13"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101748308"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "89832004",
                                    "name": "Chicken Tandoori Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Flame Grilled Tandoori Chicken, Veg Khurchan in premium Brioche buns.. \nQty: 236 Gms| Kcal: 502.7 | Carbs 62.7 Gms| Sugar: 6.9 Gms| Fat: 15 Gms| Saturated fat: 8.8 Gms| Protein: 29.4 Gms| Sodium: 1106.8 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/f698dd95-0c49-426d-a50b-ad4bf815c865_708d59be-3b1c-4b80-8f4a-c95f1ac87a41.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311641",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311642",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311643",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311644",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311645",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "96 ratings",
                                        "ratingCountV2": "96"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "45410938"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105418819",
                                    "name": "Chicken Tandoori Burger,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Flame Grilled Tandoori Chicken, Veg Khurchan in premium Brioche buns.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/f698dd95-0c49-426d-a50b-ad4bf815c865_708d59be-3b1c-4b80-8f4a-c95f1ac87a41.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311646",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311647",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311648",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311649",
                                        "groupName": "Selected - Chicken Tandoori Burger",
                                        "choices": [
                                          {
                                            "id": "139076385",
                                            "name": "Chicken Tandoori Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "96 ratings",
                                        "ratingCountV2": "96"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "45410938"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "25407608",
                                    "name": "Fiery Chicken Burger",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "Spicy Fried Chicken, Loads Of Sauces In premium Brioche Buns\nQty: 247 Gms| Kcal: 588 | Carbs 64 Gms| Sugar: 12.1 Gms| Fat: 26.6 Gms| Saturated fat: 8.7 Gms| Protein: 23.1 Gms| Sodium: 1101.3 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/10/a7c753fe-7ebd-415f-a721-ccb0d7ea95cf_0b4ade09-4dcd-4342-bca2-79bd518677c3.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620002",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620004",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "596 ratings",
                                        "ratingCountV2": "596"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379253"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560465",
                                    "name": "Korean Spicy Paneer Burger,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "\"Crunchy Soft Paneer patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours. \nQty: 228 Gms| Kcal: 695.26 | Carbs 67.94 Gms| Sugar: 16.99 Gms| Fat: 38.07 Gms| Saturated fat: 15.82 Gms| Protein: 20.20 Gms| Sodium: 1744.70 Mg \nContains: Gluten, Soybean , Milk \"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d960f43e-3328-494f-909e-1d38c67f364d_7eda4a11-d26d-4375-86a3-dc94bb55e2d6.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620015",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620018",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620022",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620024",
                                        "groupName": "Selected - Korean Spicy Paneer Burger",
                                        "choices": [
                                          {
                                            "id": "138686265",
                                            "name": "Korean Spicy Paneer Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "101703673"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560466",
                                    "name": "Korean Spicy Paneer Burger!",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "\"Crunchy Soft Paneer patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours. \nQty: 228 Gms| Kcal: 695.26 | Carbs 67.94 Gms| Sugar: 16.99 Gms| Fat: 38.07 Gms| Saturated fat: 15.82 Gms| Protein: 20.20 Gms| Sodium: 1744.70 Mg \nContains: Gluten, Soybean , Milk \"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d960f43e-3328-494f-909e-1d38c67f364d_7eda4a11-d26d-4375-86a3-dc94bb55e2d6.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620041",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620042",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620044",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620049",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620052",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703673"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560467",
                                    "name": "Korean Spicy Chicken Burger,",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "\"Crunchy Juicy whole muscle chicken patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours \nQty: 227 Gms| Kcal: 607.27 | Carbs 55.14 Gms| Sugar: 31.59 Gms| Fat: 31.59 Gms| Saturated fat: 11.58 Gms| Protein: 25.58 Gms| Sodium: 1793.87 Mg \nContains: Gluten, Soybean , Milk \"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/dd6612b2-16e2-4184-9598-5248ad305dcf_7d08c76a-18b4-497a-8206-562ef44ae963.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "finalPrice": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620065",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620067",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620071",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620076",
                                        "groupName": "Selected -Korean Spicy Chicken Burger",
                                        "choices": [
                                          {
                                            "id": "138686263",
                                            "name": "Korean Spicy Chicken Burger",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                    ],
                                    "parentId": "101703670"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560468",
                                    "name": "Korean Spicy Chicken Burger!",
                                    "category": "Burgers, Wraps & Tacos",
                                    "description": "\"Crunchy Juicy whole muscle chicken patty dunked in hot and sweet Korean glaze with Korean sesame mayo in premium Brioche buns for authentic Korean flavours \nQty: 227 Gms| Kcal: 607.27 | Carbs 55.14 Gms| Sugar: 31.59 Gms| Fat: 31.59 Gms| Saturated fat: 11.58 Gms| Protein: 25.58 Gms| Sodium: 1793.87 Mg \nContains: Gluten, Soybean , Milk \"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/dd6612b2-16e2-4184-9598-5248ad305dcf_7d08c76a-18b4-497a-8206-562ef44ae963.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620086",
                                        "groupName": "Say Cheese!",
                                        "choices": [
                                          {
                                            "id": "138686275",
                                            "name": "Double Cheese Slice",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686330",
                                            "name": "Single Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620090",
                                        "groupName": "Make it a Combo!!",
                                        "choices": [
                                          {
                                            "id": "138686312",
                                            "name": "King Fries + Coca Cola (23% off)",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686247",
                                            "name": "Medium Fries + Coca Cola (23% Off)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686266",
                                            "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                            "price": 19500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686406",
                                            "name": "Medium Fries + Classic Cold Coffee (22% off)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686332",
                                            "name": "Med Fries + Coca Cola + Choco Lava (25% Off)",
                                            "price": 21900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686385",
                                            "name": "Regular Fries + Coca Cola (28% OFF)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620094",
                                        "groupName": "Choose Your Side",
                                        "choices": [
                                          {
                                            "id": "138686334",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686410",
                                            "name": "Medium Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686337",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686276",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686370",
                                            "name": "King Fries",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686409",
                                            "name": "King Peri Peri Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686401",
                                            "name": "Medium Peri Peri Fries",
                                            "price": 14400,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686372",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686232",
                                            "name": "Boneless Wings (4 Pcs)",
                                            "price": 16900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686223",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686321",
                                            "name": "BK Chicken Pizza Puff",
                                            "price": 8900,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620097",
                                        "groupName": "Choose Your Beverages!!",
                                        "choices": [
                                          {
                                            "id": "138686249",
                                            "name": "Coca Cola Medium",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686331",
                                            "name": "Classic Cold Coffee",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686252",
                                            "name": "Chocolate Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686325",
                                            "name": "Berry Blast Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686248",
                                            "name": "Mango Thick Shake",
                                            "price": 18900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686264",
                                            "name": "Iced Latte",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686374",
                                            "name": "BK Fusion Shake (made with Kit Kat)",
                                            "price": 27900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686329",
                                            "name": "Mocha Frappe",
                                            "price": 26900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620101",
                                        "groupName": "Add Dessert",
                                        "choices": [
                                          {
                                            "id": "138686386",
                                            "name": "Choco Lava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686208",
                                            "name": "Chocolate Mousse Cup",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686388",
                                            "name": "Chocochip Muffin",
                                            "price": 13900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686366",
                                            "name": "BK Fusion Sundae (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703670"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895666"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/2192c3e7-7351-451a-8d6f-16cb27df212a_89f44cc6-1325-4715-8245-3cc87b38bdf8.jpg",
                        "categoryId": "64895651"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Sides & Snacks",
                        "categories": [
                          {
                            "title": "Fries",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102002586",
                                    "name": "Medium Peri Peri Fries.",
                                    "category": "Sides & Snacks",
                                    "description": "Crispy Fries With Tangy Peri Peri spice.  \nQty: 119 Gms| Kcal: 345.3 | Carbs 447.6 Gms| Sugar: 0.9 Gms| Fat: 14.7 Gms| Saturated fat: 6.8 Gms| Protein: 6.3 Gms| Sodium: 998.8 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/3408bb90-e96a-42e3-abe2-0381dd1230d1_08dadded-e4ce-4be6-8ff9-0935033d8887.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14400,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620114",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620118",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "135 ratings",
                                        "ratingCountV2": "135"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379545"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189925",
                                    "name": "Medium Peri Peri Fries",
                                    "category": "Sides & Snacks",
                                    "description": "Crispy Fries With Tangy Peri Peri Spice.  \nQty: 119 Gms| Kcal: 345.3 | Carbs 447.6 Gms| Sugar: 0.9 Gms| Fat: 14.7 Gms| Saturated fat: 6.8 Gms| Protein: 6.3 Gms| Sodium: 998.8 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/3408bb90-e96a-42e3-abe2-0381dd1230d1_08dadded-e4ce-4be6-8ff9-0935033d8887.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14400,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620126",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "135 ratings",
                                        "ratingCountV2": "135"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379545"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102002584",
                                    "name": "King Fries.",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fefae94a-53cd-421c-9f1f-d0f642949728_2ddc8be1-0a65-430d-9de8-542fae4ce739.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620138",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620141",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "409 ratings",
                                        "ratingCountV2": "409"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379448"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189924",
                                    "name": "King Fries",
                                    "category": "Sides & Snacks",
                                    "description": "The Perfect Crispy Partner \nQty: 156 Gms| Kcal: 455 | Carbs 609.48 Gms| Sugar: 0 Gms| Fat: 19.7 Gms| Saturated fat: 9.31 Gms| Protein: 8 Gms| Sodium: 723.7 Mg \nContains: Gluten",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fefae94a-53cd-421c-9f1f-d0f642949728_2ddc8be1-0a65-430d-9de8-542fae4ce739.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620152",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620156",
                                        "groupName": "Add Peri Peri Spice Mix",
                                        "choices": [
                                          {
                                            "id": "138686357",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 13900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "409 ratings",
                                        "ratingCountV2": "409"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379448"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "148411211",
                                    "name": "Saucy Fries.",
                                    "category": "Sides & Snacks",
                                    "description": "Crispy French Fries, Loads of Cheese, Yum!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/23/5a275756-e3eb-4286-a188-1e19b792ae1c_690db299-28ee-40ba-aba5-fc3c98552407.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14500,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620165",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620167",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "50 ratings",
                                        "ratingCountV2": "50"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "79964888"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "136447228",
                                    "name": "Saucy Fries",
                                    "category": "Sides & Snacks",
                                    "description": "Crispy French Fries, Loads of Cheese, Yum!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/23/5a275756-e3eb-4286-a188-1e19b792ae1c_690db299-28ee-40ba-aba5-fc3c98552407.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620178",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620179",
                                        "groupName": "Add Peri Peri Spice Mix",
                                        "choices": [
                                          {
                                            "id": "138686357",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "50 ratings",
                                        "ratingCountV2": "50"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "79964888"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "156521364",
                                    "name": "Regular Fries.",
                                    "category": "Sides & Snacks",
                                    "description": "The perfect crispy partner.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/19/8ec32a30-ec59-4673-bc5e-16f4b1dc0110_de467db3-09c6-4064-8188-620f259d4541.png_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9000,
                                    "finalPrice": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620190",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620193",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 9000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "127 ratings",
                                        "ratingCountV2": "127"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "83c0d13c-9986-4725-af91-ce90d308f4a7"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379846"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "110694096",
                                    "name": "2 Med Fries.",
                                    "category": "Sides & Snacks",
                                    "description": "The perfect crispy partner.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/c505c034-f3c2-46ab-be5d-09fadcee6bdb_aa606839-2a3f-4b5d-9873-0202f6eeb26b.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 23800,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620204",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620206",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 23800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "109 ratings",
                                        "ratingCountV2": "109"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "36545254"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105418823",
                                    "name": "2 King Fries,",
                                    "category": "Sides & Snacks",
                                    "description": "MRP. 260 | Save Rs. 91,  The perfect crispy partner.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/23/517fa08e-a9f9-4ec1-9e2e-ae2470b2d19a_c6e3c945-a66e-4903-a894-1a50e5ae2801.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 27800,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620216",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620217",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 27800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "60073901"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189923",
                                    "name": "Medium Fries",
                                    "category": "Sides & Snacks",
                                    "description": "The Perfect Crispy Partner.\nQty: 114 Gms| Kcal: 332.5 | Carbs 445.39 Gms| Sugar: 0 Gms| Fat: 14.4 Gms| Saturated fat: 6.8 Gms| Protein: 5.9 Gms| Sodium: 528.8 Mg \nContains: Gluten",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/fefae94a-53cd-421c-9f1f-d0f642949728_2ddc8be1-0a65-430d-9de8-542fae4ce739.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 11900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 11900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "257 ratings",
                                        "ratingCountV2": "257"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379543"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "73863568",
                                    "name": "King Peri Peri Fries",
                                    "category": "Sides & Snacks",
                                    "description": "Crispy Fries With Tangy Peri Peri Spice.  \nQty: 161 Gms| Kcal: 467.8 | Carbs 611.7 Gms| Sugar: 0.9 Gms| Fat: 20 Gms| Saturated fat: 9.3 Gms| Protein: 8.4 Gms| Sodium: 1193.7 Mg \nContains: Gluten, Soybean",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/fa747205-3c4d-497c-a948-65f3c224a4cf_11129959-8182-4b8c-bbb5-db49665fba19.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620236",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "108 ratings",
                                        "ratingCountV2": "108"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379450"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088301",
                                    "name": "Fiery Hell-Dip",
                                    "category": "Sides & Snacks",
                                    "description": "Qty: 20 Gms| Kcal: 81.4 | Carbs 3.3 Gms| Sugar: 1.8 Gms| Fat: 7.4 Gms| Saturated fat: 1.3 Gms| Protein: 0.3 Gms| Sodium: 194 Mg \nContains:  Soybean , Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/11/b9f1f683-2e5c-4742-b460-b54541edc052_ae2debde-0cd8-466a-afd2-2c661d560bac.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 2381,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 2381,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "25 ratings",
                                        "ratingCountV2": "25"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "36776245"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "111845898",
                                    "name": "Peri Peri Spice Mix",
                                    "category": "Sides & Snacks",
                                    "description": "Peri Peri Spice Mix. \nQty: 5 Gms| Kcal: 12.8 | Carbs 2.2 Gms| Sugar: 0.9 Gms| Fat: 0.3 Gms| Saturated fat: 0 Gms| Protein: 0.4 Gms| Sodium: 470 Mg \nContains:  Soybean",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/90596c36-c40b-44e1-a87b-556104893347_81a2c8d2-e722-473a-a52a-aab5bc44ae95.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 2857,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 2857,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "51 ratings",
                                        "ratingCountV2": "51"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "64492520"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560469",
                                    "name": "Korean Spicy Fries,",
                                    "category": "Sides & Snacks",
                                    "description": "\"Cheesy Fries with hot and sweet Korean glaze. \nQty: 174 Gms| Kcal: 496.70 | Carbs 53.57 Gms| Sugar: 10.88 Gms| Fat: 28.29 Gms| Saturated fat: 10.14 Gms| Protein: 6.94 Gms| Sodium: 1469.93 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/8533f983-9d52-41f7-a782-6b7477ebc1b9_b9faed4b-881a-4964-bb9e-b23d42756ed2.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620255",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "101703672"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560470",
                                    "name": "Korean Spicy Fries!",
                                    "category": "Sides & Snacks",
                                    "description": "\"Cheesy Fries with hot and sweet Korean glaze. \nQty: 174 Gms| Kcal: 496.70 | Carbs 53.57 Gms| Sugar: 10.88 Gms| Fat: 28.29 Gms| Saturated fat: 10.14 Gms| Protein: 6.94 Gms| Sodium: 1469.93 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/8533f983-9d52-41f7-a782-6b7477ebc1b9_b9faed4b-881a-4964-bb9e-b23d42756ed2.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620266",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620268",
                                        "groupName": "Add Peri Peri Spice Mix",
                                        "choices": [
                                          {
                                            "id": "138686357",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703672"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "176203746",
                                    "name": "Chilli Oregano Dip",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/11/70b5cf41-c454-4ff0-abb7-fc2e2632a7ca_523df1b4-cae9-48c4-8796-a8ddd60fdba5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 2381,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 2381,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106427207"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "176203747",
                                    "name": "Saucy Jalapeno Dip",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/11/09b9af34-73c5-4eaf-8090-582588a10cd0_aee2dbe8-51a5-4586-83ca-998c9874640e.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 2381,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 2381,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106427208"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895667"
                          },
                          {
                            "title": "Snacks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "156521366",
                                    "name": "BK Veg Pizza Puff.",
                                    "category": "Sides & Snacks",
                                    "description": "\"Crispy savoury pastry with a filling of tomato sauce with corn, carrots, bell peppers, peas and mozzarella. Caution: Served Hot.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/ee5f25e0-5f74-4daf-908a-38f6c8c23f14_35543521-018a-41fc-b967-92858b42c608.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 6500,
                                    "finalPrice": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620285",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620290",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 6500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "144 ratings",
                                        "ratingCountV2": "144"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "83c0d13c-9986-4725-af91-ce90d308f4a7"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "90842099"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "147811552",
                                    "name": "BK Veg Pizza Puff",
                                    "category": "Sides & Snacks",
                                    "description": "\"Crispy savoury pastry with a filling of tomato sauce with corn, carrots, bell peppers, peas and mozzarella. Caution: Served Hot. \nQty: 80 Gms| Kcal: 208 | Carbs 27.56 Gms| Sugar: 1.28 Gms| Fat: 8.04 Gms| Saturated fat: 4.6 Gms| Protein: 6.3 Gms| Sodium: 341 Mg \nContains: Gluten, Soybean , Milk \"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/ee5f25e0-5f74-4daf-908a-38f6c8c23f14_35543521-018a-41fc-b967-92858b42c608.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 6500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 6500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "144 ratings",
                                        "ratingCountV2": "144"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "90842099"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102002587",
                                    "name": "Veggie Strips - 5 Pcs.",
                                    "category": "Sides & Snacks",
                                    "description": "Vegetarian's favourite finger food.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/aeac450c-d789-4c00-a593-05e352a5b325_4eab783e-7b7d-4401-b8e4-64b1fba9bbf5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620310",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620314",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 5900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "733 ratings",
                                        "ratingCountV2": "733"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "44223344"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "101189921",
                                    "name": "Veggie Strips(5 Pcs)",
                                    "category": "Sides & Snacks",
                                    "description": "Qty: 85 Gms| Kcal: 246.8 | Carbs 30.1 Gms| Sugar: 3.5 Gms| Fat: 11.9 Gms| Saturated fat: 5.7 Gms| Protein: 4.8 Gms| Sodium: 441.4 Mg \nContains: Gluten, Soybean",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/aeac450c-d789-4c00-a593-05e352a5b325_4eab783e-7b7d-4401-b8e4-64b1fba9bbf5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620326",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620328",
                                        "groupName": "Add Peri Peri Spice Mix",
                                        "choices": [
                                          {
                                            "id": "138686357",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 5900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "733 ratings",
                                        "ratingCountV2": "733"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "44223344"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "96190550",
                                    "name": "Masala Hashbrown",
                                    "category": "Sides & Snacks",
                                    "description": "Fried golden brown potatoes with a desi masala twist.\nQty: 60 Gms| Kcal: 158 | Carbs 19.7 Gms| Sugar: 1 Gms| Fat: 8.1 Gms| Saturated fat: 3.9 Gms| Protein: 1.7 Gms| Sodium: 500 Mg\nContains: Gluten, Soybean",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/2b23de82-807f-4a2b-bf24-5819aeb95989_960f4062-c049-4bc2-b90b-69690014d5fe.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 4900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 4900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "31 ratings",
                                        "ratingCountV2": "31"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "87881503"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178512869",
                                    "name": "Crunchy Chicken Nuggets (4pcs)+Fiery Hell Dip.",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/8e815112-c3f4-4fe7-b7ed-fd14f2cab12b_2820009c-d7f3-4d84-85f8-3787c79faec2.jpg",
                                    "inStock": 1,
                                    "price": 13281,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "235396618",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "235396619",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 13281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447816"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "134901976",
                                    "name": "(6Pc) Crunchy Chicken Nuggets + 1 Dip.",
                                    "category": "Sides & Snacks",
                                    "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection. Served with Fiery Hell Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/288d04c7-6633-4b69-be5f-fe40bf60260c_0927498f-9490-4c91-944a-568ca366a0bf.jpg",
                                    "inStock": 1,
                                    "price": 20281,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620346",
                                        "groupName": "Choose your Dip",
                                        "choices": [
                                          {
                                            "id": "138686209",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686210",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686206",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "234620350",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620354",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 20281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "76887148"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "134901978",
                                    "name": "(6Pc) Crunchy Chicken Nuggets + 1 Dip",
                                    "category": "Sides & Snacks",
                                    "description": "Tender Crunchy Chicken Nuggets Fried To Golden Brown Perfection. Served With 1 Dip \nQty: 126 Gms| Kcal: 336.9 | Carbs 25 Gms| Sugar: 2.2 Gms| Fat: 18.8 Gms| Saturated fat: 7 Gms| Protein: 16.8 Gms| Sodium: 283 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/288d04c7-6633-4b69-be5f-fe40bf60260c_0927498f-9490-4c91-944a-568ca366a0bf.jpg",
                                    "inStock": 1,
                                    "price": 20281,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620366",
                                        "groupName": "Choose your Dip",
                                        "choices": [
                                          {
                                            "id": "138686209",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686210",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686206",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 20281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "76887148"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "176109136",
                                    "name": "(9Pc) Crunchy Chicken Nuggets + 2 Dips,",
                                    "category": "Sides & Snacks",
                                    "description": "Qty: 200 Gms | Kcal: 548.3 | Carbs 39.3 Gms | Sugar: 4 Gms | Fat: 32 Gms | Saturated fat: 11.2 Gms | Protein: 25.4 Gms | Sodium: 401.3 Mg \nContains: , Soybean , Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/67907cea-ff0a-4757-969f-a14247e10ef7_cbf8279c-162c-4fc6-9e77-78424dc78c2f.jpg",
                                    "inStock": 1,
                                    "price": 25662,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620381",
                                        "groupName": "Choose your 1st Dip",
                                        "choices": [
                                          {
                                            "id": "138686407",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686408",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686213",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "234620385",
                                        "groupName": "Choose your 2nd Dip.",
                                        "choices": [
                                          {
                                            "id": "138686215",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686211",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686204",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "234620389",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620393",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 25662,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "76887149"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "176109137",
                                    "name": "(9Pc) Crunchy Chicken Nuggets + 2 Dips",
                                    "category": "Sides & Snacks",
                                    "description": "Tender Crunchy Chicken Nuggets Fried To Golden Brown Perfection. Served With 2 Dips Of Your Choice \nQty: 200 Gms| Kcal: 548.3 | Carbs 39.3 Gms| Sugar: 4 Gms| Fat: 32 Gms| Saturated fat: 11.2 Gms| Protein: 25.4 Gms| Sodium: 401.3 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/67907cea-ff0a-4757-969f-a14247e10ef7_cbf8279c-162c-4fc6-9e77-78424dc78c2f.jpg",
                                    "inStock": 1,
                                    "price": 20900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620406",
                                        "groupName": "Choose your 1st Dip",
                                        "choices": [
                                          {
                                            "id": "138686407",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686408",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686213",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "234620409",
                                        "groupName": "Choose your 2nd Dip.",
                                        "choices": [
                                          {
                                            "id": "138686215",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686211",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686204",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 20900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "76887149"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748546",
                                    "name": "(18Pcs) Crunchy Chicken Nuggets + 3 Dips",
                                    "category": "Sides & Snacks",
                                    "description": "Tender Crunchy Chicken Nuggets Fried To Golden Brown Perfection. Served With 3 Dips Of Your Choice \nQty: 380 Gms| Kcal: 1015.3 | Carbs 75.5 Gms| Sugar: 6.7 Gms| Fat: 56.7 Gms| Saturated fat: 21.1 Gms| Protein: 50.6 Gms| Sodium: 608.7 Mg \nContains: Soybean, Milk",
                                    "imageId": "065958a42817fb100d88d3c11d169cfb",
                                    "inStock": 1,
                                    "price": 34900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311650",
                                        "groupName": "Choose your 1st Dip",
                                        "choices": [
                                          {
                                            "id": "138686407",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686408",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686213",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "237311651",
                                        "groupName": "Choose your 2nd Dip.",
                                        "choices": [
                                          {
                                            "id": "138686215",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686211",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686204",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "237311652",
                                        "groupName": "Choose your 3rd Dip",
                                        "choices": [
                                          {
                                            "id": "139076383",
                                            "name": "Chilli Oregano Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "139076381",
                                            "name": "Saucy Jalapeno Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "139076382",
                                            "name": "Fiery Hell Dip",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 34900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "76887146"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895668"
                          },
                          {
                            "title": "Chicken Wings",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64907481",
                                    "name": "Boneless Wings Regular",
                                    "category": "Sides & Snacks",
                                    "description": "4Pcs Boneless Chicken Bites \nQty: 95 Gms| Kcal: 213 | Carbs 16 Gms| Sugar: 0 Gms| Fat: 9.2 Gms| Saturated fat: 5.2 Gms| Protein: 16.8 Gms| Sodium: 555 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/9d569500-1505-4d4c-a25b-cad67011116e_0572632e-672d-4a13-b94c-d2b815e7b210.jpg",
                                    "inStock": 1,
                                    "price": 16900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620426",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 16900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "119 ratings",
                                        "ratingCountV2": "119"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "10378575"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "110694101",
                                    "name": "Boneless Wings Regular.",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/9d569500-1505-4d4c-a25b-cad67011116e_0572632e-672d-4a13-b94c-d2b815e7b210.jpg",
                                    "inStock": 1,
                                    "price": 16900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620431",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "234620436",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 16900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "119 ratings",
                                        "ratingCountV2": "119"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10378575"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64907480",
                                    "name": "Boneless Wings Large",
                                    "category": "Sides & Snacks",
                                    "description": "7Pcs Boneless Chicken Bites \nQty: 165 Gms| Kcal: 371 | Carbs 27.9 Gms| Sugar: 0 Gms| Fat: 16 Gms| Saturated fat: 9.1 Gms| Protein: 29.2 Gms| Sodium: 963.8 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/7a1ef1a7-8d6b-4126-9658-8e953901fa37_c8fc335b-7b6d-45ff-8843-cbeaf10fb9d8.jpg",
                                    "inStock": 1,
                                    "price": 26900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620445",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 26900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "71 ratings",
                                        "ratingCountV2": "71"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "10378574"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748547",
                                    "name": "Chicken Wings Fried - Two Pieces",
                                    "category": "Sides & Snacks",
                                    "description": "Chicken Wings Fried To Perfection. \nQty: 70 Gms| Kcal: 150 | Carbs 8.1 Gms| Sugar: 0 Gms| Fat: 9.3 Gms| Saturated fat: 3.6 Gms| Protein: 15.9 Gms| Sodium: 404 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/bc4b7857-eaed-4186-8283-56ce3f43cc2f_7f032f25-ae37-4eff-9815-c8301b85b831.jpg",
                                    "inStock": 1,
                                    "price": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "10379004"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748548",
                                    "name": "Chicken Wings Fried - 2pcs.",
                                    "category": "Sides & Snacks",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/bc4b7857-eaed-4186-8283-56ce3f43cc2f_7f032f25-ae37-4eff-9815-c8301b85b831.jpg",
                                    "inStock": 1,
                                    "price": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "237311653",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "237311654",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 9900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "92447812"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "90032170",
                                    "name": "Chicken Wings Fried - Ten Pieces",
                                    "category": "Sides & Snacks",
                                    "description": "Chicken Wings Fried To Perfection. \nQty: 350 Gms| Kcal: 750 | Carbs 40.1 Gms| Sugar: 0 Gms| Fat: 47 Gms| Saturated fat: 18.5 Gms| Protein: 79.9 Gms| Sodium: 2020 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/3549624e-e8c0-4d62-af4d-dbb4db34523b_5c26679f-f445-4e09-a710-412c3970ac2a.jpg",
                                    "inStock": 1,
                                    "price": 39900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 39900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379003"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "90032175",
                                    "name": "Chicken Wings Fried - Fifteen Pieces",
                                    "category": "Sides & Snacks",
                                    "description": "Chicken Wings Fried To Perfection. \nQty: 525 Gms| Kcal: 1125 | Carbs 60.8 Gms| Sugar: 0 Gms| Fat: 69.8 Gms| Saturated fat: 27 Gms| Protein: 119.3 Gms| Sodium: 3030 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/3549624e-e8c0-4d62-af4d-dbb4db34523b_5c26679f-f445-4e09-a710-412c3970ac2a.jpg",
                                    "inStock": 1,
                                    "price": 57900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 57900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378999"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560471",
                                    "name": "Korean Spicy Chicken (4 Pc)!",
                                    "category": "Sides & Snacks",
                                    "description": "\"Boneless Chicken dunked in hot and sweet Korean glaze.\nQty: 155 Gms| Kcal: 350.176 | Carbs 27.51 Gms| Sugar: 0 Gms| Fat: 15.5 Gms| Saturated fat: 5.75 Gms| Protein: 25.16 Gms| Sodium: 1592.60 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/d498fc01-a040-415d-9c02-b03f92510110_3708ee5c-620f-4ce1-b08c-f401c2f43865.jpg",
                                    "inStock": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703667"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560472",
                                    "name": "Korean Spicy Chicken (7 Pc)!",
                                    "category": "Sides & Snacks",
                                    "description": "\"Boneless Chicken dunked in hot and sweet Korean glaze. \nQty: 221 Gms| Kcal: 595.04 | Carbs 24.77 Gms| Sugar: 0 Gms| Fat: 39.89 Gms| Saturated fat: 15.25 Gms| Protein: 34.23 Gms| Sodium: 2188.96 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/a56db8d4-9277-4fc2-bbf6-80e8d79239e3_e8fa79df-a7f7-4cd2-8489-545486a41ab2.jpg",
                                    "inStock": 1,
                                    "price": 29900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703669"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168560473",
                                    "name": "Korean Spicy Chicken Wings (4pc)!",
                                    "category": "Sides & Snacks",
                                    "description": "\"Chicken Wings dunked in hot and sweet Korean glaze.\nQty: 172 Gms| Kcal: 496.80 | Carbs 28.19 Gms| Sugar: 0 Gms| Fat: 30.34 Gms| Saturated fat: 11.04 Gms| Protein: 27.74 Gms| Sodium: 2714.33 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/1684f75d-21d6-4266-8d10-ee930c4b89fd_a81918a9-0807-489c-bcec-72d00d495c94.jpg",
                                    "inStock": 1,
                                    "price": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "101703671"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895669"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/3408bb90-e96a-42e3-abe2-0381dd1230d1_08dadded-e4ce-4be6-8ff9-0935033d8887.jpg",
                        "categoryId": "64895652"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "BK Café (Coffee & Shakes)",
                        "categories": [
                          {
                            "title": "Cold Beverages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177019641",
                                    "name": "BK Fusion Shake (made with Kit Kat),",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Made with Kit Kat, enjoy our rich creamy fusion thick shake.\n\nQty: 378 gms| Kcal: 703 | Carbs: 119 gms| Sugar: 71 gms| Fat: 19 gms| Saturated fat: 14 gms| Protein: 15 gms|",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/c2f29287-024d-459a-b976-ab79f0999c4c_a73a5a21-c43e-4597-beb4-300e348520b8.png",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 27900,
                                    "finalPrice": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "235396624",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 27900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "offerIds": [
                                      "708aaa41-b0d7-406d-a347-114e61f457ea"
                                    ],
                                    "parentId": "106949913"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020868",
                                    "name": "Ice Latte.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/91baf345-275a-4914-8b1f-0db0ca0afb6e_cd56f161-3505-4b10-b43b-b022f9ee5ea1.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620470",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "92447817"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020869",
                                    "name": "Iced Latte",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "100% Arabica Espresso poured over milk and ice. | Qty: 330 Gms| Kcal: 141.9 | Carbs 22.18 Gms| Sugar: 19.47 Gms| Fat: 2.97 Gms| Saturated fat: 0 Gms| Protein: 6.3 Gms| Sodium: 6.17 Mg\nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/91baf345-275a-4914-8b1f-0db0ca0afb6e_cd56f161-3505-4b10-b43b-b022f9ee5ea1.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "86736132"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020870",
                                    "name": "Classic Cold Coffee.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature BK Café Coffee ice blended with milk & cream",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/cb0437d2-713a-4f0a-86e0-d4c09522fb47_4c9ccd82-0b11-4103-a334-a9ddea879c49.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620487",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "39984137"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020871",
                                    "name": "Classic Cold Coffee",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature BK Café Coffee ice blended with milk & cream. Qty: 350 Gms| Kcal: 215 | Carbs 24.2 Gms| Sugar: 8.9 Gms| Fat: 9.5 Gms| Saturated fat: 21 Gms| Protein: 7 Gms| Sodium: 140 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/cb0437d2-713a-4f0a-86e0-d4c09522fb47_4c9ccd82-0b11-4103-a334-a9ddea879c49.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984137"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "25407601",
                                    "name": "Chocolate Thick Shake",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Qty:  Gms300 ML| Kcal: 496.08 | Carbs 87.69 Gms| Sugar: 61.44 Gms| Fat: 11.28 Gms| Saturated fat: 7.17 Gms| Protein: 10.95 Gms| Sodium: 10.68 Mg \nContains: , Soybean , Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/cddbd1f0-c2fc-4af3-a108-b482cc0027e2_0564277b-594b-4aa9-a7cd-6796803092fc.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "333 ratings",
                                        "ratingCountV2": "333"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379036"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "110694099",
                                    "name": "Chocolate Shake.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature chocolate thick shake.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/cddbd1f0-c2fc-4af3-a108-b482cc0027e2_0564277b-594b-4aa9-a7cd-6796803092fc.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620517",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "66 ratings",
                                        "ratingCountV2": "66"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379035"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "25407599",
                                    "name": "Mango Thick Shake",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Mango Thick Shake. \nQty: 300 ML| Kcal: 393.3 | Carbs 65.2 Gms| Sugar: 57.5 Gms| Fat: 10 Gms| Saturated fat: 6.4 Gms| Protein: 10.7 Gms| Sodium: 8.9 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/8b4f61be-e218-4a8e-8548-193b08dc6a37_84575246-015c-471f-9d5b-28d4c90c0c49.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "122 ratings",
                                        "ratingCountV2": "122"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379498"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "110694098",
                                    "name": "Mango Shake.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature mango thick shake.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/8b4f61be-e218-4a8e-8548-193b08dc6a37_84575246-015c-471f-9d5b-28d4c90c0c49.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620536",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "35 ratings",
                                        "ratingCountV2": "35"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "10379497"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "71898488",
                                    "name": "Berry Blast Thick Shake",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Black Currant Thick Shake \nQty: 300 ML| Kcal: 474 | Carbs 90.9 Gms| Sugar: 68.2 Gms| Fat: 8.8 Gms| Saturated fat: 6 Gms| Protein: 7.9 Gms| Sodium: 150.9 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/689abf51-2fb7-4b92-8cae-e629dce1ea23_d5f2c362-edb4-4ab8-b87c-2cd708c668c5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "94 ratings",
                                        "ratingCountV2": "94"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378434"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020872",
                                    "name": "Iced Americano",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature Arabica espresso with ice\nQty: 330 GmsML| Kcal: 9.9 | Carbs 0.19 Gms| Sugar: 0 Gms| Fat: 0 Gms| Saturated fat: 0 Gms| Protein: 2.31 Gms| Sodium: 4.7 Mg",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/e65fb3cd-394a-46aa-9e59-687fcde7a77f_c0ca8252-72e9-420b-b4b1-974b8e6b1db5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "82675973"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895670"
                          },
                          {
                            "title": "Hot Beverages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172020873",
                                    "name": "Masala Chai",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Masala Chai \nQty: 200 Gms| Kcal: 84 | Carbs 15.8 Gms| Sugar: 1.1 Gms| Fat: 2.7 Gms| Saturated fat: 11.2 Gms| Protein: 0.7 Gms| Sodium: 36.2 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/63049b6a-d048-4d69-b625-07c395431dc2_ccfe6fd3-2656-4522-ad53-76464c3cc286.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 10900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "61389173"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170847896",
                                    "name": "Cappuccino Small.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/8fd81f5a-696a-49d2-848b-cb625c422361_6c43b654-322c-493f-9a28-75def2eb4dd9.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620560",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "40306957"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726767",
                                    "name": "Cappuccino (Small)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Small Cappuccino @ 99 \nQty: 240 Gms| Kcal: 101 | Carbs 9.8 Gms| Sugar: 4.3 Gms| Fat: 5.8 Gms| Saturated fat: 0 Gms| Protein: 3 Gms| Sodium: 72 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/8fd81f5a-696a-49d2-848b-cb625c422361_6c43b654-322c-493f-9a28-75def2eb4dd9.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620568",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "40306957"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726768",
                                    "name": "Café Latte (Small)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Bk Café© Coffee With Steamed Milk. \nQty: 240 Gms| Kcal: 110 | Carbs 9.8 Gms| Sugar: 4.9 Gms| Fat: 6.5 Gms| Saturated fat: 0 Gms| Protein: 3.4 Gms| Sodium: 79.2 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/269763e3-57e2-408c-8794-fa1d93f6557f_1f856e6d-1ae2-4189-a2ee-9632454304bd.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620584",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984129"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177324787",
                                    "name": "Hot Chocolate.",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Hot Chocolate",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/09364f2c-4eb0-46e7-a1c7-f66817f4cfb1_2836124a-4d46-4a81-914e-b100fbcf710c.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620594",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "39984142"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177324788",
                                    "name": "Hot Chocolate",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Creamy Chocolate With Steamed Milk. \nQty: 240 Gms| Kcal: 209 | Carbs 36.2 Gms| Sugar: 4.2 Gms| Fat: 6.6 Gms| Saturated fat: 22.5 Gms| Protein: 2.9 Gms| Sodium: 81.6 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/09364f2c-4eb0-46e7-a1c7-f66817f4cfb1_2836124a-4d46-4a81-914e-b100fbcf710c.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984142"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726769",
                                    "name": "Cappuccino (Regular)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Espresso With Steamed Milk & Milk Froth. \nQty: 330 Gms| Kcal: 138.9 | Carbs 13.5 Gms| Sugar: 5.9 Gms| Fat: 7.9 Gms| Saturated fat: 0 Gms| Protein: 4.1 Gms| Sodium: 99 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/8fd81f5a-696a-49d2-848b-cb625c422361_6c43b654-322c-493f-9a28-75def2eb4dd9.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620608",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "40306956"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726770",
                                    "name": "Café Latte (Regular)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Bk Café© Coffee With Steamed Milk. \nQty: 330 Gms| Kcal: 151 | Carbs 13.5 Gms| Sugar: 6.8 Gms| Fat: 8.9 Gms| Saturated fat: 0 Gms| Protein: 4.8 Gms| Sodium: 108.9 Mg \nContains: Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/269763e3-57e2-408c-8794-fa1d93f6557f_1f856e6d-1ae2-4189-a2ee-9632454304bd.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620615",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984128"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560359",
                                    "name": "Mocha Cappuccino (Small).",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/4cbfee8b-6c9d-41b4-9f1e-cacffd38bc85_0240561a-17e0-4168-883c-640554b20242.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620623",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "65448292"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560360",
                                    "name": "Mocha Cappuccino (Small)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Bk Café© Coffee With Chocolate Flavour \nQty: 240 Gms| Kcal: 246 | Carbs 41 Gms| Sugar: 6.6 Gms| Fat: 5.8 Gms| Saturated fat: 26.4 Gms| Protein: 4.3 Gms| Sodium: 57.6 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/4cbfee8b-6c9d-41b4-9f1e-cacffd38bc85_0240561a-17e0-4168-883c-640554b20242.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620633",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65448292"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560361",
                                    "name": "Mocha Cappuccino (Regular)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our Signature Bk Café© Coffee With Chocolate Flavour \nQty: 330 Gms| Kcal: 338.5 | Carbs 56.4 Gms| Sugar: 9 Gms| Fat: 7.9 Gms| Saturated fat: 36.4 Gms| Protein: 5.9 Gms| Sodium: 79.2 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/4cbfee8b-6c9d-41b4-9f1e-cacffd38bc85_0240561a-17e0-4168-883c-640554b20242.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620637",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65448291"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726771",
                                    "name": "Americano (Regular)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature BK Café Coffee with Hot Water.",
                                    "imageId": "xarekgjg37pajk0gksq4",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 18900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620647",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984124"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "170726772",
                                    "name": "Americano (Small)",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "Our signature BK Café Coffee with Hot Water.",
                                    "imageId": "xarekgjg37pajk0gksq4",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 15900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "234620651",
                                        "groupName": "Add Extra Shot",
                                        "choices": [
                                          {
                                            "id": "138686220",
                                            "name": "Extra Shot",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "39984125"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "184339651",
                                    "name": "Brew & Bite Combo",
                                    "category": "BK Café (Coffee & Shakes)",
                                    "description": "\"Choose a Muffin of your choice with Cappuccino (S).\n\nQty: 300 gms| Kcal: 345 | Carbs: 44 gms| Sugar: 17 gms| Fat: 17 gms| Saturated fat: 5 gms| Protein: 6 gms| Sodium: 391 mg\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/10/38a2d64f-73b7-4477-9ea4-2f09b311344a_47b474cb-8083-4efe-9c1d-74b6f98b03ee.jpg",
                                    "inStock": 1,
                                    "price": 28800,
                                    "finalPrice": 13900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "247658536",
                                        "groupName": "Choice of any 1 Muffin",
                                        "choices": [
                                          {
                                            "id": "140219630",
                                            "name": "Vanilla Chocolate Muffin",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219631",
                                            "name": "Choco Chip Muffin",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "247658535",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686349",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686240",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686243",
                                            "name": "4 Pc Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219627",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686242",
                                            "name": "Veggie Strips (5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686244",
                                            "name": "Saucy Fries",
                                            "price": 14500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "140219628",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686246",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686224",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686392",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 28800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "111986411"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895671"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/c2f29287-024d-459a-b976-ab79f0999c4c_a73a5a21-c43e-4597-beb4-300e348520b8.png",
                        "categoryId": "64895653"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Value Meals (Save Upto 47%)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154826065",
                                "name": "Crispy Chicken Meal.",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Signature Sauce. Served with Crispy Fries & Coke.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2640f0fb-99b6-4dc9-9dde-02cdd5c5e9fe_220d8d52-033c-41a6-ac1a-23c0893a3c9d.jpg",
                                "inStock": 1,
                                "price": 28400,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620660",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620658",
                                    "groupName": "Selected Burger - Crispy Chicken",
                                    "choices": [
                                      {
                                        "id": "138686299",
                                        "name": "Selected - Crispy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620665",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620662",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 28400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "92340527"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154826064",
                                "name": "Crispy Veg Meal.",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crispy Veg Patty, Fresh Onion and Signature Sauce. Served with Crispy Fries & Coke.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e1b67656-a09d-4385-a207-05d3c801736e_315b2548-137c-4c4f-836c-3fa4704979d7.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25500,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620673",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620669",
                                    "groupName": "Selected Burger - Crispy Veg ",
                                    "choices": [
                                      {
                                        "id": "138686298",
                                        "name": "Selected - Crispy Veg",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620680",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620676",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "92340528"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154826067",
                                "name": "Veg Makhani Burst Meal.",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Veg Patty, Fresh Onion and Makhani Sauce. Served with Crispy Fries & Coke.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/66fb90b0-752c-4528-b258-0488d2ef80e7_7dae9f2a-1d45-4a05-8843-4c8e62477a11.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 26500,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620691",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620687",
                                    "groupName": "Selected Burger - Veg Makhani Burst",
                                    "choices": [
                                      {
                                        "id": "138686297",
                                        "name": "Selected - Veg Makhani Burst",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620693",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620692",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "25 ratings",
                                    "ratingCountV2": "25"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "92340530"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154826066",
                                "name": "Crunchy Veg Taco+Veggie Strips+Coke.",
                                "category": "Value Meals (Save Upto 47%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/23/bc33dda7-2245-47f1-8153-500fae952349_c15f605f-2076-4412-bfb0-84dbbb716da5.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 24400,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311657",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 24400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "92340529"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154826063",
                                "name": "Veg Puff Meal.",
                                "category": "Value Meals (Save Upto 47%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/23/35b029f1-b617-42b0-a742-37d4b2047ff4_66f74e81-91b2-4189-9f2e-da21e342fab2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25000,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620710",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686371",
                                        "name": "Fries(Regular)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686391",
                                        "name": "Fries(M)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686393",
                                        "name": "Fries(L)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686375",
                                        "name": "Saucy Fries",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686378",
                                        "name": "Chicken Nuggets(4pcs)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620709",
                                    "groupName": "Selected - Veg Pizza Puff",
                                    "choices": [
                                      {
                                        "id": "138686294",
                                        "name": "Selected - Veg Pizza Puff",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234620714",
                                    "groupName": "Best Seller Add-ons",
                                    "choices": [
                                      {
                                        "id": "138686398",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142148148",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686397",
                                        "name": "Chicken Wings Fried (2pcs)",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686403",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686394",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686399",
                                        "name": "Veggie Strips (5pcs)",
                                        "price": 5900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686396",
                                        "name": "Masala Hashbrown",
                                        "price": 4900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686402",
                                        "name": "Chocolava Cup",
                                        "price": 10900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620712",
                                    "groupName": "Choose Your Beverage",
                                    "choices": [
                                      {
                                        "id": "138686379",
                                        "name": "Coke",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686376",
                                        "name": "Chocolate Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686377",
                                        "name": "Classic Cold Coffee",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686383",
                                        "name": "Mango Thick Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686384",
                                        "name": "Iced Latte",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686381",
                                        "name": "Berry Blast Shake",
                                        "price": 7900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686382",
                                        "name": "Thums up",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "92340531"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "166233416",
                                "name": "Crispy Chicken Burger Peri Peri Meal (R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Crispy Chicken Burger+Peri Peri Fries( R)+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/62d2a821-d442-4204-9800-fc1a79c7627c_b39ac354-cb40-4115-aa49-e35e74793f0b.jpg",
                                "inStock": 1,
                                "price": 31257,
                                "finalPrice": 15600,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450365",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 31257,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "7ddbe424-6111-41a7-b169-3c9be1f80d71"
                                ],
                                "parentId": "100153256"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "186880381",
                                "name": "Crispy Veg Burger Peri Peri Meal (R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Crispy Veg Burger+Peri Peri Fries( R)+Coke",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e0ca39c1-9ba4-4444-b0a4-aba37764620f_f238679e-1f8f-4b4f-8299-e767f9e24fb9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 28357,
                                "finalPrice": 14100,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450366",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 28357,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "22 ratings",
                                    "ratingCountV2": "22"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "804ef7d3-dfd8-4a4c-bf65-fe4b4d855df1"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "105284773"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "186880382",
                                "name": "2BK Veggie Burger +2Peri Peri Fries(R)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "2BK Veggie+2Peri Peri Fries( R)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/cff7cf49-a98c-443e-ab2e-a1ecb3953ad2_cba1b763-c241-4ca9-ac6c-f69e23e3d427.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 51514,
                                "finalPrice": 25700,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "254450367",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 51514,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f8f11c7a-97c0-4073-9ddc-b92a08b47627"
                                ],
                                "parentId": "105284772"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154974898",
                                "name": "Veg Whopper Deluxe Med Meal,",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces. Served with Fries and Coke\nQty: 759 gms| Kcal: 1014 | Carbs: 142 gms| Sugar: 58 gms| Fat: 41 gms| Saturated fat: 16 gms| Protein: 17 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b5c6a2d6-ffaa-4859-9349-c6f83122ec99_b5614192-bbc5-4dec-a3d0-4691946f825f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 36300,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620723",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36300,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503555"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150516830",
                                "name": "BK Veggie Burger+Fries(Reg)+Coca Cola,",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Mix Veg Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo. Served with Crispy Fries & Coke.\nKcal: 683.63 | Carbs 353.64 Gms | Sugar: 42.39 Gms | Fat: 22.48 Gms | Saturated fat: 8.88 Gms | Protein: 15.6 Gms | Sodium: 944.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/98334075-06d5-4e36-b48a-5e6a760f6a95_dbc612a1-8f39-47cd-8923-277c7b281423.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 32400,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620737",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686351",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686258",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686260",
                                        "name": "4 Pc Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686355",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686236",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686257",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686259",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686262",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686241",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686261",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686323",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686324",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686389",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686333",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "80799722"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "154974897",
                                "name": "Crispy Veg Double Patty Meal,",
                                "category": "Value Meals (Save Upto 47%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/966239d4-53a0-4c02-b7db-e612aac1cfc9_2b749c0c-813c-4dbb-9137-8a92570d4ccc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 30300,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620748",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30300,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "92447815"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147177312",
                                "name": "Chicken Makhani Burst+Fries(Reg)+Coke,",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Makhani Sauce. Served with Crispy Fries & Coke.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/a947f3f0-200b-4d4f-b979-1e9581ed0e5a_03cbd401-1464-4758-80a7-4c27a44156a8.jpg",
                                "inStock": 1,
                                "price": 29400,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620759",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "87092318"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "33875740",
                                "name": "Crispy Veg Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crispy Veg Patty, Fresh Onion and Signature Sauce. Served with Crispy Fries & Coke.\nKcal: 888.7 | Carbs 547.9 Gms| Sugar: 54.2 Gms| Fat: 27.2 Gms| Saturated fat: 11.7 Gms| Protein: 14.3 Gms| Sodium: 1365.3 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e1b67656-a09d-4385-a207-05d3c801736e_315b2548-137c-4c4f-836c-3fa4704979d7.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620771",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620774",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620775",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620778",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "48 ratings",
                                    "ratingCountV2": "48"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "95901578"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "23659513",
                                "name": "Original Whopper Veg Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Our Signature Whopper with Crunchy Veg Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Served With Crispy Fries & Coca Cola. \nKcal: 1203.8 | Carbs 594.5 Gms| Sugar: 75.1 Gms| Fat: 39.8 Gms| Saturated fat: 16.6 Gms| Protein: 21.7 Gms| Sodium: 1554.6 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/1a11a3a3-d8da-46da-919a-46ca2bd42d59_6b264f2f-db5f-4de0-8c3a-94b3a382e0bb.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 32800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620796",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620799",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620801",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620804",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "102401027"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62382602",
                                "name": "Original Whopper Chicken Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Our Signature Whopper with Flame Grilled Chicken Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces With Xxl Buns. Served With Crispy Fries & Coca Cola. \nKcal: 1189.8 | Carbs 556.5 Gms| Sugar: 60.7 Gms| Fat: 50.7 Gms| Saturated fat: 14.9 Gms| Protein: 32.1 Gms| Sodium: 1585.5 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/0ec9f40e-3298-498c-be28-993de57d63d4_75dcfa9f-f5c9-4fdc-b69c-dbabed959185.jpg",
                                "inStock": 1,
                                "price": 35800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620815",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620818",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620820",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620823",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 35800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "102401019"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62382616",
                                "name": "Veg Whopper Deluxe Meal (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces. Served with Fries and Coke.\nQty: 759 gms| Kcal: 1014 | Carbs: 142 gms| Sugar: 58 gms| Fat: 41 gms| Saturated fat: 16 gms| Protein: 17 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/5/b5c6a2d6-ffaa-4859-9349-c6f83122ec99_b5614192-bbc5-4dec-a3d0-4691946f825f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 26800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620836",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620840",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620844",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620848",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503554"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "32868548",
                                "name": "Crispy Chicken Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crispy Chicken Patty, Fresh Onion and Signature Sauce. Served with Crispy Fries & Coke.\nKcal: 881.7 | Carbs 541.7 Gms| Sugar: 59.5 Gms| Fat: 29.5 Gms| Saturated fat: 11.6 Gms| Protein: 17.4 Gms| Sodium: 1159.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2640f0fb-99b6-4dc9-9dde-02cdd5c5e9fe_220d8d52-033c-41a6-ac1a-23c0893a3c9d.jpg",
                                "inStock": 1,
                                "price": 26700,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620860",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620864",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620870",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620875",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 26700,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "95901577"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "89832070",
                                "name": "Chicken Tandoori Burger Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Flame Grilled Tandoori Chicken Patty, Veg Khurchan in premium Brioche Buns. Served With Crispy Fries & Coke. \nKcal: 1025.3 | Carbs 560.1 Gms| Sugar: 58.9 Gms| Fat: 29.4 Gms| Saturated fat: 15.6 Gms| Protein: 35.3 Gms| Sodium: 1673.6 Mg \nContains: Gluten, Soybean, Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/16a21654-e398-4138-a69a-143aad2d9904_fc339085-3c64-4869-92ff-50c9f4fb2943.jpg",
                                "inStock": 1,
                                "price": 35800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311658",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311659",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311660",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311661",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 35800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "95901575"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748556",
                                "name": "Hot 'N' Cheesy Burger Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Chilli Creamy Patty, Spicy Sauce, in premium Brioche Buns. Served With Crispy Fries & Coke.\nKcal: 1204.6 | Carbs 579.4 Gms| Sugar: 69.5 Gms| Fat: 45.8 Gms| Saturated fat: 18.9 Gms| Protein: 23.8 Gms| Sodium: 1765.3 Mg \nContains: Soybean, Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/23f7d986-c1a0-4342-abd9-065c0a1ceb49_37a412ce-5186-4726-82a9-cdfb3d423374.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 35800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311662",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311663",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311664",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311665",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106171551"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167873883",
                                "name": "BK Veggie Burger Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Mix Veg Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo. Served with Crispy Fries & Coke.\nKcal: 875.1 | Carbs 542.8 Gms| Sugar: 59.8 Gms| Fat: 28 Gms| Saturated fat: 11.5 Gms| Protein: 17.9 Gms| Sodium: 1160.6 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/98334075-06d5-4e36-b48a-5e6a760f6a95_dbc612a1-8f39-47cd-8923-277c7b281423.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "95901574"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62382612",
                                "name": "Grill Chicken Whopper Deluxe Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "Our Signature Whopper with Flame Grilled Chicken Patty, Onions, Lettuce, Tomatoes (Seasonal), Gherkins, Creamy And Smoky Sauces. Served With Crispy Fries & Coca Cola. \nKcal: 891.6 | Carbs 540.8 Gms| Sugar: 60.4 Gms| Fat: 28.1 Gms| Saturated fat: 13 Gms| Protein: 23.9 Gms| Sodium: 1881.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/1/1c35b5b4-1078-4aaf-9fe0-7b1ecc128999_1327b08b-3f64-4dce-a0e7-21f7db7b3b57.jpg",
                                "inStock": 1,
                                "price": 28800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620916",
                                    "groupName": "Choose Your Side",
                                    "choices": [
                                      {
                                        "id": "138686334",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686410",
                                        "name": "Medium Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686337",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686276",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686370",
                                        "name": "King Fries",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686409",
                                        "name": "King Peri Peri Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686401",
                                        "name": "Medium Peri Peri Fries",
                                        "price": 14400,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686372",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686232",
                                        "name": "Boneless Wings (4 Pcs)",
                                        "price": 16900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686223",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686321",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620922",
                                    "groupName": "Choose Your Beverages!!",
                                    "choices": [
                                      {
                                        "id": "138686249",
                                        "name": "Coca Cola Medium",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686331",
                                        "name": "Classic Cold Coffee",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686252",
                                        "name": "Chocolate Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686325",
                                        "name": "Berry Blast Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686248",
                                        "name": "Mango Thick Shake",
                                        "price": 18900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686264",
                                        "name": "Iced Latte",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686374",
                                        "name": "BK Fusion Shake (made with Kit Kat)",
                                        "price": 27900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686329",
                                        "name": "Mocha Frappe",
                                        "price": 26900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620926",
                                    "groupName": "Add Dessert",
                                    "choices": [
                                      {
                                        "id": "138686386",
                                        "name": "Choco Lava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686208",
                                        "name": "Chocolate Mousse Cup",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686388",
                                        "name": "Chocochip Muffin",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686366",
                                        "name": "BK Fusion Sundae (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620928",
                                    "groupName": "Choose Your Dip",
                                    "choices": [
                                      {
                                        "id": "138686346",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686234",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686280",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686288",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 28800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "113503545"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167873884",
                                "name": "BK Chicken Burger Combo (M)",
                                "category": "Value Meals (Save Upto 47%)",
                                "description": "New Premium Black & White Sesame Bun with Crunchy Chicken Patty, Lettuce, Tomato(Seasonal) & Our Signature Mayo. Served with Crispy Fries & Coke.\nKcal: 937.6 | Carbs 536.4 Gms| Sugar: 59.2 Gms| Fat: 35.6 Gms| Saturated fat: 14 Gms| Protein: 22.9 Gms| Sodium: 850.7 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/fd9e54bd-a061-4853-a3fb-ae63a63f7299_7e2003ab-bf6a-4aab-9c0e-6c0690ddc35a.jpg",
                                "inStock": 1,
                                "price": 28800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 28800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "95901573"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/2640f0fb-99b6-4dc9-9dde-02cdd5c5e9fe_220d8d52-033c-41a6-ac1a-23c0893a3c9d.jpg",
                        "categoryId": "64895654"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Exclusive Deals (Save upto 40%)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "148411213",
                                "name": "Crispy Veg Burger + BK Veg Pizza Puff.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4d7a4625-bda8-4368-82a2-5d8bba629414_7343bf77-fe2c-42c0-9f5f-d7af5f6eab15.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 13500,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620941",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620943",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686354",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686290",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686285",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686361",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686282",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686293",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686287",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686296",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686300",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686233",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686326",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686327",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686380",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "92 ratings",
                                    "ratingCountV2": "92"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "90842105"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "148411212",
                                "name": "Crispy Veg+Veggie Strips.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6cd92cf3-1bf0-4e25-91f9-79722fcbf678_e38497c9-33c2-4c7f-8aad-3e0b137dfef2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620951",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620953",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "16 ratings",
                                    "ratingCountV2": "16"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "87576610"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150392243",
                                "name": "BK Veg Pizza Puff+Coke.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/15b9d3a2-cde2-4ad0-a99e-017bd6163dde_c6c9f244-d3a4-4db9-abdd-992f47f0f7d9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16000,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234620974",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234620978",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686354",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686290",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686285",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686361",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686282",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686293",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686287",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686296",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686300",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686233",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686326",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686327",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686380",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "90842100"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694082",
                                "name": "Crispy Chicken + Crispy Chicken.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Crispy Chicken patty burger, our best seller. Enjoy Twice.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/c4afaacd-d922-4363-9a98-f77a4be55f7e_523f1c85-f88f-4f53-860f-f31d391bf403.jpg",
                                "inStock": 1,
                                "price": 19800,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "239046788",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046789",
                                    "groupName": "Selected Burger - Crispy Chicken",
                                    "choices": [
                                      {
                                        "id": "138686299",
                                        "name": "Selected - Crispy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "239046790",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046791",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046792",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046793",
                                    "groupName": "Selected Burger - Crispy Chicken.",
                                    "choices": [
                                      {
                                        "id": "138686363",
                                        "name": "Selected - Crispy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "161 ratings",
                                    "ratingCountV2": "161"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "36545265"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694093",
                                "name": "Veg Whopper Deluxe + Crispy Veg.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Veg Whopper Deluxe and Crispy Veg.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e6f315a7-5334-45f2-9cb9-60a0a9cdfdf2_f58dba9d-c3d5-4994-a5d9-69b31b0ea0e5.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621014",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621017",
                                    "groupName": "Selected Burger - Crispy Veg ",
                                    "choices": [
                                      {
                                        "id": "138686298",
                                        "name": "Selected - Crispy Veg",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621019",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621021",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621023",
                                    "groupName": "Selected - Whopper Jr Veg",
                                    "choices": [
                                      {
                                        "id": "138686205",
                                        "name": "Selected - Whopper Jr Veg",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621027",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "113503552"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694070",
                                "name": "Double Crispy Veg + Double Crispy Veg.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "crispy veg patty burger, our best seller! !",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ef18e36-f988-4b85-8fa2-75e1fa72406a_86684d36-3c2d-471a-a9cc-082870edc314.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 19800,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "239046794",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046795",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046796",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046797",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "239046798",
                                    "groupName": "Selected Burger - Crispy Veg Double Patty Burger",
                                    "choices": [
                                      {
                                        "id": "138686358",
                                        "name": "Selected - Crispy Veg Double Patty Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "239046799",
                                    "groupName": "Selected Burger - Crispy Veg Double Patty Burger.",
                                    "choices": [
                                      {
                                        "id": "138686359",
                                        "name": "Selected - Crispy Veg Double Patty Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "246 ratings",
                                    "ratingCountV2": "246"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "10379211"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "128841932",
                                "name": "2 BK Veggie Burgers,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/8d41b10b-e1d9-48f1-909d-a6fc26a97dcd_fc2b29e4-9da5-4a68-b0a2-e61fee7324b0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 27800,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621060",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621062",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 27800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "65328212"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694115",
                                "name": "BK Veggie Burger + Veg Taco.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/46e4b0f5-831f-41da-989c-8dccdc5ef95e_807f1634-4301-440b-b1e4-98341a7d0c40.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311676",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311677",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "53 ratings",
                                    "ratingCountV2": "53"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "65791710"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694103",
                                "name": "Veg Makhani Burst Burger+ Medium Peri Peri Fries.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Veg Makhani Burst Burger+ Medium Peri Peri Fries",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/a2fc2970-9933-460a-80fa-7593ee9154a4_b2e0960f-1aff-4db6-91b9-241d56b198fc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 22400,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621095",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621096",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 22400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "99 ratings",
                                    "ratingCountV2": "99"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "36545278"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "128841920",
                                "name": "Crispy Chicken + Chicken Nuggets (4Pcs).",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/1187a0d8-35f0-41ef-acb7-3c7d151f0110_13565add-65f9-4db1-8485-ec04bc2c536e.jpg",
                                "inStock": 1,
                                "price": 20800,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621108",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621110",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 20800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "27 ratings",
                                    "ratingCountV2": "27"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "74795533"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694114",
                                "name": "BK Veggie Burger + Crispy Veg Burger.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/38dd7e22-b98b-4958-9793-97b84f1dd5d8_90f0cc59-53a2-4a52-9d1a-cbcff22e870f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621117",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621122",
                                    "groupName": "Selected Burger - Crispy Veg ",
                                    "choices": [
                                      {
                                        "id": "138686298",
                                        "name": "Selected - Crispy Veg",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621126",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621130",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621132",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621134",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "264 ratings",
                                    "ratingCountV2": "264"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "10378535"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120716599",
                                "name": "Crispy Chicken Burger+Fries(M)",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Crispy Chicken Burger+Fries(M) \nQty: 239 Gms| Kcal: 691.6 | Carbs 489.7 Gms| Sugar: 7.5 Gms| Fat: 29.5 Gms| Saturated fat: 11.6 Gms| Protein: 17.4 Gms| Sodium: 1121.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "53601f4ac59713a4ee2f87de0ddc7cd7",
                                "inStock": 1,
                                "price": 21800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "69198426"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136952498",
                                "name": "2 Crunchy Veg Taco+Fries(M),",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Qty: 324 Gms | Kcal: 1004.7 | Carbs 0 Gms | Sugar: 128.2 Gms | Fat: 56 Gms | Saturated fat: 34.6 Gms | Protein: 13.1 Gms | Sodium: 1708 Mg \nContains: Gluten, Soybean , Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/26/4ef07b70-537e-43e1-853c-979b02f1aa03_c1425e37-7889-47e9-9335-b4d6c8309d7d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311678",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311679",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "80121927"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694076",
                                "name": "Crispy Chicken + Med Fries.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Crispy Chicken patty burger with fries on the side.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/6/403d8d68-e302-49be-aa69-999444801194_ab659491-bf9a-4687-98dc-226a276105e2.jpg",
                                "inStock": 1,
                                "price": 21800,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621172",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621175",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "65 ratings",
                                    "ratingCountV2": "65"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "36545266"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694124",
                                "name": "Crispy Veg Double Patty Burger+Veg Crunchy Taco.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/1470dec7-85c7-44c9-b496-f09e48c3a9c1_f4b7a888-0e3e-4821-a225-587b1c4014c0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311680",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311681",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "82 ratings",
                                    "ratingCountV2": "82"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "63221119"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "142693989",
                                "name": "Veg Whopper Deluxe + Pizza Puff.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces. + Pizza Puff",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/3/f28926cb-6812-4fd5-8c07-1df7b1588314_5934e31e-af86-4241-ab0b-31a30a780fcd.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21400,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621200",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621202",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686354",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686290",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686285",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686361",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686282",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686293",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686287",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686296",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686300",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686233",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686326",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686327",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686380",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 21400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "113503556"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "150516828",
                                "name": "Chicken Makhani Burst Burger+Fries(Reg)+Peri Peri Sachet.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/0baa774f-a333-485f-9a18-5ff9b7878a0b_4d648bb4-a895-4c6d-84dd-91948b93ea20.jpg",
                                "inStock": 1,
                                "price": 22757,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621214",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621217",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 22757,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "80623762"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120716600",
                                "name": "Crispy Veg Double Patty Burger+Fries(M)",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Crispy Veg Double Patty Burger+Fries(M) \nQty: 318 Gms| Kcal: 863.9 | Carbs 516 Gms| Sugar: 9.1 Gms| Fat: 37.1 Gms| Saturated fat: 16 Gms| Protein: 17.1 Gms| Sodium: 1596.8 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ca680cf-d5f0-41eb-ab25-d06762871215_cdbfe4dc-ddaf-4bb3-b2db-2156bfcb81c2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "69198429"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110694084",
                                "name": "1Crispy Veg Double Patty + 1Med Fries.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Double up the crispy veg patty burger in our best selling burger with fries on the side",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ca680cf-d5f0-41eb-ab25-d06762871215_cdbfe4dc-ddaf-4bb3-b2db-2156bfcb81c2.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21800,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621236",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621238",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 21800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "77 ratings",
                                    "ratingCountV2": "77"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "36545251"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147177308",
                                "name": "Crispy Chicken Burger+Peri Peri Fries(Reg).",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/98637694-34e7-4b39-b117-bb97c4f53e13_0ca8f051-575b-4238-9f59-9a10d0e6db7b.jpg",
                                "inStock": 1,
                                "price": 21757,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621248",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621253",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21757,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "87092319"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147177304",
                                "name": "BK Veggie Burger+Veg Makhani Burst Burger.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/e6c5514e-640e-4b02-80db-5eaa57af6bfe_fb402371-5bb4-4b05-ad80-2fae1b8303b4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 21900,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621265",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621266",
                                    "groupName": "Selected Burger - Veg Makhani Burst",
                                    "choices": [
                                      {
                                        "id": "138686297",
                                        "name": "Selected - Veg Makhani Burst",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621267",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621269",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621274",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621277",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "67446176"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "142693990",
                                "name": "BK Veggie Burger + BK Veg Pizza Puff.",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "BK Veggie Burger + Pizza Puff",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/666722e8-f247-4a24-9e20-d8504ad00f36_ffe7b747-7cb6-40ca-9507-ded3cb99e40d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 20400,
                                "finalPrice": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621290",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621291",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686354",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686290",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686285",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686361",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686282",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686293",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686287",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686296",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686300",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686233",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686326",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686327",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686380",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 20400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.9",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "edfc3a11-31f6-44e5-a46c-d459abe4934c"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "90842098"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147177317",
                                "name": "3 Veg Makhani Burst Burger,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/3f85dbb4-775a-4f3f-90f0-1135cb8fa858_923173d8-b41e-4253-9de1-0e3b40badf0f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 24000,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621317",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621319",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 24000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "87092317"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "128841940",
                                "name": "Crispy Chicken Burger + BK Chicken Burger,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/d09aef1e-2f14-475e-83fd-ff685e7ae12d_61060602-5a25-4220-b893-41d3e4bbb79d.jpg",
                                "inStock": 1,
                                "price": 24800,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621330",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621331",
                                    "groupName": "Selected Burger - Crispy Chicken",
                                    "choices": [
                                      {
                                        "id": "138686299",
                                        "name": "Selected - Crispy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621334",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621338",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621342",
                                    "groupName": "Selected - BK Chicken.",
                                    "choices": [
                                      {
                                        "id": "138686345",
                                        "name": "Selected - BK Chicken",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621345",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 24800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "67446184"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147177318",
                                "name": "2 Veg Crunchy Tacos+Crispy Veg Burger,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/09e90960-50ef-495f-badf-cfb6451d7e91_114b7ea7-31af-4eae-85a1-d0945087ff5a.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25000,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311682",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "87092316"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "128841937",
                                "name": "Veg Whopper Deluxe + Crunchy Veg Taco,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Reg. size bun with 7 layers of taste: Extra Crunchy Veg patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces.+ Crunchy Veg Taco",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/3/65727102-5711-4c7d-a1ab-452d2025e273_b4647309-3132-4513-a807-0f4a1b91738d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 23900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311683",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311684",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503553"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105418826",
                                "name": "Chocolate Thick Shake + Crispy Veg Burger,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "MRP. 259 | Save Rs. 90, Chocolate Thick Shake + Crispy Veg Burger",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/8a10ed4f-3c90-45c8-99c3-34a679fb2de7_ca3a6e35-1467-409d-a327-105657008e01.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621390",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621391",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "16 ratings",
                                    "ratingCountV2": "16"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "60138414"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "136952502",
                                "name": "BK Chicken+Crunchy Chicken Nuggets(4pcs),",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Qty: 234 Gms | Kcal: 583.7 | Carbs 53.3 Gms | Sugar: 7.5 Gms | Fat: 28.7 Gms | Saturated fat: 11 Gms | Protein: 27.9 Gms | Sodium: 289.8 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/36afb0ad-8643-4723-a164-553c7316edad_45e74e6d-45a5-46b5-866d-ec225b19d26c.jpg",
                                "inStock": 1,
                                "price": 25800,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621401",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621402",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686344",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686339",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686227",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686231",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219626",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686228",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686239",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686238",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686229",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686318",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686316",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686390",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686319",
                                        "name": "BK Chicken Pizza Puff",
                                        "price": 8900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "80121929"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176039502",
                                "name": "Grill Chicken Whopper Deluxe +Chicken Fried Wings(2pcs),",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "New Whopper Deluxe in premium glazed bun (regular size). 7 layers of taste: Flame-Grilled Chicken patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal) tangy gherkins, creamy & smoky sauces + Chicken Fried Wings(2pcs)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/3/5f707019-c84b-4c4b-bf18-5f63ca72131a_1d9207fb-af2b-4925-9550-3051aedae4f3.jpg",
                                "inStock": 1,
                                "price": 29800,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311685",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311686",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "113503544"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "171560362",
                                "name": "Crispy Veg Burger+Classic Cold Coffee,",
                                "category": "Exclusive Deals (Save upto 40%)",
                                "description": "Qty: 487 Gms | Kcal: 577.2 | Carbs 77.6 Gms | Sugar: 15.4 Gms | Fat: 22.3 Gms | Saturated fat: 25.8 Gms | Protein: 15.4 Gms | Sodium: 938.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/003cbb31-42d9-4687-909a-db8afd8d88f2_63e10813-ebc4-4966-bb04-6f7a34a0a175.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 26900,
                                "finalPrice": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621411",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621413",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "708aaa41-b0d7-406d-a347-114e61f457ea"
                                ],
                                "parentId": "80121937"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4d7a4625-bda8-4368-82a2-5d8bba629414_7343bf77-fe2c-42c0-9f5f-d7af5f6eab15.jpg",
                        "categoryId": "64895655"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Kings Collection ( Premium Burgers )",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748557",
                                "name": "Hot 'N' Cheesy Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "description": "Chilli Creamy Patty, Spicy Sauce, in premium Brioche buns.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/c686d35b-4bb8-4921-b9d4-ded351de228c_1ef2b796-68eb-4841-a27e-cefe5a42b7b4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311687",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311688",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "106171550"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "166827383",
                                "name": "Chicken Tandoori Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "description": "Flame Grilled Tandoori Chicken, Veg Khurchan in premium Brioche buns.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/f698dd95-0c49-426d-a50b-ad4bf815c865_708d59be-3b1c-4b80-8f4a-c95f1ac87a41.jpg",
                                "inStock": 1,
                                "price": 29900,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311689",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311690",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "45410938"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748558",
                                "name": "Hot 'N' Cheesy Burger+BK Veggie Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/1602fb55-1735-4d40-9eae-28c72feb48bc_81cd2c6d-ebba-4b64-bbcc-6957f67d25aa.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 43800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311691",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311692",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311693",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311694",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "237311695",
                                    "groupName": "Selected - Hot 'N' Saucy Burger",
                                    "choices": [
                                      {
                                        "id": "139076384",
                                        "name": "Hot 'N' Saucy Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "237311696",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 43800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106220298"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168569795",
                                "name": "Paneer Royale Wrap+BK Veggie Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/d967a7e4-054b-4ada-9cb2-799bf825b0fe_c51d9719-fd9f-428e-99cf-4a1f33a9e466.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 36800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621445",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621447",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "98594825"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "163856979",
                                "name": "Chicken Tandoori Burger+BK Chicken Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/f24e7aaf-0720-4498-8a60-88e5f6abca0c_f78a7a73-e4bb-419d-a528-879ad9b86078.jpg",
                                "inStock": 1,
                                "price": 44800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311697",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311698",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311699",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311700",
                                    "groupName": "Selected - BK Chicken.",
                                    "choices": [
                                      {
                                        "id": "138686345",
                                        "name": "Selected - BK Chicken",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "237311701",
                                    "groupName": "Selected - Chicken Tandoori Burger",
                                    "choices": [
                                      {
                                        "id": "139076385",
                                        "name": "Chicken Tandoori Burger",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "237311702",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 44800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "98594817"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "163856981",
                                "name": "Crunchy Chicken Wrap+BK Chicken Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/ec2e6dd0-1d93-4bbe-8bda-f394699d2163_fb0e4ad9-a536-409c-8a43-4d5a86e8d411.jpg",
                                "inStock": 1,
                                "price": 37800,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311703",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311704",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 37800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "101748309"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "163856984",
                                "name": "Grill Mutton Whopper Deluxe +Crispy Chicken Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "description": "Reg. size bun with 7 layers of taste: Flame Grilled Mutton patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy & smoky sauces + Crispy Chicken Burger.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/b2531aba-f8e6-4890-889f-c5637b4d5bd5_796f5f75-8437-4350-b51f-8364d582faf3.jpg",
                                "inStock": 1,
                                "price": 31800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621491",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621495",
                                    "groupName": "Selected Burger - Crispy Chicken",
                                    "choices": [
                                      {
                                        "id": "138686299",
                                        "name": "Selected - Crispy Chicken Burger",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621498",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621502",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621504",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621506",
                                    "groupName": "Selected Burger - Mutton Whopper Jr",
                                    "choices": [
                                      {
                                        "id": "138686364",
                                        "name": "Selected - Mutton Whopper Jr",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 31800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "113503548"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "178512870",
                                "name": "Boneless Wings(7pcs)+Fiery Hell Dip.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/d222eedd-dec7-4e26-a1d5-3b738a9cc0a4_2545bf75-f9c3-41e8-9796-44883dd6835b.jpg",
                                "inStock": 1,
                                "price": 29281,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396635",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29281,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "98594816"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "170726773",
                                "name": "Original Whopper Veg(XL size Bun)+Chocolate Thick Shake.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/13/ef7050bb-f948-493c-ba7c-41ee95b2f546_56ff4c22-3e31-46af-abb5-a408cba6db07.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 37800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621513",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621516",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 37800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278679"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120716610",
                                "name": "Original Whopper Chicken(XL size Bun)+Fries(M).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/13/ae5d81b5-ab5c-4fe6-990f-939826a1cce7_14b4c48a-29f2-4216-8ef5-4cb7178c2238.jpg",
                                "inStock": 1,
                                "price": 32800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621524",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621527",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 32800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278677"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167403908",
                                "name": "Original Whopper Veg(XL size Bun) Meal(Reg).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/3b9b0f22-4aec-4e7f-924c-e9dfc5eecb7f_9753f05d-eb7d-44ad-8668-3d04ef845a4b.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 37400,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621536",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 37400,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278680"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748560",
                                "name": "Hot 'N' Cheesy Burger+Fries(M).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/83e21bbb-ddf6-4ccd-b15a-17fd4581c239_5ce64ea1-6ba0-45f9-b34a-f8f95666a309.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 41800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311706",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311707",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106220299"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167403910",
                                "name": "Original Whopper Veg(XL size Bun)+BK Veggie Burger.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/f1dff1ee-82d0-4493-b7c7-587d40a9721b_ad1e136e-21be-4f74-92ec-943ead20bec0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 32800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621550",
                                    "groupName": "Say Cheese",
                                    "choices": [
                                      {
                                        "id": "138686328",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621551",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621553",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621555",
                                    "groupName": "Selected - Veg Whopper",
                                    "choices": [
                                      {
                                        "id": "138686251",
                                        "name": "Selected - Veg Whopper",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621557",
                                    "groupName": "Selected - BK Veggie",
                                    "choices": [
                                      {
                                        "id": "138686340",
                                        "name": "Selected - BK Veggie",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "234621558",
                                    "groupName": "Say Cheese ( 2nd Burger)",
                                    "choices": [
                                      {
                                        "id": "138686360",
                                        "name": "Cheese Slice",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278678"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167749513",
                                "name": "Original Whopper Veg(XL size Bun)+Peri Peri Fries(M).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/f6014e75-7741-4a7a-81af-2bad0dc57037_b2fd2f3e-310d-40aa-834c-33b1b46e672b.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 33300,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621564",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621565",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 33300,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278681"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167403912",
                                "name": "Chicken Tandoori Burger+Fries(Reg).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/52990437-8660-4d62-a186-87a5ccf83eb7_cf05431b-5ddf-47b8-993b-f57cdc519587.jpg",
                                "inStock": 1,
                                "price": 38900,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311708",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311709",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 38900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "100953730"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "179748561",
                                "name": "Hot 'N' Cheesy Burger+Peri Peri Fries(M).",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/56efd28d-9d3f-4420-9800-7d73b7ba010c_b7e30431-2c15-4438-a357-68913714b65d.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 44300,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "237311710",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "237311711",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 44300,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106220300"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "167403914",
                                "name": "Original Whopper Chicken(XL size Bun)+4pcs Crunchy Chicken Nuggets.",
                                "category": "Kings Collection ( Premium Burgers )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/f8d169ad-353b-4be3-8f6e-ede5bc949f4d_c464b1ec-137e-4800-9f9a-1b23113c1e0e.jpg",
                                "inStock": 1,
                                "price": 31800,
                                "finalPrice": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "234621589",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140848612",
                                        "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142048682",
                                        "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                        "price": 23900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686214",
                                        "name": "Fries (Reg) + Coke (Save Rs 56)",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686212",
                                        "name": "Fries (M) + Coke (Save Rs 60)",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686217",
                                        "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                        "price": 19600,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "234621592",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686335",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686219",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686222",
                                        "name": "4 Pcs Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686336",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686216",
                                        "name": "Veggie Strips(5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686218",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686343",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686278",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686221",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686207",
                                        "name": "Coke",
                                        "price": 9500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686230",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686226",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686291",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686283",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686369",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 31800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "236cf300-1f49-4003-8c67-c76e35fb2cd2"
                                ],
                                "parentId": "106278676"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/c686d35b-4bb8-4921-b9d4-ded351de228c_1ef2b796-68eb-4841-a27e-cefe5a42b7b4.jpg",
                        "categoryId": "64895656"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Party Specials (Save upto 37%)",
                        "categories": [
                          {
                            "title": "Family Feast for 4 ( Save upto 37%)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178512871",
                                    "name": "Classic Family Feast for 4 - Veg",
                                    "category": "Party Specials (Save upto 37%)",
                                    "description": "2 Crispy Veg + BK Veggie + Veg Crunchy Taco + 2 Med Fries + 2 Dips + Coca Cola Medium + Chocolate Thick Shake;\nServes 4 or More\n\nKcal: 2926.9 | Carbs 332.3 Gms| Sugar: 145 Gms| Fat: 114.9 Gms| Saturated fat: 51.7 Gms| Protein: 55.8 Gms| Sodium: 4274 Mg Contains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/9031fc39-d347-4618-9c99-f5b607e13bbd_672d66bc-f7b2-4509-a254-696279b960dc.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 64900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 64900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "66072496"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178512873",
                                    "name": "Premium Family Feast for 4 - Veg",
                                    "category": "Party Specials (Save upto 37%)",
                                    "description": "Veg Whopper + Paneer Royale + Crispy Veg + BK Veggie + 2 Med Fries + 1 Dip + 1 Peri Peri Sachet + Coca Cola Medium + Chocolate Thick Shake;\nServes 4 or More\n\nKcal: 3398.8 | Carbs 1315.9 Gms| Sugar: 168.3 Gms| Fat: 128.6 Gms| Saturated fat: 55.4 Gms| Protein: 78.6 Gms| Sodium: 5328.1 Mg\nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/19/0b854d6f-2497-4761-bdc3-1bf3608b638e_2f3c908b-5fdb-4b9d-8fc3-b3082bad50c3.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 84900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 84900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "66072498"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895676"
                          },
                          {
                            "title": "Chicken Wing Deal (Save upto 30%)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748562",
                                    "name": "2 Crispy Chicken Burger + 4Pc Fried Wings + 2 Coca Cola",
                                    "category": "Party Specials (Save upto 37%)",
                                    "description": "Save Rs 160 | 2Crispy Chicken Burger + 4Pc Fried Wings + 2 Coca Cola",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/ecf4a0fa-2c40-43fa-9746-7814143068fb_b7cc8592-2a41-483d-8f90-a70e43154cf7.jpg",
                                    "inStock": 1,
                                    "price": 35900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 35900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "80799720"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "140622726",
                                    "name": "11Pc Boneless Wings",
                                    "category": "Party Specials (Save upto 37%)",
                                    "description": "Save Rs 108 | 11pcs Boneless Bites",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/ee10561c-047a-47e1-9d67-d48de8574ff9_534a84a3-bbd8-4314-a55f-b37c6a467a00.jpg",
                                    "inStock": 1,
                                    "price": 32900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 32900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "78717889"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748563",
                                    "name": "2Pc Fried Wings+4Pc Boneless+4Pc Nuggets+3 Dips+1 Coca Cola",
                                    "category": "Party Specials (Save upto 37%)",
                                    "description": "Save Rs153 | 2Pc Fried Wings + 4Pc Boneless + 4Pc Nuggets + 3 Dips + 1 Coca Cola",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/7/63fbeca4-b7ab-4d9c-a39a-46d5262694a3_faa31675-d5a5-4697-8311-6c93071a13c9.jpg",
                                    "inStock": 1,
                                    "price": 39900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 39900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "80799721"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895677"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/9031fc39-d347-4618-9c99-f5b607e13bbd_672d66bc-f7b2-4509-a254-696279b960dc.jpg",
                        "categoryId": "64895657"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Desserts",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019642",
                                "name": "BK Fusion Sundae  (made with Kit Kat),",
                                "category": "Desserts",
                                "description": "Made with Kit Kat, enjoy our rich creamy fusion sundae\nQty: 128 gms| Kcal: 327 | Carbs: 49 gms| Sugar: 32 gms| Fat: 12 gms| Saturated fat: 10 gms| Protein: 6 gms",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/a645e88a-c645-4526-a2ad-ba7efcbf8fbd_60a3bced-21d8-47fd-a179-75487aece375.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396636",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "106949914"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177019643",
                                "name": "2 BK Fusion Sundae (made with Kit Kat),",
                                "category": "Desserts",
                                "description": "2 X Made with Kit Kat, enjoy our rich creamy fusion thick sundae.\n\nQty: 256 gms| Kcal: 654 | Carbs: 97 gms| Sugar: 64 gms| Fat: 24 gms| Saturated fat: 19 gms| Protein: 13 gms|",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/df0bd65b-6ae0-4212-b371-5938a48e0753_3fd5b7a3-c52e-466d-b682-c20f5a539ef7.png",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 25800,
                                "finalPrice": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "235396637",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "f90043a7-8860-4af1-8cdb-040a3dfea9b6"
                                ],
                                "parentId": "106949912"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "84357306",
                                "name": "Choco Lava Cup",
                                "category": "Desserts",
                                "description": "Melty Chocolate Filled In Cupcake \nQty: 80 Gms| Kcal: 349 | Carbs 44.4 Gms| Sugar: 16.9 Gms| Fat: 4.9 Gms| Saturated fat: 27.4 Gms| Protein: 3.6 Gms| Sodium: 112 Mg \nContains: Gluten, Soybean, Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/648dcd9f-1b47-4186-ab21-309aec43b5ce_63287661-1294-4538-862e-a82d0069d503.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "134 ratings",
                                    "ratingCountV2": "134"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "43603762"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "91105758",
                                "name": "Chocolate Mousse Cup",
                                "category": "Desserts",
                                "description": "Airy And Creamy Chocolate Mousse Topped With Chocolate Ganache And Choco Chips \nQty: 80 Gms| Kcal: 200 | Carbs 35 Gms| Sugar: 25 Gms| Fat: 5.7 Gms| Saturated fat: 4.4 Gms| Protein: 2.2 Gms| Sodium: 67 Mg \nContains: Soybean, Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/0562e11f-f0c2-41c0-95c9-cc27a981b0aa_836f2ab2-d019-46d3-9d33-1a2450c653f0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "60 ratings",
                                    "ratingCountV2": "60"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "40205666"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188776857",
                                "name": "Choco-Lava Cup.",
                                "category": "Desserts",
                                "description": "Melty Chocolate Filled In Cupcake.\nQty: 80 Gms| Kcal: 349 | Carbs 44.4 Gms| Sugar: 16.9 Gms| Fat: 4.9 Gms| Saturated fat: 27.4 Gms| Protein: 3.6 Gms| Sodium: 112 Mg\nContains: Gluten, Soybean, Milk.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/648dcd9f-1b47-4186-ab21-309aec43b5ce_63287661-1294-4538-862e-a82d0069d503.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "260668920",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "134 ratings",
                                    "ratingCountV2": "134"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "43603762"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "186242586",
                                "name": "Muffin.",
                                "category": "Desserts",
                                "description": "Choose a Muffin of your choice\n\nQty: 60 gms| Kcal: 240 | Carbs: 33 gms| Sugar: 13 gms| Fat: 11 gms| Saturated fat: 4 gms| Protein: 4 gms| Sodium: 290 mg",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/6/490385d2-61cd-4845-8440-27df8bd4b68a_43250f8e-3f51-4e84-9859-f4794b545ee3.jpg",
                                "inStock": 1,
                                "price": 12900,
                                "finalPrice": 5900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "253642362",
                                    "groupName": "Choice of any 1 Muffin",
                                    "choices": [
                                      {
                                        "id": "140219630",
                                        "name": "Vanilla Chocolate Muffin",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219631",
                                        "name": "Choco Chip Muffin",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "253642361",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "83c0d13c-9986-4725-af91-ce90d308f4a7"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "113205364"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188776856",
                                "name": "Chocolate Mousse Cup.",
                                "category": "Desserts",
                                "description": "Airy And Creamy Chocolate Mousse Topped With Chocolate Ganache And Choco Chips \nQty: 80 Gms| Kcal: 200 | Carbs 35 Gms| Sugar: 25 Gms| Fat: 5.7 Gms| Saturated fat: 4.4 Gms| Protein: 2.2 Gms| Sodium: 67 Mg \nContains: Soybean, Milk",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/0562e11f-f0c2-41c0-95c9-cc27a981b0aa_836f2ab2-d019-46d3-9d33-1a2450c653f0.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "260668918",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686352",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686353",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686350",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686245",
                                        "name": "Peri Peri Spice Mix",
                                        "price": 2857,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686235",
                                        "name": "Fiery Hell Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686237",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686225",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686302",
                                        "name": "BK Veg Pizza Puff",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686317",
                                        "name": "Chilli Oregano Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686320",
                                        "name": "Saucy Jalapeno Dip",
                                        "price": 2381,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686387",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "60 ratings",
                                    "ratingCountV2": "60"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "03d2d5cb-f959-4120-bdc1-878f33b38c28"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "40205666"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/17/a645e88a-c645-4526-a2ad-ba7efcbf8fbd_60a3bced-21d8-47fd-a179-75487aece375.png",
                        "categoryId": "64895658"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Soft Drinks",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "77593247",
                                "name": "Coca Cola Medium",
                                "category": "Soft Drinks",
                                "description": "Cola. Kcal: 190.1 | Carbs 52 Gms| Sugar: 52 Gms| Fat: 0 Gms| Saturated fat: 0 Gms| Protein: 0 Gms| Sodium: 38",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/c9494d62-a7f7-4976-9d1f-df89dd26b183_6853c1b4-f67d-42ba-a02e-076d9bfbc5a4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "73 ratings",
                                    "ratingCountV2": "73"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "80799725"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "140340759",
                                "name": "Medium Thums Up",
                                "category": "Soft Drinks",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/29/a09f3719-beb9-4a87-829d-a89173e7c7ed_e1b3bdef-2af1-48f8-a40a-c61633572735.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "82675974"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "111131820",
                                "name": "Fanta Medium",
                                "category": "Soft Drinks",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/c31f456d-3e06-41cf-bc2b-1219e2c18f28_76e2a34b-0158-4df7-9320-c7f188810bfc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "80799730"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "111131825",
                                "name": "Sprite Medium",
                                "category": "Soft Drinks",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/170ec0ba-df1f-4222-af99-53f4b7263058_d24232f8-9913-42fd-83ee-d1932c1497f7.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "80799732"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188776858",
                                "name": "Coke.",
                                "category": "Soft Drinks",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/c9494d62-a7f7-4976-9d1f-df89dd26b183_6853c1b4-f67d-42ba-a02e-076d9bfbc5a4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9500,
                                "finalPrice": 7900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "260668922",
                                    "groupName": "Choose your Sides & Dessert",
                                    "choices": [
                                      {
                                        "id": "138686349",
                                        "name": "Korean Spicy Fries",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686240",
                                        "name": "Med Fries",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686243",
                                        "name": "4 Pc Crunchy Chicken Nuggets",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219627",
                                        "name": "Korean Spicy Chicken (4 Pc)",
                                        "price": 19900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686242",
                                        "name": "Veggie Strips (5Pcs)",
                                        "price": 5900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686244",
                                        "name": "Saucy Fries",
                                        "price": 14500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "140219628",
                                        "name": "Korean Spicy Chicken Wings (4pc)",
                                        "price": 22900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686246",
                                        "name": "Chocolava Cake",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686224",
                                        "name": "Chilli Sauce With Oregano",
                                        "price": 1905,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "138686392",
                                        "name": "BK Fusion Sundae  (made with Kit Kat)",
                                        "price": 12900,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "ea82d6e3-9cac-4beb-a086-7ed17c0a7ee4"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "114854835"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/c9494d62-a7f7-4976-9d1f-df89dd26b183_6853c1b4-f67d-42ba-a02e-076d9bfbc5a4.jpg",
                        "categoryId": "64895659"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Friends & Family Combo (Save upto 20%)",
                        "categories": [
                          {
                            "title": "Buddy Box",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "77041544",
                                    "name": "4 Crispy Veg + 2 Medium Fries",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "4 Crispy Veg + 2 Medium Fries \nQty: 728 Gms| Kcal: 2101.2 | Carbs 1068.1 Gms| Sugar: 29.9 Gms| Fat: 89.2 Gms| Saturated fat: 32.7 Gms| Protein: 57.6 Gms| Sodium: 3427.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/42495fcf-8f3f-425c-a1e2-8d8c2cec0e45_6c1ec2ef-34b7-4f93-a422-52c63bc5ace6.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 40000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 40000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "72 ratings",
                                        "ratingCountV2": "72"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378395"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "77041524",
                                    "name": "6 Crispy Veg",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Qty: 822 Gms| Kcal: 2173.2 | Carbs 320.4 Gms| Sugar: 39 Gms| Fat: 76.8 Gms| Saturated fat: 29.1 Gms| Protein: 50.4 Gms| Sodium: 4789.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/5d2759d6-1fad-44f1-829d-e7447ccbca0e_d78abca3-0f8f-4312-841b-7f2677f52162.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 35000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 35000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "114 ratings",
                                        "ratingCountV2": "114"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378400"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "77041540",
                                    "name": "6 Crispy Chicken",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "6 Crispy Chicken \nQty: 750 Gms| Kcal: 2154.3 | Carbs 266 Gms| Sugar: 44.8 Gms| Fat: 90.6 Gms| Saturated fat: 28.7 Gms| Protein: 68.7 Gms| Sodium: 3554.4 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4946abe5-b74f-4c68-9464-301e7d2ff143_b22c57d2-4e39-4b99-ad0e-a7160c2bd808.jpg",
                                    "inStock": 1,
                                    "price": 49500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 49500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378399"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "77041549",
                                    "name": "4 Crispy Chicken + 2 Medium Fries",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "4 Crispy Chicken + 2 Medium Fries \nQty: 728 Gms| Kcal: 2101.2 | Carbs 1068.1 Gms| Sugar: 29.9 Gms| Fat: 89.2 Gms| Saturated fat: 32.7 Gms| Protein: 57.6 Gms| Sodium: 3427.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/f441042b-9f5c-49f8-aa2b-b2c7f96f594a_01710808-4a4f-48be-9ec5-320eb5e32f4b.jpg",
                                    "inStock": 1,
                                    "price": 48000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 48000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.3",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378394"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895680"
                          },
                          {
                            "title": "Snack Attack",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "77452791",
                                    "name": "Veggie Strips(5Pcs) + 1 Dip",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Veggie Strips(5Pcs) + 1 Dip \nQty: 105 Gms| Kcal: 328.1 | Carbs 33.5 Gms| Sugar: 5.3 Gms| Fat: 19.3 Gms| Saturated fat: 7 Gms| Protein: 5.1 Gms| Sodium: 635.4 Mg \nContains: Gluten, Soybean , Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/23b7f495-77d1-4dca-9a45-660079bbd116_30e611a2-d735-4974-9007-a0542b159629.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 7281,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "235396638",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 7281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "41 ratings",
                                        "ratingCountV2": "41"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "36412332"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560363",
                                    "name": "2 Classic Cold Coffee @139 each",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "2 Classic Cold Coffee \nQty: 700 Gms| Kcal: 430 | Carbs 48.3 Gms| Sugar: 17.7 Gms| Fat: 18.9 Gms| Saturated fat: 41.9 Gms| Protein: 13.9 Gms| Sodium: 280 Mg \nContains: Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/1631cae5-adca-47fe-a6fe-4dcc282c9c68_383b8a68-818d-447f-8592-741648e8fcbb.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 39800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 39800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "62724151"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178512875",
                                    "name": "Boneless Chicken Wings(4pcs)+1Fiery Hell Dip",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Boneless Chicken Wings (4pcs) with 1 Fiery Hell Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/9/c0f709a0-bd8c-4e1b-96ed-5da4da32eff4_7e9848c3-102d-43d4-82ca-49016dd57bc5.jpg_compressed",
                                    "inStock": 1,
                                    "price": 17281,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "235396639",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 17281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "81107709"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178512876",
                                    "name": "Boneless Chicken Wings(7Pcs)+1Fiery Hell Dip",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/d222eedd-dec7-4e26-a1d5-3b738a9cc0a4_2545bf75-f9c3-41e8-9796-44883dd6835b.jpg",
                                    "inStock": 1,
                                    "price": 27281,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "235396640",
                                        "groupName": "Choose Your Dip",
                                        "choices": [
                                          {
                                            "id": "138686346",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686234",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686280",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686288",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 27281,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "81107710"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748564",
                                    "name": "Hot 'N' Cheesy Bite",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "MRP 318 | Hot n Saucy + Med Fries.\nQty: 369 Gms| Kcal: 1014.5 | Carbs 527.4 Gms| Sugar: 17.5 Gms| Fat: 45.8 Gms| Saturated fat: 18.9 Gms| Protein: 23.8 Gms| Sodium: 1727.3 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/83e21bbb-ddf6-4ccd-b15a-17fd4581c239_5ce64ea1-6ba0-45f9-b34a-f8f95666a309.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 27000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 27000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106171549"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560364",
                                    "name": "1 Crispy Veg Double Patty+1 Classic Cold Coffee",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs. 50 | 1 Crispy Veg Double Patty+1 Classic Cold Coffee \nQty: 554 Gms| Kcal: 746.4 | Carbs 94.8 Gms| Sugar: 18 Gms| Fat: 32.2 Gms| Saturated fat: 30.2 Gms| Protein: 18.2 Gms| Sodium: 1208 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/1648b73c-380b-4bfb-bb3b-7555f71d6579_f14ce703-4ef6-465c-b220-95a7557d7b31.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 24300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 24300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "56630237"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560365",
                                    "name": "1 Crispy Chicken+1 Classic Cold Coffee",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs.  50 | 1 Crispy Chicken+1 Classic Cold Coffee \nQty: 475 Gms| Kcal: 574.1 | Carbs 68.5 Gms| Sugar: 16.3 Gms| Fat: 24.6 Gms| Saturated fat: 25.7 Gms| Protein: 18.4 Gms| Sodium: 732.4 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/87b2a452-4852-40f1-baaf-248c469ca631_0c0cebc9-5f67-4b87-a8a6-b8ec05ebb4e0.jpg",
                                    "inStock": 1,
                                    "price": 24300,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 24300,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "56630234"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "100379794",
                                    "name": "Veg Whopper Deluxe + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs. 49 | 1 Extra Crunchy Veg Whopper Deluxe +1 Chocolate Thick Shake \nQty: 194 Gms, 300 ML| Kcal: 952.1 | Carbs 149.2 Gms| Sugar: 70.7 Gms| Fat: 31.3 Gms| Saturated fat: 19 Gms| Protein: 18.2 Gms| Sodium: 1438.8 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/b473d43d-ee77-465b-99d3-bcb23cec0a2f_3521d6f3-2740-487b-bc08-f58673a9a612.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 26900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 26900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "23 ratings",
                                        "ratingCountV2": "23"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503551"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "100379795",
                                    "name": "1 Flame-Grilled Chicken Whopper Deluxe(Reg. Size Bun) +1 Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 49 | 1 Flame-Grilled Chicken Whopper Deluxe +1 Chocolate Thick Shake \nQty: 167 Gms, 300 ML| Kcal: 865.1 | Carbs 131.1 Gms| Sugar: 69.8 Gms| Fat: 25 Gms| Saturated fat: 13.3 Gms| Protein: 29 Gms| Sodium: 1325 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/6cb5418d-d28e-4f83-b790-45eced821d8c_dff27eca-5746-41e6-bf06-396e560ae467.jpg",
                                    "inStock": 1,
                                    "price": 38800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 38800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106562434"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179748565",
                                    "name": "Hot 'N' Cheesy Twins",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "MRP 398 |  2 Hot N Saucy Burgers.\nQty: 510 Gms| Kcal: 1364 | Carbs 164 Gms| Sugar: 35 Gms| Fat: 62.8 Gms| Saturated fat: 24.1 Gms| Protein: 35.8 Gms| Sodium: 2397 Mg \nContains: Gluten, Soybean, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/ebb44454-43b8-4a70-b90b-6f320027de66_23dd89ae-2a12-44dc-bbc0-15a842995bd3.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 33800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 33800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106171552"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64775683",
                                    "name": "2 Crispy Veg Double Patty + 1King Fries + 1Veggie strips",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Qty: 605 Gms| Kcal: 1772 | Carbs 745 Gms| Sugar: 23.9 Gms| Fat: 88.2 Gms| Saturated fat: 35.8 Gms| Protein: 47.6 Gms| Sodium: 2939.2 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/14d538dc-0100-47b2-b3d7-95b478ad282b_a31dd1ef-0818-43c7-b4ce-f2334b754175.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 39600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 39600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.2",
                                        "ratingCount": "69 ratings",
                                        "ratingCountV2": "69"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10378312"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105242169",
                                    "name": "Chicken Lovers",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "MRP: 449 |  Save 15%, Crispy Chicken Double Patty + Fiery Chicken + Med Fries + Fiery Hell Dip",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/19/2b14186c-3ebf-4c20-aa17-2bcf83beeb51_3da5e7a5-e4ec-4fa8-a377-5a05ab5b5ce2.jpg",
                                    "inStock": 1,
                                    "price": 56081,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 56081,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "59983158"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "83730945",
                                    "name": "2 Crispy Veg Double Patty + 1 King Fries +1Chocolate mousse cup",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "2 Crispy Veg Double Patty + 1 King Fries +1Chocolate mousse cup \nQty: 644 Gms| Kcal: 1717.8 | Carbs 785.6 Gms| Sugar: 43.2 Gms| Fat: 70.8 Gms| Saturated fat: 32.1 Gms| Protein: 32.6 Gms| Sodium: 2926.7 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/1af6cb7c-b6cb-461d-805e-8b6ac8b91100_a0d305d9-4f97-4db7-a24d-41ff489006f5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 46600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 46600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "43974602"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "171560366",
                                    "name": "2Crispy Chicken+1King Fries+1Cold Coffee+1Coca Cola Medium",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs. 115 | 2 Crispy Chicken + 1 King Fries + 1 Cold Coffee + 1 Coca Cola Medium.\nKcal: 1578.2 | Carbs 774.3 Gms| Sugar: 75.8 Gms| Fat: 59.4 Gms| Saturated fat: 39.8 Gms| Protein: 37.9 Gms| Sodium: 2086.5 Mg \nContains: Gluten, Soybean , Milk , Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/26/df1030f3-5e97-4cfe-b803-30355f55019b_21314f0a-42da-4ee0-bf8a-699e1fa56348.jpg",
                                    "inStock": 1,
                                    "price": 50700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 50700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "80799719"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895681"
                          },
                          {
                            "title": "Burger Doubles",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62104384",
                                    "name": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ef18e36-f988-4b85-8fa2-75e1fa72406a_86684d36-3c2d-471a-a9cc-082870edc314.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 19800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19800,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "943 ratings",
                                        "ratingCountV2": "943"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379134"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "67949062",
                                    "name": "Veg Whopper Deluxe + Veg Makhani Burst",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Veg Whopper Deluxe + Veg Makhani Burst",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/240052e5-aa74-4fca-a76e-e44dda2fed37_6e6f3974-41fe-4e04-a741-c1c82ae7d812.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 22900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 22900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503557"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "80081958",
                                    "name": "BK Veggie Burger + BK Veggie Burger",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "BK Veggie Burger + BK Veggie Burger",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/8d41b10b-e1d9-48f1-909d-a6fc26a97dcd_fc2b29e4-9da5-4a68-b0a2-e61fee7324b0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 27800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 27800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.2",
                                        "ratingCount": "11 ratings",
                                        "ratingCountV2": "11"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "63621018"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62104383",
                                    "name": "Crispy Chicken Double Patty + Crispy Chicken Double Patty",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Crispy Chicken Double Patty + Crispy Chicken Double Patty",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/b683e5e6-ad56-49a1-b900-90ac3b35f593_29415f00-7622-420a-a7df-2a80ee642a62.jpg",
                                    "inStock": 1,
                                    "price": 27800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 27800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.3",
                                        "ratingCount": "181 ratings",
                                        "ratingCountV2": "181"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379095"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "67949064",
                                    "name": "Chicken Makhani Burst + Flame Grilled Chicken Whopper Deluxe(Reg. Size Bun)",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Chicken Makhani Burst +  Flame Grilled Chicken Whopper Deluxe",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/19/d41a7c48-3621-475e-8e19-a755ac60c8a7_93d7f9a1-1120-4fc3-a4d2-ad6876eda144.jpg",
                                    "inStock": 1,
                                    "price": 30800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 30800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.8",
                                        "ratingCount": "76 ratings",
                                        "ratingCountV2": "76"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "106562435"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "62382593",
                                    "name": "BK Chicken Burger + BK Chicken Burger",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "BK Chicken Burger + BK Chicken Burger",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/fd9e54bd-a061-4853-a3fb-ae63a63f7299_7e2003ab-bf6a-4aab-9c0e-6c0690ddc35a.jpg",
                                    "inStock": 1,
                                    "price": 29800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 29800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "38 ratings",
                                        "ratingCountV2": "38"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "63621013"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "166080811",
                                    "name": "2 Veg Whopper Deluxe",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "2 Veg Whopper Deluxe",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/15/5a0d8f03-d754-405b-95e5-3c866988a327_8cbef449-a014-4dac-b25f-e3b57f4bc226.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 29800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 29800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "113503539"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "58222673",
                                    "name": "Original Whopper Veg + Original Whopper Veg",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Original Whopper Veg + Original Whopper Veg",
                                    "imageId": "667922098ad03c21e2176c3f52b432c0",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 37800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 37800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401030"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "55208281",
                                    "name": "Original Whopper Chicken + Original Whopper Chicken",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "imageId": "83fbae6d81b544b68562cffd4b380482",
                                    "inStock": 1,
                                    "price": 41800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "87 ratings",
                                        "ratingCountV2": "87"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401022"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895682"
                          },
                          {
                            "title": "King Deals (Save Rs 99)",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "158576961",
                                    "name": "Crunchy Veg Taco Peri Peri Meal (R)",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Crunchy Veg Taco+Peri Peri Fries( R)+Coke",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/21/6e99d335-7b8f-4d99-a3a1-8130584bd9fa_bbba3948-0690-417c-816c-09486e2292d4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 30357,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "262731852",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 30357,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "94821715"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088266",
                                    "name": "Crispy Veg + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | Crispy Veg + Medium Fries + chocolate thick shake \nQty: 251 Gms, 300 ML| Kcal: 694.7 | Carbs 498.8 Gms| Sugar: 6.5 Gms| Fat: 27.2 Gms| Saturated fat: 11.7 Gms| Protein: 14.3 Gms| Sodium: 1327 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/76f8f3f1-a193-44a1-b7fa-75f142dfe0f4_1bf61821-a5c9-4390-a984-bc9c4ec098a4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 37800,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 37800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "37 ratings",
                                        "ratingCountV2": "37"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65186030"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088269",
                                    "name": "Crispy Chicken + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | Crispy Chicken + Medium Fries + chocolate thick shake \nQty: 239 Gms, 300 ML| Kcal: 1187.6 | Carbs 580.6 Gms| Sugar: 68.9 Gms| Fat: 40.8 Gms| Saturated fat: 18.8 Gms| Protein: 28.3 Gms| Sodium: 1131.9 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/b39dab2e-9b65-43bc-bb79-7305d350321f_a472ee3e-ee4f-467a-ae28-e3a4401907cd.jpg",
                                    "inStock": 1,
                                    "price": 40700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 40700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65186029"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088270",
                                    "name": "BK Veggie + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | BK Veggie + Medium Fries + chocolate thick shake \nQty: 219 Gms, 300 ML| Kcal: 1164.7 | Carbs 566.8 Gms| Sugar: 68.5 Gms| Fat: 46.5 Gms| Saturated fat: 27.9 Gms| Protein: 20.5 Gms| Sodium: 1129.1 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/c8b3e32e-6828-44ec-b084-34e2de1296f7_6b020588-d94e-4487-a4e2-75251e516092.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 44700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 44700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65186027"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088271",
                                    "name": "BK Chicken + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | BK Chicken + Medium Fries + chocolate thick shake \nQty: 278 Gms, 300 ML| Kcal: 1243.6 | Carbs 572.1 Gms| Sugar: 68.6 Gms| Fat: 46.9 Gms| Saturated fat: 21.2 Gms| Protein: 33.9 Gms| Sodium: 823.4 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/21/8cfe6acc-0f72-4e70-9ebf-a5cc50339c74_4308bcb1-d422-4677-b45d-16252333b9ba.jpg",
                                    "inStock": 1,
                                    "price": 45700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 45700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "65186026"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088273",
                                    "name": "Original Whopper Veg + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | Original Whopper Veg + Med Fries + Chocolate thick shake \nQty: 399 Gms, 300 ML| Kcal: 1509.8 | Carbs 630.2 Gms| Sugar: 84.5 Gms| Fat: 51.1 Gms| Saturated fat: 23.8 Gms| Protein: 32.7 Gms| Sodium: 1527.3 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/65a130b3-82fd-48ae-a0d7-4e5ecc226cd6_bb810b94-da37-4e13-9951-ec0cab162139.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 49700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 49700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.1",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401029"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "113088274",
                                    "name": "Original Whopper Chicken + Med Fries + Chocolate Thick Shake",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Save Rs 99 | Original Whopper Chicken + Med Fries + Chocolate thick shake \nQty: 394 Gms, 300 ML| Kcal: 1495.8 | Carbs 592.2 Gms| Sugar: 70.1 Gms| Fat: 62 Gms| Saturated fat: 22.1 Gms| Protein: 43.1 Gms| Sodium: 1558.2 Mg \nContains: Gluten, Soybean, Milk, Sesame seeds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/28/51c540f9-6122-4d92-b3f8-40194502f91d_f9aa1bea-e84d-4c57-adaa-6b5d6f5c5122.jpg",
                                    "inStock": 1,
                                    "price": 51700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 51700,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "102401021"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "167158684",
                                    "name": "BK Veggie Burger Peri Peri Meal",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "BK Veggie Burger+Peri Peri Fries( R)+Coke",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/d3672017-32e7-4c27-ab1c-52ff435bbe59_fa8f0009-b3d6-41e7-9338-43675f3f499f.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 35257,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "262731853",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686352",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686353",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686350",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686245",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686235",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686237",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686225",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686302",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686317",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686320",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686387",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 35257,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "100802215"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "175813794",
                                    "name": "Crispy Veg Burger!",
                                    "category": "Friends & Family Combo (Save upto 20%)",
                                    "description": "Our best-selling burger with crispy veg patty, fresh onion and our signature sauce",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/4389cb8d-93e5-4dd5-8013-73a927dd6b31_622133db-f6cc-4f88-ba37-118df0b143ce.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 7000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "266100882",
                                        "groupName": "Say Cheese",
                                        "choices": [
                                          {
                                            "id": "138686328",
                                            "name": "Cheese Slice",
                                            "price": 2500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266100883",
                                        "groupName": "Selected Burger - Crispy Veg ",
                                        "choices": [
                                          {
                                            "id": "138686298",
                                            "name": "Selected - Crispy Veg",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "266100884",
                                        "groupName": "Make it a Meal",
                                        "choices": [
                                          {
                                            "id": "140848612",
                                            "name": "Fries( R ) + Coke + BK Fusion Sundae(made with KitKat)-(Save Rs 115)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142048682",
                                            "name": "Fries( R ) + BK Fusion Shake(made with KitKat)-(Save Rs 130)",
                                            "price": 23900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686214",
                                            "name": "Fries (Reg) + Coke (Save Rs 56)",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686212",
                                            "name": "Fries (M) + Coke (Save Rs 60)",
                                            "price": 14900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686217",
                                            "name": "Fries (M) + Chocolate Thickshake (Save Rs 109)",
                                            "price": 19600,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "266100885",
                                        "groupName": "Choose your Sides & Dessert",
                                        "choices": [
                                          {
                                            "id": "138686335",
                                            "name": "Korean Spicy Fries",
                                            "price": 15900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686219",
                                            "name": "Med Fries",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686222",
                                            "name": "4 Pcs Crunchy Chicken Nuggets",
                                            "price": 10900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686336",
                                            "name": "Korean Spicy Chicken (4 Pc)",
                                            "price": 19900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686216",
                                            "name": "Veggie Strips(5Pcs)",
                                            "price": 5900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686218",
                                            "name": "Peri Peri Spice Mix",
                                            "price": 2857,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686343",
                                            "name": "Korean Spicy Chicken Wings (4pc)",
                                            "price": 22900,
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686278",
                                            "name": "BK Veg Pizza Puff",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686221",
                                            "name": "Fiery Hell Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686207",
                                            "name": "Coke",
                                            "price": 9500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686230",
                                            "name": "Chocolava Cake",
                                            "price": 11900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686226",
                                            "name": "Chilli Sauce With Oregano",
                                            "price": 1905,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686291",
                                            "name": "Chilli Oregano Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686283",
                                            "name": "Saucy Jalapeno Dip",
                                            "price": 2381,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "138686369",
                                            "name": "BK Fusion Sundae  (made with Kit Kat)",
                                            "price": 12900,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 7000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "4038 ratings",
                                        "ratingCountV2": "4.0K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "10379122"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64895683"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/42495fcf-8f3f-425c-a1e2-8d8c2cec0e45_6c1ec2ef-34b7-4f93-a422-52c63bc5ace6.jpg",
                        "categoryId": "64895660"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11418010000511"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Burger King",
                        "area": "Db City Mall",
                        "completeAddress": "Fs 11 & 12 Food Court, Third Floor Db City Mall,Opp. M.P. Nagar ,Zone-1 Arera Hills,Bhopal (M.P.) Pin Code-462011"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "WQUtK98xpgnt-Dmuygg7OBJCl5Z-ts47Jnh9bxdk"
  },

  "348083": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Starbucks Coffee",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                },
                {
                  "id": "Dineout",
                  "title": "Dineout",
                  "cta": "https://swiggy.com/menu/348083/dineout"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "348083",
                "name": "Starbucks Coffee",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "starbucks-coffee-db-city-mall-mp-nagar",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/8/22/c1c06093-a225-4565-9a24-3315bcf448d4_348083.JPG",
                "locality": "Maharana Pratap Nagar",
                "areaName": "Maharana Pratap Nagar",
                "costForTwo": "40000",
                "costForTwoMessage": "₹400 for two",
                "cuisines": ["Beverages", "Cafe"],
                "avgRating": 4.4,
                "feeDetails": {
                  "restaurantId": "348083",
                  "fees": [{}]
                },
                "parentId": "195515",
                "avgRatingString": "4.4",
                "totalRatingsString": "826 ratings",
                "sla": {
                  "restaurantId": "348083",
                  "deliveryTime": 458,
                  "minDeliveryTime": 454,
                  "maxDeliveryTime": 464,
                  "lastMileTravel": 8.8,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 698,
                  "slaString": "454-464 MINS",
                  "lastMileTravelString": "8.8 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹125 off | Use FLAVORFUL",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹125 off | Use FLAVORFUL",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "starbucks-coffee-db-city-mall-mp-nagar",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Plot No.G-35, Narmadapuram Road, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Beverages,Cafe"
                  }
                ],
                "totalRatings": 826,
                "aggregatedDiscountInfoV2": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹125 off | Use FLAVORFUL",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹125 off | Use FLAVORFUL",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/348083"
                },
                "generalPurposeInfoListV2": [
                  {
                    "cta": {
                      "info": {
                        "recordings": {}
                      },
                      "linkCta": {}
                    }
                  }
                ],
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 9:00 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.233283,77.429669",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "FLAT 50% OFF",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["d8f7ca28-7246-4654-b7c0-aab24eb1ec59"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "348083",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "NO CODE REQUIRED"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹125 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["0dde20bf-19fe-46a7-a09d-0882b4d230a5"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAVORFUL",
                        "description": "ABOVE ₹199",
                        "offerType": "offers",
                        "restId": "348083",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAVORFUL"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "40% OFF UPTO ₹80",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["ea852c50-998d-4671-b73e-d90542ebce37"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE TRYNEW",
                        "description": "ABOVE ₹179",
                        "offerType": "offers",
                        "restId": "348083",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE TRYNEW"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹80 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["5bdd6b93-8a93-43af-a222-b62fd65a7675"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT80",
                        "description": "ABOVE ₹399",
                        "offerType": "offers",
                        "restId": "348083",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT80"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹200 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["65f74ec2-6984-4bd2-bcf3-c13530f5aab2"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE CELEBRATIONS",
                        "description": "ABOVE ₹1199",
                        "offerType": "offers",
                        "restId": "348083",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE CELEBRATIONS"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "50% OFF"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Signature Irish Series",
                        "categories": [
                          {
                            "title": "Drinks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188871563",
                                    "name": "Signature Irish Matcha",
                                    "category": "Signature Irish Series",
                                    "description": "Non alcoholic Bailey’s Irish Cream flavoured milk, topped with a vibrant and refreshing matcha foam with a sprinkle of Mocha powder. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 282 kcal, Grande (473ml) - 347 kcal, Venti (591ml) - 397 kcal. Allergen - Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/7bd35af9-826c-4772-a24a-b9d7a6b72dba_68298117-f115-4055-a956-d7115b6f3d53.jpg",
                                    "isVeg": 1,
                                    "price": 39500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "69207199",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Grande",
                                              "price": 4500,
                                              "default": 1,
                                              "id": "207072754",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 9000,
                                              "id": "207072755",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "id": "207072753",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "69207200",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "207072756",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260841049",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "126347766",
                                            "name": "With Whipped Topping",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841050",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114914039"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188871564",
                                    "name": "Signature Irish Cold Brew",
                                    "category": "Signature Irish Series",
                                    "description": "Bold smooth Cold brew topped with non alcoholic Bailey’s Irish Cream flavoured Sweet cream and garnished with Mocha powder dust. Serving size (ml)/Calories (kcal) -  Short (237ml) - 87 kcal, Tall (354ml) - 95 kcal, Grande (473ml) - 130 kcal. Allergen - Contains Milk, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/9163a261-9430-49a8-81e9-3baecdb7bc2a_4099dcbd-b977-4114-9ce4-936cf62a753b.jpg",
                                    "isVeg": 1,
                                    "price": 35500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "69207201",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Tall",
                                              "price": 5500,
                                              "default": 1,
                                              "id": "207072758",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 10000,
                                              "id": "207072759",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Short",
                                              "id": "207072757",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260841051",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114914036"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188871565",
                                    "name": "Signature Irish Frappuccino",
                                    "category": "Signature Irish Series",
                                    "description": "Smooth espresso with hint of non alcoholic Bailey’s Irish Cream flavour , and garnished with whipped topping and mocha powder dust. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 304 kcal, Grande (473ml) - 419 kcal, Venti (591ml) - 522 kcal. Allergen - Contains Milk, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/8cdabbe9-6e23-408e-8d81-56d82ad08894_84f93a5c-f819-4ebb-923f-50af3865e3bc.jpg",
                                    "isVeg": 1,
                                    "price": 48000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "69207202",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Blended Grande",
                                              "price": 5000,
                                              "default": 1,
                                              "id": "207072761",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Venti",
                                              "price": 10000,
                                              "id": "207072762",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Tall",
                                              "id": "207072760",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "69207203",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "207072763",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "207072764",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "207072765",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "207072766",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "207072767",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260841052",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841053",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841054",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841055",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114914037"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188871567",
                                    "name": "Signature Irish Latte",
                                    "category": "Signature Irish Series",
                                    "description": "Starbucks Signature latte paired with non alcoholic Bailey’s Irish Cream flavour topped with a sprinkle of mocha powder. Serving size (ml)/Calories (kcal) -  Short (237ml) - 279 kcal, Tall (354ml) - 442 kcal, Grande (473ml) - 591 kcal, Venti (591ml) - 754 kcal. Allergen - Contains Milk, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/9e77ef7b-6ec5-4a7c-81b6-22e56226a78d_4fe6b673-dd49-43f3-ae03-7f75b7be90a9.jpg",
                                    "isVeg": 1,
                                    "price": 39500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "69207206",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Tall",
                                              "price": 5000,
                                              "default": 1,
                                              "id": "207072773",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Grande",
                                              "price": 10000,
                                              "id": "207072774",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Venti",
                                              "price": 15000,
                                              "id": "207072775",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Short",
                                              "id": "207072772",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "69207207",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "207072776",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "207072777",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "207072778",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "207072779",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "207072782",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "260841059",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841060",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841061",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347766",
                                            "name": "With Whipped Topping",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "260841063",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114914038"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69650564"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/7bd35af9-826c-4772-a24a-b9d7a6b72dba_68298117-f115-4055-a956-d7115b6f3d53.jpg",
                        "categoryId": "69650563"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Newly Launched",
                        "categories": [
                          {
                            "title": "Drinks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "185898755",
                                    "name": "Apple Grapefruit Refresher",
                                    "category": "Newly Launched",
                                    "description": "A vibrant fusion of crisp apple and tangy grapefruit flavours. This Starbucks Refresher delivers a bright, fruity burst that’s as uplifting as it is refreshing.\nServing size (ml)/Calories (kcal) - Short (237ml) - 84 kcal / Tall (354ml) - 133 kcal / Grande (473ml) - 175 kcal / Venti (591ml) - 217 kcal.\nAllergen - NA.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/1/18695f79-7a1a-4c69-b328-5930dbb4365d_89fb874f-52c6-4c6c-a1e2-7b22c2a7f354.jpg",
                                    "isVeg": 1,
                                    "price": 24500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68002741",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "204398779",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "id": "204398780",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "204398781",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 13500,
                                              "id": "204398782",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "251982600",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "112956097"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "185898756",
                                    "name": "Spiced Classic Coffee",
                                    "category": "Newly Launched",
                                    "description": "The Starbucks Spiced Classic Coffee pairs signature Starbucks espresso with comforting spice notes. A Smooth, aromatic, and perfectly balanced beverage.\nServing size (ml)/Calories (kcal) - Picco (180ml) - 194 kcal.\nAllergen - Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/1/7ae00526-c94e-4aef-8a7d-879011112da4_4cceaf9b-4780-4f06-9082-8a770410d117.jpg",
                                    "isVeg": 1,
                                    "price": 19500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68002742",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "204398783",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "204398784",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "204398785",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "204398786",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "204398787",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "251982601",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "112956098"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186002127",
                                    "name": "Tamrind Shikanji Cold brew",
                                    "category": "Newly Launched",
                                    "description": "A must try fusion —  Starbucks Tamarind Shikanji Cold Brew pairs the tangy zest of Shikanji with the smooth notes of Starbucks Signature cold brew.\nServing size (ml)/Calories (kcal) - Short (237ml) - 55 kcal / Tall (354ml) - 80 kcal / Grande (473ml) - 118 kcal.\nAllergen - NA.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/1/971dbbc8-c177-4023-859a-124b7c070087_13e06072-ebad-4d82-8460-e543bdd0422a.jpg",
                                    "isVeg": 1,
                                    "price": 33500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68049608",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "204501930",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "id": "204501931",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "id": "204501932",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "252294388",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "112956099"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "68379440"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/1/18695f79-7a1a-4c69-b328-5930dbb4365d_89fb874f-52c6-4c6c-a1e2-7b22c2a7f354.jpg",
                        "categoryId": "68379439"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Holiday Specials",
                        "categories": [
                          {
                            "title": "Drinks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187331528",
                                    "name": "Iced Toffee Nut Matcha",
                                    "category": "Holiday Specials",
                                    "description": "Smooth matcha foam topped over iced toffee-nut latte. A perfect combination for a comforting, elevated winter sip. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 286 kcal, Grande (473ml) - 346 kcal, Venti (591ml) - 392 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/06e7acbf-650d-456c-b757-50c8f86ca0c7_0a6cb424-22d4-4686-90c6-22e5be52ce96.jpg",
                                    "isVeg": 1,
                                    "price": 39500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672921",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Grande",
                                              "price": 4500,
                                              "default": 1,
                                              "id": "205832314",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 9000,
                                              "id": "205832315",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "id": "205832313",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672922",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832316",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255485985",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "126347766",
                                            "name": "With Whipped Topping",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485986",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113916723"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "104438427",
                                    "name": "Iced Toffee Nut Crunch Latte",
                                    "category": "Holiday Specials",
                                    "description": "Delight your senses with our Iced Toffee Nut Crunch Latte. A perfect combination of velvety milk, our signature espresso, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with whipped toffee nut topping and graham crackers. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 280 kcal, Grande (473ml) - 341 kcal, Venti (591ml) - 393 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ca37af1-a133-4ee6-a3f0-c03a74ce260c_64b0e21b-3d63-4fb9-b71a-f4152c8ac428.png",
                                    "isVeg": 1,
                                    "price": 44500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672923",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Grande",
                                              "price": 5000,
                                              "default": 1,
                                              "id": "205832318",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 10000,
                                              "id": "205832319",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall",
                                              "id": "205832317",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672924",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832320",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832321",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832322",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832323",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832324",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255485987",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485988",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485989",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485990",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845486"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "104438418",
                                    "name": "Toffee Nut Crunch Latte",
                                    "category": "Holiday Specials",
                                    "description": "Delight your senses with our Toffee Nut Crunch Latte. A perfect combination of steamed milk, our signature espresso, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with whipped toffee nut topping and graham crackers. Serving size (ml)/Calories (kcal) -  Short (237ml) - 225 kcal, Tall (354ml) - 343 kcal, Grande (473ml) - 419 kcal, Venti (591ml) - 527 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/ee7209a8-3702-4b99-9861-63d1299f1e4d_a6136f6e-1b15-4a23-8f4f-8a47df43b8ff.jpg",
                                    "isVeg": 1,
                                    "price": 39500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672925",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Tall",
                                              "price": 5000,
                                              "default": 1,
                                              "id": "205832326",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Grande",
                                              "price": 10000,
                                              "id": "205832327",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Venti",
                                              "price": 15000,
                                              "id": "205832328",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Short",
                                              "id": "205832325",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672926",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832329",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832330",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832331",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832332",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832333",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255485991",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485992",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485993",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485994",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14846189"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "104438429",
                                    "name": "Toffee Nut Crunch Frappuccino",
                                    "category": "Holiday Specials",
                                    "description": "Delight your senses with our Toffee Nut Crunch Frappuccino. A perfect blend of milk, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with whipped toffee nut topping and graham crackers. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 358 kcal, Grande (473ml) - 480 kcal, Venti (591ml) - 589 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/6ca37af1-a133-4ee6-a3f0-c03a74ce260c_64b0e21b-3d63-4fb9-b71a-f4152c8ac428.png",
                                    "isVeg": 1,
                                    "price": 48000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672927",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Blended Grande",
                                              "price": 5000,
                                              "default": 1,
                                              "id": "205832335",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Venti",
                                              "price": 10000,
                                              "id": "205832336",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Tall",
                                              "id": "205832334",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672928",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832337",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832338",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832339",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832340",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832341",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255485995",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485996",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485997",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255485998",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14846188"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187331529",
                                    "name": "Toffee Nut Cold Brew",
                                    "category": "Holiday Specials",
                                    "description": "Our small-batch cold brew—slow-steeped for a super-smooth taste—gets even better. Paired with the buttery and warm notes of toffee nut foam, topped with graham crackers. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 194 kcal, Grande (473ml) - 223 kcal, Venti (591ml) - 253 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/fb58e73f-1890-473d-9610-5b2eb5b03755_d78fce7e-67af-400c-9165-214565fceb5b.jpg",
                                    "isVeg": 1,
                                    "price": 43500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672929",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Grande",
                                              "price": 4500,
                                              "default": 1,
                                              "id": "205832343",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 9000,
                                              "id": "205832344",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "id": "205832342",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255486000",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113916724"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187331531",
                                    "name": "Crunchy Red Hat Frappuccino",
                                    "category": "Holiday Specials",
                                    "description": "Almost too cute to drink, our Crunchy Red Hat Mocha Frappuccino is a perfect blend of milk, smooth coffee, decadent mocha, a generous amout of whipped vanilla topping with a whipped chocolate hat and strawberry drizzle, finished with crunchy graham crackers. This beverage is not just a delight for your eyes but also a party in your mouth. Serving size (ml)/Calories (kcal) -  Tall (354ml) - 552 kcal, Grande (473ml) - 755 kcal, Venti (591ml) - 908 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/7dc3be58-ed3a-4198-b80f-434018af0f44_1c39bab3-ab32-4f4f-99ad-19c9104ae35e.jpg",
                                    "isVeg": 1,
                                    "price": 48000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672932",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "205832349",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Grande",
                                              "price": 5000,
                                              "id": "205832350",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blended Venti",
                                              "price": 10000,
                                              "id": "205832351",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672933",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832352",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832353",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832354",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832355",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832356",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255486003",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486004",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486005",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486007",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113916720"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105160717",
                                    "name": "Iced Crunchy Red Hat Mocha",
                                    "category": "Holiday Specials",
                                    "description": "Almost too cute to drink, our Iced Crunchy Red Hat Mocha Latte combines velvety milk, our signature Espresso, decadent mocha, a generous amout of whipped vanilla topping with a whipped chocolate hat and strawberry drizzle, finished with crunchy graham crackers. This beverage is not just a delight for your eyes but also a party in your mouth.  Serving size (ml)/Calories (kcal) -  Tall (354ml) - 396 kcal, Grande (473ml) - 477 kcal, Venti (591ml) - 545 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/7dc3be58-ed3a-4198-b80f-434018af0f44_1c39bab3-ab32-4f4f-99ad-19c9104ae35e.jpg",
                                    "isVeg": 1,
                                    "price": 44500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672936",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "205832365",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 5000,
                                              "id": "205832366",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 10000,
                                              "id": "205832367",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672937",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832368",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832369",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832370",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832371",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832372",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255486012",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486013",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486014",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486015",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14845355"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "104438409",
                                    "name": "Crunchy Red Hat Mocha",
                                    "category": "Holiday Specials",
                                    "description": "Our Crunchy Red Hat Mocha Latte combines steamed milk, our  espresso, decadent mocha, a generous amout of whipped vanilla topping with a whipped chocolate hat and strawberry drizzle, finished with crunchy graham crackers. This beverage is not just a delight for your eyes but also a party in your mouth. Serving size (ml)/Calories (kcal) -  Short (237ml) - 415 kcal, Tall (354ml) - 621 kcal, Grande (473ml) - 797 kcal, Venti (591ml) - 994 kcal. Allergen - Contains Milk, Oats, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/03e7751d-3403-4aa0-a243-9ad8fb81b110_b80e4e72-8571-4ef6-9909-2a6aa70227ae.png",
                                    "isVeg": 1,
                                    "price": 39500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68672940",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "205832382",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Grande",
                                              "price": 10000,
                                              "id": "205832383",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Venti",
                                              "price": 15000,
                                              "id": "205832384",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Crunchy Red Hat Mocha-",
                                              "price": 5000,
                                              "id": "205832385",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68672941",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "205832386",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "205832387",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "205832388",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "205832389",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "205832390",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "255486020",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486022",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486023",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "135919047",
                                            "name": "With Whipped Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "255486024",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844669"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "68997188"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/06e7acbf-650d-456c-b757-50c8f86ca0c7_0a6cb424-22d4-4686-90c6-22e5be52ce96.jpg",
                        "categoryId": "68997186"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Festive Specials",
                        "categories": [
                          {
                            "title": "Food",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "181672004",
                                    "name": "Chatpata Paneer Swirl",
                                    "category": "Festive Specials",
                                    "description": "Need a quick bite for your coffee break ? This croissant swirl topped with paneer tikka and mozzarella cheese could just be your snack in need.\nPer serve (56 g) - 212 kcal.\nAllergens: Contains Milk, Wheat, Nuts.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/9/886b0083-80b2-41fe-8457-4366ec8de29a_fa476d77-5eac-49b6-8470-e69e971fe9e9.jpg",
                                    "isVeg": 1,
                                    "price": 18000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "110238615"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "66415246"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/9/886b0083-80b2-41fe-8457-4366ec8de29a_fa476d77-5eac-49b6-8470-e69e971fe9e9.jpg",
                        "categoryId": "66415244"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Breakfast Bites",
                        "categories": [
                          {
                            "title": "Breakfast Specials",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439516",
                                    "name": "Short Blonde Cappuccino & Egg White & Chicken in Multigrain Croissant",
                                    "category": "Breakfast Bites",
                                    "description": "Handcrafted with blonde espresso from the World’s finest coffee beans, steamed milk with velvety foam. Fluffy egg white omelette and chicken ham sandwiched in multigrain croissant.\nBeverage Serving size (ml)/Calories (kcal) - Short (237ml) - 66 kcal.\nFood Per serve (200 g) - 541 kcal.\nAllergen - Contains Wheat, Oats, Milk, Egg, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/c3f3e6ea-b809-4893-8dd5-22e869cf8ed5_76d05475-61c3-4b84-b057-37fcf2743068.jpg",
                                    "price": 59000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743655",
                                          "name": "Short Blonde Cappuccino Size",
                                          "variations": [
                                            {
                                              "name": "Short Blonde",
                                              "default": 1,
                                              "id": "194905278",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107937228"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439517",
                                    "name": "Short Blonde Jaggery Oat Latte with Tofu Spinach Croissant Sandwich",
                                    "category": "Breakfast Bites",
                                    "description": "Handcrafted with blonde espresso from the World’s finest coffee beans, with plant based oat (Non dairy), accentuated with jaggery powder. Scrambled tofu & spinach with Cheddar cheese & feta spread encased in a buttery & herbed croissant for a savory delight.\nBeverage Serving size (ml)/Calories (kcal) - Short (237ml) - 206 kcal.\nFood Per serve (105 g) - 595 kcal.\nAllergen - Contains Oats,Milk,Wheat,Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/927d0429-3812-414a-b859-5a44efd74e67_3a764655-6124-4bdf-9349-ea5c97a02bf7.jpg",
                                    "isVeg": 1,
                                    "price": 57000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743656",
                                          "name": "Short Blonde Jaggery Oat Latte Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "194905279",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107815415"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64993070"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/c3f3e6ea-b809-4893-8dd5-22e869cf8ed5_76d05475-61c3-4b84-b057-37fcf2743068.jpg",
                        "categoryId": "64993066"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Snack Time Combos",
                        "categories": [
                          {
                            "title": "Snack Time Specials",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439518",
                                    "name": "Tall Cold Coffee with Cheese Peri Peri Pop Fries",
                                    "category": "Snack Time Combos",
                                    "description": "Everybody’s favourite indulgence. Crafted expertly with premium espresso, blended with milk, and perfected with a hint of vanilla in every sip. Pop fries with a spicy peri peri seasoning and cheesy topping.\nBeverage Serving Size Tall (354ml) - 354 kcal.\nFood Per Serve (163g) - 380 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/7b67074b-9207-49b1-8cf0-1dc6578362b6_6b172afc-30c4-4c63-8b9a-78ec836a3355.jpg",
                                    "isVeg": 1,
                                    "price": 48000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743657",
                                          "name": "Tall Cold Coffee Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "194905280",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107815416"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439519",
                                    "name": "Tall Java Chip Frappuccino with Masala Crispers",
                                    "category": "Snack Time Combos",
                                    "description": "A joyful blend of coffee, Java chips, and mocha syrup with milk and ice. Topped with a perfect whipped vanilla swirl and mocha drizzle to finish. Crunchy potato wedges with a masala seasoning.\nBeverage Serving Size Tall (354ml) - 392 kcal.\nFood Per Serve (163g) - 312 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/25450c48-4c20-4110-9057-cb2427627ef3_ca987b82-4a40-4a00-b73a-a97db2b502fb.jpg",
                                    "isVeg": 1,
                                    "price": 51000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743658",
                                          "name": "Tall Java Chip Frappuccino Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "194905281",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107815417"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439520",
                                    "name": "Short Orange Butterscotch Classic Iced Coffee&Cheese PeriPeri PopFries",
                                    "category": "Snack Time Combos",
                                    "description": "Meet the Orange Butterscotch Classic Iced Coffee, combining bold espresso shaken over ice with zesty orange and buttery butterscotch flavours, topped with a splash of milk. Smooth, frothy, and effortlessly balanced, it's perfect for any time of the day. Pop fries with a spicy peri peri seasoning and cheesy topping.\nBeverage Serving size (ml)/Calories (kcal) - Short (237ml) - 111 kcal.\nFood Per Serve (163g) - 380 kcal.\nAllergen - Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/1/996f4c83-a9af-4ce0-9965-24e7af378505_8181eb04-24f4-4573-ab5d-2c6e45d6e55b.jpg",
                                    "isVeg": 1,
                                    "price": 45000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743659",
                                          "name": "Short Orange Butterscotch Classic Iced Coffee Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "194905282",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107937229"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439521",
                                    "name": "Picco Classic Hot Coffee with Masala Crispers",
                                    "category": "Snack Time Combos",
                                    "description": "Savour our premium coffee made with top 3% Arabica beans in an all new avatar. Starbucks Signature espresso paired with condensed milk for an ideal blend of sweetness and caffeine boost. Crunchy potato wedges with a masala seasoning.\nBeverage Serving Size Picco (180 ml) - 105 kcal.\nFood Per Serve (163g) - 312 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/31/d59998cd-15be-495b-94ae-305ea46dc1e6_9a856114-a737-4e4d-9c23-526e4bee2877.jpg",
                                    "isVeg": 1,
                                    "price": 35000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743660",
                                          "name": "Picco Classic Hot Coffee Size",
                                          "variations": [
                                            {
                                              "name": "Classic Hot Coffee",
                                              "default": 1,
                                              "id": "194905283",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "99789387"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64993071"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/7b67074b-9207-49b1-8cf0-1dc6578362b6_6b172afc-30c4-4c63-8b9a-78ec836a3355.jpg",
                        "categoryId": "64993067"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Dessert Specials Combos",
                        "categories": [
                          {
                            "title": "Dessert Specials Combos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439523",
                                    "name": "Tall Java Chip Frappuccino with Chocolate Truffle Pastry",
                                    "category": "Dessert Specials Combos",
                                    "description": "A joyful blend of coffee, Java chips, and mocha syrup with milk and ice. Topped with a perfect whipped vanilla swirl and mocha drizzle to finish. An absolute classic! A moist chocolate cake layered with whipped ganache and dark chocolate.\nBeverage Serving Size Tall (354ml) - 392 kcal.\nFood Per serve (100 g) - 575 kcal.\nAllergens: Contains Wheat, Milk, Soy, Nut.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/1/f99a679f-fd8c-48e2-8e50-383de0c363d7_414fd2c7-3ec2-4101-b97c-5ff33fd504f0.jpg",
                                    "isVeg": 1,
                                    "price": 69500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743662",
                                          "name": "Tall Java Chip Frappuccino Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "194905285",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107937230"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439525",
                                    "name": "Tall Signature Hot Chocolate with Banana Chocolate Loaf Cake",
                                    "category": "Dessert Specials Combos",
                                    "description": "Experience pure comfort in a cup. A caffeine-free delight created from the Starbucks’ signature hot chocolate powder. English tea cake with rich taste of banana and chocolate.\nBeverage Serving Size Tall (354ml) - 446 kcal.\nFood Per serve (125 g) - 385 kcal.\nAllergens: Contains Wheat, Soy, Egg, Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/a1b4fae0-ffc0-4499-aa9a-debb0f8955f3_e91e62ae-5597-4f18-9365-86e59c2a8a8f.jpg",
                                    "price": 59500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743664",
                                          "name": "Tall Signature Hot Chocolate Size",
                                          "variations": [
                                            {
                                              "name": "HOT TALL",
                                              "default": 1,
                                              "id": "194905287",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107815418"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439526",
                                    "name": "Tall Strawberry Acai Lemonade with Chocolate Truffle Pastry",
                                    "category": "Dessert Specials Combos",
                                    "description": "Sweet strawberry flavours accented by acai notes, shaken with ice and generous amount of sliced strawberry - a welcoming sweet spot of refreshment. An absolute classic! A moist chocolate cake layered with whipped ganache and dark chocolate.\nBeverage Serving Size Tall (354ml) - 89 kcal.\nFood Per serve (100 g) - 575 kcal.\nAllergens: Contains Milk, Soy, Wheat, Nut.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/1/8ae80520-2b3c-43c6-886c-d38d6baa34c8_098690f5-4831-41fe-9e9c-69c757579018.jpg",
                                    "isVeg": 1,
                                    "price": 67500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743665",
                                          "name": "Tall Strawberry Acai Lemonade Size",
                                          "variations": [
                                            {
                                              "name": "Tall Strawberry Acai Lemonade",
                                              "default": 1,
                                              "id": "194905288",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107937231"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178439528",
                                    "name": "Tall Strawberry Acai Lemonade with Banana Chocolate Loaf Cake",
                                    "category": "Dessert Specials Combos",
                                    "description": "Sweet strawberry flavours accented by acai notes, shaken with ice and generous amount of sliced strawberry - a welcoming sweet spot of refreshment. English tea cake with rich taste of banana and chocolate.\nBeverage Serving Size Tall (354ml) - 89 kcal.\nFood Per serve (125 g) - 385 kcal.\nAllergens: Contains Wheat, Soy, Egg, Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/c1f831ee-e5f4-4ad7-9386-28967bc5fc56_890cd567-5fb9-45a3-bfc2-ea4b617e2c0d.jpg",
                                    "price": 60000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "63743667",
                                          "name": "Tall Strawberry Acai Lemonade Size",
                                          "variations": [
                                            {
                                              "name": "Tall Strawberry Acai Lemonade",
                                              "default": 1,
                                              "id": "194905290",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107815419"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "64993072"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/8/1/f99a679f-fd8c-48e2-8e50-383de0c363d7_414fd2c7-3ec2-4101-b97c-5ff33fd504f0.jpg",
                        "categoryId": "64993068"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Classic Series",
                        "categories": [
                          {
                            "title": "Drink",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "151171240",
                                    "name": "Classic Hot Coffee",
                                    "category": "Classic Series",
                                    "description": "Savour our premium coffee made with top 3% Arabica beans in an all new avatar. Starbucks Signature espresso paired with condensed milk for an ideal blend of sweetness and caffeine boost.\nPicco (180 ml) - 105 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/17/66661dfc-62fc-497f-9de7-c0112bf64a60_af376f6c-200e-4e4c-9d33-22306d75094d.jpg",
                                    "isVeg": 1,
                                    "price": 15000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "48266177",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Classic Hot Coffee",
                                              "default": 1,
                                              "id": "152474149",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "176431270",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "176431271",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "176431272",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.8",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "89600184"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "150508619",
                                    "name": "Classic Iced Coffee",
                                    "category": "Classic Series",
                                    "description": "Savour our premium coffee made with top 3% Arabica beans in an all new iced avatar. Frothy iced shaken espresso flavoured with brown sugar and topped with milk for a refreshing and chic pick me up drink.\nShort (237 ml) - 128 kcal, Tall (354 ml) - 158 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/10/79edb456-9584-4ee9-9aea-3a8fcfc40a85_290e350e-78f5-4fa0-ac8a-e5468e8499f6.jpg",
                                    "isVeg": 1,
                                    "price": 22500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "48266179",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "152474151",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "price": 2500,
                                              "id": "152474152",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "48266181",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "152474154",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "206380135",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "206380136",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "206380137",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "206380138",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "176431273",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "176431274",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "176431275",
                                        "groupName": "Whipped cream",
                                        "choices": [
                                          {
                                            "id": "126347765",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "126347766",
                                            "name": "With Whipped Topping",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "176431276",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "89290753"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169574545",
                                    "name": "Orange Butterscotch Classic Iced Coffee",
                                    "category": "Classic Series",
                                    "description": "Meet the Orange Butterscotch Classic Iced Coffee, combining bold espresso shaken over ice with zesty orange and buttery butterscotch flavours, topped with a splash of milk. Smooth, frothy, and effortlessly balanced, it's perfect for any time of the day.\nServing size (ml)/Calories (kcal) - Short (237ml) - 111 kcal / Tall (354ml) - 141 kcal.\nAllergen - Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/b577b3c7-39a5-4961-b050-c26595a0a1ae_365eda6e-8f0e-49cf-a118-42ddaf6db7c3.jpg",
                                    "isVeg": 1,
                                    "price": 25500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58743825",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Tall",
                                              "price": 2500,
                                              "id": "182339123",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "182339122",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "58743826",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "182339125",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "182339124",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "182339127",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "182339126",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "182339128",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "216086622",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "216086623",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135919048",
                                            "name": "Blonde Espresso",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "216086624",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "102252182"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "53192967"
                          },
                          {
                            "title": "Food",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "151171244",
                                    "name": "Spinach & Corn Sandwich",
                                    "category": "Classic Series",
                                    "description": "A savory blend of spinach and corn, garlic & herb aioli, melted mozzarella cheese, all tucked between slices of bread.\nPer serve (200 g) - 541 kcal.\nAllergens: Contains Milk, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/20/e445ec16-66db-4f43-992c-0365a6fc9970_95447e69-6444-4b03-b677-ba7593db4a90.jpg",
                                    "isVeg": 1,
                                    "price": 25500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "89675159"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "89745215",
                                    "name": "Chicken Salad Sandwich",
                                    "category": "Classic Series",
                                    "description": "Tender chicken mixed with julienned colored bell peppers, green leafy lettuce, and a creamy mustard mayonnaise mixture.\nPer serve (185 g) - 574 kcal.\nAllergens: Contains Wheat, Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/20/c8a8c3a1-c6c7-4744-af66-2c124c17d542_34456e50-2789-4f4a-bcc6-b44fa60b4722.jpg",
                                    "price": 26000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "merch_bau/High%20Protein%201_1.png"
                                      }
                                    ],
                                    "parentId": "14844478"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "151171245",
                                    "name": "Paneer Tikka Sandwich",
                                    "category": "Classic Series",
                                    "description": "Marinated tandoori paneer filling, sliced cheese, and whole spinach leaves, all packed into a flavorful  sandwich.\nPer serve (185 g) - 738 kcal.\nAllergens: Contains Wheat, Milk, Nut, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/20/d7261255-4015-4c78-b6d1-2910d2078c0e_48aab3c9-c1f5-4c50-9b72-2d226422f6a6.jpg",
                                    "isVeg": 1,
                                    "price": 27000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "89675140"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "63574476"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/9/17/66661dfc-62fc-497f-9de7-c0112bf64a60_af376f6c-200e-4e4c-9d33-22306d75094d.jpg",
                        "categoryId": "53192962"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Make your Own Combo",
                        "categories": [
                          {
                            "title": "Combos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "156778646",
                                    "name": "Classic Coffee + Food Combo",
                                    "category": "Make your Own Combo",
                                    "description": "Try our new Classic series food & beverage combos",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/1af96853-8793-4166-9c0b-f9403db117d2_d3089568-e491-4c18-9756-227e85ffc44c.jpg",
                                    "price": 40500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "51706833",
                                          "name": "Drinks_Option",
                                          "variations": [
                                            {
                                              "name": "Picco Classic Hot Coffee.",
                                              "default": 1,
                                              "id": "161899791",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Short Classic Iced Coffee.",
                                              "price": 7500,
                                              "id": "161899792",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Short Orange Butterscotch Classic Iced Coffee",
                                              "price": 10500,
                                              "id": "190853218",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Strawberry Acai Lemonade",
                                              "price": 14000,
                                              "id": "190853219",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Mango Dragonfruit Refresher",
                                              "price": 14000,
                                              "id": "190853222",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Lychee Raspberry Refresher",
                                              "price": 14000,
                                              "id": "190853225",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Kiwi Calamansi Refresher",
                                              "price": 14000,
                                              "id": "190853227",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Java Chip Frappuccino",
                                              "price": 16000,
                                              "id": "181574130",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "51706834",
                                          "name": "Food_Options",
                                          "variations": [
                                            {
                                              "name": "Spinach & Corn Sandwich.",
                                              "default": 1,
                                              "id": "161899793",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Salad Sandwich",
                                              "price": 500,
                                              "id": "190853233",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Paneer Tikka Sandwich.",
                                              "price": 1500,
                                              "id": "161899794",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chicken Tikka Sandwich",
                                              "price": 5500,
                                              "id": "190853235",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "93603317"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169142410",
                                    "name": "Best Seller Bundle",
                                    "category": "Make your Own Combo",
                                    "description": "Try Our Best-Selling Food & Beverage Combos!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/8/d5aada58-7506-448a-9d06-9f8727160938_cc945001-2fb8-4e33-b283-049215287850.jpg",
                                    "price": 43500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58498721",
                                          "name": "Drinks_Option",
                                          "variations": [
                                            {
                                              "name": "Short Flat white",
                                              "default": 1,
                                              "id": "190853101",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Cappuccino",
                                              "price": 500,
                                              "id": "181574142",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall Latte",
                                              "price": 1000,
                                              "id": "190853102",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Cold Coffee",
                                              "price": 2500,
                                              "id": "181574143",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Java Chip Frappuccino",
                                              "price": 5000,
                                              "id": "181574144",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Vanilla Sweet Cream Cold brew",
                                              "price": 10000,
                                              "id": "190853103",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Double Chocolate Chip Frappuccino",
                                              "price": 10000,
                                              "id": "190853104",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall Cold brew with Ginger Ale",
                                              "price": 12000,
                                              "id": "190853105",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "58498722",
                                          "name": "Food_Options",
                                          "variations": [
                                            {
                                              "name": "Masala Potato Puff",
                                              "default": 1,
                                              "id": "181574145",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheese Peri Peri Pop Fries",
                                              "price": 2000,
                                              "id": "190853106",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Masala Crispers",
                                              "price": 2500,
                                              "id": "190853107",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Double Chocolate Chip Cookie",
                                              "price": 9000,
                                              "id": "190853108",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Paneer Tikka Sandwich",
                                              "price": 9500,
                                              "id": "181574148",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Cheese Toast",
                                              "price": 13500,
                                              "id": "181574150",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Egg White & Chicken in Multigrain Croiss",
                                              "price": 18500,
                                              "id": "181574151",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Basil Tomato & Mozzarella Cheese Sandwich",
                                              "price": 19500,
                                              "id": "190853109",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chocolate Truffle Pastry",
                                              "price": 21000,
                                              "id": "190853110",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "101969541"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169142413",
                                    "name": "Picco Delights",
                                    "category": "Make your Own Combo",
                                    "description": "Try our Picco beverage & food combo",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/8/b3e07cef-b9ab-40d6-b411-5a23b8cf46ca_e9356cd5-c48e-4594-9247-a39c6c4136f3.jpg",
                                    "price": 32500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58498723",
                                          "name": "Drinks_Option",
                                          "variations": [
                                            {
                                              "name": "Picco Classic Hot Coffee",
                                              "default": 1,
                                              "id": "181574152",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cappuccino",
                                              "price": 5000,
                                              "id": "181574153",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Latte",
                                              "price": 5500,
                                              "id": "181574154",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Java Chip Frappuccino",
                                              "price": 16000,
                                              "id": "181574155",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "58498724",
                                          "name": "Food_Options",
                                          "variations": [
                                            {
                                              "name": "Masala Potato Puff",
                                              "default": 1,
                                              "id": "181574156",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Double Chocolate Chip Cookie",
                                              "price": 9000,
                                              "id": "190853276",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Banana Chocolate Loaf Cake",
                                              "price": 13500,
                                              "id": "190853277",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Blueberry Muffin",
                                              "price": 13500,
                                              "id": "190853278",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chocolate Truffle Pastry",
                                              "price": 21000,
                                              "id": "190853279",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "101969542"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "182329360",
                                    "name": "Pure Veg Bliss",
                                    "category": "Make your Own Combo",
                                    "description": "Try our delicious Vegetarian Combo!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/17/0e9e1fb8-a0d3-4315-a4fc-ffe252628b83_d0d2fdba-bb99-4f79-b7af-27739f94ca00.jpg",
                                    "isVeg": 1,
                                    "price": 43000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "66065802",
                                          "name": "Drinks_Option",
                                          "variations": [
                                            {
                                              "name": "Iced Tall Americano",
                                              "default": 1,
                                              "id": "200018673",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Cappuccino",
                                              "price": 1000,
                                              "id": "200018674",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Latte",
                                              "price": 1500,
                                              "id": "200018675",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Cold Coffee",
                                              "price": 3000,
                                              "id": "200018676",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Strawberry Acai Lemonade",
                                              "price": 3500,
                                              "id": "200018677",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Flat White",
                                              "price": 4000,
                                              "id": "200018678",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tall Java Chip Frappuccino",
                                              "price": 5500,
                                              "id": "200018679",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Short Vanilla Sweet Cream Cold brew",
                                              "price": 6000,
                                              "id": "200018680",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "66065803",
                                          "name": "Food_Options",
                                          "variations": [
                                            {
                                              "name": "Masala Potato Puff",
                                              "default": 1,
                                              "id": "200018681",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheese Peri Peri Pop Fries",
                                              "price": 2000,
                                              "id": "200018682",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Masala Crispers",
                                              "price": 2500,
                                              "id": "200018683",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spinach & Corn Sandwich",
                                              "price": 8000,
                                              "id": "200018684",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Paneer Tikka Sandwich",
                                              "price": 9500,
                                              "id": "200018685",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Cheese Toast",
                                              "price": 13500,
                                              "id": "200018687",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond Butterscotch Cookie",
                                              "price": 10000,
                                              "id": "200018686",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Tofu & Spinach Croissant Sandwich",
                                              "price": 16500,
                                              "id": "200018688",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "110731598"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "56033278"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/27/1af96853-8793-4166-9c0b-f9403db117d2_d3089568-e491-4c18-9756-227e85ffc44c.jpg",
                        "categoryId": "56033277"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Hot Beverages",
                        "categories": [
                          {
                            "title": "Hot Coffee",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117751012",
                                    "name": "Cappuccino.",
                                    "category": "Hot Beverages",
                                    "description": "Espresso brewed with the world's top 3% Arabica beans, steamed milk, and velvety foam. Handcrafted by our skilled baristas with care.\nPicco (180ml) - 95 kcal / Short (237ml) 104 kcal / Tall (354ml) - 104 kcal / Grande (473ml) - 173 kcal / Venti (591ml) - 220 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "55904772a4328bfeff407ea73bf76c85",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272989",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Picco Cappuccino",
                                              "default": 1,
                                              "id": "177561871",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT SHORT",
                                              "price": 3000,
                                              "id": "177561875",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 6500,
                                              "id": "177561878",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 14500,
                                              "id": "177561881",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 10500,
                                              "id": "177561884",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272991",
                                          "name": "Milk / Non-dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177561887",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561890",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177561892",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561895",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177561897",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497153",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039583",
                                            "name": "Espresso shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497156",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039600",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "64 ratings",
                                        "ratingCountV2": "64"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                      }
                                    ],
                                    "parentId": "14844237"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972607",
                                    "name": "Latte",
                                    "category": "Hot Beverages",
                                    "description": "Handcrafted with espresso from the World’s Top 3% Arabica, steamed milk with a light foam.\nPicco (180ml) - 76 kcal / Short (237ml) 104 kcal / Tall (354ml) - 173 kcal / Grande (473ml) - 220 kcal / Venti (591ml) - 289 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "879e3f36c309519bd089ce9a8d13746f",
                                    "isVeg": 1,
                                    "price": 20500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273007",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Picco",
                                              "default": 1,
                                              "id": "177561942",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT SHORT",
                                              "price": 3000,
                                              "id": "177561945",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 10500,
                                              "id": "177561949",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 6500,
                                              "id": "177561950",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 14500,
                                              "id": "177561951",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273008",
                                          "name": "Milk / Non-dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561952",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561954",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177561957",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177561962",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177561965",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497175",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039583",
                                            "name": "Espresso shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497179",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039600",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "22 ratings",
                                        "ratingCountV2": "22"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845618"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "144139669",
                                    "name": "Cocoa Cappuccino",
                                    "category": "Hot Beverages",
                                    "description": "Crafted with premium espresso, steamed milk, velvety foam, and a touch of bittersweet cocoa for a chocolaty twist!\nShort (237ml) - 152 kcal / Tall (354ml) - 199 kcal / Grande (473ml) - 316 kcal / Venti (591ml) 411 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/24/df4dd2b9-b429-4ebc-a357-477f7e3e9c91_01e13b1b-8c5f-490a-938b-cdb67c31e4e5.jpg",
                                    "isVeg": 1,
                                    "price": 30500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273021",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "177561998",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Tall",
                                              "price": 3500,
                                              "id": "177562001",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Grande",
                                              "price": 7500,
                                              "id": "177562005",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Venti",
                                              "price": 11500,
                                              "id": "177562011",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273025",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562017",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562022",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562026",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562033",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562035",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497199",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039583",
                                            "name": "Espresso shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497204",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844584"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972434",
                                    "name": "Velvet Vanilla Latte",
                                    "category": "Hot Beverages",
                                    "description": "Savour our premium espresso made with top 3% Arabica beans, steamed milk, and velvety foam, complemented with vanilla syrup for a sweet sensation!\nShort (237ml) - 225 kcal / Tall (354ml) - 384 kcal / Grande (473ml) - 499 kcal / Venti (591ml) 658 kcal.\nAllergens: Contains Milk & Soy",
                                    "imageId": "d3ab0d1e81b2ed300fc6d4399de422fd",
                                    "isVeg": 1,
                                    "price": 33000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273040",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "177562073",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Tall",
                                              "price": 3500,
                                              "id": "177562075",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Grande",
                                              "price": 7500,
                                              "id": "177562078",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Hot Venti",
                                              "price": 11500,
                                              "id": "177562080",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273042",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562082",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562083",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562084",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562085",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562086",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497221",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039583",
                                            "name": "Espresso shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497222",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039612",
                                            "name": "Vanilla Syrup - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846309"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "159805683",
                                    "name": "Blonde Almond Latte",
                                    "category": "Hot Beverages",
                                    "description": "Ditch the dairy with our Plant-Based Almond special, paired with the subtle sweetness of our Signature Blonde Roast Espresso.\nShort (237ml)- 64 kcal.\nAllergens: Contains Nuts.",
                                    "imageId": "d3ab0d1e81b2ed300fc6d4399de422fd",
                                    "isVeg": 1,
                                    "price": 38500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "53421789",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "166792027",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "195884236",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "118782954",
                                            "name": "Almond",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884237",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884238",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884239",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "95659989"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "159805686",
                                    "name": "Honey Almond Flat White",
                                    "category": "Hot Beverages",
                                    "description": "Your daily cup of coffee gets even better in our Plant-Based Almond special, sweetened with Honey.\nShort (237ml)- 89 kcal.\nAllergens: Contains Nut.",
                                    "imageId": "8c22a38997cd0a8a8811c6654ab5565d",
                                    "isVeg": 1,
                                    "price": 39000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "53421791",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "166792029",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "195884244",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884245",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "118782954",
                                            "name": "Almond",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884246",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884247",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "95659995"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "159805687",
                                    "name": "Honey Oat Flat White",
                                    "category": "Hot Beverages",
                                    "description": "Your daily cup of coffee gets even better in our Plant-Based Oat special, sweetened with Honey.\nShort (237ml)- 114 kcal.\nAllergens: Contains Oat.",
                                    "imageId": "8c22a38997cd0a8a8811c6654ab5565d",
                                    "isVeg": 1,
                                    "price": 39000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "53421792",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Hot Short",
                                              "default": 1,
                                              "id": "166792030",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "195884248",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884249",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "118782944",
                                            "name": "Oats",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884250",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "130089341",
                                            "name": "Indian Espresso Roast (regular) - Default",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "195884251",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "95659996"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117751014",
                                    "name": "Caffe Americano.",
                                    "category": "Hot Beverages",
                                    "description": "Espresso brewed from the world’s top 3% percent Arabica beans with hot water for the perfect caffeine fix. \nShort (237ml) 0 kcal / Tall (354ml) - 0 kcal / Grande (473ml) - 0 kcal / Venti (591ml) - 0 kcal.\nAllergens: Nil.",
                                    "imageId": "l1mcce83ffcgpestbtom",
                                    "isVeg": 1,
                                    "price": 22000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273149",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562518",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562520",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562521",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562523",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497379",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497381",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "135039609",
                                            "name": "Regular milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039619",
                                            "name": "Skimmed Milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039615",
                                            "name": "Soy",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782944",
                                            "name": "Oats",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782954",
                                            "name": "Almond",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497383",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "19 ratings",
                                        "ratingCountV2": "19"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                      }
                                    ],
                                    "parentId": "14844188"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972344",
                                    "name": "Flat White",
                                    "category": "Hot Beverages",
                                    "description": "A timeless classic. Ristresso shots of espresso, steamed milk, expertly finished with a Starbucks dot.\nShort (237ml) - 104 kcal / Tall (354ml) - 173 kcal / Grande (473ml) - 220 kcal / Venti (591ml) - 289 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "8c22a38997cd0a8a8811c6654ab5565d",
                                    "isVeg": 1,
                                    "price": 26000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273159",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562561",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562565",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562568",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562571",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273162",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562572",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562574",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562577",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562580",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562583",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497394",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497395",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                      }
                                    ],
                                    "parentId": "14844838"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460204",
                                    "name": "Hazelnut Caffe Latte",
                                    "category": "Hot Beverages",
                                    "description": "Handcrafted with espresso from the World’s Top 3% Arabica, enhanced with hazelnut flavoured syrup, steamed milk, and light foam. Every sip is perfectly balanced.\nEnergy  - Hot - Short (237ml) - 130 kcal / Tall (354ml) - 199 kcal / Grande (473ml) - 246 kcal / Venti (591ml) - 315 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "1a9fdce66bf505e44187be24c8279649",
                                    "isVeg": 1,
                                    "price": 29000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273173",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562615",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562616",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562617",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562618",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273175",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562621",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562623",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562626",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562629",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562633",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497405",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497409",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55184946"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460210",
                                    "name": "Vanilla Caffe Latte",
                                    "category": "Hot Beverages",
                                    "description": "Handcrafted with espresso from the World’s Top 3% Arabica, enhanced with vanilla flavoured syrup, steamed milk, and light foam. Every sip is perfectly balanced.\nShort (237ml) - 153 kcal / Tall (354ml) - 247 kcal / Grande (473ml) - 319 kcal / Venti (591ml) - 412 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "68ee40a1b229ac0fc54c955b81190c91",
                                    "isVeg": 1,
                                    "price": 29000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273186",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562673",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562676",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562681",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562686",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273191",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562692",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562697",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562701",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562704",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562708",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497424",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497427",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55184947"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972370",
                                    "name": "White Chocolate Mocha",
                                    "category": "Hot Beverages",
                                    "description": "Espresso sourced from the world’s top 3% Arabica coffee beans and steamed milk sweetened with white chocolate sauce to create a sweet indulgence.\nShort (237ml) - 252 kcal / Tall (354ml) - 395 kcal / Grande (473ml) - 451 kcal / Venti (591ml) 564 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "c3be401a767e1112eb08332238e23486",
                                    "isVeg": 1,
                                    "price": 30500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273201",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562740",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562742",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562743",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562747",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273204",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562752",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562755",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562758",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562761",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562764",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497440",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497443",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846358"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460209",
                                    "name": "Caffe Mocha",
                                    "category": "Hot Beverages",
                                    "description": "Full-bodied espresso meets bittersweet mocha sauce and freshly steamed milk to satisfy your sweet tooth.\nShort (237ml) - 212 kcal / Tall (354ml) - 332 kcal / Grande (473ml) - 374 kcal / Venti (591ml) 466 kcal.\nAllergens: Contains Milk & Soy.",
                                    "imageId": "3025f8a9c06ea45d6b44ec51a387d617",
                                    "isVeg": 1,
                                    "price": 30500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273219",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562798",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562799",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562802",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562805",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273223",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562810",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562813",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562817",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562821",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562824",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497455",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497459",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "20 ratings",
                                        "ratingCountV2": "20"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844215"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972364",
                                    "name": "Caramel Macchiato",
                                    "category": "Hot Beverages",
                                    "description": "Espresso poured over steamed milk infused with vanilla syrup. Finished with a beautiful cross hash caramel drizzle on the top for a decadent treat.\nShort (237ml) - 162 kcal / Tall (354ml) - 255 kcal / Grande (473ml) - 333 kcal / Venti (591ml) 426 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "1941c60d2aceaa617548dd5273ae5eec",
                                    "isVeg": 1,
                                    "price": 33000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273230",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562840",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562843",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562845",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562847",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273232",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562849",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562851",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562854",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562859",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562862",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497467",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497471",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844342"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041182"
                          },
                          {
                            "title": "Chai & Filter Coffee",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804165",
                                    "name": "Filter Coffee",
                                    "category": "Hot Beverages",
                                    "description": "A South Indian specialty. Expertly handcrafted to deliver excellence in every sip. \nPicco (180ml) - 166 kcal/ Short (237ml) - 176 kcal .\nAllergens: Contains Milk.",
                                    "imageId": "0c685119085657406f83377693bc1a70",
                                    "isVeg": 1,
                                    "price": 20500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273241",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Picco",
                                              "default": 1,
                                              "id": "177562884",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT SHORT",
                                              "price": 3000,
                                              "id": "177562889",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273242",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562894",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "53018759"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95803825",
                                    "name": "Masala Chai",
                                    "category": "Hot Beverages",
                                    "description": "Delight in our classic masala chai, bursting with flavours of hearty Indian spices and flavorful handpicked teas. \nPicco (180ml) - 227 kcal/ Short (237ml) - 236 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "24eba55ea8ac447037d90e3aee86a5e4",
                                    "isVeg": 1,
                                    "price": 20500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273247",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Picco",
                                              "default": 1,
                                              "id": "177562914",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT SHORT",
                                              "price": 3000,
                                              "id": "177562915",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273249",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562918",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "53018765"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972549",
                                    "name": "Green Tea Latte",
                                    "category": "Hot Beverages",
                                    "description": "Our creamy matcha, lightly sweetened, and paired with steamed milk for a delight in every sip.\nShort (237ml) - 171 kcal / Tall (354ml) - 240 kcal / Grande (473ml) - 321 kcal / Venti (591ml) 424 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "e0564cbe64a6cbdbebadcc6e6672186e",
                                    "isVeg": 1,
                                    "price": 27500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273258",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562957",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562959",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562961",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562963",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273260",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562965",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562966",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177562967",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562968",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177562969",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497505",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497507",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845012"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972557",
                                    "name": "Chai Tea Latte",
                                    "category": "Hot Beverages",
                                    "description": "Black tea infused with cinnamon, clove, and warming spices, mixed with milk for a perfect sweet and spicy balance.\nShort (237ml) - 174 kcal / Tall (354ml) - 203 kcal / Grande (473ml) - 305 kcal / Venti (591ml) 385 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "fa43c02ef546cb60eb92c03de562d52d",
                                    "isVeg": 1,
                                    "price": 27500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273265",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "HOT SHORT",
                                              "default": 1,
                                              "id": "177562983",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 3500,
                                              "id": "177562985",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 7500,
                                              "id": "177562987",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 11500,
                                              "id": "177562989",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273267",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177562992",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177562995",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177562998",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177563002",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177563004",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497517",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497520",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844415"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041183"
                          },
                          {
                            "title": "Signature Hot Chocolate",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972689",
                                    "name": "Signature Hot Chocolate",
                                    "category": "Hot Beverages",
                                    "description": "Experience pure comfort in a cup. A caffeine-free delight created from the Starbucks’ signature hot chocolate powder.\nPicco (180ml) - 123 kcal / Short (237ml) - 284 kcal / Tall (354ml) - 446 kcal / Grande (473ml) - 580 kcal / Venti (591ml) 735 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "22a7de0a911ce1409758c05769c5fc4b",
                                    "isVeg": 1,
                                    "price": 22000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57273274",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Picco Signature Hot Chocolate",
                                              "default": 1,
                                              "id": "177563025",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT SHORT",
                                              "price": 3000,
                                              "id": "177563026",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT TALL",
                                              "price": 6500,
                                              "id": "177563027",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT GRANDE",
                                              "price": 10500,
                                              "id": "177563028",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "HOT VENTI",
                                              "price": 14500,
                                              "id": "177563029",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57273275",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177563030",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177563031",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177563032",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177563033",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177563034",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497531",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039594",
                                            "name": "Caramel Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "67 ratings",
                                        "ratingCountV2": "67"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845966"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041184"
                          }
                        ],
                        "image": "55904772a4328bfeff407ea73bf76c85",
                        "categoryId": "60041176"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Cold Beverages",
                        "categories": [
                          {
                            "title": "Frappuccino",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972374",
                                    "name": "Coffee Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Savour one of our original Frappuccinos - a smooth fusion of coffee, milk, and ice.\nTall (354ml) - 153 kcal / Grande (473ml) - 223 kcal / Venti (591ml) - 280 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "a96e63604672f1495f6b6239f5359885",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272303",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177559360",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177559362",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177559367",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272306",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177559369",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177559372",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177559374",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177559377",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177559378",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496155",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496158",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496160",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "27 ratings",
                                        "ratingCountV2": "27"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844612"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460241",
                                    "name": "Mocha  Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Brighten your day with this delightful blend of coffee, mocha sauce, milk, and ice, topped with a whipped vanilla topping.\nTall (354ml) - 261 kcal / Grande (473ml) - 359 kcal / Venti (591ml) - 443 kcal.\nAllergens: Contains Milk & Soy",
                                    "imageId": "57d5ab91750bf825caf36de7caf89e76",
                                    "isVeg": 1,
                                    "price": 35000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272316",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177559407",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177559409",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177559410",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272317",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177559411",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177559412",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177559414",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177559416",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177559418",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496172",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496174",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496177",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845702"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117751011",
                                    "name": "Java Chip Frappuccino.",
                                    "category": "Cold Beverages",
                                    "description": "A joyful blend of coffee, Java chips, and mocha syrup with milk and ice. Topped with a perfect whipped vanilla swirl and mocha drizzle to finish. \nTall (354ml) - 329 kcal / Grande - (473ml) - 456 kcal / Venti (591ml) - 569 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "434146cff15b354b9dc1b6273a9afede",
                                    "isVeg": 1,
                                    "price": 31000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272328",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177559455",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177559456",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177559457",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272329",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177559458",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177559459",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177559460",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177559461",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177559462",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496190",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496191",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496193",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "155 ratings",
                                        "ratingCountV2": "155"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845541"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972394",
                                    "name": "Vanilla Cream Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Creamy Vanilla goodness. A smooth blend of vanilla, milk, and ice, finished with a whipped vanilla topping.\nTall (354ml) - 345 kcal / Grande (473ml) - 475 kcal / Venti (591ml) - 592 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "dd9d369cc7ecf3fa8f7487cefe0df410",
                                    "isVeg": 1,
                                    "price": 32500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272483",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560040",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560042",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560044",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272485",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560047",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560050",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560052",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560054",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560056",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496427",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496428",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496434",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846217"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972382",
                                    "name": "Espresso Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Bold and refreshing, Espresso crafted from the World’s Top 3% Arabica coffee beans is blended with milk and ice.\nTall (354ml) - 195 kcal / Grande (473ml) - 293 kcal / Venti (591ml) - 378 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "941109213cfd61b695033c90c8e0bf1f",
                                    "isVeg": 1,
                                    "price": 33500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272500",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560108",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560110",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560113",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272503",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560116",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560118",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560122",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560124",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560126",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496455",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496457",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496460",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844805"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972524",
                                    "name": "Caramel Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Indulge in this divine blend of coffee, caramel syrup, milk, and ice. Crowned with a whipped vanilla topping and a swirl of caramel drizzle for that perfect treat.\nTall (354ml) - 284 kcal / Grande (473ml) - 374 kcal / Venti (591ml) - 459 kcal.\nAllergens: Contains Milk & Soy.",
                                    "imageId": "f59a4ebafc1381f2ee49c5a2ce6e93ae",
                                    "isVeg": 1,
                                    "price": 32000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272515",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560163",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560166",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560171",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272518",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560175",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560180",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560186",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560191",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560193",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496477",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496483",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496489",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "19 ratings",
                                        "ratingCountV2": "19"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844290"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460234",
                                    "name": "Strawberries & Crème Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "A blend of sweet strawberry flavours, milk, and ice, with a whipped topping. A fruity paradise in every sip!\nTall (354ml) - 530 kcal / Grande (473ml) - 753 kcal / Venti (591ml) - 963 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "99b80e8043d2b904a6dee1984a14c67f",
                                    "isVeg": 1,
                                    "price": 32500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272535",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560239",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560242",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560245",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272537",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560247",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560248",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560249",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560250",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560251",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496509",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039616",
                                            "name": "Strawberry Syrup Modifier",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496511",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "135039601",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039605",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "53358975"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972553",
                                    "name": "White Mocha Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "A heavenly blend of coffee, white chocolate, milk, and ice. Topped with whipped vanilla for a delightful treat for your tastebuds.\nTall (354ml) - 371 kcal / Grande (473ml) - 539 kcal / Venti (591ml) - 644 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "8aaebd72bc16a8d1c34f0b74a4b105df",
                                    "isVeg": 1,
                                    "price": 34500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272549",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560290",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560293",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560295",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272551",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560297",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560301",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560304",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560309",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560315",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496529",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496533",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496540",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846368"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972354",
                                    "name": "Caramel Java Chip Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "A sweet delight. Coffee with mocha syrup blended with milk, Java chips, caramel syrup and ice. Topped with a whipped topping and a drizzle of caramel perfection.\nTall (354ml) - 328 kcal / Grande (473ml) - 478 kcal / Venti (591ml) - 592 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "3c7b2ce395ed7658612e7b2f212f1b8d",
                                    "isVeg": 1,
                                    "price": 36500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272569",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560366",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560368",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560370",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272570",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560371",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560373",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560375",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560377",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560379",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496559",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496560",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496563",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "20 ratings",
                                        "ratingCountV2": "20"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844303"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972338",
                                    "name": "Double Chocolate Chip Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "Indulge in this blend of mocha syrup, chocolatey Java chips, milk, and ice. Finished with a vanilla whipped topping and mocha drizzle to make you experience pure bliss.\nTall (354ml) - 417 kcal / Grande (473ml) - 584 kcal / Venti (591ml) - 734 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "7eca19e43a0014e011e36752dfdb6b0e",
                                    "isVeg": 1,
                                    "price": 36000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272590",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560453",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560457",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560461",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272594",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560466",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560470",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560473",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560475",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560477",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496594",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496596",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496601",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "71 ratings",
                                        "ratingCountV2": "71"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844721"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972332",
                                    "name": "Green Tea Cream Frappuccino",
                                    "category": "Cold Beverages",
                                    "description": "A fusion of premium matcha green tea, chilled milk, and ice, with a dollop of whipped topping to give you a delicious energy boost!\nTall (354ml) - 412 kcal / Grande (473ml) - 576 kcal / Venti (591ml) - 727 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "8494064d33646e4697dc7f56f0908a78",
                                    "isVeg": 1,
                                    "price": 37000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272614",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177560545",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177560550",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177560555",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272616",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560558",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560561",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560564",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560569",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560572",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496627",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496632",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496637",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039585",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.5",
                                        "ratingCount": "8 ratings",
                                        "ratingCountV2": "8"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845004"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041177"
                          },
                          {
                            "title": "Refresher",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "167157046",
                                    "name": "Kiwi Calamansi Refresher",
                                    "category": "Cold Beverages",
                                    "description": "Enjoy a burst of playfulness with our Kiwi Calamansi Refresher.\nBright Calamansi flavoured refreshing drink with freeze-dried Kiwi dices and green coffee extract.\nServing size (ml)/Calories (kcal) - Short (237ml) - 72 kcal / Tall (354ml) - 114 kcal / Grande (473ml) - 150 kcal / Venti (591ml) - 184 kcal.\nAllergen - NA.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/48ddffbf-d323-47dd-b4db-985adcdeda49_31de3a2b-a29a-47e3-b326-c2d9292a1cfd.jpg",
                                    "isVeg": 1,
                                    "price": 24500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272643",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "default": 1,
                                              "id": "177560669",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "177560672",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 13500,
                                              "id": "177560674",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Short",
                                              "id": "177560666",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496667",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "133668347",
                                            "name": "Matcha Tea Powder-modifier",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496672",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "100802972"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "167157048",
                                    "name": "Lychee Raspberry Refresher",
                                    "category": "Cold Beverages",
                                    "description": "Enjoy a symphony of juicy lychee flavours and tart freeze dried raspberries with our Lychee Raspberry refresher.\nPowered with green coffee extract.\nServing size (ml)/Calories (kcal) - Short (237ml) - 67 kcal / Tall (354ml) - 107 kcal / Grande (473ml) - 143 kcal / Venti (591ml) - 179 kcal.\nAllergen - NA.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/17/1192f666-e1de-4376-9f6d-ad46886f0c48_0693de65-d61a-4378-a1b7-25946ec6adb6.jpg",
                                    "isVeg": 1,
                                    "price": 24500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272658",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "default": 1,
                                              "id": "177560726",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "177560731",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 13500,
                                              "id": "177560735",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Short",
                                              "id": "177560720",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496687",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "133668347",
                                            "name": "Matcha Tea Powder-modifier",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496695",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "100802973"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119404000",
                                    "name": "Strawberry Acai Refresher",
                                    "category": "Cold Beverages",
                                    "description": "Sweet strawberry flavours accented by acai notes, shaken with ice and generous amount of sliced strawberry - a welcoming sweet spot of refreshment.\nShort (237 ml) - 54 kcal / Tall (354ml) - 86 kcal / Grande (473ml) - 114 kcal / Venti (591ml) - 140 kcal.\nAllergens: Nil.",
                                    "imageId": "170fe1a820ea49ec31f88deb5dd820a9",
                                    "isVeg": 1,
                                    "price": 24500,
                                    "finalPrice": 12300,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272673",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "177560773",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "id": "177560779",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "177560784",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 13500,
                                              "id": "177560791",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496713",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "133668347",
                                            "name": "Matcha Tea Powder-modifier",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496719",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "d8f7ca28-7246-4654-b7c0-aab24eb1ec59"
                                    ],
                                    "parentId": "79482632"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "135408519",
                                    "name": "Mango Dragonfruit Refresher",
                                    "category": "Cold Beverages",
                                    "description": "Crafted with a combination of vibrant mango and refreshing dragonfruit flavors. Hand-shaken with ice and generous amount of diced mango and dragonfruits. A tropical inspired pick-me-up.\nShort (237 ml) - 62 kcal / Tall (354ml) - 99 kcal / Grande (473ml) - 129 kcal / Venti (591ml) - 157 kcal.\nAllergens: Nil.",
                                    "imageId": "d9b65a9d8a70dc3874763274aaaaa3b8",
                                    "isVeg": 1,
                                    "price": 24500,
                                    "finalPrice": 12300,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272685",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "177560822",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "id": "177560825",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "177560829",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 13500,
                                              "id": "177560834",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496736",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "133668347",
                                            "name": "Matcha Tea Powder-modifier",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496739",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "135039581",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039603",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039604",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039593",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039611",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039620",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039610",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039598",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "d8f7ca28-7246-4654-b7c0-aab24eb1ec59"
                                    ],
                                    "parentId": "79482631"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "63995397"
                          },
                          {
                            "title": "Cold Coffee & Milkshakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "140096036",
                                    "name": "Iced Signature Chocolate",
                                    "category": "Cold Beverages",
                                    "description": "Four cocoas and chilled milk over ice. Topped with chocolate powder.A timeless classic made to sweeten your spirits.\nTall (354ml) - 356 kcal / Grande (473ml) - 476 kcal / Venti (591ml) - 551 kcal.\nAllergens: Contains Milk & Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/9/d735ce05-87b1-42cf-9ae2-760f5316a4c0_1be2cea3-a14a-418b-b110-545f8f9a3626.jpg",
                                    "isVeg": 1,
                                    "price": 28500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272715",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Tall",
                                              "default": 1,
                                              "id": "177560920",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 4000,
                                              "id": "177560924",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Venti",
                                              "price": 8000,
                                              "id": "177560928",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272720",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177560938",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177560942",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177560947",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177560951",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177560954",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496779",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496786",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "107426216",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340836",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496790",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847856",
                                            "name": "Extra Shot",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "82438983"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972495",
                                    "name": "Iced Shaken Hibiscus & Passion Lemonade",
                                    "category": "Cold Beverages",
                                    "description": "Delight in a zesty symphony of hibiscus, flavours of orange peel and a touch of cinnamon. Hand-shaken with ice for a sip of refreshment.\nTall (354ml) - 74 kcal / Grande (473ml) - 111 kcal / Venti (591ml) - 149 kcal.\nAllergens: Nil.",
                                    "imageId": "637587e4d95cf0d6a962017feb5befc7",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272705",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "ICED TALL",
                                              "default": 1,
                                              "id": "177560886",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 4500,
                                              "id": "177560888",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 9000,
                                              "id": "177560891",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496759",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "13 ratings",
                                        "ratingCountV2": "13"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845444"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460098",
                                    "name": "Cold coffee",
                                    "category": "Cold Beverages",
                                    "description": "Everybody’s favourite indulgence. Crafted expertly with premium espresso, blended with milk, and perfected with a hint of vanilla in every sip.\nTall (354ml) - 354 kcal / Grande (473ml) - 473 kcal / Venti (591ml) - 501 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "a96e63604672f1495f6b6239f5359885",
                                    "isVeg": 1,
                                    "price": 28500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272735",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177561001",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177561004",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272736",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561006",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561008",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496806",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039617",
                                            "name": "Espresso Choice-Modifier",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496810",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039607",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 6,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496814",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "135039601",
                                            "name": "No Whip Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039605",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "19 ratings",
                                        "ratingCountV2": "19"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844637"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95803859",
                                    "name": " Chocolate Milkshake",
                                    "category": "Cold Beverages",
                                    "description": "An indulgent Starbucks signature chocolate milkshake, perfected for you.\nTall (354ml) - 632 kcal / Grande (473ml) - 825 kcal / Venti (591ml) - 1050 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "ddffd6918a67a3e5f37a7bd3c21fb450",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272755",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177561074",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177561077",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177561080",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272757",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561085",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561088",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496837",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496842",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "135039605",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "21 ratings",
                                        "ratingCountV2": "21"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844560"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95803862",
                                    "name": "Strawberry Milkshake",
                                    "category": "Cold Beverages",
                                    "description": "Experience creamy goodness and a luscious strawberry flavour in every sip.\nTall (354ml) - 569 kcal / Grande (473ml) - 769 kcal / Venti (591ml) - 943 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "e7c3aad38b061ab1e09d2fa829843a37",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272767",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177561122",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177561123",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177561127",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272771",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561133",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561140",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496856",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496860",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "135039605",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846046"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95803877",
                                    "name": "Vanilla Milkshake",
                                    "category": "Cold Beverages",
                                    "description": "Delight in the timeless flavour of our Vanilla Milkshake.\nTall (354ml) - 531 kcal / Grande (473ml) - 700 kcal / Venti (591ml) 920 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "35e43f1e67336d6464f569dd22703adf",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272784",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Tall",
                                              "default": 1,
                                              "id": "177561184",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Grande",
                                              "price": 4500,
                                              "id": "177561186",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Venti",
                                              "price": 9000,
                                              "id": "177561188",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272786",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561191",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561192",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496881",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039606",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496885",
                                        "groupName": "Custom",
                                        "choices": [
                                          {
                                            "id": "63340941",
                                            "name": "Java Chips",
                                            "price": 3500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846253"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041179"
                          },
                          {
                            "title": "Cold Brews",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "68813070",
                                    "name": "Cold Brew with Ginger Ale",
                                    "category": "Cold Beverages",
                                    "description": "A refreshing double-layered beverage. Our 48-hour steeped cold brew layered with chilled ginger ale. \nTall (354ml) - 141 kcal / Grande (473ml) - 152 kcal / Venti (591ml) 162 kcal.\nAllergens: Nil.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/09104348-48b5-408e-8592-355099f67412_969d6123-a598-4c38-99c5-c483a181fe25.jpg",
                                    "isVeg": 1,
                                    "price": 33500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272835",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "177561359",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED TALL",
                                              "price": 4500,
                                              "id": "177561362",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 9000,
                                              "id": "177561366",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 13500,
                                              "id": "177561370",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496950",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 4,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844635"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972567",
                                    "name": "Cold Brew Black",
                                    "category": "Cold Beverages",
                                    "description": "Ground coffee steeped for 48 hours, creating a refined iced coffee served unsweetened over ice. Sourced from the world’s top 3% arabica beans.\nShort (237 ml) - 0 kcal / Tall (354ml) - 0 kcal / Grande (473ml) - 0 kcal / Venti (591ml) 0 kcal.\nAllergens: Nil.",
                                    "imageId": "35949f79295efd13d1456ce8f87805ef",
                                    "isVeg": 1,
                                    "price": 27000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57910022",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "179588808",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED TALL",
                                              "price": 4500,
                                              "id": "179588809",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 9000,
                                              "id": "179588810",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 13500,
                                              "id": "179588811",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "212468374",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "135039609",
                                            "name": "Regular milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039615",
                                            "name": "Soy",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039619",
                                            "name": "Skimmed Milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782954",
                                            "name": "Almond",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782944",
                                            "name": "Oats",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "212468375",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                      }
                                    ],
                                    "parentId": "14844633"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972559",
                                    "name": "Vanilla Sweet Cream Cold Brew",
                                    "category": "Cold Beverages",
                                    "description": "Our 48- hours steeped cold brew  topped with a slowly cascading vanilla sweet cream for a delicious twist on a classic favorite.\nShort (237 ml) - 54 kcal/ Tall (354ml) - 54 kcal/ Grande (473ml) - 72 kcal / Venti (591ml) - 90 kcal.\nAllergens: Contains Milk & Soy.",
                                    "imageId": "25acb2b6f55939cf70d98678cd2c5e30",
                                    "isVeg": 1,
                                    "price": 31500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57910023",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "179588812",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED TALL",
                                              "price": 4500,
                                              "id": "179588813",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 9000,
                                              "id": "179588814",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 13500,
                                              "id": "179588815",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57910024",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "179588816",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "212468376",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846254"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460252",
                                    "name": "Vietnamese Cold Brew",
                                    "category": "Cold Beverages",
                                    "description": "Our 48-hour steeped cold brew shaken with white chocolate and milk to add a touch of sweetness to this delight.\nShort (237 ml) - 162 kcal / Tall (354ml) - 194 kcal / Grande (473ml) - 289 kcal / Venti (591ml) 372 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "7aad9626ae5348c35d80a6fb4c2f4f81",
                                    "isVeg": 1,
                                    "price": 33500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57910025",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "179588817",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED TALL",
                                              "price": 4500,
                                              "id": "179588818",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 9000,
                                              "id": "179588819",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 13500,
                                              "id": "179588820",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57910026",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "179588821",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "212468377",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846351"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169574533",
                                    "name": "Zesty Orange Cold Brew",
                                    "category": "Cold Beverages",
                                    "description": "Experience the smooth intensity of our cold brew, perfectly balanced with vibrant citrus notes of orange in a refreshing, sparkling base. Finished with a candied orange slice, for a bold and invigorating twist on your coffee drinking experience.\nServing size (ml)/Calories (kcal) - Short (237ml) - 52 kcal / Tall (354ml) - 71 kcal / Grande (473ml) - 95 kcal.\nAllergen - NA.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/1eeaf924-f713-4d77-8801-22bad8436dc1_215356ff-e0c5-4911-a6ca-f8b62fce4bc5.jpg",
                                    "isVeg": 1,
                                    "price": 33500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58743814",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Iced Short",
                                              "default": 1,
                                              "id": "182339078",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Tall",
                                              "price": 4500,
                                              "id": "182339079",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Iced Grande",
                                              "price": 9000,
                                              "id": "182339080",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "216086601",
                                        "groupName": "Syrups & Sauces ",
                                        "choices": [
                                          {
                                            "id": "73138736",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138752",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "73138775",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400995",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "64400996",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847858",
                                            "name": "Classic Syrup (sweet)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340840",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "114847855",
                                            "name": "Strawberry Sauce",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "102252183"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041180"
                          },
                          {
                            "title": "Iced Coffee Beverages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460247",
                                    "name": "Iced Caffè Americano",
                                    "category": "Cold Beverages",
                                    "description": "Espresso sourced from the World’s top 3% Arabica with cold water to create a layer of velvety, aromatic Crema. Served over ice for a refreshing kick.\nTall (354ml) - 0 kcal / Grande (473ml) - 0 kcal / Venti (591ml) - 0 kcal.\nAllergens: Nil.",
                                    "imageId": "7929088409382fd2a917275d70e58b15",
                                    "isVeg": 1,
                                    "price": 25500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272868",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "ICED TALL",
                                              "default": 1,
                                              "id": "177561480",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 4000,
                                              "id": "177561483",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 8000,
                                              "id": "177561487",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209496988",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496992",
                                        "groupName": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "choices": [
                                          {
                                            "id": "135039609",
                                            "name": "Regular milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039619",
                                            "name": "Skimmed Milk",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039615",
                                            "name": "Soy",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782944",
                                            "name": "Oats",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "118782954",
                                            "name": "Almond",
                                            "price": 8500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209496996",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "52000039"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460248",
                                    "name": "Iced Caffè Latte",
                                    "category": "Cold Beverages",
                                    "description": "Espresso from the World’s Top 3% Arabica balanced with milk and ice. An all-day favourite.\nTall (354ml) - 122 kcal / Grande (473ml) - 158 kcal / Venti (591ml) - 176 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "32632f33976aede26beb407156b51057",
                                    "isVeg": 1,
                                    "price": 27000,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272886",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "ICED TALL",
                                              "default": 1,
                                              "id": "177561537",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 4000,
                                              "id": "177561539",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 8000,
                                              "id": "177561541",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272887",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561542",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561544",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177561547",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177561550",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177561551",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497016",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497019",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "40 ratings",
                                        "ratingCountV2": "40"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "52000040"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "89745182",
                                    "name": "Iced Caramel Macchiato",
                                    "category": "Cold Beverages",
                                    "description": "Espresso poured over steamed milk infused with vanilla syrup. Finished with a beautiful cross hash caramel drizzle on the top for a decadent treat.\nTall (354ml) - 210 kcal / Grande (473ml) - 287 kcal / Venti (591ml) - 325 kcal.\nAllergen - Contains Milk.",
                                    "imageId": "8c022e30f7482347c6a7248c366d2059",
                                    "isVeg": 1,
                                    "price": 36500,
                                    "variants": {
                                      "variantGroups": [
                                        {
                                          "groupId": "57272974",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "ICED TALL",
                                              "default": 1,
                                              "id": "177561816",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED GRANDE",
                                              "price": 4000,
                                              "id": "177561820",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "ICED VENTI",
                                              "price": 8000,
                                              "id": "177561822",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "57272975",
                                          "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                          "variations": [
                                            {
                                              "name": "Regular milk",
                                              "default": 1,
                                              "id": "177561824",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Skimmed Milk",
                                              "id": "177561825",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Soy",
                                              "price": 6500,
                                              "id": "177561826",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Oats",
                                              "price": 8500,
                                              "id": "177561827",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond",
                                              "price": 8500,
                                              "id": "177561828",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "209497131",
                                        "groupName": "Choice Of Espresso",
                                        "choices": [
                                          {
                                            "id": "135039608",
                                            "name": "Espresso Shot Regular",
                                            "price": 6500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "63340797",
                                            "name": "Blonde Espresso",
                                            "price": 1,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "209497134",
                                        "groupName": "Syrup and Sauces",
                                        "choices": [
                                          {
                                            "id": "135039587",
                                            "name": "Vanilla Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039613",
                                            "name": "Hazelnut Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039596",
                                            "name": "Caramel Syrup",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039589",
                                            "name": "Caramel Drizzle",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039597",
                                            "name": "Classic Syrup",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039614",
                                            "name": "Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135039618",
                                            "name": "White Mocha Sauce",
                                            "price": 5500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 7,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845289"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60041181"
                          }
                        ],
                        "image": "a96e63604672f1495f6b6239f5359885",
                        "categoryId": "60041175"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Food",
                        "categories": [
                          {
                            "title": "Puffs",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804130",
                                    "name": "Bhuna Chicken Puff",
                                    "category": "Food",
                                    "description": "Delight in a spiced bhuna chicken filling encased in puff pastry topped with black sesame seeds.\nPer serve (85 g) - 390 kcal.\nAllergens: Contains Milk, Wheat, Soy, Rye, Oat, Egg.",
                                    "imageId": "3c99abd0beafe902d89913741a963124",
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "53018751"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "100711485",
                                    "name": "Masala Potato Puff",
                                    "category": "Food",
                                    "description": "Flaky puff pastry filled with savory masala potato filling, perfect for pairing with your evening coffee. \nPer serve (90g) - 372 kcal.\nAllergens: Nut, Milk, Wheat.",
                                    "imageId": "ce7cf19b419a57940601b8c22616b675",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.7",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "56844762"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "51360553"
                          },
                          {
                            "title": "Croissants",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "188871571",
                                    "name": "Pinwheel Croissant",
                                    "category": "Food",
                                    "description": "A croissant pastry baked into the shape of a pinwheel with vanilla custard filling inside. Decorated with a milk chocolate glaze on the outside. It is a decadent delight for your palette. Per serve (110g) - 512 kcal. Allergens : Contains Milk & Wheat",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/9/31f0ee2b-9c4b-4215-a41f-373d0d4ca35a_7afd9c58-b5eb-41da-abbd-70549c0a4644.jpg",
                                    "isVeg": 1,
                                    "price": 29500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114914035"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169142416",
                                    "name": "Veg Butter Croissant with Butter",
                                    "category": "Food",
                                    "description": "Dive deep into the delightful golden brown flaky & buttery pastry that leaves one mesmerized, served alongside butter to complete the experience.\nPer serve (80 g) - 304 kcal.\nAllergens: Contains Wheat, Barley, Soy, Milk.",
                                    "imageId": "f6fe5c49d4e670df5632783f5830f5d1",
                                    "isVeg": 1,
                                    "price": 26000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "102024607"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169142418",
                                    "name": "Veg Butter Croissant with Add on Preserve",
                                    "category": "Food",
                                    "description": "Dive deep into the delightful golden brown flaky & buttery pastry that leaves one mesmerized, served alongside butter to complete the experience. Served with a berry preserve for indulgence.\nPer serve (110 g) - 379 kcal.\nAllergens: Contains Wheat, Barley, Soy, Milk.",
                                    "imageId": "f6fe5c49d4e670df5632783f5830f5d1",
                                    "isVeg": 1,
                                    "price": 30000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "102024606"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460120",
                                    "name": "Butter Croissant Add on Preserve",
                                    "category": "Food",
                                    "description": "Dive deep into the delightful golden brown flaky & buttery pastry that leaves one mesmerized, served alongside butter to complete the experience. Add on berry preserve for indulgence\n69g/383kcal\nAllergen: Contains Milk, Wheat, Gluten",
                                    "imageId": "4ef38e705856d07085534c6273c41c3c",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "40868384"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460116",
                                    "name": "Egg White & Chicken in Multigrain Croissant",
                                    "category": "Food",
                                    "description": "Fluffy egg white omelette and chicken ham sandwiched in multigrain croissant.\nPer serve (200 g) - 541 kcal.\nAllergens: Contains Wheat, Oats, Milk, Egg, Soy.",
                                    "imageId": "b717f5cafb9785cd212a6ff489cb4ef3",
                                    "price": 36000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844775"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "48246441"
                          },
                          {
                            "title": "Wraps",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804140",
                                    "name": "Chatpata Paratha Wrap.",
                                    "category": "Food",
                                    "description": "Tangy paneer and vegetable filling wrapped in spinach paratha.\nPer serve (180 g) - 465 kcal.\nAllergens: Contains Wheat, Milk, Soy, Nut.",
                                    "imageId": "7fcbc469281a22c5555455abc913e774",
                                    "isVeg": 1,
                                    "price": 31500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.8",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844431"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "48246442"
                          },
                          {
                            "title": "Sandwiches",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "140619892",
                                    "name": "Basil Tomato & Mozzarella Cheese Sandwich",
                                    "category": "Food",
                                    "description": "A must-try. Tomato and mozzarella slices on a layer of basil sauce sandwiched in a multigrain bread.\nPer serve (170 g) - 484 kcal.\nAllergens: Contains Milk, Nut, Wheat, Soy, Oat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/31/ce70dc73-bd38-4f42-9444-c8caa9e93510_8ca4f54b-1f39-44d9-856d-c73dfa951a53.jpg",
                                    "isVeg": 1,
                                    "price": 37000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14844097"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "173059400",
                                    "name": "Grilled Spinach Corn Sandwich",
                                    "category": "Food",
                                    "description": "\"A savory blend of spinach and corn, garlic & herb aioli, melted mozzarella cheese, all tucked between slices of grilled bread.\nPer serve (210 g) - 748 kcal.\nAllergens: Wheat, Milk.\"",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/8/9fd26f71-77d7-4b0b-a26c-23060ec79a8b_2bd52aea-ca9e-4eee-9106-01f168a23fe3.jpg",
                                    "isVeg": 1,
                                    "price": 27500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "95765290"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "173059401",
                                    "name": "Grilled Chicken Salad Sandwich",
                                    "category": "Food",
                                    "description": "A creamy mixture of chicken mixed with julienned coloed bell peppers & green leafy lettuce tucked between two breads.\nPer serve (195 g) - 692 kcal.\nAllergens: Wheat, Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/8/d4144cc9-05a0-4be5-8331-7cb83ad12b7f_0ff73fdd-296e-4abb-9411-ca950108e805.jpg",
                                    "price": 29500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14845023"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169574550",
                                    "name": "Chicken Tikka Sandwich ",
                                    "category": "Food",
                                    "description": "Tandoori marinated and roasted chicken in a spiced and creamy tomato-based gravy on a bed of chopped spinach, sandwiched in a brown bread.\nPer serve (185 g) - 618 kcal.\nAllergens: Contains Wheat, Milk, Nuts, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/a6286aa5-df53-448d-b76a-8a8ff5fa121b_153cff13-4885-4c22-b06f-1cbbfca46ea6.jpg",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "102252171"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172299967",
                                    "name": "Harissa Chicken sourdough sandwich",
                                    "category": "Food",
                                    "description": "Bold flavors of harissa grilled chicken, paired perfectly with the crunch of grilled sourdough.\nPer serve (160 g) - 555 kcal.\nAllergens: Contains Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/a0f0db12-6fb4-4e78-9323-e8c57e9c0e97_fe1ef536-8b25-40e9-b3c3-cccad935eea6.jpg",
                                    "price": 42000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103886737"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172299968",
                                    "name": "Tandoori Paneer sourdough sandwich",
                                    "category": "Food",
                                    "description": "A fusion of tandoori paneer in a deliciously grilled sourdough sandwich.\nPer serve (180 g) - 446 kcal.\nAllergens: Contains Milk, Nut, Soy, wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/5c33cb4f-215e-4719-85c1-32ff7dd59ecc_5bbe8488-ef36-4d0f-b3d0-c9e5cb34d988.jpg",
                                    "isVeg": 1,
                                    "price": 40000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "103886738"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "176544655",
                                    "name": "Tofu Spinach Croissant Sandwich",
                                    "category": "Food",
                                    "description": "Scrambled tofu & spinach with Cheddar cheese & feta spread encased in a buttery & herbed croissant for a savory delight.\nPer serve (105 g) - 595 kcal.\nAllergens: Contains Milk,Wheat,Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/11/187db8ae-c648-4533-ba67-2e5315f271a5_485a1060-6cd2-451c-b6e6-06d474e439e4.jpg",
                                    "isVeg": 1,
                                    "price": 34000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "106564327"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187331532",
                                    "name": "Brocolli & Mushroom Pesto Focaccia",
                                    "category": "Food",
                                    "description": "Scrumptious broccoli and mushroom tossed in a lush basil pesto sauce, layered with bocconcini cheese, lettuce, and a tangy tomato spread - all sandwiched in a sesame and chilli flake focaccia. Per serve (200g) - 578 kcal. Allergens : Contains Wheat, Nuts, Milk",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/78495d5d-9ad1-4117-b9b5-9c31a5fd4bf3_7e453d32-fd4d-40e6-af95-ab209a2f00f3.jpg",
                                    "isVeg": 1,
                                    "price": 38500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113916718"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187331534",
                                    "name": "Basil Pesto Chicken Focaccia ",
                                    "category": "Food",
                                    "description": "Tender shredded chicken tossed in a lush basil pesto sauce, paired with garlic and herb aioli and a tangy tomato spread - all sandwiched in a sesame and chilli flake focaccia. Per serve (210g) - 599 kcal. Allergens : Contains Wheat, Nuts, Milk, Soy",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/22/38044cef-0ad3-4617-9d01-773d9b236a1e_88e3c252-b9eb-4615-9352-4c39e7d54371.jpg",
                                    "price": 39000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113916716"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "48246443"
                          },
                          {
                            "title": "Savoury Snacks",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105985615",
                                    "name": "Three dip Chips",
                                    "category": "Food",
                                    "description": "Crispy tortilla chips loaded with peri peri cheese dip, spicy tomato salsa, and cream cheese - a delicious sharing platter! \nPer serve (180 g) - 497kcal.\nAllergens: Contains Milk, Wheat, Soy.",
                                    "imageId": "439dff959b92c08625af92c8e3a10c70",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "58809792"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804148",
                                    "name": "Chilli Cheese Toast",
                                    "category": "Food",
                                    "description": "A cheesy French-style toasted baguette topped with red, yellow, green peppers, and chopped green chilli. 2 pieces in a portion.\nPer serve (140 g) - 479 kcal.\nAllergens: Contains Wheat, Milk, Soy, Rye, Oat.",
                                    "imageId": "458dd3d9e8d3f5c5a039add46980700c",
                                    "isVeg": 1,
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844494"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "172299969",
                                    "name": "Margharita Flatbread",
                                    "category": "Food",
                                    "description": "A classic flatbread featuring a tomato sauce base, topped with juicy cherry tomatoes, creamy bocconcini, and melted cheddar cheese for a timeless delight.\nPer serve (100 g) - 320 kcal.\nAllergens: Contains Milk, Wheat.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/7/5d5350d3-5d7a-4237-8cb6-6351e3fbc576_c49bf18a-e2ca-4bd1-87bb-2d249316d4ec.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "95660002"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "159805688",
                                    "name": "Chicken Tikka Flatbread",
                                    "category": "Food",
                                    "description": "A delectable flatbread with a creamy makhani sauce base, topped with roasted Indian-spiced chicken, vibrant bell peppers, onions, and melted mozzarella cheese for a flavorful bite.\nPer serve (120 g) - 388 kcal.\nAllergens: Contains Milk, Wheat, Nut, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/7/ee43daa0-c093-4ba4-b965-e34225a6f483_a5715741-132d-4ed2-b69d-19f4f7f8d466.jpg",
                                    "price": 24000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "Low%20cal/Low%20cal%201_1.png"
                                      }
                                    ],
                                    "parentId": "95659993"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "173059402",
                                    "name": "Cheese Peri Peri Pop Fries",
                                    "category": "Food",
                                    "description": "Pop potato fries with a spicy peri peri seasoning and cheesy topping.\nPer serve (163 g) - 380 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/22/374e50e4-1c52-4694-8727-8fbbc7fc6142_635a010d-56c5-49d8-964d-3f7891ccb35b.jpg",
                                    "isVeg": 1,
                                    "price": 19500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "104416595"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "173059403",
                                    "name": "Masala Crispers",
                                    "category": "Food",
                                    "description": "Crunchy potato wedges with a masala seasoning.\nPer serve (163 g) - 312 kcal.\nAllergens: Contains Milk.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/22/63f2df0c-17b9-42e3-8c77-492cb41258e9_02266e2d-724a-4daf-a7f6-434daf1bd430.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "91605597"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "48246444"
                          },
                          {
                            "title": "Cookies, Cakes & Desserts",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "184794320",
                                    "name": "Cold Brew Tiramisu",
                                    "category": "Food",
                                    "description": "Our cold brew tiramisu has soft almond sponge delicately layered with creamy mascarpone cheese, soaked in slow-steeped cold brew.  It's a luxurious treat crafted with precision to elevate your dessert experience.\nPer serve (120 g) - 467 kcal.\nAllergens: Contains Soy, Milk, Egg, Wheat, Nut.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/c450cd54-0269-421f-9a05-cbd1f0a19a62_73ced5cb-3a11-45eb-9205-142525707e1b.jpg",
                                    "price": 40000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "80916762"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804120",
                                    "name": "Chocolate Truffle Pastry",
                                    "category": "Food",
                                    "description": "An absolute classic! A moist chocolate cake layered with whipped ganache and dark chocolate.\nPer serve (100 g) - 575 kcal.\nAllergens: Contains Milk, Soy, Wheat, Nut.",
                                    "imageId": "96295a690aaa9f1e62e64d8681768c57",
                                    "isVeg": 1,
                                    "price": 38500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "53018758"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "95804126",
                                    "name": "Lemon Loaf Cake",
                                    "category": "Food",
                                    "description": "Flavourful English tea cake, infused with the warmth of butter and citrusy lemon, perfect for a comforting treat. \nPer serve (120 g) - 477 kcal.\nAllergens: Contains Wheat, Egg, Milk.",
                                    "imageId": "87bef170ad96e1af480b03926dd86dc6",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845621"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972389",
                                    "name": "Double Chocolate Chip Cookie",
                                    "category": "Food",
                                    "description": "A soft & chewy chocolate cookie topped with chocolate chips for the perfect textured bite.\nPer serve (80 g) - 385 kcal.\nAllergens: Contains Wheat, Milk, Soy.",
                                    "imageId": "ab4e963453672424b10c51b5a16133b1",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "13 ratings",
                                        "ratingCountV2": "13"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844719"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972699",
                                    "name": "Fudgy brownie pie",
                                    "category": "Food",
                                    "description": "A decadent Fudgy Brownie Pie nestled on a buttery crust for the ultimate dessert experience.\nPer serve (145 g) - 685 kcal.\nAllergens: Egg, Wheat, Nut, Milk, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/8/45aec047-b552-4515-af31-e67850dba78f_a64986a6-9f1f-4d97-8170-c2acb1af1f3c.jpg",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14844898"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "106106572",
                                    "name": "Christmas Tree Pastry",
                                    "category": "Food",
                                    "description": "A Christmassy delight! This delicious and decadent pastry is reminiscent of a Christmas tree. It is made using chocolate ganache, truffle sauce & dark chocolate compound and sprinkled with edible Christmas tree ornaments. Per serve (110g) - 648 kcal. Allergens : Contains Milk & Soy",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/1f418377-dc45-4e9b-b65b-d7b4674a5ccd_ace7ccf4-dbe5-4793-b3d9-3dd2a3ed2bbe.jpg",
                                    "isVeg": 1,
                                    "price": 28000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.4",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "60632561"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972259",
                                    "name": "Carrot Cake",
                                    "category": "Food",
                                    "description": "Indulge in the delightful decadence of carrot cake, infused with the warm spices of cinnamon and nutmeg, perfectly complemented by a vanilla sauce that transports you to a cozy winter wonderland. Per serve (130g) - 529 kcal. Allergens : Contains Egg, Wheat, Nuts, Milk, Soy",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/20/84cd7634-e3c2-4c9c-b053-426f58273eaa_28a0847d-540f-4d87-bf01-b73f114ed24a.jpg",
                                    "price": 28000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844405"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972480",
                                    "name": "Blueberry Muffin",
                                    "category": "Food",
                                    "description": "Buttery vanilla cake, with tangy blueberries, and a dusting of granulated sugar for the perfect crunch. \nPer serve (120 g) - 388 kcal.\nAllergens: Contains Wheat, Milk, Egg.",
                                    "imageId": "c6a2308b012dab5ffd4852a02f012483",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "14844133"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972676",
                                    "name": "Almond Butterscotch Cookie",
                                    "category": "Food",
                                    "description": "A buttery cookie with a combination of crunchy almond and butterscotch.\nPer serve (85 g) - 370 kcal.\nAllergens: Contains Wheat, Milk, Nut.",
                                    "imageId": "ef6123fd15a2af2424e1394babbac8b5",
                                    "isVeg": 1,
                                    "price": 27500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844019"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972598",
                                    "name": "New York Cheesecake",
                                    "category": "Food",
                                    "description": "Indulge in the iconic New York Cheesecake, with a creamy texture and a crunchy biscuit crust, paired perfectly with a berry preserve - a timeless coffee house delight.\nPer serve (125 g) - 552 kcal.\nAllergens: Contains Wheat, Milk, Egg.",
                                    "imageId": "63c8d5eca8afb261a0cab6146d98edf5",
                                    "price": 39500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845748"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972431",
                                    "name": "Banana Chocolate Loaf Cake",
                                    "category": "Food",
                                    "description": "English tea cake with rich taste of banana and chocolate.\nPer serve (125 g) - 385 kcal.\nAllergens: Contains Wheat, Soy, Egg, milk.",
                                    "imageId": "fab5ba89ee338aef3a61df9baf96a13b",
                                    "price": 31000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14844085"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179377552",
                                    "name": "Choco Kunafa Pastry",
                                    "category": "Food",
                                    "description": "A brownie base layered with kunafa-pistachio mix and smooth chocolate mousse, finished with a glossy cocoa glaze and a sprinkle of sliced pistachios.\nPer serve (100 g) - 552 kcal.\nAllergens: Contains Milk, Wheat, Soy.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/8/415597c8-d2f6-4117-9900-117136c39911_afa10dd8-9952-48ec-802a-12a8d00d972a.jpg",
                                    "isVeg": 1,
                                    "price": 35000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108542753"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115131332",
                                    "name": "Strawberry and Almond Cake",
                                    "category": "Food",
                                    "description": "Pound cake flavoured with strawberry, crunchy almonds and a layer of cream cheese.\nPer serve (100 g) - 315 kcal.\nAllergens: Contains Wheat, Milk, Nut.",
                                    "imageId": "678ec0c4377e1f749ac9a3e916b1b902",
                                    "isVeg": 1,
                                    "price": 38500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14846030"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "48246446"
                          }
                        ],
                        "image": "3c99abd0beafe902d89913741a963124",
                        "categoryId": "48246434"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Ready to Drink & Eat",
                        "categories": [
                          {
                            "title": "Bottled Frappuccino & Bottled Juice",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "111320692",
                                    "name": "Bottled Caramel Frappuccino",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Bottled Caramel Frappuccino.\nPer serve 250 ml - 161 kcal.\nNet volume 250 ml.\nAllergens: Contains Milk.",
                                    "imageId": "e9806e7571929a4056fe8d6013925033",
                                    "isVeg": 1,
                                    "price": 35238,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "63165810"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972475",
                                    "name": "Bottled Mocha Frappuccino",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Bottled Mocha Frappuccino.\nPer serve 250 ml - 168 kcal.\nNet volume 250 ml.\nAllergens: Contains Milk.",
                                    "imageId": "b05e5543a0a996215330cf3c5a03442a",
                                    "isVeg": 1,
                                    "price": 35238,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.6",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "63165812"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "111320694",
                                    "name": "Bottled Coffee Frappuccino",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Bottled Coffee Frappuccino.\nPer serve 250 ml - 165 kcal.\nNet volume 250 ml.\nAllergens: Contains Milk.",
                                    "imageId": "f78f91e8d6fb29dd433a9d85ac918943",
                                    "isVeg": 1,
                                    "price": 35238,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "63165811"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "33385797"
                          },
                          {
                            "title": "Packaged Food",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177794372",
                                    "name": "Almond Biscotti - 50g",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Almond Biscotti\nPer Serve (25 g) - 102 Kcal.\nNet Weight 50 g\nAllergens: Contains Nuts, Wheat, Egg and Milk.",
                                    "imageId": "cf5a4ac8048682e0d5f98aab89d91314",
                                    "price": 16190,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107543641"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177794373",
                                    "name": "Roasted & Salted Almond 50 gms",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Roasted & Salted Almond\nPer Serve (25 g) - 158 Kcal.\nNet Weight 50 g\nAllergens: Contains Nuts.",
                                    "imageId": "b2de7a38be1bfd89c36255cebf085961",
                                    "isVeg": 1,
                                    "price": 17619,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107543642"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "177794374",
                                    "name": "Roasted & Salted Cashew 50 gms",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Roasted & Salted Cashew\nPer Serve (25 g) - 152 Kcal.\nNet Weight 50 g\nAllergens: Contains Nuts.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/25/345b1cd6-0634-4274-a2c0-101b01477bc7_081e47b2-5ebf-4995-bb57-6e18fd64da08.jpg",
                                    "isVeg": 1,
                                    "price": 17619,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "107543643"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186213913",
                                    "name": "COFFEE CHOCO ALMOND BARKS",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Experience the perfect blend of Bombay Sweet Shop’s iconic Choco barks with Starbucks’ signature espresso and roasted almonds in this irresistible Diwali special. \nPer serve (80 g)\nAllergens: Contains Milk, Soy, Nut.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/6/ad243d54-ee82-45ab-89b5-647e8867080c_c88b75ec-a2fd-4695-a4bb-5c139e296462.jpg",
                                    "isVeg": 1,
                                    "price": 35714,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113206768"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186213914",
                                    "name": "Starbucks Signature Chocolates Box of 12",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Celebrate the festival of lights with this indulgent box of 12 assorted chocolate box. Featuring the delightful flavors of Coconut (75kcal/13g), Dark Chocolate (75kcal/13g), Rose Pistachio (75kcal/13g), and Hazelnut (77kcal/13g), this luxurious collection is ideal for Diwali gifting or enjoying as a special treat. (Net Weight: 156g).\nAllergens: Contains Wheat, Milk, Soy, Barley, Nuts.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/6/7aecf066-15f6-4712-adda-bf9718778e6f_403bcdec-106a-4a51-9dc9-1955410e9d6a.jpg",
                                    "isVeg": 1,
                                    "price": 81905,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113206769"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "33385798"
                          },
                          {
                            "title": "Other Bottled Bevarages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "64972541",
                                    "name": "Himalayan Still Water",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Himalayan Still Water\nPer serve: 0 ml - 0 kcal.\nNet Volume 300 ml.\nAllergens: Nil.",
                                    "imageId": "f090a130f49f6d29012d68cd9a01cbf8",
                                    "isVeg": 1,
                                    "price": 11429,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "14845113"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "99460280",
                                    "name": "Himalayan sparkling Water",
                                    "category": "Ready to Drink & Eat",
                                    "description": "Himalayan Still Water\nPer serve: 300 ml - 0 kcal.\nNet Volume 300 ml.\nAllergens: Nil.",
                                    "imageId": "8a8001e62cebae752b73631110cbe191",
                                    "isVeg": 1,
                                    "price": 12857,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "47205901"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "33385799"
                          }
                        ],
                        "image": "e9806e7571929a4056fe8d6013925033",
                        "categoryId": "26170165"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11421010000035"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Starbucks Coffee",
                        "area": "Maharana Pratap Nagar",
                        "completeAddress": "Plot No.G-35, Narmadapuram Road, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "5e18b66b-e460-4bcf-896f-b35cdf64377f",
    "sid": "oyq48f1a-83aa-4656-9b83-267c656a3e5b",
    "deviceId": "663cd9c7-0449-024f-940c-b517fba567ac",
    "csrfToken": "YgW60e6y3uU0-1Z5O3WD2cRj0XKut1om6CmAX0FA"
  },

  "638996": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Baskin Robbins - Ice Cream Desserts",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "638996",
                "name": "Baskin Robbins - Ice Cream Desserts",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "baskin-robbins-raisen-road-piplani",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/12/24/2c893d26-6bb4-406a-87c8-2fefb66e8d37_638996.jpg",
                "locality": "Sector B",
                "areaName": "Indrapuri",
                "costForTwo": "25000",
                "costForTwoMessage": "₹250 for two",
                "cuisines": ["Desserts", "Ice Cream"],
                "avgRating": 4.3,
                "veg": true,
                "feeDetails": {
                  "restaurantId": "638996",
                  "fees": [{}]
                },
                "parentId": "5588",
                "avgRatingString": "4.3",
                "totalRatingsString": "158 ratings",
                "sla": {
                  "restaurantId": "638996",
                  "deliveryTime": 49,
                  "minDeliveryTime": 45,
                  "maxDeliveryTime": 50,
                  "lastMileTravel": 7.2,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 1006,
                  "slaString": "45-50 MINS",
                  "lastMileTravelString": "7.2 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextOpenTimeMessage": "Opens next at 11:30 am, today",
                  "nextOpenTime": "2026-01-06 11:30:00",
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "20% off",
                  "shortDescriptionList": [
                    {
                      "meta": "20% off | Use SPECIALS",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "20% off up to ₹50 on select items | Use code SPECIALS",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "baskin-robbins-raisen-road-piplani",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Baskin Robbins, B11 Ground Floor, Raisen Road Indrapuri, Bhopal - 462021"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Desserts,Ice Cream"
                  }
                ],
                "logo": "Brand logo/BaskinRob",
                "totalRatings": 158,
                "aggregatedDiscountInfoV2": {
                  "header": "20% off",
                  "shortDescriptionList": [
                    {
                      "meta": "20% off | Use SPECIALS",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "20% off up to ₹50 on select items | Use code SPECIALS",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "minValue": 125,
                    "maxValue": 179,
                    "priority": 1,
                    "couponCode": "SPECIALS",
                    "discountInfo": {
                      "discountType": "Percentage",
                      "value": 20
                    },
                    "lockedMessage": "Add items worth ₹\u003Camount\u003E to save upto ₹50 | Code SPECIALS",
                    "unlockedMessage": "SPECIALS Coupon Unlocked! Use it to save upto ₹50",
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  },
                  {
                    "minValue": 2799,
                    "maxValue": 3999,
                    "priority": 2,
                    "couponCode": "FLAT400",
                    "discountInfo": {
                      "discountType": "Flat",
                      "value": 400
                    },
                    "lockedMessage": "Add items worth ₹\u003Camount\u003E to save ₹400 | Code FLAT400",
                    "unlockedMessage": "FLAT400 Coupon Unlocked! Use it to save ₹400",
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/638996"
                },
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 11:30 am, today",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:30 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.2510303,77.4610583",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 4,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "20% OFF UPTO ₹50",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["3d484c76-c048-4f21-a980-c2d144e0a034"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SPECIALS",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "638996",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SPECIALS"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹400 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["7b82e923-efd6-489d-93c5-b3ddb7e6bdc9"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT400",
                        "description": "ABOVE ₹3999",
                        "offerType": "offers",
                        "restId": "638996",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT400"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "638996",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹500 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["71d05db3-00f7-4fe5-9179-49b359070b9e"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT500",
                        "description": "ABOVE ₹4999",
                        "offerType": "offers",
                        "restId": "638996",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT500"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "isPureVeg": true,
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "20% OFF"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Treats Beyond Ice Cream",
                        "categories": [
                          {
                            "title": "Cheesecake",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936534",
                                    "name": "Classic Cheesecake",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Dense, velvety and smooth baked cheesecake with a crumbly biscuit base. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/bf536777-3ed8-43a4-ae68-e29bc8e333b0_324e89d6-b4e2-49ea-b66d-362cee4bb569.jpg",
                                    "isVeg": 1,
                                    "price": 19000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349672"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187866424",
                                    "name": "Classic Cheesecake With Mango Sauce",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Dense, velvety and smooth baked cheesecake with a crumbly biscuit base glazed with mango topping. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/fe3a79f1-53f6-481a-9eb4-e598388f5e52_c3620562-7731-4812-87a5-6eac687c7463.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349673"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187866426",
                                    "name": "Tiramisu Cheesecake",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Dense, velvety and smooth baked cheesecake infused with coffee on a crumbly biscuit base, dusted with rich cocoa. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/76795717-1595-4026-88b0-845e36c6c446_3cbbaf47-d045-41af-8aa0-9b0dcb42b95f.jpg",
                                    "isVeg": 1,
                                    "price": 23000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349677"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69238482"
                          },
                          {
                            "title": "Muffins",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187866433",
                                    "name": "Blueberry Crumble Muffin",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Fluffy and moist vanilla muffin baked to golden perfection with centre-filling of sweet blueberry compote. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/fd933ab8-c622-43d3-b010-151c2ab67661_81985621-96cd-42fb-b9db-41d772c3e018.jpg",
                                    "isVeg": 1,
                                    "price": 20500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349665"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187866434",
                                    "name": "Double Chocolate Muffin",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Fluffy and moist chocolate muffin, topped dark chocolate chunks. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/d434dc60-036f-4bec-9291-f4104595e3f5_5821bd8a-ed1e-4286-a901-669761bfb089.jpg",
                                    "isVeg": 1,
                                    "price": 23500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349674"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69238484"
                          },
                          {
                            "title": "Brownies",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932179",
                                    "name": "Choco Fudge Brownie",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Gooey and oh-so-fudgy warm eggless chocolate brownie baked with the finest cocoa. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/2ab113cb-f0c8-4035-8ff7-07bd699c0bb7_d0ef2ef1-890d-4cdb-a7e0-3694f7fa7bd3.jpg",
                                    "isVeg": 1,
                                    "price": 11000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "114349669"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "187866435",
                                    "name": "Choco Walnut Brownie",
                                    "category": "Treats Beyond Ice Cream",
                                    "description": "Gooey and oh-so-fudgy warm chocolate brownie baked with the finest cocoa and topped with walnut pieces. (serves 1)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/276df695-c448-49f5-9182-2a1f594409bb_ed0aa3e1-3d44-431d-af26-73c9efcb89b1.jpg",
                                    "isVeg": 1,
                                    "price": 13500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "114349671"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69238487"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/bf536777-3ed8-43a4-ae68-e29bc8e333b0_324e89d6-b4e2-49ea-b66d-362cee4bb569.jpg",
                        "categoryId": "69238481"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Warm Sundaes",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988459",
                                "name": "Almond Delight Sundae.",
                                "category": "Warm Sundaes",
                                "description": "Warm brownie with nutty roasted californian almond ice cream topped with hot fudge or butterscotch fudge",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/805d947b-9f60-407c-b85f-78dbce0e9877_02d4e72a-a9a5-42c9-8419-c31a9566fabe.jpg",
                                "isVeg": 1,
                                "price": 20500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "65784864"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988460",
                                "name": "Nutty Professor.",
                                "category": "Warm Sundaes",
                                "description": "We made sure this treat is as nutty as its name. Crunchy californian almond ice cream paired generously with nuts, almonds, cashews, and raisins drowning in a delicious hot fudge sauce and topped off with whipped cream. Going nutty has never been this fun before. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/a3de08ff-5def-4f05-97ef-ec09f126ed48_8575933f-fabd-435f-9338-250dfa0c6df9.jpg",
                                "isVeg": 1,
                                "price": 25500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28855905"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988461",
                                "name": "Thunder Hot Fudge.",
                                "category": "Warm Sundaes",
                                "description": "Creamy vanilla and decadent three cheers chocolate ice creams come together to create this extraordinary treat. Made even more special with a delicious hot fudge sauce and a dollop of whipped cream. Do we hear your taste buds thanking us already",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/8f93235c-b4b6-49bb-86c0-c2582fb7e670_d3866904-2328-4660-91fb-7ac992da6485.jpg",
                                "isVeg": 1,
                                "price": 21500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28857051"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988464",
                                "name": "Nutella Slab Sundae.",
                                "category": "Warm Sundaes",
                                "description": "Gooey brownie topped with a slab of classic vanilla ice cream drizzled with velvety nutella and sprinkled with crunchy hazelnut pralines. Nutella lovers' dream come true. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/45b8a892-9573-4d90-8343-0a4196963273_00231ecc-234b-4976-bd8d-f0cc5e1d6399.jpg",
                                "isVeg": 1,
                                "price": 21000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80725293"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988465",
                                "name": "Brownie A La Mode.",
                                "category": "Warm Sundaes",
                                "description": "When brownies are the answer, anyone seldom cares what the question is! meet our chocolicious combination of three cheers chocolate and chocolate ice cream on a delicious brownie cake, topped off with hot fudge sauce and whipped cream. Decadence, indeed!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/4fd0d896-3936-4a88-aeeb-66441f9d3d44_ba4b6f95-95ef-40fd-84c5-cd9f20f58c79.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28852470"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988467",
                                "name": "Bavarian Blast.",
                                "category": "Warm Sundaes",
                                "description": "A delicious warm brownie served with a scoop of indulgent bavarian chocolate ice cream topped with hot fudge",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/8d97f734-2e99-4abc-ab0e-ac21d965fd70_03ced841-e63d-4b1f-8669-6dbb16ad0301.jpg",
                                "isVeg": 1,
                                "price": 23500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28852033"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988468",
                                "name": "Belgian Dream.",
                                "category": "Warm Sundaes",
                                "description": "Warm brownie topped with delectable belgian bliss ice cream and hot fudge or butterscotch sauce. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e79c640f-6f3e-4df7-8cf2-e148acee47a9_d82b4313-ee36-4d42-9a23-69cf6b1bef82.jpg",
                                "isVeg": 1,
                                "price": 23500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28852220"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988469",
                                "name": "Vanilla Affair.",
                                "category": "Warm Sundaes",
                                "description": "A warm gooey brownie with the world's best vanilla ice cream, topped with hot fudge or butterscotch sauce",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/faf14686-e29a-4f7c-8f7c-eec74bd20114_6464814f-e580-4e4a-a513-8559c8b24b92.jpg",
                                "isVeg": 1,
                                "price": 19500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28857172"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190988472",
                                "name": "Classic Waffle.",
                                "category": "Warm Sundaes",
                                "description": "Nothing beats the sure-fire magic of the classics. Try this warm, toasty waffle with a creamy scoop of classic vanilla ice cream and drizzled with a sinful chocolate sauce. Always a great go-to option!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/59759bb8-6950-43b5-b85f-218228a52aa3_42e0d689-a370-4b92-bd09-71287bfede6e.jpg",
                                "isVeg": 1,
                                "price": 21500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "39320745"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/805d947b-9f60-407c-b85f-78dbce0e9877_02d4e72a-a9a5-42c9-8419-c31a9566fabe.jpg",
                        "categoryId": "70581337"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Newly Launched Italian Gelatos",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169405437",
                                "name": "Salted Caramel Crunch Gelato",
                                "category": "Newly Launched Italian Gelatos",
                                "description": "Silky salted caramel gelato loaded with golden, crunchy honeycomb pieces. Crafted the italian way",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/418e101c-8b50-4635-8528-cb85038684de_5285e12a-0a7c-4572-9844-b41275710424.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58607792",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181870241",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181870242",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181870243",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - Serves 4-5",
                                          "id": "181870244",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - Serves 4-5",
                                          "id": "183176822",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 Ltr - Serves 4-5",
                                          "id": "183176823",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "181870241"
                                        }
                                      ],
                                      "price": 12000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "181870242"
                                        }
                                      ],
                                      "price": 17200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "181870243"
                                        }
                                      ],
                                      "price": 24000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "181870244"
                                        }
                                      ],
                                      "price": 45500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "183176822"
                                        }
                                      ],
                                      "price": 63000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607792",
                                          "variationId": "183176823"
                                        }
                                      ],
                                      "price": 88500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238610",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238609",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "217238609",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "217238610",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "102192072"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "169405440",
                                "name": "Cotton Candy Burst Gelato",
                                "category": "Newly Launched Italian Gelatos",
                                "description": "Tri-coloured cotton candy gelato with popping candy. A burst of italian fun",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/03f97d4c-5d2c-4c34-9163-c6bcfcbd368d_e107221b-8603-4c07-9f4b-ad4af686ca2e.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58607795",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181870253",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181870254",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181870255",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - Serves 4-5",
                                          "id": "181870256",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - Serves 4-5",
                                          "id": "183176860",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 Ltr - Serves 4-5",
                                          "id": "183176861",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "181870253"
                                        }
                                      ],
                                      "price": 12000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "181870254"
                                        }
                                      ],
                                      "price": 17200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "181870255"
                                        }
                                      ],
                                      "price": 24000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "181870256"
                                        }
                                      ],
                                      "price": 45500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "183176860"
                                        }
                                      ],
                                      "price": 63000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58607795",
                                          "variationId": "183176861"
                                        }
                                      ],
                                      "price": 88500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "217238648",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "217238647",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "217238647",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "217238648",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "102192065"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/418e101c-8b50-4635-8528-cb85038684de_5285e12a-0a7c-4572-9844-b41275710424.jpg",
                        "categoryId": "61074515"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Chocolate Ice Creams",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932264",
                                "name": "Mississippi Mud Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Delectable chocolate fudge and ice cream, married by a fudge ribbon and sprinkled with brownie pieces. We've tripled up on chocolate with this mississippi mud flavour! chocolate overload anyone?",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/2bdad7a5-d358-4ff1-8f79-26f8ba8dd6d5_d709e8f8-aef1-4ea4-9810-ffd37825635d.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366513",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181205572",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181205558",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205562",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181205577",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181205583",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205561",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181205563",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205572"
                                        }
                                      ],
                                      "price": 53800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205558"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205561"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205562"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205563"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205567"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205577"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366513",
                                          "variationId": "181205583"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420154",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420150",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420150",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420154",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 53800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28855757"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932143",
                                "name": "Bavarian Chocolate Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Rich chocolate based ice cream adorned with chocolate pieces and cashew nut crispies. If it's bavarian chocolate flavour then it's gotta be sinful and intensely indulgent. Throw in a bit of crunch and you've got a truly divine chocolate ice cream treat. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/e6ae3c5c-efdc-4c4a-894b-9344897951ce_72cf32c4-7d85-4c97-835f-7fd2f7cde3a3.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366531",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181205651",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205654",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205658",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205661",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 4-5",
                                          "id": "181205670",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181205673",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181205666",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205651"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205654"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205658"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205661"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205666"
                                        }
                                      ],
                                      "price": 53800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205670"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366531",
                                          "variationId": "181205673"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420183",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420179",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420179",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420183",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28852074"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935127",
                                "name": "Belgian Bliss Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Rich chocolate ice cream with hidden treasures of dark chocolate cookies, hugged by a caramel ribbon. This delectable chocolate delight is like no other! sit back and enjoy this rich belgian bliss ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/263e5e74-4d4a-4c54-b7ef-92f8e62a9c18_1dee2c34-935c-458a-890a-6cefd1b1cd84.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366551",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "default": 1,
                                          "id": "181205750",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205743",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205746",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205754",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181205757",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181205760",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181205741",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205750"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205743"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205746"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205754"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205757"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205760"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366551",
                                          "variationId": "181205741"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420215",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420209",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420209",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420215",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28852180"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932260",
                                "name": "Mint Milk Chocolate Chips Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "An ice cream that tells the mint and chocolate love story like no other. This classic ice cream is a marriage of mint and milk chocolate pieces. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/026007ed-0dff-4fe9-aa8a-2f8f16bf6b61_1d7d6017-bac4-484f-b382-eaf506b91e69.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366567",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181205831",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205832",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205837",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181205840",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181205842",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205830",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181205834",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205831"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205832"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205834"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205837"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205840"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205842"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366567",
                                          "variationId": "181205830"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420250",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420245",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420245",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420250",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28855637"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935161",
                                "name": "Gold Medal Ribbon Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "A heavenly medley of vanilla and chocolate, embraced by a caramel ribbon. This vanilla and chocolate combo is our dream team! a thick, deep caramel ribbon intertwines the two flavours together in perfection. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/7c20319e-ebf6-45a2-a112-105af0e84a67_ed7d16d5-acb0-447e-855e-61992baf795a.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366582",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181205892",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205894",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205899",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181205903",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205908",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181205912",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181205916",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205892"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205894"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205899"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205903"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205908"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205912"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366582",
                                          "variationId": "181205916"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420281",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420275",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420275",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420281",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28854637"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935180",
                                "name": "Dutch Chocolate Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Tempting chocolate ice cream with a distinct hint of cocoa. The mother of every chocolate ice cream creation of ours. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/cab69a09-7fde-40c5-aaae-78184a416355_85478294-d2ae-4551-adbf-c145731a038f.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366593",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181205962",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181205947",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181205949",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181205952",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181205970",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181205966",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181205956",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205962"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205947"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205949"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205952"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205956"
                                        }
                                      ],
                                      "price": 43200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205970"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366593",
                                          "variationId": "181205966"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420305",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420299",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420299",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420305",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28853942"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935197",
                                "name": "Three Cheers Chocolate Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "A heavenly combination of chocolate and vanilla married together with chocolate chips and ribbon. A feisty ribbon twirling its way through this chocolate chip loaded chocolate and vanilla ice cream scoop. This ice cream is as enticing as they come!(contains milk & soy)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/3b7ba148-dac3-4105-bc98-d29e356d855f_f1469773-cf7a-4cb0-aa3d-f2267fbefb8e.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366605",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Regular Scoop",
                                          "default": 1,
                                          "id": "181206008",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181206010",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181206013",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181206016",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181206020",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181206026",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181206007",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206008"
                                        }
                                      ],
                                      "price": 11200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206010"
                                        }
                                      ],
                                      "price": 15000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206013"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206016"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206020"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206026"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366605",
                                          "variationId": "181206007"
                                        }
                                      ],
                                      "price": 7500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420334",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420328",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420334",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11200,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28856997"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932177",
                                "name": "Chocolate Almond Praline Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Praline coated almonds peeping out of dark chocolate ice cream (contains milk & tree nuts (almond)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/cabd2e32-bc79-4bbe-8979-f889d80a32f1_213d5cd1-e44f-4cf5-83a3-78c294e512b0.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366622",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181206075",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181206078",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181206082",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181206086",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181206090",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181206097",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206075"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206078"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206082"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206086"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206090"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366622",
                                          "variationId": "181206097"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420366",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420358",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420358",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420366",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28852847"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932181",
                                "name": "Chocolate Mousse Royale Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Mischievous chocolate chips playing peekaboo with frozen chocolate mousse dessert. There's no such thing as too much chocolate is there? how about you triple up on this cool chocolate chip mousse ice cream with a chocolate waffle cone?",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/1b8bf91f-43dc-46cb-8dc4-e235d6ae6781_3381857f-a6af-48be-af4d-b1954e4d41e0.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366638",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181206146",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181206151",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181206156",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181206162",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181206170",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181206174",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206146"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206151"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206156"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206162"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206170"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366638",
                                          "variationId": "181206174"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420397",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420389",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420389",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420397",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28853056"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935277",
                                "name": "Hazelnut Rocher Ice Cream (Factory Sealed 450 Ml - Serves 4-5)",
                                "category": "Chocolate Ice Creams",
                                "description": "Love at first bite. Rich and creamy rocher ice cream tossed with crunchy caramelized hazelnut pieces. We know you can't wait to try. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/14/c1faefaf-d50e-4f17-90e8-daebbcc928c0_e57c0b82-d50c-4697-9698-827d4875f4e1.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "214420456",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420461",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "98999911"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "137677377",
                                "name": "Naughty Nutella Ice Cream",
                                "category": "Chocolate Ice Creams",
                                "description": "Heavenly nutella ice cream made with velvety nutella paste and premium chocolate. Get nutty!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/14/548d9760-537a-4938-882c-d7f59f5286a4_cf9dc00c-3e34-4d8a-a62e-b892756dd064.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366693",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181206383",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181206389",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181206393",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181206396",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181206400",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181206386",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206383"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206389"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206393"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206396"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206400"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366693",
                                          "variationId": "181206386"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420511",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420508",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420508",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420511",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "80788731"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/2bdad7a5-d358-4ff1-8f79-26f8ba8dd6d5_d709e8f8-aef1-4ea4-9810-ffd37825635d.jpg",
                        "categoryId": "60869024"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Ice Cream Cakes",
                        "categories": [
                          {
                            "title": "Celebration Cakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932282",
                                    "name": "Pineapple Ice Cream Cake (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "A 4 decker cake made with alternate layers of super moist vanilla sponge cake and succulent pineapple ice cream. Garnished with white chocolate and whipped cream swirls. Pineapple cakes never run out of fashion!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/15829c09-cdb3-40cd-b24f-6090029d7fca_3cbc6c0d-826c-48e2-99dd-84bc6928f736.jpg",
                                    "isVeg": 1,
                                    "price": 64286,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420556",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "96202253"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168935342",
                                    "name": "Black Forest Ice Cream Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "A classic yet everyone's favourite. Layers of black forest ice cream with chocolate sponge cake, topped with dark chocolate shavings and sweet cherries. Do invite it to your next party!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/a54f9a84-903d-44b7-b2f7-eb8e2bd143be_48a6f7a6-6b00-4629-bcf5-d0c0f1d723f3.jpg",
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58366724",
                                          "name": "Quantity",
                                          "variations": [
                                            {
                                              "name": "500 gms",
                                              "default": 1,
                                              "id": "181206526",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "1000 gms",
                                              "id": "181206528",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58366724",
                                              "variationId": "181206526"
                                            }
                                          ],
                                          "price": 64286,
                                          "addonCombinations": [
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725616"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725633"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725658"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725673"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725635"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725665"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725646"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725626"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58366724",
                                              "variationId": "181206528"
                                            }
                                          ],
                                          "price": 106191,
                                          "addonCombinations": [
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725616"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725633"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725658"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725673"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725635"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725665"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725646"
                                            },
                                            {
                                              "groupId": "214420571",
                                              "addonId": "135725626"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "214420571",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 64286,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852354"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168935358",
                                    "name": "Cotton Candy Ice Cream Cake (500 G)",
                                    "category": "Ice Cream Cakes",
                                    "description": "A delicious 4 decker cake made with 2 layers of rich vanilla sponge cake intertwined with all-time-favourite cotton candy ice cream. Garnished with dark chocolate cigars and chocolate coated crispies. A treat for your eyes and taste buds!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/42718d6c-9b4d-4e7b-8ef6-3760487c57e3_72dd14aa-a36b-4850-ac13-681e368a3601.jpg",
                                    "isVeg": 1,
                                    "price": 64286,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420600",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96202250"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932294",
                                    "name": "Red Velvet Fantasy Ice Cream Cake (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "A divine combo of soft red velvet cake intertwined with creamy cookies n cream ice cream topped with cookies and red velvet cake crumble. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/a945e0e0-9076-420a-af08-14ffe1d0d53e_33035434-84f3-4f82-8e54-a19233f3cbed.jpg",
                                    "isVeg": 1,
                                    "price": 67715,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420614",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96202254"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932160",
                                    "name": "Blueberry Ice Cream Cheesecake (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "Beautiful biscuit crumble base layered with delicious cheesecake ice cream. Add to it another layer of fluffy vanilla sponge cake and some more cheesecake ice cream. Adorned with exotic blueberries and whipped cream. Get transported to ny!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/de590f20-fdd3-4ebf-94de-cfe6b19261f6_b8f77b33-1c41-4313-931b-a612435756ee.jpg",
                                    "isVeg": 1,
                                    "price": 67715,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420633",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96202248"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168935383",
                                    "name": "Dutch Chocolate Ice Cream Cake-made With Kit Kat (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "Smooth, creamy dutch chocolate ice cream with kit-kat bits spread generously on top of a luscious chocolate sponge cake, and topped with crunchy kit-kat wafer biscuits and chocolate balls. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/82a601fd-0bf9-4125-ba16-b7f7b42dcbe7_9f29202d-2374-453a-b0e4-28ff3b0efe1e.jpg",
                                    "isVeg": 1,
                                    "price": 77620,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420653",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "74923229"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932257",
                                    "name": "Mango Ice Cream Cake (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "Delicious 4 layered?cake?made with 2 layers of vanilla sponge?cake?intermixed with 2 layers of fresh and juicy alphonso mango ice cream. Yummy white chocolate discs and whipped cream swirls on top will make your celebrations a lot sweeter!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/07181ffd-c463-49d5-b70d-7d1cb54dd91f_4370eaae-6377-4a42-af65-847498984665.jpg",
                                    "isVeg": 1,
                                    "price": 64289,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "214420678",
                                        "groupName": "Cake Toppers",
                                        "choices": [
                                          {
                                            "id": "135725665",
                                            "name": "Happy Birthday Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725646",
                                            "name": "Congratulations Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725626",
                                            "name": "Happy Anniversary Chocolate Topper",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725616",
                                            "name": "Birthday Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725633",
                                            "name": "Anniversary Cake Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725658",
                                            "name": "Congrats Topper (1 Pc)",
                                            "price": 3000,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725673",
                                            "name": "Number Candle Golden (1 Pc)",
                                            "price": 2500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135725635",
                                            "name": "Heart Shape Red (4 Pcs)",
                                            "price": 6500,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 8,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "96202252"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "155734436",
                                    "name": "Pistachio Caramel Cake (500g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "Caramel sponge cake layered with pistachio & caramel ice cream with caramel ribbon swirls, garnished with caramel sauce, whipped cream and pista bits!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/0f7ba790-06b0-4d4f-b34d-7571c7c58165_e728b2e6-043b-46cb-878a-64529eb08262.jpg",
                                    "isVeg": 1,
                                    "price": 67715,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "91183342"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869075"
                          },
                          {
                            "title": "Roll Cakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932185",
                                    "name": "Classic Fudge Roll Cake Slice",
                                    "category": "Ice Cream Cakes",
                                    "description": "This ice cream roll cake is a classic combination of vanilla ice cream wrapped in chocolate sponge & covered with chocolate fudge and almonds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/30a577dc-795b-42a6-b3a4-cac0b8d829cc_f8c9b2fd-e0ad-487a-87a6-4f8bdc0e290b.jpg",
                                    "isVeg": 1,
                                    "price": 13500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.9",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28853183"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932184",
                                    "name": "Classic Fudge Roll Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "This ice cream roll cake is a classic combination of vanilla ice cream wrapped in chocolate sponge & covered with chocolate fudge and almonds",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/779129d0-0bd3-4ad6-a226-afcbadc48e2b_683f41e7-3497-44cc-9719-9428eff0ec53.jpg",
                                    "isVeg": 1,
                                    "price": 84700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28853177"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932147",
                                    "name": "Bavarian Knight Roll Cake Slice",
                                    "category": "Ice Cream Cakes",
                                    "description": "Bavarian chocolate ice cream wrapped in chocolate sponge & covered with chocolate fudge and almonds. Chocolate, chocolate and then some more chocolate. This ice cream roll cake sounds perfect, doesn't it?",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e2741c53-283b-4240-8480-49f38acfafb5_29b1450c-4560-46fd-9310-a9eaa9718fa5.jpg",
                                    "isVeg": 1,
                                    "price": 13500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.2",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28852136"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932146",
                                    "name": "Bavarian Knight Roll Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "Bavarian chocolate ice cream wrapped in chocolate sponge & covered with chocolate fudge and almonds. Chocolate, chocolate and then some more chocolate. This ice cream roll cake sounds perfect, doesn't it?",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/24baa2b8-a0a9-44b3-8059-c31cacf71baf_26f2505c-10b2-4a22-9de4-434c085c6aae.jpg",
                                    "isVeg": 1,
                                    "price": 84700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852130"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932268",
                                    "name": "Mississippi Mud Roll Cake Slice",
                                    "category": "Ice Cream Cakes",
                                    "description": "Mississippi mud ice cream wrapped in brownie chocolate cake & chocolate truffle, drizzled with chocolate confectionery & pecan pralines. A luxurious chocolate delight all swirled into one cake make a sinful chocolate ice cream roll cake. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/865bc761-6cf0-4c5f-a26e-24b4b01e13e6_ad3141ee-4c33-4658-bcb5-e808f90d2c81.jpg",
                                    "isVeg": 1,
                                    "price": 13500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "18 ratings",
                                        "ratingCountV2": "18"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28855799"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932267",
                                    "name": "Mississippi Mud Roll Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "Mississippi mud ice cream wrapped in brownie chocolate cake & chocolate truffle, drizzled with chocolate confectionery & pecan pralines. A luxurious chocolate delight all swirled into one cake make a sinful chocolate ice cream roll cake. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/7cab373e-34fd-44a4-9955-b12e430d6fa4_9142eea1-5db0-4925-818c-b8df8aa237d0.jpg",
                                    "isVeg": 1,
                                    "price": 84700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28855793"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932296",
                                    "name": "Red Velvet Roll Cake Slice",
                                    "category": "Ice Cream Cakes",
                                    "description": "Red velvet ice cream wrapped in red velvet marble cake & white chocolate truffle, drizzled with red velvet and white chocolate confectionery. This white chocolate and red velvet ice cream roll cake will have you dreaming of christmas!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/c3dd0f9f-acac-486a-b9ef-a8f167c89eb9_93237be5-53bc-45e9-8b60-d92893ee3ef5.jpg",
                                    "isVeg": 1,
                                    "price": 13500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28856274"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932295",
                                    "name": "Red Velvet Roll Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "Red velvet ice cream wrapped in red velvet marble cake & white chocolate truffle, drizzled with red velvet and white chocolate confectionery. This white chocolate and red velvet ice cream roll cake will have you dreaming of christmas!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/2e4a77bf-1772-4268-a70b-a0e0983086f9_adfc4345-d324-4ab8-912f-521ae8c8bbe3.jpg",
                                    "isVeg": 1,
                                    "price": 84700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28856268"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932254",
                                    "name": "Biscoff Roll Cake Slice",
                                    "category": "Ice Cream Cakes",
                                    "description": "Soft vanilla sponge cake with biscoff ice cream, swirled with a cream caramel ribbon and topped off with biscoff cookie crumble. A biscoff style celebration!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/30af44c5-509c-4fd5-8c2e-9c4225cd4fe2_551ac6c2-3fb7-477f-ae9d-64ef582507f1.jpg",
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "115050828"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932253",
                                    "name": "Biscoff Roll Cake",
                                    "category": "Ice Cream Cakes",
                                    "description": "Soft vanilla sponge cake with biscoff ice cream, swirled with a cream caramel ribbon and topped off with biscoff cookie crumble. A biscoff style celebration!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/a1a0351f-c946-4cc4-800d-8c15e6e4730e_59cb5d32-18a9-4da5-9373-365d1a02c477.jpg",
                                    "isVeg": 1,
                                    "price": 90600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115050827"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168935494",
                                    "name": "Iranian Pista Kulfi Roll Slice (80g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "A slice of delicious malai kulfi & creamy vanilla ice cream topped with iranian pistachio slivers",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/65e43f1c-8410-452d-8034-e61b07de7390_751d0783-8a10-440c-815d-241286496662.jpg",
                                    "isVeg": 1,
                                    "price": 17900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "92024661"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "155734434",
                                    "name": "Iranian Pista Kulfi Roll (650g)",
                                    "category": "Ice Cream Cakes",
                                    "description": "Classic malai kulfi & creamy vanilla ice cream topped with iranian pistachio slivers",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/abf28c29-7079-436a-b1f4-4beacb3c4af9_947cd40e-4f2c-43b2-88b6-d01dd02a9850.jpg",
                                    "isVeg": 1,
                                    "price": 90600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "91183338"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869078"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/28/15829c09-cdb3-40cd-b24f-6090029d7fca_3cbc6c0d-826c-48e2-99dd-84bc6928f736.jpg",
                        "categoryId": "60869026"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Classic & Nuts Ice Creams",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935579",
                                "name": "Vanilla Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Not quite like a plain jane, this is a rich, dense vanilla ice cream that you'll recommend to friends. Seriously creamy, seriously tasty, a lot can happen over a vanilla ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/379e52bf-4e22-4ba0-a1d8-7a76fbd178b4_6b8ecce0-1204-4a6e-987f-ac00d69d9831.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366870",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207234",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207236",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207237",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207238",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207239",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181207241",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207244",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181207246",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207234"
                                        }
                                      ],
                                      "price": 7500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207236"
                                        }
                                      ],
                                      "price": 11200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207237"
                                        }
                                      ],
                                      "price": 15000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207238"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207239"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207241"
                                        }
                                      ],
                                      "price": 37714,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207244"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366870",
                                          "variationId": "181207246"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420868",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420867",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420867",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420868",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 7500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28857227"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932237",
                                "name": "Honey Nut Crunch Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Ice cream with rich caramel and honey praline almonds. Honey, it's nutty, it's crunchy and it's delightful. What are you waiting for? get yourself a load of this honey nut crunch ice cream. (contains milk & tree nuts)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/60013145-2753-4b94-97aa-a7894dbe0071_265582c5-3283-4f2d-a6ca-0edb47b5483c.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366880",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207294",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207299",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207303",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207296",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207304",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181207301",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207302",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181207305",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207294"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207299"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207303"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207296"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207304"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207301"
                                        }
                                      ],
                                      "price": 50476,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207302"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366880",
                                          "variationId": "181207305"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420885",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420884",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420884",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420885",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28855021"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932194",
                                "name": "Cotton Candy Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Perky pink, purple and childhood coloured cotton candy flavoured ice cream. We're happy to let you know that we have fulfilled every child's wish of cotton candy ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/6623e668-656a-4d10-9d1e-78da7980fb4b_382f903f-8be8-4f25-bacc-9f1d5651c99f.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366892",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207364",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207366",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207368",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207370",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207372",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181207374",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207378",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181207382",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207364"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207366"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207368"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207370"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207372"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207374"
                                        }
                                      ],
                                      "price": 50476,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207378"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366892",
                                          "variationId": "181207382"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420909",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420912",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28853395"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932297",
                                "name": "Roasted Californian Almond Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Vanilla ice cream with caramel ribbon and almond praline. We've put together two classics flavours with a caramel ribbon stitching them together. This almond praline gold proves that sometime old is truly gold! (contains milk & tree nuts)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/283b5b55-048f-4450-9e2a-f959310e5852_754b8b15-df40-458c-9e17-b59a8ba32692.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366910",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207466",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207471",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207477",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207482",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207485",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207488",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207480",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207466"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207471"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207477"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207482"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207485"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207488"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366910",
                                          "variationId": "181207480"
                                        }
                                      ],
                                      "price": 32670,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420945",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420939",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420939",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420945",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28856360"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932166",
                                "name": "Butterscotch Ribbon Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Vanilla ice cream swirled with butterscotch ribbon. This thick, sinful butterscotch ribbon will leave you going back for seconds!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/8ed5e70d-4191-4b7c-8cdb-0ed17c52cbf0_2bf78742-9533-46db-ad5e-192314edfd6f.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366921",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Regular Scoop",
                                          "default": 1,
                                          "id": "181207537",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207540",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207542",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181207543",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207544",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207546",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181207535",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207537"
                                        }
                                      ],
                                      "price": 11200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207540"
                                        }
                                      ],
                                      "price": 15000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207542"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207543"
                                        }
                                      ],
                                      "price": 37714,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207544"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207546"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366921",
                                          "variationId": "181207535"
                                        }
                                      ],
                                      "price": 7500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420967",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420964",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420964",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420967",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11200,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28852543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932306",
                                "name": "Splish Splash Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Celestial ice cream with a dark blue raspberry and light blueberry embrace. This delectable blue raspberry and blueberry ice cream scoop with leave you feeling blue. The right kind of blue! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c5675367-b2d3-4a8a-81fa-11ef844e7233_4b3b9ef0-b30b-4665-9fe4-aab44b18ca83.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366938",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207601",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207606",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207611",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207614",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207616",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207617",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207601"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207606"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207611"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207614"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207616"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366938",
                                          "variationId": "181207617"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214420993",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214420988",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214420988",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214420993",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28856810"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932300",
                                "name": "Roasted Coffee Creme Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Luscious ice cream with freshly ground coffee. This cool coffee flavoured ice cream will delight all coffee lovers out there! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/f86a9c53-f950-483c-bc35-50866bf72372_d2b1a918-f255-4d34-8d5d-e2a09c5cc91d.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366949",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207664",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207667",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207670",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207673",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207672",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207674",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207675",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207664"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207667"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207670"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207673"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207672"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207674"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421015",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421013",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366949",
                                          "variationId": "181207675"
                                        }
                                      ],
                                      "price": 36000
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421013",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421015",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28856402"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932240",
                                "name": "Hop Scotch Butterscotch Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "With a butterscotch base, this ice cream has cashew crunch along with an enticing butterscotch ribbon. Stop drooling, start clicking! our butterscotch ice cream is calling out to you! (contains milk & tree nuts)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/28cc1197-d4aa-4a7f-8b61-ff602668ef74_4cea8131-150f-499e-a126-8007af1b4511.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366961",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207725",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207731",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207732",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207735",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207738",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207728",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207740",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207725"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207728"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207731"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207732"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207735"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207738"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366961",
                                          "variationId": "181207740"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421041",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421037",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421037",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421041",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28855112"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932285",
                                "name": "Pralines 'N Cream Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "A vanilla base decorated with praline coated pecans and a delicate caramel ribbon. This creamy cool ice cream dotted with praline pecans has just the right amount of crunch and sweetness with a swirled in caramel ribbon. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/ba63fef3-3915-4faf-be0f-6e3da141f76f_3230d8ea-590d-4b56-945a-90fa27639977.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366974",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181207787",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181207790",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207792",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207793",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207794",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207795",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207787"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207790"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207792"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207793"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207794"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366974",
                                          "variationId": "181207795"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421061",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421058",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421058",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421061",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28856125"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935725",
                                "name": "Cookies 'N Cream Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Classic vanilla ice cream loaded with sweet oreo cookie crumble. Classic never goes out of style!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/5b89192a-1c23-4fa0-9ed3-77c7420901ba_b8740347-ba0e-44e2-aa45-b2d04b54aa5f.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58366984",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Regular Scoop",
                                          "default": 1,
                                          "id": "181207838",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181207842",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181207846",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181207849",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181207853",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181207857",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181207835",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207838"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207842"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207846"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207849"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207853"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207857"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58366984",
                                          "variationId": "181207835"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421088",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421083",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421083",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421088",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 15700,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28853315"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932250",
                                "name": "Biscoff Ice Cream",
                                "category": "Classic & Nuts Ice Creams",
                                "description": "Biscoff flavoured ice cream with biscoff pieces and a caramel ribbon. Unexpectedly delightful!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/3b05dac0-4183-4df0-9f6b-db8c5ae1477a_3c7083cc-a031-4b11-8a68-729445a0566b.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367018",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181208002",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208003",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208005",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208009",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208012",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208014",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208002"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208003"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208005"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208009"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208012"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367018",
                                          "variationId": "181208014"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421149",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421144",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421144",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421149",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "115050822"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/379e52bf-4e22-4ba0-a1d8-7a76fbd178b4_6b8ecce0-1204-4a6e-987f-ac00d69d9831.jpg",
                        "categoryId": "60869028"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Fruit Ice Creams",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932210",
                                "name": "Very Berry Strawberry Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Sublime strawberry ice cream with real strawberry pieces. This strawberry ice cream is a childhood favourite. Scrap that actually, it's an all time favourite! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/b044c7a3-010a-4808-9fd1-c11fa7f7917a_6c96274e-1fa4-4b6c-9000-78032170d972.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367120",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Regular Scoop",
                                          "default": 1,
                                          "id": "181208504",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208507",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208508",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208511",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208513",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181208502",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181208509",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208504"
                                        }
                                      ],
                                      "price": 11200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208507"
                                        }
                                      ],
                                      "price": 15000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208508"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208509"
                                        }
                                      ],
                                      "price": 37714,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208511"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208513"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367120",
                                          "variationId": "181208502"
                                        }
                                      ],
                                      "price": 7500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421310",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421308",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421308",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421310",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11200,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28857351"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168935914",
                                "name": "Alphonso Mango Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Delicious alphonso mango based ice cream made with juicy, real mango pulp. Just go for this aam-azing mango ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/d7d0f27f-6fb8-4210-a3ce-6a81220fe3a1_4f87d431-025e-45e3-a0c1-6702e9e9a0ff.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367132",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181208565",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208569",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "id": "181208571",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208573",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Factory sealed 700 ml - serves 6-8",
                                          "id": "181208575",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208578",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208580",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208565"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208567"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208569"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208571"
                                        }
                                      ],
                                      "price": 32670,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208573"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208575"
                                        }
                                      ],
                                      "price": 43200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208578"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367132",
                                          "variationId": "181208580"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421329",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421328",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421328",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421329",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28851799"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932135",
                                "name": "Banana 'N Strawberry Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Ice cream with real banana and strawberries with strawberry ribbon. This banana and strawberry ice cream combination has stood the test of time. You simply cannot go wrong with this delicious ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/ffeab69e-7638-403e-adc7-aa0063efde66_6bfcb09e-f259-423a-8076-72c6df029b2e.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367148",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181208647",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208651",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208657",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208658",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208659",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208655",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208647"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208651"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208655"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208657"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208658"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367148",
                                          "variationId": "181208659"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421359",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421355",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421355",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421359",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28851955"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932156",
                                "name": "Black Currant Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Black currant ice cream with real black currant and raisins. This flavoured sweet treat is a universal favourite!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/3/f21381d3-3efe-444c-bc11-6739c421f813_b1935344-bc6e-485c-8df1-774e93537fbd.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367159",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Factory sealed 450 ml - serves 4-5",
                                          "default": 1,
                                          "id": "181208702",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181208693",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208699",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208704",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208706",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208697",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208707",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208702"
                                        }
                                      ],
                                      "price": 36000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208693"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208699"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208704"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208706"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208697"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367159",
                                          "variationId": "181208707"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421381",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421379",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421379",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421381",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28852282"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932218",
                                "name": "Fruit Overload Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Orange flavoured ice cream adorned with exotic fruit chunks and jelly. This fruity delight is truly delicious! get a load of this fruit overload ice cream!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c03c6538-03f1-4e37-9b9f-c7b872d9694a_2b903d20-bd9f-41cb-86b6-54139fc3c5f8.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367182",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Regular Scoop",
                                          "default": 1,
                                          "id": "181208793",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208794",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208796",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208798",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208800",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Small Scoop",
                                          "id": "181208789",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208793"
                                        }
                                      ],
                                      "price": 13200,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208794"
                                        }
                                      ],
                                      "price": 18000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208796"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208798"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208800"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367182",
                                          "variationId": "181208789"
                                        }
                                      ],
                                      "price": 9000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421424",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421420",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421420",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421424",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13200,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "28854511"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "105932303",
                                "name": "Shooting Star Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Your wish for a quirky, vibrant ice cream just came true. A combination of blueberry and vanilla ice cream swirled with a refreshing cherry ribbon and loaded with coloured sugar strands and popping candy. Super fun, super delicious. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c8580b81-6bf4-4057-a001-57df0007e1f5_2c8441f0-23cc-485e-82a7-500f5b54a3f3.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367187",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181208811",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208818",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208826",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208834",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208839",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208843",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208811"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208818"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208826"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208834"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208839"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367187",
                                          "variationId": "181208843"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421445",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421436",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421436",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421445",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82541471"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114329096",
                                "name": "Blueberry 'N White Chocolate Ice Cream",
                                "category": "Fruit Ice Creams",
                                "description": "Exotic blend of white chocolate ice cream with sweet blueberries. A purple scoop of joy!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/291d7ab2-c2d0-4833-8e7e-073cc8325330_689ee250-027c-4ad2-bf61-ebaa81ab26ab.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367214",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "181208929",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "181208933",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "181208942",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181208937",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "181208945",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr- serves 8-10",
                                          "id": "181208946",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208929"
                                        }
                                      ],
                                      "price": 11000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208933"
                                        }
                                      ],
                                      "price": 15700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208942"
                                        }
                                      ],
                                      "price": 22000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208937"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208945"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367214",
                                          "variationId": "181208946"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214421487",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214421482",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214421482",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214421487",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65784867"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/b044c7a3-010a-4808-9fd1-c11fa7f7917a_6c96274e-1fa4-4b6c-9000-78032170d972.jpg",
                        "categoryId": "60869030"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Sundaes",
                        "categories": [
                          {
                            "title": "Classic Sundaes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932312",
                                    "name": "Thunder Hot Fudge",
                                    "category": "Sundaes",
                                    "description": "Creamy vanilla and decadent three cheers chocolate ice creams come together to create this extraordinary treat. Made even more special with a delicious hot fudge sauce and a dollop of whipped cream do we hear your taste buds thanking us already?",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/8f93235c-b4b6-49bb-86c0-c2582fb7e670_d3866904-2328-4660-91fb-7ac992da6485.jpg",
                                    "isVeg": 1,
                                    "price": 21500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "28857051"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932276",
                                    "name": "Nutty Professor",
                                    "category": "Sundaes",
                                    "description": "We made sure this treat is as nutty as its name. Crunchy californian almond ice cream paired generously with nuts, almonds, cashews, and raisins drowning in a delicious hot fudge sauce and topped off with whipped cream. Going nutty has never been this fun before. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/a3de08ff-5def-4f05-97ef-ec09f126ed48_8575933f-fabd-435f-9338-250dfa0c6df9.jpg",
                                    "isVeg": 1,
                                    "price": 25500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28855905"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932161",
                                    "name": "Brownie A La Mode",
                                    "category": "Sundaes",
                                    "description": "When brownies are the answer, anyone seldom cares what the question is! meet our chocolicious combination of three cheers chocolate and chocolate ice cream on a delicious brownie cake, topped off with hot fudge sauce and whipped cream. Decadence, indeed!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/4fd0d896-3936-4a88-aeeb-66441f9d3d44_ba4b6f95-95ef-40fd-84c5-cd9f20f58c79.jpg",
                                    "isVeg": 1,
                                    "price": 36000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852470"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869089"
                          },
                          {
                            "title": "Cheesecake Sundaes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936144",
                                    "name": "Biscoff Ice Cream With Butterscotch Sauce Cheesecake Sundae",
                                    "category": "Sundaes",
                                    "description": "Baked cheesecake with biscoff ice cream, caramel sauce, and whipped cream. Unexpectedly delightful!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/17b5099b-274f-412f-b4ef-325056fea398_40a88b8b-c73a-43ac-b5a9-7dbed725ef8d.jpg",
                                    "isVeg": 1,
                                    "price": 30000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "115050825"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936157",
                                    "name": "Vanilla Ice Cream With Mango Sauce Cheesecake Sundae",
                                    "category": "Sundaes",
                                    "description": "Baked cheesecake with vanilla ice cream, mango sauce, and whipped cream. Exotic and fun, all at once!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/87532bd7-9e12-4bed-b2b1-6661502483ab_bf7a8a28-f8ba-454d-a300-ba3c86ecba23.jpg",
                                    "isVeg": 1,
                                    "price": 30000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "58926215"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936161",
                                    "name": "Vanilla Ice Cream With Nutella Spread Cheesecake Sundae",
                                    "category": "Sundaes",
                                    "description": "Baked cheesecake with vanilla ice cream, nutella spread, and whipped cream. Indulgence at its best!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/de84941c-06a4-49ef-856d-b87c939a189c_477af4c5-1870-4386-8036-6ede7c3f5a12.jpg",
                                    "isVeg": 1,
                                    "price": 30000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "58926216"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "138177766",
                                    "name": "Cheese Cake Gold Medal Ribbon Sundae",
                                    "category": "Sundaes",
                                    "description": "Baked cheesecake topped with a scoop of gold medal ribbon ice cream and nutella spread! ultimate sundae joy with nutella!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/a5251d5f-c0b3-4fb2-bc1e-2897097f4351_335d6051-6627-49f8-aba5-df310d59482b.jpg",
                                    "isVeg": 1,
                                    "price": 30000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "81097928"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869092"
                          },
                          {
                            "title": "Brownie And Lava Cake Sundae",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932313",
                                    "name": "Vanilla Affair",
                                    "category": "Sundaes",
                                    "description": "A warm gooey brownie with the world's best vanilla ice cream, topped with hot fudge or butterscotch sauce",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/faf14686-e29a-4f7c-8f7c-eec74bd20114_6464814f-e580-4e4a-a513-8559c8b24b92.jpg",
                                    "isVeg": 1,
                                    "price": 19500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28857172"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932151",
                                    "name": "Belgian Dream",
                                    "category": "Sundaes",
                                    "description": "Warm brownie topped with delectable belgian bliss ice cream and hot fudge or butterscotch sauce. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e79c640f-6f3e-4df7-8cf2-e148acee47a9_d82b4313-ee36-4d42-9a23-69cf6b1bef82.jpg",
                                    "isVeg": 1,
                                    "price": 23500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852220"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "105932142",
                                    "name": "Bavarian Blast",
                                    "category": "Sundaes",
                                    "description": "A delicious warm brownie served with a scoop of indulgent bavarian chocolate ice cream topped with hot fudge",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/8d97f734-2e99-4abc-ab0e-ac21d965fd70_03ced841-e63d-4b1f-8669-6dbb16ad0301.jpg",
                                    "isVeg": 1,
                                    "price": 23500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852033"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114329093",
                                    "name": "Almond Delight Sundae",
                                    "category": "Sundaes",
                                    "description": "Warm brownie with nutty roasted californian almond ice cream topped with hot fudge or butterscotch fudge",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/805d947b-9f60-407c-b85f-78dbce0e9877_02d4e72a-a9a5-42c9-8419-c31a9566fabe.jpg",
                                    "isVeg": 1,
                                    "price": 20500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65784864"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869096"
                          },
                          {
                            "title": "Fruit Cream Sundae",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114329095",
                                    "name": "Banana N Strawberry Fruit Cream Sundae",
                                    "category": "Sundaes",
                                    "description": "Single scoop of banana n strawberry ice cream layered with a blend of soft fruits, fruit toppings, whipped cream, and cherry on top. A pop of color and fruity flavor!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/cf5ecf7e-0170-434f-8928-048a3d00dbaf_cbae64e8-8afb-4c85-be6e-1dcb0b5d1dda.jpg",
                                    "isVeg": 1,
                                    "price": 22500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65784866"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114329094",
                                    "name": "Alphonso Mango Fruit Cream Sundae",
                                    "category": "Sundaes",
                                    "description": "Single scoop of alphonso mango ice cream layered with a blend of soft fruits, fruit toppings, whipped cream, and cherry on top. A pop of color and fruity flavor!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/cbf1efdf-60ed-49f0-af1a-82809341dde2_b9185958-b162-4eec-a3da-450b191e11da.jpg",
                                    "isVeg": 1,
                                    "price": 22500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65784865"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114329104",
                                    "name": "Vanilla Fruit Cream Sundae",
                                    "category": "Sundaes",
                                    "description": "Single scoop of vanilla ice cream layered with a blend of soft fruits, fruit toppings, whipped cream, and cherry on top. A pop of color and fruity flavor!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/03d990f9-e2fc-40c6-8159-13bdb66e1cc9_a708e089-ae26-4b87-be28-5a88ec58ad09.jpg",
                                    "isVeg": 1,
                                    "price": 22500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65784873"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869099"
                          },
                          {
                            "title": "Kids Special Sundaes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "169405450",
                                    "name": "Princess Sundae",
                                    "category": "Sundaes",
                                    "description": "Your favourite scoop turned into a charming and noble princess. Your fairytale begins here!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e3b25309-52f5-434b-bd9f-8e7d43dd21e4_a21f3b98-1a33-44fb-b52e-494f63c41da8.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "215619625",
                                        "groupName": "Preparation",
                                        "choices": [
                                          {
                                            "id": "135861570",
                                            "name": "Black Currant Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "136847694",
                                            "name": "Very Berry Strawberry Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861569",
                                            "name": "Honey Nut Crunch Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861568",
                                            "name": "Alphonso Mango Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861576",
                                            "name": "Vanilla Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861577",
                                            "name": "Cotton Candy Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861574",
                                            "name": "Splish Splash Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861575",
                                            "name": "Roasted Californian Almond Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861572",
                                            "name": "Shooting Star Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861573",
                                            "name": "Bavarian Chocolate Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861571",
                                            "name": "Mississippi Mud Ice Cream",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "102192070"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114329103",
                                    "name": "Unicorn Sundae",
                                    "category": "Sundaes",
                                    "description": "Chocolate unicorn toppers with multicolored sprinkles on your choice of ice cream. There's magic in every bite",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/97e8695a-92d1-4b65-be79-207795f329c5_ab94393b-7fb3-4f1e-ad11-fd395c3eab07.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "215619627",
                                        "groupName": "Preparation",
                                        "choices": [
                                          {
                                            "id": "135861570",
                                            "name": "Black Currant Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "136847694",
                                            "name": "Very Berry Strawberry Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861569",
                                            "name": "Honey Nut Crunch Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861568",
                                            "name": "Alphonso Mango Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861576",
                                            "name": "Vanilla Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861577",
                                            "name": "Cotton Candy Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861574",
                                            "name": "Splish Splash Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861575",
                                            "name": "Roasted Californian Almond Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861572",
                                            "name": "Shooting Star Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861573",
                                            "name": "Bavarian Chocolate Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861571",
                                            "name": "Mississippi Mud Ice Cream",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65784872"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114479541",
                                    "name": "Mermaid Sundae",
                                    "category": "Sundaes",
                                    "description": "Chocolate mermaid toppers with multicolored sprinkles on your choice of ice cream. A fairytale sundae!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e47c7f64-d98f-4031-af3c-fe19222a289f_f74fc509-174f-4cfd-8f92-b54158a4ca18.jpg",
                                    "isVeg": 1,
                                    "price": 20000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "215619628",
                                        "groupName": "Preparation",
                                        "choices": [
                                          {
                                            "id": "135861570",
                                            "name": "Black Currant Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "136847694",
                                            "name": "Very Berry Strawberry Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861569",
                                            "name": "Honey Nut Crunch Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861568",
                                            "name": "Alphonso Mango Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861576",
                                            "name": "Vanilla Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861577",
                                            "name": "Cotton Candy Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861574",
                                            "name": "Splish Splash Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861575",
                                            "name": "Roasted Californian Almond Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861572",
                                            "name": "Shooting Star Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861573",
                                            "name": "Bavarian Chocolate Ice Cream",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "135861571",
                                            "name": "Mississippi Mud Ice Cream",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "65883458"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "137677376",
                                    "name": "Lollipop Sundae",
                                    "category": "Sundaes",
                                    "description": "Add a swirl of fun to your ice cream. Lollipop sundae comes with a lollipop, crunchy wafer roll, colorful sprinkles and more. More fun, more yum!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/6a087350-a1df-4eeb-97af-4c1132b6b7e8_188e8b10-aeb9-49f4-ab13-83468b342678.jpg",
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "58367250",
                                          "name": "Preparation",
                                          "variations": [
                                            {
                                              "name": "Strawberry Lollipop Sundae",
                                              "default": 1,
                                              "id": "181209042",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Dutch Chocolate Lollipop Sundae",
                                              "id": "181209047",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Alphonso Mango Lollipop Sundae",
                                              "id": "181209043",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cotton Candy Lollipop Sundae",
                                              "id": "181209051",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Shooting Star Lollipop Sundae",
                                              "id": "181209052",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Jello Mello Lollipop Sundae",
                                              "id": "181209053",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209042"
                                            }
                                          ],
                                          "price": 16000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209047"
                                            }
                                          ],
                                          "price": 16000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209043"
                                            }
                                          ],
                                          "price": 16000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209051"
                                            }
                                          ],
                                          "price": 19000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209052"
                                            }
                                          ],
                                          "price": 19000
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "58367250",
                                              "variationId": "181209053"
                                            }
                                          ],
                                          "price": 16000
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "80788729"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "68879982"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/8f93235c-b4b6-49bb-86c0-c2582fb7e670_d3866904-2328-4660-91fb-7ac992da6485.jpg",
                        "categoryId": "60869033"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Beverages",
                        "categories": [
                          {
                            "title": "Super-duper Thickshakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936312",
                                    "name": "Mango Super-duper Thick Shake",
                                    "category": "Beverages",
                                    "description": "Irresistible super-duper thickshake made with succulent and juicy alphonso mango ice cream and fruity popping boba. Dressed with whipped cream and some more fruity popping boba. Definitely your new summer favourite!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/36b9709f-0a36-4d57-a9c7-6e1642f2e68a_bcd2e7c3-a591-447b-a279-4b5fd951f5e6.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108680505"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936317",
                                    "name": "Biscoff Super-duper Thickshake",
                                    "category": "Beverages",
                                    "description": "The talk of the town a unique thickshake packed with flavour and crunch and made with creamy vanilla ice cream and biscoff. Crowned with a whipped cream swirl and biscuit crumble. A must try!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/f81f7f83-98a6-427d-ae8b-50dfecab3629_d188d80a-588c-4461-bcb7-8c99b4b0cff8.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "68914129"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936329",
                                    "name": "Cotton Candy And Marshmallows Super-duper Thickshake",
                                    "category": "Beverages",
                                    "description": "Dreamy thickshake crafted with the all-time-favourite cotton candy ice cream. Topped with whipped cream, coloured sprinkles and mushy marshmallows. Yum!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/53ae95ad-32a9-4e2d-a105-e1d94ba22110_00b54090-7158-47f8-9acb-5f89a84dd709.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28853375"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936332",
                                    "name": "Berry Bubble Super-duper Thickshake",
                                    "category": "Beverages",
                                    "description": "Creamy and luscious thickshake made with br favourite very berry strawberry ice cream and fruity popping boba. Topped with whipped cream and some more popping boba to give you an out of the world flavour experience. Berry tempting, right. ",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/76b3baee-d3fe-4488-be61-eeef2e1fa20f_f6685879-e8a0-4cf4-b6c9-ca770629f91a.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852234"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936335",
                                    "name": "Cafe Mocha Super-duper Thickshake",
                                    "category": "Beverages",
                                    "description": "Relive the classic cold coffee experience with this thickshake made especially with roasted coffee ice cream, and garnished with whipped cream, chocolate sauce and chocolate sprinkles. You know where to head for your next caffeine rush!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/26/5711a54c-352b-4176-89a1-d93f59105ae9_ba44424b-64dc-45bc-a607-a4259d7b9368.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28852588"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "168936338",
                                    "name": "Cookies 'N Cream Thickshake",
                                    "category": "Beverages",
                                    "description": "Crunchy oreo cookies blended to perfection with a rich milk base and topped with more cookie crumble to create a truly super duper thickshake. Yum!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/506aa251-5c4c-4807-8cb2-53f4a4b0a03d_6d6837ca-c59c-4f0a-8753-469fa68d3837.jpg",
                                    "isVeg": 1,
                                    "price": 26500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "28853332"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "60869101"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/36b9709f-0a36-4d57-a9c7-6e1642f2e68a_bcd2e7c3-a591-447b-a279-4b5fd951f5e6.jpg",
                        "categoryId": "60869035"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Ice Cream Sticks",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936687",
                                "name": "Cotton Candy 65 Ml (2 Sticks)",
                                "category": "Ice Cream Sticks",
                                "description": "Playful cotton candy ice cream coated with raspberry flavoured white choco-dip",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/9d1da919-0081-404a-b180-600c0255fc9a_0bcbe7c0-1e7f-4e90-af0b-86690d9f272f.jpg",
                                "isVeg": 1,
                                "price": 14476,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "73581427"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/9d1da919-0081-404a-b180-600c0255fc9a_0bcbe7c0-1e7f-4e90-af0b-86690d9f272f.jpg",
                        "categoryId": "60869050"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Family Prepacks",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936742",
                                "name": "Butterscotch Ribbon Ice Cream (Family Prepack 700 Ml)",
                                "category": "Family Prepacks",
                                "description": "Vanilla ice cream swirled with butterscotch ribbon. This thick, sinful butterscotch ribbon will leave you going back for seconds!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/8747afa3-769d-46ef-8b52-644d4dbbe6b5_206f2659-63b4-4dac-be96-dd717738fe7c.jpg",
                                "isVeg": 1,
                                "price": 37714,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968204"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936759",
                                "name": "Hop Scotch Butterscotch Ice Cream (Family Prepack 450 Ml)",
                                "category": "Family Prepacks",
                                "description": "With a butterscotch base, this ice cream has cashew crunch along with an enticing butterscotch ribbon. Stop drooling, start clicking! our butterscotch ice cream is calling out to you! (contains milk & tree nuts)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/28cc1197-d4aa-4a7f-8b61-ff602668ef74_4cea8131-150f-499e-a126-8007af1b4511.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968211"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936771",
                                "name": "Cookies N Cream Ice Cream (Family Prepack 450 Ml)",
                                "category": "Family Prepacks",
                                "description": "Classic vanilla ice cream loaded with sweet oreo cookie crumble. Classic never goes out of style!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/523aeb95-80cb-4aec-83a3-85285cced892_76e4cbf8-a076-47b1-aff1-2a64d3edd5aa.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968205"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936781",
                                "name": "Three Cheers Chocolate Ice Cream (Family Prepack 450 Ml)",
                                "category": "Family Prepacks",
                                "description": "A heavenly combination of chocolate and vanilla married together with chocolate chips and ribbon. A feisty ribbon twirling its way through this chocolate chip loaded chocolate and vanilla ice cream scoop. This ice cream is as enticing as they come!(contains milk & soy)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/3b7ba148-dac3-4105-bc98-d29e356d855f_f1469773-cf7a-4cb0-aa3d-f2267fbefb8e.jpg",
                                "isVeg": 1,
                                "price": 28900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968215"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936789",
                                "name": "Dutch Chocolate Ice Cream (Family Prepack 700 Ml)",
                                "category": "Family Prepacks",
                                "description": "Tempting chocolate ice cream with a distinct hint of cocoa. The mother of every chocolate ice cream creation of ours. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/2e22d97a-5e19-42d7-bb85-300fe35903da_88e40562-16ca-40b3-a62a-8726b6efe72d.jpg",
                                "isVeg": 1,
                                "price": 43200,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968207"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936800",
                                "name": "Gold Medal Ribbon Ice Cream (Family Prepack 450 Ml)",
                                "category": "Family Prepacks",
                                "description": "A heavenly medley of vanilla and chocolate, embraced by a caramel ribbon. This vanilla and chocolate combo is our dream team! a thick, deep caramel ribbon intertwines the two flavours together in perfection. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/7c20319e-ebf6-45a2-a112-105af0e84a67_ed7d16d5-acb0-447e-855e-61992baf795a.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968208"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936804",
                                "name": "Belgian Bliss Ice Cream (Family Prepack 450 Ml)",
                                "category": "Family Prepacks",
                                "description": "Rich chocolate ice cream with hidden treasures of dark chocolate cookies, hugged by a caramel ribbon. This delectable chocolate delight is like no other! sit back and enjoy this rich belgian bliss ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/263e5e74-4d4a-4c54-b7ef-92f8e62a9c18_1dee2c34-935c-458a-890a-6cefd1b1cd84.jpg",
                                "isVeg": 1,
                                "price": 36000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968202"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176898975",
                                "name": "Alphonso Mango Ice Cream (Family Prepack)",
                                "category": "Family Prepacks",
                                "description": "Delicious alphonso mango based ice cream made with juicy, real mango pulp. Just go for this aam-azing mango ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/d7d0f27f-6fb8-4210-a3ce-6a81220fe3a1_4f87d431-025e-45e3-a0c1-6702e9e9a0ff.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "62947142",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Family Prepack 450 ml",
                                          "default": 1,
                                          "id": "193199108",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Prepack 700 ml",
                                          "id": "193199109",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947142",
                                          "variationId": "193199108"
                                        }
                                      ],
                                      "price": 32670
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947142",
                                          "variationId": "193199109"
                                        }
                                      ],
                                      "price": 43200
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32670,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968200"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176898976",
                                "name": "Vanilla Ice Cream (Family Prepack)",
                                "category": "Family Prepacks",
                                "description": "Not quite like a plain jane, this is a rich, dense vanilla ice cream that you'll recommend to friends. Seriously creamy, seriously tasty, a lot can happen over a vanilla ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/bf4e2057-83e9-49d9-936a-bec9f04ab6f1_150ee045-404b-489a-87e4-e38ffdb4471a.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "62947143",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Family Prepack 450 ml",
                                          "default": 1,
                                          "id": "193199110",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Prepack 700 ml",
                                          "id": "193199111",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947143",
                                          "variationId": "193199110"
                                        }
                                      ],
                                      "price": 28900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947143",
                                          "variationId": "193199111"
                                        }
                                      ],
                                      "price": 37714
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 28900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968216"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176898977",
                                "name": "Cotton Candy Ice Cream (Family Prepack)",
                                "category": "Family Prepacks",
                                "description": "Perky pink, purple and childhood coloured cotton candy flavoured ice cream. We're happy to let you know that we have fulfilled every child's wish of cotton candy ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/d537c583-034b-4413-8711-b01b9856e136_3f555ecc-03b9-4d30-875b-3c949cab9fab.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "62947144",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Family Prepack 450 ml",
                                          "default": 1,
                                          "id": "193199112",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Prepack 700 ml",
                                          "id": "193199113",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947144",
                                          "variationId": "193199112"
                                        }
                                      ],
                                      "price": 36000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947144",
                                          "variationId": "193199113"
                                        }
                                      ],
                                      "price": 50476
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968206"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "176898978",
                                "name": "Honey Nut Crunch Ice Cream(family Prepack)",
                                "category": "Family Prepacks",
                                "description": "Ice cream with rich caramel and honey praline almonds. Honey, it's nutty, it's crunchy and it's delightful. What are you waiting for? get yourself a load of this honey nut crunch ice cream. (contains milk & tree nuts)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/57f8c016-432a-4013-80f1-5f4b472dcd8f_560d770a-e3d2-4d10-a780-7d0adf632a2e.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "62947145",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Family Prepack 450 ml",
                                          "default": 1,
                                          "id": "193199114",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Prepack 700 ml",
                                          "id": "193199115",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947145",
                                          "variationId": "193199114"
                                        }
                                      ],
                                      "price": 36000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62947145",
                                          "variationId": "193199115"
                                        }
                                      ],
                                      "price": 50476
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 36000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "106968210"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/8747afa3-769d-46ef-8b52-644d4dbbe6b5_206f2659-63b4-4dac-be96-dd717738fe7c.jpg",
                        "categoryId": "60869055"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Freshly Scooped Tubs",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936841",
                                "name": "Three Cheers Chocolate Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "A heavenly combination of chocolate and vanilla married together with chocolate chips and ribbon. A feisty ribbon twirling its way through this chocolate chip loaded chocolate and vanilla ice cream scoop. This ice cream is as enticing as they come!(contains milk & soy)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/3b7ba148-dac3-4105-bc98-d29e356d855f_f1469773-cf7a-4cb0-aa3d-f2267fbefb8e.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367667",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210488",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210490",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225715",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367667",
                                          "variationId": "181210488"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367667",
                                          "variationId": "181210490"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367667",
                                          "variationId": "209225715"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422400",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422396",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422396",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422400",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 40700,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515516"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734390",
                                "name": "Dutch Chocolate Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Tempting chocolate ice cream with a distinct hint of cocoa. The mother of every chocolate ice cream creation of ours. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/cab69a09-7fde-40c5-aaae-78184a416355_85478294-d2ae-4551-adbf-c145731a038f.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367675",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210510",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210514",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225650",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367675",
                                          "variationId": "181210510"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367675",
                                          "variationId": "181210514"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367675",
                                          "variationId": "209225650"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422414",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422412",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422412",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422414",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 46500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515497"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734391",
                                "name": "Belgian Bliss Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Rich chocolate ice cream with hidden treasures of dark chocolate cookies, hugged by a caramel ribbon. This delectable chocolate delight is like no other! sit back and enjoy this rich belgian bliss ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/263e5e74-4d4a-4c54-b7ef-92f8e62a9c18_1dee2c34-935c-458a-890a-6cefd1b1cd84.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367687",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210558",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210560",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225853",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367687",
                                          "variationId": "181210558"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367687",
                                          "variationId": "181210560"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367687",
                                          "variationId": "209225853"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422438",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422434",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422434",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422438",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515485"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734392",
                                "name": "Chocolate Almond Praline Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Praline coated almonds peeping out of dark chocolate ice cream (contains milk & tree nuts (almond)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/cabd2e32-bc79-4bbe-8979-f889d80a32f1_213d5cd1-e44f-4cf5-83a3-78c294e512b0.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367699",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210602",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210600",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225527",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367699",
                                          "variationId": "181210602"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367699",
                                          "variationId": "181210600"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367699",
                                          "variationId": "209225527"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422460",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422458",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422458",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422460",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515493"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734393",
                                "name": "Mint Milk Chocolate Chips Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "An ice cream that tells the mint and chocolate love story like no other. This classic ice cream is a marriage of mint and milk chocolate pieces. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/026007ed-0dff-4fe9-aa8a-2f8f16bf6b61_1d7d6017-bac4-484f-b382-eaf506b91e69.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367709",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210638",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210639",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225975",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367709",
                                          "variationId": "181210638"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367709",
                                          "variationId": "181210639"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367709",
                                          "variationId": "209225975"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422479",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422476",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422476",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422479",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515507"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734394",
                                "name": "Bavarian Chocolate Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Rich chocolate based ice cream adorned with chocolate pieces and cashew nut crispies. If it's bavarian chocolate flavour then it's gotta be sinful and intensely indulgent. Throw in a bit of crunch and you've got a truly divine chocolate ice cream treat. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/e6ae3c5c-efdc-4c4a-894b-9344897951ce_72cf32c4-7d85-4c97-835f-7fd2f7cde3a3.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367722",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225489",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181210687",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210691",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367722",
                                          "variationId": "209225489"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367722",
                                          "variationId": "181210687"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367722",
                                          "variationId": "181210691"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422508",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422503",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422508",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422503",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515484"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734395",
                                "name": "Chocolate Mousse Royale Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Mischievous chocolate chips playing peekaboo with frozen chocolate mousse dessert. There's no such thing as too much chocolate is there? how about you triple up on this cool chocolate chip mousse ice cream with a chocolate waffle cone?",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/2a308cfd-a4df-46dd-b48a-bf564363fa11_fd037f90-aa9c-4bd0-b5b6-5bb024669ade.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367736",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225928",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181210743",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210748",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367736",
                                          "variationId": "209225928"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367736",
                                          "variationId": "181210743"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367736",
                                          "variationId": "181210748"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422533",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422527",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422533",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422527",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515494"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734396",
                                "name": "Gold Medal Ribbon Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "A heavenly medley of vanilla and chocolate, embraced by a caramel ribbon. This vanilla and chocolate combo is our dream team! a thick, deep caramel ribbon intertwines the two flavours together in perfection. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/7c20319e-ebf6-45a2-a112-105af0e84a67_ed7d16d5-acb0-447e-855e-61992baf795a.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367752",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210808",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210810",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225981",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367752",
                                          "variationId": "181210808"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367752",
                                          "variationId": "181210810"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367752",
                                          "variationId": "209225981"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422566",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422563",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422563",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422566",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515501"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734399",
                                "name": "Naughty Nutella Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Heavenly nutella ice cream made with velvety nutella paste and premium chocolate. Get nutty!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/14/548d9760-537a-4938-882c-d7f59f5286a4_cf9dc00c-3e34-4d8a-a62e-b892756dd064.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367790",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181210955",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181210958",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367790",
                                          "variationId": "181210955"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367790",
                                          "variationId": "181210958"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422640",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422635",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422635",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422640",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515509"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734401",
                                "name": "Vanilla Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Not quite like a plain jane, this is a rich, dense vanilla ice cream that you'll recommend to friends. Seriously creamy, seriously tasty, a lot can happen over a vanilla ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/fad04639-39ea-47d3-b2d7-c2a78847dadc_2e0f0769-8f4f-46af-9b23-15cceb402565.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367814",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211052",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211053",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225772",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367814",
                                          "variationId": "181211052"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367814",
                                          "variationId": "181211053"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367814",
                                          "variationId": "209225772"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422685",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422682",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422682",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422685",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 40700,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515517"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734402",
                                "name": "Butterscotch Ribbon Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Vanilla ice cream swirled with butterscotch ribbon. This thick, sinful butterscotch ribbon will leave you going back for seconds!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/9d3fa704-ed97-46d6-b899-01afbcbae609_6500f3f4-515b-40fb-8e0a-c5a5d894e2cf.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367828",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211112",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211113",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225393",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367828",
                                          "variationId": "181211112"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367828",
                                          "variationId": "181211113"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367828",
                                          "variationId": "209225393"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422709",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422705",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422705",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422709",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 40700,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515490"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734404",
                                "name": "Splish Splash Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Celestial ice cream with a dark blue raspberry and light blueberry embrace. This delectable blue raspberry and blueberry ice cream scoop with leave you feeling blue. The right kind of blue! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c5675367-b2d3-4a8a-81fa-11ef844e7233_4b3b9ef0-b30b-4665-9fe4-aab44b18ca83.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367858",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211214",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211220",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225629",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367858",
                                          "variationId": "181211214"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367858",
                                          "variationId": "181211220"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367858",
                                          "variationId": "209225629"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422758",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422750",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422750",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422758",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 46500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515515"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734405",
                                "name": "Cotton Candy Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Perky pink, purple and childhood coloured cotton candy flavoured ice cream. We're happy to let you know that we have fulfilled every child's wish of cotton candy ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/27/759d2ef8-3a8d-4068-a566-50def62201d3_cea90030-ce83-4840-bc01-6e010fefcd09.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367870",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225519",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181211258",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211262",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367870",
                                          "variationId": "209225519"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367870",
                                          "variationId": "181211258"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367870",
                                          "variationId": "181211262"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422783",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422777",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422783",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422777",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515496"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734407",
                                "name": "Roasted Coffee Creme Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Luscious ice cream with freshly ground coffee. This cool coffee flavoured ice cream will delight all coffee lovers out there! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/f1396dcc-9c48-47e8-98e2-3ea15cb95138_87e0968d-f04d-4cc3-a041-f384b6e84ab8.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367897",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225468",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181211367",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211371",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367897",
                                          "variationId": "209225468"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367897",
                                          "variationId": "181211367"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367897",
                                          "variationId": "181211371"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422841",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422836",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422841",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422836",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515512"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734409",
                                "name": "Pralines 'N Cream Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "A vanilla base decorated with praline coated pecans and a delicate caramel ribbon. This creamy cool ice cream dotted with praline pecans has just the right amount of crunch and sweetness with a swirled in caramel ribbon. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/7c18f141-d564-42c3-bf4c-5bd9c521dc49_f13de9cf-3cd1-4e77-8515-114f3312310c.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367917",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211449",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211450",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225384",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367917",
                                          "variationId": "181211449"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367917",
                                          "variationId": "181211450"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367917",
                                          "variationId": "209225384"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422892",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422889",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422889",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422892",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515510"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168937005",
                                "name": "Cookies 'N Cream Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Classic vanilla ice cream loaded with sweet oreo cookie crumble. Classic never goes out of style!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/908798eb-1142-46c4-9f9f-06e962691e5e_1d1baeeb-8f7e-4ba6-9eb1-f1369cc3eec3.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367928",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211492",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211493",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225534",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367928",
                                          "variationId": "181211492"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367928",
                                          "variationId": "181211493"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367928",
                                          "variationId": "209225534"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422912",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422909",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422909",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422912",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515495"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734413",
                                "name": "Biscoff Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Biscoff flavoured ice cream with biscoff pieces and a caramel ribbon. Unexpectedly delightful!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c007808f-6dc7-4fb8-9a41-bf3113c68466_53f01bf8-d67d-489d-a910-1af166f7415b.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58367965",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225601",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181211633",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211638",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367965",
                                          "variationId": "209225601"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367965",
                                          "variationId": "181211633"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58367965",
                                          "variationId": "181211638"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214422982",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214422977",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214422982",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214422977",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "115050824"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734419",
                                "name": "Very Berry Strawberry Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Sublime strawberry ice cream with real strawberry pieces. This strawberry ice cream is a childhood favourite. Scrap that actually, it's an all time favourite! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/00fa0872-5fa1-4921-99ef-04ba30d14886_acbb162f-df8f-43b4-a84e-eeb453789034.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368013",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211847",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211848",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225617",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368013",
                                          "variationId": "181211847"
                                        }
                                      ],
                                      "price": 40700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368013",
                                          "variationId": "181211848"
                                        }
                                      ],
                                      "price": 59900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368013",
                                          "variationId": "209225617"
                                        }
                                      ],
                                      "price": 31000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423082",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423079",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423079",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423082",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 40700,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515518"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734421",
                                "name": "Alphonso Mango Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Delicious alphonso mango based ice cream made with juicy, real mango pulp. Just go for this aam-azing mango ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/d7d0f27f-6fb8-4210-a3ce-6a81220fe3a1_4f87d431-025e-45e3-a0c1-6702e9e9a0ff.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368037",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211949",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211954",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225828",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368037",
                                          "variationId": "181211949"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368037",
                                          "variationId": "181211954"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368037",
                                          "variationId": "209225828"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423125",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423120",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423125",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423120",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 46500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515482"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734422",
                                "name": "Fruit Overload Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Orange flavoured ice cream adorned with exotic fruit chunks and jelly. This fruity delight is truly delicious! get a load of this fruit overload ice cream!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/c03c6538-03f1-4e37-9b9f-c7b872d9694a_2b903d20-bd9f-41cb-86b6-54139fc3c5f8.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368047",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181211992",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181211995",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225934",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368047",
                                          "variationId": "181211992"
                                        }
                                      ],
                                      "price": 46500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368047",
                                          "variationId": "181211995"
                                        }
                                      ],
                                      "price": 67400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368047",
                                          "variationId": "209225934"
                                        }
                                      ],
                                      "price": 35700,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423144",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423140",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423140",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423144",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 46500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515500"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734423",
                                "name": "Black Currant Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Black currant ice cream with real black currant and raisins. This flavoured sweet treat is a universal favourite!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/3/f21381d3-3efe-444c-bc11-6739c421f813_b1935344-bc6e-485c-8df1-774e93537fbd.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368056",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "default": 1,
                                          "id": "181212031",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181212029",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225552",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368056",
                                          "variationId": "181212031"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368056",
                                          "variationId": "181212029"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368056",
                                          "variationId": "209225552"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423160",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423158",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423158",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423160",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 79800,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515486"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734424",
                                "name": "Shooting Star Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Your wish for a quirky, vibrant ice cream just came true. A combination of blueberry and vanilla ice cream swirled with a refreshing cherry ribbon and loaded with coloured sugar strands and popping candy. Super fun, super delicious. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/9a8349d8-c3a5-48e8-95a6-645b6ad810c9_b3840e7e-2910-49d2-b723-d589e0887646.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368064",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "default": 1,
                                          "id": "181212050",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181212059",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225858",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368064",
                                          "variationId": "181212050"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368064",
                                          "variationId": "181212059"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368064",
                                          "variationId": "209225858"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423175",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423165",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423165",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423175",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 57000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515513"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "155734426",
                                "name": "Blueberry 'N White Chocolate Ice Cream (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Exotic blend of white chocolate ice cream with sweet blueberries. A purple scoop of joy!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/5bafd71e-a9dc-4ec4-99cb-204425fdea44_fd7158e1-5844-4c12-9b3e-c077d51557c8.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58368080",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "default": 1,
                                          "id": "209225777",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 700 ml - serves 6-8",
                                          "id": "181212119",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 ltr - serves 8-10",
                                          "id": "181212125",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368080",
                                          "variationId": "209225777"
                                        }
                                      ],
                                      "price": 41500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368080",
                                          "variationId": "181212119"
                                        }
                                      ],
                                      "price": 57000,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58368080",
                                          "variationId": "181212125"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141407"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141408"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141406"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141405"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291865"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291867"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "136291866"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142141409"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960170"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960169"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960171"
                                        },
                                        {
                                          "groupId": "214423223",
                                          "addonId": "142960168"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725670"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725675"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725680"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725645"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725620"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725608"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725636"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725609"
                                        },
                                        {
                                          "groupId": "214423217",
                                          "addonId": "135725618"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214423223",
                                    "groupName": "Accompaniments",
                                    "choices": [
                                      {
                                        "id": "142141407",
                                        "name": "Choco Fudge Brownie",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141406",
                                        "name": "Classic Cheesecake",
                                        "price": 19000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960171",
                                        "name": "Choco Walnut Brownie",
                                        "price": 13500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960170",
                                        "name": "Blueberry Crumble Muffin",
                                        "price": 20500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960168",
                                        "name": "Double Chocolate Muffin",
                                        "price": 23500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291866",
                                        "name": "Waffle Cone - Chocolate",
                                        "price": 1800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291867",
                                        "name": "Waffle Cone Vanilla X 4",
                                        "price": 4800,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141409",
                                        "name": "Gulab Jamun (2 Pcs)",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142960169",
                                        "name": "Choco Chunk Cookie",
                                        "price": 13500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141408",
                                        "name": "Choco Lava Cake",
                                        "price": 11000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "136291865",
                                        "name": "Waffle Cone - Vanilla",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142141405",
                                        "name": "Haldiram's Carrot Halwa",
                                        "price": 11500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 12,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214423217",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "135725608",
                                        "name": "Wheat Crispies",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725670",
                                        "name": "Hot Fudge",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725620",
                                        "name": "Chocolate Chips",
                                        "price": 1200,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725675",
                                        "name": "Hot Fudge X 2",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725636",
                                        "name": "Chocolate Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725645",
                                        "name": "Chocolate Syrup X 4",
                                        "price": 8000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725680",
                                        "name": "Chocolate Syrup",
                                        "price": 2000,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725618",
                                        "name": "Marshmellows",
                                        "price": 2700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725609",
                                        "name": "Coloured Sprinkles",
                                        "price": 1200,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 9,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 41500,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "95515487"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172867272",
                                "name": "Cotton Candy Burst Gelato (Tub)",
                                "category": "Freshly Scooped Tubs",
                                "description": "Tri-coloured cotton candy gelato with popping candy! a burst of italian fun",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/12/20da142c-bd15-4526-8aaa-df0a2c2049bc_af864773-6b10-4583-bb9e-2402883fa6b2.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "60764654",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Hand scooped 700 ml - Serves 6-8",
                                          "default": 1,
                                          "id": "187900700",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 1 Ltr - Serves 8-10",
                                          "id": "187900701",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Hand scooped 500 ml - serves 4-5",
                                          "id": "209225401",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60764654",
                                          "variationId": "187900700"
                                        }
                                      ],
                                      "price": 63000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60764654",
                                          "variationId": "187900701"
                                        }
                                      ],
                                      "price": 88500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60764654",
                                          "variationId": "209225401"
                                        }
                                      ],
                                      "price": 45500
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 63000,
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "20% OFF",
                                    "subTitle": "USE SPECIALS",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "offerIds": [
                                  "3d484c76-c048-4f21-a980-c2d144e0a034"
                                ],
                                "parentId": "104317529"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/3b7ba148-dac3-4105-bc98-d29e356d855f_f1469773-cf7a-4cb0-aa3d-f2267fbefb8e.jpg",
                        "categoryId": "60869060"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Gifting And Sharing",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "122594913",
                                "name": "Variety Pack",
                                "category": "Gifting And Sharing",
                                "description": "The variety pack is a delightful assortment of 6 small ice cream scoops of your choice, perfect for sharing with friends and family. Share the scoops. Share the happyness!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/edb708b6-957d-4ff9-bf98-c5fd31bb8e6a_8dd63489-cf1e-4bd1-9fd9-cd9fd987a5d8.jpg",
                                "isVeg": 1,
                                "price": 52900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "214423235",
                                    "groupName": "Choose Your 1st Scoop",
                                    "choices": [
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725631",
                                        "name": "Butterscotch Ribbon Ice Cream Small Scoop",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "214423240",
                                    "groupName": "Choose Your 2nd Scoop",
                                    "choices": [
                                      {
                                        "id": "135725648",
                                        "name": "Butterscotch Ribbon Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "214423248",
                                    "groupName": "Choose Your 3rd Scoop",
                                    "choices": [
                                      {
                                        "id": "135725648",
                                        "name": "Butterscotch Ribbon Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "214423251",
                                    "groupName": "Choose Your 4th Scoop",
                                    "choices": [
                                      {
                                        "id": "135725648",
                                        "name": "Butterscotch Ribbon Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "214423253",
                                    "groupName": "Choose Your 5th Scoop",
                                    "choices": [
                                      {
                                        "id": "135725648",
                                        "name": "Butterscotch Ribbon Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "214423256",
                                    "groupName": "Choose Your 6th Scoop",
                                    "choices": [
                                      {
                                        "id": "135725648",
                                        "name": "Butterscotch Ribbon Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725614",
                                        "name": "Mississippi Mud Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725669",
                                        "name": "Fruit Overload Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725656",
                                        "name": "Three Cheers Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725629",
                                        "name": "Fresh Fruit Alphonso Mango Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "142515468",
                                        "name": "Biscoff Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "137345471",
                                        "name": "Banana 'N Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725661",
                                        "name": "Vanilla Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725677",
                                        "name": "Blueberry 'N White Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725643",
                                        "name": "Roasted Californian Almond Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725676",
                                        "name": "Bavarian Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725653",
                                        "name": "Fresh Very Berry Strawberry Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725664",
                                        "name": "Dutch Chocolate Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725630",
                                        "name": "Cotton Candy Ice Cream",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135725628",
                                        "name": "Fresh Tender Coconut Ice Cream",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "70463664"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114329102",
                                "name": "Mississippi Mud Ice Cream Rocks",
                                "category": "Gifting And Sharing",
                                "description": "16 delicious bite-sized mississippi mud chocolate ice cream coated with milk choco-dip and brownie crumble",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/3574bbca-738c-410e-83a7-6dfe77ce88b4_241ed341-2f83-4f69-9846-e2c15dfbca7c.jpg",
                                "isVeg": 1,
                                "price": 28381,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65784871"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114329099",
                                "name": "Cotton Candy Ice Cream Rocks",
                                "category": "Gifting And Sharing",
                                "description": "16 playful bite-sized cotton candy ice cream coated with raspberry flavoured white choco-dip",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/56b9dab3-4ef9-431e-81b4-2fad342c9562_6083abe1-4209-44ad-a224-0511485ddfb1.jpg",
                                "isVeg": 1,
                                "price": 28381,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65784869"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "168936603",
                                "name": "Hazelnut Rocher Ice Cream Rocks",
                                "category": "Gifting And Sharing",
                                "description": "16 creamy bite-sized vanilla ice cream coated with hazelnut flavored chocolate, roasted hazelnut pieces and wheat crispies pop the rock!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/e2f3428f-2de8-42d0-8d67-4b5a57a5b076_c71c855e-b4ee-41b3-a967-7f69da4331a8.jpg",
                                "isVeg": 1,
                                "price": 28381,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "81097929"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "138177765",
                                "name": "Caramel Biscuit Ice Cream Rocks",
                                "category": "Gifting And Sharing",
                                "description": "16 delicious bite-sized ice cream coated with white chocolate and biscoff cookie crumbs pop the rock!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/13/99c6171b-36c9-4f1d-9eae-a8beed1bd994_f624606c-30a6-442b-957b-02a5736bcf3f.jpg",
                                "isVeg": 1,
                                "price": 28381,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "81097927"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/edb708b6-957d-4ff9-bf98-c5fd31bb8e6a_8dd63489-cf1e-4bd1-9fd9-cd9fd987a5d8.jpg",
                        "categoryId": "62240802"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Value Scoops",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "174374341",
                                "name": "Alphonso Mango Ice Cream.",
                                "category": "Value Scoops",
                                "description": "Delicious alphonso mango based ice cream made with juicy, real mango pulp. Just go for this aam-azing mango ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/d7e6c557-73c8-4330-b4e4-e9fd8b053f61_2dd60aa2-11b5-4a9b-b356-2185201bbbbf.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "63353792",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "194129542",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "194129543",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "194129544",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353792",
                                          "variationId": "194129542"
                                        }
                                      ],
                                      "price": 9000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353792",
                                          "variationId": "194129543"
                                        }
                                      ],
                                      "price": 13200
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353792",
                                          "variationId": "194129544"
                                        }
                                      ],
                                      "price": 18000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 9000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28851799"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "174374336",
                                "name": "Vanilla Ice Cream.",
                                "category": "Value Scoops",
                                "description": "Not quite like a plain jane, this is a rich, dense vanilla ice cream that you'll recommend to friends. Seriously creamy, seriously tasty, a lot can happen over a vanilla ice cream! (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/fad04639-39ea-47d3-b2d7-c2a78847dadc_2e0f0769-8f4f-46af-9b23-15cceb402565.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "63353794",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "194129548",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "194129549",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "194129550",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353794",
                                          "variationId": "194129548"
                                        }
                                      ],
                                      "price": 7500
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353794",
                                          "variationId": "194129549"
                                        }
                                      ],
                                      "price": 11200
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353794",
                                          "variationId": "194129550"
                                        }
                                      ],
                                      "price": 15000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 7500,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28857227"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177786540",
                                "name": "Cotton Candy Ice Cream.",
                                "category": "Value Scoops",
                                "description": "Perky pink, purple and childhood coloured cotton candy flavoured ice cream. We're happy to let you know that we have fulfilled every child's wish of cotton candy ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/27/759d2ef8-3a8d-4068-a566-50def62201d3_cea90030-ce83-4840-bc01-6e010fefcd09.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "63353793",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "194129545",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "194129546",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "194129547",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353793",
                                          "variationId": "194129545"
                                        }
                                      ],
                                      "price": 11000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353793",
                                          "variationId": "194129546"
                                        }
                                      ],
                                      "price": 15700
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353793",
                                          "variationId": "194129547"
                                        }
                                      ],
                                      "price": 22000
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28853395"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "177786539",
                                "name": "Belgian Bliss Ice Cream.",
                                "category": "Value Scoops",
                                "description": "Rich chocolate ice cream with hidden treasures of dark chocolate cookies, hugged by a caramel ribbon. This delectable chocolate delight is like no other! sit back and enjoy this rich belgian bliss ice cream. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/ea5e7db7-9ea4-44b9-8c6c-146304fc1906_18db2f36-b978-4156-bda4-00a820cab242.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "63353791",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Small Scoop",
                                          "default": 1,
                                          "id": "194129539",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double Scoop",
                                          "id": "194129541",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Regular Scoop",
                                          "id": "194129540",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353791",
                                          "variationId": "194129539"
                                        }
                                      ],
                                      "price": 11000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353791",
                                          "variationId": "194129541"
                                        }
                                      ],
                                      "price": 22000
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "63353791",
                                          "variationId": "194129540"
                                        }
                                      ],
                                      "price": 15700
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28852180"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172035641",
                                "name": "Very Berry Strawberry Ice Cream.(small Scoop)",
                                "category": "Value Scoops",
                                "description": "Sublime strawberry ice cream with real strawberry pieces. This strawberry ice cream is a childhood favourite. Scrap that actually, it's an all time favourite. (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/00fa0872-5fa1-4921-99ef-04ba30d14886_acbb162f-df8f-43b4-a84e-eeb453789034.jpg",
                                "isVeg": 1,
                                "price": 7500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28857369"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172035642",
                                "name": "Vanilla Ice Cream.(small Scoop)",
                                "category": "Value Scoops",
                                "description": "Not quite like a plain jane, this is a rich, dense vanilla ice cream that you'll recommend to friends. Seriously creamy, seriously tasty, a lot can happen over a vanilla ice cream. (contains milk)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/16/fad04639-39ea-47d3-b2d7-c2a78847dadc_2e0f0769-8f4f-46af-9b23-15cceb402565.jpg",
                                "isVeg": 1,
                                "price": 7500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "88433693"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172035643",
                                "name": "Butterscotch Ribbon Ice Cream.(small Scoop)",
                                "category": "Value Scoops",
                                "description": "Vanilla ice cream swirled with butterscotch ribbon. This thick, sinful butterscotch ribbon will leave you going back for seconds. ",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/8ed5e70d-4191-4b7c-8cdb-0ed17c52cbf0_2bf78742-9533-46db-ad5e-192314edfd6f.jpg",
                                "isVeg": 1,
                                "price": 7500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "28852563"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "172035645",
                                "name": "Three Cheers Chocolate Ice Cream.(small Scoop)",
                                "category": "Value Scoops",
                                "description": "A heavenly combination of chocolate and vanilla married together with chocolate chips and ribbon. A feisty ribbon twirling its way through this chocolate chip loaded chocolate and vanilla ice cream scoop. This ice cream is as enticing as they come. (contains milk & soy)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/1/3b7ba148-dac3-4105-bc98-d29e356d855f_f1469773-cf7a-4cb0-aa3d-f2267fbefb8e.jpg",
                                "isVeg": 1,
                                "price": 7500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "88433692"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/13/d7e6c557-73c8-4330-b4e4-e9fd8b053f61_2dd60aa2-11b5-4a9b-b356-2185201bbbbf.jpg",
                        "categoryId": "63362205"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 21422010006426"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Baskin Robbins - Ice Cream Desserts",
                        "area": "Indrapuri",
                        "completeAddress": "Baskin Robbins, B11 Ground Floor, Raisen Road Indrapuri, Bhopal - 462021"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "2BvfMhIaXlOQ-GfzAwZD5si_f9qT7dn09IWXE4Eg"
  },

  "79807" :{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Sweet Truth - Cake and Desserts",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "975202",
              "name": "Sweet Truth - Cake and Desserts",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "sweet-truth-cake-and-desserts-housing-board-colony-bairagarh",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/12/30/0386bc7a-c3af-44c6-a802-81f54be312b2_975202.JPG",
              "locality": "Housing Board Colony",
              "areaName": "Kohefiza",
              "costForTwo": "45000",
              "costForTwoMessage": "₹450 for two",
              "cuisines": [
                "Desserts",
                "Ice Cream"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "975202",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "4444",
              "avgRatingString": "4.3",
              "totalRatingsString": "186 ratings",
              "sla": {
                "restaurantId": "975202",
                "deliveryTime": 22,
                "minDeliveryTime": 20,
                "maxDeliveryTime": 25,
                "lastMileTravel": 4.6,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3040,
                "slaString": "20-25 MINS",
                "lastMileTravelString": "4.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 149",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 149",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off | Use SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 149",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off up to ₹100 on select items | Use code SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "sweet-truth-cake-and-desserts-housing-board-colony-bairagarh",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "1st Floor, A/9, Main Road , Housing Board Colony , Kohefiza, Bhopal , ward No.7, Huzur, Bhopal, Madhya Pradesh-462001"
                },
                {
                  "title": "Cuisines",
                  "message": "Desserts,Ice Cream"
                }
              ],
              "logo": "Brand logo/SweetTruth",
              "totalRatings": 186,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 149",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 149",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off | Use SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 149",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "50% off up to ₹100 on select items | Use code SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 1,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 149
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/975202"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.26825046,77.37775968",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 4,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹149",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "bcac97d9-582b-4e08-9c73-6e2e9320573c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "975202",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SPECIALS",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "975202",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SPECIALS"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "566aa41a-c0f6-451c-b814-fa444d7360e1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹179",
                      "offerType": "offers",
                      "restId": "975202",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "975202",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "50% OFF"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7576947",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Plum Cake (250 gm).",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "188585917",
                              "name": "Plum Cake (250 gm).",
                              "category": "Newly Launched",
                              "description": "A rich, moist plum cake made with a generous blend of fruits and warm spices, baked slow for deep flavour in every bite. Comforting, timeless, and perfect for any moment that calls for something indulgent. (Energy: 1027KCal, Carbohydrates: 137gm, Proteins: 10gm, Fats: 48gm, Sodium: 762mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/e8ec016f-aae4-4dc1-881e-d463e9d9ae44_784aa893-a465-444b-958c-c6c08a1236fe.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "96051816"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7578342",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Plum Cake (100 gm).",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "188585916",
                              "name": "Plum Cake (100 gm).",
                              "category": "Newly Launched",
                              "description": "A soft, flavour-packed slice of classic plum cake rich with fruits, subtly spiced, and perfectly moist. Just the right treat when you want a little something special. (Energy: 349KCal, Carbohydrates: 46gm, Proteins: 3gm, Fats: 16gm, Sodium: 259mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/426d1ab2-4ce4-414b-bb9a-145b5b12c6df_ccd09052-04fc-4d99-9653-37ad859a8aca.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114642305"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7577327",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "Tiramisu Cake (500 gm)(Eggless)",
                          "description": "  ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "188585915",
                              "name": "Tiramisu Cake (500 gm)(Eggless)",
                              "category": "Newly Launched",
                              "description": "Coffee-soaked cake layered with cream and cocoa on top. A soft, melt-in-mouth Tiramisu experience. (Energy: 1491KCal, Carbohydrates: 237gm, Proteins: 19gm, Fats: 52gm, Sodium: 1244mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/153c7667-1454-40cf-a0b6-0fab0dcd4329_5082fc61-3f16-4436-b398-3bd389685c2b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "114642307"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585915",
                              "name": "Tiramisu Cake (500 gm)(Eggless)",
                              "category": "Newly Launched",
                              "description": "Coffee-soaked cake layered with cream and cocoa on top. A soft, melt-in-mouth Tiramisu experience. (Energy: 1491KCal, Carbohydrates: 237gm, Proteins: 19gm, Fats: 52gm, Sodium: 1244mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/153c7667-1454-40cf-a0b6-0fab0dcd4329_5082fc61-3f16-4436-b398-3bd389685c2b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "114642307"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188999851",
                              "name": "Rasmalai Cake (500 gm).",
                              "category": "Newly Launched",
                              "description": "Soft, spongy layers soaked in rasmalai goodness. A cake that is festive, fun, and unforgettable. (Energy: 1300KCal, Carbohydrates: 196gm, Proteins: 20gm, Fats: 50gm, Sodium: 703mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/d8f13381-6776-4e0b-85e3-61e909bf16ac_0dbd30bf-c590-487c-bef1-4e928cdc34a6.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "112338721"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184523171",
                              "name": "Rasmalai Mousse Jar..",
                              "category": "Newly Launched",
                              "description": "This festive season, indulge in a jar that layers the richness of rasmalai with the lightness of mousse. One spoon and it is pure festive fireworks! (Energy: 324KCal, Carbohydrates: 56gm, Proteins: 6gm, Fats: 8gm, Sodium: 202mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/bea00c06-bcd9-43bd-b191-3c818dd9fb67_1902dd6f-ea1d-4b06-a335-03bf94b411d1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111716809"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "180397060",
                              "name": "Tiramisu Cheesecake Slice.",
                              "category": "Newly Launched",
                              "description": "If coffee is your love language, this Tiramisu Cheesecake is about to be your new obsession. (Energy: 383KCal, Carbohydrates: 30gm, Proteins: 4gm, Fats: 27gm, Sodium: 306mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/16/11aaf7c8-8e01-42ff-ab3e-05ed99d70161_8381527c-646a-4af0-ba36-ca0a2f0345e0.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109390767"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "180397061",
                              "name": "Chocolate Cheesecake Slice.",
                              "category": "Newly Launched",
                              "description": "Cheesecake and chocolate lovers, 'tis one's specially for you! A match made for the season, sure to elevate every celebration.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/41c39c6d-1efa-4638-b1ea-07af6609a2ba_37c6423a-aadd-482e-ae4d-87966e2132c9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104955720"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585916",
                              "name": "Plum Cake (100 gm).",
                              "category": "Newly Launched",
                              "description": "A soft, flavour-packed slice of classic plum cake rich with fruits, subtly spiced, and perfectly moist. Just the right treat when you want a little something special. (Energy: 349KCal, Carbohydrates: 46gm, Proteins: 3gm, Fats: 16gm, Sodium: 259mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/426d1ab2-4ce4-414b-bb9a-145b5b12c6df_ccd09052-04fc-4d99-9653-37ad859a8aca.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114642305"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585917",
                              "name": "Plum Cake (250 gm).",
                              "category": "Newly Launched",
                              "description": "A rich, moist plum cake made with a generous blend of fruits and warm spices, baked slow for deep flavour in every bite. Comforting, timeless, and perfect for any moment that calls for something indulgent. (Energy: 1027KCal, Carbohydrates: 137gm, Proteins: 10gm, Fats: 48gm, Sodium: 762mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/e8ec016f-aae4-4dc1-881e-d463e9d9ae44_784aa893-a465-444b-958c-c6c08a1236fe.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "96051816"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852919",
                              "name": "Dutch Chocolate Truffle Cake (500 gm)",
                              "category": "Celebration Cakes",
                              "description": "(Eggless) Want to go classic for your celebration. What's better than a Chocolate Truffle Cake! This luscious, soft, moist Chocolate Cake is coated with a ganache made from Chocolate & Fresh Cream. (Energy: 1685KCal, Carbohydrates: 270gm, Proteins: 20gm, Fats: 58gm, Sodium: 1434mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/bba40c78-695b-4c32-b04d-6988154a4b78_6fce09f9-d113-44b7-8ad6-9f9d1deac655.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 57900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366572",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803191"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852926",
                              "name": "Chocolate Mousse Cake (Half Kg) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "This triple-layered delight is made of moist chocolate cake, airy chocolate mousse, and chocolate ganache, topped with delicious chocolate whipped cream. A must try for all chocolate cake lovers! (Energy: 1555KCal, Carbohydrates: 226gm, Proteins: 23gm, Fats: 59gm, Sodium: 998mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/1237017c-2509-4b74-9183-2e0233e164f9_aae88d31-00ff-4baf-9c10-2b25953a71f2.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366574",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "59422848"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852936",
                              "name": "Hazelnut Chocolate Cake (500 gm)",
                              "category": "Celebration Cakes",
                              "description": "Made with rich chocolate, and hazelnut, making it sinfully divine! This cake tastes as delicious as it looks and is sure to impress all! (Energy: 2020KCal, Carbohydrates: 213gm, Proteins: 24gm, Fats: 116gm)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/10bb01f9-f3e3-4a09-a663-f4f1abad9cb0_244a328e-4c73-489a-93e3-7bd6e55e6c44.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 69900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366576",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189342350",
                              "name": "Tiramisu Cake (500 gm) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "Coffee-soaked cake layered with cream and cocoa on top. A soft, melt-in-mouth Tiramisu experience. (Energy: 1491KCal, Carbohydrates: 237gm, Proteins: 19gm, Fats: 52gm, Sodium: 1244mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/15/3e51e7a7-4344-4ae2-8830-0db182f2740c_7454a187-5f71-4d94-9f60-6149d476ff51.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "262180895",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "114642307"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852968",
                              "name": "Rasmalai Cake (500 gm) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "Soft, spongy layers soaked in rasmalai goodness. A cake that is festive, fun, and unforgettable. (Energy: 1300KCal, Carbohydrates: 196gm, Proteins: 20gm, Fats: 50gm, Sodium: 703mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/f8f02cf7-c2a7-43a5-980f-4e1cc9994655_182f823a-f405-46c1-9adb-b2b854997d86.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261029137",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803230"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167434944",
                              "name": "Black Forest Cake (Half Kg) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "Chocolate cake soaks in cherry kirsch, layered with whipped cream & juicy cherries. Topped with chocolate shavings - Black Forest bliss! (Energy: 1339KCal, Carbohydrates: 195gm, Proteins: 35gm, Fats: 46gm, Sodium: 1040mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/e3c34247-ea7d-4ce0-baba-3ff95b9e7e8b_1ac5b6bc-3b5f-4dae-990c-ae9191cd4528.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "217207167",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803155"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852948",
                              "name": "Butterscotch Cake (500 gm)",
                              "category": "Celebration Cakes",
                              "description": "Soft vanilla sponge layered with the sweetness of butterscotch flavoured whipped cream is sure to bring your childhood memories back (Energy: 1505KCal, Carbohydrates: 209gm, Proteins: 123gm, Fats: 16gm, Sodium: 1265mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/4367a0d4-01b1-4ba1-a659-7601f05daddc_8f13b48f-60e1-4c8b-856b-40cce82b2783.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366578",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "58241312"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852953",
                              "name": "Pineapple Cake (500 gm) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "(Eggless) The evergreen Pineapple Cake with real juicy pineapple chunks and delicious cream, makes this one a delicious fit for all your special occasions! (Energy: 1200KCal, Carbohydrates: 247gm, Proteins: 10gm, Fats: 18gm, Sodium: 720mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/ad10de03-89ed-446c-8107-f3a95701987d_67350130-d39a-436b-a650-832a9418ffa6.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366579",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "106225034"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852961",
                              "name": "Red Velvet Cake (500 gm) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "(Eggless) Soft and rich Red Velvet Cake with luscious Cream Cheese and Whipped Cream Icing is sure to up your celebration. Coated with Red Velvet Crumbs makes this a treat to all your senses! (Energy: 1434KCal, Carbohydrates: 155gm, Proteins: 23gm, Fats: 79gm, Sodium: 1215mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/a2de31a3-350b-49d8-a375-fa67a7c268e3_831012bf-249f-416c-a90b-df403e51323f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 59900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366581",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "51436167"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852984",
                              "name": "Blueberry Cheesecake (500 gm) (Eggless)",
                              "category": "Celebration Cakes",
                              "description": "Rich, decadent, creamy cheesecake with a burst of blueberries makes for a delightful celebration cake. (Energy: 1613KCal, Carbohydrates: 103gm, Proteins: 34gm, Fats: 103gm, Sodium: 2695mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/fd61c935-0a5c-4bcc-905e-82229c795150_7f68cfc6-d90a-4ebe-b904-db9287c88a1e.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 79900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366585",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "73231525"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166852993",
                              "name": "Biscoff Cheesecake (500 gm)",
                              "category": "Celebration Cakes",
                              "description": "When a slice is not enough. This 500gm Biscoff cheesecake is rich and full of caramel flavour and cream cheese. If you are a Biscoff fan then this is definitely something you should get for all celebrations to get sweeter. (Energy: 1750KCal, Carbohydrates: 173gm, Proteins: 30gm, Fats: 104gm, Sodium: 830mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/d8e2be04-32cf-47c2-9df1-dd2d9aabd975_b344403b-7838-468c-874b-821c7abbbc0b.jpeg",
                              "inStock": 1,
                              "price": 84900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "211366586",
                                  "groupName": "Add Message on Cake (message will be written on Topper)",
                                  "choices": [
                                    {
                                      "id": "134877083",
                                      "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "134877200",
                                      "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140921267",
                                      "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "73555091"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837930",
                              "name": "2 Cheesecakes at 165 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Why stop at one!! Grab 2 luscious cheesecakes and double your joy.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/2d9d4517-55b7-49ba-8bbd-9ae951008cee_2e8c0458-7bcf-4d40-8dcb-4f6b0837a308.jpeg",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201095",
                                  "groupName": "Choose Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089276",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089245",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089227",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089235",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089256",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089225",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089273",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201096",
                                  "groupName": "Choose Second Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089261",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089173",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089168",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089209",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089268",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089212",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089174",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670201"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837929",
                              "name": "3 Cheesecakes at 160 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "One for now, one to share, one for later all at the price of no guilt.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/9e012da3-516a-49ae-aad8-dc881bfd66ee_2408a889-88cb-4adc-addb-d554cdb1365d.jpeg",
                              "inStock": 1,
                              "price": 47900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201089",
                                  "groupName": "Choose Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089276",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089245",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089227",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089235",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089256",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089225",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089273",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201091",
                                  "groupName": "Choose Second Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089261",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089173",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089168",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089209",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089268",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089212",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089174",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201092",
                                  "groupName": "Choose Third Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089244",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089226",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089202",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089216",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089270",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089183",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089250",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Newly Launched",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585915",
                              "name": "Tiramisu Cake (500 gm)(Eggless)",
                              "category": "Newly Launched",
                              "description": "Coffee-soaked cake layered with cream and cocoa on top. A soft, melt-in-mouth Tiramisu experience. (Energy: 1491KCal, Carbohydrates: 237gm, Proteins: 19gm, Fats: 52gm, Sodium: 1244mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/153c7667-1454-40cf-a0b6-0fab0dcd4329_5082fc61-3f16-4436-b398-3bd389685c2b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "114642307"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188999851",
                              "name": "Rasmalai Cake (500 gm).",
                              "category": "Newly Launched",
                              "description": "Soft, spongy layers soaked in rasmalai goodness. A cake that is festive, fun, and unforgettable. (Energy: 1300KCal, Carbohydrates: 196gm, Proteins: 20gm, Fats: 50gm, Sodium: 703mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/d8f13381-6776-4e0b-85e3-61e909bf16ac_0dbd30bf-c590-487c-bef1-4e928cdc34a6.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "112338721"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184523171",
                              "name": "Rasmalai Mousse Jar..",
                              "category": "Newly Launched",
                              "description": "This festive season, indulge in a jar that layers the richness of rasmalai with the lightness of mousse. One spoon and it is pure festive fireworks! (Energy: 324KCal, Carbohydrates: 56gm, Proteins: 6gm, Fats: 8gm, Sodium: 202mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/bea00c06-bcd9-43bd-b191-3c818dd9fb67_1902dd6f-ea1d-4b06-a335-03bf94b411d1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111716809"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "180397060",
                              "name": "Tiramisu Cheesecake Slice.",
                              "category": "Newly Launched",
                              "description": "If coffee is your love language, this Tiramisu Cheesecake is about to be your new obsession. (Energy: 383KCal, Carbohydrates: 30gm, Proteins: 4gm, Fats: 27gm, Sodium: 306mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/16/11aaf7c8-8e01-42ff-ab3e-05ed99d70161_8381527c-646a-4af0-ba36-ca0a2f0345e0.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "109390767"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "180397061",
                              "name": "Chocolate Cheesecake Slice.",
                              "category": "Newly Launched",
                              "description": "Cheesecake and chocolate lovers, 'tis one's specially for you! A match made for the season, sure to elevate every celebration.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/41c39c6d-1efa-4638-b1ea-07af6609a2ba_37c6423a-aadd-482e-ae4d-87966e2132c9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "104955720"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585916",
                              "name": "Plum Cake (100 gm).",
                              "category": "Newly Launched",
                              "description": "A soft, flavour-packed slice of classic plum cake rich with fruits, subtly spiced, and perfectly moist. Just the right treat when you want a little something special. (Energy: 349KCal, Carbohydrates: 46gm, Proteins: 3gm, Fats: 16gm, Sodium: 259mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/426d1ab2-4ce4-414b-bb9a-145b5b12c6df_ccd09052-04fc-4d99-9653-37ad859a8aca.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114642305"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188585917",
                              "name": "Plum Cake (250 gm).",
                              "category": "Newly Launched",
                              "description": "A rich, moist plum cake made with a generous blend of fruits and warm spices, baked slow for deep flavour in every bite. Comforting, timeless, and perfect for any moment that calls for something indulgent. (Energy: 1027KCal, Carbohydrates: 137gm, Proteins: 10gm, Fats: 48gm, Sodium: 762mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/12/e8ec016f-aae4-4dc1-881e-d463e9d9ae44_784aa893-a465-444b-958c-c6c08a1236fe.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "96051816"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/3/153c7667-1454-40cf-a0b6-0fab0dcd4329_5082fc61-3f16-4436-b398-3bd389685c2b.jpeg",
                      "categoryId": "65858503"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Celebration Cakes",
                      "categories": [
                        {
                          "title": "Chocolate Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852919",
                                  "name": "Dutch Chocolate Truffle Cake (500 gm)",
                                  "category": "Celebration Cakes",
                                  "description": "(Eggless) Want to go classic for your celebration. What's better than a Chocolate Truffle Cake! This luscious, soft, moist Chocolate Cake is coated with a ganache made from Chocolate & Fresh Cream. (Energy: 1685KCal, Carbohydrates: 270gm, Proteins: 20gm, Fats: 58gm, Sodium: 1434mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/bba40c78-695b-4c32-b04d-6988154a4b78_6fce09f9-d113-44b7-8ad6-9f9d1deac655.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 57900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366572",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "101803191"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852926",
                                  "name": "Chocolate Mousse Cake (Half Kg) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "This triple-layered delight is made of moist chocolate cake, airy chocolate mousse, and chocolate ganache, topped with delicious chocolate whipped cream. A must try for all chocolate cake lovers! (Energy: 1555KCal, Carbohydrates: 226gm, Proteins: 23gm, Fats: 59gm, Sodium: 998mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/1237017c-2509-4b74-9183-2e0233e164f9_aae88d31-00ff-4baf-9c10-2b25953a71f2.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 54900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366574",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "59422848"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852936",
                                  "name": "Hazelnut Chocolate Cake (500 gm)",
                                  "category": "Celebration Cakes",
                                  "description": "Made with rich chocolate, and hazelnut, making it sinfully divine! This cake tastes as delicious as it looks and is sure to impress all! (Energy: 2020KCal, Carbohydrates: 213gm, Proteins: 24gm, Fats: 116gm)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/10bb01f9-f3e3-4a09-a663-f4f1abad9cb0_244a328e-4c73-489a-93e3-7bd6e55e6c44.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 69900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366576",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "101803204"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "59902337"
                        },
                        {
                          "title": "Cream Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "189342350",
                                  "name": "Tiramisu Cake (500 gm) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "Coffee-soaked cake layered with cream and cocoa on top. A soft, melt-in-mouth Tiramisu experience. (Energy: 1491KCal, Carbohydrates: 237gm, Proteins: 19gm, Fats: 52gm, Sodium: 1244mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/15/3e51e7a7-4344-4ae2-8830-0db182f2740c_7454a187-5f71-4d94-9f60-6149d476ff51.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 64900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "262180895",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "114642307"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852968",
                                  "name": "Rasmalai Cake (500 gm) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "Soft, spongy layers soaked in rasmalai goodness. A cake that is festive, fun, and unforgettable. (Energy: 1300KCal, Carbohydrates: 196gm, Proteins: 20gm, Fats: 50gm, Sodium: 703mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/f8f02cf7-c2a7-43a5-980f-4e1cc9994655_182f823a-f405-46c1-9adb-b2b854997d86.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 64900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "261029137",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "101803230"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "167434944",
                                  "name": "Black Forest Cake (Half Kg) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "Chocolate cake soaks in cherry kirsch, layered with whipped cream & juicy cherries. Topped with chocolate shavings - Black Forest bliss! (Energy: 1339KCal, Carbohydrates: 195gm, Proteins: 35gm, Fats: 46gm, Sodium: 1040mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/e3c34247-ea7d-4ce0-baba-3ff95b9e7e8b_1ac5b6bc-3b5f-4dae-990c-ae9191cd4528.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "217207167",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "101803155"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852948",
                                  "name": "Butterscotch Cake (500 gm)",
                                  "category": "Celebration Cakes",
                                  "description": "Soft vanilla sponge layered with the sweetness of butterscotch flavoured whipped cream is sure to bring your childhood memories back (Energy: 1505KCal, Carbohydrates: 209gm, Proteins: 123gm, Fats: 16gm, Sodium: 1265mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/4367a0d4-01b1-4ba1-a659-7601f05daddc_8f13b48f-60e1-4c8b-856b-40cce82b2783.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366578",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "58241312"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852953",
                                  "name": "Pineapple Cake (500 gm) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "(Eggless) The evergreen Pineapple Cake with real juicy pineapple chunks and delicious cream, makes this one a delicious fit for all your special occasions! (Energy: 1200KCal, Carbohydrates: 247gm, Proteins: 10gm, Fats: 18gm, Sodium: 720mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/ad10de03-89ed-446c-8107-f3a95701987d_67350130-d39a-436b-a650-832a9418ffa6.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 54900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366579",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "106225034"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852961",
                                  "name": "Red Velvet Cake (500 gm) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "(Eggless) Soft and rich Red Velvet Cake with luscious Cream Cheese and Whipped Cream Icing is sure to up your celebration. Coated with Red Velvet Crumbs makes this a treat to all your senses! (Energy: 1434KCal, Carbohydrates: 155gm, Proteins: 23gm, Fats: 79gm, Sodium: 1215mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/a2de31a3-350b-49d8-a375-fa67a7c268e3_831012bf-249f-416c-a90b-df403e51323f.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 59900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366581",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "51436167"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "59902338"
                        },
                        {
                          "title": "Cheesecakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852984",
                                  "name": "Blueberry Cheesecake (500 gm) (Eggless)",
                                  "category": "Celebration Cakes",
                                  "description": "Rich, decadent, creamy cheesecake with a burst of blueberries makes for a delightful celebration cake. (Energy: 1613KCal, Carbohydrates: 103gm, Proteins: 34gm, Fats: 103gm, Sodium: 2695mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/fd61c935-0a5c-4bcc-905e-82229c795150_7f68cfc6-d90a-4ebe-b904-db9287c88a1e.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 79900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366585",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "73231525"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166852993",
                                  "name": "Biscoff Cheesecake (500 gm)",
                                  "category": "Celebration Cakes",
                                  "description": "When a slice is not enough. This 500gm Biscoff cheesecake is rich and full of caramel flavour and cream cheese. If you are a Biscoff fan then this is definitely something you should get for all celebrations to get sweeter. (Energy: 1750KCal, Carbohydrates: 173gm, Proteins: 30gm, Fats: 104gm, Sodium: 830mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/d8e2be04-32cf-47c2-9df1-dd2d9aabd975_b344403b-7838-468c-874b-821c7abbbc0b.jpeg",
                                  "inStock": 1,
                                  "price": 84900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "211366586",
                                      "groupName": "Add Message on Cake (message will be written on Topper)",
                                      "choices": [
                                        {
                                          "id": "134877083",
                                          "name": "Happy Birthday Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "134877200",
                                          "name": "Happy Anniversary Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "140921267",
                                          "name": "Add any message on Blank Paper Topper (add message in cooking instructions)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "50% OFF",
                                      "subTitle": "USE SPECIALS",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                                  ],
                                  "parentId": "73555091"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "59902339"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/bba40c78-695b-4c32-b04d-6988154a4b78_6fce09f9-d113-44b7-8ad6-9f9d1deac655.jpeg",
                      "categoryId": "59902323"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Heart of Every Celebration Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837930",
                              "name": "2 Cheesecakes at 165 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Why stop at one!! Grab 2 luscious cheesecakes and double your joy.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/2d9d4517-55b7-49ba-8bbd-9ae951008cee_2e8c0458-7bcf-4d40-8dcb-4f6b0837a308.jpeg",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201095",
                                  "groupName": "Choose Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089276",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089245",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089227",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089235",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089256",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089225",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089273",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201096",
                                  "groupName": "Choose Second Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089261",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089173",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089168",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089209",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089268",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089212",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089174",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670201"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837929",
                              "name": "3 Cheesecakes at 160 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "One for now, one to share, one for later all at the price of no guilt.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/9e012da3-516a-49ae-aad8-dc881bfd66ee_2408a889-88cb-4adc-addb-d554cdb1365d.jpeg",
                              "inStock": 1,
                              "price": 47900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201089",
                                  "groupName": "Choose Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089276",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089245",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089227",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089235",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089256",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089225",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089273",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201091",
                                  "groupName": "Choose Second Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089261",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089173",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089168",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089209",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089268",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089212",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089174",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201092",
                                  "groupName": "Choose Third Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089244",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089226",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089202",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089216",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089270",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089183",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089250",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837927",
                              "name": "4 Cheesecakes at 150 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Customize your cravings, get any 4 creamy cheesecakes of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/759eb2f0-c8bf-4806-bba7-e7b340bf4e84_660b75d2-7c9e-4325-8877-e70d9ae2a8f7.jpeg",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201084",
                                  "groupName": "Choose Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089276",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089245",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089227",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089235",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089256",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089225",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089273",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201085",
                                  "groupName": "Choose Second Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089261",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089173",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089168",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089209",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089268",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089212",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089174",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201086",
                                  "groupName": "Choose Third Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089244",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089226",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089202",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089216",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089270",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089183",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089250",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201087",
                                  "groupName": "Choose Fourth Cheesecake Slice",
                                  "choices": [
                                    {
                                      "id": "140089177",
                                      "name": "Chocolate Cheesecake Slice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089206",
                                      "name": "Tiramisu Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089264",
                                      "name": "Mango Cheesecake",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089196",
                                      "name": "Biscoff Cheesecake Slice",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089200",
                                      "name": "New York Cheesecake",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089232",
                                      "name": "Peanut Butter Cheesecake Slice",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089213",
                                      "name": "Blueberry Cheesecake",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670207"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837926",
                              "name": "2 Brownies at 95 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Sweetness 2x, because one brownie is never enough for your sweet cravings.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/0e52a01d-9b12-4596-bcee-2250c103f9e9_df8fcc46-57d1-43ca-b857-ca3910ca50c2.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201082",
                                  "groupName": "Choose Brownie",
                                  "choices": [
                                    {
                                      "id": "140089238",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089195",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089260",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201083",
                                  "groupName": "Choose Second Brownie",
                                  "choices": [
                                    {
                                      "id": "140089230",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089220",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089253",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670200"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837925",
                              "name": "4 Brownies at 90 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Your brownie binge pack, four irresistible treats for your cravings.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/7ebdb50a-bb91-450b-a166-64823ab73102_e0f1ce10-eef2-4f06-9e7e-7e57209993cb.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201078",
                                  "groupName": "Choose Brownie",
                                  "choices": [
                                    {
                                      "id": "140089238",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089195",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089260",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201079",
                                  "groupName": "Choose Second Brownie",
                                  "choices": [
                                    {
                                      "id": "140089230",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089220",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089253",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201080",
                                  "groupName": "Choose Third Brownie",
                                  "choices": [
                                    {
                                      "id": "140089266",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089237",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089262",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201081",
                                  "groupName": "Choose Fourth Brownie",
                                  "choices": [
                                    {
                                      "id": "140089192",
                                      "name": "Walnut Brownie",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089189",
                                      "name": "Choco Lava Cake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089166",
                                      "name": "Chocochip Brownie",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670206"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837924",
                              "name": "2 Pastries at 90 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Customize your cravings, choose your own pair of favourite pastries.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/4f2bc708-f842-4c77-a242-e55d2e01f7f2_499a5148-eeb9-415d-92b7-272236433f5d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201076",
                                  "groupName": "Choose Pastry",
                                  "choices": [
                                    {
                                      "id": "140089255",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089199",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089219",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089239",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201077",
                                  "groupName": "Choose Second Pastry",
                                  "choices": [
                                    {
                                      "id": "140089234",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089246",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089228",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089179",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670203"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837923",
                              "name": "3 Pastries at 83 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Why stop at one when you can have thrice the delight!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/b33859b2-8fe5-42ef-922b-808b15e8a5d4_f7f9ebaa-a68d-4589-a1d5-b7cf3027a01c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201073",
                                  "groupName": "Choose Pastry",
                                  "choices": [
                                    {
                                      "id": "140089255",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089199",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089219",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089239",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201074",
                                  "groupName": "Choose Second Pastry",
                                  "choices": [
                                    {
                                      "id": "140089234",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089246",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089228",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089179",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201075",
                                  "groupName": "Choose Third Pastry",
                                  "choices": [
                                    {
                                      "id": "140089193",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089165",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089214",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089229",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670205"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837922",
                              "name": "4 Pastries at 75 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Your pastry pack of four, because celebrations deserve a pastry party.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/1651dfea-9df5-4057-ba81-3d3be62e8c8e_e6c8963d-d207-4e3b-bc0c-6dea3e06a1ce.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201069",
                                  "groupName": "Choose Pastry",
                                  "choices": [
                                    {
                                      "id": "140089255",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089199",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089219",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089239",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201070",
                                  "groupName": "Choose Second Pastry",
                                  "choices": [
                                    {
                                      "id": "140089234",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089246",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089228",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089179",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201071",
                                  "groupName": "Choose Third Pastry",
                                  "choices": [
                                    {
                                      "id": "140089193",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089165",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089214",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089229",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201072",
                                  "groupName": "Choose Fourth Pastry",
                                  "choices": [
                                    {
                                      "id": "140089249",
                                      "name": "Black forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089242",
                                      "name": "Rich Red Velvet Pastry",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089167",
                                      "name": "Truffle Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089180",
                                      "name": "Choco chip Pastry",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670209"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837921",
                              "name": "2 Dessert Jars at 110 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "When the craving says this and your heart says that, take both jars.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/812dbbbc-3e69-4950-8593-49f472655611_ea3774b5-d39d-4cfb-b53f-8851b9db83a8.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201067",
                                  "groupName": "Choose Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089184",
                                      "name": "Red Velvet Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089277",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089203",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089223",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089171",
                                      "name": "Death by Chocolate Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089190",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089274",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201068",
                                  "groupName": "Choose Second Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089181",
                                      "name": "Red Velvet Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089252",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089164",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089208",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089217",
                                      "name": "Death by Chocolate Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089265",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089169",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670202"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183837920",
                              "name": "4 Dessert Jars at 100 each",
                              "category": "Heart of Every Celebration Combos",
                              "description": "Four jars is equals to one unforgettable dessert party.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/d71cdd3f-339b-40b4-868d-151f0f069519_da7a44d8-8096-419b-b28a-1e84a5144c99.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "246201063",
                                  "groupName": "Choose Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089184",
                                      "name": "Red Velvet Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089277",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089203",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089223",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089171",
                                      "name": "Death by Chocolate Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089190",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089274",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201064",
                                  "groupName": "Choose Second Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089181",
                                      "name": "Red Velvet Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089252",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089164",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089208",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089217",
                                      "name": "Death by Chocolate Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089265",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089169",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201065",
                                  "groupName": "Choose Third Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089258",
                                      "name": "Red Velvet Dessert Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089241",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089210",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089187",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089233",
                                      "name": "Death by Chocolate Cake Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089224",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089201",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "246201066",
                                  "groupName": "Choose Fourth Dessert Jar",
                                  "choices": [
                                    {
                                      "id": "140089269",
                                      "name": "Red Velvet Dessert Jar",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089197",
                                      "name": "Blueberry Cheesecake Jar",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089205",
                                      "name": "Choco Mud Jar",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089247",
                                      "name": "Triple Chocolate Mousse Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089172",
                                      "name": "Death by Chocolate Cake Jar",
                                      "price": 2000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089221",
                                      "name": "Hazelnut Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140089186",
                                      "name": "Biscoff Cheesecake Jar",
                                      "price": 6000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670208"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/2d9d4517-55b7-49ba-8bbd-9ae951008cee_2e8c0458-7bcf-4d40-8dcb-4f6b0837a308.jpeg",
                      "categoryId": "67444305"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cheesecake Slices",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853000",
                              "name": "Mango Cheesecake",
                              "category": "Cheesecake Slices",
                              "description": "This New York Style Mango Cheesecake, made with premium quality mango infused cream cheese with the perfect cracker crust is every dessert lovers delight! (Energy: 331KCal, Carbohydrates: 41gm, Proteins: 5gm, Fats: 16gm, Sodium: 382mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/611ed3ab-b2be-4898-a6dd-28fe35f917d5_30e9d3b9-4495-4f0f-91aa-9e1bf8308661.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "44968599"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853030",
                              "name": "Biscoff Cheesecake Slice",
                              "category": "Cheesecake Slices",
                              "description": "A Dreamy, Creamy & Caramelly affair! That's everything you get with every bite of this Delicious Biscoff Slice. (Energy: 420KCal, Carbohydrates: 42gm, Proteins: 7gm, Fats: 25gm, Sodium: 199mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/5daab977-ac59-4178-bd51-c9ed5c703986_0aab8735-8172-47f0-a81d-0f3ce9480ebe.jpeg",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "73555092"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "174776286",
                              "name": "Chocolate Cheesecake Slice",
                              "category": "Cheesecake Slices",
                              "description": "Cheesecake and chocolate lovers, 'tis one's specially for you! A match made for the season, sure to elevate every celebration.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/41c39c6d-1efa-4638-b1ea-07af6609a2ba_37c6423a-aadd-482e-ae4d-87966e2132c9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "bcac97d9-582b-4e08-9c73-6e2e9320573c"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "104955720"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "178061257",
                              "name": "Tiramisu Cheesecake",
                              "category": "Cheesecake Slices",
                              "description": "If coffee is your love language, this Tiramisu Cheesecake is about to be your new obsession. (Energy: 383KCal, Carbohydrates: 30gm, Proteins: 4gm, Fats: 27gm, Sodium: 306mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/16/11aaf7c8-8e01-42ff-ab3e-05ed99d70161_8381527c-646a-4af0-ba36-ca0a2f0345e0.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803240"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853039",
                              "name": "Biscoff Cheesecake Combo (Box of 2)",
                              "category": "Cheesecake Slices",
                              "description": "You get 2 Biscoff Cheesecakes which are dreamy, creamy, caramelly & just too yummy to stop at one. (Energy: 840KCal, Carbohydrates: 84gm, Proteins: 14gm, Fats: 50gm, Sodium: 398mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/3407243a-1402-40d1-b8d7-035d20ff6abd_6981b9a3-f15f-425f-a258-5f8e41c13878.jpeg",
                              "inStock": 1,
                              "price": 37900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803152"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853046",
                              "name": "Mango Cheesecake (Box of 2)",
                              "category": "Cheesecake Slices",
                              "description": "New York Style Mango Cheesecake but with the hint of delicious notes of mangoes, the perfect balance of sweet and tart! Indulge in not 1 but 2. (Energy: 662KCal, Carbohydrates: 82gm, Proteins: 10gm, Fats: 32gm, Sodium: 764mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/b7aa6848-a338-4e84-ae51-bda71b66a370_54c222fd-cfd8-425b-ac97-4add14e1aa3f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "44968600"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183832401",
                              "name": "Chocolate Cheesecake (Box of 2)",
                              "category": "Cheesecake Slices",
                              "description": "Creamy cheesecake layered with chocolatey goodness. Share one, save one.. or keep both for yourself.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/9cd846a2-4139-4729-a1f1-cbd8de13bfa0_5d1301e5-bf16-4030-94a1-7c41da710bad.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "111670210"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183832402",
                              "name": "Tiramisu Cheesecake (Box of 2)",
                              "category": "Cheesecake Slices",
                              "description": "Two slices of tiramisu cheesecake: perfect for sharing, even better for keeping. (Energy: 766KCal, Carbohydrates: 60gm, Proteins: 8gm, Fats: 54gm, Sodium: 612mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/ef1912e3-4e82-431e-9ff5-0f2bec88f714_7ae6db48-af1c-4391-b389-51e6de5d77d0.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "91306464"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/611ed3ab-b2be-4898-a6dd-28fe35f917d5_30e9d3b9-4495-4f0f-91aa-9e1bf8308661.jpeg",
                      "categoryId": "59902324"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert Jars",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853113",
                              "name": "Red Velvet Dessert Jar",
                              "category": "Dessert Jars",
                              "description": "Fluffy red velvet sponge cakes with perfectly sweet cream cheese frosting, layered in a mason jar. This dessert jar is worth the indulgence!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/139ec21e-f83f-407c-ac52-291e90a06aac_975b1aa0-69e7-4ae2-8bc8-a58d34da9e49.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "44968613"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "174776288",
                              "name": "Blueberry Cheesecake Jar",
                              "category": "Dessert Jars",
                              "description": "A graham cracker crust with tart cheesy layers topped with a dreamy blueberry coulis makes for a perfect blueberry cheesecake jar. (Energy: 374KCal, Carbohydrates: 40gm, Proteins: 3gm, Fats: 22gm, Sodium: 203mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/b3f94250-552d-46b7-9da3-52b770a58d73_78226ca9-6d1b-4d6f-bed1-93a8ff5affcc.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803158"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184175695",
                              "name": "Rasmalai Mousse Jar",
                              "category": "Dessert Jars",
                              "description": "This festive season, indulge in a jar that layers the richness of rasmalai with the lightness of mousse. One spoon and it is pure festive fireworks! (Energy: 324KCal, Carbohydrates: 56gm, Proteins: 6gm, Fats: 8gm, Sodium: 202mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/29/bea00c06-bcd9-43bd-b191-3c818dd9fb67_1902dd6f-ea1d-4b06-a335-03bf94b411d1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111716809"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "174776290",
                              "name": "Blueberry Cheesecake Jar (Pack of 2)",
                              "category": "Dessert Jars",
                              "description": "Indulge in the ultimate blueberry cheesecake experience in a jar with our pack of 2! Perfect for sharing, or not! (Energy: 748KCal, Carbohydrates: 80gm, Proteins: 6gm, Fats: 44gm, Sodium: 406mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/85e3dce1-a553-4b57-8ed7-ff555249db93_d2968111-87a5-43e9-bc3a-b9d501a7e04f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803159"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853149",
                              "name": "Red Velvet Dessert Jar (Pack of 2)",
                              "category": "Dessert Jars",
                              "description": "We got the goodness of the most loved pastry and cake together in a jar! Red Velvet is sure to set the mood right for you and your loved one.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/c3cf12c1-9230-49df-a298-21a24fe3683b_2a4fa2e1-6d6d-4f79-b48a-e9ddd409b71e.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803232"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/139ec21e-f83f-407c-ac52-291e90a06aac_975b1aa0-69e7-4ae2-8bc8-a58d34da9e49.jpeg",
                      "categoryId": "59902325"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pastries",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170078482",
                              "name": "Black forest Pastry",
                              "category": "Pastries",
                              "description": "Chocolate cake soaks in cherry kirsch, layered with whipped cream & juicy cherries. Topped with chocolate shavings - Black Forest bliss in a pastry size! (Energy: 241KCal, Carbohydrates: 35gm, Proteins: 6gm, Fats: 8gm, Sodium: 187mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/18/f8d40e9f-80a5-4018-a235-55beab246266_4b7123d4-dee5-436b-979e-85e0c0425be9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803156"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853174",
                              "name": "Rich Red Velvet Pastry",
                              "category": "Pastries",
                              "description": "Rich and moist Red Velvet cake layered with fresh cream cheese makes our Red Velvet pastry difficult to share. Youll think twice too.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/18/9e8d33ad-5223-4aba-b1f3-56fa975e845e_7094787b-a6f5-49e8-a848-f54c2b8221d5.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "44908515"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170078483",
                              "name": "Black Forest Pastry Combo (Box of 2)",
                              "category": "Pastries",
                              "description": "You get 2 Black Forest Pastries which is a chocolate lover's dream come true! (Energy: 482KCal, Carbohydrates: 70gm, Proteins: 12gm, Fats: 16gm, Sodium: 374mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/18/3bd749a3-2119-4329-a5b0-da7da7d09900_2ceb5220-722b-49f4-a906-022f2a7e0b67.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803157"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183832406",
                              "name": "Red Velvet Pastry (Pack of 2)",
                              "category": "Pastries",
                              "description": "Red velvet layered with creamy frosting, doubled up for double the smiles.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/3/81d453ff-a878-4554-b43f-6e3610cd1429_52444516-9230-4318-abfc-797af8dc689b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "111670214"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/18/f8d40e9f-80a5-4018-a235-55beab246266_4b7123d4-dee5-436b-979e-85e0c0425be9.jpeg",
                      "categoryId": "59902326"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Brownies & Lava Cakes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853339",
                              "name": "Walnut Brownie",
                              "category": "Brownies & Lava Cakes",
                              "description": "Our Walnut Brownie is the perfect combination of Chocolate & Crunch, featuring a dense, fudgy loaded with walnuts for a treat that's pure bliss.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/0fc56f4e-a274-414b-ab81-a39bcbfad2d3_08156731-9390-449a-835d-c0df05ab4625.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "84406831"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853347",
                              "name": "Choco Lava Cake",
                              "category": "Brownies & Lava Cakes",
                              "description": "A perfect match of Chocolate Cake on the outside and molten Chocolate on the inside, our Choco Lava cake is every dessert lovers dream come true.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/01eb23f9-3905-458f-aecb-38db4a407799_828a87a8-08cb-453b-89e3-d36a02e4213d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "45352261"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853364",
                              "name": "Walnut Brownie (Box of 2)",
                              "category": "Brownies & Lava Cakes",
                              "description": "Indulge in the rich flavors of our Walnut Brownie in a pack of 2! Brownie so dense, fudgy and loaded with crunchy walnuts, it's true perfection.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/a71d4a6f-984b-4f64-beef-620f5331f5db_999485de-83b7-4532-a9f2-7d64cd8708c1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "86273037"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853388",
                              "name": "Choco Lava Cake (Box Of 2)",
                              "category": "Brownies & Lava Cakes",
                              "description": "A perfect match between Chocolate Cake on the outside and melted gooey chocolate on the inside is an irresistible indulgence for 2.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/abe4b755-1d3b-4498-919f-e182bdc30654_71dbd050-9b49-4bac-a5a9-a485e40f1281.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "59422849"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/6/17/0fc56f4e-a274-414b-ab81-a39bcbfad2d3_08156731-9390-449a-835d-c0df05ab4625.jpeg",
                      "categoryId": "59902328"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188999852",
                              "name": "Jeera Masala Cola (250 ml)",
                              "category": "Beverages",
                              "description": "Experience a twisty take on the classic bubbly cola, infused with cumin that makes for a refreshing Jeera Masala Cola.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/b5176a91-e3ea-4b0b-9416-ae6b99ee2cc5_ac763d92-0525-498d-a1c7-60867ed49361.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "107826424"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853702",
                              "name": "Lemon Ice Tea (250 mL)",
                              "category": "Beverages",
                              "description": "117KCal, Carbs: 45g Sip on this refreshing drink for a citrusy lemon punch, infused with brewed tea. This iced tea is a perfect way to re-energize you anytime of the day!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/e3825774-d440-45d6-be5c-56f063075aa6_47f8fded-4676-4ed4-9686-04c29fb0d9d4.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "102309252"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853716",
                              "name": "Lemon Soda (250 mL)",
                              "category": "Beverages",
                              "description": "115KCal, Carbs: 27g, Sodium: 300mg. A refreshing drink made of Lemon Soda, sugar and a dash of salt. A delicious bubbling delight!\n",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/e90b7f5f-6500-4064-8638-1e93fd31ca76_62a26a2c-9bf4-42b7-b9d9-38fcddeea449.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "102309253"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853736",
                              "name": "Thums Up Can (330 mL)",
                              "category": "Beverages",
                              "description": "330 mL Thums Up Can (Energy: 145KCal, Carbohydrates: 36gm)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/dffe5813-1732-4828-a6d0-cc4aa93e1487_b8042f1f-c643-4ac1-a8e5-726c0a62e6e1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6650,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "102309256"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853748",
                              "name": "Coca Cola Bottle (475 mL)",
                              "category": "Beverages",
                              "description": "475 mL Coca Cola Bottle. (Energy: 209KCal, Carbohydrates: 52gm, Sodium: 40mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/74fe8967-82b8-4185-8f79-94fb8bc3ec31_2505aede-4b8f-4dca-9879-e9c7d968e6d6.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6650,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "46007094"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "167307532",
                              "name": "Coke Zero 330 ml Can",
                              "category": "Beverages",
                              "description": "0 KCal,. The iconic Coca-cola taste you love , now with zero sugar and zero calories! Crisp, refreshing, and full of flavor, it is the perfect guilt-free fizz to quench your thirst. (Sodium: 24mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/d6735cb7-1bbd-425a-9614-69acf7bca1fa_99cdcfb9-4e5b-4271-88a1-ecb7c28c6c22.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6650,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                }
                              ],
                              "parentId": "102309248"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853763",
                              "name": "Jeera Masala Soda (350 mL)",
                              "category": "Beverages",
                              "description": "123KCal, Proteins: 1g, Carbs: 28g. Aerated drink with the added zing of jeera and masala , a perfect accompaniment to your meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/52f5333e-9f6d-40a2-8513-3bceea6decbe_298edc4c-7a75-49d0-a88d-07514b95602b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "102309251"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853770",
                              "name": "Masala Lemonade (200 mL)",
                              "category": "Beverages",
                              "description": "94KCal , Carbs: 24g. A refreshing classic drink with combined goodness of fresh lime , himalayan pink salt & infused spices.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/23/6da6aaec-40b3-45ff-9f79-b071cd905b60_55641a06-fb9c-4ded-99c0-9c211dbb5d15.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "102309254"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/30/b5176a91-e3ea-4b0b-9416-ae6b99ee2cc5_ac763d92-0525-498d-a1c7-60867ed49361.jpeg",
                      "categoryId": "61180927"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Savoury Delights",
                      "categories": [
                        {
                          "title": "Snacks & More",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166853511",
                                  "name": "Pizza Puff (Pack of 2)",
                                  "category": "Savoury Delights",
                                  "description": "Snack-time just got cheesier! Munch on 2 yummy pizza pockets loaded with fresh veggies, diced cheddar mixed with zesty pizza sauce and let the partyy begin! (Energy: 223KCal, Carbohydrates: 24gm, Proteins: 4gm, Fats: 12gm, Sodium: 420mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/16/23984e21-e4fa-413a-a3e1-ad035271359a_689ceb00-c77e-457a-b734-24df595ccfd4.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "101803224"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166853517",
                                  "name": "Potato Wedges (Small)",
                                  "category": "Savoury Delights",
                                  "description": "When you don't know what to eat next, keep it simple! Indulge in our delicious potato wedges sprinkled with Teekha Chaska for that perfect flavour punch. (Energy: 118KCal, Carbohydrates: 14gm, Proteins: 2gm, Fats: 5gm, Sodium: 265mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/16/6bef02f0-ccef-4c13-8a22-9ccb1d2b08c9_fafe431e-8eb2-4501-b9d0-4d70637c504f.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "101803228"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166853522",
                                  "name": "Falafel Shots (6 pieces)",
                                  "category": "Savoury Delights",
                                  "description": "Mediterranean inspired crispy falafel- made from the finest soaked chickpeas and spices, served with a cheesy mayonnaise dip (Energy: 252KCal, Carbohydrates: 18gm, Proteins: 4gm, Fats: 17gm, Sodium: 508mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/8/5e67f89e-a14e-4bbc-bd0b-b442974f8e1c_c60cd5bd-8f32-4a02-a6cc-867f4f90b772.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "101803192"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166853528",
                                  "name": "Potato Chilli Shots with Mayo Dip",
                                  "category": "Savoury Delights",
                                  "description": "Crispy and spiced potato shots served with a cheesy mayonnaise dip to tantalize your tastebuds. (Energy: 370KCal, Carbohydrates: 31gm, Proteins: 2gm, Fats: 26gm, Sodium: 676mg)",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/16/85a9a6d8-a5a7-4cad-bd05-914ae71151e2_4ea98f65-945b-4c05-947c-41ad1a3fdd34.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "101803227"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "166853532",
                                  "name": "French Fries (Medium)",
                                  "category": "Savoury Delights",
                                  "description": "Just one can never be enough! Golden fried crunchy Fries that are salted to perfection. (Energy: 313KCal, Carbohydrates: 41gm, Proteins: 3gm, Fats: 14gm, Sodium: 406mg)",
                                  "imageId": "fc04fd7f94bbb86b1f7dd3479214d8fe",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "101803193"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "59902346"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/16/23984e21-e4fa-413a-a3e1-ad035271359a_689ceb00-c77e-457a-b734-24df595ccfd4.jpeg",
                      "categoryId": "59902330"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Indian Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853643",
                              "name": "Moong Dal Halwa (80 gm)",
                              "category": "Indian Desserts",
                              "description": "Add this rich & decadent Indian dessert made with moong lentils, ghee, milk, sugar, garnished with chopped dry-fruits. Perfect for one with Indian sweet cravings (Energy: 473KCal, Carbohydrates: 56gm, Proteins: 9gm, Fats: 23gm, Sodium: 200mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/1316fe9b-0f42-48d0-b989-fabbffb05c4c_5b7aca2c-84e4-484d-8dbc-c9cec50472d5.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803217"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853655",
                              "name": "Moong Dal Halwa (300gm)",
                              "category": "Indian Desserts",
                              "description": "Add this rich & decadent Indian dessert made with moong lentils, ghee, milk, sugar, garnished with chopped dry-fruits. Perfect for one with Indian sweet cravings. (Energy: 1391KCal, Carbohydrates: 167gm, Proteins: 26gm, Fats: 68gm, Sodium: 600mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/cc3bfbe8-f4b2-4ff9-abe0-99da8802425d_cf70e893-901c-4b83-8e30-e76d81af9d7c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101803216"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853666",
                              "name": "Gajar Halwa (80 gm)",
                              "category": "Indian Desserts",
                              "description": "Indulge in the comforting warmth of our aromatic Gajar Halwa, a classic Indian dessert crafted with freshly grated carrots, simmered in milk, ghee, and garnished with almonds, Perfect for one with Indian sweet cravings (Energy: 370KCal, Carbohydrates: 40gm, Proteins: 3gm, Fats: 21gm, Sodium: 245mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/9a0d561d-5543-47c2-bdfa-4c167eaaec5c_81d6315d-3575-4075-b667-82e46a0dc63c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "101549030"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853675",
                              "name": "Gajar Halwa (300 gm)",
                              "category": "Indian Desserts",
                              "description": "Satisfy your sweet tooth with our aromatic Gajar Halwa, a classic Indian dessert crafted with freshly grated carrots, simmered in milk, ghee, and garnished with almonds, Perfect for one with Indian sweet cravings. (Energy: 1099KCal, Carbohydrates: 120gm, Proteins: 10gm, Fats: 64gm, Sodium: 737mg)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/9a798fc4-d588-4019-8ed3-69af0a5f3648_38ea6f30-cdf6-4bd4-ad3d-a13543ae5b0a.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "94985087"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166853681",
                              "name": "Gulab Jamun Box (Pack of 10)",
                              "category": "Indian Desserts",
                              "description": "Gulab Jamun. Soft. Plump and the way we are used to. There is nothing else in our gulab jamuns than authenticity and love.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/7fe41d7b-5e3f-4fea-a909-276717d87b1b_bc26b216-a437-40d9-80d6-ed24c4b4b965.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "50% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "78b8768a-5ca7-4dca-b2bb-3277da0072ad"
                              ],
                              "parentId": "101803199"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/8/1316fe9b-0f42-48d0-b989-fabbffb05c4c_5b7aca2c-84e4-484d-8dbc-c9cec50472d5.jpeg",
                      "categoryId": "59902331"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11424010000665"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Sweet Truth - Cake and Desserts",
                      "area": "Kohefiza",
                      "completeAddress": "1st Floor, A/9, Main Road , Housing Board Colony , Kohefiza, Bhopal , ward No.7, Huzur, Bhopal, Madhya Pradesh-462001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "ERN6zyHLKzJh-vDN9B3vkbcCpqUcMGlB9yrarlCo"
},

  "79893": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Natural Ice Cream",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                },
                {
                  "id": "Dineout",
                  "title": "Dineout",
                  "cta": "https://swiggy.com/menu/79893/dineout"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "79893",
                "name": "Natural Ice Cream",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "natural-ice-cream-hansa-complex-test-bhopal",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/3/21/144f686e-493b-4139-9219-e6d8d3e4b7ae_79893.jpg",
                "locality": "Maharana Pratap Nagar",
                "areaName": "Maharana Pratap Nagar",
                "costForTwo": "15000",
                "costForTwoMessage": "₹150 for two",
                "cuisines": ["Ice Cream", "Desserts"],
                "avgRating": 4.8,
                "feeDetails": {
                  "restaurantId": "79893",
                  "fees": [{}]
                },
                "parentId": "2093",
                "avgRatingString": "4.8",
                "totalRatingsString": "5.5K+ ratings",
                "sla": {
                  "restaurantId": "79893",
                  "deliveryTime": 33,
                  "minDeliveryTime": 30,
                  "maxDeliveryTime": 35,
                  "lastMileTravel": 5,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                  "zoneId": 698,
                  "slaString": "30-35 MINS",
                  "lastMileTravelString": "5.0 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextOpenTimeMessage": "Opens next at 11 am, today",
                  "nextOpenTime": "2026-01-06 11:00:00",
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "Flat ₹400 off",
                  "shortDescriptionList": [
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "20% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "20% off up to ₹50 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "natural-ice-cream-hansa-complex-test-bhopal",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Hansa Complex, 190, Service Road, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh- 462011"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Ice Cream,Desserts"
                  }
                ],
                "totalRatings": 5500,
                "aggregatedDiscountInfoV2": {
                  "header": "Flat ₹400 off",
                  "shortDescriptionList": [
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "20% off | Use TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Flat ₹400 off | Use FLAT400",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "20% off up to ₹50 | Use code TRYNEW",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "minValue": 2799,
                    "maxValue": 3999,
                    "priority": 1,
                    "couponCode": "FLAT400",
                    "discountInfo": {
                      "discountType": "Flat",
                      "value": 400
                    },
                    "lockedMessage": "Add items worth ₹\u003Camount\u003E to save ₹400 | Code FLAT400",
                    "unlockedMessage": "FLAT400 Coupon Unlocked! Use it to save ₹400",
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/79893"
                },
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 11 am, today",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:00 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.232143,77.43315899999993",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 4,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "FLAT ₹400 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["b8144163-d768-4002-ac31-d0a985382484"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT400",
                        "description": "ABOVE ₹3999",
                        "offerType": "offers",
                        "restId": "79893",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT400"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "20% OFF UPTO ₹50",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["707ff7fe-c0b6-4765-85c0-71e451a8ed3e"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE TRYNEW",
                        "description": "ABOVE ₹199",
                        "offerType": "offers",
                        "restId": "79893",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE TRYNEW"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "79893",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹500 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["2980e288-36ca-4583-9e41-1f21cf43104d"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT500",
                        "description": "ABOVE ₹4999",
                        "offerType": "offers",
                        "restId": "79893",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT500"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "No Added Sugar",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "113002024",
                                "name": "Mango (Medium Fat Ice Cream, No Added Sugar)",
                                "category": "No Added Sugar",
                                "description": "Serves 1 | Energy (Kcal) :- 143,\nCarbohydrate (g):- 19,\nProtein (g):- 3,\nFats (g):- 4,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/27/c248d22c-d2c8-4d1e-a69b-de7ca1fb830e_daa0a367-b47e-42d5-b216-d58f2706f943.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "25676522",
                                      "name": "Option",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 84.85,
                                          "default": 1,
                                          "id": "121235780",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 159.24,
                                          "id": "81424675",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "25676522",
                                          "variationId": "121235780"
                                        }
                                      ],
                                      "price": 8485,
                                      "addonCombinations": [
                                        {
                                          "groupId": "87119291",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "25676522",
                                          "variationId": "81424675"
                                        }
                                      ],
                                      "price": 15924,
                                      "addonCombinations": [
                                        {
                                          "groupId": "87119291",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "87119291",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 8485,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                  }
                                ],
                                "parentId": "62117753"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/1/27/c248d22c-d2c8-4d1e-a69b-de7ca1fb830e_daa0a367-b47e-42d5-b216-d58f2706f943.jpg",
                        "categoryId": "33022629"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Friday Funday Flavour (New Attraction)",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62929241",
                                "name": "Raspberry Chocolate Ice Cream",
                                "category": "Friday Funday Flavour (New Attraction)",
                                "description": "Serves 1 | Treat yourself and your loved ones to this lusciously original flavour. Raspberry comes all the way from Serbia to make this special flavour. Chocolate chunks are also added so you relish this one with all your heart!\n\nEnergy (Kcal) :- 191,\nCarbohydrate (g):- 24,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "c1b5d08bf2cf9ff2aaf206115272e6df",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "67698570",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "203606974",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "203606975",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "203606976",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698570",
                                          "variationId": "203606974"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038557",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698570",
                                          "variationId": "203606975"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038557",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698570",
                                          "variationId": "203606976"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038558",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "250038558",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "250038558",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "250038558",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "250038557",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "250038558",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253684"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "98955933",
                                "name": "@ Gajar Halwa Ice Cream",
                                "category": "Friday Funday Flavour (New Attraction)",
                                "description": "Serves 1 | Energy (Kcal) :- 183,\nCarbohydrate (g):- 15,\nProtein (g):- 4,\nFats (g):- 10,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "e73ce1b721680cdc61346d63698a7ee8",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "68812880",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "206114877",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "206114878",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "206114879",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68812880",
                                          "variationId": "206114877"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "258206749",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68812880",
                                          "variationId": "206114878"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "258206749",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68812880",
                                          "variationId": "206114879"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "258206750",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "258206750",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "258206750",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "258206750",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "258206749",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "258206750",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252972"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "107478089",
                                "name": "Persian Delight Ice Cream",
                                "category": "Friday Funday Flavour (New Attraction)",
                                "description": "Serves 1 | If there’s one word that best describes this sumptuous delicacy, it is ‘exotic’.  Flavours of the East such as Pista, Dates, Cinnamon and Honey mingle together in this utterly blissful treat!\n\nEnergy (Kcal) :- 188,\nCarbohydrate (g):- 21,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/3/7d66ab90-22e7-4422-8591-90c9818d0571_73ab89eb-ef89-420b-b1aa-0f6fa64ff909.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69293970",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "207286223",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "207286224",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "207286225",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293970",
                                          "variationId": "207286223"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481070",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293970",
                                          "variationId": "207286224"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481070",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293970",
                                          "variationId": "207286225"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481071",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "261481071",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "261481071",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "261481071",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "261481070",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261481071",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253619"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "120901239",
                                "name": "@ Rose Walnut Ice Cream",
                                "category": "Friday Funday Flavour (New Attraction)",
                                "description": "Serves 1 | An exotic dessert made from Rose Petals sourced from Rajasthan. Roasted walnuts add to the rich and heavenly taste. This treat is a perfect reward after a long day at work!\n\nEnergy (Kcal) :- 208,\nCarbohydrate (g):- 31,\nProtein (g):- 4,\nFats (g):- 7,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/3/9111a729-69bf-447c-9007-ac2f02fa2593_ae76f617-77bd-429c-90f8-5abe0ceb4aa4.jpg",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "68388181",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "205236530",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "205236531",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "205236532",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68388181",
                                          "variationId": "205236530"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "254094792",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68388181",
                                          "variationId": "205236531"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "254094792",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "68388181",
                                          "variationId": "205236532"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "254094794",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "254094794",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "254094794",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "254094794",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "254094792",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "254094794",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "72 ratings",
                                    "ratingCountV2": "72"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "69246991"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "c1b5d08bf2cf9ff2aaf206115272e6df",
                        "categoryId": "22109410"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Seasonal",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238500",
                                "name": "Sitaphal Ice Cream",
                                "category": "Seasonal",
                                "description": "Serves 1 | Made with the finest Sitaphals from Saswad, Maharashtra, this iconic flavour is a nationwide favourite. Naturals uses innovative, self-engineered machines to pulp Sitaphal, ensuring every scoop is as delicious as the fruit itself.\nEnergy (Kcal) :- 155,\nCarbohydrate (g):- 20,\nProtein (g):- 3,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "1b654ff7a6b7a47d802757094517fdfa",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "62992209",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "193284381",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "193284382",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "193284384",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "193284383",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62992209",
                                          "variationId": "193284381"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "232143465",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62992209",
                                          "variationId": "193284382"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "232143465",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62992209",
                                          "variationId": "193284383"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "62992209",
                                          "variationId": "193284384"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "232143466",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "232143465",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "232143466",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "562 ratings",
                                    "ratingCountV2": "562"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253807"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238504",
                                "name": "Mango (Medium Fat) Ice Cream",
                                "category": "Seasonal",
                                "description": "Serves 1 | We’ve taken the king of fruits and created an ice cream flavour that rules! Our mango ice cream is made from hand-picked Alphonso mangoes sourced from Ratnagiri. This flavour is every mango lover’s fantasy come true.\n\nEnergy (Kcal) :- 149,\nCarbohydrate (g):- 16,\nProtein (g):- 4,\nFats (g):- 6,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person\n\n\n\n\n \n\n\n\n\n",
                                "imageId": "dbb46aa1f3ff504c27cf70c78b0f0091",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567709",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235801",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034364",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034365",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034366",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567709",
                                          "variationId": "121235801"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304823",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567709",
                                          "variationId": "38034364"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304823",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567709",
                                          "variationId": "38034365"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567709",
                                          "variationId": "38034366"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304822",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304823",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304822",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "652 ratings",
                                    "ratingCountV2": "652"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "60405854"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "62929226",
                                "name": "Strawberry Ice Cream",
                                "category": "Seasonal",
                                "description": "Serves 1 | This much loved flavour from Naturals owes its taste to fresh strawberries from Mahabaleshwar. And if you taste it once, you’re bound to get hooked!\n\nEnergy (Kcal) :- 156,\nCarbohydrate (g):- 15,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "be5a2a6e2a03f446b669d0e81b3621b7",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69293969",
                                      "name": "Choose Size Strawberry.",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "207286219",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "207286220",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "207286222",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "207286221",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293969",
                                          "variationId": "207286219"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481068",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293969",
                                          "variationId": "207286220"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481068",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293969",
                                          "variationId": "207286221"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293969",
                                          "variationId": "207286222"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "261481069",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "261481068",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261481069",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "47 ratings",
                                    "ratingCountV2": "47"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253856"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64205677",
                                "name": "Guava Ice Cream",
                                "category": "Seasonal",
                                "description": "Serves 1 | Take a trip down memory lane with our original Guava ice cream, made from Allahabadi pink guavas. It’s that unforgettable taste that will remind you of childhood’s most adored flavour!\n\nEnergy (Kcal) :- 160,\nCarbohydrate (g):- 16,\nProtein (g):- 3,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "501706b8a9de8962560fb8243144cf4d",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69293971",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "207286226",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "207286227",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "207286228",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293971",
                                          "variationId": "207286226"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481072",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293971",
                                          "variationId": "207286227"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481072",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69293971",
                                          "variationId": "207286228"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "261481073",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "261481073",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "261481073",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "261481073",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "261481072",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261481073",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253017"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "79472656",
                                "name": "Black Grapes (Medium Fat) Ice Cream",
                                "category": "Seasonal",
                                "description": "Serves 1 | Expect a taste of heaven in every bite of our original Black Grapes ice cream. It’s amazing taste will leave you craving for more!\n\nEnergy (Kcal) :- 162,\nCarbohydrate (g):- 18,\nProtein (g):- 4,\nFats (g):- 7,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "a560e9340c3bd4de0c87ce56d2767520",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "67698571",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "203606977",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "203606978",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "203606979",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698571",
                                          "variationId": "203606977"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038559",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698571",
                                          "variationId": "203606978"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038559",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "67698571",
                                          "variationId": "203606979"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "250038560",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "250038560",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "250038560",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "250038560",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "250038559",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "250038560",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "60405852"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "1b654ff7a6b7a47d802757094517fdfa",
                        "categoryId": "21944193"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Round The Year",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238506",
                                "name": "Tender Coconut Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | An original Naturals creation, Tender Coconut ice cream is a creamy delight made with real malai from coconuts sourced from Kerala and Karnataka. Its natural, tropical sweetness makes it a must-try for every ice cream lover.\nEnergy (Kcal) :- 167,\nCarbohydrate (g):- 15,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "6cd8778cf0c95e12108d06eac5c8288f",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567682",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235691",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034271",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034272",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034273",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567682",
                                          "variationId": "121235691"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "77285400",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567682",
                                          "variationId": "38034271"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "77285400",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567682",
                                          "variationId": "38034272"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567682",
                                          "variationId": "38034273"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304801",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "77285400",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304801",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "1268 ratings",
                                    "ratingCountV2": "1.3K+"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253912"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238499",
                                "name": "Roasted Almond Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | The almonds are sourced from California. But the inimitable taste of this delicious flavour is our very own! As the name suggests, the almonds are roasted and that’s how they lend a crispy and chunky feel to the ice cream. Indulgence, anyone?\n\nEnergy (Kcal) :- 191,\nCarbohydrate (g):- 16,\nProtein (g):- 6,\nFats (g):- 10,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "6adb6d1ee1571542b377f745de410054",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567684",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235703",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034278",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034279",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034280",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567684",
                                          "variationId": "121235703"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304803",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567684",
                                          "variationId": "38034278"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304803",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567684",
                                          "variationId": "38034279"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567684",
                                          "variationId": "38034280"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304802",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304803",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304802",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "327 ratings",
                                    "ratingCountV2": "327"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253716"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238497",
                                "name": "Chocobite Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Have a weakness for chocolate? Then you’ll fall in love with our original Choco Bite ice cream. It’s made from coco mass sourced from Ghana. You’ll even find hand-cut chocolate chunks in this flavour, making it truly hard to resist.\n\nEnergy (Kcal) :- 200,\nCarbohydrate (g):- 17,\nProtein (g):- 4,\nFats (g):- 11,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "63f60e028f241425fcb1e6a44bf2c840",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567695",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235686",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034317",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034320",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034321",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567695",
                                          "variationId": "121235686"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304815",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567695",
                                          "variationId": "38034317"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304815",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567695",
                                          "variationId": "38034320"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567695",
                                          "variationId": "38034321"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304814",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304815",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304814",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "423 ratings",
                                    "ratingCountV2": "423"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252741"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238498",
                                "name": "Kaju Kismis Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Good news for cashew connoisseurs who also love kismis. Our Kaju Kismis ice cream is just the thing your taste buds desire!\n\nEnergy (Kcal) :- 184,\nCarbohydrate (g):- 17,\nProtein (g):- 5,\nFats (g):- 9,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "169808e5716cf9a05868419e6b9801e4",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567686",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235769",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034285",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034287",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567686",
                                          "variationId": "121235769"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304805",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567686",
                                          "variationId": "38034285"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304805",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567686",
                                          "variationId": "38034287"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304804",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304804",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304804",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304804",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304805",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304804",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "71 ratings",
                                    "ratingCountV2": "71"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253145"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238502",
                                "name": "Coffee Walnut Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Coffee comes together with roasted walnuts to give you this unique flavour. It’s taste will stay with you long after the scoop has disappeared from your cup.\n\nEnergy (Kcal) :- 198,\nCarbohydrate (g):- 20,\nProtein (g):- 6,\nFats (g):- 9,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "9848f661e2c1cbb27304b44140fbfb26",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567707",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235716",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034357",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034358",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034359",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567707",
                                          "variationId": "121235716"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304821",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567707",
                                          "variationId": "38034357"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304821",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567707",
                                          "variationId": "38034358"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567707",
                                          "variationId": "38034359"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304820",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304821",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304820",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "293 ratings",
                                    "ratingCountV2": "293"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252861"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238507",
                                "name": "Chickoo Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Say hello to this sweet temptation! Our mouth-watering chickoo ice cream is made from chickoos sourced from Gholvad, Maharashtra. Try it for yourself today and you’ll be a chickoo ice cream fan in no time!\n\nEnergy (Kcal) :- 167,\nCarbohydrate (g):- 15,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "a3ca176bc647bc970c687971d20b3478",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "58262385",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "180799839",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "180799840",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "180799841",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58262385",
                                          "variationId": "180799839"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214207763",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58262385",
                                          "variationId": "180799840"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214207763",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "58262385",
                                          "variationId": "180799841"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "214207764",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "214207764",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "214207764",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "214207764",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "214207763",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "214207764",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "197 ratings",
                                    "ratingCountV2": "197"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252632"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238510",
                                "name": "Anjeer Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Discover the subtle sweetness of dry figs in our original Anjeer ice cream. Figs sourced from Afghanistan lend their unique taste to this delicious flavour.\n\nEnergy (Kcal) :- 183,\nCarbohydrate (g):- 16,\nProtein (g):- 4,\nFats (g):- 9,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "1b9e3130d79765753d436cfcec51abb2",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567699",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235809",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034328",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034330",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567699",
                                          "variationId": "121235809"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304817",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567699",
                                          "variationId": "38034328"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304817",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567699",
                                          "variationId": "38034330"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304816",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304816",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304816",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304816",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304817",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304816",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "264 ratings",
                                    "ratingCountV2": "264"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252448"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "59238511",
                                "name": "Malai Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Simple yet magical, Malai ice cream is made with just milk and sugar for a creamy, timeless experience. Perfect on its own or as a base for sundaes and other desserts, it’s always a hit.\nEnergy (Kcal) :- 220,\nCarbohydrate (g):- 16,\nProtein (g):- 5,\nFats (g):- 13,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "43654617aec2c77a7aad579263bef835",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567693",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235731",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034310",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034311",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567693",
                                          "variationId": "121235731"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304813",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567693",
                                          "variationId": "38034310"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304813",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567693",
                                          "variationId": "38034311"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304812",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304812",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304812",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304812",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304813",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304812",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "188 ratings",
                                    "ratingCountV2": "188"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253302"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "76273346",
                                "name": "Kesar Pista Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Looking for a royal flavour to pamper yourself with? Look no further. Our Kesar Pista ice cream has Kesar from Kashmir and Pista from Iran. Time to give your ice cream cravings an exotic touch!\n\nEnergy (Kcal) :- 217,\nCarbohydrate (g):- 17,\nProtein (g):- 4,\nFats (g):- 13,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "7a6095bca9c7d3736429cd26a19bf8c0",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "11567690",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "121235777",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "38034300",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "38034302",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "38034304",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567690",
                                          "variationId": "121235777"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304809",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567690",
                                          "variationId": "38034300"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304809",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567690",
                                          "variationId": "38034302"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "11567690",
                                          "variationId": "38034304"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "78304808",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "78304809",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "78304808",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "304 ratings",
                                    "ratingCountV2": "304"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17253217"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "76273347",
                                "name": "Choco cream Ice Cream",
                                "category": "Round The Year",
                                "description": "Serves 1 | Choco Cream is pure indulgence for chocolate lovers, crafted with premium cocoa mass from Ghana. Whether enjoyed solo or shared, its rich, creamy taste is guaranteed to leave you craving more.\nEnergy (Kcal) :- 174,\nCarbohydrate (g):- 16,\nProtein (g):- 4,\nFats (g):- 8,\nAllergen Declaration:- May contain: Brazilnuts, Cashew, Hazelnuts, Pecans, Pistachio, Walnut, Peanut & Milk,\nServing size : 80 gm per person",
                                "imageId": "6160360502a4585f9ce4b032c5e3d908",
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "47175838",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Single scoop cup",
                                          "price": 79.62,
                                          "default": 1,
                                          "id": "149421365",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Double scoop cup",
                                          "price": 149.82,
                                          "id": "149421366",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Mini Pack 300 grams",
                                          "price": 298.56,
                                          "id": "149421367",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Family Pack 500 grams",
                                          "price": 397.06,
                                          "id": "149421368",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "47175838",
                                          "variationId": "149421365"
                                        }
                                      ],
                                      "price": 7962,
                                      "addonCombinations": [
                                        {
                                          "groupId": "171929092",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "47175838",
                                          "variationId": "149421366"
                                        }
                                      ],
                                      "price": 14982,
                                      "addonCombinations": [
                                        {
                                          "groupId": "171929092",
                                          "addonId": "62360687"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "47175838",
                                          "variationId": "149421367"
                                        }
                                      ],
                                      "price": 29856,
                                      "addonCombinations": [
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "47175838",
                                          "variationId": "149421368"
                                        }
                                      ],
                                      "price": 39706,
                                      "addonCombinations": [
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186482"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186483"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "63186484"
                                        },
                                        {
                                          "groupId": "171929093",
                                          "addonId": "127069793"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "171929092",
                                    "groupName": "Waffle Cone",
                                    "choices": [
                                      {
                                        "id": "62360687",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "171929093",
                                    "groupName": "Waffle Cone pack",
                                    "choices": [
                                      {
                                        "id": "63186482",
                                        "name": "Waffle Cone Pack of 2",
                                        "price": 1886,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186483",
                                        "name": "Waffle Cone Pack of 4",
                                        "price": 3771,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "63186484",
                                        "name": "Waffle Cone Pack of 6",
                                        "price": 5656,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "127069793",
                                        "name": "Waffle cone",
                                        "price": 944,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 7962,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "162 ratings",
                                    "ratingCountV2": "162"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "17252774"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "6cd8778cf0c95e12108d06eac5c8288f",
                        "categoryId": "16948224"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Combo",
                        "categories": [
                          {
                            "title": "Mini pack combo",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "76273365",
                                    "name": "Best of Three Worlds Mini Pack Combo",
                                    "category": "Combo",
                                    "description": "Serves 1",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/fa4201e8-00ea-44f6-b46d-d5f8bad89e03_6cce6525-12e1-4139-b5ac-f5e864bfd72e.jpg",
                                    "isVeg": 1,
                                    "price": 79306,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "48902794",
                                        "groupName": "Best of three world Mini Pack Combo",
                                        "choices": [
                                          {
                                            "id": "35769508",
                                            "name": "Chocobite Ice Cream Mini Pack",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "35769510",
                                            "name": "Roasted Almond Ice Cream Mini Pack",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "35769512",
                                            "name": "Tender Coconut Ice Cream Mini Pack",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1,
                                        "minAddons": 3
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "17252496"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "16948227"
                          },
                          {
                            "title": "Scoop combo",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "102370493",
                                    "name": "Choice of Double scoop",
                                    "category": "Combo",
                                    "description": "Serves 1",
                                    "imageId": "b1yds8fo5m69xubfdh3v",
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "43234791",
                                          "name": "Choose Your First Flavour",
                                          "variations": [
                                            {
                                              "name": "Anjeer (Medium Fat Ice Cream, No Added Sugar) Single Scoop",
                                              "price": 155.06,
                                              "id": "137787795",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Mango (Medium Fat Ice Cream, No Added Sugar) Single Scoop",
                                              "price": 155.06,
                                              "id": "137787796",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "@ Gajar Halwa Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "default": 1,
                                              "id": "206114870",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "@ Rose Walnut Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "205236522",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Anjeer Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787798",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Black Grapes (Medium Fat) Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "203606970",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Chickoo Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "180799806",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Choco Cream Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "149421352",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Chocobite Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787800",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Coffee Walnut Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787801",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Guava Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "207286210",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Kaju Kismis Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787802",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Kesar Pista Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787803",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Malai Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787804",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Mango (Medium Fat) Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787806",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Persian Delight Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "207286211",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Raspberry Chocolate Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "203606971",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Roasted Almond Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787813",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Sitaphal Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "193284368",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Strawberry Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "207286212",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            },
                                            {
                                              "name": "Tender Coconut Ice Cream Single Scoop",
                                              "price": 149.82,
                                              "id": "137787816",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234792",
                                                "variationId": "206114871"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "43234792",
                                          "name": "Choose Your Second Flavour",
                                          "variations": [
                                            {
                                              "name": "Anjeer (Medium Fat Ice Cream, No Added Sugar) Single Scoop",
                                              "price": 5.24,
                                              "id": "137787819",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Mango (Medium Fat Ice Cream, No Added Sugar) Single Scoop",
                                              "price": 5.24,
                                              "id": "137787820",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "@ Gajar Halwa Ice Cream Single Scoop",
                                              "default": 1,
                                              "id": "206114871",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "@ Rose Walnut Ice Cream Single Scoop",
                                              "id": "205236524",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Anjeer Ice Cream Single Scoop",
                                              "id": "137787822",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Black Grapes (Medium Fat) Ice Cream Single Scoop",
                                              "id": "203606972",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Chickoo Ice Cream Single Scoop",
                                              "id": "180799810",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Choco Cream Ice Cream Single Scoop",
                                              "id": "149421355",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Chocobite Ice Cream Single Scoop",
                                              "id": "137787824",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Coffee Walnut Ice Cream Single Scoop",
                                              "id": "137787825",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Guava Ice Cream Single Scoop",
                                              "id": "207286213",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Kaju Kismis Ice Cream Single Scoop",
                                              "id": "137787826",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Kesar Pista Ice Cream Single Scoop",
                                              "id": "137787827",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Malai Ice Cream Single Scoop",
                                              "id": "137787828",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Mango (Medium Fat) Ice Cream Single Scoop",
                                              "id": "137787830",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Persian Delight Ice Cream Single Scoop",
                                              "id": "207286214",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Raspberry Chocolate Ice Cream Single Scoop",
                                              "id": "203606973",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Roasted Almond Ice Cream Single Scoop",
                                              "id": "137787837",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Sitaphal Ice Cream Single Scoop",
                                              "id": "193284372",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Strawberry Ice Cream Single Scoop",
                                              "id": "207286215",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            },
                                            {
                                              "name": "Tender Coconut Ice Cream Single Scoop",
                                              "id": "137787840",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "43234793",
                                                "variationId": "137787843"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "43234793",
                                          "name": "Choice of cup/cone",
                                          "variations": [
                                            {
                                              "name": "Waffle cone",
                                              "price": 9.44,
                                              "id": "137787844",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Double scoop cup",
                                              "default": 1,
                                              "id": "137787843",
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 16030
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16974
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 16030
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16974
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787795"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 16030
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16974
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 16030
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16974
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787796"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "206114870"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "205236522"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787798"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606970"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "180799806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "149421352"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787800"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787801"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286210"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787802"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787803"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787804"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787806"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286211"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "203606971"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787813"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "193284368"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "207286212"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787819"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 15506
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787820"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 16450
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "206114871"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "205236524"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787822"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606972"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "180799810"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "149421355"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787824"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787825"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286213"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787826"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787827"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787828"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787830"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286214"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "203606973"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787837"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "193284372"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "207286215"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787843"
                                            }
                                          ],
                                          "price": 14982
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "43234791",
                                              "variationId": "137787816"
                                            },
                                            {
                                              "groupId": "43234792",
                                              "variationId": "137787840"
                                            },
                                            {
                                              "groupId": "43234793",
                                              "variationId": "137787844"
                                            }
                                          ],
                                          "price": 15926
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 14982,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "57798406"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "49011653"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/2/fa4201e8-00ea-44f6-b46d-d5f8bad89e03_6cce6525-12e1-4139-b5ac-f5e864bfd72e.jpg",
                        "categoryId": "16948226"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11415010000104"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Natural Ice Cream",
                        "area": "Maharana Pratap Nagar",
                        "completeAddress": "Hansa Complex, 190, Service Road, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh- 462011"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "Psr3H2OBfTs2-K-u-px4_j22K-mecguy8FCYjDJQ"
  },

  "699962": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "The Belgian Waffle Co.",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "699962",
                "name": "The Belgian Waffle Co.",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "the-belgian-waffle-co-shaheed-bhagat-singh-market-piplani",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/17/47e2abae-c990-4e1c-9508-8ac845b9a851_699962.JPG",
                "locality": "Shaheed Bhagat Singh Market",
                "areaName": "Indrapuri Main Rd",
                "costForTwo": "20000",
                "costForTwoMessage": "₹200 for two",
                "cuisines": ["Waffle", "Desserts"],
                "avgRating": 4.6,
                "veg": true,
                "feeDetails": {
                  "restaurantId": "699962",
                  "fees": [{}]
                },
                "parentId": "2233",
                "avgRatingString": "4.6",
                "totalRatingsString": "1.0K+ ratings",
                "sla": {
                  "restaurantId": "699962",
                  "deliveryTime": 49,
                  "minDeliveryTime": 45,
                  "maxDeliveryTime": 50,
                  "lastMileTravel": 6.6,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 1006,
                  "slaString": "45-50 MINS",
                  "lastMileTravelString": "6.6 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextOpenTimeMessage": "Opens next at 10 am, today",
                  "nextOpenTime": "2026-01-06 10:00:00",
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "Freedel",
                  "shortDescriptionList": [
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "10% off upto ₹100|Use SBIDC100 Above ₹599",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "the-belgian-waffle-co-shaheed-bhagat-singh-market-piplani",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Shop No.1, Ground Floor, A-34, BHEL, Shaheed Bhagat Singh Market, Sector A, Indrapuri Main Rd, Bhopal, Madhya Pradesh 462023"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Waffle,Desserts"
                  }
                ],
                "logo": "Brand logo/TBWCo",
                "totalRatings": 1000,
                "aggregatedDiscountInfoV2": {
                  "header": "Freedel",
                  "shortDescriptionList": [
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "Freedel",
                      "discountType": "FREE_DELIVERY",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "10% off upto ₹100|Use SBIDC100 Above ₹599",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/699962"
                },
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 10 am, today",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 10:00 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.2513382,77.4587913",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 1,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "699962",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "isPureVeg": true,
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Waffles",
                        "categories": [
                          {
                            "title": "Double Chocolatey Waffle",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579039",
                                    "name": "Triple Chocomelt Waffle",
                                    "category": "Waffles",
                                    "description": "Your Favourite Triple Chocolate Waffle gets a new name! Signature Dark Choco Waffle + 3 Layers Of Melted White Choco, Belgian Milk Choco and Belgian Dark Choco. The most indulgent Choco Waffle Ever!",
                                    "imageId": "onq8rhxujd0sx8kubaew",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301073",
                                        "groupName": "Choose From Ice Cream for Triple Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301075",
                                        "groupName": "Choose From Extra Fillings for Triple Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301077",
                                        "groupName": "Choose From Coolers for Triple Chocomelt Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301080",
                                        "groupName": "Choose From Add On for Triple Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "64 ratings",
                                        "ratingCountV2": "64"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464820"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579040",
                                    "name": "Chocobite Overload Dark Waffle",
                                    "category": "Waffles",
                                    "description": "Your Favourite Chocolate Overload dark gets a new name! Signature Dark Choco Waffle + Melted Belgian Dark Choco. Double the chocolicious!",
                                    "imageId": "ggnwmgrznp4jjzwwyhjx",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301054",
                                        "groupName": "Choose From Ice Cream for Chocolate Overload Dark Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301056",
                                        "groupName": "Choose From Extra Fillings for Chocolate Overload Dark Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301058",
                                        "groupName": "Choose From Coolers for Chocobite Overload Dark Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301059",
                                        "groupName": "Choose From Add On for Chocolate Overload Dark Waffle",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "16 ratings",
                                        "ratingCountV2": "16"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464807"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813040",
                                    "name": "Chocobite Overload Milk Waffle",
                                    "category": "Waffles",
                                    "description": "Your Favourite Chocolate Overload milk gets a new name! Signature Dark Choco Waffle + Melted Belgian Milk Choco. Double the chocolicious!",
                                    "imageId": "uoqt4nodzskmp1xldjbw",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301046",
                                        "groupName": "Choose From Ice Cream for Chocolate Overload Milk Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301048",
                                        "groupName": "Choose From Extra Fillings for Chocolate Overload Milk Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301050",
                                        "groupName": "Choose From Coolers for Chocobite Overload Milk Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301052",
                                        "groupName": "Choose From Add On for Chocolate Overload Milk Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464809"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813041",
                                    "name": "Dark & White Fantasy Waffle",
                                    "category": "Waffles",
                                    "description": "Signature Dark Choco Waffle + Fondant of Melted Belgian White Choco. A Match Made In Heaven!",
                                    "imageId": "mtexxlclhen7gkljsems",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301063",
                                        "groupName": "Choose From Ice Cream for Dark and White Fantasy Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301065",
                                        "groupName": "Choose From Extra Fillings for Dark and White Fantasy Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301068",
                                        "groupName": "Choose From Coolers for Dark & White Fantasy Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301070",
                                        "groupName": "Choose From Add On for Dark and White Fantasy Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "20 ratings",
                                        "ratingCountV2": "20"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612281"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354674"
                          },
                          {
                            "title": "Chocolatey Waffle",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579002",
                                    "name": "Belgian Dark Waffle",
                                    "category": "Waffles",
                                    "description": "Your Favourite Belgian Chocolate Dark Waffle gets a new name! Classic Crispy Waffle + Melted Belgian Dark Choco. Darker Simplicity!",
                                    "imageId": "hlrrukbpjasmhczocwb6",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953303",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Belgian Dark Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491370",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Belgian Dark Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491373",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953303",
                                              "variationId": "206491370"
                                            }
                                          ],
                                          "price": 16500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300930",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300925",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300925",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300915",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300915",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300920",
                                              "addonId": "142226056"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953303",
                                              "variationId": "206491373"
                                            }
                                          ],
                                          "price": 20000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300933",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300923",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300928",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300928",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300918",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300918",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259300915",
                                        "groupName": "Choose From Ice Cream for Belgian Chocolate Dark Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300918",
                                        "groupName": "Choose From Ice Cream for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300920",
                                        "groupName": "Choose From Extra Fillings for Belgian Chocolate Dark Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300923",
                                        "groupName": "Choose From Extra Fillings for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300925",
                                        "groupName": "Choose From Coolers for Belgian Dark Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300928",
                                        "groupName": "Choose From Coolers for Belgian Dark Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300930",
                                        "groupName": "Choose From Add On for Belgian Chocolate Dark Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300933",
                                        "groupName": "Choose From Add On for Belgian Chocolate Dark Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "11 ratings",
                                        "ratingCountV2": "11"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "102677672"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579004",
                                    "name": "Kitkat Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Melted Belgian White Choco and KitKat Bits for KitKat Lovers!",
                                    "imageId": "eozerfua7ygpxho5wkao",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953321",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "KitKat Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491398",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "KitKat Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491401",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953321",
                                              "variationId": "206491398"
                                            }
                                          ],
                                          "price": 18500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300980",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300980",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300984",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300975",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300972",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300972",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953321",
                                              "variationId": "206491401"
                                            }
                                          ],
                                          "price": 22000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300974",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300974",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300982",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300982",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300978",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300985",
                                              "addonId": "142226049"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259300972",
                                        "groupName": "Choose From Ice Cream for KitKat Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300974",
                                        "groupName": "Choose From Ice Cream for KitKat Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300975",
                                        "groupName": "Choose From Extra Fillings for KitKat Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300978",
                                        "groupName": "Choose From Extra Fillings for KitKat Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300980",
                                        "groupName": "Choose From Coolers for KitKat Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300982",
                                        "groupName": "Choose From Coolers for KitKat Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300984",
                                        "groupName": "Choose From Add On for KitKat Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300985",
                                        "groupName": "Choose From Add On for KitKat Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "36 ratings",
                                        "ratingCountV2": "36"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612526"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579041",
                                    "name": "Belgian Milk Waffle",
                                    "category": "Waffles",
                                    "description": "Your Favourite Belgian Chocolate Milk Waffle gets a new name! Classic Crispy Waffle + Melted Belgian Milk Choco. Simplicity At Its Best!",
                                    "imageId": "uepao2q7bc4prdmqw6rx",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953296",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Belgian Milk Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491361",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Belgian Milk Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491363",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953296",
                                              "variationId": "206491361"
                                            }
                                          ],
                                          "price": 16500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300893",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300893",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300903",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300903",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300908",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300898",
                                              "addonId": "142226056"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953296",
                                              "variationId": "206491363"
                                            }
                                          ],
                                          "price": 20000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300896",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300896",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300901",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300906",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300906",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300911",
                                              "addonId": "142226049"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259300893",
                                        "groupName": "Choose From Ice Cream for Belgian Chocolate Milk Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300896",
                                        "groupName": "Choose From Ice Cream for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300898",
                                        "groupName": "Choose From Extra Fillings for Belgian Chocolate Milk Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300901",
                                        "groupName": "Choose From Extra Fillings for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300903",
                                        "groupName": "Choose From Coolers for Belgian Milk Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300906",
                                        "groupName": "Choose From Coolers for Belgian Milk Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300908",
                                        "groupName": "Choose From Add On for Belgian Chocolate Milk Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300911",
                                        "groupName": "Choose From Add On for Belgian Chocolate Milk Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.9",
                                        "ratingCount": "13 ratings",
                                        "ratingCountV2": "13"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "102677674"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579027",
                                    "name": "Butterscotch Crunch Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Crunchy Butterscotch Fudge. Go On Indulge!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/1425c17e-cf50-48d1-9a29-d82aecddd489_ad1e4ae1-aa69-4a40-b807-c8dfcfd99a11.png",
                                    "isVeg": 1,
                                    "price": 14500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953314",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Butterscotch Crunch Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491384",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Butterscotch Crunch Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491385",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953314",
                                              "variationId": "206491384"
                                            }
                                          ],
                                          "price": 14500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300939",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300939",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300951",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300943",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300948",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300948",
                                              "addonId": "142226119"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953314",
                                              "variationId": "206491385"
                                            }
                                          ],
                                          "price": 18000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300950",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300950",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300953",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300945",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300941",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300941",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259300939",
                                        "groupName": "Choose From Ice Cream for Butterscotch Crunch Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300941",
                                        "groupName": "Choose From Ice Cream for Butterscotch Crunch Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300943",
                                        "groupName": "Choose From Extra Fillings for Butterscotch Crunch Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300945",
                                        "groupName": "Choose From Extra Fillings for Butterscotch Crunch Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300948",
                                        "groupName": "Choose From Coolers for Butterscotch Crunch Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300950",
                                        "groupName": "Choose From Coolers for Butterscotch Crunch Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300951",
                                        "groupName": "Choose From Add On for Butterscotch Crunch Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300953",
                                        "groupName": "Choose From Add On for Butterscotch Crunch Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "28 ratings",
                                        "ratingCountV2": "28"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19611846"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579026",
                                    "name": "Coffee Mocha Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Melted Choco Infused with Coffee Crumbs for Coffee Lovers!",
                                    "imageId": "ii9usixjbv7djr6g8xui",
                                    "isVeg": 1,
                                    "price": 15500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953317",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Coffee Mocha Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491390",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Coffee Mocha Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491391",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953317",
                                              "variationId": "206491390"
                                            }
                                          ],
                                          "price": 15500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300959",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300967",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300956",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300956",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259300963",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300963",
                                              "addonId": "142226119"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953317",
                                              "variationId": "206491391"
                                            }
                                          ],
                                          "price": 19000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259300965",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259300965",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259300969",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259300961",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259300958",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259300958",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259300956",
                                        "groupName": "Choose From Ice Cream for Coffee Mocha Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300958",
                                        "groupName": "Choose From Ice Cream for Coffee Mocha Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300959",
                                        "groupName": "Choose From Extra Fillings for Coffee Mocha Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300961",
                                        "groupName": "Choose From Extra Fillings for Coffee Mocha Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300963",
                                        "groupName": "Choose From Coolers for Coffee Mocha Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300965",
                                        "groupName": "Choose From Coolers for Coffee Mocha Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300967",
                                        "groupName": "Choose From Add On for Coffee Mocha Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300969",
                                        "groupName": "Choose From Add On for Coffee Mocha Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "12 ratings",
                                        "ratingCountV2": "12"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612104"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354670"
                          },
                          {
                            "title": "Club Velvet Waffle",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114578988",
                                    "name": "Kiki & Oreo Cream Waffle",
                                    "category": "Waffles",
                                    "description": "Signature Black Velvet Waffle + Our Special Blue Filling with Cookie Crunchy Oreo Bits Filling. Kiki Do You Love Me?",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/ed40c028-724c-4c62-8a67-e90e61976f05_d9033ffc-f58d-446d-818b-e4ec91c82d8b.png",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259300988",
                                        "groupName": "Choose From Ice Cream for Kiki & Oreo Cream Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300990",
                                        "groupName": "Choose From Extra Fillings for Kiki & Oreo Cream Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 12,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300992",
                                        "groupName": "Choose From Coolers for Kiki & Oreo Cream Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300993",
                                        "groupName": "Choose From Add On for Kiki & Oreo Cream Waffle",
                                        "choices": [
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 9,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16500,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "96 ratings",
                                        "ratingCountV2": "96"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "65149521"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579035",
                                    "name": "Lotus Biscoff Waffle",
                                    "category": "Waffles",
                                    "description": "Signature Black Velvet Waffle + Fondant of Melted White Choco Filled with Crunchy Lotus Biscoff Bits. An All Time Favorite!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/30/3360f699-06ac-418d-abcb-a8c1076bd556_d866f41a-6656-49a2-819f-dc4ed0f71dc8.png",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301006",
                                        "groupName": "Choose From Ice Cream for Biscoff Milkyway Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301007",
                                        "groupName": "Choose From Extra Fillings for Biscoff Milkyway Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 11,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301010",
                                        "groupName": "Choose From Coolers for Lotus Biscoff Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301012",
                                        "groupName": "Choose From Add On for Biscoff Milkyway Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "30 ratings",
                                        "ratingCountV2": "30"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "68087056"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579058",
                                    "name": "Red Velvet Waffle",
                                    "category": "Waffles",
                                    "description": "\"Original Red Velvet Waffle + Creamy Cheesecake* filling and Melted White Choco. A True Original - Enhanced! *Cheesecake flavour filling, contains spray dried cheese powder\"",
                                    "imageId": "izclpbaijnfbe6dvksts",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259300998",
                                        "groupName": "Choose From Ice Cream for Red Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259300999",
                                        "groupName": "Choose From Extra Fillings for Red Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301000",
                                        "groupName": "Choose From Coolers for Red Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301001",
                                        "groupName": "Choose From Add On for Red Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "37 ratings",
                                        "ratingCountV2": "37"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612961"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579049",
                                    "name": "Berry Red Velvet Waffle",
                                    "category": "Waffles",
                                    "description": "\"Original Red Velvet Waffle +Strawberry Compote + Creamy Cheesecake* filling And Melted White Choco. A True Original - Enhanced! *Cheesecake flavour filling, contains spray dried cheese powder\"",
                                    "imageId": "ax9pjars4v2qj7jthb3m",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301015",
                                        "groupName": "Choose From Ice Cream for Berry Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301017",
                                        "groupName": "Choose From Extra Fillings for Berry Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 11,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301019",
                                        "groupName": "Choose From Coolers for Berry Red Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301021",
                                        "groupName": "Choose From Add On for Berry Velvet Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 9,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "68087052"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354676"
                          },
                          {
                            "title": "Cheesecake* Flavour Waffle",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "137738895",
                                    "name": "Blueberry Cheesecake* Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle layered with creamy Cheesecake filling & fresh Blueberry Compote topped with lotus biscoff crumbles. Deliciously Tart! *Cheesecake flavour filling, contains spray dried cheese powder",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/3f084317-3144-4656-9795-2313745b2aba_863869c3-6756-43ba-a995-05c8278d9b51.png",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301023",
                                        "groupName": "Choose From Ice Cream for Blueberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301025",
                                        "groupName": "Choose From Extra Fillings for Blueberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301028",
                                        "groupName": "Choose From Coolers for Blueberry Cheesecake* Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301029",
                                        "groupName": "Choose From Add On for Blueberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 17500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "12 ratings",
                                        "ratingCountV2": "12"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48711898"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "137738900",
                                    "name": "Mango Cheesecake* Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle layered with creamy Cheesecake filling & fresh Mango Compote topped with lotus biscoff crumbles. Mangoliciously Cheesy!*Cheesecake flavour filling, contains spray dried cheese powder",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/1e1e680c-e198-4715-b8e2-aa0e8d1d38d3_1d7f9e0a-adaa-4c74-bc1f-6dd0f44c0042.png",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301038",
                                        "groupName": "Choose From Ice Cream for Mango Cheesecake Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301039",
                                        "groupName": "Choose From Extra Fillings for Mango Cheesecake Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 16,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301042",
                                        "groupName": "Choose From Coolers for Mango Cheesecake* Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301044",
                                        "groupName": "Choose From Add On for Mango Cheesecake Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "80741433"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "137738898",
                                    "name": "Strawberry Cheesecake* Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle layered with creamy Cheesecake filling & fresh Strawberry Compote topped with lotus biscoff crumbles. Deliciously Tart! *Cheesecake flavour filling, contains spray dried cheese powder",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/f8859b2a-05c1-4ade-be85-18b0aa7657ac_1eed53a7-eee1-4fb5-89a2-77b71539b197.png",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301032",
                                        "groupName": "Choose From Ice Cream for Strawberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301033",
                                        "groupName": "Choose From Extra Fillings for Strawberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301036",
                                        "groupName": "Choose From Coolers for Strawberry Cheesecake* Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301037",
                                        "groupName": "Choose From Add On for Strawberry Cream Cheese Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48711925"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354672"
                          },
                          {
                            "title": "Classic Waffle",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579057",
                                    "name": "Almond Cocoa Butter Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Cocoa Butter Topped with Roasted Almonds, Nutty & Delicious!",
                                    "imageId": "sltrdervslg41lifbjhh",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953356",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Almond Cocoa Butter Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491445",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Almond Cocoa Butter Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491446",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953356",
                                              "variationId": "206491445"
                                            }
                                          ],
                                          "price": 18500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301126",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301126",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259301121",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301121",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301124",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301131",
                                              "addonId": "142226049"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953356",
                                              "variationId": "206491446"
                                            }
                                          ],
                                          "price": 22000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301122",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301122",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259301128",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301128",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301125",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301132",
                                              "addonId": "142226049"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259301121",
                                        "groupName": "Choose From Ice Cream for Almond Cocoa Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301122",
                                        "groupName": "Choose From Ice Cream for Almond Cocoa Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301124",
                                        "groupName": "Choose From Extra Fillings for Almond Cocoa Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301125",
                                        "groupName": "Choose From Extra Fillings for Almond Cocoa Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301126",
                                        "groupName": "Choose From Coolers for Almond Cocoa Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301128",
                                        "groupName": "Choose From Coolers for Almond Cocoa Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301131",
                                        "groupName": "Choose From Add On for Almond Cocoa Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301132",
                                        "groupName": "Choose From Add On for Almond Cocoa Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "37 ratings",
                                        "ratingCountV2": "37"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19611558"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579021",
                                    "name": "Honey Butter Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Warm Melted Butter and Golden Honey Drizzle an American Classic!",
                                    "imageId": "fzepkoysubchbzr4gt6f",
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953351",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Honey Butter Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491438",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Honey Butter Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491439",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953351",
                                              "variationId": "206491438"
                                            }
                                          ],
                                          "price": 10500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259301095",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301090",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259301092",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301092",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259301085",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301085",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953351",
                                              "variationId": "206491439"
                                            }
                                          ],
                                          "price": 14000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301087",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301087",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301097",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301091",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259301093",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301093",
                                              "addonId": "142226119"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259301085",
                                        "groupName": "Choose From Ice Cream for Honey Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301087",
                                        "groupName": "Choose From Ice Cream for Honey Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301090",
                                        "groupName": "Choose From Extra Fillings for Honey Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301091",
                                        "groupName": "Choose From Extra Fillings for Honey Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301092",
                                        "groupName": "Choose From Coolers for Honey Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301093",
                                        "groupName": "Choose From Coolers for Honey Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301095",
                                        "groupName": "Choose From Add On for Honey Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301097",
                                        "groupName": "Choose From Add On for Honey Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 10500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612386"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579024",
                                    "name": "Maple Butter Waffle",
                                    "category": "Waffles",
                                    "description": "Classic Crispy Waffle + Warm Melted Butter and Maple Syrup Drizzle an American Classic!",
                                    "imageId": "cme1izhghagg1vkvvpgu",
                                    "isVeg": 1,
                                    "price": 10500,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68953353",
                                          "name": "Choose From Variant",
                                          "variations": [
                                            {
                                              "name": "Maple Butter Waffle (Regular Batter)",
                                              "default": 1,
                                              "id": "206491441",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Maple Butter Waffle (Almond Flour Batter)",
                                              "price": 35,
                                              "id": "206491442",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953353",
                                              "variationId": "206491441"
                                            }
                                          ],
                                          "price": 10500,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259301114",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259301111",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301111",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259301102",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301102",
                                              "addonId": "142226038"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301106",
                                              "addonId": "142226056"
                                            }
                                          ]
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68953353",
                                              "variationId": "206491442"
                                            }
                                          ],
                                          "price": 14000,
                                          "addonCombinations": [
                                            {
                                              "groupId": "259301113",
                                              "addonId": "142226117"
                                            },
                                            {
                                              "groupId": "259301113",
                                              "addonId": "142226119"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226023"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226102"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226100"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226035"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226033"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226031"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226029"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226028"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226069"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226067"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226064"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226042"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226053"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226062"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226103"
                                            },
                                            {
                                              "groupId": "259301108",
                                              "addonId": "142226056"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226084"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226111"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226071"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226007"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226044"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226123"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226005"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226065"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226095"
                                            },
                                            {
                                              "groupId": "259301115",
                                              "addonId": "142226049"
                                            },
                                            {
                                              "groupId": "259301104",
                                              "addonId": "142226090"
                                            },
                                            {
                                              "groupId": "259301104",
                                              "addonId": "142226038"
                                            }
                                          ]
                                        }
                                      ]
                                    },
                                    "addons": [
                                      {
                                        "groupId": "259301102",
                                        "groupName": "Choose From Ice Cream for Maple Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301104",
                                        "groupName": "Choose From Ice Cream for Maple Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301106",
                                        "groupName": "Choose From Extra Fillings for Maple Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301108",
                                        "groupName": "Choose From Extra Fillings for Maple Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301111",
                                        "groupName": "Choose From Coolers for Maple Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301113",
                                        "groupName": "Choose From Coolers for Maple Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301114",
                                        "groupName": "Choose From Add On for Maple Butter Waffle (Regular Batter)",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301115",
                                        "groupName": "Choose From Add On for Maple Butter Waffle (Almond Flour Batter)",
                                        "choices": [
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226005",
                                            "name": "Vanilla Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 10,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 10500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "11 ratings",
                                        "ratingCountV2": "11"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612581"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354668"
                          }
                        ],
                        "image": "sltrdervslg41lifbjhh",
                        "categoryId": "69354641"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Mini Waffle Combos",
                        "categories": [
                          {
                            "title": "Premium Assorted Mini Waffle Combo Pack",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "161508310",
                                    "name": "Mini Waffle Box of 4 - Premium Assorted",
                                    "category": "Mini Waffle Combos",
                                    "description": "Experience indulgence at its finest with our newly launched Premium Mini Waffle Box of 4. Get your favourites in one box: Blueberry Cheesecake + Lotus Biscoff Cheesecake + KitKat + Belgian Milk Choco -  Serves 4",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/26/1493150b-b9df-43fc-a9e3-12c1d61b818a_8b212fd5-b3f8-4ad8-86b6-9c7a74bf3fef.png",
                                    "isVeg": 1,
                                    "price": 37500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301212",
                                        "groupName": "Mini Waffle 1",
                                        "choices": [
                                          {
                                            "id": "142226026",
                                            "name": "Blueberry Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301213",
                                        "groupName": "Mini Waffle 2",
                                        "choices": [
                                          {
                                            "id": "142226061",
                                            "name": "Biscoff Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301215",
                                        "groupName": "Mini Waffle 3",
                                        "choices": [
                                          {
                                            "id": "142226046",
                                            "name": "KitKat Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301217",
                                        "groupName": "Mini Waffle 4",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301219",
                                        "groupName": "Group-5",
                                        "choices": [
                                          {
                                            "id": "142226014",
                                            "name": "Mini Waffle Box",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 37500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "15 ratings",
                                        "ratingCountV2": "15"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "95140320"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "159045554",
                                    "name": "Mini Waffle Box of 6 - Premium Assorted",
                                    "category": "Mini Waffle Combos",
                                    "description": "Devour the ultimate indulgence with our newly launched Premium Mini Waffle Box of 6. Could you ask for more when you have Blueberry Cheesecake + Strawberry Cheesecake + Red Velvet + Berry Red Velvet + Lotus Biscoff + Kiki and Oreo, all favourite waffle in one box! - Serves 6",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/26/61c7bb36-0755-4a59-89fc-79632fe2e444_f8594c39-0bf5-473a-871e-991e8109ed03.png",
                                    "isVeg": 1,
                                    "price": 52500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301222",
                                        "groupName": "Group-1",
                                        "choices": [
                                          {
                                            "id": "142226026",
                                            "name": "Blueberry Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301223",
                                        "groupName": "Group-2",
                                        "choices": [
                                          {
                                            "id": "142226077",
                                            "name": "Strawberry Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301226",
                                        "groupName": "Group-3",
                                        "choices": [
                                          {
                                            "id": "142226008",
                                            "name": "Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301228",
                                        "groupName": "Group-4",
                                        "choices": [
                                          {
                                            "id": "142226075",
                                            "name": "Berry Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301230",
                                        "groupName": "Group-5",
                                        "choices": [
                                          {
                                            "id": "142226004",
                                            "name": "Lotus Biscoff Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301232",
                                        "groupName": "Group-6",
                                        "choices": [
                                          {
                                            "id": "142226003",
                                            "name": "Kiki & Oreo Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301233",
                                        "groupName": "Group-7",
                                        "choices": [
                                          {
                                            "id": "142226098",
                                            "name": "Mini Waffle Box (6 Mini Waffle)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 52500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "12 ratings",
                                        "ratingCountV2": "12"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "95140321"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354662"
                          },
                          {
                            "title": "Chocolate Mini Waffle Combo Pack",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813073",
                                    "name": "Mini Waffle Box of 6 - Chocoholic's",
                                    "category": "Mini Waffle Combos",
                                    "description": "Can’t Pick One? Try A Carefully Curated Assortment of our Bestselling Chocolate Favorites. Includes Naked Nutella, Belgian Chocolate (Dark), Belgian Chocolate (Milk), Kit kat, Chocolate Overload (Milk) And Dark & White Fantasy Mini Waffles In An All-In-One Combo Pack -  Serves 6",
                                    "imageId": "d7kc3dqkztnvfmbq5tjc",
                                    "isVeg": 1,
                                    "price": 52500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301184",
                                        "groupName": "Mini Waffle 1",
                                        "choices": [
                                          {
                                            "id": "142226125",
                                            "name": "Naked Nutella Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301186",
                                        "groupName": "Mini Waffle 2",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301188",
                                        "groupName": "Mini Waffle 3",
                                        "choices": [
                                          {
                                            "id": "142226010",
                                            "name": "Belgian Chocomelt Dark Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301190",
                                        "groupName": "Mini Waffle 4",
                                        "choices": [
                                          {
                                            "id": "142226002",
                                            "name": "Chocobite Overload Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301192",
                                        "groupName": "Mini Waffle 5",
                                        "choices": [
                                          {
                                            "id": "142226091",
                                            "name": "Dark & White Fantasy Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301193",
                                        "groupName": "Mini Waffle 6",
                                        "choices": [
                                          {
                                            "id": "142226046",
                                            "name": "KitKat Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301194",
                                        "groupName": "Box",
                                        "choices": [
                                          {
                                            "id": "142226098",
                                            "name": "Mini Waffle Box (6 Mini Waffle)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 52500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464818"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "161508311",
                                    "name": "Mini Waffle Box of 4 - Chocoholic's",
                                    "category": "Mini Waffle Combos",
                                    "description": "Can’t Pick One? Try A Carefully Curated Assortment of our Bestselling Chocolate Favorites. Includes Naked Nutella, Belgian Chocolate (Milk), Chocolate Overload (Dark) And Dark & White Fantasy Mini Waffles In An All-In-One Combo Pack - Serves 4",
                                    "imageId": "hs4fcgudajhidwcn3xpy",
                                    "isVeg": 1,
                                    "price": 36500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301173",
                                        "groupName": "Mini Waffle 1",
                                        "choices": [
                                          {
                                            "id": "142226125",
                                            "name": "Naked Nutella Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301174",
                                        "groupName": "Mini Waffle 2",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301175",
                                        "groupName": "Mini Waffle 3",
                                        "choices": [
                                          {
                                            "id": "142226091",
                                            "name": "Dark & White Fantasy Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301176",
                                        "groupName": "Mini Waffle 4",
                                        "choices": [
                                          {
                                            "id": "142226113",
                                            "name": "Chocobite Overload Dark Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301178",
                                        "groupName": "Box",
                                        "choices": [
                                          {
                                            "id": "142226014",
                                            "name": "Mini Waffle Box",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 36500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "18 ratings",
                                        "ratingCountV2": "18"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464817"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354658"
                          },
                          {
                            "title": "Assorted Mini Waffle Combo Pack",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "161508313",
                                    "name": "Mini Waffle Box of 6 - Assorted",
                                    "category": "Mini Waffle Combos",
                                    "description": "In The Mood For Even More Variety? Try A Carefully Curated Assortment of Some of our Fan Favorites. Includes Naked Nutella, Belgian Chocomelt (Milk), Chocobite Overload (Milk), Dark & White Fantasy, Red Velvet And Berry Red Velvet Mini Waffles In An All-In-One Combo Pack -  Serves 6",
                                    "imageId": "nqtcnakfpwk4dhaum1uq",
                                    "isVeg": 1,
                                    "price": 52500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301203",
                                        "groupName": "Mini Waffle 1",
                                        "choices": [
                                          {
                                            "id": "142226125",
                                            "name": "Naked Nutella Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301204",
                                        "groupName": "Mini Waffle 2",
                                        "choices": [
                                          {
                                            "id": "142226002",
                                            "name": "Chocobite Overload Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301205",
                                        "groupName": "Mini Waffle 3",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301206",
                                        "groupName": "Mini Waffle 4",
                                        "choices": [
                                          {
                                            "id": "142226091",
                                            "name": "Dark & White Fantasy Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301207",
                                        "groupName": "Mini Waffle 5",
                                        "choices": [
                                          {
                                            "id": "142226008",
                                            "name": "Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301208",
                                        "groupName": "Mini Waffle 6",
                                        "choices": [
                                          {
                                            "id": "142226075",
                                            "name": "Berry Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301210",
                                        "groupName": "Box",
                                        "choices": [
                                          {
                                            "id": "142226098",
                                            "name": "Mini Waffle Box (6 Mini Waffle)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 52500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "56204419"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "161508312",
                                    "name": "Mini Waffle Box of 4 - Assorted",
                                    "category": "Mini Waffle Combos",
                                    "description": "In The Mood For Variety? Try A Carefully Curated Assortment Of Some Of Our Fan Favorites. Includes Belgian Chocomelt (Milk), Almond Cocoa Butter, Red Velvet And Berry Red Velvet Mini Waffles in an All-In-One Combo Pack -  Serves 4",
                                    "imageId": "hiqwcprb2zpypkhgxoce",
                                    "isVeg": 1,
                                    "price": 36500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301196",
                                        "groupName": "Mini Waffle 1",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301197",
                                        "groupName": "Mini Waffle 2",
                                        "choices": [
                                          {
                                            "id": "142226080",
                                            "name": "Almond Cocoa Butter Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301198",
                                        "groupName": "Mini Waffle 3",
                                        "choices": [
                                          {
                                            "id": "142226008",
                                            "name": "Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301200",
                                        "groupName": "Mini Waffle 4",
                                        "choices": [
                                          {
                                            "id": "142226075",
                                            "name": "Berry Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301201",
                                        "groupName": "Box",
                                        "choices": [
                                          {
                                            "id": "142226014",
                                            "name": "Mini Waffle Box",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 36500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "56204417"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354660"
                          }
                        ],
                        "image": "d7kc3dqkztnvfmbq5tjc",
                        "categoryId": "69354635"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Waffle Cakes",
                        "categories": [
                          {
                            "title": "Double Layer Waffle Cake",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813061",
                                    "name": "Death by Choco-rush Waffle Cake (Double Layer)",
                                    "category": "Waffle Cakes",
                                    "description": "Your Favourite Death By Chocolate (Double Layer) gets a new name! Signature dark Choco double layer waffle cake layered inside and out with creamy White, Milk and Dark melted Belgian Chocomelt. Triple the Choco, triple the fun! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order)",
                                    "imageId": "g7v2sn7eezaricdwqcfz",
                                    "isVeg": 1,
                                    "price": 62500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464812"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119016389",
                                    "name": "Almond Brownie Waffle Cake (Double Layer)",
                                    "category": "Waffle Cakes",
                                    "description": "The Best of Two Worlds In A Double Layer Cake - A Waffle And A Brownie. With Deliciously Rich Melted Choco and Almonds. Your Doorway To Heaven! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order)",
                                    "imageId": "ca123c7d807dc099ca8673d9fbdcd025",
                                    "isVeg": 1,
                                    "price": 62500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "68087048"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813062",
                                    "name": "Kiki & Oreo Waffle Cake (Double Layer)",
                                    "category": "Waffle Cakes",
                                    "description": "Signature black velvet double layer waffle cake layered thick inside and out with Kiki spread and topped with Crushed Oreos. A universal favorite! (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order)",
                                    "imageId": "fxatt8nrpmsquqshuk7e",
                                    "isVeg": 1,
                                    "price": 62500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301271",
                                        "groupName": "Choose From Add On for Kiki and Oreo Waffle Cake (Double Layer)",
                                        "choices": [
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 62500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.7",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "67988879"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114578974",
                                    "name": "Berry Red Velvet Waffle Cake (Double Layer)",
                                    "category": "Waffle Cakes",
                                    "description": "\"Original Red Velvet Double Layer Waffle Cake with Strawberry Compote + Creamy Cheesecake* filling And Melted White Choco Topped With Red Velvet Crumbs. A True Original - Enhanced! *Cheesecake flavour filling, contains spray dried cheese powder (Sorry! Our special waffle cakes do not allow for any customization. We do not provide candles or cutlery with this order)\"",
                                    "imageId": "pu745scsltqx0ewsfvec",
                                    "isVeg": 1,
                                    "price": 62500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.9",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "68043342"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354680"
                          }
                        ],
                        "image": "g7v2sn7eezaricdwqcfz",
                        "categoryId": "69354643"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Offers & Value Deals",
                        "categories": [
                          {
                            "title": "Offers & Value Deals",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186052153",
                                    "name": "Steal Deal",
                                    "category": "Offers & Value Deals",
                                    "description": "A waffle party awaits! Buy 4 of your favourites and we’ll add 1 for FREE. Perfect for your waffle-loving tribe",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/9737bf8a-1200-4eb1-8d09-b4a3d5f68503_d8f9138a-1ff1-4289-9552-a88a611c9c64.png",
                                    "isVeg": 1,
                                    "price": 73900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301261",
                                        "groupName": "Group-1",
                                        "choices": [
                                          {
                                            "id": "142226087",
                                            "name": "Naked Nutella Waffle (Regular Batter)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226021",
                                            "name": "Belgian Milk Waffle (Regular Batter)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226115",
                                            "name": "Belgian Dark Waffle (Regular Batter)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226073",
                                            "name": "KitKat Waffle (Regular Batter)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226040",
                                            "name": "Triple Chocomelt Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226093",
                                            "name": "Chocobite Overload Milk Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226089",
                                            "name": "Chocobite Overload Dark Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226085",
                                            "name": "Red Velvet Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226121",
                                            "name": "Kiki & Oreo Cream Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226025",
                                            "name": "Nutella Cheesecake* Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226019",
                                            "name": "Blueberry Cheesecake* Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 5,
                                        "maxFreeAddons": -1,
                                        "minAddons": 5
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 73900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113113288"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579157",
                                    "name": "Mini Treats",
                                    "category": "Offers & Value Deals",
                                    "description": "Treat your tribe! Save Rs. 91 flat & enjoy Mini Waffle pack of 4 (Chocoholic's) + Mini Waffle pack of 6 (Premium).",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/23/cee83e17-9c91-416d-a5d5-0c83ed900868_4a7e72ff-d805-4845-b658-67fe0bee2261.png",
                                    "isVeg": 1,
                                    "price": 79900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301237",
                                        "groupName": "Group-1",
                                        "choices": [
                                          {
                                            "id": "142226026",
                                            "name": "Blueberry Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301240",
                                        "groupName": "Group-2",
                                        "choices": [
                                          {
                                            "id": "142226077",
                                            "name": "Strawberry Cheesecake Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301242",
                                        "groupName": "Group-3",
                                        "choices": [
                                          {
                                            "id": "142226008",
                                            "name": "Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301243",
                                        "groupName": "Group-4",
                                        "choices": [
                                          {
                                            "id": "142226075",
                                            "name": "Berry Red Velvet Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301244",
                                        "groupName": "Group-5",
                                        "choices": [
                                          {
                                            "id": "142226004",
                                            "name": "Lotus Biscoff Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301245",
                                        "groupName": "Group-6",
                                        "choices": [
                                          {
                                            "id": "142226003",
                                            "name": "Kiki & Oreo Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301247",
                                        "groupName": "Group-7",
                                        "choices": [
                                          {
                                            "id": "142226098",
                                            "name": "Mini Waffle Box (6 Mini Waffle)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301248",
                                        "groupName": "Group-8",
                                        "choices": [
                                          {
                                            "id": "142226125",
                                            "name": "Naked Nutella Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301249",
                                        "groupName": "Group-9",
                                        "choices": [
                                          {
                                            "id": "142226012",
                                            "name": "Belgian Chocomelt Milk Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301251",
                                        "groupName": "Group-10",
                                        "choices": [
                                          {
                                            "id": "142226091",
                                            "name": "Dark & White Fantasy Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301253",
                                        "groupName": "Group-11",
                                        "choices": [
                                          {
                                            "id": "142226113",
                                            "name": "Chocobite Overload Dark Mini Waffle",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      },
                                      {
                                        "groupId": "259301255",
                                        "groupName": "Group-12",
                                        "choices": [
                                          {
                                            "id": "142226014",
                                            "name": "Mini Waffle Box",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 79900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "53440798"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354656"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/9737bf8a-1200-4eb1-8d09-b4a3d5f68503_d8f9138a-1ff1-4289-9552-a88a611c9c64.png",
                        "categoryId": "69354633"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Limited Edition Specials",
                        "categories": [
                          {
                            "title": "Limited Edition Specials",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "178295681",
                                    "name": "Choco Kunafa Waffle",
                                    "category": "Limited Edition Specials",
                                    "description": "Our signature dark choco Waff-Wich meets the VIRAL Dubai-Chocolate — and the rest is history ! A rich blend of dark chocolate, pistachio kunafa, and the creamy chocolate spread.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/31/4498dffb-7bcf-4833-8400-79dbef2970c0_ca5766ee-d361-4538-a54f-05198ec89b4f.png",
                                    "isVeg": 1,
                                    "price": 21500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301279",
                                        "groupName": "Choose From Ice Cream for Choco Kunafa Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 21500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "107879550"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186536677",
                                    "name": "Colour Burst Sundae (L)",
                                    "category": "Limited Edition Specials",
                                    "description": "A scoop of happiness in every bite! Creamy vanilla ice cream paired with our red velvet waffle chunks, topped with strawberry compote, white chocolate spread, Cadbury Gems and colourful sprinkles — a perfect mix of choco, crunch, and colour.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/11/80bf38fe-1182-4f5e-aa3c-62936d2e446b_a6f30a1f-1e8b-4fbf-bb9d-5498700f04e6.png",
                                    "isVeg": 1,
                                    "price": 16000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113805812"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186536676",
                                    "name": "Choco Colour Burst Waffle",
                                    "category": "Limited Edition Specials",
                                    "description": "A double dose of chocolatey goodness! Made with our rich Double Choco batter, filled with rich Belgian milk spread, loaded and topped with Cadbury Gems — finished with a burst of colourful sprinkles for that perfect crunch.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/11/c3166a55-f16b-4ffc-b47b-a5584bcc2775_ebda7deb-5a4c-4ed3-8b2d-34abc4c74c37.png",
                                    "isVeg": 1,
                                    "price": 16500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113805811"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354647"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/31/4498dffb-7bcf-4833-8400-79dbef2970c0_ca5766ee-d361-4538-a54f-05198ec89b4f.png",
                        "categoryId": "69354627"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Waffle Sundae",
                        "categories": [
                          {
                            "title": "Waffle Sundae",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119016391",
                                    "name": "Choco Brownie Sundae (L)",
                                    "category": "Waffle Sundae",
                                    "description": "A chocolicious combination is on your way! Choco ice cream topped with brownie waffle chunks, crushed Almonds & choco fudge sauce will surely melt your heart. (Images are for representation purpose only)",
                                    "imageId": "811ae72fb321c8d62a0246cd1f80ffaf",
                                    "isVeg": 1,
                                    "price": 16000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "11 ratings",
                                        "ratingCountV2": "11"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55814794"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813079",
                                    "name": "Choco Brownie Sundae (S)",
                                    "category": "Waffle Sundae",
                                    "description": "A chocolicious combination is on your way! Choco ice cream topped with brownie waffle chunks, crushed Almonds, and choco fudge sauce will surely melt your heart. (Images are for representation purpose only)",
                                    "imageId": "470cc03f5f2b98c2ca5dde4f71300f55",
                                    "isVeg": 1,
                                    "price": 13000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.9",
                                        "ratingCount": "12 ratings",
                                        "ratingCountV2": "12"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55814796"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119016390",
                                    "name": "Lotus Biscoff Sundae (S)",
                                    "category": "Waffle Sundae",
                                    "description": "A combination that you have never tasted before! Dense vanilla ice cream paired with classic waffle chunks and generously topped with real bananas, lotus biscoff spread, and biscuits. (Images are for representation purpose only)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/6/37071830-f471-47b2-8f9f-3a8d92e1f505_87a4c3c9-18c6-4cd1-84f9-288b6072a094.png",
                                    "isVeg": 1,
                                    "price": 13000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "11 ratings",
                                        "ratingCountV2": "11"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "67988882"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119016385",
                                    "name": "Berry Red Velvet Sundae (L)",
                                    "category": "Waffle Sundae",
                                    "description": "We love this sundae berry berry much! Enjoy the richness of the red velvet waffle chunks and vanilla ice cream with the blast of fresh strawberry compote and white chocolate spread (Images are for representation purpose only)",
                                    "imageId": "9b6c3c732b7e645f0c0df0891f73aa2e",
                                    "isVeg": 1,
                                    "price": 16000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55814790"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119016388",
                                    "name": "Lotus Biscoff Sundae (L)",
                                    "category": "Waffle Sundae",
                                    "description": "A combination that you have never tasted before! Dense vanilla ice cream paired with classic waffle chunks and generously topped with real bananas, lotus biscoff spread, and biscuits. (Images are for representation purpose only)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/6/37071830-f471-47b2-8f9f-3a8d92e1f505_87a4c3c9-18c6-4cd1-84f9-288b6072a094.png",
                                    "isVeg": 1,
                                    "price": 16000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "67988881"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813080",
                                    "name": "Berry Red Velvet Sundae (S)",
                                    "category": "Waffle Sundae",
                                    "description": "We love this sundae berry berry much! Enjoy the richness of the red velvet waffle chunks and vanilla ice cream with the blast of fresh strawberry compote and white Choco spread (Images are for representation purpose only)",
                                    "imageId": "7ddddec0fb30872828f755002eab4351",
                                    "isVeg": 1,
                                    "price": 13000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.8",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "55814792"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354664"
                          }
                        ],
                        "image": "811ae72fb321c8d62a0246cd1f80ffaf",
                        "categoryId": "69354637"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Beverages",
                        "categories": [
                          {
                            "title": "Shakes",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813046",
                                    "name": "KitKat Shake",
                                    "category": "Beverages",
                                    "description": "A Chocoy Shake topped with Kit Kat bits! (Images are for representation purpose only)",
                                    "imageId": "sqianae2afslhoyodfrq",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612496"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813047",
                                    "name": "Blueberry White Choco Shake",
                                    "category": "Beverages",
                                    "description": "A smoothie blended with bluberries and white chocolate (Images are for representation purpose only)",
                                    "imageId": "ras4pxevvedpkuq0ync7",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.0",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "73638887"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579131",
                                    "name": "Belgian Chocomelt Shake",
                                    "category": "Beverages",
                                    "description": "Your Favourite  Belgian Chocolate shake gets a new name! One of our Darker Choco Shakes made with pure indulgence! (Images are for representation purpose only)",
                                    "imageId": "c5spw0kigqbyh5uq1zl9",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464805"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579242",
                                    "name": "Nutella Shake",
                                    "category": "Beverages",
                                    "description": "Our Signature Shake made with real Nutella! (Images are for representation purpose only)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/9bcc33e4-7cf4-4992-828d-e31a0bbaaced_160957bd-f6fb-48a8-9029-75f8c7370300.png",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612761"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114579149",
                                    "name": "Oreo Shake",
                                    "category": "Beverages",
                                    "description": "Thick shake blended with tons of chocloate Oreos! (Images are for representation purpose only)",
                                    "imageId": "lzuyxde65ewytxvjowlv",
                                    "isVeg": 1,
                                    "price": 17500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612785"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354648"
                          },
                          {
                            "title": "Cold Coffee",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "114578975",
                                    "name": "Signature Cold Coffee",
                                    "category": "Beverages",
                                    "description": "Our Perfectly Balanced Cold Coffee (Images are for representation purpose only)",
                                    "imageId": "dukeorbtr1re1c8taqne",
                                    "isVeg": 1,
                                    "price": 15500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19613051"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354650"
                          },
                          {
                            "title": "Coolers",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813045",
                                    "name": "Peach - Iced Tea",
                                    "category": "Beverages",
                                    "description": "Refreshing peach Iced tea (Images are for representation purpose only)",
                                    "imageId": "fa9byrd8uoyrjjzg4mch",
                                    "isVeg": 1,
                                    "price": 11500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612858"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813044",
                                    "name": "Lemon - Iced Tea",
                                    "category": "Beverages",
                                    "description": "Refreshing Lemon Iced Tea (Images are for representation purpose only)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/400b38ab-4c02-427e-8d54-3070f336b257_5eac2a1e-f7b8-49a9-b7ff-7fc9c10e147c.png",
                                    "isVeg": 1,
                                    "price": 11500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.3",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "19612540"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354652"
                          }
                        ],
                        "image": "sqianae2afslhoyodfrq",
                        "categoryId": "69354629"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "The BWC Store",
                        "categories": [
                          {
                            "title": "Pancake & Waffle Premix",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813076",
                                    "name": "Almond Flour Pancake & Waffle Mix",
                                    "category": "The BWC Store",
                                    "description": "Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice.",
                                    "imageId": "a7570a6f9ba5dfd6d01734c505fc4451",
                                    "isVeg": 1,
                                    "price": 23809,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301320",
                                        "groupName": "Choose From Spreads for Almond Flour Pancake & Waffle Mix",
                                        "choices": [
                                          {
                                            "id": "142226016",
                                            "name": "Milk Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226058",
                                            "name": "Dark Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226082",
                                            "name": "Kiki & Cream Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 23809,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "54789154"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813075",
                                    "name": "Chocolate Oats Pancake & Waffle Mix",
                                    "category": "The BWC Store",
                                    "description": "Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice.",
                                    "imageId": "fcdd253008cf1b491bb50f8b56f6b172",
                                    "isVeg": 1,
                                    "price": 21000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301306",
                                        "groupName": "Choose From Spreads for Chocolate Oats Pancake & Waffle Mix",
                                        "choices": [
                                          {
                                            "id": "142226016",
                                            "name": "Milk Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226058",
                                            "name": "Dark Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226082",
                                            "name": "Kiki & Cream Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 21000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "19611982"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813074",
                                    "name": "Original Pancake & Waffle Mix",
                                    "category": "The BWC Store",
                                    "description": "Now enjoy your favorite, 100% vegetarian, original waffles and pancakes at home with The Belgian Waffle Co. Pancake and Waffle premix. This super easy 3-step premix requires you to just Mix, Cook, and Enjoy! Try our Original, Choco Oats or Almond Flour variants with toppings of your choice.",
                                    "imageId": "2e5753e66c0a1a12a9cc33f0432db7fd",
                                    "isVeg": 1,
                                    "price": 19000,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301289",
                                        "groupName": "Choose From Spreads for Original Pancake & Waffle Mix",
                                        "choices": [
                                          {
                                            "id": "142226016",
                                            "name": "Milk Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226058",
                                            "name": "Dark Chocolate Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226082",
                                            "name": "Kiki & Cream Spread at Rs 275",
                                            "price": 26190,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 3,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 19000,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "19612789"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354682"
                          },
                          {
                            "title": "Spreads",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186052154",
                                    "name": "Milk Chocolate Spread at Rs 275",
                                    "category": "The BWC Store",
                                    "description": "A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/5/8d84499f-730d-4b54-ab1a-58926b298b06_a2aa2da8-f906-4dbc-9856-2eb6bd9a2695.png",
                                    "isVeg": 1,
                                    "price": 26190,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113113286"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186052155",
                                    "name": "Dark Chocolate Spread at Rs 275",
                                    "category": "The BWC Store",
                                    "description": "A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/5/d8f1f99c-e14c-403a-989a-f56195981b1e_d5510752-a24b-4ae9-8991-9ac485e4942a.png",
                                    "isVeg": 1,
                                    "price": 26190,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113113284"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186052156",
                                    "name": "Kiki & Cream Spread at Rs 275",
                                    "category": "The BWC Store",
                                    "description": "A Delicious, Creamy Smooth Spread From Your Favourite The Belgian Waffle Co. Spread It On To Your Favourites Or To Magically Transform Something Into Your New Favorite.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/5/13e36aa2-b9ba-4e2e-9282-f0133d218935_d35162cf-f0de-4a96-aa28-2182dcdba0f5.png",
                                    "isVeg": 1,
                                    "price": 26190,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113113285"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354684"
                          }
                        ],
                        "image": "a7570a6f9ba5dfd6d01734c505fc4451",
                        "categoryId": "69354644"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Waffle/ Pancake with Ice Cream",
                        "categories": [
                          {
                            "title": "Waffle with Ice Cream",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813063",
                                    "name": "Ice Cream & Fudge Vanilla Waffle",
                                    "category": "Waffle/ Pancake with Ice Cream",
                                    "description": "Classic Crispy Waffle + Layer of Choco Fudge Sauce Topped with Vanilla Ice Cream and Choco Fudge Drizzle. A Dreamy Combination!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/547fe5c9-d69f-4400-8b3a-ec5b0f83fc18_9f151b45-f595-4b6b-9951-60d2216d0c61.png",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301153",
                                        "groupName": "Choose From Ice Cream for Ice Cream & Fudge Vanilla Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301154",
                                        "groupName": "Choose From Extra Fillings for Ice Cream & Fudge Vanilla Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301156",
                                        "groupName": "Choose From Coolers for Ice Cream & Fudge Vanilla Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301157",
                                        "groupName": "Choose From Add On for Ice Cream & Fudge Vanilla Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "7 ratings",
                                        "ratingCountV2": "7"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "56204416"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "115813071",
                                    "name": "Ice Cream & Fudge Choco Waffle",
                                    "category": "Waffle/ Pancake with Ice Cream",
                                    "description": "Classic Crispy Waffle + Layer of Choco Fudge Sauce Topped with Choco Ice Cream and Choco Fudge Drizzle. A Dreamy Combination!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/5823ee2c-480d-4923-9af9-6436f82e5ec4_6ca7f6dd-c71f-482c-a435-5cccdeccb752.png",
                                    "isVeg": 1,
                                    "price": 18500,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "259301163",
                                        "groupName": "Choose From Ice Cream for Ice Cream & Fudge Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226090",
                                            "name": "Vanilla Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226038",
                                            "name": "Chocolatey Ice Cream Cup",
                                            "price": 5000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301164",
                                        "groupName": "Choose From Extra Fillings for Ice Cream & Fudge Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226023",
                                            "name": "Milk Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226102",
                                            "name": "Dark Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226100",
                                            "name": "White Chococream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226035",
                                            "name": "Butterscotch Crunch",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226033",
                                            "name": "Coffee Mocha",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226031",
                                            "name": "Peanut Butter Filling",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226029",
                                            "name": "Blueberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226028",
                                            "name": "Strawberry Compote",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226069",
                                            "name": "Honey Drizzle",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226067",
                                            "name": "Maple Syrup",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226042",
                                            "name": "Nutella",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226064",
                                            "name": "Cheesecake Filling",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226053",
                                            "name": "Kiki & Oreo Cream",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226062",
                                            "name": "Almond Cocoa",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226103",
                                            "name": "Caramel Syrup",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226056",
                                            "name": "Mango Compote",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 14,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301167",
                                        "groupName": "Choose From Coolers for Ice Cream & Fudge Choco Waffle",
                                        "choices": [
                                          {
                                            "id": "142226117",
                                            "name": "Lemon - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226119",
                                            "name": "Peach - Iced Tea",
                                            "price": 11500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      },
                                      {
                                        "groupId": "259301169",
                                        "groupName": "Choose From Add On for Ice Cream & Fudge Chocolate Waffle",
                                        "choices": [
                                          {
                                            "id": "142226095",
                                            "name": "Roasted Almonds",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226084",
                                            "name": "Bananas Slices",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226111",
                                            "name": "Fudge Sauce",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226123",
                                            "name": "Biscoff Biscuit",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226065",
                                            "name": "Chocolate Ice Cream & Fudge",
                                            "price": 6000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226071",
                                            "name": "KitKat Bits",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226007",
                                            "name": "Oreos",
                                            "price": 2000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226044",
                                            "name": "Chocolatey Sprinkles",
                                            "price": 1000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "142226049",
                                            "name": "Snickers Pieces",
                                            "price": 4000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 2,
                                        "maxFreeAddons": -1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "98464816"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "69354666"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/3/5/547fe5c9-d69f-4400-8b3a-ec5b0f83fc18_9f151b45-f595-4b6b-9951-60d2216d0c61.png",
                        "categoryId": "69354639"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11425045000235"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "The Belgian Waffle Co.",
                        "area": "Indrapuri Main Rd",
                        "completeAddress": "Shop No.1, Ground Floor, A-34, BHEL, Shaheed Bhagat Singh Market, Sector A, Indrapuri Main Rd, Bhopal, Madhya Pradesh 462023"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "eUSuzH4yJrRp-T1neVjBVhowAsng8mTbk1yVuCEk"
  },

  "79019": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Pizza Hut",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                },
                {
                  "id": "Dineout",
                  "title": "Dineout",
                  "cta": "https://swiggy.com/menu/79019/dineout"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "79019",
                "name": "Pizza Hut",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "pizza-hut-indrapuri-test-bhopal",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/9/1/8ad0381f-48d6-462f-80da-a46058c27345_79019.JPG",
                "locality": "Indrapuri",
                "areaName": "Indrapuri",
                "costForTwo": "35000",
                "costForTwoMessage": "₹350 for two",
                "cuisines": ["Pizzas"],
                "avgRating": 4.2,
                "feeDetails": {
                  "restaurantId": "79019",
                  "fees": [{}]
                },
                "parentId": "721",
                "avgRatingString": "4.2",
                "totalRatingsString": "10K+ ratings",
                "sla": {
                  "restaurantId": "79019",
                  "deliveryTime": 50,
                  "minDeliveryTime": 45,
                  "maxDeliveryTime": 50,
                  "lastMileTravel": 6.7,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 1006,
                  "slaString": "45-50 MINS",
                  "lastMileTravelString": "6.7 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "nextCloseTime": "2026-01-06 04:00:00",
                  "visibility": true,
                  "opened": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "pizza-hut-indrapuri-test-bhopal",
                "multiOutlet": true,
                "isOpen": true,
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Unit No 17B, Ground Floor, Sector-B, Indrapuri, Bhopal, Madhya Pradesh"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Pizzas"
                  }
                ],
                "logo": "Brand logo/PizzaHut",
                "totalRatings": 10000,
                "aggregatedDiscountInfoV2": {
                  "header": "50% off",
                  "shortDescriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "50% off",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Get items under 99",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    }
                  ]
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "priority": 2,
                    "discountInfo": {
                      "discountType": "FinalPrice",
                      "value": 99
                    },
                    "unlockedMessage": "Deal of the Day unlocked!",
                    "minItemCount": 1,
                    "maxItemCount": 1,
                    "type": "SILD",
                    "nudgeTagInfo": {
                      "title": "Deal of the Day",
                      "fontName": "FONT_NAME_CONDENSED_BOLD"
                    },
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/79019"
                },
                "generalPurposeInfoListV2": [
                  {
                    "cta": {
                      "info": {
                        "recordings": {}
                      },
                      "linkCta": {}
                    }
                  }
                ],
                "ratingSlab": "RATING_SLAB_5",
                "orderabilityCommunication": {
                  "title": {},
                  "subTitle": {},
                  "message": {},
                  "customIcon": {},
                  "commsStyling": {}
                },
                "hasBestsellerItems": true,
                "nearestOutletNudge": {
                  "nearestOutletInfo": {
                    "siblingOutlet": {
                      "id": "920945",
                      "city": "0",
                      "slugs": {},
                      "areaName": "TT Nagar",
                      "costForTwo": "0",
                      "feeDetails": {},
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 3,
                        "slaString": "32 MINS",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "restaurantClosedMeta": {}
                      },
                      "aggregatedDiscountInfo": {
                        "visible": true
                      },
                      "badges": {},
                      "aggregatedDiscountInfoV2": {
                        "visible": true
                      },
                      "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                      "cartOrderabilityNudgeBanner": {
                        "parameters": {},
                        "presentation": {}
                      },
                      "featuredSectionInfo": {}
                    }
                  },
                  "nearestOutletComms": {
                    "title": {
                      "text": "Get your order 18 min faster"
                    },
                    "subTitle": {
                      "text": "Switch to the faster outlet"
                    }
                  }
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.2508863,77.46194967",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {},
                "requestContexts": ["enable_ecosaver", "99store"]
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 4,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "FLAT 50% OFF",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["451aad6b-f77a-4a9b-a26a-61133d344905"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "NO CODE REQUIRED",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "79019",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "NO CODE REQUIRED"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "ITEMS AT ₹99",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["800616e5-c608-4c83-b50e-4b84a65d7d71"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "79019",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹80 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["e76113c5-5106-4db4-99b5-eb60705a1267"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT80",
                        "description": "ABOVE ₹249",
                        "offerType": "offers",
                        "restId": "79019",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT80"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "79019",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "50% OFF"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                        "title": "Top Picks",
                        "carousel": [
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7787405",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Paneer Makhni Masala Flatzz Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "190189897",
                                "name": "Paneer Makhni Masala Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Masala Paneer, Onions, Green Chilli, Red Bell Pepper, Makhni Sauce, Mint Sauce Drizzle (273 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/22/4c73b33a-7a3f-4933-a8b9-e0cd2852dc0d_3cf3ffb7-1d10-4bcc-b76a-0869285c6c85.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703614",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177014",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703615",
                                            "variationId": "208177015"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703615",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 359,
                                          "default": 1,
                                          "id": "208177015",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703614",
                                          "variationId": "208177014"
                                        },
                                        {
                                          "groupId": "69703615",
                                          "variationId": "208177015"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194302",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194302",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "116156647"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7788485",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Overloaded Veggies Flatzz Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "190189899",
                                "name": "Overloaded Veggies Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Capsicum, Onion, Corn, Tomato, Jalapeno, Olives, Texas Garlic Drizzle (242.9 kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/15dfb988-6aab-4d54-8c16-f4ebd50542ee_e681b79b-7464-43f2-a279-56402ba33fbc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703618",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177018",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703619",
                                            "variationId": "208177019"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703619",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 359,
                                          "default": 1,
                                          "id": "208177019",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703618",
                                          "variationId": "208177018"
                                        },
                                        {
                                          "groupId": "69703619",
                                          "variationId": "208177019"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194306",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194306",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "116156646"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7785771",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Ultimate Flatzz Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "190189901",
                                "name": "Ultimate Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Chicken Sausage, Chicken Pepperoni, Herbed Onion, Tomatoes, Duo Peppers - Green & Red, Texas Garlic Drizzle (256.1 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/b2bbc0c8-2a34-4102-ae9d-d01c4e6970e2_af469a0c-2a32-4920-9966-96c97f3846ed.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703622",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177022",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703623",
                                            "variationId": "208177023"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703623",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 399,
                                          "default": 1,
                                          "id": "208177023",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703622",
                                          "variationId": "208177022"
                                        },
                                        {
                                          "groupId": "69703623",
                                          "variationId": "208177023"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194312",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194312",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "115709729"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7789054",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Tandoori Chicken Flatzz Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "190189902",
                                "name": "Tandoori Chicken Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Tikka Duo - Chicken Tikka & Chicken Malai Tikka, Duo Peppers - Green & Red , Tandoori Sauce, Mint Drizzle (258.1 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/22/48ae26de-9502-4614-9d95-6a2dc335715b_a8db7712-44f4-4aa7-91fb-13e1e1a50264.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703624",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177024",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703625",
                                            "variationId": "208177025"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703625",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 399,
                                          "default": 1,
                                          "id": "208177025",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703624",
                                          "variationId": "208177024"
                                        },
                                        {
                                          "groupId": "69703625",
                                          "variationId": "208177025"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194315",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194315",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "116156649"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7790232",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Tandoori Paneer Ultimate Cheese Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "183131299",
                                "name": "Tandoori Paneer Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Spiced paneer, paprika, onions, capsicum, tandoori sauce, extra molten cheese and a melty gooey cheese crown on the crust, you’ll want to Flip to the Cheese first. (345.4Kcal/100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/feb4705b-1f7a-4f28-aeb3-ab5b072b47c8_caee536d-2261-44f2-bfda-190f8a01c4ea.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509623",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987705",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509624",
                                            "variationId": "200987706"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509624",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "default": 1,
                                          "id": "200987706",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987708",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509623",
                                          "variationId": "200987705"
                                        },
                                        {
                                          "groupId": "66509624",
                                          "variationId": "200987706"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741073",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741071",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509623",
                                          "variationId": "200987705"
                                        },
                                        {
                                          "groupId": "66509624",
                                          "variationId": "200987708"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741073",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741070",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741071",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741072",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741073",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741074",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "111067040"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "type": "TopCarousel",
                            "subtype": "image",
                            "bannerId": "7790310",
                            "creativeId": "TopPicks/PrDiGiftHamper",
                            "title": "Chicken Tikka Ultimate Cheese Pizza",
                            "description": "  ",
                            "fontColor": "#FFFFFF",
                            "dish": {
                              "info": {
                                "id": "183131297",
                                "name": "Chicken Tikka Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Tandoori-spiced chicken tikka, onion, tomato, tandoori sauce, extra molten cheese and a melty gooey cheese crown on the crust, you’ll want to Flip to the Cheese first. (277.7Kcal / 100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/3b4ba01a-924f-4c66-a42b-91545bfe3c27_fd02cf9f-6777-4ffe-becf-e3d22a5da939.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509619",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987689",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509620",
                                            "variationId": "200987690"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509620",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "default": 1,
                                          "id": "200987690",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987691",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509619",
                                          "variationId": "200987689"
                                        },
                                        {
                                          "groupId": "66509620",
                                          "variationId": "200987690"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741062",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "244741058",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509619",
                                          "variationId": "200987689"
                                        },
                                        {
                                          "groupId": "66509620",
                                          "variationId": "200987691"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741062",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741059",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741058",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741060",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741061",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741062",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741063",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741064",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {},
                                "itemBadge": {},
                                "badgesV2": {},
                                "parentId": "111067037"
                              },
                              "analytics": {},
                              "restaurant": {
                                "info": {
                                  "dishStyle": {
                                    "socialMarkerStyle": [
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                        "title": "Protein Rich",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "brand_proteinator_primary"
                                      },
                                      {
                                        "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                        "title": "Bestseller",
                                        "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                        "textColor": "color_swiggy_one"
                                      }
                                    ]
                                  }
                                }
                              },
                              "hideRestaurantDetails": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Recommended",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073728",
                                "name": "Margherita",
                                "category": "Veg Pizza",
                                "description": "Pizza topped with our herb-infused signature pan sauce and mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ef2f1053-c8e3-4072-aaa7-4539a67c8554_e8da5065-4d03-47d7-bad7-5413398a1564.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848793",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136720031",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720034"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987417",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "200987419"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136720032",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720035"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136720033",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720036"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848794",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 244,
                                          "id": "200987419",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 169,
                                          "default": 1,
                                          "id": "136720034",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 428,
                                          "id": "200987421",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 244,
                                          "id": "136720035",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 479,
                                          "id": "136720036",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 329,
                                          "id": "136720037",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 428,
                                          "id": "136720038",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720031"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720034"
                                        }
                                      ],
                                      "price": 16900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720031"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720037"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "200987417"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "200987419"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "200987417"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "200987421"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720032"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720035"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720032"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720038"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720033"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720036"
                                        }
                                      ],
                                      "price": 47900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817623",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817619",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817623",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433460",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255681",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540979",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540992",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "276 ratings",
                                    "ratingCountV2": "276"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607978"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073805",
                                "name": "Veggie Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Herbed onion and green capsicum, juicy sweet corn & mozzarella cheese with flavourful pan sauce (PAN Per/Med-269 Kcal/100g | TnC-274 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ee9985e4-828b-4a0e-b99b-656442e80877_7492ef8f-5b57-4ca4-86e6-4a8981c38510.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848807",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136720090",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720093"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987584",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "200987585"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136720091",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720094"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136720092",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720095"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848808",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "200987585",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 259,
                                          "default": 1,
                                          "id": "136720093",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987586",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "136720094",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 649,
                                          "id": "136720095",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 489,
                                          "id": "136720096",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "136720097",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720090"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720093"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720090"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720096"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "200987584"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "200987585"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "200987584"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "200987586"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720091"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720094"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720091"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720097"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720092"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720095"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817754",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817748",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817754",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433481",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255697",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541368",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541373",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "147 ratings",
                                    "ratingCountV2": "147"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609373"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073779",
                                "name": "Tandoori Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | It's our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/92cfd7cf-0504-4444-befc-ff4aee0486cd_bac2d634-a13d-4cc3-828e-b2ad12dc73c0.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42703917",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136391328",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391331"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987368",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "200987369"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136391329",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391332"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136391330",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391333"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42703918",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987369",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136391331",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987370",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136391332",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136391333",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136391334",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136391335",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391328"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391331"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391328"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391334"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "200987368"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "200987369"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "200987368"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "200987370"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391329"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391332"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391329"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391335"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391330"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391333"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817806",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817799",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817806",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433469",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "154483240",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540845",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540853",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "130 ratings",
                                    "ratingCountV2": "130"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608985"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073646",
                                "name": "Country Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Loaded with herbed onion & green capsicum, sweet corn, tomato with signature pan sauce and mozzarella cheese. It's a feast you can't refuse (PAN Per/Med-244 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/78bc0268-a19e-4c65-8ea2-4b4626898698_c52e5d95-51c4-4239-92b0-70b1ab93d12f.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848756",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136719934",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719937"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987657",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "200987658"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136719935",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719938"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136719936",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719940"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848757",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987658",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136719937",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987661",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136719938",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136719940",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136719941",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136719942",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719934"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719937"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719934"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719941"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "200987657"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "200987658"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "200987657"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "200987661"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719935"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719938"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719935"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719942"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719936"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719940"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817516",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817518",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817516",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433458",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255632",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540693",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540701",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607392"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114714935",
                                "name": "Veggie Supreme",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/2f6b03bf-3bb0-40cd-a5b8-7f0cfdf21998_7cc4fe8f-d5f8-44ed-ada9-0a719fc4d89f.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "43007375",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "137153163",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153166"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987614",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "200987615"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "137153164",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153167"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "137153165",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153168"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "43007376",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987615",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "137153166",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987616",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "137153167",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "137153168",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "137153169",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "137153170",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153163"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153166"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153163"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153169"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "200987614"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "200987615"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "200987614"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "200987616"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153164"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153167"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153164"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153170"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153165"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153168"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817731",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817728",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817731",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433529",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155993574",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540433",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540450",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "57 ratings",
                                    "ratingCountV2": "57"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073593",
                                "name": "Chicken Sausage",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Pizza topped with chicken n cheese sausages & crunchy onions, flavourful pan sauce and mozzarella cheese (PAN Per/Med-310 Kcal/100g | TnC-312 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/4b4ded4e-1e01-4d35-bebd-b055a22cb43a_2b6ef11b-6134-4744-87d5-9f49a9042d50.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798586",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641985",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642002"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641990",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642004"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987497",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "200987498"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641998",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642008"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798588",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "200987498",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 259,
                                          "default": 1,
                                          "id": "173642002",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "173642004",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987499",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 649,
                                          "id": "173642008",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 489,
                                          "id": "173642010",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "173642012",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641985"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642002"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641985"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642010"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641990"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642004"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641990"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642012"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "200987497"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "200987498"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "200987497"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "200987499"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641998"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642008"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700294",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700284",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700294",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700300",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700306",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700312",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700319",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700321",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700325",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700330",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607039"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "72273084",
                                "name": "Murg Malai Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Amazingly flavourful chicken malai tikka, herbed onion & green capsicum, spicy red paprika with flavourful pan sauce and mozzarella cheese (PAN Per/Med-269 Kcal/100g | TnC-299 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/a17de87b-9413-49b6-9982-42a676e8cbab_6e749005-f69b-4754-a229-18681a4f03c8.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798548",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641785",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641793"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641787",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641795"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987515",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "200987516"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641790",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641799"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798550",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987516",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "173641793",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "173641795",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987517",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "173641799",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "173641801",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "173641803",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641785"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641793"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641785"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641801"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641787"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641795"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641787"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641803"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "200987515"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "200987516"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "200987515"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "200987517"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641790"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641799"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700114",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700106",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700114",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700117",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700122",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700128",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700132",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700137",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700143",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700149",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066910"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114714940",
                                "name": "Chicken Supreme",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Loaded with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and mozzarella cheese. (PAN Per/Med-273 Kcal/100g | TnC-284 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/e4d15638-5d14-444b-96ce-0314b1d4b0dc_e626776a-fa5d-4302-9c53-58893fe5c90d.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798565",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641882",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641886"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641883",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641887"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987599",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "200987600"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641885",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641889"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798566",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987600",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173641886",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173641887",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987601",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173641889",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173641890",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173641891",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641882"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641886"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641882"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641890"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641883"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641887"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641883"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641891"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "200987599"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "200987600"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "200987599"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "200987601"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641885"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641889"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700200",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700194",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700200",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700202",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700207",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700216",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700223",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700229",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700234",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700240",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607147"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073795",
                                "name": "Triple Chicken Feast",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Spicy schezwan chicken meatball, flavourful herbed chicken, juicy chicken sausage, green capsicum & onion, spicy red paprika with classic pan sauce and mozzarella cheese (PAN Per/Med-262 Kcal/100g | TnC-277 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/cef96188-c26a-4706-9843-5d03f41ba7cb_00643046-5886-4012-964f-010fa22f50d1.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798495",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641497",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641501"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641498",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641502"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987458",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "200987459"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641500",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641504"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798496",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987459",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173641501",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173641502",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987460",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173641504",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173641505",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173641506",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641497"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641501"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641497"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641505"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641498"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641502"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641498"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641506"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "200987458"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "200987459"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "200987458"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "200987460"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641500"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641504"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204699849",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699855",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699857",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699861",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699864",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699866",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699872",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699877",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609105"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "117545724",
                                "name": "Classic Onion Capsicum",
                                "category": "Flavour Fun Pizzas",
                                "description": "Serves 1 | Pizza topped with our classic pan sauce, crunchy onion & capsicum and a flavourful dressing. (307 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/43d430bb-cf34-4230-b88e-8784728fd3ef_06fd1528-17e2-418e-bc67-d7e7b8e493bf.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "finalPrice": 9900,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "28707817",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "90376529",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "28707818",
                                            "variationId": "90376530"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "28707818",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 109,
                                          "default": 1,
                                          "id": "90376530",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "28707817",
                                          "variationId": "90376529"
                                        },
                                        {
                                          "groupId": "28707818",
                                          "variationId": "90376530"
                                        }
                                      ],
                                      "price": 10900,
                                      "finalPrice": {
                                        "units": "99"
                                      }
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "1114 ratings",
                                    "ratingCountV2": "1.1K+"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "800616e5-c608-4c83-b50e-4b84a65d7d71"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "47040143"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133110494",
                                "name": "Cheesy Spicy Delight",
                                "category": "Flavour Fun Pizzas",
                                "description": "Pizza topped with mozzarella cheese, a flavourful dressing, onion and spicy green chilli, sprinkled with our signature spiced seasoning. (367 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/78fc6391-10f2-45b3-afd4-416a3bfb8260_dc58c551-a663-4499-b951-99b287116ced.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37431628",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117075147",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37431629",
                                            "variationId": "117075148"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37431629",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 169,
                                          "default": 1,
                                          "id": "117075148",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37431628",
                                          "variationId": "117075147"
                                        },
                                        {
                                          "groupId": "37431629",
                                          "variationId": "117075148"
                                        }
                                      ],
                                      "price": 16900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "69 ratings",
                                    "ratingCountV2": "69"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "77519006"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133110497",
                                "name": "Chilli Paneer Sizzle",
                                "category": "Flavour Fun Pizzas",
                                "description": "Pizza topped with spiced paneer, a spicy Schezwan sauce, juicy tomato, crunchy onion & capsicum and a flavourful dressing. (298 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/4cbb05b7-a58e-41e5-9ac9-6e1dd9c7e64f_b046f848-fbdf-43dd-9a50-39a2528d2eab.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37431634",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117075153",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37431635",
                                            "variationId": "117075154"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37431635",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 189,
                                          "default": 1,
                                          "id": "117075154",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37431634",
                                          "variationId": "117075153"
                                        },
                                        {
                                          "groupId": "37431635",
                                          "variationId": "117075154"
                                        }
                                      ],
                                      "price": 18900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "201 ratings",
                                    "ratingCountV2": "201"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "77519007"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133110500",
                                "name": "Classic Chicken Pepperoni & Onion",
                                "category": "Flavour Fun Pizzas",
                                "description": "Pizza topped with our classic signature pan sauce, chicken pepperoni, crunchy onion and a flavourful dressing. (332 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/e6f4237a-55ab-46a4-adbe-cbf79541416f_ef441d3e-0f31-4c12-b114-08a564de7ee9.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37431640",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117075159",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37431641",
                                            "variationId": "117075160"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37431641",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 159,
                                          "default": 1,
                                          "id": "117075160",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37431640",
                                          "variationId": "117075159"
                                        },
                                        {
                                          "groupId": "37431641",
                                          "variationId": "117075160"
                                        }
                                      ],
                                      "price": 15900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 15900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "77519008"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133110499",
                                "name": "Classic Herbed Chicken & Capsicum",
                                "category": "Flavour Fun Pizzas",
                                "description": "Pizza topped with our classic signature pan sauce, herbed chicken, crunchy capsicum and a flavourful dressing. (331 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/4bd67a36-e254-489a-9519-3118951e5b11_1a56a4d2-72dd-46cc-aa17-8c806f086c91.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37431638",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117075157",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37431639",
                                            "variationId": "117075158"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37431639",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 179,
                                          "default": 1,
                                          "id": "117075158",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37431638",
                                          "variationId": "117075157"
                                        },
                                        {
                                          "groupId": "37431639",
                                          "variationId": "117075158"
                                        }
                                      ],
                                      "price": 17900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "77519009"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "133110498",
                                "name": "Chatpata Chicken Feast",
                                "category": "Flavour Fun Pizzas",
                                "description": "Pizza topped with a spicy tandoori sauce, Schezwan chicken meatballs, crunchy onion & capsicum, green chilli, juicy tomato and a flavourful dressing. (294 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/d0247064-0689-49fc-b382-fed753d47f28_61e83c62-d60d-456b-aa27-b83f2f89082a.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "37431636",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "117075155",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "37431637",
                                            "variationId": "117075156"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "37431637",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 199,
                                          "default": 1,
                                          "id": "117075156",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "37431636",
                                          "variationId": "117075155"
                                        },
                                        {
                                          "groupId": "37431637",
                                          "variationId": "117075156"
                                        }
                                      ],
                                      "price": 19900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "16 ratings",
                                    "ratingCountV2": "16"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "77519004"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114788276",
                                "name": "Sprinkled Fries - New",
                                "category": "Appetizers",
                                "description": "Serves 1 | Baked fries seasoned with our signature peruvian seasoning (204 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/366ad3ca-9597-4f0a-aa87-66ff29d4204d_8ee697df-7baa-49df-87dc-d6277bcf73fa.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66114575"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "55978472",
                                "name": "Spicy Baked Chicken Wings 4pc",
                                "category": "Appetizers",
                                "description": "Serves 1 | 4 pcs of tender and juicy sweet chilly chicken wings (189 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/03653d71-0f72-4f8d-9bb0-c96d8038ee7d_21b9ecf2-4aeb-49d9-a513-54140c5c4a8a.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608911"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "119746530",
                                "name": "Brow-wow-nie",
                                "category": "Drinks & Desserts",
                                "description": "Serves 1 | A divine choco brownie for your all time chocolate cravings (273 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/c99e2359-999f-410a-be36-89f5dd86fc4e_be0bb96e-ae2b-405a-abaa-a80f7551c3a5.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "68626769"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "22019365",
                                "name": "Choco Volcano",
                                "category": "Drinks & Desserts",
                                "description": "Serves 1 | Warm choco cake with gooey center (262 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/f70ec3a0-baa2-4b7d-a1f3-2f16c10028c3_f127c54f-8b53-45f1-b92f-a62e650bf334.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "showImage": true,
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "207 ratings",
                                    "ratingCountV2": "207"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607330"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "type": "CATEGORY_TYPE_RECOMMENDED",
                        "subtitleSuffix": {},
                        "categoryId": "-1"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "New Flatzz Pizzas - Light Crust, Big Flavour",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191094125",
                                "name": "3 in 1 Flatzz Pizzas – Veg",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Serves 3. 1 Schezwan Veggie Flatzz Pizza, 1 Tandoori Paneer Flatzz Pizza & 1 BBQ Veggie Fiesta Flatzz Pizza. For this meal, refer to the nutritional data for individual products",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/1/4f2e96fc-4b81-40fd-b1cd-c2b8ab722aee_7c9d68e2-0d94-4c53-a3c2-adb5eb1cfbf4.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "70268806",
                                      "name": "1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Schezwan Veggie",
                                          "price": 339,
                                          "default": 1,
                                          "id": "209442006",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "70268807",
                                            "variationId": "209442007"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "70268807",
                                      "name": "2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Tandoori Paneer",
                                          "price": 339,
                                          "default": 1,
                                          "id": "209442007",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "70268808",
                                            "variationId": "209442008"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "70268808",
                                      "name": "3rd Pizza",
                                      "variations": [
                                        {
                                          "name": "BBQ Veggie Fiesta",
                                          "price": 339,
                                          "default": 1,
                                          "id": "209442008",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "70268806",
                                          "variationId": "209442006"
                                        },
                                        {
                                          "groupId": "70268807",
                                          "variationId": "209442007"
                                        },
                                        {
                                          "groupId": "70268808",
                                          "variationId": "209442008"
                                        }
                                      ],
                                      "price": 101700
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 101700,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115248215"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "191094126",
                                "name": "3 in 1 Flatzz Pizzas – Non-Veg",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Serves 3. 1 Masala Keema Flatzz Pizza, 1 Ultimate Flatzz Pizza & 1 Tandoori Chicken Flatzz Pizza. For this meal, refer to the nutritional data for individual products",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/1/d4a1170e-1c7a-4333-a802-b5d6586b8d42_ccf36e9a-f0e4-47b0-8e37-a2abc2f1940b.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "70268809",
                                      "name": "1st Pizza",
                                      "variations": [
                                        {
                                          "name": "Masala Keema",
                                          "price": 399,
                                          "default": 1,
                                          "id": "209442009",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "70268810",
                                            "variationId": "209442010"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "70268810",
                                      "name": "2nd Pizza",
                                      "variations": [
                                        {
                                          "name": "Ultimate",
                                          "price": 399,
                                          "default": 1,
                                          "id": "209442010",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "70268811",
                                            "variationId": "209442011"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "70268811",
                                      "name": "3rd Pizza",
                                      "variations": [
                                        {
                                          "name": "Tandoori Chicken",
                                          "price": 399,
                                          "default": 1,
                                          "id": "209442011",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "70268809",
                                          "variationId": "209442009"
                                        },
                                        {
                                          "groupId": "70268810",
                                          "variationId": "209442010"
                                        },
                                        {
                                          "groupId": "70268811",
                                          "variationId": "209442011"
                                        }
                                      ],
                                      "price": 119700
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 119700,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115248214"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189896",
                                "name": "Fiery Schezwan Veggie Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Mushroom, Duo Peppers-Red and Green, Onion, Schezwan Sauce (263.7 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/c844dbd8-4162-4537-b5c1-b2c07ab4083f_aea1c3c2-805c-4910-aba8-1dddfa3fa4b3.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703612",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177012",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703613",
                                            "variationId": "208177013"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703613",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 329,
                                          "default": 1,
                                          "id": "208177013",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703612",
                                          "variationId": "208177012"
                                        },
                                        {
                                          "groupId": "69703613",
                                          "variationId": "208177013"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194300",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194300",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194300",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194300",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194300",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115709724"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189897",
                                "name": "Paneer Makhni Masala Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Masala Paneer, Onions, Green Chilli, Red Bell Pepper, Makhni Sauce, Mint Sauce Drizzle (273 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/22/4c73b33a-7a3f-4933-a8b9-e0cd2852dc0d_3cf3ffb7-1d10-4bcc-b76a-0869285c6c85.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703614",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177014",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703615",
                                            "variationId": "208177015"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703615",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 359,
                                          "default": 1,
                                          "id": "208177015",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703614",
                                          "variationId": "208177014"
                                        },
                                        {
                                          "groupId": "69703615",
                                          "variationId": "208177015"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194302",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194302",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194302",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "116156647"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189898",
                                "name": "Smokey BBQ Veggie Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Exotic Veggie Mix, Corn, White Pizza Sauce, BBQ Drizzle (257.6 kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/d194214c-33a2-4574-b55a-6783443dcef9_1b2a6a6e-6ebe-453b-919c-a39acae63ae8.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703616",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177016",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703617",
                                            "variationId": "208177017"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703617",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 329,
                                          "default": 1,
                                          "id": "208177017",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703616",
                                          "variationId": "208177016"
                                        },
                                        {
                                          "groupId": "69703617",
                                          "variationId": "208177017"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194304",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194304",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194304",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194304",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194304",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "116156648"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189899",
                                "name": "Overloaded Veggies Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Capsicum, Onion, Corn, Tomato, Jalapeno, Olives, Texas Garlic Drizzle (242.9 kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/15dfb988-6aab-4d54-8c16-f4ebd50542ee_e681b79b-7464-43f2-a279-56402ba33fbc.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703618",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177018",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703619",
                                            "variationId": "208177019"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703619",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 359,
                                          "default": 1,
                                          "id": "208177019",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703618",
                                          "variationId": "208177018"
                                        },
                                        {
                                          "groupId": "69703619",
                                          "variationId": "208177019"
                                        }
                                      ],
                                      "price": 35900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194306",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194306",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194306",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "116156646"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189900",
                                "name": "Keema Masala Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Chicken Keema, Onion, Red Paprika, Green Capsicum, Makhni Sauce, Mint Sauce Drizzle (275.8 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/8906f07a-66cb-4479-9593-0ccf891fde62_f8afa7f6-1dc9-45bc-b430-1129f6d27300.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703620",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177020",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703621",
                                            "variationId": "208177021"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703621",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 399,
                                          "default": 1,
                                          "id": "208177021",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703620",
                                          "variationId": "208177020"
                                        },
                                        {
                                          "groupId": "69703621",
                                          "variationId": "208177021"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194309",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194309",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194309",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194309",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194309",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "116156645"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189901",
                                "name": "Ultimate Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Chicken Sausage, Chicken Pepperoni, Herbed Onion, Tomatoes, Duo Peppers - Green & Red, Texas Garlic Drizzle (256.1 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/18/b2bbc0c8-2a34-4102-ae9d-d01c4e6970e2_af469a0c-2a32-4920-9966-96c97f3846ed.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703622",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177022",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703623",
                                            "variationId": "208177023"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703623",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 399,
                                          "default": 1,
                                          "id": "208177023",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703622",
                                          "variationId": "208177022"
                                        },
                                        {
                                          "groupId": "69703623",
                                          "variationId": "208177023"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194312",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194312",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194312",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "115709729"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "190189902",
                                "name": "Tandoori Chicken Flatzz Pizza",
                                "category": "New Flatzz Pizzas - Light Crust, Big Flavour",
                                "description": "Mozzarella Cheese, Tikka Duo - Chicken Tikka & Chicken Malai Tikka, Duo Peppers - Green & Red , Tandoori Sauce, Mint Drizzle (258.1 Kcal/100gm)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/22/48ae26de-9502-4614-9d95-6a2dc335715b_a8db7712-44f4-4aa7-91fb-13e1e1a50264.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "69703624",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Crafted-Flatzz",
                                          "default": 1,
                                          "id": "208177024",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "69703625",
                                            "variationId": "208177025"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "69703625",
                                      "name": "Choose Your Size",
                                      "variations": [
                                        {
                                          "name": "Oval 10in",
                                          "price": 399,
                                          "default": 1,
                                          "id": "208177025",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "69703624",
                                          "variationId": "208177024"
                                        },
                                        {
                                          "groupId": "69703625",
                                          "variationId": "208177025"
                                        }
                                      ],
                                      "price": 39900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "264194315",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "264194315",
                                          "addonId": "101431064"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "264194315",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 39900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "116156649"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2026/1/1/4f2e96fc-4b81-40fd-b1cd-c2b8ab722aee_7c9d68e2-0d94-4c53-a3c2-adb5eb1cfbf4.jpg",
                        "categoryId": "70237678"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Veg Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285230",
                                "name": "Schezwan Margherita",
                                "category": "Veg Pizza",
                                "description": "Serves 2 | Your very own margherita, now with a spicy twist! Loaded with our signature spicy schezwan sauce & mozzarella cheese (PAN Per/Med-300 Kcal/100g | TnC-309 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/d718f493-f644-410a-b6e8-46ef517f5950_b3be8e09-8ec3-483f-b688-f5ab2b7b1bbd.png_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42808447",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136633272",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808448",
                                            "variationId": "136633275"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987407",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808448",
                                            "variationId": "200987408"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136633273",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808448",
                                            "variationId": "136633276"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136633274",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808448",
                                            "variationId": "136633277"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42808448",
                                      "name": "Choose Size (Pan)",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 294,
                                          "id": "200987408",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal,",
                                          "price": 219,
                                          "default": 1,
                                          "id": "136633275",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 508,
                                          "id": "200987409",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 294,
                                          "id": "136633276",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 575,
                                          "id": "136633277",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium,",
                                          "price": 409,
                                          "id": "136633278",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 508,
                                          "id": "136633279",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "136633272"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "136633275"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914691",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "136633272"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "136633278"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914692",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "200987407"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "200987408"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914691",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "200987407"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "200987409"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914692",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "136633273"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "136633276"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989942",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914691",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "136633273"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "136633279"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914692",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543302",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808447",
                                          "variationId": "136633274"
                                        },
                                        {
                                          "groupId": "42808448",
                                          "variationId": "136633277"
                                        }
                                      ],
                                      "price": 57500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543293",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543293",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914693",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433495",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150914691",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150914693",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433495",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "154989942",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543293",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543302",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "20 ratings",
                                    "ratingCountV2": "20"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "65363967"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285231",
                                "name": "Mexican Fiesta",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Flavourful mix of red capsicum, green capsicum, jalapeno, onion, black olives, sweet corn and mozzarella cheese with a signature spice sprinkle & our flavourful pan sauce (PAN Per/Med-266 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/7c9490c2-f3bb-4287-a7d8-c931d0a3d26c_1b42f971-a95b-4f5a-989d-367e57c81e59.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42808479",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136633424",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808480",
                                            "variationId": "136633427"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987362",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808480",
                                            "variationId": "200987363"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136633425",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808480",
                                            "variationId": "136633428"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136633426",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42808480",
                                            "variationId": "136633429"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42808480",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987363",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136633427",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987364",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136633428",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136633429",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136633430",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136633431",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "136633424"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "136633427"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914698",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "136633424"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "136633430"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914699",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "200987362"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "200987363"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914698",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "200987362"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "200987364"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914699",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "136633425"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "136633428"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154989950",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914698",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "136633425"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "136633431"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914699",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543357",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42808479",
                                          "variationId": "136633426"
                                        },
                                        {
                                          "groupId": "42808480",
                                          "variationId": "136633429"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543332",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543332",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914700",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433470",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150914698",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150914700",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433470",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "154989950",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543332",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543357",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "30 ratings",
                                    "ratingCountV2": "30"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066909"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319065",
                                "name": "Bold BBQ Veggies",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Our signature pan sauce, with BBQ Sauce drizzle, topped with mushroom, onion, green capsicum, & red paprika (PAN Per/Med-242 Kcal/100g | TnC-266 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/fadeba2d-637a-4dda-8173-8e73df9c6f84_9aef4e12-c06a-4593-9a4e-46f1861124ee.jpeg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848752",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136719924",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848753",
                                            "variationId": "136719927"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987398",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848753",
                                            "variationId": "200987400"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136719925",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848753",
                                            "variationId": "136719928"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136719926",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848753",
                                            "variationId": "136719929"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848753",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987400",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136719927",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987401",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136719928",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136719929",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136719930",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136719931",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "136719924"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "136719927"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914724",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "136719924"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "136719930"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914727",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "200987398"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "200987400"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914724",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "200987398"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "200987401"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914727",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "136719925"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "136719928"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255620",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "150914724",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "136719925"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "136719931"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914727",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "150914732",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848752",
                                          "variationId": "136719926"
                                        },
                                        {
                                          "groupId": "42848753",
                                          "variationId": "136719929"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "155255622",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "155255622",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "150914729",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140222076",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "150914724",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150914729",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140222076",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255620",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255622",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "150914732",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79042376"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285233",
                                "name": "Ultimate Tandoori Veggie",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | An ultimate combination of your favourite veggies-onion, green capsicum, mushroom, tomato, spicy jalapeno on tandoori sauce, topped with mozzarella cheese & generous drizzle of mint mayo (PAN Per/Med-314 Kcal/100g | TnC-395 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/106171b3-4470-4db2-af5b-c92b65f5c8a0_2b0083a2-01ca-4454-a529-0f1560b3833a.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42748823",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136505341",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42748824",
                                            "variationId": "136505344"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987491",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42748824",
                                            "variationId": "200987492"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136505342",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42748824",
                                            "variationId": "136505345"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136505343",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42748824",
                                            "variationId": "136505346"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42748824",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987492",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "136505344",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987493",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "136505345",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "136505346",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "136505347",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "136505348",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "136505341"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "136505344"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817610",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "136505341"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "136505347"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817611",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "200987491"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "200987492"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817610",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "200987491"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "200987493"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817611",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "136505342"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "136505345"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154722556",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817610",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "136505342"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "136505348"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817611",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543464",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42748823",
                                          "variationId": "136505343"
                                        },
                                        {
                                          "groupId": "42748824",
                                          "variationId": "136505346"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543456",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543456",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817612",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433486",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817610",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817612",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433486",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "154722556",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543456",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543464",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066915"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285235",
                                "name": "Mazedar Makhni Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A treat for all makhni lovers. Spiced paneer, onion, juicy red bell peppers with our new flavourful makhni sauce, topped with mozzarella cheese and buttery spice sprinkle (PAN Per/Med-288 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/19/9dc55b5a-3f2e-4200-bb47-373f260e6989_e9d3d572-d03b-47ba-b072-7ebe80e4461b.jpeg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "43007331",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "137152950",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007332",
                                            "variationId": "137152953"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987470",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007332",
                                            "variationId": "200987471"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "137152951",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007332",
                                            "variationId": "137152954"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "137152952",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007332",
                                            "variationId": "137152955"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "43007332",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987471",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "137152953",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987472",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "137152954",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "137152955",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "137152956",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "137152957",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "137152950"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "137152953"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817476",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "137152950"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "137152956"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817477",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "200987470"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "200987471"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817476",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "200987470"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "200987472"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817477",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "137152951"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "137152954"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993563",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817476",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "137152951"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "137152957"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817477",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114543535",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007331",
                                          "variationId": "137152952"
                                        },
                                        {
                                          "groupId": "43007332",
                                          "variationId": "137152955"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114543525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114543525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817479",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433509",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817476",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817479",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433509",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155993563",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543525",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114543535",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066908"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073728",
                                "name": "Margherita",
                                "category": "Veg Pizza",
                                "description": "Pizza topped with our herb-infused signature pan sauce and mozzarella cheese. A classic treat for all cheese lovers out there! (PAN Per/Med-292 Kcal/100g | TnC-293 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ef2f1053-c8e3-4072-aaa7-4539a67c8554_e8da5065-4d03-47d7-bad7-5413398a1564.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848793",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136720031",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720034"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987417",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "200987419"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136720032",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720035"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136720033",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848794",
                                            "variationId": "136720036"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848794",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 244,
                                          "id": "200987419",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 169,
                                          "default": 1,
                                          "id": "136720034",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 428,
                                          "id": "200987421",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 244,
                                          "id": "136720035",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 479,
                                          "id": "136720036",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 329,
                                          "id": "136720037",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 428,
                                          "id": "136720038",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720031"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720034"
                                        }
                                      ],
                                      "price": 16900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720031"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720037"
                                        }
                                      ],
                                      "price": 32900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "200987417"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "200987419"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "200987417"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "200987421"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720032"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720035"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255681",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817619",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720032"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720038"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817621",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540992",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848793",
                                          "variationId": "136720033"
                                        },
                                        {
                                          "groupId": "42848794",
                                          "variationId": "136720036"
                                        }
                                      ],
                                      "price": 47900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540979",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540979",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817623",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433460",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817619",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817623",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433460",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255681",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540979",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540992",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "276 ratings",
                                    "ratingCountV2": "276"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607978"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "72273188",
                                "name": "Corn & Cheese",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A combination of juicy sweet corn & mozzarella cheese with flavourful signature pan sauce (PAN Per/Med-320 Kcal/100g | TnC-304 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/8267ff21-1cc8-418a-9e28-e47b0bb7efef_5cf4f617-9ce2-42d2-a8e3-23e1114c99e2.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42506251",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "135859952",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42506252",
                                            "variationId": "135859955"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987635",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42506252",
                                            "variationId": "200987636"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "135859953",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42506252",
                                            "variationId": "135859956"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "135859954",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42506252",
                                            "variationId": "135859957"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42506252",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 294,
                                          "id": "200987636",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 219,
                                          "default": 1,
                                          "id": "135859955",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 508,
                                          "id": "200987637",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 294,
                                          "id": "135859956",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 575,
                                          "id": "135859957",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 409,
                                          "id": "135859958",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 508,
                                          "id": "135859959",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "135859952"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "135859955"
                                        }
                                      ],
                                      "price": 21900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817711",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "135859952"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "135859958"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817713",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "200987635"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "200987636"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817711",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "200987635"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "200987637"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817713",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "135859953"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "135859956"
                                        }
                                      ],
                                      "price": 29400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "153658164",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817711",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "135859953"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "135859959"
                                        }
                                      ],
                                      "price": 50800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817713",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540910",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42506251",
                                          "variationId": "135859954"
                                        },
                                        {
                                          "groupId": "42506252",
                                          "variationId": "135859957"
                                        }
                                      ],
                                      "price": 57500,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540898",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540898",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817714",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433539",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817711",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817714",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433539",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "153658164",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540898",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540910",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "148 ratings",
                                    "ratingCountV2": "148"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607377"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073805",
                                "name": "Veggie Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Herbed onion and green capsicum, juicy sweet corn & mozzarella cheese with flavourful pan sauce (PAN Per/Med-269 Kcal/100g | TnC-274 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ee9985e4-828b-4a0e-b99b-656442e80877_7492ef8f-5b57-4ca4-86e6-4a8981c38510.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848807",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136720090",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720093"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987584",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "200987585"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136720091",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720094"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136720092",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848808",
                                            "variationId": "136720095"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848808",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "200987585",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 259,
                                          "default": 1,
                                          "id": "136720093",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987586",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "136720094",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 649,
                                          "id": "136720095",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 489,
                                          "id": "136720096",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "136720097",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720090"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720093"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720090"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720096"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "200987584"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "200987585"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "200987584"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "200987586"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720091"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720094"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255697",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817748",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720091"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720097"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817752",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541373",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848807",
                                          "variationId": "136720092"
                                        },
                                        {
                                          "groupId": "42848808",
                                          "variationId": "136720095"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541368",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541368",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817754",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433481",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817748",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817754",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433481",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255697",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541368",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541373",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "147 ratings",
                                    "ratingCountV2": "147"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609373"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073775",
                                "name": "Spiced Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Spiced paneer, crunchy onion, juicy tomato & mozzarella cheese, with our classic pan sauce (PAN Per/Med-276 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/d703d8df-5ccf-46ea-b6b8-87df2ce3e69d_fdd8da64-fba0-4e4a-ac39-7682a786df47.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "43007313",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "137152869",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007314",
                                            "variationId": "137152872"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987645",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007314",
                                            "variationId": "200987649"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "137152870",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007314",
                                            "variationId": "137152873"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "137152871",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007314",
                                            "variationId": "137152874"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "43007314",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "200987649",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 259,
                                          "default": 1,
                                          "id": "137152872",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987650",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "137152873",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 649,
                                          "id": "137152874",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 489,
                                          "id": "137152875",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "137152876",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "137152869"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "137152872"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817632",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "137152869"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "137152875"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817633",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "200987645"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "200987649"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817632",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "200987645"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "200987650"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817633",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "137152870"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "137152873"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993557",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817632",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "137152870"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "137152876"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817633",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114541289",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007313",
                                          "variationId": "137152871"
                                        },
                                        {
                                          "groupId": "43007314",
                                          "variationId": "137152874"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114541271",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114541271",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817634",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433465",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817632",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817634",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433465",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155993557",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541271",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114541289",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "50 ratings",
                                    "ratingCountV2": "50"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608868"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073779",
                                "name": "Tandoori Paneer",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | It's our signature. Spiced paneer, crunchy onions & green capsicum, spicy red paprika with delicious tandoori sauce and mozzarella cheese! (PAN Per/Med-335 Kcal/100g | TnC-326 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/92cfd7cf-0504-4444-befc-ff4aee0486cd_bac2d634-a13d-4cc3-828e-b2ad12dc73c0.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42703917",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136391328",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391331"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987368",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "200987369"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136391329",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391332"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136391330",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42703918",
                                            "variationId": "136391333"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42703918",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987369",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136391331",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987370",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136391332",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136391333",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136391334",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136391335",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391328"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391331"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391328"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391334"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "200987368"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "200987369"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "200987368"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "200987370"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391329"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391332"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "154483240",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817799",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391329"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391335"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817804",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540853",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42703917",
                                          "variationId": "136391330"
                                        },
                                        {
                                          "groupId": "42703918",
                                          "variationId": "136391333"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540845",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540845",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817806",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433469",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817799",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817806",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433469",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "154483240",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540845",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540853",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "130 ratings",
                                    "ratingCountV2": "130"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608985"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073646",
                                "name": "Country Feast",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Loaded with herbed onion & green capsicum, sweet corn, tomato with signature pan sauce and mozzarella cheese. It's a feast you can't refuse (PAN Per/Med-244 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/78bc0268-a19e-4c65-8ea2-4b4626898698_c52e5d95-51c4-4239-92b0-70b1ab93d12f.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "42848756",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "136719934",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719937"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987657",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "200987658"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "136719935",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719938"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "136719936",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "42848757",
                                            "variationId": "136719940"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "42848757",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987658",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "136719937",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987661",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "136719938",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "136719940",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "136719941",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "136719942",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719934"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719937"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719934"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719941"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "200987657"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "200987658"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "200987657"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "200987661"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719935"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719938"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155255632",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817518",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719935"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719942"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155255628",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540701",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "42848756",
                                          "variationId": "136719936"
                                        },
                                        {
                                          "groupId": "42848757",
                                          "variationId": "136719940"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540693",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540693",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817516",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433458",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817518",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817516",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433458",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155255632",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540693",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540701",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607392"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114714935",
                                "name": "Veggie Supreme",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | A supreme combination of black olives, green capsicum, mushroom, onion, spicy red paprika & juicy sweet corn with flavourful pan sauce and mozzarella cheese. (PAN Per/Med-254 Kcal/100g | TnC-258 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/2f6b03bf-3bb0-40cd-a5b8-7f0cfdf21998_7cc4fe8f-d5f8-44ed-ada9-0a719fc4d89f.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "43007375",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "137153163",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153166"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987614",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "200987615"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "137153164",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153167"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "137153165",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "43007376",
                                            "variationId": "137153168"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "43007376",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987615",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "137153166",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987616",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "137153167",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "137153168",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "137153169",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "137153170",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153163"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153166"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153163"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153169"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "200987614"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "200987615"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "200987614"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "200987616"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153164"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153167"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "155993574",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "151817728",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153164"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153170"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817730",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "114540450",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "43007375",
                                          "variationId": "137153165"
                                        },
                                        {
                                          "groupId": "43007376",
                                          "variationId": "137153168"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114540433",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "114540433",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "151817731",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "140433529",
                                          "addonId": "114766608"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "151817728",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "151817731",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "140433529",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "155993574",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540433",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114540450",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.6",
                                    "ratingCount": "57 ratings",
                                    "ratingCountV2": "57"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609543"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "96589951",
                                "name": "Margherita Pizza",
                                "category": "Veg Pizza",
                                "description": "Serves 1 | Pizza topped with our herb-infused signature pan sauce and mozzarella cheese. A classic treat for all cheese lovers out there! (292 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ef2f1053-c8e3-4072-aaa7-4539a67c8554_e8da5065-4d03-47d7-bad7-5413398a1564.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "667 ratings",
                                    "ratingCountV2": "667"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608004"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/d718f493-f644-410a-b6e8-46ef517f5950_b3be8e09-8ec3-483f-b688-f5ab2b7b1bbd.png_compressed",
                        "categoryId": "40706816"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Non Veg Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "125375031",
                                "name": "Sausage & Sweet Corn.",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Our classic chicken & cheese sausage, juicy sweet corn and mozzarella cheese with flavourful pan sauce (PAN Per/Med-277 Kcal/100g | TnC-282 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/2ff3f88f-00f4-4b58-b7e9-9c0bacce6f23_a5713f80-6204-4de9-be41-9766082388f6.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798623",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173642201",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798624",
                                            "variationId": "173642205"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173642202",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798624",
                                            "variationId": "173642206"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987572",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798624",
                                            "variationId": "200987573"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173642204",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798624",
                                            "variationId": "173642208"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798624",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 338,
                                          "id": "200987573",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 289,
                                          "default": 1,
                                          "id": "173642205",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 388,
                                          "id": "173642206",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 628,
                                          "id": "200987574",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 699,
                                          "id": "173642208",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 529,
                                          "id": "173642209",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 628,
                                          "id": "173642210",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "173642201"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "173642205"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700477",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "173642201"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "173642209"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700481",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "173642202"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "173642206"
                                        }
                                      ],
                                      "price": 38800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700477",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "173642202"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "173642210"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700481",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "200987572"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "200987573"
                                        }
                                      ],
                                      "price": 33800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700512",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700521",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700477",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "200987572"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "200987574"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700481",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700528",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700532",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798623",
                                          "variationId": "173642204"
                                        },
                                        {
                                          "groupId": "55798624",
                                          "variationId": "173642208"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700525",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700525",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700487",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700501",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700491",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700477",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700487",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700491",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700501",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700512",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700521",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700525",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700528",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700532",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 28900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066912"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285269",
                                "name": "Dhabe Da Keema",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Dhaba style chicken keema masala, with green chiili, crunchy onion with flavourful pan sauce, 100 % mozzarella cheese & a generous drizzle of mint mayo (PAN Per/Med-270 Kcal/100g | TnC-290 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/234a93c1-b182-4816-9bee-f8a3cf87877e_656b33c9-3933-4b54-b3eb-64a092b3735c.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798643",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173642311",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798645",
                                            "variationId": "173642319"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173642312",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798645",
                                            "variationId": "173642322"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987377",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798645",
                                            "variationId": "200987378"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173642316",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798645",
                                            "variationId": "173642327"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798645",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987378",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "173642319",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "173642322",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987379",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "173642327",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "173642329",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "173642331",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "173642311"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "173642319"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700582",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "173642311"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "173642329"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700593",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "173642312"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "173642322"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700582",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "173642312"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "173642331"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700593",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "200987377"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "200987378"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700616",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700620",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700582",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "200987377"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "200987379"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700593",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700626",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700630",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798643",
                                          "variationId": "173642316"
                                        },
                                        {
                                          "groupId": "55798645",
                                          "variationId": "173642327"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700623",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700623",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700598",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700609",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700603",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700582",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700598",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700603",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700609",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700616",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700620",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700623",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700626",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700630",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066902"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285272",
                                "name": "Sizzling Schezwan Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Loaded with our signature spicy schezwan sauce, juicy schezwan chicken meatballs & mozzarella cheese (PAN Per/Med-277 Kcal/100g | TnC-286 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/d3de1ec0-7720-4020-9999-ed2750bf9ce4_c70a72d7-3a57-4599-8f92-430fd810ea9f.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798663",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173642421",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798664",
                                            "variationId": "173642425"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173642422",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798664",
                                            "variationId": "173642426"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987428",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798664",
                                            "variationId": "200987429"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173642424",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798664",
                                            "variationId": "173642428"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798664",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "200987429",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 319,
                                          "default": 1,
                                          "id": "173642425",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "id": "173642426",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987430",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 749,
                                          "id": "173642428",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 569,
                                          "id": "173642429",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "173642430",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "173642421"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "173642425"
                                        }
                                      ],
                                      "price": 31900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700680",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "173642421"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "173642429"
                                        }
                                      ],
                                      "price": 56900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700685",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "173642422"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "173642426"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700680",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "173642422"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "173642430"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700685",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "200987428"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "200987429"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700704",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700708",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700680",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "200987428"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "200987430"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700685",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700714",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700717",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798663",
                                          "variationId": "173642424"
                                        },
                                        {
                                          "groupId": "55798664",
                                          "variationId": "173642428"
                                        }
                                      ],
                                      "price": 74900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700711",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700711",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700690",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700699",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700693",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700680",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700690",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700693",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700699",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700704",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700708",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700711",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700714",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700717",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 31900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "65363968"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "116285276",
                                "name": "Nawabi Murg Makhni",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | A chicken lovers delight! Combination of chicken malai tikka, flavourful chicken keema masala, crunchy onion, juicy tomato on our new makhni sauce with mozzarella cheese and buttery spice sprinkle (PAN Per/Med-252 Kcal/100g | TnC-269 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/12eae187-0032-4f50-8821-baf276bc85a9_839bac37-8d97-4dcd-b1ad-620db84fe82b.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798696",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173642598",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798698",
                                            "variationId": "173642606"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173642600",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798698",
                                            "variationId": "173642608"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987536",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798698",
                                            "variationId": "200987537"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173642604",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798698",
                                            "variationId": "173642612"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798698",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987537",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173642606",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173642608",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987539",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173642612",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173642614",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173642616",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "173642598"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "173642606"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700857",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "173642598"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "173642614"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700860",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "173642600"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "173642608"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700857",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "173642600"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "173642616"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700860",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "200987536"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "200987537"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700867",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700871",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700857",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "200987536"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "200987539"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700860",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700878",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700883",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798696",
                                          "variationId": "173642604"
                                        },
                                        {
                                          "groupId": "55798698",
                                          "variationId": "173642612"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700875",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700875",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700862",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700865",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700864",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700857",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700862",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700864",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700865",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700867",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700871",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700875",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700878",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700883",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066911"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073593",
                                "name": "Chicken Sausage",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Pizza topped with chicken n cheese sausages & crunchy onions, flavourful pan sauce and mozzarella cheese (PAN Per/Med-310 Kcal/100g | TnC-312 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/4b4ded4e-1e01-4d35-bebd-b055a22cb43a_2b6ef11b-6134-4744-87d5-9f49a9042d50.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798586",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641985",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642002"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641990",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642004"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987497",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "200987498"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641998",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798588",
                                            "variationId": "173642008"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798588",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "200987498",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 259,
                                          "default": 1,
                                          "id": "173642002",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "id": "173642004",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987499",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 649,
                                          "id": "173642008",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 489,
                                          "id": "173642010",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "173642012",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641985"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642002"
                                        }
                                      ],
                                      "price": 25900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641985"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642010"
                                        }
                                      ],
                                      "price": 48900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641990"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642004"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641990"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642012"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "200987497"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "200987498"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700312",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700319",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700284",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "200987497"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "200987499"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700289",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700325",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700330",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798586",
                                          "variationId": "173641998"
                                        },
                                        {
                                          "groupId": "55798588",
                                          "variationId": "173642008"
                                        }
                                      ],
                                      "price": 64900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700321",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700321",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700294",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700306",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700300",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700284",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700294",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700300",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700306",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700312",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700319",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700321",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700325",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700330",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607039"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "72273084",
                                "name": "Murg Malai Chicken",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Amazingly flavourful chicken malai tikka, herbed onion & green capsicum, spicy red paprika with flavourful pan sauce and mozzarella cheese (PAN Per/Med-269 Kcal/100g | TnC-299 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/a17de87b-9413-49b6-9982-42a676e8cbab_6e749005-f69b-4754-a229-18681a4f03c8.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798548",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641785",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641793"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641787",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641795"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987515",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "200987516"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641790",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798550",
                                            "variationId": "173641799"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798550",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987516",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "173641793",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "173641795",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987517",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "173641799",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "173641801",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "173641803",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641785"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641793"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641785"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641801"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641787"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641795"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641787"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641803"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "200987515"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "200987516"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700128",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700132",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700106",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "200987515"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "200987517"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700110",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700143",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700149",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798548",
                                          "variationId": "173641790"
                                        },
                                        {
                                          "groupId": "55798550",
                                          "variationId": "173641799"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700137",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700137",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700114",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700122",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700117",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700106",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700114",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700117",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700122",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700128",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700132",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700137",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700143",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700149",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066910"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073616",
                                "name": "Chicken Tikka",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Mouth-watering chicken tikka, crunchy onion & tomato with delicious tandoori sauce and mozzarella cheese (PAN Per/Med-275 Kcal/100g | TnC-283 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/8bb55a05-9c47-4704-9922-30cac26104f6_0105516f-1ca7-4ba0-8385-58807e99f533.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798529",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641680",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798532",
                                            "variationId": "173641695"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641683",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798532",
                                            "variationId": "173641698"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987554",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798532",
                                            "variationId": "200987555"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641690",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798532",
                                            "variationId": "173641702"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798532",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987555",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "173641695",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "173641698",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987556",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "173641702",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "173641704",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "173641706",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "173641680"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "173641695"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700007",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "173641680"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "173641704"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700010",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "173641683"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "173641698"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700007",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "173641683"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "173641706"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700010",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "200987554"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "200987555"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700038",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700043",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700007",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "200987554"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "200987556"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700010",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700052",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700056",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798529",
                                          "variationId": "173641690"
                                        },
                                        {
                                          "groupId": "55798532",
                                          "variationId": "173641702"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700048",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700048",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700016",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700030",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700022",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700007",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700016",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700022",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700030",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700038",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700043",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700048",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700052",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700056",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.4",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607215"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114714937",
                                "name": "Chicken Pepperoni",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Yummy chicken pepperoni & mozzarella cheese with signature pan sauce. Its a classic! (PAN Per/Med-301 Kcal/100g | TnC-311 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/ac22063e-df35-4541-b856-70ac4c784c89_ff068fa6-9fdd-43cb-b66c-10637a182081.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798605",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173642099",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798606",
                                            "variationId": "173642106"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173642101",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798606",
                                            "variationId": "173642107"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987467",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798606",
                                            "variationId": "200987468"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173642105",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798606",
                                            "variationId": "173642109"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798606",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "200987468",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 379,
                                          "default": 1,
                                          "id": "173642106",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "id": "173642107",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987469",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 849,
                                          "id": "173642109",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 639,
                                          "id": "173642110",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "173642111",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "173642099"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "173642106"
                                        }
                                      ],
                                      "price": 37900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700383",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "173642099"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "173642110"
                                        }
                                      ],
                                      "price": 63900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700388",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "173642101"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "173642107"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700383",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "173642101"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "173642111"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700388",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "200987467"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "200987468"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700406",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700410",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700383",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "200987467"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "200987469"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700388",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700415",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700419",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798605",
                                          "variationId": "173642105"
                                        },
                                        {
                                          "groupId": "55798606",
                                          "variationId": "173642109"
                                        }
                                      ],
                                      "price": 84900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700412",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700412",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700392",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700399",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700396",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700383",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700392",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700396",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700399",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700406",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700410",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700412",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700415",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700419",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607006"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114714940",
                                "name": "Chicken Supreme",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Loaded with delicious chicken tikka, flavourful herbed chicken, spicy schezwan chicken meatball with flavourful pan sauce and mozzarella cheese. (PAN Per/Med-273 Kcal/100g | TnC-284 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/e4d15638-5d14-444b-96ce-0314b1d4b0dc_e626776a-fa5d-4302-9c53-58893fe5c90d.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798565",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641882",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641886"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641883",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641887"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987599",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "200987600"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641885",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798566",
                                            "variationId": "173641889"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798566",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987600",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173641886",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173641887",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987601",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173641889",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173641890",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173641891",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641882"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641886"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641882"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641890"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641883"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641887"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641883"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641891"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "200987599"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "200987600"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204700216",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204700223",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204700194",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "200987599"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "200987601"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700197",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204700234",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204700240",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798565",
                                          "variationId": "173641885"
                                        },
                                        {
                                          "groupId": "55798566",
                                          "variationId": "173641889"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204700229",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204700229",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204700200",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204700207",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204700202",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204700194",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700200",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700202",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700207",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700216",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700223",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700229",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700234",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204700240",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607147"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "72273032",
                                "name": "Chicken Tikka Supreme",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | A divine combination of delicious chicken tikka & malai chicken tikka, onion, spicy red paprika with flavourful pan sauce and mozzarella cheese (PAN Per/Med-267 Kcal/100g |TnC-274 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/d1c474cd-4738-4533-b080-081d5c54311e_6a08f580-a5a2-44cc-8abe-3cbedd004315.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798509",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641574",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798510",
                                            "variationId": "173641578"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641575",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798510",
                                            "variationId": "173641579"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987440",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798510",
                                            "variationId": "200987441"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641577",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798510",
                                            "variationId": "173641581"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798510",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987441",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173641578",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173641579",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987442",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173641581",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173641582",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173641583",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "173641574"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "173641578"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699914",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "173641574"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "173641582"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699916",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "173641575"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "173641579"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699914",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "173641575"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "173641583"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699916",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "200987440"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "200987441"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699943",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699948",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699914",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "200987440"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "200987442"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699916",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699960",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699967",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798509",
                                          "variationId": "173641577"
                                        },
                                        {
                                          "groupId": "55798510",
                                          "variationId": "173641581"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699955",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699955",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699919",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204699932",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204699924",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204699914",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699919",
                                    "groupName": "Extra-Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699924",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699932",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699943",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699948",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699955",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699960",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699967",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31607275"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "48073795",
                                "name": "Triple Chicken Feast",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Spicy schezwan chicken meatball, flavourful herbed chicken, juicy chicken sausage, green capsicum & onion, spicy red paprika with classic pan sauce and mozzarella cheese (PAN Per/Med-262 Kcal/100g | TnC-277 Kcal/100g | Stuffed Crust Add : Per: 295 Kcal/Pizza | Med: 448kcal/Pizza| Ultimate Cheese : PER: 250 kcal/Pizza | MED: 375 kcal/Pizza| Stuff Crust Chicken Seekh Kebab Add : Per: 389 kcal/Pizza | Med: 614 Kcal/Pizza. Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/cef96188-c26a-4706-9843-5d03f41ba7cb_00643046-5886-4012-964f-010fa22f50d1.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "55798495",
                                      "name": "Choose your Crust",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "default": 1,
                                          "id": "173641497",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641501"
                                          }
                                        },
                                        {
                                          "name": "Stuffed Crust - Maxx",
                                          "id": "173641498",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641502"
                                          }
                                        },
                                        {
                                          "name": "Ultimate Cheese",
                                          "id": "200987458",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "200987459"
                                          }
                                        },
                                        {
                                          "name": "Thin n Crispy",
                                          "id": "173641500",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "55798496",
                                            "variationId": "173641504"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "55798496",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "200987459",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 409,
                                          "default": 1,
                                          "id": "173641501",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "id": "173641502",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987460",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Large.",
                                          "price": 949,
                                          "id": "173641504",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 699,
                                          "id": "173641505",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "173641506",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641497"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641501"
                                        }
                                      ],
                                      "price": 40900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641497"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641505"
                                        }
                                      ],
                                      "price": 69900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641498"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641502"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641498"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641506"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "200987458"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "200987459"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "204699861",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "204699864",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "204699849",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "200987458"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "200987460"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699851",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "204699872",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "204699877",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "55798495",
                                          "variationId": "173641500"
                                        },
                                        {
                                          "groupId": "55798496",
                                          "variationId": "173641504"
                                        }
                                      ],
                                      "price": 94900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "204699866",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "204699866",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "135557378"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766602"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766603"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766604"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766605"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766601"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766616"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766617"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766612"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766613"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766614"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766615"
                                        },
                                        {
                                          "groupId": "204699857",
                                          "addonId": "114766608"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "135557384"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237330"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237340"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237341"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237346"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237348"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237350"
                                        },
                                        {
                                          "groupId": "204699855",
                                          "addonId": "134237345"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "204699849",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699855",
                                    "groupName": "Add More Non Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "134237330",
                                        "name": "Chicken Keema Masala",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237340",
                                        "name": "Chicken Malai Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237341",
                                        "name": "Chicken Pepperoni",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237346",
                                        "name": "Chicken sausage",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237348",
                                        "name": "Chicken Tikka",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237350",
                                        "name": "Herbed Chicken",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237345",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557384",
                                        "name": "Marinated Chicken",
                                        "price": 9900,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699857",
                                    "groupName": "Add More Veg Toppings TNC",
                                    "choices": [
                                      {
                                        "id": "114766602",
                                        "name": "Black Olives",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766603",
                                        "name": "Cheese",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766604",
                                        "name": "Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766605",
                                        "name": "Herbed Veggies",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766601",
                                        "name": "Jalapeno",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766616",
                                        "name": "Paneer",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766617",
                                        "name": "Mushroom",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766612",
                                        "name": "Onion",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766613",
                                        "name": "Red Capsicum",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766614",
                                        "name": "Red Paprika",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766615",
                                        "name": "Sweet Corn",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "114766608",
                                        "name": "Tomato",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557378",
                                        "name": "Marinated Paneer",
                                        "price": 8500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699861",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699864",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699866",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699872",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "204699877",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 40900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31609105"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "125367924",
                                "name": "Sausage & Sweet Corn",
                                "category": "Non Veg Pizza",
                                "description": "Serves 1 | Our classic chicken & cheese sausage, juicy sweet corn and 100% mozzarella cheese with flavourful pan sauce",
                                "imageId": "190c84ffc8773254c38b3b993e31ba73",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "32859223",
                                      "name": "Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "default": 1,
                                          "id": "101804134",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "32859224",
                                            "variationId": "101804136"
                                          }
                                        },
                                        {
                                          "name": "Medium",
                                          "id": "101804135",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "32859224",
                                            "variationId": "101804140"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "32859224",
                                      "name": "Base",
                                      "variations": [
                                        {
                                          "name": "Pan",
                                          "price": 289,
                                          "default": 1,
                                          "id": "101804136",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "San Francisco Style",
                                          "price": 289,
                                          "id": "101804137",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Cheese Maxx",
                                          "price": 388,
                                          "id": "101804138",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 388,
                                          "id": "101804139",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Pan",
                                          "price": 529,
                                          "id": "101804140",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "San Francisco Style",
                                          "price": 529,
                                          "id": "101804141",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Cheese Maxx",
                                          "price": 628,
                                          "id": "101804142",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Stuffed Crust - Chicken Seekh Kebab",
                                          "price": 628,
                                          "id": "101804143",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804134"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804136"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390357"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390358"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390359"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390360"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390361"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390362"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390363"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390364"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390365"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390366"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390367"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390368"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390369"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390370"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390371"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390372"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390373"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390374"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390375"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390376"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804134"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804137"
                                        }
                                      ],
                                      "price": 28900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390357"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390358"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390359"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390360"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390361"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390362"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390363"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390364"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390365"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390366"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390367"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390368"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390369"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390370"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390371"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390372"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390373"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390374"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390375"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390376"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804134"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804138"
                                        }
                                      ],
                                      "price": 38800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390357"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390358"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390359"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390360"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390361"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390362"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390363"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390364"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390365"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390366"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390367"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390368"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390369"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390370"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390371"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390372"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390373"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390374"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390375"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390376"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804134"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804139"
                                        }
                                      ],
                                      "price": 38800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390357"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390358"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390359"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390360"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390361"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390362"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390363"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390364"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390365"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390366"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390367"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390368"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390369"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390370"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390371"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390372"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390373"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390374"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390375"
                                        },
                                        {
                                          "groupId": "114420426",
                                          "addonId": "101390376"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804135"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804140"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390377"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390378"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390379"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390380"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390381"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390382"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390383"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390384"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390385"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390386"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390387"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390388"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390389"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390390"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390391"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390392"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390393"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390394"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390395"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390396"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804135"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804141"
                                        }
                                      ],
                                      "price": 52900,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390377"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390378"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390379"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390380"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390381"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390382"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390383"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390384"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390385"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390386"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390387"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390388"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390389"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390390"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390391"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390392"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390393"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390394"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390395"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390396"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804135"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804142"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390377"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390378"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390379"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390380"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390381"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390382"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390383"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390384"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390385"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390386"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390387"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390388"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390389"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390390"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390391"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390392"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390393"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390394"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390395"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390396"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "32859223",
                                          "variationId": "101804135"
                                        },
                                        {
                                          "groupId": "32859224",
                                          "variationId": "101804143"
                                        }
                                      ],
                                      "price": 62800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390377"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390378"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390379"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390380"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390381"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390382"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390383"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390384"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390385"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390386"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390387"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390388"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390389"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390390"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390391"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390392"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390393"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390394"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390395"
                                        },
                                        {
                                          "groupId": "114420440",
                                          "addonId": "101390396"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390344"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390345"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390347"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390349"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390351"
                                        },
                                        {
                                          "groupId": "114420420",
                                          "addonId": "101390353"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "114420420",
                                    "groupName": "Add Ons",
                                    "choices": [
                                      {
                                        "id": "101390345",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390347",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390349",
                                        "name": "Creamy BreadStix : Flat Rs 20 Off",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390351",
                                        "name": "Zesty Paneer Pocket : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390353",
                                        "name": "Choco Volcano : Flat Rs 20 Off",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390344",
                                        "name": "Pepsi Pet Bottle",
                                        "price": 5700,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 6,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114420426",
                                    "groupName": "Toppings.",
                                    "choices": [
                                      {
                                        "id": "101390357",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390358",
                                        "name": "Black Olives",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390360",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390361",
                                        "name": "Herbed Veggies",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390362",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390363",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390364",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390365",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390366",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390367",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390368",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390369",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390371",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390370",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390373",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390372",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390374",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390375",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390376",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390359",
                                        "name": "Baby Corn",
                                        "price": 4500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "114420440",
                                    "groupName": "Toppings",
                                    "choices": [
                                      {
                                        "id": "101390377",
                                        "name": "Cheese",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390379",
                                        "name": "Baby Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390378",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390380",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390381",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390382",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390383",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390384",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390385",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390387",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390386",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390388",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390389",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390391",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390390",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390393",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390392",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390395",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390394",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101390396",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 28900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                }
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/2ff3f88f-00f4-4b58-b7e9-9c0bacce6f23_a5713f80-6204-4de9-be41-9766082388f6.jpg_compressed",
                        "categoryId": "58988597"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Ultimate Cheese Crust Pizza",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131298",
                                "name": "Margherita Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Classic cheese pizza with extra molten cheese and a melty gooey Cheese Crown on the crust, you’ll want to Flip to the Cheese first. (283.9Kcal/100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/f0061ceb-be06-448d-97c0-dbe18d1b7176_b653ba04-9cda-4fd9-bf2d-697a48a1b24b.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509621",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987695",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509622",
                                            "variationId": "200987696"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509622",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 244,
                                          "default": 1,
                                          "id": "200987696",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 428,
                                          "id": "200987697",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509621",
                                          "variationId": "200987695"
                                        },
                                        {
                                          "groupId": "66509622",
                                          "variationId": "200987696"
                                        }
                                      ],
                                      "price": 24400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741068",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741067",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741066",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509621",
                                          "variationId": "200987695"
                                        },
                                        {
                                          "groupId": "66509622",
                                          "variationId": "200987697"
                                        }
                                      ],
                                      "price": 42800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741068",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741068",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741065",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741069",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741066",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741067",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741068",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741069",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "111067039"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131299",
                                "name": "Tandoori Paneer Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Spiced paneer, paprika, onions, capsicum, tandoori sauce, extra molten cheese and a melty gooey cheese crown on the crust, you’ll want to Flip to the Cheese first. (345.4Kcal/100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/feb4705b-1f7a-4f28-aeb3-ab5b072b47c8_caee536d-2261-44f2-bfda-190f8a01c4ea.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509623",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987705",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509624",
                                            "variationId": "200987706"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509624",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 394,
                                          "default": 1,
                                          "id": "200987706",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 668,
                                          "id": "200987708",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509623",
                                          "variationId": "200987705"
                                        },
                                        {
                                          "groupId": "66509624",
                                          "variationId": "200987706"
                                        }
                                      ],
                                      "price": 39400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741073",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741072",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741071",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509623",
                                          "variationId": "200987705"
                                        },
                                        {
                                          "groupId": "66509624",
                                          "variationId": "200987708"
                                        }
                                      ],
                                      "price": 66800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741073",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741073",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741070",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741074",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741071",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741072",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741073",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741074",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 39400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "111067040"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131303",
                                "name": "Veggie Supreme Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Black olives, green capsicum, mushroom, onion, red paprika, sweet corn, extra molten cheese and a melty gooey Cheese Crown on the crust, you’ll want to Flip to the Cheese first. (252.6Kcal /100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/76ba8c14-3ffb-4825-a869-019e925007ad_81987b47-73a5-4221-bb00-64bf88365458.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509627",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987723",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509628",
                                            "variationId": "200987724"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509628",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "default": 1,
                                          "id": "200987724",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987725",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509627",
                                          "variationId": "200987723"
                                        },
                                        {
                                          "groupId": "66509628",
                                          "variationId": "200987724"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741085",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741084",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741083",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509627",
                                          "variationId": "200987723"
                                        },
                                        {
                                          "groupId": "66509628",
                                          "variationId": "200987725"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741085",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741085",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741082",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741086",
                                          "addonId": "101431107"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741083",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741084",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741085",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741086",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "111067042"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131296",
                                "name": "Chicken Sausage Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Chicken sausage, onion, extra molten cheese and a melty gooey Cheese Crown on the crust, you’ll want to Flip to the Cheese first. (295Kcal / 100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/24/1af96d1f-342d-4ca2-a455-7c74574dc405_42824f05-4a9a-41b3-992c-543c8eee95e7.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509617",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987684",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509618",
                                            "variationId": "200987686"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509618",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 334,
                                          "default": 1,
                                          "id": "200987686",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 588,
                                          "id": "200987687",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509617",
                                          "variationId": "200987684"
                                        },
                                        {
                                          "groupId": "66509618",
                                          "variationId": "200987686"
                                        }
                                      ],
                                      "price": 33400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741055",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741053",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "244741054",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "244741051",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509617",
                                          "variationId": "200987684"
                                        },
                                        {
                                          "groupId": "66509618",
                                          "variationId": "200987687"
                                        }
                                      ],
                                      "price": 58800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741055",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741055",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741052",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741056",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "244741057",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741051",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741053",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741054",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741055",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741056",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741057",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 33400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "111067036"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131297",
                                "name": "Chicken Tikka Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Tandoori-spiced chicken tikka, onion, tomato, tandoori sauce, extra molten cheese and a melty gooey cheese crown on the crust, you’ll want to Flip to the Cheese first. (277.7Kcal / 100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/3b4ba01a-924f-4c66-a42b-91545bfe3c27_fd02cf9f-6777-4ffe-becf-e3d22a5da939.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509619",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987689",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509620",
                                            "variationId": "200987690"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509620",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 454,
                                          "default": 1,
                                          "id": "200987690",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 738,
                                          "id": "200987691",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509619",
                                          "variationId": "200987689"
                                        },
                                        {
                                          "groupId": "66509620",
                                          "variationId": "200987690"
                                        }
                                      ],
                                      "price": 45400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741062",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741060",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "244741061",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "244741058",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509619",
                                          "variationId": "200987689"
                                        },
                                        {
                                          "groupId": "66509620",
                                          "variationId": "200987691"
                                        }
                                      ],
                                      "price": 73800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741062",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741062",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741059",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741063",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "244741064",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741058",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741060",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741061",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741062",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741063",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741064",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 45400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "111067037"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131300",
                                "name": "Triple Chicken Feast Ultimate Cheese Pizza",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Three kinds of Chicken : Schezwan meatballs, herbed chicken, chicken sausage, green capsicum, onion, red paprika, extra molten cheese and a melty gooey cheese crown on the crust, you’ll want to Flip to the Cheese first.  (260Kcal/ 100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/4c16ee73-0f4d-4306-98d9-ff01b4249614_52f23c8b-982d-4752-b287-7bbd62a85ee2.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "66509625",
                                      "name": "Choose Your Crust",
                                      "variations": [
                                        {
                                          "name": "Ultimate Cheese",
                                          "default": 1,
                                          "id": "200987713",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "66509626",
                                            "variationId": "200987714"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "66509626",
                                      "name": "Choose Size",
                                      "variations": [
                                        {
                                          "name": "Personal",
                                          "price": 484,
                                          "default": 1,
                                          "id": "200987714",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Medium",
                                          "price": 798,
                                          "id": "200987715",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509625",
                                          "variationId": "200987713"
                                        },
                                        {
                                          "groupId": "66509626",
                                          "variationId": "200987714"
                                        }
                                      ],
                                      "price": 48400,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741079",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "135557381"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431075"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431077"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431078"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431079"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431080"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431081"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431082"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431083"
                                        },
                                        {
                                          "groupId": "244741077",
                                          "addonId": "101431084"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "135557379"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237319"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237331"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237329"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237323"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237335"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237328"
                                        },
                                        {
                                          "groupId": "244741078",
                                          "addonId": "134237320"
                                        },
                                        {
                                          "groupId": "244741075",
                                          "addonId": "101431068"
                                        }
                                      ]
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "66509625",
                                          "variationId": "200987713"
                                        },
                                        {
                                          "groupId": "66509626",
                                          "variationId": "200987715"
                                        }
                                      ],
                                      "price": 79800,
                                      "addonCombinations": [
                                        {
                                          "groupId": "244741079",
                                          "addonId": "140544432"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431063"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431067"
                                        },
                                        {
                                          "groupId": "244741079",
                                          "addonId": "101431064"
                                        },
                                        {
                                          "groupId": "244741076",
                                          "addonId": "117352501"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "135557382"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431096"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431098"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431099"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431100"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431101"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431102"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431103"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431104"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431105"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431106"
                                        },
                                        {
                                          "groupId": "244741080",
                                          "addonId": "101431107"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "135557380"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237342"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237349"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237332"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237321"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237334"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237337"
                                        },
                                        {
                                          "groupId": "244741081",
                                          "addonId": "134237347"
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "addons": [
                                  {
                                    "groupId": "244741075",
                                    "groupName": "Extra Cheese Topping",
                                    "choices": [
                                      {
                                        "id": "101431068",
                                        "name": "Cheese",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741077",
                                    "groupName": "Add More Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "135557381",
                                        "name": "Marinated Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431075",
                                        "name": "Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431077",
                                        "name": "Jalapeno",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431078",
                                        "name": "Mushroom",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431079",
                                        "name": "Onion",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431080",
                                        "name": "Paneer",
                                        "price": 5500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431081",
                                        "name": "Red Paprika",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431082",
                                        "name": "Red Capsicum",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431083",
                                        "name": "Sweet Corn",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431084",
                                        "name": "Tomato",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741078",
                                    "groupName": "Add More Non-Veg Toppings Personal",
                                    "choices": [
                                      {
                                        "id": "134237319",
                                        "name": "Chicken Pepperoni",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237331",
                                        "name": "Chicken Sausage",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237329",
                                        "name": "Chicken Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237323",
                                        "name": "Chicken Malai Tikka",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237335",
                                        "name": "Herbed Chicken",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237328",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 6500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237320",
                                        "name": "Chicken Keema Masala",
                                        "price": 6000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557379",
                                        "name": "Marinated Chicken",
                                        "price": 6500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741079",
                                    "groupName": "Make it a Meal",
                                    "choices": [
                                      {
                                        "id": "140544432",
                                        "name": "Indi Cheese Pocket - Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431063",
                                        "name": "Classic BreadStix : Flat Rs 20 Off",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431067",
                                        "name": "Choco Volcano",
                                        "price": 9900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431064",
                                        "name": "Cheese Garlic Bread : Flat Rs 20 Off",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 4,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741080",
                                    "groupName": "Add More Veg Toppings",
                                    "choices": [
                                      {
                                        "id": "101431096",
                                        "name": "Black Olives",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431098",
                                        "name": "Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431099",
                                        "name": "Herbed Veggies",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431100",
                                        "name": "Jalapeno",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431101",
                                        "name": "Mushroom",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431102",
                                        "name": "Onion",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431103",
                                        "name": "Paneer",
                                        "price": 7500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431104",
                                        "name": "Red Paprika",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431105",
                                        "name": "Red Capsicum",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431106",
                                        "name": "Sweet Corn",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "101431107",
                                        "name": "Tomato",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557382",
                                        "name": "Marinated Paneer",
                                        "price": 7500,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "244741081",
                                    "groupName": "Add More Non-Veg Toppings Medium",
                                    "choices": [
                                      {
                                        "id": "134237342",
                                        "name": "Chicken Pepperoni",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237349",
                                        "name": "Chicken Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237332",
                                        "name": "Chicken Sausage",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237321",
                                        "name": "Chicken Malai Tikka",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237334",
                                        "name": "Herbed Chicken",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237337",
                                        "name": "Chicken Keema Masala",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "134237347",
                                        "name": "Schezwan Chicken Meatball",
                                        "price": 8500,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "135557380",
                                        "name": "Marinated Chicken",
                                        "price": 8500,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 48400,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "111067041"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131302",
                                "name": "Cheesy Pocket 2Pcs",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Cheese-loaded pockets, stuffed with finely chopped veggie mix and Texas garlic sauce. (275Kcal/100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/f66e5927-43f2-4433-9624-9d89b6eac7f2_f072960d-82df-4152-9b8a-8554404f96d3.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "111067035"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "183131301",
                                "name": "Indi Cheesy Pocket 2Pcs",
                                "category": "Ultimate Cheese Crust Pizza",
                                "description": "Serves 1 | Cheese-loaded pockets, stuffed with onion, green chill and tandoori sauce. (291.7Kcal/100gm). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/f66e5927-43f2-4433-9624-9d89b6eac7f2_f072960d-82df-4152-9b8a-8554404f96d3.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "111067038"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/22/f0061ceb-be06-448d-97c0-dbe18d1b7176_b653ba04-9cda-4fd9-bf2d-697a48a1b24b.jpg",
                        "categoryId": "67113898"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Everyday Meals",
                        "categories": [
                          {
                            "title": "1+1 PER Pizza: Ultimate Cheese Combos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123268",
                                    "name": "Ultimate Cheese Veg Pizza - Combo 1 (PER)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the OG favorites – Margherita Pizza & Tandoori Paneer Pizza with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/9c453692-a7a1-4344-9172-3e34b9a8b1d6_26bcec80-fdbe-4f79-86ef-02a0fddd32e1.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090176",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita Ultimate Cheese Pizza Personal",
                                              "price": 244,
                                              "default": 1,
                                              "id": "204609818",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090177",
                                                "variationId": "204609819"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090177",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Tandoori Paneer Ultimate Cheese Pizza Personal",
                                              "price": 394,
                                              "default": 1,
                                              "id": "204609819",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090176",
                                              "variationId": "204609818"
                                            },
                                            {
                                              "groupId": "68090177",
                                              "variationId": "204609819"
                                            }
                                          ],
                                          "price": 63800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 63800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436337"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123269",
                                    "name": "Ultimate Cheese Veg Pizza - Combo 2 (PER)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the loaded veg pizzas – Veggie Supreme & Tandoori Paneer Pizza with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/2fe702a6-a5ed-496d-b6d4-e646d2070b88_225c8964-9de3-433c-a4a8-ee78297a2a33.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090178",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Tandoori Paneer Ultimate Cheese Pizza",
                                              "price": 394,
                                              "default": 1,
                                              "id": "204609820",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090179",
                                                "variationId": "204609821"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090179",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Veggie Supreme Ultimate Cheese Pizza Personal",
                                              "price": 454,
                                              "default": 1,
                                              "id": "204609821",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090178",
                                              "variationId": "204609820"
                                            },
                                            {
                                              "groupId": "68090179",
                                              "variationId": "204609821"
                                            }
                                          ],
                                          "price": 84800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 84800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436339"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123270",
                                    "name": "Ultimate Cheese Veg Pizza - Combo 3 (PER)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the bestsellers- Margherita Pizza & Veggie Supreme Pizza with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/6ed9e5aa-2221-4808-91ff-bc2e8223ade2_0e008077-ee3d-466a-9564-4de7df3f021c.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090180",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita Ultimate Cheese Pizza Personal",
                                              "price": 244,
                                              "default": 1,
                                              "id": "204609822",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090181",
                                                "variationId": "204609823"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090181",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Veggie Supreme Ultimate Cheese Pizza Personal",
                                              "price": 454,
                                              "default": 1,
                                              "id": "204609823",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090180",
                                              "variationId": "204609822"
                                            },
                                            {
                                              "groupId": "68090181",
                                              "variationId": "204609823"
                                            }
                                          ],
                                          "price": 69800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 69800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436340"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123274",
                                    "name": "Ultimate Cheese Non Veg Pizza - Combo 1 (PER)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the chicken top picks- Chicken Sausage Pizza & Chicken Tikka Pizza with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/3bdedbc0-5e98-45ef-a6cf-90ef368a217c_9499b27b-ef37-47b4-89ba-ea2d8c46d772.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090188",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage Ultimate Cheese Pizza Personal",
                                              "price": 334,
                                              "default": 1,
                                              "id": "204609830",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090189",
                                                "variationId": "204609831"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090189",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka Ultimate Cheese Pizza",
                                              "price": 454,
                                              "default": 1,
                                              "id": "204609831",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090188",
                                              "variationId": "204609830"
                                            },
                                            {
                                              "groupId": "68090189",
                                              "variationId": "204609831"
                                            }
                                          ],
                                          "price": 78800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 78800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436335"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "68476689"
                          },
                          {
                            "title": "1+1 MED Pizza: Ultimate Cheese Combos",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123271",
                                    "name": "Ultimate Cheese Veg Pizza - Combo 1 (MED)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the OG favorites – Margherita Pizza & Tandoori Paneer Pizza with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/118f627f-ef5a-4c89-b456-7f4f415fad76_c226c04e-cb56-44bc-89f2-c70161926010.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090182",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita Ultimate Cheese Pizza",
                                              "price": 428,
                                              "default": 1,
                                              "id": "204609824",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090183",
                                                "variationId": "204609825"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090183",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Tandoori Paneer Ultimate Cheese Pizza",
                                              "price": 668,
                                              "default": 1,
                                              "id": "204609825",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090182",
                                              "variationId": "204609824"
                                            },
                                            {
                                              "groupId": "68090183",
                                              "variationId": "204609825"
                                            }
                                          ],
                                          "price": 109600
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 109600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436336"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123272",
                                    "name": "Ultimate Cheese Veg Pizza - Combo 2 (MED)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the bestsellers- Margherita Pizza & Veggie Supreme with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/42bda711-b97a-4a8a-a08d-c9e94e0a5c75_752db304-cf2e-40ff-853b-e9756c3d6127.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090184",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Margherita Ultimate Cheese Pizza Medium",
                                              "price": 428,
                                              "default": 1,
                                              "id": "204609826",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090185",
                                                "variationId": "204609827"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090185",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Veggie Supreme Ultimate Cheese Pizza Medium",
                                              "price": 738,
                                              "default": 1,
                                              "id": "204609827",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090184",
                                              "variationId": "204609826"
                                            },
                                            {
                                              "groupId": "68090185",
                                              "variationId": "204609827"
                                            }
                                          ],
                                          "price": 116600
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 116600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436338"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "186123273",
                                    "name": "Ultimate Cheese Non Veg Pizza - Combo 1 (MED)",
                                    "category": "Everyday Meals",
                                    "description": "Get 2X the cheese on the chicken top picks- Chicken Sausage & Chicken Tikka with Ultimate Cheese Crust!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/dd8fe2aa-9a53-4674-ac1b-011e2f3db914_74a6332c-4ec0-492d-95ed-17f6dbec0103.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "68090186",
                                          "name": "Choose 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Sausage Ultimate Cheese Pizza Medium",
                                              "price": 588,
                                              "default": 1,
                                              "id": "204609828",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "68090187",
                                                "variationId": "204609829"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "68090187",
                                          "name": "Choose 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka Ultimate Cheese Pizza Medium",
                                              "price": 738,
                                              "default": 1,
                                              "id": "204609829",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "68090186",
                                              "variationId": "204609828"
                                            },
                                            {
                                              "groupId": "68090187",
                                              "variationId": "204609829"
                                            }
                                          ],
                                          "price": 132600
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 132600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "113436334"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "68476690"
                          },
                          {
                            "title": "1 Plus 1 Personal: Pizza Pair Deals",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048361",
                                    "name": "1 Chicken Pepperoni PER Pizza +1 Nawabi Murgh Makhni PER",
                                    "category": "Everyday Meals",
                                    "description": "Classic pepperoni paired with the rich, regal Nawabi-style Chicken Murgh Makhni.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/17df5e10-45e5-4ae5-b330-a1b172d08fbf_4cbe5323-9a21-46ba-8925-c46eb1db76ce.png_compressed",
                                    "inStock": 1,
                                    "finalPrice": 39400,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005214",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 394,
                                              "default": 1,
                                              "id": "195373315",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005215",
                                                "variationId": "195373316"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005215",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Nawabi Murg Makhni",
                                              "price": 394,
                                              "default": 1,
                                              "id": "195373316",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005214",
                                              "variationId": "195373315"
                                            },
                                            {
                                              "groupId": "64005215",
                                              "variationId": "195373316"
                                            }
                                          ],
                                          "price": 78800,
                                          "finalPrice": {
                                            "units": "394"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 78800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "5.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "451aad6b-f77a-4a9b-a26a-61133d344905"
                                    ],
                                    "parentId": "108975388"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048363",
                                    "name": "1 Mazedaar Makhni Paneer PER Pizza + 1 Veggie Supreme PER",
                                    "category": "Everyday Meals",
                                    "description": "Flavourful Mazerdar Makhni Paneer meets the all-time favourite loaded Veggie Supreme.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/7820e391-8ccb-4986-aa9f-9039b6981d2d_18f94c6d-751e-4645-a4e2-6b8747f7d37f.png_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "finalPrice": 37900,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005218",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Mazedar Makhni Paneer",
                                              "price": 379,
                                              "default": 1,
                                              "id": "195373319",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005219",
                                                "variationId": "195373320"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005219",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Veggie Supreme",
                                              "price": 379,
                                              "default": 1,
                                              "id": "195373320",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005218",
                                              "variationId": "195373319"
                                            },
                                            {
                                              "groupId": "64005219",
                                              "variationId": "195373320"
                                            }
                                          ],
                                          "price": 75800,
                                          "finalPrice": {
                                            "units": "379"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 75800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "6 ratings",
                                        "ratingCountV2": "6"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "451aad6b-f77a-4a9b-a26a-61133d344905"
                                    ],
                                    "parentId": "108975390"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048365",
                                    "name": "1 Nawabi Murg Makhni PER Pizza +1 Chicken Tikka Supreme PER",
                                    "category": "Everyday Meals",
                                    "description": "Nawabi style Murg Makhni meets spicy, bold Chicken Tikka Supreme.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/0abda3f7-978a-4246-94b7-57777b87bdb9_cf43b0fd-44e0-46a8-9712-2819c68bc8a5.png_compressed",
                                    "inStock": 1,
                                    "finalPrice": 40900,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005222",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Nawabi Murg Makhni",
                                              "price": 409,
                                              "default": 1,
                                              "id": "195373323",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005223",
                                                "variationId": "195373324"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005223",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka Supreme",
                                              "price": 409,
                                              "default": 1,
                                              "id": "195373324",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005222",
                                              "variationId": "195373323"
                                            },
                                            {
                                              "groupId": "64005223",
                                              "variationId": "195373324"
                                            }
                                          ],
                                          "price": 81800,
                                          "finalPrice": {
                                            "units": "409"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 81800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "451aad6b-f77a-4a9b-a26a-61133d344905"
                                    ],
                                    "parentId": "108975392"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048366",
                                    "name": "1 Ultimate Tandoori Veggie PER Pizza + 1 Mazedaar Makhni Paneer PER",
                                    "category": "Everyday Meals",
                                    "description": "The ultimate pizza party: Ultimate Tandoori Veggie & Mazedar Makhni Paneer",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/20/082abb1b-32b5-44f9-8306-efa6171007df_ddfa1682-cae5-4acd-818d-138aeba07d24.png_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "finalPrice": 37900,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005224",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Ultimate Tandoori Veggie",
                                              "price": 379,
                                              "default": 1,
                                              "id": "195373325",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005225",
                                                "variationId": "195373326"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005225",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Mazedar Makhni Paneer",
                                              "price": 379,
                                              "default": 1,
                                              "id": "195373326",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005224",
                                              "variationId": "195373325"
                                            },
                                            {
                                              "groupId": "64005225",
                                              "variationId": "195373326"
                                            }
                                          ],
                                          "price": 75800,
                                          "finalPrice": {
                                            "units": "379"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 75800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "title": "50% OFF",
                                        "textColor": "#DB6742",
                                        "backgroundColor": "#FAE8E3",
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "CouponlessSild",
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "offerIds": [
                                      "451aad6b-f77a-4a9b-a26a-61133d344905"
                                    ],
                                    "parentId": "108975393"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "65224389"
                          },
                          {
                            "title": "1 Plus 1 Medium: Pizza Pair Deals",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048359",
                                    "name": "1 Bold BBQ Veggies MED Pizza + 1 Tandoori Paneer MED",
                                    "category": "Everyday Meals",
                                    "description": "BBQ Veggie meets Tandoori Paneer for a fiery veggie treat for the squad!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/9688a6bd-724e-456e-a52f-6594315421f5_90e19d6d-5ebe-4e4d-893e-bab6993ab6f0.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005210",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 569,
                                              "default": 1,
                                              "id": "195373311",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005211",
                                                "variationId": "195373312"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005211",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 569,
                                              "default": 1,
                                              "id": "195373312",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005210",
                                              "variationId": "195373311"
                                            },
                                            {
                                              "groupId": "64005211",
                                              "variationId": "195373312"
                                            }
                                          ],
                                          "price": 113800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 113800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108975386"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048360",
                                    "name": "1 Bold BBQ Veggies MED Pizza +1 Veggie Supreme MED",
                                    "category": "Everyday Meals",
                                    "description": "Big, Cheesy &amp; Bold! Bold BBQ Veggie team up with the best-seller Veggie Supreme.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/5235af37-6ac7-4b93-b605-6fe0b6503b08_56c70501-7149-432d-a208-4bf09cb1c40d.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005212",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Bold BBQ Veggies",
                                              "price": 604,
                                              "default": 1,
                                              "id": "195373313",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005213",
                                                "variationId": "195373314"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005213",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Veggie Supreme",
                                              "price": 604,
                                              "default": 1,
                                              "id": "195373314",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005212",
                                              "variationId": "195373313"
                                            },
                                            {
                                              "groupId": "64005213",
                                              "variationId": "195373314"
                                            }
                                          ],
                                          "price": 120800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 120800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "108975387"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048362",
                                    "name": "1 Chicken Tikka MED Pizza + 1 Chicken Pepperoni MED",
                                    "category": "Everyday Meals",
                                    "description": "Desi spice meets the West! Chicken Tikka teamed up with Chicken Pepperoni.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/fbebe4c9-37bd-48fc-ae78-ed4d57ab1819_1b1d80ed-bb7c-40f9-a397-8928bd56efd8.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005216",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 738,
                                              "default": 1,
                                              "id": "195373317",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005217",
                                                "variationId": "195373318"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005217",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Pepperoni",
                                              "price": 738,
                                              "default": 1,
                                              "id": "195373318",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005216",
                                              "variationId": "195373317"
                                            },
                                            {
                                              "groupId": "64005217",
                                              "variationId": "195373318"
                                            }
                                          ],
                                          "price": 147600
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 147600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108975389"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048364",
                                    "name": "1 Murg Malai Chicken MED Pizza + 1 Chicken Tikka MED",
                                    "category": "Everyday Meals",
                                    "description": "A combo of Murg Malai Chicken and zesty Chicken Tikka creating the perfect chicken combo!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/85352411-8d81-487c-a842-73da0c46fc41_83c0dc68-401a-40ac-95a2-4f51cad951b2.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005220",
                                          "name": "Choose Your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 738,
                                              "default": 1,
                                              "id": "195373321",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005221",
                                                "variationId": "195373322"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005221",
                                          "name": "Choose Your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 738,
                                              "default": 1,
                                              "id": "195373322",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005220",
                                              "variationId": "195373321"
                                            },
                                            {
                                              "groupId": "64005221",
                                              "variationId": "195373322"
                                            }
                                          ],
                                          "price": 147600
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 147600,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108975391"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "65224388"
                          },
                          {
                            "title": "Meal for 4: Pizza Party Pack",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048367",
                                    "name": "Pizza Party Pack for 4 (Non Veg)",
                                    "category": "Everyday Meals",
                                    "description": "For the true chicken lovers! Creamy 1 Medium murgh malai and 1 Medium spicy tikka pizzas paired with 2 loaded breadstix, choco volcano & Pepsi joy!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/0a68598f-b8e9-4337-8325-daa63b3eb64f_74f5e261-fb35-4fc6-bd9f-63b0d8ad2df7.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005226",
                                          "name": "1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Murg Malai Chicken",
                                              "price": 1356,
                                              "default": 1,
                                              "id": "195373327",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005227",
                                                "variationId": "195373328"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005227",
                                          "name": "2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chicken Tikka",
                                              "price": 642,
                                              "default": 1,
                                              "id": "195373328",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005226",
                                              "variationId": "195373327"
                                            },
                                            {
                                              "groupId": "64005227",
                                              "variationId": "195373328"
                                            }
                                          ],
                                          "price": 199800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 199800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108479068"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "179048368",
                                    "name": "Pizza Party Pack for 4 (Veg)",
                                    "category": "Everyday Meals",
                                    "description": "A full-on feast! 1 Medium Tandoori Paneer &amp; 1 Medium Country Feast pizzas, paired with 2 loaded breadstix, gooey choco volcano & Pepsi to seal the deal!",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/6/c8654b70-45eb-4211-89e6-58689742ad94_db5517e7-eb54-49e1-8812-a4995d6afcfe.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "64005228",
                                          "name": "1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Tandoori Paneer",
                                              "price": 1292,
                                              "default": 1,
                                              "id": "195373329",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "64005229",
                                                "variationId": "195373330"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "64005229",
                                          "name": "2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Country Feast",
                                              "price": 582,
                                              "default": 1,
                                              "id": "195373330",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "64005228",
                                              "variationId": "195373329"
                                            },
                                            {
                                              "groupId": "64005229",
                                              "variationId": "195373330"
                                            }
                                          ],
                                          "price": 187400
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 187400,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "108479069"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "65224390"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/9c453692-a7a1-4344-9172-3e34b9a8b1d6_26bcec80-fdbe-4f79-86ef-02a0fddd32e1.jpg",
                        "categoryId": "65224387"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Flavour Fun Pizzas",
                        "categories": [
                          {
                            "title": "Combos and Deals",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117545734",
                                    "name": "Create Your Flavour Fun Combo - Box Of 4 - Veg",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/a5a7e6ae-6f80-48e1-b089-660fc6e621f3_fed0df22-1826-4cfc-8bd6-953418c79d56.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "62591391",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "192229773",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "192229774",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "192229775",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "192229776",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "192229777",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "192229778",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591392",
                                                "variationId": "192229779"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591392",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "192229779",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "192229780",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "192229781",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "192229782",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "192229783",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "192229784",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591393",
                                                "variationId": "192229785"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591393",
                                          "name": "Choose your 3rd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "192229785",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "192229786",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "192229787",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "192229788",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "192229789",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "192229790",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591394",
                                                "variationId": "192229791"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591394",
                                          "name": "Choose your 4th Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 106.25,
                                              "default": 1,
                                              "id": "192229791",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 136.25,
                                              "id": "192229792",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 146.25,
                                              "id": "192229793",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 156.25,
                                              "id": "192229794",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 126.25,
                                              "id": "192229795",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 106.25,
                                              "id": "192229796",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229773"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229774"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229775"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229776"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229777"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229779"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229780"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229781"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229782"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 53500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229783"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229785"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229786"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229787"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 50500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 51500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 52500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229788"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 48500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 49500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229789"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229791"
                                            }
                                          ],
                                          "price": 42500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229792"
                                            }
                                          ],
                                          "price": 45500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229793"
                                            }
                                          ],
                                          "price": 46500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229794"
                                            }
                                          ],
                                          "price": 47500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229795"
                                            }
                                          ],
                                          "price": 44500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591391",
                                              "variationId": "192229778"
                                            },
                                            {
                                              "groupId": "62591392",
                                              "variationId": "192229784"
                                            },
                                            {
                                              "groupId": "62591393",
                                              "variationId": "192229790"
                                            },
                                            {
                                              "groupId": "62591394",
                                              "variationId": "192229796"
                                            }
                                          ],
                                          "price": 42500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 42500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "52 ratings",
                                        "ratingCountV2": "52"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48818045"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117545735",
                                    "name": "Create Your Flavour Fun Combo - Box Of 4 - Non Veg",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Get 4 assorted flavor fun personal pizzas. Perfect personal pizza crust topped with exciting new sauces, cheesy dressing & your favorite toppings. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/b927c2cf-cfe7-467a-be00-29baaef3ca24_f40929da-965d-4e81-98b7-1c5f04753539.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "62591395",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "192229797",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591396",
                                                "variationId": "192229801"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "192229798",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591396",
                                                "variationId": "192229801"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "192229799",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591396",
                                                "variationId": "192229801"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591396",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "192229800",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591397",
                                                "variationId": "192229804"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "192229801",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591397",
                                                "variationId": "192229804"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "192229802",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591397",
                                                "variationId": "192229804"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591397",
                                          "name": "Choose your 3rd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "192229803",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591399",
                                                "variationId": "192229808"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "192229804",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591399",
                                                "variationId": "192229808"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "192229805",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "62591399",
                                                "variationId": "192229808"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "62591399",
                                          "name": "Choose your 4th Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 166.25,
                                              "id": "192229807",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 136.25,
                                              "default": 1,
                                              "id": "192229808",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 146.25,
                                              "id": "192229810",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 66500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229797"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 63500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 54500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229798"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 64500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229800"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 61500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 58500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 55500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229801"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 62500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229803"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 59500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 56500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229804"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229807"
                                            }
                                          ],
                                          "price": 60500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229808"
                                            }
                                          ],
                                          "price": 57500
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "62591395",
                                              "variationId": "192229799"
                                            },
                                            {
                                              "groupId": "62591396",
                                              "variationId": "192229802"
                                            },
                                            {
                                              "groupId": "62591397",
                                              "variationId": "192229805"
                                            },
                                            {
                                              "groupId": "62591399",
                                              "variationId": "192229810"
                                            }
                                          ],
                                          "price": 58500
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 54500,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "3 ratings",
                                        "ratingCountV2": "3"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48818044"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117545736",
                                    "name": "Create Your Flavour Fun Combo - Box Of 2 - Veg Pizza",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Serves 2 | Choose any 2 veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/7/e4a3d9a3-9997-4b73-accc-b029abeb1cc9_83eb91d8-7d3d-4463-8e7e-9188ba95bcf7.jpg_compressed",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "28707865",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 119,
                                              "id": "90376721",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 159,
                                              "id": "117074353",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 169,
                                              "id": "117074354",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 189,
                                              "id": "117074355",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 149,
                                              "id": "117074356",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 109,
                                              "default": 1,
                                              "id": "90376722",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707866",
                                                "variationId": "90376729"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "28707866",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Classic Corn",
                                              "price": 119,
                                              "id": "90376728",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chatpata Tomato Onion & Chilli",
                                              "price": 159,
                                              "id": "117074357",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Cheesy Spicy Delight",
                                              "price": 169,
                                              "id": "117074358",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Chilli Paneer Sizzle",
                                              "price": 189,
                                              "id": "117074359",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Spicy Sweet corn, Onion, Green Chilli",
                                              "price": 149,
                                              "id": "117074360",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Onion Capsicum",
                                              "price": 109,
                                              "default": 1,
                                              "id": "90376729",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 23800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376721"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 22800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 32800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 34800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074353"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 28800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 32800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074354"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 34800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 37800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074355"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 30800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "117074356"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376728"
                                            }
                                          ],
                                          "price": 22800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074357"
                                            }
                                          ],
                                          "price": 26800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074358"
                                            }
                                          ],
                                          "price": 27800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074359"
                                            }
                                          ],
                                          "price": 29800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "117074360"
                                            }
                                          ],
                                          "price": 25800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707865",
                                              "variationId": "90376722"
                                            },
                                            {
                                              "groupId": "28707866",
                                              "variationId": "90376729"
                                            }
                                          ],
                                          "price": 21800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 21800,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "4229 ratings",
                                        "ratingCountV2": "4.2K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48818043"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117545740",
                                    "name": "Create Your Flavour Fun Combo - Box Of 2 - Non Veg Pizza",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Serves 2 | Choose any 2 non veg personal pizzas from our flavour fun range. For Meals, refer to the nutritional data for individual products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/7/ddac9151-7d1a-47c9-8f6d-a931e6891760_64cfba69-6eae-41bb-b7c8-059bc645f538.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "28707855",
                                          "name": "Choose your 1st Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 199,
                                              "id": "117074746",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707856",
                                                "variationId": "117074750"
                                              }
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 159,
                                              "default": 1,
                                              "id": "117074747",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707856",
                                                "variationId": "117074750"
                                              }
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 179,
                                              "id": "117074748",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707856",
                                                "variationId": "117074750"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "28707856",
                                          "name": "Choose your 2nd Pizza",
                                          "variations": [
                                            {
                                              "name": "Chatpata Chicken Feast",
                                              "price": 199,
                                              "id": "117074749",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Chicken Pepperoni & Onion",
                                              "price": 159,
                                              "default": 1,
                                              "id": "117074750",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            },
                                            {
                                              "name": "Classic Herbed Chicken & Capsicum",
                                              "price": 179,
                                              "id": "117074751",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074746"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074749"
                                            }
                                          ],
                                          "price": 39800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074746"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074750"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074746"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074751"
                                            }
                                          ],
                                          "price": 37800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074747"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074749"
                                            }
                                          ],
                                          "price": 35800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074747"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074750"
                                            }
                                          ],
                                          "price": 31800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074747"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074751"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074748"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074749"
                                            }
                                          ],
                                          "price": 37800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074748"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074750"
                                            }
                                          ],
                                          "price": 33800
                                        },
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707855",
                                              "variationId": "117074748"
                                            },
                                            {
                                              "groupId": "28707856",
                                              "variationId": "117074751"
                                            }
                                          ],
                                          "price": 35800
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG",
                                      "portionSize": "Serves 2"
                                    },
                                    "defaultPrice": 31800,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "69 ratings",
                                        "ratingCountV2": "69"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "48818042"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "40706832"
                          },
                          {
                            "title": "Veg Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "48073621",
                                    "name": "Classic Corn",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Serves 1 | Pizza topped with our classic pan sauce, sweet corn and a flavourful dressing. An all time favorite (319 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/fb512d21-8958-46b5-b157-20e294e479ed_91a978d7-40cb-4aa4-97d0-4322b892fd70.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "28707813",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "90376525",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707814",
                                                "variationId": "90376526"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "28707814",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 119,
                                              "default": 1,
                                              "id": "90376526",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707813",
                                              "variationId": "90376525"
                                            },
                                            {
                                              "groupId": "28707814",
                                              "variationId": "90376526"
                                            }
                                          ],
                                          "price": 11900,
                                          "finalPrice": {
                                            "units": "99"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 11900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "1054 ratings",
                                        "ratingCountV2": "1.1K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "800616e5-c608-4c83-b50e-4b84a65d7d71"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "31607351"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "117545724",
                                    "name": "Classic Onion Capsicum",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Serves 1 | Pizza topped with our classic pan sauce, crunchy onion & capsicum and a flavourful dressing. (307 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/43d430bb-cf34-4230-b88e-8784728fd3ef_06fd1528-17e2-418e-bc67-d7e7b8e493bf.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "finalPrice": 9900,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "28707817",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "90376529",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "28707818",
                                                "variationId": "90376530"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "28707818",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 109,
                                              "default": 1,
                                              "id": "90376530",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "28707817",
                                              "variationId": "90376529"
                                            },
                                            {
                                              "groupId": "28707818",
                                              "variationId": "90376530"
                                            }
                                          ],
                                          "price": 10900,
                                          "finalPrice": {
                                            "units": "99"
                                          }
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "defaultPrice": 10900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "offerTags": [
                                      {
                                        "matchText": "SILD"
                                      }
                                    ],
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "itemNudgeType": "FinalPrice",
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "1114 ratings",
                                        "ratingCountV2": "1.1K+"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "cartContext": "quick_prep",
                                    "offerIds": [
                                      "800616e5-c608-4c83-b50e-4b84a65d7d71"
                                    ],
                                    "isNinetyninestoreItem": true,
                                    "parentId": "47040143"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110496",
                                    "name": "Chatpata Tomato Onion & Chilli",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with a spicy tandoori sauce, juicy tomato, crunchy onion & green chilli for an extra zing and a flavourful dressing. (328 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/9c94a440-ee53-413c-94c2-510622bf4f3e_7259e53f-da66-403c-b932-cb2b9ccadacb.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431632",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075151",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431633",
                                                "variationId": "117075152"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431633",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 159,
                                              "default": 1,
                                              "id": "117075152",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431632",
                                              "variationId": "117075151"
                                            },
                                            {
                                              "groupId": "37431633",
                                              "variationId": "117075152"
                                            }
                                          ],
                                          "price": 15900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.6",
                                        "ratingCount": "10 ratings",
                                        "ratingCountV2": "10"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519005"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110495",
                                    "name": "Spicy Sweet Corn, Onion, Green Chilli",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with a spicy tandoori sauce, juicy sweet corn, crunchy onion & spicy green chilli and a flavourful dressing. (327 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/cdbcda83-b9e1-4eff-be7f-c7913f90da59_caeb441a-90b2-406f-b6c7-ce7167d968b7.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431630",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075149",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431631",
                                                "variationId": "117075150"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431631",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 149,
                                              "default": 1,
                                              "id": "117075150",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431630",
                                              "variationId": "117075149"
                                            },
                                            {
                                              "groupId": "37431631",
                                              "variationId": "117075150"
                                            }
                                          ],
                                          "price": 14900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 14900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.8",
                                        "ratingCount": "29 ratings",
                                        "ratingCountV2": "29"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519010"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110494",
                                    "name": "Cheesy Spicy Delight",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with mozzarella cheese, a flavourful dressing, onion and spicy green chilli, sprinkled with our signature spiced seasoning. (367 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/78fc6391-10f2-45b3-afd4-416a3bfb8260_dc58c551-a663-4499-b951-99b287116ced.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431628",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075147",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431629",
                                                "variationId": "117075148"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431629",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 169,
                                              "default": 1,
                                              "id": "117075148",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431628",
                                              "variationId": "117075147"
                                            },
                                            {
                                              "groupId": "37431629",
                                              "variationId": "117075148"
                                            }
                                          ],
                                          "price": 16900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 16900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.2",
                                        "ratingCount": "69 ratings",
                                        "ratingCountV2": "69"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519006"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110497",
                                    "name": "Chilli Paneer Sizzle",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with spiced paneer, a spicy Schezwan sauce, juicy tomato, crunchy onion & capsicum and a flavourful dressing. (298 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/4cbb05b7-a58e-41e5-9ac9-6e1dd9c7e64f_b046f848-fbdf-43dd-9a50-39a2528d2eab.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431634",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075153",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431635",
                                                "variationId": "117075154"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431635",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 189,
                                              "default": 1,
                                              "id": "117075154",
                                              "inStock": 1,
                                              "isVeg": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431634",
                                              "variationId": "117075153"
                                            },
                                            {
                                              "groupId": "37431635",
                                              "variationId": "117075154"
                                            }
                                          ],
                                          "price": 18900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 18900,
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.4",
                                        "ratingCount": "201 ratings",
                                        "ratingCountV2": "201"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519007"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "40706833"
                          },
                          {
                            "title": "Non-Veg Pizza",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110500",
                                    "name": "Classic Chicken Pepperoni & Onion",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with our classic signature pan sauce, chicken pepperoni, crunchy onion and a flavourful dressing. (332 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/e6f4237a-55ab-46a4-adbe-cbf79541416f_ef441d3e-0f31-4c12-b114-08a564de7ee9.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431640",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075159",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431641",
                                                "variationId": "117075160"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431641",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 159,
                                              "default": 1,
                                              "id": "117075160",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431640",
                                              "variationId": "117075159"
                                            },
                                            {
                                              "groupId": "37431641",
                                              "variationId": "117075160"
                                            }
                                          ],
                                          "price": 15900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 15900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "3.5",
                                        "ratingCount": "9 ratings",
                                        "ratingCountV2": "9"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#D9EFEC", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_medium",
                                        "ratingTextColor": "rating_medium",
                                        "ratingCountTextColor": "rating_medium",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519008"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110499",
                                    "name": "Classic Herbed Chicken & Capsicum",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with our classic signature pan sauce, herbed chicken, crunchy capsicum and a flavourful dressing. (331 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/4bd67a36-e254-489a-9519-3118951e5b11_1a56a4d2-72dd-46cc-aa17-8c806f086c91.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431638",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075157",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431639",
                                                "variationId": "117075158"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431639",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 179,
                                              "default": 1,
                                              "id": "117075158",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431638",
                                              "variationId": "117075157"
                                            },
                                            {
                                              "groupId": "37431639",
                                              "variationId": "117075158"
                                            }
                                          ],
                                          "price": 17900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 17900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.5",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519009"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "133110498",
                                    "name": "Chatpata Chicken Feast",
                                    "category": "Flavour Fun Pizzas",
                                    "description": "Pizza topped with a spicy tandoori sauce, Schezwan chicken meatballs, crunchy onion & capsicum, green chilli, juicy tomato and a flavourful dressing. (294 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/d0247064-0689-49fc-b382-fed753d47f28_61e83c62-d60d-456b-aa27-b83f2f89082a.jpg",
                                    "inStock": 1,
                                    "variants": {},
                                    "variantsV2": {
                                      "variantGroups": [
                                        {
                                          "groupId": "37431636",
                                          "name": "Size",
                                          "variations": [
                                            {
                                              "name": "Personal",
                                              "default": 1,
                                              "id": "117075155",
                                              "inStock": 1,
                                              "isEnabled": 1,
                                              "dependantVariation": {
                                                "groupId": "37431637",
                                                "variationId": "117075156"
                                              }
                                            }
                                          ]
                                        },
                                        {
                                          "groupId": "37431637",
                                          "name": "Choose your Crust",
                                          "variations": [
                                            {
                                              "name": "Pan",
                                              "price": 199,
                                              "default": 1,
                                              "id": "117075156",
                                              "inStock": 1,
                                              "isEnabled": 1
                                            }
                                          ]
                                        }
                                      ],
                                      "pricingModels": [
                                        {
                                          "variations": [
                                            {
                                              "groupId": "37431636",
                                              "variationId": "117075155"
                                            },
                                            {
                                              "groupId": "37431637",
                                              "variationId": "117075156"
                                            }
                                          ],
                                          "price": 19900
                                        }
                                      ]
                                    },
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 19900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "16 ratings",
                                        "ratingCountV2": "16"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "77519004"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "40706834"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2026/1/2/a5a7e6ae-6f80-48e1-b089-660fc6e621f3_fed0df22-1826-4cfc-8bd6-953418c79d56.jpg",
                        "categoryId": "40706821"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Garlic Bread",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "22019332",
                                "name": "Cheese Garlic Bread",
                                "category": "Garlic Bread",
                                "description": "Nothing beats our garlic bread! Period! (363 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/37c2d298-6a39-4042-8052-099eac78fa89_2e24c2e3-723d-4022-8201-fa1321af5f8a.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "231 ratings",
                                    "ratingCountV2": "231"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31606715"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114788274",
                                "name": "Exotica Veggie Garlic Bread",
                                "category": "Garlic Bread",
                                "description": "Hut's signature Garlic Bread topped with spiced exotic veggies and a flavourful dressing (449 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/965b53e7-4839-48d1-a887-13540a78c31d_f3142c0b-d7cc-48cc-b620-7752d86dd795.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "43 ratings",
                                    "ratingCountV2": "43"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066903"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "22019336",
                                "name": "Classic Bread Stix",
                                "category": "Garlic Bread",
                                "description": "Serves 1 | Freshly baked buttery bread stix, sprinkled with herbs (287 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/740bb625-1399-47a5-84e7-1ee06537f4cf_a471fd7f-7f53-4a54-83e4-06cc6e670ee9.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "214 ratings",
                                    "ratingCountV2": "214"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66066899"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135772194",
                                "name": "Loaded Bread Stix",
                                "category": "Garlic Bread",
                                "description": "Serves 1 | Freshly baked bread sticks, topped with a flavourful dressing & seasoned with herbs (320 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/5ed9aec1-1b63-4477-a43b-476a628d3b45_07825b66-79bb-456f-b698-3177bb31275f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "112 ratings",
                                    "ratingCountV2": "112"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79614662"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/37c2d298-6a39-4042-8052-099eac78fa89_2e24c2e3-723d-4022-8201-fa1321af5f8a.jpg",
                        "categoryId": "59598407"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Appetizers",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319068",
                                "name": "Cheezy Sprinkled Fries",
                                "category": "Appetizers",
                                "description": "Serves 1 | Baked fries seasoned with cheezy seasoning (213 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/0d0300d1-65e2-4102-b275-b1db003a6e56_f752e6cd-3a83-47a2-a6d6-97d2c4c19402.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "25 ratings",
                                    "ratingCountV2": "25"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79516771"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319080",
                                "name": "BBQ Baked Chicken Wings 6pc",
                                "category": "Appetizers",
                                "description": "All new baked BBQ chicken wings. Its juicy, spicy & so much flaourful (206 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/1af9446c-7ee3-49da-9735-68bbd8d37aaa_2602e279-23b9-47c6-bb94-1a006634c2d9.jpg",
                                "inStock": 1,
                                "price": 26900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.9",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "101649686"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319081",
                                "name": "BBQ Baked Chicken Wings 4pc",
                                "category": "Appetizers",
                                "description": "All new baked BBQ chicken wings. Its juicy, spicy & so much flaourful (206 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/a0eeb5d3-b04a-4a1e-addb-40fca47a6b20_e14ca512-d869-4538-a13a-5b95582d4ac3.jpg",
                                "inStock": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "101649685"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "114788276",
                                "name": "Sprinkled Fries - New",
                                "category": "Appetizers",
                                "description": "Serves 1 | Baked fries seasoned with our signature peruvian seasoning (204 Kcal/100g) Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/366ad3ca-9597-4f0a-aa87-66ff29d4204d_8ee697df-7baa-49df-87dc-d6277bcf73fa.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.2",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "66114575"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147077338",
                                "name": "Melts Meal for 1 with Exotica Veggie Garlic Bread 2Pcs & 1 Dip-Veg",
                                "category": "Appetizers",
                                "description": "Choose your favourite Melts & get Exotica Veggie Garlic Bread (2 Pcs) with Mayo Dip.  Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/c38cd4b4-9e70-4e02-bb5e-933f8c7c5409_24b9a1f3-f09f-40c0-8b08-2b80086dcd65.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "60045137",
                                      "name": "Choose your Melts",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 199,
                                          "default": 1,
                                          "id": "185844365",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045138",
                                            "variationId": "185844371"
                                          }
                                        },
                                        {
                                          "name": "Cheesy Cheese Veg",
                                          "price": 219,
                                          "id": "185844367",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045138",
                                            "variationId": "185844371"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "60045138",
                                      "name": "1st Appetizer",
                                      "variations": [
                                        {
                                          "name": "Exotica Veggie Garlic Bread (2 Pcs)",
                                          "price": 50,
                                          "default": 1,
                                          "id": "185844371",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045139",
                                            "variationId": "185844372"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "60045139",
                                      "name": "2nd Appetizer",
                                      "variations": [
                                        {
                                          "name": "Veg Mayonnaise Dip",
                                          "price": 10,
                                          "default": 1,
                                          "id": "185844372",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045137",
                                          "variationId": "185844365"
                                        },
                                        {
                                          "groupId": "60045138",
                                          "variationId": "185844371"
                                        },
                                        {
                                          "groupId": "60045139",
                                          "variationId": "185844372"
                                        }
                                      ],
                                      "price": 25900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045137",
                                          "variationId": "185844367"
                                        },
                                        {
                                          "groupId": "60045138",
                                          "variationId": "185844371"
                                        },
                                        {
                                          "groupId": "60045139",
                                          "variationId": "185844372"
                                        }
                                      ],
                                      "price": 27900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "86493936"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319073",
                                "name": "Create your Melts Box of 2 - Veg",
                                "category": "Appetizers",
                                "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/5f5e3b3a-ed17-4337-8c81-a70ae4381431_26f3e1cc-3e21-425f-87f4-702b3ba6e820.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "65684705",
                                      "name": "Choose your 1st Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "199070940",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "65684706",
                                            "variationId": "199070944"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "199070941",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "65684706",
                                            "variationId": "199070944"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "65684706",
                                      "name": "Choose your 2nd Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 189.5,
                                          "default": 1,
                                          "id": "199070944",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 219,
                                          "id": "199070945",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684705",
                                          "variationId": "199070940"
                                        },
                                        {
                                          "groupId": "65684706",
                                          "variationId": "199070944"
                                        }
                                      ],
                                      "price": 37900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684705",
                                          "variationId": "199070940"
                                        },
                                        {
                                          "groupId": "65684706",
                                          "variationId": "199070945"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684705",
                                          "variationId": "199070941"
                                        },
                                        {
                                          "groupId": "65684706",
                                          "variationId": "199070944"
                                        }
                                      ],
                                      "price": 40850
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684705",
                                          "variationId": "199070941"
                                        },
                                        {
                                          "groupId": "65684706",
                                          "variationId": "199070945"
                                        }
                                      ],
                                      "price": 43800
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 37900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79250081"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319076",
                                "name": "Melts 3 Course Meal for 1 - Veg",
                                "category": "Appetizers",
                                "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g), Makhni Paneer Melts : (265 Kcal/100g). For Meals, refer to the nutritional data for individual products",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/e66988d7-5533-4e3c-b69b-f7a72d711485_4a9be141-b1a5-404c-8470-b8e78f80b395.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "60045124",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Veggie BBQ",
                                          "price": 309,
                                          "default": 1,
                                          "id": "185844294",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Veg",
                                          "price": 329,
                                          "id": "185844295",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045124",
                                          "variationId": "185844294"
                                        }
                                      ],
                                      "price": 30900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045124",
                                          "variationId": "185844295"
                                        }
                                      ],
                                      "price": 32900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "78885246"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "147077339",
                                "name": "Melts Meal for 1 with Exotica Veggie Garlic Bread 2Pcs & 1 Dip-Non Veg",
                                "category": "Appetizers",
                                "description": "Choose your favourite Melts & get Exotica Veggie Garlic Bread (2 Pcs) with Mayo Dip. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g).  Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/24/3bf70d79-b9f1-4017-92f5-0f46ce5185cb_7d6da5db-403d-4005-9ae1-1a7baa6b0a33.jpg",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "60045140",
                                      "name": "Choose your Melts",
                                      "variations": [
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "185844373",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045142",
                                            "variationId": "185844378"
                                          }
                                        },
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "185844374",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045142",
                                            "variationId": "185844378"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "60045142",
                                      "name": "1st Appetizer",
                                      "variations": [
                                        {
                                          "name": "Exotica Veggie Garlic Bread (2 Pcs)",
                                          "price": 50,
                                          "default": 1,
                                          "id": "185844378",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "60045143",
                                            "variationId": "185844380"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "60045143",
                                      "name": "2nd Appetizer",
                                      "variations": [
                                        {
                                          "name": "Veg Mayonnaise Dip",
                                          "price": 10,
                                          "default": 1,
                                          "id": "185844380",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045140",
                                          "variationId": "185844373"
                                        },
                                        {
                                          "groupId": "60045142",
                                          "variationId": "185844378"
                                        },
                                        {
                                          "groupId": "60045143",
                                          "variationId": "185844380"
                                        }
                                      ],
                                      "price": 32900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045140",
                                          "variationId": "185844374"
                                        },
                                        {
                                          "groupId": "60045142",
                                          "variationId": "185844378"
                                        },
                                        {
                                          "groupId": "60045143",
                                          "variationId": "185844380"
                                        }
                                      ],
                                      "price": 30900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "86493935"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135671573",
                                "name": "Cheezy Cheese Veg & Loaded BBQ Veg Combo",
                                "category": "Appetizers",
                                "description": "Serves 2 | Double the satisfaction with Cheezy Cheese Veg & Loaded BBQ Veg Melts. Cheezy Cheese Veg Melts :  (296 Kcal/100g), Loaded BBQ Veg Melts : (255 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/5f5e3b3a-ed17-4337-8c81-a70ae4381431_26f3e1cc-3e21-425f-87f4-702b3ba6e820.jpg_compressed",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 39900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 2"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "79614658"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "55978472",
                                "name": "Spicy Baked Chicken Wings 4pc",
                                "category": "Appetizers",
                                "description": "Serves 1 | 4 pcs of tender and juicy sweet chilly chicken wings (189 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/03653d71-0f72-4f8d-9bb0-c96d8038ee7d_21b9ecf2-4aeb-49d9-a513-54140c5c4a8a.jpg",
                                "inStock": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "31608911"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "33314461",
                                "name": "Spicy Baked Chicken Wings 6pc",
                                "category": "Appetizers",
                                "description": "Serves 1 | 6 pcs of tender and Juicy sweet chilli chicken wings (189 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/154d9449-09f4-485c-8ce7-ce06eaf57723_a6c62cab-52ef-4866-bf77-57d54e867ce5.jpg",
                                "inStock": 1,
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "101649690"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319078",
                                "name": "Create your Melts Box of 2 Non-Veg",
                                "category": "Appetizers",
                                "description": "Serves 2 | Choose any 2 Melts. Double the flavour, double the satisfaction. Cheezy Cheese Chicken : (268 Kcal/100g), Loaded BBQ Non-Veg : (330 Kcal/100g), Chicken Tikka Keema : (283 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/36f7eae1-c1b8-4d15-b8bb-120264974614_1832d753-a67b-4f1f-b6c9-c6d95d56e719.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "65684707",
                                      "name": "Choose your 1st Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "199070948",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "65684708",
                                            "variationId": "199070952"
                                          }
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "199070949",
                                          "inStock": 1,
                                          "isEnabled": 1,
                                          "dependantVariation": {
                                            "groupId": "65684708",
                                            "variationId": "199070952"
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "groupId": "65684708",
                                      "name": "Choose your 2nd Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 249,
                                          "default": 1,
                                          "id": "199070952",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 269,
                                          "id": "199070953",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684707",
                                          "variationId": "199070948"
                                        },
                                        {
                                          "groupId": "65684708",
                                          "variationId": "199070952"
                                        }
                                      ],
                                      "price": 49800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684707",
                                          "variationId": "199070948"
                                        },
                                        {
                                          "groupId": "65684708",
                                          "variationId": "199070953"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684707",
                                          "variationId": "199070949"
                                        },
                                        {
                                          "groupId": "65684708",
                                          "variationId": "199070952"
                                        }
                                      ],
                                      "price": 51800
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "65684707",
                                          "variationId": "199070949"
                                        },
                                        {
                                          "groupId": "65684708",
                                          "variationId": "199070953"
                                        }
                                      ],
                                      "price": 53800
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 2"
                                },
                                "defaultPrice": 49800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "79250080"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135319079",
                                "name": "Melts 3 Course Meal for 1 Non-Veg",
                                "category": "Appetizers",
                                "description": "Serves 1 | The perfect \"Me Time\" meal. Choose your favourite Melts & Fries accompanied with 1 Pepsi PET. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts : (330 Kcal/100g), Chicken Tikka Keema Melts : (283 Kcal/100g). For Meals, refer to the nutritional data for individual products",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/5ecb8dd2-9320-4331-b9fa-e86c25957788_aaa42e08-a75c-486e-be8d-b89f70a8fa61.jpg_compressed",
                                "inStock": 1,
                                "variants": {},
                                "variantsV2": {
                                  "variantGroups": [
                                    {
                                      "groupId": "60045131",
                                      "name": "Choose your Melt",
                                      "variations": [
                                        {
                                          "name": "Loaded Chicken BBQ",
                                          "price": 359,
                                          "default": 1,
                                          "id": "185844330",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Cheezy Cheese Chicken",
                                          "price": 379,
                                          "id": "185844333",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ],
                                  "pricingModels": [
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045131",
                                          "variationId": "185844330"
                                        }
                                      ],
                                      "price": 35900
                                    },
                                    {
                                      "variations": [
                                        {
                                          "groupId": "60045131",
                                          "variationId": "185844333"
                                        }
                                      ],
                                      "price": 37900
                                    }
                                  ]
                                },
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 35900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "78885245"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "135333645",
                                "name": "Cheezy Cheese Chicken & Loaded BBQ Non-Veg Combo",
                                "category": "Appetizers",
                                "description": "Serves 1 | Satisfy your non veg cravings with Cheezy Cheese Chicken & Loaded Chicken BBQ Melts. Cheezy Cheese Chicken Melts : (268 Kcal/100g), Loaded BBQ Non-Veg Melts: (330 Kcal/100g).",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/36f7eae1-c1b8-4d15-b8bb-120264974614_1832d753-a67b-4f1f-b6c9-c6d95d56e719.jpg_compressed",
                                "inStock": 1,
                                "price": 48900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "79614656"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "81890473",
                                "name": "Jalapeno Pepper Dip",
                                "category": "Appetizers",
                                "description": "Serves 1 | Cheesy jalapeno dip 20 gm (49 Kcal/100g) Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/f0334c32-1b35-414e-803c-0114f826ac13_1e6c4d47-9b8e-4838-a347-a1309d97cbc6.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "101649689"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "81890472",
                                "name": "Veg Mayonnaise Dip",
                                "category": "Appetizers",
                                "description": "Serves 1 | Veg mayonnaise dip 20 gm (55 Kcal/100g). Contains Cereals containing Gluten (Wheat) & Soya.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/d5e73b0a-6921-4886-a20b-05df6f68884f_c6a23139-44b4-42ef-ab12-9e336dc783db.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 2857,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "41295168"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "110321103",
                                "name": "Tomato Ketchup",
                                "category": "Appetizers",
                                "description": "Serves 1 | Ketchup sachet (11 Kcal/100g)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/58a496f7-2659-4485-b709-ae792549355f_69a9a228-08cc-4d6c-94dd-52024b469510.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 95,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "794 ratings",
                                    "ratingCountV2": "794"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "79614663"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "76892661",
                                "name": "Momo Dip",
                                "category": "Appetizers",
                                "description": "Serves 1 | Schezwan dip (18 Kcal/100g)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/17/902e7ef1-71a7-4899-975d-88e96585f6a8_9db6ac0b-d3af-4374-b521-e187a3bdd82f.jpg",
                                "inStock": 1,
                                "isVeg": 1,
                                "price": 3000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "26 ratings",
                                    "ratingCountV2": "26"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "37766992"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/0d0300d1-65e2-4102-b275-b1db003a6e56_f752e6cd-3a83-47a2-a6d6-97d2c4c19402.jpg",
                        "categoryId": "40706812"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Drinks & Desserts",
                        "categories": [
                          {
                            "title": "Beverages",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "22019368",
                                    "name": "Pepsi 475ml",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Pepsi PET 475ml. Contains Caffeine (43 Kcal/100ml)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/54bec0bd-d1fe-45d2-a1be-35182bb79359_63f92b9f-a7d4-4c7a-97a6-fa17c954c413.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {
                                      "text": "Bestseller",
                                      "textColor": "#ffffff",
                                      "topBackgroundColor": "#d53d4c",
                                      "bottomBackgroundColor": "#b02331"
                                    },
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "isBestseller": true,
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "783 ratings",
                                        "ratingCountV2": "783"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "81489708"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "60784358",
                                    "name": "Pepsi Zero Sugar 300ml",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Pepsi Zero Sugar Can 300ml. Contains Caffeine (0 Kcal/100ml)",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/7/7371efdd-b41f-4f9d-92b6-affff4113f52_ac059385-6e48-4c77-9677-0fa4e11bc5b4.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 5700,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.1",
                                        "ratingCount": "92 ratings",
                                        "ratingCountV2": "92"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "imageBadges": [
                                      {
                                        "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                      }
                                    ],
                                    "parentId": "81489709"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "54627679",
                                    "name": "Water Bottle 1000ml",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Packaged Drinking Water, A PepsiCo Product. 1000ml.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/13/c923159f-0d2e-44e0-89e0-147714f2cebb_1c6f9391-f440-489e-a1ee-b8a580729aff.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 4286,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.2",
                                        "ratingCount": "4 ratings",
                                        "ratingCountV2": "4"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "31609759"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "40706824"
                          },
                          {
                            "title": "Dessert",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "119746530",
                                    "name": "Brow-wow-nie",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | A divine choco brownie for your all time chocolate cravings (273 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/c99e2359-999f-410a-be36-89f5dd86fc4e_be0bb96e-ae2b-405a-abaa-a80f7551c3a5.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 10900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "2 ratings",
                                        "ratingCountV2": "2"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "68626769"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "22019365",
                                    "name": "Choco Volcano",
                                    "category": "Drinks & Desserts",
                                    "description": "Serves 1 | Warm choco cake with gooey center (262 Kcal/100g). Contains Cereals containing Gluten (Wheat), Soya and Milk & Milk Products.",
                                    "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/f70ec3a0-baa2-4b7d-a1f3-2f16c10028c3_f127c54f-8b53-45f1-b92f-a62e650bf334.jpg",
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "price": 9900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG",
                                      "portionSize": "Serves 1"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.3",
                                        "ratingCount": "207 ratings",
                                        "ratingCountV2": "207"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "31607330"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "40706825"
                          }
                        ],
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/16/54bec0bd-d1fe-45d2-a1be-35182bb79359_63f92b9f-a7d4-4c7a-97a6-fa17c954c413.jpg",
                        "categoryId": "40706810"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 11419010000119"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Pizza Hut",
                        "area": "Indrapuri",
                        "completeAddress": "Unit No 17B, Ground Floor, Sector-B, Indrapuri, Bhopal, Madhya Pradesh"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "I2ckgwWotAS0-gFP3M61D4FYlGkVCrJPWiC2xbrc"
  },

  "111736": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Rolls Mania - Rolls, Wraps & More",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                },
                {
                  "id": "Dineout",
                  "title": "Dineout",
                  "cta": "https://swiggy.com/menu/111736/dineout"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "111736",
                "name": "Rolls Mania - Rolls, Wraps & More",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "rolls-mania-piplani-piplani",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "vojccqen25sa8rkqgpcj",
                "locality": "BHEL",
                "areaName": "BHEL",
                "costForTwo": "20000",
                "costForTwoMessage": "₹200 for two",
                "cuisines": ["Rolls & Wraps", "Fast Food"],
                "avgRating": 4.5,
                "feeDetails": {
                  "restaurantId": "111736",
                  "fees": [{}]
                },
                "parentId": "514939",
                "avgRatingString": "4.5",
                "totalRatingsString": "1.4K+ ratings",
                "sla": {
                  "restaurantId": "111736",
                  "deliveryTime": 579,
                  "minDeliveryTime": 574,
                  "maxDeliveryTime": 579,
                  "lastMileTravel": 8.6,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 1006,
                  "slaString": "574-579 MINS",
                  "lastMileTravelString": "8.6 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "shortDescriptionList": [
                    {
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "10% off upto ₹100|Use SBIDC100 Above ₹599",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "rolls-mania-piplani-piplani",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "shop no 25 , raj avenue 5 , near minal street gate no 2  Bhopal"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Rolls & Wraps,Fast Food"
                  }
                ],
                "logo": "Brand logo/RollsMania",
                "totalRatings": 1400,
                "aggregatedDiscountInfoV2": {
                  "shortDescriptionList": [
                    {
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "10% off upto ₹100|Use SBIDC100 Above ₹599",
                      "discountType": "Percentage",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/111736"
                },
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:15 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "hasBestsellerItems": true,
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.273078,77.460273",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {}
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 1,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "10% OFF UPTO ₹100",
                        "offerTagColor": "#E46D47",
                        "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "offerIds": ["febf18d0-c5b4-4e9b-8dd4-78648914fca1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE SBIDC100",
                        "description": "ABOVE ₹599",
                        "offerType": "offers",
                        "restId": "111736",
                        "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE SBIDC100"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Classic Chicken Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135155",
                                "name": "Chicken Mughlai Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Served Boneless | | Creamy Brown Onion Gravy With Tender Chicken Chunks Cooked In Mughlai Style And Rolled In Your Choice Of Base |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f1e34846-1663-43dc-8d46-4e1918ff6dfe_fba9c54f-d514-45af-935b-4951173ea4a8.png_compressed",
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380073",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380074",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380075",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380076",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380078",
                                    "groupName": "Extra Filling Chicken Mughlai Roll",
                                    "choices": [
                                      {
                                        "id": "112012620",
                                        "name": "Extra Chicken Mughlai Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "27 ratings",
                                    "ratingCountV2": "27"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648591"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136074",
                                "name": "Chicken Bhuna Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | |  spicy | | Tender Chicken Sauteed In Bhuna Masala And Spices And then Wrapped - A Total Win! |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0a5420c6-c3fd-4db8-bf53-c946407bfa13_b8831fe1-fea6-4a56-92e0-a5241cd75cd8.png_compressed",
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380067",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380068",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380069",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380070",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380072",
                                    "groupName": "Extra Filling  Chicken Bhuna Roll",
                                    "choices": [
                                      {
                                        "id": "112012622",
                                        "name": "Extra Chicken Bhuna Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648580"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "78218930",
                                "name": "Tandoori Chicken Tikka Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | Tender Chicken Marinated with Aromatic Spices, Roasted and Topped with our Secret Sauces Rolled In Your Favourite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/887da559-2dd4-4954-8662-be7981c20e94_e6694373-13ee-495b-b5cb-74440e0d6033.png_compressed",
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "143807203",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "143807204",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807205",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807206",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807207",
                                    "groupName": "Extra Filling  Tandoori Chicken Tikka Roll",
                                    "choices": [
                                      {
                                        "id": "115558079",
                                        "name": "Extra  Tandoori Chicken Tikka Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.5",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648637"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136643",
                                "name": "Double Chicken Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Served Boneless | | Juicy Chunks Of Loaded Chicken Rolled Up In A Fulfilling Roll! |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/27c717cc-9532-4665-b7d9-52345ac72495_56126c8a-9526-464b-a548-09d6e5e2285d.png_compressed",
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380036",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380037",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380038",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380039",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648603"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136260",
                                "name": "Chicken Keema Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | Serves 1 , 1 Pc | | Medium spicy | | Served Boneless | | Minced Chicken Seasoned With Aromatic Spices Rolled Up In Your Favorite Base ,",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0aa05b3d-75ed-4b0b-8265-3358af001f9e_c01efa69-830d-40f1-ab76-899f0d2366ce.png_compressed",
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "194947093",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "194947094",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "194947095",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "194947096",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "194947098",
                                    "groupName": "Extra Filling   Chicken Keema Roll",
                                    "choices": [
                                      {
                                        "id": "131908915",
                                        "name": "Extra Chicken Keema Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648587"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137082",
                                "name": "Butter Chicken Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Served Boneless | | The Most Popular Recipe On Our Menu - Butter Chicken Roll Is A Hit! |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/cc41815f-b324-4ffb-b45b-d21d263eb628_9f559d98-ac33-4d18-9909-bb8f41fb244f.png_compressed",
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "143807213",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "143807214",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807215",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807216",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807218",
                                    "groupName": "Extra Filling  Butter Chicken Roll",
                                    "choices": [
                                      {
                                        "id": "115558078",
                                        "name": "Extra Butter Chicken Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648569"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136232",
                                "name": "Chicken Fry Roll.",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | Serves 1 Medium spicy | Yummy Tawa Chicken Fry With Delicious Garnishing Rolled In Your Favorite Base",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/27c717cc-9532-4665-b7d9-52345ac72495_56126c8a-9526-464b-a548-09d6e5e2285d.png_compressed",
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380001",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380002",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380003",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380004",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380006",
                                    "groupName": "Extra Filling  Chicken Fry Roll",
                                    "choices": [
                                      {
                                        "id": "112012630",
                                        "name": "Extra Chicken Fry Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "26 ratings",
                                    "ratingCountV2": "26"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648583"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135238",
                                "name": "Chicken Cheese Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | Yummy Chicken Rolled With Lots Of Melted Cheese - What A Hit!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/74134636-03e2-4256-9b26-8304df439345_edb53605-435c-41e4-8679-c9f7a6025b87.png_compressed",
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380079",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380080",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380081",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380082",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380084",
                                    "groupName": "Extra Filling  Chicken Cheese Roll",
                                    "choices": [
                                      {
                                        "id": "112012621",
                                        "name": "Extra Chicken Cheese Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "22 ratings",
                                    "ratingCountV2": "22"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648581"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "78218956",
                                "name": "Chicken Tikka Masala Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | Special Creamy Spiced Curry Blended Well with Marinated Chicken Chunks Rolled In Your Favourite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/c8a851d4-2a73-4c31-9920-88a90ff3d6b9_9962e716-db0e-402e-a89b-b45973d420e1.png_compressed",
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "143807208",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "143807209",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807210",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807211",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807212",
                                    "groupName": "Extra Filling  Chicken Tikka Masala Roll",
                                    "choices": [
                                      {
                                        "id": "115558080",
                                        "name": "Extra Chicken Tikka Masala Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648596"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200224",
                                "name": "Chicken Kathi Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Juicy Chicken Marinated in Aromatic Spices, Cooked to Perfection and Wrapped Around Egg Omelette, Topped with our Secret Dressing Rolled in your Favorite Base Wrap.",
                                "imageId": "byc8vbkgnyyrpoyzvs3r",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380056",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380057",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380058",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380059",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380060",
                                    "groupName": "Extra Filling  Chicken Kathi Kebab Roll",
                                    "choices": [
                                      {
                                        "id": "112012624",
                                        "name": "Extra Chicken Kathi Kebab Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648586"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135196",
                                "name": "Chicken Mayonnaise Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | A Classic Combination Of Tender Chicken Chunks With Mayonnaise Deliciously Rolled In Your Favorite Base Wrap |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/74134636-03e2-4256-9b26-8304df439345_edb53605-435c-41e4-8679-c9f7a6025b87.png_compressed",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380061",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380062",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380063",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380064",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380066",
                                    "groupName": "Extra Filling  Chicken Mayonnaise Roll",
                                    "choices": [
                                      {
                                        "id": "112012623",
                                        "name": "Extra Chicken Mayonnaise Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648589"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200223",
                                "name": "Chicken Seekh Kebab Roll",
                                "category": "Classic Chicken Rolls",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f5b6b921-6027-4c12-989a-f1cb4d6e7e47_bca440e4-c15e-4c21-a87b-8d370b750dae.png_compressed",
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380046",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380047",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380048",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380049",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380050",
                                    "groupName": "Extra Filling  Chicken Seekh Kebab Roll",
                                    "choices": [
                                      {
                                        "id": "112012628",
                                        "name": "Extra Chicken Seekh Kebab Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648595"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952272",
                                "name": "Chicken 65 Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "India's Famous Chicken 65 Made In Special Hyderabadi Style - Spicy and Aromatic Burst with Curry Flavors Wrapped In Your Favourite Base",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/6fd376d1-b78a-4232-b63a-8089b3d23429_ed41b523-917d-43db-9632-15328f8e6ceb.png_compressed",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380025",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380026",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380027",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380028",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380029",
                                    "groupName": "Extra Filling  Chicken 65 Roll",
                                    "choices": [
                                      {
                                        "id": "112012633",
                                        "name": "Extra Chicken 65 Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648578"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136980",
                                "name": "Cheesy Barbeque Chicken Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Delicious BBQ Chicken With Lots Of Melted Cheese And Yum Sauces Rolled In Your Favorite Base Wrap |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/a02e7c57-8bea-419e-bf3f-1abacaf18821_a08a49d3-4e19-46a2-b34d-9f2dfe9f73f8.png_compressed",
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209412",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "261209413",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209414",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209415",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209417",
                                    "groupName": "Extra Filling  Cheesy Barbeque Chicken Roll",
                                    "choices": [
                                      {
                                        "id": "142514470",
                                        "name": "Extra Cheesy Barbeque Chicken  Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648573"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136291",
                                "name": "Chicken Hot Garlic Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | A Perfect Combination Of Tender Chicken And Hot Garlic Spicy Sauce Rolled Up In Your Favorite Base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f1298edb-dba4-4acd-a703-c2d0a9e5052e_142d8e98-addd-4e14-8976-adfd911cecba.png_compressed",
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380019",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380020",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380021",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380022",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380024",
                                    "groupName": " Extra Filling  Chicken Hot Garlic Roll",
                                    "choices": [
                                      {
                                        "id": "112012631",
                                        "name": "Extra Chicken Hot Garlic Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648585"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136497",
                                "name": "Chicken Hariyali Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | A Punjabi Chicken Recipe With Chicken Cubes Cooked In A Creamy Green Chutney Rolled To Perfection!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/af55e84d-e042-4b3e-922d-a5f6690b62c9_d7463b1e-eafb-4d9e-8302-6a395fc701ec.png_compressed",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380030",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380031",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380032",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380033",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380035",
                                    "groupName": "Extra Filling  Chicken Hariyali Roll",
                                    "choices": [
                                      {
                                        "id": "112012626",
                                        "name": "Extra Chicken Hariyali Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648584"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135833",
                                "name": "Chicken Chilli Roll",
                                "category": "Classic Chicken Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Chicken Cooked With Chillies In Chinese Sauces And Deliciously Wrapped |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/9c11418c-70be-4caf-8a03-b50d8477f974_83b7d323-2f71-47a5-9676-fff6c4886025.png_compressed",
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380013",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380014",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380015",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380016",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380018",
                                    "groupName": "Extra Filling  Chicken Chilli Roll",
                                    "choices": [
                                      {
                                        "id": "112012632",
                                        "name": "Extra Chicken Chili Filling",
                                        "price": 9000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648582"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f1e34846-1663-43dc-8d46-4e1918ff6dfe_fba9c54f-d514-45af-935b-4951173ea4a8.png_compressed",
                        "categoryId": "44804513"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Meal Box & Rice Bowl",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473187",
                                "name": "Chicken Mughlai Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Creamy Brown Onion Gravy With Tender Chicken Chunks Cooked In Mughlai Style. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "ntzuhvsrkqldeelfoede",
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380094",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380095",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380096",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648590"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473188",
                                "name": "Chicken Bhuna Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Tender Chicken Sauteed In Bhuna Masala. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "ntzuhvsrkqldeelfoede",
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380097",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380098",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380099",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648579"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473189",
                                "name": "Butter Chicken Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "The Most Popular Punjabi Recipe - Butter Chicken. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "ntzuhvsrkqldeelfoede",
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "143807243",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "143807244",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "143807245",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648567"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473186",
                                "name": "Chicken Kheema Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Minced Juicy Chicken Cooked With Aromatic Spices. Served with 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "ntzuhvsrkqldeelfoede",
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133380091",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133380092",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133380093",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648588"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239115",
                                "name": "Butter Chicken Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | The Most Popular Punjabi Recipe - Butter Chicken Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "imageId": "rbto37po2bfzphdifdof",
                                "price": 27900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285738",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82933503"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239108",
                                "name": "Amritsari Chole Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Spiced Tangy Chickpea Curry, The Most Popular Punjabi Dish Liked By All Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "imageId": "iag5gn3qzsa4jjnvj6vf",
                                "isVeg": 1,
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285732",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82933502"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239114",
                                "name": "Chicken Bhuna Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Tender Chicken Sauteed In Bhuna Masala Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "price": 26900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285737",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82933504"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473183",
                                "name": "Paneer Mughlai Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Fresh Cottage Cheese With Creamy Brown Onion Gravy Cooked In Mughlai Style. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/d9937b3b-fc60-4f7e-990c-76cd420d5193_a4eed8c8-565e-4023-b808-32936e359dc2.png_compressed",
                                "isVeg": 1,
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "98663331",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108111",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108112",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648623"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473184",
                                "name": "Paneer Bhuna Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Cottage Cheese Sauteed In Bhuna Masala Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/241cf71c-4b66-4bc8-93f4-1bfdbce630ee_da4b2e5c-c7c4-4fb9-bcc2-2b49093c25cf.png_compressed",
                                "isVeg": 1,
                                "price": 23900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "98663322",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108113",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108114",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 23900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648613"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239113",
                                "name": "Paneer Makhani Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Fresh Cottage Cheese Cooked In Secret Makhani Gravy Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "imageId": "iget2dtquzjzeva4znlq",
                                "isVeg": 1,
                                "price": 27900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285736",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82933511"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64473185",
                                "name": "Paneer Makhani Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Fresh Cottage Cheese Cooked In Secret Makhani Gravy Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/d9937b3b-fc60-4f7e-990c-76cd420d5193_a4eed8c8-565e-4023-b808-32936e359dc2.png_compressed",
                                "isVeg": 1,
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "98663391",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108115",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108116",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648619"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239111",
                                "name": "Rajma Masala Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Most Popular North Indian Creamy, Tangy and Spiced Curry with Kidney Beans Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "imageId": "gckebnq3g68lte4iwdh6",
                                "isVeg": 1,
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285733",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82933512"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239112",
                                "name": "Paneer Bhuna Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Cottage Cheese Sauteed In Bhuna Masala Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "isVeg": 1,
                                "price": 26900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285735",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 26900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82933510"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "76381911",
                                "name": "Dal Makhani Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Rich Creamy & Buttery Dal Makhani Served With Aromatic Basmati Rice And Salad To Complete Your Meal.",
                                "imageId": "q9ngixy1yxl4vcu9tv3e",
                                "isVeg": 1,
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285734",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82933505"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239106",
                                "name": "Amritsari Chole Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Spiced Tangy Chickpea Curry, The Most Popular Punjabi Dish Liked By All. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/575b8f58-3eff-429c-b7a0-6c8d23cd60a2_3b6b6aa8-322f-4963-bb10-e69e7d8ae384.png_compressed",
                                "isVeg": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "128699519",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "128699520",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "128699521",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648562"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "73964344",
                                "name": "Rajma Masala Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | Most Popular North Indian Creamy, Tangy and Spiced Curry with Kidney Beans. Served With 2 Parathas And Salad To Complete Your Meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f851df30-82a4-4dc8-8317-3f3c061bcac4_1b116613-34d3-4b5e-8973-357b3b1479e4.png_compressed",
                                "isVeg": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "98663374",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108109",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108110",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648630"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239107",
                                "name": "Mutton Shammi Meal Box",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | EXTRA SPICY \nJuicy Mouth-Watering Mutton Galouti Kebabs Topped With Secret Dressing Served With 2 Parathas And Salad/Green Chutney To Complete Your Meal.",
                                "imageId": "wykflvfqdip4ytrql4lw",
                                "price": 32900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209432",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209433",
                                    "groupName": "Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691000",
                                        "name": "Maida Paratha (2 Parathas)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691001",
                                        "name": "Wheat Paratha (2 Parathas)",
                                        "price": 3000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "261209434",
                                    "groupName": "Extra Paratha ",
                                    "choices": [
                                      {
                                        "id": "49691002",
                                        "name": "Extra Maida Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691003",
                                        "name": "Extra Wheat Paratha (1 Paratha)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82933507"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239116",
                                "name": "Mutton Shammi Rice Bowl",
                                "category": "Meal Box & Rice Bowl",
                                "description": "Serves 1 | EXTRA SPICY \nJuicy Mouth-Watering Mutton Galouti Kebabs Topped With Secret Gravy Served With Aromatic Basmati Rice And Salad/Green Chutney To Complete Your Meal.",
                                "imageId": "ga8um6rq1gowksz42q4h",
                                "price": 32900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209437",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 32900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82933508"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "ntzuhvsrkqldeelfoede",
                        "categoryId": "26585265"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Signature Paneer Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135125",
                                "name": "Paneer Mughlai Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Fresh Paneer Chunks Rolled In Creamy Brown Onion Gravy Cooked In Mughlai Style |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/8588f54d-f77a-48ec-bd5d-5d5040b676db_12a9e491-0500-4803-8fd1-97c13974d892.png_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607024",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607025",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253493",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607026",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935879",
                                    "groupName": "Extra Filling  Paneer Mughlai Roll",
                                    "choices": [
                                      {
                                        "id": "103253502",
                                        "name": "Extra Paneer Mughlai Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648624"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136503",
                                "name": "Paneer Cheese Masala Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | King Sized Paneer & Melted Cheese Masala Roll For King Sized Hunger!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/984b3009-cc31-41a3-b998-45546917c481_00809a50-0183-404f-a5f1-9aa50ea33458.png_compressed",
                                "isVeg": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607491",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607492",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253668",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607493",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935963",
                                    "groupName": "Extra Filling  Paneer Cheese Masala Roll",
                                    "choices": [
                                      {
                                        "id": "103253660",
                                        "name": "Extra Paneer Cheese Masala Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "31 ratings",
                                    "ratingCountV2": "31"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648615"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "30667448",
                                "name": "Veg Paneer Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Fresh Vegetables Mashed Together With Our Secret Spice Blended With Paneer &  Topped With Delicious Sauces Wrapped in Your Favorite Base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/12e38832-569b-4c70-9e0a-42a856cc4313_9dc2d2f7-61f0-4f21-a22a-619804e88e18.png_compressed",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "73319998",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "73319999",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253533",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "73320000",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935912",
                                    "groupName": "Extra Filling  Veg Paneer Roll",
                                    "choices": [
                                      {
                                        "id": "103253560",
                                        "name": "Extra Veg Paneer Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648639"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135781",
                                "name": "Paneer Bhuna Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | Paneer Sauteed In Bhuna Masala - Wrapped In Your Favorite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/479c7918-cc8f-41ae-bb8f-a7ed8337c17c_d75da2a1-704e-4975-a4ce-d8a1efd5b6a5.png_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607433",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607434",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253612",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607435",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935946",
                                    "groupName": "Extra Filling  Paneer Bhuna Roll",
                                    "choices": [
                                      {
                                        "id": "103253633",
                                        "name": "Extra Paneer Bhuna Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648614"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136157",
                                "name": "Paneer Masala Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Paneer, Tomatoes, Onions And Variety Of Spices Rolled Up To Perfection! |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/b39355d1-1684-46d7-a56a-46aa893f6d44_05511a1b-3181-4b26-a794-bff4ec5df1e3.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607391",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607392",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253563",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607393",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935931",
                                    "groupName": "Extra Filling  Paneer Masala Roll",
                                    "choices": [
                                      {
                                        "id": "103253582",
                                        "name": "Extra Paneer Masala Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "42 ratings",
                                    "ratingCountV2": "42"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648621"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "30667465",
                                "name": "Paneer Hariyali Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | A Punjabi Paneer Recipe Cooked In A Creamy Green Chutney Rolled With Chunks Of Paneer.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0f212c35-ab29-4ffa-9a36-3d9e13853b1f_33cc0205-6a92-4d97-b9da-81b7abf854e5.png_compressed",
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607500",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607501",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253690",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607502",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935974",
                                    "groupName": "Extra Filling  Paneer Hariyali Roll ",
                                    "choices": [
                                      {
                                        "id": "103253679",
                                        "name": "Extra Paneer Hariyali Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648617"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136910",
                                "name": "Paneer Makhani Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | Classic Paneer (Cottage Cheese) Makhani Recipe Rolled In Your Favorite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/8588f54d-f77a-48ec-bd5d-5d5040b676db_12a9e491-0500-4803-8fd1-97c13974d892.png_compressed",
                                "isVeg": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607117",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607118",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253517",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607119",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935898",
                                    "groupName": "Extra Filling  Paneer Makhani Roll",
                                    "choices": [
                                      {
                                        "id": "103253540",
                                        "name": "Extra Paneer Makhani Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648620"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136751",
                                "name": "Cheesy Barbeque Paneer Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Paneer With Barbecue Sauce, Gooey Cheese Rolled To Perfection |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/72acc12a-72ee-490f-acf7-4914d5828105_0f3a1b58-95cb-4987-bc9c-572814f6b574.png_compressed",
                                "isVeg": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209405",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "261209406",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209408",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209409",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209411",
                                    "groupName": "Extra Filling  Cheesy Barbeque Paneer Roll ",
                                    "choices": [
                                      {
                                        "id": "142514471",
                                        "name": "Extra Cheesy Barbeque Paneer Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648575"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135730",
                                "name": "Paneer Chilli Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Paneer Made With Chilies And Delicious Sauces Rolled Into One! |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/032c9ad5-cbc6-4af8-a263-d4d32877bcf2_f20654f4-6796-4fc6-9028-543596a96710.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607411",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607412",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253592",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607413",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935935",
                                    "groupName": "Extra Filling Paneer Chili Roll",
                                    "choices": [
                                      {
                                        "id": "103253604",
                                        "name": "Extra Paneer Chili  Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648616"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135096",
                                "name": "Paneer Mayonnaise Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | A Classic Combination Of Fresh Paneer Chunks And Delish Mayonnaise Rolled In Your Favorite Base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/fd7e5762-dc9d-4326-96a3-4eb36fc156ce_082423cc-acbd-4bf0-9260-744271ea770e.png_compressed",
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "73320004",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "73320005",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253516",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "73320007",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935897",
                                    "groupName": "Extra Filling  Paneer Mayonnaise Roll",
                                    "choices": [
                                      {
                                        "id": "103253539",
                                        "name": "Extra Paneer Mayonnaise Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648622"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136203",
                                "name": "Paneer Hot Garlic Roll",
                                "category": "Signature Paneer Rolls",
                                "description": "Serves 1 | A Combination Of Fresh Paneer And Hot Garlic Spicy Sauce Rolled Up In Your Favorite Base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/574602e3-6127-473f-b01a-3797d7d5dba1_f712675d-e1a8-4b10-84df-e251756c9292.png_compressed",
                                "isVeg": 1,
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "103588924",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "103588925",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "103588926",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "103588927",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935868",
                                    "groupName": "EXtra Filling  Paneer Hot Garlic Roll",
                                    "choices": [
                                      {
                                        "id": "103253483",
                                        "name": "Extra Paneer Hot Garlic Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.4",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648618"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/8588f54d-f77a-48ec-bd5d-5d5040b676db_12a9e491-0500-4803-8fd1-97c13974d892.png_compressed",
                        "categoryId": "26585269"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "SUPER VALUE COMBOS",
                        "categories": [
                          {
                            "title": "Single Saver Mania",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026626",
                                    "name": "Butter Chicken Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Butter Chicken Roll + Chicken Popcorn(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "price": 41900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240668",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865126"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "67695960",
                                    "name": "Chicken Bhuna Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Chicken Bhuna Roll + Chicken Popcorn(Half) +Chilli Garlic Poppers(Half)+ French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "price": 41900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240664",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865130"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026625",
                                    "name": "Chicken Mughlai Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in  Chicken Mughlai Roll + Chicken Popcorn(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "price": 41900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240656",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865138"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026623",
                                    "name": "Chicken Chilli Super Mania.",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Chicken Chilli Roll + Chicken Popcorn + Chilli Garlic Poppers + French Fries + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "price": 41900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240660",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865132"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026620",
                                    "name": "Paneer Mughlai Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in  Paneer Mughlai  Roll + Cheese Poppers(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "isVeg": 1,
                                    "price": 39900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240666",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 39900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865150"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026621",
                                    "name": "Paneer Chilli Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "|Serves 1| |Medium spicy| Scrumptious filling in Paneer Chilli Roll + Cheese Poppers(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo |Paneer Chilli Super Mania Served as Dry|",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "isVeg": 1,
                                    "price": 39900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240653",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 39900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865143"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026619",
                                    "name": "Paneer Masala Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Paneer Masala Roll + Cheese Poppers(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "isVeg": 1,
                                    "price": 56900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "153240659",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 56900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "2.9",
                                        "ratingCount": "5 ratings",
                                        "ratingCountV2": "5"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#FFF0CD", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_low",
                                        "ratingTextColor": "rating_low",
                                        "ratingCountTextColor": "rating_low",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "83865147"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026622",
                                    "name": "Cheesy BBQ Paneer Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Cheesy BBQ Paneer Roll + Cheese Poppers (Half) + Chilli Garlic Poppers (Half) + French Fries (Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "isVeg": 1,
                                    "price": 39900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "261209398",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 39900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865128"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66026629",
                                    "name": "Cheesy BBQ Chicken Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Cheesy BBQ Chicken Roll + Chicken Popcorn(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + Cold Coffee Combo",
                                    "imageId": "tcqnew58psjule7ijs55",
                                    "price": 41900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "261209399",
                                        "groupName": "Base",
                                        "choices": [
                                          {
                                            "id": "49690990",
                                            "name": "Maida Base",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "49690991",
                                            "name": "Wheat Base",
                                            "price": 1500,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 41900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {
                                        "rating": "4.0",
                                        "ratingCount": "1 rating",
                                        "ratingCountV2": "1"
                                      },
                                      "ratingsPresentationConfig": {
                                        "bgGradient": {
                                          "colours": ["#C8F9E5", "#00FFFFFF"],
                                          "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                        },
                                        "ratingIconColor": "rating_very_good",
                                        "ratingTextColor": "rating_very_good",
                                        "ratingCountTextColor": "rating_very_good",
                                        "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                        "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                      }
                                    },
                                    "parentId": "83865127"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "26585277"
                          },
                          {
                            "title": "Couple Saver Mania",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "67695961",
                                    "name": "Chicken Bhuna Roll + Butter Chicken Roll Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Chicken Bhuna Roll +  Butter Chicken Roll + Chicken Popcorn(Half) + Chilli Garlic Poppers(Half)+ French Fries(Half) + 2 Ice Tea Combo",
                                    "imageId": "xdn9v3fzg3shucyhjyvp",
                                    "price": 55900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "164258211",
                                        "groupName": "Couple Saver Base ",
                                        "choices": [
                                          {
                                            "id": "120287939",
                                            "name": "Maida Base (CSM)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "120287938",
                                            "name": "Wheat Base (CSM)",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 55900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865129"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66347860",
                                    "name": "Paneer Mughlai Roll + Paneer Chilli Roll Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Paneer Mughlai Roll + Paneer Chilli Roll + Cheese Poppers(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + 2 Ice Tea Combo",
                                    "imageId": "xdn9v3fzg3shucyhjyvp",
                                    "isVeg": 1,
                                    "price": 55900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "164258285",
                                        "groupName": "Couple Saver Base ",
                                        "choices": [
                                          {
                                            "id": "120287939",
                                            "name": "Maida Base (CSM)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "120287938",
                                            "name": "Wheat Base (CSM)",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 55900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865149"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66347858",
                                    "name": "Paneer Masala Roll  + Cheesy BBQ Paneer Roll Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Paneer Masala Roll + Cheesy BBQ Paneer Roll + Cheese Poppers(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + 2 Ice Tea Combo",
                                    "imageId": "xdn9v3fzg3shucyhjyvp",
                                    "isVeg": 1,
                                    "price": 55900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "263732176",
                                        "groupName": "Couple Saver Base ",
                                        "choices": [
                                          {
                                            "id": "120287939",
                                            "name": "Maida Base (CSM)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "120287938",
                                            "name": "Wheat Base (CSM)",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "defaultPrice": 55900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865146"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              },
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "66347863",
                                    "name": "Chicken Mughlai Roll + Cheesy BBQ Chicken Roll Super Mania",
                                    "category": "SUPER VALUE COMBOS",
                                    "description": "Scrumptious filling in Chicken Mughlai Roll + Cheesy BBQ Chicken Roll + Chicken Popcorn(Half) + Chilli Garlic Poppers(Half) + French Fries(Half) + 2 Ice Tea Combo",
                                    "imageId": "xdn9v3fzg3shucyhjyvp",
                                    "price": 55900,
                                    "variants": {},
                                    "variantsV2": {},
                                    "addons": [
                                      {
                                        "groupId": "263732177",
                                        "groupName": "Couple Saver Base ",
                                        "choices": [
                                          {
                                            "id": "120287939",
                                            "name": "Maida Base (CSM)",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "id": "120287938",
                                            "name": "Wheat Base (CSM)",
                                            "price": 3000,
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ],
                                        "maxAddons": 1,
                                        "maxFreeAddons": -1,
                                        "minAddons": 1
                                      }
                                    ],
                                    "itemAttribute": {
                                      "vegClassifier": "NONVEG"
                                    },
                                    "defaultPrice": 55900,
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "parentId": "83865135"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "26585278"
                          }
                        ],
                        "image": "tcqnew58psjule7ijs55",
                        "categoryId": "26585267"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Egg Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "30667473",
                                "name": "Double Egg Omelette Roll",
                                "category": "Egg Rolls",
                                "description": "Serves 1 | | Serves 1 | | Medium spicy | | Double Layered Omlette Wrapped In A Quick Breakfast Roll |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/7d3b6667-a3ab-47a0-b56a-9df780a3f4c3_7a2016dd-2a85-4244-8aed-7b704bae3e4b.png_compressed",
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133379981",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133379982",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379983",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379984",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {
                                  "text": "Bestseller",
                                  "textColor": "#ffffff",
                                  "topBackgroundColor": "#d53d4c",
                                  "bottomBackgroundColor": "#b02331"
                                },
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "isBestseller": true,
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "164 ratings",
                                    "ratingCountV2": "164"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82466922"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136706",
                                "name": "Double Omelette Double Chicken Roll",
                                "category": "Egg Rolls",
                                "description": "Serves 1 | Our King Sized Special Double Omelette Loaded With Juicy Extra Chicken Chunks",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/33b51903-5440-4c1e-858b-3a786622f9c1_9d5814d6-d181-48ba-8b6f-229c063d4a1a.png_compressed",
                                "price": 25900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133379996",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133379997",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379998",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379999",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 25900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648605"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136604",
                                "name": "Double Omelette Chicken Roll",
                                "category": "Egg Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | A Fullfilling King Sized Roll Made With Double Egg Omelette And Stuffed With Some Juicy Chicken |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0bef9b80-fb3f-4c2f-a632-14b5e2306c4f_fff1d879-5d3e-4124-86c9-76fcac7341c4.png_compressed",
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133379986",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133379987",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379988",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379989",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "24 ratings",
                                    "ratingCountV2": "24"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648604"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45134899",
                                "name": "Egg Omelette Roll",
                                "category": "Egg Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | |A Quick Breakfast Choice Of Single Omlette And Delicious Wrapping In Your Favorite Base wrap |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/7d3b6667-a3ab-47a0-b56a-9df780a3f4c3_7a2016dd-2a85-4244-8aed-7b704bae3e4b.png_compressed",
                                "price": 8900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133379976",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133379977",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379978",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379979",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 8900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "103 ratings",
                                    "ratingCountV2": "103"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82466923"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136674",
                                "name": "Double Chicken Omelette Roll",
                                "category": "Egg Rolls",
                                "description": "Serves 1 | A Perfect Roll Made With Single Egg Omelette And Stuffed With Loads Of Juicy Chicken!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/33b51903-5440-4c1e-858b-3a786622f9c1_9d5814d6-d181-48ba-8b6f-229c063d4a1a.png_compressed",
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "133379991",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "133379992",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379993",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "133379994",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648602"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/7d3b6667-a3ab-47a0-b56a-9df780a3f4c3_7a2016dd-2a85-4244-8aed-7b704bae3e4b.png_compressed",
                        "categoryId": "44804512"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Sides",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137248",
                                "name": "Chicken Popcorn (R)",
                                "category": "Sides",
                                "description": "Serves 1 | |Serves 1| |Medium spicy| Crispy Crunchy Bite Sized Chicken Snack You Will Love!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/6/636e85f5-19be-4217-9adf-7d5af6cdce18_486b9259-5039-4ba2-be99-c2c408c4c67d_compressed",
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 13900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "22 ratings",
                                    "ratingCountV2": "22"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82466920"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952276",
                                "name": "Chicken Nuggets (L)",
                                "category": "Sides",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/e93918e8-da7a-4ce0-9a5c-2d5c2b7ea4a9_6b9a6a79-0eff-45c4-a468-a598b32377fb_compressed",
                                "price": 22900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 22900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648592"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952275",
                                "name": "Chicken Popcorn (L)",
                                "category": "Sides",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/6/636e85f5-19be-4217-9adf-7d5af6cdce18_486b9259-5039-4ba2-be99-c2c408c4c67d_compressed",
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648594"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137250",
                                "name": "Chicken Nuggets (R)",
                                "category": "Sides",
                                "description": "Serves 1",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/e93918e8-da7a-4ce0-9a5c-2d5c2b7ea4a9_6b9a6a79-0eff-45c4-a468-a598b32377fb_compressed",
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648593"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137267",
                                "name": "Butter Chicken Nachos",
                                "category": "Sides",
                                "description": "Serves 1 | The Combination Of Crispy Nachos With India's Classic Butter Chicken Gravy.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/bf929268-eaf7-4f57-89f2-1e13dcd06bfd_0a71d442-54f8-45e7-8726-005f26f2f408_compressed",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648568"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952273",
                                "name": "Chilli Garlic Poppers (L)",
                                "category": "Sides",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/03ca8034-3dd2-4432-90cc-c1fdea46cff7_357956fd-302b-482c-8f33-a8e899d083ea_compressed",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648598"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137244",
                                "name": "Cheese Poppers (R)",
                                "category": "Sides",
                                "description": "Serves 1 | Delicious Cheese Poppers Which Make A Great Snack For Any Party in Regular Size!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/2255ce3c-5305-4e73-bfc1-880e4001a261_6e38e2f2-8c2e-41d8-bc35-663cd3083b35_compressed",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466919"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137239",
                                "name": "Chilli Garlic Poppers (R)",
                                "category": "Sides",
                                "description": "Serves 1 | Chilli Garlic Potato Bites Seasoned With Delicious Flavors in Regular Size!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/03ca8034-3dd2-4432-90cc-c1fdea46cff7_357956fd-302b-482c-8f33-a8e899d083ea_compressed",
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466921"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952274",
                                "name": "Cheese Poppers (L)",
                                "category": "Sides",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/2255ce3c-5305-4e73-bfc1-880e4001a261_6e38e2f2-8c2e-41d8-bc35-663cd3083b35_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648572"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137258",
                                "name": "Punjabi Nachos",
                                "category": "Sides",
                                "description": "Serves 1 | Crispy Nachos Tossed In Our Rich & Creamy Makhani Gravy With Chunks Of Fresh Paneer!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/b4ee650e-ead8-400a-9450-dd6e2a50c439_d696e669-bd2f-4438-bccf-e12493c7bd12_compressed",
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648629"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137251",
                                "name": "Nachos",
                                "category": "Sides",
                                "description": "Serves 1 | Classic Crispy Mexican Nachos",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/c0aceb21-926d-45ac-a6d1-b7bbd9bd97ed_e2359219-fbc5-4f7d-b7e7-a3f9e2b26586_compressed",
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.8",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466929"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137253",
                                "name": "Salsa Nachos",
                                "category": "Sides",
                                "description": "Serves 1 | Crispy Nachos Topped With Homemade Salsa Sauce And Cheese.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/9414d558-38f6-4ade-93ca-18e40ea7c681_c67d73e1-53a3-415e-ab43-0fb5f02ff3d3_compressed",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.1",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648632"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/6/636e85f5-19be-4217-9adf-7d5af6cdce18_486b9259-5039-4ba2-be99-c2c408c4c67d_compressed",
                        "categoryId": "26585275"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Beverages",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200222",
                                "name": "Bubblegum Iced Tea",
                                "category": "Beverages",
                                "imageId": "jfnx0nj4wbmvxztgtxny",
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648565"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137268",
                                "name": "Iced Tea Peach",
                                "category": "Beverages",
                                "description": "Serves 1 | |300 ml| Substitute Regular Tea With Some Peach And Ice Cubes.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/ba1add76-2e6e-4699-8569-f3c7e50575c5_2e607db2-00b2-4301-87a2-e96df1ca2e9d_compressed",
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466926"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137270",
                                "name": "Iced Tea Lemon",
                                "category": "Beverages",
                                "description": "Serves 1 | Substitute Regular Tea With Some Fresh Lemons And Ice Cubes.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/ba1add76-2e6e-4699-8569-f3c7e50575c5_2e607db2-00b2-4301-87a2-e96df1ca2e9d_compressed",
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466925"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137288",
                                "name": "Chocolate Frappe",
                                "category": "Beverages",
                                "description": "Serves 1 | Chocolate And Thick Creamy Milk Blended To Perfection.",
                                "imageId": "dgyhoni9t496jaoacc3c",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648599"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200217",
                                "name": "Hazelnut Cold Coffee",
                                "category": "Beverages",
                                "description": "Chocolate And Thick Creamy Milk Blended To Perfection.",
                                "imageId": "orw68q630bazavs5gy3w",
                                "isVeg": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648608"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200216",
                                "name": "Irish Cold Coffee",
                                "category": "Beverages",
                                "description": "Irish cold coffee for coffee lovers!",
                                "imageId": "jsyh8z9u66vqdgna9tpt",
                                "isVeg": 1,
                                "price": 13900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 13900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648610"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200220",
                                "name": "Blueberry Frappe",
                                "category": "Beverages",
                                "imageId": "i1lfvh9w9at8d2v8bivr",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648564"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137273",
                                "name": "Cold Coffee",
                                "category": "Beverages",
                                "description": "Serves 1 | For All The Caffeine Lovers - A Creamy, Frothy Cold Coffee!",
                                "imageId": "pmworocly7y32mlbpfkh",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648600"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137278",
                                "name": "Mint Mojito",
                                "category": "Beverages",
                                "description": "Serves 1 | |300 ml| This Classic Mint Mojito Is the Favorite Of All!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/34d9c617-1783-4917-b49f-782db55b37ad_edf3462d-ab86-4f49-9c59-34f5b6b40f18_compressed",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.6",
                                    "ratingCount": "10 ratings",
                                    "ratingCountV2": "10"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466927"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137276",
                                "name": "Blue Lagoon",
                                "category": "Beverages",
                                "description": "Serves 1 | |300 ml| A Blend Of Sweet And Sour This One Is A Perfect Refreshing Drink.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/14e29cf3-8ca4-4e1c-b7c1-8b939c0564a1_4698903c-af06-479e-8f17-1857334ac07b_compressed",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466917"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "104200221",
                                "name": "Watermelon Iced Tea",
                                "category": "Beverages",
                                "imageId": "rt7shqnwzvhio2dz57kc",
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648640"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137284",
                                "name": "Strawberry Frappe",
                                "category": "Beverages",
                                "description": "Serves 1 | A Perfect Blend Of Strawberry Essence And Thick Milk.",
                                "imageId": "aqhupsfmqeilcn5kmfvh",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466931"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137287",
                                "name": "Butterscotch Frappe",
                                "category": "Beverages",
                                "description": "Serves 1 | A Perfect Blend Of Butterscotch Essence And Thick Milk.",
                                "imageId": "waxvlhtysvbettw3b91d",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466918"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "jfnx0nj4wbmvxztgtxny",
                        "categoryId": "28050875"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Fries Mania.",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137190",
                                "name": "Butter Chicken Fries",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Golden Crispy Fries With India's Most Popular Butter Chicken Gravy Is One Of Our Best-Sellers.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/4d323d96-b4ab-40f0-b762-bcf7a71d7de7_cdb90a79-9e24-4191-a5dc-39aa8d404acb_compressed",
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "143807247",
                                    "groupName": "Fries Add Ons (Chicken, Cheese)",
                                    "choices": [
                                      {
                                        "id": "115558081",
                                        "name": "Chicken",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "115558086",
                                        "name": "Cheese",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648566"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137178",
                                "name": "French Fries (R)",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Classic Crispy Salted Fries.",
                                "imageId": "p7cp0timcvznyceazc2e",
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "36 ratings",
                                    "ratingCountV2": "36"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466924"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952279",
                                "name": "French Fries (M)",
                                "category": "Fries Mania.",
                                "description": "Classic Crispy Salted Fries in Medium Size.",
                                "imageId": "d3a83cabb1f47cafee9109c59b408489",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648607"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137185",
                                "name": "Cheesy  Barbeque Fries",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Crispy Salted Fries Topped With Cheesy Barbecue Sauce.",
                                "imageId": "k7dekpqeifr2qlcrrzvg",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209440",
                                    "groupName": "Fries Add Ons",
                                    "choices": [
                                      {
                                        "id": "49691222",
                                        "name": "Chicken",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691223",
                                        "name": "Paneer",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691224",
                                        "name": "Cheese",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648574"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137187",
                                "name": "Chilli Garlic Jalapeno Fries",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Crispy Fries Topped With Spiced Chilly Garlic Jalapenos-Sauce.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/8512ae1e-1dba-4cde-9726-f734af35098d_c47313ec-e2d7-4b0e-8067-f30d442bd7b6_compressed",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "62108519",
                                    "groupName": "Fries Add Ons",
                                    "choices": [
                                      {
                                        "id": "49691222",
                                        "name": "Chicken",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691223",
                                        "name": "Paneer",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691224",
                                        "name": "Cheese",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.1",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648597"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952277",
                                "name": "Peri Peri Fries (L)",
                                "category": "Fries Mania.",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648625"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952271",
                                "name": "French Fries (L)",
                                "category": "Fries Mania.",
                                "description": "Classic Crispy Salted Fries in Large Portion",
                                "imageId": "p7cp0timcvznyceazc2e",
                                "isVeg": 1,
                                "price": 14800,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 14800,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648606"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "118952278",
                                "name": "Peri Peri Fries (M)",
                                "category": "Fries Mania.",
                                "description": "Classic Crispy Peri Peri Fries in Medium Size",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648626"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "73964345",
                                "name": "Peri Peri Fries (R)",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Crispy French Fries Tossed In Your Favorite Peri Peri Masala Tantalizing Your Taste Buds!",
                                "isVeg": 1,
                                "price": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 12900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648627"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137191",
                                "name": "Punjabi Fries",
                                "category": "Fries Mania.",
                                "description": "Serves 1 | Crispy Golden French Fries Tossed In Our Rich & Creamy Secret Makhani Gravy With Chunks Of Paneer!",
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "62108523",
                                    "groupName": "Fries Add Ons (Paneer, Cheese)",
                                    "choices": [
                                      {
                                        "id": "49691227",
                                        "name": "Paneer",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691228",
                                        "name": "Cheese",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648628"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/5/4d323d96-b4ab-40f0-b762-bcf7a71d7de7_cdb90a79-9e24-4191-a5dc-39aa8d404acb_compressed",
                        "categoryId": "26585273"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "REGULAR SAVER COMBOS",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "88705107",
                                "name": "2 Classic Non-Veg Rolls at 299",
                                "category": "REGULAR SAVER COMBOS",
                                "description": "Great Savings on Combo of Two Classic Bestseller Non - Veg Rolls.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/dbdea1a6-904d-49ac-a0e5-b9af7e60096f_528cad47-2579-4820-ac6d-699e81275192.png_compressed",
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258208",
                                    "groupName": "Upgrade Your Base - I",
                                    "choices": [
                                      {
                                        "id": "120287936",
                                        "name": "Maida Base (Roll - I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287935",
                                        "name": "Wheat Base (Roll - I)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108139",
                                    "groupName": "*Choose Your Roll - I @ 299*",
                                    "choices": [
                                      {
                                        "id": "49691054",
                                        "name": "Chicken Mughlai Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691055",
                                        "name": "Chicken Mayonnaise Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691056",
                                        "name": "Chicken Bhuna Roll  (Spicy) (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108140",
                                    "groupName": "Upgrade your Roll - I",
                                    "choices": [
                                      {
                                        "id": "49691025",
                                        "name": "Single Egg Omelette (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691026",
                                        "name": "Double Egg Omelette (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691027",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691028",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691029",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 5,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "164258210",
                                    "groupName": "Upgrade Your Base - II",
                                    "choices": [
                                      {
                                        "id": "120287937",
                                        "name": "Maida Base (Roll - II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287934",
                                        "name": "Wheat Base (Roll - Il)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108141",
                                    "groupName": "*Choose Your Roll - II @ 299*.",
                                    "choices": [
                                      {
                                        "id": "49691057",
                                        "name": "Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691058",
                                        "name": "Double Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108142",
                                    "groupName": "Upgrade your Roll - II",
                                    "choices": [
                                      {
                                        "id": "49691035",
                                        "name": "Single Egg Omelette (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691036",
                                        "name": "Double Egg Omelette (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691037",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691038",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691039",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253647",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108143",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648557"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "88705111",
                                "name": "2 Supreme Non-Veg Rolls at 309",
                                "category": "REGULAR SAVER COMBOS",
                                "description": "Great Savings on Combo of Two Supreme Bestseller Non - Veg Rolls.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/09df1ff3-bd42-46e4-8a22-9be489760d4c_18ee8429-d197-483c-9959-ce69fbd84e35.png_compressed",
                                "price": 30900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258205",
                                    "groupName": "Upgrade Your Base - I",
                                    "choices": [
                                      {
                                        "id": "120287936",
                                        "name": "Maida Base (Roll - I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287935",
                                        "name": "Wheat Base (Roll - I)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108151",
                                    "groupName": "**Choose Your Roll - I @ 309**",
                                    "choices": [
                                      {
                                        "id": "49691075",
                                        "name": "Butter Chicken Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "68226099",
                                        "name": "Cheesy BBQ Chicken Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691077",
                                        "name": "Chicken Cheese Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108152",
                                    "groupName": "Upgrade your Roll - I",
                                    "choices": [
                                      {
                                        "id": "49691025",
                                        "name": "Single Egg Omelette (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691026",
                                        "name": "Double Egg Omelette (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691027",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691028",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691029",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 5,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "164258206",
                                    "groupName": "Upgrade Your Base - II",
                                    "choices": [
                                      {
                                        "id": "120287937",
                                        "name": "Maida Base (Roll - II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287934",
                                        "name": "Wheat Base (Roll - Il)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108153",
                                    "groupName": "**Choose Your Roll - II @ 309**",
                                    "choices": [
                                      {
                                        "id": "49691078",
                                        "name": "Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691079",
                                        "name": "Double Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691080",
                                        "name": "Aloo Chilli Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691081",
                                        "name": "Aloo Fry Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691082",
                                        "name": "Mix Veg Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108154",
                                    "groupName": "Upgrade your Roll - II",
                                    "choices": [
                                      {
                                        "id": "49691035",
                                        "name": "Single Egg Omelette (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691036",
                                        "name": "Double Egg Omelette (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691037",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691038",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691039",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253558",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108155",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648560"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "88705105",
                                "name": "2 Classic Veg Rolls at 299",
                                "category": "REGULAR SAVER COMBOS",
                                "description": "Great Savings on  Combo of Two Classic Bestseller Veg Rolls.\n#MI54",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/9775a4e6-c599-45b8-b670-da6dbfdc35ac_0707880a-0de4-4f56-9e3f-8deeb25b5b55.png_compressed",
                                "isVeg": 1,
                                "price": 29900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258218",
                                    "groupName": "Upgrade Your Base - I",
                                    "choices": [
                                      {
                                        "id": "120287936",
                                        "name": "Maida Base (Roll - I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287935",
                                        "name": "Wheat Base (Roll - I)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108133",
                                    "groupName": "*Choose Your Roll - I @ 299.",
                                    "choices": [
                                      {
                                        "id": "49691041",
                                        "name": "Paneer Mayonnaise Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691042",
                                        "name": "Paneer Bhunna Roll (Spicy) (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691043",
                                        "name": "Paneer Mughlai Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108134",
                                    "groupName": "*Upgrade your Roll - I",
                                    "choices": [
                                      {
                                        "id": "49691065",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691066",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691067",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "164258219",
                                    "groupName": "Upgrade Your Base - II",
                                    "choices": [
                                      {
                                        "id": "120287937",
                                        "name": "Maida Base (Roll - II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287934",
                                        "name": "Wheat Base (Roll - Il)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108135",
                                    "groupName": "*Choose Your Roll - II @ 299.",
                                    "choices": [
                                      {
                                        "id": "49691047",
                                        "name": "Aloo Fry Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691048",
                                        "name": "Aloo Chilli Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691049",
                                        "name": "Mix Veg Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108136",
                                    "groupName": "*Upgrade your Roll - II",
                                    "choices": [
                                      {
                                        "id": "49691071",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691051",
                                        "name": "Tangy Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691052",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691053",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253644",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108137",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 29900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648558"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "88705103",
                                "name": "2 Pocket Friendly Rolls at 199",
                                "category": "REGULAR SAVER COMBOS",
                                "description": "Great Savings on Combo of Two Pocket Friendly Rolls.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0918f6e4-0446-4e58-a9d3-359c54c8ab33_932f73ea-0569-4067-bbde-fd41bb34bd88.png_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258221",
                                    "groupName": "Upgrade Your Base - I",
                                    "choices": [
                                      {
                                        "id": "120287936",
                                        "name": "Maida Base (Roll - I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287935",
                                        "name": "Wheat Base (Roll - I)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108127",
                                    "groupName": "Choose Your Roll - I @ 199.",
                                    "choices": [
                                      {
                                        "id": "49691020",
                                        "name": "Aloo Fry Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691021",
                                        "name": "Aloo Chilli Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691022",
                                        "name": "Mix Veg Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691023",
                                        "name": "Egg Omelette Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691024",
                                        "name": "Double Egg Omelette Roll (Roll-I)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108128",
                                    "groupName": "Upgrade your Roll - I",
                                    "choices": [
                                      {
                                        "id": "49691025",
                                        "name": "Single Egg Omelette (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691026",
                                        "name": "Double Egg Omelette (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691027",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691028",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691029",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 5,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "164258222",
                                    "groupName": "Upgrade Your Base - II",
                                    "choices": [
                                      {
                                        "id": "120287937",
                                        "name": "Maida Base (Roll - II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287934",
                                        "name": "Wheat Base (Roll - Il)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108129",
                                    "groupName": "Choose Your Roll - II @ 199.",
                                    "choices": [
                                      {
                                        "id": "49691030",
                                        "name": "Aloo Fry Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691031",
                                        "name": "Aloo Chilli Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691032",
                                        "name": "Mix Veg Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691033",
                                        "name": "Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691034",
                                        "name": "Double Egg Omelette Roll (Roll-II)",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108130",
                                    "groupName": "Upgrade your Roll - II",
                                    "choices": [
                                      {
                                        "id": "49691035",
                                        "name": "Single Egg Omelette (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691036",
                                        "name": "Double Egg Omelette (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691037",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691038",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691039",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253617",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108131",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "17 ratings",
                                    "ratingCountV2": "17"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648559"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "88705108",
                                "name": "2 Supreme Veg Rolls at 309",
                                "category": "REGULAR SAVER COMBOS",
                                "description": "Great Savings on Combo of Two Supreme Bestseller Veg Rolls.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/dccb6129-736b-4715-bcc0-87809d7b8ad9_2d484afe-58ab-4169-8d8b-522c7592a904.png_compressed",
                                "isVeg": 1,
                                "price": 30900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258235",
                                    "groupName": "Upgrade Your Base - I",
                                    "choices": [
                                      {
                                        "id": "120287936",
                                        "name": "Maida Base (Roll - I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287935",
                                        "name": "Wheat Base (Roll - I)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108145",
                                    "groupName": "**Choose Your Roll - I @ 309",
                                    "choices": [
                                      {
                                        "id": "49691062",
                                        "name": "Paneer Makhani Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "68226098",
                                        "name": "Cheesy BBQ Paneer Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691064",
                                        "name": "Paneer Cheese Roll (Roll-I)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108146",
                                    "groupName": "*Upgrade your Roll - I",
                                    "choices": [
                                      {
                                        "id": "49691065",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-I)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691066",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691067",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-I)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "164258238",
                                    "groupName": "Upgrade Your Base - II",
                                    "choices": [
                                      {
                                        "id": "120287937",
                                        "name": "Maida Base (Roll - II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "120287934",
                                        "name": "Wheat Base (Roll - Il)",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108147",
                                    "groupName": "**Choose Your Roll - II @ 309",
                                    "choices": [
                                      {
                                        "id": "49691068",
                                        "name": "Aloo Chilli Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691069",
                                        "name": "Aloo Fry Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691070",
                                        "name": "Mix Veg Roll (Roll-II)",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "62108148",
                                    "groupName": "*Upgrade your Roll - II",
                                    "choices": [
                                      {
                                        "id": "49691071",
                                        "name": "Cheese Melt (Goes inside the roll) (Roll-II)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691051",
                                        "name": "Tangy Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691052",
                                        "name": "Mayonnaise (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49691053",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll) (Roll-II)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253557",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "62108149",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 30900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648561"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/dbdea1a6-904d-49ac-a0e5-b9af7e60096f_528cad47-2579-4820-ac6d-699e81275192.png_compressed",
                        "categoryId": "26585266"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Best Cheesy Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "100174181",
                                "name": "Aloo Cheese Roll",
                                "category": "Best Cheesy Rolls",
                                "description": "Serves 1 | Your Favorite Aloo Roll With Lots Of Melted Cheese-Wrapped In Your Favorite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/eccc578c-2654-4a32-84f2-5fab99237634_c064740f-f901-49d7-84dc-d2e5b0b00f5d.png_compressed",
                                "isVeg": 1,
                                "price": 14900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "89405463",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "89405464",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253729",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "89405465",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935989",
                                    "groupName": "Extra Filling  Aloo Cheese Roll",
                                    "choices": [
                                      {
                                        "id": "103253702",
                                        "name": "Extra Aloo Cheese Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 14900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82466914"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135419",
                                "name": "Cheese Chilli Manchurian Roll",
                                "category": "Best Cheesy Rolls",
                                "description": "Serves 1 | A Delicious Indo-Chinese Recipe With Manchurian Cheese Chunks Rolled To Perfection.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/c2ca4557-ceeb-49ff-aaf5-5fa9ca36895e_e52de2ef-24d2-44c3-b763-ddd390b99b38.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607522",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607523",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253732",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607524",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935990",
                                    "groupName": "Extra Filling  Cheese Chili Manchurian Roll",
                                    "choices": [
                                      {
                                        "id": "103253703",
                                        "name": "Extra Cheese Chili Manchurian Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "28 ratings",
                                    "ratingCountV2": "28"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648570"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135067",
                                "name": "Cheesy Corn Roll",
                                "category": "Best Cheesy Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | A Combination Of American Corn With Loads Of Gooey Cheese Rolled In Your Favorite Base |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/4e55f09e-fafb-482c-8f1d-94d2658c7853_63d902ae-d3e9-4d66-a912-3d7526b9aff4.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "74675163",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "74675164",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253519",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "74675165",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935899",
                                    "groupName": "Extra Filling  Cheesy Corn Roll",
                                    "choices": [
                                      {
                                        "id": "103253541",
                                        "name": "Extra Cheesy Corn Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "37 ratings",
                                    "ratingCountV2": "37"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648577"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "100174182",
                                "name": "Veg Cheese Roll",
                                "category": "Best Cheesy Rolls",
                                "description": "Serves 1 | Fresh Vegetables Tossed In Yum Sauces With Lots Of Melted Cheese Wrapped In Your Favorite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/eccc578c-2654-4a32-84f2-5fab99237634_c064740f-f901-49d7-84dc-d2e5b0b00f5d.png_compressed",
                                "isVeg": 1,
                                "price": 16900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607387",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607388",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253561",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607389",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935930",
                                    "groupName": "Extra Filling  Vegetable Cheese Roll",
                                    "choices": [
                                      {
                                        "id": "103253581",
                                        "name": "Extra Vegetable Cheese Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 16900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "103901683"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136189",
                                "name": "Cheese Masala Roll",
                                "category": "Best Cheesy Rolls",
                                "description": "Serves 1 | A Combination Of Melted Cheese And Our Secret Masala Rolled Up In Your Favorite Base",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/8b27a506-0ddf-4806-be39-bd5f78b58881_dfe77fee-ad4c-4562-bf2d-4d040941b24a.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607510",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607511",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253705",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607512",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935979",
                                    "groupName": "Extra Filling  Cheese Masala Roll",
                                    "choices": [
                                      {
                                        "id": "103253688",
                                        "name": "Extra Cheese Masala Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.0",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "82648571"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/eccc578c-2654-4a32-84f2-5fab99237634_c064740f-f901-49d7-84dc-d2e5b0b00f5d.png_compressed",
                        "categoryId": "29748060"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Soya Chaap Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64332759",
                                "name": "Soya Chaap Mughlai Roll",
                                "category": "Soya Chaap Rolls",
                                "description": "Serves 1 | Creamy Brown Onion Gravy Combined With Fresh Soya Chaap, Rolled In Goodness!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f9b462ae-843a-4617-a62c-3e5a92f0d85e_cf4ca8de-8d24-4544-bed8-eb8842df59a5.png_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285720",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "181285721",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285722",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285723",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285725",
                                    "groupName": "Extra Filling  Soya Chaap Mughlai Roll",
                                    "choices": [
                                      {
                                        "id": "127732859",
                                        "name": "Extra  Soya Chaap Mughlai Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648636"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64332763",
                                "name": "Soya Chaap Masala Roll",
                                "category": "Soya Chaap Rolls",
                                "description": "Serves 1 | Fresh Soya Chaap Seasoned With Masala Rolled To Perfection In Your Favourite Base!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/301cfe88-fa62-4053-acef-cc8dcc1527eb_98e0516d-9b99-4b40-9551-b8f2c1b3f709.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285702",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "181285703",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285704",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285705",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285707",
                                    "groupName": "Extra Filling  Soya Chaap Masala Roll",
                                    "choices": [
                                      {
                                        "id": "127732858",
                                        "name": "Extra Soya Chaap Masala Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648635"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64332762",
                                "name": "Soya Chaap Bhuna Roll",
                                "category": "Soya Chaap Rolls",
                                "description": "Serves 1 | Fresh Soya Chaap Sauteed In Our Secret Bhuna Masala Rolled In Your Favourite Base!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/0edbede5-455a-4e1e-b8b5-7db5eb06b07c_026c4a4f-08bb-42b5-b912-91372c832ff7.png_compressed",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285708",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "181285709",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285710",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285711",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285713",
                                    "groupName": "Extra Filling  Soya Chaap Bhuna Roll",
                                    "choices": [
                                      {
                                        "id": "127732857",
                                        "name": "Extra Soya Chaap Bhuna Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648633"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64332760",
                                "name": "Soya Chaap Makhani Roll",
                                "category": "Soya Chaap Rolls",
                                "description": "Serves 1 | A Delicious Combination Of Soya Chaap In Creamy Makhani Gravy Wrapped In Your Favourite Base!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f9b462ae-843a-4617-a62c-3e5a92f0d85e_cf4ca8de-8d24-4544-bed8-eb8842df59a5.png_compressed",
                                "isVeg": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285726",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "181285727",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285728",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285729",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285731",
                                    "groupName": " Extra Filling  Soya Chaap Makhani Roll",
                                    "choices": [
                                      {
                                        "id": "127732856",
                                        "name": "Extra Soya Chaap Makhani Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648634"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "64332761",
                                "name": "Cheesy BBQ Soya Chaap Roll",
                                "category": "Soya Chaap Rolls",
                                "description": "Serves 1 | An Awesome Combination Of BBQ Sauce, Gooey Cheese With Fresh Soya Chaap Rolled In Your Favourite Base!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/3963f503-136a-4719-9137-d44401515dd3_f96221f4-63a6-4f90-ba2c-1b41eacb3851.png_compressed",
                                "isVeg": 1,
                                "price": 21900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "181285714",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "181285715",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285716",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285717",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "181285719",
                                    "groupName": " Extra Filling  Cheesy BBQ Soya Chaap Roll",
                                    "choices": [
                                      {
                                        "id": "127732860",
                                        "name": "Extra Cheesy BBQ Soya Chaap Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 21900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648576"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f9b462ae-843a-4617-a62c-3e5a92f0d85e_cf4ca8de-8d24-4544-bed8-eb8842df59a5.png_compressed",
                        "categoryId": "54187060"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Special Combos",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "60486766",
                                "name": "Chicken Mughlai Roll + Chicken Chilli Roll + Chicken Cheese Roll",
                                "category": "Special Combos",
                                "description": "Let's Mix It Up",
                                "price": 55900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "164258287",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 55900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "83865136"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "60486764",
                                "name": "Butter Chicken Roll  + Chicken Fry Roll + Chicken Mughlai Roll",
                                "category": "Special Combos",
                                "description": "Every Meat Eaters Favorite Combo",
                                "price": 55900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "153240654",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 55900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "83865123"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "60486767",
                                "name": "Double Omelette Chicken Roll + Butter Chicken Roll  + Chicken Mayonnaise Roll",
                                "category": "Special Combos",
                                "description": "Chicken Overload Combo",
                                "price": 55900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "153240650",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG"
                                },
                                "defaultPrice": 55900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "83865139"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "60486768",
                                "name": "Paneer Mughali Roll  + Paneer Mayonnaise Roll  + Aloo Fry Roll  + Cheese Masala Roll",
                                "category": "Special Combos",
                                "description": "Our Super veggie Delight Combo",
                                "isVeg": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "153240661",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "83865148"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "60486769",
                                "name": "Paneer Makhani Roll + Paneer Masala Roll + Aloo Cheese Roll + Mix Veg Roll",
                                "category": "Special Combos",
                                "description": "Our Fantastic 4 Combo Delight",
                                "isVeg": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "153240675",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "83865144"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "93770963",
                                "name": "Aloo Fry Roll + Paneer Masala Roll + Cheesy Corn Roll + Paneer Chilli Roll",
                                "category": "Special Combos",
                                "description": "As good as it gets!",
                                "isVeg": 1,
                                "price": 64900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "153240663",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 64900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "83865120"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "categoryId": "28050781"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Aloo Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45134857",
                                "name": "Aloo Chilli Roll",
                                "category": "Aloo Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc | | Medium spicy | | Mashed Potatoes Seasoned And Wrapped With Spicy Chilies In Your Favorite Base Wrap |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/1176c485-1c54-42fb-9325-6c1ce1b60351_85b2ea6c-c71f-4167-b1d9-130018f1ec09.png_compressed",
                                "isVeg": 1,
                                "price": 10900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "89405455",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "89405456",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253523",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "89405457",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935900",
                                    "groupName": " Extra Filling  Aloo Chili Roll",
                                    "choices": [
                                      {
                                        "id": "103253542",
                                        "name": "Extra Aloo Chilli Filling",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 10900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "47 ratings",
                                    "ratingCountV2": "47"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466915"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45134839",
                                "name": "Aloo Fry Roll.",
                                "category": "Aloo Rolls",
                                "description": "Serves 1 | | Serves 1 , 1 Pc| | Medium spicy | | Mashed Potatoes Sauteed In Secret Spices Rolled To Perfection In Your Favorite Base Wrap |",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/4c0b340e-0995-47c9-bcb4-545c6b39e7e6_41b91efd-5259-4c50-bb17-c69ab95ae25c.png_compressed",
                                "isVeg": 1,
                                "price": 9900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "89405459",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "89405460",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253613",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "89405461",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935947",
                                    "groupName": "Extra Filling   Aloo Fry Roll",
                                    "choices": [
                                      {
                                        "id": "103253634",
                                        "name": "Extra Aloo Fry Filling",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 9900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466916"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45134881",
                                "name": "Mix-Veg Roll",
                                "category": "Aloo Rolls",
                                "description": "Serves 1 | |Serves 1| |Medium spicy| Fresh Vegetables Mashed Together With Our \nSecret Spice, Topped With Delicious Sauces Wrapped in Your Favorite Base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/45ab112f-25db-487e-a218-ed54c78b1e6d_0522f916-dce4-41a4-95a1-fcae732bcbd7.png_compressed",
                                "isVeg": 1,
                                "price": 11900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67607460",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67607461",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253619",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67607462",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935952",
                                    "groupName": "Extra Filling  Mix-Veg Roll",
                                    "choices": [
                                      {
                                        "id": "103253635",
                                        "name": "Extra Mix Veg Filling",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 11900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "54 ratings",
                                    "ratingCountV2": "54"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82466928"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/1176c485-1c54-42fb-9325-6c1ce1b60351_85b2ea6c-c71f-4167-b1d9-130018f1ec09.png_compressed",
                        "categoryId": "28050869"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Mutton Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239080",
                                "name": "Mutton Shammi Roll",
                                "category": "Mutton Rolls",
                                "description": "Serves 1",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/a83f587f-5459-4b92-9cf5-177ae2941859_dbc8dcf2-96fe-4151-b8b8-0e486bbdf5df.png_compressed",
                                "price": 27900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209418",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "261209419",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209420",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209421",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209422",
                                    "groupName": "Extra Filling  Mutton Shammi Roll",
                                    "choices": [
                                      {
                                        "id": "142514473",
                                        "name": "Extra Mutton Shammi Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 27900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82933509"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "75239095",
                                "name": "Mutton Kheema Roll",
                                "category": "Mutton Rolls",
                                "description": "Serves 1",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/f44adc29-c720-42c9-ac0b-533e3ad29c7a_34dfd7e2-0606-45a0-a88b-8dec40fca15a.png_compressed",
                                "price": 24900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "261209426",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "261209428",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209429",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209430",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "261209431",
                                    "groupName": "Extra Filling  Mutton Kheema Roll",
                                    "choices": [
                                      {
                                        "id": "142514472",
                                        "name": "Extra Mutton Kheema Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "NONVEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 24900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82933506"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/a83f587f-5459-4b92-9cf5-177ae2941859_dbc8dcf2-96fe-4151-b8b8-0e486bbdf5df.png_compressed",
                        "categoryId": "69723901"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Mushroom Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45136113",
                                "name": "Mushroom Masala Roll",
                                "category": "Mushroom Rolls",
                                "description": "Serves 1 | Mushrooms Sauteed In Yummy Masala Rolled In One Perfect Roll!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/ea299404-dcf1-4f71-a7aa-e4e31fd396ca_b16b2658-41c0-4a01-aa77-a5a22fc1c9bf.png_compressed",
                                "isVeg": 1,
                                "price": 20900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "113761200",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "113761201",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "113761202",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "113761203",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935857",
                                    "groupName": "Extra Filling  Mushroom Masala Roll",
                                    "choices": [
                                      {
                                        "id": "103253469",
                                        "name": "Extra Mushroom Masala Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 20900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "8 ratings",
                                    "ratingCountV2": "8"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648612"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45135269",
                                "name": "Mushroom Chilli Roll",
                                "category": "Mushroom Rolls",
                                "description": "Serves 1 | Mushrooms, Chillies And Chinese Sauces - Made Into A Yummy Roll!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/d55ed81f-b8d1-4b1a-a449-699b70144ce0_9c44c124-f105-4455-a1bf-d3d24c0ab033.png_compressed",
                                "isVeg": 1,
                                "price": 15900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "113761205",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "113761206",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "113761207",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "113761208",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935971",
                                    "groupName": "Extra Filling  Mushroom Chili Roll",
                                    "choices": [
                                      {
                                        "id": "103253675",
                                        "name": "Extra Mushroom Chili Filling",
                                        "price": 7000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 15900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648611"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/ea299404-dcf1-4f71-a7aa-e4e31fd396ca_b16b2658-41c0-4a01-aa77-a5a22fc1c9bf.png_compressed",
                        "categoryId": "40601230"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Make it a Meal",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137224",
                                "name": "Cold Coffee + French Fries",
                                "category": "Make it a Meal",
                                "imageId": "pjeo0wa6jfydnycwfalw",
                                "isVeg": 1,
                                "price": 19900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 19900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "1 rating",
                                    "ratingCountV2": "1"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648601"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "45137209",
                                "name": "Iced Tea + French Fries",
                                "category": "Make it a Meal",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/3f7db107-41e3-45a9-b3ee-0122a7657b90_8b629705-b6cf-402d-9ea9-e47ff93b09b9.png_compressed",
                                "isVeg": 1,
                                "price": 18900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 18900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "2 ratings",
                                    "ratingCountV2": "2"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "parentId": "82648609"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "pjeo0wa6jfydnycwfalw",
                        "categoryId": "26585274"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Punjabi Tadka Rolls",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "93770961",
                                "name": "Amritsari Chole Roll",
                                "category": "Punjabi Tadka Rolls",
                                "description": "Serves 1 | Spiced Tangy Chickpea Curry, Chole The Most Popular Punjabi Dish Rolled In Your Favorite Base Wrap",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/1e06aa81-ef39-4e1d-af10-1d5630f1f2af_1bf82b69-b0cd-417b-a3b7-5d509ebbc2d0.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "125285441",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "125285442",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "125285443",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "125285444",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "125285445",
                                    "groupName": "Extra Filling  Amritsari Chole Roll",
                                    "choices": [
                                      {
                                        "id": "103253449",
                                        "name": "Extra Amritsari Chole Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648563"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "73964328",
                                "name": "Rajma Masala Roll",
                                "category": "Punjabi Tadka Rolls",
                                "description": "Serves 1 | Most Popular North Indian Creamy, Tangy and Spiced Curry with Kidney Beans Rolled In Your Favorite Base Wrap.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/c329c037-92f0-4978-ba61-6038d72cfe85_2d7d5a3e-f8f2-4af6-8aa4-7b088d6e3dfc.png_compressed",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "67606948",
                                    "groupName": "Base",
                                    "choices": [
                                      {
                                        "id": "49690990",
                                        "name": "Maida Base",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690991",
                                        "name": "Wheat Base",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1,
                                    "minAddons": 1
                                  },
                                  {
                                    "groupId": "67606949",
                                    "groupName": "Upgrade your Roll",
                                    "choices": [
                                      {
                                        "id": "49690992",
                                        "name": "Single Egg Omelette",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690993",
                                        "name": "Double Egg Omelette",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690994",
                                        "name": "Cheese Melt (Goes inside the roll)",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690995",
                                        "name": "Tangy Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690996",
                                        "name": "Mayonnaise (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690997",
                                        "name": "Hot Garlic Sauce (Goes inside the Roll)",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 3,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "100253438",
                                    "groupName": "Sides & Beverages Add On",
                                    "choices": [
                                      {
                                        "id": "94937322",
                                        "name": "French Fries  [Regular- Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937323",
                                        "name": "Peri Peri Fries [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937324",
                                        "name": "Chilli Garlic Poppers [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937325",
                                        "name": "Cheese Poppers [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937326",
                                        "name": "Chicken Popcorn [Regular - Add On]",
                                        "price": 13900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937327",
                                        "name": "Chicken Nuggets [Regular- Add On]",
                                        "price": 15900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937328",
                                        "name": "Iced Tea Lemon  [Regular - Add On]",
                                        "price": 10900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937329",
                                        "name": "Watermelon Iced Tea  [Regular - Add On]",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937330",
                                        "name": "Cold Coffee [Regular - Add On]",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "94937331",
                                        "name": "Hazelnut Cold Coffee [Regular - Add On]",
                                        "price": 14900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 2,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "67606950",
                                    "groupName": "**Make it a Meal**",
                                    "choices": [
                                      {
                                        "id": "49690998",
                                        "name": "Fries+ Iced Tea",
                                        "price": 11900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "49690999",
                                        "name": "Fries + Cold Coffee",
                                        "price": 12900,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "117935833",
                                    "groupName": "Extra Filling  Rajma Masala Roll",
                                    "choices": [
                                      {
                                        "id": "103253450",
                                        "name": "Extra Rajma Masala Filling",
                                        "price": 8000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": 1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG",
                                  "portionSize": "Serves 1"
                                },
                                "defaultPrice": 17900,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "82648631"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/11/1e06aa81-ef39-4e1d-af10-1d5630f1f2af_1bf82b69-b0cd-417b-a3b7-5d509ebbc2d0.png_compressed",
                        "categoryId": "29748063"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Drinks - CD",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "115695420",
                                "name": "Cold Drink",
                                "category": "Drinks - CD",
                                "isVeg": 1,
                                "price": 6000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "defaultPrice": 6000,
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "parentId": "83917330"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "categoryId": "69723902"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 21417010000738"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Rolls Mania - Rolls, Wraps & More",
                        "area": "BHEL",
                        "completeAddress": "shop no 25 , raj avenue 5 , near minal street gate no 2  Bhopal"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "XSLtBFZT1A1g-lhNVmzug0D6hg3eDXOC0DbcfnWg"
  },

  "581782": {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "NIC Ice Creams",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "499782",
              "name": "NIC Ice Creams",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "nic-natural-ice-creams-mansarovar-complex-mp-nagar",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/12/18/5a2091b1-0a0d-4d85-a268-bd4a64892eb7_499782.JPG",
              "locality": "Mansarovar complex",
              "areaName": "Maharana Pratap Nagar",
              "costForTwo": "12000",
              "costForTwoMessage": "₹120 for two",
              "cuisines": [
                "Ice Cream",
                "Desserts"
              ],
              "avgRating": 4.7,
              "veg": true,
              "feeDetails": {
                "restaurantId": "499782",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "6249",
              "avgRatingString": "4.7",
              "totalRatingsString": "2.3K+ ratings",
              "sla": {
                "restaurantId": "499782",
                "deliveryTime": 39,
                "minDeliveryTime": 35,
                "maxDeliveryTime": 40,
                "lastMileTravel": 6.4,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 698,
                "slaString": "35-40 MINS",
                "lastMileTravelString": "6.4 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 109",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 109",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Use DUOJOY",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 109",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Use DUOJOY",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "nic-natural-ice-creams-mansarovar-complex-mp-nagar",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Shop No 15B, Mansarovar complex, MPSRTC Depo, Bhopal, MP-462016"
                },
                {
                  "title": "Cuisines",
                  "message": "Ice Cream,Desserts"
                }
              ],
              "totalRatings": 2300,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 109",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 109",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Use DUOJOY",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 109",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Use DUOJOY",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 2,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 123
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/499782"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.224525,77.436142",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹109",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "6a909604-801d-4daf-9c3d-0bea0e6ebfa3"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "499782",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9ce1bcb9-c0c4-4b14-b75f-456cc3c559d7",
                        "04b1c921-9c46-41f4-81e4-79cd7a9acdf2"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE DUOJOY",
                      "offerType": "offers",
                      "restId": "499782",
                      "offerLogo": "offers/generic",
                      "secondaryDiscountCallout": "EXTRA ₹30 OFF ON NEXT ORDER",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE DUOJOY"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "cd6bab0c-716f-4e36-bada-1d78c3630f6e"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAVORFUL",
                      "description": "ABOVE ₹449",
                      "offerType": "offers",
                      "restId": "499782",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAVORFUL"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "deeb93f4-8bc8-4f48-8ad6-1973e0817889"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT150",
                      "description": "ABOVE ₹549",
                      "offerType": "offers",
                      "restId": "499782",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT150"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "77c14ef5-23a0-4945-bb44-c21377fdd4ae"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE XTRAPARTY",
                      "description": "ABOVE ₹2000",
                      "offerType": "offers",
                      "restId": "499782",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE XTRAPARTY"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1825992",
                          "creativeId": "TopPicks/TCICream",
                          "title": "Tender Coconut Ice Cream 500ml",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "87231385",
                              "name": "Tender Coconut Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Relish the refreshing and fresh bites of  tender coconut, only in nic's tender coconut. Serving; 5 serves, serving size :100/76,energy(kcal) :143,carbohydrate(gm):14. 9,protein(gm): 4. 3,dietary fiber(gm) : 0. 6,fat(gm) : 7. 4,allergen :contains milk. May contain traces of treenuts.  [Energy: 143 kcal, Allergen: milk,nuts, Carbohydrates: 14.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/9cab7810-ccb8-4cfa-b982-cc2c16c11c1a_766bc881-32f8-4310-a0ae-f9b45ab8a645.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "29996571"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1826277",
                          "creativeId": "TopPicks/MCIC500",
                          "title": "Madagascar Chocolate Ice Cream 500ml",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "87231387",
                              "name": "Madagascar Chocolate Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving; 5 serves, serving size :100/76,energy(kcal) :173,carbohydrate(gm):21. 7,protein(gm): 4. 5,dietary fiber(gm) : 1. 4,fat(gm) : 7. 6,allergen :contains milk. May contain traces of treenuts.  [Energy: 173 kcal, Allergen: milk,nuts, Carbohydrates: 21.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/0ff6b5e2-404c-4380-83b7-ce4482dd8e72_5d5c8a7e-a9f3-43ca-a885-2095da2b3f11.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42857,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126089"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1827537",
                          "creativeId": "TopPicks/DOIcCream",
                          "title": "Dryfruit Overload Ice Cream 500ml",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "87231384",
                              "name": "Dryfruit Overload Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "A scoop of ice cream loaded with cashews, almonds, pistas and kishmishs. Needs no further description. Serving; 5 serves, serving size :100/76,energy(kcal) :172,carbohydrate(gm):14. 7,protein(gm): 5,dietary fiber(gm) : 1. 4,fat(gm) : 10. 3,allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 14.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/85f227a3-ca80-4df2-821c-41e7c3c4bd4d_debf2a01-5280-4236-9803-b7a67df70f92.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996392"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1827801",
                          "creativeId": "TopPicks/MixBerry",
                          "title": "Mixed Berries Ice Cream 500ml",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "87231388",
                              "name": "Mixed Berries Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Crafted with imported californian cranberries, blueberries and strawberries. This ice cream is perfect to give you a berry rush!. Serving; 5 serves, serving size :100/76,energy(kcal) :153,carbohydrate(gm):18. 7,protein(gm): 3. 5,dietary fiber(gm) : 3. 1,fat(gm) : 7. 1,allergen :contains milk. May contain traces of treenuts.  [Energy: 153 kcal, Allergen: milk,nuts, Carbohydrates: 18.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/bdb4b32f-2ec1-455b-8732-098ebea765b7_a7bae359-3f14-4c47-8eb6-11251591d1d5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996480"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1827005",
                          "creativeId": "TopPicks/ChocoICream",
                          "title": "Chocochips Ice Cream 500ml",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "87231386",
                              "name": "Chocochips Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Melt in mouth chocolate chips in every spoon. Truly, a decadent ice cream experience.  [Energy: 204 kcal, Allergen: milk,nuts, Carbohydrates: 24g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/6fd003f9-6568-45e4-a3a0-dc7c886302e7_d4836f31-ae89-4344-9ac1-476692e6407a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "29996357"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231423",
                              "name": "Anjeer Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The smooth and creamy texture of anjeer ice cream. Great for consuming anytime! serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 156,carbohydrate(gm) :18. 3,protein (gm) :4. 1,dietary fiber(gm) : 0. 7,fat(gm) : 7. 4, allergen :contains milk. May contain traces of treenuts.  [Energy: 156 kcal, Allergen: milk,nuts, Protein: 4.1g, Carbohydrates: 18.3g, Fiber: 0.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/de41569d-6b71-4723-88dd-5d85e0a093dd_b20aef3d-c43c-4f0a-8f9c-d5a6f78f9222.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996334"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231422",
                              "name": "Roasted Almond Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Roasted almonds is a must-have. Its crunchy texture with its singular flavour is unparalleled. Also available in sugarless. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 172,carbohydrate(gm) : 13. 7,protein (gm) :5. 4,dietary fiber(gm) : 2,fat (gm) :10. 5, allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/deb6e7cb-9bf1-47d2-b333-b9e699f554a5_c22ffcbc-5903-442b-b77a-0cc5ac6ca2c6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996515"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231412",
                              "name": "Tender Coconut Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Relish the refreshing and fresh bites of tender coconut, only in nic's tender coconut! serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 143,carbohydrate(gm) : 14. 9,protein (gm) :4. 3,dietary fiber(gm) : 0. 6,fat (gm) :7. 4, allergen :contains milk. May contain traces of treenuts.  [Energy: 143 kcal, Allergen: milk,nuts, Carbohydrates: 14.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/2b53a0ef-a399-41a1-9fcd-99f4f1a3b5d9_b247cb37-5fdb-4d0e-b803-75c6cf68738e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996570"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231411",
                              "name": "Alphonso Mango 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0.2g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/3d97c93d-eefd-425d-af89-059d3fc0f7b1_ec5a0e87-123b-4c37-a10c-812bb2f229d4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "90241975"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231431",
                              "name": "French Vanilla Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The world's favourite ice cream taste, it's plain but delicious. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 151,carbohydrate (gm) :15. 2,protein(gm) : 4. 1,dietary fiber(gm) : 0,fat (gm) :8. 2, allergen :contains milk. May contain traces of treenuts.  [Energy: 151 kcal, Allergen: milk,nuts, Carbohydrates: 15.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/17/2971a4f3-4cf3-4dfd-9f56-5fd1be71310f_86b5ee18-9a92-4830-a6b5-9800d85c77da.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996397"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231416",
                              "name": "Chocochips Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Melt in mouth chocolate chips in every spoon. Truly, a decadent ice cream experience. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 204,carbohydrate(gm) : 24,protein (gm) :4. 4,dietary fiber(gm) : 1. 9,fat (gm) :10, allergen :contains milk. May contain traces of treenuts.  [Energy: 204 kcal, Allergen: milk,nuts, Carbohydrates: 24g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/8aed5368-e134-44e5-b24a-4ce96e31b3e8_7d247c69-4d66-4faa-a23d-faa67a7b74a2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "122 ratings",
                                  "ratingCountV2": "122"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996356"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231419",
                              "name": "Sea Salt Caramel Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "A decadent swirl of mediterranean sea salt & crunch of crispy pearls ice cream for a tantalizing combination of taste and texture. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 179,carbohydrate(gm) : 21. 3,protein(gm) :4. 3,dietary fiber(gm) : 0,fat (gm) :8. 4, allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 179 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 21.3g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/b3f63ba9-5301-4b05-be2e-476e202a05b7_9ecb0536-c955-4138-963c-c5b02f510c2a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "37409409"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231420",
                              "name": "Gulab Jamun Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Now india's favourite gulab jamun in ice cream. Lose yourself in its rich aroma & indulgent texture. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 186,carbohydrate (gm) :20. 4,protein(gm) : 6. 3,dietary fiber(gm) : 0,fat(gm) : 8. 8, allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 186 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 20.4g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/f70118c6-88a8-44a5-8b56-acf58f22cf58_9b88a4b9-1843-47bf-937b-ee7f3263c48e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996415"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231432",
                              "name": "Coffee Walnut Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The distinctively bittersweet headiness of coffee crafted with nuttiness of walnut. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 172,carbohydrate(gm) : 16,protein (gm) :4. 8,dietary fiber (gm) :0. 4,fat (gm) :9. 9, allergen :contains milk and treenuts. Contains caffeine.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 16g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/777ee05b-4433-4796-9ac5-9dfe34ea5e00_28490269-e185-497c-a9d1-f3e16abd7a8e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996362"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231417",
                              "name": "Madagascar Chocolate Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 173,carbohydrate (gm) :21. 7,protein (gm) :4. 5,dietary fiber (gm) :1. 4,fat(gm) : 7. 6, allergen :contains milk. May contain traces of treenuts.  [Energy: 173 kcal, Allergen: milk,nuts, Carbohydrates: 21.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/112c9b35-9729-49ed-ab22-31ccdc76c6e4_73c2f184-8734-4a9e-a6f1-17b01679cf74.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126088"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231386",
                              "name": "Chocochips Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Melt in mouth chocolate chips in every spoon. Truly, a decadent ice cream experience.  [Energy: 204 kcal, Allergen: milk,nuts, Carbohydrates: 24g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/6fd003f9-6568-45e4-a3a0-dc7c886302e7_d4836f31-ae89-4344-9ac1-476692e6407a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "206 ratings",
                                  "ratingCountV2": "206"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996357"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231405",
                              "name": "French Vanilla Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The world's favourite ice cream taste, it's plain but delicious. Serving; 5 serves, serving size :100/76,energy(kcal) :151,carbohydrate(gm):15. 2,protein(gm): 4. 1,dietary fiber(gm) : 0,fat(gm) : 8. 2,allergen :contains milk. May contain traces of treenuts.  [Energy: 151 kcal, Allergen: milk,nuts, Carbohydrates: 15.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/ab6e7eea-253f-4298-82bd-ab83dccd0d6b_0c2ceca7-d222-4ab9-8e19-7b0ba64ad3a0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996398"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231380",
                              "name": "Alphonso Mango Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/3a230bb3-fa02-4ee8-9637-bf14c5787060_f66b21e6-7ff3-4abc-8e1d-8c674a246ca9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "227 ratings",
                                  "ratingCountV2": "227"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996329"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231406",
                              "name": "Coffee Walnut Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The distinctively bittersweet headiness of coffee crafted with nuttiness of walnut [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 16g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/70250824-98a4-4cfa-9634-bd6e5010c1fc_3421ec95-dd52-4236-90a8-3308aa580d32.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996363"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231392",
                              "name": "Roasted Almond Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Roasted almonds is a must-have. Its crunchy texture with its singular flavour is unparalleled. Also available in sugarless. Serving; 5 serves, serving size :100/76,energy(kcal) :172,carbohydrate(gm):13. 7,protein(gm): 5. 4,dietary fiber(gm) : 2,fat(gm) : 10. 5,allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/26/f7225059-7a4f-40fe-8119-d9e55639f43d_7efc0b05-e00f-43e8-95a7-5fcf51c32527.png_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996516"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231385",
                              "name": "Tender Coconut Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Relish the refreshing and fresh bites of  tender coconut, only in nic's tender coconut. Serving; 5 serves, serving size :100/76,energy(kcal) :143,carbohydrate(gm):14. 9,protein(gm): 4. 3,dietary fiber(gm) : 0. 6,fat(gm) : 7. 4,allergen :contains milk. May contain traces of treenuts.  [Energy: 143 kcal, Allergen: milk,nuts, Carbohydrates: 14.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/9cab7810-ccb8-4cfa-b982-cc2c16c11c1a_766bc881-32f8-4310-a0ae-f9b45ab8a645.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996571"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231387",
                              "name": "Madagascar Chocolate Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving; 5 serves, serving size :100/76,energy(kcal) :173,carbohydrate(gm):21. 7,protein(gm): 4. 5,dietary fiber(gm) : 1. 4,fat(gm) : 7. 6,allergen :contains milk. May contain traces of treenuts.  [Energy: 173 kcal, Allergen: milk,nuts, Carbohydrates: 21.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/0ff6b5e2-404c-4380-83b7-ce4482dd8e72_5d5c8a7e-a9f3-43ca-a885-2095da2b3f11.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42857,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126089"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231444",
                              "name": "Alphonso Mango Ice Cream 750ml",
                              "category": "750 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0.2g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/58d8fee0-27a9-4987-bc83-3cddb8e5c010_885f0d25-ebde-46fe-a418-b2a55dd3355a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40476,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996330"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231447",
                              "name": "Madagascar Chocolate Ice Cream 750ml",
                              "category": "750 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving; 7. 5 serves, serving size :100/76,energy(kcal) :173,carbohydrate(gm):21. 7,protein(gm): 4. 5,dietary fiber(gm) : 1. 4,fat(gm) : 7. 6,allergen :contains milk. May contain traces of treenuts [Energy: 173 kcal, Allergen: milk,nuts, Protein: 4.5g, Carbohydrates: 21.7g, Fiber: 1.4g, Fat: 7.6g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/ff2c429c-11ef-4c7d-b177-476ada67941d_ba763506-e48b-4210-8940-35e1d06cb012.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 52381,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55175137"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94337055",
                              "name": "Stick Malai Kulfi",
                              "category": "Kulfi",
                              "description": "The all-time favorite desi ice cream - malai stick kulfi, is here to be ordered right away",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/a1995213-15cd-4c55-bdcf-72fd85ed8c72_8cb95edd-3834-438a-8ed9-406a66398513.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "61 ratings",
                                  "ratingCountV2": "61"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996554"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Double Scoops, Double Smiles",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176176910",
                              "name": "Sweet & Salty Thrill",
                              "category": "Double Scoops, Double Smiles",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/0e643eb9-1cce-479a-a05f-3b5c584a319c_c96352f9-c8a8-4da0-9639-29f362ef07bf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19048,
                              "finalPrice": 10900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "6a909604-801d-4daf-9c3d-0bea0e6ebfa3"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "106449076"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176176867",
                              "name": "Nutty Brew & Coconut Dew",
                              "category": "Double Scoops, Double Smiles",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/bbf868e7-0d71-4dc1-8522-2802e0f9115a_2c1233b9-5815-453b-ad6d-5a0c93f6c5db.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16190,
                              "finalPrice": 12300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "1d0bfa93-6b31-492f-8cc9-0285031c5d3c"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "106449073"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176176796",
                              "name": "Desert Gold Duo",
                              "category": "Double Scoops, Double Smiles",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/230f7bda-8d37-44a3-84c1-32be6aa65bf4_b8656fdf-9526-4951-a95a-7f1e0fe5dbd9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19048,
                              "finalPrice": 10900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "6a909604-801d-4daf-9c3d-0bea0e6ebfa3"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "106449070"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/0e643eb9-1cce-479a-a05f-3b5c584a319c_c96352f9-c8a8-4da0-9639-29f362ef07bf.jpg",
                      "categoryId": "64118979"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "100 Ml Ice Creams",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231415",
                              "name": "Sitaphal Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 129,carbohydrate (gm) :15. 4,protein(gm) : 3. 7,dietary fiber (gm) :0,fat (gm) :5. 9, allergen :contains milk. May contain traces of treenuts.  [Energy: 129 kcal, Allergen: milk,nuts, Carbohydrates: 15.4g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/45900dc8-1523-4a78-97be-cd0eed58232d_3a412a48-dcb2-49b4-a8b0-e267aa899267.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996538"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106426970",
                              "name": "Gajar Halwa Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Favourite traditional dessert, now in every bite if your scoop",
                              "imageId": "1353982fa4a1bd8b99101fe6e3a32bae",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996405"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231424",
                              "name": "Apricot Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Dive into the premium taste of imported apricot ice cream. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 132,carbohydrate(gm) : 15. 2,protein(gm) : 3. 6,dietary fiber(gm) : 2. 1,fat(gm) : 6. 3, allergen :contains milk. May contain traces of treenuts.  [Energy: 132 kcal, Allergen: milk,nuts, Protein: 3.6g, Carbohydrates: 15.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/16/56ffdf3f-ec96-46b1-9fcc-c17ef17ac772_278e5d4a-76fb-413a-bdb6-430989aa9e4b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996339"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231423",
                              "name": "Anjeer Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The smooth and creamy texture of anjeer ice cream. Great for consuming anytime! serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 156,carbohydrate(gm) :18. 3,protein (gm) :4. 1,dietary fiber(gm) : 0. 7,fat(gm) : 7. 4, allergen :contains milk. May contain traces of treenuts.  [Energy: 156 kcal, Allergen: milk,nuts, Protein: 4.1g, Carbohydrates: 18.3g, Fiber: 0.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/de41569d-6b71-4723-88dd-5d85e0a093dd_b20aef3d-c43c-4f0a-8f9c-d5a6f78f9222.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996334"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231422",
                              "name": "Roasted Almond Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Roasted almonds is a must-have. Its crunchy texture with its singular flavour is unparalleled. Also available in sugarless. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 172,carbohydrate(gm) : 13. 7,protein (gm) :5. 4,dietary fiber(gm) : 2,fat (gm) :10. 5, allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/deb6e7cb-9bf1-47d2-b333-b9e699f554a5_c22ffcbc-5903-442b-b77a-0cc5ac6ca2c6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996515"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231412",
                              "name": "Tender Coconut Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Relish the refreshing and fresh bites of tender coconut, only in nic's tender coconut! serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 143,carbohydrate(gm) : 14. 9,protein (gm) :4. 3,dietary fiber(gm) : 0. 6,fat (gm) :7. 4, allergen :contains milk. May contain traces of treenuts.  [Energy: 143 kcal, Allergen: milk,nuts, Carbohydrates: 14.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/2b53a0ef-a399-41a1-9fcd-99f4f1a3b5d9_b247cb37-5fdb-4d0e-b803-75c6cf68738e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996570"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231411",
                              "name": "Alphonso Mango 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0.2g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/3d97c93d-eefd-425d-af89-059d3fc0f7b1_ec5a0e87-123b-4c37-a10c-812bb2f229d4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "90241975"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231431",
                              "name": "French Vanilla Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The world's favourite ice cream taste, it's plain but delicious. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 151,carbohydrate (gm) :15. 2,protein(gm) : 4. 1,dietary fiber(gm) : 0,fat (gm) :8. 2, allergen :contains milk. May contain traces of treenuts.  [Energy: 151 kcal, Allergen: milk,nuts, Carbohydrates: 15.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/17/2971a4f3-4cf3-4dfd-9f56-5fd1be71310f_86b5ee18-9a92-4830-a6b5-9800d85c77da.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996397"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231414",
                              "name": "Dryfruit Overload Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "A scoop of ice cream loaded with cashews, almonds, pistas and kishmishs. Needs no further description. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 172,carbohydrate (gm) :14. 7,protein(gm) : 5,dietary fiber(gm) : 1. 4,fat (gm) :10. 3, allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Protein: 5g, Carbohydrates: 14.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/e58f84c9-435e-43ef-b21e-72ffbe763c75_a5332a1f-3908-4d91-9c6b-67ca217f35d5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996391"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231408",
                              "name": "Strawberry Cheesecake Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Super fruity, tangy, sweet and incredibly creamy - nic's strawberry cheesecake variant contains all the essentials for a perfect dessert experience. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 174,carbohydrate (gm) :21. 2,protein(gm) : 3. 7,dietary fiber(gm) : 0. 4,fat(gm) : 8. 2, allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 174 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 21.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/7a5bd21b-71fd-42ff-9cca-f761589ef6ce_4aee235b-1507-4769-b872-39a975fafbbb.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "41294326"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231416",
                              "name": "Chocochips Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Melt in mouth chocolate chips in every spoon. Truly, a decadent ice cream experience. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 204,carbohydrate(gm) : 24,protein (gm) :4. 4,dietary fiber(gm) : 1. 9,fat (gm) :10, allergen :contains milk. May contain traces of treenuts.  [Energy: 204 kcal, Allergen: milk,nuts, Carbohydrates: 24g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/8aed5368-e134-44e5-b24a-4ce96e31b3e8_7d247c69-4d66-4faa-a23d-faa67a7b74a2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "122 ratings",
                                  "ratingCountV2": "122"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996356"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231419",
                              "name": "Sea Salt Caramel Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "A decadent swirl of mediterranean sea salt & crunch of crispy pearls ice cream for a tantalizing combination of taste and texture. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 179,carbohydrate(gm) : 21. 3,protein(gm) :4. 3,dietary fiber(gm) : 0,fat (gm) :8. 4, allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 179 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 21.3g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/b3f63ba9-5301-4b05-be2e-476e202a05b7_9ecb0536-c955-4138-963c-c5b02f510c2a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "37409409"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231420",
                              "name": "Gulab Jamun Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Now india's favourite gulab jamun in ice cream. Lose yourself in its rich aroma & indulgent texture. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 186,carbohydrate (gm) :20. 4,protein(gm) : 6. 3,dietary fiber(gm) : 0,fat(gm) : 8. 8, allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 186 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 20.4g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/f70118c6-88a8-44a5-8b56-acf58f22cf58_9b88a4b9-1843-47bf-937b-ee7f3263c48e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996415"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231432",
                              "name": "Coffee Walnut Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "The distinctively bittersweet headiness of coffee crafted with nuttiness of walnut. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 172,carbohydrate(gm) : 16,protein (gm) :4. 8,dietary fiber (gm) :0. 4,fat (gm) :9. 9, allergen :contains milk and treenuts. Contains caffeine.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 16g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/777ee05b-4433-4796-9ac5-9dfe34ea5e00_28490269-e185-497c-a9d1-f3e16abd7a8e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996362"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231417",
                              "name": "Madagascar Chocolate Ice Cream 100ml",
                              "category": "100 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving :1 serve , serving size(mg/gm) 100/76, energy(kcal) : 173,carbohydrate (gm) :21. 7,protein (gm) :4. 5,dietary fiber (gm) :1. 4,fat(gm) : 7. 6, allergen :contains milk. May contain traces of treenuts.  [Energy: 173 kcal, Allergen: milk,nuts, Carbohydrates: 21.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/112c9b35-9729-49ed-ab22-31ccdc76c6e4_73c2f184-8734-4a9e-a6f1-17b01679cf74.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126088"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/45900dc8-1523-4a78-97be-cd0eed58232d_3a412a48-dcb2-49b4-a8b0-e267aa899267.jpg",
                      "categoryId": "29300638"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "500 Ml Ice Creams",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231390",
                              "name": "Gulab Jamun Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Now india's favourite gulab jamun in ice cream. Lose yourself in its rich aroma & indulgent texture. Serving; 5 serves, serving size :100/76,energy(kcal) :186,carbohydrate(gm):20. 4,protein(gm): 6. 3,dietary fiber(gm) : 0,fat(gm) : 8. 8,allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 186 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 20.4g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/7042e33c-825b-482d-aa56-f7c21f0634c9_46b49e84-eda7-42c7-a1cd-6af13dbce403.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996416"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231386",
                              "name": "Chocochips Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Melt in mouth chocolate chips in every spoon. Truly, a decadent ice cream experience.  [Energy: 204 kcal, Allergen: milk,nuts, Carbohydrates: 24g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/6fd003f9-6568-45e4-a3a0-dc7c886302e7_d4836f31-ae89-4344-9ac1-476692e6407a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "206 ratings",
                                  "ratingCountV2": "206"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996357"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231394",
                              "name": "Anjeer Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The smooth and creamy texture of anjeer ice cream. Great for consuming anytime! serving; 5 serves, serving size :100/76,energy(kcal) :156,carbohydrate(gm):18. 3,protein(gm): 4. 1,dietary fiber(gm) : 0. 7,fat(gm) : 7. 4,allergen :contains milk. May contain traces of treenuts.  [Energy: 156 kcal, Allergen: milk,nuts, Protein: 4.1g, Carbohydrates: 18.3g, Fiber: 0.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/ccd98365-f39e-4e19-be57-f2f86b1ba700_55f87399-a729-406c-a3bd-36a323312100.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996335"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231405",
                              "name": "French Vanilla Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The world's favourite ice cream taste, it's plain but delicious. Serving; 5 serves, serving size :100/76,energy(kcal) :151,carbohydrate(gm):15. 2,protein(gm): 4. 1,dietary fiber(gm) : 0,fat(gm) : 8. 2,allergen :contains milk. May contain traces of treenuts.  [Energy: 151 kcal, Allergen: milk,nuts, Carbohydrates: 15.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/ab6e7eea-253f-4298-82bd-ab83dccd0d6b_0c2ceca7-d222-4ab9-8e19-7b0ba64ad3a0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996398"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231388",
                              "name": "Mixed Berries Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Crafted with imported californian cranberries, blueberries and strawberries. This ice cream is perfect to give you a berry rush!. Serving; 5 serves, serving size :100/76,energy(kcal) :153,carbohydrate(gm):18. 7,protein(gm): 3. 5,dietary fiber(gm) : 3. 1,fat(gm) : 7. 1,allergen :contains milk. May contain traces of treenuts.  [Energy: 153 kcal, Allergen: milk,nuts, Carbohydrates: 18.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/bdb4b32f-2ec1-455b-8732-098ebea765b7_a7bae359-3f14-4c47-8eb6-11251591d1d5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996480"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231380",
                              "name": "Alphonso Mango Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/3a230bb3-fa02-4ee8-9637-bf14c5787060_f66b21e6-7ff3-4abc-8e1d-8c674a246ca9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "227 ratings",
                                  "ratingCountV2": "227"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996329"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106426971",
                              "name": "Gajar Halwa Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Favourite traditional dessert, now in every bite if your scoop",
                              "imageId": "b737923fda66f5e725dcc80ba0c9fbef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996406"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231384",
                              "name": "Dryfruit Overload Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "A scoop of ice cream loaded with cashews, almonds, pistas and kishmishs. Needs no further description. Serving; 5 serves, serving size :100/76,energy(kcal) :172,carbohydrate(gm):14. 7,protein(gm): 5,dietary fiber(gm) : 1. 4,fat(gm) : 10. 3,allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 14.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/85f227a3-ca80-4df2-821c-41e7c3c4bd4d_debf2a01-5280-4236-9803-b7a67df70f92.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "170 ratings",
                                  "ratingCountV2": "170"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996392"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231381",
                              "name": "Sitaphal Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Indulge in the exotic sweetness of sitaphal ice cream, a luxurious treat crafted from the finest custard apples. This rich and creamy dessert captures the unique flavor of sitaphal fruit—sweet, fragrant, and slightly tangy—blended into a velvety ice cream base that melts in your mouth.  [Energy: 129 kcal, Allergen: milk,nuts, Carbohydrates: 15.4g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/348cdc68-4717-4283-8906-e982246302cc_2704e429-5814-4ecb-ba7b-7ca1f955c8c0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "93 ratings",
                                  "ratingCountV2": "93"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996539"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231396",
                              "name": "Jaggery Almond Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Pure jaggery and crunchy almond come together in this playful ice cream delight! serving; 5 serves, serving size :100/76,energy(kcal) :181,carbohydrate(gm):17. 8,protein(gm): 5,dietary fiber(gm) : 0. 7,fat(gm) : 10,allergen :contains milk and treenuts.  [Energy: 181 kcal, Allergen: milk,nuts, Carbohydrates: 17.8g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/393e9302-b907-46b6-81ce-9f24e41f4f3a_aa9ca82f-5e44-446b-9f6f-abc1e875efcc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996425"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231406",
                              "name": "Coffee Walnut Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The distinctively bittersweet headiness of coffee crafted with nuttiness of walnut [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 16g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/70250824-98a4-4cfa-9634-bd6e5010c1fc_3421ec95-dd52-4236-90a8-3308aa580d32.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996363"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231400",
                              "name": "Paan Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "The tantalizing taste of paan meets the creamy goodness of our pure milk ice cream. Serving; 5 serves, serving size :100/76,energy(kcal) :153,carbohydrate(gm):17. 7,protein(gm): 3. 9,dietary fiber(gm) : 0. 3,fat(gm) : 7. 4,allergen :contains milk. May contain traces of treenuts.  [Energy: 153 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/b3d10933-2b37-414d-bbfd-aa0a5428cd37_ff3497ff-3af8-4450-8cae-2a5be136ee74.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996496"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231392",
                              "name": "Roasted Almond Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Roasted almonds is a must-have. Its crunchy texture with its singular flavour is unparalleled. Also available in sugarless. Serving; 5 serves, serving size :100/76,energy(kcal) :172,carbohydrate(gm):13. 7,protein(gm): 5. 4,dietary fiber(gm) : 2,fat(gm) : 10. 5,allergen :contains milk and treenuts.  [Energy: 172 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/6/26/f7225059-7a4f-40fe-8119-d9e55639f43d_7efc0b05-e00f-43e8-95a7-5fcf51c32527.png_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996516"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231385",
                              "name": "Tender Coconut Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Relish the refreshing and fresh bites of  tender coconut, only in nic's tender coconut. Serving; 5 serves, serving size :100/76,energy(kcal) :143,carbohydrate(gm):14. 9,protein(gm): 4. 3,dietary fiber(gm) : 0. 6,fat(gm) : 7. 4,allergen :contains milk. May contain traces of treenuts.  [Energy: 143 kcal, Allergen: milk,nuts, Carbohydrates: 14.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/9cab7810-ccb8-4cfa-b982-cc2c16c11c1a_766bc881-32f8-4310-a0ae-f9b45ab8a645.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996571"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "92233389",
                              "name": "Belgian Chocolate Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Serving; 5 serves, serving size :100/76,energy(kcal) :178,carbohydrate(gm):20. 9,protein(gm): 5. 6,dietary fiber(gm) : 0,fat(gm) : 8,allergen :contains milk. May contain traces of treenuts.  [Energy: 178 kcal, Allergen: milk,nuts, Protein: 5.6g, Carbohydrates: 20.9g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/16/fc97ec52-e777-4fbc-87f1-bb71f629788b_4e4bf9d5-838d-4d5c-a9c5-1f02e5dc3f25.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42857,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "50321069"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231387",
                              "name": "Madagascar Chocolate Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving; 5 serves, serving size :100/76,energy(kcal) :173,carbohydrate(gm):21. 7,protein(gm): 4. 5,dietary fiber(gm) : 1. 4,fat(gm) : 7. 6,allergen :contains milk. May contain traces of treenuts.  [Energy: 173 kcal, Allergen: milk,nuts, Carbohydrates: 21.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/0ff6b5e2-404c-4380-83b7-ce4482dd8e72_5d5c8a7e-a9f3-43ca-a885-2095da2b3f11.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42857,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126089"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231378",
                              "name": "Strawberry Cheesecake Ice Cream 500ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Super fruity, tangy, sweet and incredibly creamy - nic's strawberry cheesecake variant contains all the essentials for a perfect dessert experience. Serving; 5 serves, serving size :100/76,energy(kcal) :174,carbohydrate(gm):21. 2,protein(gm): 3. 7,dietary fiber(gm) : 0. 4,fat(gm) : 8. 2,allergen :contains milk and gluten. May contain traces of treenuts.  [Energy: 174 kcal, Allergen: milk,nuts,gluten, Carbohydrates: 21.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/c1b8f6c7-0a6d-4ad4-b32a-a77085532e90_a984436c-a4ce-46fc-867a-cb4f18a94959.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42857,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "41294327"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "135264555",
                              "name": "Velvety Nutella Ice-cream 500 Ml",
                              "category": "500 Ml Ice Creams",
                              "description": "Indulge in creamy bliss: nutella ice cream crafted with care, each scoop is a delightful balance of creamy dairy and nutella's signature blend of cocoa and hazelnuts, creating a harmonious symphony of taste and texture. Whether enjoyed on its own or as a delightful complement to your favorite desserts, this ice cream promises a moment of pure indulgence.  [Energy: 181 kcal, Allergen: milk,nuts, Carbohydrates: 17.8g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/2a67e5a7-ee40-4b43-b572-cd89efdf8785_b485abef-e66f-4cf4-8026-f93bff9368bf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "88168570"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/7042e33c-825b-482d-aa56-f7c21f0634c9_46b49e84-eda7-42c7-a1cd-6af13dbce403.jpg",
                      "categoryId": "29300639"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "750 Ml Ice Creams",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231444",
                              "name": "Alphonso Mango Ice Cream 750ml",
                              "category": "750 Ml Ice Creams",
                              "description": "Indulge in the luscious delight of nic alphonso mango ice cream. A creamy fusion of velvety textures and the rich,tropical sweetness of premium ratnagiri alphonso mangoes, creating a taste of pure bliss. Perfect for savoring the essence of summer in every spoonful.  [Energy: 138 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.5g, Fiber: 0.2g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/58d8fee0-27a9-4987-bc83-3cddb8e5c010_885f0d25-ebde-46fe-a418-b2a55dd3355a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40476,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996330"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114391438",
                              "name": "Kesar Pista Ice Cream 750ml",
                              "category": "750 Ml Ice Creams",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/570ad8a0-310f-4df4-9a40-fbf9b2de5bee_c7c4b69e-ed56-447a-ab26-a8f86e3f19d6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40476,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "37409271"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231447",
                              "name": "Madagascar Chocolate Ice Cream 750ml",
                              "category": "750 Ml Ice Creams",
                              "description": "Extra rich & smooth madagascar ice cream, takes chocolate indulgence to a level beyond description. Serving; 7. 5 serves, serving size :100/76,energy(kcal) :173,carbohydrate(gm):21. 7,protein(gm): 4. 5,dietary fiber(gm) : 1. 4,fat(gm) : 7. 6,allergen :contains milk. May contain traces of treenuts [Energy: 173 kcal, Allergen: milk,nuts, Protein: 4.5g, Carbohydrates: 21.7g, Fiber: 1.4g, Fat: 7.6g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/ff2c429c-11ef-4c7d-b177-476ada67941d_ba763506-e48b-4210-8940-35e1d06cb012.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 52381,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55175137"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/15/58d8fee0-27a9-4987-bc83-3cddb8e5c010_885f0d25-ebde-46fe-a418-b2a55dd3355a.jpg",
                      "categoryId": "42446798"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Kulfi",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94337055",
                              "name": "Stick Malai Kulfi",
                              "category": "Kulfi",
                              "description": "The all-time favorite desi ice cream - malai stick kulfi, is here to be ordered right away",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/a1995213-15cd-4c55-bdcf-72fd85ed8c72_8cb95edd-3834-438a-8ed9-406a66398513.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "61 ratings",
                                  "ratingCountV2": "61"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996554"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231436",
                              "name": "Stick Gulkand Kulfi",
                              "category": "Kulfi",
                              "description": "Taste the aromatic sweetness of gulkand in every bite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/9c53a4e1-521b-43f5-b8a6-e8161841931f_0a8e2c37-134b-42c9-bb8e-80fb49518efc.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996547"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231437",
                              "name": "Stick Jaggery Almond Kulfi",
                              "category": "Kulfi",
                              "description": "Made from jaggery and almond give into its unique & tantalizing taste. ",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/086165e2-63bc-45c0-99c9-04b79aad6ec8_18052717-2a27-4928-8e21-7d0d4f99037f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996549"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231439",
                              "name": "Stick Paan Kulfi",
                              "category": "Kulfi",
                              "description": "Tradition meets innovation. This combination made for indian hearts and palates. ",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/a98b783f-22f0-4fbc-9121-12d7bcd61a5c_38d8ca91-54ab-4aae-aec5-6154d25d9856.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996556"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231440",
                              "name": "Matka Malai Kulfi [Pack Of 2]",
                              "category": "Kulfi",
                              "description": "Desi ice cream treat in a hygienically packed matka",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/e77a2cc0-f62b-4085-a80e-8d65152a5a1c_d9bad993-6824-4770-8e7f-8b75ffa4552f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16190,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "29996467"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231441",
                              "name": "Matka Dryfruit Malai Kulfi [Pack Of 2]",
                              "category": "Kulfi",
                              "description": "Indias ice cream combined with dry fruits and served in a hygienically packed matka!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/1177ec92-88eb-4fa6-a723-22624378a717_883897f8-3f60-476f-b0e1-aee00d6cf89c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126090"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87231442",
                              "name": "Slice Malai Kulfi [Pack Of 3]",
                              "category": "Kulfi",
                              "description": "Traditional malai kulfi with the unadulterated aroma of condensed milk is truly a treat for your taste buds. ",
                              "imageId": "2f790294471c4723d64d05fecce83d88",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "55126091"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/3/20/a1995213-15cd-4c55-bdcf-72fd85ed8c72_8cb95edd-3834-438a-8ed9-406a66398513.jpg",
                      "categoryId": "24766812"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "No Added Sugar Range",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101769320",
                              "name": "Alphonso Mango No Added Sugar 100ml",
                              "category": "No Added Sugar Range",
                              "description": "Experience the taste of the king of fruits in every bite, without any added sugar. Serving; 1 serve, serving size :100/76,energy(kcal) :137,carbohydrate(gm):16. 1,protein(gm): 4. 2,dietary fiber(gm) : 0. 2,fat(gm) : 6. 2,allergen :contains milk. May contain traces of treenuts.  [Energy: 137 kcal, Allergen: milk,nuts, Protein: 4.2g, Carbohydrates: 16.1g, Fiber: 0.2g, Fat: 6.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/25/105d7495-6b6a-4aa1-9c9b-5380ec818cc1_4815b570-caab-4ea1-b481-88d41371b080.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                }
                              ],
                              "parentId": "98452117"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99816960",
                              "name": "Roasted Almond No Added Sugar 500ml",
                              "category": "No Added Sugar Range",
                              "description": "A crunchy delight that leaves you pining for now, now available in a no added sugar variant. It’s time to get roasted the right way, with this tasteful treat [Energy: 182 kcal, Allergen: milk,nuts, Carbohydrates: 17.7g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/14/44a0523f-2f1b-4340-a23e-67c3b53e5f1c_2e041c11-de1e-49ed-9cd8-55119c16fb1f.png_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                }
                              ],
                              "parentId": "98452123"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99816961",
                              "name": "Tender Coconut No Added Sugar 500ml",
                              "category": "No Added Sugar Range",
                              "description": "One of the most sought-after flavors, this pure fruit-based delight now comes with the allure of no added sugar. Serving; 5 serves, serving size :100/76,energy(kcal) :132,carbohydrate(gm):13. 2,protein(gm): 3. 9,dietary fiber(gm) : 0. 1,fat(gm) : 7. 1,allergen :contains milk. May contain traces of treenuts [Energy: 132 kcal, Allergen: milk,nuts, Carbohydrates: 13.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/e12fce33-be4b-4514-8979-3cc0f8e8bc08_374bc5f7-132e-437a-90a6-8be319a9cce1.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "98452125"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "163534132",
                              "name": "Belgian Chocolate No Added Sugar 500ml",
                              "category": "No Added Sugar Range",
                              "description": " [Energy: 132 kcal, Allergen: milk,nuts, Carbohydrates: 13.2g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/18/9aff7a75-92e5-49b3-899a-c70669baed6e_a591aea6-22bc-4e2b-9c28-67246a4f4aa6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47619,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "sachin/OCT2025/NO%20ADDEED%20SUGAR.png"
                                }
                              ],
                              "parentId": "98452121"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/25/105d7495-6b6a-4aa1-9c9b-5380ec818cc1_4815b570-caab-4ea1-b481-88d41371b080.jpg",
                      "categoryId": "61541116"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Ice Cream Cones",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155338815",
                              "name": "Td Waffle Cone 110ml X 5",
                              "category": "Ice Cream Cones",
                              "description": "Nic ice cream cones, now scoop out your favourite ice creams in a cone. Introducing ice cream cones in a vacuum pack, to ensure they reach your doorstep in its best form. ",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/25/26b314cd-f931-479c-9f3a-b69016beeeec_fae9c45d-af1c-4f72-a28b-ce525a65c431.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "92737810"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/25/26b314cd-f931-479c-9f3a-b69016beeeec_fae9c45d-af1c-4f72-a28b-ce525a65c431.jpg",
                      "categoryId": "52114013"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "New Year Special Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191182179",
                              "name": "Frosty Fresh Start",
                              "category": "New Year Special Combo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2026/1/3/78053f62-acdd-4b73-9768-2dbd1021ee26_9a4b5203-420a-4f2e-968f-52d098c19960.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 78095,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "116349451"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2026/1/3/78053f62-acdd-4b73-9768-2dbd1021ee26_9a4b5203-420a-4f2e-968f-52d098c19960.jpg",
                      "categoryId": "70673442"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Winter Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "155152828",
                              "name": "Frosty Fusion",
                              "category": "Winter Combos",
                              "description": "(1x500 ml tub and 2x100 ml tubs) experience a winter fusion with 500ml of mixed berries for a tart kick, paired with the boldness of coffee walnut (100ml) and the decadent madagascar chocolate (100ml). Each scoop brings a new flavor to keep the winter blues away!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/9/b4fb77c9-4136-41cb-9159-f206f70bd3f9_dbdc5db2-9ee8-4faf-a1ae-6011161bbd22.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 50847,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "92589083"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/9/b4fb77c9-4136-41cb-9159-f206f70bd3f9_dbdc5db2-9ee8-4faf-a1ae-6011161bbd22.jpg",
                      "categoryId": "69941266"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11422010000186"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "NIC Ice Creams",
                      "area": "Maharana Pratap Nagar",
                      "completeAddress": "Shop No 15B, Mansarovar complex, MPSRTC Depo, Bhopal, MP-462016"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "cA7yqoFv6vyV-G1J0pODyu1_yn4C4dki4fZLilgk"
},

  "585068": {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Shri Anjani Veg Bhojnalaya",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "585068",
              "name": "Shri Anjani Veg Bhojnalaya",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "shri-anjani-veg-bhojnalaya-piplani-piplani",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "db050d896c76f203d42b50936b48d339",
              "locality": "Ganesh Galaxy",
              "areaName": "Ayodhya Bypass",
              "costForTwo": "25000",
              "costForTwoMessage": "₹250 for two",
              "cuisines": [
                "Thalis",
                "Indian"
              ],
              "avgRating": 4.2,
              "veg": true,
              "feeDetails": {
                "restaurantId": "585068",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "350139",
              "avgRatingString": "4.2",
              "totalRatingsString": "4.6K+ ratings",
              "sla": {
                "restaurantId": "585068",
                "deliveryTime": 45,
                "minDeliveryTime": 40,
                "maxDeliveryTime": 45,
                "lastMileTravel": 9.6,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 1006,
                "slaString": "40-45 MINS",
                "lastMileTravelString": "9.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 59",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹249",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹249 | Use code SUPERSAVER",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "shri-anjani-veg-bhojnalaya-piplani-piplani",
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Airport Road, ISRO Colony, Ayodhya Nagar, Bhopal, Madhya Pradesh 462021"
                },
                {
                  "title": "Cuisines",
                  "message": "Thalis,Indian"
                }
              ],
              "totalRatings": 4600,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 59",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹249",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹249 | Use code SUPERSAVER",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 4,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 129
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/585068"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.27263776,77.46658044",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹59",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "08fac3f8-9189-43ff-94be-1a682b24f543"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "585068",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "DEFAULT",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "652acd80-29f1-420c-9beb-94d12ce12193"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SUPERSAVER",
                      "description": "ABOVE ₹249",
                      "offerType": "offers",
                      "restId": "585068",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SUPERSAVER"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "35729425-1585-4f75-a52b-ad620e5e16b1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE MEGADEALS",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "585068",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE MEGADEALS"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "a624c44f-2add-4d20-83f9-f2fae2923f9f"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT200",
                      "description": "ABOVE ₹399",
                      "offerType": "offers",
                      "restId": "585068",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT200"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "DEFAULT",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "c7a92548-8858-47a3-ad9d-fcd2766619b4"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CELEBRATIONS",
                      "description": "ABOVE ₹799",
                      "offerType": "offers",
                      "restId": "585068",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE CELEBRATIONS"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "Buy 1 Get 1"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5334059",
                          "creativeId": "TopPicks2024/97446459B.png",
                          "title": "Special Thali (Dal + Veg Sabzi + Paneer Masala  + 4 Butter Roti + Raita  + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "97446459",
                              "name": "Special Thali (Dal + Veg Sabzi + Paneer Masala  + 4 Butter Roti + Raita  + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                              "category": "Thali",
                              "description": "Indulge in a flavorful journey through Thailand with this delectable veg Thali, filled with aromatic Dal, tempting Veg Sabzi, rich Paneer Masala, fluffy Butter Roti, refreshing Raita, delightful Gulab Jamun, fragrant Jeera Rice, crispy Papad, refreshing Salad, and tangy Achar.",
                              "imageId": "6cd2ae46561d8996919a496fbb9a72b4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492218",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "54622259"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7702816",
                          "creativeId": "TopPicks2024/174448683F.png",
                          "title": "Fix Thali ",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "174448683",
                              "name": "Fix Thali ",
                              "category": "99 Store",
                              "description": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/b491aae2-48d3-4390-840b-57dd468badb9_43e8520c-9c10-439f-bf68-fc05a0e7d373.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "finalPrice": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492222",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "94072076-d21c-444e-9763-23889b8cfac9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "57546893"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7703099",
                          "creativeId": "TopPicks2024/174445963F.png",
                          "title": "Mini Bafla thali",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "174445963",
                              "name": "Mini Bafla thali",
                              "category": "99 Store",
                              "description": "Special Thai (Dal + Veg Sabzi + Paneer Masala + 4 Butter Roti + Raita + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/9/6f47bbee-e35d-4a2e-9e68-3dd39dbe12b1_00dc9572-7323-4eb7-a1b5-a36a75a61b8d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "finalPrice": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492116",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "94072076-d21c-444e-9763-23889b8cfac9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "105615716"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Buy 1 Get 1 Free",
                      "subtitle": "1 out of 2 items will be made free.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446463",
                              "name": "Daal Bafla Thali (mini) ",
                              "category": "Thali",
                              "description": "(2 bafla  + Dal fry  + Baigan Bharta + Kadhi)",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492741",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1",
                                  "filterIndex": 1
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "b477d90f-80ef-4023-bddf-0e08ae28d11c"
                              ],
                              "parentId": "54622186"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {
                        "displayText": "Learn More",
                        "offerIds": [
                          "b477d90f-80ef-4023-bddf-0e08ae28d11c"
                        ]
                      },
                      "subtitleColor": "noteworthy",
                      "categoryId": "17"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446459",
                              "name": "Special Thali (Dal + Veg Sabzi + Paneer Masala  + 4 Butter Roti + Raita  + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                              "category": "Thali",
                              "description": "Indulge in a flavorful journey through Thailand with this delectable veg Thali, filled with aromatic Dal, tempting Veg Sabzi, rich Paneer Masala, fluffy Butter Roti, refreshing Raita, delightful Gulab Jamun, fragrant Jeera Rice, crispy Papad, refreshing Salad, and tangy Achar.",
                              "imageId": "6cd2ae46561d8996919a496fbb9a72b4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492218",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "878 ratings",
                                  "ratingCountV2": "878"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622259"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446461",
                              "name": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                              "category": "Thali",
                              "description": "Indulge in this delectable Thali featuring dal, a delightful vegetable sabzi, aromatic jeera rice, soft rotis, and refreshing raita.",
                              "imageId": "d97025b289cbf239479ff6596bda05e7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492733",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "196 ratings",
                                  "ratingCountV2": "196"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622197"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446404",
                              "name": "Jain Daal",
                              "category": "Dal Item",
                              "description": "A rich and flavorful lentil dish crafted with a variety of aromatic spices, delivering a delightful culinary experience.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/fe13f4db-e3b8-460e-8f53-c3094c245431_ad583c5d-6347-457a-9678-f6b50568a6f4.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887613",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380519",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9000,
                                        "id": "60380520",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492618",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446372",
                              "name": "Matar Paneer Combo",
                              "category": "Meals And Combo",
                              "description": "matar paneer  + 5  tawa roti or 4 tandoori",
                              "imageId": "c55b2a2169e2328a181a1c87190f4335",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887598",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380489",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380490",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492410",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622216"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446376",
                              "name": "Butter Paneer Masala Combo  ",
                              "category": "Meals And Combo",
                              "description": "butter paneer masala + 5 tawa roti",
                              "imageId": "384108faea8895ee448434d39a5c4512",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492510",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "346 ratings",
                                  "ratingCountV2": "346"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622178"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446378",
                              "name": "Paneer Masala Combo",
                              "category": "Meals And Combo",
                              "description": "paneer masala  + 5 tawa roti or 4 tandoori roti",
                              "imageId": "000a9291e463465c5ff0100ab892d539",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887600",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380493",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380495",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492179",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "292 ratings",
                                  "ratingCountV2": "292"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622238"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446383",
                              "name": "Sev Tamatar Combo",
                              "category": "Meals And Combo",
                              "description": "sev tamatar  + 5 tawa roti or 4 tandoori roti",
                              "imageId": "440bbb4ae51c52929915a38bc7e8762e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887603",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380499",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380500",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492283",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622255"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446387",
                              "name": "Bhindi Combo",
                              "category": "Meals And Combo",
                              "description": "bhindi masala +5 tawa roti or 4 tandoori roti",
                              "imageId": "d14920ea1971a53e27ed15b3c8273f70",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887604",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380501",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380502",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492514",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622173"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446390",
                              "name": "Aloo Sabji Combo",
                              "category": "Meals And Combo",
                              "description": "aloo tamatar  + 5 tawa or 4 tandoori",
                              "imageId": "2c74849abfda767a8d1453f643891738",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887606",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380505",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380506",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281785",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622167"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446379",
                              "name": "Kaju Kari",
                              "category": "Paneer Item",
                              "description": "Roasted cashews cooked in white and cashew nut gravy, crunchiness of cashew topper and garnish with creams. Mildly sweet in taste",
                              "imageId": "e53e054f96dbee0d310238457dcb6bf1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887601",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380494",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380496",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492600",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622208"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446388",
                              "name": "Paneer Masala",
                              "category": "Paneer Item",
                              "description": "Soft paneer soaked in a rich and creamy gravy laden with butter",
                              "imageId": "c9ff8bc2a131b616d24f7fde74307220",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "finalPrice": 9000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887605",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380503",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380504",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492416",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492418",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "156 ratings",
                                  "ratingCountV2": "156"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "844407f6-2a78-40d5-b543-21e1ec64c10f"
                              ],
                              "parentId": "54622237"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446418",
                              "name": "Aloo Gobhi",
                              "category": "Sabji Item",
                              "description": "All time favorite mouthwatering aloo gobhi made with fresh veggies",
                              "imageId": "3f8a05c074e394d4d31746dbcacacb30",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887621",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380535",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380537",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492696",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622160"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446434",
                              "name": "Sev Tamater",
                              "category": "Sabji Item",
                              "description": "An authentic recipe from rajasthani cuisine prepared with gram flour dumplings simmered in spicy curd gravy, served with indian bread or rice. It is a scrumptious dish consisting of an array of aromatic spices which enhance it's rich taste.",
                              "imageId": "2820c84d306e4b0b81f885cca6c366d2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887637",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380567",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380568",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492724",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492726",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622256"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446414",
                              "name": "Aloo Mater",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic combination of tender peas and tender potatoes cooked in a mouthwatering gravy.",
                              "imageId": "9f5c1e10f7fdbc18a49268240992abaa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887617",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380527",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380529",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492434",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622163"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446440",
                              "name": "Kadi Pakora",
                              "category": "Sabji Item",
                              "description": "A comforting and flavorful vegetarian curry made with fritters, perfect for a satisfying and hearty meal.",
                              "imageId": "b5a32b3bcad2180bfe4cf1801d07ad0a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887643",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380579",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380580",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492536",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622207"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446437",
                              "name": "Sada Rice ",
                              "category": "Rice Item",
                              "description": "A delightful and flavorsome rice dish that is sure to satisfy your taste buds with its rich, aromatic essence.",
                              "imageId": "c021dbd43a20580a6b55d7c7002b09b2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887640",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380573",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6750,
                                        "id": "60380574",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257282217",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492090",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492094",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622253"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446439",
                              "name": "Jeera Rice       ",
                              "category": "Rice Item",
                              "description": "Aromatic rice cooked in a tempering of cumin and whole spices.",
                              "imageId": "6c27cdf576dfee2ff7b419ceeaf139b3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887642",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380577",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380578",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492099",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492103",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622205"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446443",
                              "name": "Khichdi Butter Fry ",
                              "category": "Rice Item",
                              "description": "A flavorful and aromatic rice dish, delicately seasoned and infused with butter to create a mouthwatering symphony of flavors.",
                              "imageId": "bdebee87294aa4db2362ca4c51eb7534",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887646",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380585",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7000,
                                        "id": "60380586",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622211"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446450",
                              "name": "Malai Kofta",
                              "category": "Sabji Kuch Hatke",
                              "description": "Tawa- toasted, crispy and delicious dosa, folded in with masala.",
                              "imageId": "15fac8db30e4bcf6b6604450dc7ec811",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887653",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380599",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380600",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492325",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622213"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446452",
                              "name": "Dum Aloo",
                              "category": "Sabji Kuch Hatke",
                              "description": "Rich indian spices mixed with marinated aloo in yogurt",
                              "imageId": "6870c9ffb2105540126318aab0bb3a58",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887655",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380603",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380604",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492629",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622193"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Large Order",
                      "categories": [
                        {
                          "title": "Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "189885790",
                                  "name": "Manchurian (Pack of 2)                       ",
                                  "category": "Large Order",
                                  "description": "Manchurian (Pack of 2)",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "115544407"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "70091710"
                        }
                      ],
                      "categoryId": "70091263"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Masala Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446415",
                              "name": "Baingan Masala ",
                              "category": "Masala Item",
                              "description": "A tantalizing blend of flavors that will leave your taste buds craving for more.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/ec10f88b-4238-4c1b-96a6-c38f9fc61d86_756368aa-91c2-4726-8629-b7b5280565c5.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887618",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380528",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380530",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492441",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622171"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446431",
                              "name": "Tamatar Masala  ",
                              "category": "Masala Item",
                              "description": "A delectable and flavorsome dish bursting with rich, aromatic spices and a luscious tomato base.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/610c0068-b502-4566-9cea-51a3b97e1290_bebd08df-f31d-42be-866e-376d308aa6a0.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887634",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380561",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380562",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492623",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622260"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446417",
                              "name": "Gobi Masala   ",
                              "category": "Masala Item",
                              "description": "Gobi made in indian spices with a tinch of a tangy flavour",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887620",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380532",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380534",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492201",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622200"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446429",
                              "name": "Chana Masala                              ",
                              "category": "Masala Item",
                              "description": "Chickpeas in a spicy onion tomato masala gravy and cream",
                              "imageId": "197382e7c1ab15ebcfb760ef520b281c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887632",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380556",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380558",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492446",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622180"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446433",
                              "name": "Rajma Masala ",
                              "category": "Masala Item",
                              "description": "A wholesome dish consisting of a delicious red bean gravy",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887636",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380565",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380566",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492084",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622249"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446419",
                              "name": "Bhindi Masala  ",
                              "category": "Masala Item",
                              "description": "Okra or ladyfinger fried and tossed with onion, tomotoes spices and herbs. (served for two)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/046446ab-58f9-4c6c-a407-68cb9cf975c9_7e0de74f-e564-4672-b299-4f537b670506.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887622",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380536",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380538",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492301",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "257281872",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622175"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446423",
                              "name": "Sev Masala ",
                              "category": "Masala Item",
                              "description": "A delectable and flavorful vegetable dish infused with aromatic Indian spices.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887626",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380544",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380546",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622254"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446421",
                              "name": "Aloo Masala ",
                              "category": "Masala Item",
                              "description": "Simply spiced half-mashed potatoes and onion, glistening with fat, is a standard side dish",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/a1893b08-c4b4-4a10-aacd-df018705dd35_2d090f72-d556-472f-8f6b-0414f148a8a3.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887624",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380540",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380542",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492315",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622162"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446425",
                              "name": "Mater Masala",
                              "category": "Masala Item",
                              "description": "A flavorful and aromatic vegetable masala that will tantalize your taste buds with its rich, bold flavors.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/3c68514c-5c74-4fc3-b43c-ef52df3bfd6b_8dd011c9-5a82-45f8-973a-cdb8f0aff9ca.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887628",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380548",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380550",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281992",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622217"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446427",
                              "name": "Palak Masala ",
                              "category": "Masala Item",
                              "description": "A flavorful and aromatic vegetable dish bursting with rich flavors and delightful spices.",
                              "imageId": "b0b09ceae5aa01c1aa9f36867cc2a92e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887630",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380553",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380554",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257282047",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622227"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446435",
                              "name": "Simla Masala",
                              "category": "Masala Item",
                              "description": "A flavorful and aromatic dish bursting with rich Indian spices.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/2746d8b1-6348-411d-8591-b9cb26cabf9a_1e9e52da-6b5f-4556-aaec-88632d1a1aba.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887638",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380569",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380570",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281877",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622258"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/ec10f88b-4238-4c1b-96a6-c38f9fc61d86_756368aa-91c2-4726-8629-b7b5280565c5.JPG",
                      "categoryId": "25184493"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "99 Store",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "174448683",
                              "name": "Fix Thali ",
                              "category": "99 Store",
                              "description": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/b491aae2-48d3-4390-840b-57dd468badb9_43e8520c-9c10-439f-bf68-fc05a0e7d373.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "finalPrice": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492222",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "94072076-d21c-444e-9763-23889b8cfac9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "57546893"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "178187309",
                              "name": "Aloo Paratha                             ",
                              "category": "99 Store",
                              "description": "na",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/15/72580de3-a10f-4bde-87cc-6e3cb43a8dca_49670a80-29a1-4901-aba2-e9acdca50991.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "finalPrice": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "285 ratings",
                                  "ratingCountV2": "285"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "08fac3f8-9189-43ff-94be-1a682b24f543"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "54622165"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "174445963",
                              "name": "Mini Bafla thali",
                              "category": "99 Store",
                              "description": "Special Thai (Dal + Veg Sabzi + Paneer Masala + 4 Butter Roti + Raita + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/9/6f47bbee-e35d-4a2e-9e68-3dd39dbe12b1_00dc9572-7323-4eb7-a1b5-a36a75a61b8d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "finalPrice": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492116",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "94072076-d21c-444e-9763-23889b8cfac9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "105615716"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/b491aae2-48d3-4390-840b-57dd468badb9_43e8520c-9c10-439f-bf68-fc05a0e7d373.jpg",
                      "categoryId": "63390971"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Thali",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446459",
                              "name": "Special Thali (Dal + Veg Sabzi + Paneer Masala  + 4 Butter Roti + Raita  + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                              "category": "Thali",
                              "description": "Indulge in a flavorful journey through Thailand with this delectable veg Thali, filled with aromatic Dal, tempting Veg Sabzi, rich Paneer Masala, fluffy Butter Roti, refreshing Raita, delightful Gulab Jamun, fragrant Jeera Rice, crispy Papad, refreshing Salad, and tangy Achar.",
                              "imageId": "6cd2ae46561d8996919a496fbb9a72b4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492218",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "878 ratings",
                                  "ratingCountV2": "878"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622259"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446461",
                              "name": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                              "category": "Thali",
                              "description": "Indulge in this delectable Thali featuring dal, a delightful vegetable sabzi, aromatic jeera rice, soft rotis, and refreshing raita.",
                              "imageId": "d97025b289cbf239479ff6596bda05e7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492733",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "196 ratings",
                                  "ratingCountV2": "196"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622197"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446463",
                              "name": "Daal Bafla Thali (mini) ",
                              "category": "Thali",
                              "description": "(2 bafla  + Dal fry  + Baigan Bharta + Kadhi)",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492741",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "b477d90f-80ef-4023-bddf-0e08ae28d11c"
                              ],
                              "parentId": "54622186"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188020358",
                              "name": "Dal Bafla Thali",
                              "category": "Thali",
                              "description": "Dal Bafla 4 pc+ Dal Fry + Kadhi + Baigan Bharta",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398968"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188020378",
                              "name": "Mini Thali",
                              "category": "Thali",
                              "description": "Dal +2 roti+ Aloo sabji+Rice ( subject to availability)",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398973"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "6cd2ae46561d8996919a496fbb9a72b4",
                      "categoryId": "25184495"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dal Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446396",
                              "name": "Daal Fry",
                              "category": "Dal Item",
                              "description": "A comforting and delicious preparation made with mixed daal cooked and tempered with onions, chillies and more in pure ghee.",
                              "imageId": "4986ebc3e4355b97c960ddc0df4bfe3f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887609",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380511",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9000,
                                        "id": "60380512",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492525",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "257282143",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "No_Sugar/Pure_ghee1.png"
                                }
                              ],
                              "parentId": "54622187"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446398",
                              "name": "Daal Hari Mirchi ",
                              "category": "Dal Item",
                              "description": "A vibrant and flavorful lentil dish simmered with aromatic spices and fresh herbs.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887611",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380515",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9500,
                                        "id": "60380516",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492192",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622188"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446412",
                              "name": "Daal Tadka ",
                              "category": "Dal Item",
                              "description": "All time favorite mouthwatering dal tadka and served with salad and along with pickles.(Serve 2)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/e6719281-3575-414a-b8d8-17fad638840c_48491c67-1f7a-4a78-856d-6e95831a4ab8.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887616",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380525",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9500,
                                        "id": "60380526",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492292",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492295",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "75 ratings",
                                  "ratingCountV2": "75"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622192"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446401",
                              "name": "Daal Hari Mirchi Butter",
                              "category": "Dal Item",
                              "description": "A flavorful and creamy lentil dish accented with fresh green chili and a touch of butter.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/c0306a37-1a59-4fc6-a36a-ad04a2f7ea22_8b4c507b-234f-42a3-9a50-1d72f70aea87.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887612",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380517",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9750,
                                        "id": "60380518",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492059",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622189"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446404",
                              "name": "Jain Daal",
                              "category": "Dal Item",
                              "description": "A rich and flavorful lentil dish crafted with a variety of aromatic spices, delivering a delightful culinary experience.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/fe13f4db-e3b8-460e-8f53-c3094c245431_ad583c5d-6347-457a-9678-f6b50568a6f4.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887613",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380519",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9000,
                                        "id": "60380520",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492618",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446407",
                              "name": "Daal Makhini",
                              "category": "Dal Item",
                              "description": "A delectable and creamy dal preparation that tantalizes the taste buds with its rich and flavorful blend.",
                              "imageId": "aef2e84f0d2c89088aec74e27182d852",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887614",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380521",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 9500,
                                        "id": "60380522",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257282151",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492532",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "67 ratings",
                                  "ratingCountV2": "67"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622190"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446409",
                              "name": "Daal Sada",
                              "category": "Dal Item",
                              "description": "A flavorful and comforting Dal Item that is sure to satisfy your taste buds.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/a08c0600-227f-48cd-8017-3e7996dc7e18_2feb0f6a-c078-4237-b35e-791100ade687.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887615",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380523",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380524",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492197",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622191"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "4986ebc3e4355b97c960ddc0df4bfe3f",
                      "categoryId": "25184492"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals And Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446372",
                              "name": "Matar Paneer Combo",
                              "category": "Meals And Combo",
                              "description": "matar paneer  + 5  tawa roti or 4 tandoori",
                              "imageId": "c55b2a2169e2328a181a1c87190f4335",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887598",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380489",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380490",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492410",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622216"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446376",
                              "name": "Butter Paneer Masala Combo  ",
                              "category": "Meals And Combo",
                              "description": "butter paneer masala + 5 tawa roti",
                              "imageId": "384108faea8895ee448434d39a5c4512",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492510",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "346 ratings",
                                  "ratingCountV2": "346"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622178"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446378",
                              "name": "Paneer Masala Combo",
                              "category": "Meals And Combo",
                              "description": "paneer masala  + 5 tawa roti or 4 tandoori roti",
                              "imageId": "000a9291e463465c5ff0100ab892d539",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887600",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380493",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380495",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492179",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "292 ratings",
                                  "ratingCountV2": "292"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622238"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446383",
                              "name": "Sev Tamatar Combo",
                              "category": "Meals And Combo",
                              "description": "sev tamatar  + 5 tawa roti or 4 tandoori roti",
                              "imageId": "440bbb4ae51c52929915a38bc7e8762e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887603",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380499",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380500",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492283",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622255"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446387",
                              "name": "Bhindi Combo",
                              "category": "Meals And Combo",
                              "description": "bhindi masala +5 tawa roti or 4 tandoori roti",
                              "imageId": "d14920ea1971a53e27ed15b3c8273f70",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887604",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380501",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380502",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492514",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622173"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446390",
                              "name": "Aloo Sabji Combo",
                              "category": "Meals And Combo",
                              "description": "aloo tamatar  + 5 tawa or 4 tandoori",
                              "imageId": "2c74849abfda767a8d1453f643891738",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887606",
                                    "name": "Choice of Roti",
                                    "variations": [
                                      {
                                        "name": "5 Tawa Roti",
                                        "default": 1,
                                        "id": "60380505",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Tandoori Roti",
                                        "id": "60380506",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281785",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622167"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188019166",
                              "name": "Dum Aloo Combo",
                              "category": "Meals And Combo",
                              "description": "Dum Aloo with 4 tawa roti combo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398969"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188019178",
                              "name": "Malai Kofta Combo",
                              "category": "Meals And Combo",
                              "description": "Malai Kofta with 4 Tawa roti combo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398971"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "c55b2a2169e2328a181a1c87190f4335",
                      "categoryId": "25184496"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Paneer Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446361",
                              "name": "Shahi Paneer",
                              "category": "Paneer Item",
                              "description": "Fresh cottage cheese cooked in a mild thick tomato curry.",
                              "imageId": "6eebfdc1d5abf518a6e828c5e53a1209",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887595",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380483",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380484",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492278",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "143 ratings",
                                  "ratingCountV2": "143"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622257"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446403",
                              "name": "Paneer 65             ",
                              "category": "Paneer Item",
                              "description": "The Grilled Paneer Cubes are cooked In clay oven, Sour, Spicy masla.& Its Dry",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622230"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446406",
                              "name": "Paneer Pasanda      ",
                              "category": "Paneer Item",
                              "description": "Paneer prepared in thick sweet gravy with veggies and cream",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257282102",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622240"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446408",
                              "name": "Paneer Makhmali",
                              "category": "Paneer Item",
                              "description": "A rich and creamy delicacy bursting with delectable flavors.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622236"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446410",
                              "name": "Handi Paneer",
                              "category": "Paneer Item",
                              "description": "Fresh paneer and creamy gravy cooked in a handi.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/9991bef0-5e04-4aec-8d1d-d43094d4306b_14b6376e-470f-4c84-87ec-562eeea449c1.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "49872477",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Serves 1",
                                        "default": 1,
                                        "id": "156432073",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Serves 2",
                                        "price": 37000,
                                        "id": "156432075",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492062",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622202"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446366",
                              "name": "Punjabi Paneer",
                              "category": "Paneer Item",
                              "description": "Mildly tangy and creamy dish of fresh paneer prepared with khoya, malai and special masala in spicy gravy",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/3/c0aa93a9-beba-4bdc-98be-78257b161362_f3a74607-18dc-408e-97f5-c605724c4344.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887596",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380485",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380486",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492397",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "118 ratings",
                                  "ratingCountV2": "118"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622247"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446371",
                              "name": "Kadai Paneer",
                              "category": "Paneer Item",
                              "description": "Cottage cheese and bell peppers cooked in a spicy masala.",
                              "imageId": "43abe2023c6f49411f43181fd3984911",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887597",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380487",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380488",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492404",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "376 ratings",
                                  "ratingCountV2": "376"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622206"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446374",
                              "name": "Butter Paneer",
                              "category": "Paneer Item",
                              "description": "Marinated paneer tossed and served in delicious spicy buttery gravy.",
                              "imageId": "c3d558f6895995358de89e285aaa8698",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887599",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380491",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380492",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492596",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "177 ratings",
                                  "ratingCountV2": "177"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622177"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446379",
                              "name": "Kaju Kari",
                              "category": "Paneer Item",
                              "description": "Roasted cashews cooked in white and cashew nut gravy, crunchiness of cashew topper and garnish with creams. Mildly sweet in taste",
                              "imageId": "e53e054f96dbee0d310238457dcb6bf1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887601",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380494",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380496",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492600",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622208"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446382",
                              "name": "Paneer Korma",
                              "category": "Paneer Item",
                              "description": "Korma made with nuts,seeds, coconut ,curd ,veggie even with paneer.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/ee7a8ed9-f08b-447f-960f-6704af42082f_ad104f81-b8f1-4677-b976-a016cc7c20d8.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887602",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380497",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380498",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492183",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622234"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446385",
                              "name": "Paneer Bhurji",
                              "category": "Paneer Item",
                              "description": "Soft grated paneer cooked with onions, tomatoes and green chillies.",
                              "imageId": "45466091b606f4b1b805b27a7e2a1bba",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622232"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446388",
                              "name": "Paneer Masala",
                              "category": "Paneer Item",
                              "description": "Soft paneer soaked in a rich and creamy gravy laden with butter",
                              "imageId": "c9ff8bc2a131b616d24f7fde74307220",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "finalPrice": 9000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887605",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380503",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380504",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492416",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492418",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "156 ratings",
                                  "ratingCountV2": "156"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "844407f6-2a78-40d5-b543-21e1ec64c10f"
                              ],
                              "parentId": "54622237"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446392",
                              "name": "Chole Paneer",
                              "category": "Paneer Item",
                              "description": "Aspicy & Tangy Curry Prepared Of Chana,Often Paired With Bhatoora/Poori/Rice.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887607",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380507",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380508",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492519",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622184"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446395",
                              "name": "Matar Paneer",
                              "category": "Paneer Item",
                              "description": "The ghar ki matter paneer in our chef's own unique way",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/e2af8bd8-e4c3-4c8a-8201-a12db8a220ca_dac85cdd-a8ef-4ab9-a1a3-b4123c7925a5.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887608",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380509",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380510",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492607",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "257281789",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622215"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446397",
                              "name": "Palak Paneer",
                              "category": "Paneer Item",
                              "description": "Rich and thick spinach and onion gravy in aromatic herbs",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/e570966e-945b-4675-b420-d8e15d70f22d_3699c10c-1220-4a7a-a2fd-97494c68f9da.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887610",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380513",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 12750,
                                        "id": "60380514",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492187",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "257281856",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622228"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446399",
                              "name": "Chilli Paneer",
                              "category": "Paneer Item",
                              "description": "Cubes fried cottage cheese with onion, capsicum & green chili",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622181"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446400",
                              "name": "Kaju Paneer",
                              "category": "Paneer Item",
                              "description": "Cashew and Indian cottage cheese in silky-smooth tomato-onion-cream based gravy!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/fab1ac67-b054-498e-80aa-03c555c5c121_f2869368-a1d5-4c4f-a383-eb2da19d6b72.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492612",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622209"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446402",
                              "name": "Paneer Chatpata",
                              "category": "Paneer Item",
                              "description": "Rich And Creamy Dish Of Paneer (Cottage Cheese) mashed In a indian spices and different flavour sauces.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/ba805a45-1972-4e23-9d82-02b3e6a895a5_697a2021-e71e-4b48-a48c-43ed813dc139.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281863",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622233"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446405",
                              "name": "Paneer 2 Pyaza",
                              "category": "Paneer Item",
                              "description": "A rich, creamy curry of soft succulent paneer and plenty of onions in a wonderful medley of spices, herbs and tomatoes.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492430",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622229"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "6eebfdc1d5abf518a6e828c5e53a1209",
                      "categoryId": "25184484"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sabji Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446418",
                              "name": "Aloo Gobhi",
                              "category": "Sabji Item",
                              "description": "All time favorite mouthwatering aloo gobhi made with fresh veggies",
                              "imageId": "3f8a05c074e394d4d31746dbcacacb30",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887621",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380535",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380537",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492696",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622160"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446424",
                              "name": "Aloo Chole",
                              "category": "Sabji Item",
                              "description": "aloo chole ki sabji is one such fusion curry which has the goodness of both chickpeas and potatoes",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887627",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380547",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380549",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492072",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622158"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446428",
                              "name": "Aloo Palak",
                              "category": "Sabji Item",
                              "description": "A hearty dish with soft potato cooked in Palak puree with a flavorful masala.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/7b0cea01-24ff-4a04-8716-61d50ec31547_37ad91b4-12b3-4c7f-9966-3c831655f6b0.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887631",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380555",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380557",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492205",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622164"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446434",
                              "name": "Sev Tamater",
                              "category": "Sabji Item",
                              "description": "An authentic recipe from rajasthani cuisine prepared with gram flour dumplings simmered in spicy curd gravy, served with indian bread or rice. It is a scrumptious dish consisting of an array of aromatic spices which enhance it's rich taste.",
                              "imageId": "2820c84d306e4b0b81f885cca6c366d2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887637",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380567",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380568",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492724",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492726",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622256"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446436",
                              "name": "Baingan Bharta",
                              "category": "Sabji Item",
                              "description": "Baingan bharta is a popular north Indian dish where fire roasted eggplant is mashed and cooked with spices. It's best served with fresh rotis",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/03df0038-bcb0-4203-b0f2-bf0bbde4699f_4b84ce98-d2ae-4680-b46d-2cf095c275d9.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887639",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380571",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380572",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492211",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622170"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446446",
                              "name": "Mix Veg",
                              "category": "Sabji Item",
                              "description": "Mix veggies cooked in a fresh and delectable tomato flavoured curry.",
                              "imageId": "cd232d6ce991b0ae14105e8fa5f5325c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887649",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380591",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 8000,
                                        "id": "60380592",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492318",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "257281940",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622224"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446414",
                              "name": "Aloo Mater",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic combination of tender peas and tender potatoes cooked in a mouthwatering gravy.",
                              "imageId": "9f5c1e10f7fdbc18a49268240992abaa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887617",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380527",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380529",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492434",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622163"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446448",
                              "name": "Panjabi Chole ",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic Punjabi dish that will tantalize your taste buds and leave you craving for more.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/7157b8d0-108a-4cf5-8680-791619b5f968_8059c8f2-989f-4c57-9f88-9ccaf3229eba.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887651",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380595",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 8000,
                                        "id": "60380596",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281994",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492109",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622243"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446440",
                              "name": "Kadi Pakora",
                              "category": "Sabji Item",
                              "description": "A comforting and flavorful vegetarian curry made with fritters, perfect for a satisfying and hearty meal.",
                              "imageId": "b5a32b3bcad2180bfe4cf1801d07ad0a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887643",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380579",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380580",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492536",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622207"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446416",
                              "name": "Aloo Jira",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic vegetable dish bursting with Indian flavors and fragrance.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/89137e33-49b7-4152-a6a0-8d8a9eeb591c_a0a80a64-94fa-4afa-a6a1-5a8b62bd2df6.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887619",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380531",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380533",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492068",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622161"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446420",
                              "name": "Aloo Baingan",
                              "category": "Sabji Item",
                              "description": "Delicious combination of potatoes and eggplant sauteed together to create a flavorful Indian vegetable dish.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/69df45d5-b0e8-4bf5-8ef5-5599151773a8_6896aa9a-50c7-4578-bfc6-6ceb6d2cde44.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887623",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380539",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380541",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492308",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622157"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446422",
                              "name": "Aloo Tamater",
                              "category": "Sabji Item",
                              "description": "A delectable and flavorful potato and tomato dish that will tantalize your taste buds.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887625",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380543",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380545",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492707",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622169"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446426",
                              "name": "Aloo Fry",
                              "category": "Sabji Item",
                              "description": "An irresistible vegetable dish that is full of flavor and perfect for vegetarians, offering a delightful blend of textures and tantalizing taste.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/aaa6fdf4-2dcf-4cc3-857e-e4c1ecc43f53_d80604ea-3ac1-49fd-a70f-1315dceb773b.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887629",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380551",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380552",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622159"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446430",
                              "name": "Aloo Rajma",
                              "category": "Sabji Item",
                              "description": "A mouthwatering combination of tender kidney beans and flavorful potatoes, this classic Indian sabji item is sure to satisfy your tastebuds.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/84aa8517-71ca-4cac-9d1f-f294f1b0d95b_69b89923-c69d-4e4d-b438-5b138d2a1e13.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887633",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380559",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380560",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492078",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622166"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446432",
                              "name": "Aloo Simla",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic vegetable dish with a delightful combination of textures.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/2a1b97e7-dfcc-4ace-ac83-9dd5ae0a1dfe_ae3ec251-e5dd-4431-8a30-99711bc4bdb1.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887635",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380563",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "id": "60380564",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492716",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622168"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446438",
                              "name": "Bhindi Fry",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic vegetable dish that will tickle your taste buds with its tantalizing blend of flavors.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887641",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Full",
                                        "price": 7100,
                                        "default": 1,
                                        "id": "60380576",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Half",
                                        "id": "60380575",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257281798",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409291",
                                      "name": "Missi Roti",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409286",
                                      "name": "Tawa Butter Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409279",
                                      "name": "Tandoori Roti",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409293",
                                      "name": "Tandoori Roti Butter",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622174"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446442",
                              "name": "Gobi 2 Pyaza",
                              "category": "Sabji Item",
                              "description": "A flavorful and aromatic vegetable dish that celebrates the rich flavors of cauliflower in a delightful combination.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887645",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380583",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6500,
                                        "id": "60380584",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492539",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622199"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446444",
                              "name": "Bhindi 2 Pyaza",
                              "category": "Sabji Item",
                              "description": "An aromatic and flavorful vegetable dish featuring tender okra cooked with a delightful blend of onions and tantalizing spices.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887647",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380587",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6500,
                                        "id": "60380588",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492545",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622172"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "3f8a05c074e394d4d31746dbcacacb30",
                      "categoryId": "25184486"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446437",
                              "name": "Sada Rice ",
                              "category": "Rice Item",
                              "description": "A delightful and flavorsome rice dish that is sure to satisfy your taste buds with its rich, aromatic essence.",
                              "imageId": "c021dbd43a20580a6b55d7c7002b09b2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887640",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380573",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6750,
                                        "id": "60380574",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "257282217",
                                  "groupName": "Roti",
                                  "choices": [
                                    {
                                      "id": "141409294",
                                      "name": "Tawa Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492090",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492094",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622253"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446439",
                              "name": "Jeera Rice       ",
                              "category": "Rice Item",
                              "description": "Aromatic rice cooked in a tempering of cumin and whole spices.",
                              "imageId": "6c27cdf576dfee2ff7b419ceeaf139b3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887642",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380577",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7500,
                                        "id": "60380578",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492099",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492103",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622205"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446441",
                              "name": "Khichdi ",
                              "category": "Rice Item",
                              "description": "A flavorful and aromatic rice dish that is hearty and satisfying.",
                              "imageId": "221415f66366c4afb4df3f84fbb59ef8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887644",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380581",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7000,
                                        "id": "60380582",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622210"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446455",
                              "name": "Chole Rice ",
                              "category": "Rice Item",
                              "description": "A wholesome dish consisting of a delicious chick pea gravy served with rice - perfect to satisfy your cravings.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/27/b5d02955-a0b8-4ece-af16-3a28c9b345ba_0c4b75eb-7f4e-48fe-8379-6344aed1ed50.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887658",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380609",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 8000,
                                        "id": "60380610",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491977",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256491990",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622185"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446443",
                              "name": "Khichdi Butter Fry ",
                              "category": "Rice Item",
                              "description": "A flavorful and aromatic rice dish, delicately seasoned and infused with butter to create a mouthwatering symphony of flavors.",
                              "imageId": "bdebee87294aa4db2362ca4c51eb7534",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887646",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380585",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7000,
                                        "id": "60380586",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622211"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446453",
                              "name": "Veg Biryani          ",
                              "category": "Rice Item",
                              "description": "A delightfully wholesome combo of aromatic veg biryani.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/e8c7ab6d-b05a-4acd-9c4a-e033f57e5f64_43a8287f-189b-4886-bf89-93a61b72e4c9.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17000,
                              "finalPrice": 8000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887656",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380605",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6000,
                                        "id": "60380606",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4a84e39-bbda-4541-a6ea-8c1cdb4a3cd8"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "54622265"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446457",
                              "name": "Rajma Rice ",
                              "category": "Rice Item",
                              "description": "Tawa- toasted, crispy and delicious dosa, folded in with masala.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/11/e2a1bda0-336d-4820-ba5c-f8507211c44d_cdf5b732-2fca-40ae-b0ea-4a6f7cdb2daf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887660",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380613",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 7000,
                                        "id": "60380614",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491999",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409287",
                                      "name": "Aloo Chole",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912737",
                                      "name": "Butter Paneer Masala Combo",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409272",
                                      "name": "Aloo Mater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409283",
                                      "name": "Aloo Jira",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409284",
                                      "name": "Daal Fry",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409295",
                                      "name": "Sev Tamater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409282",
                                      "name": "Kadi Pakora",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256492014",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622250"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446451",
                              "name": "Matar Pulao",
                              "category": "Rice Item",
                              "description": "A delightful, savory rice dish bursting with fresh, flavorful ingredients, ideal for veggie lovers.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887654",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380601",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6000,
                                        "id": "60380602",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491956",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409287",
                                      "name": "Aloo Chole",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912737",
                                      "name": "Butter Paneer Masala Combo",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409272",
                                      "name": "Aloo Mater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409283",
                                      "name": "Aloo Jira",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409284",
                                      "name": "Daal Fry",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409295",
                                      "name": "Sev Tamater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409282",
                                      "name": "Kadi Pakora",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "112780951"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446445",
                              "name": "Masala Rice",
                              "category": "Rice Item",
                              "description": "A delicious rice treat, a very fragnant and flavourful rice dish.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887648",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380589",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6500,
                                        "id": "60380590",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491915",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409287",
                                      "name": "Aloo Chole",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912737",
                                      "name": "Butter Paneer Masala Combo",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409272",
                                      "name": "Aloo Mater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409283",
                                      "name": "Aloo Jira",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409284",
                                      "name": "Daal Fry",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409295",
                                      "name": "Sev Tamater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409282",
                                      "name": "Kadi Pakora",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "256491924",
                                  "groupName": "Papad",
                                  "choices": [
                                    {
                                      "id": "141409285",
                                      "name": "Fry Papad",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409292",
                                      "name": "Papad Dry",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622214"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446447",
                              "name": "Veg Pulao",
                              "category": "Rice Item",
                              "description": "Fragmented basmati rice cooked with mix vegetables.",
                              "imageId": "6fa5a9280306841a92b47b2770be82c2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887650",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380593",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6000,
                                        "id": "60380594",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491930",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409287",
                                      "name": "Aloo Chole",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141948730",
                                      "name": "Aloo Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912737",
                                      "name": "Butter Paneer Masala Combo",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409272",
                                      "name": "Aloo Mater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409283",
                                      "name": "Aloo Jira",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409284",
                                      "name": "Daal Fry",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409295",
                                      "name": "Sev Tamater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409282",
                                      "name": "Kadi Pakora",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622266"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446449",
                              "name": "Paneer Pulao",
                              "category": "Rice Item",
                              "description": "A wholesome dish prepared by cooking green veggies and rice in a flavorful Indian masala with paneer.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887652",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380597",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 6000,
                                        "id": "60380598",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256491940",
                                  "groupName": "Curry",
                                  "choices": [
                                    {
                                      "id": "141409276",
                                      "name": "Daal Hari Mirchi",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409287",
                                      "name": "Aloo Chole",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409288",
                                      "name": "Aloo Baingan",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409274",
                                      "name": "Daal Sada",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409297",
                                      "name": "Daal Makhini",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409278",
                                      "name": "Jain Daal",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409289",
                                      "name": "Daal Hari Mirchi Butter",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141948730",
                                      "name": "Aloo Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912735",
                                      "name": "Gobi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912734",
                                      "name": "Daal Tadka",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912737",
                                      "name": "Butter Paneer Masala Combo",
                                      "price": 18000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912736",
                                      "name": "Methi Malai",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409272",
                                      "name": "Aloo Mater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409283",
                                      "name": "Aloo Jira",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409273",
                                      "name": "Baingan Bharta",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409284",
                                      "name": "Daal Fry",
                                      "price": 17000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409295",
                                      "name": "Sev Tamater",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141912733",
                                      "name": "Bhindi Masala",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "141409282",
                                      "name": "Kadi Pakora",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622241"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "c021dbd43a20580a6b55d7c7002b09b2",
                      "categoryId": "25184494"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sabji Kuch Hatke",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446450",
                              "name": "Malai Kofta",
                              "category": "Sabji Kuch Hatke",
                              "description": "Tawa- toasted, crispy and delicious dosa, folded in with masala.",
                              "imageId": "15fac8db30e4bcf6b6604450dc7ec811",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887653",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380599",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380600",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492325",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622213"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446452",
                              "name": "Dum Aloo",
                              "category": "Sabji Kuch Hatke",
                              "description": "Rich indian spices mixed with marinated aloo in yogurt",
                              "imageId": "6870c9ffb2105540126318aab0bb3a58",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887655",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380603",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380604",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492629",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622193"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446454",
                              "name": "Hariyali Kofta",
                              "category": "Sabji Kuch Hatke",
                              "description": "Soft melt in the mouth paneer based dumplings prepared in rich, creamy, and nutty gravy",
                              "imageId": "9039250eeb835d3eb7e0c99072d6f7b3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887657",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380607",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380608",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492632",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622203"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446456",
                              "name": "Methi Malai ",
                              "category": "Sabji Kuch Hatke",
                              "description": "Creamy and flavorful, this unique veggie dish takes your tastebuds on a delightful journey with its aromatic blend of fenugreek and creamy goodness.",
                              "imageId": "156c993c66d129f4883ca59118d8c994",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887659",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380611",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380612",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492549",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622220"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446458",
                              "name": "Methi Butter Malai",
                              "category": "Sabji Kuch Hatke",
                              "description": "Indulge in the rich and creamy flavors of this unique and flavorful vegetable curry.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/8a7772ce-25a8-4407-9191-ebb270c735d4_524da79b-a74d-4d74-94b1-9e4e4cc86a4c.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17887661",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "default": 1,
                                        "id": "60380615",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 11000,
                                        "id": "60380616",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492333",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622219"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "15fac8db30e4bcf6b6604450dc7ec811",
                      "categoryId": "25184487"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Special Paneer Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446460",
                              "name": "Paneer Tikka Masala                ",
                              "category": "Special Paneer Item",
                              "description": "Cheese cubes marinated in curd,oil,lot of spices and grilled.",
                              "imageId": "ba267b2731e91b57214ae0beedb73bae",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492638",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "54622242"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446462",
                              "name": "Paneer Angara",
                              "category": "Special Paneer Item",
                              "description": "A delightfully flavor-packedPaneer Angaratossed with veggies and delectable masalas - perfect to satiate your cravings.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492336",
                                  "groupName": "Naan",
                                  "choices": [
                                    {
                                      "id": "141409280",
                                      "name": "Naan Sada",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622231"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "ba267b2731e91b57214ae0beedb73bae",
                      "categoryId": "25184488"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Snacks",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97683582",
                              "name": "Veg Hakka Noodles",
                              "category": "Snacks",
                              "description": "A satisfying and flavorful Chinese dish that showcases a delightful combination of vegetables and noodles.",
                              "imageId": "c55f9245af53731d4fb8f90c6f3ed294",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398978"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97683581",
                              "name": "Manchurian ",
                              "category": "Snacks",
                              "description": "A delectable Chinese delight bursting with savory flavors and enticing textures.",
                              "imageId": "80c93aeecc9a087818062f9e32cdad5b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "17963326",
                                    "name": "Preparation type",
                                    "variations": [
                                      {
                                        "name": "Dry",
                                        "default": 1,
                                        "id": "60579357",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Gravy",
                                        "price": 1000,
                                        "id": "60579358",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "256492750",
                                  "groupName": "Noodles",
                                  "choices": [
                                    {
                                      "id": "141409299",
                                      "name": "Chaumin",
                                      "price": 14000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "271 ratings",
                                  "ratingCountV2": "271"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54754696"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188019204",
                              "name": "Veg Kothe",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398979"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188019208",
                              "name": "Veg Chowmein",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398977"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188019243",
                              "name": "Chilli Paneer Gravy",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398965"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188020176",
                              "name": "Poori Sabji",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398975"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188020215",
                              "name": "Chole Bhature",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398966"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188020280",
                              "name": "Chole Kucle",
                              "category": "Snacks",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398967"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "c55f9245af53731d4fb8f90c6f3ed294",
                      "categoryId": "25273746"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tandoor Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446375",
                              "name": "Tandoori Roti",
                              "category": "Tandoor Item",
                              "description": "Authentic Indian bread cooked in a clay oven, boasting a tantalizing aroma and a smoky flavor that will transport your taste buds to the streets of India.",
                              "imageId": "3bc160f76ad87002dc9f9c67bb1a9d6e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "601 ratings",
                                  "ratingCountV2": "601"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622261"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446377",
                              "name": "Tandoori Roti Butter",
                              "category": "Tandoor Item",
                              "description": "Delight in the delectable flavors of a buttered Tandoori Roti straight from the tandoor oven.",
                              "imageId": "44f79c1a8b2982de2ea243b2c8feedbd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "193 ratings",
                                  "ratingCountV2": "193"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622262"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446380",
                              "name": "Missi Roti",
                              "category": "Tandoor Item",
                              "description": "A flavorful and aromatic tandoor delight that will transport your taste buds to culinary bliss.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/9f8a5ea5-4f49-4eb3-8241-dc862d647d0f_1e97585d-78d9-49db-842b-838bd8bd4734.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622222"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446381",
                              "name": "Missi Roti Butter",
                              "category": "Tandoor Item",
                              "description": "Flaky and crispy bread with a delightful buttery flavor straight from the tandoor.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/6b425cde-101a-453d-b835-608d6eb9e06c_fe459336-bd99-4931-bfab-a627f7e7278d.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622223"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446384",
                              "name": "Lacha Paratha",
                              "category": "Tandoor Item",
                              "description": "Flaky and buttery, this tandoor delight is a must-try for all veggie lovers!",
                              "imageId": "f59567eaad1a59231094c8a16b5565dc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622212"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446386",
                              "name": "Naan Sada",
                              "category": "Tandoor Item",
                              "description": "A delightful and delectable vegetarian tandoor item that will satisfy your cravings.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/425599c1-2417-438b-bba5-cbdb336495ba_5020d016-702f-4458-9caf-5cd1f1c17964.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622226"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446389",
                              "name": "Naan Butter",
                              "category": "Tandoor Item",
                              "description": "Deliciously buttery.",
                              "imageId": "8a18485d158e7d0a703ebdb62866b6d2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "127 ratings",
                                  "ratingCountV2": "127"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622225"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "3bc160f76ad87002dc9f9c67bb1a9d6e",
                      "categoryId": "25184490"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446467",
                              "name": "Tawa Roti",
                              "category": "Breads",
                              "description": "A mouthwatering vegetarian delight prepared on a hot tawa, offering a delectable taste of Indian flavors.",
                              "imageId": "cb33c539c450dc8f36f22897a82e9280",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "902 ratings",
                                  "ratingCountV2": "902"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622264"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446468",
                              "name": "Tawa Butter Roti",
                              "category": "Breads",
                              "description": "A delectable and flavorful Indian bread cooked on a hot griddle, perfect for a wholesome and satisfying meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/fb639ea1-70b7-4798-b502-ec900ebadbc9_928ec4f3-6fd0-446c-91ca-ceacdb257d74.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "168 ratings",
                                  "ratingCountV2": "168"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622263"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446469",
                              "name": "Sada Paratha ",
                              "category": "Breads",
                              "description": "A delectable Indian flatbread cooked on a griddle, prepared with simplicity and love.",
                              "imageId": "0cedbf4155cb0dc3b39d33c105469c8a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "87 ratings",
                                  "ratingCountV2": "87"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622252"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "187987791",
                              "name": "Gobi Paratha",
                              "category": "Breads",
                              "description": "serve 1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622201"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446470",
                              "name": "Aloo Paratha",
                              "category": "Breads",
                              "description": "Generously stuffed aloo and pyaz paratha served with raita, salad and pickle.",
                              "imageId": "12756ee40f94f21fe6eae3108f59a118",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "285 ratings",
                                  "ratingCountV2": "285"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622165"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446365",
                              "name": "Paneer Paratha                 ",
                              "category": "Breads",
                              "description": "Soft and fluffy flatbread with a mashed paneer and spices stuffing",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/b2603340-bea7-4a32-bd6c-c4bca1c52754_3ec17d88-b74c-4611-b765-379b59cea934.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622239"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446368",
                              "name": "Extra Bafla",
                              "category": "Breads",
                              "description": "A flavorful and delectable veg tawa item, Extra Bafla is a culinary delight that will tantalize your taste buds.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622194"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446370",
                              "name": "Extra Kulcha",
                              "category": "Breads",
                              "description": "A flavorful and savory vegetarian delight straight from the tawa, tempting you with its unique kulcha goodness.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622196"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446373",
                              "name": "Extra Bhature",
                              "category": "Breads",
                              "description": "Crispy and fluffy, Extra Bhature is a delightful tawa item that will leave you craving for more.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622195"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "cb33c539c450dc8f36f22897a82e9280",
                      "categoryId": "25184489"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Papad Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446391",
                              "name": "Papad Dry",
                              "category": "Papad Item",
                              "description": "A delectable and crispy delight that perfectly complements any meal.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "49872482",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "1 Piece",
                                        "default": 1,
                                        "id": "156432084",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "2 Piece",
                                        "price": 3000,
                                        "id": "156432085",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622244"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446393",
                              "name": "Fry Papad",
                              "category": "Papad Item",
                              "description": "Crispy and flavorful, a scrumptious papad dish that will leave you craving for more.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622198"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188018356",
                              "name": "Masala Papad",
                              "category": "Papad Item",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "114398972"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "25184491"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dahi Item",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446411",
                              "name": "Boondi Ka Raita",
                              "category": "Dahi Item",
                              "description": "Creamy yogurt-based dish with crispy gram flour dumplings.",
                              "imageId": "7dd5517ca27c19d21bf78163b1b41f78",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622176"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97446413",
                              "name": "Chach",
                              "category": "Dahi Item",
                              "description": "A refreshing and tangy yogurt-based delight that will tantalize your taste buds.",
                              "imageId": "25405842d880c04cdcbee12e853c5331",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "312 ratings",
                                  "ratingCountV2": "312"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "54622179"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "7dd5517ca27c19d21bf78163b1b41f78",
                      "categoryId": "25184485"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 21422010002481"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Shri Anjani Veg Bhojnalaya",
                      "area": "Ayodhya Bypass",
                      "completeAddress": "Airport Road, ISRO Colony, Ayodhya Nagar, Bhopal, Madhya Pradesh 462021"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "ycJsHz4MtsMJ-VlHCqv1-CP94qK9DEmBFuAxl2Eg"
},

  "637339": {
    "statusCode": 0,
    "data": {
      "statusMessage": "done successfully",
      "cards": [
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
              "text": "Shri Anjani Veg Bhojnalaya",
              "headerStyling": {
                "textColor": "text_Highest_Emphasis",
                "textVariant": "header_H3_Black"
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
              "tabs": [
                {
                  "id": "Order Online",
                  "title": "Order Online"
                }
              ]
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
              "info": {
                "id": "585068",
                "name": "Shri Anjani Veg Bhojnalaya",
                "city": "Bhopal",
                "slugs": {
                  "restaurant": "shri-anjani-veg-bhojnalaya-piplani-piplani",
                  "city": "bhopal"
                },
                "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
                "cloudinaryImageId": "db050d896c76f203d42b50936b48d339",
                "locality": "Ganesh Galaxy",
                "areaName": "Ayodhya Bypass",
                "costForTwo": "25000",
                "costForTwoMessage": "₹250 for two",
                "cuisines": ["Thalis", "Indian"],
                "avgRating": 4.2,
                "veg": true,
                "feeDetails": {
                  "restaurantId": "585068",
                  "fees": [{}]
                },
                "parentId": "350139",
                "avgRatingString": "4.2",
                "totalRatingsString": "4.6K+ ratings",
                "sla": {
                  "restaurantId": "585068",
                  "deliveryTime": 561,
                  "minDeliveryTime": 557,
                  "maxDeliveryTime": 562,
                  "lastMileTravel": 9.6,
                  "serviceability": "SERVICEABLE",
                  "stressFactor": 1,
                  "rainMode": "RAIN_MODE_NONE",
                  "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                  "zoneId": 1006,
                  "slaString": "557-562 MINS",
                  "lastMileTravelString": "9.6 km",
                  "iconType": "ICON_TYPE_EMPTY"
                },
                "availability": {
                  "visibility": true,
                  "restaurantClosedMeta": {}
                },
                "aggregatedDiscountInfo": {
                  "header": "Get items under 59",
                  "shortDescriptionList": [
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹150 off  | Use code MEGADEALS",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹150 off  | Use code MEGADEALS",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "visible": true
                },
                "badges": {},
                "slugString": "shri-anjani-veg-bhojnalaya-piplani-piplani",
                "labels": [
                  {
                    "title": "Timings",
                    "message": "null"
                  },
                  {
                    "title": "Address",
                    "message": "Airport Road, ISRO Colony, Ayodhya Nagar, Bhopal, Madhya Pradesh 462021"
                  },
                  {
                    "title": "Cuisines",
                    "message": "Thalis,Indian"
                  }
                ],
                "totalRatings": 4600,
                "aggregatedDiscountInfoV2": {
                  "header": "Get items under 59",
                  "shortDescriptionList": [
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹150 off  | Use code MEGADEALS",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "descriptionList": [
                    {
                      "meta": "99 store",
                      "discountType": "FinalPrice",
                      "operationType": "RESTAURANT"
                    },
                    {
                      "meta": "Flat ₹150 off  | Use code MEGADEALS",
                      "discountType": "Flat",
                      "operationType": "RESTAURANT"
                    }
                  ],
                  "couponDetailsCta": "View coupon details"
                },
                "type": "F",
                "nudgeBanners": [
                  {
                    "priority": 4,
                    "discountInfo": {
                      "discountType": "FinalPrice",
                      "value": 129
                    },
                    "unlockedMessage": "Deal of the Day unlocked!",
                    "minItemCount": 1,
                    "maxItemCount": 1,
                    "type": "SILD",
                    "nudgeTagInfo": {
                      "title": "Deal of the Day",
                      "fontName": "FONT_NAME_CONDENSED_BOLD"
                    },
                    "logoCtx": {},
                    "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                  }
                ],
                "headerBanner": {
                  "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/585068"
                },
                "ratingSlab": "RATING_SLAB_5",
                "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                "orderabilityCommunication": {
                  "title": {
                    "text": "Currently"
                  },
                  "subTitle": {
                    "text": "CLOSED"
                  },
                  "message": {
                    "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:00 AM",
                    "textColour": "primary"
                  },
                  "customIcon": {
                    "bgGradientColorStart": "#EB8322",
                    "bgGradientColorEnd": "#EE5803"
                  },
                  "commsStyling": {}
                },
                "cartOrderabilityNudgeBanner": {
                  "parameters": {},
                  "presentation": {}
                },
                "latLong": "23.27263776,77.46658044",
                "backgroundImageOverlayInfo": {},
                "featuredSectionInfo": {},
                "requestContexts": ["99store", "enable_ecosaver"]
              },
              "analytics": {}
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
              "layout": {
                "rows": 1,
                "columns": 5,
                "horizontalScrollEnabled": true,
                "itemSpacing": 12,
                "lineSpacing": 10,
                "widgetPadding": {},
                "containerStyle": {
                  "containerPadding": {
                    "left": 10,
                    "right": 10
                  }
                },
                "scrollBar": {
                  "scrollThumbColor": "#E46D47",
                  "scrollTrackColor": "#e4e4e4",
                  "width": 54,
                  "height": 4,
                  "scrollStyling": {
                    "padding": {
                      "top": 20,
                      "bottom": 20
                    }
                  }
                }
              },
              "id": "offerCollectionWidget",
              "gridElements": {
                "infoWithStyle": {
                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                  "offers": [
                    {
                      "info": {
                        "header": "ITEMS AT ₹59",
                        "offerTag": "DEAL OF DAY",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["08fac3f8-9189-43ff-94be-1a682b24f543"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "description": "ON SELECT ITEMS |",
                        "offerType": "offers",
                        "restId": "585068",
                        "offerLogo": "offers/deal-of-day",
                        "descriptionTextColor": "#7302060C"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹150 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["35729425-1585-4f75-a52b-ad620e5e16b1"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE MEGADEALS",
                        "description": "ABOVE ₹299",
                        "offerType": "offers",
                        "restId": "585068",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE MEGADEALS"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹200 OFF",
                        "offerTag": "FLAT DEAL",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["a624c44f-2add-4d20-83f9-f2fae2923f9f"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE FLAT200",
                        "description": "ABOVE ₹399",
                        "offerType": "offers",
                        "restId": "585068",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE FLAT200"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "FLAT ₹200 OFF",
                        "offerTag": "DEFAULT",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["c7a92548-8858-47a3-ad9d-fcd2766619b4"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE CELEBRATIONS",
                        "description": "ABOVE ₹799",
                        "offerType": "offers",
                        "restId": "585068",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE CELEBRATIONS"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    },
                    {
                      "info": {
                        "header": "BUY 1 GET 1 FREE",
                        "offerTagColor": "#E46D47",
                        "offerIds": ["b477d90f-80ef-4023-bddf-0e08ae28d11c"],
                        "expiryTime": "1970-01-01T00:00:00Z",
                        "couponCode": "USE BUY1GET1",
                        "description": "ON SELECT ITEMS",
                        "offerType": "offers",
                        "restId": "585068",
                        "offerLogo": "offers/generic",
                        "descriptionTextColor": "#7302060C",
                        "primaryDescription": "USE BUY1GET1"
                      },
                      "cta": {
                        "type": "OFFER_HALF_CARD"
                      }
                    }
                  ],
                  "habitMilestoneInfo": {
                    "callout": {}
                  },
                  "loyaltyDiscoverPresentationInfo": {
                    "logoCtx": {}
                  }
                }
              }
            }
          }
        },
        {
          "card": {
            "card": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
              "tabs": [
                {
                  "id": "REGULAR",
                  "title": "Full Menu",
                  "selected": true,
                  "analytics": {},
                  "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                  "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
                }
              ]
            }
          }
        },
        {
          "groupedCard": {
            "cardGroupMap": {
              "REGULAR": {
                "cards": [
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                        "isPureVeg": true,
                        "badges": {},
                        "vegOnlyDetails": {
                          "imageId": "AutoVegOnly_qkjowj",
                          "title": "Showing only vegetarian options.",
                          "description": "Tap on the VEG ONLY button to turn off the setting"
                        },
                        "offersFilter": {
                          "attributes": {
                            "displayText": "Buy 1 Get 1"
                          }
                        },
                        "topRatedFilter": {
                          "attributes": {
                            "displayText": "Ratings 4.0+"
                          }
                        },
                        "kidsCategoryFilter": {
                          "attributes": {
                            "displayText": "Kids Favourites",
                            "tooltip": {
                              "enabled": true,
                              "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                            }
                          }
                        },
                        "vegFilter": {
                          "attributes": {
                            "displayText": "VEG"
                          }
                        },
                        "nonvegFilter": {
                          "attributes": {
                            "displayText": "NONVEG"
                          }
                        }
                      },
                      "relevance": {
                        "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                        "sectionId": "MENU_FILTER_TOGGLE"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                        "title": "Large Order",
                        "categories": [
                          {
                            "title": "Starters",
                            "itemCards": [
                              {
                                "card": {
                                  "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                  "info": {
                                    "id": "189885790",
                                    "name": "Manchurian (Pack of 2)                       ",
                                    "category": "Large Order",
                                    "description": "Manchurian (Pack of 2)",
                                    "isVeg": 1,
                                    "price": 26600,
                                    "variants": {},
                                    "variantsV2": {},
                                    "itemAttribute": {
                                      "vegClassifier": "VEG"
                                    },
                                    "ribbon": {},
                                    "type": "ITEM",
                                    "itemBadge": {},
                                    "badgesV2": {},
                                    "ratings": {
                                      "aggregatedRating": {}
                                    },
                                    "itemPriceStrikeOff": true,
                                    "parentId": "115544407"
                                  },
                                  "analytics": {},
                                  "hideRestaurantDetails": true
                                }
                              }
                            ],
                            "subtitleSuffix": {},
                            "categoryId": "70091710"
                          }
                        ],
                        "categoryId": "70091263"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Masala Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446415",
                                "name": "Baingan Masala ",
                                "category": "Masala Item",
                                "description": "A tantalizing blend of flavors that will leave your taste buds craving for more.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/ec10f88b-4238-4c1b-96a6-c38f9fc61d86_756368aa-91c2-4726-8629-b7b5280565c5.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887618",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380528",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380530",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492441",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622171"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446431",
                                "name": "Tamatar Masala  ",
                                "category": "Masala Item",
                                "description": "A delectable and flavorsome dish bursting with rich, aromatic spices and a luscious tomato base.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/610c0068-b502-4566-9cea-51a3b97e1290_bebd08df-f31d-42be-866e-376d308aa6a0.JPG",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887634",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380561",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380562",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492623",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622260"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446417",
                                "name": "Gobi Masala   ",
                                "category": "Masala Item",
                                "description": "Gobi made in indian spices with a tinch of a tangy flavour",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887620",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380532",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380534",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492201",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622200"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446429",
                                "name": "Chana Masala                              ",
                                "category": "Masala Item",
                                "description": "Chickpeas in a spicy onion tomato masala gravy and cream",
                                "imageId": "197382e7c1ab15ebcfb760ef520b281c",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887632",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380556",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380558",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492446",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "5.0",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622180"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446433",
                                "name": "Rajma Masala ",
                                "category": "Masala Item",
                                "description": "A wholesome dish consisting of a delicious red bean gravy",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887636",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380565",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380566",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492084",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622249"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446419",
                                "name": "Bhindi Masala  ",
                                "category": "Masala Item",
                                "description": "Okra or ladyfinger fried and tossed with onion, tomotoes spices and herbs. (served for two)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/046446ab-58f9-4c6c-a407-68cb9cf975c9_7e0de74f-e564-4672-b299-4f537b670506.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887622",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380536",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380538",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492301",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "257281872",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622175"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446423",
                                "name": "Sev Masala ",
                                "category": "Masala Item",
                                "description": "A delectable and flavorful vegetable dish infused with aromatic Indian spices.",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887626",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380544",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380546",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622254"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446421",
                                "name": "Aloo Masala ",
                                "category": "Masala Item",
                                "description": "Simply spiced half-mashed potatoes and onion, glistening with fat, is a standard side dish",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/a1893b08-c4b4-4a10-aacd-df018705dd35_2d090f72-d556-472f-8f6b-0414f148a8a3.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887624",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380540",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380542",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492315",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622162"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446425",
                                "name": "Mater Masala",
                                "category": "Masala Item",
                                "description": "A flavorful and aromatic vegetable masala that will tantalize your taste buds with its rich, bold flavors.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/3c68514c-5c74-4fc3-b43c-ef52df3bfd6b_8dd011c9-5a82-45f8-973a-cdb8f0aff9ca.JPG",
                                "isVeg": 1,
                                "price": 28000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887628",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380548",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380550",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281992",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622217"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446427",
                                "name": "Palak Masala ",
                                "category": "Masala Item",
                                "description": "A flavorful and aromatic vegetable dish bursting with rich flavors and delightful spices.",
                                "imageId": "b0b09ceae5aa01c1aa9f36867cc2a92e",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887630",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380553",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380554",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257282047",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622227"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446435",
                                "name": "Simla Masala",
                                "category": "Masala Item",
                                "description": "A flavorful and aromatic dish bursting with rich Indian spices.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/2746d8b1-6348-411d-8591-b9cb26cabf9a_1e9e52da-6b5f-4556-aaec-88632d1a1aba.JPG",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887638",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380569",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380570",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281877",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622258"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/ec10f88b-4238-4c1b-96a6-c38f9fc61d86_756368aa-91c2-4726-8629-b7b5280565c5.JPG",
                        "categoryId": "25184493"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "99 Store",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "174448683",
                                "name": "Fix Thali ",
                                "category": "99 Store",
                                "description": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/b491aae2-48d3-4390-840b-57dd468badb9_43e8520c-9c10-439f-bf68-fc05a0e7d373.jpg",
                                "isVeg": 1,
                                "price": 26000,
                                "finalPrice": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492222",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "33 ratings",
                                    "ratingCountV2": "33"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "94072076-d21c-444e-9763-23889b8cfac9"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "57546893"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "178187309",
                                "name": "Aloo Paratha                             ",
                                "category": "99 Store",
                                "description": "na",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/15/72580de3-a10f-4bde-87cc-6e3cb43a8dca_49670a80-29a1-4901-aba2-e9acdca50991.jpg",
                                "isVeg": 1,
                                "price": 7000,
                                "finalPrice": 5900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "285 ratings",
                                    "ratingCountV2": "285"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "08fac3f8-9189-43ff-94be-1a682b24f543"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "54622165"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "174445963",
                                "name": "Mini Bafla thali",
                                "category": "99 Store",
                                "description": "Special Thai (Dal + Veg Sabzi + Paneer Masala + 4 Butter Roti + Raita + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/9/6f47bbee-e35d-4a2e-9e68-3dd39dbe12b1_00dc9572-7323-4eb7-a1b5-a36a75a61b8d.jpeg",
                                "isVeg": 1,
                                "price": 27500,
                                "finalPrice": 12900,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492116",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "30 ratings",
                                    "ratingCountV2": "30"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "94072076-d21c-444e-9763-23889b8cfac9"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "105615716"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/b491aae2-48d3-4390-840b-57dd468badb9_43e8520c-9c10-439f-bf68-fc05a0e7d373.jpg",
                        "categoryId": "63390971"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Thali",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446459",
                                "name": "Special Thali (Dal + Veg Sabzi + Paneer Masala  + 4 Butter Roti + Raita  + Gulab Jamun + Jeera Rice + Papad + Salad+ Achar )",
                                "category": "Thali",
                                "description": "Indulge in a flavorful journey through Thailand with this delectable veg Thali, filled with aromatic Dal, tempting Veg Sabzi, rich Paneer Masala, fluffy Butter Roti, refreshing Raita, delightful Gulab Jamun, fragrant Jeera Rice, crispy Papad, refreshing Salad, and tangy Achar.",
                                "imageId": "6cd2ae46561d8996919a496fbb9a72b4",
                                "isVeg": 1,
                                "price": 27500,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492218",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "878 ratings",
                                    "ratingCountV2": "878"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622259"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446461",
                                "name": "Fix Thali (Dal  + 1 Veg Sabzi + Jeera Rice + 4 Roti  + Raita  )",
                                "category": "Thali",
                                "description": "Indulge in this delectable Thali featuring dal, a delightful vegetable sabzi, aromatic jeera rice, soft rotis, and refreshing raita.",
                                "imageId": "d97025b289cbf239479ff6596bda05e7",
                                "isVeg": 1,
                                "price": 26000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492733",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "196 ratings",
                                    "ratingCountV2": "196"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622197"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446463",
                                "name": "Daal Bafla Thali (mini) ",
                                "category": "Thali",
                                "description": "(2 bafla  + Dal fry  + Baigan Bharta + Kadhi)",
                                "isVeg": 1,
                                "price": 27500,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492741",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "title": "Buy 1 Get 1",
                                    "textColor": "#DB6742",
                                    "backgroundColor": "#FAE8E3",
                                    "matchText": "B1G1"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "B1G1",
                                "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "48 ratings",
                                    "ratingCountV2": "48"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "b477d90f-80ef-4023-bddf-0e08ae28d11c"
                                ],
                                "parentId": "54622186"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188020358",
                                "name": "Dal Bafla Thali",
                                "category": "Thali",
                                "description": "Dal Bafla 4 pc+ Dal Fry + Kadhi + Baigan Bharta",
                                "isVeg": 1,
                                "price": 40000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398968"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188020378",
                                "name": "Mini Thali",
                                "category": "Thali",
                                "description": "Dal +2 roti+ Aloo sabji+Rice ( subject to availability)",
                                "isVeg": 1,
                                "price": 17900,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398973"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "6cd2ae46561d8996919a496fbb9a72b4",
                        "categoryId": "25184495"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Dal Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446396",
                                "name": "Daal Fry",
                                "category": "Dal Item",
                                "description": "A comforting and delicious preparation made with mixed daal cooked and tempered with onions, chillies and more in pure ghee.",
                                "imageId": "4986ebc3e4355b97c960ddc0df4bfe3f",
                                "isVeg": 1,
                                "price": 17000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887609",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380511",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9000,
                                          "id": "60380512",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492525",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "257282143",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "89 ratings",
                                    "ratingCountV2": "89"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "imageBadges": [
                                  {
                                    "imageId": "No_Sugar/Pure_ghee1.png"
                                  }
                                ],
                                "parentId": "54622187"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446398",
                                "name": "Daal Hari Mirchi ",
                                "category": "Dal Item",
                                "description": "A vibrant and flavorful lentil dish simmered with aromatic spices and fresh herbs.",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887611",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380515",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9500,
                                          "id": "60380516",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492192",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622188"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446412",
                                "name": "Daal Tadka ",
                                "category": "Dal Item",
                                "description": "All time favorite mouthwatering dal tadka and served with salad and along with pickles.(Serve 2)",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/e6719281-3575-414a-b8d8-17fad638840c_48491c67-1f7a-4a78-856d-6e95831a4ab8.JPG",
                                "isVeg": 1,
                                "price": 11000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887616",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380525",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9500,
                                          "id": "60380526",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492292",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492295",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "75 ratings",
                                    "ratingCountV2": "75"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622192"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446401",
                                "name": "Daal Hari Mirchi Butter",
                                "category": "Dal Item",
                                "description": "A flavorful and creamy lentil dish accented with fresh green chili and a touch of butter.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/c0306a37-1a59-4fc6-a36a-ad04a2f7ea22_8b4c507b-234f-42a3-9a50-1d72f70aea87.JPG",
                                "isVeg": 1,
                                "price": 15000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887612",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380517",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9750,
                                          "id": "60380518",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492059",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "7 ratings",
                                    "ratingCountV2": "7"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622189"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446404",
                                "name": "Jain Daal",
                                "category": "Dal Item",
                                "description": "A rich and flavorful lentil dish crafted with a variety of aromatic spices, delivering a delightful culinary experience.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/fe13f4db-e3b8-460e-8f53-c3094c245431_ad583c5d-6347-457a-9678-f6b50568a6f4.JPG",
                                "isVeg": 1,
                                "price": 10000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887613",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380519",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9000,
                                          "id": "60380520",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492618",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.9",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622204"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446407",
                                "name": "Daal Makhini",
                                "category": "Dal Item",
                                "description": "A delectable and creamy dal preparation that tantalizes the taste buds with its rich and flavorful blend.",
                                "imageId": "aef2e84f0d2c89088aec74e27182d852",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887614",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380521",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 9500,
                                          "id": "60380522",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257282151",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492532",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "66 ratings",
                                    "ratingCountV2": "66"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622190"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446409",
                                "name": "Daal Sada",
                                "category": "Dal Item",
                                "description": "A flavorful and comforting Dal Item that is sure to satisfy your taste buds.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/a08c0600-227f-48cd-8017-3e7996dc7e18_2feb0f6a-c078-4237-b35e-791100ade687.JPG",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887615",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380523",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380524",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492197",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622191"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "4986ebc3e4355b97c960ddc0df4bfe3f",
                        "categoryId": "25184492"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Meals And Combo",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446372",
                                "name": "Matar Paneer Combo",
                                "category": "Meals And Combo",
                                "description": "matar paneer  + 5  tawa roti or 4 tandoori",
                                "imageId": "c55b2a2169e2328a181a1c87190f4335",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887598",
                                      "name": "Choice of Roti",
                                      "variations": [
                                        {
                                          "name": "5 Tawa Roti",
                                          "default": 1,
                                          "id": "60380489",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "4 Tandoori Roti",
                                          "id": "60380490",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492410",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "86 ratings",
                                    "ratingCountV2": "86"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622216"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446376",
                                "name": "Butter Paneer Masala Combo  ",
                                "category": "Meals And Combo",
                                "description": "butter paneer masala + 5 tawa roti",
                                "imageId": "384108faea8895ee448434d39a5c4512",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492510",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "346 ratings",
                                    "ratingCountV2": "346"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622178"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446378",
                                "name": "Paneer Masala Combo",
                                "category": "Meals And Combo",
                                "description": "paneer masala  + 5 tawa roti or 4 tandoori roti",
                                "imageId": "000a9291e463465c5ff0100ab892d539",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887600",
                                      "name": "Choice of Roti",
                                      "variations": [
                                        {
                                          "name": "5 Tawa Roti",
                                          "default": 1,
                                          "id": "60380493",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "4 Tandoori Roti",
                                          "id": "60380495",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492179",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "291 ratings",
                                    "ratingCountV2": "291"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622238"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446383",
                                "name": "Sev Tamatar Combo",
                                "category": "Meals And Combo",
                                "description": "sev tamatar  + 5 tawa roti or 4 tandoori roti",
                                "imageId": "440bbb4ae51c52929915a38bc7e8762e",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887603",
                                      "name": "Choice of Roti",
                                      "variations": [
                                        {
                                          "name": "5 Tawa Roti",
                                          "default": 1,
                                          "id": "60380499",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "4 Tandoori Roti",
                                          "id": "60380500",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492283",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "73 ratings",
                                    "ratingCountV2": "73"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622255"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446387",
                                "name": "Bhindi Combo",
                                "category": "Meals And Combo",
                                "description": "bhindi masala +5 tawa roti or 4 tandoori roti",
                                "imageId": "d14920ea1971a53e27ed15b3c8273f70",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887604",
                                      "name": "Choice of Roti",
                                      "variations": [
                                        {
                                          "name": "5 Tawa Roti",
                                          "default": 1,
                                          "id": "60380501",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "4 Tandoori Roti",
                                          "id": "60380502",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492514",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622173"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446390",
                                "name": "Aloo Sabji Combo",
                                "category": "Meals And Combo",
                                "description": "aloo tamatar  + 5 tawa or 4 tandoori",
                                "imageId": "2c74849abfda767a8d1453f643891738",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887606",
                                      "name": "Choice of Roti",
                                      "variations": [
                                        {
                                          "name": "5 Tawa Roti",
                                          "default": 1,
                                          "id": "60380505",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "4 Tandoori Roti",
                                          "id": "60380506",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281785",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622167"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188019166",
                                "name": "Dum Aloo Combo",
                                "category": "Meals And Combo",
                                "description": "Dum Aloo with 4 tawa roti combo",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398969"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188019178",
                                "name": "Malai Kofta Combo",
                                "category": "Meals And Combo",
                                "description": "Malai Kofta with 4 Tawa roti combo",
                                "isVeg": 1,
                                "price": 24000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398971"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "c55b2a2169e2328a181a1c87190f4335",
                        "categoryId": "25184496"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Paneer Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446361",
                                "name": "Shahi Paneer",
                                "category": "Paneer Item",
                                "description": "Fresh cottage cheese cooked in a mild thick tomato curry.",
                                "imageId": "6eebfdc1d5abf518a6e828c5e53a1209",
                                "isVeg": 1,
                                "price": 20000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887595",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380483",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380484",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492278",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "143 ratings",
                                    "ratingCountV2": "143"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622257"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446403",
                                "name": "Paneer 65             ",
                                "category": "Paneer Item",
                                "description": "The Grilled Paneer Cubes are cooked In clay oven, Sour, Spicy masla.& Its Dry",
                                "isVeg": 1,
                                "price": 35000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622230"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446406",
                                "name": "Paneer Pasanda      ",
                                "category": "Paneer Item",
                                "description": "Paneer prepared in thick sweet gravy with veggies and cream",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257282102",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622240"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446408",
                                "name": "Paneer Makhmali",
                                "category": "Paneer Item",
                                "description": "A rich and creamy delicacy bursting with delectable flavors.",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622236"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446410",
                                "name": "Handi Paneer",
                                "category": "Paneer Item",
                                "description": "Fresh paneer and creamy gravy cooked in a handi.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/9991bef0-5e04-4aec-8d1d-d43094d4306b_14b6376e-470f-4c84-87ec-562eeea449c1.JPG",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49872477",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Serves 1",
                                          "default": 1,
                                          "id": "156432073",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Serves 2",
                                          "price": 37000,
                                          "id": "156432075",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492062",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622202"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446366",
                                "name": "Punjabi Paneer",
                                "category": "Paneer Item",
                                "description": "Mildly tangy and creamy dish of fresh paneer prepared with khoya, malai and special masala in spicy gravy",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/3/c0aa93a9-beba-4bdc-98be-78257b161362_f3a74607-18dc-408e-97f5-c605724c4344.jpg",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887596",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380485",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380486",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492397",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "118 ratings",
                                    "ratingCountV2": "118"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622247"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446371",
                                "name": "Kadai Paneer",
                                "category": "Paneer Item",
                                "description": "Cottage cheese and bell peppers cooked in a spicy masala.",
                                "imageId": "43abe2023c6f49411f43181fd3984911",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887597",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380487",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380488",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492404",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "376 ratings",
                                    "ratingCountV2": "376"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622206"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446374",
                                "name": "Butter Paneer",
                                "category": "Paneer Item",
                                "description": "Marinated paneer tossed and served in delicious spicy buttery gravy.",
                                "imageId": "c3d558f6895995358de89e285aaa8698",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887599",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380491",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380492",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492596",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "177 ratings",
                                    "ratingCountV2": "177"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622177"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446379",
                                "name": "Kaju Kari",
                                "category": "Paneer Item",
                                "description": "Roasted cashews cooked in white and cashew nut gravy, crunchiness of cashew topper and garnish with creams. Mildly sweet in taste",
                                "imageId": "e53e054f96dbee0d310238457dcb6bf1",
                                "isVeg": 1,
                                "price": 20000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887601",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380494",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380496",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492600",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "28 ratings",
                                    "ratingCountV2": "28"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622208"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446382",
                                "name": "Paneer Korma",
                                "category": "Paneer Item",
                                "description": "Korma made with nuts,seeds, coconut ,curd ,veggie even with paneer.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/ee7a8ed9-f08b-447f-960f-6704af42082f_ad104f81-b8f1-4677-b976-a016cc7c20d8.JPG",
                                "isVeg": 1,
                                "price": 20000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887602",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380497",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380498",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492183",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "40 ratings",
                                    "ratingCountV2": "40"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622234"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446385",
                                "name": "Paneer Bhurji",
                                "category": "Paneer Item",
                                "description": "Soft grated paneer cooked with onions, tomatoes and green chillies.",
                                "imageId": "45466091b606f4b1b805b27a7e2a1bba",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622232"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446388",
                                "name": "Paneer Masala",
                                "category": "Paneer Item",
                                "description": "Soft paneer soaked in a rich and creamy gravy laden with butter",
                                "imageId": "c9ff8bc2a131b616d24f7fde74307220",
                                "isVeg": 1,
                                "price": 18000,
                                "finalPrice": 9000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887605",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380503",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380504",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492416",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492418",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "156 ratings",
                                    "ratingCountV2": "156"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "offerIds": [
                                  "844407f6-2a78-40d5-b543-21e1ec64c10f"
                                ],
                                "parentId": "54622237"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446392",
                                "name": "Chole Paneer",
                                "category": "Paneer Item",
                                "description": "Aspicy & Tangy Curry Prepared Of Chana,Often Paired With Bhatoora/Poori/Rice.",
                                "isVeg": 1,
                                "price": 25000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887607",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380507",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380508",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492519",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622184"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446395",
                                "name": "Matar Paneer",
                                "category": "Paneer Item",
                                "description": "The ghar ki matter paneer in our chef's own unique way",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/e2af8bd8-e4c3-4c8a-8201-a12db8a220ca_dac85cdd-a8ef-4ab9-a1a3-b4123c7925a5.JPG",
                                "isVeg": 1,
                                "price": 25000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887608",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380509",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380510",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492607",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "257281789",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "57 ratings",
                                    "ratingCountV2": "57"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622215"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446397",
                                "name": "Palak Paneer",
                                "category": "Paneer Item",
                                "description": "Rich and thick spinach and onion gravy in aromatic herbs",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/e570966e-945b-4675-b420-d8e15d70f22d_3699c10c-1220-4a7a-a2fd-97494c68f9da.JPG",
                                "isVeg": 1,
                                "price": 25000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887610",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380513",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 12750,
                                          "id": "60380514",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492187",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "257281856",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "58 ratings",
                                    "ratingCountV2": "58"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622228"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446399",
                                "name": "Chilli Paneer",
                                "category": "Paneer Item",
                                "description": "Cubes fried cottage cheese with onion, capsicum & green chili",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622181"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446400",
                                "name": "Kaju Paneer",
                                "category": "Paneer Item",
                                "description": "Cashew and Indian cottage cheese in silky-smooth tomato-onion-cream based gravy!",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/fab1ac67-b054-498e-80aa-03c555c5c121_f2869368-a1d5-4c4f-a383-eb2da19d6b72.jpg",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492612",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622209"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446402",
                                "name": "Paneer Chatpata",
                                "category": "Paneer Item",
                                "description": "Rich And Creamy Dish Of Paneer (Cottage Cheese) mashed In a indian spices and different flavour sauces.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/ba805a45-1972-4e23-9d82-02b3e6a895a5_697a2021-e71e-4b48-a48c-43ed813dc139.JPG",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281863",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.5",
                                    "ratingCount": "3 ratings",
                                    "ratingCountV2": "3"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622233"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446405",
                                "name": "Paneer 2 Pyaza",
                                "category": "Paneer Item",
                                "description": "A rich, creamy curry of soft succulent paneer and plenty of onions in a wonderful medley of spices, herbs and tomatoes.",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492430",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.0",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622229"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "6eebfdc1d5abf518a6e828c5e53a1209",
                        "categoryId": "25184484"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Sabji Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446418",
                                "name": "Aloo Gobhi",
                                "category": "Sabji Item",
                                "description": "All time favorite mouthwatering aloo gobhi made with fresh veggies",
                                "imageId": "3f8a05c074e394d4d31746dbcacacb30",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887621",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380535",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380537",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492696",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "31 ratings",
                                    "ratingCountV2": "31"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622160"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446424",
                                "name": "Aloo Chole",
                                "category": "Sabji Item",
                                "description": "aloo chole ki sabji is one such fusion curry which has the goodness of both chickpeas and potatoes",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887627",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380547",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380549",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492072",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "12 ratings",
                                    "ratingCountV2": "12"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622158"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446428",
                                "name": "Aloo Palak",
                                "category": "Sabji Item",
                                "description": "A hearty dish with soft potato cooked in Palak puree with a flavorful masala.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/7b0cea01-24ff-4a04-8716-61d50ec31547_37ad91b4-12b3-4c7f-9966-3c831655f6b0.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887631",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380555",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380557",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492205",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622164"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446434",
                                "name": "Sev Tamater",
                                "category": "Sabji Item",
                                "description": "An authentic recipe from rajasthani cuisine prepared with gram flour dumplings simmered in spicy curd gravy, served with indian bread or rice. It is a scrumptious dish consisting of an array of aromatic spices which enhance it's rich taste.",
                                "imageId": "2820c84d306e4b0b81f885cca6c366d2",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887637",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380567",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380568",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492724",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492726",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "150 ratings",
                                    "ratingCountV2": "150"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622256"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446436",
                                "name": "Baingan Bharta",
                                "category": "Sabji Item",
                                "description": "Baingan bharta is a popular north Indian dish where fire roasted eggplant is mashed and cooked with spices. It's best served with fresh rotis",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/03df0038-bcb0-4203-b0f2-bf0bbde4699f_4b84ce98-d2ae-4680-b46d-2cf095c275d9.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887639",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380571",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380572",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492211",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622170"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446446",
                                "name": "Mix Veg",
                                "category": "Sabji Item",
                                "description": "Mix veggies cooked in a fresh and delectable tomato flavoured curry.",
                                "imageId": "cd232d6ce991b0ae14105e8fa5f5325c",
                                "isVeg": 1,
                                "price": 19000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887649",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380591",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 8000,
                                          "id": "60380592",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492318",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "257281940",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "70 ratings",
                                    "ratingCountV2": "70"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622224"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446414",
                                "name": "Aloo Mater",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic combination of tender peas and tender potatoes cooked in a mouthwatering gravy.",
                                "imageId": "9f5c1e10f7fdbc18a49268240992abaa",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887617",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380527",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380529",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492434",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622163"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446448",
                                "name": "Panjabi Chole ",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic Punjabi dish that will tantalize your taste buds and leave you craving for more.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/7157b8d0-108a-4cf5-8680-791619b5f968_8059c8f2-989f-4c57-9f88-9ccaf3229eba.JPG",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887651",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380595",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 8000,
                                          "id": "60380596",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281994",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492109",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "62 ratings",
                                    "ratingCountV2": "62"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622243"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446440",
                                "name": "Kadi Pakora",
                                "category": "Sabji Item",
                                "description": "A comforting and flavorful vegetarian curry made with fritters, perfect for a satisfying and hearty meal.",
                                "imageId": "b5a32b3bcad2180bfe4cf1801d07ad0a",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887643",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380579",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380580",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492536",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622207"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446416",
                                "name": "Aloo Jira",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic vegetable dish bursting with Indian flavors and fragrance.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/89137e33-49b7-4152-a6a0-8d8a9eeb591c_a0a80a64-94fa-4afa-a6a1-5a8b62bd2df6.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887619",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380531",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380533",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492068",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.3",
                                    "ratingCount": "15 ratings",
                                    "ratingCountV2": "15"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622161"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446420",
                                "name": "Aloo Baingan",
                                "category": "Sabji Item",
                                "description": "Delicious combination of potatoes and eggplant sauteed together to create a flavorful Indian vegetable dish.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/69df45d5-b0e8-4bf5-8ef5-5599151773a8_6896aa9a-50c7-4578-bfc6-6ceb6d2cde44.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887623",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380539",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380541",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492308",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622157"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446422",
                                "name": "Aloo Tamater",
                                "category": "Sabji Item",
                                "description": "A delectable and flavorful potato and tomato dish that will tantalize your taste buds.",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887625",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380543",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380545",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492707",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622169"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446426",
                                "name": "Aloo Fry",
                                "category": "Sabji Item",
                                "description": "An irresistible vegetable dish that is full of flavor and perfect for vegetarians, offering a delightful blend of textures and tantalizing taste.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/aaa6fdf4-2dcf-4cc3-857e-e4c1ecc43f53_d80604ea-3ac1-49fd-a70f-1315dceb773b.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887629",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380551",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380552",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622159"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446430",
                                "name": "Aloo Rajma",
                                "category": "Sabji Item",
                                "description": "A mouthwatering combination of tender kidney beans and flavorful potatoes, this classic Indian sabji item is sure to satisfy your tastebuds.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/20/84aa8517-71ca-4cac-9d1f-f294f1b0d95b_69b89923-c69d-4e4d-b438-5b138d2a1e13.JPG",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887633",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380559",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380560",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492078",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622166"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446432",
                                "name": "Aloo Simla",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic vegetable dish with a delightful combination of textures.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/2a1b97e7-dfcc-4ace-ac83-9dd5ae0a1dfe_ae3ec251-e5dd-4431-8a30-99711bc4bdb1.JPG",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887635",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380563",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "id": "60380564",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492716",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622168"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446438",
                                "name": "Bhindi Fry",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic vegetable dish that will tickle your taste buds with its tantalizing blend of flavors.",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887641",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Full",
                                          "price": 7100,
                                          "default": 1,
                                          "id": "60380576",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Half",
                                          "id": "60380575",
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257281798",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409291",
                                        "name": "Missi Roti",
                                        "price": 3500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409286",
                                        "name": "Tawa Butter Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409279",
                                        "name": "Tandoori Roti",
                                        "price": 2000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409293",
                                        "name": "Tandoori Roti Butter",
                                        "price": 2500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "26 ratings",
                                    "ratingCountV2": "26"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622174"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446442",
                                "name": "Gobi 2 Pyaza",
                                "category": "Sabji Item",
                                "description": "A flavorful and aromatic vegetable dish that celebrates the rich flavors of cauliflower in a delightful combination.",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887645",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380583",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6500,
                                          "id": "60380584",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492539",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622199"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446444",
                                "name": "Bhindi 2 Pyaza",
                                "category": "Sabji Item",
                                "description": "An aromatic and flavorful vegetable dish featuring tender okra cooked with a delightful blend of onions and tantalizing spices.",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887647",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380587",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6500,
                                          "id": "60380588",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492545",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "18 ratings",
                                    "ratingCountV2": "18"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622172"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "3f8a05c074e394d4d31746dbcacacb30",
                        "categoryId": "25184486"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Rice Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446437",
                                "name": "Sada Rice ",
                                "category": "Rice Item",
                                "description": "A delightful and flavorsome rice dish that is sure to satisfy your taste buds with its rich, aromatic essence.",
                                "imageId": "c021dbd43a20580a6b55d7c7002b09b2",
                                "isVeg": 1,
                                "price": 9000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887640",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380573",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6750,
                                          "id": "60380574",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "257282217",
                                    "groupName": "Roti",
                                    "choices": [
                                      {
                                        "id": "141409294",
                                        "name": "Tawa Roti",
                                        "price": 1500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492090",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492094",
                                    "groupName": "Papad",
                                    "choices": [
                                      {
                                        "id": "141409285",
                                        "name": "Fry Papad",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409292",
                                        "name": "Papad Dry",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622253"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446439",
                                "name": "Jeera Rice       ",
                                "category": "Rice Item",
                                "description": "Aromatic rice cooked in a tempering of cumin and whole spices.",
                                "imageId": "6c27cdf576dfee2ff7b419ceeaf139b3",
                                "isVeg": 1,
                                "price": 13000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887642",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380577",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7500,
                                          "id": "60380578",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492099",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492103",
                                    "groupName": "Papad",
                                    "choices": [
                                      {
                                        "id": "141409285",
                                        "name": "Fry Papad",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409292",
                                        "name": "Papad Dry",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "102 ratings",
                                    "ratingCountV2": "102"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622205"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446441",
                                "name": "Khichdi ",
                                "category": "Rice Item",
                                "description": "A flavorful and aromatic rice dish that is hearty and satisfying.",
                                "imageId": "221415f66366c4afb4df3f84fbb59ef8",
                                "isVeg": 1,
                                "price": 13000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887644",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380581",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7000,
                                          "id": "60380582",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "99 ratings",
                                    "ratingCountV2": "99"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622210"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446455",
                                "name": "Chole Rice ",
                                "category": "Rice Item",
                                "description": "A wholesome dish consisting of a delicious chick pea gravy served with rice - perfect to satisfy your cravings.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/27/b5d02955-a0b8-4ece-af16-3a28c9b345ba_0c4b75eb-7f4e-48fe-8379-6344aed1ed50.JPG",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887658",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380609",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 8000,
                                          "id": "60380610",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491977",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256491990",
                                    "groupName": "Papad",
                                    "choices": [
                                      {
                                        "id": "141409285",
                                        "name": "Fry Papad",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409292",
                                        "name": "Papad Dry",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "26 ratings",
                                    "ratingCountV2": "26"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622185"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446443",
                                "name": "Khichdi Butter Fry ",
                                "category": "Rice Item",
                                "description": "A flavorful and aromatic rice dish, delicately seasoned and infused with butter to create a mouthwatering symphony of flavors.",
                                "imageId": "bdebee87294aa4db2362ca4c51eb7534",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887646",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380585",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7000,
                                          "id": "60380586",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "60 ratings",
                                    "ratingCountV2": "60"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622211"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446453",
                                "name": "Veg Biryani          ",
                                "category": "Rice Item",
                                "description": "A delightfully wholesome combo of aromatic veg biryani.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/7/26/e8c7ab6d-b05a-4acd-9c4a-e033f57e5f64_43a8287f-189b-4886-bf89-93a61b72e4c9.jpg",
                                "isVeg": 1,
                                "price": 17000,
                                "finalPrice": 8000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887656",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380605",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6000,
                                          "id": "60380606",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "offerTags": [
                                  {
                                    "matchText": "SILD"
                                  }
                                ],
                                "itemBadge": {},
                                "badgesV2": {},
                                "itemNudgeType": "FinalPrice",
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "121 ratings",
                                    "ratingCountV2": "121"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "cartContext": "quick_prep",
                                "offerIds": [
                                  "c4a84e39-bbda-4541-a6ea-8c1cdb4a3cd8"
                                ],
                                "isNinetyninestoreItem": true,
                                "parentId": "54622265"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446457",
                                "name": "Rajma Rice ",
                                "category": "Rice Item",
                                "description": "Tawa- toasted, crispy and delicious dosa, folded in with masala.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/11/e2a1bda0-336d-4820-ba5c-f8507211c44d_cdf5b732-2fca-40ae-b0ea-4a6f7cdb2daf.jpg",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887660",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380613",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 7000,
                                          "id": "60380614",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491999",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409287",
                                        "name": "Aloo Chole",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912737",
                                        "name": "Butter Paneer Masala Combo",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409272",
                                        "name": "Aloo Mater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409283",
                                        "name": "Aloo Jira",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409284",
                                        "name": "Daal Fry",
                                        "price": 17000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409295",
                                        "name": "Sev Tamater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409282",
                                        "name": "Kadi Pakora",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256492014",
                                    "groupName": "Papad",
                                    "choices": [
                                      {
                                        "id": "141409285",
                                        "name": "Fry Papad",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409292",
                                        "name": "Papad Dry",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "19 ratings",
                                    "ratingCountV2": "19"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622250"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446451",
                                "name": "Matar Pulao",
                                "category": "Rice Item",
                                "description": "A delightful, savory rice dish bursting with fresh, flavorful ingredients, ideal for veggie lovers.",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887654",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380601",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6000,
                                          "id": "60380602",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491956",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409287",
                                        "name": "Aloo Chole",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912737",
                                        "name": "Butter Paneer Masala Combo",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409272",
                                        "name": "Aloo Mater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409283",
                                        "name": "Aloo Jira",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409284",
                                        "name": "Daal Fry",
                                        "price": 17000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409295",
                                        "name": "Sev Tamater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409282",
                                        "name": "Kadi Pakora",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "112780951"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446445",
                                "name": "Masala Rice",
                                "category": "Rice Item",
                                "description": "A delicious rice treat, a very fragnant and flavourful rice dish.",
                                "isVeg": 1,
                                "price": 16000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887648",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380589",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6500,
                                          "id": "60380590",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491915",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409287",
                                        "name": "Aloo Chole",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912737",
                                        "name": "Butter Paneer Masala Combo",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409272",
                                        "name": "Aloo Mater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409283",
                                        "name": "Aloo Jira",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409284",
                                        "name": "Daal Fry",
                                        "price": 17000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409295",
                                        "name": "Sev Tamater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409282",
                                        "name": "Kadi Pakora",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  },
                                  {
                                    "groupId": "256491924",
                                    "groupName": "Papad",
                                    "choices": [
                                      {
                                        "id": "141409285",
                                        "name": "Fry Papad",
                                        "price": 5000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409292",
                                        "name": "Papad Dry",
                                        "price": 4000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "4 ratings",
                                    "ratingCountV2": "4"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622214"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446447",
                                "name": "Veg Pulao",
                                "category": "Rice Item",
                                "description": "Fragmented basmati rice cooked with mix vegetables.",
                                "imageId": "6fa5a9280306841a92b47b2770be82c2",
                                "isVeg": 1,
                                "price": 17000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887650",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380593",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6000,
                                          "id": "60380594",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491930",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409287",
                                        "name": "Aloo Chole",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141948730",
                                        "name": "Aloo Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912737",
                                        "name": "Butter Paneer Masala Combo",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409272",
                                        "name": "Aloo Mater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409283",
                                        "name": "Aloo Jira",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409284",
                                        "name": "Daal Fry",
                                        "price": 17000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409295",
                                        "name": "Sev Tamater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409282",
                                        "name": "Kadi Pakora",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "9 ratings",
                                    "ratingCountV2": "9"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622266"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446449",
                                "name": "Paneer Pulao",
                                "category": "Rice Item",
                                "description": "A wholesome dish prepared by cooking green veggies and rice in a flavorful Indian masala with paneer.",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887652",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380597",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 6000,
                                          "id": "60380598",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256491940",
                                    "groupName": "Curry",
                                    "choices": [
                                      {
                                        "id": "141409276",
                                        "name": "Daal Hari Mirchi",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409287",
                                        "name": "Aloo Chole",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409288",
                                        "name": "Aloo Baingan",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409274",
                                        "name": "Daal Sada",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409297",
                                        "name": "Daal Makhini",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409278",
                                        "name": "Jain Daal",
                                        "price": 10000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409289",
                                        "name": "Daal Hari Mirchi Butter",
                                        "price": 15000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141948730",
                                        "name": "Aloo Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912735",
                                        "name": "Gobi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912734",
                                        "name": "Daal Tadka",
                                        "price": 11000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912737",
                                        "name": "Butter Paneer Masala Combo",
                                        "price": 18000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912736",
                                        "name": "Methi Malai",
                                        "price": 13000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409272",
                                        "name": "Aloo Mater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409283",
                                        "name": "Aloo Jira",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409273",
                                        "name": "Baingan Bharta",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409284",
                                        "name": "Daal Fry",
                                        "price": 17000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409295",
                                        "name": "Sev Tamater",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141912733",
                                        "name": "Bhindi Masala",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "id": "141409282",
                                        "name": "Kadi Pakora",
                                        "price": 16000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622241"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "c021dbd43a20580a6b55d7c7002b09b2",
                        "categoryId": "25184494"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Sabji Kuch Hatke",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446450",
                                "name": "Malai Kofta",
                                "category": "Sabji Kuch Hatke",
                                "description": "Tawa- toasted, crispy and delicious dosa, folded in with masala.",
                                "imageId": "15fac8db30e4bcf6b6604450dc7ec811",
                                "isVeg": 1,
                                "price": 18000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887653",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380599",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 11000,
                                          "id": "60380600",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492325",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "28 ratings",
                                    "ratingCountV2": "28"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622213"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446452",
                                "name": "Dum Aloo",
                                "category": "Sabji Kuch Hatke",
                                "description": "Rich indian spices mixed with marinated aloo in yogurt",
                                "imageId": "6870c9ffb2105540126318aab0bb3a58",
                                "isVeg": 1,
                                "price": 20000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887655",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380603",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 11000,
                                          "id": "60380604",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492629",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.4",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622193"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446454",
                                "name": "Hariyali Kofta",
                                "category": "Sabji Kuch Hatke",
                                "description": "Soft melt in the mouth paneer based dumplings prepared in rich, creamy, and nutty gravy",
                                "imageId": "9039250eeb835d3eb7e0c99072d6f7b3",
                                "isVeg": 1,
                                "price": 20000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887657",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380607",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 11000,
                                          "id": "60380608",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492632",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622203"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446456",
                                "name": "Methi Malai ",
                                "category": "Sabji Kuch Hatke",
                                "description": "Creamy and flavorful, this unique veggie dish takes your tastebuds on a delightful journey with its aromatic blend of fenugreek and creamy goodness.",
                                "imageId": "156c993c66d129f4883ca59118d8c994",
                                "isVeg": 1,
                                "price": 13000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887659",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380611",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 11000,
                                          "id": "60380612",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492549",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.8",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622220"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446458",
                                "name": "Methi Butter Malai",
                                "category": "Sabji Kuch Hatke",
                                "description": "Indulge in the rich and creamy flavors of this unique and flavorful vegetable curry.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/8a7772ce-25a8-4407-9191-ebb270c735d4_524da79b-a74d-4d74-94b1-9e4e4cc86a4c.JPG",
                                "isVeg": 1,
                                "price": 22000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17887661",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "Half",
                                          "default": 1,
                                          "id": "60380615",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Full",
                                          "price": 11000,
                                          "id": "60380616",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492333",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.7",
                                    "ratingCount": "14 ratings",
                                    "ratingCountV2": "14"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622219"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "15fac8db30e4bcf6b6604450dc7ec811",
                        "categoryId": "25184487"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Special Paneer Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446460",
                                "name": "Paneer Tikka Masala                ",
                                "category": "Special Paneer Item",
                                "description": "Cheese cubes marinated in curd,oil,lot of spices and grilled.",
                                "imageId": "ba267b2731e91b57214ae0beedb73bae",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492638",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "imageBadges": [
                                  {
                                    "imageId": "merch_bau/High%20Protein%201_1.png"
                                  }
                                ],
                                "parentId": "54622242"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446462",
                                "name": "Paneer Angara",
                                "category": "Special Paneer Item",
                                "description": "A delightfully flavor-packedPaneer Angaratossed with veggies and delectable masalas - perfect to satiate your cravings.",
                                "isVeg": 1,
                                "price": 38000,
                                "variants": {},
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492336",
                                    "groupName": "Naan",
                                    "choices": [
                                      {
                                        "id": "141409280",
                                        "name": "Naan Sada",
                                        "price": 4500,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "6 ratings",
                                    "ratingCountV2": "6"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622231"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "ba267b2731e91b57214ae0beedb73bae",
                        "categoryId": "25184488"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Snacks",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97683582",
                                "name": "Veg Hakka Noodles",
                                "category": "Snacks",
                                "description": "A satisfying and flavorful Chinese dish that showcases a delightful combination of vegetables and noodles.",
                                "imageId": "c55f9245af53731d4fb8f90c6f3ed294",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.2",
                                    "ratingCount": "77 ratings",
                                    "ratingCountV2": "77"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398978"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97683581",
                                "name": "Manchurian ",
                                "category": "Snacks",
                                "description": "A delectable Chinese delight bursting with savory flavors and enticing textures.",
                                "imageId": "80c93aeecc9a087818062f9e32cdad5b",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "17963326",
                                      "name": "Preparation type",
                                      "variations": [
                                        {
                                          "name": "Dry",
                                          "default": 1,
                                          "id": "60579357",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "Gravy",
                                          "price": 1000,
                                          "id": "60579358",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "addons": [
                                  {
                                    "groupId": "256492750",
                                    "groupName": "Noodles",
                                    "choices": [
                                      {
                                        "id": "141409299",
                                        "name": "Chaumin",
                                        "price": 14000,
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ],
                                    "maxAddons": -1,
                                    "maxFreeAddons": -1
                                  }
                                ],
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "271 ratings",
                                    "ratingCountV2": "271"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54754696"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188019204",
                                "name": "Veg Kothe",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 21000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398979"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188019208",
                                "name": "Veg Chowmein",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 14000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398977"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188019243",
                                "name": "Chilli Paneer Gravy",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 41000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398965"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188020176",
                                "name": "Poori Sabji",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 19000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398975"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188020215",
                                "name": "Chole Bhature",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 21000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398966"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188020280",
                                "name": "Chole Kucle",
                                "category": "Snacks",
                                "isVeg": 1,
                                "price": 22000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398967"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "c55f9245af53731d4fb8f90c6f3ed294",
                        "categoryId": "25273746"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Tandoor Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446375",
                                "name": "Tandoori Roti",
                                "category": "Tandoor Item",
                                "description": "Authentic Indian bread cooked in a clay oven, boasting a tantalizing aroma and a smoky flavor that will transport your taste buds to the streets of India.",
                                "imageId": "3bc160f76ad87002dc9f9c67bb1a9d6e",
                                "isVeg": 1,
                                "price": 2000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "600 ratings",
                                    "ratingCountV2": "600"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622261"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446377",
                                "name": "Tandoori Roti Butter",
                                "category": "Tandoor Item",
                                "description": "Delight in the delectable flavors of a buttered Tandoori Roti straight from the tandoor oven.",
                                "imageId": "44f79c1a8b2982de2ea243b2c8feedbd",
                                "isVeg": 1,
                                "price": 2500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "193 ratings",
                                    "ratingCountV2": "193"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622262"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446380",
                                "name": "Missi Roti",
                                "category": "Tandoor Item",
                                "description": "A flavorful and aromatic tandoor delight that will transport your taste buds to culinary bliss.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/9f8a5ea5-4f49-4eb3-8241-dc862d647d0f_1e97585d-78d9-49db-842b-838bd8bd4734.JPG",
                                "isVeg": 1,
                                "price": 3500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.7",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622222"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446381",
                                "name": "Missi Roti Butter",
                                "category": "Tandoor Item",
                                "description": "Flaky and crispy bread with a delightful buttery flavor straight from the tandoor.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/20/6b425cde-101a-453d-b835-608d6eb9e06c_fe459336-bd99-4931-bfab-a627f7e7278d.JPG",
                                "isVeg": 1,
                                "price": 4000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "33 ratings",
                                    "ratingCountV2": "33"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622223"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446384",
                                "name": "Lacha Paratha",
                                "category": "Tandoor Item",
                                "description": "Flaky and buttery, this tandoor delight is a must-try for all veggie lovers!",
                                "imageId": "f59567eaad1a59231094c8a16b5565dc",
                                "isVeg": 1,
                                "price": 5000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "84 ratings",
                                    "ratingCountV2": "84"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622212"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446386",
                                "name": "Naan Sada",
                                "category": "Tandoor Item",
                                "description": "A delightful and delectable vegetarian tandoor item that will satisfy your cravings.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/21/425599c1-2417-438b-bba5-cbdb336495ba_5020d016-702f-4458-9caf-5cd1f1c17964.JPG",
                                "isVeg": 1,
                                "price": 4500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.9",
                                    "ratingCount": "20 ratings",
                                    "ratingCountV2": "20"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622226"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446389",
                                "name": "Naan Butter",
                                "category": "Tandoor Item",
                                "description": "Deliciously buttery.",
                                "imageId": "8a18485d158e7d0a703ebdb62866b6d2",
                                "isVeg": 1,
                                "price": 5000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "127 ratings",
                                    "ratingCountV2": "127"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622225"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "3bc160f76ad87002dc9f9c67bb1a9d6e",
                        "categoryId": "25184490"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Breads",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446467",
                                "name": "Tawa Roti",
                                "category": "Breads",
                                "description": "A mouthwatering vegetarian delight prepared on a hot tawa, offering a delectable taste of Indian flavors.",
                                "imageId": "cb33c539c450dc8f36f22897a82e9280",
                                "isVeg": 1,
                                "price": 1500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.3",
                                    "ratingCount": "901 ratings",
                                    "ratingCountV2": "901"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622264"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446468",
                                "name": "Tawa Butter Roti",
                                "category": "Breads",
                                "description": "A delectable and flavorful Indian bread cooked on a hot griddle, perfect for a wholesome and satisfying meal.",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/fb639ea1-70b7-4798-b502-ec900ebadbc9_928ec4f3-6fd0-446c-91ca-ceacdb257d74.JPG",
                                "isVeg": 1,
                                "price": 2000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.4",
                                    "ratingCount": "168 ratings",
                                    "ratingCountV2": "168"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622263"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446469",
                                "name": "Sada Paratha ",
                                "category": "Breads",
                                "description": "A delectable Indian flatbread cooked on a griddle, prepared with simplicity and love.",
                                "imageId": "0cedbf4155cb0dc3b39d33c105469c8a",
                                "isVeg": 1,
                                "price": 3500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "87 ratings",
                                    "ratingCountV2": "87"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622252"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "187987791",
                                "name": "Gobi Paratha",
                                "category": "Breads",
                                "description": "serve 1",
                                "isVeg": 1,
                                "price": 6000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622201"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446470",
                                "name": "Aloo Paratha",
                                "category": "Breads",
                                "description": "Generously stuffed aloo and pyaz paratha served with raita, salad and pickle.",
                                "imageId": "12756ee40f94f21fe6eae3108f59a118",
                                "isVeg": 1,
                                "price": 7000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "285 ratings",
                                    "ratingCountV2": "285"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622165"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446365",
                                "name": "Paneer Paratha                 ",
                                "category": "Breads",
                                "description": "Soft and fluffy flatbread with a mashed paneer and spices stuffing",
                                "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/23/b2603340-bea7-4a32-bd6c-c4bca1c52754_3ec17d88-b74c-4611-b765-379b59cea934.JPG",
                                "isVeg": 1,
                                "price": 7500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "69 ratings",
                                    "ratingCountV2": "69"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622239"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446368",
                                "name": "Extra Bafla",
                                "category": "Breads",
                                "description": "A flavorful and delectable veg tawa item, Extra Bafla is a culinary delight that will tantalize your taste buds.",
                                "isVeg": 1,
                                "price": 5000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.0",
                                    "ratingCount": "13 ratings",
                                    "ratingCountV2": "13"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622194"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446370",
                                "name": "Extra Kulcha",
                                "category": "Breads",
                                "description": "A flavorful and savory vegetarian delight straight from the tawa, tempting you with its unique kulcha goodness.",
                                "isVeg": 1,
                                "price": 5000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.5",
                                    "ratingCount": "27 ratings",
                                    "ratingCountV2": "27"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622196"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446373",
                                "name": "Extra Bhature",
                                "category": "Breads",
                                "description": "Crispy and fluffy, Extra Bhature is a delightful tawa item that will leave you craving for more.",
                                "isVeg": 1,
                                "price": 3500,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.8",
                                    "ratingCount": "23 ratings",
                                    "ratingCountV2": "23"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622195"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "cb33c539c450dc8f36f22897a82e9280",
                        "categoryId": "25184489"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Papad Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446391",
                                "name": "Papad Dry",
                                "category": "Papad Item",
                                "description": "A delectable and crispy delight that perfectly complements any meal.",
                                "isVeg": 1,
                                "price": 4000,
                                "variants": {
                                  "variantGroups": [
                                    {
                                      "groupId": "49872482",
                                      "name": "Quantity",
                                      "variations": [
                                        {
                                          "name": "1 Piece",
                                          "default": 1,
                                          "id": "156432084",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "name": "2 Piece",
                                          "price": 3000,
                                          "id": "156432085",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ]
                                    }
                                  ]
                                },
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.9",
                                    "ratingCount": "21 ratings",
                                    "ratingCountV2": "21"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622244"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446393",
                                "name": "Fry Papad",
                                "category": "Papad Item",
                                "description": "Crispy and flavorful, a scrumptious papad dish that will leave you craving for more.",
                                "isVeg": 1,
                                "price": 5000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "2.6",
                                    "ratingCount": "5 ratings",
                                    "ratingCountV2": "5"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#FFF0CD", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_low",
                                    "ratingTextColor": "rating_low",
                                    "ratingCountTextColor": "rating_low",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622198"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "188018356",
                                "name": "Masala Papad",
                                "category": "Papad Item",
                                "isVeg": 1,
                                "price": 8000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {}
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "114398972"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "categoryId": "25184491"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                        "title": "Dahi Item",
                        "itemCards": [
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446411",
                                "name": "Boondi Ka Raita",
                                "category": "Dahi Item",
                                "description": "Creamy yogurt-based dish with crispy gram flour dumplings.",
                                "imageId": "7dd5517ca27c19d21bf78163b1b41f78",
                                "isVeg": 1,
                                "price": 15000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "3.1",
                                    "ratingCount": "11 ratings",
                                    "ratingCountV2": "11"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#D9EFEC", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_medium",
                                    "ratingTextColor": "rating_medium",
                                    "ratingCountTextColor": "rating_medium",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622176"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          },
                          {
                            "card": {
                              "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                              "info": {
                                "id": "97446413",
                                "name": "Chach",
                                "category": "Dahi Item",
                                "description": "A refreshing and tangy yogurt-based delight that will tantalize your taste buds.",
                                "imageId": "25405842d880c04cdcbee12e853c5331",
                                "isVeg": 1,
                                "price": 4000,
                                "variants": {},
                                "variantsV2": {},
                                "itemAttribute": {
                                  "vegClassifier": "VEG"
                                },
                                "ribbon": {},
                                "type": "ITEM",
                                "itemBadge": {},
                                "badgesV2": {},
                                "ratings": {
                                  "aggregatedRating": {
                                    "rating": "4.1",
                                    "ratingCount": "312 ratings",
                                    "ratingCountV2": "312"
                                  },
                                  "ratingsPresentationConfig": {
                                    "bgGradient": {
                                      "colours": ["#C8F9E5", "#00FFFFFF"],
                                      "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                    },
                                    "ratingIconColor": "rating_very_good",
                                    "ratingTextColor": "rating_very_good",
                                    "ratingCountTextColor": "rating_very_good",
                                    "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                    "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                  }
                                },
                                "itemPriceStrikeOff": true,
                                "parentId": "54622179"
                              },
                              "analytics": {},
                              "hideRestaurantDetails": true
                            }
                          }
                        ],
                        "subtitleSuffix": {},
                        "image": "7dd5517ca27c19d21bf78163b1b41f78",
                        "categoryId": "25184485"
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                        "type": "FSSAI",
                        "imageId": "fssai_final_edss9i",
                        "text": ["License No. 21422010002481"]
                      }
                    }
                  },
                  {
                    "card": {
                      "card": {
                        "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                        "name": "Shri Anjani Veg Bhojnalaya",
                        "area": "Ayodhya Bypass",
                        "completeAddress": "Airport Road, ISRO Colony, Ayodhya Nagar, Bhopal, Madhya Pradesh 462021"
                      }
                    }
                  }
                ]
              }
            }
          }
        }
      ],
      "firstOffsetRequest": true,
      "isQCLink": false
    },
    "tid": "a59701c9-dde2-4154-88f8-bda181ef4a9a",
    "sid": "oypb8c8d-8070-405e-a530-033ed6c04ab4",
    "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
    "csrfToken": "Wfp3sGgfioLm-_xY8dUkiZTwb2Kr0x6chCfP8Vkg"
  },

  "253997":{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "McDonald's",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              },
              {
                "id": "Dineout",
                "title": "Dineout",
                "cta": "https://swiggy.com/menu/253997/dineout"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "253997",
              "name": "McDonald's",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "mcdonalds-mp-bhopal-mp-nagar",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/9/45ffb1eb-e956-4664-b1c1-59a029abccce_253997.JPG",
              "locality": "Arera Hills",
              "areaName": "Maharana Pratap Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "American"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "253997",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "630",
              "avgRatingString": "4.3",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "253997",
                "deliveryTime": 45,
                "minDeliveryTime": 40,
                "maxDeliveryTime": 50,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 698,
                "slaString": "40-50 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-08 00:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 49",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 49",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "25% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 49",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "25% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "mcdonalds-mp-bhopal-mp-nagar",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Mp Bhopal Db Mall,  Shop No. R2, 3Rd Floor. D.B City Mall, Opp. M.P. Nagar, Arera Hills, Bhopal- 462011"
                },
                {
                  "title": "Cuisines",
                  "message": "American"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 49",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 49",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "25% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 49",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "25% off",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ]
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 7,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 359
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/253997"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {

                      }
                    },
                    "linkCta": {

                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.23327709,77.43006725",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 3,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹49",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "38b7547b-558d-4051-b7b2-f39f126da3dd"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "253997",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 25% OFF",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "f2dc9cc3-e6e4-4c1a-81e7-3960003ee759"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "253997",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "NO CODE REQUIRED"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "253997",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "Offer"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7830865",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "   Cheesy Mushroom",
                          "description": "   ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "189235979",
                              "name": "   Cheesy Mushroom",
                              "category": "Signature Collection By McDonald's",
                              "description": "Protein bun, with rich and crusty cheesy Mushroom patty, topped with Italian sauce served with Gherkin slices, Cheddar cheese patty and crisp iceberg lettuce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/96952440-3983-4e8d-bcef-018c3bb1904f_f510e6aa-2442-4ba9-bfa8-6dfecdb1cb90.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928057",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928058",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "114930709"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7830386",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "  EVM Cheesy Mushroom",
                          "description": "   ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "189235981",
                              "name": "  EVM Cheesy Mushroom",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/ad956dd0-3a54-4721-875b-fcb3978e199e_b5aff320-9e6b-40a7-8a3e-2cdc44b0e8c8.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928064",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928065",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928066",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605753",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605755",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928067",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928068",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "142605756",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605759",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "114930712"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7831153",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "   Cheesy Chicken",
                          "description": "   ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "189235983",
                              "name": "   Cheesy Chicken",
                              "category": "Signature Collection By McDonald's",
                              "description": " Protein Bun with Chicken Flame Grilled Patty & Egg Patty topped with fresh and premium ingredients such as Gherkin slices,Cheese and crunchy lettuce, dressed with Hebanarro Mayo.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/e3281369-0aa8-4ec1-b04d-600985e47e3d_baaa2722-633e-4b0a-8129-aac0496cf013.png",
                              "inStock": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928075",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928076",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "114930707"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7830583",
                          "creativeId": "TopPicks/PrDiGiftHamper",
                          "title": "   EVM Cheesy Chicken",
                          "description": "   ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "189235985",
                              "name": "   EVM Cheesy Chicken",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/29195563-4f76-4565-9980-89e3b57cf0f8_d5679915-22f7-487d-b76c-ac98900e2047.png",
                              "inStock": 1,
                              "price": 41300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928082",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928083",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928084",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605758",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605757",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928085",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928086",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "142605752",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605754",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "114930711"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5192152",
                          "creativeId": "TopPicks2024/171724178E.png",
                          "title": "Tandoori Chicken Wrap Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "171724178",
                              "name": "Tandoori Chicken Wrap Meal",
                              "category": "Deal Of The Day",
                              "imageId": "8318530be40be4ef88d21d005e598630",
                              "inStock": 1,
                              "price": 29000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125750",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464191",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464192",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378851",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378796",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "103683276"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Signature Collection By McDonald's",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235979",
                              "name": "   Cheesy Mushroom",
                              "category": "Signature Collection By McDonald's",
                              "description": "Protein bun, with rich and crusty cheesy Mushroom patty, topped with Italian sauce served with Gherkin slices, Cheddar cheese patty and crisp iceberg lettuce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/96952440-3983-4e8d-bcef-018c3bb1904f_f510e6aa-2442-4ba9-bfa8-6dfecdb1cb90.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928057",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928058",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930709"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235980",
                              "name": "  Cheesy Mushroom VM",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/9039b8b8-7521-44fc-ae75-a302c48ce42e_260e2e87-e675-42ef-a168-f263fec96f11.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928059",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928060",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928061",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605753",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605755",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928062",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928063",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "142605756",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605759",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930710"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235981",
                              "name": "  EVM Cheesy Mushroom",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/ad956dd0-3a54-4721-875b-fcb3978e199e_b5aff320-9e6b-40a7-8a3e-2cdc44b0e8c8.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928064",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928065",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928066",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605753",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605755",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928067",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928068",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "142605756",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605759",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930712"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235982",
                              "name": "Large EVM Cheesy Mushroom",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/fa9955b8-67ac-4966-8d99-4638b19711c2_201ffe55-01c8-40f4-963d-3e7442940d65.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 43700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928069",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928070",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928071",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928072",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605755",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605753",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928073",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928074",
                                  "groupName": "Extra for    Cheesy Mushroom",
                                  "choices": [
                                    {
                                      "id": "142605756",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605759",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930714"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235983",
                              "name": "   Cheesy Chicken",
                              "category": "Signature Collection By McDonald's",
                              "description": " Protein Bun with Chicken Flame Grilled Patty & Egg Patty topped with fresh and premium ingredients such as Gherkin slices,Cheese and crunchy lettuce, dressed with Hebanarro Mayo.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/e3281369-0aa8-4ec1-b04d-600985e47e3d_baaa2722-633e-4b0a-8129-aac0496cf013.png",
                              "inStock": 1,
                              "price": 27500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928075",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928076",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930707"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235984",
                              "name": "   Cheesy Chicken VM",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/bf510611-307e-4c29-a94e-e0c626c45421_b14466b8-880a-4b96-95ab-f114ae9ea6ec.png",
                              "inStock": 1,
                              "price": 38400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928077",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928078",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928079",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605758",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605757",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928080",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928081",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "142605752",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605754",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930708"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235985",
                              "name": "   EVM Cheesy Chicken",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/29195563-4f76-4565-9980-89e3b57cf0f8_d5679915-22f7-487d-b76c-ac98900e2047.png",
                              "inStock": 1,
                              "price": 41300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928082",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928083",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928084",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605758",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605757",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928085",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928086",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "142605752",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605754",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930711"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "189235986",
                              "name": "Large EVM Cheesy Chicken",
                              "category": "Signature Collection By McDonald's",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/34b159b0-98f2-42e7-93f3-0fdd28c39aa9_54d9e456-c7d4-47cf-9a95-208797c69687.png",
                              "inStock": 1,
                              "price": 43700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928087",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928088",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928089",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928090",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142605757",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605758",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928091",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928092",
                                  "groupName": "Extra for    Cheesy Chicken",
                                  "choices": [
                                    {
                                      "id": "142605752",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142605754",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "114930713"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/11/96952440-3983-4e8d-bcef-018c3bb1904f_f510e6aa-2442-4ba9-bfa8-6dfecdb1cb90.png",
                      "categoryId": "69825809"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Deal Of The Day",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938215",
                              "name": "McSpicy Paneer Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/d3dea0ef-02f6-406c-a043-98c6b1792031_4bb66b95-0270-4645-98a7-ac3994b06ccb.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37000,
                              "finalPrice": 25900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068949",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463894",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463895",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378864",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378873",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "06f2db11-81aa-4596-bf83-cc445d25043d"
                              ],
                              "parentId": "30080490"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938216",
                              "name": "Crispy Veggie Burger Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/118969ce-7198-4dcc-8004-985db238acb2_d6613ba1-a670-4295-bca9-7d787847eede.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37200,
                              "finalPrice": 24100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068952",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464202",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464203",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378802",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378931",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "42aef7ee-c2dc-414c-b795-c0c112d028f1"
                              ],
                              "parentId": "110437395"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938217",
                              "name": "Veg MahaMac Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/b3d4c9c6-813a-4c66-a2a5-d0792f84921f_fc21a995-9fa2-46b5-a21b-e500935413c9.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41300,
                              "finalPrice": 33000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068955",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463721",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463722",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378890",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378834",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "7943459b-3bcf-402e-92a1-399e2f01e361"
                              ],
                              "parentId": "110437397"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938218",
                              "name": "McSpicy Chicken Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/5ad866b3-673d-4114-bcf1-3f9ceb6e31e2_6953495d-21b7-4344-bea9-7e435e1e1de6.png",
                              "inStock": 1,
                              "price": 37700,
                              "finalPrice": 28200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068958",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463468",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463469",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378878",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378854",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "d32612d9-2041-403a-ae5e-cb2fafed5db3"
                              ],
                              "parentId": "30080445"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938219",
                              "name": "Chicken MahaMac Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/1f94ae94-6f75-4f26-8833-74d2f7bab54d_74ddf728-0439-4a1f-af8f-21b9f82f1956.png",
                              "inStock": 1,
                              "price": 42300,
                              "finalPrice": 35900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068961",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464177",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464178",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378912",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378801",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "a9940b31-2236-4e24-bbaa-3a09f93f0798"
                              ],
                              "parentId": "110437394"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938220",
                              "name": "McCrispy Chicken Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/cc563e7e-b894-4e28-9606-850968f94a8e_7effec7e-6809-499c-ba02-1b5a2b9da551.png",
                              "inStock": 1,
                              "price": 39400,
                              "finalPrice": 33500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068964",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463335",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463337",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378831",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378825",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "15% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "b4239e81-dbb5-4d2a-b631-9c3af1a4b45d"
                              ],
                              "parentId": "110437396"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938221",
                              "name": "Filet o Fish Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/1a961a7d-b44b-4925-81f6-8b9ea4f41746_99a7faba-ecf4-485a-8d14-de9cdd851e23.png",
                              "inStock": 1,
                              "price": 37000,
                              "finalPrice": 27800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068967",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463475",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463477",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378836",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378891",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "25% OFF",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "CouponlessSild",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "f2dc9cc3-e6e4-4c1a-81e7-3960003ee759"
                              ],
                              "parentId": "30079799"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724174",
                              "name": "Aloo Wrap Meal",
                              "category": "Deal Of The Day",
                              "imageId": "1c5ff48d1aa4cd315745ca7fdf3519f2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125738",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463313",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463315",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378868",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378939",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "103517728"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724175",
                              "name": "McVeggie Meal",
                              "category": "Deal Of The Day",
                              "imageId": "yowiha1jthhpjafnnqld",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125741",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464160",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464161",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378817",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378799",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080548"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166505533",
                              "name": "McAloo Tikki Meal",
                              "category": "Deal Of The Day",
                              "imageId": "qjacrl5imzdgvbfecjf1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23400,
                              "finalPrice": 11700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "215650325",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463977",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463979",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378852",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378824",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "249 ratings",
                                  "ratingCountV2": "249"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "f2bf2a47-e352-4cae-8706-daf13ca9bb37"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "30080206"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166505534",
                              "name": "Veg Surprise Meal",
                              "category": "Deal Of The Day",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/6/718ec660-e3e5-42e2-9ba1-310d8281d5c9_21f6c83b-2daa-4401-8e53-03b18e4657da.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "215650327",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463374",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463375",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378866",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378835",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "100083695"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457704",
                              "name": "Pizza McPuff®",
                              "category": "Deal Of The Day",
                              "description": "Blend of assorted vegetables [carrot, beans, capsicum, onion and green peas], mozzarella cheese mixed with tomato sauce and exotic spices stuffed in rectangle shaped savoury dough",
                              "imageId": "w9fphivfbl55zzbm8lxd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5500,
                              "finalPrice": 4900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "935 ratings",
                                  "ratingCountV2": "935"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "38b7547b-558d-4051-b7b2-f39f126da3dd"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "30080709"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724176",
                              "name": "Chicken McGrill Meal",
                              "category": "Deal Of The Day",
                              "imageId": "hvqfaosliamvgscaqstj",
                              "inStock": 1,
                              "price": 28200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125744",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463726",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463728",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378886",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378926",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "103517729"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724177",
                              "name": "McChicken Meal",
                              "category": "Deal Of The Day",
                              "imageId": "rphagkrvp9rntb3nusdz",
                              "inStock": 1,
                              "price": 32700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125747",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463754",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463757",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378811",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378849",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080288"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724178",
                              "name": "Tandoori Chicken Wrap Meal",
                              "category": "Deal Of The Day",
                              "imageId": "8318530be40be4ef88d21d005e598630",
                              "inStock": 1,
                              "price": 29000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "221125750",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464191",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464192",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378851",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378796",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "103683276"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "166505536",
                              "name": "McEgg Meal",
                              "category": "Deal Of The Day",
                              "imageId": "k33isy2arro5etraswap",
                              "inStock": 1,
                              "price": 24400,
                              "finalPrice": 12200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "215650328",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463733",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378798",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378905",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463734",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378944",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378846",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "f0ef3c2f-f8c9-4b8e-88b1-d7024a6ac479"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "30080322"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/9/11/d3dea0ef-02f6-406c-a043-98c6b1792031_4bb66b95-0270-4645-98a7-ac3994b06ccb.png",
                      "categoryId": "59738424"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Protein Burgers Menu",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089902",
                              "name": "Large EVM McAloo Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/48611254-3c48-43f9-aafc-be01285be6f5_e715bbd1-7ed3-4209-9ea0-e990415ca532.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536913",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536914",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536915",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536916",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526108",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526094",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536917",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536918",
                                  "groupName": "Extra for     McAloo Tikki Protein Burger® ",
                                  "choices": [
                                    {
                                      "id": "143526102",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526121",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066523"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089903",
                              "name": "    EVM McAloo Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/598f3713-7b5b-4296-8c6f-82440ff2130b_950fc808-f426-489b-bf7b-bc5be1beb9be.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536919",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536920",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536921",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526094",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526108",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536922",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536923",
                                  "groupName": "Extra for     McAloo Tikki Protein Burger® ",
                                  "choices": [
                                    {
                                      "id": "143526102",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526121",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066513"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089904",
                              "name": "  McAloo Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536924",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536925",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536926",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526094",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526108",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536927",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536928",
                                  "groupName": "Extra for     McAloo Tikki Protein Burger® ",
                                  "choices": [
                                    {
                                      "id": "143526102",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526121",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066530"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089905",
                              "name": "    McAloo Tikki Protein Burger® ",
                              "category": "Protein Burgers Menu",
                              "description": "A tikki delight: Potato and peas patty topped with veg sauce, ketchup, tomatoes and onions with Proteinbuns",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/df3fc2c1-3970-44bb-9b79-acd8ffa36dd9_00331f07-d77b-41a9-b0b9-115b2045ab22.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536929",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536930",
                                  "groupName": "Extra for     McAloo Tikki Protein Burger® ",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066531"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089906",
                              "name": "Large EVM Veg Surprise Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/c3886455-af07-4e77-9c15-63275b1ba985_b6de3100-4a22-4aa2-b82e-2846f5b2b3a2.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536931",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536932",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536933",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536934",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526140",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526100",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536935",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536936",
                                  "groupName": "Extra for    Veg Surprise Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526130",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526122",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526097",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066529"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089907",
                              "name": "  EVM Veg Surprise Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/13bf562f-3344-4f35-88b7-b4c163aa94c7_d16ff993-3421-4b2e-942a-560f671fb665.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536937",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536938",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536939",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526100",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526140",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536940",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536941",
                                  "groupName": "Extra for    Veg Surprise Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526122",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526097",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526130",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066519"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089908",
                              "name": "   Veg Surprise Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536942",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536943",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536944",
                                  "groupName": "   Addon Waffle Cone",
                                  "choices": [
                                    {
                                      "id": "143526106",
                                      "name": "No ADD ON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526117",
                                      "name": "  Vanila Mini Waffle Cone*",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526131",
                                      "name": "  Choco Mini Waffle Cone*",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526114",
                                      "name": "  Butterscotch Mini Waffle Cone*",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526112",
                                      "name": "  Mango Mini Waffle Cone*",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536945",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526100",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526140",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536946",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536947",
                                  "groupName": "Extra for    Veg Surprise Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526122",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526097",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526130",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066543"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089909",
                              "name": "   Veg Surprise Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "A surprise that will leave you wide-eyed. A scrumptious potato patty topped with a delectable Italian herb sauce and shredded onions placed between perfectly toasted buns.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/b63f1490-e85c-462a-b392-bd536abfc7e1_df613558-f245-4503-958a-91f942c4b7ab.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536948",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536949",
                                  "groupName": "Extra for    Veg Surprise Protein Burger",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748777",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066542"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089910",
                              "name": "Large EVM McVeggie Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/fa3796f9-1160-4a5c-a344-ede98d5b023f_abc56627-2641-424e-b472-7f4392ef01d0.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536950",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536951",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536952",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536953",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526107",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526123",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536954",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536955",
                                  "groupName": "Extra for    McVeggie Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526138",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526143",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526104",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066528"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089911",
                              "name": "  EVM McVeggie Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/2c444278-af27-46d0-ad7d-eef0a7f286a3_52ac190f-ffc5-44b3-a02c-0e8f38c38948.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536956",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536957",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536958",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526107",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526123",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536959",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536960",
                                  "groupName": "Extra for    McVeggie Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526143",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526104",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526138",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066518"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089912",
                              "name": "    McVeggie Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536961",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536962",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536963",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526107",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526123",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536964",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536965",
                                  "groupName": "Extra for    McVeggie Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526143",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526104",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526138",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066541"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089913",
                              "name": "   McVeggie Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "A patty made of potatoes, peas, carrots, beans, onions, red capsicum and a selection of Indian spices, topped with crispy lettuce, mayonnaise, packed into sesame toasted buns.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/bb95e143-72c9-4407-8bcb-5d4b918bbcd7_378d65c7-248f-4299-bd3b-ae0ecf7078f4.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536966",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536967",
                                  "groupName": "Extra for    McVeggie Protein Burger",
                                  "choices": [
                                    {
                                      "id": "130453409",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066540"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089914",
                              "name": "Large EVM McSpicy Paneer Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/cc5e864b-fd0d-4786-bb20-703c80e74140_ae288677-4a80-43a0-a0f9-40ec75adf066.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536968",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536969",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536970",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536971",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526134",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526095",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536972",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536973",
                                  "groupName": "Extra for     McSpicy® Paneer Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526135",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526124",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526120",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066527"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089915",
                              "name": "     EVM McSpicy Paneer Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/3936cc21-fba5-45aa-a52d-8a74b9714d7a_b0f2d6fd-b091-4ed3-b6df-ffaa387c2c8a.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536974",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536975",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536976",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526095",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526134",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536977",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536978",
                                  "groupName": "Extra for     McSpicy® Paneer Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526120",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526124",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526135",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066517"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089916",
                              "name": "   McSpicy Paneer Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536979",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536980",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536981",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526095",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526134",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536982",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536983",
                                  "groupName": "Extra for     McSpicy® Paneer Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526120",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526124",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526135",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066539"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089917",
                              "name": "    McSpicy® Paneer Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "Crispy and spicy paneer patty with creamy tandoori sauce and crispy lettuce topping.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/9ac3c940-86a4-45c7-a708-b2590f7a367c_45cacbe8-aa2a-477f-b3e4-a57c17c0c4ff.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536984",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536985",
                                  "groupName": "Extra for     McSpicy® Paneer Protein Burger",
                                  "choices": [
                                    {
                                      "id": "130453349",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066538"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089918",
                              "name": "Large EVM Crispy Veg Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/a9424e8a-91f0-4ad1-be84-5e02f0e13213_9d9cff46-5bf1-4fc4-aec5-2b130941f1ff.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536986",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536987",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536988",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536989",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526118",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526125",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536990",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536991",
                                  "groupName": "Extra for   Crispy Veg Protein Burger*",
                                  "choices": [
                                    {
                                      "id": "143526101",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526098",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526109",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066522"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089919",
                              "name": "  EVM Crispy Veg Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/9b8842c0-96c7-4d0e-9e9e-18373c19e441_067c212b-43ab-44a6-bd63-9392d3b4f1ef.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536992",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536993",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536994",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526118",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526125",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536995",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266536996",
                                  "groupName": "Extra for   Crispy Veg Protein Burger*",
                                  "choices": [
                                    {
                                      "id": "143526098",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526101",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526109",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066512"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089920",
                              "name": "    Crispy Veg Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266536997",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536998",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266536999",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526118",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526125",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537000",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537001",
                                  "groupName": "Extra for   Crispy Veg Protein Burger*",
                                  "choices": [
                                    {
                                      "id": "143526098",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526101",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526109",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066509"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089921",
                              "name": "  Crispy Veg Protein Burger*",
                              "category": "Protein Burgers Menu",
                              "description": "A crunchy patty made from a blend of 7 exotic veggies, topped with crisp lettuce and a tangy cocktail sauce, all nestled in soft, glazed potato buns. A delightful mix of bold flavours and ultimate satisfaction in every bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/5b7cc449-4f04-4832-98b5-0b395109c1c0_f4d65979-906d-4b15-9504-f8b7fdf440a7.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537002",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537003",
                                  "groupName": "Extra for   Crispy Veg Protein Burger*",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "127915311",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066508"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089922",
                              "name": "Large EVM Butter Paneer Grilled Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/e3e03982-3b0b-43d9-a938-7adf4dd787a2_69e1ae96-9107-4fc8-adfa-20a49854658c.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537004",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537005",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537006",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537007",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526099",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526142",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537008",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537009",
                                  "groupName": "Extra for    Butter Paneer Grilled Protein",
                                  "choices": [
                                    {
                                      "id": "143526137",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526127",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526110",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066520"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089923",
                              "name": "  EVM Butter Paneer Grilled Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/5dd13450-722d-4cb4-a418-8dcb3f047d92_6bfddb14-1f61-44b6-8d08-dafc37ba6cca.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537010",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537011",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537012",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526142",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526099",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537013",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537014",
                                  "groupName": "Extra for    Butter Paneer Grilled Protein",
                                  "choices": [
                                    {
                                      "id": "143526110",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526137",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526127",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066510"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089924",
                              "name": "   Butter Paneer Grilled Protein",
                              "category": "Protein Burgers Menu",
                              "description": "Mildly spiced grilled paneer patty topped with makhani sauce and shredded onions placed between freshly toasted sesame seeded buns",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/27ad3741-ecdd-42df-9511-ff479bf0db85_68c93876-2a8d-4798-b506-d198414086e1.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537015",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537016",
                                  "groupName": "Extra for    Butter Paneer Grilled Protein",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453327",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066505"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089925",
                              "name": "Large EVM McChicken Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/8c3d8881-aa90-470a-8d32-698b30f8e098_51abf492-e914-4bf6-85c7-31bf210fbab6.png",
                              "inStock": 1,
                              "price": 33400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537017",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537018",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537019",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537020",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526119",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526113",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537021",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537022",
                                  "groupName": "Extra for     McChicken® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526093",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526105",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526115",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066524"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089926",
                              "name": "   EVM McChicken Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/51bfad2f-ce94-4432-b102-f5f14e8cfc41_2ba009b7-96f6-4504-84f7-cb25edcef008.png",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537023",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537024",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537025",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526113",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526119",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537026",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537027",
                                  "groupName": "Extra for     McChicken® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526115",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526093",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526105",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066514"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089927",
                              "name": "  McChicken Protein  VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "price": 24200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537028",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537029",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537030",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526113",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526119",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537031",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537032",
                                  "groupName": "Extra for     McChicken® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526115",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526093",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526105",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066533"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089928",
                              "name": "    McChicken® Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "Delightfully crispy chicken sandwich with a crispy chicken patty topped with mayonnaise and shredded iceberg lettuce served on a perfectly toasty bun.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/bc2dd460-32b9-4856-bd93-4c987d76eb67_37e3b306-4052-4009-8230-ed0a008c5d4a.png",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537033",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537034",
                                  "groupName": "Extra for     McChicken® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "130453470",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066532"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089929",
                              "name": "Large EVM McEgg Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/b0448f94-bd0a-4718-b228-ac9629de1a44_bb135d49-e278-4e50-a97e-ec159a603a81.png",
                              "inStock": 1,
                              "price": 25200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537035",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537036",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537037",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537038",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526144",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526103",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537039",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537040",
                                  "groupName": "Extra for     McEgg® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526136",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526145",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066525"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089930",
                              "name": "   EVM McEgg Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/378f5973-8459-44d9-918a-53e403370fe1_ca70bf42-cf88-4276-be08-56ea09849923.png",
                              "inStock": 1,
                              "price": 22800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537041",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537042",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537043",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526144",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526103",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537044",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537045",
                                  "groupName": "Extra for     McEgg® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526136",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526145",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066515"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089931",
                              "name": "   McEgg Protein  VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537046",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537047",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537048",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526144",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526103",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537049",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537050",
                                  "groupName": "Extra for     McEgg® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526136",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526145",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066535"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089932",
                              "name": "    McEgg® Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "An Egg lover's delight! A unique combination of perfectly steamed egg, classic mayonnaise and chopped onions with a sprinkling of magic masala sandwiched in a toasted bun.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/9be87aea-cd6b-4e1f-be95-f64891f3d839_4a66fa34-6702-4add-85a3-9d1387874329.png",
                              "inStock": 1,
                              "price": 9700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537051",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537052",
                                  "groupName": "Extra for     McEgg® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066534"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089933",
                              "name": "Large EVM McSpicy Chicken Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/5050081c-c89a-48f9-8869-95a770772bd1_b32e6525-fb32-4eaf-9730-e02ffc2b19ab.png",
                              "inStock": 1,
                              "price": 39700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537053",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537054",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537055",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537056",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526096",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526116",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537057",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537058",
                                  "groupName": "Extra for   McSpicy® Chicken Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526128",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526141",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526129",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066526"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089934",
                              "name": "   EVM McSpicy Chicken Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/aa53b3cc-2f2f-4982-bf95-186e385fe174_a1029ca2-3cea-4159-998a-26dcb0875b82.png",
                              "inStock": 1,
                              "price": 37300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537059",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537060",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537061",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526096",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526116",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537062",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537063",
                                  "groupName": "Extra for   McSpicy® Chicken Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526128",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526129",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526141",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066516"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089935",
                              "name": "      McSpicy Chicken Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "price": 30400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537064",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537065",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537066",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526096",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526116",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537067",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537068",
                                  "groupName": "Extra for   McSpicy® Chicken Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526128",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526129",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526141",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066537"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089936",
                              "name": "  McSpicy® Chicken Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "Juicy Chicken meat coated in crispy batter with a kick of spice topped with a creamy sauce and crispy lettuce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/2a6be87d-1b7f-4fa3-9a37-ffee15ff0181_67c55923-77b4-4664-8a8d-4f66358cc846.png",
                              "inStock": 1,
                              "price": 23000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537069",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537070",
                                  "groupName": "Extra for   McSpicy® Chicken Protein Burger",
                                  "choices": [
                                    {
                                      "id": "119748924",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066536"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089937",
                              "name": "Large EVM Chicken McGrill Protein Burger",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/92e9dea0-fc14-46ee-9dc7-1584e2cfd498_aa308de2-b3cd-43ee-97e3-481b7291a52f.png",
                              "inStock": 1,
                              "price": 30100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537071",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537072",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537073",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537074",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526132",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526139",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537075",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537076",
                                  "groupName": "Extra for     Chicken McGrill® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526133",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526126",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526111",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066521"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089938",
                              "name": "   EVM Chicken McGrill Protein",
                              "category": "Protein Burgers Menu",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/d5a84635-4e0b-4229-92a5-b2170b060b11_a6a73dd2-c064-4b6c-9b85-7c569ae2f724.png",
                              "inStock": 1,
                              "price": 27700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537077",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537078",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537079",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526139",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526132",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537080",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537081",
                                  "groupName": "Extra for     Chicken McGrill® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526111",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526126",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526133",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066511"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089939",
                              "name": "    Chicken McGrill Protein VM",
                              "category": "Protein Burgers Menu",
                              "inStock": 1,
                              "price": 20600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537082",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537083",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537084",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "143526139",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526132",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537085",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "266537086",
                                  "groupName": "Extra for     Chicken McGrill® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "143526111",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526126",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "143526133",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066507"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "191089940",
                              "name": "    Chicken McGrill® Protein Burger",
                              "category": "Protein Burgers Menu",
                              "description": "Grilled chicken patty served with freshly toasted bun, tomatoes, onions and cool mint sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/a96082bd-5295-466f-97d6-eb4d32930fe2_364a5a8e-8516-4017-b678-65d38817c566.png",
                              "inStock": 1,
                              "price": 13500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537087",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537088",
                                  "groupName": "Extra for     Chicken McGrill® Protein Burger",
                                  "choices": [
                                    {
                                      "id": "119748907",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "116066506"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/12/31/48611254-3c48-43f9-aafc-be01285be6f5_e715bbd1-7ed3-4209-9ea0-e990415ca532.png",
                      "categoryId": "70631843"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McCrispy Range",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895007",
                              "name": " Crispy Veggie Burger*",
                              "category": "McCrispy Range",
                              "description": "A crunchy patty made from a blend of 7 exotic veggies, topped with crisp lettuce and a tangy cocktail sauce, all nestled in soft, glazed potato buns. A delightful mix of bold flavours and ultimate satisfaction in every bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/2b9de8bf-4151-4b7a-873e-f8da1b2f08ca_27f46a38-9b46-45f8-a094-98624968aca7.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928093",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928094",
                                  "groupName": "Extra for  Crispy Veggie Burger*",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "127915311",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "89667056"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895008",
                              "name": " EVM Crispy Veggie*",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/714a8f45-5e5f-493f-b9da-b9dbe003d058_486b2810-7188-4469-b420-1d56eb47d638.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625218",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625219",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464162",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378898",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378911",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464163",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625222",
                                  "groupName": "Extra for  Crispy Veggie Burger*",
                                  "choices": [
                                    {
                                      "id": "127915317",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453366",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190563",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453390",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91653065"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895010",
                              "name": "Large Crispy Veggie*",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/19c59881-08f6-4d5e-985f-13536fce0338_432c8f29-a3b8-4a0e-95cf-758eede91625.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625223",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463427",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463428",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463429",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378898",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378911",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625227",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625228",
                                  "groupName": "Extra for  Crispy Veggie Burger*",
                                  "choices": [
                                    {
                                      "id": "130453390",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453366",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190563",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "127915317",
                                      "name": "Add Crispy Veggie Patty*",
                                      "price": 11300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91653069"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895006",
                              "name": " McCrispy® Chicken* ",
                              "category": "McCrispy Range",
                              "description": "Delightfully crispy chicken sandwich with a crispy chicken patty topped with mayonnaise and shredded iceberg lettuce served on a perfectly toasty bun.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/0e6c0852-d701-4836-b495-1b9e3521f71d_fc363684-ae50-47f9-b2f8-2d15b71b6054.png",
                              "inStock": 1,
                              "price": 21800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928095",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928096",
                                  "groupName": "Extra for  McCrispy® Chicken* ",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "127915313",
                                      "name": "Add McCrispy Chicken* Patty",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91653073"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895009",
                              "name": " EVM McCrispy® Chicken*",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/779a757e-046e-4e70-825b-9ab83a6dbd16_c2e432dd-c959-422c-9b91-fa43c1880c26.png",
                              "inStock": 1,
                              "price": 35700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625229",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625230",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463291",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378876",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378862",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463293",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625233",
                                  "groupName": "Extra for  McCrispy® Chicken* ",
                                  "choices": [
                                    {
                                      "id": "127915324",
                                      "name": "Add McCrispy Chicken* Patty",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453321",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453353",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91653067"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895011",
                              "name": "Large EVM McCrispy® Chicken",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/a02baae7-6330-42e7-91fa-82558145fe79_5beca3c2-9919-41ce-90a3-7276a87b4494.png",
                              "inStock": 1,
                              "price": 38300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625236",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463810",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378876",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378862",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463811",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463812",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625240",
                                  "groupName": "Extra for  McCrispy® Chicken* ",
                                  "choices": [
                                    {
                                      "id": "130453353",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453321",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "127915324",
                                      "name": "Add McCrispy Chicken* Patty",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625241",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91653071"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895014",
                              "name": "Crispy Veggie Double patty Burger",
                              "category": "McCrispy Range",
                              "description": "A crunchy patty made from a blend of 7 exotic veggies, topped with crisp lettuce and a tangy cocktail sauce, all nestled in soft, glazed potato buns. A delightful mix of bold flavours and ultimate satisfaction in every bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/a7200275-16dc-4bfc-813d-b0c987e7a666_7e7177a0-0d99-4a6c-b760-464982a17ea3.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463555",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625243",
                                  "groupName": "Extra for Crispy Veggie Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653064"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895013",
                              "name": "EVM Crispy Veggie Double patty Burger ",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/0d0d50cc-6c86-4798-8eaa-a88866e712ec_6c822451-490d-47cc-a362-eb42d7261b68.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 44700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625244",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625245",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464087",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378807",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378810",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464088",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625248",
                                  "groupName": "Extra for Crispy Veggie Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453355",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453407",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190568",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653066"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895012",
                              "name": "Large EVM Crispy Veggie Double patty Burger ",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/23/3c57c3ad-e074-4b3d-9eab-1e0c1627cde1_0ccfae10-b8e1-425b-a8f2-2e99d7fa985d.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625249",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463686",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463688",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463690",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378807",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378810",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625253",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625254",
                                  "groupName": "Extra for Crispy Veggie Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453355",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453407",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190568",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653070"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895017",
                              "name": "McCrispy® Chicken Double patty Burger",
                              "category": "McCrispy Range",
                              "description": "A golden, crispy chicken fillet made from whole muscle, paired with fresh lettuce and creamy ranch, all inside soft, glazed potato buns. Packed with bold flavours and pure satisfaction in every bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/26/388c40ac-04b2-48fa-bdfd-4063a0f5e294_086fae9f-1805-4c91-a286-c0d27d20324b.png",
                              "inStock": 1,
                              "price": 33200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464159",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625256",
                                  "groupName": "Extra for McCrispy® Chicken Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653074"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895016",
                              "name": "EVM   McCrispy® Chicken Double patty Burger ",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/26/302b73ee-4a5f-4ad1-803f-d33862468892_9b477839-37a1-4afc-b3f9-8ae84b4d5428.png",
                              "inStock": 1,
                              "price": 47000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625257",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625258",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463407",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378877",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378907",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463409",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625261",
                                  "groupName": "Extra for McCrispy® Chicken Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453354",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453396",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653068"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "153895015",
                              "name": "Large EVM  McCrispy® Chicken  Double patty Burger ",
                              "category": "McCrispy Range",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/26/e0ef4df1-88b0-44ba-87ec-66c1447e33b5_3df9a5e1-0eae-4d8b-950a-24f47d012e09.png",
                              "inStock": 1,
                              "price": 49700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "187625262",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463521",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463522",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463523",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378907",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378877",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "187625266",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "187625267",
                                  "groupName": "Extra for McCrispy® Chicken Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453354",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453396",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "91653072"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/4/2b9de8bf-4151-4b7a-873e-f8da1b2f08ca_27f46a38-9b46-45f8-a094-98624968aca7.png",
                      "categoryId": "55518103"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sharing Meal",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457235",
                              "name": "Spicy Paneer/Spicy Chicken Wrap(Any 2)+1 Med. Fries+2  Puff",
                              "category": "Sharing Meal",
                              "imageId": "pttteiblrrc0pmg8crpk",
                              "inStock": 1,
                              "price": 63500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928097",
                                  "groupName": "Premium - McSpicy Wrap 1/2",
                                  "choices": [
                                    {
                                      "id": "115222063",
                                      "name": "Big Spicy Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222116",
                                      "name": "Big Spicy Paneer Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928098",
                                  "groupName": "Premium - McSpicy Wrap 2/2",
                                  "choices": [
                                    {
                                      "id": "115221882",
                                      "name": "Big Spicy Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222100",
                                      "name": "Big Spicy Paneer Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928099",
                                  "groupName": "Addon Drinks",
                                  "choices": [
                                    {
                                      "id": "115221980",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222058",
                                      "name": "Small Coke ® X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222202",
                                      "name": "Small Fanta X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221887",
                                      "name": "Small Sprite X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928100",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928101",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378883",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378869",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928102",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378932",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378858",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928103",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005760"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457238",
                              "name": "MaharajMac Veg/MaharajMac Chicken(Any Two)+1 Medium Fries+2 ",
                              "category": "Sharing Meal",
                              "imageId": "iiumwsbahfytibujpll7",
                              "inStock": 1,
                              "price": 62700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928104",
                                  "groupName": "Premium - Maharaja Mac 1/2",
                                  "choices": [
                                    {
                                      "id": "115221971",
                                      "name": "Veg Maharaja Mac",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221951",
                                      "name": "Chicken Maharaja Mac®",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928105",
                                  "groupName": "Premium - Maharaja Mac 2/2",
                                  "choices": [
                                    {
                                      "id": "115221919",
                                      "name": "Veg Maharaja Mac",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222022",
                                      "name": "Chicken Maharaja Mac®",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928106",
                                  "groupName": "Addon Drinks",
                                  "choices": [
                                    {
                                      "id": "115221980",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222058",
                                      "name": "Small Coke ® X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222202",
                                      "name": "Small Fanta X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221887",
                                      "name": "Small Sprite X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928107",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928108",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378893",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378897",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928109",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378885",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378815",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928110",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005733"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457243",
                              "name": "Spicy Paneer/Spicy Chicken Burger(Any 2)+1 Med Fries+2 Puff",
                              "category": "Sharing Meal",
                              "imageId": "a6abr4enf0zkz6snuytu",
                              "inStock": 1,
                              "price": 54800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928111",
                                  "groupName": "Premium - McSpicy Burger 1/2",
                                  "choices": [
                                    {
                                      "id": "115222039",
                                      "name": "McSpicy® Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221874",
                                      "name": "McSpicy® Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928112",
                                  "groupName": "Premium - McSpicy Burger 2/2",
                                  "choices": [
                                    {
                                      "id": "115222044",
                                      "name": "McSpicy® Chicken",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221912",
                                      "name": "McSpicy® Paneer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928113",
                                  "groupName": "Addon Drinks",
                                  "choices": [
                                    {
                                      "id": "115221980",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222058",
                                      "name": "Small Coke ® X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222202",
                                      "name": "Small Fanta X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221887",
                                      "name": "Small Sprite X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928114",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928115",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378837",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378842",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928116",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378797",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378908",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928117",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005759"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457247",
                              "name": "McVeggie/McChicken(Any Two)+1 Medium Fries+2 McPuff",
                              "category": "Sharing Meal",
                              "imageId": "q2znpbxvoyetwyysryxc",
                              "inStock": 1,
                              "price": 42000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928118",
                                  "groupName": "BCV Meal Burger 1/2",
                                  "choices": [
                                    {
                                      "id": "115221973",
                                      "name": "McVeggie Burger®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222101",
                                      "name": "McChicken®",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928119",
                                  "groupName": "BCV Meal Burger 2/2",
                                  "choices": [
                                    {
                                      "id": "115221881",
                                      "name": "McVeggie Burger®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222197",
                                      "name": "McChicken®",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928120",
                                  "groupName": "Addon Drinks",
                                  "choices": [
                                    {
                                      "id": "115221980",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222058",
                                      "name": "Small Coke ® X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222202",
                                      "name": "Small Fanta X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221887",
                                      "name": "Small Sprite X 2 Qty",
                                      "price": 15800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928121",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928122",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378857",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378943",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928123",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378915",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378910",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928124",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005742"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737253",
                              "name": " Match Night  Combo-veg",
                              "category": "Sharing Meal",
                              "imageId": "261596602f0339dd265e54351c9f03ca",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928125",
                                  "groupName": "Select Drink 1/2",
                                  "choices": [
                                    {
                                      "id": "115221862",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222178",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221905",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928126",
                                  "groupName": "Select Drink 2/2",
                                  "choices": [
                                    {
                                      "id": "115221952",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221947",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222168",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928127",
                                  "groupName": "Addon Puff 1/2",
                                  "choices": [
                                    {
                                      "id": "115222111",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453454",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928128",
                                  "groupName": "Addon Puff 2/2",
                                  "choices": [
                                    {
                                      "id": "115222033",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453460",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928129",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928130",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378816",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378902",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928131",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928132",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453376",
                                      "name": "Add Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091198"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737254",
                              "name": " Cricket wali Party  Combo-veg",
                              "category": "Sharing Meal",
                              "imageId": "8c932f5b9bb2e5a7861a9e7b5eb7720d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928133",
                                  "groupName": "Select Drink 1/3",
                                  "choices": [
                                    {
                                      "id": "115222078",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221953",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221946",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928134",
                                  "groupName": "Select Drink 2/3",
                                  "choices": [
                                    {
                                      "id": "115222008",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221904",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222122",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928135",
                                  "groupName": "Select Drink 3/3",
                                  "choices": [
                                    {
                                      "id": "115222117",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221999",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222084",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928136",
                                  "groupName": "Addon Puff 1/3",
                                  "choices": [
                                    {
                                      "id": "115221865",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453331",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928137",
                                  "groupName": "Addon Puff 2/3",
                                  "choices": [
                                    {
                                      "id": "115222011",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453426",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928138",
                                  "groupName": "Addon Puff 3/3",
                                  "choices": [
                                    {
                                      "id": "115221914",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453405",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928139",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928140",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378816",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378902",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928141",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677026",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222123",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 4600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928142",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453429",
                                      "name": "Add Cheese",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091194"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737255",
                              "name": " House Party wali  Meal-veg",
                              "category": "Sharing Meal",
                              "imageId": "f219b710ba408f0e18b7af03af8b0012",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928143",
                                  "groupName": "Select Drink 1/4",
                                  "choices": [
                                    {
                                      "id": "115221883",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222171",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221893",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928144",
                                  "groupName": "Select Drink 2/4",
                                  "choices": [
                                    {
                                      "id": "115222056",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221990",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221894",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928145",
                                  "groupName": "Select Drink 3/4",
                                  "choices": [
                                    {
                                      "id": "115222066",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221899",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222095",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928146",
                                  "groupName": "Select Drink 4/4",
                                  "choices": [
                                    {
                                      "id": "115222163",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221965",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222198",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928147",
                                  "groupName": "Addon Puff 1/4",
                                  "choices": [
                                    {
                                      "id": "115222146",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453439",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928148",
                                  "groupName": "Addon Puff 2/4",
                                  "choices": [
                                    {
                                      "id": "115221976",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453394",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928149",
                                  "groupName": "Addon Puff 3/4",
                                  "choices": [
                                    {
                                      "id": "115222073",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453364",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928150",
                                  "groupName": "Addon Puff 4/4",
                                  "choices": [
                                    {
                                      "id": "115222071",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453377",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928151",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928152",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378816",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378902",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928153",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677026",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222123",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 4600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928154",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453432",
                                      "name": "Add Cheese",
                                      "price": 11600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091196"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737256",
                              "name": " Match Night  Combo-Non-veg",
                              "category": "Sharing Meal",
                              "imageId": "f493363f64077d54c76a2bc11730d313",
                              "inStock": 1,
                              "price": 51900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928155",
                                  "groupName": "Select Value Wrap 1/3",
                                  "choices": [
                                    {
                                      "id": "115222174",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222017",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928156",
                                  "groupName": "Select Value Wrap 2/3",
                                  "choices": [
                                    {
                                      "id": "115222057",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222191",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928157",
                                  "groupName": "Select Value Wrap 3/3",
                                  "choices": [
                                    {
                                      "id": "115222093",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222024",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928158",
                                  "groupName": "Select Drink 1/3",
                                  "choices": [
                                    {
                                      "id": "115222078",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221953",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221946",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928159",
                                  "groupName": "Select Drink 2/3",
                                  "choices": [
                                    {
                                      "id": "115222008",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221904",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222122",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928160",
                                  "groupName": "Select Drink 3/3",
                                  "choices": [
                                    {
                                      "id": "115222117",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221999",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222084",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928161",
                                  "groupName": "Addon Puff 1/3",
                                  "choices": [
                                    {
                                      "id": "115221865",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453331",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928162",
                                  "groupName": "Addon Puff 2/3",
                                  "choices": [
                                    {
                                      "id": "115222011",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453426",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928163",
                                  "groupName": "Addon Puff 3/3",
                                  "choices": [
                                    {
                                      "id": "115221914",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453405",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928164",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928165",
                                  "groupName": " Ketchup  Choice 1/3",
                                  "choices": [
                                    {
                                      "id": "142378895",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378805",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928166",
                                  "groupName": " Ketchup  Choice 2/3",
                                  "choices": [
                                    {
                                      "id": "142378925",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378848",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928167",
                                  "groupName": " Ketchup  Choice 3/3",
                                  "choices": [
                                    {
                                      "id": "142378945",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378896",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928168",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677026",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222123",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 4600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091197"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737257",
                              "name": " Cricket Wali Party  Combo-Non -veg",
                              "category": "Sharing Meal",
                              "imageId": "fd09306e9e59de6f2eca376d809f9638",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928169",
                                  "groupName": "Select Value Wrap 1/2",
                                  "choices": [
                                    {
                                      "id": "115222012",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221927",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928170",
                                  "groupName": "Select Value Wrap 2/2",
                                  "choices": [
                                    {
                                      "id": "115222064",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222144",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928171",
                                  "groupName": "Select Drink 1/2",
                                  "choices": [
                                    {
                                      "id": "115221862",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222178",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221905",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928172",
                                  "groupName": "Select Drink 2/2",
                                  "choices": [
                                    {
                                      "id": "115221952",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221947",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222168",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928173",
                                  "groupName": "Addon Puff 1/2",
                                  "choices": [
                                    {
                                      "id": "115222111",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453454",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928174",
                                  "groupName": "Addon Puff 2/2",
                                  "choices": [
                                    {
                                      "id": "115222033",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453460",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928175",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928176",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378933",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378934",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928177",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378942",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378888",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928178",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677007",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222141",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091193"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737258",
                              "name": " House Party wali   Meal-Non-veg",
                              "category": "Sharing Meal",
                              "imageId": "7337121dc9eea62d9cfb727746a9528a",
                              "inStock": 1,
                              "price": 64900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "261928179",
                                  "groupName": "Select Value Wrap 1/4",
                                  "choices": [
                                    {
                                      "id": "115221902",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222079",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928180",
                                  "groupName": "Select Value Wrap 2/4",
                                  "choices": [
                                    {
                                      "id": "115221956",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221991",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928181",
                                  "groupName": "Select Value Wrap 3/4",
                                  "choices": [
                                    {
                                      "id": "115222085",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222156",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928182",
                                  "groupName": "Select Value Wrap 4/4",
                                  "choices": [
                                    {
                                      "id": "115222052",
                                      "name": "Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221992",
                                      "name": "Tandoori Chicken Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928183",
                                  "groupName": "Select Drink 1/4",
                                  "choices": [
                                    {
                                      "id": "115221883",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222171",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221893",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928184",
                                  "groupName": "Select Drink 2/4",
                                  "choices": [
                                    {
                                      "id": "115222056",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221990",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221894",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928185",
                                  "groupName": "Select Drink 3/4",
                                  "choices": [
                                    {
                                      "id": "115222066",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221899",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222095",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928186",
                                  "groupName": "Select Drink 4/4",
                                  "choices": [
                                    {
                                      "id": "115222163",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221965",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222198",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928187",
                                  "groupName": "Addon Puff 1/4",
                                  "choices": [
                                    {
                                      "id": "115222146",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453439",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928188",
                                  "groupName": "Addon Puff 2/4",
                                  "choices": [
                                    {
                                      "id": "115221976",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453394",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928189",
                                  "groupName": "Addon Puff 3/4",
                                  "choices": [
                                    {
                                      "id": "115222073",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453364",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928190",
                                  "groupName": "Addon Puff 4/4",
                                  "choices": [
                                    {
                                      "id": "115222071",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453377",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928191",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378860",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378847",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "261928192",
                                  "groupName": " Ketchup  Choice 1/4",
                                  "choices": [
                                    {
                                      "id": "142378949",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378920",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928193",
                                  "groupName": " Ketchup  Choice 2/4",
                                  "choices": [
                                    {
                                      "id": "142378929",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378903",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928194",
                                  "groupName": " Ketchup  Choice 3/4",
                                  "choices": [
                                    {
                                      "id": "142378818",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378814",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928195",
                                  "groupName": " Ketchup  Choice 4/4",
                                  "choices": [
                                    {
                                      "id": "142378832",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378867",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "261928196",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677026",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222123",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 4600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "80091195"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "pttteiblrrc0pmg8crpk",
                      "categoryId": "69825810"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Menu Starts @125/-",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "139766830",
                              "name": "McVeggie Burger+ Small Fries+Small Coke+McPuff",
                              "category": "Menu Starts @125/-",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/11/41a4b8dc-4f0f-4a96-a420-6871f09235c2_67e053a0-e833-4928-95b7-375713df6243.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "197559131",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463330",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378922",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378914",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463331",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378913",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378808",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559134",
                                  "groupName": "Extra for McVeggie Burger®",
                                  "choices": [
                                    {
                                      "id": "130453338",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044513",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453346",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453467",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011635",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453462",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "197559135",
                                  "groupName": "Extra for Small Fries",
                                  "choices": [
                                    {
                                      "id": "132827377",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827379",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "82271487"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "139766831",
                              "name": "McChicken Burger+Small Fries +Small Coke+McPuff",
                              "category": "Menu Starts @125/-",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/11/85976806-e9c4-4212-b3aa-4db4a923a7c3_630a15df-8aa6-4d1e-857c-dfb6a55ade43.png",
                              "inStock": 1,
                              "price": 23700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "197559136",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463857",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378827",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378800",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463858",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378913",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378808",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559139",
                                  "groupName": "Extra for McChicken®",
                                  "choices": [
                                    {
                                      "id": "142044487",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453395",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453424",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453435",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011639",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453309",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "197559140",
                                  "groupName": "Extra for Small Fries",
                                  "choices": [
                                    {
                                      "id": "132827377",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827379",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "82271486"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132470893",
                              "name": "McAloo Tikki+Small Fries+Small drink+McPuff",
                              "category": "Menu Starts @125/-",
                              "imageId": "befe665d4e3a53a7c0457b86d3639f76",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "197559141",
                                  "groupName": "Drink",
                                  "choices": [
                                    {
                                      "id": "132827384",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827378",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827382",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464139",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378821",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378901",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464140",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378913",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378808",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559144",
                                  "groupName": "Extra for McAloo Tikki Burger  ®",
                                  "choices": [
                                    {
                                      "id": "130453308",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190561",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453359",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748826",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428427",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453400",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "197559145",
                                  "groupName": "Extra for Small Fries",
                                  "choices": [
                                    {
                                      "id": "132827377",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "132827379",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "559 ratings",
                                  "ratingCountV2": "559"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "77567078"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132470904",
                              "name": "McAloo Tikki+Small Coke",
                              "category": "Menu Starts @125/-",
                              "imageId": "5a64912a4a299d7f8f84e15b33a0dc44",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464153",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378821",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378901",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559153",
                                  "groupName": "Extra for McAloo Tikki Burger  ®",
                                  "choices": [
                                    {
                                      "id": "130453308",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190561",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453359",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748826",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428427",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453400",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "197559154",
                                  "groupName": "Extra for Small  Coke  ®",
                                  "choices": [
                                    {
                                      "id": "132827381",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "77567076"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132470902",
                              "name": "VegSurprise+McPuff",
                              "category": "Menu Starts @125/-",
                              "imageId": "05d21acd60425a2822f425ed9bd84636",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464174",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378826",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378927",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559156",
                                  "groupName": "Extra for Veg-Surprise Burger*",
                                  "choices": [
                                    {
                                      "id": "130453319",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190567",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748819",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453397",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428433",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453433",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "77567086"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132470901",
                              "name": "McAloo Tikki+McPuff",
                              "category": "Menu Starts @125/-",
                              "imageId": "ab0583cd7df4453c6d59b2fae068f4a7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463284",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378821",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378901",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559158",
                                  "groupName": "Extra for McAloo Tikki Burger  ®",
                                  "choices": [
                                    {
                                      "id": "130453308",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190561",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453359",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748826",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428427",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453400",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "77567074"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132470896",
                              "name": "McEgg+Puff",
                              "category": "Menu Starts @125/-",
                              "inStock": 1,
                              "price": 11100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464111",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378919",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378820",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "197559160",
                                  "groupName": "Extra for McEgg®",
                                  "choices": [
                                    {
                                      "id": "130453459",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190562",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453456",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453445",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428428",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "77567081"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/5/11/41a4b8dc-4f0f-4a96-a420-6871f09235c2_67e053a0-e833-4928-95b7-375713df6243.png",
                      "categoryId": "57576770"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "No Deal Like McDeal",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "171724179",
                              "name": " Chicken Puff 1+1*",
                              "category": "No Deal Like McDeal",
                              "description": "Blend of assorted chicken, mozzarella cheese mixed with tomato sauce and exotic spices stuffed in rectangle shaped savoury dough",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/15/674199b8-0976-4968-b58a-19de40a49513_534d87da-3212-4665-bca3-bf9f1d0e5f0e.png",
                              "inStock": 1,
                              "price": 13600,
                              "finalPrice": 11700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "f2bf2a47-e352-4cae-8706-daf13ca9bb37"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "103517730"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115798768",
                              "name": "VM McChicken®",
                              "category": "No Deal Like McDeal",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/a51e49b8-9404-48e6-b239-6fe05a13be5f_8ce37256-7945-4426-a56e-418ebae40053.png",
                              "inStock": 1,
                              "price": 23400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "161703125",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703126",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "130453474",
                                      "name": "Cold Coffee - Reusable Bottle",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222059",
                                      "name": "Small Coke - Reusable Bottle",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221940",
                                      "name": "Small Fanta - Reusable Bottle",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221954",
                                      "name": "Small Sprite - Reusable Bottle",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703127",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703128",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464184",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378827",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378800",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464185",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "161703132",
                                  "groupName": "Extra for McChicken®",
                                  "choices": [
                                    {
                                      "id": "142044487",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453395",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453424",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453435",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011639",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453309",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "64808281"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396383",
                              "name": "Egg Wrap VM",
                              "category": "No Deal Like McDeal",
                              "imageId": "bde4a78f0931d7ce4e4ab22b2157f1a9",
                              "inStock": 1,
                              "price": 16700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "161703157",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703158",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453418",
                                      "name": "McFlavor- Fries (Reg.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748888",
                                      "name": "Small-Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703159",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "161703160",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464189",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378863",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378871",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464190",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378881",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378833",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "161703164",
                                  "groupName": "Extra for Egg Wrap",
                                  "choices": [
                                    {
                                      "id": "130453450",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "73845688"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938222",
                              "name": " Veg 4Pc Meal*",
                              "category": "No Deal Like McDeal",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/27/941c4c96-636e-454d-8e07-6db736777ee4_47e4a5ce-8ba4-4c69-aa65-3ed0643d167e.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068975",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "242068976",
                                  "groupName": "Veg Burger Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "139511623",
                                      "name": "McAloo Tikki Burger  ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511625",
                                      "name": "Veg-Surprise Burger*",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "242068977",
                                  "groupName": "Veg Burger Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "139511619",
                                      "name": "Veg-Surprise Burger*",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511618",
                                      "name": "McAloo Tikki Burger  ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464151",
                                  "groupName": " Ketchup  Choice 1/2",
                                  "choices": [
                                    {
                                      "id": "142378946",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378916",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "260464152",
                                  "groupName": " Ketchup  Choice 2/2",
                                  "choices": [
                                    {
                                      "id": "142378906",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378899",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "109044840"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "181938223",
                              "name": " Non-Veg 4Pc Meal*",
                              "category": "No Deal Like McDeal",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/27/905c4922-975f-410a-a81d-ebe67ac20819_6b4971e3-dd59-4de2-99b3-28e997d77a3c.png",
                              "inStock": 1,
                              "price": 17100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068980",
                                  "groupName": "VALUE DRINK",
                                  "choices": [
                                    {
                                      "id": "115222014",
                                      "name": "Small Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453464",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453341",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222143",
                                      "name": "Ice Tea",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886353",
                                      "name": "Minute Maid Pulpy Orange",
                                      "price": 829,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253115",
                                      "name": "   Bobaaa Sprite",
                                      "price": 2100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886354",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222074",
                                      "name": "Small Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221879",
                                      "name": "Small Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453317",
                                      "name": "Coke ® Zero",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453326",
                                      "name": "Cold Coffee",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453386",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791740",
                                      "name": "  Mango Ras^",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341940",
                                      "name": "VM Bobaaa Blast-Reusable Bottle",
                                      "price": 7800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463364",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378865",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378947",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463367",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378812",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378900",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "242068983",
                                  "groupName": "Extra for Chicken McGrill®",
                                  "choices": [
                                    {
                                      "id": "142190572",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453369",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748795",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453371",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428429",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453378",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "242068984",
                                  "groupName": "Extra for Small-Fries",
                                  "choices": [
                                    {
                                      "id": "139511596",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511604",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "109044839"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/5/15/674199b8-0976-4968-b58a-19de40a49513_534d87da-3212-4665-bca3-bf9f1d0e5f0e.png",
                      "categoryId": "49825467"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McCafe",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255177",
                              "name": "  Vietnamese Iced Coffee",
                              "category": "McCafe",
                              "imageId": "ba3bb7171b7fda2892471266ff8b3260",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "231910281",
                                  "groupName": "Extra for   Vietnamese Iced Coffee",
                                  "choices": [
                                    {
                                      "id": "115222094",
                                      "name": "Add No Whip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "106757701"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255178",
                              "name": "Watermelon Cooler",
                              "category": "McCafe",
                              "imageId": "dbf9eb845272ed7464d2e463db204d50",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129643814",
                                  "groupName": "Extra for Watermelon Cooler",
                                  "choices": [
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "67159661"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255173",
                              "name": "Strawberry Shake",
                              "category": "McCafe",
                              "description": "An all time favourite treat bringing together the perfect blend of creamy vanilla soft serve and strawberry flavor.Now in new, convenient and delivery friendly packaging.",
                              "imageId": "ebyu6tihineezej6rzvl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422437",
                                  "groupName": "Extra for Strawberry Shake",
                                  "choices": [
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080961"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255174",
                              "name": "Chocolate  Shake ",
                              "category": "McCafe",
                              "description": "The classic sinful chocolate shake, a treat for anytime you need one. Now in a new, convenient and delivery friendly packaging",
                              "imageId": "878d4fd655a28b92e0b64d07879e1d9f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422438",
                                  "groupName": "Extra for Chocolate  Shake ",
                                  "choices": [
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079619"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255175",
                              "name": "Vanilla Oreo Shake",
                              "category": "McCafe",
                              "description": "A refreshing sweet treat made from vanilla flavour and Oreo cookie pieces which are blended with ice. Now in a new, convenient and delivery friendly packaging.",
                              "imageId": "cvahrsea3s7gfermoqxm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422439",
                                  "groupName": "Extra for Vanilla Oreo Shake",
                                  "choices": [
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "57323881"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255176",
                              "name": "Cold Coffee  Frappe",
                              "category": "McCafe",
                              "description": "Rich, creamy and irresistible cold coffee, created by blending a double shot of espresso, ice cream & milk",
                              "imageId": "hpungvwxgmcibh7h10y9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422440",
                                  "groupName": "Extra for Cold Coffee  Frappe",
                                  "choices": [
                                    {
                                      "id": "115222094",
                                      "name": "Add No Whip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "66673405"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255161",
                              "name": "Cappuccino ",
                              "category": "McCafe",
                              "description": "A refreshing shot of our signature McCafé coffee made with 100% arabica beans, topped with milk that is steamed to a thick, perfect foam.",
                              "imageId": "qxhgb7jcjakkvloktx0b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "235287833",
                                  "groupName": "Extra for Cappuccino ",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079351"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255152",
                              "name": " Latte ",
                              "category": "McCafe",
                              "description": "Rich in flavour espresso balanced with steamed milk and a light layer of foam",
                              "imageId": "zxytnuj7gyxjp8iulm4q",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068947",
                                  "groupName": "Extra for  Latte ",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080110"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255154",
                              "name": " Mocha ",
                              "category": "McCafe",
                              "description": "A refreshing combination of chocolate, our signature McCafé coffee made with 100% Arabica beans and steamed milk, topped off with chocolate syrup.",
                              "imageId": "kxr9odmjtptqsza3qkrd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068946",
                                  "groupName": "Extra for  Mocha ",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080629"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255162",
                              "name": "  Americano ",
                              "category": "McCafe",
                              "description": "Our Americano is bold and robust, made with our signature McCafé coffee combined with hot water. For coffee aficionados who prefer a bolder cup.",
                              "imageId": "t4iacybiqwggynu5cxqm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "242068948",
                                  "groupName": "Extra for   Americano ",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "57323866"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255156",
                              "name": "Peach Iced Tea",
                              "category": "McCafe",
                              "description": "A perfect blend of aromatic teas, infused with peach flavour. Now in a new, convenient and delivery friendly packaging",
                              "imageId": "lkrzdhoaq94erls45ceu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422414",
                                  "groupName": "Extra for Peach Iced Tea",
                                  "choices": [
                                    {
                                      "id": "115222019",
                                      "name": "Add Reusable  Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "57323877"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255151",
                              "name": "    Velvety Chocolate Cup",
                              "category": "McCafe",
                              "description": "A perfect silky treat made with sinful chocolate steamed with 100% real milk and topped with an even sweeter touch of more chocolate.",
                              "imageId": "ac31e79de5fbd5bea592e3ea63885cff",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "264127199",
                                  "groupName": "Extra for     Velvety Chocolate Cup",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "115649070"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255170",
                              "name": "Espresso Small",
                              "category": "McCafe",
                              "description": "Concentrated black coffee shot.Our signature McCafé coffee made with 100% Arabica beans",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/de51dbdb-4de3-418d-a480-7c44e395837b_9761df72-aef3-4eaa-8a7c-72ea897ea7d6.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422435",
                                  "groupName": "Extra for Espresso Small",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "57323872"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255165",
                              "name": "Macchiato Small",
                              "category": "McCafe",
                              "description": "Freshly steamed milk with vanilla-flavoured syrup is marked with espresso",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/be58229e-c951-4050-b027-19934b0e9e6b_83ea1902-e9e7-4034-8422-ca84759a8051.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "129422420",
                                  "groupName": "Extra for Macchiato Small",
                                  "choices": [
                                    {
                                      "id": "115221983",
                                      "name": "Add Espresso Shot",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222149",
                                      "name": "Add Extra Milk",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221886",
                                      "name": "Add Whipped Cream",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "57323874"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255160",
                              "name": "Strawberry Cheese cake",
                              "category": "McCafe",
                              "description": "Strawberry Cheesecake",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/9445d121-a8f3-4dc7-8822-dab4ff459cc7_624f1ccd-cf05-49ba-8fe4-16b68ed73483.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "70799129"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255171",
                              "name": " Butter  Croissant",
                              "category": "McCafe",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/2df0cdff-94bc-4c83-9542-2790915a1c3b_86cf5e8d-269d-44a5-80ab-7301efaa585c.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "75983690"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131255168",
                              "name": " Garlic  Marinara Toasty",
                              "category": "McCafe",
                              "description": "Garlic Sub Marinara Toasty",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/85e6dc96-f924-4ae5-9922-5584bfe38648_f3104f76-9ea1-49ae-8794-ad548eee4099.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "76083633"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "ba3bb7171b7fda2892471266ff8b3260",
                      "categoryId": "44027836"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extra Value Meal Medium",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457302",
                              "name": "EVM Veg Maharaja Mac",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/07cfeefa-82e8-49ea-9970-61019cd9158e_6655ab03-0735-4842-b166-63c727c8f1ff.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225315",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254188",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254189",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254190",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463484",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378838",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378839",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463485",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254192",
                                  "groupName": "Extra for Veg Maharaja Mac",
                                  "choices": [
                                    {
                                      "id": "130453374",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453381",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "169 ratings",
                                  "ratingCountV2": "169"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079774"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457286",
                              "name": "EVM Big Spicy Paneer Wrap",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/2a18a000-652b-41de-848e-e2e5aa2566fe_9ad2cd33-3630-4aac-b08b-34b311fc8d13.png_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225319",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254112",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254113",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254114",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464007",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378804",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378879",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464008",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254116",
                                  "groupName": "Extra for Big Spicy Paneer Wrap",
                                  "choices": [
                                    {
                                      "id": "130453318",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453466",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005706"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457308",
                              "name": "EVM McSpicy® Paneer",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/a35d6605-8388-43c9-9a66-4056a6d672ca_a22ab423-845e-42a2-8c7f-e15ede7711c2.png_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225312",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254138",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254139",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254140",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463546",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378803",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378923",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463547",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254142",
                                  "groupName": "Extra for McSpicy® Paneer",
                                  "choices": [
                                    {
                                      "id": "130453342",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453473",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453436",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044511",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453350",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428431",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079759"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457318",
                              "name": "EVM McVeggie® ",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/ad05eeb9-ae8b-408f-af86-1a111a0f4d2f_d0d339da-456a-42b0-a971-28c8b2d04ccf.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225297",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254276",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254277",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254278",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463769",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378922",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378914",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463771",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132271652",
                                  "groupName": "Extra for McVeggie Burger®",
                                  "choices": [
                                    {
                                      "id": "130453338",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044513",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453346",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453467",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011635",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453462",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "140 ratings",
                                  "ratingCountV2": "140"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079763"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457186",
                              "name": "EVM  Butter Paneer Grilled Burger",
                              "category": "Extra Value Meal Medium",
                              "imageId": "fi0fdx32d8f2ufshe9ar",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225299",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254213",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254214",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254215",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464154",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378830",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378874",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464155",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254217",
                                  "groupName": "Extra for Butter Paneer Grilled",
                                  "choices": [
                                    {
                                      "id": "130453311",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453399",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044497",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453425",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453358",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428436",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45326227"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739039",
                              "name": "EVM Veg Surprise",
                              "category": "Extra Value Meal Medium",
                              "imageId": "c29a9768861f560504350a225c7e1264",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225291",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254021",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463903",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378826",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378927",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463905",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132271890",
                                  "groupName": "Extra for Veg-Surprise Burger*",
                                  "choices": [
                                    {
                                      "id": "130453319",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190567",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748819",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453397",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428433",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453433",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "60393384"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457363",
                              "name": "EVM Pizza McPuff®",
                              "category": "Extra Value Meal Medium",
                              "imageId": "wglxu9prpxmijxbzfcro",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254005",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254006",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254007",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "144225309",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463832",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079768"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457353",
                              "name": "EVM McAloo Tikki Burger® ",
                              "category": "Extra Value Meal Medium",
                              "imageId": "rpexjrzhh8d8yo1k6qtf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225322",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254035",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254036",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254037",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464126",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378821",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378901",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464127",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254039",
                                  "groupName": "Extra for McAloo Tikki Burger  ®",
                                  "choices": [
                                    {
                                      "id": "130453308",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190561",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453359",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748826",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428427",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453400",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "135 ratings",
                                  "ratingCountV2": "135"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079748"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457366",
                              "name": "EVM Big Spicy Chicken Wrap ",
                              "category": "Extra Value Meal Medium",
                              "imageId": "ejqnbbt8p8pez7yinowp",
                              "inStock": 1,
                              "price": 38600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225303",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254083",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254084",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254085",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463664",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378892",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378928",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463666",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254087",
                                  "groupName": "Extra for Big Spicy Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453357",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453389",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005705"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170844701",
                              "name": "  EVM Chicken  Puff",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/30/30683a08-ffde-4e60-93d1-255866b44156_ee2a048a-b3eb-46d0-82b5-0c2e02e197f9.png",
                              "inStock": 1,
                              "price": 20700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537089",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537090",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537091",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "103079035"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457369",
                              "name": "EVM Chicken Maharaja Mac®",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/4d0fa0e0-5b5f-4320-a872-b0a554efffe3_96a75f8d-7549-4308-9bbb-142025ee4e93.png",
                              "inStock": 1,
                              "price": 38600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225288",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254065",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254066",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254067",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463792",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378855",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378936",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463793",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254069",
                                  "groupName": "Extra for Chicken Maharaja Mac®",
                                  "choices": [
                                    {
                                      "id": "130453379",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453312",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079726"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457375",
                              "name": "EVM McNuggets®  9pc",
                              "category": "Extra Value Meal Medium",
                              "imageId": "vvytxewzdpxeqbmnm4gp",
                              "inStock": 1,
                              "price": 34800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225321",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253899",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253900",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253901",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253903",
                                  "groupName": "Nuggets DIP 1/2",
                                  "choices": [
                                    {
                                      "id": "115222003",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222090",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253904",
                                  "groupName": "Nuggets DIP 2/2",
                                  "choices": [
                                    {
                                      "id": "115222003",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222090",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464146",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253905",
                                  "groupName": "Extra for Chicken McNuggets® 9pc",
                                  "choices": [
                                    {
                                      "id": "115677028",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221897",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005713"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457378",
                              "name": "EVM McSpicy® Chicken",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/bbc80103-242d-43f9-b609-e8a18041201a_d49d6fe8-6cfc-4a4a-8f73-2fa2509dd04f.png",
                              "inStock": 1,
                              "price": 34400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225302",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253870",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253871",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253872",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464064",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378841",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378875",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464065",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253874",
                                  "groupName": "Extra for McSpicy® Chicken",
                                  "choices": [
                                    {
                                      "id": "142044505",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748927",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453401",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453356",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428437",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453313",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079755"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457384",
                              "name": "EVM Filet O Fish® ",
                              "category": "Extra Value Meal Medium",
                              "imageId": "xtcceyibjmtbjm9xk1ao",
                              "inStock": 1,
                              "price": 31700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225307",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253956",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253957",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253958",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464033",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378894",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378853",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464034",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253960",
                                  "groupName": "Extra for Filet O Fish®",
                                  "choices": [
                                    {
                                      "id": "130453328",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453335",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453444",
                                      "name": "Add Filet O Fish Patty",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079742"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457387",
                              "name": "EVM McNuggets®  6pc",
                              "category": "Extra Value Meal Medium",
                              "imageId": "qz5uzkf3lgyuqs9fagdo",
                              "inStock": 1,
                              "price": 30600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225304",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253929",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253930",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253931",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253933",
                                  "groupName": "Nuggets DIP",
                                  "choices": [
                                    {
                                      "id": "115222127",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222106",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464179",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253934",
                                  "groupName": "Extra for Chicken McNuggets® 6pc",
                                  "choices": [
                                    {
                                      "id": "115677011",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222045",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005712"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457394",
                              "name": "EVM McChicken®",
                              "category": "Extra Value Meal Medium",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/5abe29a8-c389-4788-8bae-652c188524e1_dec138c9-9333-4eed-8944-575a93f65e90.png",
                              "inStock": 1,
                              "price": 28100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225308",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254307",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254308",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254309",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463588",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378827",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378800",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463589",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254311",
                                  "groupName": "Extra for McChicken®",
                                  "choices": [
                                    {
                                      "id": "142044487",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453395",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453424",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453435",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011639",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453309",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079750"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457400",
                              "name": "EVM Chicken McGrill®",
                              "category": "Extra Value Meal Medium",
                              "imageId": "wodn9kxqq5ilzqtslw1f",
                              "inStock": 1,
                              "price": 24800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225301",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254358",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254359",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254360",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463821",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378865",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378947",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463822",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254362",
                                  "groupName": "Extra for Chicken McGrill®",
                                  "choices": [
                                    {
                                      "id": "142190572",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453369",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748795",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453371",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428429",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453378",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079728"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457407",
                              "name": "EVM McEgg® ",
                              "category": "Extra Value Meal Medium",
                              "imageId": "owhmilk4ljvb8ehix6o7",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225305",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254345",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254346",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254347",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463437",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378919",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378820",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463438",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254349",
                                  "groupName": "Extra for McEgg®",
                                  "choices": [
                                    {
                                      "id": "130453459",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190562",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453456",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453445",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428428",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079753"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/07cfeefa-82e8-49ea-9970-61019cd9158e_6655ab03-0735-4842-b166-63c727c8f1ff.png",
                      "categoryId": "38404901"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extra Value Meal Large",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457425",
                              "name": "Large EVM Veg Maharaja Mac",
                              "category": "Extra Value Meal Large",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/ae034e5d-e3bd-4001-a811-1c510e00a5e2_91e490c2-8532-44fb-a97c-cd8301fd32b8.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254143",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254144",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254145",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463653",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378839",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378838",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463654",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463655",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254147",
                                  "groupName": "Extra for Veg Maharaja Mac",
                                  "choices": [
                                    {
                                      "id": "130453374",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453381",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254148",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "76 ratings",
                                  "ratingCountV2": "76"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080106"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457415",
                              "name": "Large EVM Big Spicy Paneer Wrap",
                              "category": "Extra Value Meal Large",
                              "imageId": "yeb72ubynzuo1kjesusv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254158",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254159",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254160",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463499",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378804",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378879",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463500",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463502",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254162",
                                  "groupName": "Extra for Big Spicy Paneer Wrap",
                                  "choices": [
                                    {
                                      "id": "130453318",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453466",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254163",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005721"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457436",
                              "name": "Large EVM McSpicy® Paneer",
                              "category": "Extra Value Meal Large",
                              "imageId": "wsaktelrkhtya7zapylx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254244",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254245",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254246",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463744",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378803",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378923",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463746",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463749",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254248",
                                  "groupName": "Extra for McSpicy® Paneer",
                                  "choices": [
                                    {
                                      "id": "130453342",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453473",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453436",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044511",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453350",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428431",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254249",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080094"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457449",
                              "name": "Large EVM McVeggie®",
                              "category": "Extra Value Meal Large",
                              "imageId": "xgesvsnl3riu0qhuegv2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254218",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254219",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254220",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464186",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378922",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378914",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464187",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464188",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "132271891",
                                  "groupName": "Extra for McVeggie Burger®",
                                  "choices": [
                                    {
                                      "id": "130453338",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044513",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453346",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453467",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011635",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453462",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254223",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080098"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739041",
                              "name": "Large EVM Veg Surprise",
                              "category": "Extra Value Meal Large",
                              "imageId": "abf59cb45e291093fa270226932fe883",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254030",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463776",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463778",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463780",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378826",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378927",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254032",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132271081",
                                  "groupName": "Extra for Veg-Surprise Burger*",
                                  "choices": [
                                    {
                                      "id": "130453319",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190567",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748819",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453397",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428433",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453433",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "60393385"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457182",
                              "name": "Large EVM Butter Paneer Grilled Burger",
                              "category": "Extra Value Meal Large",
                              "imageId": "xor27galfupyx1ioby1u",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253915",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253916",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253917",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464095",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378830",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378874",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464096",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464097",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253919",
                                  "groupName": "Extra for Butter Paneer Grilled",
                                  "choices": [
                                    {
                                      "id": "130453311",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453399",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044497",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453425",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453358",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428436",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253920",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45326229"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457469",
                              "name": "Large EVM McAloo Tikki Burger®",
                              "category": "Extra Value Meal Large",
                              "imageId": "ztddl0szi6xrxyy7wvci",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253979",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253980",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253981",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463351",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378821",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378901",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463353",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463355",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253983",
                                  "groupName": "Extra for McAloo Tikki Burger  ®",
                                  "choices": [
                                    {
                                      "id": "130453308",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190561",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453359",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748826",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428427",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453400",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253984",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080082"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457474",
                              "name": "Large EVM Pizza McPuff®",
                              "category": "Extra Value Meal Large",
                              "imageId": "gebwke4itbbvz0xkochc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253893",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253894",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253895",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463271",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463273",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253897",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080102"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457479",
                              "name": "Large EVM Big Spicy Chicken Wrap ",
                              "category": "Extra Value Meal Large",
                              "imageId": "lnfkobyfltfgxupmj692",
                              "inStock": 1,
                              "price": 41100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254321",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254322",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254323",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463298",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378928",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378892",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463300",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463302",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254325",
                                  "groupName": "Extra for Big Spicy Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453357",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453389",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254326",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.1",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005720"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170844702",
                              "name": "Large EVM Chicken Puff",
                              "category": "Extra Value Meal Large",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/30/67e72a76-d626-4ed8-80ac-be78457f9e37_cae4aa32-053a-4e25-800f-5e7c463da238.png",
                              "inStock": 1,
                              "price": 23100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "266537092",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537093",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537094",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "266537095",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "103079036"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457484",
                              "name": "Large EVM Chicken Maharaja Mac®",
                              "category": "Extra Value Meal Large",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/54f816a6-cc19-4832-8576-1f0025a094f8_8aef80a0-c717-4925-9963-bcbc93142a41.png",
                              "inStock": 1,
                              "price": 41100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253961",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253962",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253963",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463459",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378936",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378855",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463460",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463461",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253965",
                                  "groupName": "Extra for Chicken Maharaja Mac®",
                                  "choices": [
                                    {
                                      "id": "130453312",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453379",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253966",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080060"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457489",
                              "name": "Large EVM McNuggets®  9pc",
                              "category": "Extra Value Meal Large",
                              "imageId": "nyliy5bxf58ffbtfteko",
                              "inStock": 1,
                              "price": 37300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254372",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254373",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254374",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254376",
                                  "groupName": "Nuggets DIP 1/2",
                                  "choices": [
                                    {
                                      "id": "115222090",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222003",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254377",
                                  "groupName": "Nuggets DIP 2/2",
                                  "choices": [
                                    {
                                      "id": "115222090",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222003",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463702",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463703",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254378",
                                  "groupName": "Extra for Chicken McNuggets® 9pc",
                                  "choices": [
                                    {
                                      "id": "115677028",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221897",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254379",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005729"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457498",
                              "name": "Large EVM McSpicy® Chicken",
                              "category": "Extra Value Meal Large",
                              "imageId": "hi4nyjqesdhow91ozlp1",
                              "inStock": 1,
                              "price": 36800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254366",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254367",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254368",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463255",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378841",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378875",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463256",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463257",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254370",
                                  "groupName": "Extra for McSpicy® Chicken",
                                  "choices": [
                                    {
                                      "id": "142044505",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748927",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453401",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453356",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428437",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453313",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254371",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080090"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457502",
                              "name": "Large EVM Filet O Fish®",
                              "category": "Extra Value Meal Large",
                              "imageId": "wyszmxk4qbdg6bsy0m79",
                              "inStock": 1,
                              "price": 34200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254263",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254264",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254265",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464074",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378853",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378894",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464075",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464076",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254267",
                                  "groupName": "Extra for Filet O Fish®",
                                  "choices": [
                                    {
                                      "id": "130453444",
                                      "name": "Add Filet O Fish Patty",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453328",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453335",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254268",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005726"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457510",
                              "name": "Large EVM McNuggets®  6pc",
                              "category": "Extra Value Meal Large",
                              "imageId": "cdky8zq38hrh6rksvtgq",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253879",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253880",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253881",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253883",
                                  "groupName": "Nuggets DIP",
                                  "choices": [
                                    {
                                      "id": "115222106",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222127",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463803",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463804",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253884",
                                  "groupName": "Extra for Chicken McNuggets® 6pc",
                                  "choices": [
                                    {
                                      "id": "115677011",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222045",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253885",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "45005728"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457513",
                              "name": "Large EVM McChicken®",
                              "category": "Extra Value Meal Large",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/10/4aa35100-4e77-4691-9a5e-bb3d11f7ba8c_55f58a95-9b8b-4146-81bd-7bb1ed549e67.png",
                              "inStock": 1,
                              "price": 30500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253987",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253988",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253989",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463562",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378827",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378800",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463565",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463567",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253991",
                                  "groupName": "Extra for McChicken®",
                                  "choices": [
                                    {
                                      "id": "142044487",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453395",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453424",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453435",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011639",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453309",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253992",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080084"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457517",
                              "name": "Large EVM Chicken McGrill®",
                              "category": "Extra Value Meal Large",
                              "imageId": "qjbovjul9rpyso2a1m4z",
                              "inStock": 1,
                              "price": 27300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254050",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254051",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254052",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464171",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378865",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378947",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464172",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464173",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254054",
                                  "groupName": "Extra for Chicken McGrill®",
                                  "choices": [
                                    {
                                      "id": "142190572",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453369",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748795",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453371",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428429",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453378",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254055",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080062"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457524",
                              "name": "Large EVM McEgg®",
                              "category": "Extra Value Meal Large",
                              "imageId": "jhbcryulbfxjgdxmiz3z",
                              "inStock": 1,
                              "price": 22300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254070",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254071",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254072",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464042",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378919",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378820",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464043",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464044",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254074",
                                  "groupName": "Extra for McEgg®",
                                  "choices": [
                                    {
                                      "id": "130453459",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190562",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453456",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453445",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428428",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254075",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080088"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396373",
                              "name": "Large EVM Aloo Wrap",
                              "category": "Extra Value Meal Large",
                              "imageId": "141d0f07edb4db16ef1b898607c53db6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "120172368",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463509",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378816",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378902",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463512",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463513",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "120172370",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453452",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120172371",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080058"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396378",
                              "name": "Large EVM Tandoori Chicken Wrap",
                              "category": "Extra Value Meal Large",
                              "imageId": "c1807cdb3925201000b347517fcd79bb",
                              "inStock": 1,
                              "price": 27700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "120172383",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464156",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378813",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378843",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464157",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464158",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "120172385",
                                  "groupName": "Extra for Tandoori Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453447",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120172386",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73889108"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396377",
                              "name": "Large EVM Egg Wrap",
                              "category": "Extra Value Meal Large",
                              "imageId": "7b7754a705b5b4fcaa1d6b629b725062",
                              "inStock": 1,
                              "price": 27100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "120172379",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464165",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378863",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378871",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464166",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464167",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "120172381",
                                  "groupName": "Extra for Egg Wrap",
                                  "choices": [
                                    {
                                      "id": "130453450",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120172382",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080072"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/ae034e5d-e3bd-4001-a811-1c510e00a5e2_91e490c2-8532-44fb-a97c-cd8301fd32b8.png",
                      "categoryId": "38404902"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50663441",
                              "name": "Veg Maharaja Mac",
                              "category": "Burgers",
                              "description": "Big Mac sesame seeds bun, with rich and crusty cheesy corn patty, topped with chunky vegetable-cocktail sauce served with pungent jalapeño slices, red onion slices, tomato slices, Cheddar cheese slice and crisp iceberg lettuce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/06cdba91-f1e3-40d4-8bc6-7382fa501fe8_4869ab02-2f11-49f2-a863-0498c14c7644.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463929",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077650",
                                  "groupName": "Extra for Veg Maharaja Mac",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "461 ratings",
                                  "ratingCountV2": "461"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30081019"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902898",
                              "name": "McSpicy® Paneer",
                              "category": "Burgers",
                              "description": "Crispy and spicy paneer patty with creamy tandoori sauce and crispy lettuce topping.",
                              "imageId": "elssdjqcsdrwjmwa4yaf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463784",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077652",
                                  "groupName": "Extra for McSpicy® Paneer",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453349",
                                      "name": "Add McSpicy Paneer Patty",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "513 ratings",
                                  "ratingCountV2": "513"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080472"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457667",
                              "name": "McVeggie®",
                              "category": "Burgers",
                              "description": "A patty made of potatoes, peas, carrots, beans, onions, red capsicum and a selection of Indian spices, topped with crispy lettuce, mayonnaise, packed into sesame toasted buns.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/9b543220-0121-4003-8ec4-7b2ef2637cac_f6776088-d2e5-4fc3-9957-5b3cbbbbdd70.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077653",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463948",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463950",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077656",
                                  "groupName": "Extra for McVeggie®",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453409",
                                      "name": "Add McVeggie Patty",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011633",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "965 ratings",
                                  "ratingCountV2": "965"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080508"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457672",
                              "name": "McAloo Tikki Burger ®",
                              "category": "Burgers",
                              "description": "A tikki delight: Potato and peas patty topped with veg sauce, ketchup, tomatoes and onions with toasted buns",
                              "imageId": "ni4jj1hlo4zt7i3ioaow",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077659",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463761",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463763",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077662",
                                  "groupName": "Extra for McAloo Tikki Burger ®",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748781",
                                      "name": "Add McAloo Tikki Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1292 ratings",
                                  "ratingCountV2": "1.3K+"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080185"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457197",
                              "name": "Butter Paneer Grilled",
                              "category": "Burgers",
                              "description": "Mildly spiced grilled paneer patty topped with makhani sauce and shredded onions placed between freshly toasted sesame seeded buns",
                              "imageId": "i8cc2ekzmyo7hokzr7z3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464150",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077664",
                                  "groupName": "Extra for Butter Paneer Grilled",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453327",
                                      "name": "Add Grilled Paneer Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044515",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453411",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "141 ratings",
                                  "ratingCountV2": "141"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005697"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739034",
                              "name": "Veg-Surprise Burger*",
                              "category": "Burgers",
                              "description": "A surprise that will leave you wide-eyed. A scrumptious potato patty topped with a delectable Italian herb sauce and shredded onions placed between perfectly toasted buns.",
                              "imageId": "c74108490c0ec3db9123681b90fa003d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463986",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077666",
                                  "groupName": "Extra for Veg-Surprise Burger*",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748777",
                                      "name": "Add Veg Surprise Patty",
                                      "price": 3100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "201 ratings",
                                  "ratingCountV2": "201"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "77235823"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457676",
                              "name": "Chicken Maharaja Mac®",
                              "category": "Burgers",
                              "description": "Chunky juicy grilled chicken patty with fresh and premium ingredients such as jalapeño, onion, Cheddar cheese, tomatoes and crunchy lettuce, dressed with classic Habanero sauce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/e85fe267-0b97-4bca-a02e-f7d401aa86e2_909a2441-0b47-4603-ac54-7a08d78277b6.png",
                              "inStock": 1,
                              "price": 24700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463711",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077668",
                                  "groupName": "Extra for Chicken Maharaja Mac®",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "239 ratings",
                                  "ratingCountV2": "239"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079488"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457683",
                              "name": "Filet O Fish®",
                              "category": "Burgers",
                              "description": "Made with Alaskan Pollock sourced from sustainable fisheries, topped with cheese slice and creamy tartar sauce, served on a soft, steamed bun.",
                              "imageId": "i7gn93slyqqlbn3xi14k",
                              "inStock": 1,
                              "price": 19400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463971",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077670",
                                  "groupName": "Extra for Filet O Fish®",
                                  "choices": [
                                    {
                                      "id": "130453320",
                                      "name": "Add Filet O Fish Patty",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "134 ratings",
                                  "ratingCountV2": "134"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079787"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902903",
                              "name": "McSpicy® Chicken",
                              "category": "Burgers",
                              "description": "Juicy Chicken meat coated in crispy batter with a kick of spice topped with a creamy sauce and crispy lettuce.",
                              "imageId": "aekaxqqfayw0bt7luwhv",
                              "inStock": 1,
                              "price": 20100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463386",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077672",
                                  "groupName": "Extra for McSpicy® Chicken",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748924",
                                      "name": "Add McSpicy Chicken  Patty",
                                      "price": 14100,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "508 ratings",
                                  "ratingCountV2": "508"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080426"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457685",
                              "name": "McChicken®",
                              "category": "Burgers",
                              "description": "Delightfully crispy chicken sandwich with a crispy chicken patty topped with mayonnaise and shredded iceberg lettuce served on a perfectly toasty bun.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/ec7df92b-152e-457d-a3f5-c1ccc541226f_35b04a72-9e47-4fe4-a8a9-f4a6eacb2799.png",
                              "inStock": 1,
                              "price": 15100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077673",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463604",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463607",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077676",
                                  "groupName": "Extra for McChicken®",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453470",
                                      "name": "Add McChicken Patty",
                                      "price": 8700,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011633",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "405 ratings",
                                  "ratingCountV2": "405"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080252"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457689",
                              "name": "Chicken McGrill®",
                              "category": "Burgers",
                              "description": "Grilled chicken patty served with freshly toasted bun, tomatoes, onions and cool mint sauce",
                              "imageId": "itzi0e3twpnak2hvn37q",
                              "inStock": 1,
                              "price": 10600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077679",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463573",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463576",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077682",
                                  "groupName": "Extra for Chicken McGrill®",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119748907",
                                      "name": "Add Chicken McGrill Patty",
                                      "price": 6200,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "203 ratings",
                                  "ratingCountV2": "203"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079504"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457693",
                              "name": "McEgg®",
                              "category": "Burgers",
                              "description": "An Egg lover's delight! A unique combination of perfectly steamed egg, classic mayonnaise and chopped onions with a sprinkling of magic masala sandwiched in a toasted bun.",
                              "imageId": "m32bv6bf9zhdhecik2xz",
                              "inStock": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077685",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464026",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464027",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077688",
                                  "groupName": "Extra for McEgg®",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "288 ratings",
                                  "ratingCountV2": "288"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080306"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/06cdba91-f1e3-40d4-8bc6-7382fa501fe8_4869ab02-2f11-49f2-a863-0498c14c7644.png",
                      "categoryId": "53120274"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Wraps",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902897",
                              "name": "Big Spicy Paneer Wrap",
                              "category": "Wraps",
                              "description": "Tender paneer patty with a fiery, crunchy batter coating, dressed with fresh veggies and seasonings, topped with creamy sauce and a dash of mustard and melted cheese.",
                              "imageId": "oswfs7fqndtob54z7vib",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463849",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077690",
                                  "groupName": "Extra for Big Spicy Paneer Wrap",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079299"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396376",
                              "name": "EVM Aloo Wrap",
                              "category": "Wraps",
                              "imageId": "1d841d631ed8ddd6e9a4ee54f12159c3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077691",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077692",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463318",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378816",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378902",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463321",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077696",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453452",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30079724"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396382",
                              "name": "Aloo Wrap",
                              "category": "Wraps",
                              "description": "Aloo Tikki patty topped with tandoori sauce, onions and lettuce wrapped in a tortilla.",
                              "imageId": "2bebb02ac62ec20ed8fe299e7dd971a6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463444",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077698",
                                  "groupName": "Extra for Aloo Wrap",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079204"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902900",
                              "name": "Big Spicy Chicken Wrap",
                              "category": "Wraps",
                              "description": "Juicy chicken coated with hot and crispy batter, dressed with fresh salad of lettuce, onions, tomatoes and seasonings. Served with creamy sauce and supple cheese slices.",
                              "imageId": "fmxujouku75sstddk9ic",
                              "inStock": 1,
                              "price": 24800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464180",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077700",
                                  "groupName": "Extra for Big Spicy Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "109 ratings",
                                  "ratingCountV2": "109"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079291"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396372",
                              "name": "EVM Tandoori Chicken Wrap",
                              "category": "Wraps",
                              "imageId": "17e61c8b0af0bf6cd025f98112fb8f42",
                              "inStock": 1,
                              "price": 26000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077701",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077702",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463449",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378843",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378813",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463452",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077706",
                                  "groupName": "Extra for Tandoori Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453447",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73845689"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396380",
                              "name": "EVM Egg Wrap",
                              "category": "Wraps",
                              "imageId": "cfbd7dba74a8d45036e3bb60c727f195",
                              "inStock": 1,
                              "price": 24800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "176077707",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077708",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464131",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378863",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378871",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464133",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "176077712",
                                  "groupName": "Extra for Egg Wrap",
                                  "choices": [
                                    {
                                      "id": "130453450",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30079741"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396374",
                              "name": "Tandoori Chicken Wrap",
                              "category": "Wraps",
                              "description": "Grilled chicken patty topped with tandoori sauce, onions and lettuce wrapped in a tortilla.",
                              "imageId": "2aa782e04760a3597042d973450c92b2",
                              "inStock": 1,
                              "price": 11400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463491",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077714",
                                  "groupName": "Extra for Tandoori Chicken Wrap",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "73845691"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127396375",
                              "name": "Egg Wrap",
                              "category": "Wraps",
                              "description": "Egg patty topped with tandoori sauce, onions and lettuce wrapped in a tortilla.",
                              "imageId": "4ee5bccfae2147b9e33ef77d3ee575d5",
                              "inStock": 1,
                              "price": 10200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463598",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "176077716",
                                  "groupName": "Extra for Egg Wrap",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079722"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "oswfs7fqndtob54z7vib",
                      "categoryId": "53120275"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Double Patty Burgers & Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457529",
                              "name": "Large EVM McSpicy Paneer® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "i7xqlsfln0us8yzbgmjq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254180",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254181",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254182",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463244",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378850",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378861",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463245",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463246",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254184",
                                  "groupName": "Extra for McSpicy Paneer® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453469",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044514",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453446",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453391",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428440",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254185",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080096"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457533",
                              "name": "EVM McSpicy Paneer® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "ommvhrngbalbsm20bv7q",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 45900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225320",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254122",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254123",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254124",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463414",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378850",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378861",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463415",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254126",
                                  "groupName": "Extra for McSpicy Paneer® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453469",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044514",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453446",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453391",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428440",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30079761"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457538",
                              "name": "Large EVM McVeggie® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "zejhk2ggusxzgrohahen",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254269",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254270",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254271",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463874",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378829",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378859",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463875",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463878",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254273",
                                  "groupName": "Extra for McVeggie® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453322",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453465",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044502",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011637",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453457",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254274",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080101"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902891",
                              "name": "McSpicy Paneer® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "Crispy and spicy paneer patty with creamy tandoori sauce and crispy lettuce topping.",
                              "imageId": "bhipiuo0oxogtjun5oyo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463738",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254203",
                                  "groupName": "Extra for McSpicy Paneer® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080482"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457543",
                              "name": "EVM McVeggie® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "p0iva8gqt1lakjhhrvmg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225323",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254332",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254333",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254334",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463232",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378829",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378859",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463234",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254336",
                                  "groupName": "Extra for McVeggie® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453322",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453465",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044502",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011637",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453457",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079766"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739042",
                              "name": "Large EVM Veg Surprise Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "9cf59d40674381eef985ebb113aadec8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253865",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464147",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464148",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464149",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378917",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378937",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253867",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253868",
                                  "groupName": "Extra for Veg Surprise Double patty",
                                  "choices": [
                                    {
                                      "id": "130453344",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453438",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190569",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453314",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428422",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "60393386"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739044",
                              "name": "EVM Dbl Veg Surprise Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "64008f7c35b3831513f93df7917f532c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225287",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253876",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464204",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378917",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378937",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464205",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253878",
                                  "groupName": "Extra for Veg Surprise Double patty",
                                  "choices": [
                                    {
                                      "id": "130453344",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453438",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190569",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453314",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428422",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "60393383"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457575",
                              "name": "Large EVM McAloo Tikki Burger® Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "upcg8usnmf8xlydfghch",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253922",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253923",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253924",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463343",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378823",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378882",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463344",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463345",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253926",
                                  "groupName": "Extra for McAloo Tikki Burger® Double patty",
                                  "choices": [
                                    {
                                      "id": "130453380",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190565",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453367",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453441",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428423",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253927",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005727"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457591",
                              "name": "EVM McAloo Tikki Burger® Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "fo5mwzaz5lrivtxfywjl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225316",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253994",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253995",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253996",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464168",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378823",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378882",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464169",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253998",
                                  "groupName": "Extra for McAloo Tikki Burger® Double patty",
                                  "choices": [
                                    {
                                      "id": "130453380",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142190565",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453367",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453441",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428423",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005711"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457609",
                              "name": "McVeggie® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "A patty made of potatoes, peas, carrots, beans, onions, red capsicum and a selection of Indian spices, topped with crispy lettuce, mayonnaise, packed into sesame toasted buns.",
                              "imageId": "rv0knl5nqndhygw9u7tl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463327",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253947",
                                  "groupName": "Extra for McVeggie® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011633",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "54 ratings",
                                  "ratingCountV2": "54"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080529"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457192",
                              "name": "Butter Paneer Grilled Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "Mildly spiced grilled paneer patty topped with makhani sauce and shredded onions placed between freshly toasted sesame seeded buns",
                              "imageId": "ymk6sj7audeog2opdb96",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464170",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254063",
                                  "groupName": "Extra for Butter Paneer Grilled Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044515",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453411",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005698"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105739047",
                              "name": "Veg Surprise Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "eaa54264804dfac74c856a4dfb6931e1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463844",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254102",
                                  "groupName": "Extra for Veg Surprise Double patty",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "60393388"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457164",
                              "name": "Large EVM  Butter Paneer Grilled Double Patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "ymyzcxwg6rdjnytw4cvr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254057",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254058",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254059",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464105",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378856",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378828",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464106",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464107",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254061",
                                  "groupName": "Extra for Butter Paneer Grilled Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453443",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453403",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453461",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044493",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428443",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254062",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005725"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457174",
                              "name": "EVM Butter Paneer Grilled Double Patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "g7jdx5pqwcguuwvrv8jp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225286",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254025",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254026",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254027",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463920",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378856",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378828",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463921",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254029",
                                  "groupName": "Extra for Butter Paneer Grilled Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453443",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453403",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453461",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044493",
                                      "name": "Add   Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428443",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "45005710"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457632",
                              "name": "McAloo Tikki Burger® Double patty",
                              "category": "Double Patty Burgers & Meals",
                              "description": "A tikki delight: Potato and peas patty topped with veg sauce, ketchup, tomatoes and onions with toasted buns",
                              "imageId": "d0b4ox1om6dk98b8otwe",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "116944042",
                                  "groupName": "Value Campaign Save upto 38%",
                                  "choices": [
                                    {
                                      "id": "130562185",
                                      "name": "Match By You Coke",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222154",
                                      "name": "No Offer",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562187",
                                      "name": "Match By You Sprite",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562186",
                                      "name": "Match By You Fanta",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130562189",
                                      "name": "Match By You Fries",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463955",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463956",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378889",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378884",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254049",
                                  "groupName": "Extra for McAloo Tikki Burger® Double patty",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "233 ratings",
                                  "ratingCountV2": "233"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005734"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457635",
                              "name": "Large EVM McSpicy Chicken® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "epknyfyu4ecnlf4idivo",
                              "inStock": 1,
                              "price": 49800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254152",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254153",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254154",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463627",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378845",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378880",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463629",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463630",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254156",
                                  "groupName": "Extra for McSpicy Chicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453442",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044504",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453402",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453382",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428442",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254157",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080092"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457637",
                              "name": "Large EVM Filet O Fish® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "sqmmcjpluxybj9wfhfex",
                              "inStock": 1,
                              "price": 48200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254104",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254105",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254106",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463264",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378930",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378904",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463265",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463266",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254108",
                                  "groupName": "Extra for Filet O Fish® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453336",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453325",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254109",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080079"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457640",
                              "name": "EVM McSpicy Chicken® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "xbhik8wvybdhoexwa7hw",
                              "inStock": 1,
                              "price": 46600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225293",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254225",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254226",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254227",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463536",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378845",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378880",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463537",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254229",
                                  "groupName": "Extra for McSpicy Chicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453442",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044504",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453402",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453382",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428442",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079757"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457642",
                              "name": "EVM Filet O Fish® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "ab7igasqrikmg6ysfw6p",
                              "inStock": 1,
                              "price": 46000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225314",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254167",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254168",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254169",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463676",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378904",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378930",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463679",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254171",
                                  "groupName": "Extra for Filet O Fish® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453325",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453336",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079744"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457644",
                              "name": "Large EVM  McChicken® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/11caaabd-af76-4aa7-9bc0-ade2fa6e3208_c51a4711-8a12-4c6f-9bcb-0724bb51edc9.png",
                              "inStock": 1,
                              "price": 39000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254312",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254313",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254314",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463613",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378935",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378819",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463615",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463616",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254316",
                                  "groupName": "Extra for McChicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453365",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453420",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044498",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011636",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453345",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254317",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080087"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457647",
                              "name": "EVM  McChicken® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/9/953a573c-98ca-492a-ac14-73431188202b_2f76c38d-07d1-4b5a-888f-40986e1e5f28.png",
                              "inStock": 1,
                              "price": 36600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225318",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254258",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254259",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254260",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464143",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378935",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378819",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464144",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254262",
                                  "groupName": "Extra for McChicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453365",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453420",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044498",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011636",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453345",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079752"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98902894",
                              "name": "McSpicy Chicken® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "Juicy Chicken meat coated in crispy batter with a kick of spice topped with a creamy sauce and crispy lettuce.",
                              "imageId": "msevdrrmbea9xhhpb2wh",
                              "inStock": 1,
                              "price": 33900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464164",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254320",
                                  "groupName": "Extra for McSpicy Chicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080436"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457651",
                              "name": "Large EVM Chicken McGrill® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "eyywvokrgqvxafzqdtly",
                              "inStock": 1,
                              "price": 33100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253906",
                                  "groupName": "LARGE EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "130453310",
                                      "name": "Strawberry Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337620",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222077",
                                      "name": "Large Coke ®",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453383",
                                      "name": "Peach Iced Tea",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139511602",
                                      "name": "  Cold CoffeeFrappe",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453448",
                                      "name": "Watermelon Cooler",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221941",
                                      "name": "Large Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453468",
                                      "name": "Chocolate Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222138",
                                      "name": "Large Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453412",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791738",
                                      "name": "  Mango-Ras",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734344",
                                      "name": "Mango Thick Shake",
                                      "price": 9000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453423",
                                      "name": "Caramel Frappe",
                                      "price": 7300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253907",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253908",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464181",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378940",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378840",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464182",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260464183",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378924",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378938",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253910",
                                  "groupName": "Extra for Chicken McGrill® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "142190566",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453414",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453413",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428432",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453370",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104253911",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115221968",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677030",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30080065"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457654",
                              "name": "Filet O Fish® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "Made with Alaskan Pollock sourced from sustainable fisheries, topped with cheese slice and creamy tartar sauce, served on a soft, steamed bun.",
                              "imageId": "umoeqnbt5xzivdgfyde2",
                              "inStock": 1,
                              "price": 33400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464128",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254381",
                                  "groupName": "Extra for Filet O Fish® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079793"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457656",
                              "name": "EVM Chicken McGrill® Double patty Burger ",
                              "category": "Double Patty Burgers & Meals",
                              "imageId": "qlqscidfgy6j6umrngnb",
                              "inStock": 1,
                              "price": 30700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144225296",
                                  "groupName": "Fries",
                                  "choices": [
                                    {
                                      "id": "130453476",
                                      "name": "McFlavor Fries  (Med.)",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115677010",
                                      "name": "Medium Fries",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136444329",
                                      "name": "Medium Piri Piri Fries*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254231",
                                  "groupName": "EVM DRINK",
                                  "choices": [
                                    {
                                      "id": "139918432",
                                      "name": "Masala Chai",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "140253116",
                                      "name": "   Bobaaa Sprite",
                                      "price": 400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221937",
                                      "name": "Medium Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886351",
                                      "name": "Schweppes™ Bottled Water",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453408",
                                      "name": "Cold Coffee",
                                      "price": 2400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139886352",
                                      "name": "Minute Maid Pulpy Orange",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453329",
                                      "name": "Chocolate Milk shake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453406",
                                      "name": "Coke ® Zero",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341943",
                                      "name": " Latte*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341942",
                                      "name": " Mocha*",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221970",
                                      "name": "Medium Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882020",
                                      "name": "Strawberry Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453472",
                                      "name": "Vanilla Oreo Shake",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882013",
                                      "name": "Chocolate Shake",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138337621",
                                      "name": "  Vietnamese Iced Coffee",
                                      "price": 2200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341939",
                                      "name": " Cold  Coffee  Frappe*",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453360",
                                      "name": "Ice Tea",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341938",
                                      "name": " Cappuccino*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341937",
                                      "name": " Americano*",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882018",
                                      "name": "Watermelon Cooler",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065580",
                                      "name": "   Iced Latte",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882017",
                                      "name": "Peach Iced Tea",
                                      "price": 1700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138065581",
                                      "name": "   Iced Americano",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222206",
                                      "name": "Medium Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137791739",
                                      "name": "  Mango Ras*",
                                      "price": 2300,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138734343",
                                      "name": "Mango Thick Shake",
                                      "price": 5200,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453324",
                                      "name": "Coke® Zero Can",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "139341941",
                                      "name": " EVM Bobaaa Blast - Reusable Bottle",
                                      "price": 6100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "136882023",
                                      "name": "Caramel Frappe",
                                      "price": 7500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254232",
                                  "groupName": " ADDON 1/2",
                                  "choices": [
                                    {
                                      "id": "130453337",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221981",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221885",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222041",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254233",
                                  "groupName": " ADDON 2/2",
                                  "choices": [
                                    {
                                      "id": "115222037",
                                      "name": "McFlurry® Choc crunch",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221868",
                                      "name": "McFlurry® Oreo",
                                      "price": 5200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221871",
                                      "name": "NO ADDON",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453428",
                                      "name": "Pizza McPuff®",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463380",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378940",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378840",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463382",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378909",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378941",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "104254235",
                                  "groupName": "Extra for Chicken McGrill® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "142190566",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453414",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453413",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428432",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453370",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "30079731"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457658",
                              "name": "McChicken® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "Delightfully crispy chicken sandwich with a crispy chicken patty topped with mayonnaise and shredded iceberg lettuce served on a perfectly toasty bun.",
                              "imageId": "j5f6hvkmwxvte4r6z0mt",
                              "inStock": 1,
                              "price": 23800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260464049",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254089",
                                  "groupName": "Extra for McChicken® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142044500",
                                      "name": "Add  Protein Bun",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453388",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "138011633",
                                      "name": "Add Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080273"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457661",
                              "name": "Chicken McGrill® Double patty Burger",
                              "category": "Double Patty Burgers & Meals",
                              "description": "2 grilled chicken patties served with freshly toasted bun, tomatoes, onions and cool mint sauce",
                              "imageId": "vrutrcwuxhgzbmg35cs7",
                              "inStock": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463240",
                                  "groupName": " Ketchup  Choice",
                                  "choices": [
                                    {
                                      "id": "142378887",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378844",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254165",
                                  "groupName": "Extra for Chicken McGrill® Double patty Burger",
                                  "choices": [
                                    {
                                      "id": "142190570",
                                      "name": "Add    Protein Bun ",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453398",
                                      "name": "Add Double Cheese",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453422",
                                      "name": "Add Cheese",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "130453339",
                                      "name": "Add Whole Wheat Bun",
                                      "price": 1100,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "137428430",
                                      "name": "Add  Multi Millet Bun",
                                      "price": 1700,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079514"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "i7xqlsfln0us8yzbgmjq",
                      "categoryId": "21272791"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737259",
                              "name": "McFlavor Fries  (Med.)",
                              "category": "Sides",
                              "description": "Hi, it’s McFlavor on this side! The all-time favourite fries with a generous dollop of McFlavor yet smoky chipotle sauce.",
                              "imageId": "nicellxiu3czfltrniwa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "79871613"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737260",
                              "name": "McFlavor Fries (Reg.)",
                              "category": "Sides",
                              "description": "Hi, it’s McFlavor on this side! The all-time favourite fries with a generous dollop of McFlavor yet smoky chipotle sauce.",
                              "imageId": "nicellxiu3czfltrniwa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "79871614"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457699",
                              "name": "Medium-Fries",
                              "category": "Sides",
                              "description": "World Famous Fries®. These epic, fan-favourite fries are crispy and golden on the outside and fluffy on the inside.",
                              "imageId": "f8lydfzpcijyqrepiena",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463990",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378870",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378918",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253948",
                                  "groupName": "Extra for Medium-Fries",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "292 ratings",
                                  "ratingCountV2": "292"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005747"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457698",
                              "name": "Large Fries",
                              "category": "Sides",
                              "description": "World Famous Fries®. These epic, fan-favourite fries are crispy and golden on the outside and fluffy on the inside.",
                              "imageId": "wi0hrjmyfit6zxkqffe3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463835",
                                  "groupName": "Ketchup  Choice 2 1/2",
                                  "choices": [
                                    {
                                      "id": "142378948",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378872",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "260463836",
                                  "groupName": "Ketchup  Choice 2 2/2",
                                  "choices": [
                                    {
                                      "id": "142378822",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378806",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254047",
                                  "groupName": "Extra for Large Fries",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "482 ratings",
                                  "ratingCountV2": "482"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005731"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457702",
                              "name": "Small Fries",
                              "category": "Sides",
                              "description": "World Famous Fries®. These epic, fan-favourite fries are crispy and golden on the outside and fluffy on the inside.",
                              "imageId": "yxo2aketiepllsjphsue",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260463913",
                                  "groupName": "Ketchup  Choice 2",
                                  "choices": [
                                    {
                                      "id": "142378870",
                                      "name": "No  Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142378918",
                                      "name": "Complimentary Ketchup",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104253978",
                                  "groupName": "Extra for Small Fries",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "185 ratings",
                                  "ratingCountV2": "185"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005755"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "170844703",
                              "name": "  Chicken Puff",
                              "category": "Sides",
                              "description": "Blend of assorted chicken, mozzarella cheese mixed with tomato sauce and exotic spices stuffed in rectangle shaped savoury dough",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/30/0a70bf9c-9b6a-458f-81fa-a645bccc7ee3_d3bd2ed7-c9f7-46ed-86b1-7ff84ce439d1.png",
                              "inStock": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "103079034"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457703",
                              "name": "Piri Piri Seasoning",
                              "category": "Sides",
                              "description": "The perfect, taste bud tingling partner for our world-famous fries. Shake shake, and dive in!",
                              "imageId": "fzpg845dqylcf8rao2yd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "287 ratings",
                                  "ratingCountV2": "287"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005751"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457705",
                              "name": "Chicken McNuggets® 20pc",
                              "category": "Sides",
                              "description": "Bite-sized pieces of breaded boneless chicken, fried and served hot with smoke-flavoured Barbeque Sauce or Mustard Sauce",
                              "imageId": "b3m7q9mjhiimaoktebyn",
                              "inStock": 1,
                              "price": 39700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254199",
                                  "groupName": "Nuggets DIP 1/3",
                                  "choices": [
                                    {
                                      "id": "115222009",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221891",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254200",
                                  "groupName": "Nuggets DIP 2/3",
                                  "choices": [
                                    {
                                      "id": "115221903",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222164",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254201",
                                  "groupName": "Nuggets DIP 3/3",
                                  "choices": [
                                    {
                                      "id": "115222121",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221900",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254202",
                                  "groupName": "Extra for Chicken McNuggets® 20pc",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "54139311"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457708",
                              "name": "Chicken McNuggets® 9pc",
                              "category": "Sides",
                              "description": "Bite-sized pieces of breaded boneless chicken, fried and served hot with smoke-flavoured Barbeque Sauce or Mustard Sauce",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/6/8cbcde38-fc14-4500-a2c1-0ef43369db38_bbf361c1-b53e-41cf-b581-5ab4e01c7b64.png",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254236",
                                  "groupName": "Nuggets DIP 1/2",
                                  "choices": [
                                    {
                                      "id": "115222060",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222195",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254237",
                                  "groupName": "Nuggets DIP 2/2",
                                  "choices": [
                                    {
                                      "id": "115222147",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222036",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254238",
                                  "groupName": "Extra for Chicken McNuggets® 9pc",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "54139313"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457711",
                              "name": "Chicken McNuggets® 6pc",
                              "category": "Sides",
                              "description": "Bite-sized pieces of breaded boneless chicken, fried and served hot with smoke-flavoured Barbeque Sauce or Mustard Sauce",
                              "imageId": "wwg9chdmfoilpmx2iqgc",
                              "inStock": 1,
                              "price": 16100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254135",
                                  "groupName": "Nuggets DIP",
                                  "choices": [
                                    {
                                      "id": "115222179",
                                      "name": "Barbeque Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115221931",
                                      "name": "Mustard Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "104254136",
                                  "groupName": "Extra for Chicken McNuggets® 6pc",
                                  "choices": [
                                    {
                                      "id": "115677029",
                                      "name": "Add  Smoky    Chipotle Sauce",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115222139",
                                      "name": "Add Piri Piri Seasoning",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "141 ratings",
                                  "ratingCountV2": "141"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "54139312"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115798770",
                              "name": "Medium Fries",
                              "category": "Sides",
                              "description": "World Famous Fries®. These epic, fan-favourite fries are crispy and golden on the outside and fluffy on the inside.",
                              "imageId": "f8lydfzpcijyqrepiena",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "292 ratings",
                                  "ratingCountV2": "292"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005747"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "nicellxiu3czfltrniwa",
                      "categoryId": "21272793"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184407481",
                              "name": " Bobaaa Sundae *",
                              "category": "Desserts",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "112003325"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457736",
                              "name": "Chocolate Brownie Sundae",
                              "category": "Desserts",
                              "imageId": "nkhluilb3xpnvqn3zni6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254350",
                                  "groupName": "Extra for Chocolate Brownie Sundae",
                                  "choices": [
                                    {
                                      "id": "115222208",
                                      "name": "Add Chocolate  Topping*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005701"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457739",
                              "name": "McFlurry® Oreo",
                              "category": "Desserts",
                              "imageId": "hkxcqhy4m6jfebyh0js0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253914",
                                  "groupName": "Extra for McFlurry® Oreo",
                                  "choices": [
                                    {
                                      "id": "115222133",
                                      "name": "Add Oreo  ExtraShot*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080345"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457741",
                              "name": "McFlurry® Choc Crunch",
                              "category": "Desserts",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/9/9/3fa87d10-9806-4485-839e-8c4a8126262c_4c14c169-7c89-40e5-a8e1-694f3676bf50.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254365",
                                  "groupName": "Extra for McFlurry® Choc Crunch",
                                  "choices": [
                                    {
                                      "id": "115221961",
                                      "name": "Add Crunch ExtraShot*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005738"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457744",
                              "name": "StrawberrySundae",
                              "category": "Desserts",
                              "imageId": "sdlhh22ksvt9c3of7sni",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254295",
                                  "groupName": "Extra for StrawberrySundae",
                                  "choices": [
                                    {
                                      "id": "115221986",
                                      "name": "Add Strawberry Topping*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005761"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457747",
                              "name": "Chocolate Sundae",
                              "category": "Desserts",
                              "imageId": "civovt4qrppezyete7qt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254319",
                                  "groupName": "Extra for Chocolate Sundae",
                                  "choices": [
                                    {
                                      "id": "115222208",
                                      "name": "Add Chocolate  Topping*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005703"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457750",
                              "name": "Small McFlurry® Oreo",
                              "category": "Desserts",
                              "imageId": "hkxcqhy4m6jfebyh0js0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254186",
                                  "groupName": "Extra for Small McFlurry® Oreo",
                                  "choices": [
                                    {
                                      "id": "115222133",
                                      "name": "Add Oreo  ExtraShot*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005757"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457752",
                              "name": "Small McFlurry® Choc crunch",
                              "category": "Desserts",
                              "imageId": "mrk2pjv0mgmtbyd7mtsb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254288",
                                  "groupName": "Extra for Small McFlurry® Choc crunch",
                                  "choices": [
                                    {
                                      "id": "115221961",
                                      "name": "Add Crunch ExtraShot*",
                                      "price": 2300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005756"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "nkhluilb3xpnvqn3zni6",
                      "categoryId": "28301860"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457754",
                              "name": "Large Coke ®",
                              "category": "Beverages",
                              "imageId": "bpemo1ivwgqkchia8uij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005719"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457755",
                              "name": "Large Fanta",
                              "category": "Beverages",
                              "imageId": "nnbsl2ytdpssdu2vhdeb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005730"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457757",
                              "name": "Large Sprite",
                              "category": "Beverages",
                              "imageId": "at9casntpac410sqjszk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005732"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457759",
                              "name": "Medium Coke",
                              "category": "Beverages",
                              "imageId": "bpemo1ivwgqkchia8uij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "136 ratings",
                                  "ratingCountV2": "136"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005745"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457762",
                              "name": "Medium Fanta",
                              "category": "Beverages",
                              "imageId": "nnbsl2ytdpssdu2vhdeb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005746"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457764",
                              "name": "Medium Sprite",
                              "category": "Beverages",
                              "imageId": "at9casntpac410sqjszk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005748"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457765",
                              "name": "Cold Coffee",
                              "category": "Beverages",
                              "description": "A rich smooth creamy cold coffee made with coffee powder and milk.",
                              "imageId": "lnvffebavfrkpp2qvjxl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254149",
                                  "groupName": "Extra for Cold Coffee",
                                  "choices": [
                                    {
                                      "id": "115221949",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "186 ratings",
                                  "ratingCountV2": "186"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30079662"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "184407482",
                              "name": "   Bobaaa Sprite",
                              "category": "Beverages",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/27/3e535c89-274d-4b23-8691-ec570af82ab8_e561a0f2-564e-4b3a-ae87-3dda46440b3b.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "247856611",
                                  "groupName": "Extra for    Bobaaa Sprite",
                                  "choices": [
                                    {
                                      "id": "115221949",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "112003324"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457766",
                              "name": "Chocolate Milk shake",
                              "category": "Beverages",
                              "description": "Specially curated milk based beverage for indian kids with rich chocolate taste and no artificial colors, flavors & preservatives",
                              "imageId": "emfbudaoxk1drkqmw1hz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "45005702"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457767",
                              "name": "Minute Maid Pulpy Orange",
                              "category": "Beverages",
                              "imageId": "s5to0jlcitltkgvr4ykj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8929,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080624"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457770",
                              "name": "Ice Tea",
                              "category": "Beverages",
                              "description": "A sweet tangy lime flavored tea",
                              "imageId": "s5ojkyxx9sueghdeq0fj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080022"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457772",
                              "name": "Small Coke ®",
                              "category": "Beverages",
                              "imageId": "bpemo1ivwgqkchia8uij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253864",
                                  "groupName": "Extra for Small Coke ®",
                                  "choices": [
                                    {
                                      "id": "115221949",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005753"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457774",
                              "name": "Small Fanta",
                              "category": "Beverages",
                              "imageId": "nnbsl2ytdpssdu2vhdeb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104253935",
                                  "groupName": "Extra for Small Fanta",
                                  "choices": [
                                    {
                                      "id": "115221949",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005754"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457775",
                              "name": "Small Sprite",
                              "category": "Beverages",
                              "imageId": "at9casntpac410sqjszk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "104254337",
                                  "groupName": "Extra for Small Sprite",
                                  "choices": [
                                    {
                                      "id": "115221949",
                                      "name": "Add Reusable Bottle",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005758"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457780",
                              "name": "Masala Chai",
                              "category": "Beverages",
                              "description": "Masala chai is a smooth and spicy blend of natural tea extract, milk solids, black pepper, fennel, clove and cinnamon.",
                              "imageId": "lhfxdxo65xxvsc3ayrfs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "30080138"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457783",
                              "name": "Schweppes™ Bottled Water",
                              "category": "Beverages",
                              "imageId": "erbjhptcs2v9ieaouuly",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5085,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "45005752"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "bpemo1ivwgqkchia8uij",
                      "categoryId": "21272796"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Condiments",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457784",
                              "name": "Barbeque Dip",
                              "category": "Condiments",
                              "imageId": "nmssr6mrtbvymj6lyfjs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005694"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457786",
                              "name": "Mustard Dip",
                              "category": "Condiments",
                              "imageId": "iqc0f1yzwbcgfmhyzwvw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 0"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005750"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457788",
                              "name": "Chilli Sauce",
                              "category": "Condiments",
                              "imageId": "qpytmuoblhprjo5pv7ie",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 179,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005700"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88457789",
                              "name": "Ketchup",
                              "category": "Condiments",
                              "imageId": "mdaqkikng65wrwr00n3i",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "115 ratings",
                                  "ratingCountV2": "115"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "45005718"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136737261",
                              "name": " Smoky    Chipotle Sauce",
                              "category": "Condiments",
                              "description": "Smoky Chipotle Sauce",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "80361480"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "nmssr6mrtbvymj6lyfjs",
                      "categoryId": "21272797"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11413010000005"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "McDonald's",
                      "area": "Maharana Pratap Nagar",
                      "completeAddress": "Mp Bhopal Db Mall,  Shop No. R2, 3Rd Floor. D.B City Mall, Opp. M.P. Nagar, Arera Hills, Bhopal- 462011"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "zhvn15bSU9Ql-MFfN_xhsBdhYgAppYp8BM2i_7pk"
},

  "501801":{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Amer Bakery Hut",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "1016444",
              "name": "Amer Bakery Hut",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "amer-bakery-hut-jahangirabad-jahangirabad",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/3/63ffaa41-82d0-4cb1-84f1-1264386a22be_1016444 (1).jpg",
              "locality": "Jahangirabad",
              "areaName": "Jahangirabad",
              "costForTwo": "29900",
              "costForTwoMessage": "₹299 for two",
              "cuisines": [
                "Bakery",
                "Desserts"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "1016444",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "7107",
              "avgRatingString": "4.3",
              "totalRatingsString": "165 ratings",
              "sla": {
                "restaurantId": "1016444",
                "deliveryTime": 32,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 35,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 1004,
                "slaString": "30-35 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-08 03:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "40% off",
                "shortDescriptionList": [
                  {
                    "meta": "40% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "40% off up to ₹80 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "amer-bakery-hut-jahangirabad-jahangirabad",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Amer Bakery Hut Sanjay Taran Pushkar Pari Park Idgah Hills Road ,Huzur,Bhopal,Madhya Pradesh-462001\t"
                },
                {
                  "title": "Cuisines",
                  "message": "Bakery,Desserts"
                }
              ],
              "totalRatings": 165,
              "aggregatedDiscountInfoV2": {
                "header": "40% off",
                "shortDescriptionList": [
                  {
                    "meta": "40% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "40% off up to ₹80 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/1016444"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.26506250000001,77.3889589576721",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              }
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 2,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "40% OFF UPTO ₹80",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "152cd3bf-ce78-4685-ad4e-1761fcd6dade"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹169",
                      "offerType": "offers",
                      "restId": "1016444",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "1016444",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7703110",
                          "creativeId": "TopPicks2024/186204460F.png",
                          "title": "Pinapple Cake [500 g]",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "186204460",
                              "name": "Pinapple Cake [500 g]",
                              "category": "Cakes",
                              "description": "Light vanilla sponge layered with pineapple chunks and whipped cream. [500g]",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/7/17368e3a-d67a-42de-acc5-968d7710a6c1_4c0d3206-e883-4a22-bc44-77f1c382dbf1.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "108592168"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179327381",
                              "name": "Chocolate Truffle Pastry",
                              "category": "Pastries",
                              "description": "Rich and indulgent chocolate pastry layered with smooth truffle ganache. [100g]\n",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/15/447dc0d0-6c65-42cf-867b-88de5fdeff85_a0e77aba-31ff-4841-bd4b-dfef112cc30a.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "31423538"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179327466",
                              "name": "Swiss Truffle Pastry",
                              "category": "Pastries",
                              "description": "Decadent pastry made with rich Swiss chocolate and a smooth, creamy truffle layer. [100g]",
                              "imageId": "jrajtr4i5xox6hmjnrj0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31424008"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179327400",
                              "name": "Blueberry Cheesecake Pastry",
                              "category": "Pastries",
                              "description": "Light vanilla sponge layered with blueberry compote and whipped cream. [100g]",
                              "imageId": "ujdkuluitmt8zqmrdxsk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "31423358"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "183937825",
                              "name": "Oreo Nutella Cheese Pastry",
                              "category": "Pastries",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/13/79447ffb-8e3f-4fe7-b9b3-bcef5b0662fe_4cbbd4df-37f2-4b2a-a781-e4b6b244dc18.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "80364712"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193868",
                              "name": "Paneer Kathi Roll",
                              "category": "Rolls",
                              "description": "Tandoori Paneer Tikka, Peppers, And Onions Wrapped In A Warm Flaky Paratha With Spiced Mayo And Tangy Sauces.",
                              "imageId": "llg9esqx9fepphqzql1w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "31423848"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "179327819",
                              "name": "Veg Burnt Garlic Noodles",
                              "category": "Noodles & Fried Rice",
                              "description": "Noodles With Veggies And Smoky Burnt Garlic.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/dad10b54-fe26-418b-9683-fb69cd89a490_7037bd7f-dcd9-469d-ac8a-9e4aca610cfd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962096",
                                  "groupName": "Soup",
                                  "choices": [
                                    {
                                      "id": "142467725",
                                      "name": "Broccoli & Almond Soup 300 Ml",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467726",
                                      "name": "Veg Manchow Soup 300 Ml",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467727",
                                      "name": "Mushroom Cream Soup",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467722",
                                      "name": "Veg Hot N Sour Soup 300 Ml",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467723",
                                      "name": "Cream Of Tomato Soup 300 Ml",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467724",
                                      "name": "Chicken Manchow Soup 300 Ml",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "91052221"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Breads",
                      "categories": [
                        {
                          "title": "Breads",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327712",
                                  "name": "Milk Bread ( Small )",
                                  "category": "Breads",
                                  "description": "Soft And Fluffy White Bread Made With Milk For A Rich And Tender Texture.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423783"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204453",
                                  "name": "Garlic Loaf [250 G]",
                                  "category": "Breads",
                                  "description": "Soft, Buttery Bread Loaf Flavoured With Garlic Perfect For Toasting Or Sandwiches.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478860"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204483",
                                  "name": "Whole Wheat Multigrain Bread [450 G]",
                                  "category": "Breads",
                                  "description": "Nutritious Bread Made With Whole Wheat And A Mix Of Grains For Added Fiber.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110163908"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327423",
                                  "name": "Atta Bread",
                                  "category": "Breads",
                                  "description": "Healthy Whole Wheat Bread, Ideal For Sandwiches Or Toast.",
                                  "imageId": "b8b5ec7e8d20a617b08d45a0f45c519c",
                                  "isVeg": 1,
                                  "price": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "66534908"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677647"
                        },
                        {
                          "title": "Indian Breads",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327544",
                                  "name": "Plain Tandoori Roti",
                                  "category": "Breads",
                                  "description": "Classic Whole Wheat Roti Cooked In A Tandoor.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478896"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327471",
                                  "name": "Missi Roti",
                                  "category": "Breads",
                                  "description": "Spiced Whole Wheat Flatbread Made With Gram Flour.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/520ac936-d111-4388-a553-4410692af923_95331bb3-ead3-4d13-908d-b573a2267533.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423786"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327448",
                                  "name": "Butter Naan",
                                  "category": "Breads",
                                  "description": "Soft Leavened Bread Brushed With Butter.",
                                  "imageId": "329f8195a751ca91de12177604599f17",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423384"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327538",
                                  "name": "Lachha Paratha",
                                  "category": "Breads",
                                  "description": "Multi-Layered, Flaky Indian Flatbread Cooked With Ghee.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/fd898026-334e-48ce-a40a-cbe1543ab726_e6944a56-2d7e-4429-89ff-3780596dfae6.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "60352970"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327542",
                                  "name": "Garlic Naan",
                                  "category": "Breads",
                                  "description": "Tandoori Naan Topped With Minced Garlic And Herbs.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423678"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327799",
                                  "name": "Stuffed Kulcha With Paneer",
                                  "category": "Breads",
                                  "description": "Soft, Leavened Indian Bread Stuffed With Spiced Paneer Filling, Cooked In A Tandoor.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "46124546"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327440",
                                  "name": "Amritsari Kulcha",
                                  "category": "Breads",
                                  "description": "Punjabi-Style Stuffed Kulcha With Flavourful Masala Filling.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/6/0c0f47af-75b7-44e0-99a6-b1f240da5dd1_4ffbcfcb-bc65-4fc8-8ba1-9bf4f55cbddb.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423322"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829062",
                                  "name": "Plain Naan",
                                  "category": "Breads",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423905"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327740",
                                  "name": "Rumali Roti ",
                                  "category": "Breads",
                                  "description": "Thin, Soft Indian Flatbread Folded Like A Handkerchief, Served With Curries Or Kebabs.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423954"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193687",
                                  "name": "Paneer Kulcha",
                                  "category": "Breads",
                                  "description": "Flatbread Stuffed With Spiced Paneer Filling.",
                                  "isVeg": 1,
                                  "price": 12000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423850"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193684",
                                  "name": "Chicken Kulcha",
                                  "category": "Breads",
                                  "description": "Soft Stuffed Flatbread With Spicy Chicken Filling.",
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423463"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677751"
                        }
                      ],
                      "image": "b8b5ec7e8d20a617b08d45a0f45c519c",
                      "categoryId": "69677645"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Lebanese & Mexican",
                      "categories": [
                        {
                          "title": "Lebanese",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193695",
                                  "name": "Veg Falafel",
                                  "category": "Lebanese & Mexican",
                                  "description": "Deep-Fried Chickpea Balls Served With Hummus And Salad.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226093",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Extra Cheese",
                                            "default": 1,
                                            "id": "207124691",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Fries",
                                            "id": "207124692",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307267"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193833",
                                  "name": "Chicken Shawarma",
                                  "category": "Lebanese & Mexican",
                                  "description": "Juicy Chicken Slices Wrapped In Pita Bread With Garlic Sauce And Veggies.",
                                  "imageId": "wwxs2jkvex9m16hzbkq8",
                                  "inStock": 1,
                                  "price": 32500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226086",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Fries",
                                            "default": 1,
                                            "id": "207124678",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Extra Cheese",
                                            "id": "207124677",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423487"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193834",
                                  "name": "Lebanese Platter ",
                                  "category": "Lebanese & Mexican",
                                  "description": "Pita Chips + Hummus + Baba Ganoush + Tzatziki Sauce",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/1979f574-fd9c-41ff-bd8c-3970a29ab979_98fc8ff2-4a54-4d0e-b285-80f03d2a772a.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226087",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Extra Cheese",
                                            "default": 1,
                                            "id": "207124679",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Fries",
                                            "id": "207124680",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423762"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677741"
                        },
                        {
                          "title": "Mexican",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193737",
                                  "name": "Veg Burrito Wrap",
                                  "category": "Lebanese & Mexican",
                                  "description": "A Tortilla Wrap Stuffed With Veggies, Beans, And Mexican Flavors.",
                                  "imageId": "peiczeonsh4yf6undw29",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424072"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193718",
                                  "name": "Veg Burrito Bowl",
                                  "category": "Lebanese & Mexican",
                                  "description": "Rice, Beans, Veggies, Salsa, And Sauces Served In A Bowl.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "95307266"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327484",
                                  "name": "Non-Veg Burrito Wrap",
                                  "category": "Lebanese & Mexican",
                                  "description": "A Hearty Tortilla Wrap Filled With Chicken, Rice, Beans, And Sauces.",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307234"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327494",
                                  "name": "Non-Veg Burrito Bowl",
                                  "category": "Lebanese & Mexican",
                                  "description": "Rice, Beans, Chicken, Salsa, And Sauces Served In A Bowl.",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307233"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968723",
                                  "name": "Veg Quesadilla",
                                  "category": "Lebanese & Mexican",
                                  "description": "Soft tortillas stuffed with spicy Chipotle style vegetables oozing with cheese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/6bf41c57-5457-4516-8845-ca97f8176fbb_2b700d01-b748-4dd3-8311-d1d2854ae9cc.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818545"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968682",
                                  "name": "Chicken Quesadilla",
                                  "category": "Lebanese & Mexican",
                                  "description": "Grilled tortilla stuffed with spicy chicken, cheese and veggies.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/6bf41c57-5457-4516-8845-ca97f8176fbb_2b700d01-b748-4dd3-8311-d1d2854ae9cc.JPG_compressed",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818533"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968632",
                                  "name": "Veg Loaded Nachos",
                                  "category": "Lebanese & Mexican",
                                  "description": "Bowlful of nachos topped with refried beans, sour cream, Cheddar cheese, Salsa, jalapenos & black olives. A game day must-have",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/962f9d0f-f5e2-48c9-8b1a-cf3794c3a62a_005cd9f8-83d2-45d7-8358-7537677e746f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775174"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968620",
                                  "name": "Chicken Loaded Nachos",
                                  "category": "Lebanese & Mexican",
                                  "description": "Bowlful of nachos topped with chicken, refried beans, sour cream, Cheddar cheese, Salsa, jalapenos & black olives. A game day must-have",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818531"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677758"
                        }
                      ],
                      "image": "wwxs2jkvex9m16hzbkq8",
                      "categoryId": "69677740"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cakes",
                      "categories": [
                        {
                          "title": "Traditional Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204460",
                                  "name": "Pinapple Cake [500 g]",
                                  "category": "Cakes",
                                  "description": "Light vanilla sponge layered with pineapple chunks and whipped cream. [500g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/7/17368e3a-d67a-42de-acc5-968d7710a6c1_4c0d3206-e883-4a22-bc44-77f1c382dbf1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592168"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327967",
                                  "name": "Chocolate Truffle Cake",
                                  "category": "Cakes",
                                  "description": "A rich, moist chocolate cake layered with decadent chocolate ganache.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226145",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "500G",
                                            "default": 1,
                                            "id": "207124805",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1000G",
                                            "price": 47000,
                                            "id": "207124806",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "60848474"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327609",
                                  "name": "Black Forest Cake [500g]",
                                  "category": "Cakes",
                                  "description": "Chocolate sponge layered with cherries and whipped cream, topped with choco shavings.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108592154"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327404",
                                  "name": "Rainbow Cake",
                                  "category": "Cakes",
                                  "description": "A vibrant multi-colored sponge cake layered with vanilla cream frosting.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 57500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "37412425"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677718"
                        },
                        {
                          "title": "Premium Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327835",
                                  "name": "Royal Pineapple Cake",
                                  "category": "Cakes",
                                  "description": "Classic pineapple sponge cake with premium pineapple filling and whipped cream. [500g & 750g]\n",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226125",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "500G",
                                            "default": 1,
                                            "id": "207124764",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "750G",
                                            "price": 30800,
                                            "id": "207124765",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423952"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327453",
                                  "name": "Double Trouble Choco Cake",
                                  "category": "Cakes",
                                  "description": "Indulgent double-layered chocolate cake with dark and milk chocolate richness. [500g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 50000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592161"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327971",
                                  "name": "Rasmalai Pastry",
                                  "category": "Cakes",
                                  "description": "Traditional rasmalai flavors blended into a soft and creamy pastry.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108592171"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327876",
                                  "name": "Swiss Truffle Cake",
                                  "category": "Cakes",
                                  "description": "Smooth chocolate cake with creamy Swiss truffle layers for a melt-in-mouth feel. [500g & 750g}",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 70000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226128",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "500G",
                                            "default": 1,
                                            "id": "207124770",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "750G",
                                            "price": 35000,
                                            "id": "207124771",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478918"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327559",
                                  "name": "Begiam Chocolate Cake",
                                  "category": "Cakes",
                                  "description": "Dense, moist cake made with rich Belgian chocolate and layered with ganache.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/85ae62e5-6533-43d1-9852-8a5d8f3f04e9_33071c5b-9450-4718-b8f9-b5abce14101e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 72500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226101",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "500G",
                                            "default": 1,
                                            "id": "207124707",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "750G",
                                            "price": 36700,
                                            "id": "207124708",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592152"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327564",
                                  "name": "Red Velvet Choco Delight Cake",
                                  "category": "Cakes",
                                  "description": "A rich fusion of classic red velvet and indulgent chocolate, layered with smooth cream cheese frosting and chocolate ganache for a decadent treat. [500g & 750]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 70000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226104",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "550G",
                                            "default": 1,
                                            "id": "207124715",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "750G",
                                            "price": 27500,
                                            "id": "207124716",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478902"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327367",
                                  "name": "The Great biscoff Cake",
                                  "category": "Cakes",
                                  "description": "Moist sponge with layers of Biscoff spread and crushed Biscoff biscuits.",
                                  "isVeg": 1,
                                  "price": 80000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592176"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677668"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/7/17368e3a-d67a-42de-acc5-968d7710a6c1_4c0d3206-e883-4a22-bc44-77f1c382dbf1.jpg",
                      "categoryId": "69677667"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cookie",
                      "categories": [
                        {
                          "title": "Cookie",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204437",
                                  "name": "Almond Biscotti [150 Gm]",
                                  "category": "Cookie",
                                  "description": "Twice-Baked Italian-Style Crisp Biscuits With Chunks Of Almonds.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84528949"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204440",
                                  "name": "Oatmeal & Raisin Cookies [150 Gm]",
                                  "category": "Cookie",
                                  "description": "Soft And Chewy Cookies Loaded With Oats And Sweet Raisins.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18400,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84528952"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204452",
                                  "name": "Dark Couverture Chocolate Cookies [150 Gm]",
                                  "category": "Cookie",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20400,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84528951"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327929",
                                  "name": "Couverture Chocolate Cookies [150gm]'",
                                  "category": "Cookie",
                                  "description": "Rich, Decadent Cookies Made With Premium Couverture Chocolate.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20400,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84528950"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204426",
                                  "name": "Butter Cookies [150 Gm]",
                                  "category": "Cookie",
                                  "description": "Classic Crisp And Golden Cookies Made With Rich Butter, Perfect For Tea-Time Snacking",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84381307"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204438",
                                  "name": "Cashew Biscotti [150 Gm]",
                                  "category": "Cookie",
                                  "description": "Crunchy Biscotti Made With Roasted Cashew Pieces For A Rich, Nutty Taste.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "84381312"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677636"
                        }
                      ],
                      "categoryId": "69677635"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastries",
                      "categories": [
                        {
                          "title": "Traditional Pastry",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327795",
                                  "name": "Pinapple Pastry",
                                  "category": "Pastries",
                                  "description": "Soft sponge layered with light pineapple cream and chunks, topped with fruity glaze. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108592169"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327381",
                                  "name": "Chocolate Truffle Pastry",
                                  "category": "Pastries",
                                  "description": "Rich and indulgent chocolate pastry layered with smooth truffle ganache. [100g]\n",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/15/447dc0d0-6c65-42cf-867b-88de5fdeff85_a0e77aba-31ff-4841-bd4b-dfef112cc30a.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423538"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327371",
                                  "name": "Black Forest Pastry",
                                  "category": "Pastries",
                                  "description": "Classic chocolate sponge pastry filled with whipped cream and cherry filling. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423353"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327365",
                                  "name": "Rainbow Pastry",
                                  "category": "Pastries",
                                  "description": "Soft multi-colored layers with light vanilla cream treat for the eyes. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "37412426"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677653"
                        },
                        {
                          "title": "Premium Pastry",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327426",
                                  "name": "Royal Pinapple Pastry",
                                  "category": "Pastries",
                                  "description": "Tropical pineapple-flavoured pastry with soft sponge and creamy filling. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108592174"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327363",
                                  "name": "Double Trouble Chocolate Pastry",
                                  "category": "Pastries",
                                  "description": "A chocolate lover's dream with double layers of moist chocolate and fudge. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592162"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327474",
                                  "name": "Belgiam Chocolate Crunchy Pastry",
                                  "category": "Pastries",
                                  "description": "Premium Belgian chocolate pastry with dark, moist layers and rich ganache.[100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592153"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327466",
                                  "name": "Swiss Truffle Pastry",
                                  "category": "Pastries",
                                  "description": "Decadent pastry made with rich Swiss chocolate and a smooth, creamy truffle layer. [100g]",
                                  "imageId": "jrajtr4i5xox6hmjnrj0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424008"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327400",
                                  "name": "Blueberry Cheesecake Pastry",
                                  "category": "Pastries",
                                  "description": "Light vanilla sponge layered with blueberry compote and whipped cream. [100g]",
                                  "imageId": "ujdkuluitmt8zqmrdxsk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423358"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327397",
                                  "name": "All New Triple Layer Pastry",
                                  "category": "Pastries",
                                  "description": "Three flavorful layers of sponge and cream for a perfect bite every time. [100g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/8/14/5a8e1b99-487c-4c0c-afb0-140592534653_8672cd58-442a-42c3-94d4-aa3aa911c0bf.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108619940"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327486",
                                  "name": "Red Velvet Choco Pastry",
                                  "category": "Pastries",
                                  "description": "Red velvet pastry with a hint of chocolate and cream cheese frosting. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592172"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327553",
                                  "name": "Chicago Pastry ",
                                  "category": "Pastries",
                                  "description": "Dense chocolate pastry inspired by Chicago fudge cake richness. [100g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/27781b4d-a485-48b7-86ef-8d5cf4eb0c44_beebb71f-2965-4fb6-b38b-9eb5f7bee795.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592155"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183937825",
                                  "name": "Oreo Nutella Cheese Pastry",
                                  "category": "Pastries",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/13/79447ffb-8e3f-4fe7-b9b3-bcef5b0662fe_4cbbd4df-37f2-4b2a-a781-e4b6b244dc18.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "80364712"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183937848",
                                  "name": "Red Velvet Choco Pastry [100 G]",
                                  "category": "Pastries",
                                  "description": "Red velvet pastry with a hint of chocolate and cream cheese frosting.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111771557"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327424",
                                  "name": "The Great Biscoff Pastry",
                                  "category": "Pastries",
                                  "description": "Creamy Biscoff spread layered in soft sponge with a caramel crunch. [100g]",
                                  "isVeg": 1,
                                  "price": 18000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "86368178"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183937847",
                                  "name": "The Great Biscoff Pastry [100 G]",
                                  "category": "Pastries",
                                  "description": "Creamy biscoff spread layered in soft sponge with a caramel crunch.",
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111771558"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677651"
                        },
                        {
                          "title": "Dry Cake",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327369",
                                  "name": "Marble Dry Cake",
                                  "category": "Pastries",
                                  "description": "Soft cake swirled with vanilla and chocolate for a rich marble effect. [200g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961875",
                                      "groupName": "Pastry",
                                      "choices": [
                                        {
                                          "id": "142467673",
                                          "name": "Mango Choco Delight Pastry",
                                          "price": 14000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467674",
                                          "name": "Double Trouble Chocolate Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467675",
                                          "name": "Chocolate Eclair [100 G]",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467665",
                                          "name": "Pinapple Pastry",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467670",
                                          "name": "Blueberry Cheesecake Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467671",
                                          "name": "All New Triple Layer Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467672",
                                          "name": "Rainbow Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467666",
                                          "name": "Chocolate Truffle Pastry",
                                          "price": 10200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467667",
                                          "name": "Belgiam Chocolate Crunchy Pastry",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467668",
                                          "name": "Swiss Truffle Pastry",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467669",
                                          "name": "Black Forest Pastry",
                                          "price": 11500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592165"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327392",
                                  "name": "Choco Chips Dry Cake",
                                  "category": "Pastries",
                                  "description": "Moist vanilla cake generously studded with chocolate chips in every bite. [200g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/06da53a2-1b2c-4753-9e43-65c8d43d29d9_a727f293-d4c0-42ca-afbc-6f3403ed4c12.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961908",
                                      "groupName": "Pastry",
                                      "choices": [
                                        {
                                          "id": "142467673",
                                          "name": "Mango Choco Delight Pastry",
                                          "price": 14000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467674",
                                          "name": "Double Trouble Chocolate Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467675",
                                          "name": "Chocolate Eclair [100 G]",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467665",
                                          "name": "Pinapple Pastry",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467670",
                                          "name": "Blueberry Cheesecake Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467671",
                                          "name": "All New Triple Layer Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467672",
                                          "name": "Rainbow Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467666",
                                          "name": "Chocolate Truffle Pastry",
                                          "price": 10200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467667",
                                          "name": "Belgiam Chocolate Crunchy Pastry",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467668",
                                          "name": "Swiss Truffle Pastry",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467669",
                                          "name": "Black Forest Pastry",
                                          "price": 11500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592157"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327764",
                                  "name": "Dry Fruits Tea Cake",
                                  "category": "Pastries",
                                  "description": "Soft and moist cake packed with assorted dry fruits, offering a rich, nutty sweetness in every bite. [200g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962056",
                                      "groupName": "Pastry",
                                      "choices": [
                                        {
                                          "id": "142467769",
                                          "name": "Chicago Pastry",
                                          "price": 18000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467666",
                                          "name": "Chocolate Truffle Pastry",
                                          "price": 10200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467667",
                                          "name": "Belgiam Chocolate Crunchy Pastry",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467668",
                                          "name": "Swiss Truffle Pastry",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467669",
                                          "name": "Black Forest Pastry",
                                          "price": 11500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467768",
                                          "name": "Oreo Nutella Cheese Pastry",
                                          "price": 16800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467673",
                                          "name": "Mango Choco Delight Pastry",
                                          "price": 14000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467674",
                                          "name": "Double Trouble Chocolate Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467675",
                                          "name": "Chocolate Eclair [100 G]",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467665",
                                          "name": "Pinapple Pastry",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467670",
                                          "name": "Blueberry Cheesecake Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467671",
                                          "name": "All New Triple Layer Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467672",
                                          "name": "Rainbow Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592163"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327383",
                                  "name": "Orange Dry Cake",
                                  "category": "Pastries",
                                  "description": "Light and zesty sponge cake with a refreshing orange flavour. [200g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/849a31d0-fe8e-4e23-a459-81b52bcef27d_6966649e-17cf-4891-bf7e-87f7f01f002e.jpg",
                                  "isVeg": 1,
                                  "price": 16600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961892",
                                      "groupName": "Pastry",
                                      "choices": [
                                        {
                                          "id": "142467673",
                                          "name": "Mango Choco Delight Pastry",
                                          "price": 14000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467674",
                                          "name": "Double Trouble Chocolate Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467675",
                                          "name": "Chocolate Eclair [100 G]",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467665",
                                          "name": "Pinapple Pastry",
                                          "price": 9000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467670",
                                          "name": "Blueberry Cheesecake Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467671",
                                          "name": "All New Triple Layer Pastry",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467672",
                                          "name": "Rainbow Pastry",
                                          "price": 12000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467666",
                                          "name": "Chocolate Truffle Pastry",
                                          "price": 10200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467667",
                                          "name": "Belgiam Chocolate Crunchy Pastry",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467668",
                                          "name": "Swiss Truffle Pastry",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467669",
                                          "name": "Black Forest Pastry",
                                          "price": 11500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592167"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677669"
                        },
                        {
                          "title": "Muffins",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327513",
                                  "name": "Choco Chip Muffin",
                                  "category": "Pastries",
                                  "description": "Moist muffin loaded with rich chocolate chips for a sweet treat. [100g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/021abf84-0d46-4c7b-9518-98b0662df5a9_c1346b13-45d9-4a0c-890e-db9245c637c8.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "95307198"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327518",
                                  "name": "Marble Muffin",
                                  "category": "Pastries",
                                  "description": "Soft muffin with a delightful swirl of vanilla and chocolate batter. [100g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/e785cd26-67f2-41b6-aa26-1e4d40449c70_1536a8ef-7da7-4903-b415-682d2f2aab04.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108592166"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327690",
                                  "name": "Dry Fruits Muffins",
                                  "category": "Pastries",
                                  "description": "Nutritious muffins packed with assorted dry fruits for a wholesome bite. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "88594098"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327388",
                                  "name": "Orange Muffin",
                                  "category": "Pastries",
                                  "description": "Zesty and fluffy muffin infused with refreshing orange flavour. [100g]",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/6ad37efa-6575-4888-b782-c4a028c0cdae_1fd79f5e-0ded-4918-a91c-ef4f8e3bc9f1.jpg",
                                  "isVeg": 1,
                                  "price": 8600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "88594100"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677731"
                        },
                        {
                          "title": "Gourmet Treats",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193783",
                                  "name": "Cream Roll",
                                  "category": "Pastries",
                                  "description": "Soft sponge roll filled with sweet whipped cream or flavored filling.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423585"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327460",
                                  "name": "Swiss Love Donut",
                                  "category": "Pastries",
                                  "description": "Donut filled with creamy Swiss chocolate and topped with powdered sugar. [100g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "42721675"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204442",
                                  "name": "Dark Knight Donut [100 G]",
                                  "category": "Pastries",
                                  "description": "Rich chocolate donut with decadent dark chocolate glaze.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/19/6459c2b2-1467-40d9-aa62-346e4aefb4a2_c3d80765-41b7-420e-a9a8-e2e6a471e16c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231929"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204458",
                                  "name": "Chocolate Eclair [100 G]",
                                  "category": "Pastries",
                                  "description": "Choux pastry filled with rich cream and topped with glossy chocolate glaze.",
                                  "imageId": "txhrqkjpq8h2fprrrabu",
                                  "inStock": 1,
                                  "price": 12000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231926"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327477",
                                  "name": "Chocolate Pyramid",
                                  "category": "Pastries",
                                  "description": "Triangular chocolate dessert with layered mousse or ganache. [100g]",
                                  "price": 9000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423528"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677663"
                        },
                        {
                          "title": "Brownie",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327986",
                                  "name": "Choco Chips Brownie",
                                  "category": "Pastries",
                                  "description": "Fudgy brownie loaded with rich chocolate chips in every bite.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478838"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183937864",
                                  "name": "All New Walnut Brownie With Egg",
                                  "category": "Pastries",
                                  "description": "Decadent brownie blended with crunchy walnut pieces for added texture.",
                                  "inStock": 1,
                                  "price": 13800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "60352966"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193661",
                                  "name": "American Brownie",
                                  "category": "Pastries",
                                  "description": "Classic dense and chewy chocolate brownie, American-style.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/18/166047ca-b1db-44b5-90aa-5542cc4a196d_ff9776de-0587-45cd-bf0a-506913fa48bc.JPG",
                                  "inStock": 1,
                                  "price": 16000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423315"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327374",
                                  "name": "Millionaire Brownie",
                                  "category": "Pastries",
                                  "description": "A rich layered brownie with caramel, shortbread, and a chocolate topping.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "66534917"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327385",
                                  "name": "All New Walnut Brownie",
                                  "category": "Pastries",
                                  "description": "Decadent brownie blended with crunchy walnut pieces for added texture.",
                                  "isVeg": 1,
                                  "price": 14000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478794"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677672"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/1/15/447dc0d0-6c65-42cf-867b-88de5fdeff85_a0e77aba-31ff-4841-bd4b-dfef112cc30a.JPG",
                      "categoryId": "69677649"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Starters",
                      "categories": [
                        {
                          "title": "Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327528",
                                  "name": "Sauteed Vegetable [Serves 1-2]",
                                  "category": "Starters",
                                  "description": "Lightly Stir-Fried Seasonal Vegetables With Herbs.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478909"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327531",
                                  "name": "Honey Chilli Potato [Serves 1-2]",
                                  "category": "Starters",
                                  "description": "Crispy Potato Tossed In Sweet & Spicy Indo-Chinese Style Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/c96aa9da-481b-4162-8772-863f03439f3d_18635127-7f43-4e51-9b3f-f515ff61c6e7.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478862"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327529",
                                  "name": "Burnt Garlic Paneer [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Tossed Paneer Cubes With Garlic And Soy In A Smoky, Spicy Sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478809"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327520",
                                  "name": "Schezwan Paneer [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Crunchy Rolls Stuffed With Spinach, Corn, And Cheese.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478913"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327687",
                                  "name": "Hunan Style Paneer Dry [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "A Spicy Dry Stir Fried Paneer Tossed In Savory & Spicy Sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478868"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327679",
                                  "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Our In House Garlic Bread Baked With Cheddar & Mozzarella Cheese & Chilies",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/8cd4e492-1a88-4d14-a6c0-c79415a12d00_6b926c18-1364-48d9-a07a-5e9a85e0816a.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962018",
                                      "groupName": "Pizza",
                                      "choices": [
                                        {
                                          "id": "142467754",
                                          "name": "Veg Kothe [Serves 2]",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478924"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204520",
                                  "name": "Hunan Style Manchurian Dry [Serves 2]",
                                  "category": "Starters",
                                  "description": "A Spicy Dry Stir Fried Manchurian Tossed In Savory & Spicy Sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961919",
                                      "groupName": "Fried rice",
                                      "choices": [
                                        {
                                          "id": "142467720",
                                          "name": "Veg Burnt Chilli Garlic Fried Rice",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467721",
                                          "name": "Egg Fried Rice",
                                          "price": 22200,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961917",
                                      "groupName": "Noodles",
                                      "choices": [
                                        {
                                          "id": "142467718",
                                          "name": "Veg Schezwan Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467719",
                                          "name": "Veg Burnt Garlic Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467717",
                                          "name": "Veg Hakka Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231935"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327524",
                                  "name": "Chilli Paneer Dry [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Crispy Paneer Cubes Tossed In A Spicy Indo-Chinese Chilli Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/07c72886-ea38-4872-af3a-1da0e4847d5b_4d60ea17-42fe-4ee6-94f7-d3b7e0d1aa2d.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 31300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478833"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327649",
                                  "name": "Paneer Tikka [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Soft Paneer, Bell Peppers, Onion & Tomato Marinated With Yogurt & Indian Spices And Grilled On Live Charcoal.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/5bc99a7e-30aa-466b-84e7-72ec486f6814_33382cbd-9b68-4eb7-9ccf-b05d857a9321.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962012",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962013",
                                      "groupName": "Roti",
                                      "choices": [
                                        {
                                          "id": "142467750",
                                          "name": "Rumali Roti",
                                          "price": 4200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467751",
                                          "name": "Missi Roti",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467749",
                                          "name": "Plain Tandoori Roti",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478892"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968716",
                                  "name": "Veg Kothe [Serves 2]",
                                  "category": "Starters",
                                  "description": "An Amer invention. Crispy tempura vegetables tossed in chef's special sweet & spicy chili garlic sauce",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/b25e6520-1b46-46f6-901f-4ada5e8b3a24_f5923608-b566-4bab-b35e-78419fca860d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961955",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775173"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327810",
                                  "name": "Paneer Malai Tikka [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Soft Paneer Tikka S With Bell Peppers In A Creamy Marinade Grilled On Live Charcoal.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/d0d6e899-cb7b-4f5a-9001-a26947b82343_1ad0b5f4-d346-40b5-be6a-f1b9f3432ae1.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962086",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962087",
                                      "groupName": "Roti",
                                      "choices": [
                                        {
                                          "id": "142467750",
                                          "name": "Rumali Roti",
                                          "price": 4200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467751",
                                          "name": "Missi Roti",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467749",
                                          "name": "Plain Tandoori Roti",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478889"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204408",
                                  "name": "Burnt Garlic Manchurian [Serves 2]",
                                  "category": "Starters",
                                  "description": "Manchurian balls tossed in a flavorsome burnt garlic sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962164",
                                      "groupName": "Fried rice",
                                      "choices": [
                                        {
                                          "id": "142467720",
                                          "name": "Veg Burnt Chilli Garlic Fried Rice",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467721",
                                          "name": "Egg Fried Rice",
                                          "price": 22200,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962163",
                                      "groupName": "Noodles",
                                      "choices": [
                                        {
                                          "id": "142467718",
                                          "name": "Veg Schezwan Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467719",
                                          "name": "Veg Burnt Garlic Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467717",
                                          "name": "Veg Hakka Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231921"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940327",
                                  "name": "Hunan Style Exotic Vegetable Dry",
                                  "category": "Starters",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110345110"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204412",
                                  "name": "Crispy Corn [Serves 2]",
                                  "category": "Starters",
                                  "description": "Deep-Fried Sweet Corn Kernels Tossed With Herbs And Spices.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/341ee657-a2cc-4950-8822-62df8090044d_2f3eb877-3b63-41a7-be25-d3beeb842d1d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231928"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204518",
                                  "name": "Spinach Corn & Cheese Cigar Roll [6 Pieces]",
                                  "category": "Starters",
                                  "description": "A Deep Fried Roll Stuffed With Spinach , Corn Kernels & Cheese. Served With Sweet Chilli Garlic Dip",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/a3d60376-6984-4e46-a6c1-db5d0120c5d2_44b8ff6b-b551-4db8-80bb-5de6a70c1dca.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231939"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968554",
                                  "name": "Schezwan Potato Dry",
                                  "category": "Starters",
                                  "description": "Crispy potatoes tossed in a flavorful and aromatic sauce, perfect for a flavorful start to your meal.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110345114"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968542",
                                  "name": "Burnt Chilli Garlic Potato Dry",
                                  "category": "Starters",
                                  "description": "Crispy fried potatoes tossed in a savory, garlicky sauce with a hint of charred flavor.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110345108"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968486",
                                  "name": "Hunan Style Potato Dry",
                                  "category": "Starters",
                                  "description": "Crispy, savory potatoes tossed in flavorful Hunan-style seasoning, perfect for starting off your meal on a delicious note.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110345111"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204409",
                                  "name": "ABH signature Potato",
                                  "category": "Starters",
                                  "description": "Crispy golden potato bites tossed in a special house seasoning, served hot for a perfect blend of crunch and flavor.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/6878368d-3e4e-436c-98b3-d26199fddbb6_01d89ce4-2e8e-476e-bf1c-92c51d4c24b5.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231919"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968732",
                                  "name": "Tomato Olive Bruschetta",
                                  "category": "Starters",
                                  "description": "Crispy toasted bread topped with fresh tomatoes, olives, herbs, and a drizzle of olive oil.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/2e31a0b5-121a-45dc-9060-e69f9135911e_508cf597-b6eb-4cf1-9181-ee4c105a2498.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818541"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968520",
                                  "name": "Schezwan Manchurian [Serves 2]",
                                  "category": "Starters",
                                  "description": "Crispy vegetable balls tossed in a rich Indo Chinese sauce infused with burnt garlic flavor.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962151",
                                      "groupName": "Noodles",
                                      "choices": [
                                        {
                                          "id": "142467718",
                                          "name": "Veg Schezwan Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467719",
                                          "name": "Veg Burnt Garlic Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467717",
                                          "name": "Veg Hakka Noodles",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962152",
                                      "groupName": "Fried rice",
                                      "choices": [
                                        {
                                          "id": "142467720",
                                          "name": "Veg Burnt Chilli Garlic Fried Rice",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467721",
                                          "name": "Egg Fried Rice",
                                          "price": 22200,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818538"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940330",
                                  "name": "Schezwan Exotic Vegetable Dry",
                                  "category": "Starters",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999124"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940345",
                                  "name": "Burnt Chilli Garlic Exotic Vegetable Dry",
                                  "category": "Starters",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "110345107"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677638"
                        },
                        {
                          "title": "Non Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193708",
                                  "name": "Sesame Chicken",
                                  "category": "Starters",
                                  "description": "Crispy Chicken Tossed In A Tangy Sesame Glaze.",
                                  "imageId": "jbwnrul85o5q7ggozxu1",
                                  "inStock": 1,
                                  "price": 30300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423974"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327715",
                                  "name": "Non-Veg Platter [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "An Assortment Of 2 Pieces Of Tandoori Chicken, 3 Pieces Of Chicken Tikka & 3 Pieces Of Chicken Malai Tikka On A Platter.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/f246012f-3d74-47af-97ab-6d2f687c4eba_740c2caf-3d8d-45ef-9970-d2fc44e4fc21.JPG",
                                  "inStock": 1,
                                  "price": 49500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478882"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204505",
                                  "name": "Tandoori Chicken ",
                                  "category": "Starters",
                                  "description": "Spicy Marinated Bone In Chicken Slow Roasted Over Tandoor.",
                                  "inStock": 1,
                                  "price": 40000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226080",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Chicken Tandoori [4 Pcs]",
                                            "default": 1,
                                            "id": "207124664",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Tandoori [8 Pcs]",
                                            "price": 37500,
                                            "id": "207124665",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424009"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327777",
                                  "name": "Chicken Malai Tikka [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Juicy Chicken Tikka Ina Creamy Marinade Grilled On Live Charcoal.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/dd56f93d-9bce-4eb8-84ad-f8e671e4110c_a9c1b286-55e1-4a25-97da-b5a669f1b291.JPG",
                                  "inStock": 1,
                                  "price": 38500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962065",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962063",
                                      "groupName": "Roti",
                                      "choices": [
                                        {
                                          "id": "142467750",
                                          "name": "Rumali Roti",
                                          "price": 4200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467772",
                                          "name": "Butter Chicken Combo [Serves 1]",
                                          "price": 37500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467751",
                                          "name": "Missi Roti",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467749",
                                          "name": "Plain Tandoori Roti",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478823"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327780",
                                  "name": "Chicken Tikka [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Juicy Chunks Of Chicken Marinated In Indian Spices And Grilled.",
                                  "inStock": 1,
                                  "price": 37500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962068",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962069",
                                      "groupName": "Roti",
                                      "choices": [
                                        {
                                          "id": "142467750",
                                          "name": "Rumali Roti",
                                          "price": 4200,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467751",
                                          "name": "Missi Roti",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467749",
                                          "name": "Plain Tandoori Roti",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478828"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327760",
                                  "name": "Chilli Chicken [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Indo-Chinese Favourite With Fried Chicken Tossed In A Tangy Chilli Sauce.",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478831"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327746",
                                  "name": "Peri Peri Roasted Chicken [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Oven-Roasted Chicken Marinated In Fiery Peri-Peri Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/d97153b2-37cd-4b53-97d5-a8394a674055_2cfa8232-ff1e-41c3-872b-592fcc4219a1.JPG",
                                  "inStock": 1,
                                  "price": 48000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478894"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327754",
                                  "name": "Chicken Lollipop [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Juicy Chicken Wings Marinated, Battered, And Deep-Fried To Perfection. A Spicy Indo-Chinese Starter.",
                                  "inStock": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962043",
                                      "groupName": "Fried rice",
                                      "choices": [
                                        {
                                          "id": "142467720",
                                          "name": "Veg Burnt Chilli Garlic Fried Rice",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467721",
                                          "name": "Egg Fried Rice",
                                          "price": 22200,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467765",
                                          "name": "Chicken Schezwan Fried Rice",
                                          "price": 28000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467766",
                                          "name": "Veg Fried Rice [Serves 2]",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467767",
                                          "name": "Veg Schezwan Fried Rice",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478822"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327937",
                                  "name": "Burnt Garlic Chicken Dry [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Chicken Chunks Tossed In A Wok With Crunchy Veggies And A Smoky Burnt Garlic Sauce.",
                                  "inStock": 1,
                                  "price": 30200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478804"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327924",
                                  "name": "Schezwan Chicken Dry [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "Spicy Chicken Bites Stir-Fried With Bold Schezwan Sauce, Capsicum, And Onions.",
                                  "inStock": 1,
                                  "price": 30200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478910"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327900",
                                  "name": "Hunan Chicken Dry [Serves 2-3]",
                                  "category": "Starters",
                                  "description": "A Spicy Dry Stir Fried Chicken Tossed In Savory & Spicy Sauce.",
                                  "inStock": 1,
                                  "price": 30200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478864"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829076",
                                  "name": "Schezwan Chicken Gravy [4 Pieces]",
                                  "category": "Starters",
                                  "description": "Fiery chicken gravy cooked with schezwan spices and sauces.",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638257"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677711"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/c96aa9da-481b-4162-8772-863f03439f3d_18635127-7f43-4e51-9b3f-f515ff61c6e7.JPG_compressed",
                      "categoryId": "69677637"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Soup And Salad",
                      "categories": [
                        {
                          "title": "Soup",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327839",
                                  "name": "Veg Hot N Sour Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Spicy And Tangy Soup With Mixed Vegetables And Flavourful Asian Seasoning.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/e7c9383d-a24d-4231-8c58-503c0d1755c8_41400737-eb0d-4106-8e18-feecd4393fa2.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478927"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327825",
                                  "name": "Cream Of Tomato Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Smooth And Creamy Tomato-Based Soup With Mild Herbs And Butter.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478849"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327833",
                                  "name": "Veg Manchow Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Hearty Vegetable Soup With Garlic, Soy, And Crunchy Fried Noodles On Top.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/8556853a-dacd-4062-a2e4-910914eb34c0_5dba4ede-f66b-4fd5-84d7-437d6d47a5e1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478930"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327890",
                                  "name": "Broccoli & Almond Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Nutritious Broccoli Soup Blended With Roasted Almonds For A Rich, Creamy Flavour.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478803"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327847",
                                  "name": "Chicken Hot N Sour Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Classic Hot And Sour Soup With Shredded Chicken And Crunchy Veggies.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/2b896b16-d4d1-4fda-a70e-e3b589567ef8_98518d70-59bc-45bc-8332-defaba9fc826.jpg",
                                  "inStock": 1,
                                  "price": 17500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478820"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327830",
                                  "name": "Chicken Manchow Soup 300 Ml",
                                  "category": "Soup And Salad",
                                  "description": "Spicy Chinese-Style Chicken Soup Topped With Crispy Noodles.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/d41092d9-9ffc-4b3a-808e-b44774cfe3cf_cf2c9ef3-3560-4c89-a73e-cd71d9b3f6ea.jpg",
                                  "inStock": 1,
                                  "price": 17500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478824"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968547",
                                  "name": "Mushroom Cream Soup",
                                  "category": "Soup And Salad",
                                  "description": "A rich, velvety blend of earthy mushrooms and fresh cream, simmered to perfection for a warm, comforting bowl of goodness.\n\n",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/e6e303b7-7278-4773-99c9-8780f9e302d7_ea3b9910-30b0-4530-ac44-fabc9e5c24ee.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818535"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677774"
                        },
                        {
                          "title": "Salad",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159194026",
                                  "name": "Greek Salad",
                                  "category": "Soup And Salad",
                                  "description": "A refreshing mix of cucumbers, tomatoes, olives, onions, and feta cheese tossed in a light dressing.\n\n",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/5cea5379-4d5c-459f-a12a-35e0dd7b793c_ff187780-bf36-44ae-901f-3f1c1b538c6f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961942",
                                      "groupName": "Juice",
                                      "choices": [
                                        {
                                          "id": "142467649",
                                          "name": "Orange Bliss",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961943",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467644",
                                          "name": "Cheese Corn And Peppers Sandwich",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467645",
                                          "name": "Bombay Masala Sandwich",
                                          "price": 23000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423684"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327633",
                                  "name": "Onion Salad",
                                  "category": "Soup And Salad",
                                  "description": "Freshly Sliced Onions Served With Lemon And A Dash Of Chaat Masala.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423825"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327640",
                                  "name": "Green Salad",
                                  "category": "Soup And Salad",
                                  "description": "A Mix Of Fresh Lettuce, Cucumber, Tomato, And Carrots With A Light Seasoning.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962010",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423686"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968652",
                                  "name": "Kachumber Salad",
                                  "category": "Soup And Salad",
                                  "description": "A crunchy mix of cucumber, tomato, onion, and fresh herbs with a light squeeze of lemon.\n\n",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962011",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "36811865"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327586",
                                  "name": "Roasted Paneer Caesar Veg Salad",
                                  "category": "Soup And Salad",
                                  "description": "Grilled Paneer Served On Crisp Lettuce With Caesar Dressing And Croutons.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961990",
                                      "groupName": "Juice",
                                      "choices": [
                                        {
                                          "id": "142467649",
                                          "name": "Orange Bliss",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961991",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467644",
                                          "name": "Cheese Corn And Peppers Sandwich",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467645",
                                          "name": "Bombay Masala Sandwich",
                                          "price": 23000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478905"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193759",
                                  "name": "Falafel & Hummus Salad",
                                  "category": "Soup And Salad",
                                  "description": "Salad veggies, two types of hummus & falafel served with soft pita bread.\n\n",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961950",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467648",
                                          "name": "Caprese Panini Sandwich",
                                          "price": 39500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467644",
                                          "name": "Cheese Corn And Peppers Sandwich",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467645",
                                          "name": "Bombay Masala Sandwich",
                                          "price": 23000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961949",
                                      "groupName": "Juice",
                                      "choices": [
                                        {
                                          "id": "142467649",
                                          "name": "Orange Bliss",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307212"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193949",
                                  "name": "Roasted Chicken Caesar Salad",
                                  "category": "Soup And Salad",
                                  "description": "Classic Caesar Salad With Roasted Chicken, Lettuce, Parmesan, And Croutons.",
                                  "inStock": 1,
                                  "price": 37300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962133",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467648",
                                          "name": "Caprese Panini Sandwich",
                                          "price": 39500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467644",
                                          "name": "Cheese Corn And Peppers Sandwich",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467645",
                                          "name": "Bombay Masala Sandwich",
                                          "price": 23000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962132",
                                      "groupName": "Juice",
                                      "choices": [
                                        {
                                          "id": "142467649",
                                          "name": "Orange Bliss",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307248"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968483",
                                  "name": "Chicken Hummus Salad",
                                  "category": "Soup And Salad",
                                  "description": "Roasted chicken,salad veggies, two types of hummus served with soft pita bread.\n\n",
                                  "inStock": 1,
                                  "price": 39500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961868",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467648",
                                          "name": "Caprese Panini Sandwich",
                                          "price": 39500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467644",
                                          "name": "Cheese Corn And Peppers Sandwich",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467645",
                                          "name": "Bombay Masala Sandwich",
                                          "price": 23000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961869",
                                      "groupName": "Juice",
                                      "choices": [
                                        {
                                          "id": "142467649",
                                          "name": "Orange Bliss",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818530"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677643"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/e7c9383d-a24d-4231-8c58-503c0d1755c8_41400737-eb0d-4106-8e18-feecd4393fa2.jpg",
                      "categoryId": "69677641"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Burger And Sandwich",
                      "categories": [
                        {
                          "title": "Burgers",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193961",
                                  "name": "Veg Cheese Burger",
                                  "category": "Burger And Sandwich",
                                  "description": "Crispy Veg Patty With Cheese, Lettuce & Sauces.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/23c0aa7b-0b7d-46ff-944c-cb909eac548b_98c7147a-8bb4-4ebd-b500-5c4a3efa8f08.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "77043283"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204474",
                                  "name": "Chicken Cheese Burger (Classic Chicken Burger)",
                                  "category": "Burger And Sandwich",
                                  "description": "Juicy Chicken Patty With Cheese And Fresh Toppings.",
                                  "inStock": 1,
                                  "price": 23000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231923"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159194025",
                                  "name": "Crispy Chicken Burger",
                                  "category": "Burger And Sandwich",
                                  "inStock": 1,
                                  "price": 24000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307204"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677710"
                        },
                        {
                          "title": "Sandwich",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193710",
                                  "name": "Paneer Junglee Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Spicy Marinated Paneer Tossed In Masala, Served In Toasted Sandwich Bread.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/90d929ce-0bde-436c-b112-0f95767a6513_798e1b53-e69d-4384-8e15-d6f41a5d8a2b.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423846"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193714",
                                  "name": "Chicken Junglee Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Spicy Shredded Chicken Mixed With Herbs And Sauces, Served In Toasted Bread.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/18/351d2646-a74f-4124-9402-67c1216c2d50_972fcf5c-16fb-412d-8676-f37e38cb5b41.JPG",
                                  "inStock": 1,
                                  "price": 10000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423458"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193768",
                                  "name": "Roasted Chicken Panini Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Grilled Panini Stuffed With Juicy Roasted Chicken And Flavourful Seasonings.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "70464367"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327659",
                                  "name": "Bombay Masala Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Classic Mumbai-Style Sandwich With Spicy Potato Filling, Chutney, And Veggies.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/c017d73d-38f6-4757-8f98-d1af12b28ab1_22c8f821-c039-4424-9104-8b0caded89d3.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423361"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327873",
                                  "name": "Cheese Corn And Peppers Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Creamy Cheese, Sweet Corn, And Bell Peppers In A Soft Toasted Sandwich.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/a4df72e3-91fa-46a9-b369-d0c639e339cd_7357fc23-0d98-4622-9811-5e7c70682e72.JPG_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478812"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327562",
                                  "name": "Chicken Tikka Panini",
                                  "category": "Burger And Sandwich",
                                  "description": "Panini Filled With Tender Chicken Tikka And Tangy Sauces, Grilled To Perfection.",
                                  "inStock": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "70464361"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327435",
                                  "name": "Caprese Panini Sandwich",
                                  "category": "Burger And Sandwich",
                                  "description": "Fresh Mozzarella, Tomatoes, And Basil In Grilled Panini Bread.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/10/1/143c213b-e7f2-4ddd-9c55-a6d7128d6c00_b2c164e0-c02e-447e-b94a-e8babcb94e12.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "77283403"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677756"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/23c0aa7b-0b7d-46ff-944c-cb909eac548b_98c7147a-8bb4-4ebd-b500-5c4a3efa8f08.jpg",
                      "categoryId": "69677708"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Rolls",
                      "categories": [
                        {
                          "title": "Rolls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193850",
                                  "name": "Cold Cheese Roll",
                                  "category": "Rolls",
                                  "description": "Chilled Cheesy Delight Made With Creamy Cheese, Herbs, And Crunchy Veggies Rolled In Soft Bread. Served Cold For A Refreshing Bite.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/18/faadbc29-9e7d-438a-b780-636da7941b8c_e18cd502-6e04-4ea9-b573-91d4149462ba.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423545"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193868",
                                  "name": "Paneer Kathi Roll",
                                  "category": "Rolls",
                                  "description": "Tandoori Paneer Tikka, Peppers, And Onions Wrapped In A Warm Flaky Paratha With Spiced Mayo And Tangy Sauces.",
                                  "imageId": "llg9esqx9fepphqzql1w",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423848"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327710",
                                  "name": "Paneer Roll",
                                  "category": "Rolls",
                                  "description": "Soft Wrap Stuffed With Smoky Grilled Paneer, Sauteed Veggies, And House-Made Chutney. A Perfect Blend Of Spice And Creaminess.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478890"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327708",
                                  "name": "Chicken Roll",
                                  "category": "Rolls",
                                  "description": "Juicy Chunks Of Chicken Marinated In Aromatic Spices, Wrapped In A Flaky Paratha With Onions And Mint Chutney.",
                                  "inStock": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478825"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193903",
                                  "name": "Chicken Kathi Roll",
                                  "category": "Rolls",
                                  "description": "Succulent Grilled Chicken Tossed In Indian Spices, Layered With Onions And Chutneys, Wrapped In A Soft Paratha.",
                                  "price": 11500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423461"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677724"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/18/faadbc29-9e7d-438a-b780-636da7941b8c_e18cd502-6e04-4ea9-b573-91d4149462ba.JPG",
                      "categoryId": "69677723"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Special Hampers",
                      "categories": [
                        {
                          "title": "Hamper",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327801",
                                  "name": "Cookies Pair Hamper",
                                  "category": "Special Hampers",
                                  "description": "[Veg Preparation] Almond Biscotti[150G] + Cashew Biscotti [150G]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "92048536"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940313",
                                  "name": "Gourmet Cookies  Hamper",
                                  "category": "Special Hampers",
                                  "description": "Dark Couverture Chocolate Cookies [150]+Couverture Chocolate Cookies [150 g]",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 64900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999122"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940309",
                                  "name": "Gourmet Cookies Collection Hamper",
                                  "category": "Special Hampers",
                                  "description": "Pack of 6: Almond Biscotti [150g]+Cashew Biscotti [150 g]+Butter Cookies [150 g]+Dark Couverture Chocolate Cookies [150 g]+Couverture Chocolate Cookies [150 g]+Oatmeal and Raisins [150 g].\n\nPack of 4: Almond Biscotti [150 g] + Cashew Biscotti [150 g] + Dark Couverture Chocolate Cookies [150 g] + Couverture Chocolate Cookies [150 g].\n\nPack of 2: Almond Biscotti [150 g] + Cashew Biscotti [150 g] .",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 55000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226073",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Pack Of 6",
                                            "price": 85000,
                                            "default": 1,
                                            "id": "207124647",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of 4",
                                            "price": 40000,
                                            "id": "207124648",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of 2",
                                            "id": "207124649",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999121"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940317",
                                  "name": "Joy Of Festival Hamper",
                                  "category": "Special Hampers",
                                  "description": "Roasted Cashews + Roasted Almonds + Chocolate Coated Cashews + Chocolate Coated Almonds + Orange Tea Cake + Cashew Almond Tea Cake + Cashew Biscotti Jar + Almond Biscotti Jar",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 234900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999123"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677634"
                        }
                      ],
                      "categoryId": "69677633"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Snacks&Momos",
                      "categories": [
                        {
                          "title": "Snacks",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327607",
                                  "name": "French Fries [Serves 1-2]",
                                  "category": "Snacks&Momos",
                                  "description": "Crispy Golden Fries, Lightly Salted And Served With Dip.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961999",
                                      "groupName": "Sandwich",
                                      "choices": [
                                        {
                                          "id": "142467646",
                                          "name": "Chicken Junglee Sandwich",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467647",
                                          "name": "Atta Bread",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478859"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327591",
                                  "name": "Chole Bhature [2 Bhature]",
                                  "category": "Snacks&Momos",
                                  "description": "Punjabi-Style Spicy Chickpeas Served With 2 Soft, Deep-Fried Bhature.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478845"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968688",
                                  "name": "Pav Bhaji",
                                  "category": "Snacks&Momos",
                                  "description": "Butter-Toasted Pav (2 pcs) Served With Spicy Mashed Vegetable Bhaji.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423880"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193716",
                                  "name": "Veg Puff",
                                  "category": "Snacks&Momos",
                                  "description": "Buttery Puff Pastry Filled With A Mildly Spiced Vegetable Mixture.",
                                  "isVeg": 1,
                                  "price": 6000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31424101"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193904",
                                  "name": "Chicken Puff",
                                  "category": "Snacks&Momos",
                                  "description": "Flaky Puff Pastry Filled With Spiced Minced Chicken.",
                                  "price": 9000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "77043155"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193715",
                                  "name": "Paneer Puff",
                                  "category": "Snacks&Momos",
                                  "description": "Crisp Puff Pastry Stuffed With Flavourful Paneer And Spices.",
                                  "isVeg": 1,
                                  "price": 8000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423858"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193663",
                                  "name": "Paneer Tikka Hot Dog",
                                  "category": "Snacks&Momos",
                                  "description": "Hot Dog Roll Loaded With Marinated Paneer Tikka And Flavourful Chutneys.",
                                  "isVeg": 1,
                                  "price": 12000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423862"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193913",
                                  "name": "Chicken Tikka Hot Dog",
                                  "category": "Snacks&Momos",
                                  "description": "Grilled Hot Dog Roll Stuffed With Spicy Chicken Tikka And Tangy Sauces.",
                                  "price": 14000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423498"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677750"
                        },
                        {
                          "title": "Momos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968451",
                                  "name": "Veg Momos [6 Pieces]",
                                  "category": "Snacks&Momos",
                                  "description": "Soft, steamed dumplings filled with a savory mix of fresh vegetables and spices, served with a tangy dip.\n\n",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/f3379300-59fc-43ee-a635-e85dcc620b95_ed1b21de-afe6-40cc-bee2-54442eab5ae0.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818544"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968445",
                                  "name": "Chicken Momos [6 Pieces]",
                                  "category": "Snacks&Momos",
                                  "description": "Juicy, steamed dumplings stuffed with spiced minced chicken, served with a zesty dipping sauce.\n\n",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/fcc354e2-f9d0-42bf-bc54-89c727bbbbe3_f088c66e-b8ed-4bb8-9127-542a5dbe1c6c.jpg",
                                  "price": 27500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818532"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677717"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/fcc354e2-f9d0-42bf-bc54-89c727bbbbe3_f088c66e-b8ed-4bb8-9127-542a5dbe1c6c.jpg",
                      "categoryId": "69677716"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Main Course",
                      "categories": [
                        {
                          "title": "Veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327888",
                                  "name": "Hunan Manchurian Gravy",
                                  "category": "Main Course",
                                  "description": "Manchurian Balls In A Spicy, Dark Hunan-Style Sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962147",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478866"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327862",
                                  "name": "Burnt Garlic Manchurian Gravy",
                                  "category": "Main Course",
                                  "description": "Garlic-Rich Indo-Chinese Gravy With Manchurian Balls.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962127",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478806"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327870",
                                  "name": "Paneer Hunan Gravy",
                                  "category": "Main Course",
                                  "description": "Paneer Cubes Tossed In Bold And Spicy Hunan Gravy.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962138",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478887"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327581",
                                  "name": "Burnt Garlic Paneer Gravy",
                                  "category": "Main Course",
                                  "description": "Smoky Garlic Flavour Gravy With Soft Paneer Cubes.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961987",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478808"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327573",
                                  "name": "Chilli Paneer Gravy",
                                  "category": "Main Course",
                                  "description": "Fried Paneer Cubes In A Spicy Indo-Chinese Chilli Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/7/20/425450b5-bdd7-4415-833f-e9d29c027697_12b8169c-dafc-4962-a946-c9df0b944f96.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 31300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961980",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478834"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327495",
                                  "name": "Kadhai Paneer",
                                  "category": "Main Course",
                                  "description": "Rich And Mildly Spiced Paneer Gravy With A Touch Of Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/689cdc07-c741-4512-933d-0f09a660a403_5e75e155-d37f-43eb-a880-bad861f3988a.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961930",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423748"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193746",
                                  "name": "Paneer Shashlik",
                                  "category": "Main Course",
                                  "description": "Red Kidney Beans Cooked In Spiced Onion-Tomato Gravy.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "70464366"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327939",
                                  "name": "Paneer Butter Masala",
                                  "category": "Main Course",
                                  "description": "Creamy Tomato Gravy With Soft Paneer Cubes, Mildly Sweet And Rich.",
                                  "imageId": "e0yuayayvhdk0ivwfe9k",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962168",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423840"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327624",
                                  "name": "Dal Makhani",
                                  "category": "Main Course",
                                  "description": "Slow-Cooked Black Lentils In A Buttery, Creamy Gravy.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/86d3c6c6-43c6-40f0-afec-76f966cbab06_2e6e24d6-af00-4efa-947e-b4e24202f048.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962003",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423593"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327948",
                                  "name": "Rajma Masala",
                                  "category": "Main Course",
                                  "description": "Larger Portion Of Our Rich And Creamy Dal Makhani.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/d75b826b-3f50-40f2-980e-b57be8d37e32_542ae383-1653-46cf-87ed-4c175a3336a2.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962174",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "36811871"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327571",
                                  "name": "Chilli Manchurian Gravy",
                                  "category": "Main Course",
                                  "description": "Manchurian In A Tangy Chilli Garlic Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/1c790a4c-c157-4664-9cef-a6d2680966bd_25ad14f1-66c1-49ae-b026-153b0d271fb0.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961975",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478832"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968500",
                                  "name": "Schezwan Exotic Vegetables Gravy",
                                  "category": "Main Course",
                                  "description": "A tantalizing blend of exotic vegetables in a rich and flavorful Schezwan gravy.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962178",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818537"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204424",
                                  "name": "Tawa Paneer",
                                  "category": "Main Course",
                                  "description": "Soft paneer in a rich and spicy brown gravy.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962077",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818539"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829072",
                                  "name": "Yellow Dal Tadka",
                                  "category": "Main Course",
                                  "description": "Creamy yellow lentils tempered with aromatic spices for a comforting, flavorful dish.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26400,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638270"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829049",
                                  "name": "Hunan Exotic Vegetables Gravy",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638244"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829035",
                                  "name": "Schezwan Paneer Gravy",
                                  "category": "Main Course",
                                  "description": "Soft paneer cubes tossed in a spicy, flavorful schezwan sauce.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638259"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829043",
                                  "name": "Schezwan Manchurian Gravy",
                                  "category": "Main Course",
                                  "description": "Crispy Manchurian balls tossed in a tangy, spicy schezwan sauce, bursting with flavor.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638258"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677702"
                        },
                        {
                          "title": "Chicken",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204485",
                                  "name": "Egg Curry [2 Eggs]",
                                  "category": "Main Course",
                                  "description": "Hard-Boiled Eggs Cooked In A Mildly Spiced Curry Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/df47633d-780f-4099-b01e-bccad7dbf226_3a3632f8-974a-4863-bc1e-93787c7e01c8.jpg",
                                  "inStock": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961880",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231930"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204489",
                                  "name": "Hunan Chicken Gravy [Serves 2]",
                                  "category": "Main Course",
                                  "description": "Boneless Chicken In Bold Hunan-Style Spicy Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/f1207fd4-61b4-4f24-b843-2a43b4198c69_956adc59-399b-4107-a3d1-dc86b84d94b0.jpg",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961909",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231934"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968692",
                                  "name": "Schezwan Chicken Gravy",
                                  "category": "Main Course",
                                  "description": "Fiery Chicken Gravy Cooked With Schezwan Spices And Sauces.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/ac968f9a-6d6b-4c3c-bba9-3b67b4a1d74e_511b5ee6-1945-4971-92ec-b319c5552f8e.jpg",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961989",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775169"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204493",
                                  "name": "Burnt Garlic Chicken Gravy [Serves 2]",
                                  "category": "Main Course",
                                  "description": "Garlic-Rich Gravy With Wok-Tossed Chicken Pieces.",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961900",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231920"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204495",
                                  "name": "Chili Chicken Gravy [Serves 2]",
                                  "category": "Main Course",
                                  "description": "Indo-Chinese Chicken Tossed In Spicy Chilli Garlic Gravy.",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961903",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231924"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968675",
                                  "name": "Kadhai Chicken",
                                  "category": "Main Course",
                                  "description": "Spicy Chicken Cooked In Traditional Indian Kadhai Masala.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/87cfbb9f-3d14-4add-9310-c0b957003bf0_73beca35-1d7b-4c51-a9fc-450ab34baa79.jpg",
                                  "inStock": 1,
                                  "price": 50000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961994",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423746"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968680",
                                  "name": "Chicken Curry",
                                  "category": "Main Course",
                                  "description": "Classic Indian-Style Chicken In Onion-Tomato Gravy.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/0a1b7187-836a-4853-b9b0-e797b13acc30_ed378234-d7bc-49b4-bd18-de11c16b6ed1.jpg",
                                  "inStock": 1,
                                  "price": 50000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962185",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423447"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968677",
                                  "name": "Butter Chicken",
                                  "category": "Main Course",
                                  "description": "Creamy, Mildly Sweet Tomato Gravy With Grilled Chicken.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/03989d2a-d174-4669-afd1-d3efd6453e86_257f5899-ec09-4584-84d4-441540d11f25.jpg",
                                  "inStock": 1,
                                  "price": 50000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961910",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423378"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968647",
                                  "name": "Tawa Chicken",
                                  "category": "Main Course",
                                  "description": "Spiced chicken pieces sauted in a hot tawa for a smoky, flavorful taste.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/8461617a-70c2-4dcd-ae66-99284168455c_236fe3e4-d409-4ce9-8e1e-904d5d3126bd.jpg",
                                  "price": 50000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775171"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677696"
                        },
                        {
                          "title": "Mutton Dishes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204500",
                                  "name": "Mutton Rogan Josh",
                                  "category": "Main Course",
                                  "description": "Aromatic Kashmiri-Style Mutton Curry, Spiced Gravy.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/736ab5a8-2311-4fab-a8b4-4a27efd2082b_d50f50f2-df8e-415f-9a7c-c7b8cab13863.jpg",
                                  "inStock": 1,
                                  "price": 62500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961896",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423807"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677640"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/7/20/425450b5-bdd7-4415-833f-e9d29c027697_12b8169c-dafc-4962-a946-c9df0b944f96.jpg",
                      "categoryId": "69677639"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Rice And Biryani",
                      "categories": [
                        {
                          "title": "Rice",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327386",
                                  "name": "Steamed Rice",
                                  "category": "Rice And Biryani",
                                  "description": "Plain, Fluffy Long-Grain Rice, Served As A Side Or Base.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423982"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327390",
                                  "name": "Jeera Rice",
                                  "category": "Rice And Biryani",
                                  "description": "Basmati Rice Tempered With Cumin Seeds And Mild Spices.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423737"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677726"
                        },
                        {
                          "title": "Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327751",
                                  "name": "Veg Biryani",
                                  "category": "Rice And Biryani",
                                  "description": "Aromatic basmati rice layered with assorted vegetables and flavorful spices.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226118",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "default": 1,
                                            "id": "207124746",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 20000,
                                            "id": "207124748",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424067"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327628",
                                  "name": "Chicken Biryani         ",
                                  "category": "Rice And Biryani",
                                  "description": "Fragrant basmati rice cooked with spiced chicken, herbs and aromatic masalas.",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226111",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "2 Pcs [Half]",
                                            "default": 1,
                                            "id": "207124730",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "4 Pcs [Full]",
                                            "price": 27500,
                                            "id": "207124731",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423435"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677771"
                        }
                      ],
                      "categoryId": "69677725"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Noodles & Fried Rice",
                      "categories": [
                        {
                          "title": "Fried Rice",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327905",
                                  "name": "Veg Schezwan Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Chicken Fried Rice With A Strong Burnt Garlic Flavour.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962100",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962101",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424105"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327951",
                                  "name": "Veg Pot Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Aromatic Rice Cooked With Assorted Vegetables In A Flavourful Asian-Style Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/d690fdee-b1f2-4c2c-b632-ec2cf285ee1f_20704321-a504-445e-a83c-8ab0fc49e183.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962176",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962177",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478932"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327696",
                                  "name": "Egg Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Rice Stir-Fried With Egg, Spring Onions, And Soy Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/e47a7626-9017-4020-8508-12452e5be6ea_2e24233e-fbe4-48e2-9495-cd71d907f067.jpg",
                                  "inStock": 1,
                                  "price": 22200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962022",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423614"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327902",
                                  "name": "Chicken Burnt Garlic Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Spicy Rice With Chicken Tossed In Schezwan Sauce.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962106",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962107",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478816"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327417",
                                  "name": "Chicken Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Spicy Veg Fried Rice With Bold Schezwan Sauce.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961925",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961924",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423452"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327395",
                                  "name": "Chicken Schezwan Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Wok-Tossed Rice With Chicken, Veggies, And Sauces.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962130",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962131",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423482"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193752",
                                  "name": "Chicken Pot Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Hearty Rice Dish With Tender Chicken And Vegetables Cooked In A Savory Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/badfd036-9c8a-47c5-b4e4-3b137a0d0d77_612a2af4-933d-41f5-b9a3-ad03343a736c.JPG",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962181",
                                      "groupName": "Curry",
                                      "choices": [
                                        {
                                          "id": "142467806",
                                          "name": "Paneer Butter Masala",
                                          "price": 33500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467807",
                                          "name": "Chicken Red Thai Curry With Rice",
                                          "price": 32500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467808",
                                          "name": "Tawa Paneer",
                                          "price": 33500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467802",
                                          "name": "Dal Makhani",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467803",
                                          "name": "Chili Chicken Gravy [Serves 2]",
                                          "price": 33000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467804",
                                          "name": "Paneer Hunan Gravy",
                                          "price": 30000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467805",
                                          "name": "Kadhai Paneer Combo [Serves 1]",
                                          "price": 33500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467798",
                                          "name": "Burnt Garlic Manchurian Gravy",
                                          "price": 26000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467799",
                                          "name": "Hunan Manchurian Gravy",
                                          "price": 26000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467800",
                                          "name": "Kadhai Paneer",
                                          "price": 33500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467801",
                                          "name": "Chilli Paneer Gravy",
                                          "price": 31300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467794",
                                          "name": "Rajma Masala",
                                          "price": 21000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467795",
                                          "name": "Veg Red Thai Curry With Rice",
                                          "price": 30000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467796",
                                          "name": "Dal Makhani Combo [Serves 1-2]",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467797",
                                          "name": "Chilli Manchurian Gravy",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467791",
                                          "name": "Dal Tadka Combo [Serves 1]",
                                          "price": 19000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467792",
                                          "name": "Burnt Garlic Paneer Gravy",
                                          "price": 30000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467793",
                                          "name": "Egg Curry [2 Eggs]",
                                          "price": 25000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307194"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968590",
                                  "name": "Veg Burnt Chilli Garlic Fried Rice",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Veg Fried Rice Infused With Burnt Garlic.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962046",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962047",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818543"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968597",
                                  "name": "Veg Fried Rice [Serves 2]",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Aromatic rice, wok tossed.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/b41904cf-1d63-4dc6-b649-cddaecfd33bb_fef6eee2-ea34-406c-a93e-b3424a68a582.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962074",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962073",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775172"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677749"
                        },
                        {
                          "title": "Noodles",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327819",
                                  "name": "Veg Burnt Garlic Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Noodles With Veggies And Smoky Burnt Garlic.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/dad10b54-fe26-418b-9683-fb69cd89a490_7037bd7f-dcd9-469d-ac8a-9e4aca610cfd.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962096",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "91052221"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327822",
                                  "name": "Veg Hakka Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Classic Wok-Tossed Noodles With Fresh Vegetables.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/7d075c35-55a5-4122-9c90-c866b87d015a_673300bb-cce4-4979-a02d-8b60da7862e1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962098",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31424084"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968712",
                                  "name": "Veg Schezwan Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Noodles & veggies tossed in spicy schezwan sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/c3ecf8c4-60d4-44bd-b026-00d22feaee05_4ba66425-324f-4d98-8996-c2544728b39b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961957",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "37412464"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327415",
                                  "name": "Egg Hakka Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Stir-Fried Noodles Tossed With Egg, Veggies, And Sauces.",
                                  "inStock": 1,
                                  "price": 23000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961923",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "EGG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423616"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327405",
                                  "name": "Chicken Hakka Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Chicken Stir-Fried Noodles With Vegetables And Soy Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/f84c4ca5-bff4-410a-ae94-889b099ad32a_df1f6610-01ba-42c1-bc86-4e3cbfe5ad06.jpg",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961921",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260961922",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "31423454"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327850",
                                  "name": "Chicken Burnt Garlic Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Chicken Noodles With Intense Burnt Garlic Flavour.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962112",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962113",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "77417772"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327857",
                                  "name": "Chicken Schezwan Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Spicy Noodles With Chicken In Fiery Schezwan Sauce.",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962120",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962119",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "77417777"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193742",
                                  "name": "Veg Pot Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "description": "Stir fried noodles with exotic veg. Tossed in chefs special gravy and served with gravy of the day.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962144",
                                      "groupName": "Soup",
                                      "choices": [
                                        {
                                          "id": "142467725",
                                          "name": "Broccoli & Almond Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467726",
                                          "name": "Veg Manchow Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467727",
                                          "name": "Mushroom Cream Soup",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467722",
                                          "name": "Veg Hot N Sour Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467723",
                                          "name": "Cream Of Tomato Soup 300 Ml",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467724",
                                          "name": "Chicken Manchow Soup 300 Ml",
                                          "price": 17500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "260962143",
                                      "groupName": "Manchurian",
                                      "choices": [
                                        {
                                          "id": "142467730",
                                          "name": "Schezwan Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467729",
                                          "name": "Hunan Style Manchurian Dry [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467728",
                                          "name": "Burnt Garlic Manchurian [Serves 2]",
                                          "price": 24500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307273"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828979",
                                  "name": "Non Veg Pot Noodles",
                                  "category": "Noodles & Fried Rice",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638252"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677743"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/d690fdee-b1f2-4c2c-b632-ec2cf285ee1f_20704321-a504-445e-a83c-8ab0fc49e183.jpg",
                      "categoryId": "69677742"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pizza And Pasta",
                      "categories": [
                        {
                          "title": "Pasta",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327550",
                                  "name": "Arrabiata Pasta (Penne)",
                                  "category": "Pizza And Pasta",
                                  "description": "Spicy Tomato-Based Pasta With Herbs And Garlic.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/241c1611-00c2-4aa8-ba93-2ab0967a0815_18419e4c-6567-4de2-a866-33b74a7a84a1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961959",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114176596"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327554",
                                  "name": "Alfredo Pasta (Penne)",
                                  "category": "Pizza And Pasta",
                                  "description": "Pasta In Rich And Creamy White Sauce With Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/53ec02e5-c8e5-4c1c-8d77-3f881b46b08a_3759b923-c155-46d0-a225-91bba44fff0b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961961",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114176595"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327547",
                                  "name": "Chicken Arrabiata Pasta (Penne)",
                                  "category": "Pizza And Pasta",
                                  "description": "Pasta Tossed In Spicy Arrabiata Sauce With Tender Chicken Pieces.",
                                  "inStock": 1,
                                  "price": 37500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961958",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114176598"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327556",
                                  "name": "Chicken Alfredo (Penne)",
                                  "category": "Pizza And Pasta",
                                  "description": "Creamy White Sauce Pasta With Grilled Chicken And Herbs.",
                                  "inStock": 1,
                                  "price": 37400,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961964",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114176597"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677761"
                        },
                        {
                          "title": "Pizza",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327804",
                                  "name": "Margherita Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "A Timeless Classic With Rich Tomato Sauce, Mozzarella Cheese, And A Touch Of Basil.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/884541e8-574b-47f9-9003-c304a0cfa6d3_c1fe22c9-dd64-42cb-abc3-7cff02e82a5e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962083",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478879"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968441",
                                  "name": "The Vegecian Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "A Flavourful Mix Of Crunchy Bell Peppers, Sweet Corn, Onions, And Melted Cheese On A Crispy Crust.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/dbdce565-2a72-468a-953f-dec4b882aa58_10b7a3fe-3612-4ba5-a2e6-40af7fdc700b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35750,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961886",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "111818540"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327727",
                                  "name": "Paneer Tikka Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "Smoky Paneer Tikka Cubes With Capsicum, Onions, And A Spiced Tomato Sauce.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/aa4f5321-cf96-4472-ac19-c68437ac63a7_83a039a8-a2fc-40cd-b8b9-092eea133679.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962030",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478891"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327817",
                                  "name": "Chicken Supreme Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "Loaded With Grilled Chicken, Onions, Capsicum, And A Medley Of Cheese For A Hearty Bite.",
                                  "inStock": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962091",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478826"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327724",
                                  "name": "Chicken Tikka Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "Tandoori-Spiced Chicken Tikka On A Cheesy Base With Onions And Peppers.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/03b2f4af-4f73-40ac-afad-7b88cef47e66_301ba6f8-f33a-42ad-8fa8-eaa5e8558c97.jpg",
                                  "inStock": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962028",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478827"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327798",
                                  "name": "Fiery Paprika Chicken Pizza [10 Inches]",
                                  "category": "Pizza And Pasta",
                                  "description": "Spicy Chicken Chunks With Roasted Paprika, Jalapenos, And A Fiery Seasoning Blend.",
                                  "inStock": 1,
                                  "price": 47500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260962080",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478857"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677715"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/241c1611-00c2-4aa8-ba93-2ab0967a0815_18419e4c-6567-4de2-a866-33b74a7a84a1.jpg",
                      "categoryId": "69677713"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Indian Meal Box",
                      "categories": [
                        {
                          "title": "Meals",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968588",
                                  "name": "Dal Tadka Combo [Serves 1]",
                                  "category": "Indian Meal Box",
                                  "description": "Yellow Dal Tempered With Spices, Served With Rice/Roti.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226120",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124751",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Rumali Roti ",
                                            "id": "207124752",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326124",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326125",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "266058933",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818534"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327915",
                                  "name": "Dal Makhani Combo [Serves 1-2]",
                                  "category": "Indian Meal Box",
                                  "description": "Slow-Cooked Creamy Black Lentils With Rice And Roti.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/db9d819d-47db-40b9-92ac-3b7c4240d89d_57ebb25b-b5ee-44ce-9067-946b1868381d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226135",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124784",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "2 Rumali Roti",
                                            "id": "207124785",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326061",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326062",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "266058883",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478851"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327943",
                                  "name": "Rajma With Rice Combo [Serves 1-2]",
                                  "category": "Indian Meal Box",
                                  "description": "Punjabi-Style Rajma Served With Steamed Rice.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/db9d819d-47db-40b9-92ac-3b7c4240d89d_57ebb25b-b5ee-44ce-9067-946b1868381d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "108478900"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204434",
                                  "name": "Kadhai Paneer Combo [Serves 1]",
                                  "category": "Indian Meal Box",
                                  "description": "Spicy Kadhai Paneer With Rice And Choice Of Bread.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/c8a90d9b-c1db-42e6-bc3b-803a392bd535_254e2355-6d45-4e57-9be1-6f7279867399.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 33500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226075",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124652",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "2 Rumali Roti",
                                            "id": "207124653",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326069",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326070",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "266058888",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231937"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968654",
                                  "name": "Chicken Curry Combo [Serves 1]",
                                  "category": "Indian Meal Box",
                                  "description": "Homestyle Chicken Curry Paired With Rice And Bread.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/5d9d78c3-b10e-43f6-868b-5a8da9ea14e7_c54c87c8-b011-4513-b3fa-6cdfedee5f1b.jpg",
                                  "inStock": 1,
                                  "price": 37500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226110",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124728",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "2 Rumali Roti",
                                            "id": "207124729",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326073",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326074",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "266058891",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818529"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968705",
                                  "name": "Butter Chicken Combo [Serves 1]",
                                  "category": "Indian Meal Box",
                                  "description": "Creamy Butter Chicken Served With Naan/Roti And Rice.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/fda7fe26-a96f-4e44-887d-d6d36e763a71_ba2ceed8-4189-4ffa-b741-cb53a505f005.jpg",
                                  "inStock": 1,
                                  "price": 37500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226100",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124705",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "2 Rumali Roti",
                                            "id": "207124706",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326078",
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326079",
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111775167"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968516",
                                  "name": "Mutton Rogan Josh Combo [Serves 1]",
                                  "category": "Indian Meal Box",
                                  "description": "Aromatic Kashmiri-Style Mutton Curry With Rice And Naan.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/d0c53c23-14f5-4047-aa6e-5cf93c75d58c_98e8e09b-92cc-4b4d-a1fa-b1cc30d52710.jpg",
                                  "inStock": 1,
                                  "price": 51000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226134",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice [Half]",
                                            "default": 1,
                                            "id": "207124782",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "2 Rumali Roti",
                                            "id": "207124783",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326122",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326123",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "266058913",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818536"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327841",
                                  "name": "Chole Kulche",
                                  "category": "Indian Meal Box",
                                  "description": "Tangy And Spicy Chole Served With 2 Soft Kulchas.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478846"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186204421",
                                  "name": "Butter Paneer Masala Combo",
                                  "category": "Indian Meal Box",
                                  "description": "Butter Paneer Masala,  Served With Rice/Roti.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 33500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "69226136",
                                        "name": "Choice",
                                        "variations": [
                                          {
                                            "name": "Rice",
                                            "default": 1,
                                            "id": "207124786",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Rumali Roti [2 Pcs]",
                                            "id": "207124787",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Roti ",
                                            "id": "209326127",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Naan",
                                            "id": "209326128",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113231922"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677671"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/10/5/db9d819d-47db-40b9-92ac-3b7c4240d89d_57ebb25b-b5ee-44ce-9067-946b1868381d.jpg",
                      "categoryId": "69677670"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Continental Special",
                      "categories": [
                        {
                          "title": "Continental Special",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327490",
                                  "name": "Sauteed Vegetable [Serves 1-2]       ",
                                  "category": "Continental Special",
                                  "description": "Fresh Vegetables Sauteed In Olive Oil With Herbs And Light Seasoning.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478909"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327503",
                                  "name": "Baked Vegetable [Serves 1-2]",
                                  "category": "Continental Special",
                                  "description": "Mixed Vegetables Baked In Creamy White Sauce With Cheese Topping.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/a1dca2ee-a193-4b6f-a583-fe54cf2f22e8_0e3e3c16-6297-4146-8a01-fb379d64bece.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 31900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478798"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327492",
                                  "name": "Veg Lasagna [Serves 1-2]",
                                  "category": "Continental Special",
                                  "description": "Layered Pasta With Vegetables, Cheese, And Tomato Sauce, Oven-Baked.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/8fa7662a-9483-4626-956a-d0bdb18253d1_670404d8-50b6-46d4-9633-d5119314b446.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478929"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968608",
                                  "name": "Grilled Chicken",
                                  "category": "Continental Special",
                                  "description": "Italian marinated chicken breast grilled olive oil and served with brown sauce and sauteed vegetable and fresh garlic bread slice.",
                                  "inStock": 1,
                                  "price": 38500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "31423687"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193988",
                                  "name": "Baked Pink Sauce Pasta",
                                  "category": "Continental Special",
                                  "description": "Penne Pasta In Creamy Pink Sauce, Topped With Cheese And Baked.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961935",
                                      "groupName": "Garlic bread",
                                      "choices": [
                                        {
                                          "id": "142467686",
                                          "name": "Three Cheese & Chilli Garlic Bread [Serves 2-3]",
                                          "price": 24700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467687",
                                          "name": "Garlic Loaf [250 G]",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "95307179"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327500",
                                  "name": "Chicken Lasagna [Serves 1-2]",
                                  "category": "Continental Special",
                                  "description": "Layers Of Pasta With Chicken, Cheese, And Rich Tomato Sauce, Baked Golden.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/8fa7662a-9483-4626-956a-d0bdb18253d1_670404d8-50b6-46d4-9633-d5119314b446.jpg",
                                  "inStock": 1,
                                  "price": 45000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478821"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "159193784",
                                  "name": "Pepper Chicken",
                                  "category": "Continental Special",
                                  "inStock": 1,
                                  "price": 40250,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "36811870"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327511",
                                  "name": "Peri Peri Roasted Chicken [Serves 2-3]        ",
                                  "category": "Continental Special",
                                  "description": "Juicy Chicken Marinated In Spicy Peri Peri Sauce, Oven-Roasted To Perfection.",
                                  "inStock": 1,
                                  "price": 48000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478894"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327514",
                                  "name": "Grilled Fish [Serves 1-2]",
                                  "category": "Continental Special",
                                  "description": "Lightly Seasoned Fish Fillet Grilled And Served With Sauteed Veggies.",
                                  "inStock": 1,
                                  "price": 62500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478861"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "179327516",
                                  "name": "Fish And Chips [Serves 1-2]",
                                  "category": "Continental Special",
                                  "description": "Classic Battered Fish Fillets Served With Crispy Fries And Tartar Sauce.",
                                  "inStock": 1,
                                  "price": 62500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "108478858"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968595",
                                  "name": "Cajun Grilled Chicken",
                                  "category": "Continental Special",
                                  "description": "Cajun spiced 1 whole grilled chicken breast served with chef's special brown sauce.",
                                  "inStock": 1,
                                  "price": 45000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818528"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "183968480",
                                  "name": "Tuscan Chicken",
                                  "category": "Continental Special",
                                  "description": "Juicy chicken breast in a creamy and tangy paprika sauce",
                                  "inStock": 1,
                                  "price": 55000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "260961877",
                                      "groupName": "Naan",
                                      "choices": [
                                        {
                                          "id": "142467676",
                                          "name": "Butter Naan",
                                          "price": 5300,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "142467677",
                                          "name": "Garlic Naan",
                                          "price": 6600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": -1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "111818542"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677666"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/a1dca2ee-a193-4b6f-a583-fe54cf2f22e8_0e3e3c16-6297-4146-8a01-fb379d64bece.jpg",
                      "categoryId": "69677664"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193732",
                              "name": "Virgin Mojito",
                              "category": "Beverages",
                              "description": "[Non Alcoholic] Refreshing lime and mint beverage with soda.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/17/3b8752ef-1610-493d-97e7-0f636c2a8960_a3504bdf-35a0-495b-8481-67cd514beaaf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31424116"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193729",
                              "name": "Lemon Ice Tea",
                              "category": "Beverages",
                              "description": "Cold brewed tea served chilled with lemon.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/28/5a4aad64-5607-4121-ab47-290e41db5374_0b24715f-3be6-4fff-affe-bd0d9c4aca72.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423763"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193725",
                              "name": "Pink Lemonade",
                              "category": "Beverages",
                              "description": "Zesty lemonade with a splash of cranberry.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "69226081",
                                    "name": "Make your Own",
                                    "variations": [
                                      {
                                        "name": "Mint ",
                                        "default": 1,
                                        "id": "207124666",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Soda",
                                        "id": "207124667",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Sugar Free",
                                        "id": "207124669",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73627293"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193741",
                              "name": "Fresh Lime Water",
                              "category": "Beverages",
                              "description": "Refreshing lime juice with chilled water.",
                              "imageId": "igotoocq0az5te0ft1kc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423669"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193743",
                              "name": "Thandai Shake",
                              "category": "Beverages",
                              "description": "Traditional Indian chilled milk shake with dry fruits and spices.",
                              "imageId": "d60848e6a6029f4b92724d826e742489",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962054",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31424019"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "188940316",
                              "name": "Iced Tea",
                              "category": "Beverages",
                              "description": "Cold brewed tea served chilled with lemon.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423730"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193935",
                              "name": "Kitkat Shake",
                              "category": "Beverages",
                              "description": "Thick chocolate milkshake blended with KitKat bars.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962019",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467685",
                                      "name": "Chicken Cheese Burger (Classic Chicken Burger)",
                                      "price": 23000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73627290"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193707",
                              "name": "Watermelon Mojito",
                              "category": "Beverages",
                              "description": "[Non Alcoholic] Fresh watermelon, mint and a hint of lime come together over ice for a cool, revitalizing beverage.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73627296"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193726",
                              "name": "Orange Bliss",
                              "category": "Beverages",
                              "description": "Sweet and tangy orange based fizzy beverage.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/11/17/16e6a7bb-93f3-48ea-a4b8-7485c537fb69_e997ce91-6483-4c97-a6ef-3dfb482a0511.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73627292"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186204519",
                              "name": "7Up Soft Beverage [750 Ml]",
                              "category": "Beverages",
                              "description": "Bottle of lemon lime flavored soft beverage.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113231918"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186204487",
                              "name": "Vanilla Red Strawberry Shake",
                              "category": "Beverages",
                              "description": "Creamy milkshake with vanilla and strawberry flavors.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113231940"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193727",
                              "name": "Passion Fruit Ice Tea",
                              "category": "Beverages",
                              "description": "Chilled iced tea infused with tangy passion fruit flavor.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "69226114",
                                    "name": "Make Your Own",
                                    "variations": [
                                      {
                                        "name": "Mint ",
                                        "default": 1,
                                        "id": "207124738",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Soda",
                                        "id": "207124739",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Sugar Free",
                                        "id": "207124740",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "81928362"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186204472",
                              "name": "Chocolate Brownie Shake [280 Ml]",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260961883",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467685",
                                      "name": "Chicken Cheese Burger (Classic Chicken Burger)",
                                      "price": 23000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113231925"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193720",
                              "name": "Fresh Lime Soda",
                              "category": "Beverages",
                              "description": "Sparkling soda with fresh lime and a dash of salted/sugar.",
                              "imageId": "jjihm2iruqj1jhai1dti",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                "variantGroups": [
                                  {
                                    "groupId": "69226105",
                                    "name": "Make Your Own ",
                                    "variations": [
                                      {
                                        "name": "Mint",
                                        "default": 1,
                                        "id": "207124717",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Soda",
                                        "id": "207124718",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Sugar Free",
                                        "id": "207124719",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ]
                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423668"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186204469",
                              "name": "Biscoff Shake",
                              "category": "Beverages",
                              "description": "Creamy shake blended with biscoff spread and cookies.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962032",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "142467685",
                                      "name": "Chicken Cheese Burger (Classic Chicken Burger)",
                                      "price": 23000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "73627287"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186828995",
                              "name": "Iced Americano",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638245"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829009",
                              "name": "Iced Latte",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638248"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829024",
                              "name": "Iced Cappuccino",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638246"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829026",
                              "name": "Iced Vanilla Latte",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638249"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829054",
                              "name": "Iced Hazelnut Latte",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638247"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829046",
                              "name": "Hot Cappuccino",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638241"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829064",
                              "name": "Hot Latte",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638243"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829069",
                              "name": "Hot Espresso Shot",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638242"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186829032",
                              "name": "Hot Americano",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "113638240"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "186204428",
                              "name": "Cold Coffee With Ice Cream",
                              "category": "Beverages",
                              "description": "Chilled creamy coffee blended with milk and ice serve with one extra scope of ice-cream.",
                              "imageId": "3a0effb3f8bc5b9ce5122c6dbe10d836",
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962034",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423546"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "159193807",
                              "name": "Classic Cold Coffee",
                              "category": "Beverages",
                              "description": "Chilled, creamy coffee blended with milk and ice.",
                              "imageId": "3a9a257e44f3878dc224a8d3509f2af8",
                              "isVeg": 1,
                              "price": 22000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "260962050",
                                  "groupName": "Burger",
                                  "choices": [
                                    {
                                      "id": "142467684",
                                      "name": "Veg Cheese Burger",
                                      "price": 20000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12:15 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "31423542"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/11/17/3b8752ef-1610-493d-97e7-0f636c2a8960_a3504bdf-35a0-495b-8481-67cd514beaaf.jpg",
                      "categoryId": "69677692"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Burger and Sandwich Combos",
                      "categories": [
                        {
                          "title": "Burgercombos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828996",
                                  "name": "Veg Cheese Burger Fish Virgin Mojito",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled veg patty with cheese in a toasted bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "price": 31900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638265"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829070",
                                  "name": "Veg Cheese Burger with Iced Tea",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled veg patty with cheese in a toasted bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638267"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828920",
                                  "name": "Chicken Cheese Burger with Virgin Mojito",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Juicy chicken patty with melted cheese in a soft bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "price": 36000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638236"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828944",
                                  "name": "Veg Cheese Burger with Classic Cold Coffee",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled veg patty with cheese in a toasted bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638266"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940340",
                                  "name": "Chicken Cheese Burger & Ice Tea",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Juicy chicken patty with melted cheese in a soft bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "price": 40300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999120"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828994",
                                  "name": "Veg Cheese Burger Fish Chocolate Brownie Shake",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled veg patty with cheese in a toasted bun, served with fries and beverage.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638264"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829002",
                                  "name": "Chicken Cheese Burger with Classic Cold Coffee",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Juicy chicken patty with melted cheese in a soft bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "price": 44500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638235"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186829012",
                                  "name": "Chicken Cheese Burger with Chocolate Brownie Shake",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Juicy chicken patty with melted cheese in a soft bun, served with fries or beverage.",
                                  "inStock": 1,
                                  "price": 44500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638234"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677700"
                        },
                        {
                          "title": "Sandwichcombo",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940337",
                                  "name": "Cheese Corn Red Pepper Sandwich & Virgin Mojito",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Toasted sandwich filled with cheesy corn and bell peppers, served with fries or dip.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999119"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940344",
                                  "name": "Cheese Corn Red Pepper Sandwich & Ice Tea",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Toasted sandwich filled with cheesy corn and bell peppers, served with fries or dip.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999118"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "188940348",
                                  "name": "Cheese Corn Red Pepper Sandwich & Classic Cold Coffee",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Toasted sandwich filled with cheesy corn and bell peppers, served with fries or dip.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 43900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "114999117"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828980",
                                  "name": "Cheese Corn and  Pepper Sandwich with Chocolate Brownie Shake",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Toasted sandwich filled with cheesy corn and bell peppers, served with fries or dip.",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 44900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638229"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828921",
                                  "name": "Roasted Chicken Panini Sandwich with Iced Tea",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled panini with seasoned roasted chicken, served with sides.",
                                  "inStock": 1,
                                  "price": 42100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638255"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828928",
                                  "name": "Roasted Chicken Panini Sandwich with Virgin Mojito",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled panini with seasoned roasted chicken, served with sides.",
                                  "inStock": 1,
                                  "price": 37800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638256"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828965",
                                  "name": "Roasted Chicken Panini Sandwich with Classic Cold Coffee",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled panini with seasoned roasted chicken, served with sides.",
                                  "inStock": 1,
                                  "price": 46300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638254"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "186828981",
                                  "name": "Roasted Chicken Panini Sandwich with Chocolate Brownie Shake",
                                  "category": "Burger and Sandwich Combos",
                                  "description": "Grilled panini with seasoned roasted chicken, served with sides",
                                  "inStock": 1,
                                  "price": 46500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "113638253"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "69677732"
                        }
                      ],
                      "categoryId": "69677698"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11424010000687"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Amer Bakery Hut",
                      "area": "Jahangirabad",
                      "completeAddress": "Amer Bakery Hut Sanjay Taran Pushkar Pari Park Idgah Hills Road ,Huzur,Bhopal,Madhya Pradesh-462001\t"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "7uIwuMbExV0k-d3m3g-XOeYWc50rfEpPTRp89DRw"
},

  "111098": {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Da Pizzeria",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "548126",
              "name": "Da Pizzeria",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "da-pizzeria-bairagarh-bairagarh",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "qpwyav7ejytqruclfbha",
              "locality": "Indira Vihar Colony",
              "areaName": "Lalghati Square",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Pizzas",
                "Pastas"
              ],
              "avgRating": 4.2,
              "veg": true,
              "feeDetails": {
                "restaurantId": "548126",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "7067",
              "avgRatingString": "4.2",
              "totalRatingsString": "5.0K+ ratings",
              "sla": {
                "restaurantId": "548126",
                "deliveryTime": 40,
                "minDeliveryTime": 35,
                "maxDeliveryTime": 40,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3040,
                "slaString": "35-40 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 59",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "60% Off | Use FEASTMODE60",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "60% Off | Use FEASTMODE60",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "da-pizzeria-bairagarh-bairagarh",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "H.No 87,Nayapura,Lalghati,Bhopal 462030"
                },
                {
                  "title": "Cuisines",
                  "message": "Pizzas,Pastas"
                }
              ],
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 59",
                "shortDescriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "60% Off | Use FEASTMODE60",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "99 store",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "60% Off | Use FEASTMODE60",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 9,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 94
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/548126"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.2758896,77.37214389",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "enable_ecosaver",
                "99store"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹59",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "a4c2b492-d639-452d-832b-ab8ca893ba9f"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "548126",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "60% OFF UPTO ₹120",
                      "offerTag": "DEFAULT",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "13f68828-f3fd-4140-838d-b8c15f616135"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FEASTMODE60",
                      "description": "ABOVE ₹189",
                      "offerType": "offers",
                      "restId": "548126",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FEASTMODE60"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "50% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "f1b3775b-fc3f-4d3c-9d34-4c8f44bea443"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹159",
                      "offerType": "offers",
                      "restId": "548126",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "20ee07e6-9292-4ced-9a5a-05f51a5687f5"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT150",
                      "description": "ABOVE ₹449",
                      "offerType": "offers",
                      "restId": "548126",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT150"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "6bde5571-335d-4676-b919-4ac629214d9f"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT200",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "548126",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT200"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5730431",
                          "creativeId": "TopPicks2024/93961837B.png",
                          "title": "Makhani Paneer Pizza + Garlic Bread Stick",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93961837",
                              "name": "Makhani Paneer Pizza + Garlic Bread Stick",
                              "category": "Jumbo Combos",
                              "imageId": "7979d1d6066f122efb0504adb0082d4c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822927",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "144822928",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119339",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119340",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48401424"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5334228",
                          "creativeId": "TopPicks2024/93961843B.png",
                          "title": "Pack Of 4 Pan Pizzas {single Topping}",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93961843",
                              "name": "Pack Of 4 Pan Pizzas {single Topping}",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/75de8a8b-4b94-4263-97b4-3691da0893fa_1021209a-b0a2-4e74-89eb-f9d370602e6a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "52867716",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867714",
                                  "groupName": "Choice Of Toppings [single]",
                                  "choices": [
                                    {
                                      "id": "115822120",
                                      "name": "Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822118",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822161",
                                      "name": "All Of The Above",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822126",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822130",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31357005"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5336474",
                          "creativeId": "TopPicks2024/93961846B.png",
                          "title": "Pack Of 4 Pan Pizzas {double Topping}",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93961846",
                              "name": "Pack Of 4 Pan Pizzas {double Topping}",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/7849653e-a767-4eca-a0ea-a548aabeb707_56406528-0b60-4abd-9468-7c3ba0789e5b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119260",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867722",
                                  "groupName": "Choice Of Toppings [double]",
                                  "choices": [
                                    {
                                      "id": "115822165",
                                      "name": "Tomato & Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822144",
                                      "name": "All Of The Above",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822155",
                                      "name": "Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822157",
                                      "name": "Paneer & Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822147",
                                      "name": "Mushroom & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31357002"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961881",
                              "name": "Simply Capsicum",
                              "category": "Pizza",
                              "description": "Crisp Capsicum with 100 % Mozzarella Cheese",
                              "imageId": "h8gzfts48apa0ecoqpc8",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064609",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 145,
                                        "default": 1,
                                        "id": "53370203",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 285,
                                        "id": "53370204",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 375,
                                        "id": "53370205",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064609",
                                        "variationId": "53370203"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867759",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867758",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867758",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867758",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867758",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867760",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "94"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064609",
                                        "variationId": "53370204"
                                      }
                                    ],
                                    "price": 28500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867765",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867764",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867763",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867763",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867763",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867763",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "234"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064609",
                                        "variationId": "53370205"
                                      }
                                    ],
                                    "price": 37500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822659",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822660",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119223",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822661",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867766",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867766",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867766",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867766",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867768",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822662",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867767",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867762",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119224",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "324"
                                    }
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867758",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867763",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867766",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867760",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867765",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867768",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867759",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867764",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867767",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867762",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48225432"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961884",
                              "name": "Simply Corn",
                              "category": "Pizza",
                              "description": "Sweet & Juicy Golden Corn with 100 % Mozzarella Cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/0d1f21bc-55a7-4d04-9dc0-2f2ad56ac127_7ad752d9-4608-456c-a4a4-272e9927ad0b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064610",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 145,
                                        "default": 1,
                                        "id": "53370206",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 285,
                                        "id": "53370207",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 375,
                                        "id": "53370208",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064610",
                                        "variationId": "53370206"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867775",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867774",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867774",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867774",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867774",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867776",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "94"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064610",
                                        "variationId": "53370207"
                                      }
                                    ],
                                    "price": 28500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867781",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867780",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867779",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867779",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867779",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867779",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "234"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064610",
                                        "variationId": "53370208"
                                      }
                                    ],
                                    "price": 37500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822700",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822701",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119234",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822702",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867782",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867782",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867782",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867782",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867784",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822703",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867783",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867778",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119235",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "324"
                                    }
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867774",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867779",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867782",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867776",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867781",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867784",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867775",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867780",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867783",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867778",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "96 ratings",
                                  "ratingCountV2": "96"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48225433"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961885",
                              "name": "Simply Tomato",
                              "category": "Pizza",
                              "description": "Tomato with 100 % Mozzarella Cheese",
                              "imageId": "euzclq1xs5cjgiwjnmag",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064611",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 145,
                                        "default": 1,
                                        "id": "53370209",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 285,
                                        "id": "53370210",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 375,
                                        "id": "53370211",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064611",
                                        "variationId": "53370209"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867791",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867790",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867790",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867790",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867790",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867792",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "94"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064611",
                                        "variationId": "53370210"
                                      }
                                    ],
                                    "price": 28500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867797",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867796",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867795",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867795",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867795",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867795",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "234"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064611",
                                        "variationId": "53370211"
                                      }
                                    ],
                                    "price": 37500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822687",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822688",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119221",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822689",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867798",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867798",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867798",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867798",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867800",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822690",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867799",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867794",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119222",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "324"
                                    }
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867790",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867795",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867798",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867792",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867797",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867800",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867791",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867796",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867799",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867794",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48225434"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961857",
                              "name": "Mergherita Pizza",
                              "category": "Pizza",
                              "description": "On house marinara sauce, 100% mozzarella cheese and fresh organic basil",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/0f869477-b747-4e49-b463-eea1f27b60c5_391a56b0-8716-4b07-b4df-9be762c13015.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064598",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small",
                                        "price": 145,
                                        "default": 1,
                                        "id": "53370180",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 285,
                                        "id": "53370181",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 375,
                                        "id": "53370182",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064598",
                                        "variationId": "53370180"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867743",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867742",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867742",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867742",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867742",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867744",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "94"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064598",
                                        "variationId": "53370181"
                                      }
                                    ],
                                    "price": 28500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867749",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867748",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867747",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867747",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867747",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867747",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "234"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064598",
                                        "variationId": "53370182"
                                      }
                                    ],
                                    "price": 37500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822675",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822676",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119227",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822677",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867750",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867750",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867750",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867750",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867752",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822678",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867751",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867746",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119228",
                                        "addonId": "115822125"
                                      }
                                    ],
                                    "finalPrice": {
                                      "units": "324"
                                    }
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867742",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867747",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867750",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867744",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867749",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867752",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867743",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867748",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867751",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867746",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "397 ratings",
                                  "ratingCountV2": "397"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833757"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961888",
                              "name": "Golden Delight",
                              "category": "Pizza",
                              "description": "A flavorful combination of onion, capsicum, golden corn, red paprika & 100% Mozzarella cheese",
                              "imageId": "ct7ermfnsfnm88gqmtjy",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064614",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 215,
                                        "default": 1,
                                        "id": "53370218",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 310,
                                        "id": "53370219",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 475,
                                        "id": "53370220",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064614",
                                        "variationId": "53370218"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867839",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867838",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867838",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867838",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867838",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867840",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064614",
                                        "variationId": "53370219"
                                      }
                                    ],
                                    "price": 31000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867845",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867844",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867843",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867843",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867843",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867843",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064614",
                                        "variationId": "53370220"
                                      }
                                    ],
                                    "price": 47500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822738",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822739",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119284",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822740",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867846",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867846",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867846",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867846",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867848",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822741",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867847",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867842",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119285",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867838",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867843",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867846",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867840",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867845",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867848",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867839",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867844",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867847",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867842",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "123 ratings",
                                  "ratingCountV2": "123"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225424"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961891",
                              "name": "Mexican Delight",
                              "category": "Pizza",
                              "description": "Onion, tomato, jalapenos & mexican seasoning with 100 % Mozzarella Cheese.",
                              "imageId": "vr4idn0nrnn14uukcppm",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064615",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 215,
                                        "default": 1,
                                        "id": "53370221",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 310,
                                        "id": "53370222",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 475,
                                        "id": "80919313",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064615",
                                        "variationId": "53370221"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867855",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867854",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867854",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867854",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867854",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867856",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064615",
                                        "variationId": "53370222"
                                      }
                                    ],
                                    "price": 31000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867861",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867860",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867859",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867859",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867859",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867859",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064615",
                                        "variationId": "80919313"
                                      }
                                    ],
                                    "price": 47500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822734",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822735",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119274",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822736",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "82426306",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "82426306",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "82426306",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "82426306",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "82426308",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822737",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "82426307",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867858",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119275",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867854",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867859",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "82426306",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867856",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867861",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82426308",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867855",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867860",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "82426307",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867858",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "155 ratings",
                                  "ratingCountV2": "155"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51833758"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961892",
                              "name": "Mushroom Magic",
                              "category": "Pizza",
                              "description": "Onion, mushroom, green chilly, garlic & 100 % Mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/6745dd15-f676-4b71-bfb4-1ce7357e174c_a83fe512-a0e6-45fa-ac06-ec398d796124.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064616",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 215,
                                        "default": 1,
                                        "id": "53370223",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 310,
                                        "id": "53370224",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 475,
                                        "id": "53370225",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064616",
                                        "variationId": "53370223"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867868",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867867",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867867",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867867",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867867",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867869",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064616",
                                        "variationId": "53370224"
                                      }
                                    ],
                                    "price": 31000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867874",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867873",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867872",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867872",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867872",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867872",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064616",
                                        "variationId": "53370225"
                                      }
                                    ],
                                    "price": 47500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822671",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822672",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119280",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822673",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867875",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867875",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867875",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867875",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867877",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822674",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867876",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867871",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119281",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867867",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867872",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867875",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867869",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867874",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867877",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867868",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867873",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867876",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867871",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225429"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961955",
                              "name": "Tandoori Paneer",
                              "category": "Pizza",
                              "description": "Powerful combination of tandoori sauce, topped with seasoned onion ,capsicum, black olive ,mustard oil and paneer & 100 % Mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/935fda5c-4806-466f-bf6e-f1640020f05a_41cc04dc-3be1-401d-9d36-228facc131a7.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064624",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 240,
                                        "default": 1,
                                        "id": "53370247",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 345,
                                        "id": "53370248",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 515,
                                        "id": "53370249",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064624",
                                        "variationId": "53370247"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52868046",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52868045",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52868045",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52868045",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52868045",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52868047",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064624",
                                        "variationId": "53370248"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868052",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52868051",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52868050",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52868050",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52868050",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52868050",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064624",
                                        "variationId": "53370249"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822683",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822684",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119294",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822685",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868053",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52868053",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52868053",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52868053",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52868055",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822686",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52868054",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868049",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119295",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52868045",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868050",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868053",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868047",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868052",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868055",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868046",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868051",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868054",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868049",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 24000,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "120 ratings",
                                  "ratingCountV2": "120"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225439"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961951",
                              "name": "Achari Paneer",
                              "category": "Pizza",
                              "description": "Classic combination of Indian pickle spices with topped achari marinated paneer, capsicum, onion & mustard oil & 100% Mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/dfacd98b-b33d-42cf-9354-dcbc63afc2b6_dbfbd7b3-8db8-4b77-917e-faa6dc9ac014.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064622",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 240,
                                        "default": 1,
                                        "id": "53370241",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 345,
                                        "id": "53370242",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 515,
                                        "id": "53370243",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064622",
                                        "variationId": "53370241"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52868014",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52868013",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52868013",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52868013",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52868013",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52868015",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064622",
                                        "variationId": "53370242"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868020",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52868019",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52868018",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52868018",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52868018",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52868018",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064622",
                                        "variationId": "53370243"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822696",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822697",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119290",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822698",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868021",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52868021",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52868021",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52868021",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52868023",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822699",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52868022",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868017",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119291",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52868013",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868018",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868021",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868015",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868020",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868023",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868014",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868019",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868022",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868017",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 24000,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "78682553"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961956",
                              "name": "Garden Delight",
                              "category": "Pizza",
                              "description": "Assorted Bell Pepper, Sweet Corn, Onion, Oregano, Basil & Olive Oil & 100 % Mozzarella Cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/040c3106-0a36-46a7-b906-8a753f57ec58_5176b4d2-93b3-4a6e-a880-940456bd1c3f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064625",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 240,
                                        "default": 1,
                                        "id": "53370250",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 345,
                                        "id": "53370251",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 515,
                                        "id": "53370252",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064625",
                                        "variationId": "53370250"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52868062",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52868061",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52868061",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52868061",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52868061",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52868063",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064625",
                                        "variationId": "53370251"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868068",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52868067",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52868066",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52868066",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52868066",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52868066",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064625",
                                        "variationId": "53370252"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822667",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822668",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119310",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822669",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868069",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52868069",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52868069",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52868069",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52868071",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822670",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52868070",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868065",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119311",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52868061",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868066",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868069",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868063",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868068",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868071",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868062",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868067",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868070",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868065",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 24000,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "78682575"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961896",
                              "name": "Hawaiian Special",
                              "category": "Pizza",
                              "description": "Sweet & Tangy combination of Pineapple, Jalapeño, Mushroom & Paneer marinated in house marinara sauce with 100 % Mozzarella cheese.",
                              "imageId": "qe6uw6n86yk9hv1faa96",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064619",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 240,
                                        "default": 1,
                                        "id": "53370232",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 345,
                                        "id": "53370233",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 515,
                                        "id": "53370234",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064619",
                                        "variationId": "53370232"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867916",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867915",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867915",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867915",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867915",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867917",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064619",
                                        "variationId": "53370233"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867934",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867931",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867929",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867929",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867929",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867929",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064619",
                                        "variationId": "53370234"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822713",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822714",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119292",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822715",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867936",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867936",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867936",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867936",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867939",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822716",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867938",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867927",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119293",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867915",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867929",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867936",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867917",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867934",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867939",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867916",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867931",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867938",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867927",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 24000,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225425"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961895",
                              "name": "Corn O Mania",
                              "category": "Pizza",
                              "description": "A Delicious Combination of mozzarella Cheese, Onion, Capsicum, Baby Corn and Golden Corn & 100 % Mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/7aae0659-c16c-4af7-bbb6-425420886634_7fcfb2ae-3363-464f-9256-02a20fdc54c0.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064618",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 240,
                                        "default": 1,
                                        "id": "53370229",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 345,
                                        "id": "53370230",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 515,
                                        "id": "53370231",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064618",
                                        "variationId": "53370229"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52867900",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52867899",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52867899",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52867899",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52867899",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52867901",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064618",
                                        "variationId": "53370230"
                                      }
                                    ],
                                    "price": 34500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867906",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52867905",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52867904",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52867904",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52867904",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52867904",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064618",
                                        "variationId": "53370231"
                                      }
                                    ],
                                    "price": 51500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822721",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822722",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119298",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822723",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52867907",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "52867907",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "52867907",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "52867907",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52867909",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822724",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52867908",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52867903",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119299",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52867899",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867904",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867907",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52867901",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867906",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867909",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867900",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867905",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867908",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867903",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 24000,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225420"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961961",
                              "name": "Party Lovers",
                              "category": "Pizza",
                              "description": "Grated paneer, Onion, Black Olives, Jalapeno, Golden Corn, Red Capsicum and garlic chunks and liquid cheddar cheese & 100 % Mozzarella cheese.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/b8ed143d-5879-4d05-9886-7983dc245c46_d7d4e878-5c67-46a4-b65c-ddc147fafc42.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064629",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 265,
                                        "default": 1,
                                        "id": "53370262",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 399,
                                        "id": "53370263",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 550,
                                        "id": "53370264",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064629",
                                        "variationId": "53370262"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52868126",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52868125",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52868125",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52868125",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52868125",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52868127",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064629",
                                        "variationId": "53370263"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868132",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52868131",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52868130",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52868130",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52868130",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52868130",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064629",
                                        "variationId": "53370264"
                                      }
                                    ],
                                    "price": 55000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822726",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822727",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119312",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822728",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "91119314",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "91119314",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "91119314",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "91119314",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52868135",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822729",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52868134",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868129",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119313",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52868125",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868130",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "91119314",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868127",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868132",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868135",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868126",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868131",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868134",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868129",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225430"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961960",
                              "name": "La Italiano",
                              "category": "Pizza",
                              "description": "A gourmet sauce with Onion, capsicum, mushroom, black olives, jalapenos, liquid Cheddar cheese & 100 % Mozzarella cheese.",
                              "imageId": "d6a4cc86a4e2e15ec0f7a3e33cff103c",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "16064628",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Small [ 7 Inch]",
                                        "price": 265,
                                        "default": 1,
                                        "id": "53370259",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium  [10 Inch]",
                                        "price": 399,
                                        "id": "53370260",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large  [14 Inch]",
                                        "price": 550,
                                        "id": "53370261",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064628",
                                        "variationId": "53370259"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013897"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013898"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013899"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013900"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013901"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013902"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013903"
                                      },
                                      {
                                        "groupId": "52868110",
                                        "addonId": "85013904"
                                      },
                                      {
                                        "groupId": "52868109",
                                        "addonId": "63390106"
                                      },
                                      {
                                        "groupId": "52868109",
                                        "addonId": "63390107"
                                      },
                                      {
                                        "groupId": "52868109",
                                        "addonId": "63390108"
                                      },
                                      {
                                        "groupId": "52868109",
                                        "addonId": "63390109"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "52868111",
                                        "addonId": "43435693"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064628",
                                        "variationId": "53370260"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "52868116",
                                        "addonId": "43435699"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013912"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013913"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013914"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013915"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013916"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013917"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013918"
                                      },
                                      {
                                        "groupId": "52868115",
                                        "addonId": "85013919"
                                      },
                                      {
                                        "groupId": "52868114",
                                        "addonId": "63390117"
                                      },
                                      {
                                        "groupId": "52868114",
                                        "addonId": "63390118"
                                      },
                                      {
                                        "groupId": "52868114",
                                        "addonId": "63390119"
                                      },
                                      {
                                        "groupId": "52868114",
                                        "addonId": "63390120"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "16064628",
                                        "variationId": "53370261"
                                      }
                                    ],
                                    "price": 55000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822132"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822138"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822122"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822115"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822131"
                                      },
                                      {
                                        "groupId": "144822744",
                                        "addonId": "115822159"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822135"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822141"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822124"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822156"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822163"
                                      },
                                      {
                                        "groupId": "144822745",
                                        "addonId": "115822162"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822142"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822145"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822149"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822153"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822136"
                                      },
                                      {
                                        "groupId": "91119315",
                                        "addonId": "115822134"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822133"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822139"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822123"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822116"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822128"
                                      },
                                      {
                                        "groupId": "144822746",
                                        "addonId": "115822160"
                                      },
                                      {
                                        "groupId": "91119317",
                                        "addonId": "63390127"
                                      },
                                      {
                                        "groupId": "91119317",
                                        "addonId": "63390128"
                                      },
                                      {
                                        "groupId": "91119317",
                                        "addonId": "63390129"
                                      },
                                      {
                                        "groupId": "91119317",
                                        "addonId": "63390130"
                                      },
                                      {
                                        "groupId": "52868119",
                                        "addonId": "43435707"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822158"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822164"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822146"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822143"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822140"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822137"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822117"
                                      },
                                      {
                                        "groupId": "144822747",
                                        "addonId": "115822129"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013920"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013921"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013922"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013923"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013924"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013925"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013926"
                                      },
                                      {
                                        "groupId": "52868118",
                                        "addonId": "85013927"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013905"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013910"
                                      },
                                      {
                                        "groupId": "52868113",
                                        "addonId": "85013911"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "61089627"
                                      },
                                      {
                                        "groupId": "91119316",
                                        "addonId": "115822125"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "52868109",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868114",
                                  "groupName": "Choice Of Crust (Medium)",
                                  "choices": [
                                    {
                                      "id": "63390119",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390120",
                                      "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390117",
                                      "name": "Double Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390118",
                                      "name": "Cheese Burst",
                                      "price": 11000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "91119317",
                                  "groupName": "Choice Of Crust (Large)",
                                  "choices": [
                                    {
                                      "id": "63390129",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390130",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390127",
                                      "name": "Double Burst",
                                      "price": 16000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390128",
                                      "name": "Cheese Burst",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "52868111",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868116",
                                  "groupName": "Extra Cheese [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435699",
                                      "name": "Cheese",
                                      "price": 10000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868119",
                                  "groupName": "Extra Cheese [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435707",
                                      "name": "Cheese",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868110",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868115",
                                  "groupName": "Extra Toppings [10 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013912",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013913",
                                      "name": "Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013914",
                                      "name": "Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013916",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013918",
                                      "name": "Red Pepprika",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013915",
                                      "name": "Corn",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013917",
                                      "name": "Jalepeno",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013919",
                                      "name": "Black Olives",
                                      "price": 3500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868118",
                                  "groupName": "Extra Toppings [14 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013920",
                                      "name": "Onion",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013921",
                                      "name": "Capsicum",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013922",
                                      "name": "Tomato",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013924",
                                      "name": "Paneer",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013926",
                                      "name": "Red Pepprika",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013923",
                                      "name": "Corn",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013925",
                                      "name": "Jalepeno",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013927",
                                      "name": "Black Olives",
                                      "price": 5500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52868113",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26500,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48225427"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961840",
                              "name": "Corn Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/97b547cd-33d0-4a0b-ac00-8d718c118f51_bfb9ffd1-0cfb-4f7f-bd04-3b683b5df21c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119343",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119344",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119345",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1875 ratings",
                                  "ratingCountV2": "1.9K+"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833756"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961841",
                              "name": "Double Topping Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/b139801c-c713-41a0-a002-2d73cc7bd150_744d9f5d-b5a8-4df2-95dd-bc0c8bf48ab8.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119348",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119349",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119350",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144823199",
                                  "groupName": "Double Topping",
                                  "choices": [
                                    {
                                      "id": "115822421",
                                      "name": "Mushroom & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822419",
                                      "name": "Paneer & Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822426",
                                      "name": "Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822420",
                                      "name": "Corn & Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "664 ratings",
                                  "ratingCountV2": "664"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48401415"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961845",
                              "name": "Tomato Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/e91d76c5-7f6f-4847-a491-454f356b7cde_32db4c3d-03b0-49f2-852d-d124fa8a2450.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119369",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119370",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119371",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833762"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93009593",
                              "name": "Stuffed Garlic Bread",
                              "category": "Sides & Quick Bites ",
                              "imageId": "zadhzrtfvwbdlolza5aw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12000,
                              "finalPrice": 7800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119278",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "687 ratings",
                                  "ratingCountV2": "687"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "08ad31c5-4155-457f-a1cb-7dd4dc8ef0e8"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "31357028"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pizza",
                      "categories": [
                        {
                          "title": "Classic Pizza's ",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961857",
                                  "name": "Mergherita Pizza",
                                  "category": "Pizza",
                                  "description": "On house marinara sauce, 100% mozzarella cheese and fresh organic basil",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/0f869477-b747-4e49-b463-eea1f27b60c5_391a56b0-8716-4b07-b4df-9be762c13015.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 9400,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064598",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small",
                                            "price": 145,
                                            "default": 1,
                                            "id": "53370180",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium",
                                            "price": 285,
                                            "id": "53370181",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large",
                                            "price": 375,
                                            "id": "53370182",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064598",
                                            "variationId": "53370180"
                                          }
                                        ],
                                        "price": 14500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867743",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867742",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867742",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867742",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867742",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867744",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "94"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064598",
                                            "variationId": "53370181"
                                          }
                                        ],
                                        "price": 28500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867749",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867748",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867747",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867747",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867747",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867747",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "234"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064598",
                                            "variationId": "53370182"
                                          }
                                        ],
                                        "price": 37500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822675",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822676",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119227",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822677",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867750",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867750",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867750",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867750",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867752",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822678",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867751",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867746",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119228",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "324"
                                        }
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867742",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867747",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867750",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867744",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867749",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867752",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867743",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867748",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867751",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867746",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14500,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "397 ratings",
                                      "ratingCountV2": "397"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "51833757"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961887",
                                  "name": "Farm Fresh",
                                  "category": "Pizza",
                                  "description": "A Delightful combination of Onion, capsicum, tomato  & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/7f139a18-d7ef-47d6-918e-73c0e8c7b0f3_cc56bde2-ac26-471e-9576-156077f4b625.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064613",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370215",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370216",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "53370217",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064613",
                                            "variationId": "53370215"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867823",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867822",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867822",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867822",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867822",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867824",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064613",
                                            "variationId": "53370216"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867829",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867828",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867827",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867827",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867827",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867827",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064613",
                                            "variationId": "53370217"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822638",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822639",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119268",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822640",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867830",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867830",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867830",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867830",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867832",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822641",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867831",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867826",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119269",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867822",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867827",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867830",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867824",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867829",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867832",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867823",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867828",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867831",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867826",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "87 ratings",
                                      "ratingCountV2": "87"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682572"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961888",
                                  "name": "Golden Delight",
                                  "category": "Pizza",
                                  "description": "A flavorful combination of onion, capsicum, golden corn, red paprika & 100% Mozzarella cheese",
                                  "imageId": "ct7ermfnsfnm88gqmtjy",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064614",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370218",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370219",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "53370220",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064614",
                                            "variationId": "53370218"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867839",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867838",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867838",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867838",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867838",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867840",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064614",
                                            "variationId": "53370219"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867845",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867844",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867843",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867843",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867843",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867843",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064614",
                                            "variationId": "53370220"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822738",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822739",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119284",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822740",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867846",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867846",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867846",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867846",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867848",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822741",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867847",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867842",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119285",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867838",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867843",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867846",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867840",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867845",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867848",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867839",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867844",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867847",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867842",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "123 ratings",
                                      "ratingCountV2": "123"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225424"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961891",
                                  "name": "Mexican Delight",
                                  "category": "Pizza",
                                  "description": "Onion, tomato, jalapenos & mexican seasoning with 100 % Mozzarella Cheese.",
                                  "imageId": "vr4idn0nrnn14uukcppm",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064615",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370221",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370222",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "80919313",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064615",
                                            "variationId": "53370221"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867855",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867854",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867854",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867854",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867854",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867856",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064615",
                                            "variationId": "53370222"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867861",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867860",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867859",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867859",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867859",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867859",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064615",
                                            "variationId": "80919313"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822734",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822735",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119274",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822736",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "82426306",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "82426306",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "82426306",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "82426306",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "82426308",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822737",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "82426307",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867858",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119275",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867854",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867859",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "82426306",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867856",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867861",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82426308",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867855",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867860",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82426307",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867858",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "155 ratings",
                                      "ratingCountV2": "155"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51833758"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961892",
                                  "name": "Mushroom Magic",
                                  "category": "Pizza",
                                  "description": "Onion, mushroom, green chilly, garlic & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/6745dd15-f676-4b71-bfb4-1ce7357e174c_a83fe512-a0e6-45fa-ac06-ec398d796124.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064616",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370223",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370224",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "53370225",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064616",
                                            "variationId": "53370223"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867868",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867867",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867867",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867867",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867867",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867869",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064616",
                                            "variationId": "53370224"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867874",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867873",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867872",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867872",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867872",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867872",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064616",
                                            "variationId": "53370225"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822671",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822672",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119280",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822673",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867875",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867875",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867875",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867875",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867877",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822674",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867876",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867871",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119281",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867867",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867872",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867875",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867869",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867874",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867877",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867868",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867873",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867876",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867871",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225429"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961893",
                                  "name": "Spicy Treat",
                                  "category": "Pizza",
                                  "description": "Onion, capsicum, green chilli, coriander & 100 % Mozzarella cheese.",
                                  "imageId": "50745485b7fb19d977013b30641ebc7c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064617",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370226",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370227",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "53370228",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064617",
                                            "variationId": "53370226"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867884",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867883",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867883",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867883",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867883",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867885",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064617",
                                            "variationId": "53370227"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867890",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867889",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867888",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867888",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867888",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867888",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064617",
                                            "variationId": "53370228"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822709",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822710",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119288",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822711",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867891",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867891",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867891",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867891",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867893",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822712",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867892",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867887",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119289",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867883",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867888",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867891",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867885",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867890",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867893",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867884",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867889",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867892",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867887",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225436"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23545557"
                        },
                        {
                          "title": "Indian Twist Pizza's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961955",
                                  "name": "Tandoori Paneer",
                                  "category": "Pizza",
                                  "description": "Powerful combination of tandoori sauce, topped with seasoned onion ,capsicum, black olive ,mustard oil and paneer & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/935fda5c-4806-466f-bf6e-f1640020f05a_41cc04dc-3be1-401d-9d36-228facc131a7.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064624",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370247",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370248",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370249",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064624",
                                            "variationId": "53370247"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868046",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868045",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868045",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868045",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868045",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868047",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064624",
                                            "variationId": "53370248"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868052",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868051",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868050",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868050",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868050",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868050",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064624",
                                            "variationId": "53370249"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822683",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822684",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119294",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822685",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868053",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52868053",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52868053",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52868053",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868055",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822686",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868054",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868049",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119295",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868045",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868050",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868053",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868047",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868052",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868055",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868046",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868051",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868054",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868049",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "120 ratings",
                                      "ratingCountV2": "120"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225439"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116934",
                                  "name": "Butter Paneer Masala",
                                  "category": "Pizza",
                                  "description": "A Butter Marinated Paneer tossed in rich Lababdar gravy and filled with goodness of Cream & 100% Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/49e72c9e-deb8-4a3c-8a0c-16f092dd6380_65eabc15-2aa5-4a8a-a3cd-e79168df2b8c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519547",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687236",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687237",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687238",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519547",
                                            "variationId": "129687236"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821543",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821537",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821537",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821537",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821537",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821540",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519547",
                                            "variationId": "129687237"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821541",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821544",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821538",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821538",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821538",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821538",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519547",
                                            "variationId": "129687238"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821547",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821548",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821550",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821549",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821539",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821539",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821539",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821539",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821542",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821551",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821545",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821546",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821552",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821537",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821538",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821539",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821540",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821541",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821542",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821543",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821544",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821545",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821546",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682558"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961935",
                                  "name": "Makhani Paneer",
                                  "category": "Pizza",
                                  "description": "A great combination of makhani sauce topped with capsicum, black olive, paneer, onion with makhani sauce & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/c2cc0c16-0946-4a3b-88fe-f77575567ada_0578474e-0d08-4a08-a1fe-9dc3cd4a42cd.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064621",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370238",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370239",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370240",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064621",
                                            "variationId": "53370238"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867990",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867989",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867989",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867989",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867989",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867995",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064621",
                                            "variationId": "53370239"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868004",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868003",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868002",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868002",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868002",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868002",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064621",
                                            "variationId": "53370240"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822655",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822656",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119296",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822657",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868005",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52868005",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52868005",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52868005",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868007",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822658",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868006",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868001",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119297",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867989",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868002",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868005",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867995",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868004",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868007",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867990",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868003",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868006",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868001",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225428"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116939",
                                  "name": "Paneer Malai Tikka",
                                  "category": "Pizza",
                                  "description": "A tender paneer tikka marinate with cream and Indian spices, chunks with onion and bell pepper & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/ced46186-ea8d-4ef5-bbb7-55ef866d58d9_0fcfa4fa-cdbf-49a5-b92d-73e9f80b620d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519551",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687248",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687249",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687250",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519551",
                                            "variationId": "129687248"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821575",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821569",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821569",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821569",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821569",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821572",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519551",
                                            "variationId": "129687249"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821573",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821576",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821570",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821570",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821570",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821570",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519551",
                                            "variationId": "129687250"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821579",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821580",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821582",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821581",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821571",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821571",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821571",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821571",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821574",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821583",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821577",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821578",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821584",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821569",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821570",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821571",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821572",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821573",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821574",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821575",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821576",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821577",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821578",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682591"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961951",
                                  "name": "Achari Paneer",
                                  "category": "Pizza",
                                  "description": "Classic combination of Indian pickle spices with topped achari marinated paneer, capsicum, onion & mustard oil & 100% Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/dfacd98b-b33d-42cf-9354-dcbc63afc2b6_dbfbd7b3-8db8-4b77-917e-faa6dc9ac014.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064622",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370241",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370242",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370243",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064622",
                                            "variationId": "53370241"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868014",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868013",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868013",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868013",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868013",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868015",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064622",
                                            "variationId": "53370242"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868020",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868019",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868018",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868018",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868018",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868018",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064622",
                                            "variationId": "53370243"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822696",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822697",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119290",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822698",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868021",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52868021",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52868021",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52868021",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868023",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822699",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868022",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868017",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119291",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868013",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868018",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868021",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868015",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868020",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868023",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868014",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868019",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868022",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868017",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682553"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116940",
                                  "name": "Signature Peri Peri Paneer",
                                  "category": "Pizza",
                                  "description": "A special pizza for spicy lovers topped with capsicum, red paprika, onion marinated paneer with cheese and red, yellow capsicum & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/bb00bbcb-708b-4b31-8be0-f1d2dcdaf846_72c852cd-93eb-4eda-b9c0-39015ee352f0.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519554",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687263",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687264",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687265",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519554",
                                            "variationId": "129687263"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821591",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821585",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821585",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821585",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821585",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821588",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519554",
                                            "variationId": "129687264"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821589",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821592",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821586",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821586",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821586",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821586",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519554",
                                            "variationId": "129687265"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821595",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821596",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821598",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821597",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821587",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821587",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821587",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821587",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821590",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821599",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821593",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821594",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821600",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821585",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821586",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821587",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821588",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821589",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821590",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821591",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821592",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821593",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821594",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682599"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116949",
                                  "name": "Tikka Fussion Overload",
                                  "category": "Pizza",
                                  "description": "Tandoori sauce marinated veggies such as all 3 types of capsicum, paneer, onion, mint, spices & green coriander with 100% Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/8e6b6ab4-6fcb-48ad-8a4c-ef1bdc928561_4f9dabaa-20c0-4d96-8994-b209753b974d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519569",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687339",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687340",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687341",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519569",
                                            "variationId": "129687339"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821607",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821601",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821601",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821601",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821601",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821604",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519569",
                                            "variationId": "129687340"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821605",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821608",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821602",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821602",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821602",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821602",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519569",
                                            "variationId": "129687341"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821611",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821612",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821614",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821613",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821603",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821603",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821603",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821603",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821606",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821615",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821609",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821610",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821616",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821601",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821602",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821603",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821604",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821605",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821606",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821607",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821608",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821609",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821610",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682607"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116938",
                                  "name": "Chilly Paneer",
                                  "category": "Pizza",
                                  "description": "A classic oriental sauce, topped with marinated paneer with three type of capsicum, onion with garlic sauce & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/fba6ff2d-0a8c-47b1-9e89-57d44df10c8b_ee968ecd-d279-4cd8-a4ee-93974324f44b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519550",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687245",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687246",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687247",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519550",
                                            "variationId": "129687245"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821559",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821553",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821553",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821553",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821553",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821556",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519550",
                                            "variationId": "129687246"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821557",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821560",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821554",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821554",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821554",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821554",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519550",
                                            "variationId": "129687247"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821563",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821564",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821566",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821565",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821555",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821555",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821555",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821555",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821558",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821567",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821561",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821562",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821568",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821553",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821554",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821555",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821556",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821557",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821558",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821559",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821560",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821561",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821562",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682563"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23545558"
                        },
                        {
                          "title": "Exotic Pizza's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961961",
                                  "name": "Party Lovers",
                                  "category": "Pizza",
                                  "description": "Grated paneer, Onion, Black Olives, Jalapeno, Golden Corn, Red Capsicum and garlic chunks and liquid cheddar cheese & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/b8ed143d-5879-4d05-9886-7983dc245c46_d7d4e878-5c67-46a4-b65c-ddc147fafc42.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064629",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "53370262",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 399,
                                            "id": "53370263",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "53370264",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064629",
                                            "variationId": "53370262"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868126",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868125",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868125",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868125",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868125",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868127",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064629",
                                            "variationId": "53370263"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868132",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868131",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868130",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868130",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868130",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868130",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064629",
                                            "variationId": "53370264"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822726",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822727",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119312",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822728",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119314",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119314",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119314",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119314",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868135",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822729",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868134",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868129",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119313",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868125",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868130",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119314",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868127",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868132",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868135",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868126",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868131",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868134",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868129",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225430"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961957",
                                  "name": "Barbeque Delight",
                                  "category": "Pizza",
                                  "description": "Special In House BBQ Sauce, Baby Corn,\tMushroom, Tomato, Black Olives & BBQ sauce marinated Paneer & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/183b97ca-8983-4b8d-99ba-28f040b3a54b_bb33b55d-e63b-497f-b34f-5d63b7752ab7.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064626",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "53370253",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 399,
                                            "id": "53370254",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "53370255",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064626",
                                            "variationId": "53370253"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868078",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868077",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868077",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868077",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868077",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868079",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064626",
                                            "variationId": "53370254"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868084",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868083",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868082",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868082",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868082",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868082",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064626",
                                            "variationId": "53370255"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822717",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822718",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119324",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822719",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119326",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119326",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119326",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119326",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868087",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822720",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868086",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868081",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119325",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868077",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868082",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119326",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868079",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868084",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868087",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868078",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868083",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868086",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868081",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225419"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112436086",
                                  "name": "Exotica",
                                  "category": "Pizza",
                                  "description": "In house prepared marinara sauce, Red & Yellow Capsicum, Black Olives, Jalapeno, Tomato & Sweet Corn & 100 % Mozzarella Cheese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/147b0805-e3e5-46d7-9af3-35fbb9c9f9a4_4df35586-f15e-480d-9586-aca1dd847753.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "25456085",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 235,
                                            "default": 1,
                                            "id": "80919321",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 365,
                                            "id": "80919322",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "80919323",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25456085",
                                            "variationId": "80919321"
                                          }
                                        ],
                                        "price": 23500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "91119331",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "82426322",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "82426322",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "82426322",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "82426322",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "91119330",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25456085",
                                            "variationId": "80919322"
                                          }
                                        ],
                                        "price": 36500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119334",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "91119335",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "82426323",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "82426323",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "82426323",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "82426323",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25456085",
                                            "variationId": "80919323"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822663",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822664",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119332",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822665",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119336",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119336",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119336",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119336",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "91119337",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822666",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "91119338",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "82426321",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119333",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "82426322",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "82426323",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119336",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119330",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "91119334",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "91119337",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "91119331",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "91119335",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "91119338",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "82426321",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "50 ratings",
                                      "ratingCountV2": "50"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "64851317"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961988",
                                  "name": "Supreme Ecstasy",
                                  "category": "Pizza",
                                  "description": "A gourmet sauce with Onion, capsicum, Golden corn, mushroom, jalapenos, liquid Cheddar cheese & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/df5b29c4-a8e7-4257-8d0f-0592a776c90e_c3c8ed80-aab8-46f4-8e55-e127b48904ee.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064643",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "53370292",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 399,
                                            "id": "53370293",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "53370294",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064643",
                                            "variationId": "53370292"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868158",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868157",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868157",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868157",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868157",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868159",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064643",
                                            "variationId": "53370293"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868164",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868163",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868162",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868162",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868162",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868162",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064643",
                                            "variationId": "53370294"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822705",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822706",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119318",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822707",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119320",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119320",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119320",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119320",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868168",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822708",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868166",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868161",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119319",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868157",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868162",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119320",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868159",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868164",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868168",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868158",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868163",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868166",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868161",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225438"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961959",
                                  "name": "Five Pepper",
                                  "category": "Pizza",
                                  "description": "A gourmet sauce with Green, Red and Yellow Capsicum, jalapeno, Red Paprika and Seasoned with Special Spicy Herb’s & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/7a6c4ba0-6c2b-4480-b875-57bba8620530_34311300-ed4f-4908-902f-cb43b4fae482.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064627",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "53370256",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 399,
                                            "id": "53370257",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "53370258",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064627",
                                            "variationId": "53370256"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868094",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868093",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868093",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868093",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868093",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868095",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064627",
                                            "variationId": "53370257"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868100",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868099",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868098",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868098",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868098",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868098",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064627",
                                            "variationId": "53370258"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822679",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822680",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119327",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822681",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119329",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119329",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119329",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119329",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868103",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822682",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868102",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868097",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119328",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868093",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868098",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119329",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868095",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868100",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868103",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868094",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868099",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868102",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868097",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225423"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961960",
                                  "name": "La Italiano",
                                  "category": "Pizza",
                                  "description": "A gourmet sauce with Onion, capsicum, mushroom, black olives, jalapenos, liquid Cheddar cheese & 100 % Mozzarella cheese.",
                                  "imageId": "d6a4cc86a4e2e15ec0f7a3e33cff103c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064628",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "53370259",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 399,
                                            "id": "53370260",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "53370261",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064628",
                                            "variationId": "53370259"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868110",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868109",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868109",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868109",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868109",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868111",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064628",
                                            "variationId": "53370260"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868116",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868115",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868114",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868114",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868114",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868114",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064628",
                                            "variationId": "53370261"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822744",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822745",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119315",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822746",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "91119317",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "91119317",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "91119317",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "91119317",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868119",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822747",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868118",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868113",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119316",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868109",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868114",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "91119317",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868111",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868116",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868119",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868110",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868115",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868118",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868113",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225427"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23545559"
                        },
                        {
                          "title": "Italiano Special Pizza's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961886",
                                  "name": "Classic Double Cheese Margherita",
                                  "category": "Pizza",
                                  "description": "A Fresh Dough topped with Marinara sauce, Liquid Cheese and 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/3d63e1b0-0b7a-4de2-a5dd-4408a9736dc8_a9009381-d634-4bcb-8575-e25b47abe68e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064612",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 215,
                                            "default": 1,
                                            "id": "53370212",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 310,
                                            "id": "53370213",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 475,
                                            "id": "53370214",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064612",
                                            "variationId": "53370212"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867807",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867806",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867806",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867806",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867806",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867808",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064612",
                                            "variationId": "53370213"
                                          }
                                        ],
                                        "price": 31000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867813",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867812",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867811",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867811",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867811",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867811",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064612",
                                            "variationId": "53370214"
                                          }
                                        ],
                                        "price": 47500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822730",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822731",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119236",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822732",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867814",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867814",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867814",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867814",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867816",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822733",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867815",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867810",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119237",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867806",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867811",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867814",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867808",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867813",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867816",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867807",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867812",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867815",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867810",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "41 ratings",
                                      "ratingCountV2": "41"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682567"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118200",
                                  "name": "Special Four Cheese Pizza",
                                  "category": "Pizza",
                                  "description": "Traditional pizza dough topped with Marinara sauce and Four types of cheese Mozzarella, Monterey Jack, Colby Cheese, cheddar cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/b0dc9c46-a454-4796-b41e-cfc9937f4b8c_5178e51a-67c3-4ee4-81d8-fbb4015a92e1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519795",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "129688010",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 370,
                                            "id": "129688011",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "129688012",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519795",
                                            "variationId": "129688010"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144822385",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144822379",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144822379",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144822379",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144822379",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822382",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519795",
                                            "variationId": "129688011"
                                          }
                                        ],
                                        "price": 37000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822383",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144822386",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144822380",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144822380",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144822380",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144822380",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519795",
                                            "variationId": "129688012"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822389",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822390",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822392",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822391",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822381",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144822381",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144822381",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144822381",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144822384",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822393",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144822387",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822388",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822394",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822379",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822380",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822381",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822382",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822383",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822384",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822385",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822386",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822387",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822388",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682603"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118190",
                                  "name": "Funghi De Bosco",
                                  "category": "Pizza",
                                  "description": "Mushroom, Garlic Butter, Basil, Jalapeno with White Cheddar Cheese &  100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/4cab1b9e-e66b-422f-8f70-e4ffe335588a_e623b653-ae3e-4cf4-9d20-f3bf9345564a.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519789",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "129687993",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 370,
                                            "id": "129687994",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "129687995",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519789",
                                            "variationId": "129687993"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144822336",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144822330",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144822330",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144822330",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144822330",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822333",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519789",
                                            "variationId": "129687994"
                                          }
                                        ],
                                        "price": 37000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822334",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144822337",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144822331",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144822331",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144822331",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144822331",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519789",
                                            "variationId": "129687995"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822340",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822341",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822343",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822342",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822332",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144822332",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144822332",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144822332",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144822335",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822344",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144822338",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822339",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822345",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822330",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822331",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822332",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822333",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822334",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822335",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822336",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822337",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822338",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822339",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682574"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137117903",
                                  "name": "Charcoal Grilled",
                                  "category": "Pizza",
                                  "description": "Seasoned with Special Charcoal Herb’s, Green & Yellow Capsicum, Rustic Tomato, Red Paprika & 100 % Mozzarella Cheese.",
                                  "imageId": "1c66d401218040369780d11087e13518",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519734",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "129687877",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 370,
                                            "id": "129687878",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "129687879",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519734",
                                            "variationId": "129687877"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144822036",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144822030",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144822030",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144822030",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144822030",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822033",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519734",
                                            "variationId": "129687878"
                                          }
                                        ],
                                        "price": 37000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822034",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144822037",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144822031",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144822031",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144822031",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144822031",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519734",
                                            "variationId": "129687879"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822040",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822041",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822043",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822042",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822032",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144822032",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144822032",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144822032",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144822035",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822044",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144822038",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822039",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822045",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822030",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822031",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822032",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822033",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822034",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822035",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822036",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822037",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822038",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822039",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682560"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118199",
                                  "name": "Smoky Charcoal Grilled",
                                  "category": "Pizza",
                                  "description": "Creamy sauce, mozzarella cheese, smoked charcoal paneer & onion, with three types of capsicum  and BBQ sauce & 100 % Mozzarella Cheese.",
                                  "imageId": "1c66d401218040369780d11087e13518",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519794",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "129688007",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 370,
                                            "id": "129688008",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "129688009",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519794",
                                            "variationId": "129688007"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144822368",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144822362",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144822362",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144822362",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144822362",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822365",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519794",
                                            "variationId": "129688008"
                                          }
                                        ],
                                        "price": 37000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822366",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144822369",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144822363",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144822363",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144822363",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144822363",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519794",
                                            "variationId": "129688009"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822372",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822373",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822375",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822374",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822364",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144822364",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144822364",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144822364",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144822367",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822376",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144822370",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822371",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822377",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822362",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822363",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822364",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822365",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822366",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822367",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822368",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822369",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822370",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822371",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682602"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118195",
                                  "name": "Giardinera",
                                  "category": "Pizza",
                                  "description": "Green, Yellow & Red Capsicum, Sundried Tomatoes, Olives, Mushroom & 100 % Mozzarella Cheese.",
                                  "imageId": "d6a4cc86a4e2e15ec0f7a3e33cff103c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519791",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 265,
                                            "default": 1,
                                            "id": "129687998",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 370,
                                            "id": "129687999",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 550,
                                            "id": "129688000",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519791",
                                            "variationId": "129687998"
                                          }
                                        ],
                                        "price": 26500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144822352",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144822346",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144822346",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144822346",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144822346",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822349",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519791",
                                            "variationId": "129687999"
                                          }
                                        ],
                                        "price": 37000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822350",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144822353",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144822347",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144822347",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144822347",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144822347",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519791",
                                            "variationId": "129688000"
                                          }
                                        ],
                                        "price": 55000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822356",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822357",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144822359",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822358",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822348",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144822348",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144822348",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144822348",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144822351",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822360",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144822354",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144822355",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144822361",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822346",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822347",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822348",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144822349",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822350",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822351",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822352",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822353",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822354",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144822355",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682579"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870892"
                        },
                        {
                          "title": "Fusion Affair Pizza's ",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137117035",
                                  "name": "Charcoal Paneer Grilled",
                                  "category": "Pizza",
                                  "description": "Spicy Charcoal marinated paneer, capsicum, onion, golden corn and special Harissa seasoning  & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/d15997bb-41f1-4922-9b0d-d2694a6b180e_44531af8-b6de-4a8c-8012-6f59bdc317f7.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519613",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687540",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687541",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687542",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519613",
                                            "variationId": "129687540"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821648",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821642",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821642",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821642",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821642",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821645",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519613",
                                            "variationId": "129687541"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821646",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821649",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821643",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821643",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821643",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821643",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519613",
                                            "variationId": "129687542"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821652",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821653",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821655",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821654",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821644",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821644",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821644",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821644",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821647",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821656",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821650",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821651",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821657",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821642",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821643",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821644",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821645",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821646",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821647",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821648",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821649",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821650",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821651",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682561"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961956",
                                  "name": "Garden Delight",
                                  "category": "Pizza",
                                  "description": "Assorted Bell Pepper, Sweet Corn, Onion, Oregano, Basil & Olive Oil & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/040c3106-0a36-46a7-b906-8a753f57ec58_5176b4d2-93b3-4a6e-a880-940456bd1c3f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064625",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370250",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370251",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370252",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064625",
                                            "variationId": "53370250"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52868062",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52868061",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52868061",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52868061",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52868061",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52868063",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064625",
                                            "variationId": "53370251"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868068",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52868067",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52868066",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52868066",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52868066",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52868066",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064625",
                                            "variationId": "53370252"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822667",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822668",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119310",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822669",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52868069",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52868069",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52868069",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52868069",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52868071",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822670",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52868070",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52868065",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119311",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52868061",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868066",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868069",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52868063",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868068",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868071",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868062",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868067",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868070",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52868065",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682575"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137117814",
                                  "name": "Hell Spicy",
                                  "category": "Pizza",
                                  "description": "Special Mexican chili sauce, Onion, Green Chilly, Jalapeno, Garlic, Tomato & Red Paprika & 100 % Mozzarella Cheese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/3dc7646d-2a92-4a14-8f55-feec4c6fb5b8_a41c45a6-8faf-46fa-a16f-a0d64e0a3272.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519711",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687790",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687791",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687792",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519711",
                                            "variationId": "129687790"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821751",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821745",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821745",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821745",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821745",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821748",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519711",
                                            "variationId": "129687791"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821749",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821752",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821746",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821746",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821746",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821746",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519711",
                                            "variationId": "129687792"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821755",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821756",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821758",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821757",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821747",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821747",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821747",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821747",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821750",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821759",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821753",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821754",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821760",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821745",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821746",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821747",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821748",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821749",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821750",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821751",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821752",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821753",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821754",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682581"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961896",
                                  "name": "Hawaiian Special",
                                  "category": "Pizza",
                                  "description": "Sweet & Tangy combination of Pineapple, Jalapeño, Mushroom & Paneer marinated in house marinara sauce with 100 % Mozzarella cheese.",
                                  "imageId": "qe6uw6n86yk9hv1faa96",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064619",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370232",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370233",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370234",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064619",
                                            "variationId": "53370232"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867916",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867915",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867915",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867915",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867915",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867917",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064619",
                                            "variationId": "53370233"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867934",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867931",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867929",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867929",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867929",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867929",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064619",
                                            "variationId": "53370234"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822713",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822714",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119292",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822715",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867936",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867936",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867936",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867936",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867939",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822716",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867938",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867927",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119293",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867915",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867929",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867936",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867917",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867934",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867939",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867916",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867931",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867938",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867927",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225425"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137117830",
                                  "name": "Milano Special",
                                  "category": "Pizza",
                                  "description": "Seasoned with Special Spices Herb’s & Basil Garlic, Red paprika, Paneer, Onion & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/b8ed143d-5879-4d05-9886-7983dc245c46_d7d4e878-5c67-46a4-b65c-ddc147fafc42.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519715",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687802",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687803",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687804",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519715",
                                            "variationId": "129687802"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821802",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821793",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821793",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821793",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821793",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821799",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519715",
                                            "variationId": "129687803"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821800",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821803",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821795",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821795",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821795",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821795",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519715",
                                            "variationId": "129687804"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821806",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821807",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821809",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821808",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821797",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821797",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821797",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821797",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821801",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821810",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821804",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821805",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821811",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821793",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821795",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821797",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821799",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821800",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821801",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821802",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821803",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821804",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821805",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682587"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116970",
                                  "name": "American Heat",
                                  "category": "Pizza",
                                  "description": "Seasoned with Special Spicy Herb’s, Capsicum, Onion, Baby Corn, Jalapeno & 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/eef800ab-0d6a-45a5-82e1-27b915cc004a_86bb1ce1-53ea-408e-a240-5b1bcfa618a4.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519576",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687356",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687357",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687358",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519576",
                                            "variationId": "129687356"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821629",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821623",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821623",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821623",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821623",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821626",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519576",
                                            "variationId": "129687357"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821627",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821630",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821624",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821624",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821624",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821624",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519576",
                                            "variationId": "129687358"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821633",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821634",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821636",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821635",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821625",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821625",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821625",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821625",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821628",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821637",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821631",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821632",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821638",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821623",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821624",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821625",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821626",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821627",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821628",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821629",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821630",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821631",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821632",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682555"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137117868",
                                  "name": "Oriental Delight",
                                  "category": "Pizza",
                                  "description": "A classic oriental sauce, topped with marinated paneer with three type of capsicum, onion with garlic sauce & 100 % Mozzarella cheese.",
                                  "imageId": "1c66d401218040369780d11087e13518",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519723",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "129687819",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "129687820",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "129687821",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519723",
                                            "variationId": "129687819"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821946",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821939",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821939",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821939",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821939",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821942",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519723",
                                            "variationId": "129687820"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821944",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821948",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821940",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821940",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821940",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821940",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519723",
                                            "variationId": "129687821"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821951",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821953",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821955",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821954",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821941",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821941",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821941",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821941",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821945",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821957",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821949",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821950",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821959",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821939",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821940",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821941",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821942",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821944",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821945",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821946",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821948",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821949",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821950",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "78682590"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961895",
                                  "name": "Corn O Mania",
                                  "category": "Pizza",
                                  "description": "A Delicious Combination of mozzarella Cheese, Onion, Capsicum, Baby Corn and Golden Corn & 100 % Mozzarella cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/7aae0659-c16c-4af7-bbb6-425420886634_7fcfb2ae-3363-464f-9256-02a20fdc54c0.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064618",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 240,
                                            "default": 1,
                                            "id": "53370229",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 345,
                                            "id": "53370230",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 515,
                                            "id": "53370231",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064618",
                                            "variationId": "53370229"
                                          }
                                        ],
                                        "price": 24000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867900",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867899",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867899",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867899",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867899",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867901",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064618",
                                            "variationId": "53370230"
                                          }
                                        ],
                                        "price": 34500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867906",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867905",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867904",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867904",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867904",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867904",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064618",
                                            "variationId": "53370231"
                                          }
                                        ],
                                        "price": 51500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822721",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822722",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119298",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822723",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867907",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867907",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867907",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867907",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867909",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822724",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867908",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867903",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119299",
                                            "addonId": "115822125"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867899",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867904",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867907",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867901",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867906",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867909",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867900",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867905",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867908",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867903",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24000,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "48225420"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870891"
                        },
                        {
                          "title": "Regular Pizza's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961881",
                                  "name": "Simply Capsicum",
                                  "category": "Pizza",
                                  "description": "Crisp Capsicum with 100 % Mozzarella Cheese",
                                  "imageId": "h8gzfts48apa0ecoqpc8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 9400,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064609",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 145,
                                            "default": 1,
                                            "id": "53370203",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 285,
                                            "id": "53370204",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 375,
                                            "id": "53370205",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064609",
                                            "variationId": "53370203"
                                          }
                                        ],
                                        "price": 14500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867759",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867758",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867758",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867758",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867758",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867760",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "94"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064609",
                                            "variationId": "53370204"
                                          }
                                        ],
                                        "price": 28500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867765",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867764",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867763",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867763",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867763",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867763",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "234"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064609",
                                            "variationId": "53370205"
                                          }
                                        ],
                                        "price": 37500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822659",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822660",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119223",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822661",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867766",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867766",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867766",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867766",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867768",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822662",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867767",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867762",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119224",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "324"
                                        }
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867758",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867763",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867766",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867760",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867765",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867768",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867759",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867764",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867767",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867762",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "48225432"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961884",
                                  "name": "Simply Corn",
                                  "category": "Pizza",
                                  "description": "Sweet & Juicy Golden Corn with 100 % Mozzarella Cheese.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/0d1f21bc-55a7-4d04-9dc0-2f2ad56ac127_7ad752d9-4608-456c-a4a4-272e9927ad0b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 9400,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064610",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 145,
                                            "default": 1,
                                            "id": "53370206",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 285,
                                            "id": "53370207",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 375,
                                            "id": "53370208",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064610",
                                            "variationId": "53370206"
                                          }
                                        ],
                                        "price": 14500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867775",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867774",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867774",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867774",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867774",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867776",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "94"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064610",
                                            "variationId": "53370207"
                                          }
                                        ],
                                        "price": 28500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867781",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867780",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867779",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867779",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867779",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867779",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "234"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064610",
                                            "variationId": "53370208"
                                          }
                                        ],
                                        "price": 37500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822700",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822701",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119234",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822702",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867782",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867782",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867782",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867782",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867784",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822703",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867783",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867778",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119235",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "324"
                                        }
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867774",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867779",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867782",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867776",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867781",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867784",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867775",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867780",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867783",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867778",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "96 ratings",
                                      "ratingCountV2": "96"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "48225433"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961885",
                                  "name": "Simply Tomato",
                                  "category": "Pizza",
                                  "description": "Tomato with 100 % Mozzarella Cheese",
                                  "imageId": "euzclq1xs5cjgiwjnmag",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 9400,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "16064611",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 145,
                                            "default": 1,
                                            "id": "53370209",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 285,
                                            "id": "53370210",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 375,
                                            "id": "53370211",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064611",
                                            "variationId": "53370209"
                                          }
                                        ],
                                        "price": 14500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "52867791",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "52867790",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "52867790",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "52867790",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "52867790",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "52867792",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "94"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064611",
                                            "variationId": "53370210"
                                          }
                                        ],
                                        "price": 28500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867797",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "52867796",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "52867795",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "52867795",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "52867795",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "52867795",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "234"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "16064611",
                                            "variationId": "53370211"
                                          }
                                        ],
                                        "price": 37500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144822687",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144822688",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "91119221",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144822689",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "52867798",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "52867798",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "52867798",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "52867798",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "52867800",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144822690",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "52867799",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "52867794",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "91119222",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "324"
                                        }
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52867790",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867795",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867798",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "52867792",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867797",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867800",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867791",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867796",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867799",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "52867794",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "48225434"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137116927",
                                  "name": "Simply Onion",
                                  "category": "Pizza",
                                  "description": "Crunchy onion with 100 % Mozzarella Cheese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/3d958226-30d5-4545-be1a-2479bb149213_98625bea-51bb-48d5-b01a-22262f4f144e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 9400,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40519544",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Small [ 7 Inch]",
                                            "price": 145,
                                            "default": 1,
                                            "id": "129687228",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Medium  [10 Inch]",
                                            "price": 285,
                                            "id": "129687229",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large  [14 Inch]",
                                            "price": 375,
                                            "id": "129687230",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519544",
                                            "variationId": "129687228"
                                          }
                                        ],
                                        "price": 14500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013897"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013898"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013899"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013900"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013901"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013902"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013903"
                                          },
                                          {
                                            "groupId": "144821527",
                                            "addonId": "85013904"
                                          },
                                          {
                                            "groupId": "144821521",
                                            "addonId": "63390106"
                                          },
                                          {
                                            "groupId": "144821521",
                                            "addonId": "63390107"
                                          },
                                          {
                                            "groupId": "144821521",
                                            "addonId": "63390108"
                                          },
                                          {
                                            "groupId": "144821521",
                                            "addonId": "63390109"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821524",
                                            "addonId": "43435693"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "94"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519544",
                                            "variationId": "129687229"
                                          }
                                        ],
                                        "price": 28500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821525",
                                            "addonId": "43435699"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013912"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013913"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013914"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013915"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013916"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013917"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013918"
                                          },
                                          {
                                            "groupId": "144821528",
                                            "addonId": "85013919"
                                          },
                                          {
                                            "groupId": "144821522",
                                            "addonId": "63390117"
                                          },
                                          {
                                            "groupId": "144821522",
                                            "addonId": "63390118"
                                          },
                                          {
                                            "groupId": "144821522",
                                            "addonId": "63390119"
                                          },
                                          {
                                            "groupId": "144821522",
                                            "addonId": "63390120"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "234"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40519544",
                                            "variationId": "129687230"
                                          }
                                        ],
                                        "price": 37500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822132"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822138"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822122"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822115"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822131"
                                          },
                                          {
                                            "groupId": "144821531",
                                            "addonId": "115822159"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822135"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822141"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822124"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822156"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822163"
                                          },
                                          {
                                            "groupId": "144821532",
                                            "addonId": "115822162"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822142"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822145"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822149"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822153"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822136"
                                          },
                                          {
                                            "groupId": "144821534",
                                            "addonId": "115822134"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822133"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822139"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822123"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822116"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822128"
                                          },
                                          {
                                            "groupId": "144821533",
                                            "addonId": "115822160"
                                          },
                                          {
                                            "groupId": "144821523",
                                            "addonId": "63390127"
                                          },
                                          {
                                            "groupId": "144821523",
                                            "addonId": "63390128"
                                          },
                                          {
                                            "groupId": "144821523",
                                            "addonId": "63390129"
                                          },
                                          {
                                            "groupId": "144821523",
                                            "addonId": "63390130"
                                          },
                                          {
                                            "groupId": "144821526",
                                            "addonId": "43435707"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822158"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822164"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822146"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822143"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822140"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822137"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822117"
                                          },
                                          {
                                            "groupId": "144821535",
                                            "addonId": "115822129"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013920"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013921"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013922"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013923"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013924"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013925"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013926"
                                          },
                                          {
                                            "groupId": "144821529",
                                            "addonId": "85013927"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013905"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013910"
                                          },
                                          {
                                            "groupId": "144821530",
                                            "addonId": "85013911"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "61089627"
                                          },
                                          {
                                            "groupId": "144821536",
                                            "addonId": "115822125"
                                          }
                                        ],
                                        "finalPrice": {
                                          "units": "324"
                                        }
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "144821521",
                                      "groupName": "Choice Of Crust (Small)",
                                      "choices": [
                                        {
                                          "id": "63390108",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390109",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390106",
                                          "name": "Double Burst",
                                          "price": 10500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390107",
                                          "name": "Cheese Burst",
                                          "price": 8000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821522",
                                      "groupName": "Choice Of Crust (Medium)",
                                      "choices": [
                                        {
                                          "id": "63390119",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390120",
                                          "name": "Hand Tossed Chicago Thin Crust [crispy Thin Crust Base]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390117",
                                          "name": "Double Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390118",
                                          "name": "Cheese Burst",
                                          "price": 11000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821523",
                                      "groupName": "Choice Of Crust (Large)",
                                      "choices": [
                                        {
                                          "id": "63390129",
                                          "name": "Hand Tossed Regular Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390130",
                                          "name": "Hand Tossed Chicago Thin Crust",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390127",
                                          "name": "Double Burst",
                                          "price": 16000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63390128",
                                          "name": "Cheese Burst",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "144821524",
                                      "groupName": "Extra Cheese [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435693",
                                          "name": "Cheese",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821525",
                                      "groupName": "Extra Cheese [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435699",
                                          "name": "Cheese",
                                          "price": 10000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821526",
                                      "groupName": "Extra Cheese [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "43435707",
                                          "name": "Cheese",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821527",
                                      "groupName": "Extra Toppings [7 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013897",
                                          "name": "Onion",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013898",
                                          "name": "Capsicum",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013899",
                                          "name": "Tomato",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013901",
                                          "name": "Paneer",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013903",
                                          "name": "Red Pepprika",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013900",
                                          "name": "Corn",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013902",
                                          "name": "Jalepeno",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013904",
                                          "name": "Black Olives",
                                          "price": 2500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821528",
                                      "groupName": "Extra Toppings [10 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013912",
                                          "name": "Onion",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013913",
                                          "name": "Capsicum",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013914",
                                          "name": "Tomato",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013916",
                                          "name": "Paneer",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013918",
                                          "name": "Red Pepprika",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013915",
                                          "name": "Corn",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013917",
                                          "name": "Jalepeno",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013919",
                                          "name": "Black Olives",
                                          "price": 3500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821529",
                                      "groupName": "Extra Toppings [14 Inch]",
                                      "choices": [
                                        {
                                          "id": "85013920",
                                          "name": "Onion",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013921",
                                          "name": "Capsicum",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013922",
                                          "name": "Tomato",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013924",
                                          "name": "Paneer",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013926",
                                          "name": "Red Pepprika",
                                          "price": 5500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013923",
                                          "name": "Corn",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013925",
                                          "name": "Jalepeno",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013927",
                                          "name": "Black Olives",
                                          "price": 5500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "144821530",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14500,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "78682600"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23545556"
                        }
                      ],
                      "image": "h8gzfts48apa0ecoqpc8",
                      "categoryId": "23545555"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Single Toppings",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961840",
                              "name": "Corn Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/97b547cd-33d0-4a0b-ac00-8d718c118f51_bfb9ffd1-0cfb-4f7f-bd04-3b683b5df21c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119343",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119344",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119345",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1875 ratings",
                                  "ratingCountV2": "1.9K+"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833756"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961839",
                              "name": "Capsicum Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/55691b33-860e-4c92-a24f-79d434b38a47_eb3bfda4-7227-4ae1-a62f-332168fd0156.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119229",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119230",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119231",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "664 ratings",
                                  "ratingCountV2": "664"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833755"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961841",
                              "name": "Double Topping Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/b139801c-c713-41a0-a002-2d73cc7bd150_744d9f5d-b5a8-4df2-95dd-bc0c8bf48ab8.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119348",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119349",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119350",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144823199",
                                  "groupName": "Double Topping",
                                  "choices": [
                                    {
                                      "id": "115822421",
                                      "name": "Mushroom & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822419",
                                      "name": "Paneer & Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822426",
                                      "name": "Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822420",
                                      "name": "Corn & Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "664 ratings",
                                  "ratingCountV2": "664"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48401415"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961842",
                              "name": "Onion Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/90c77cf1-bb8b-4eb9-8178-f04b38495be3_f2cfcec3-c45b-4cb9-9f53-bdcf204c6252.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119364",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119365",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119366",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "562 ratings",
                                  "ratingCountV2": "562"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833759"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961843",
                              "name": "Pack Of 4 Pan Pizzas {single Topping}",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/75de8a8b-4b94-4263-97b4-3691da0893fa_1021209a-b0a2-4e74-89eb-f9d370602e6a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "52867716",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867714",
                                  "groupName": "Choice Of Toppings [single]",
                                  "choices": [
                                    {
                                      "id": "115822120",
                                      "name": "Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822118",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822161",
                                      "name": "All Of The Above",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822126",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822130",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "87 ratings",
                                  "ratingCountV2": "87"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31357005"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961844",
                              "name": "Single Topping Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/97b547cd-33d0-4a0b-ac00-8d718c118f51_bfb9ffd1-0cfb-4f7f-bd04-3b683b5df21c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119353",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119354",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867719",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144823196",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "115822425",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822422",
                                      "name": "Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822427",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822424",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "155 ratings",
                                  "ratingCountV2": "155"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48401435"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961845",
                              "name": "Tomato Pizza",
                              "category": "Single Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/e91d76c5-7f6f-4847-a491-454f356b7cde_32db4c3d-03b0-49f2-852d-d124fa8a2450.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "finalPrice": 7100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119369",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119370",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119371",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833762"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/97b547cd-33d0-4a0b-ac00-8d718c118f51_bfb9ffd1-0cfb-4f7f-bd04-3b683b5df21c.jpg",
                      "categoryId": "23545548"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Sides & Quick Bites ",
                      "categories": [
                        {
                          "title": "Stuffed Garlic Bread's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93009593",
                                  "name": "Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "zadhzrtfvwbdlolza5aw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12000,
                                  "finalPrice": 7800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119278",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "687 ratings",
                                      "ratingCountV2": "687"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "08ad31c5-4155-457f-a1cb-7dd4dc8ef0e8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "31357028"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118275",
                                  "name": "Tandoori Paneer Tikka Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "cd8c1c57120a3a4c5561e05b2da4900e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822466",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "137 ratings",
                                      "ratingCountV2": "137"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872144"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118245",
                                  "name": "Chilly Paneer Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "cd8c1c57120a3a4c5561e05b2da4900e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822444",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872136"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118259",
                                  "name": "Chipotle Mix Paneer Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/af5fe3ce-d33c-40c4-bae5-8890854f7baa_c340b9ac-8b4b-427d-b827-39c273d57bfc.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822451",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872137"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118222",
                                  "name": "Achari Paneer Tikka Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "cd8c1c57120a3a4c5561e05b2da4900e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822437",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872134"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118269",
                                  "name": "Smoky Charcoal Stuffed Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/fbecb173-2f1d-4a05-97cf-b3165f588aff_81b12209-d5b1-40e7-a3f3-b327649c4fac.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822459",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872143"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870897"
                        },
                        {
                          "title": "French Fries",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118330",
                                  "name": "Signature Peri Peri French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/db991855-3ac9-4310-860c-0efd120a6f97_73b84fc4-7ac6-46ad-8d69-48e74a5335b7.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822495",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872141"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118280",
                                  "name": "Cheezy & Creamy French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/a21a16b9-8795-40e6-b5b4-26e6c4ba7c3d_960bfb29-f6ac-4402-8c80-fce34640c18c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822473",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872135"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118333",
                                  "name": "Tandoori Tikka French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/4ff69394-d4eb-4432-8703-e0d5bb3a14b4_caa6c993-c0c6-448b-b12d-7ebdb0b10a3a.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822509",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872145"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98057639",
                                  "name": "French Fries (regular Salted)",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/7ab9b97e-67d1-4177-8366-4e8a5df1b086_8ddd5122-6647-409c-8f8f-7ef741606c28.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9000,
                                  "finalPrice": 5900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119263",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "137 ratings",
                                      "ratingCountV2": "137"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "a4c2b492-d639-452d-832b-ab8ca893ba9f"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872139"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118298",
                                  "name": "Creamy Garlic & Herb's French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/fafff844-587d-4586-9d4d-b0260e302980_6b1016d7-f19a-43ee-b212-bded476c937c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822480",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872138"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118328",
                                  "name": "Garden Mint French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/fdbfe1aa-937a-408c-951b-3dcea44d18ea_4478c5d9-b191-430d-b9f4-eb8c1c39a68b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822487",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872140"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118331",
                                  "name": "Smoky Charcoal French Fries",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/4d998418-c5c4-4a56-85e9-2b137a1e5782_c7af7d02-37c8-413e-b44f-fd0ac4fa3eeb.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10000,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822502",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "205843a9-e258-4a76-a44b-72c142bc97cd"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "79872142"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870898"
                        },
                        {
                          "title": "Sides & Quick Bites",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93961850",
                                  "name": "Garlic Bread Stick",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "ec9b5b79fa8ad2f116a69542845bfc96",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9000,
                                  "finalPrice": 5900,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119266",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "105 ratings",
                                      "ratingCountV2": "105"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "a4c2b492-d639-452d-832b-ab8ca893ba9f"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "31356960"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93009590",
                                  "name": "Cheese Bites",
                                  "category": "Sides & Quick Bites ",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12500,
                                  "finalPrice": 8100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119286",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "57 ratings",
                                      "ratingCountV2": "57"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "20077e7e-233f-4e72-829f-7936c089aaf6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "31356934"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870895"
                        },
                        {
                          "title": "Cheese Garlic Bread's",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118215",
                                  "name": "Four Cheese Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/1/70d8faa9-1a2a-4386-9fa3-114404c7b5ca_80a06d42-e347-47aa-b098-42762dcd9f6f.jpg",
                                  "isVeg": 1,
                                  "price": 12500,
                                  "finalPrice": 8100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822407",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "20077e7e-233f-4e72-829f-7936c089aaf6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "78711612"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118212",
                                  "name": "Corn & Cheese Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/24a4cfef-73fd-4ebb-86e0-d5177861dfa5_ab3732d4-f815-4072-9dd3-d3fb23c8d5d8.jpg",
                                  "isVeg": 1,
                                  "price": 12000,
                                  "finalPrice": 7800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822400",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "08ad31c5-4155-457f-a1cb-7dd4dc8ef0e8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "78682569"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118220",
                                  "name": "Punjabi Tadka Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/4fb6cccf-79cd-46af-a99f-3c2bc01fc654_b89ce358-b52f-4498-a31f-ba160732a31a.jpg",
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822423",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "78682594"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137118221",
                                  "name": "Tandoori Paneer Tikka Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/4fb6cccf-79cd-46af-a99f-3c2bc01fc654_b89ce358-b52f-4498-a31f-ba160732a31a.jpg",
                                  "isVeg": 1,
                                  "price": 14000,
                                  "finalPrice": 9100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "144822430",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "b17dccf1-4cbb-4081-98f9-76e8a6bfeaf8"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "80364632"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93009591",
                                  "name": "Garlic Bread Exotica",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/f96d1bda-028b-4b3c-8282-c3cd7adbdf95_2f726ec0-fd07-4ce4-b996-5dff0d9dd71f.jpg",
                                  "isVeg": 1,
                                  "price": 12500,
                                  "finalPrice": 8100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119270",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "20077e7e-233f-4e72-829f-7936c089aaf6"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "31356959"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93009594",
                                  "name": "Cheese Garlic Bread",
                                  "category": "Sides & Quick Bites ",
                                  "imageId": "6df69b48cfcdaabf258b8d8971f8a9ec",
                                  "isVeg": 1,
                                  "price": 10900,
                                  "finalPrice": 7100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "91119276",
                                      "groupName": "Quick Bites",
                                      "choices": [
                                        {
                                          "id": "85013905",
                                          "name": "Garlic Bread Stick",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013911",
                                          "name": "Cheese Bites",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "85013910",
                                          "name": "Cheese Bruschetta",
                                          "price": 11500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "107 ratings",
                                      "ratingCountV2": "107"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "cartContext": "quick_prep",
                                  "offerIds": [
                                    "63c9ade4-0893-43fa-845a-4266d9ec54b9"
                                  ],
                                  "isNinetyninestoreItem": true,
                                  "parentId": "31356937"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46870896"
                        }
                      ],
                      "image": "ec9b5b79fa8ad2f116a69542845bfc96",
                      "categoryId": "46870893"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Double Toppings",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112436083",
                              "name": "Paneer & Onion",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/acaddedc-8cf7-44f0-a9e9-7579f30cb865_bd34b266-2887-4152-9c72-3325b067863c.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119253",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119254",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119255",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "145 ratings",
                                  "ratingCountV2": "145"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48331577"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961846",
                              "name": "Pack Of 4 Pan Pizzas {double Topping}",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/7849653e-a767-4eca-a0ea-a548aabeb707_56406528-0b60-4abd-9468-7c3ba0789e5b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 47200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119260",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867722",
                                  "groupName": "Choice Of Toppings [double]",
                                  "choices": [
                                    {
                                      "id": "115822165",
                                      "name": "Tomato & Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822144",
                                      "name": "All Of The Above",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822155",
                                      "name": "Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822157",
                                      "name": "Paneer & Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822147",
                                      "name": "Mushroom & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31357002"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112436085",
                              "name": "Onion & Capsicum",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/306ad1de-79f5-4d07-9a6b-2a421fdd7bba_80460cc4-38fb-4f17-b03f-e0c26f2de87f.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119248",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119249",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119250",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48331576"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112436084",
                              "name": "Mushroom & Capsicum",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/4e5fac0b-fb95-4d26-aad8-52b308ded294_bdeb2bc7-8185-4446-9ed0-4e0486754a95.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119243",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119244",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119245",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48331574"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112436090",
                              "name": "Tomato & Corn",
                              "category": "Double Toppings",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/147d82a1-f272-4f2d-a79d-66be3e146274_73528204-fa3e-4f26-8ebb-8b499b6d0129.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "finalPrice": 8500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119238",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119239",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119240",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "8cd053df-4715-4e0d-98ad-49fa57c748de"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48331579"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/acaddedc-8cf7-44f0-a9e9-7579f30cb865_bd34b266-2887-4152-9c72-3325b067863c.jpg",
                      "categoryId": "23545549"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pasta",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137116909",
                              "name": "Alfredo Pasta",
                              "category": "Pasta",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/dc90ccd0-4e6e-4800-ad87-e6507ce61f87_0ac06c1c-746c-47be-b40e-f737cf20f22b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144821506",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "75 ratings",
                                  "ratingCountV2": "75"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "64891774"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137118574",
                              "name": "Hot & Spicy Pasta",
                              "category": "Pasta",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/e75a0ded-f491-4b94-b671-c893d87fb2ec_a9c8cf2c-cb64-47a8-b9d6-77d0739b540d.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144823186",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "78682582"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961847",
                              "name": "Arrabiata Pasta",
                              "category": "Pasta",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/21aefd0d-028e-43b5-b357-41762a50ca61_87227fad-f41e-493c-8d07-103fdac80ff8.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "finalPrice": 9400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "91119374",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "c4fa48a3-a3f8-4c5a-a4b3-a829ae028ae6"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51833754"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/3/27/dc90ccd0-4e6e-4800-ad87-e6507ce61f87_0ac06c1c-746c-47be-b40e-f737cf20f22b.jpg",
                      "categoryId": "23545550"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Jumbo Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961838",
                              "name": "Tandoori Paneer Pizza [7 Inches] + Stuffed Garlic Bread",
                              "category": "Jumbo Combos",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822803",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "144822804",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119357",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119358",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "76 ratings",
                                  "ratingCountV2": "76"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48401442"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961837",
                              "name": "Makhani Paneer Pizza + Garlic Bread Stick",
                              "category": "Jumbo Combos",
                              "imageId": "7979d1d6066f122efb0504adb0082d4c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822927",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "144822928",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119339",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119340",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48401424"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "7979d1d6066f122efb0504adb0082d4c",
                      "categoryId": "23545547"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Choose Your Dip",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961852",
                              "name": "Cheese Dip",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822902",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "91 ratings",
                                  "ratingCountV2": "91"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31356936"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961855",
                              "name": "Mexican Salsa Dip",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822887",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31356991"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137116904",
                              "name": "Garlic & Herb's (da Pizzeria's Special))",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144821491",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "78682578"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961854",
                              "name": "Hot Garlic Dip",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822832",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31356970"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961853",
                              "name": "Chocolate Dip",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822748",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31356945"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137116906",
                              "name": "Mustard Dip",
                              "category": "Choose Your Dip",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144821499",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "31356996"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "23545553"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137116917",
                              "name": "Choco Lava",
                              "category": "Desserts",
                              "imageId": "d37801487a805878c9fd8718e911c70d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9000,
                              "finalPrice": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144821515",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "a4c2b492-d639-452d-832b-ab8ca893ba9f"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "31356946"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "d37801487a805878c9fd8718e911c70d",
                      "categoryId": "23545554"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Family Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961851",
                              "name": "Tandoori Paneer Pizza(7 Inches) With Stuffed Garlic Bread",
                              "category": "Family Meals",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822760",
                                  "groupName": "Choice Of Crust (Small)",
                                  "choices": [
                                    {
                                      "id": "63390108",
                                      "name": "Hand Tossed Regular Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390109",
                                      "name": "Hand Tossed Chicago Thin Crust",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390106",
                                      "name": "Double Burst",
                                      "price": 10500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "63390107",
                                      "name": "Cheese Burst",
                                      "price": 8000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "144822761",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "52867736",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119361",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "48401443"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "23545552"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Yummy Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93961836",
                              "name": "Single Topping Pizza + Cheese Dip",
                              "category": "Yummy Meals",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13500,
                              "finalPrice": 8800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "144822818",
                                  "groupName": "Extra Cheese [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "43435693",
                                      "name": "Cheese",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119306",
                                  "groupName": "Extra Toppings [7 Inch]",
                                  "choices": [
                                    {
                                      "id": "85013897",
                                      "name": "Onion",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013898",
                                      "name": "Capsicum",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013899",
                                      "name": "Tomato",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013901",
                                      "name": "Paneer",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013903",
                                      "name": "Red Pepprika",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013900",
                                      "name": "Corn",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013902",
                                      "name": "Jalepeno",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013904",
                                      "name": "Black Olives",
                                      "price": 2500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 8,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "91119307",
                                  "groupName": "Quick Bites",
                                  "choices": [
                                    {
                                      "id": "85013905",
                                      "name": "Garlic Bread Stick",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013911",
                                      "name": "Cheese Bites",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "85013910",
                                      "name": "Cheese Bruschetta",
                                      "price": 11500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144823193",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "115822425",
                                      "name": "Corn",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822422",
                                      "name": "Tomato",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822427",
                                      "name": "Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115822424",
                                      "name": "Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "2e88bd75-e939-4d52-bb20-a49b63010663"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "48401436"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "23545546"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11422010000261"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Da Pizzeria",
                      "area": "Lalghati Square",
                      "completeAddress": "H.No 87,Nayapura,Lalghati,Bhopal 462030"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "voUvwLBIDxa5-GMHANYYZws-L5ZRHj15g_fD2reg"
},

  "376280":{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Kwality Walls Ice Cream and More",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "412415",
              "name": "Kwality Walls Ice Cream and More",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "kwality-walls-frozen-dessert-and-ice-cream-shop-bairagarh-bairagarh-8",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/13/15307d46-565e-4f2a-a45b-982edc85c15f_412415.JPG",
              "locality": "Meenakshi Complex",
              "areaName": "Idgah Hills",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Desserts",
                "Ice Cream"
              ],
              "avgRating": 4.6,
              "veg": true,
              "feeDetails": {
                "restaurantId": "412415",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "582",
              "avgRatingString": "4.6",
              "totalRatingsString": "788 ratings",
              "sla": {
                "restaurantId": "412415",
                "deliveryTime": 24,
                "minDeliveryTime": 20,
                "maxDeliveryTime": 25,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 3040,
                "slaString": "20-25 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:30:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "20% off",
                "shortDescriptionList": [
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "kwality-walls-frozen-dessert-and-ice-cream-shop-bairagarh-bairagarh-8",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Eat N Meet Cafe and Restro: SHOP NO 14, MEENAKSHI COMPLEX, IDGAH HILLS, BHOPAL, MADHYA PRADESH-462001"
                },
                {
                  "title": "Cuisines",
                  "message": "Desserts,Ice Cream"
                }
              ],
              "logo": "Brand logo/KwWaICr",
              "totalRatings": 788,
              "aggregatedDiscountInfoV2": {
                "header": "20% off",
                "shortDescriptionList": [
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Freedel",
                    "discountType": "FREE_DELIVERY",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/412415"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.2663030000,77.3867570000",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              }
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 2,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹50",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "412415",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "412415",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "20% OFF"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5192045",
                          "creativeId": "TopPicks2024/169833875E.png",
                          "title": "Magnum Pistachio Ice Cream 61 gms",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "169833875",
                              "name": "Magnum Pistachio Ice Cream 61 gms",
                              "category": "Magnum Ice Cream",
                              "description": "Rich cracking belgian chocolate studded with roasted pistachio pieces surrounding velvety smooth pistachio ice cream.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/37ef4c50-a389-456c-a4cf-ce3ca22da747_43bae533-9352-4ea7-a60d-f4b1fca77354.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7619,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "102231246"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5138063",
                          "creativeId": "TopPicks2024/169766665D.png",
                          "title": "Choco Brownie Fudge Cup (100ml x 2pcs)",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "169766665",
                              "name": "Choco Brownie Fudge Cup (100ml x 2pcs)",
                              "category": "Cups",
                              "description": "Rich Chocolate Full Of Chunky Brownie Pieces And Chocolate Fudge. Kcal/Serving: 144",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/18/d03a9e73-0036-4fb4-a2c9-0beaed73fc99_3829e887-8e23-430b-a113-1449e8526888.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "92802197"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "5140761",
                          "creativeId": "TopPicks2024/169833891D.png",
                          "title": "The Dairy Factory  Slow Churned Butterscotch IceCream TUB 700 ML",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "169833891",
                              "name": "The Dairy Factory  Slow Churned Butterscotch IceCream TUB 700 ML",
                              "category": "Family Tubs",
                              "description": "Indulge in the irresistible combination of creamy butterscotch ice cream and crunchy cashew crackle.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/2b1efa50-f27c-4f08-aeac-53294e3cb5fa_6a6e5b22-d110-4bef-993a-15afd38c35f4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "102320177"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Magnum Ice Cream",
                      "categories": [
                        {
                          "title": "New Magnum Ice Cream",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833875",
                                  "name": "Magnum Pistachio Ice Cream 61 gms",
                                  "category": "Magnum Ice Cream",
                                  "description": "Rich cracking belgian chocolate studded with roasted pistachio pieces surrounding velvety smooth pistachio ice cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/37ef4c50-a389-456c-a4cf-ce3ca22da747_43bae533-9352-4ea7-a60d-f4b1fca77354.png",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7619,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102231246"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283546"
                        },
                        {
                          "title": "Magnum Ice Cream",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833883",
                                  "name": "Magnum Almond Ice Cream 61 gms",
                                  "category": "Magnum Ice Cream",
                                  "description": "Made with Belgian Chocolate. Velvety smooth Madagascan vanilla ice cream is covered in thick cracking Belgian chocolate and crunchy roasted almond pieces.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/89865462-bb14-46b7-b49a-90ed60da6bd0_6941ea9c-275c-4aea-972a-f4e29c2f5353.png",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7619,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320170"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833884",
                                  "name": "Magnum Brownie Ice Cream 61 gms",
                                  "category": "Magnum Ice Cream",
                                  "description": "Made with Belgian chocolate. Brownie-flavoured ice cream is covered in thick, cracking Belgian chocolate and crunchy cashew pieces.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/989e2b08-fd0c-4797-9a67-70459dca4873_99261263-5257-4e7f-b301-e8aea7ef5103.png",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320172"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833887",
                                  "name": "Magnum Chocolate Truffle Ice Cream 61 gms",
                                  "category": "Magnum Ice Cream",
                                  "description": "Smooth chocolate truffle sauce, swirled through creamy chocolate ice cream, and wrapped in thick cracking belgian chocolate",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/3003c23c-b117-45c8-b8aa-fb2a33cede4f_45f2ec7d-41ca-41c9-9e2e-0a01113c1b00.png",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320173"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283547"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/37ef4c50-a389-456c-a4cf-ce3ca22da747_43bae533-9352-4ea7-a60d-f4b1fca77354.png",
                      "categoryId": "61248042"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Family Tubs",
                      "categories": [
                        {
                          "title": "Family Ice Cream Tubs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833891",
                                  "name": "The Dairy Factory  Slow Churned Butterscotch IceCream TUB 700 ML",
                                  "category": "Family Tubs",
                                  "description": "Indulge in the irresistible combination of creamy butterscotch ice cream and crunchy cashew crackle.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/2b1efa50-f27c-4f08-aeac-53294e3cb5fa_6a6e5b22-d110-4bef-993a-15afd38c35f4.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15238,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320177"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833889",
                                  "name": "The Dairy Factory Slow Churned Chocolate Ice Cream TUB 700 ML",
                                  "category": "Family Tubs",
                                  "description": "Experience the ultimate chocolate indulgence with Kwality Walls Slow Churned Chocolate Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/06359dfd-869c-4eaf-aeaf-9cf80caa5c18_6c62d468-31d7-4c8a-8303-c7eba6dd5ff7.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18952,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320178"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833893",
                                  "name": "The Dairy Factory  Slow Churned Vanilla Ice Cream TUB 700 ML",
                                  "category": "Family Tubs",
                                  "description": "Savor the authentic taste of vanilla in every spoonful of Kwality Walls Slow Churned Vanilla Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/2dee6ef4-9f28-4d54-bb49-b26b66ddf662_1cfbe31f-8fef-4819-bea3-95f083d8d449.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13810,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320180"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833894",
                                  "name": "The Dairy Factory  Slow Churned Mango Ice Cream TUB 700 ML",
                                  "category": "Family Tubs",
                                  "description": "Savor the authentic taste of summer with Kwality Walls Slow Churned Mango Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/9bc519b4-6bbc-410a-9d2b-87d7273a591f_0e8e631a-14f6-4a07-a818-20601abdf791.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15238,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320179"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766654",
                                  "name": "Hazelnut Chocolate Ice Cream 500ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "Ice Cream with Hazelnuts Decadent Chocolate Ice Cream full of crunchy and roasted hazelnuts and chocolate. Kcal/Serving: 165",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/6/002f4ec0-98aa-4de0-aca7-ac101a94af1a_1dc7cfc2-ef29-4da9-8884-e1c970cf506c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27619,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541579"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283548"
                        },
                        {
                          "title": "Family Tubs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766674",
                                  "name": "Choco Brownie Fudge 700ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "Rich chocolate tub full of chunky brownie pieces and chocolate fudge. A tub that will make a dark chocolate lover Rock N Roll. Kcal/Serving: 150",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/98b0d109-1518-4180-8d7a-fd0d5763c1d1_dfa994b6-96a8-4a12-ab2d-d369d8d7112e.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28095,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541575"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766671",
                                  "name": "Cadbury Crackle 700ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "A Cadbury lover's delight! Cadbury Crackle chocolate balls in creamy chocolate tub with swirls of rich chocolate sauce. A perfect partner for celebrations! Kcal/Serving: 155",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/3b2f63f3-4a2a-4635-a2e0-4b5cbfbdd32f_e0aeeff8-36d5-4aab-abf2-46ce4afbe803.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32286,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541574"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766677",
                                  "name": "Oreo & Cream 700ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "The OG Oreo Tub!Crunchy Oreos chunks in rich creamy vanilla. Kcal/Serving: 126",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/71e8fefc-ada1-44fa-8894-73969bdb138b_f0a59e8c-b5b4-49f6-9356-5018f1e54ed5.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27619,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541581"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766658",
                                  "name": "Majestic Kesar Pista Tub 500ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "Royal Delight In Every Bite! A Rich and Creamy Scoop with mesmerizing aroma of Kesar and richness of Pistachios. Kcal/Serving: 165",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/931e7d54-f0ab-4c2d-a078-63900516fa56_30cd474f-8e43-4046-81a3-0763c1cf3e78.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20952,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541580"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766683",
                                  "name": "Fruit & Nut 700ml Family Tub",
                                  "category": "Family Tubs",
                                  "description": "A dry fruit lover's paradise! Crunchy cashew nuts, almond and delicious raisins in every bite of creamy scoop. Kcal/Serving: 128",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/7168b868-f144-42e1-b564-f9c699cefae7_97a0b580-7444-4805-a8e8-800eee94eb70.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23810,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541578"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283549"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/2b1efa50-f27c-4f08-aeac-53294e3cb5fa_6a6e5b22-d110-4bef-993a-15afd38c35f4.jpg",
                      "categoryId": "61248041"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Party Packs",
                      "categories": [
                        {
                          "title": "Dairy Factory Slow Churned Ice Cream",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833907",
                                  "name": "The  Dairy Factory Vanilla Ice cream PP (700+700ML )",
                                  "category": "Party Packs",
                                  "description": "Savor the authentic taste of vanilla in every spoonful of Kwality Walls Slow Churned Vanilla Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/78f96388-4a24-497d-97cd-5d81de30f8ca_bc14c87d-29da-4362-9048-ff9d4b9b6c4c.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320181"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833910",
                                  "name": "The Dairy Factory Butterscotch Ice Cream PP (700+700ML )",
                                  "category": "Party Packs",
                                  "description": "Indulge in the irresistible combination of creamy butterscotch ice cream and crunchy cashew crackle.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/45432cd2-e617-433c-b4d9-1bf22166db23_c30f3f92-2bd2-4e97-99d9-054b360e4c81.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23810,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320175"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833911",
                                  "name": "The  Dairy Factory Chocolate Ice cream PP (700+700ML)",
                                  "category": "Party Packs",
                                  "description": "Experience the ultimate chocolate indulgence with Kwality Walls Slow Churned Chocolate Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/4a33fb33-f093-4249-aa5a-b53965842760_d04b569e-272c-488f-b53d-66c842186654.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27619,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320176"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833913",
                                  "name": "The Dairy Factory Alphonso Mango Ice Cream PP (700+ 700ML)",
                                  "category": "Party Packs",
                                  "description": "Savor the authentic taste of summer with Kwality Walls Slow Churned Mango Ice Cream.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/1c6626d5-2030-4362-adb9-2fd2023e9448_2cb09cc9-d5a2-42d5-aeb8-48e237ccac51.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25714,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "102320174"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283551"
                        },
                        {
                          "title": "Family Party Packs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "149719735",
                                  "name": "Kesar Pista Party Pack [700ml X 2]",
                                  "category": "Party Packs",
                                  "description": "Royal delight in every bite!A rich and creamy scoop loaded with rich flavourful kesar and pieces of pista.  Kcal/Serving: 117",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/20/96901d9c-aa70-483b-8afa-d49bd071be51_86c62e92-8d3b-4a1c-934f-fb8ca559412d.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34095,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82723560"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766714",
                                  "name": "Blushing Strawberry 700ml Party Pack",
                                  "category": "Party Packs",
                                  "description": "A fruit lover's delight.A scoop that tastes like fresh strawberries.  Kcal/Serving: 112",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/259922c4-6f45-4d4d-bc31-5329940805f2_379268e2-85a6-402e-b33f-1fccb1b2adbf.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11905,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541572"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169766710",
                                  "name": "Tutti Frutti 700ml Party Pack",
                                  "category": "Party Packs",
                                  "description": "Rich creamy scoop loaded with tiny bites of tutti fruity. Kcal/Serving: 96",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/81161111-24f3-4fc3-8aba-5b53e6e36b5e_0a2d2312-0294-4cb7-84d2-a2c09d45b31f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14286,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "82541584"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "140532348",
                                  "name": "Choco Brownie Fudge Party Pack 700ml",
                                  "category": "Party Packs",
                                  "description": "Choco Brownie Fudge is a delectable treat that combines the richness of chocolate with the indulgence of fudgy brownies. This frozen dessert features a velvety chocolate base swirled with generous chunks of fudge brownie pieces throughout Kcal/Serving129",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/ccdeffa4-cb70-43ee-9693-30c4c83e66db_82d0e2b6-88e1-4033-9e8a-b38eb3665a92.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17048,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "81265971"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "140532378",
                                  "name": "American Nuts Party Pack 700ml",
                                  "category": "Party Packs",
                                  "description": "Dive into a world full of nuts and raisins, Crunchy creamy and delicious! Kcal/Serving130",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/ea010d47-6cfe-4d7e-aaf6-e7fe2fbd2415_ae6450cd-cdb6-4da8-ae13-02bad236a8a9.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16095,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "81488049"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283552"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/78f96388-4a24-497d-97cd-5d81de30f8ca_bc14c87d-29da-4362-9048-ff9d4b9b6c4c.jpg",
                      "categoryId": "61248043"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cornetto.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169833924",
                              "name": "Cornetto Double Chocolate (105ml x 2 pcs)",
                              "category": "Cornetto.",
                              "description": "Duo of milk and dark chocolate topped with chocolate sauce, chocochips in a crunchy waffle cone. Kcal/Serving: 184",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/20/e9e8f274-6195-4b41-b507-b6431a254213_daaca77d-3c59-448f-b90a-3859a5db6720.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "70849590"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121899828",
                              "name": "Cornetto Choco Vanilla [105ml x 4pcs]",
                              "category": "Cornetto.",
                              "description": "A duo of rich and creamy vanilla topped with chocolate sauce and Choco chips in a crunchy waffle cone. Kcal/Serving: 177",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/7db6b930-2b50-4a49-b10c-d0573b38602a_13b1ce75-a7b3-4591-a6d1-4e069911a70f.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "69936794"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169766748",
                              "name": "Cornetto Choco Brownie 110ml",
                              "category": "Cornetto.",
                              "description": "Disc as soft as a kiss!Crunchy waffle cone filled with creamy chocolate and brownie pieces with a soft chocolate disc and almond sprinkles on top. Kcal/Serving: 249",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/26/e01abe03-28bd-45e8-b433-9e3b1e39e86a_114e9f15-5809-4ba2-ba42-be7b069de196.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "29238864"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/12/20/e9e8f274-6195-4b41-b507-b6431a254213_daaca77d-3c59-448f-b90a-3859a5db6720.jpg_compressed",
                      "categoryId": "61283554"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Classic Childhood Favorites",
                      "categories": [
                        {
                          "title": "Sandwich",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121899832",
                                  "name": "Sandwich Chocolate and Vanilla [90ml x 2pcs]",
                                  "category": "Classic Childhood Favorites",
                                  "description": "Looking for a sweet snack? A hearty delicious sandwich filled creamy vanilla and yummy chocolate between two crunchy biscuits. Kcal/Serving: 168",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/52b6f0aa-222a-4ded-95ca-23ab7e7d9d30_0ef18695-b42b-4511-8366-d39bae5ff88f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5714,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "69936800"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283561"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/52b6f0aa-222a-4ded-95ca-23ab7e7d9d30_0ef18695-b42b-4511-8366-d39bae5ff88f.jpg",
                      "categoryId": "61283555"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cups",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114130955",
                              "name": "Kulfi Cup Icecream 100ml",
                              "category": "Cups",
                              "description": "Your favourite Desi Matka Kulfi in a cup!Rich creamy kulfi with almonds - a desi delight for an  icecream lover. Kcal/Serving: 139",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/12bdd577-e858-4127-87a2-bbae2dde2174_f5efc2b4-7dac-4482-bc59-09632d57d40b.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4762,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "43725481"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114130952",
                              "name": "Trixy Cookie Sundae 110ml",
                              "category": "Cups",
                              "description": "(110ml) Parlour like fun in a cup. 3 delicious layers - silky chocolate disc, delicious cookies & cream and crunchy choco cookies. Kcal/Serving: 235",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/27cb8197-330c-4fae-b1f2-acf2ad9f27f0_408006d0-5247-44ce-9fcb-4876b003a6ef.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "57731786"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121899842",
                              "name": "Trixy blueberry cheesecake Sundae 110ml",
                              "category": "Cups",
                              "description": "Parlour like fun in a cup!3 delicious layers - blueberry sauce, creamy cheesecake dessert  and crunchy cinnamon cookies. Kcal/Serving: 340",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/18e21a13-7c04-4091-8a19-bbc8b49bba14_fee25597-0398-4eba-8dd0-8313ebc6bcd3.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "57731785"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169766665",
                              "name": "Choco Brownie Fudge Cup (100ml x 2pcs)",
                              "category": "Cups",
                              "description": "Rich Chocolate Full Of Chunky Brownie Pieces And Chocolate Fudge. Kcal/Serving: 144",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/18/d03a9e73-0036-4fb4-a2c9-0beaed73fc99_3829e887-8e23-430b-a113-1449e8526888.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "92802197"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121899841",
                              "name": "Oreo and Cream Cup 100ml",
                              "category": "Cups",
                              "description": "Crunchy oreo cookie chunks with rich and creamy vanilla in a cup.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/26/ddcb7bc6-adb2-49a1-8962-cd114b3601cc_7cb87098-08b5-43e2-861e-decdae050c40.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5238,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "29240171"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169766661",
                              "name": "Dry Fruit Delight Cup (100ml x 2pcs)",
                              "category": "Cups",
                              "description": "A Dry Fruit Lover's Dessert! Cashews , Almonds and  Raisins In Every Bite, a perfect dry fruit cup  Kcal/Serving: 126",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/12/18/e8946231-4331-453e-94ca-47d7485180ed_4f5cca29-6bf8-4155-b5e7-05604801b1b7.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "92802199"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "169766732",
                              "name": "Choco Sundae Cup [100ml x 4pcs]",
                              "category": "Cups",
                              "description": "Creamy vanilla scoop with swirls of rich chocolate sauce topped with butterscotch crunchies.  Kcal/Serving: 116 (6%)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/bdf8980d-afc5-41bb-a3e5-0bd1e0c4a207_595be20c-bd7b-4a25-af15-121ad7588e9a.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13333,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "offerIds": [
                                "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                              ],
                              "parentId": "83677186"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/12bdd577-e858-4127-87a2-bbae2dde2174_f5efc2b4-7dac-4482-bc59-09632d57d40b.jpg_compressed",
                      "categoryId": "61283556"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Kwality Wall's Sticks.",
                      "categories": [
                        {
                          "title": "Feast",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "133925885",
                                  "name": "Feast Cadbury Crackle 70ml",
                                  "category": "Kwality Wall's Sticks.",
                                  "description": "Experience the delight of Cadbury Crackle chocolate in a Kwality Walls Feast. Every bite has the deliciousness of Cadbury crackle Chocolate with signature hard chocolate. For any chocolate lover",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/d3b163e6-45e3-4a07-8de5-0168424f3eb0_80ef627d-5b73-4d20-bff5-c29f3e72cadd.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5714,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "77103737"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "169833928",
                                  "name": "Black Forest Feast - [70ml x 2pcs]",
                                  "category": "Kwality Wall's Sticks.",
                                  "description": "Black Forest cake meets Feast!Cake pieces through layers of Feast with a solid chocolate surprise at the end. Kcal/Serving: 246",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/e4e16f51-2e17-4bf9-be75-744e111c6bc9_f94481ed-c040-47d7-a00c-3cb85988b81c.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8571,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "title": "20% OFF",
                                      "subTitle": "USE TRYNEW",
                                      "textColor": "#DB6742",
                                      "backgroundColor": "#FAE8E3",
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "offerIds": [
                                    "26cda8ef-b7fd-4c8c-9ff7-2c2536744b49"
                                  ],
                                  "parentId": "91134999"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "61283563"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/4/15/d3b163e6-45e3-4a07-8de5-0168424f3eb0_80ef627d-5b73-4d20-bff5-c29f3e72cadd.jpg",
                      "categoryId": "61283557"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 21420010003296"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Kwality Walls Ice Cream and More",
                      "area": "Idgah Hills",
                      "completeAddress": "Eat N Meet Cafe and Restro: SHOP NO 14, MEENAKSHI COMPLEX, IDGAH HILLS, BHOPAL, MADHYA PRADESH-462001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "bw0ZYj1R7kMs-vKQ07YeeDWCLM9CToP1kHio9574"
},

  "119238": {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Sharma & Vishnu Fast Food - Hamidia Road",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "613953",
              "name": "Sharma & Vishnu Fast Food - Hamidia Road",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "sharma-&-vishnu-fast-food-jahangirabad-jahangirabad",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/17/5697054d-380a-4c96-8f07-a10d07c5e3f8_613953.jpg",
              "locality": "Manohar Dairy",
              "areaName": "Hamidia Road",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Indian",
                "Snacks"
              ],
              "avgRating": 4.4,
              "veg": true,
              "feeDetails": {
                "restaurantId": "613953",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "182026",
              "avgRatingString": "4.4",
              "totalRatingsString": "2.1K+ ratings",
              "sla": {
                "restaurantId": "613953",
                "deliveryTime": 30,
                "minDeliveryTime": 30,
                "maxDeliveryTime": 40,
                "lastMileTravel": 2.3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 1004,
                "slaString": "30-40 MINS",
                "lastMileTravelString": "2.3 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:30:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹100 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹100 off | Use FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹200 off | Use FLAT200",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Use FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹200 off | Use FLAT200",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "sharma-&-vishnu-fast-food-jahangirabad-jahangirabad",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Revenue Survey No 449/450/2, Situated near Gurudwara And Manohar Dairy,Hamidia ROad,Ward No 18,Bhopal"
                },
                {
                  "title": "Cuisines",
                  "message": "Indian,Snacks"
                }
              ],
              "totalRatings": 2100,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹100 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹100 off | Use FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹200 off | Use FLAT200",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Use FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹200 off | Use FLAT200",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 3,
                  "couponCode": "BUY1GET1",
                  "discountInfo": {
                    "discountType": "BXGY",
                    "value": 100
                  },
                  "minItemCount": 1,
                  "maxItemCount": 2,
                  "type": "B1G1",
                  "nudgeTagInfo": {
                    "title": "'Buy 1 Get 1'",
                    "textColor": "#ffffff",
                    "backgroundColor": "#753428",
                    "separatorColor": "#E44629",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "styling": {
                    "backgroundColor": "#2C1F1D",
                    "textColor": "#B3FFFFFF"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/613953"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.264552012409112,77.40777589760101",
              "backgroundImageOverlayInfo": {

              },
              "menuHeaderLottie": {
                "menuHeaderLottie": "https://media-assets.swiggy.com/bolt/bolt%2015%20black.json?updatedAt=1733379625251",
                "frequencyCapping": {

                }
              },
              "featuredSectionInfo": {

              },
              "hasBoltItems": true
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9828f3d7-712c-4945-af6a-21b6dd5bc3f9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT100",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "613953",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "2720b221-57fd-4a60-85e3-be9439881d1d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT200",
                      "description": "ABOVE ₹999",
                      "offerType": "offers",
                      "restId": "613953",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT200"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "BUY 1 GET 1 FREE",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE BUY1GET1",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "613953",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE BUY1GET1"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹50",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "7326d719-239d-41f6-8707-85c77c2e2729"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹169",
                      "offerType": "offers",
                      "restId": "613953",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE TRYNEW"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "613953",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "Buy 1 Get 1"
                        }
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      },
                      "bolt": {
                        "attributes": {
                          "displayText": "Food in 10-15 mins",
                          "displayImage": "bolt/bolt%2011.png",
                          "unselectedDisplayImage": "bolt/bolt%2011.png"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7702246",
                          "creativeId": "TopPicks2024/101263869F.png",
                          "title": "Veg Crispy Manchurian",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "101263869",
                              "name": "Veg Crispy Manchurian",
                              "category": "Chinese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/c18a81a0-4204-46fa-b78d-eb2c5e11d8da_39b19c15-2d01-46ee-9cb3-ee87c37af36b.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "12854967"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7424968",
                          "creativeId": "TopPicks2024/101929325F.png",
                          "title": "Butter Paneer Kulcha",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "101929325",
                              "name": "Butter Paneer Kulcha",
                              "category": "Indian",
                              "description": "A Combo of Buttter Paneer Masala & 3 Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/8524b57b-7e69-490f-b06a-fd5c5a28c043_6c50c349-7fff-4a1e-ac4b-3a81dd8c80f6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "parentId": "12854563"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7425207",
                          "creativeId": "TopPicks2024/101263902F.png",
                          "title": "Veg Cheese Pasta",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "101263902",
                              "name": "Veg Cheese Pasta",
                              "category": "Pastapasta",
                              "imageId": "a2a31e255f062268a6c5e5f29994d9fd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "12854940"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7425007",
                          "creativeId": "TopPicks2024/101929297F.png",
                          "title": "Veg Hot Garlic Cheese Pasta",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "101929297",
                              "name": "Veg Hot Garlic Cheese Pasta",
                              "category": "Pastapasta",
                              "imageId": "d687b33e3c5ee62ac5df8e1e0cc378a1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "12854986"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7425095",
                          "creativeId": "TopPicks2024/101929371F.png",
                          "title": "Special Thali Parcel",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "101929371",
                              "name": "Special Thali Parcel",
                              "category": "Thali",
                              "description": "The Meal comes with 3 Rotis, Rice, Butter Paneer Masala, Chole, Rajma, Dal Fry, Mixed Vegetables, onion salad , pickles and and Gulab Jamun",
                              "imageId": "5a9da154a1b60f7f3ace8f61d75a8292",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "parentId": "12854898"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Buy 1 Get 1 Free",
                      "subtitle": "1 out of 2 items will be made free.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929214",
                              "name": "Hot And Sour Soup",
                              "category": "Soup",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/12a71010-dd32-43e1-834a-3f415eca068f_6d70415d-84de-4ddb-bbb5-d6d1f9618f29.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1",
                                  "filterIndex": 1
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854703"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929321",
                              "name": "Pav Bhaji",
                              "category": "Pav Bhaji",
                              "description": "A spicy curry of mixed vegetables (bhaji) cooked in a special blend of spices and served with soft buttered pav (bread bun shallow fried in butter)",
                              "imageId": "b9b04b5b72c9218412eed5763684ab2e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1",
                                  "filterIndex": 1
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854839"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {
                        "displayText": "Learn More",
                        "offerIds": [
                          "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                        ]
                      },
                      "subtitleColor": "noteworthy",
                      "categoryId": "17"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929214",
                              "name": "Hot And Sour Soup",
                              "category": "Soup",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/12a71010-dd32-43e1-834a-3f415eca068f_6d70415d-84de-4ddb-bbb5-d6d1f9618f29.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854703"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263831",
                              "name": "Veg Sandwich",
                              "category": "Sandwich",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/196c9076-6f8b-4c02-b9a1-89fa29019d7a_8b7ed319-7c8c-428a-ba43-e5500f17c342.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855077"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263832",
                              "name": "Veg Cheese Sandwich",
                              "category": "Sandwich",
                              "description": "A golden, crispy sandwich with melty cheddar cheese oozing between three perfectly toasted slices of sourdough bread, offering a comforting and nostalgic bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/65e8bd0c-1c85-4eee-b225-ec80498dabbe_5973c0c0-359f-42ed-a0cb-43eacf1cb7fd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "144 ratings",
                                  "ratingCountV2": "144"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854948"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929321",
                              "name": "Pav Bhaji",
                              "category": "Pav Bhaji",
                              "description": "A spicy curry of mixed vegetables (bhaji) cooked in a special blend of spices and served with soft buttered pav (bread bun shallow fried in butter)",
                              "imageId": "b9b04b5b72c9218412eed5763684ab2e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854839"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263902",
                              "name": "Veg Cheese Pasta",
                              "category": "Pastapasta",
                              "imageId": "a2a31e255f062268a6c5e5f29994d9fd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854940"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263860",
                              "name": "Veg Hakka Noodles",
                              "category": "Chinese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/388e0cbe-b330-47c4-8794-1b941fa874de_bf87ea1b-bdab-45e9-91ec-f9b1f7ebd76b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854985"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263912",
                              "name": "Veg Biryani",
                              "category": "Chinese",
                              "imageId": "236470139e46f5a8c586ec127fef91fd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854934"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263945",
                              "name": "Chole Kulcha",
                              "category": "Indian",
                              "description": "A Combo of Chole & 3 Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/1301279a-c74f-4062-beb6-eb18df70df57_b8839700-c8a6-45bf-883b-919f89fad1a4.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854621"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929325",
                              "name": "Butter Paneer Kulcha",
                              "category": "Indian",
                              "description": "A Combo of Buttter Paneer Masala & 3 Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/8524b57b-7e69-490f-b06a-fd5c5a28c043_6c50c349-7fff-4a1e-ac4b-3a81dd8c80f6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854563"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263973",
                              "name": "Masala Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/23640a70-5911-4665-90e2-74e24d4f7090_a6f10a21-2e28-49d7-a609-aad24aac2adf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854765"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soup",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263828",
                              "name": "Manchow Soup",
                              "category": "Soup",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/5722fd06-8661-4982-bba3-923be7f8782e_2e576dff-e738-41b6-93e6-3f799626ae50.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "imageBadges": [
                                {
                                  "imageId": "Low%20cal/Low%20cal%201_1.png"
                                }
                              ],
                              "parentId": "12854756"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929214",
                              "name": "Hot And Sour Soup",
                              "category": "Soup",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/12a71010-dd32-43e1-834a-3f415eca068f_6d70415d-84de-4ddb-bbb5-d6d1f9618f29.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854703"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/5722fd06-8661-4982-bba3-923be7f8782e_2e576dff-e738-41b6-93e6-3f799626ae50.jpg",
                      "categoryId": "27534770"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sandwich",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263831",
                              "name": "Veg Sandwich",
                              "category": "Sandwich",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/196c9076-6f8b-4c02-b9a1-89fa29019d7a_8b7ed319-7c8c-428a-ba43-e5500f17c342.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855077"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263832",
                              "name": "Veg Cheese Sandwich",
                              "category": "Sandwich",
                              "description": "A golden, crispy sandwich with melty cheddar cheese oozing between three perfectly toasted slices of sourdough bread, offering a comforting and nostalgic bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/65e8bd0c-1c85-4eee-b225-ec80498dabbe_5973c0c0-359f-42ed-a0cb-43eacf1cb7fd.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "144 ratings",
                                  "ratingCountV2": "144"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854948"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263834",
                              "name": "Corn Cheese Sandwich",
                              "category": "Sandwich",
                              "description": "A golden, crispy sandwich with corn and melty cheddar cheese oozing between three perfectly toasted slices of sourdough bread, offering a comforting and nostalgic bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/d2aba6de-95ed-4ab3-b898-142396a98778_1211af19-f0d0-4f91-a924-febf78e889f5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "114825716"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263835",
                              "name": "Veg Paneer Cheese Sandwich",
                              "category": "Sandwich",
                              "description": "A golden, crispy sandwich with paneer and melty cheddar cheese oozing between three perfectly toasted slices of sourdough bread, offering a comforting and nostalgic bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/9b7da758-8012-486b-bfdc-a9fd0824ae12_9672f765-14c2-4980-ad11-13ea445d9ff1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263837",
                              "name": "Indori Cheese Chutney Sandwich",
                              "category": "Sandwich",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/b29e5c09-fe08-4361-b35e-7749498c3793_6a85d988-3922-4724-b99a-ac436efe8482.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854718"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263838",
                              "name": "Paneer Tikka Masala Sandwich",
                              "category": "Sandwich",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/e7e0efe3-c610-4baa-ba87-c72ee7d3d692_9a0dc083-2fd0-42bf-8ea5-234d4ef2f3ff.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854830"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929224",
                              "name": "Veg Double Cheese Sandwich",
                              "category": "Sandwich",
                              "description": "A golden, crispy sandwich with 2 melty cheddar cheese slices oozing between three perfectly toasted slices of sourdough bread, offering a comforting and nostalgic bite.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/add3b7cc-177b-4a4a-a926-2df26a33a52d_05fcb42d-2651-4808-8999-fcc01c6e3d2a.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854973"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929226",
                              "name": "Veg Paneer Mexican Sandwich",
                              "category": "Sandwich",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/f665dcd6-dcbc-4399-afd2-e114221bf52a_fff7d4a4-1337-4f50-a24c-ee1afa669472.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855053"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/196c9076-6f8b-4c02-b9a1-89fa29019d7a_8b7ed319-7c8c-428a-ba43-e5500f17c342.jpg",
                      "categoryId": "27534771"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burger",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263841",
                              "name": "Veg Cheese Burger",
                              "category": "Burger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/b4de3b5b-d567-4265-bc7f-0a81961b2452_420c7d8c-1a5c-4e49-8c8a-06e6627d7361.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "imageBadges": [
                                {
                                  "imageId": "merch_bau/High%20Protein%201_1.png"
                                }
                              ],
                              "parentId": "12854938"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263843",
                              "name": "Veg Paneer Cheese Burger",
                              "category": "Burger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/05be073e-3bd5-463a-8261-79c3abe35ff8_08260d25-1763-4801-9854-24cb1eef0cbb.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855038"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929232",
                              "name": "Veg Tikki Cheese Burger",
                              "category": "Burger",
                              "imageId": "4a9edd2982820514e4fe9a862fae1b7a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855088"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929233",
                              "name": "Veg Burger",
                              "category": "Burger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/e04b5f40-1ac4-4180-aa71-d2737485a3f8_0d892a3b-d054-4d01-b760-2cc01b99b478.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854937"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/b4de3b5b-d567-4265-bc7f-0a81961b2452_420c7d8c-1a5c-4e49-8c8a-06e6627d7361.jpeg",
                      "categoryId": "27534772"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pav Bhaji",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263928",
                              "name": "Extra Pav",
                              "category": "Pav Bhaji",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4300,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854684"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929321",
                              "name": "Pav Bhaji",
                              "category": "Pav Bhaji",
                              "description": "A spicy curry of mixed vegetables (bhaji) cooked in a special blend of spices and served with soft buttered pav (bread bun shallow fried in butter)",
                              "imageId": "b9b04b5b72c9218412eed5763684ab2e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "Buy 1 Get 1",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3",
                                  "matchText": "B1G1"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "B1G1",
                              "itemLevelDiscount": "ITEM_LEVEL_DISCOUNT_B1G1",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "offerIds": [
                                "9c8b3513-08a6-4268-9ed1-e393c5d1a73f"
                              ],
                              "parentId": "12854839"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "b9b04b5b72c9218412eed5763684ab2e",
                      "categoryId": "27534778"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263844",
                              "name": "Veg Cheese Pizza",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/d31843c4-ec48-4564-8902-67071e74856d_9e14ee4d-ca7b-42b1-a65f-0929767da056.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854946"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263847",
                              "name": "Veg Corn Cheese Pizza",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/184c69f1-753c-438b-98c8-aedd6add5c36_412d8545-0bd9-4c22-a40d-8dd2a1fd4ef9.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "57235055"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263849",
                              "name": "Veg Special Cheese Pizza",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/ce47024c-7456-4d49-881c-9fd2951ee681_bc19c86c-436c-4ebf-abf9-cfa35b88020e.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12855084"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929235",
                              "name": "Veg Cheese Pizza (extra Cheese)",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/9e434d1d-dec8-4cdb-acdb-66e79273961c_c74fb59b-b0c0-4f24-a4d8-3d63e91ad75d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854947"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929237",
                              "name": "Veg Mashroom Cheese Pizza",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/876df5d7-2232-470f-abcc-d3c0f01904c8_254fb864-c63c-4a33-81db-1a5bfe214096.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12855016"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929241",
                              "name": "Veg Paneer Cheese Pizza",
                              "category": "Pizza",
                              "description": "8 inch.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/f3d8feef-c794-47ed-9e9e-2711614f2643_9a9351d1-3762-47c4-9d4b-5c6847fbad14.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855041"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/d31843c4-ec48-4564-8902-67071e74856d_9e14ee4d-ca7b-42b1-a65f-0929767da056.jpg",
                      "categoryId": "27534773"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastapasta",
                      "categories": [
                        {
                          "title": "Pasta",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263898",
                                  "name": "Veg Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/de992393-4988-4e35-b618-03a2e41fa6d6_968b75ee-b8ba-4453-bf9e-f17c82c6ba67.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855058"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263900",
                                  "name": "Veg Tomato Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/63478b99-b1a2-4c15-b716-3927a66ecb0d_c63fe81d-1dc5-4514-9a95-54f91add0683.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855092"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263901",
                                  "name": "Veg Hot Garlic Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/f1e3890e-092f-447e-a5ac-8759437be359_304d09d0-e8fc-4929-a73e-88a4555a0f82.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854988"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263902",
                                  "name": "Veg Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "a2a31e255f062268a6c5e5f29994d9fd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "83 ratings",
                                      "ratingCountV2": "83"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854940"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263907",
                                  "name": "Veg Paneer Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/7c058a15-5f25-47d9-b2b9-ef7d9fe628ff_4978bb81-2c6b-4ddd-b76b-47256e25bcb8.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855039"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263909",
                                  "name": "Veg Corn Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/0bdc7dd2-2eb8-45f5-9711-3312eb77b4bb_e4a562be-231f-44ec-b7ce-ccf5ff0ecaa6.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57235054"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929296",
                                  "name": "Veg Cheese Pasta (extra Cheese)",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/d2c59271-f5c3-4206-952a-826455fd96f0_0d0a1b96-ee62-4434-8548-e5e0c8e33c85.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854941"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929297",
                                  "name": "Veg Hot Garlic Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "d687b33e3c5ee62ac5df8e1e0cc378a1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "74 ratings",
                                      "ratingCountV2": "74"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854986"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929298",
                                  "name": "Veg Mashroom Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/defd9591-102b-45d9-9abf-b35c11915a5d_4dfa8901-ba61-428b-af15-f05d5b4b8fd9.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855015"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929302",
                                  "name": "Veg Tamato Cheese Pasta",
                                  "category": "Pastapasta",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/9ca90a82-e042-4d64-beab-3a54a1f66a8e_e195455e-bb7a-4354-8531-c2f4351add30.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57688070"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "31641111"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/de992393-4988-4e35-b618-03a2e41fa6d6_968b75ee-b8ba-4453-bf9e-f17c82c6ba67.jpg",
                      "categoryId": "31641025"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Chinese",
                      "categories": [
                        {
                          "title": "Chinese",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263859",
                                  "name": "Veg Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/2b11a969-e5e0-4a7a-b9d6-0f25b6049fa9_a575f046-a133-40b0-b8f8-bb80897972aa.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "97 ratings",
                                      "ratingCountV2": "97"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855034"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263860",
                                  "name": "Veg Hakka Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/388e0cbe-b330-47c4-8794-1b941fa874de_bf87ea1b-bdab-45e9-91ec-f9b1f7ebd76b.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "56 ratings",
                                      "ratingCountV2": "56"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854985"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263861",
                                  "name": "Veg Schezwan Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/72e11b65-4f68-4ccd-9b07-a80a8a987490_123aa8d6-9b6d-4527-a419-96edaaf5a053.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "53 ratings",
                                      "ratingCountV2": "53"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855081"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263862",
                                  "name": "Veg Paneer Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/7b685d52-3617-4f9b-bc68-710bbd9e5c49_09f2e603-6010-438d-bc2a-fed61e591481.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855054"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263864",
                                  "name": "Veg Chilli Garlic Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/c2a6eb14-3253-44a7-9983-3a2f00651947_66a94cd4-a05f-4c89-bd8f-6fa017fd3412.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854951"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263866",
                                  "name": "Veg Crispy Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/239fa8d6-ca65-45e1-aa4d-0444d3e1210a_5fcc2147-d703-49ba-824d-9879a0493eb3.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854968"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263867",
                                  "name": "Veg Paneer Crispy Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/d2a97996-814e-4c2d-bf24-64145992bdcb_ee617634-ba1d-4b1f-8445-f9fe9d16b71b.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855043"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263868",
                                  "name": "Veg Mashroom Crispy Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/4784d92b-c60c-41c4-a572-0b42a8e300b3_3162bedb-03b2-4eca-9a16-64ea4c24a5f2.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12855018"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263869",
                                  "name": "Veg Crispy Manchurian",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/c18a81a0-4204-46fa-b78d-eb2c5e11d8da_39b19c15-2d01-46ee-9cb3-ee87c37af36b.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854967"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263870",
                                  "name": "Veg Macroni",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/1291f17f-a667-4a57-970d-a6cdfedad73d_5e329bbd-04da-4b90-a4ec-e3c0a1d52c92.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855001"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263874",
                                  "name": "Veg Manchurian Noodles",
                                  "category": "Chinese",
                                  "description": "Manchurian Noodles are essentially veggie noodles that are tossed in a Manchurian sauce and manchuriyan balls are added",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/387cec7c-f1c4-4bce-a6d7-582559c12255_541e7f82-40b3-4db3-aba9-f48bb8667b0b.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855010"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263877",
                                  "name": "Veg Kothey",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/387cec7c-f1c4-4bce-a6d7-582559c12255_541e7f82-40b3-4db3-aba9-f48bb8667b0b.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854999"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263886",
                                  "name": "Veg Potato Chilli",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/e03c33a7-0f48-4ce4-b053-41fbb328609c_62462c01-4a92-4500-9f5d-c3969dbba1ac.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855075"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263888",
                                  "name": "Veg Potato 65",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/cf204d90-0913-4fdc-85ca-b6f31155305c_2cd32784-87d2-4932-8388-f55932d2c02e.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855074"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263890",
                                  "name": "French Fry",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/0548b3eb-1a6c-4ec3-b93e-bb4da6774fd9_3dd81e83-e96b-43e8-b17c-7d4f9a0a4a80.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57796172"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929244",
                                  "name": "Mtr Fry Crispy Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/06910535-18d9-4beb-9285-1c79153dd886_73389587-456a-45ca-a734-bccd7a398e05.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "52535119"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929249",
                                  "name": "Veg American Chopsuey",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/55b3b1f1-8eb0-408c-b45f-41fcda03b73b_a2e2c746-ceae-4f06-acf9-991db139c631.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854932"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929251",
                                  "name": "Veg Chilly Paneer Dry (10 Pieces)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/c293ca8c-3371-44ac-bb4f-f89bd2132165_dac79fd0-d842-44fb-9764-945aa20a599d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57796174"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929253",
                                  "name": "Veg Chilly Paneer Gravy (10 Pieces)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/2f090bb6-c3fb-4851-8b29-31189eab2342_047a7972-f23a-42c4-b276-73bbe16f4f9f.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57796175"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929254",
                                  "name": "Veg Chinese Chopsuey",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/c0af0dd9-b99a-446b-abf4-a14556610595_6f67fba8-4b14-42ec-8ed9-d664b1491f57.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854961"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929260",
                                  "name": "Veg Chinese Combi (mix Of Noodles+rice+manchurian)",
                                  "category": "Chinese",
                                  "description": "A fusion of Noodles, Fried Rice and Manchurian",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/ff582e32-97be-482c-9223-a4dff39eb4aa_a54cac06-804e-4185-a504-222dcb726dce.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "87744815"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929261",
                                  "name": "Veg Manchurian All Mix",
                                  "category": "Chinese",
                                  "description": "A fusion of Manchurian, Macroni, Noodles and Rice",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/8a89699e-3e52-4586-87b6-302ee763c059_881b9889-520b-426f-ae84-7269fc9829d1.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855003"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929262",
                                  "name": "Veg Manchurian (dry)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/b56bdcc9-d8cc-428b-967c-579acc44fb2a_b670970a-e1d2-496a-bde1-f5aa9ecde2bd.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "36 ratings",
                                      "ratingCountV2": "36"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855006"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929264",
                                  "name": "Veg Manchurian (gravy)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/113d422c-dd4a-424c-aa25-183df7c47de9_0574dbe1-a9a9-41d3-900a-eddaad59a288.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18500,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "43 ratings",
                                      "ratingCountV2": "43"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12855009"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929269",
                                  "name": "Chinese Thali ( Noodles+rice+manchuriyan Gravy)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/8/29/b90ae5bc-9929-4033-91c0-de47f81bd510_05ac2b23-e73d-4dcf-bd41-dba25c6a898a.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "87744814"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929271",
                                  "name": "Veg Mashroom Noodles",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/c42e3c28-4c0a-4cd2-886a-29d074c5ee9f_e7c06885-57bc-4530-9884-32c5c4ea8e5a.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12855021"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929275",
                                  "name": "Veg Paneer 65 (10 Pieces)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/9cfaef56-c3c9-4259-8b7c-e116404a4db2_4ed1e40b-8750-48e9-801f-adacc79504a3.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855036"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929280",
                                  "name": "Veg Paneer Manchurin (10 Pieces)",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/abb6a8fc-1af7-45fe-ab75-cfb59aef316e_37b8384f-f13c-4285-9e55-39709ebc0c10.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "57796179"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46998071"
                        },
                        {
                          "title": "Chinese Rice",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263912",
                                  "name": "Veg Biryani",
                                  "category": "Chinese",
                                  "imageId": "236470139e46f5a8c586ec127fef91fd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854934"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263913",
                                  "name": "Veg Manchurian Biryani",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/ed35062c-ca2e-4acc-972e-ceaa6eb79c5a_c0b55483-2472-4bac-8e0c-dc103a9ed913.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855005"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263917",
                                  "name": "Veg Schezwan Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "bfb3ba3d531294230ae058c08d0b3af2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855080"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929304",
                                  "name": "Chilli Paneer Biryani",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/0e30176f-e3f0-4148-b24c-09fd2c2e0695_6120e673-c35e-43e0-a924-a6c105b54df2.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854605"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929306",
                                  "name": "Hong Kong Style Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/bccf4536-6055-4b55-827a-4ece97dab965_c520a05a-e9b7-40cb-a9aa-a2493a87533e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854702"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929310",
                                  "name": "Veg Chilly Garlic Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/982fb8b4-913f-45a6-a13d-7a29bbcb06f4_219f989b-4f62-489a-9b62-1c34f2d26aa3.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "57688062"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929311",
                                  "name": "Veg Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/4fa953ce-7e11-428b-bdde-8ab227799d71_93b2c471-a472-42b2-a51a-f575cd6d169f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854984"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929314",
                                  "name": "Veg Manchurin Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/01b4da61-c859-442f-84ea-7cfb982d05c9_38219ea2-7bc0-4a53-9f53-b9404adcd502.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855012"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929315",
                                  "name": "Veg Mashroom Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/4471e312-ba78-4a11-b554-368b5e8be9ef_011b5f1c-a218-4177-9ff5-d10102a466b6.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855020"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929316",
                                  "name": "Veg Paneer Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/fdacbeea-1f64-4d0b-a800-b7f67271104f_b9aac0e4-9b41-4161-b054-dd37cecc165b.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12855046"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929317",
                                  "name": "Veg Singapure Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/58964bb5-2359-4121-8bd0-87fc92c97e54_4fa3bb73-ca23-4bb0-b0a6-3a8937aa57c6.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "57688069"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929318",
                                  "name": "Veg Triple Schezwan Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/b95eb270-fb2a-4ebc-8fe3-baf591fe2c28_ab3008d9-e8f4-4f11-81d9-9da92334538f.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57688071"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129863134",
                                  "name": "Veg Peas Fry Rice",
                                  "category": "Chinese",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/dc3c2b95-5fd4-42df-994a-d45ef91acd73_00aaaff7-eab3-4541-8953-189a5a74559f.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "75456644"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "27534777"
                        },
                        {
                          "title": "Momos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929242",
                                  "name": "Momos Fry",
                                  "category": "Chinese",
                                  "imageId": "a4c94f71eb2122b922fe0a9e8241b710",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17200,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57688053"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929246",
                                  "name": "Veg Steam Momos",
                                  "category": "Chinese",
                                  "imageId": "191ad9ce7ac04577bf20f8a4b7e955ee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15600,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "48766094"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129863136",
                                  "name": "Chilli Momo",
                                  "category": "Chinese",
                                  "imageId": "54758a38093c0d9e265545381a9de26e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "75456643"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "43448241"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/2b11a969-e5e0-4a7a-b9d6-0f25b6049fa9_a575f046-a133-40b0-b8f8-bb80897972aa.jpg",
                      "categoryId": "27534774"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Indian",
                      "categories": [
                        {
                          "title": "Indian",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263945",
                                  "name": "Chole Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of Chole & 3 Kulcha",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/1301279a-c74f-4062-beb6-eb18df70df57_b8839700-c8a6-45bf-883b-919f89fad1a4.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "119 ratings",
                                      "ratingCountV2": "119"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854621"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929325",
                                  "name": "Butter Paneer Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of Buttter Paneer Masala & 3 Kulcha",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/8524b57b-7e69-490f-b06a-fd5c5a28c043_6c50c349-7fff-4a1e-ac4b-3a81dd8c80f6.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854563"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929326",
                                  "name": "Butter Paneer Laccha Paratha",
                                  "category": "Indian",
                                  "description": "A Combo of Buttter Paneer Masala & 3 Lachha Paratha",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/85c5b771-5616-4f82-88c8-142b73a5c03f_5d2e2e84-467a-41bd-8bf4-b9ce67544026.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524537",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854565"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929327",
                                  "name": "Butter Paneer Naan",
                                  "category": "Indian",
                                  "description": "A Combo of Buttter Paneer Masala & 2 Naan",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/6648fe5d-88ad-466b-8b9f-108ae4074619_45305835-7d6c-4e26-955c-34e8ae48a034.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524544",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854572"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929328",
                                  "name": "Butter Paneer Roti",
                                  "category": "Indian",
                                  "description": "A Combo of Buttter Paneer Masala & 4 Roti",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/0965b2ef-f51d-47f9-b59d-de86dd711b1f_609735f9-2498-4454-9c88-392ed20a355f.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524567",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854577"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929329",
                                  "name": "Butter Paneer Cheese Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of Buttter Paneer Masala & 2 Cheese Kulcha",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524550",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854562"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929330",
                                  "name": "Chola Cheese Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of Chole & 2 Cheese Kulcha",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/48fb0796-e48e-4313-bc94-82677c3f3f80_198de5ff-0e2b-4d16-bf84-d7dc8098ae49.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524535",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854616"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929331",
                                  "name": "Chole Laccha Paratha",
                                  "category": "Indian",
                                  "description": "A Combo of Chole & 3 Lachha Parataha",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/f0cfd3fd-5419-4a39-aafa-aa6487e8e835_35ec5aaf-8570-425f-ae26-4eadf472ac28.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524546",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854622"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929332",
                                  "name": "Chole Naan",
                                  "category": "Indian",
                                  "description": "A Combo of Chole & 2 Naan",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/4354b92a-e42a-4f18-a6d5-0250962d459a_e8c23a79-0d16-486b-9056-14ecdaa5510f.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524548",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854625"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929336",
                                  "name": "Chole Roti",
                                  "category": "Indian",
                                  "description": "A Combo of Chole & 4 Roti",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/bb7644e3-e6c2-472e-a07f-1d00faf6cd26_acde8cd7-5842-46ec-8a4f-effd0839c5c3.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524556",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854629"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929337",
                                  "name": "Dal Fry Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Kulcha & Dal Fry",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/93f19fff-779d-4fcf-8f66-351b51f68c35_cec1af99-d3b3-4098-bcd4-cf6500f0aa19.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524564",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854653"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929338",
                                  "name": "Dal Fry Laccha Parata",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Lachha Paratha & Dal Fry",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/b6e08df4-b010-48e1-bdca-4e5bb2e5ea10_561858d0-3a5c-45f7-85fa-1fc646f6e547.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524560",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "57235040"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929339",
                                  "name": "Dal Fry Naan",
                                  "category": "Indian",
                                  "description": "A Combo of 2 Naan & Dal Fry",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/ce97f262-ae60-4148-adbd-d6c929b13b12_9e1beb98-cc94-4cd9-9efc-fa6b08f40404.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24100,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524538",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854656"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929340",
                                  "name": "Dal Fry Roti",
                                  "category": "Indian",
                                  "description": "A Combo of 4 Rotis & Dal Fry",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/9184058d-b820-4136-bfc7-f6349954c1c5_80f2eb2d-c615-45bb-8414-22ed59130b45.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21300,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524568",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854659"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929341",
                                  "name": "Kadai Paneer Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Kulcha & Kadai Paneer",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/4339810e-e569-4795-9590-7260e6bb98f0_5090ccf2-1c05-4fc8-8260-09b9059a1077.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524545",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854732"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929342",
                                  "name": "Kadai Paneer Naan",
                                  "category": "Indian",
                                  "description": "A Combo of 2 Naan & Kadai Paneer",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/ec8b2023-5770-4f69-9c5d-a749aed6c53a_309d7e08-1d08-4afd-b1f6-776fc92d09e4.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524536",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854734"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929343",
                                  "name": "Kadai Paneer Paratha",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Lachha Paratha & Kadai Paneer",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/9f15ac66-16a7-4a95-b0b2-be110d0add38_90aacb32-1ecd-496c-a055-3972e3e65a4d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524540",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854735"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929344",
                                  "name": "Kadai Paneer Roti",
                                  "category": "Indian",
                                  "description": "A Combo of 4 Rotis & Kadai Paneer",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/9ad5effa-765b-4591-9e94-edd208eb7f9a_1e2414f9-9a3b-474d-87e7-2c8ed78a6a3a.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524570",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854737"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929346",
                                  "name": "Combo Paneer + Chola Kulcha Parcel",
                                  "category": "Indian",
                                  "description": "A combo of 3 Kulcha served with Butter Paneer Masala and Chole",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/677fb608-4d06-4fbd-b3fe-88e1e8098522_5c31e4e6-e1ce-4486-af0e-ecd46b7672ce.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524565",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854637"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929347",
                                  "name": "Rajma Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Kulcha & Rajma",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/f9fa94ce-2ab0-4a8d-824e-3518e51ba86f_27def306-39c7-44bb-92a9-f3d8b3dc3238.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524557",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854872"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929349",
                                  "name": "Rajma Laccha Paratha",
                                  "category": "Indian",
                                  "description": "A Combo of 3 Lachha Paratha & Rajma",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/31/91327ac3-9e44-4476-932f-9ce9a472eb2a_f17b5718-d83b-407e-a4e5-cb4a4df2afbf.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524534",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854873"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929350",
                                  "name": "Rajma Naan",
                                  "category": "Indian",
                                  "description": "A Combo of 2 Naan & Rajma",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/8a691476-fd4f-4645-b2b5-ea95390abc85_8cbdf483-d537-4282-b86c-4d595a60119d.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524547",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854877"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929351",
                                  "name": "Rajma Roti",
                                  "category": "Indian",
                                  "description": "A Combo of 4 Roti & Rajma",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/4aa2ecd0-5c48-44df-a8e7-21217482a85b_9bbec412-4465-49e3-b448-181c9a007619.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524569",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854880"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137383512",
                                  "name": "Chole Bhature (2 Pcs)",
                                  "category": "Indian",
                                  "description": "A Combo of 2 bhature and chole",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/d906b1c0-d085-4aec-aa26-dde1656f3db4_81e6c640-adcb-4c9a-8c93-fc6c756d782c.JPG",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "80405384"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "137383519",
                                  "name": "Kadai Paneer Cheese Kulcha",
                                  "category": "Indian",
                                  "description": "A Combo of kadai paneer and 2 cheese kulcha",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524553",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "80405388"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "46998072"
                        },
                        {
                          "title": "Vegetable",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263957",
                                  "name": "Dal Fry",
                                  "category": "Indian",
                                  "imageId": "47520b20f95b6ecbc68367372d5402e0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40713705",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 148,
                                            "default": 1,
                                            "id": "130317103",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 198,
                                            "id": "130317104",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713705",
                                            "variationId": "130317103"
                                          }
                                        ],
                                        "price": 14800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713705",
                                            "variationId": "130317104"
                                          }
                                        ],
                                        "price": 19800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524541",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524541",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854650"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263958",
                                  "name": "Rajma",
                                  "category": "Indian",
                                  "imageId": "475eafdbea601601ae11c7a6033e7902",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40713708",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 138,
                                            "default": 1,
                                            "id": "130317109",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 208,
                                            "id": "130317110",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713708",
                                            "variationId": "130317109"
                                          }
                                        ],
                                        "price": 13800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713708",
                                            "variationId": "130317110"
                                          }
                                        ],
                                        "price": 20800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524543",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524543",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854869"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101263959",
                                  "name": "Chole",
                                  "category": "Indian",
                                  "imageId": "308b4ca5e28b9aaf2ea821bf791fbd0a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40713704",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 138,
                                            "default": 1,
                                            "id": "130317101",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 208,
                                            "id": "130317102",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713704",
                                            "variationId": "130317101"
                                          }
                                        ],
                                        "price": 13800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713704",
                                            "variationId": "130317102"
                                          }
                                        ],
                                        "price": 20800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524555",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524555",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854619"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929356",
                                  "name": "Butter Paneer Masala",
                                  "category": "Indian",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/bbc8ca9e-2a7b-4786-b2a9-6818a70a3426_535834fc-0e29-418d-9b20-327cb09e40c1.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "20793467",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 228,
                                            "default": 1,
                                            "id": "68648499",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 308,
                                            "id": "68648500",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "20793467",
                                            "variationId": "68648499"
                                          }
                                        ],
                                        "price": 22800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "20793467",
                                            "variationId": "68648500"
                                          }
                                        ],
                                        "price": 30800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524558",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524558",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 22800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854569"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929357",
                                  "name": "Kadai Paneer",
                                  "category": "Indian",
                                  "imageId": "03ef757dc2bcf71b42fd7047df133fee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "20793468",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 258,
                                            "default": 1,
                                            "id": "68648501",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 338,
                                            "id": "68648502",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "20793468",
                                            "variationId": "68648501"
                                          }
                                        ],
                                        "price": 25800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "20793468",
                                            "variationId": "68648502"
                                          }
                                        ],
                                        "price": 33800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524552",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524552",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 25800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854729"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929358",
                                  "name": "Mix Veg",
                                  "category": "Indian",
                                  "imageId": "d3ca08fcb20cd473d70f7803b9a8e0b4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "40713707",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 148,
                                            "default": 1,
                                            "id": "130317107",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 188,
                                            "id": "130317108",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713707",
                                            "variationId": "130317107"
                                          }
                                        ],
                                        "price": 14800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "40713707",
                                            "variationId": "130317108"
                                          }
                                        ],
                                        "price": 18800,
                                        "addonCombinations": [
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998900"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998901"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998899"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998897"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998902"
                                          },
                                          {
                                            "groupId": "145524571",
                                            "addonId": "115998898"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "145524571",
                                      "groupName": "Extra Breads",
                                      "choices": [
                                        {
                                          "id": "115998900",
                                          "name": "Tandoori Butter Roti",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998901",
                                          "name": "Kulcha",
                                          "price": 3600,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998899",
                                          "name": "Butter Naan",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998897",
                                          "name": "Lachha Paratha",
                                          "price": 5800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998902",
                                          "name": "Garlic Naan",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "115998898",
                                          "name": "Cheese Kulcha",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14800,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854783"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "27534781"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/1301279a-c74f-4062-beb6-eb18df70df57_b8839700-c8a6-45bf-883b-919f89fad1a4.jpg",
                      "categoryId": "27534780"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Roti & Kulcha",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263966",
                              "name": "Kulcha",
                              "category": "Roti & Kulcha",
                              "imageId": "87bfdebbe94218e96c589fa489ae9de0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854747"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263967",
                              "name": "Butter Naan",
                              "category": "Roti & Kulcha",
                              "imageId": "34cf1b3aebd6ceb86bcd9b95730b48ae",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854561"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263968",
                              "name": "Lachha Paratha",
                              "category": "Roti & Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/d0ef9d04-6d83-473a-a38e-25e7597a9c7a_f1baf048-071c-45db-8b14-429c60941818.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854749"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929361",
                              "name": "Tandoori Butter Roti",
                              "category": "Roti & Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/94d1062e-e035-4a4c-af6a-c593491bf746_3d7eeaa8-d768-496d-8b6a-2353f90f3331.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854910"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128734376",
                              "name": "Garlic Naan",
                              "category": "Roti & Kulcha",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/89fd74e3-8055-41f8-9eb1-e031ca666f5f_a7090473-7651-4785-9fa6-16dbaf448764.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "63525097"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137383510",
                              "name": "Cheese Kulcha",
                              "category": "Roti & Kulcha",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "67918423"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "87bfdebbe94218e96c589fa489ae9de0",
                      "categoryId": "27534782"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Indian Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263929",
                              "name": "Plain Rice",
                              "category": "Indian Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/202db6f9-fc93-4d8f-b0bd-4f025d4e0e5f_3ca41699-4271-4ea8-a0f6-e2fcf25ad13a.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12854855"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263931",
                              "name": "Chola Rice",
                              "category": "Indian Rice",
                              "description": "Chole + Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/041047b6-7c52-40a6-92e5-65607abc94bb_799cafa9-53e3-4743-883d-42e2a5047460.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "145524542",
                                  "groupName": "Extra Breads",
                                  "choices": [
                                    {
                                      "id": "115998900",
                                      "name": "Tandoori Butter Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998901",
                                      "name": "Kulcha",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998899",
                                      "name": "Butter Naan",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998897",
                                      "name": "Lachha Paratha",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998902",
                                      "name": "Garlic Naan",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998898",
                                      "name": "Cheese Kulcha",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854618"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263932",
                              "name": "Rajma Rice",
                              "category": "Indian Rice",
                              "description": "Rajma + Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/8f646a0b-08d8-409f-8f6e-5478644f7900_7fa778ae-71ed-439b-b58f-04d51e0012c6.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "145524559",
                                  "groupName": "Extra Breads",
                                  "choices": [
                                    {
                                      "id": "115998900",
                                      "name": "Tandoori Butter Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998901",
                                      "name": "Kulcha",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998899",
                                      "name": "Butter Naan",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998897",
                                      "name": "Lachha Paratha",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998902",
                                      "name": "Garlic Naan",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998898",
                                      "name": "Cheese Kulcha",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854878"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263934",
                              "name": "Kadai Paneer Rice",
                              "category": "Indian Rice",
                              "description": "Kadai Paneer + Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/9a6ebe9b-afe5-475c-af48-a8c6536eb0ee_786d9677-d014-4f65-a916-7ccb4d47cc71.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "145524539",
                                  "groupName": "Extra Breads",
                                  "choices": [
                                    {
                                      "id": "115998900",
                                      "name": "Tandoori Butter Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998901",
                                      "name": "Kulcha",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998899",
                                      "name": "Butter Naan",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998897",
                                      "name": "Lachha Paratha",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998902",
                                      "name": "Garlic Naan",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998898",
                                      "name": "Cheese Kulcha",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854736"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929323",
                              "name": "Butter Paneer Rice",
                              "category": "Indian Rice",
                              "description": "Butter Paneer Masala + Rice",
                              "imageId": "325666f0d624eb952e1594b32d921cfa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "145524563",
                                  "groupName": "Extra Breads",
                                  "choices": [
                                    {
                                      "id": "115998900",
                                      "name": "Tandoori Butter Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998901",
                                      "name": "Kulcha",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998899",
                                      "name": "Butter Naan",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998897",
                                      "name": "Lachha Paratha",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998902",
                                      "name": "Garlic Naan",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998898",
                                      "name": "Cheese Kulcha",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854574"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929324",
                              "name": "Dal Fry Rice",
                              "category": "Indian Rice",
                              "description": "Dal Fry + Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/faa3a39d-eca8-4ed9-8727-fb3bb9789424_1d9a20c6-a72b-410a-b097-d0efbc70c7af.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "addons": [
                                {
                                  "groupId": "145524562",
                                  "groupName": "Extra Breads",
                                  "choices": [
                                    {
                                      "id": "115998900",
                                      "name": "Tandoori Butter Roti",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998901",
                                      "name": "Kulcha",
                                      "price": 3600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998899",
                                      "name": "Butter Naan",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998897",
                                      "name": "Lachha Paratha",
                                      "price": 5800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998902",
                                      "name": "Garlic Naan",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115998898",
                                      "name": "Cheese Kulcha",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854657"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128734391",
                              "name": "Jeera Rice",
                              "category": "Indian Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/9287a904-f41c-47fd-b1f6-a310b7664916_51af2d5a-da6d-445b-a829-523b8da77b76.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854720"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128734387",
                              "name": "Dal Makhani Rice",
                              "category": "Indian Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/29b63a8c-2dc7-42ea-96b8-81b627a299fb_151e7565-f779-45e4-bc13-c4334ea7cf67.jpg",
                              "isVeg": 1,
                              "price": 25100,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:54 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854670"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/202db6f9-fc93-4d8f-b0bd-4f025d4e0e5f_3ca41699-4271-4ea8-a0f6-e2fcf25ad13a.jpeg",
                      "categoryId": "27534779"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Thali",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929371",
                              "name": "Special Thali Parcel",
                              "category": "Thali",
                              "description": "The Meal comes with 3 Rotis, Rice, Butter Paneer Masala, Chole, Rajma, Dal Fry, Mixed Vegetables, onion salad , pickles and and Gulab Jamun",
                              "imageId": "5a9da154a1b60f7f3ace8f61d75a8292",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854898"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "137383511",
                              "name": "Mini Thali Parcel",
                              "category": "Thali",
                              "description": "The Meal comes with 2 tandoori rotis, rice, rajma, mixed vegetable, dal fry ,onion salad , pickles and and gulab jamun",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "80405389"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "5a9da154a1b60f7f3ace8f61d75a8292",
                      "categoryId": "27534784"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "South Indian",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263969",
                              "name": "Idli Sambhar",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/40aae6f5-2078-45d4-b21d-f0a8fbf63a6a_c7a158f2-0de0-4808-94a4-51d94236797c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854712"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263970",
                              "name": "Idli Vada Sambhar",
                              "category": "South Indian",
                              "description": "A combination of 1 Idly and 1 Vada served with Sambhar and Chutney",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/d019cc56-788a-4e91-985a-113a2f27fbc2_f145b95b-8d0c-4696-b3fa-7cdfac2fc780.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854715"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263971",
                              "name": "Vada Sambhar",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/4f9554a7-caec-494c-907f-30c00b7428d0_062d7bae-e9c9-4f01-87e9-d14f6cd99684.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854930"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263973",
                              "name": "Masala Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/23640a70-5911-4665-90e2-74e24d4f7090_a6f10a21-2e28-49d7-a609-aad24aac2adf.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854765"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263974",
                              "name": "Paneer Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/38cf601c-1888-400c-91f6-3c42086f9d64_379c4a62-7b6e-483e-aa1b-5485d857b2e3.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854817"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263977",
                              "name": "Paper Masala Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/f450cf1c-5dac-4c29-8346-b7a5e7ad8209_739860a8-2b9f-433e-ac53-36a3c8aff5da.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854836"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263980",
                              "name": "Veg Uttapam",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/590c082a-a7b0-46d5-9b6e-748694465fde_980760b3-c789-40ac-a07a-baaf73a9b153.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12855094"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263981",
                              "name": "Onion Uttapam",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/e6efad40-bf5a-44ee-87d6-714fc52cbde1_1e756855-ef9b-48e2-b1f3-21bbe0f684c2.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854798"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263982",
                              "name": "Tomato Uttapam",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/311077fd-d81d-44cb-8fb8-881e31535d00_46e75945-cc0c-4b0c-a5f1-be9c3eefd085.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12854927"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263983",
                              "name": "Mix Uttapam",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "2 ratings",
                                  "ratingCountV2": "2"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854782"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263984",
                              "name": "Paneer Uttapam",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12854833"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263986",
                              "name": "Bahubali Dosa",
                              "category": "South Indian",
                              "imageId": "0264d36835146f9eceeec6529bebcacc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854537"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263987",
                              "name": "Paneer Makhani Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/1bc8bc5b-d114-4add-bd08-de71661f4eee_d6dface1-906a-424b-a7fc-bbd6ff6a5dc5.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26700,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12854822"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101263989",
                              "name": "Chilli Paneer Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/432bd9aa-1b42-45aa-ad5e-8c0551d1669d_cd31db48-9761-4659-b302-75e2b6e785c4.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38400,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854606"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929364",
                              "name": "Mysore Masala Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/baa316da-1328-4138-8189-9dc342269d9b_484d500b-6ee5-4481-8aa4-01fca9db4d1a.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854794"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929366",
                              "name": "Paper Plain Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/d6a304b9-5103-44e6-a40a-a7200855d54a_55417c5e-9477-4f2e-a3cf-9e9b27a87fac.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "parentId": "12854837"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929367",
                              "name": "Plain Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/8de18e87-4d17-4572-ab45-0fb23e31a6c8_90b438b7-8165-475f-9982-e2258950a041.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "isBolt": true,
                              "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                              "parentId": "12854851"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101929369",
                              "name": "Sharma & Vishnu Special Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/8/4e725483-b71a-4129-867c-9c108e40eadd_8e48b95d-2bac-4bc1-9f40-3f225e52d470.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "1 rating",
                                  "ratingCountV2": "1"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "parentId": "12854890"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/40aae6f5-2078-45d4-b21d-f0a8fbf63a6a_c7a158f2-0de0-4808-94a4-51d94236797c.jpeg",
                      "categoryId": "27534783"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cold Coffee",
                      "categories": [
                        {
                          "title": "Cold Coffee",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929372",
                                  "name": "Cold Coffee",
                                  "category": "Cold Coffee",
                                  "description": "330 Ml- Chilled, creamy and irresistibly smooth — our classic Cold Coffee is the perfect blend of rich coffee and milk, served over ice.",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/b3d394a3-649b-4eb6-8f7f-3f512c987532_786e91ee-b8a6-477b-a43c-a9434a6b61d8.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17000,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "59 ratings",
                                      "ratingCountV2": "59"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854631"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929373",
                                  "name": "Cold Coffee With Ice Cream",
                                  "category": "Cold Coffee",
                                  "description": "330 Ml-Chilled, creamy and irresistibly smooth — our classic Cold Coffee is the perfect blend of rich coffee and milk, served over ice.",
                                  "imageId": "b9315e909f2c4e02c4d50179fb9c611f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854633"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "31641161"
                        },
                        {
                          "title": "Shake",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264001",
                                  "name": "Mango Shake",
                                  "category": "Cold Coffee",
                                  "imageId": "5a2c20ab98bef768248f15e3918bfcc7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854763"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264002",
                                  "name": "Badam Shake",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854534"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929374",
                                  "name": "Black Currant Shake",
                                  "category": "Cold Coffee",
                                  "imageId": "d6aef889654bb24f65bde1d049aac755",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854541"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929375",
                                  "name": "Chocolate Shake",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/449b8cb4-093d-4004-a1f7-77bd2c64c8ef_05b19720-43c7-4141-b4a8-779d4a7df2db.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854615"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929376",
                                  "name": "Kitkat Shake",
                                  "category": "Cold Coffee",
                                  "imageId": "1480743e65e1643cd6fdcc243f038a26",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26700,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854739"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929379",
                                  "name": "Vanilla Milkshake",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/5/4993b3c5-55b1-4779-ab8b-3ec2dd9a5ae3_50169651-76eb-404d-9ff9-44cdcafe3ea0.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854931"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929382",
                                  "name": "Pineapple Shake",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854848"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101929383",
                                  "name": "Strawberry Shake",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/14f86f70-df1c-43fe-bf67-fc59d44e41d0_540ffd25-6c12-4df5-823d-5406caf62598.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854905"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734386",
                                  "name": "Choco Chips Shake",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854613"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734393",
                                  "name": "Butterscotch Shake",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "1 rating",
                                      "ratingCountV2": "1"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854580"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "31641160"
                        },
                        {
                          "title": "Thandai",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264007",
                                  "name": "Ice Tea",
                                  "category": "Cold Coffee",
                                  "imageId": "01190d2f8a7507eea14ef4f07a6fc982",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854709"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264009",
                                  "name": "Mint Mojito",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/37278f58-cbe9-4a52-b8d7-664778a65ba9_aa88ae47-3ed2-40c7-ac92-3757ba6c86a1.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "12854777"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264011",
                                  "name": "Green Apple Soda",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854694"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101264013",
                                  "name": "Masala Lemonade",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/4/4/b0513f16-1619-409a-b15e-729316bd66a9_ae4c45d6-a003-4217-aa9d-5c5f3ddc82eb.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "2 ratings",
                                      "ratingCountV2": "2"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "parentId": "12854767"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110416000",
                                  "name": "Blue Sky Soda",
                                  "category": "Cold Coffee",
                                  "imageId": "eb35686c81c047f812aae83ab24ec5ac",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "63575745"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734380",
                                  "name": "Lime Soda",
                                  "category": "Cold Coffee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "74685789"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734395",
                                  "name": "Nimbu Pani",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/be9a9968-c9d6-48cb-a219-a5fc1c64a90a_ee0ca8b9-81c9-456b-958c-39955c2460ad.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854795"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734396",
                                  "name": "Aam Panna",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/3f7e7739-d0b2-48f0-af6b-11ef1c9d1a26_c4090e89-40b3-4616-968f-19392a55eaaa.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "isBolt": true,
                                  "boltImageId": "bolt/bolt-tag/bolt_menu_tag.png",
                                  "parentId": "74685788"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128734397",
                                  "name": "Jaljeera",
                                  "category": "Cold Coffee",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/1/28/b7894e0c-9339-4bc1-bb35-70cd22b530d7_79bda41a-b857-4969-8c7e-08a580684032.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13800,
                                  "variants": {

                                  },
                                  "variantsV2": {

                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "parentId": "12854719"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "31641163"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/2/17/b3d394a3-649b-4eb6-8f7f-3f512c987532_786e91ee-b8a6-477b-a43c-a9434a6b61d8.jpg",
                      "categoryId": "31641159"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11422010000331"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Sharma & Vishnu Fast Food - Hamidia Road",
                      "area": "Hamidia Road",
                      "completeAddress": "Revenue Survey No 449/450/2, Situated near Gurudwara And Manohar Dairy,Hamidia ROad,Ward No 18,Bhopal"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "XVqYEq7ydbLk-3xnWilrPaMiZB7bTdl8kpc62qLk"
},

  "117679":{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "Rajoriya Dk Restaurant",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "117679",
              "name": "Rajoriya Dk Restaurant",
              "city": "Bhopal",
              "slugs": {
                "restaurant": "rajoriya-restaurant-piplani-piplani",
                "city": "bhopal"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "wa3rhvxhpqghamehdtrg",
              "locality": "BHEL",
              "areaName": "BHEL",
              "costForTwo": "20000",
              "costForTwoMessage": "₹200 for two",
              "cuisines": [
                "Thali",
                "North Indian"
              ],
              "avgRating": 4.2,
              "veg": true,
              "feeDetails": {
                "restaurantId": "117679",
                "fees": [
                  {

                  }
                ]
              },
              "parentId": "165783",
              "avgRatingString": "4.2",
              "totalRatingsString": "4.8K+ ratings",
              "sla": {
                "restaurantId": "117679",
                "deliveryTime": 43,
                "minDeliveryTime": 40,
                "maxDeliveryTime": 50,
                "lastMileTravel": 7.9,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 1006,
                "slaString": "40-50 MINS",
                "lastMileTravelString": "7.9 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2026-01-07 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {

                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get every item @ 15",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 15",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT150 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 15",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT150 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {

              },
              "slugString": "rajoriya-restaurant-piplani-piplani",
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "22, Chanakyapuri, Near Minal Gate 1, J.K Road, Bhel, Bhopal"
                },
                {
                  "title": "Cuisines",
                  "message": "Thali,North Indian"
                }
              ],
              "logo": "Brand logo/RaDkRe",
              "totalRatings": 4800,
              "aggregatedDiscountInfoV2": {
                "header": "Get every item @ 15",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 15",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT150 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 15",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT150 off | Use FLATDEAL",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 7,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 99
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {

                  },
                  "movComputationType": "MOV_COMPUTATION_TYPE_DISCOUNTED_PRICE"
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/117679"
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {

                },
                "subTitle": {

                },
                "message": {

                },
                "customIcon": {

                },
                "commsStyling": {

                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {

                },
                "presentation": {

                }
              },
              "latLong": "23.26655321,77.45773736",
              "backgroundImageOverlayInfo": {

              },
              "featuredSectionInfo": {

              },
              "requestContexts": [
                "99store",
                "enable_ecosaver"
              ]
            },
            "analytics": {

            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {

              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#e4e4e4",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 20,
                    "bottom": 20
                  }
                }
              }
            },
            "id": "offerCollectionWidget",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹15",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "117679",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "526af4c8-8b59-4177-94c7-d7da9015f3ea"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLATDEAL",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "117679",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLATDEAL"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "e958dc40-b846-4748-83cb-ddc3590ad730"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT200",
                      "description": "ABOVE ₹449",
                      "offerType": "offers",
                      "restId": "117679",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE FLAT200"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹200 OFF",
                      "offerTag": "DEFAULT",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "477a44a2-fa1a-48c5-b864-6ac081d81665"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE BUMPERDEAL",
                      "description": "ABOVE ₹749",
                      "offerType": "offers",
                      "restId": "117679",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE BUMPERDEAL"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "offerIds": [
                        "febf18d0-c5b4-4e9b-8dd4-78648914fca1"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SBIDC100",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "117679",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2025/12/31/a0e7dbd0-7ae1-4cec-9600-8f7bef1d4a27_SBIMenuLogo.png",
                      "descriptionTextColor": "#7302060C",
                      "primaryDescription": "USE SBIDC100"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {

                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {

                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuTab",
            "tabs": [
              {
                "id": "REGULAR",
                "title": "Full Menu",
                "selected": true,
                "analytics": {

                },
                "selectedImage": "v1594205104/fullMenuActive_qcsdzt.png",
                "unselectedImage": "v1594205107/fullMenuInactive_fbdtp2.png"
              }
            ]
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {

                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "7700036",
                          "creativeId": "TopPicks2024/93033421F.png",
                          "title": "DK Speial Thali",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93033421",
                              "name": "DK Speial Thali",
                              "category": "Thali",
                              "description": "Today special paneer , tava veg, dal tadka, veg briyani, 5 tava butter, 1 lacha paratha ya 1 butter naan , rayta ,papad ,rayta, salad, sweet",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/875d52c9-c820-4981-a790-7a50bf327d2d_39b12e72-1594-4858-a807-41001d0e974e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026749"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "6447781",
                          "creativeId": "TopPicks2024/93033422F.png",
                          "title": "Special Thali",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93033422",
                              "name": "Special Thali",
                              "category": "Thali",
                              "description": "Butter Paneer Masala+Mix Veg+Butter Dal Fry+Jeera Rice+5 Butter Roti+Papad+Sweet+Raita+Salad",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/6e4c132c-78e6-45c3-bef5-d221a7714290_c3f7e7b1-e668-422d-96db-f61e9b60052f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "51026805"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "4860597",
                          "creativeId": "TopPicks2024/93033424D.png",
                          "title": "Chole With 2 Lachha Paratha",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93033424",
                              "name": "Chole With 2 Lachha Paratha",
                              "category": "Rice Combo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/12ccf4ad-c727-48fb-94b7-b0b41f646744_640bfb2d-1a9b-48a2-a70e-1fc91787dae9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "51026745"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "4860455",
                          "creativeId": "TopPicks2024/93033419D.png",
                          "title": "Chole Bhature",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93033419",
                              "name": "Chole Bhature",
                              "category": "Thali",
                              "imageId": "eae4adaa6f513c52536089a7aaf86fec",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "itemPriceStrikeOff": true,
                              "parentId": "51026740"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "4860873",
                          "creativeId": "TopPicks2024/93033430D.png",
                          "title": "Chana Roasted",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "93033430",
                              "name": "Chana Roasted",
                              "category": "Starter",
                              "imageId": "37525a62e676420d36e852b8142a4991",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026739"
                            },
                            "analytics": {

                            },
                            "restaurant": {
                              "info": {
                                "dishStyle": {
                                  "socialMarkerStyle": [
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_HIGH_PROTEIN",
                                      "title": "Protein Rich",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "brand_proteinator_primary"
                                    },
                                    {
                                      "socialMarkerType": "SOCIAL_MARKER_TYPE_BESTSELLER",
                                      "title": "Bestseller",
                                      "textStyle": "FONT_NAME_V2_BODY3_NEUTRAL_BOLD",
                                      "textColor": "color_swiggy_one"
                                    }
                                  ]
                                }
                              }
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033420",
                              "name": "Deluxe Thali",
                              "category": "Thali",
                              "description": "Paneer Masala+Seasonal Veg+Dal+Jeera Rice+5 Butter Roti+Raita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/4e1d2c86-c973-4cb2-b900-2277c4e1387b_0066170f-2b3c-4b60-87dd-f5b047efbb0e.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1418 ratings",
                                  "ratingCountV2": "1.4K+"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e1bc1d04-ed1a-4bfb-869b-05a654592266"
                              ],
                              "parentId": "51026748"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033422",
                              "name": "Special Thali",
                              "category": "Thali",
                              "description": "Butter Paneer Masala+Mix Veg+Butter Dal Fry+Jeera Rice+5 Butter Roti+Papad+Sweet+Raita+Salad",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/6e4c132c-78e6-45c3-bef5-d221a7714290_c3f7e7b1-e668-422d-96db-f61e9b60052f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "665 ratings",
                                  "ratingCountV2": "665"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026805"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765555",
                              "name": "Butter Khichdi",
                              "category": "Rice Combo",
                              "imageId": "4d9b4b993bfba9be88cc81e75dd52a0c",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849384",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785403",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785404",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849384",
                                        "variationId": "52785403"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849384",
                                        "variationId": "52785404"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "202 ratings",
                                  "ratingCountV2": "202"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765588",
                              "name": "Sev Tamatar",
                              "category": "Main Course",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/99068283-82bf-48b7-9041-5a3201a0fb9a_4cbf2c13-1f25-4eb3-b835-34e8c7a592ba.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849425",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 119,
                                        "default": 1,
                                        "id": "52785487",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 189,
                                        "id": "52785488",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849425",
                                        "variationId": "52785487"
                                      }
                                    ],
                                    "price": 11900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849425",
                                        "variationId": "52785488"
                                      }
                                    ],
                                    "price": 18900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "191 ratings",
                                  "ratingCountV2": "191"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350094"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033491",
                              "name": "Kadhai Paneer",
                              "category": "Main Course",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/422bc575-8f16-42bb-87b9-350942d6b484_3561fd6c-952b-4264-a23d-5ce29b9382c7.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849429",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 169,
                                        "default": 1,
                                        "id": "52785495",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 249,
                                        "id": "52785496",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849429",
                                        "variationId": "52785495"
                                      }
                                    ],
                                    "price": 16900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849429",
                                        "variationId": "52785496"
                                      }
                                    ],
                                    "price": 24900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "182 ratings",
                                  "ratingCountV2": "182"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026761"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765559",
                              "name": "Dal Tadka",
                              "category": "Main Course",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/f4ed2a2e-7d6a-4070-aa0b-672c4274cfa4_e60c5b7a-b604-4a22-8667-58c438d8b093.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 6500,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849464",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 99,
                                        "default": 1,
                                        "id": "52785571",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 149,
                                        "id": "52785572",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849464",
                                        "variationId": "52785571"
                                      }
                                    ],
                                    "price": 9900,
                                    "finalPrice": {
                                      "units": "65"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849464",
                                        "variationId": "52785572"
                                      }
                                    ],
                                    "price": 14900,
                                    "finalPrice": {
                                      "units": "115"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "155 ratings",
                                  "ratingCountV2": "155"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "746e4d69-a359-43f3-86a6-6b209e055760"
                              ],
                              "parentId": "10350052"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765570",
                              "name": "Tawa Roti",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/70b80126-af19-4aae-b8ee-1c885f474926_d65a7ec3-2661-41b9-9241-5856d843777c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "627 ratings",
                                  "ratingCountV2": "627"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350099"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033444",
                              "name": "Butter Naan",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/ac8ec331-cca0-4f85-bb66-51a35f51f5e8_17e428ac-b220-4e7c-a532-06283c3e2753.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026737"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033450",
                              "name": "Tandoori Aloo Paratha",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/fdd7ddd8-e7f5-4d1c-9e20-5fdc51bfdd7f_b65ef8a6-39e5-4111-a0ee-285c538111d1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "120 ratings",
                                  "ratingCountV2": "120"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026808"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765624",
                              "name": "Veg Biryani",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/5fc2e7c1-7f46-498f-b4bc-3f1a877d720f_82319255-4a25-4e2a-bf5a-44f9447b25c3.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849400",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785435",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785436",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849400",
                                        "variationId": "52785435"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849400",
                                        "variationId": "52785436"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "showImage": true,
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350100"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED",
                      "subtitleSuffix": {

                      },
                      "categoryId": "-1"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Main Course",
                      "categories": [
                        {
                          "title": "Paneer Main Course",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033491",
                                  "name": "Kadhai Paneer",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/422bc575-8f16-42bb-87b9-350942d6b484_3561fd6c-952b-4264-a23d-5ce29b9382c7.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849429",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785495",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785496",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849429",
                                            "variationId": "52785495"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849429",
                                            "variationId": "52785496"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "182 ratings",
                                      "ratingCountV2": "182"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026761"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765601",
                                  "name": "Paneer Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/3ca41eb4-d445-432d-b66b-d2571a1514e5_8f8bd17d-4230-4656-bfb4-e731e6c22b4f.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849449",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 149,
                                            "default": 1,
                                            "id": "52785538",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785539",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849449",
                                            "variationId": "52785538"
                                          }
                                        ],
                                        "price": 14900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849449",
                                            "variationId": "52785539"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "72 ratings",
                                      "ratingCountV2": "72"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350077"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033498",
                                  "name": "Paneer Angara",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/0c147dd9-2498-468b-bc21-295b0baafa9e_ef981e66-8e6e-4f24-ac61-100a6e86506b.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849440",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785519",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785520",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849440",
                                            "variationId": "52785519"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849440",
                                            "variationId": "52785520"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "52 ratings",
                                      "ratingCountV2": "52"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026780"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765605",
                                  "name": "Shahi Paneer",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/49dcab09-7ff9-4fa6-a2a0-f50640d22025_b6b3d32d-97a8-4017-8563-a6224602e648.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849455",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785550",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785551",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849455",
                                            "variationId": "52785550"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849455",
                                            "variationId": "52785551"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "58 ratings",
                                      "ratingCountV2": "58"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350095"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033503",
                                  "name": "Paneer Kolhapuri",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/25e76473-2915-4cd7-9178-f9bc21c38c77_6fa6ba63-3a08-4762-911f-e70c90886fe3.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849445",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 159,
                                            "default": 1,
                                            "id": "52785529",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785530",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849445",
                                            "variationId": "52785529"
                                          }
                                        ],
                                        "price": 15900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849445",
                                            "variationId": "52785530"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 15900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "38 ratings",
                                      "ratingCountV2": "38"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026788"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765606",
                                  "name": "Punjabi Paneer",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/1536d16e-5e06-40b4-9fa4-e0a1db8cb005_a43cb1e2-5266-4427-957d-9e01b0886416.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849453",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785546",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785547",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849453",
                                            "variationId": "52785546"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849453",
                                            "variationId": "52785547"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "75 ratings",
                                      "ratingCountV2": "75"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350086"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033493",
                                  "name": "Kaju Matar Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849433",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785504",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 269,
                                            "id": "52785505",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849433",
                                            "variationId": "52785504"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849433",
                                            "variationId": "52785505"
                                          }
                                        ],
                                        "price": 26900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026763"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765618",
                                  "name": "Kaju Paneer Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/65c9ea76-ee51-4609-8928-c0d0a3e7d768_3d25ae0d-f2b0-4f89-ac3f-80815dec8afa.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849434",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785506",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 269,
                                            "id": "52785507",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849434",
                                            "variationId": "52785506"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849434",
                                            "variationId": "52785507"
                                          }
                                        ],
                                        "price": 26900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350064"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033505",
                                  "name": "Paneer Korma",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849447",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785534",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785535",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849447",
                                            "variationId": "52785534"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849447",
                                            "variationId": "52785535"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026789"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033499",
                                  "name": "Paneer Bhurji",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849441",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785521",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 259,
                                            "id": "52785522",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849441",
                                            "variationId": "52785521"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849441",
                                            "variationId": "52785522"
                                          }
                                        ],
                                        "price": 25900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026781"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765615",
                                  "name": "Kaju Curry",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/3fd821b9-2cbd-4e8d-ad61-a63cf25e8086_645c1665-ab1b-44e1-a90c-538237ddac96.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849431",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785500",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 269,
                                            "id": "52785501",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849431",
                                            "variationId": "52785500"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849431",
                                            "variationId": "52785501"
                                          }
                                        ],
                                        "price": 26900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350061"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033497",
                                  "name": "Mutter Paneer",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849438",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 159,
                                            "default": 1,
                                            "id": "52785515",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785516",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849438",
                                            "variationId": "52785515"
                                          }
                                        ],
                                        "price": 15900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849438",
                                            "variationId": "52785516"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 15900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "59 ratings",
                                      "ratingCountV2": "59"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026776"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765616",
                                  "name": "Kaju Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/5aa87df2-614d-4907-8f6a-83e273e48c6d_d10f0be4-2bd2-4130-839e-7d8dca079451.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849432",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785502",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 269,
                                            "id": "52785503",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849432",
                                            "variationId": "52785502"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849432",
                                            "variationId": "52785503"
                                          }
                                        ],
                                        "price": 26900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350062"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033506",
                                  "name": "Paneer Lachha",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849448",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785536",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785537",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849448",
                                            "variationId": "52785536"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849448",
                                            "variationId": "52785537"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026790"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033490",
                                  "name": "Chole Paneer",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849428",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 159,
                                            "default": 1,
                                            "id": "52785493",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785494",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849428",
                                            "variationId": "52785493"
                                          }
                                        ],
                                        "price": 15900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849428",
                                            "variationId": "52785494"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 15900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026744"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033495",
                                  "name": "Mushroom Paneer",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/1d55a807-9c27-436a-a092-b0fa14e8b0a9_df54b425-dd26-4cdd-ba8a-0b664eed13d4.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849436",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785510",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785511",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849436",
                                            "variationId": "52785510"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849436",
                                            "variationId": "52785511"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026774"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765608",
                                  "name": "Paneer Tikka Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849452",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785544",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 269,
                                            "id": "52785545",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849452",
                                            "variationId": "52785544"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849452",
                                            "variationId": "52785545"
                                          }
                                        ],
                                        "price": 26900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350080"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033502",
                                  "name": "Paneer Hyderabadi",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849444",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 179,
                                            "default": 1,
                                            "id": "52785527",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 299,
                                            "id": "52785528",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849444",
                                            "variationId": "52785527"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849444",
                                            "variationId": "52785528"
                                          }
                                        ],
                                        "price": 29900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026787"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765604",
                                  "name": "Palak Paneer",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849439",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785517",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785518",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849439",
                                            "variationId": "52785517"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849439",
                                            "variationId": "52785518"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.5",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350074"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033501",
                                  "name": "Paneer Do Pyaza",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849443",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 159,
                                            "default": 1,
                                            "id": "52785525",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785526",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849443",
                                            "variationId": "52785525"
                                          }
                                        ],
                                        "price": 15900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849443",
                                            "variationId": "52785526"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 15900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026784"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033508",
                                  "name": "Paneer Silbatta",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849451",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785542",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785543",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849451",
                                            "variationId": "52785542"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849451",
                                            "variationId": "52785543"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026794"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033509",
                                  "name": "Rajma Paneer",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849454",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 159,
                                            "default": 1,
                                            "id": "52785548",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785549",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849454",
                                            "variationId": "52785548"
                                          }
                                        ],
                                        "price": 15900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849454",
                                            "variationId": "52785549"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 15900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026804"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033494",
                                  "name": "Paneer Methi Malai",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849435",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 179,
                                            "default": 1,
                                            "id": "52785508",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 259,
                                            "id": "52785509",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849435",
                                            "variationId": "52785508"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849435",
                                            "variationId": "52785509"
                                          }
                                        ],
                                        "price": 25900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026791"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765614",
                                  "name": "Paneer Pasanda",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849450",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 199,
                                            "default": 1,
                                            "id": "52785540",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 299,
                                            "id": "52785541",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849450",
                                            "variationId": "52785540"
                                          }
                                        ],
                                        "price": 19900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849450",
                                            "variationId": "52785541"
                                          }
                                        ],
                                        "price": 29900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 19900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350079"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033500",
                                  "name": "Paneer Dhaba",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849442",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785523",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 249,
                                            "id": "52785524",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849442",
                                            "variationId": "52785523"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849442",
                                            "variationId": "52785524"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026783"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23173043"
                        },
                        {
                          "title": "Hari Sabji",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765588",
                                  "name": "Sev Tamatar",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/99068283-82bf-48b7-9041-5a3201a0fb9a_4cbf2c13-1f25-4eb3-b835-34e8c7a592ba.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849425",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785487",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785488",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849425",
                                            "variationId": "52785487"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849425",
                                            "variationId": "52785488"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "191 ratings",
                                      "ratingCountV2": "191"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350094"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765620",
                                  "name": "Mushroom Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/52eecc59-719b-44ca-b633-30b3eab94347_341628cd-c0d4-428a-a005-2b7c8a8fa2ae.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849418",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 149,
                                            "default": 1,
                                            "id": "52785472",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 199,
                                            "id": "52785473",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849418",
                                            "variationId": "52785472"
                                          }
                                        ],
                                        "price": 14900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849418",
                                            "variationId": "52785473"
                                          }
                                        ],
                                        "price": 19900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "54 ratings",
                                      "ratingCountV2": "54"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350072"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765569",
                                  "name": "Bhindi Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/73ec6905-34ef-4907-8f5a-a35c9569c5cd_f995e420-8166-40cc-920d-d94c41541dbc.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849409",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785453",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785454",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849409",
                                            "variationId": "52785453"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849409",
                                            "variationId": "52785454"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "47 ratings",
                                      "ratingCountV2": "47"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350040"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033485",
                                  "name": "Mix Veg",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/13e85458-fc7c-4ef5-bd72-980419902d36_27115056-3351-4051-a818-c9668242e95a.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849417",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785470",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785471",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849417",
                                            "variationId": "52785470"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849417",
                                            "variationId": "52785471"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "102 ratings",
                                      "ratingCountV2": "102"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026772"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765586",
                                  "name": "Dum Aloo",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/9b3dc080-6963-4fb6-b294-0ae1953d9a4e_4101d73c-c424-489d-ad79-bab684cc6c10.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849411",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 149,
                                            "default": 1,
                                            "id": "52785457",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 199,
                                            "id": "52785458",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849411",
                                            "variationId": "52785457"
                                          }
                                        ],
                                        "price": 14900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849411",
                                            "variationId": "52785458"
                                          }
                                        ],
                                        "price": 19900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350054"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033486",
                                  "name": "Mushroom Matar",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849419",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 149,
                                            "default": 1,
                                            "id": "52785474",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 199,
                                            "id": "52785475",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849419",
                                            "variationId": "52785474"
                                          }
                                        ],
                                        "price": 14900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849419",
                                            "variationId": "52785475"
                                          }
                                        ],
                                        "price": 19900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026773"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033487",
                                  "name": "Punjabi Chole",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849420",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 139,
                                            "default": 1,
                                            "id": "52785476",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785477",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849420",
                                            "variationId": "52785476"
                                          }
                                        ],
                                        "price": 13900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849420",
                                            "variationId": "52785477"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026802"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765599",
                                  "name": "Baingan Bharta",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849407",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785449",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785450",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849407",
                                            "variationId": "52785449"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849407",
                                            "variationId": "52785450"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350037"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033476",
                                  "name": "Aloo Chole",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/eaeb592d-daef-4bb7-ac10-343717b755f5_ed2d2bf6-2930-4c9b-80b9-dcd05a75304c.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849402",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785439",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785440",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849402",
                                            "variationId": "52785439"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849402",
                                            "variationId": "52785440"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026733"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033483",
                                  "name": "Kadi Pakoda",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849414",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 129,
                                            "default": 1,
                                            "id": "52785466",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785467",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849414",
                                            "variationId": "52785466"
                                          }
                                        ],
                                        "price": 12900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849414",
                                            "variationId": "52785467"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026762"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765583",
                                  "name": "Aloo Jeera",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/0eafbaeb-b2b7-4a77-9703-70c7f7c167f4_ae723732-d400-4e35-9e41-34ae6c937c29.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849404",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785443",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785444",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849404",
                                            "variationId": "52785443"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849404",
                                            "variationId": "52785444"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350036"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765592",
                                  "name": "Sev Bhaji",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/93ed3c45-c5fb-4a74-a724-c56fdca64cb9_b3fd6ae5-540b-4c8f-b17b-c65c6729a812.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849423",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785483",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785484",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849423",
                                            "variationId": "52785483"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849423",
                                            "variationId": "52785484"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "43 ratings",
                                      "ratingCountV2": "43"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350092"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033484",
                                  "name": "Matar Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/1bc9f3b7-230c-4d33-95fd-513141d2d8fb_f4da1562-7ba3-4283-8b06-5ad4709c2716.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849416",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785468",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785469",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849416",
                                            "variationId": "52785468"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849416",
                                            "variationId": "52785469"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026768"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765600",
                                  "name": "Bhindi Kurkuri",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849408",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 129,
                                            "default": 1,
                                            "id": "52785451",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785452",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849408",
                                            "variationId": "52785451"
                                          }
                                        ],
                                        "price": 12900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849408",
                                            "variationId": "52785452"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350039"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033477",
                                  "name": "Aloo Gobhi",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849403",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785441",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785442",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849403",
                                            "variationId": "52785441"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849403",
                                            "variationId": "52785442"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026734"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765591",
                                  "name": "Sev Masala",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/e47e5089-7caf-4f20-aedf-c075452a8af9_d0c81b81-3158-45da-a5d5-1d53104fddaf.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849424",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785485",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785486",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849424",
                                            "variationId": "52785485"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849424",
                                            "variationId": "52785486"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350093"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033481",
                                  "name": "Gobhi Matar",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849413",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785461",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785462",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849413",
                                            "variationId": "52785461"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849413",
                                            "variationId": "52785462"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026757"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033479",
                                  "name": "Aloo Matar",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849406",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785447",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785448",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849406",
                                            "variationId": "52785447"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849406",
                                            "variationId": "52785448"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026736"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765595",
                                  "name": "Rajma Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849421",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 129,
                                            "default": 1,
                                            "id": "52785478",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785479",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849421",
                                            "variationId": "52785478"
                                          }
                                        ],
                                        "price": 12900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849421",
                                            "variationId": "52785479"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#FFF0CD",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_low",
                                      "ratingTextColor": "rating_low",
                                      "ratingCountTextColor": "rating_low",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350087"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765572",
                                  "name": "Chana Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849410",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785455",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785456",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849410",
                                            "variationId": "52785455"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849410",
                                            "variationId": "52785456"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350044"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033480",
                                  "name": "Gobhi Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849412",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785459",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785460",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849412",
                                            "variationId": "52785459"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849412",
                                            "variationId": "52785460"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026756"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765578",
                                  "name": "Tamatar Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849426",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785489",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785490",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849426",
                                            "variationId": "52785489"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849426",
                                            "variationId": "52785490"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350097"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033478",
                                  "name": "Aloo Masala",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849405",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785445",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 189,
                                            "id": "52785446",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849405",
                                            "variationId": "52785445"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849405",
                                            "variationId": "52785446"
                                          }
                                        ],
                                        "price": 18900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026735"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23173042"
                        },
                        {
                          "title": "Kofta Main Course",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765612",
                                  "name": "Malai Kofta",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/fde795d8-bced-467e-adb2-eab3ca1eb734_78391356-8273-4439-9205-4c08c2dd3655.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849456",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785552",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 259,
                                            "id": "52785553",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849456",
                                            "variationId": "52785552"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849456",
                                            "variationId": "52785553"
                                          }
                                        ],
                                        "price": 25900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350066"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765613",
                                  "name": "Paneer Kofta",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/fc62392f-21c5-4200-8235-d141649936d9_02d3b847-7806-4322-a896-829f0b1c964e.jpg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849457",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 189,
                                            "default": 1,
                                            "id": "52785554",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 259,
                                            "id": "52785557",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849457",
                                            "variationId": "52785554"
                                          }
                                        ],
                                        "price": 18900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849457",
                                            "variationId": "52785557"
                                          }
                                        ],
                                        "price": 25900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350076"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93033510",
                                  "name": "Stuffed Tomato",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849458",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785559",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785560",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849458",
                                            "variationId": "52785559"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849458",
                                            "variationId": "52785560"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {

                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "51026807"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765596",
                                  "name": "Veg Kofta",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849459",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 169,
                                            "default": 1,
                                            "id": "52785561",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 239,
                                            "id": "52785562",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849459",
                                            "variationId": "52785561"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849459",
                                            "variationId": "52785562"
                                          }
                                        ],
                                        "price": 23900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350103"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23173044"
                        },
                        {
                          "title": "Dal",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765559",
                                  "name": "Dal Tadka",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/f4ed2a2e-7d6a-4070-aa0b-672c4274cfa4_e60c5b7a-b604-4a22-8667-58c438d8b093.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "finalPrice": 6500,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849464",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 99,
                                            "default": 1,
                                            "id": "52785571",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 149,
                                            "id": "52785572",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849464",
                                            "variationId": "52785571"
                                          }
                                        ],
                                        "price": 9900,
                                        "finalPrice": {
                                          "units": "65"
                                        }
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849464",
                                            "variationId": "52785572"
                                          }
                                        ],
                                        "price": 14900,
                                        "finalPrice": {
                                          "units": "115"
                                        }
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      "matchText": "SILD"
                                    }
                                  ],
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "155 ratings",
                                      "ratingCountV2": "155"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "offerIds": [
                                    "746e4d69-a359-43f3-86a6-6b209e055760"
                                  ],
                                  "parentId": "10350052"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765561",
                                  "name": "Dal Makhani",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/d35fcfb1-0b7f-4963-a9f6-8822de339b97_6b53188f-df9a-4f64-bddd-1deab98e3a78.jpg_compressed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849463",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 119,
                                            "default": 1,
                                            "id": "52785569",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 159,
                                            "id": "52785570",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849463",
                                            "variationId": "52785569"
                                          }
                                        ],
                                        "price": 11900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849463",
                                            "variationId": "52785570"
                                          }
                                        ],
                                        "price": 15900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 11900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "36 ratings",
                                      "ratingCountV2": "36"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350051"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765554",
                                  "name": "Dal Fry",
                                  "category": "Main Course",
                                  "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/698011f1-56c9-49bc-afab-032f7a3d9efa_f43b498f-20f6-4c3a-a17f-e1964baf7426.jpeg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849460",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 99,
                                            "default": 1,
                                            "id": "52785563",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 149,
                                            "id": "52785564",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849460",
                                            "variationId": "52785563"
                                          }
                                        ],
                                        "price": 9900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849460",
                                            "variationId": "52785564"
                                          }
                                        ],
                                        "price": 14900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 9900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "73 ratings",
                                      "ratingCountV2": "73"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#C8F9E5",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_very_good",
                                      "ratingTextColor": "rating_very_good",
                                      "ratingCountTextColor": "rating_very_good",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350049"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31765563",
                                  "name": "Dal Hari Mirch",
                                  "category": "Main Course",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {

                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "15849461",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Half",
                                            "price": 109,
                                            "default": 1,
                                            "id": "52785565",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Full",
                                            "price": 149,
                                            "id": "52785566",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849461",
                                            "variationId": "52785565"
                                          }
                                        ],
                                        "price": 10900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "15849461",
                                            "variationId": "52785566"
                                          }
                                        ],
                                        "price": 14900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 10900,
                                  "ribbon": {

                                  },
                                  "type": "ITEM",
                                  "itemBadge": {

                                  },
                                  "badgesV2": {

                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    },
                                    "ratingsPresentationConfig": {
                                      "bgGradient": {
                                        "colours": [
                                          "#D9EFEC",
                                          "#00FFFFFF"
                                        ],
                                        "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                      },
                                      "ratingIconColor": "rating_medium",
                                      "ratingTextColor": "rating_medium",
                                      "ratingCountTextColor": "rating_medium",
                                      "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                      "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                    }
                                  },
                                  "itemPriceStrikeOff": true,
                                  "parentId": "10350050"
                                },
                                "analytics": {

                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ],
                          "subtitleSuffix": {

                          },
                          "categoryId": "23173045"
                        }
                      ],
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/99068283-82bf-48b7-9041-5a3201a0fb9a_4cbf2c13-1f25-4eb3-b835-34e8c7a592ba.jpg_compressed",
                      "categoryId": "23173041"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Thali",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033420",
                              "name": "Deluxe Thali",
                              "category": "Thali",
                              "description": "Paneer Masala+Seasonal Veg+Dal+Jeera Rice+5 Butter Roti+Raita",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/4e1d2c86-c973-4cb2-b900-2277c4e1387b_0066170f-2b3c-4b60-87dd-f5b047efbb0e.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1418 ratings",
                                  "ratingCountV2": "1.4K+"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "e1bc1d04-ed1a-4bfb-869b-05a654592266"
                              ],
                              "parentId": "51026748"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033422",
                              "name": "Special Thali",
                              "category": "Thali",
                              "description": "Butter Paneer Masala+Mix Veg+Butter Dal Fry+Jeera Rice+5 Butter Roti+Papad+Sweet+Raita+Salad",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/6e4c132c-78e6-45c3-bef5-d221a7714290_c3f7e7b1-e668-422d-96db-f61e9b60052f.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "665 ratings",
                                  "ratingCountV2": "665"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026805"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033421",
                              "name": "DK Speial Thali",
                              "category": "Thali",
                              "description": "Today special paneer , tava veg, dal tadka, veg briyani, 5 tava butter, 1 lacha paratha ya 1 butter naan , rayta ,papad ,rayta, salad, sweet",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/875d52c9-c820-4981-a790-7a50bf327d2d_39b12e72-1594-4858-a807-41001d0e974e.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "129 ratings",
                                  "ratingCountV2": "129"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026749"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033419",
                              "name": "Chole Bhature",
                              "category": "Thali",
                              "imageId": "eae4adaa6f513c52536089a7aaf86fec",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026740"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/4e1d2c86-c973-4cb2-b900-2277c4e1387b_0066170f-2b3c-4b60-87dd-f5b047efbb0e.JPG",
                      "categoryId": "23173031"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bread",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765570",
                              "name": "Tawa Roti",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/70b80126-af19-4aae-b8ee-1c885f474926_d65a7ec3-2661-41b9-9241-5856d843777c.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1800,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "627 ratings",
                                  "ratingCountV2": "627"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350099"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033444",
                              "name": "Butter Naan",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/ac8ec331-cca0-4f85-bb66-51a35f51f5e8_17e428ac-b220-4e7c-a532-06283c3e2753.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "183 ratings",
                                  "ratingCountV2": "183"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026737"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033442",
                              "name": "2 Paneer Kulcha",
                              "category": "Bread",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026731"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033451",
                              "name": "Tandoori Butter Roti",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/36988d47-d514-424e-ad93-8bef58a361ae_df51bf85-c4a6-4f89-9a4c-5c92e7306eb1.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "106 ratings",
                                  "ratingCountV2": "106"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026809"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033452",
                              "name": "Tandoori Paneer Paratha",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/bdba0fe5-0063-46a9-815b-8b124cf0f80a_110b2fd5-51f9-4a66-b39d-aaca3e60f0d3.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "finalPrice": 3900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "404695af-e410-48c9-9f7e-c7544946fe41"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51026810"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033450",
                              "name": "Tandoori Aloo Paratha",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/fdd7ddd8-e7f5-4d1c-9e20-5fdc51bfdd7f_b65ef8a6-39e5-4111-a0ee-285c538111d1.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "120 ratings",
                                  "ratingCountV2": "120"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026808"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033443",
                              "name": "2 Paneer Lachha Paratha",
                              "category": "Bread",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026732"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765571",
                              "name": "Tawa Butter Roti",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/97f073e5-2679-46de-baa8-97948b07b615_23222e72-9b46-4e86-b112-e6373588dfae.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2200,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "212 ratings",
                                  "ratingCountV2": "212"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350098"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033445",
                              "name": "Garlic Naan",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/235e16c1-2742-47af-8375-b1e45ae2ce99_9b6ec624-fa95-4a4f-ba8f-0002ced74264.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026755"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033447",
                              "name": "Missi Roti",
                              "category": "Bread",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026770"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033453",
                              "name": "Tandoori Roti",
                              "category": "Bread",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/69d3ac40-e404-4dbe-ba48-b0695b4bdafd_6106dd2c-4777-4c5c-9107-61062f7b865b.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026812"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033446",
                              "name": "Lachha Paratha",
                              "category": "Bread",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026764"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033448",
                              "name": "Naan Plain",
                              "category": "Bread",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026777"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/70b80126-af19-4aae-b8ee-1c885f474926_d65a7ec3-2661-41b9-9241-5856d843777c.jpeg",
                      "categoryId": "23173035"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765624",
                              "name": "Veg Biryani",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/5fc2e7c1-7f46-498f-b4bc-3f1a877d720f_82319255-4a25-4e2a-bf5a-44f9447b25c3.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849400",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785435",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785436",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849400",
                                        "variationId": "52785435"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849400",
                                        "variationId": "52785436"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350100"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765621",
                              "name": "Jeera Rice",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/542518b2-11a1-4edd-bfc9-707931412bc8_6a2e3831-e3f9-48c7-85a1-a61b85087901.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849393",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785421",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 119,
                                        "id": "52785422",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849393",
                                        "variationId": "52785421"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849393",
                                        "variationId": "52785422"
                                      }
                                    ],
                                    "price": 11900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350058"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033455",
                              "name": "Dum Biryani",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/5/11/b054c37a-9497-4e1e-aaea-77c48c309bdd_196a414a-0742-4d8b-ad5c-eab80c9dc837.jpg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849391",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785417",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785418",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849391",
                                        "variationId": "52785417"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849391",
                                        "variationId": "52785418"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026751"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765623",
                              "name": "Masala Rice",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/2901023a-7a60-42b0-bbab-496b65e0982c_ef7662c5-72f1-443d-83ec-7082714625f2.JPG",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 3900,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849394",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785423",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785424",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849394",
                                        "variationId": "52785423"
                                      }
                                    ],
                                    "price": 7900,
                                    "finalPrice": {
                                      "units": "39"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849394",
                                        "variationId": "52785424"
                                      }
                                    ],
                                    "price": 12900,
                                    "finalPrice": {
                                      "units": "89"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "404695af-e410-48c9-9f7e-c7544946fe41"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "10350067"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033457",
                              "name": "Matar Pulao",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/a27b814b-03a5-49c2-9752-a84ab315c702_bac6b083-4b61-4aab-8aa3-0844a0e68d44.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849395",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785425",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785426",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849395",
                                        "variationId": "52785425"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849395",
                                        "variationId": "52785426"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026769"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033459",
                              "name": "Paneer Pulao",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/82d674da-5c1d-4ea0-b6f2-ef960f442b92_ec2f57fe-3a78-4580-89aa-1b7b0a4ce3cb.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849397",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785429",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 139,
                                        "id": "52785430",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849397",
                                        "variationId": "52785429"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849397",
                                        "variationId": "52785430"
                                      }
                                    ],
                                    "price": 13900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026793"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033458",
                              "name": "Paneer Fried Rice",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/6aee98c9-cc62-4c3d-aa39-67b9f517fe29_212dedc6-6215-401d-86da-b5cde1bec34c.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849396",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785427",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 139,
                                        "id": "52785428",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849396",
                                        "variationId": "52785427"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849396",
                                        "variationId": "52785428"
                                      }
                                    ],
                                    "price": 13900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026786"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033456",
                              "name": "Fried Rice",
                              "category": "Rice",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849392",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785419",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785420",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849392",
                                        "variationId": "52785419"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849392",
                                        "variationId": "52785420"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026753"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033461",
                              "name": "Steam Rice",
                              "category": "Rice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/c9003c12-a43f-40a8-80ad-693a969e5703_04516f46-367a-464d-8b88-48466fbbd92f.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849399",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 69,
                                        "default": 1,
                                        "id": "52785433",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 119,
                                        "id": "52785434",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849399",
                                        "variationId": "52785433"
                                      }
                                    ],
                                    "price": 6900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849399",
                                        "variationId": "52785434"
                                      }
                                    ],
                                    "price": 11900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 6900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026806"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033460",
                              "name": "Paneer Soya Rice",
                              "category": "Rice",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849398",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785431",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 139,
                                        "id": "52785432",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849398",
                                        "variationId": "52785431"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849398",
                                        "variationId": "52785432"
                                      }
                                    ],
                                    "price": 13900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026795"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765625",
                              "name": "Veg Pulao",
                              "category": "Rice",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849401",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785437",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785438",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849401",
                                        "variationId": "52785437"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849401",
                                        "variationId": "52785438"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350106"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033454",
                              "name": "Butter Pulao",
                              "category": "Rice",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849390",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785415",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785416",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849390",
                                        "variationId": "52785415"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849390",
                                        "variationId": "52785416"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026738"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/5fc2e7c1-7f46-498f-b4bc-3f1a877d720f_82319255-4a25-4e2a-bf5a-44f9447b25c3.jpg_compressed",
                      "categoryId": "23173036"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "South Indian",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "164744606",
                              "name": "Dk Special Uttappam",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "99171745"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033466",
                              "name": "Masala Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/b2f9403d-2405-4c14-bca4-e1dc173fae82_3b70deb2-e225-4aca-8445-e3a77414defd.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026766"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033468",
                              "name": "Paneer Dosa",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026785"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033469",
                              "name": "Paneer Uttappam",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026796"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033472",
                              "name": "Tomato Uttappam",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/f84a8ec6-4d81-4ec6-b85f-1ad2391c96c8_9ba0a8ce-c3ec-498c-ab1c-13b28e6d9c75.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026813"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765574",
                              "name": "Idli Fry",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350056"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "164744607",
                              "name": "Tawa Veg Dosa",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "99171749"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033471",
                              "name": "Plain Uttappam",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026801"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033470",
                              "name": "Plain Dosa",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/64ec91be-f067-44a7-b9c2-65794b3bd79a_0f517de0-8e11-45f1-acfe-75fb25eab645.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "imageBadges": [
                                {
                                  "imageId": "Low%20cal/Low%20cal%201_1.png"
                                }
                              ],
                              "parentId": "51026799"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "164744605",
                              "name": "Butter Plain Dosa",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "99171744"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033465",
                              "name": "Idli Sambhar",
                              "category": "South Indian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026760"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033473",
                              "name": "Vada Sambhar",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/848388d5-6be1-4080-beea-4dc2a9f742d3_c5cff254-bb93-4d8c-8caf-dbcca57b6cf0.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026814"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033467",
                              "name": "Onion Uttappam",
                              "category": "South Indian",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/907b0843-9eb4-4fb9-9c7e-b870833a198b_9e0603b0-d4ab-48d9-9b13-2afa25b1799b.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026779"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/b2f9403d-2405-4c14-bca4-e1dc173fae82_3b70deb2-e225-4aca-8445-e3a77414defd.jpg_compressed",
                      "categoryId": "23173038"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rice Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765555",
                              "name": "Butter Khichdi",
                              "category": "Rice Combo",
                              "imageId": "4d9b4b993bfba9be88cc81e75dd52a0c",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849384",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785403",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785404",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849384",
                                        "variationId": "52785403"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849384",
                                        "variationId": "52785404"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "202 ratings",
                                  "ratingCountV2": "202"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350042"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033424",
                              "name": "Chole With 2 Lachha Paratha",
                              "category": "Rice Combo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/12ccf4ad-c727-48fb-94b7-b0b41f646744_640bfb2d-1a9b-48a2-a70e-1fc91787dae9.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026745"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033427",
                              "name": "Masaledar Khichdi",
                              "category": "Rice Combo",
                              "imageId": "0f50bdcffac58a1dbf60eb2df523221c",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849387",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "52785409",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785410",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849387",
                                        "variationId": "52785409"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849387",
                                        "variationId": "52785410"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "96 ratings",
                                  "ratingCountV2": "96"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026767"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033425",
                              "name": "Chole Chawal",
                              "category": "Rice Combo",
                              "inStock": 1,
                              "isVeg": 1,
                              "finalPrice": 4400,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849385",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785405",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785406",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849385",
                                        "variationId": "52785405"
                                      }
                                    ],
                                    "price": 8900,
                                    "finalPrice": {
                                      "units": "44"
                                    }
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849385",
                                        "variationId": "52785406"
                                      }
                                    ],
                                    "price": 12900,
                                    "finalPrice": {
                                      "units": "84"
                                    }
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "d10d518d-c383-4394-a84e-f47aa0df6d66"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51026742"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033429",
                              "name": "Rajma Chawal",
                              "category": "Rice Combo",
                              "imageId": "6233be99fcccb8fb66fac7f5119bfa1e",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849389",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785413",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785414",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849389",
                                        "variationId": "52785413"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849389",
                                        "variationId": "52785414"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "100 ratings",
                                  "ratingCountV2": "100"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026803"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033426",
                              "name": "Lapeta Dal Chawal",
                              "category": "Rice Combo",
                              "imageId": "d817568006279c877b989742c4a23b52",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849386",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785407",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785408",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849386",
                                        "variationId": "52785407"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849386",
                                        "variationId": "52785408"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026765"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033428",
                              "name": "Mixed Dal Chawal",
                              "category": "Rice Combo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/95f227fc-a68e-48d2-a899-d4d9b84759f3_a9592bd2-d9ee-4766-803e-78ac681aecc0.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "15849388",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "52785411",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "52785412",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849388",
                                        "variationId": "52785411"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "15849388",
                                        "variationId": "52785412"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026771"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "4d9b4b993bfba9be88cc81e75dd52a0c",
                      "categoryId": "23173033"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chinese",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765585",
                              "name": "Chilli Paneer",
                              "category": "Chinese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/98a49502-e541-4a07-9c1d-d304c0242d69_747eeda5-6acc-4d57-9a41-dc1f6b6dd76d.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350046"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033462",
                              "name": "Veg Chowmin",
                              "category": "Chinese",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "finalPrice": 5900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "61 ratings",
                                  "ratingCountV2": "61"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "6f25236e-eaa1-4b02-b641-c60f7342a36d"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "51026815"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033463",
                              "name": "Veg Kothey",
                              "category": "Chinese",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026816"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765584",
                              "name": "Veg Fried Rice",
                              "category": "Chinese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/f62f90f7-74b6-4b3b-9f26-12eefb5a10fa_1b8fe20e-6532-4769-af7d-e61395fb0f05.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "finalPrice": 6900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "cartContext": "quick_prep",
                              "offerIds": [
                                "a5ac2962-a55b-4ef7-9855-750a5da7dfb8"
                              ],
                              "isNinetyninestoreItem": true,
                              "parentId": "10350102"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033464",
                              "name": "Veg Manchurian Fried Rice",
                              "category": "Chinese",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/5a643569-79e4-4875-9faa-f9b61d21373b_67f6956e-d5af-4597-a997-7c0cb8acf8a0.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026817"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765581",
                              "name": "Veg Manchurian",
                              "category": "Chinese",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350105"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/98a49502-e541-4a07-9c1d-d304c0242d69_747eeda5-6acc-4d57-9a41-dc1f6b6dd76d.jpeg",
                      "categoryId": "23173037"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Starter",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033437",
                              "name": "Tandoori Paneer Tikka",
                              "category": "Starter",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026811"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033436",
                              "name": "Paneer Pakode",
                              "category": "Starter",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026792"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033430",
                              "name": "Chana Roasted",
                              "category": "Starter",
                              "imageId": "37525a62e676420d36e852b8142a4991",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026739"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033439",
                              "name": "Fried Papad",
                              "category": "Starter",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026752"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033438",
                              "name": "Dry Papad",
                              "category": "Starter",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026750"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "37525a62e676420d36e852b8142a4991",
                      "categoryId": "23173034"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "164744608",
                              "name": "Rasgulle 2 Pcs",
                              "category": "Dessert",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/9d2a27a3-a529-436a-969b-d1dfa60d32be_75e46511-b96d-4197-b4e6-3b41670dd9cb.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3600,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "99171746"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033475",
                              "name": "Gulab Jamun 1 Pec",
                              "category": "Dessert",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/108b0a82-0b26-4db4-bd49-2ec100ebac57_5025d8b2-7f7f-4dc1-9518-70c205bd3b13.jpg_compressed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "286 ratings",
                                  "ratingCountV2": "286"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "91904491"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/9d2a27a3-a529-436a-969b-d1dfa60d32be_75e46511-b96d-4197-b4e6-3b41670dd9cb.jpg_compressed",
                      "categoryId": "23173040"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dk Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93033423",
                              "name": "Dal Bafle Special",
                              "category": "Dk Special",
                              "description": "Kadi, Dal Tadka, Baingan  Bharta, Salad, Achar Chatni, Sweet",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/4621ae61-8e21-40ec-85a0-6d3af0f31419_05588f81-1e90-486b-ae9a-78934824e72b.jpeg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "160 ratings",
                                  "ratingCountV2": "160"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "51026746"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "image": "FOOD_CATALOG/IMAGES/CMS/2025/11/27/4621ae61-8e21-40ec-85a0-6d3af0f31419_05588f81-1e90-486b-ae9a-78934824e72b.jpeg",
                      "categoryId": "23173032"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Raita",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765560",
                              "name": "Veg Raita",
                              "category": "Raita",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "55660302",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 89,
                                        "default": 1,
                                        "id": "173176399",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 129,
                                        "id": "173176400",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660302",
                                        "variationId": "173176399"
                                      }
                                    ],
                                    "price": 8900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660302",
                                        "variationId": "173176400"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350107"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765558",
                              "name": "Boondi Raita",
                              "category": "Raita",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "55660299",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 79,
                                        "default": 1,
                                        "id": "173176393",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 109,
                                        "id": "173176394",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660299",
                                        "variationId": "173176393"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660299",
                                        "variationId": "173176394"
                                      }
                                    ],
                                    "price": 10900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350041"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31765557",
                              "name": "Plain Raita",
                              "category": "Raita",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {

                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "55660301",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Half",
                                        "price": 69,
                                        "default": 1,
                                        "id": "173176397",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Full",
                                        "price": 99,
                                        "id": "173176398",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660301",
                                        "variationId": "173176397"
                                      }
                                    ],
                                    "price": 6900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "55660301",
                                        "variationId": "173176398"
                                      }
                                    ],
                                    "price": 9900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 6900,
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#FFF0CD",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_low",
                                  "ratingTextColor": "rating_low",
                                  "ratingCountTextColor": "rating_low",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "10350084"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "58919547"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breakfast Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265079",
                              "name": "Poha",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 2900,
                              "finalPrice": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                              ],
                              "parentId": "108775417"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265081",
                              "name": "Kachori [1 Pc]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 2900,
                              "finalPrice": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#D9EFEC",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_medium",
                                  "ratingTextColor": "rating_medium",
                                  "ratingCountTextColor": "rating_medium",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                              ],
                              "parentId": "106479212"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265084",
                              "name": "Jalebi [100 gm]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "106479211"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265085",
                              "name": "Bhaji Vada [1 Pc]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 2900,
                              "finalPrice": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {

                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                              ],
                              "parentId": "106479209"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265083",
                              "name": "Bread Pakoda [1 Pc]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "parentId": "106479210"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265080",
                              "name": "Samosa [1 Pc]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 2900,
                              "finalPrice": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                              ],
                              "parentId": "106479214"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "176265082",
                              "name": "Aloo Vada [1 Pc]",
                              "category": "Breakfast Special",
                              "isVeg": 1,
                              "price": 2900,
                              "finalPrice": 1500,
                              "variants": {

                              },
                              "variantsV2": {

                              },
                              "nextAvailableAtMessage": "Next available at 10:30 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {

                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "matchText": "SILD"
                                }
                              ],
                              "itemBadge": {

                              },
                              "badgesV2": {

                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                },
                                "ratingsPresentationConfig": {
                                  "bgGradient": {
                                    "colours": [
                                      "#C8F9E5",
                                      "#00FFFFFF"
                                    ],
                                    "gradientDirection": "GRADIENT_DIRECTION_LEFT_TO_RIGHT"
                                  },
                                  "ratingIconColor": "rating_very_good",
                                  "ratingTextColor": "rating_very_good",
                                  "ratingCountTextColor": "rating_very_good",
                                  "ratingFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD",
                                  "ratingCountFontName": "FONT_NAME_V2_OVERLINE_NEUTRAL_BOLD"
                                }
                              },
                              "itemPriceStrikeOff": true,
                              "offerIds": [
                                "c3da9e68-cc8f-4190-bfca-f85bce3d3e1a"
                              ],
                              "parentId": "106479208"
                            },
                            "analytics": {

                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "subtitleSuffix": {

                      },
                      "categoryId": "64156321"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11422010000442"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Rajoriya Dk Restaurant",
                      "area": "BHEL",
                      "completeAddress": "22, Chanakyapuri, Near Minal Gate 1, J.K Road, Bhel, Bhopal"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "fe033f91-35c0-4527-8425-212ce1b7139e",
  "sid": "ozve9135-b6a1-4f5a-9ff5-a88c42efa775",
  "deviceId": "592793de-f1cd-a117-1c46-1144b57fd981",
  "csrfToken": "xsoO6N6Rti4L-jHUf-QhL4vRbjKDnajRR9tw42gQ"
}
}
